let chanchengArray = '113.175339, 23.000923;113.1707, 23.007744;113.168223, 23.007381;113.163742, 23.001805;113.151303, 23.00564;113.149046, 23.006768;113.150709, 23.009469;113.154487, 23.018438;113.159128, 23.028594;113.150053, 23.029793;113.144131, 23.036116;113.141274, 23.047512;113.138846, 23.049885;113.133093, 23.053409;113.127159, 23.063042;113.1247, 23.068895;113.119969, 23.07095;113.111688, 23.067444;113.108772, 23.064385;113.105024, 23.061514;113.098176, 23.060403;113.093607, 23.059889;113.0905, 23.060887;113.089035, 23.058611;113.09029, 23.053098;113.075376, 23.057049;113.060249, 23.057131;113.059569, 23.049877;113.054, 23.040373;113.042348, 23.041098;113.039084, 23.039266;113.02865, 23.036975;113.012801, 23.038122;113.00278, 23.031582;112.992998, 23.026097;112.992516, 23.00439;112.986998, 22.985512;113.001738, 22.971542;113.022019, 22.932287;113.037913, 22.928215;113.049284, 22.928736;113.049261, 22.933013;113.051011, 22.933637;113.052593, 22.936826;113.053666, 22.937347;113.055484, 22.939315;113.05774, 22.939683;113.058874, 22.939387;113.061359, 22.938311;113.06316, 22.93815;113.064574, 22.939957;113.065919, 22.93857;113.072831, 22.941079;113.074531, 22.944282;113.071711, 22.95089;113.072778, 22.954285;113.071284, 22.95476;113.07257, 22.95639;113.07244, 22.95872;113.070907, 22.956693;113.067001, 22.957588;113.064591, 22.961613;113.061575, 22.965564;113.059211, 22.965941;113.058276, 22.968257;113.059542, 22.971844;113.057407, 22.971818;113.057316, 22.974044;113.056814, 22.976026;113.057514, 22.978404;113.058687, 22.983262;113.066273, 22.984749;113.075658, 22.986215;113.087587, 22.985107;113.097005, 22.982042;113.106287, 22.982551;113.111689, 22.980459;113.120658, 22.978289;113.135966, 22.980216;113.142999, 22.985523;113.157108, 22.993009;113.169757, 22.989668;113.1729, 22.995995'.split(';');
let nanhaiArray = '113.269166, 23.026804;113.266926, 23.027091;113.265302, 23.031778;113.264082, 23.035804;113.264544, 23.038827;113.262658, 23.040717;113.262718, 23.050133;113.257095, 23.049156;113.244739, 23.04939;113.232707, 23.046978;113.217054, 23.049563;113.208902, 23.05715;113.199778, 23.063032;113.189163, 23.067374;113.184655, 23.073594;113.18417, 23.076574;113.185443, 23.080354;113.183781, 23.082946;113.1877, 23.08362;113.193304, 23.085521;113.201475, 23.089968;113.215672, 23.089004;113.21654, 23.09076;113.215912, 23.09139;113.216494, 23.092954;113.220591, 23.095052;113.219851, 23.096858;113.220981, 23.099077;113.222773, 23.09812;113.22413, 23.098364;113.223664, 23.099953;113.22051, 23.101556;113.222398, 23.101958;113.223264, 23.103641;113.22297, 23.105742;113.221866, 23.106267;113.219771, 23.105431;113.213403, 23.105588;113.213873, 23.106762;113.214351, 23.112124;113.21138, 23.114925;113.209067, 23.115284;113.212486, 23.116813;113.211304, 23.121089;113.21196, 23.123834;113.211218, 23.127343;113.214383, 23.127809;113.217661, 23.12807;113.217104, 23.133348;113.220721, 23.143281;113.220096, 23.147345;113.204057, 23.153031;113.19792, 23.151501;113.195576, 23.15417;113.192817, 23.162301;113.196943, 23.166533;113.207212, 23.178649;113.210033, 23.178887;113.213866, 23.180206;113.216057, 23.185646;113.214901, 23.188316;113.216175, 23.19875;113.205734, 23.211612;113.199426, 23.216732;113.196156, 23.221496;113.192208, 23.222463;113.187004, 23.221871;113.184514, 23.225906;113.18194, 23.230233;113.184399, 23.233896;113.181565, 23.240903;113.189954, 23.250752;113.185602, 23.281124;113.175259, 23.289571;113.158051, 23.305142;113.147581, 23.309577;113.142256, 23.312586;113.130151, 23.313032;113.122559, 23.312391;113.116384, 23.31198;113.114514, 23.308355;113.116337, 23.302822;113.11281, 23.298619;113.103909, 23.297304;113.096834, 23.295458;113.09349, 23.292065;113.08412, 23.290505;113.078067, 23.289659;113.078065, 23.287376;113.081767, 23.280622;113.083812, 23.274855;113.087534, 23.268686;113.088113, 23.261428;113.086002, 23.255733;113.079761, 23.254711;113.074762, 23.255379;113.069352, 23.257954;113.063731, 23.257102;113.058948, 23.257926;113.053744, 23.256826;113.053067, 23.24923;113.060107, 23.240579;113.062593, 23.237108;113.058235, 23.232603;113.04655, 23.229026;113.039697, 23.228434;113.036367, 23.225734;113.038214, 23.220983;113.035924, 23.217719;113.028876, 23.217065;113.021014, 23.219987;113.018744, 23.223002;113.01461, 23.223312;113.005485, 23.221434;112.990969, 23.220139;112.986194, 23.2207;112.981846, 23.227388;112.976002, 23.231294;112.963265, 23.222717;112.952512, 23.202591;112.94259, 23.19283;112.937991, 23.187354;112.933386, 23.179379;112.933099, 23.168049;112.922712, 23.155728;112.915656, 23.14958;112.907808, 23.149118;112.900381, 23.149198;112.898644, 23.144123;112.901521, 23.137473;112.909174, 23.126988;112.911017, 23.12319;112.906057, 23.121789;112.899876, 23.1217;112.889573, 23.121922;112.883388, 23.120887;112.880694, 23.115516;112.880471, 23.108836;112.8784, 23.104614;112.873642, 23.100575;112.872601, 23.096944;112.874454, 23.093898;112.874655, 23.089888;112.877115, 23.083798;112.878545, 23.080372;112.877504, 23.076735;112.874605, 23.073472;112.874794, 23.068694;112.879493, 23.056699;112.877822, 23.050572;112.874705, 23.04597;112.876936, 23.039745;112.877128, 23.033187;112.880614, 23.027867;112.885135, 23.024093;112.889244, 23.021865;112.892943, 23.020771;112.894364, 23.014491;112.896813, 23.006227;112.908797, 22.993019;112.900996, 22.964198;112.885792, 22.959291;112.877045, 22.943096;112.895555, 22.916692;112.912753, 22.90195;112.920363, 22.878557;112.92485, 22.862541;112.91018, 22.876712;112.892102, 22.884808;112.886345, 22.884442;112.873667, 22.890172;112.863952, 22.872674;112.853743, 22.858949;112.866087, 22.840391;112.877365, 22.847176;112.895814, 22.842797;112.919586, 22.851729;112.934192, 22.857615;112.961533, 22.837912;112.9833, 22.81147;113.01042, 22.808658;113.040164, 22.811993;113.054453, 22.812848;113.069929, 22.80295;113.070849, 22.811507;113.073173, 22.816365;113.074652, 22.818384;113.072523, 22.821831;113.071302, 22.82597;113.066639, 22.828199;113.061348, 22.829062;113.056459, 22.833218;113.055778, 22.836934;113.053505, 22.837167;113.054783, 22.839271;113.052805, 22.839756;113.051514, 22.8411;113.048427, 22.840115;113.042674, 22.842381;113.039986, 22.844928;113.033204, 22.846214;113.032886, 22.849763;113.030843, 22.850712;113.030729, 22.853636;113.029247, 22.854486;113.029934, 22.85678;113.027973, 22.858495;113.024581, 22.859649;113.023339, 22.860597;113.022072, 22.865597;113.019504, 22.865089;113.015826, 22.87533;113.019509, 22.878877;113.020353, 22.880684;113.02132, 22.883183;113.022002, 22.883375;113.022289, 22.886906;113.019728, 22.887498;113.019755, 22.888492;113.02265, 22.888524;113.029619, 22.885826;113.032519, 22.888512;113.03774, 22.888601;113.037575, 22.886999;113.040608, 22.887959;113.046685, 22.888737;113.051234, 22.886754;113.055403, 22.891188;113.052934, 22.894728;113.053376, 22.898053;113.05405, 22.90291;113.056716, 22.90287;113.06128, 22.909178;113.063519, 22.911971;113.061373, 22.916726;113.058078, 22.918572;113.058674, 22.920796;113.058501, 22.925624;113.049552, 22.927853;113.026009, 22.929237;113.007657, 22.957872;112.990608, 22.982527;112.98615, 22.990925;112.994673, 23.015866;112.998659, 23.031532;113.007608, 23.035588;113.021281, 23.038234;113.034871, 23.036555;113.04113, 23.041246;113.050855, 23.039186;113.059168, 23.046766;113.059667, 23.056373;113.064392, 23.058051;113.089336, 23.052843;113.089439, 23.057085;113.08925, 23.060521;113.092161, 23.060663;113.096103, 23.05966;113.102121, 23.06114;113.107727, 23.06285;113.110025, 23.067059;113.116032, 23.068622;113.123484, 23.070432;113.125937, 23.066456;113.130429, 23.056616;113.137199, 23.050616;113.140487, 23.049208;113.139764, 23.041739;113.147388, 23.032633;113.156412, 23.028559;113.163569, 23.021513;113.150305, 23.010614;113.149669, 23.007727;113.149866, 23.006005;113.154754, 23.005539;113.167531, 23.003601;113.169464, 23.00833;113.172561, 23.00547;113.179098, 22.995667;113.185211, 22.997668;113.191763, 23.002475;113.191134, 23.004879;113.192447, 23.008397;113.201264, 23.012561;113.207719, 23.012973;113.210435, 23.010728;113.217288, 23.00957;113.219317, 23.00944;113.221762, 23.011643;113.229296, 23.008236;113.229201, 23.005043;113.231585, 22.998226;113.235771, 22.995723;113.236226, 22.992253;113.238203, 22.991465;113.238778, 22.987671;113.24019, 22.987477;113.244186, 22.98614;113.248996, 22.987968;113.250126, 22.984808;113.253177, 22.984093;113.255389, 22.983291;113.25785, 22.990183;113.261721, 22.998088;113.25727, 23.006809;113.259012, 23.015457;113.261259, 23.019896;113.261073, 23.024354;113.265188, 23.023742'.split(';');
let shundeArray = '113.40012, 22.815586;113.395666, 22.817995;113.390114, 22.823251;113.380303, 22.829005;113.37496, 22.827567;113.371055, 22.829369;113.361781, 22.827757;113.359419, 22.823979;113.355872, 22.823671;113.354651, 22.82113;113.352068, 22.82496;113.343497, 22.823843;113.335373, 22.828951;113.319061, 22.836589;113.316504, 22.849592;113.315751, 22.856591;113.311259, 22.85737;113.310212, 22.858588;113.309074, 22.860581;113.30757, 22.861881;113.30654, 22.864634;113.303215, 22.863169;113.302975, 22.86552;113.302568, 22.86786;113.30594, 22.870827;113.307011, 22.87286;113.304853, 22.879113;113.306879, 22.882717;113.282603, 22.900355;113.284082, 22.905485;113.289043, 22.907209;113.292494, 22.910269;113.289944, 22.929396;113.289667, 22.932562;113.290209, 22.93269;113.291011, 22.933791;113.292579, 22.93344;113.292937, 22.934529;113.294358, 22.93358;113.295264, 22.933496;113.295954, 22.934376;113.298435, 22.935784;113.305581, 22.938792;113.303493, 22.943441;113.296312, 22.954844;113.287137, 22.959569;113.276138, 22.963628;113.273703, 22.961371;113.273922, 22.965862;113.262851, 22.972902;113.256056, 22.982073;113.254671, 22.983306;113.252679, 22.984367;113.249896, 22.985119;113.24879, 22.987966;113.243155, 22.987394;113.239861, 22.987352;113.238718, 22.987939;113.237789, 22.991553;113.236044, 22.9929;113.235406, 22.996192;113.230941, 22.999388;113.229141, 23.005691;113.228201, 23.009313;113.221175, 23.011516;113.219071, 23.009119;113.216384, 23.009739;113.209708, 23.010933;113.207316, 23.013093;113.19876, 23.011282;113.191719, 23.008059;113.19145, 23.004135;113.19164, 23.002099;113.182918, 22.99622;113.177464, 22.997547;113.172647, 22.992402;113.168511, 22.989654;113.154678, 22.993003;113.141114, 22.982687;113.130949, 22.98016;113.118062, 22.978101;113.1104, 22.981618;113.105595, 22.982549;113.096436, 22.982;113.085649, 22.985652;113.073726, 22.98601;113.065442, 22.984791;113.057984, 22.982269;113.057454, 22.977877;113.056894, 22.975774;113.056849, 22.972921;113.057657, 22.971914;113.059596, 22.971655;113.058281, 22.967416;113.059641, 22.965644;113.062364, 22.96538;113.064954, 22.960511;113.067569, 22.957424;113.071244, 22.957075;113.072771, 22.958498;113.072052, 22.955861;113.071435, 22.954644;113.072748, 22.954046;113.071803, 22.950397;113.074829, 22.943583;113.07007, 22.939986;113.065448, 22.938682;113.064269, 22.940014;113.063158, 22.937974;113.060709, 22.938537;113.058834, 22.939501;113.056993, 22.939871;113.055257, 22.938841;113.053436, 22.937281;113.052052, 22.935983;113.050831, 22.933576;113.049161, 22.932787;113.049555, 22.928231;113.055536, 22.92719;113.061134, 22.923431;113.057665, 22.919249;113.060838, 22.917562;113.062961, 22.91312;113.063367, 22.910902;113.058191, 22.904834;113.054686, 22.902945;113.052586, 22.899936;113.052523, 22.896207;113.055332, 22.892149;113.052432, 22.887231;113.047808, 22.888885;113.042119, 22.888023;113.038014, 22.88672;113.038018, 22.888149;113.032994, 22.888771;113.030887, 22.886258;113.025122, 22.887408;113.020437, 22.888734;113.019498, 22.888166;113.022158, 22.887044;113.022238, 22.884031;113.021558, 22.883314;113.021352, 22.881286;113.019729, 22.879259;113.017901, 22.878011;113.016763, 22.87034;113.020867, 22.865249;113.023181, 22.861297;113.0239, 22.859721;113.026622, 22.85835;113.029214, 22.858069;113.029553, 22.855203;113.029416, 22.853996;113.0307, 22.851828;113.032352, 22.850252;113.033183, 22.847041;113.038461, 22.844352;113.041681, 22.844774;113.044762, 22.839336;113.050746, 22.841488;113.052475, 22.839726;113.053846, 22.840435;113.053667, 22.838025;113.055277, 22.837077;113.055662, 22.835071;113.060534, 22.829652;113.064265, 22.828484;113.070375, 22.826695;113.072673, 22.822541;113.07396, 22.819831;113.07347, 22.816894;113.07307, 22.815183;113.069903, 22.808312;113.076247, 22.794827;113.084686, 22.776943;113.088423, 22.753218;113.103402, 22.709624;113.11139, 22.704896;113.120181, 22.707899;113.125573, 22.705757;113.134866, 22.699479;113.159291, 22.685165;113.161121, 22.686288;113.168341, 22.680125;113.171068, 22.681941;113.173087, 22.681235;113.17798, 22.686525;113.178636, 22.686464;113.179761, 22.68699;113.181427, 22.686568;113.183457, 22.687946;113.186141, 22.685518;113.187996, 22.685137;113.190164, 22.683712;113.19578, 22.679977;113.198586, 22.680534;113.20365, 22.681486;113.207383, 22.68227;113.20648, 22.685656;113.208453, 22.691859;113.21212, 22.699346;113.215978, 22.705059;113.230001, 22.72032;113.237489, 22.729856;113.244656, 22.747138;113.253851, 22.751354;113.267957, 22.736946;113.27742, 22.732286;113.289921, 22.745025;113.30526, 22.743463;113.330287, 22.746017;113.336696, 22.749601;113.335893, 22.754743;113.340305, 22.758128;113.347143, 22.762143;113.350773, 22.764684;113.361448, 22.769343;113.369258, 22.776505;113.370388, 22.780076;113.362818, 22.797144;113.365627, 22.798522;113.374571, 22.800586;113.379286, 22.801654;113.382048, 22.801176;113.385457, 22.803709;113.392435, 22.808468;113.400053, 22.815134'.split(';');
let gaomingArray = '112.927727, 22.86334;112.918191, 22.891905;112.906545, 22.905273;112.882506, 22.928274;112.877384, 22.953417;112.873299, 22.974008;112.853862, 22.999582;112.845272, 23.006862;112.842543, 23.013215;112.837028, 23.018016;112.834474, 23.018079;112.823614, 23.013456;112.817685, 23.007767;112.813361, 23.005234;112.812216, 23.003901;112.811204, 23.002612;112.80731, 23.002451;112.803789, 22.998566;112.798761, 22.996485;112.79531, 23.00014;112.795748, 23.003633;112.796957, 23.004665;112.800239, 23.004114;112.801014, 23.006228;112.798802, 23.007023;112.798122, 23.006363;112.797236, 23.008566;112.796842, 23.007135;112.795661, 23.007695;112.79619, 23.008658;112.796136, 23.00984;112.794576, 23.009772;112.795201, 23.006157;112.794334, 23.004491;112.789789, 23.004111;112.792146, 23.00391;112.793989, 23.003319;112.787282, 23.001941;112.783505, 23.001119;112.782862, 23.000014;112.77868, 22.998996;112.775204, 22.992475;112.76854, 22.985324;112.763875, 22.989126;112.758743, 22.995435;112.752863, 22.995723;112.746961, 22.991098;112.742384, 22.981866;112.742294, 22.974043;112.744205, 22.969861;112.747353, 22.968631;112.74876, 22.965334;112.74364, 22.957913;112.743918, 22.953485;112.741417, 22.947235;112.736209, 22.942302;112.731006, 22.94288;112.724042, 22.937126;112.716887, 22.933574;112.711337, 22.939044;112.711479, 22.943591;112.712202, 22.949284;112.708626, 22.951116;112.7062, 22.954054;112.703333, 22.953597;112.701029, 22.954616;112.699296, 22.954204;112.696364, 22.95484;112.693816, 22.954483;112.694068, 22.953407;112.691756, 22.95212;112.690405, 22.95315;112.688559, 22.94881;112.683965, 22.950106;112.682687, 22.949428;112.680478, 22.948619;112.680367, 22.945949;112.682777, 22.945805;112.686531, 22.938822;112.692487, 22.934649;112.694565, 22.937466;112.697748, 22.937394;112.697146, 22.938777;112.699726, 22.940703;112.700913, 22.938891;112.697951, 22.935057;112.700178, 22.934134;112.703744, 22.936123;112.706049, 22.939452;112.707473, 22.935842;112.704905, 22.93502;112.708541, 22.930537;112.707306, 22.930172;112.701631, 22.932637;112.700017, 22.929782;112.69778, 22.932511;112.694664, 22.932082;112.698264, 22.925819;112.701119, 22.923708;112.700095, 22.922425;112.699663, 22.921427;112.697244, 22.922776;112.694878, 22.922709;112.695842, 22.918899;112.696646, 22.915969;112.694142, 22.914111;112.693594, 22.912641;112.697342, 22.908292;112.696245, 22.906719;112.694409, 22.904965;112.691979, 22.903922;112.689635, 22.902404;112.68711, 22.908114;112.686558, 22.909825;112.683982, 22.909127;112.6817, 22.907152;112.68231, 22.901546;112.677961, 22.899954;112.675409, 22.897311;112.671212, 22.896637;112.668457, 22.897103;112.665378, 22.894614;112.658619, 22.893285;112.651973, 22.892954;112.647437, 22.8904;112.642297, 22.889997;112.639182, 22.888277;112.637484, 22.887128;112.639526, 22.887024;112.638939, 22.886226;112.62742, 22.881554;112.622501, 22.879414;112.620042, 22.883083;112.617884, 22.880995;112.615685, 22.880671;112.613091, 22.878714;112.611263, 22.876725;112.608888, 22.879051;112.607428, 22.876396;112.602071, 22.876608;112.60047, 22.876111;112.599204, 22.875278;112.598002, 22.875475;112.598149, 22.871411;112.595582, 22.870291;112.587803, 22.870811;112.581783, 22.872824;112.576226, 22.874297;112.574133, 22.877668;112.566252, 22.875172;112.567425, 22.872236;112.565474, 22.868921;112.567552, 22.86696;112.568204, 22.866265;112.570164, 22.86251;112.575663, 22.859003;112.578631, 22.856093;112.581443, 22.852663;112.580613, 22.849045;112.580812, 22.846482;112.579465, 22.845005;112.580246, 22.840405;112.577244, 22.840726;112.57537, 22.837368;112.571737, 22.838283;112.568277, 22.837155;112.556338, 22.832261;112.551794, 22.830583;112.547548, 22.830353;112.539824, 22.829521;112.538141, 22.825632;112.534752, 22.820824;112.532291, 22.824863;112.529406, 22.824982;112.529767, 22.827022;112.527518, 22.8321;112.522479, 22.831093;112.512054, 22.830491;112.505748, 22.832661;112.505423, 22.828929;112.505061, 22.826835;112.50703, 22.823386;112.505858, 22.818709;112.499137, 22.815972;112.494131, 22.809531;112.492804, 22.804838;112.490839, 22.802668;112.485453, 22.801324;112.473641, 22.797829;112.466384, 22.796064;112.461543, 22.798262;112.453811, 22.796966;112.451044, 22.79906;112.449718, 22.795964;112.431855, 22.785871;112.427743, 22.784612;112.417474, 22.780298;112.409677, 22.775848;112.406495, 22.775509;112.404367, 22.777166;112.402002, 22.781277;112.399539, 22.776929;112.396172, 22.768824;112.398485, 22.761019;112.403335, 22.75186;112.402862, 22.736087;112.404071, 22.728642;112.40736, 22.724264;112.412906, 22.718392;112.412432, 22.706144;112.406795, 22.695548;112.4117, 22.687559;112.419704, 22.679216;112.431649, 22.675103;112.440609, 22.688137;112.450203, 22.70299;112.451291, 22.713882;112.453799, 22.720739;112.45772, 22.717031;112.466207, 22.716462;112.471186, 22.717099;112.479661, 22.710133;112.485873, 22.709183;112.491695, 22.713003;112.489835, 22.719717;112.492944, 22.726146;112.504448, 22.732956;112.516064, 22.738828;112.528123, 22.733418;112.549632, 22.717258;112.559469, 22.69982;112.551789, 22.68575;112.543663, 22.676589;112.544735, 22.650993;112.566511, 22.651507;112.584301, 22.668119;112.586727, 22.680222;112.590924, 22.685989;112.605622, 22.689524;112.596202, 22.700707;112.599416, 22.711762;112.622229, 22.717633;112.632773, 22.715883;112.638567, 22.725627;112.64883, 22.730236;112.660577, 22.730736;112.670022, 22.725107;112.682311, 22.735124;112.685147, 22.750906;112.692705, 22.76108;112.703774, 22.76508;112.70875, 22.756231;112.716555, 22.719877;112.727285, 22.703054;112.741, 22.700325;112.753739, 22.703349;112.770526, 22.707756;112.785166, 22.723459;112.802315, 22.728052;112.812928, 22.740508;112.813848, 22.752732;112.817378, 22.774119;112.826562, 22.788943;112.817158, 22.802211;112.829894, 22.813405;112.84869, 22.818104;112.86342, 22.838094;112.856069, 22.85244;112.861494, 22.870187;112.871294, 22.885313;112.882331, 22.885357;112.891877, 22.884778;112.907919, 22.878874;112.922797, 22.861955'.split(';');
let sanshuiArray = '113.062592, 23.237868;113.058658, 23.242119;113.052254, 23.252854;113.051024, 23.258332;113.057662, 23.275733;113.055865, 23.286623;113.043942, 23.295734;113.042631, 23.320781;113.039331, 23.325536;113.032911, 23.329109;113.031266, 23.333475;113.034187, 23.336369;113.03814, 23.340219;113.042313, 23.345199;113.047952, 23.352071;113.04922, 23.359132;113.044042, 23.363328;113.0378, 23.361394;113.027807, 23.353273;113.023246, 23.352435;113.020783, 23.356397;113.017061, 23.35977;113.013532, 23.358181;113.00959, 23.359263;113.004827, 23.360903;112.998602, 23.360056;112.993412, 23.3623;112.992808, 23.365732;112.992626, 23.372792;112.990762, 23.375645;112.988917, 23.378701;112.991038, 23.382741;112.988413, 23.388067;112.992442, 23.390636;112.990896, 23.391677;112.989581, 23.392542;112.99186, 23.395287;112.993571, 23.397039;112.991712, 23.402156;112.993208, 23.404796;112.994904, 23.406679;113.000034, 23.409494;113.006513, 23.411496;113.005275, 23.415047;113.000405, 23.420808;112.996202, 23.423586;112.993941, 23.428918;112.991267, 23.434815;112.988368, 23.437669;112.989001, 23.440724;112.99317, 23.443598;112.990693, 23.446643;112.984242, 23.447026;112.976099, 23.443255;112.969011, 23.443157;112.969231, 23.446969;112.974465, 23.453007;112.980318, 23.458489;112.980536, 23.461535;112.976378, 23.461761;112.972677, 23.460558;112.969677, 23.456599;112.966805, 23.45552;112.965812, 23.45415;112.960902, 23.457328;112.957238, 23.463801;112.957198, 23.461615;112.955534, 23.462179;112.950233, 23.464507;112.949655, 23.466722;112.940415, 23.470737;112.936579, 23.470761;112.935317, 23.474895;112.937755, 23.475724;112.938856, 23.477519;112.940771, 23.478622;112.938307, 23.480319;112.937108, 23.481119;112.934091, 23.477444;112.932713, 23.480686;112.936201, 23.485567;112.934266, 23.495518;112.933411, 23.495768;112.928961, 23.493058;112.921468, 23.496245;112.916302, 23.492548;112.910117, 23.494915;112.9039, 23.507189;112.900374, 23.51899;112.895341, 23.520474;112.896564, 23.527554;112.899197, 23.530429;112.900933, 23.533864;112.903368, 23.53622;112.909738, 23.542875;112.917079, 23.549781;112.922352, 23.559059;112.917987, 23.562793;112.916881, 23.565534;112.911951, 23.570977;112.905173, 23.574301;112.903488, 23.569904;112.899165, 23.562302;112.900427, 23.560886;112.899092, 23.560717;112.893949, 23.564809;112.883857, 23.571654;112.88215, 23.573267;112.880036, 23.573022;112.878633, 23.577598;112.877676, 23.575631;112.87734, 23.573094;112.876304, 23.577222;112.870267, 23.579954;112.863799, 23.578512;112.85828, 23.575528;112.85549, 23.574166;112.852679, 23.575399;112.847485, 23.573051;112.845482, 23.572757;112.83711, 23.574862;112.835198, 23.570406;112.837737, 23.567606;112.835951, 23.56624;112.834761, 23.561332;112.838114, 23.556764;112.839635, 23.554043;112.840039, 23.544666;112.848442, 23.543835;112.851099, 23.539638;112.857479, 23.536438;112.857445, 23.533028;112.855677, 23.530062;112.857235, 23.52737;112.855348, 23.523712;112.854993, 23.517272;112.853847, 23.515461;112.85386, 23.513062;112.853543, 23.51207;112.85224, 23.510204;112.853181, 23.500032;112.853428, 23.494264;112.845777, 23.490458;112.846459, 23.487955;112.845173, 23.485626;112.843211, 23.48559;112.839801, 23.476865;112.834689, 23.473941;112.829077, 23.472277;112.825898, 23.470197;112.82023, 23.470037;112.817503, 23.464042;112.810989, 23.451801;112.809261, 23.439999;112.806336, 23.438051;112.802874, 23.433033;112.803127, 23.422091;112.80289, 23.415662;112.796821, 23.411226;112.796621, 23.405868;112.794929, 23.403609;112.794226, 23.400691;112.792646, 23.397842;112.792854, 23.390236;112.794589, 23.38447;112.793612, 23.380569;112.797824, 23.374542;112.810808, 23.375167;112.815236, 23.374068;112.818692, 23.378022;112.815165, 23.384361;112.815328, 23.389158;112.814306, 23.392188;112.818785, 23.394245;112.825966, 23.398894;112.830718, 23.396445;112.834591, 23.397783;112.838289, 23.395485;112.84102, 23.397571;112.843959, 23.395352;112.846651, 23.391361;112.851285, 23.386902;112.856332, 23.38387;112.860951, 23.379029;112.861945, 23.378885;112.86214, 23.378332;112.862482, 23.377575;112.864222, 23.37515;112.865152, 23.375597;112.865998, 23.374529;112.86703, 23.37362;112.866382, 23.372015;112.866608, 23.370867;112.868106, 23.365265;112.86943, 23.36128;112.870872, 23.360721;112.875082, 23.356264;112.878444, 23.356297;112.883668, 23.353233;112.889469, 23.346754;112.878632, 23.319787;112.875561, 23.300272;112.866161, 23.291697;112.857287, 23.279905;112.848188, 23.264861;112.833151, 23.252915;112.829639, 23.244479;112.834233, 23.24725;112.837511, 23.252869;112.840851, 23.251048;112.840301, 23.24952;112.844553, 23.246898;112.844879, 23.246001;112.850922, 23.242798;112.852175, 23.243095;112.851753, 23.244505;112.856341, 23.243231;112.853692, 23.24126;112.85489, 23.237743;112.857199, 23.238996;112.856269, 23.236608;112.852548, 23.231562;112.851732, 23.230911;112.848564, 23.229607;112.844562, 23.22757;112.845195, 23.224737;112.839641, 23.222032;112.831376, 23.222386;112.823864, 23.223618;112.821397, 23.214607;112.819714, 23.206592;112.814546, 23.206704;112.810093, 23.207711;112.810994, 23.2114;112.811543, 23.215801;112.813748, 23.216203;112.816704, 23.219473;112.815921, 23.221354;112.81012, 23.2258;112.810964, 23.227468;112.812296, 23.227683;112.811555, 23.229862;112.810128, 23.230959;112.809052, 23.233577;112.808607, 23.234461;112.80762, 23.233992;112.806958, 23.235096;112.804107, 23.232555;112.806014, 23.230332;112.805042, 23.22937;112.803876, 23.226882;112.803754, 23.224362;112.805541, 23.223741;112.806317, 23.222274;112.804345, 23.221631;112.802978, 23.217861;112.803907, 23.215959;112.801917, 23.214828;112.801728, 23.217076;112.800573, 23.215295;112.799209, 23.214477;112.79588, 23.21226;112.792887, 23.214216;112.794546, 23.217683;112.792099, 23.221376;112.789318, 23.225046;112.790907, 23.225228;112.794772, 23.229679;112.789307, 23.231957;112.786356, 23.230989;112.782471, 23.232237;112.781502, 23.230972;112.780108, 23.230229;112.778605, 23.22879;112.77608, 23.22714;112.777223, 23.223928;112.780071, 23.223591;112.776771, 23.220376;112.773118, 23.219329;112.771664, 23.210363;112.771131, 23.207881;112.777868, 23.206103;112.779201, 23.203738;112.77916, 23.195438;112.781773, 23.18165;112.788691, 23.170324;112.805155, 23.151019;112.806637, 23.144857;112.806848, 23.114376;112.822965, 23.082062;112.828361, 23.052412;112.843108, 23.020348;112.840891, 23.016877;112.843874, 23.008988;112.848322, 23.004705;112.866185, 22.985611;112.875336, 22.958005;112.889705, 22.958797;112.906651, 22.978459;112.909084, 23.003161;112.895793, 23.00993;112.893961, 23.017353;112.891713, 23.021325;112.887186, 23.022409;112.88411, 23.02561;112.878767, 23.029757;112.87684, 23.034642;112.874489, 23.04291;112.875956, 23.048077;112.878859, 23.052103;112.878273, 23.060884;112.873981, 23.070603;112.87605, 23.075197;112.878333, 23.077689;112.878142, 23.08208;112.875675, 23.08627;112.874866, 23.09161;112.873631, 23.095419;112.872608, 23.09828;112.875504, 23.102306;112.879433, 23.105578;112.880887, 23.111506;112.88111, 23.117999;112.885448, 23.121675;112.893281, 23.121783;112.904071, 23.121913;112.909161, 23.122211;112.91123, 23.124147;112.906708, 23.130197;112.900139, 23.140609;112.898562, 23.147275;112.902439, 23.149425;112.910897, 23.14896;112.918553, 23.150933;112.927898, 23.157652;112.933563, 23.171735;112.934652, 23.182996;112.940075, 23.188663;112.943487, 23.195581;112.955418, 23.208865;112.971041, 23.2271;112.978249, 23.231783;112.983082, 23.224519;112.988269, 23.219752;112.996986, 23.220563;113.01046, 23.222279;113.016471, 23.223534;113.019776, 23.221874;113.023907, 23.218319;113.032191, 23.217302;113.037589, 23.218691;113.037601, 23.222889;113.036787, 23.227268;113.042389, 23.228258;113.052132, 23.228979;113.062136, 23.234519'.split(';');
let guicheng = [
    [
        113.18407810824,
        23.075445649747
    ],
    [
        113.18408708436,
        23.075407002674
    ],
    [
        113.18410449254,
        23.075335412702
    ],
    [
        113.18414529561,
        23.075236364439
    ],
    [
        113.18416487903,
        23.075152807035
    ],
    [
        113.18419235087,
        23.075055573931
    ],
    [
        113.18422526103,
        23.074922726527
    ],
    [
        113.18424592953,
        23.074812567896
    ],
    [
        113.18427394354,
        23.074709900021
    ],
    [
        113.18429814974,
        23.074624647256
    ],
    [
        113.18433296124,
        23.074487158518
    ],
    [
        113.18436668709,
        23.074385492464
    ],
    [
        113.18439687798,
        23.074306120625
    ],
    [
        113.18443223427,
        23.074193036345
    ],
    [
        113.18446296514,
        23.074081645171
    ],
    [
        113.18449206413,
        23.073979228809
    ],
    [
        113.18452959741,
        23.073882930036
    ],
    [
        113.1845641376,
        23.073786402176
    ],
    [
        113.18458262916,
        23.073717503463
    ],
    [
        113.18460384202,
        23.073654804645
    ],
    [
        113.1846258702,
        23.073586939546
    ],
    [
        113.18465959637,
        23.073513751051
    ],
    [
        113.18467020077,
        23.073469922498
    ],
    [
        113.18470691854,
        23.073390721764
    ],
    [
        113.18475506109,
        23.073298333483
    ],
    [
        113.18479232451,
        23.073231059198
    ],
    [
        113.18483203409,
        23.07314882835
    ],
    [
        113.18488942259,
        23.073031887069
    ],
    [
        113.1849364795,
        23.072959584139
    ],
    [
        113.18498870324,
        23.07287228422
    ],
    [
        113.18503331202,
        23.072803812433
    ],
    [
        113.18508254534,
        23.072730931315
    ],
    [
        113.18515925129,
        23.072616953453
    ],
    [
        113.18523078486,
        23.0724892134
    ],
    [
        113.18523051219,
        23.072486233347
    ],
    [
        113.18529661158,
        23.072397635001
    ],
    [
        113.18536161578,
        23.072275683141
    ],
    [
        113.18541002967,
        23.072189241438
    ],
    [
        113.18545680881,
        23.072093327931
    ],
    [
        113.18546905073,
        23.072083108717
    ],
    [
        113.18551229513,
        23.071999453929
    ],
    [
        113.1855449334,
        23.071941185251
    ],
    [
        113.18555716547,
        23.071887289397
    ],
    [
        113.18557267,
        23.071865898381
    ],
    [
        113.18559633081,
        23.071815901037
    ],
    [
        113.18567058483,
        23.071694614084
    ],
    [
        113.18572144166,
        23.071588052866
    ],
    [
        113.18578644898,
        23.071487788601
    ],
    [
        113.18582887542,
        23.071402239762
    ],
    [
        113.18587592866,
        23.071321503384
    ],
    [
        113.18592406822,
        23.071233153547
    ],
    [
        113.18596296409,
        23.071175325827
    ],
    [
        113.1860108361,
        23.07110488257
    ],
    [
        113.18605897591,
        23.071018699647
    ],
    [
        113.18612044786,
        23.070928515266
    ],
    [
        113.18620313651,
        23.070810063998
    ],
    [
        113.18626923264,
        23.070714107723
    ],
    [
        113.18631411014,
        23.070640176145
    ],
    [
        113.18637014316,
        23.070562274988
    ],
    [
        113.18641937667,
        23.07049587044
    ],
    [
        113.18649553243,
        23.070371539034
    ],
    [
        113.18657441356,
        23.070261269718
    ],
    [
        113.18664840168,
        23.070167621347
    ],
    [
        113.18671504555,
        23.070083578917
    ],
    [
        113.18677924315,
        23.070008253452
    ],
    [
        113.18687091106,
        23.06988773748
    ],
    [
        113.1869293924,
        23.069807341802
    ],
    [
        113.18697835372,
        23.069740657162
    ],
    [
        113.18707220423,
        23.069636104665
    ],
    [
        113.18714401796,
        23.069548984164
    ],
    [
        113.1872128438,
        23.069477642897
    ],
    [
        113.1873145821,
        23.069359392172
    ],
    [
        113.18739456499,
        23.069284885857
    ],
    [
        113.18744761572,
        23.069237388033
    ],
    [
        113.18748870019,
        23.069211781101
    ],
    [
        113.18753250175,
        23.06917392249
    ],
    [
        113.18758799946,
        23.069119057994
    ],
    [
        113.18766471173,
        23.069028859409
    ],
    [
        113.18776400674,
        23.068923107051
    ],
    [
        113.18784153344,
        23.068826921387
    ],
    [
        113.18789730475,
        23.068774486917
    ],
    [
        113.18793049429,
        23.068740045789
    ],
    [
        113.1879805496,
        23.068685259072
    ],
    [
        113.18807250223,
        23.068592362064
    ],
    [
        113.18817261446,
        23.068485765997
    ],
    [
        113.18825233253,
        23.068423172198
    ],
    [
        113.18834319512,
        23.06832485694
    ],
    [
        113.18839869757,
        23.068278112708
    ],
    [
        113.18845963887,
        23.068220156339
    ],
    [
        113.18856111735,
        23.068123831966
    ],
    [
        113.18863130105,
        23.068038049879
    ],
    [
        113.18874583876,
        23.067928755506
    ],
    [
        113.18882691033,
        23.067844689973
    ],
    [
        113.18889819192,
        23.067779501191
    ],
    [
        113.18899422761,
        23.067681892777
    ],
    [
        113.18908020016,
        23.0676007237
    ],
    [
        113.18921269444,
        23.067471582039
    ],
    [
        113.18929675784,
        23.067380671135
    ],
    [
        113.18938109649,
        23.067296264277
    ],
    [
        113.18949047577,
        23.067210355705
    ],
    [
        113.18955223186,
        23.067144494095
    ],
    [
        113.18965725628,
        23.067057566312
    ],
    [
        113.18973534354,
        23.066990615979
    ],
    [
        113.18981777819,
        23.06690704224
    ],
    [
        113.18992171653,
        23.066823921591
    ],
    [
        113.19000361485,
        23.066756358332
    ],
    [
        113.19011326572,
        23.066664454482
    ],
    [
        113.1901859162,
        23.066610063569
    ],
    [
        113.19027108665,
        23.066552747959
    ],
    [
        113.19039163252,
        23.066472860284
    ],
    [
        113.19048714462,
        23.066409939308
    ],
    [
        113.19057503458,
        23.066345516515
    ],
    [
        113.19067871252,
        23.066280553407
    ],
    [
        113.19076224845,
        23.066217556011
    ],
    [
        113.19093123515,
        23.066108614701
    ],
    [
        113.19098674351,
        23.066064264634
    ],
    [
        113.19108797645,
        23.066005842588
    ],
    [
        113.19115736422,
        23.065954200132
    ],
    [
        113.1912550617,
        23.065900988564
    ],
    [
        113.19131411562,
        23.065868510431
    ],
    [
        113.19140854695,
        23.065815079532
    ],
    [
        113.19153182712,
        23.065748944173
    ],
    [
        113.19165401882,
        23.065682552533
    ],
    [
        113.19179390332,
        23.065612055255
    ],
    [
        113.19190494348,
        23.065561583477
    ],
    [
        113.19199775158,
        23.065523360251
    ],
    [
        113.19206605853,
        23.065483115935
    ],
    [
        113.19212783914,
        23.065455734314
    ],
    [
        113.19224703939,
        23.065390463314
    ],
    [
        113.19231888682,
        23.06535205328
    ],
    [
        113.19239318534,
        23.065315227577
    ],
    [
        113.19250177792,
        23.0652653268
    ],
    [
        113.19262669281,
        23.06519370779
    ],
    [
        113.1927263013,
        23.065141787824
    ],
    [
        113.19281448295,
        23.065102001954
    ],
    [
        113.19290973695,
        23.065051510878
    ],
    [
        113.1930205103,
        23.06500400347
    ],
    [
        113.19316367442,
        23.06494616216
    ],
    [
        113.19327689694,
        23.064895623006
    ],
    [
        113.19334875686,
        23.06487591921
    ],
    [
        113.19344918272,
        23.064822073701
    ],
    [
        113.19352294507,
        23.064796094811
    ],
    [
        113.19363453399,
        23.06474367901
    ],
    [
        113.19374884523,
        23.064690671132
    ],
    [
        113.19391242711,
        23.064627843865
    ],
    [
        113.19401340994,
        23.064593785805
    ],
    [
        113.19410159333,
        23.064552626308
    ],
    [
        113.19421183403,
        23.064520573568
    ],
    [
        113.19434411687,
        23.064471310764
    ],
    [
        113.19445680285,
        23.064429987767
    ],
    [
        113.19461848785,
        23.064378846829
    ],
    [
        113.19469851264,
        23.064351390745
    ],
    [
        113.19484495464,
        23.064304313538
    ],
    [
        113.19486673274,
        23.064301216146
    ],
    [
        113.19498486154,
        23.064254908261
    ],
    [
        113.19506298385,
        23.064232366844
    ],
    [
        113.19519364142,
        23.064194517545
    ],
    [
        113.19535641502,
        23.064140363672
    ],
    [
        113.19548870885,
        23.064106552652
    ],
    [
        113.19565937817,
        23.064052527769
    ],
    [
        113.1958284205,
        23.0640091113
    ],
    [
        113.19594301961,
        23.063977510113
    ],
    [
        113.19605870941,
        23.063948602274
    ],
    [
        113.1961564347,
        23.06392652362
    ],
    [
        113.19628899561,
        23.063883479916
    ],
    [
        113.19641883912,
        23.063848894564
    ],
    [
        113.19654568204,
        23.063804866632
    ],
    [
        113.19663932104,
        23.063778790388
    ],
    [
        113.19671989052,
        23.063750503972
    ],
    [
        113.19690226231,
        23.063689485678
    ],
    [
        113.19706123144,
        23.063646788484
    ],
    [
        113.19717582895,
        23.063613287961
    ],
    [
        113.19725639806,
        23.063585002396
    ],
    [
        113.19734432304,
        23.063564997304
    ],
    [
        113.19744504026,
        23.063539340053
    ],
    [
        113.19758332307,
        23.063505693495
    ],
    [
        113.1976745108,
        23.063479391979
    ],
    [
        113.19782830263,
        23.06343163641
    ],
    [
        113.19800442325,
        23.063391355745
    ],
    [
        113.19808418523,
        23.063379908854
    ],
    [
        113.19826493329,
        23.063339549825
    ],
    [
        113.19834877122,
        23.063316366568
    ],
    [
        113.19843615695,
        23.063306957954
    ],
    [
        113.19857525435,
        23.063273578078
    ],
    [
        113.19869040044,
        23.063250931288
    ],
    [
        113.19878947925,
        23.063221243271
    ],
    [
        113.19889345851,
        23.063192012771
    ],
    [
        113.19899498955,
        23.063166353478
    ],
    [
        113.1991313623,
        23.063132487212
    ],
    [
        113.19923316146,
        23.063101400031
    ],
    [
        113.19934911134,
        23.063061655715
    ],
    [
        113.19948221668,
        23.063029209436
    ],
    [
        113.19961613888,
        23.062997836601
    ],
    [
        113.19975850208,
        23.062969845968
    ],
    [
        113.19984969674,
        23.062961742592
    ],
    [
        113.19990522825,
        23.062953991145
    ],
    [
        113.20000812501,
        23.062940259879
    ],
    [
        113.20009224137,
        23.062933097359
    ],
    [
        113.20018860178,
        23.062916227349
    ],
    [
        113.20027190162,
        23.062910166868
    ],
    [
        113.20035954721,
        23.06288911033
    ],
    [
        113.20047333353,
        23.062878454054
    ],
    [
        113.20055853278,
        23.062864225835
    ],
    [
        113.200672031,
        23.062830517819
    ],
    [
        113.20077000984,
        23.062794096184
    ],
    [
        113.20089466286,
        23.062752061236
    ],
    [
        113.20106557822,
        23.062686714102
    ],
    [
        113.2011921425,
        23.062656048966
    ],
    [
        113.20133584044,
        23.062601760917
    ],
    [
        113.20147001491,
        23.062555508609
    ],
    [
        113.20156908035,
        23.062521527188
    ],
    [
        113.20167059591,
        23.062488591485
    ],
    [
        113.20175359771,
        23.062451904526
    ],
    [
        113.2018273533,
        23.062429484823
    ],
    [
        113.20187034706,
        23.062405148557
    ],
    [
        113.20191933006,
        23.062381796042
    ],
    [
        113.20197891823,
        23.062341985338
    ],
    [
        113.20208340458,
        23.062277537948
    ],
    [
        113.20214979286,
        23.062231103044
    ],
    [
        113.20225183324,
        23.062174298366
    ],
    [
        113.20234679248,
        23.062113003965
    ],
    [
        113.20245453406,
        23.062036031713
    ],
    [
        113.20254839898,
        23.061968792256
    ],
    [
        113.20264036358,
        23.061909997807
    ],
    [
        113.20273341037,
        23.061842505725
    ],
    [
        113.20281883531,
        23.061775686584
    ],
    [
        113.20292411747,
        23.06169063073
    ],
    [
        113.20304654154,
        23.061597695161
    ],
    [
        113.20315154447,
        23.061505597111
    ],
    [
        113.20320458716,
        23.06145560635
    ],
    [
        113.20330522525,
        23.061351919633
    ],
    [
        113.20340451119,
        23.061262095303
    ],
    [
        113.20352092518,
        23.061145944799
    ],
    [
        113.20359898553,
        23.061065973862
    ],
    [
        113.20366862248,
        23.061006763489
    ],
    [
        113.20376654726,
        23.060921585521
    ],
    [
        113.20391315991,
        23.060793015171
    ],
    [
        113.20401108074,
        23.060705674868
    ],
    [
        113.20406466298,
        23.060655418845
    ],
    [
        113.20415007497,
        23.060585380599
    ],
    [
        113.20422079503,
        23.060523723847
    ],
    [
        113.20430783792,
        23.060452578525
    ],
    [
        113.20437175245,
        23.060390765057
    ],
    [
        113.20443513597,
        23.060347410887
    ],
    [
        113.20450857321,
        23.060282461618
    ],
    [
        113.20461547317,
        23.060199880575
    ],
    [
        113.20470415949,
        23.060147170564
    ],
    [
        113.20477297807,
        23.060095597341
    ],
    [
        113.20485458864,
        23.060045176859
    ],
    [
        113.20496014134,
        23.059985150396
    ],
    [
        113.20510322843,
        23.059896040597
    ],
    [
        113.20520986252,
        23.059829767049
    ],
    [
        113.20533689847,
        23.0597525928
    ],
    [
        113.20547373235,
        23.05967825451
    ],
    [
        113.20555614848,
        23.059620790011
    ],
    [
        113.20565978644,
        23.05955729652
    ],
    [
        113.20572888202,
        23.059520396247
    ],
    [
        113.20579145218,
        23.059491739774
    ],
    [
        113.20586108842,
        23.059451307835
    ],
    [
        113.20591140247,
        23.059410908728
    ],
    [
        113.205994086,
        23.059352098773
    ],
    [
        113.20608248331,
        23.059292931547
    ],
    [
        113.20615319405,
        23.059237298134
    ],
    [
        113.20621928407,
        23.05918933534
    ],
    [
        113.20626197791,
        23.059150689956
    ],
    [
        113.2063452109,
        23.059102465522
    ],
    [
        113.20641130017,
        23.05905532235
    ],
    [
        113.20646325141,
        23.059024406257
    ],
    [
        113.20653260655,
        23.058978844345
    ],
    [
        113.20661746209,
        23.058920837959
    ],
    [
        113.20668110058,
        23.05887401179
    ],
    [
        113.20677057542,
        23.058809429231
    ],
    [
        113.20685868663,
        23.058742157999
    ],
    [
        113.20697753808,
        23.058665742391
    ],
    [
        113.20702866214,
        23.058625356479
    ],
    [
        113.20710453047,
        23.058563707029
    ],
    [
        113.20721113342,
        23.058486675608
    ],
    [
        113.20730413634,
        23.058417450375
    ],
    [
        113.20740938582,
        23.058352116112
    ],
    [
        113.20753747247,
        23.058265284855
    ],
    [
        113.20761469842,
        23.058205804686
    ],
    [
        113.20769437354,
        23.058147647848
    ],
    [
        113.20778002684,
        23.058080995216
    ],
    [
        113.20784963487,
        23.058024892395
    ],
    [
        113.20794426112,
        23.05795323121
    ],
    [
        113.20806037336,
        23.057872849851
    ],
    [
        113.2081596206,
        23.057798961187
    ],
    [
        113.20826974852,
        23.057723834646
    ],
    [
        113.20836628044,
        23.057659492223
    ],
    [
        113.20844186471,
        23.05759844088
    ],
    [
        113.20854165521,
        23.057529176855
    ],
    [
        113.20864062279,
        23.057453418354
    ],
    [
        113.20874827312,
        23.057351766382
    ],
    [
        113.20882548571,
        23.05729043621
    ],
    [
        113.20891465577,
        23.057214831614
    ],
    [
        113.20899484022,
        23.057131218569
    ],
    [
        113.20906333758,
        23.057061610605
    ],
    [
        113.20915413162,
        23.056979754712
    ],
    [
        113.20920957944,
        23.056922001903
    ],
    [
        113.20927697297,
        23.05683668111
    ],
    [
        113.20935851661,
        23.056756863875
    ],
    [
        113.2094452162,
        23.056663413108
    ],
    [
        113.2095264891,
        23.056587405885
    ],
    [
        113.20962814808,
        23.056493757864
    ],
    [
        113.20970452902,
        23.056425423134
    ],
    [
        113.20977465116,
        23.05635554933
    ],
    [
        113.20985184893,
        23.056289923206
    ],
    [
        113.2099184276,
        23.056213591873
    ],
    [
        113.2100037649,
        23.056125885394
    ],
    [
        113.21008747788,
        23.056048243917
    ],
    [
        113.21014672472,
        23.055988842129
    ],
    [
        113.21021248602,
        23.055914432619
    ],
    [
        113.21032527471,
        23.055806840134
    ],
    [
        113.21042665197,
        23.05571568582
    ],
    [
        113.21051578537,
        23.055621986218
    ],
    [
        113.21056986189,
        23.055564295801
    ],
    [
        113.21064893295,
        23.055474534517
    ],
    [
        113.21072284763,
        23.055398681835
    ],
    [
        113.21078290299,
        23.055337393175
    ],
    [
        113.21086632685,
        23.055251655572
    ],
    [
        113.21092637473,
        23.055183589365
    ],
    [
        113.21099050743,
        23.055121713049
    ],
    [
        113.21104321905,
        23.055062970862
    ],
    [
        113.21109320328,
        23.054996397151
    ],
    [
        113.21118966796,
        23.05489965623
    ],
    [
        113.2112627406,
        23.054802133671
    ],
    [
        113.21131952621,
        23.054739821661
    ],
    [
        113.21143064743,
        23.054614420809
    ],
    [
        113.21149095803,
        23.054542302977
    ],
    [
        113.21156323686,
        23.054472750575
    ],
    [
        113.21163033911,
        23.054394041316
    ],
    [
        113.21169473262,
        23.05432784951
    ],
    [
        113.21174146906,
        23.054284128043
    ],
    [
        113.21179225446,
        23.054208070557
    ],
    [
        113.21184197127,
        23.054153191057
    ],
    [
        113.21190037059,
        23.054077314426
    ],
    [
        113.21191530248,
        23.054049998383
    ],
    [
        113.21195550671,
        23.054002294078
    ],
    [
        113.21202858075,
        23.053916474648
    ],
    [
        113.21208887236,
        23.053830543227
    ],
    [
        113.21212933792,
        23.05377280145
    ],
    [
        113.2121817463,
        23.053691310817
    ],
    [
        113.21224448442,
        23.05360616993
    ],
    [
        113.21231049735,
        23.053534015721
    ],
    [
        113.21235639071,
        23.053466447126
    ],
    [
        113.2124177891,
        23.053404392063
    ],
    [
        113.21246801804,
        23.053321580969
    ],
    [
        113.21259567892,
        23.053168393539
    ],
    [
        113.2126793369,
        23.053068914642
    ],
    [
        113.21273230204,
        23.053006429551
    ],
    [
        113.21281977709,
        23.052919666061
    ],
    [
        113.21290263856,
        23.052843543142
    ],
    [
        113.21295043364,
        23.052779226934
    ],
    [
        113.21302188502,
        23.052715452845
    ],
    [
        113.21307512662,
        23.052660845531
    ],
    [
        113.21315526671,
        23.052585853851
    ],
    [
        113.2132272339,
        23.052495494443
    ],
    [
        113.21326607601,
        23.052454353432
    ],
    [
        113.21328671264,
        23.052425629804
    ],
    [
        113.2133168587,
        23.052389744176
    ],
    [
        113.2133480914,
        23.052353032919
    ],
    [
        113.21340486445,
        23.052298126682
    ],
    [
        113.21347168688,
        23.052232799533
    ],
    [
        113.21356701942,
        23.052128900363
    ],
    [
        113.2136161814,
        23.052077886205
    ],
    [
        113.21366290133,
        23.052032327349
    ],
    [
        113.21372483106,
        23.051971136462
    ],
    [
        113.21379871107,
        23.051897878635
    ],
    [
        113.21387640541,
        23.051833808046
    ],
    [
        113.21396088649,
        23.051760442987
    ],
    [
        113.21405704123,
        23.051671220126
    ],
    [
        113.21411408566,
        23.051622580472
    ],
    [
        113.21417900474,
        23.05156490509
    ],
    [
        113.21423469488,
        23.051522525466
    ],
    [
        113.21429934509,
        23.051469199899
    ],
    [
        113.21434932417,
        23.051425800401
    ],
    [
        113.21442565207,
        23.05136150428
    ],
    [
        113.21451638583,
        23.051295976336
    ],
    [
        113.21456527656,
        23.051253410229
    ],
    [
        113.21461227792,
        23.051224974419
    ],
    [
        113.21466985018,
        23.051165499805
    ],
    [
        113.21473775598,
        23.05111026239
    ],
    [
        113.21482006609,
        23.051052710298
    ],
    [
        113.21490753746,
        23.050992668892
    ],
    [
        113.21500640037,
        23.050908370321
    ],
    [
        113.21507049126,
        23.050847490701
    ],
    [
        113.2151440992,
        23.050790588955
    ],
    [
        113.2152155231,
        23.050725030657
    ],
    [
        113.2153143839,
        23.05064373991
    ],
    [
        113.21541244657,
        23.050581457227
    ],
    [
        113.21549364766,
        23.050511206044
    ],
    [
        113.21556400424,
        23.050469825198
    ],
    [
        113.2156454748,
        23.050399309635
    ],
    [
        113.2157155432,
        23.050343288295
    ],
    [
        113.21578588583,
        23.050290524078
    ],
    [
        113.21587252168,
        23.050224315106
    ],
    [
        113.21594612226,
        23.050169901056
    ],
    [
        113.2160153677,
        23.050109833995
    ],
    [
        113.21611803894,
        23.050047291035
    ],
    [
        113.21620630415,
        23.049984617011
    ],
    [
        113.21626767744,
        23.049936845545
    ],
    [
        113.21634154872,
        23.049886250576
    ],
    [
        113.21637088626,
        23.049872690309
    ],
    [
        113.21644584767,
        23.049826432835
    ],
    [
        113.21650722421,
        23.04978437088
    ],
    [
        113.21657810973,
        23.049740328314
    ],
    [
        113.21667832116,
        23.04967351178
    ],
    [
        113.21674024507,
        23.049637696975
    ],
    [
        113.21685947676,
        23.049571543024
    ],
    [
        113.21694666912,
        23.049533892539
    ],
    [
        113.21706644889,
        23.049476436297
    ],
    [
        113.21718107104,
        23.049426632045
    ],
    [
        113.21732366711,
        23.049365211435
    ],
    [
        113.21746761998,
        23.049305424405
    ],
    [
        113.21760667167,
        23.049238910649
    ],
    [
        113.21775305526,
        23.049171540904
    ],
    [
        113.2178660385,
        23.049126426794
    ],
    [
        113.21795322367,
        23.049096445619
    ],
    [
        113.21801921888,
        23.049069889359
    ],
    [
        113.21810124902,
        23.049049183649
    ],
    [
        113.21817649414,
        23.049036674565
    ],
    [
        113.2182666758,
        23.049019174585
    ],
    [
        113.21835413958,
        23.049001972889
    ],
    [
        113.21844840044,
        23.048991239637
    ],
    [
        113.21853042701,
        23.048973005488
    ],
    [
        113.21862033398,
        23.048957976331
    ],
    [
        113.21874092687,
        23.048932697428
    ],
    [
        113.21882757346,
        23.048920420425
    ],
    [
        113.21893078554,
        23.048904236594
    ],
    [
        113.21906305313,
        23.048879452779
    ],
    [
        113.21915349367,
        23.048863104229
    ],
    [
        113.21922411112,
        23.048854491735
    ],
    [
        113.21928629855,
        23.048837528149
    ],
    [
        113.219350117,
        23.048822456474
    ],
    [
        113.21942805958,
        23.048807567907
    ],
    [
        113.21950166284,
        23.048800309559
    ],
    [
        113.21958666927,
        23.048789184866
    ],
    [
        113.21966922576,
        23.048774011939
    ],
    [
        113.21975260277,
        23.048765622959
    ],
    [
        113.21983543918,
        23.048761041888
    ],
    [
        113.21989708219,
        23.048749541032
    ],
    [
        113.21995112384,
        23.048742159207
    ],
    [
        113.21999538357,
        23.048731039988
    ],
    [
        113.22003937825,
        23.048726707183
    ],
    [
        113.22012275638,
        23.048724856897
    ],
    [
        113.22022540224,
        23.048709334646
    ],
    [
        113.22029736943,
        23.048705935343
    ],
    [
        113.22040083839,
        23.048701819827
    ],
    [
        113.22047525274,
        23.048703573152
    ],
    [
        113.22056459259,
        23.048695481533
    ],
    [
        113.22063166525,
        23.048690231047
    ],
    [
        113.22072833479,
        23.048682112523
    ],
    [
        113.22087251328,
        23.048662086143
    ],
    [
        113.22098927584,
        23.048656327124
    ],
    [
        113.2210932703,
        23.048647659767
    ],
    [
        113.22118884395,
        23.048637958325
    ],
    [
        113.22120730922,
        23.048638409871
    ],
    [
        113.22126921793,
        23.048636207371
    ],
    [
        113.22133002574,
        23.048620176036
    ],
    [
        113.22140794892,
        23.048613563003
    ],
    [
        113.22153772469,
        23.048599388351
    ],
    [
        113.22160288184,
        23.048591220156
    ],
    [
        113.22166179691,
        23.04858661118
    ],
    [
        113.22176224621,
        23.048575308821
    ],
    [
        113.22188333118,
        23.048566910781
    ],
    [
        113.22197293208,
        23.048571139885
    ],
    [
        113.22201202925,
        23.048572060149
    ],
    [
        113.22207365376,
        23.048566376336
    ],
    [
        113.22215048311,
        23.048562533108
    ],
    [
        113.22220016105,
        23.048557447775
    ],
    [
        113.22226395919,
        23.048555564341
    ],
    [
        113.22237118744,
        23.048547274826
    ],
    [
        113.22242248037,
        23.048530526283
    ],
    [
        113.22255928746,
        23.048513731056
    ],
    [
        113.22260977191,
        23.048504591319
    ],
    [
        113.22271182582,
        23.048486857576
    ],
    [
        113.22279325099,
        23.048473275084
    ],
    [
        113.22292352909,
        23.048451935527
    ],
    [
        113.22302802063,
        23.048434765619
    ],
    [
        113.22314147328,
        23.048423003665
    ],
    [
        113.22325111762,
        23.048405567383
    ],
    [
        113.22332466305,
        23.048392048688
    ],
    [
        113.22339685778,
        23.048385864678
    ],
    [
        113.22348070875,
        23.048365814437
    ],
    [
        113.22353579818,
        23.048356161576
    ],
    [
        113.22359061589,
        23.048346783577
    ],
    [
        113.22367583224,
        23.048337868876
    ],
    [
        113.22376864728,
        23.048329483701
    ],
    [
        113.22385440526,
        23.048322209528
    ],
    [
        113.22395833526,
        23.048304587547
    ],
    [
        113.22401287778,
        23.048295774158
    ],
    [
        113.22411247789,
        23.04829337139
    ],
    [
        113.22422183034,
        23.048275490953
    ],
    [
        113.22433281187,
        23.048260602726
    ],
    [
        113.22439385757,
        23.048245825864
    ],
    [
        113.22448339392,
        23.048228012161
    ],
    [
        113.22460550274,
        23.048219642125
    ],
    [
        113.22469314815,
        23.048213787513
    ],
    [
        113.22476965917,
        23.048200904212
    ],
    [
        113.22484101997,
        23.048194546397
    ],
    [
        113.22492811131,
        23.048181386005
    ],
    [
        113.22500191238,
        23.048175306423
    ],
    [
        113.22511884739,
        23.048160761583
    ],
    [
        113.22513078725,
        23.048161559454
    ],
    [
        113.22521000699,
        23.0481503317
    ],
    [
        113.22530333568,
        23.048139906964
    ],
    [
        113.22538878867,
        23.048124072501
    ],
    [
        113.2254492884,
        23.048118038321
    ],
    [
        113.22549106454,
        23.048110398317
    ],
    [
        113.22557190734,
        23.048099738205
    ],
    [
        113.2256619758,
        23.048091246882
    ],
    [
        113.22571433114,
        23.04808333529
    ],
    [
        113.22580657012,
        23.048077296256
    ],
    [
        113.22586923743,
        23.048073183416
    ],
    [
        113.22592701478,
        23.048063379368
    ],
    [
        113.22599808562,
        23.048054113856
    ],
    [
        113.22604610522,
        23.048054360472
    ],
    [
        113.22611093254,
        23.048042934925
    ],
    [
        113.22616816577,
        23.048034229375
    ],
    [
        113.22621156227,
        23.048024988818
    ],
    [
        113.22627719863,
        23.048010859797
    ],
    [
        113.22633715089,
        23.048010030889
    ],
    [
        113.22641444889,
        23.047994279798
    ],
    [
        113.22648498335,
        23.04799752747
    ],
    [
        113.22663579059,
        23.047980160744
    ],
    [
        113.22672774498,
        23.047976914027
    ],
    [
        113.22682078112,
        23.04797204749
    ],
    [
        113.22690323604,
        23.047966371756
    ],
    [
        113.2269905757,
        23.04796423144
    ],
    [
        113.22708849314,
        23.047962917207
    ],
    [
        113.22717094582,
        23.047959161293
    ],
    [
        113.22726206998,
        23.047948905462
    ],
    [
        113.2273385521,
        23.047944344641
    ],
    [
        113.22739902588,
        23.047934893037
    ],
    [
        113.22749421689,
        23.047927101942
    ],
    [
        113.22757583628,
        23.047910352874
    ],
    [
        113.22769136543,
        23.047903141042
    ],
    [
        113.22780336281,
        23.047892410379
    ],
    [
        113.22789718971,
        23.047883839447
    ],
    [
        113.22798071121,
        23.047876891104
    ],
    [
        113.22806043805,
        23.047873199871
    ],
    [
        113.22816781329,
        23.047858430927
    ],
    [
        113.22823506295,
        23.047854734204
    ],
    [
        113.22835490709,
        23.047838375319
    ],
    [
        113.22842973971,
        23.047827377613
    ],
    [
        113.22853954796,
        23.047812649934
    ],
    [
        113.22862901933,
        23.047800336301
    ],
    [
        113.22872283243,
        23.047792651247
    ],
    [
        113.22879168976,
        23.047777054248
    ],
    [
        113.22888983863,
        23.047769663979
    ],
    [
        113.22894324295,
        23.047758384668
    ],
    [
        113.22902864594,
        23.047751521669
    ],
    [
        113.22909913584,
        23.0477454443
    ],
    [
        113.22916880919,
        23.047737198973
    ],
    [
        113.22924470874,
        23.047720291221
    ],
    [
        113.22931844708,
        23.047712065617
    ],
    [
        113.22940546384,
        23.047698453399
    ],
    [
        113.2294913936,
        23.047683759933
    ],
    [
        113.22958409342,
        23.047662851739
    ],
    [
        113.22969522863,
        23.047643632632
    ],
    [
        113.22981151246,
        23.047624440346
    ],
    [
        113.22992128329,
        23.047601170421
    ],
    [
        113.23006900022,
        23.047573963991
    ],
    [
        113.23017794946,
        23.047547732731
    ],
    [
        113.23032944992,
        23.04751623307
    ],
    [
        113.23046468952,
        23.047492021449
    ],
    [
        113.23058014068,
        23.047470194913
    ],
    [
        113.23066713915,
        23.047458854023
    ],
    [
        113.2307367829,
        23.047441755305
    ],
    [
        113.23084952413,
        23.047426187138
    ],
    [
        113.2309443791,
        23.047415441959
    ],
    [
        113.23099478062,
        23.047403437179
    ],
    [
        113.23106143816,
        23.047385804205
    ],
    [
        113.23111888357,
        23.047371935074
    ],
    [
        113.23120317083,
        23.047368222277
    ],
    [
        113.23125168135,
        23.047364632172
    ],
    [
        113.2312917821,
        23.047353681837
    ],
    [
        113.23135518593,
        23.04733822304
    ],
    [
        113.23146304568,
        23.047332192426
    ],
    [
        113.23149095496,
        23.047326892182
    ],
    [
        113.23155436814,
        23.047322840393
    ],
    [
        113.23163810914,
        23.047321600149
    ],
    [
        113.23174108966,
        23.047319914997
    ],
    [
        113.2318264488,
        23.047313812858
    ],
    [
        113.23190042002,
        23.04730304889
    ],
    [
        113.23196790476,
        23.047310164899
    ],
    [
        113.23206464523,
        23.047307393442
    ],
    [
        113.23221423033,
        23.047309515576
    ],
    [
        113.2323039183,
        23.047304015067
    ],
    [
        113.23240742772,
        23.047301851563
    ],
    [
        113.23251175922,
        23.047310554977
    ],
    [
        113.2326431715,
        23.047306395026
    ],
    [
        113.23280601261,
        23.047303786068
    ],
    [
        113.23291520866,
        23.047307670822
    ],
    [
        113.23302440118,
        23.047310209478
    ],
    [
        113.23308752773,
        23.047308142027
    ],
    [
        113.23317152503,
        23.047315428771
    ],
    [
        113.23325632912,
        23.04731811417
    ],
    [
        113.23331295469,
        23.047319818055
    ],
    [
        113.23336335008,
        23.04732311403
    ],
    [
        113.23344436394,
        23.047331216357
    ],
    [
        113.23351942312,
        23.047345798397
    ],
    [
        113.23351915137,
        23.047344982708
    ],
    [
        113.23358960096,
        23.047356555599
    ],
    [
        113.23367087775,
        23.047360063165
    ],
    [
        113.23374619842,
        23.047368421335
    ],
    [
        113.23378304637,
        23.04737327524
    ],
    [
        113.23385159245,
        23.047381053191
    ],
    [
        113.23392284308,
        23.047385326123
    ],
    [
        113.23400819158,
        23.047401636881
    ],
    [
        113.23412550375,
        23.047418172917
    ],
    [
        113.23424715599,
        23.047442890721
    ],
    [
        113.23434794499,
        23.047464489316
    ],
    [
        113.23443437201,
        23.047482195634
    ],
    [
        113.23451239157,
        23.047490894195
    ],
    [
        113.23461208106,
        23.047501383499
    ],
    [
        113.23469931975,
        23.047522099848
    ],
    [
        113.23479198705,
        23.047555343827
    ],
    [
        113.2348821988,
        23.047572568674
    ],
    [
        113.23495318217,
        23.047592910523
    ],
    [
        113.23503255424,
        23.047606808973
    ],
    [
        113.23509838365,
        23.047621151101
    ],
    [
        113.23519294211,
        23.047656069013
    ],
    [
        113.2352874871,
        23.047679327515
    ],
    [
        113.23538176362,
        23.047706389891
    ],
    [
        113.23541833832,
        23.047719161395
    ],
    [
        113.23553346142,
        23.047741789476
    ],
    [
        113.23561011882,
        23.047757061147
    ],
    [
        113.23569923441,
        23.047774067708
    ],
    [
        113.23578727429,
        23.047799754252
    ],
    [
        113.23588858269,
        23.047825829325
    ],
    [
        113.23600370469,
        23.047856370666
    ],
    [
        113.23612072559,
        23.047892365576
    ],
    [
        113.2362342131,
        23.047917759668
    ],
    [
        113.23629894902,
        23.047935142574
    ],
    [
        113.23637696241,
        23.047962141329
    ],
    [
        113.23650968925,
        23.048006179395
    ],
    [
        113.23661261535,
        23.04803748399
    ],
    [
        113.236712832,
        23.048068772693
    ],
    [
        113.23678460799,
        23.0480913998
    ],
    [
        113.2368937575,
        23.048123326954
    ],
    [
        113.23702079493,
        23.048174964575
    ],
    [
        113.23712208926,
        23.048207652811
    ],
    [
        113.23722419943,
        23.048245512017
    ],
    [
        113.23739646169,
        23.048315251114
    ],
    [
        113.23752185549,
        23.048358241285
    ],
    [
        113.2376304588,
        23.048398366651
    ],
    [
        113.23773689054,
        23.04843468139
    ],
    [
        113.2378785157,
        23.048472982661
    ],
    [
        113.23796787829,
        23.048499379244
    ],
    [
        113.23805236431,
        23.048523290928
    ],
    [
        113.2381799093,
        23.048565010485
    ],
    [
        113.23827548966,
        23.048587421808
    ],
    [
        113.23838596138,
        23.048614335191
    ],
    [
        113.23846692342,
        23.048638779955
    ],
    [
        113.23861069788,
        23.048677183301
    ],
    [
        113.23867730583,
        23.048696606382
    ],
    [
        113.23874770431,
        23.048717700973
    ],
    [
        113.2388294711,
        23.048739463282
    ],
    [
        113.23896998562,
        23.04877407225
    ],
    [
        113.23909371161,
        23.048804443452
    ],
    [
        113.23918685854,
        23.048842630597
    ],
    [
        113.23928513046,
        23.048864872718
    ],
    [
        113.23935064234,
        23.048877805481
    ],
    [
        113.23944701149,
        23.048894340529
    ],
    [
        113.23953282556,
        23.048912392049
    ],
    [
        113.23963326225,
        23.048939295934
    ],
    [
        113.2396917384,
        23.048956506856
    ],
    [
        113.2397588721,
        23.048971376724
    ],
    [
        113.23981382281,
        23.048982583713
    ],
    [
        113.23987471526,
        23.048982194115
    ],
    [
        113.23993562945,
        23.049003784357
    ],
    [
        113.24005202243,
        23.049026018252
    ],
    [
        113.24014486186,
        23.049040933135
    ],
    [
        113.2402263402,
        23.049061961556
    ],
    [
        113.24030970122,
        23.049072435329
    ],
    [
        113.24039117104,
        23.049086961458
    ],
    [
        113.24047614003,
        23.049083897999
    ],
    [
        113.240554079,
        23.049087538719
    ],
    [
        113.24067748505,
        23.049097698221
    ],
    [
        113.24080658118,
        23.049117433329
    ],
    [
        113.24089399266,
        23.04912636216
    ],
    [
        113.24099547534,
        23.04913682489
    ],
    [
        113.24109262412,
        23.049144256826
    ],
    [
        113.24117434048,
        23.049143907488
    ],
    [
        113.2413250685,
        23.049158257958
    ],
    [
        113.24141004649,
        23.049175055374
    ],
    [
        113.24150176921,
        23.049173492672
    ],
    [
        113.2416319253,
        23.049185716314
    ],
    [
        113.24170714645,
        23.049189655004
    ],
    [
        113.24179400194,
        23.049194559868
    ],
    [
        113.24191791883,
        23.049195604269
    ],
    [
        113.24203588284,
        23.049197938317
    ],
    [
        113.2422076876,
        23.049203966762
    ],
    [
        113.24231969267,
        23.049203802832
    ],
    [
        113.24242493861,
        23.049209526864
    ],
    [
        113.24263433038,
        23.04920741531
    ],
    [
        113.24277772183,
        23.049218554409
    ],
    [
        113.24293624582,
        23.049215801748
    ],
    [
        113.24305203359,
        23.049221437874
    ],
    [
        113.2432373444,
        23.049230202031
    ],
    [
        113.24333580695,
        23.049227481676
    ],
    [
        113.24341506745,
        23.049229657446
    ],
    [
        113.24355572496,
        23.049225904166
    ],
    [
        113.24364391292,
        23.04923119902
    ],
    [
        113.24373615276,
        23.049231942623
    ],
    [
        113.24382514921,
        23.04923617286
    ],
    [
        113.24388952577,
        23.04923599156
    ],
    [
        113.24401583917,
        23.049231803186
    ],
    [
        113.24411348334,
        23.049231286721
    ],
    [
        113.24423898284,
        23.049227916863
    ],
    [
        113.24435960699,
        23.049219602291
    ],
    [
        113.24445156375,
        23.049215495841
    ],
    [
        113.24458192391,
        23.049209235489
    ],
    [
        113.2447342087,
        23.049221752748
    ],
    [
        113.24486402383,
        23.049215504627
    ],
    [
        113.24502008099,
        23.049218875744
    ],
    [
        113.245124483,
        23.049225838612
    ],
    [
        113.24525296041,
        23.049239404046
    ],
    [
        113.24536546972,
        23.049242973115
    ],
    [
        113.24544931727,
        23.049252904047
    ],
    [
        113.24554803988,
        23.049264417751
    ],
    [
        113.24565838713,
        23.0492728552
    ],
    [
        113.24574386025,
        23.049288249561
    ],
    [
        113.24581606617,
        23.04928852467
    ],
    [
        113.24589828694,
        23.049298178852
    ],
    [
        113.24602863884,
        23.049303683986
    ],
    [
        113.24617656706,
        23.049309737264
    ],
    [
        113.24631989593,
        23.049315730574
    ],
    [
        113.24639939853,
        23.049315595688
    ],
    [
        113.24656381406,
        23.049319217045
    ],
    [
        113.24666251804,
        23.049323187512
    ],
    [
        113.24678583453,
        23.049333514521
    ],
    [
        113.24689237308,
        23.04933246239
    ],
    [
        113.24699323426,
        23.049333497055
    ],
    [
        113.24709247702,
        23.049339394625
    ],
    [
        113.24719603928,
        23.049339395615
    ],
    [
        113.24731150137,
        23.049342845187
    ],
    [
        113.24738747796,
        23.049339163324
    ],
    [
        113.24747751535,
        23.049336521085
    ],
    [
        113.24755322757,
        23.049339894749
    ],
    [
        113.24763380385,
        23.049340906522
    ],
    [
        113.24774141207,
        23.049336112699
    ],
    [
        113.24785714101,
        23.049341492705
    ],
    [
        113.24795825665,
        23.049335247894
    ],
    [
        113.24807668511,
        23.049338511185
    ],
    [
        113.24820727529,
        23.049337907055
    ],
    [
        113.24834164331,
        23.049331402002
    ],
    [
        113.24842166977,
        23.049328632244
    ],
    [
        113.24854658024,
        23.049329581082
    ],
    [
        113.2486504085,
        23.049337788068
    ],
    [
        113.24881073924,
        23.049343941117
    ],
    [
        113.24892807094,
        23.049339899817
    ],
    [
        113.24899728952,
        23.049347008417
    ],
    [
        113.24911867389,
        23.049341956743
    ],
    [
        113.24920166656,
        23.049336274707
    ],
    [
        113.24926140845,
        23.049330481053
    ],
    [
        113.24934792174,
        23.049331644581
    ],
    [
        113.24939576939,
        23.049327555527
    ],
    [
        113.24944036389,
        23.049314730958
    ],
    [
        113.24948550635,
        23.049309241792
    ],
    [
        113.24952687117,
        23.049311015974
    ],
    [
        113.24959905518,
        23.049312762177
    ],
    [
        113.24967365826,
        23.049300984618
    ],
    [
        113.24973745642,
        23.049298252929
    ],
    [
        113.24980611176,
        23.049286921754
    ],
    [
        113.24988396315,
        23.049280358812
    ],
    [
        113.24994423829,
        23.049269975375
    ],
    [
        113.25004209317,
        23.049262667177
    ],
    [
        113.25010615576,
        23.049255606387
    ],
    [
        113.25017265415,
        23.049251572467
    ],
    [
        113.25024753413,
        23.049249038077
    ],
    [
        113.2503364644,
        23.049239960124
    ],
    [
        113.25040512454,
        23.049235967476
    ],
    [
        113.2504913627,
        23.049238786045
    ],
    [
        113.25060463229,
        23.049240709582
    ],
    [
        113.25072950999,
        23.049227640682
    ],
    [
        113.25085169887,
        23.049229724113
    ],
    [
        113.25095198908,
        23.04923008064
    ],
    [
        113.25105173122,
        23.049223647546
    ],
    [
        113.25115282692,
        23.04921968218
    ],
    [
        113.25132934687,
        23.049221899351
    ],
    [
        113.25140854351,
        23.049215936263
    ],
    [
        113.2514942319,
        23.049214427715
    ],
    [
        113.25160532404,
        23.049207661728
    ],
    [
        113.25176804677,
        23.049202605587
    ],
    [
        113.25185075856,
        23.049199424927
    ],
    [
        113.25195454625,
        23.049188471746
    ],
    [
        113.2520526643,
        23.049184748112
    ],
    [
        113.25211915991,
        23.049184817997
    ],
    [
        113.25218537678,
        23.049176744433
    ],
    [
        113.25227376243,
        23.049172584888
    ],
    [
        113.25235268997,
        23.049171246622
    ],
    [
        113.25241594076,
        23.049170992777
    ],
    [
        113.25249243205,
        23.049166629753
    ],
    [
        113.25254917975,
        23.049151070242
    ],
    [
        113.25263891232,
        23.049143684895
    ],
    [
        113.25272702083,
        23.049134373426
    ],
    [
        113.2528462115,
        23.049123166098
    ],
    [
        113.25294350358,
        23.049108050042
    ],
    [
        113.25304054233,
        23.049110024258
    ],
    [
        113.25313053507,
        23.049094240568
    ],
    [
        113.25322622115,
        23.049095651415
    ],
    [
        113.25331379081,
        23.049089866594
    ],
    [
        113.25338838452,
        23.049082497825
    ],
    [
        113.25352649857,
        23.049076792378
    ],
    [
        113.25359839708,
        23.04907751799
    ],
    [
        113.25371867487,
        23.049075571495
    ],
    [
        113.25382191789,
        23.049067628187
    ],
    [
        113.25393570871,
        23.04906638452
    ],
    [
        113.25405274134,
        23.049063843299
    ],
    [
        113.25415761705,
        23.049067599985
    ],
    [
        113.25425005549,
        23.049067610316
    ],
    [
        113.25433682365,
        23.049073490027
    ],
    [
        113.25442520954,
        23.049075600797
    ],
    [
        113.25455656986,
        23.04907684758
    ],
    [
        113.25467604642,
        23.049087109663
    ],
    [
        113.25478930413,
        23.049095363232
    ],
    [
        113.25487553904,
        23.049109377506
    ],
    [
        113.25495608706,
        23.04911270977
    ],
    [
        113.25505420536,
        23.049117983208
    ],
    [
        113.25513043487,
        23.049127479965
    ],
    [
        113.25518043512,
        23.049125385894
    ],
    [
        113.25525693313,
        23.049133260167
    ],
    [
        113.25534585962,
        23.049136743867
    ],
    [
        113.25543154312,
        23.049140712852
    ],
    [
        113.25549831992,
        23.049157639738
    ],
    [
        113.25555806538,
        23.049170643009
    ],
    [
        113.25562185357,
        23.049172323178
    ],
    [
        113.25569511492,
        23.04918719578
    ],
    [
        113.25574213898,
        23.04918233693
    ],
    [
        113.2558207972,
        23.049188623982
    ],
    [
        113.25592054262,
        23.049200171275
    ],
    [
        113.25600541266,
        23.049201957225
    ],
    [
        113.25611084002,
        23.049219575441
    ],
    [
        113.25616570938,
        23.049221911476
    ],
    [
        113.25622274979,
        23.049232968506
    ],
    [
        113.2563065438,
        23.049239890795
    ],
    [
        113.2564754876,
        23.049258100854
    ],
    [
        113.25655983011,
        23.049272901291
    ],
    [
        113.2566557938,
        23.049286823914
    ],
    [
        113.25674959083,
        23.049296366697
    ],
    [
        113.25684691037,
        23.049314654442
    ],
    [
        113.25694450297,
        23.049335660084
    ],
    [
        113.25703883052,
        23.049335173108
    ],
    [
        113.2571507437,
        23.049351821429
    ],
    [
        113.25722967958,
        23.049365439158
    ],
    [
        113.25731563692,
        23.049373212911
    ],
    [
        113.25738024771,
        23.049386574663
    ],
    [
        113.25744242047,
        23.049394466394
    ],
    [
        113.25751595683,
        23.049413955916
    ],
    [
        113.25760435765,
        23.049432353531
    ],
    [
        113.25767085981,
        23.049444934126
    ],
    [
        113.25776547685,
        23.049462899083
    ],
    [
        113.25787957856,
        23.049504815154
    ],
    [
        113.25796934325,
        23.049535173088
    ],
    [
        113.25810803279,
        23.049568842806
    ],
    [
        113.25821077276,
        23.049600515199
    ],
    [
        113.25839543841,
        23.049661045638
    ],
    [
        113.25853711853,
        23.049711042444
    ],
    [
        113.25866473895,
        23.049755904115
    ],
    [
        113.25876856578,
        23.049792202731
    ],
    [
        113.25887996132,
        23.049828905546
    ],
    [
        113.25897649234,
        23.049866700356
    ],
    [
        113.25913250502,
        23.049922096534
    ],
    [
        113.25927094008,
        23.049968225567
    ],
    [
        113.25941208025,
        23.050016027633
    ],
    [
        113.25955430979,
        23.05007144295
    ],
    [
        113.25970114016,
        23.05013209126
    ],
    [
        113.25978982726,
        23.050162411464
    ],
    [
        113.25984525784,
        23.050182378411
    ],
    [
        113.25989636778,
        23.050206338705
    ],
    [
        113.26000183235,
        23.050255128887
    ],
    [
        113.26010404468,
        23.050294906638
    ],
    [
        113.26020031123,
        23.050335121021
    ],
    [
        113.26033092392,
        23.050393027708
    ],
    [
        113.26041610327,
        23.05042761793
    ],
    [
        113.26047397025,
        23.050450063108
    ],
    [
        113.26057455704,
        23.050484377173
    ],
    [
        113.26064215791,
        23.050509432106
    ],
    [
        113.2607119209,
        23.050533981139
    ],
    [
        113.26075111876,
        23.050537648265
    ],
    [
        113.26080762574,
        23.050550841072
    ],
    [
        113.26085736751,
        23.050556318675
    ],
    [
        113.26092955797,
        23.050574937742
    ],
    [
        113.26099255019,
        23.0505855278
    ],
    [
        113.26108313916,
        23.050621285492
    ],
    [
        113.26116100398,
        23.050637014766
    ],
    [
        113.26120696427,
        23.050644593577
    ],
    [
        113.26130130721,
        23.050648938908
    ],
    [
        113.26139483907,
        23.050652725513
    ],
    [
        113.26150512491,
        23.050650558599
    ],
    [
        113.26157648632,
        23.050648803782
    ],
    [
        113.26165811342,
        23.05064044137
    ],
    [
        113.26175944412,
        23.050602028183
    ],
    [
        113.26186022143,
        23.050550308294
    ],
    [
        113.26189130331,
        23.050545414887
    ],
    [
        113.26192182402,
        23.050519891454
    ],
    [
        113.26197152083,
        23.050477603115
    ],
    [
        113.26202551532,
        23.050407713207
    ],
    [
        113.26207353748,
        23.050312487843
    ],
    [
        113.26210886783,
        23.050230610926
    ],
    [
        113.26212496219,
        23.050105808212
    ],
    [
        113.26214400302,
        23.049954195203
    ],
    [
        113.26214605496,
        23.049844075034
    ],
    [
        113.26215858756,
        23.049672544503
    ],
    [
        113.26216898516,
        23.049528651914
    ],
    [
        113.26216691977,
        23.049357143391
    ],
    [
        113.26216131788,
        23.049163868966
    ],
    [
        113.26214305671,
        23.049016231199
    ],
    [
        113.2621288624,
        23.04888060079
    ],
    [
        113.26211792125,
        23.048754250707
    ],
    [
        113.2620963829,
        23.048574269706
    ],
    [
        113.26209352372,
        23.048420925704
    ],
    [
        113.26207611229,
        23.048312100585
    ],
    [
        113.26206198205,
        23.048239959524
    ],
    [
        113.26204863622,
        23.048141785199
    ],
    [
        113.26202854795,
        23.048058960672
    ],
    [
        113.26200735843,
        23.047956582219
    ],
    [
        113.26198265077,
        23.04785034495
    ],
    [
        113.26195713459,
        23.047746535536
    ],
    [
        113.26192759291,
        23.047671416798
    ],
    [
        113.26187014404,
        23.047533416006
    ],
    [
        113.26182673405,
        23.047378019513
    ],
    [
        113.26178773225,
        23.047303822621
    ],
    [
        113.26175191913,
        23.047175687604
    ],
    [
        113.26170288163,
        23.047068216517
    ],
    [
        113.26166221946,
        23.046956276461
    ],
    [
        113.26162858514,
        23.046843914295
    ],
    [
        113.26156654135,
        23.046705829925
    ],
    [
        113.26152237884,
        23.04660712279
    ],
    [
        113.26149580551,
        23.046526625547
    ],
    [
        113.2614835744,
        23.04646129804
    ],
    [
        113.26145833156,
        23.04636020324
    ],
    [
        113.26141850185,
        23.046268895346
    ],
    [
        113.26139542551,
        23.046171636026
    ],
    [
        113.26135664825,
        23.046052128521
    ],
    [
        113.26132895768,
        23.04593633942
    ],
    [
        113.26128799437,
        23.045793731382
    ],
    [
        113.26125274895,
        23.045691377113
    ],
    [
        113.26122344388,
        23.045582613708
    ],
    [
        113.26118763099,
        23.045453931138
    ],
    [
        113.26116998044,
        23.045375485583
    ],
    [
        113.26115231519,
        23.04528265979
    ],
    [
        113.26114033074,
        23.045194002142
    ],
    [
        113.26112945314,
        23.045130325003
    ],
    [
        113.26110826555,
        23.045029298439
    ],
    [
        113.26107133151,
        23.044861254267
    ],
    [
        113.26104794243,
        23.044721933276
    ],
    [
        113.26102311093,
        23.044493594523
    ],
    [
        113.26101268134,
        23.044339033057
    ],
    [
        113.26099092199,
        23.044207065727
    ],
    [
        113.26099771799,
        23.043979547154
    ],
    [
        113.26100160742,
        23.043817366008
    ],
    [
        113.2610152305,
        23.043657524356
    ],
    [
        113.26104130638,
        23.043515805764
    ],
    [
        113.26106979157,
        23.043350795423
    ],
    [
        113.26109017502,
        23.043192970096
    ],
    [
        113.26112839477,
        23.043030841388
    ],
    [
        113.26116312788,
        23.042895512528
    ],
    [
        113.26123274209,
        23.042770825903
    ],
    [
        113.26130390881,
        23.042576978847
    ],
    [
        113.26138672739,
        23.042410735012
    ],
    [
        113.26146225181,
        23.042248162231
    ],
    [
        113.26154592449,
        23.042123713031
    ],
    [
        113.26163770001,
        23.041992075968
    ],
    [
        113.26172057479,
        23.041879547452
    ],
    [
        113.26179643277,
        23.041778020805
    ],
    [
        113.26185935054,
        23.041711270806
    ],
    [
        113.26191606923,
        23.041662591866
    ],
    [
        113.26202222677,
        23.041583556532
    ],
    [
        113.26218459399,
        23.041485942725
    ],
    [
        113.26229995805,
        23.041420622301
    ],
    [
        113.26239021948,
        23.041392584551
    ],
    [
        113.26248210474,
        23.041365928622
    ],
    [
        113.26260454734,
        23.041348741514
    ],
    [
        113.262672929,
        23.041336333353
    ],
    [
        113.26275646176,
        23.041336117776
    ],
    [
        113.26286837876,
        23.041334479555
    ],
    [
        113.26294298991,
        23.041332752184
    ],
    [
        113.26301462656,
        23.041329887788
    ],
    [
        113.26309438302,
        23.04133638291
    ],
    [
        113.26310059259,
        23.041328076311
    ],
    [
        113.26311734721,
        23.041321574594
    ],
    [
        113.26311409123,
        23.041309581972
    ],
    [
        113.26312640598,
        23.041187695698
    ],
    [
        113.26315153907,
        23.04090567581
    ],
    [
        113.26318028391,
        23.040721390667
    ],
    [
        113.26321149494,
        23.040570247351
    ],
    [
        113.2632208897,
        23.040501761485
    ],
    [
        113.26325378158,
        23.040410064403
    ],
    [
        113.26326723308,
        23.04034300291
    ],
    [
        113.26327062163,
        23.040214184082
    ],
    [
        113.2632628982,
        23.040056419793
    ],
    [
        113.26323110746,
        23.039891198421
    ],
    [
        113.26320288958,
        23.039785726291
    ],
    [
        113.26315357684,
        23.039671489443
    ],
    [
        113.26308100258,
        23.039544109444
    ],
    [
        113.26300277917,
        23.039445121017
    ],
    [
        113.2629773479,
        23.039424887133
    ],
    [
        113.26293839541,
        23.039400084345
    ],
    [
        113.26285290688,
        23.039335427091
    ],
    [
        113.26279745335,
        23.039299220326
    ],
    [
        113.26272604825,
        23.039260843818
    ],
    [
        113.26259516142,
        23.039213047728
    ],
    [
        113.26242856251,
        23.039134252589
    ],
    [
        113.26234255027,
        23.039084224538
    ],
    [
        113.26226193785,
        23.039026689564
    ],
    [
        113.26217888047,
        23.038956087915
    ],
    [
        113.26213991504,
        23.038915539489
    ],
    [
        113.26211554047,
        23.038867914363
    ],
    [
        113.26209926602,
        23.038810117484
    ],
    [
        113.2620954056,
        23.038730284794
    ],
    [
        113.26210156443,
        23.038668530108
    ],
    [
        113.26211738353,
        23.038531243475
    ],
    [
        113.26214542798,
        23.038457924608
    ],
    [
        113.26219478721,
        23.038341016147
    ],
    [
        113.26224982917,
        23.038229901524
    ],
    [
        113.26230541808,
        23.038125035652
    ],
    [
        113.26234805938,
        23.038049793293
    ],
    [
        113.26236449816,
        23.037994996072
    ],
    [
        113.2623682185,
        23.037926145447
    ],
    [
        113.26236707978,
        23.037864537686
    ],
    [
        113.26235240259,
        23.037779095288
    ],
    [
        113.26233795015,
        23.037644277492
    ],
    [
        113.26233568712,
        23.03753571332
    ],
    [
        113.26232774139,
        23.037420540951
    ],
    [
        113.26233008554,
        23.037323993101
    ],
    [
        113.26233721492,
        23.03713907847
    ],
    [
        113.26235007398,
        23.037011237282
    ],
    [
        113.26235592749,
        23.036908237777
    ],
    [
        113.26237474001,
        23.036786466796
    ],
    [
        113.26238782947,
        23.036613049015
    ],
    [
        113.26239259441,
        23.036500806497
    ],
    [
        113.26239654115,
        23.036380139433
    ],
    [
        113.26240373057,
        23.036257628367
    ],
    [
        113.26242203928,
        23.036174917924
    ],
    [
        113.26242981963,
        23.036108307291
    ],
    [
        113.26244761207,
        23.03605271922
    ],
    [
        113.2624567801,
        23.036026557645
    ],
    [
        113.26248433401,
        23.036004235243
    ],
    [
        113.26250432147,
        23.035985039986
    ],
    [
        113.26253189299,
        23.035982523288
    ],
    [
        113.2626078554,
        23.035981640295
    ],
    [
        113.26273519845,
        23.03599980222
    ],
    [
        113.26283739149,
        23.036006953911
    ],
    [
        113.26293444797,
        23.036013201965
    ],
    [
        113.26305124445,
        23.036024662423
    ],
    [
        113.26320426964,
        23.036038353556
    ],
    [
        113.26351898654,
        23.036077794872
    ],
    [
        113.26366065925,
        23.036088560692
    ],
    [
        113.26370590842,
        23.035896408484
    ],
    [
        113.2637722352,
        23.035691581915
    ],
    [
        113.26382858217,
        23.035511820931
    ],
    [
        113.26386871393,
        23.03533775991
    ],
    [
        113.2639037505,
        23.035210822462
    ],
    [
        113.26393579179,
        23.035058332012
    ],
    [
        113.26394463681,
        23.034968674089
    ],
    [
        113.26396318964,
        23.034849332141
    ],
    [
        113.2639850174,
        23.034765585796
    ],
    [
        113.2640103592,
        23.034680811974
    ],
    [
        113.26403675138,
        23.034558885766
    ],
    [
        113.26405748398,
        23.034457757115
    ],
    [
        113.26408795863,
        23.034367098381
    ],
    [
        113.26411060051,
        23.034285263825
    ],
    [
        113.26412700331,
        23.034178094816
    ],
    [
        113.26415097872,
        23.034073491941
    ],
    [
        113.26416170485,
        23.033966500927
    ],
    [
        113.2641813514,
        23.033857214578
    ],
    [
        113.26419609925,
        23.033707965399
    ],
    [
        113.26420550329,
        23.033635951564
    ],
    [
        113.26423569251,
        23.033523310942
    ],
    [
        113.26426071687,
        23.033375315379
    ],
    [
        113.26428655593,
        23.03323086006
    ],
    [
        113.26432133968,
        23.033113953051
    ],
    [
        113.2643485513,
        23.032993937497
    ],
    [
        113.26438521615,
        23.032861053446
    ],
    [
        113.26440300044,
        23.032784835263
    ],
    [
        113.26443455351,
        23.032682796223
    ],
    [
        113.26444722834,
        23.032641221734
    ],
    [
        113.26446473809,
        23.032558758705
    ],
    [
        113.26448466719,
        23.032457886184
    ],
    [
        113.26450405322,
        23.032353477746
    ],
    [
        113.26452749028,
        23.032242623845
    ],
    [
        113.26455606325,
        23.032129682933
    ],
    [
        113.2645738288,
        23.032025790447
    ],
    [
        113.26459563648,
        23.031903514835
    ],
    [
        113.26462744332,
        23.03177434763
    ],
    [
        113.26464223802,
        23.031672848412
    ],
    [
        113.26465812748,
        23.031588730467
    ],
    [
        113.26468186032,
        23.031507724066
    ],
    [
        113.2647063982,
        23.031418048789
    ],
    [
        113.26472685759,
        23.031296564623
    ],
    [
        113.26476462389,
        23.03117834497
    ],
    [
        113.2647918453,
        23.031058869066
    ],
    [
        113.26481016351,
        23.030965294185
    ],
    [
        113.264830636,
        23.030859002779
    ],
    [
        113.26485811385,
        23.030717555001
    ],
    [
        113.26487532954,
        23.030592219599
    ],
    [
        113.26489500052,
        23.030497309734
    ],
    [
        113.26492221843,
        23.030367794742
    ],
    [
        113.26494159843,
        23.030241680193
    ],
    [
        113.26496017352,
        23.030123691707
    ],
    [
        113.26498224077,
        23.029971304075
    ],
    [
        113.26500650019,
        23.029860732137
    ],
    [
        113.26503590126,
        23.029755940057
    ],
    [
        113.26504638427,
        23.029663323539
    ],
    [
        113.26506174659,
        23.029588962618
    ],
    [
        113.26508247167,
        23.02944604866
    ],
    [
        113.26509941754,
        23.029311213034
    ],
    [
        113.26512342106,
        23.029217999601
    ],
    [
        113.26512259235,
        23.02919085628
    ],
    [
        113.26516531898,
        23.029200222975
    ],
    [
        113.26531537994,
        23.029195569264
    ],
    [
        113.26538703264,
        23.029195355454
    ],
    [
        113.26545003057,
        23.02919093232
    ],
    [
        113.26550410811,
        23.029189892735
    ],
    [
        113.26557035161,
        23.029185789204
    ],
    [
        113.26564254967,
        23.02919018831
    ],
    [
        113.26573800661,
        23.029201192223
    ],
    [
        113.26580074134,
        23.029204894379
    ],
    [
        113.26588917035,
        23.029217680317
    ],
    [
        113.26593297917,
        23.029223523013
    ],
    [
        113.26595595798,
        23.029215201928
    ],
    [
        113.2659697413,
        23.029204023454
    ],
    [
        113.26597028106,
        23.029202404114
    ],
    [
        113.26598295618,
        23.029149970552
    ],
    [
        113.26601400899,
        23.029082089371
    ],
    [
        113.26603341968,
        23.028990693842
    ],
    [
        113.26604498602,
        23.028894563411
    ],
    [
        113.26603901475,
        23.02885920104
    ],
    [
        113.26604684766,
        23.02884521601
    ],
    [
        113.26603466923,
        23.028829018795
    ],
    [
        113.26600167259,
        23.028817378915
    ],
    [
        113.26592189699,
        23.02880663243
    ],
    [
        113.26579670247,
        23.02880791905
    ],
    [
        113.26563473095,
        23.028801834521
    ],
    [
        113.26546492033,
        23.028795613966
    ],
    [
        113.26537352067,
        23.028783035728
    ],
    [
        113.26538968565,
        23.028689966364
    ],
    [
        113.26539421642,
        23.02858423191
    ],
    [
        113.26540386726,
        23.028449550122
    ],
    [
        113.26540676701,
        23.028327783268
    ],
    [
        113.26539722281,
        23.028194966434
    ],
    [
        113.26538931472,
        23.028083879596
    ],
    [
        113.265380883,
        23.028000728143
    ],
    [
        113.26538378048,
        23.027871094103
    ],
    [
        113.26538532801,
        23.027743609066
    ],
    [
        113.26538825761,
        23.027666878693
    ],
    [
        113.26543097692,
        23.027662946843
    ],
    [
        113.26551966704,
        23.027665984308
    ],
    [
        113.26559024096,
        23.027668188818
    ],
    [
        113.26570245136,
        23.027661825155
    ],
    [
        113.2658173702,
        23.027661195864
    ],
    [
        113.26589903506,
        23.027667906187
    ],
    [
        113.26597907446,
        23.027668348228
    ],
    [
        113.26605289554,
        23.027669504033
    ],
    [
        113.26611887083,
        23.027662938596
    ],
    [
        113.26619675312,
        23.027671206688
    ],
    [
        113.26628652457,
        23.027663107591
    ],
    [
        113.26634899047,
        23.027664348277
    ],
    [
        113.26640550898,
        23.027667936774
    ],
    [
        113.26647256844,
        23.027661919932
    ],
    [
        113.26654558607,
        23.027670642841
    ],
    [
        113.26662265693,
        23.027673185717
    ],
    [
        113.26671135882,
        23.027679702283
    ],
    [
        113.2668344053,
        23.02768592601
    ],
    [
        113.26690200841,
        23.027679903687
    ],
    [
        113.26699097971,
        23.027680443795
    ],
    [
        113.26709373956,
        23.027673592569
    ],
    [
        113.26723030919,
        23.027674028569
    ],
    [
        113.26735281709,
        23.027673158909
    ],
    [
        113.26749398981,
        23.027676901384
    ],
    [
        113.26761704714,
        23.027684976202
    ],
    [
        113.26772089607,
        23.027679193631
    ],
    [
        113.26781366297,
        23.027682737088
    ],
    [
        113.26786477787,
        23.02768132135
    ],
    [
        113.26792400538,
        23.02767758198
    ],
    [
        113.26803732167,
        23.027668123245
    ],
    [
        113.26812684538,
        23.02767024724
    ],
    [
        113.26823529561,
        23.027660434048
    ],
    [
        113.26835646507,
        23.027660836734
    ],
    [
        113.26848872031,
        23.027652167071
    ],
    [
        113.26861963531,
        23.027661102806
    ],
    [
        113.26871728195,
        23.027667926265
    ],
    [
        113.26876245462,
        23.027672097824
    ],
    [
        113.26880437653,
        23.027667269155
    ],
    [
        113.26885981528,
        23.02764933798
    ],
    [
        113.2689506786,
        23.027614815042
    ],
    [
        113.26903476943,
        23.027560658511
    ],
    [
        113.26913616455,
        23.027492091043
    ],
    [
        113.26921375496,
        23.027419115103
    ],
    [
        113.26929133885,
        23.027332842089
    ],
    [
        113.26936757659,
        23.027256042252
    ],
    [
        113.26941271963,
        23.027201053899
    ],
    [
        113.26942218019,
        23.027188434306
    ],
    [
        113.26938508775,
        23.027127691441
    ],
    [
        113.26929574633,
        23.026988629066
    ],
    [
        113.26924078658,
        23.026899147775
    ],
    [
        113.26917336863,
        23.026779647675
    ],
    [
        113.2691227474,
        23.026707043889
    ],
    [
        113.26905586652,
        23.026576423871
    ],
    [
        113.26898413201,
        23.026472319677
    ],
    [
        113.26890834168,
        23.026368969021
    ],
    [
        113.26887368362,
        23.026299568705
    ],
    [
        113.26879219966,
        23.026166290067
    ],
    [
        113.26873913215,
        23.026061628111
    ],
    [
        113.2686920261,
        23.025977125602
    ],
    [
        113.2686045899,
        23.025832901906
    ],
    [
        113.26854639324,
        23.025742810725
    ],
    [
        113.26848278901,
        23.025655081424
    ],
    [
        113.26843081138,
        23.025558022697
    ],
    [
        113.26837775777,
        23.025471798668
    ],
    [
        113.26830197278,
        23.025358656792
    ],
    [
        113.26823187036,
        23.025248850095
    ],
    [
        113.26815852058,
        23.025132753759
    ],
    [
        113.26812009972,
        23.025099909087
    ],
    [
        113.26807084318,
        23.025028924318
    ],
    [
        113.26799371066,
        23.024915479226
    ],
    [
        113.26794444498,
        23.024821160145
    ],
    [
        113.26790925856,
        23.024760415911
    ],
    [
        113.26787624042,
        23.024709469461
    ],
    [
        113.26782157999,
        23.024644367099
    ],
    [
        113.26777097594,
        23.024577152918
    ],
    [
        113.26770277895,
        23.024477121803
    ],
    [
        113.26764269955,
        23.02438453385
    ],
    [
        113.26755285739,
        23.024257589392
    ],
    [
        113.26749414104,
        23.024186449132
    ],
    [
        113.26742053444,
        23.024075204749
    ],
    [
        113.26735100293,
        23.024006611147
    ],
    [
        113.2672784784,
        23.023891037267
    ],
    [
        113.26721787006,
        23.023815248619
    ],
    [
        113.26713074583,
        23.023704061185
    ],
    [
        113.26705146848,
        23.02360058514
    ],
    [
        113.26699681585,
        23.023534646659
    ],
    [
        113.2669489243,
        23.023468267062
    ],
    [
        113.26692078939,
        23.023441252655
    ],
    [
        113.26690428903,
        23.023430149818
    ],
    [
        113.26684102366,
        23.02346879267
    ],
    [
        113.26669908914,
        23.023569167068
    ],
    [
        113.26653497552,
        23.023651013834
    ],
    [
        113.26640898576,
        23.023713634236
    ],
    [
        113.26634761659,
        23.023751477764
    ],
    [
        113.26626922249,
        23.023815912525
    ],
    [
        113.26616378392,
        23.023869614122
    ],
    [
        113.26602130476,
        23.023932768802
    ],
    [
        113.26584718893,
        23.023991618845
    ],
    [
        113.26575039464,
        23.024013424825
    ],
    [
        113.26564711021,
        23.024031597279
    ],
    [
        113.26554626018,
        23.024049532423
    ],
    [
        113.26541999636,
        23.024072484571
    ],
    [
        113.26527237407,
        23.024097259045
    ],
    [
        113.26515313994,
        23.024112170642
    ],
    [
        113.26508149818,
        23.024136251045
    ],
    [
        113.26495442582,
        23.024153197313
    ],
    [
        113.26481843239,
        23.02417026414
    ],
    [
        113.26467351591,
        23.024182024373
    ],
    [
        113.26456591957,
        23.024210932241
    ],
    [
        113.26446237439,
        23.024227151116
    ],
    [
        113.26434531103,
        23.024241788473
    ],
    [
        113.26423906339,
        23.024256597937
    ],
    [
        113.26412605648,
        23.024268850546
    ],
    [
        113.26399953115,
        23.024277891581
    ],
    [
        113.26390356089,
        23.02429502758
    ],
    [
        113.26379217652,
        23.024301596239
    ],
    [
        113.2637224271,
        23.024306951915
    ],
    [
        113.26362996969,
        23.024315455619
    ],
    [
        113.26352129252,
        23.024325585474
    ],
    [
        113.26341748202,
        23.024334707338
    ],
    [
        113.26330934957,
        23.024350535576
    ],
    [
        113.26322149129,
        23.024360459852
    ],
    [
        113.2631631023,
        23.024373317357
    ],
    [
        113.26310768769,
        23.024387037543
    ],
    [
        113.26299685173,
        23.024397383642
    ],
    [
        113.26293100555,
        23.024665123532
    ],
    [
        113.26290241527,
        23.024812223776
    ],
    [
        113.26289137032,
        23.024898307998
    ],
    [
        113.26288275532,
        23.024976837064
    ],
    [
        113.26286442921,
        23.025100236742
    ],
    [
        113.26285530285,
        23.025239526467
    ],
    [
        113.26285399997,
        23.025342595203
    ],
    [
        113.26285648642,
        23.025454137966
    ],
    [
        113.26284708454,
        23.025577959815
    ],
    [
        113.26283501084,
        23.025764133955
    ],
    [
        113.26280991445,
        23.025854593564
    ],
    [
        113.26280423826,
        23.025856396824
    ],
    [
        113.26277044945,
        23.025863151314
    ],
    [
        113.26273206292,
        23.025865758374
    ],
    [
        113.26264689851,
        23.025848583151
    ],
    [
        113.26252442728,
        23.025828874174
    ],
    [
        113.26241222422,
        23.025798483601
    ],
    [
        113.26228785457,
        23.025762998983
    ],
    [
        113.26218484892,
        23.025741981691
    ],
    [
        113.26204858652,
        23.02570628589
    ],
    [
        113.2619458498,
        23.025679569316
    ],
    [
        113.26185717166,
        23.025655261347
    ],
    [
        113.26178011923,
        23.025633863826
    ],
    [
        113.26169442305,
        23.025625066948
    ],
    [
        113.26157494289,
        23.025627623511
    ],
    [
        113.26145221563,
        23.025621981757
    ],
    [
        113.26137868347,
        23.025609861137
    ],
    [
        113.26129488429,
        23.025607328281
    ],
    [
        113.26122514139,
        23.025603951828
    ],
    [
        113.26115540389,
        23.025611154733
    ],
    [
        113.26106998517,
        23.025611573673
    ],
    [
        113.2610386332,
        23.025620253938
    ],
    [
        113.26096483814,
        23.025620329872
    ],
    [
        113.26089320889,
        23.025626681965
    ],
    [
        113.26081184131,
        23.025617942508
    ],
    [
        113.26071047502,
        23.025616992178
    ],
    [
        113.26061856814,
        23.025612406552
    ],
    [
        113.26055531152,
        23.025602622006
    ],
    [
        113.26050151679,
        23.025594900893
    ],
    [
        113.26040555621,
        23.025590511881
    ],
    [
        113.26032933327,
        23.025596504159
    ],
    [
        113.26026229775,
        23.025596145144
    ],
    [
        113.26012579382,
        23.025594025525
    ],
    [
        113.26000955439,
        23.025574081647
    ],
    [
        113.25995711149,
        23.025564751083
    ],
    [
        113.25988871303,
        23.025539133527
    ],
    [
        113.25980382306,
        23.025506442953
    ],
    [
        113.25971975114,
        23.025487872781
    ],
    [
        113.25963621834,
        23.025465784188
    ],
    [
        113.25960485396,
        23.025445427506
    ],
    [
        113.25960831223,
        23.025329918202
    ],
    [
        113.25963012897,
        23.025166985102
    ],
    [
        113.25963413746,
        23.02506884837
    ],
    [
        113.25964544326,
        23.02496812731
    ],
    [
        113.25965998325,
        23.024845760037
    ],
    [
        113.25967372309,
        23.024745624561
    ],
    [
        113.2596844666,
        23.024592534908
    ],
    [
        113.25969957205,
        23.024521722902
    ],
    [
        113.25970117885,
        23.02448756871
    ],
    [
        113.25970707012,
        23.024360437728
    ],
    [
        113.25971540645,
        23.024260478795
    ],
    [
        113.25973291294,
        23.024111849351
    ],
    [
        113.25974205892,
        23.024005936512
    ],
    [
        113.25975012837,
        23.023910042481
    ],
    [
        113.25976547865,
        23.023770327982
    ],
    [
        113.2597849022,
        23.02367544767
    ],
    [
        113.25979781335,
        23.023515072685
    ],
    [
        113.25981830099,
        23.023372464742
    ],
    [
        113.25985389916,
        23.023156875224
    ],
    [
        113.25987168371,
        23.023006895356
    ],
    [
        113.25990997917,
        23.022763682553
    ],
    [
        113.25992318643,
        23.022656485677
    ],
    [
        113.25993447451,
        23.022467869844
    ],
    [
        113.25996845948,
        23.022247912604
    ],
    [
        113.25996731577,
        23.022053382235
    ],
    [
        113.25998132281,
        23.021897640343
    ],
    [
        113.25999886438,
        23.021805983363
    ],
    [
        113.2600245168,
        23.021718809242
    ],
    [
        113.26005500375,
        23.021524292188
    ],
    [
        113.26005845716,
        23.021310854115
    ],
    [
        113.26008678925,
        23.021129050059
    ],
    [
        113.26008268946,
        23.020957800078
    ],
    [
        113.26010023592,
        23.020867500104
    ],
    [
        113.26002804798,
        23.020800041706
    ],
    [
        113.25996072537,
        23.020730497623
    ],
    [
        113.25984338491,
        23.020609344625
    ],
    [
        113.25974119014,
        23.020520738193
    ],
    [
        113.25964358705,
        23.020414306596
    ],
    [
        113.25959681276,
        23.020359769596
    ],
    [
        113.2595824813,
        23.020335102033
    ],
    [
        113.25968030891,
        23.020243504891
    ],
    [
        113.25979057045,
        23.020148869645
    ],
    [
        113.25990515778,
        23.020054579778
    ],
    [
        113.26004649615,
        23.019912469666
    ],
    [
        113.26015648859,
        23.019808328495
    ],
    [
        113.26025431636,
        23.019693935082
    ],
    [
        113.26034701085,
        23.019587317294
    ],
    [
        113.26039213209,
        23.019479595452
    ],
    [
        113.26043373703,
        23.019354721505
    ],
    [
        113.26046804809,
        23.01925060825
    ],
    [
        113.26052506531,
        23.01914444971
    ],
    [
        113.26053965216,
        23.019084209815
    ],
    [
        113.26056504759,
        23.018998658595
    ],
    [
        113.26060881865,
        23.01887463542
    ],
    [
        113.26067177535,
        23.018699404155
    ],
    [
        113.26075851751,
        23.018495560105
    ],
    [
        113.26085445631,
        23.018320901028
    ],
    [
        113.26073686317,
        23.018255648638
    ],
    [
        113.26057817989,
        23.018155225235
    ],
    [
        113.26040544367,
        23.018068928764
    ],
    [
        113.26019107998,
        23.01796290858
    ],
    [
        113.26000726359,
        23.017865283154
    ],
    [
        113.25985723799,
        23.017783165843
    ],
    [
        113.25965774646,
        23.017677387346
    ],
    [
        113.25948771902,
        23.017568324501
    ],
    [
        113.25928039038,
        23.017437168391
    ],
    [
        113.25913577536,
        23.017348620018
    ],
    [
        113.2589281813,
        23.017240236414
    ],
    [
        113.25875221394,
        23.017144344325
    ],
    [
        113.25860895347,
        23.017054183348
    ],
    [
        113.25845650458,
        23.016977420628
    ],
    [
        113.25830324475,
        23.016882737491
    ],
    [
        113.25809863001,
        23.016772761579
    ],
    [
        113.25796510263,
        23.016660521469
    ],
    [
        113.25785401037,
        23.016555732696
    ],
    [
        113.25769291431,
        23.01640041019
    ],
    [
        113.25755614602,
        23.0162653226
    ],
    [
        113.25745370578,
        23.016175062951
    ],
    [
        113.25733775159,
        23.016056621299
    ],
    [
        113.25723071773,
        23.015937253288
    ],
    [
        113.2571201712,
        23.015795307172
    ],
    [
        113.257012329,
        23.015636319352
    ],
    [
        113.25693286803,
        23.015488959961
    ],
    [
        113.25682151546,
        23.015310378352
    ],
    [
        113.25675800338,
        23.015177138377
    ],
    [
        113.25667233039,
        23.015011493651
    ],
    [
        113.25662179565,
        23.014854614393
    ],
    [
        113.25655207686,
        23.014627406816
    ],
    [
        113.25650289414,
        23.014502832584
    ],
    [
        113.25647830595,
        23.014406637696
    ],
    [
        113.25644479954,
        23.01430187453
    ],
    [
        113.25641885897,
        23.014226271641
    ],
    [
        113.25641129878,
        23.014145300457
    ],
    [
        113.25639806451,
        23.014048766097
    ],
    [
        113.25638294151,
        23.013926970763
    ],
    [
        113.25635863162,
        23.013787379568
    ],
    [
        113.25635890745,
        23.013740998809
    ],
    [
        113.25635161697,
        23.013681462454
    ],
    [
        113.25634298423,
        23.013552188136
    ],
    [
        113.25631597196,
        23.0134290961
    ],
    [
        113.25631247773,
        23.013290691002
    ],
    [
        113.25630194998,
        23.013199088457
    ],
    [
        113.25628683222,
        23.013078921802
    ],
    [
        113.25626280292,
        23.012914652222
    ],
    [
        113.25625038876,
        23.012800773123
    ],
    [
        113.25624527022,
        23.012703028647
    ],
    [
        113.25624068278,
        23.012660901695
    ],
    [
        113.25623286199,
        23.012563651627
    ],
    [
        113.25621802509,
        23.012409041011
    ],
    [
        113.25622264351,
        23.012288142597
    ],
    [
        113.25622941936,
        23.012194951066
    ],
    [
        113.25625322534,
        23.012094468455
    ],
    [
        113.25627730696,
        23.011971476576
    ],
    [
        113.2563021976,
        23.011860434569
    ],
    [
        113.25631465919,
        23.011733709203
    ],
    [
        113.25633982184,
        23.01162131604
    ],
    [
        113.25635552245,
        23.011519875544
    ],
    [
        113.25635610054,
        23.01136499918
    ],
    [
        113.25635477271,
        23.011270036289
    ],
    [
        113.25635641443,
        23.011191130515
    ],
    [
        113.25635156986,
        23.011111023981
    ],
    [
        113.25631781891,
        23.010977506909
    ],
    [
        113.2562783879,
        23.010862062602
    ],
    [
        113.25624192567,
        23.010764845412
    ],
    [
        113.25619899133,
        23.01061705972
    ],
    [
        113.25615038183,
        23.010469986711
    ],
    [
        113.25611608012,
        23.010385286124
    ],
    [
        113.25608773261,
        23.01027573671
    ],
    [
        113.25605966253,
        23.010145034736
    ],
    [
        113.2560129562,
        23.009973855104
    ],
    [
        113.25598381789,
        23.009809499363
    ],
    [
        113.25595114187,
        23.009721302178
    ],
    [
        113.25593793577,
        23.009607141263
    ],
    [
        113.25591123824,
        23.009427910951
    ],
    [
        113.25589154397,
        23.009322043322
    ],
    [
        113.25587885917,
        23.009268652039
    ],
    [
        113.25585811129,
        23.009088714755
    ],
    [
        113.25584465174,
        23.008938745189
    ],
    [
        113.25583361017,
        23.008830591235
    ],
    [
        113.25583392314,
        23.008717757524
    ],
    [
        113.25584591574,
        23.008460014816
    ],
    [
        113.25585895562,
        23.008294244142
    ],
    [
        113.25588170172,
        23.008191033686
    ],
    [
        113.25590146769,
        23.008105943685
    ],
    [
        113.25593773762,
        23.007982631307
    ],
    [
        113.25596129628,
        23.007879164453
    ],
    [
        113.25598107667,
        23.007763424218
    ],
    [
        113.25601246879,
        23.007673930933
    ],
    [
        113.25604602089,
        23.00759071494
    ],
    [
        113.25607879101,
        23.007442928748
    ],
    [
        113.25611127958,
        23.007322533461
    ],
    [
        113.25613944017,
        23.007211012133
    ],
    [
        113.25616408275,
        23.007110006653
    ],
    [
        113.25619061545,
        23.00701418865
    ],
    [
        113.25621794813,
        23.006942525717
    ],
    [
        113.25625285897,
        23.006850112371
    ],
    [
        113.25630562734,
        23.006720043862
    ],
    [
        113.25634676286,
        23.006613094739
    ],
    [
        113.2563754522,
        23.006533590285
    ],
    [
        113.25640629721,
        23.006468228995
    ],
    [
        113.25645797267,
        23.006366621918
    ],
    [
        113.25649639532,
        23.006283222792
    ],
    [
        113.2565342899,
        23.006175673763
    ],
    [
        113.25657163659,
        23.006083575827
    ],
    [
        113.25662603886,
        23.005939161618
    ],
    [
        113.25667529038,
        23.00582584834
    ],
    [
        113.25676538254,
        23.005662813455
    ],
    [
        113.25684680527,
        23.005539767519
    ],
    [
        113.25690145577,
        23.005443096511
    ],
    [
        113.25695879606,
        23.005371427616
    ],
    [
        113.25702344726,
        23.005276291296
    ],
    [
        113.25711377984,
        23.005175103466
    ],
    [
        113.25718004798,
        23.005090302968
    ],
    [
        113.25729172292,
        23.005009838494
    ],
    [
        113.2573969083,
        23.004934682633
    ],
    [
        113.25747018771,
        23.004880656578
    ],
    [
        113.25758888325,
        23.004814420376
    ],
    [
        113.25769324112,
        23.004770169555
    ],
    [
        113.25776597161,
        23.004731864465
    ],
    [
        113.25785518914,
        23.004695208854
    ],
    [
        113.25796278939,
        23.004653997654
    ],
    [
        113.25803496414,
        23.004642805218
    ],
    [
        113.25818797607,
        23.004598331641
    ],
    [
        113.25832206051,
        23.004566539211
    ],
    [
        113.25840667597,
        23.004543902373
    ],
    [
        113.25855670913,
        23.00451103413
    ],
    [
        113.25865591648,
        23.004496248857
    ],
    [
        113.25878269996,
        23.004471915529
    ],
    [
        113.25889488471,
        23.004452746602
    ],
    [
        113.25896058017,
        23.004430583415
    ],
    [
        113.25907709753,
        23.004399011797
    ],
    [
        113.25919091328,
        23.004365763283
    ],
    [
        113.25934499955,
        23.004340547463
    ],
    [
        113.25944719161,
        23.004310073398
    ],
    [
        113.25954937645,
        23.004292345856
    ],
    [
        113.25964101426,
        23.004283924344
    ],
    [
        113.2597580591,
        23.004278660874
    ],
    [
        113.25984267079,
        23.004268214189
    ],
    [
        113.25995403197,
        23.004276408956
    ],
    [
        113.26009378235,
        23.004273707471
    ],
    [
        113.26022731365,
        23.004275504673
    ],
    [
        113.26035895976,
        23.004266687379
    ],
    [
        113.2604600584,
        23.004262758108
    ],
    [
        113.26061576445,
        23.004252455786
    ],
    [
        113.26071929954,
        23.004244223986
    ],
    [
        113.26082715928,
        23.00423742136
    ],
    [
        113.26093582739,
        23.004235783809
    ],
    [
        113.26106855637,
        23.00423076359
    ],
    [
        113.26120993501,
        23.004228059016
    ],
    [
        113.26132779569,
        23.004226842204
    ],
    [
        113.26144322237,
        23.004228563728
    ],
    [
        113.26164866926,
        23.004228305272
    ],
    [
        113.26177572388,
        23.004226691196
    ],
    [
        113.26192089189,
        23.004224298319
    ],
    [
        113.26204957324,
        23.004217820738
    ],
    [
        113.26221772175,
        23.004215537829
    ],
    [
        113.2623766888,
        23.004199257832
    ],
    [
        113.26248131407,
        23.004191541965
    ],
    [
        113.26257404939,
        23.004176569278
    ],
    [
        113.26267327631,
        23.004156821606
    ],
    [
        113.26278494409,
        23.004129686407
    ],
    [
        113.26287336652,
        23.004096730939
    ],
    [
        113.26293393887,
        23.004071983853
    ],
    [
        113.26299749036,
        23.00403887739
    ],
    [
        113.26308510474,
        23.004003190142
    ],
    [
        113.26319949519,
        23.00394977628
    ],
    [
        113.26331659046,
        23.003895860929
    ],
    [
        113.26341096571,
        23.00386027744
    ],
    [
        113.26355158954,
        23.003797252126
    ],
    [
        113.26363056107,
        23.003753539552
    ],
    [
        113.26369249591,
        23.003717136925
    ],
    [
        113.2637747252,
        23.003653403024
    ],
    [
        113.26383289144,
        23.003591981307
    ],
    [
        113.26390188603,
        23.003509309647
    ],
    [
        113.26394112717,
        23.003448658145
    ],
    [
        113.26398306996,
        23.003391576713
    ],
    [
        113.26402664474,
        23.00331960362
    ],
    [
        113.26408753104,
        23.003235709064
    ],
    [
        113.26417356371,
        23.003149513732
    ],
    [
        113.26424633989,
        23.003077473956
    ],
    [
        113.26429964022,
        23.003020302684
    ],
    [
        113.2643781015,
        23.002938859243
    ],
    [
        113.2644192383,
        23.002877960843
    ],
    [
        113.26446445249,
        23.002784580244
    ],
    [
        113.26452211305,
        23.002678382404
    ],
    [
        113.26457574038,
        23.002539841015
    ],
    [
        113.26463045042,
        23.002401045014
    ],
    [
        113.2646635206,
        23.002277628425
    ],
    [
        113.26466952901,
        23.002189846518
    ],
    [
        113.26468772641,
        23.002070799406
    ],
    [
        113.26468241518,
        23.001931842347
    ],
    [
        113.26467871479,
        23.001810270389
    ],
    [
        113.26466904776,
        23.001715453662
    ],
    [
        113.2646485597,
        23.00162941196
    ],
    [
        113.26461755183,
        23.001508752888
    ],
    [
        113.26458895173,
        23.001424748885
    ],
    [
        113.2645525154,
        23.001334650039
    ],
    [
        113.26450149305,
        23.001225327005
    ],
    [
        113.26443964109,
        23.001136982377
    ],
    [
        113.26442155638,
        23.001095188997
    ],
    [
        113.26439185453,
        23.001041271653
    ],
    [
        113.26433703231,
        23.000954395673
    ],
    [
        113.2643059725,
        23.000909405801
    ],
    [
        113.26425545713,
        23.000849450464
    ],
    [
        113.26417578849,
        23.000726904197
    ],
    [
        113.26409231816,
        23.000627890145
    ],
    [
        113.26401856776,
        23.000547748557
    ],
    [
        113.26393400922,
        23.000459832283
    ],
    [
        113.26381918492,
        23.000353240619
    ],
    [
        113.26373244888,
        23.000286980683
    ],
    [
        113.26362301705,
        23.000202711347
    ],
    [
        113.26347034927,
        23.00009222229
    ],
    [
        113.26333876726,
        22.999986688686
    ],
    [
        113.26316366062,
        22.999880691272
    ],
    [
        113.26301260355,
        22.999792447053
    ],
    [
        113.26292721214,
        22.999743002837
    ],
    [
        113.26290885243,
        22.999712316061
    ],
    [
        113.26287508685,
        22.999676758665
    ],
    [
        113.26275025738,
        22.999587316738
    ],
    [
        113.26257758639,
        22.99948810922
    ],
    [
        113.26239871072,
        22.999374954865
    ],
    [
        113.26226494905,
        22.999305142949
    ],
    [
        113.26215444343,
        22.999227586197
    ],
    [
        113.26196720195,
        22.999102875949
    ],
    [
        113.26183400907,
        22.999002680649
    ],
    [
        113.26172243443,
        22.99891397258
    ],
    [
        113.26153603423,
        22.998758607303
    ],
    [
        113.26142041179,
        22.998664125404
    ],
    [
        113.26129722379,
        22.99856652607
    ],
    [
        113.26115917448,
        22.998462427672
    ],
    [
        113.26101490377,
        22.998364726461
    ],
    [
        113.26091765816,
        22.998280856688
    ],
    [
        113.26080446269,
        22.998199148493
    ],
    [
        113.26062078959,
        22.998028603551
    ],
    [
        113.26047708656,
        22.997904044699
    ],
    [
        113.26032285854,
        22.997760583259
    ],
    [
        113.26018727009,
        22.997632903822
    ],
    [
        113.26004356767,
        22.997512130635
    ],
    [
        113.25996442098,
        22.997448902381
    ],
    [
        113.25994388872,
        22.997435794306
    ],
    [
        113.25992740666,
        22.997427910563
    ],
    [
        113.2599039064,
        22.997408512057
    ],
    [
        113.25981341868,
        22.997332063802
    ],
    [
        113.25965514146,
        22.997189327174
    ],
    [
        113.25954358853,
        22.997092704822
    ],
    [
        113.25947364858,
        22.997012816828
    ],
    [
        113.25938398954,
        22.996918205312
    ],
    [
        113.25925923839,
        22.996769813027
    ],
    [
        113.25913449112,
        22.996618164117
    ],
    [
        113.25900541943,
        22.996467250431
    ],
    [
        113.25888932391,
        22.996315479748
    ],
    [
        113.25870978058,
        22.996083114427
    ],
    [
        113.2585823382,
        22.995927612869
    ],
    [
        113.25838846045,
        22.99570881981
    ],
    [
        113.25829017304,
        22.995596957054
    ],
    [
        113.25815627213,
        22.995413128773
    ],
    [
        113.25804747118,
        22.995271785195
    ],
    [
        113.25798216594,
        22.995155082553
    ],
    [
        113.25790878016,
        22.995007858993
    ],
    [
        113.25784241704,
        22.994866727087
    ],
    [
        113.25776257272,
        22.994689824868
    ],
    [
        113.25771163965,
        22.994524828802
    ],
    [
        113.25765585589,
        22.99434482912
    ],
    [
        113.25762325599,
        22.99423142039
    ],
    [
        113.25760902009,
        22.994135425852
    ],
    [
        113.25759891457,
        22.993958681331
    ],
    [
        113.25758793446,
        22.993850268789
    ],
    [
        113.25758489064,
        22.993638662966
    ],
    [
        113.25758742625,
        22.993529949026
    ],
    [
        113.25758898057,
        22.993316526885
    ],
    [
        113.2576134479,
        22.993168877167
    ],
    [
        113.25762136671,
        22.99308494031
    ],
    [
        113.25763088945,
        22.993019746187
    ],
    [
        113.25764960941,
        22.992947121844
    ],
    [
        113.2576837926,
        22.992815918511
    ],
    [
        113.2577087677,
        22.99270380765
    ],
    [
        113.25774782985,
        22.992559130289
    ],
    [
        113.25777008525,
        22.992464871415
    ],
    [
        113.25778076838,
        22.992318874871
    ],
    [
        113.25779897433,
        22.992219933182
    ],
    [
        113.25780636329,
        22.992126494427
    ],
    [
        113.25782703927,
        22.991989626197
    ],
    [
        113.25784150898,
        22.991842341178
    ],
    [
        113.25784188482,
        22.991734674272
    ],
    [
        113.25785746057,
        22.991562728211
    ],
    [
        113.25785867421,
        22.991428225743
    ],
    [
        113.25786986771,
        22.991315327246
    ],
    [
        113.25788734868,
        22.991131210488
    ],
    [
        113.2578964008,
        22.990997661397
    ],
    [
        113.25790927929,
        22.990821870554
    ],
    [
        113.25793349879,
        22.990657944029
    ],
    [
        113.25796804254,
        22.990441313956
    ],
    [
        113.2579824618,
        22.990347729486
    ],
    [
        113.25799311122,
        22.990239974635
    ],
    [
        113.25800484384,
        22.990130340561
    ],
    [
        113.25802230013,
        22.989973616621
    ],
    [
        113.25803697738,
        22.98989278397
    ],
    [
        113.25803606795,
        22.98972217241
    ],
    [
        113.25803670723,
        22.989624274541
    ],
    [
        113.25803767906,
        22.989464816426
    ],
    [
        113.25803105117,
        22.989336684236
    ],
    [
        113.25803011245,
        22.989195906141
    ],
    [
        113.25801866858,
        22.989019411767
    ],
    [
        113.2580028312,
        22.988910914548
    ],
    [
        113.25798698867,
        22.988807570346
    ],
    [
        113.25796850373,
        22.988644782733
    ],
    [
        113.25794616892,
        22.988546747279
    ],
    [
        113.25792410281,
        22.988450343883
    ],
    [
        113.25789880849,
        22.988338966092
    ],
    [
        113.25786968235,
        22.988274440434
    ],
    [
        113.2578446153,
        22.988205376339
    ],
    [
        113.25780554522,
        22.988085074162
    ],
    [
        113.25776891811,
        22.987954780425
    ],
    [
        113.25775168825,
        22.987887211892
    ],
    [
        113.25773256583,
        22.98782015206
    ],
    [
        113.25767970849,
        22.987702316135
    ],
    [
        113.25765572342,
        22.98763272863
    ],
    [
        113.25763417238,
        22.987561828396
    ],
    [
        113.25761422756,
        22.987506144863
    ],
    [
        113.25759296046,
        22.987421960065
    ],
    [
        113.25756550257,
        22.987312441809
    ],
    [
        113.25752398189,
        22.98721026686
    ],
    [
        113.25748843153,
        22.987084873711
    ],
    [
        113.25742913193,
        22.986923798946
    ],
    [
        113.25737954614,
        22.986779170229
    ],
    [
        113.25735072898,
        22.986677492742
    ],
    [
        113.25729597022,
        22.986569385736
    ],
    [
        113.25724849845,
        22.986471986034
    ],
    [
        113.25717567775,
        22.986317449859
    ],
    [
        113.25711822178,
        22.986203870066
    ],
    [
        113.25706672417,
        22.986078734226
    ],
    [
        113.2570400224,
        22.986022929667
    ],
    [
        113.2569377927,
        22.985816879549
    ],
    [
        113.25686873612,
        22.98568193749
    ],
    [
        113.25678595661,
        22.985486540443
    ],
    [
        113.25674685859,
        22.985394442717
    ],
    [
        113.25668698704,
        22.985264275096
    ],
    [
        113.25663848703,
        22.985115325343
    ],
    [
        113.25659215232,
        22.984963430848
    ],
    [
        113.25654043263,
        22.984791098992
    ],
    [
        113.25649539839,
        22.984688860196
    ],
    [
        113.25642914623,
        22.9844544316
    ],
    [
        113.2563776718,
        22.984306242299
    ],
    [
        113.25630276253,
        22.98407898195
    ],
    [
        113.25627636925,
        22.983985483633
    ],
    [
        113.25627880628,
        22.983981187682
    ],
    [
        113.25619364884,
        22.983995940431
    ],
    [
        113.25571922214,
        22.98405609163
    ],
    [
        113.25547974245,
        22.984055075544
    ],
    [
        113.25526485969,
        22.984053415699
    ],
    [
        113.25494297036,
        22.984021105373
    ],
    [
        113.25466375551,
        22.984019123842
    ],
    [
        113.25439564234,
        22.983996733968
    ],
    [
        113.25411673187,
        22.983958429807
    ],
    [
        113.25389078265,
        22.983935988122
    ],
    [
        113.25376129916,
        22.983944276803
    ],
    [
        113.2535510407,
        22.983906934373
    ],
    [
        113.25333457948,
        22.983854301082
    ],
    [
        113.25316810134,
        22.983823708384
    ],
    [
        113.25302623133,
        22.983782432317
    ],
    [
        113.25283896191,
        22.983727888102
    ],
    [
        113.25271384073,
        22.983695321002
    ],
    [
        113.25263951156,
        22.983688596538
    ],
    [
        113.25258112102,
        22.983691372951
    ],
    [
        113.25254517349,
        22.983687219138
    ],
    [
        113.25249433621,
        22.983705045351
    ],
    [
        113.25242187205,
        22.983724393319
    ],
    [
        113.2522872213,
        22.98375703343
    ],
    [
        113.25225586147,
        22.983760013219
    ],
    [
        113.25216069302,
        22.983776257719
    ],
    [
        113.25215285697,
        22.983773138095
    ],
    [
        113.25215365962,
        22.983781288531
    ],
    [
        113.25215793099,
        22.983833978708
    ],
    [
        113.25214294589,
        22.983949256197
    ],
    [
        113.2521276458,
        22.984108194012
    ],
    [
        113.25207514195,
        22.98416884775
    ],
    [
        113.25196231157,
        22.984273477155
    ],
    [
        113.25184487103,
        22.984391861545
    ],
    [
        113.25173471371,
        22.984524749448
    ],
    [
        113.25165862522,
        22.984649278453
    ],
    [
        113.25164229942,
        22.984753143314
    ],
    [
        113.25162785553,
        22.984867075709
    ],
    [
        113.25163709918,
        22.985079597263
    ],
    [
        113.25163628488,
        22.985082837789
    ],
    [
        113.25160437681,
        22.985092321838
    ],
    [
        113.25151383733,
        22.985073130875
    ],
    [
        113.25125953752,
        22.984996068833
    ],
    [
        113.25078006687,
        22.984897819755
    ],
    [
        113.25034461521,
        22.984832925329
    ],
    [
        113.24994431316,
        22.984752947465
    ],
    [
        113.24959103628,
        22.984679500297
    ],
    [
        113.24954453787,
        22.984676555173
    ],
    [
        113.24952857372,
        22.984689307474
    ],
    [
        113.24948489826,
        22.984833680389
    ],
    [
        113.249394517,
        22.985176892081
    ],
    [
        113.2493727768,
        22.98528555954
    ],
    [
        113.24936372133,
        22.985415863804
    ],
    [
        113.24933784589,
        22.98560230169
    ],
    [
        113.2492817087,
        22.985770337728
    ],
    [
        113.24926303648,
        22.985787114809
    ],
    [
        113.24923463383,
        22.985801289901
    ],
    [
        113.24909409417,
        22.985752587938
    ],
    [
        113.24854377511,
        22.985599269753
    ],
    [
        113.24839052552,
        22.98554551527
    ],
    [
        113.24836430044,
        22.985543733183
    ],
    [
        113.24834320301,
        22.985551255909
    ],
    [
        113.24831531719,
        22.985586875092
    ],
    [
        113.24805258324,
        22.986036370475
    ],
    [
        113.24791360129,
        22.986302095366
    ],
    [
        113.24777240443,
        22.986616882705
    ],
    [
        113.24763961301,
        22.986907674193
    ],
    [
        113.24759331033,
        22.986970943163
    ],
    [
        113.2475992415,
        22.986988124197
    ],
    [
        113.24759058447,
        22.986992325768
    ],
    [
        113.24762733572,
        22.987014608535
    ],
    [
        113.24763597496,
        22.987027764601
    ],
    [
        113.24764245577,
        22.987036275616
    ],
    [
        113.2476240036,
        22.987099988273
    ],
    [
        113.24741348857,
        22.987505635203
    ],
    [
        113.24724813813,
        22.987901707284
    ],
    [
        113.24720912536,
        22.987974591526
    ],
    [
        113.24718043946,
        22.987996921727
    ],
    [
        113.24713446366,
        22.988003249807
    ],
    [
        113.24700278127,
        22.987996029628
    ],
    [
        113.24667488538,
        22.987879718265
    ],
    [
        113.24638107108,
        22.987746080536
    ],
    [
        113.24603858358,
        22.987599267026
    ],
    [
        113.24580013585,
        22.987520797963
    ],
    [
        113.24567711812,
        22.987486941357
    ],
    [
        113.2454397631,
        22.987389275763
    ],
    [
        113.24523161637,
        22.987287189572
    ],
    [
        113.24506698948,
        22.987205022379
    ],
    [
        113.24478021051,
        22.987021822004
    ],
    [
        113.24460803898,
        22.986903785232
    ],
    [
        113.24439533092,
        22.986747483731
    ],
    [
        113.24416070091,
        22.986598218504
    ],
    [
        113.24370733177,
        22.986348551572
    ],
    [
        113.2434586021,
        22.986213287885
    ],
    [
        113.24337965001,
        22.986176127837
    ],
    [
        113.24333041701,
        22.986175179744
    ],
    [
        113.24329252534,
        22.986193916024
    ],
    [
        113.24304778126,
        22.986381242325
    ],
    [
        113.24284984907,
        22.986552147142
    ],
    [
        113.24276316181,
        22.986665708039
    ],
    [
        113.2426723912,
        22.986803086038
    ],
    [
        113.24254269,
        22.986912560166
    ],
    [
        113.24243656949,
        22.986977876361
    ],
    [
        113.24232854901,
        22.9870477854
    ],
    [
        113.24215523257,
        22.987206352177
    ],
    [
        113.24193481938,
        22.987379519772
    ],
    [
        113.24168294476,
        22.987620122789
    ],
    [
        113.24150418237,
        22.987798492487
    ],
    [
        113.24140091808,
        22.987968062305
    ],
    [
        113.24138113949,
        22.987993580395
    ],
    [
        113.24134812109,
        22.988000490922
    ],
    [
        113.24123477499,
        22.987970874924
    ],
    [
        113.24097162196,
        22.987837723835
    ],
    [
        113.24084344995,
        22.98774611998
    ],
    [
        113.24065335094,
        22.987610388642
    ],
    [
        113.2404505031,
        22.987498940482
    ],
    [
        113.24028114917,
        22.987444326589
    ],
    [
        113.24004905615,
        22.987338830702
    ],
    [
        113.23976718087,
        22.987209753031
    ],
    [
        113.2395158601,
        22.98709843208
    ],
    [
        113.23933296548,
        22.987028865407
    ],
    [
        113.23917356208,
        22.987010297131
    ],
    [
        113.23895865756,
        22.98700009836
    ],
    [
        113.23868475693,
        22.986969510385
    ],
    [
        113.23861358043,
        22.98695465663
    ],
    [
        113.23838056569,
        22.986900424273
    ],
    [
        113.23837461114,
        22.986899549063
    ],
    [
        113.23835184852,
        22.986922638342
    ],
    [
        113.23829185639,
        22.987085562534
    ],
    [
        113.23821365043,
        22.987322887129
    ],
    [
        113.23814629646,
        22.987536459857
    ],
    [
        113.23809876057,
        22.987694637774
    ],
    [
        113.23805089691,
        22.987908684224
    ],
    [
        113.23802504925,
        22.988036165493
    ],
    [
        113.23802882904,
        22.988046238479
    ],
    [
        113.23813244929,
        22.988108580741
    ],
    [
        113.23813379071,
        22.988120527781
    ],
    [
        113.2381164405,
        22.988144760996
    ],
    [
        113.23803507883,
        22.9882898517
    ],
    [
        113.23793522973,
        22.988511516129
    ],
    [
        113.23788938571,
        22.988602457667
    ],
    [
        113.23780167472,
        22.988866562951
    ],
    [
        113.23772836415,
        22.989078742763
    ],
    [
        113.23767185993,
        22.989269665409
    ],
    [
        113.23759118203,
        22.989538464903
    ],
    [
        113.23747682328,
        22.989916243939
    ],
    [
        113.23746132649,
        22.989980914939
    ],
    [
        113.23745699387,
        22.989981686863
    ],
    [
        113.23744615648,
        22.989989447801
    ],
    [
        113.23735901488,
        22.98995172735
    ],
    [
        113.23734847217,
        22.989935353819
    ],
    [
        113.2373484822,
        22.989925318967
    ],
    [
        113.23741228464,
        22.989747741283
    ],
    [
        113.23742124594,
        22.989720977019
    ],
    [
        113.2374204598,
        22.989694932863
    ],
    [
        113.23725972177,
        22.989610137318
    ],
    [
        113.23696450699,
        22.989431086495
    ],
    [
        113.2369482603,
        22.989432021405
    ],
    [
        113.23693362915,
        22.989441921484
    ],
    [
        113.23682293594,
        22.989661946578
    ],
    [
        113.23674629922,
        22.989941414506
    ],
    [
        113.23670388888,
        22.990111625015
    ],
    [
        113.23666875252,
        22.990319058909
    ],
    [
        113.23665236096,
        22.990465096375
    ],
    [
        113.23664879813,
        22.990508187554
    ],
    [
        113.23666285199,
        22.99053489295
    ],
    [
        113.23669614432,
        22.990547939938
    ],
    [
        113.236800637,
        22.990573296325
    ],
    [
        113.23690430863,
        22.990605705557
    ],
    [
        113.23700285078,
        22.990621260531
    ],
    [
        113.23715879031,
        22.990637903471
    ],
    [
        113.23717204716,
        22.990648063013
    ],
    [
        113.23718258898,
        22.990665791169
    ],
    [
        113.23716839532,
        22.991056207844
    ],
    [
        113.23715258751,
        22.991162104644
    ],
    [
        113.23712385771,
        22.991192482638
    ],
    [
        113.23708430694,
        22.991213267704
    ],
    [
        113.23700037415,
        22.991210859871
    ],
    [
        113.23678081324,
        22.991180638321
    ],
    [
        113.23672341077,
        22.991179575444
    ],
    [
        113.23664136154,
        22.991184260464
    ],
    [
        113.23660614673,
        22.99119831926
    ],
    [
        113.23658664875,
        22.991200314656
    ],
    [
        113.23645780691,
        22.99114926681
    ],
    [
        113.23628888406,
        22.991099510795
    ],
    [
        113.23622713921,
        22.991103586423
    ],
    [
        113.23616971497,
        22.991119364552
    ],
    [
        113.23614070548,
        22.991154102407
    ],
    [
        113.23604172914,
        22.991290764516
    ],
    [
        113.23591124815,
        22.991519112385
    ],
    [
        113.23585508642,
        22.991625773223
    ],
    [
        113.23573952509,
        22.991825786554
    ],
    [
        113.23562144062,
        22.992112850884
    ],
    [
        113.23555113305,
        22.992283146795
    ],
    [
        113.23544853902,
        22.992513398343
    ],
    [
        113.23533182753,
        22.992778534205
    ],
    [
        113.23531280611,
        22.99284456099
    ],
    [
        113.23530575383,
        22.992855625304
    ],
    [
        113.23550016639,
        22.992902465807
    ],
    [
        113.23583399184,
        22.993002563114
    ],
    [
        113.23605032412,
        22.993047505377
    ],
    [
        113.23606251191,
        22.99304571047
    ],
    [
        113.23607335083,
        22.993038479856
    ],
    [
        113.2361673653,
        22.99270460229
    ],
    [
        113.23628878926,
        22.992309675339
    ],
    [
        113.23634296133,
        22.992014792793
    ],
    [
        113.23642304507,
        22.991529204709
    ],
    [
        113.23645794541,
        22.991284062148
    ],
    [
        113.23647583242,
        22.991268489689
    ],
    [
        113.23647447878,
        22.991268206504
    ],
    [
        113.23654161592,
        22.991285346107
    ],
    [
        113.236764677,
        22.991344577205
    ],
    [
        113.2369703887,
        22.991416706323
    ],
    [
        113.23712493433,
        22.991475370756
    ],
    [
        113.23714197422,
        22.99149343071
    ],
    [
        113.23714520071,
        22.991516514328
    ],
    [
        113.23706560408,
        22.991788613395
    ],
    [
        113.23691733981,
        22.992231492863
    ],
    [
        113.23673737072,
        22.99270013985
    ],
    [
        113.23658043027,
        22.993154644547
    ],
    [
        113.23647237523,
        22.99345582072
    ],
    [
        113.23637543991,
        22.993738390063
    ],
    [
        113.23629101403,
        22.993964120233
    ],
    [
        113.23628258857,
        22.99399740685
    ],
    [
        113.23624196798,
        22.993999224375
    ],
    [
        113.23615993071,
        22.993984413801
    ],
    [
        113.23590326766,
        22.993921755236
    ],
    [
        113.23589460865,
        22.993914359852
    ],
    [
        113.23591262496,
        22.993761001372
    ],
    [
        113.23594827025,
        22.99357985601
    ],
    [
        113.23600125278,
        22.99339316274
    ],
    [
        113.23599286786,
        22.993382514381
    ],
    [
        113.23599503965,
        22.993376837166
    ],
    [
        113.23598177874,
        22.993367774992
    ],
    [
        113.23577982519,
        22.993292858616
    ],
    [
        113.23551936227,
        22.99322265642
    ],
    [
        113.23521312595,
        22.993142117967
    ],
    [
        113.23519553119,
        22.993131674614
    ],
    [
        113.23517412998,
        22.993136661325
    ],
    [
        113.2351746714,
        22.993136936747
    ],
    [
        113.23508091486,
        22.993471165482
    ],
    [
        113.23506045799,
        22.993623975039
    ],
    [
        113.23505149343,
        22.993652384149
    ],
    [
        113.23505717027,
        22.993664090027
    ],
    [
        113.23514300104,
        22.993693229198
    ],
    [
        113.23567152355,
        22.993843624167
    ],
    [
        113.23568911477,
        22.993856515501
    ],
    [
        113.23567980835,
        22.993962485492
    ],
    [
        113.23568575094,
        22.993979078485
    ],
    [
        113.2357390837,
        22.993998773248
    ],
    [
        113.23605069288,
        22.994098205984
    ],
    [
        113.23606747669,
        22.994104586742
    ],
    [
        113.23607721516,
        22.99411578962
    ],
    [
        113.23608064201,
        22.994216983291
    ],
    [
        113.23604502904,
        22.994366664179
    ],
    [
        113.23603879614,
        22.994371493195
    ],
    [
        113.23577478797,
        22.994338633371
    ],
    [
        113.23546095391,
        22.994286174774
    ],
    [
        113.23515360516,
        22.994231950268
    ],
    [
        113.23489716943,
        22.994168966432
    ],
    [
        113.23487306221,
        22.994170141153
    ],
    [
        113.23485272858,
        22.994191143576
    ],
    [
        113.23476098971,
        22.994395771739
    ],
    [
        113.2346980018,
        22.994556952413
    ],
    [
        113.23462764961,
        22.99477395384
    ],
    [
        113.23458189625,
        22.995047009328
    ],
    [
        113.23454133058,
        22.995275895666
    ],
    [
        113.23445586575,
        22.995432045696
    ],
    [
        113.23438997103,
        22.995512399342
    ],
    [
        113.23438481399,
        22.995524025181
    ],
    [
        113.23438425557,
        22.995542735389
    ],
    [
        113.23447710362,
        22.995613101582
    ],
    [
        113.23469198221,
        22.995829469879
    ],
    [
        113.23490362382,
        22.996023070873
    ],
    [
        113.23519782713,
        22.996261016905
    ],
    [
        113.23531610189,
        22.9963547017
    ],
    [
        113.23532910047,
        22.996356431641
    ],
    [
        113.2353391208,
        22.996357053282
    ],
    [
        113.23541312002,
        22.99628576714
    ],
    [
        113.23542532005,
        22.996271218493
    ],
    [
        113.23544400789,
        22.996270554108
    ],
    [
        113.23550950509,
        22.996320170639
    ],
    [
        113.23551734793,
        22.996332981202
    ],
    [
        113.23551462296,
        22.99635221596
    ],
    [
        113.23544386593,
        22.996434099399
    ],
    [
        113.23530294042,
        22.996541198261
    ],
    [
        113.23510756453,
        22.996657385343
    ],
    [
        113.23486237595,
        22.996737699661
    ],
    [
        113.23449253731,
        22.996864354593
    ],
    [
        113.23426250996,
        22.996924561725
    ],
    [
        113.23405658044,
        22.99698796182
    ],
    [
        113.23380780878,
        22.997089086061
    ],
    [
        113.23360399844,
        22.997190552003
    ],
    [
        113.23339587022,
        22.997263548894
    ],
    [
        113.23309451043,
        22.99736233121
    ],
    [
        113.23270399797,
        22.99745173751
    ],
    [
        113.23251645457,
        22.997495990985
    ],
    [
        113.23245412967,
        22.997498364286
    ],
    [
        113.23243813364,
        22.997508855535
    ],
    [
        113.23244651859,
        22.997527072723
    ],
    [
        113.23244271553,
        22.997538443527
    ],
    [
        113.23246705726,
        22.997593362213
    ],
    [
        113.23250627882,
        22.997676569716
    ],
    [
        113.23260318183,
        22.997801051563
    ],
    [
        113.23264136862,
        22.99782404662
    ],
    [
        113.23265869934,
        22.997837162116
    ],
    [
        113.23267414134,
        22.997840503256
    ],
    [
        113.23275543818,
        22.997829028121
    ],
    [
        113.23293241442,
        22.997774717348
    ],
    [
        113.23317740779,
        22.997699417115
    ],
    [
        113.23333350152,
        22.997654806778
    ],
    [
        113.23347685258,
        22.997616375416
    ],
    [
        113.23371829001,
        22.997554187626
    ],
    [
        113.23398466192,
        22.997465638871
    ],
    [
        113.23402449069,
        22.997457229449
    ],
    [
        113.23402990517,
        22.997461334561
    ],
    [
        113.23409429973,
        22.997555074478
    ],
    [
        113.23409348097,
        22.99756239189
    ],
    [
        113.23408724079,
        22.997574011757
    ],
    [
        113.2340717912,
        22.997584483832
    ],
    [
        113.23388562247,
        22.997659440982
    ],
    [
        113.23359890804,
        22.997772020808
    ],
    [
        113.2332027167,
        22.997892410194
    ],
    [
        113.23289892356,
        22.997974685191
    ],
    [
        113.232655826,
        22.998037037625
    ],
    [
        113.23238830663,
        22.998128603664
    ],
    [
        113.23190151528,
        22.998253036788
    ],
    [
        113.23167546262,
        22.998297513878
    ],
    [
        113.23123084604,
        22.998476684861
    ],
    [
        113.2308710603,
        22.998621924369
    ],
    [
        113.23051911768,
        22.99876052982
    ],
    [
        113.23025012708,
        22.998869694212
    ],
    [
        113.22986101919,
        22.998989941923
    ],
    [
        113.22969260383,
        22.999066738327
    ],
    [
        113.22968283232,
        22.999081627328
    ],
    [
        113.22970907729,
        22.999148967473
    ],
    [
        113.22980028578,
        22.999347503417
    ],
    [
        113.22998901228,
        22.999645892928
    ],
    [
        113.23009268828,
        22.999846121223
    ],
    [
        113.23010975203,
        22.999865705543
    ],
    [
        113.23006879198,
        22.999900017271
    ],
    [
        113.22996544867,
        22.999976714286
    ],
    [
        113.22982143138,
        23.00006306145
    ],
    [
        113.2297731363,
        23.000115263134
    ],
    [
        113.22976280758,
        23.000151305556
    ],
    [
        113.22975382679,
        23.000197658705
    ],
    [
        113.22976731726,
        23.000285305124
    ],
    [
        113.22986906998,
        23.000532972191
    ],
    [
        113.23006802491,
        23.000948309083
    ],
    [
        113.23030166638,
        23.001378992305
    ],
    [
        113.23053264814,
        23.001730518005
    ],
    [
        113.23064418843,
        23.001933543284
    ],
    [
        113.23073646289,
        23.002167154765
    ],
    [
        113.23073723976,
        23.002221946504
    ],
    [
        113.23071661343,
        23.002261466749
    ],
    [
        113.23068459414,
        23.002313962952
    ],
    [
        113.23057122854,
        23.002409009528
    ],
    [
        113.23040364347,
        23.002509298078
    ],
    [
        113.229860988,
        23.002841929586
    ],
    [
        113.22978257282,
        23.002947744136
    ],
    [
        113.22975354017,
        23.002986715192
    ],
    [
        113.22957909832,
        23.003176888783
    ],
    [
        113.22932844504,
        23.003402152212
    ],
    [
        113.2290883284,
        23.003674422296
    ],
    [
        113.22898494738,
        23.003802478004
    ],
    [
        113.22891354278,
        23.003960720419
    ],
    [
        113.22882689183,
        23.004226344788
    ],
    [
        113.22874810734,
        23.004489822828
    ],
    [
        113.2287010382,
        23.004775340224
    ],
    [
        113.22862656997,
        23.005089016021
    ],
    [
        113.22856383093,
        23.005277678736
    ],
    [
        113.22853225252,
        23.005513597826
    ],
    [
        113.22850476587,
        23.00570639869
    ],
    [
        113.22846099499,
        23.005930635439
    ],
    [
        113.22844299107,
        23.006147324641
    ],
    [
        113.22844426279,
        23.006321463446
    ],
    [
        113.22849026141,
        23.006532842218
    ],
    [
        113.22857143779,
        23.006910017856
    ],
    [
        113.22862260458,
        23.007095916354
    ],
    [
        113.22868896505,
        23.007264216843
    ],
    [
        113.22876918389,
        23.007364739181
    ],
    [
        113.22884670433,
        23.007432712551
    ],
    [
        113.22892043253,
        23.007489562178
    ],
    [
        113.22918203137,
        23.007610872836
    ],
    [
        113.22945121155,
        23.007727113593
    ],
    [
        113.22948753136,
        23.007751623921
    ],
    [
        113.22949104123,
        23.007787437813
    ],
    [
        113.22946770271,
        23.007842437178
    ],
    [
        113.22946688233,
        23.007859794647
    ],
    [
        113.22939062193,
        23.008048649159
    ],
    [
        113.2293629337,
        23.008134290249
    ],
    [
        113.22937320914,
        23.008204298562
    ],
    [
        113.22941110196,
        23.008372028635
    ],
    [
        113.22946850601,
        23.008568022626
    ],
    [
        113.22946738056,
        23.008679773435
    ],
    [
        113.22944513318,
        23.008722841829
    ],
    [
        113.22940472606,
        23.008750943859
    ],
    [
        113.22926480002,
        23.008821920629
    ],
    [
        113.22895484285,
        23.008957893495
    ],
    [
        113.22842597733,
        23.009272576056
    ],
    [
        113.22795944021,
        23.009585157506
    ],
    [
        113.22775490815,
        23.009734639291
    ],
    [
        113.22754601679,
        23.009927556258
    ],
    [
        113.22728582708,
        23.010224367248
    ],
    [
        113.22715070356,
        23.01040059722
    ],
    [
        113.22699332668,
        23.010612640489
    ],
    [
        113.22672518701,
        23.011185451234
    ],
    [
        113.2266161027,
        23.01134710694
    ],
    [
        113.22655289029,
        23.011380469421
    ],
    [
        113.22652549254,
        23.011379113502
    ],
    [
        113.22649077108,
        23.011374503625
    ],
    [
        113.22619241441,
        23.011161356413
    ],
    [
        113.22584793744,
        23.01088593358
    ],
    [
        113.22568734591,
        23.010797079962
    ],
    [
        113.22565479445,
        23.010773507676
    ],
    [
        113.22563634742,
        23.010764571911
    ],
    [
        113.22559944702,
        23.010770571594
    ],
    [
        113.22488250319,
        23.011085829234
    ],
    [
        113.22397735773,
        23.011555799022
    ],
    [
        113.22316573456,
        23.011940511574
    ],
    [
        113.22267572392,
        23.012146955846
    ],
    [
        113.22226361697,
        23.012190553845
    ],
    [
        113.22209719257,
        23.012198277399
    ],
    [
        113.22205076852,
        23.012189788786
    ],
    [
        113.22199511657,
        23.012162624105
    ],
    [
        113.22176899167,
        23.011961510473
    ],
    [
        113.22151761457,
        23.011728822994
    ],
    [
        113.22148992739,
        23.011689619442
    ],
    [
        113.22145086797,
        23.011502364611
    ],
    [
        113.22143512601,
        23.011472600497
    ],
    [
        113.22142454078,
        23.011453119983
    ],
    [
        113.2211687921,
        23.011295670371
    ],
    [
        113.22097141148,
        23.011158323286
    ],
    [
        113.22094751758,
        23.011147866882
    ],
    [
        113.22092715002,
        23.011153125517
    ],
    [
        113.22084538872,
        23.011254185164
    ],
    [
        113.22057373682,
        23.011659536072
    ],
    [
        113.22042217079,
        23.01179763021
    ],
    [
        113.22035725701,
        23.011830817625
    ],
    [
        113.22030701276,
        23.011840054495
    ],
    [
        113.21957593415,
        23.011523291409
    ],
    [
        113.2195444323,
        23.011496908633
    ],
    [
        113.21954280792,
        23.011472777318
    ],
    [
        113.21981049156,
        23.01085834126
    ],
    [
        113.21990753773,
        23.010537943275
    ],
    [
        113.21991950637,
        23.010470871712
    ],
    [
        113.21991272491,
        23.010439718776
    ],
    [
        113.21989833392,
        23.01042570083
    ],
    [
        113.21984048456,
        23.010418457873
    ],
    [
        113.2197522071,
        23.010438259624
    ],
    [
        113.21900730697,
        23.010820420837
    ],
    [
        113.21888151667,
        23.010890727545
    ],
    [
        113.21881632039,
        23.010890639206
    ],
    [
        113.21877503526,
        23.010865973425
    ],
    [
        113.21874109639,
        23.010795144292
    ],
    [
        113.21872103946,
        23.010620599581
    ],
    [
        113.21870648335,
        23.010210841826
    ],
    [
        113.2186555451,
        23.009763641268
    ],
    [
        113.21861565881,
        23.009611213052
    ],
    [
        113.21854420927,
        23.00961742337
    ],
    [
        113.21813148285,
        23.009783226902
    ],
    [
        113.21763885514,
        23.00992322622
    ],
    [
        113.21707147196,
        23.010027708361
    ],
    [
        113.21618227377,
        23.010104438211
    ],
    [
        113.2155644961,
        23.010131949882
    ],
    [
        113.21524784096,
        23.010135315333
    ],
    [
        113.2146329575,
        23.010181145444
    ],
    [
        113.21400877279,
        23.010227631395
    ],
    [
        113.21326868415,
        23.010344612144
    ],
    [
        113.21279990701,
        23.010402365368
    ],
    [
        113.21221607345,
        23.010453520185
    ],
    [
        113.21197078007,
        23.010469796809
    ],
    [
        113.21185737576,
        23.010480684392
    ],
    [
        113.2110773418,
        23.010654878471
    ],
    [
        113.21039080456,
        23.0108065175
    ],
    [
        113.20978119567,
        23.010941933746
    ],
    [
        113.20926023762,
        23.011036186635
    ],
    [
        113.20855206693,
        23.011159579003
    ],
    [
        113.20815538018,
        23.011228507368
    ],
    [
        113.20813796531,
        23.011238254539
    ],
    [
        113.20811429287,
        23.011247550483
    ],
    [
        113.20810367664,
        23.01127021912
    ],
    [
        113.20808216565,
        23.011342957227
    ],
    [
        113.20806909815,
        23.011377054463
    ],
    [
        113.20803835173,
        23.011386183311
    ],
    [
        113.20794148582,
        23.011416895656
    ],
    [
        113.20791209589,
        23.011441196854
    ],
    [
        113.2078824242,
        23.01150754697
    ],
    [
        113.20786825148,
        23.011617341732
    ],
    [
        113.20786929193,
        23.011839212603
    ],
    [
        113.20787714435,
        23.012023821985
    ],
    [
        113.20788138097,
        23.012659855983
    ],
    [
        113.20786987348,
        23.013185180872
    ],
    [
        113.20787254141,
        23.013599355208
    ],
    [
        113.20784503763,
        23.013813512808
    ],
    [
        113.20781944345,
        23.013999432016
    ],
    [
        113.20694960295,
        23.013620450867
    ],
    [
        113.20628731445,
        23.013338982124
    ],
    [
        113.20550960154,
        23.013069297946
    ],
    [
        113.20497050653,
        23.012891789299
    ],
    [
        113.20447765506,
        23.01273046409
    ],
    [
        113.20375045811,
        23.012489531397
    ],
    [
        113.20329348695,
        23.012372311466
    ],
    [
        113.20267973533,
        23.012170716223
    ],
    [
        113.20220259487,
        23.012043409363
    ],
    [
        113.20168761321,
        23.011880190754
    ],
    [
        113.20152729221,
        23.011825695889
    ],
    [
        113.2008059524,
        23.011661781526
    ],
    [
        113.20052448475,
        23.011612399598
    ],
    [
        113.20037559367,
        23.011541742908
    ],
    [
        113.20002145662,
        23.011407661959
    ],
    [
        113.19963547168,
        23.011246762493
    ],
    [
        113.19934122187,
        23.01110624938
    ],
    [
        113.19912101522,
        23.010981266176
    ],
    [
        113.19887712935,
        23.010834462914
    ],
    [
        113.19854204709,
        23.010672183905
    ],
    [
        113.19824154101,
        23.010502253744
    ],
    [
        113.19804393558,
        23.010356825363
    ],
    [
        113.19796228037,
        23.010297507577
    ],
    [
        113.19790485612,
        23.010234235945
    ],
    [
        113.19776906527,
        23.01004377773
    ],
    [
        113.19760117029,
        23.009794756807
    ],
    [
        113.197432738,
        23.009533270254
    ],
    [
        113.19736716413,
        23.009424846935
    ],
    [
        113.1973105747,
        23.009317078649
    ],
    [
        113.19719632717,
        23.009050296352
    ],
    [
        113.1970956937,
        23.00878815664
    ],
    [
        113.19696322604,
        23.008487522664
    ],
    [
        113.19686668109,
        23.008231551381
    ],
    [
        113.19676034462,
        23.007961107357
    ],
    [
        113.19662488504,
        23.007682500483
    ],
    [
        113.19662270824,
        23.007679826632
    ],
    [
        113.19660910068,
        23.007668946799
    ],
    [
        113.19657996187,
        23.007688721147
    ],
    [
        113.1964288288,
        23.007774398491
    ],
    [
        113.19641113004,
        23.007780950594
    ],
    [
        113.19632862666,
        23.007811435042
    ],
    [
        113.19627553483,
        23.007820784057
    ],
    [
        113.19623605629,
        23.00782772196
    ],
    [
        113.19623033471,
        23.007838130502
    ],
    [
        113.19620691187,
        23.00786105849
    ],
    [
        113.19618975155,
        23.00788197685
    ],
    [
        113.19619323935,
        23.00800424527
    ],
    [
        113.19618256121,
        23.008150634141
    ],
    [
        113.19621045476,
        23.008519030915
    ],
    [
        113.1962006407,
        23.008552839002
    ],
    [
        113.19617259383,
        23.008567169255
    ],
    [
        113.19616523893,
        23.008578149295
    ],
    [
        113.19614917823,
        23.008573551388
    ],
    [
        113.1961252212,
        23.008572077027
    ],
    [
        113.19607785408,
        23.008562879976
    ],
    [
        113.19588731594,
        23.008477286352
    ],
    [
        113.19571419366,
        23.008412811719
    ],
    [
        113.19544251872,
        23.008350079608
    ],
    [
        113.19520486698,
        23.008307628193
    ],
    [
        113.19487519619,
        23.008270053
    ],
    [
        113.19456702475,
        23.008255688596
    ],
    [
        113.19418371701,
        23.008241823546
    ],
    [
        113.19392290901,
        23.008252374171
    ],
    [
        113.19368360161,
        23.008281797876
    ],
    [
        113.19362370388,
        23.008296680864
    ],
    [
        113.19360300764,
        23.008312504267
    ],
    [
        113.19359946517,
        23.008320974854
    ],
    [
        113.19360135856,
        23.008351320925
    ],
    [
        113.19360270927,
        23.008377336619
    ],
    [
        113.19362448797,
        23.008377497595
    ],
    [
        113.1936449042,
        23.008380937298
    ],
    [
        113.19386078752,
        23.008379863953
    ],
    [
        113.19428113003,
        23.008361626604
    ],
    [
        113.19447768444,
        23.008368201485
    ],
    [
        113.1947774178,
        23.008378106065
    ],
    [
        113.1950093672,
        23.008380520931
    ],
    [
        113.19529738784,
        23.008412319895
    ],
    [
        113.19552932644,
        23.008445920231
    ],
    [
        113.19580616173,
        23.008541380575
    ],
    [
        113.19593572879,
        23.008596861347
    ],
    [
        113.1960516825,
        23.008655837751
    ],
    [
        113.19612679509,
        23.008726658355
    ],
    [
        113.1961967285,
        23.008815472811
    ],
    [
        113.19623046477,
        23.008874549065
    ],
    [
        113.19623533746,
        23.008949055127
    ],
    [
        113.19623366596,
        23.009052429188
    ],
    [
        113.19622817078,
        23.009191404299
    ],
    [
        113.19620470814,
        23.009330969146
    ],
    [
        113.1961894098,
        23.009482324438
    ],
    [
        113.19618826911,
        23.009634514189
    ],
    [
        113.19618715747,
        23.009702345704
    ],
    [
        113.19618606514,
        23.009712401207
    ],
    [
        113.19617789691,
        23.009714987122
    ],
    [
        113.1961648293,
        23.009714404852
    ],
    [
        113.19586808042,
        23.009717761625
    ],
    [
        113.19546515807,
        23.009716755633
    ],
    [
        113.19521169893,
        23.009716084086
    ],
    [
        113.19520516631,
        23.009712402097
    ],
    [
        113.19519673194,
        23.009696818836
    ],
    [
        113.19519810397,
        23.009664516158
    ],
    [
        113.19519816501,
        23.009484949592
    ],
    [
        113.19521351422,
        23.009190647348
    ],
    [
        113.19521270099,
        23.009180896875
    ],
    [
        113.19521515482,
        23.009170817407
    ],
    [
        113.1951969133,
        23.009174123553
    ],
    [
        113.19508366128,
        23.009170700044
    ],
    [
        113.1947920865,
        23.009178832352
    ],
    [
        113.19444171245,
        23.009177957583
    ],
    [
        113.19432600915,
        23.009181622534
    ],
    [
        113.19425521757,
        23.009207551824
    ],
    [
        113.19418388222,
        23.009231862672
    ],
    [
        113.19413705484,
        23.009238382332
    ],
    [
        113.19375292315,
        23.009252180214
    ],
    [
        113.19327596934,
        23.009251306133
    ],
    [
        113.19304103629,
        23.009244555881
    ],
    [
        113.19303150701,
        23.00924797693
    ],
    [
        113.19303096644,
        23.009237136517
    ],
    [
        113.19303045631,
        23.009142209413
    ],
    [
        113.19304664285,
        23.008806668382
    ],
    [
        113.1930630998,
        23.008489839639
    ],
    [
        113.19305496854,
        23.008400471051
    ],
    [
        113.19304898335,
        23.00839081063
    ],
    [
        113.19304680474,
        23.008392747311
    ],
    [
        113.19261584928,
        23.008439574107
    ],
    [
        113.1922839869,
        23.008493062542
    ],
    [
        113.19200004166,
        23.008541363473
    ],
    [
        113.1916189181,
        23.008592671023
    ],
    [
        113.19131701294,
        23.008648017801
    ],
    [
        113.19130694979,
        23.008625947631
    ],
    [
        113.19132159822,
        23.008079685017
    ],
    [
        113.19133523927,
        23.007384531721
    ],
    [
        113.19134539514,
        23.007200457467
    ],
    [
        113.19133587371,
        23.007187600609
    ],
    [
        113.19101521233,
        23.007188454105
    ],
    [
        113.1909085069,
        23.007190809169
    ],
    [
        113.19090170639,
        23.007180888716
    ],
    [
        113.19090174596,
        23.007095718805
    ],
    [
        113.19089779616,
        23.006814239656
    ],
    [
        113.190908309,
        23.006467961292
    ],
    [
        113.19090992901,
        23.005958550703
    ],
    [
        113.19090958098,
        23.005587234821
    ],
    [
        113.19092782093,
        23.005087039835
    ],
    [
        113.19093265936,
        23.004715910366
    ],
    [
        113.19091128698,
        23.004489522707
    ],
    [
        113.19089925273,
        23.004128174883
    ],
    [
        113.19088301787,
        23.003967610265
    ],
    [
        113.19087349745,
        23.003956651303
    ],
    [
        113.19073549899,
        23.003943800691
    ],
    [
        113.19053190382,
        23.003927712381
    ],
    [
        113.19052265067,
        23.003925156156
    ],
    [
        113.19051531505,
        23.003902767718
    ],
    [
        113.19049518251,
        23.003449339029
    ],
    [
        113.19053973498,
        23.003160542143
    ],
    [
        113.19072729241,
        23.002319007498
    ],
    [
        113.19071559983,
        23.002301304386
    ],
    [
        113.19002600062,
        23.002093753903
    ],
    [
        113.19001103753,
        23.002083155008
    ],
    [
        113.19031098219,
        23.000948475586
    ],
    [
        113.19032762082,
        23.000901003016
    ],
    [
        113.18986606483,
        23.000795087513
    ],
    [
        113.18920969485,
        23.000622071139
    ],
    [
        113.18805462079,
        23.000281741051
    ],
    [
        113.18781952869,
        23.000224202799
    ],
    [
        113.1878078327,
        23.000215981296
    ],
    [
        113.18787662006,
        22.99994637469
    ],
    [
        113.18723328687,
        22.999941098445
    ],
    [
        113.1872267504,
        22.999947981561
    ],
    [
        113.18721288743,
        22.999927586209
    ],
    [
        113.18718146443,
        22.999053392231
    ],
    [
        113.1871675928,
        22.99904465933
    ],
    [
        113.18715344187,
        22.999044880971
    ],
    [
        113.18680539981,
        22.999036743738
    ],
    [
        113.18619231352,
        22.999054572994
    ],
    [
        113.18617898367,
        22.999050436383
    ],
    [
        113.18617628416,
        22.999023626703
    ],
    [
        113.18621172235,
        22.998608663916
    ],
    [
        113.18624850721,
        22.998217277214
    ],
    [
        113.18624879216,
        22.99820181343
    ],
    [
        113.18624281993,
        22.998184817761
    ],
    [
        113.18623085047,
        22.998180931972
    ],
    [
        113.1857129964,
        22.998238936893
    ],
    [
        113.18539625354,
        22.998277292214
    ],
    [
        113.18538239081,
        22.998260953508
    ],
    [
        113.18531099817,
        22.998062665506
    ],
    [
        113.18507339464,
        22.997194744773
    ],
    [
        113.18506986605,
        22.997185032742
    ],
    [
        113.18505871178,
        22.997184111459
    ],
    [
        113.18422380291,
        22.997442433684
    ],
    [
        113.18422243221,
        22.997454657935
    ],
    [
        113.18419426443,
        22.997948673919
    ],
    [
        113.18418609467,
        22.997958553757
    ],
    [
        113.18315619336,
        22.997941412198
    ],
    [
        113.1831216593,
        22.997927235936
    ],
    [
        113.1831170512,
        22.997908042056
    ],
    [
        113.18307616757,
        22.997682672477
    ],
    [
        113.18305237006,
        22.99751863721
    ],
    [
        113.18304105913,
        22.997385893963
    ],
    [
        113.18300195281,
        22.997312109443
    ],
    [
        113.1829076778,
        22.997181840636
    ],
    [
        113.18287561995,
        22.997136707335
    ],
    [
        113.18287129596,
        22.997104219443
    ],
    [
        113.18287268751,
        22.997067857731
    ],
    [
        113.18286827113,
        22.996829246715
    ],
    [
        113.18286883863,
        22.9968023887
    ],
    [
        113.1826959571,
        22.996673704762
    ],
    [
        113.18269758817,
        22.996674767884
    ],
    [
        113.18268590536,
        22.996659735484
    ],
    [
        113.18268078691,
        22.99660339078
    ],
    [
        113.18267020172,
        22.996577495024
    ],
    [
        113.18265334687,
        22.996567141914
    ],
    [
        113.18248661943,
        22.996559858781
    ],
    [
        113.18237239067,
        22.996551056422
    ],
    [
        113.1823506351,
        22.99654700247
    ],
    [
        113.18232671514,
        22.996529958228
    ],
    [
        113.18230416096,
        22.996506386581
    ],
    [
        113.18228027282,
        22.996453540776
    ],
    [
        113.18225449341,
        22.996386616119
    ],
    [
        113.18224445581,
        22.996357455874
    ],
    [
        113.18222979108,
        22.996332152933
    ],
    [
        113.18220179372,
        22.996312990289
    ],
    [
        113.18209169234,
        22.996255295418
    ],
    [
        113.18186302869,
        22.996178774894
    ],
    [
        113.18142936389,
        22.996046491782
    ],
    [
        113.18104843875,
        22.995961444248
    ],
    [
        113.18062753506,
        22.99590417269
    ],
    [
        113.18017209589,
        22.995877289156
    ],
    [
        113.17972887985,
        22.995896228984
    ],
    [
        113.17923073575,
        22.99595713126
    ],
    [
        113.179044179,
        22.996017755299
    ],
    [
        113.17884317447,
        22.996128141457
    ],
    [
        113.17856107968,
        22.996335092582
    ],
    [
        113.17824575599,
        22.9966307434
    ],
    [
        113.17803757714,
        22.996892693315
    ],
    [
        113.17795989491,
        22.99713703057
    ],
    [
        113.17794431668,
        22.997234554345
    ],
    [
        113.17792733668,
        22.997381996128
    ],
    [
        113.17788239027,
        22.99749418846
    ],
    [
        113.17770514073,
        22.997844737003
    ],
    [
        113.17753116057,
        22.998196315307
    ],
    [
        113.17736268294,
        22.998477572301
    ],
    [
        113.17720158215,
        22.998720224596
    ],
    [
        113.17697404065,
        22.99912648068
    ],
    [
        113.17694708526,
        22.999187755931
    ],
    [
        113.17695901094,
        22.999228328355
    ],
    [
        113.17701659478,
        22.999270102498
    ],
    [
        113.17708639008,
        22.999336169332
    ],
    [
        113.17710675091,
        22.99936499863
    ],
    [
        113.17712032363,
        22.999385754918
    ],
    [
        113.17711758826,
        22.999407749625
    ],
    [
        113.1771088792,
        22.999422748795
    ],
    [
        113.17709636061,
        22.999443479377
    ],
    [
        113.17687660037,
        22.999648400139
    ],
    [
        113.17631285327,
        23.000139777807
    ],
    [
        113.17589954987,
        23.000475585566
    ],
    [
        113.17541394476,
        23.000889951789
    ],
    [
        113.17497748775,
        23.001405186781
    ],
    [
        113.17490756199,
        23.001546217164
    ],
    [
        113.174897766,
        23.001567447475
    ],
    [
        113.17473949307,
        23.001782369101
    ],
    [
        113.17442515094,
        23.002194504658
    ],
    [
        113.17424109393,
        23.002401681191
    ],
    [
        113.17408670988,
        23.002526712921
    ],
    [
        113.17403698335,
        23.002548754852
    ],
    [
        113.17399079346,
        23.002563718508
    ],
    [
        113.17391799658,
        23.002558790308
    ],
    [
        113.17332508363,
        23.002487533118
    ],
    [
        113.17289844008,
        23.00242313822
    ],
    [
        113.17265105037,
        23.002386057702
    ],
    [
        113.17240069487,
        23.002333750829
    ],
    [
        113.17219323986,
        23.00230584457
    ],
    [
        113.17204961376,
        23.002267808649
    ],
    [
        113.1717509514,
        23.00221614824
    ],
    [
        113.17152806086,
        23.002163784133
    ],
    [
        113.17111812454,
        23.002089416776
    ],
    [
        113.17077065594,
        23.002022243803
    ],
    [
        113.170646318,
        23.002019209386
    ],
    [
        113.17058576937,
        23.00203137772
    ],
    [
        113.17048121354,
        23.002084935205
    ],
    [
        113.17034758987,
        23.002171407217
    ],
    [
        113.17006434053,
        23.002340017095
    ],
    [
        113.1697284135,
        23.002559707751
    ],
    [
        113.16956709994,
        23.002682242998
    ],
    [
        113.16949079311,
        23.002735894938
    ],
    [
        113.16938520276,
        23.0027470393
    ],
    [
        113.16925031942,
        23.00273221259
    ],
    [
        113.16911817222,
        23.002689696874
    ],
    [
        113.1689491473,
        23.002604397944
    ],
    [
        113.16881620819,
        23.002540420241
    ],
    [
        113.1687006176,
        23.00251083582
    ],
    [
        113.16851745472,
        23.002484356297
    ],
    [
        113.1683228934,
        23.002468715159
    ],
    [
        113.16816714443,
        23.002451078084
    ],
    [
        113.16806512037,
        23.002443644463
    ],
    [
        113.16797312676,
        23.002452731762
    ],
    [
        113.16783200492,
        23.002486829951
    ],
    [
        113.16768326924,
        23.002550753924
    ],
    [
        113.16748486768,
        23.002641288298
    ],
    [
        113.16734943381,
        23.002709221476
    ],
    [
        113.1671667654,
        23.002823009472
    ],
    [
        113.16700311539,
        23.002905564893
    ],
    [
        113.1667974065,
        23.003010080805
    ],
    [
        113.16668749895,
        23.00306680114
    ],
    [
        113.16662291758,
        23.003092311048
    ],
    [
        113.16657599511,
        23.003079571057
    ],
    [
        113.16654212161,
        23.003025329255
    ],
    [
        113.16652887886,
        23.002950470957
    ],
    [
        113.1665300162,
        23.002872085158
    ],
    [
        113.16656459724,
        23.002679778668
    ],
    [
        113.16658997516,
        23.002460349903
    ],
    [
        113.16657515365,
        23.002316871713
    ],
    [
        113.16657166459,
        23.002262626343
    ],
    [
        113.16655920098,
        23.002240929692
    ],
    [
        113.16655243022,
        23.002224928025
    ],
    [
        113.16653235445,
        23.00222710015
    ],
    [
        113.16651689058,
        23.002229000263
    ],
    [
        113.166492199,
        23.002237410317
    ],
    [
        113.16640449063,
        23.002365432926
    ],
    [
        113.16634338725,
        23.00246551407
    ],
    [
        113.16632190061,
        23.002548779899
    ],
    [
        113.16629607323,
        23.00263340102
    ],
    [
        113.16625696058,
        23.002709069052
    ],
    [
        113.16616901202,
        23.002800185581
    ],
    [
        113.16608894038,
        23.002878007134
    ],
    [
        113.16593914987,
        23.002971525279
    ],
    [
        113.1657408086,
        23.003071773857
    ],
    [
        113.16570689478,
        23.003086669628
    ],
    [
        113.16567841435,
        23.00308854899
    ],
    [
        113.16565240951,
        23.00303835297
    ],
    [
        113.16559201367,
        23.002906218661
    ],
    [
        113.16550724803,
        23.00271655981
    ],
    [
        113.16545115734,
        23.002640023761
    ],
    [
        113.16542378261,
        23.002613146947
    ],
    [
        113.16535815416,
        23.002604947228
    ],
    [
        113.16525021079,
        23.00260727628
    ],
    [
        113.16516856635,
        23.002624271867
    ],
    [
        113.16507742846,
        23.002645317908
    ],
    [
        113.16497215107,
        23.002724109396
    ],
    [
        113.16488069336,
        23.002822710365
    ],
    [
        113.16487252395,
        23.002873147586
    ],
    [
        113.16486487809,
        23.002952064786
    ],
    [
        113.16485644139,
        23.002997076928
    ],
    [
        113.16482548251,
        23.003062940688
    ],
    [
        113.16477009716,
        23.003159686811
    ],
    [
        113.16469843332,
        23.003269694609
    ],
    [
        113.16467234535,
        23.003354005691
    ],
    [
        113.16465928813,
        23.003416910258
    ],
    [
        113.16466358765,
        23.003477944545
    ],
    [
        113.16466541951,
        23.003581558331
    ],
    [
        113.16464851655,
        23.00372311413
    ],
    [
        113.16458824164,
        23.003840457141
    ],
    [
        113.16453312972,
        23.003942616899
    ],
    [
        113.16445280611,
        23.004035234984
    ],
    [
        113.16431008688,
        23.00417682006
    ],
    [
        113.16421702197,
        23.004271565644
    ],
    [
        113.16413454018,
        23.004356018897
    ],
    [
        113.16401515081,
        23.004495987295
    ],
    [
        113.16392807021,
        23.004569294073
    ],
    [
        113.16388548992,
        23.00458845245
    ],
    [
        113.16386488332,
        23.004588675023
    ],
    [
        113.1637507694,
        23.004532252797
    ],
    [
        113.1635320132,
        23.004461439156
    ],
    [
        113.16333955006,
        23.004413440554
    ],
    [
        113.16310968271,
        23.004364480104
    ],
    [
        113.16299609822,
        23.00435653127
    ],
    [
        113.16292074414,
        23.004341100572
    ],
    [
        113.16283482475,
        23.004315865209
    ],
    [
        113.16277845888,
        23.004283671001
    ],
    [
        113.1627410783,
        23.004236620804
    ],
    [
        113.16272049665,
        23.004203188705
    ],
    [
        113.16272350094,
        23.004166582357
    ],
    [
        113.16273710211,
        23.004089869536
    ],
    [
        113.16275123733,
        23.004026720106
    ],
    [
        113.16273774654,
        23.003924961537
    ],
    [
        113.16272510855,
        23.003761093361
    ],
    [
        113.16272756744,
        23.003730723641
    ],
    [
        113.16268995154,
        23.003629695718
    ],
    [
        113.16263961858,
        23.003493090681
    ],
    [
        113.16262637221,
        23.003436627873
    ],
    [
        113.16262557788,
        23.00340733197
    ],
    [
        113.16262748118,
        23.003398387978
    ],
    [
        113.16262776576,
        23.003377504076
    ],
    [
        113.16269284978,
        23.003337859358
    ],
    [
        113.16277474116,
        23.003299081324
    ],
    [
        113.16297455851,
        23.003259052507
    ],
    [
        113.16301631316,
        23.00324942061
    ],
    [
        113.16306105497,
        23.003232473149
    ],
    [
        113.16312588085,
        23.003181410121
    ],
    [
        113.16315898621,
        23.0031340451
    ],
    [
        113.1631793338,
        23.003111322935
    ],
    [
        113.16318261115,
        23.003074716493
    ],
    [
        113.16318182023,
        23.003040810165
    ],
    [
        113.16318292904,
        23.003003926001
    ],
    [
        113.16317237171,
        23.002980297135
    ],
    [
        113.16314800379,
        23.00293330048
    ],
    [
        113.16307729388,
        23.002862834855
    ],
    [
        113.16300495672,
        23.002795071837
    ],
    [
        113.16294751242,
        23.002754475153
    ],
    [
        113.16289086579,
        23.002738017614
    ],
    [
        113.16278596547,
        23.002723565692
    ],
    [
        113.16273174877,
        23.002724195619
    ],
    [
        113.1626241293,
        23.002726806419
    ],
    [
        113.16248883788,
        23.002766736243
    ],
    [
        113.16229931758,
        23.002837093283
    ],
    [
        113.16220984589,
        23.002871737673
    ],
    [
        113.16214153911,
        23.002874182111
    ],
    [
        113.16207296123,
        23.002877977374
    ],
    [
        113.16199544705,
        23.002870882633
    ],
    [
        113.16189273888,
        23.002846589867
    ],
    [
        113.16179654798,
        23.002806583941
    ],
    [
        113.1617345163,
        23.002755054866
    ],
    [
        113.16163671574,
        23.002694956977
    ],
    [
        113.16153350312,
        23.002625333017
    ],
    [
        113.16142757181,
        23.002571418357
    ],
    [
        113.16128153626,
        23.002513236124
    ],
    [
        113.1612059477,
        23.002480870713
    ],
    [
        113.16119023992,
        23.0024656063
    ],
    [
        113.16115855222,
        23.002436974112
    ],
    [
        113.16113987216,
        23.002409217992
    ],
    [
        113.16112146431,
        23.002379835509
    ],
    [
        113.1610946876,
        23.002304031361
    ],
    [
        113.16103459518,
        23.002204465073
    ],
    [
        113.1609904615,
        23.002149185895
    ],
    [
        113.16095146197,
        23.002115629213
    ],
    [
        113.16091788349,
        23.002080742458
    ],
    [
        113.16086262137,
        23.002052796146
    ],
    [
        113.16082632625,
        23.002028470739
    ],
    [
        113.16081088015,
        23.002028391246
    ],
    [
        113.16078676684,
        23.002022299665
    ],
    [
        113.16077321279,
        23.002029281417
    ],
    [
        113.16076019845,
        23.00203952057
    ],
    [
        113.1607184449,
        23.002071579086
    ],
    [
        113.16063222212,
        23.002145712572
    ],
    [
        113.16052674605,
        23.00224279013
    ],
    [
        113.16042752774,
        23.002306259698
    ],
    [
        113.16035624646,
        23.002331903902
    ],
    [
        113.16032128208,
        23.00234689794
    ],
    [
        113.16030013009,
        23.00237173274
    ],
    [
        113.16027926072,
        23.002379752437
    ],
    [
        113.16026218817,
        23.002382911023
    ],
    [
        113.16024647717,
        23.002376312748
    ],
    [
        113.16020665329,
        23.00236659376
    ],
    [
        113.16012998237,
        23.002353678258
    ],
    [
        113.16005820676,
        23.002315832857
    ],
    [
        113.15996395436,
        23.002262661513
    ],
    [
        113.15985236461,
        23.002208022261
    ],
    [
        113.15977463676,
        23.002163613687
    ],
    [
        113.15965574484,
        23.002096163011
    ],
    [
        113.1595503983,
        23.002033667098
    ],
    [
        113.15947459634,
        23.001953719083
    ],
    [
        113.15943046638,
        23.001911398077
    ],
    [
        113.159376337,
        23.001835107519
    ],
    [
        113.15932842506,
        23.001778925625
    ],
    [
        113.15925480285,
        23.001686771977
    ],
    [
        113.15919906089,
        23.00159581628
    ],
    [
        113.1591663284,
        23.001530234398
    ],
    [
        113.1591252136,
        23.001443440145
    ],
    [
        113.15909439241,
        23.001358340506
    ],
    [
        113.15905626888,
        23.001257459948
    ],
    [
        113.15904303335,
        23.001204752889
    ],
    [
        113.15901868121,
        23.001165532345
    ],
    [
        113.15897455607,
        23.00112319411
    ],
    [
        113.15887600677,
        23.00104712138
    ],
    [
        113.15881048059,
        23.00100761355
    ],
    [
        113.15872221046,
        23.000955195631
    ],
    [
        113.15865667147,
        23.000935478698
    ],
    [
        113.1586409657,
        23.000928316049
    ],
    [
        113.15859113081,
        23.000919012803
    ],
    [
        113.15849362348,
        23.000908281072
    ],
    [
        113.15839963101,
        23.000908415862
    ],
    [
        113.15823899479,
        23.0009259529
    ],
    [
        113.15810219308,
        23.000950428087
    ],
    [
        113.15800033705,
        23.000971085178
    ],
    [
        113.15787112138,
        23.000999930921
    ],
    [
        113.15780772019,
        23.001032258956
    ],
    [
        113.1577332104,
        23.001071277433
    ],
    [
        113.15767413455,
        23.001116651185
    ],
    [
        113.15761504206,
        23.00118561879
    ],
    [
        113.15755783072,
        23.001275754362
    ],
    [
        113.15751362128,
        23.001364092888
    ],
    [
        113.1574398768,
        23.001474161362
    ],
    [
        113.15732066108,
        23.001549137326
    ],
    [
        113.15731849298,
        23.001551289443
    ],
    [
        113.15730195929,
        23.001570411488
    ],
    [
        113.15727783445,
        23.001601133904
    ],
    [
        113.15723819419,
        23.001742661064
    ],
    [
        113.15716760878,
        23.001988625572
    ],
    [
        113.1571149065,
        23.002225242666
    ],
    [
        113.15708469962,
        23.002438991663
    ],
    [
        113.15705753233,
        23.002565971629
    ],
    [
        113.1570019856,
        23.002612427471
    ],
    [
        113.15695918032,
        23.002639460083
    ],
    [
        113.15693372266,
        23.002642770212
    ],
    [
        113.15685139758,
        23.002645594449
    ],
    [
        113.15674824003,
        23.002622466235
    ],
    [
        113.15651079478,
        23.002569399483
    ],
    [
        113.15638515396,
        23.002567740418
    ],
    [
        113.15628631633,
        23.002574718764
    ],
    [
        113.15614549873,
        23.002600292831
    ],
    [
        113.15606369013,
        23.002655959359
    ],
    [
        113.15597321576,
        23.00271560874
    ],
    [
        113.15588216728,
        23.002826237926
    ],
    [
        113.15585907734,
        23.002940210887
    ],
    [
        113.15586304217,
        23.003086442457
    ],
    [
        113.15591003606,
        23.003266437623
    ],
    [
        113.15604207057,
        23.003414940922
    ],
    [
        113.15617252075,
        23.003506185641
    ],
    [
        113.15625343643,
        23.003575813483
    ],
    [
        113.15627291258,
        23.003606367677
    ],
    [
        113.15627802197,
        23.00366201678
    ],
    [
        113.15630995022,
        23.003698378638
    ],
    [
        113.15638841989,
        23.003786148455
    ],
    [
        113.15640246711,
        23.003839164603
    ],
    [
        113.15639564123,
        23.003929696034
    ],
    [
        113.15636794661,
        23.004051504125
    ],
    [
        113.1563632966,
        23.00412767955
    ],
    [
        113.15637055697,
        23.0042104713
    ],
    [
        113.1564116612,
        23.004299261219
    ],
    [
        113.15642299418,
        23.004365001231
    ],
    [
        113.15644324291,
        23.004464453719
    ],
    [
        113.15644697898,
        23.004556435943
    ],
    [
        113.15642474607,
        23.004605331909
    ],
    [
        113.15638492204,
        23.004638609933
    ],
    [
        113.15631640355,
        23.004659423339
    ],
    [
        113.15616773396,
        23.004687371029
    ],
    [
        113.15601419355,
        23.004716612171
    ],
    [
        113.15587718199,
        23.004730528544
    ],
    [
        113.15566248811,
        23.004711958493
    ],
    [
        113.15560590672,
        23.004704909155
    ],
    [
        113.15551901145,
        23.004683461468
    ],
    [
        113.15541126822,
        23.004666416526
    ],
    [
        113.15527887863,
        23.004669463504
    ],
    [
        113.15511347472,
        23.004653724777
    ],
    [
        113.15490502229,
        23.004653804618
    ],
    [
        113.15477859287,
        23.004666896178
    ],
    [
        113.15462996837,
        23.00468001789
    ],
    [
        113.15450274121,
        23.004677885279
    ],
    [
        113.15438525005,
        23.004695100483
    ],
    [
        113.15426260895,
        23.00472771119
    ],
    [
        113.15417190602,
        23.004768246214
    ],
    [
        113.15415374956,
        23.004803855743
    ],
    [
        113.15413096464,
        23.004886068339
    ],
    [
        113.1540845746,
        23.005066758001
    ],
    [
        113.15403840948,
        23.005332346322
    ],
    [
        113.15400750834,
        23.005411486188
    ],
    [
        113.15396986643,
        23.005444170708
    ],
    [
        113.15389752667,
        23.005571682307
    ],
    [
        113.15387712541,
        23.005757530438
    ],
    [
        113.15386023902,
        23.005953723985
    ],
    [
        113.15386803388,
        23.006057151309
    ],
    [
        113.15386692208,
        23.006112743424
    ],
    [
        113.15384728594,
        23.006399501897
    ],
    [
        113.15384201414,
        23.006656038563
    ],
    [
        113.15382844813,
        23.0067218022
    ],
    [
        113.153805162,
        23.006739449673
    ],
    [
        113.15376183986,
        23.006770981695
    ],
    [
        113.15369063817,
        23.006805731501
    ],
    [
        113.15362484676,
        23.006848132266
    ],
    [
        113.15360152236,
        23.006946334765
    ],
    [
        113.15357756373,
        23.007241723388
    ],
    [
        113.15355693318,
        23.007371690859
    ],
    [
        113.15354446749,
        23.007405186368
    ],
    [
        113.15350277297,
        23.007434558516
    ],
    [
        113.15341290278,
        23.007463660749
    ],
    [
        113.1533390155,
        23.007463371912
    ],
    [
        113.15318961964,
        23.00746249267
    ],
    [
        113.15303238135,
        23.007455539829
    ],
    [
        113.15281100174,
        23.007461385261
    ],
    [
        113.1526892163,
        23.007470267665
    ],
    [
        113.15267866133,
        23.007471771144
    ],
    [
        113.1525498361,
        23.007493849798
    ],
    [
        113.15240856454,
        23.007517124513
    ],
    [
        113.15233602007,
        23.007562910508
    ],
    [
        113.15228593951,
        23.00760272455
    ],
    [
        113.1522418066,
        23.007656170792
    ],
    [
        113.15223149468,
        23.007720873827
    ],
    [
        113.15223688399,
        23.007772204015
    ],
    [
        113.1522511854,
        23.007864599552
    ],
    [
        113.15229310248,
        23.007926405289
    ],
    [
        113.15236883983,
        23.008002990944
    ],
    [
        113.15245594481,
        23.008077809337
    ],
    [
        113.15251653416,
        23.008144442043
    ],
    [
        113.15255196502,
        23.008191516161
    ],
    [
        113.15257630097,
        23.008238187055
    ],
    [
        113.15258683345,
        23.008289848208
    ],
    [
        113.15259303822,
        23.008336575779
    ],
    [
        113.15258651322,
        23.008409463867
    ],
    [
        113.15257702857,
        23.00844108757
    ],
    [
        113.15253750138,
        23.008482662921
    ],
    [
        113.15239053678,
        23.008534620777
    ],
    [
        113.15228715398,
        23.008559421153
    ],
    [
        113.15219298009,
        23.008567236961
    ],
    [
        113.15217052307,
        23.00855964167
    ],
    [
        113.1521258824,
        23.008538214696
    ],
    [
        113.15207259856,
        23.008478164212
    ],
    [
        113.15201606313,
        23.008430278195
    ],
    [
        113.15193004077,
        23.008364668818
    ],
    [
        113.1518816189,
        23.008330168233
    ],
    [
        113.15185186063,
        23.00831379837
    ],
    [
        113.15181939186,
        23.008308786781
    ],
    [
        113.15178448535,
        23.008309982991
    ],
    [
        113.15175742183,
        23.008321311632
    ],
    [
        113.15170600489,
        23.00833450749
    ],
    [
        113.15163969979,
        23.00836324835
    ],
    [
        113.15161263874,
        23.008369963213
    ],
    [
        113.15160451864,
        23.00837637174
    ],
    [
        113.15148954718,
        23.008316071233
    ],
    [
        113.15148279293,
        23.008291574225
    ],
    [
        113.15146656937,
        23.008265059382
    ],
    [
        113.15142061515,
        23.008161135997
    ],
    [
        113.15137492569,
        23.008072675639
    ],
    [
        113.15134600117,
        23.008010194586
    ],
    [
        113.15132599356,
        23.007976035529
    ],
    [
        113.15129354469,
        23.007930597295
    ],
    [
        113.15126298235,
        23.007902813291
    ],
    [
        113.15120536256,
        23.007876853844
    ],
    [
        113.15117289518,
        23.0078753545
    ],
    [
        113.15113826343,
        23.007873826773
    ],
    [
        113.15101730411,
        23.007914317205
    ],
    [
        113.15093909779,
        23.007948027727
    ],
    [
        113.15091527653,
        23.007976200389
    ],
    [
        113.15092039781,
        23.008021022108
    ],
    [
        113.15093823117,
        23.008075773024
    ],
    [
        113.1509528132,
        23.008141874084
    ],
    [
        113.1509733507,
        23.008200999511
    ],
    [
        113.15096116284,
        23.008231221728
    ],
    [
        113.15091351071,
        23.008312522029
    ],
    [
        113.15086234781,
        23.008379670585
    ],
    [
        113.15078900423,
        23.008436763969
    ],
    [
        113.15077979453,
        23.008463497408
    ],
    [
        113.15077518787,
        23.008481339652
    ],
    [
        113.15079976482,
        23.008588530846
    ],
    [
        113.15081623909,
        23.008662253043
    ],
    [
        113.15083217096,
        23.008740036774
    ],
    [
        113.1508716353,
        23.008833586847
    ],
    [
        113.15090786733,
        23.008891560737
    ],
    [
        113.15091109256,
        23.008947208229
    ],
    [
        113.15090404389,
        23.008984277912
    ],
    [
        113.15087506945,
        23.009049815712
    ],
    [
        113.15080550412,
        23.009137067773
    ],
    [
        113.15074947382,
        23.009206862311
    ],
    [
        113.15070589168,
        23.009270578978
    ],
    [
        113.15065744362,
        23.009324737013
    ],
    [
        113.15064605575,
        23.009393213653
    ],
    [
        113.15065442082,
        23.009454083061
    ],
    [
        113.15076474722,
        23.00961746097
    ],
    [
        113.15084317262,
        23.009718029961
    ],
    [
        113.1509075406,
        23.009788575705
    ],
    [
        113.15098406548,
        23.00991569565
    ],
    [
        113.15104005121,
        23.009976362888
    ],
    [
        113.15108251293,
        23.010026275885
    ],
    [
        113.15111253436,
        23.010060024617
    ],
    [
        113.15112848056,
        23.010112308942
    ],
    [
        113.15115822247,
        23.010174805807
    ],
    [
        113.15122934649,
        23.01028448489
    ],
    [
        113.15128938266,
        23.010380457469
    ],
    [
        113.1513421258,
        23.010439173984
    ],
    [
        113.15140406889,
        23.010498276081
    ],
    [
        113.15144707438,
        23.010550627287
    ],
    [
        113.15146654832,
        23.010575556288
    ],
    [
        113.15147843954,
        23.010622632395
    ],
    [
        113.15147247449,
        23.010664058951
    ],
    [
        113.15144188705,
        23.01070571808
    ],
    [
        113.15142022264,
        23.010768375576
    ],
    [
        113.15141859043,
        23.010798464007
    ],
    [
        113.15143264671,
        23.01084556788
    ],
    [
        113.15148240959,
        23.010926484923
    ],
    [
        113.15156192662,
        23.011044120967
    ],
    [
        113.15167878001,
        23.011182833005
    ],
    [
        113.1517591093,
        23.011312404106
    ],
    [
        113.15183916633,
        23.011455259112
    ],
    [
        113.15188947401,
        23.01154267986
    ],
    [
        113.15189190101,
        23.011575802736
    ],
    [
        113.15189947675,
        23.011579150901
    ],
    [
        113.15188865026,
        23.011590410512
    ],
    [
        113.15187538793,
        23.011603810112
    ],
    [
        113.15177066389,
        23.011627744506
    ],
    [
        113.15155337563,
        23.011667355374
    ],
    [
        113.15142863303,
        23.011693998791
    ],
    [
        113.1512838719,
        23.011714410203
    ],
    [
        113.1511209837,
        23.01174352722
    ],
    [
        113.15098813453,
        23.011758095491
    ],
    [
        113.15087720256,
        23.011772936631
    ],
    [
        113.15075544821,
        23.011796037656
    ],
    [
        113.15068239515,
        23.011815698579
    ],
    [
        113.15058445535,
        23.011823907558
    ],
    [
        113.15044756255,
        23.011816676277
    ],
    [
        113.15031364622,
        23.011817068027
    ],
    [
        113.1501681002,
        23.011813766359
    ],
    [
        113.15006827657,
        23.011807270679
    ],
    [
        113.1500266196,
        23.011789891091
    ],
    [
        113.14994708921,
        23.0117738966
    ],
    [
        113.149826438,
        23.011768731411
    ],
    [
        113.14967873596,
        23.011768340639
    ],
    [
        113.14952671174,
        23.011754043138
    ],
    [
        113.14942770592,
        23.01175403025
    ],
    [
        113.14929488522,
        23.011767645923
    ],
    [
        113.1492148161,
        23.011771682023
    ],
    [
        113.14911148744,
        23.011765622729
    ],
    [
        113.14899625538,
        23.011772138351
    ],
    [
        113.14888427207,
        23.011772996048
    ],
    [
        113.14881313416,
        23.01177144384
    ],
    [
        113.14875443896,
        23.011770608589
    ],
    [
        113.14865679353,
        23.01177463987
    ],
    [
        113.14858105676,
        23.011783862798
    ],
    [
        113.14853561449,
        23.011791619311
    ],
    [
        113.14851154211,
        23.011791001991
    ],
    [
        113.14845528454,
        23.011784495618
    ],
    [
        113.14836900351,
        23.011783249929
    ],
    [
        113.14828515523,
        23.01179180064
    ],
    [
        113.14819264973,
        23.011813241768
    ],
    [
        113.14813233257,
        23.011826196746
    ],
    [
        113.14801711163,
        23.011839702404
    ],
    [
        113.14794786864,
        23.011860387023
    ],
    [
        113.14792974686,
        23.011864460836
    ],
    [
        113.14781560348,
        23.011907536831
    ],
    [
        113.14766278493,
        23.011958983926
    ],
    [
        113.14753809711,
        23.012003785694
    ],
    [
        113.14746804712,
        23.012021728374
    ],
    [
        113.14734498591,
        23.012060845726
    ],
    [
        113.14726248832,
        23.012118740225
    ],
    [
        113.14720812569,
        23.012137723377
    ],
    [
        113.14710264965,
        23.012161629064
    ],
    [
        113.14700825928,
        23.012200887795
    ],
    [
        113.14693658575,
        23.012242115239
    ],
    [
        113.14681920324,
        23.012316821397
    ],
    [
        113.14671561343,
        23.012394987265
    ],
    [
        113.14661554093,
        23.012471032011
    ],
    [
        113.14648220261,
        23.012574769997
    ],
    [
        113.14630802286,
        23.012737001077
    ],
    [
        113.14616684131,
        23.012878302997
    ],
    [
        113.14607380083,
        23.012988339612
    ],
    [
        113.14603755799,
        23.013035515007
    ],
    [
        113.1459913067,
        23.013104505199
    ],
    [
        113.14594154137,
        23.013168556742
    ],
    [
        113.14589989026,
        23.013222426698
    ],
    [
        113.14583822654,
        23.013295783378
    ],
    [
        113.1457584421,
        23.013398691612
    ],
    [
        113.14569461078,
        23.013512970639
    ],
    [
        113.14565511981,
        23.013602676736
    ],
    [
        113.1455926307,
        23.013806761693
    ],
    [
        113.14555936316,
        23.013875949052
    ],
    [
        113.14551879227,
        23.013970518746
    ],
    [
        113.14549958467,
        23.014052406311
    ],
    [
        113.14549551665,
        23.014161388987
    ],
    [
        113.14551660043,
        23.014227911364
    ],
    [
        113.14552606219,
        23.01424813479
    ],
    [
        113.14555120474,
        23.014290307652
    ],
    [
        113.14554985333,
        23.014284589734
    ],
    [
        113.14557202381,
        23.014305014309
    ],
    [
        113.14561528582,
        23.014321160895
    ],
    [
        113.14568504838,
        23.014324975821
    ],
    [
        113.14576319413,
        23.014325665537
    ],
    [
        113.14580267496,
        23.014304586086
    ],
    [
        113.1459075948,
        23.014273954245
    ],
    [
        113.14604442626,
        23.014220487842
    ],
    [
        113.14614421222,
        23.014176201557
    ],
    [
        113.14632431454,
        23.014112269802
    ],
    [
        113.1464541207,
        23.014060567762
    ],
    [
        113.14668777736,
        23.013958098601
    ],
    [
        113.14677269654,
        23.013914097727
    ],
    [
        113.14686248156,
        23.013891868444
    ],
    [
        113.14698526223,
        23.013853318252
    ],
    [
        113.14722190198,
        23.01379070929
    ],
    [
        113.14743501972,
        23.013721752875
    ],
    [
        113.14756240652,
        23.013676183324
    ],
    [
        113.14771927274,
        23.013643520189
    ],
    [
        113.14783611371,
        23.01361242443
    ],
    [
        113.14788912493,
        23.013601541298
    ],
    [
        113.14794484011,
        23.013597477908
    ],
    [
        113.148041663,
        23.013614088337
    ],
    [
        113.14809629342,
        23.013637401853
    ],
    [
        113.14819284044,
        23.013705539882
    ],
    [
        113.14829533682,
        23.013790848614
    ],
    [
        113.14840945632,
        23.013946847417
    ],
    [
        113.14850653889,
        23.014099339153
    ],
    [
        113.14857090124,
        23.01420090196
    ],
    [
        113.14859307653,
        23.014237840381
    ],
    [
        113.14858900942,
        23.01433299505
    ],
    [
        113.14858006681,
        23.014505932227
    ],
    [
        113.14857167509,
        23.014582036673
    ],
    [
        113.14852568519,
        23.014683099806
    ],
    [
        113.14844723475,
        23.014840930748
    ],
    [
        113.14837582133,
        23.014958713231
    ],
    [
        113.14832875245,
        23.015062740064
    ],
    [
        113.14830142919,
        23.015158371712
    ],
    [
        113.14829087475,
        23.015270793484
    ],
    [
        113.14830169009,
        23.015340936655
    ],
    [
        113.14830899083,
        23.015383088566
    ],
    [
        113.14834820438,
        23.015495417783
    ],
    [
        113.14841581804,
        23.015619820897
    ],
    [
        113.14847099166,
        23.015725596402
    ],
    [
        113.1485472633,
        23.01583764134
    ],
    [
        113.1486411175,
        23.015946408401
    ],
    [
        113.14872307191,
        23.016073175835
    ],
    [
        113.14875661133,
        23.016154762792
    ],
    [
        113.14877608602,
        23.016220415525
    ],
    [
        113.14877554506,
        23.016252688648
    ],
    [
        113.14875471794,
        23.016310172046
    ],
    [
        113.14872442446,
        23.016406040268
    ],
    [
        113.14870062305,
        23.016495219062
    ],
    [
        113.14867438817,
        23.016603080364
    ],
    [
        113.1486589733,
        23.016714080116
    ],
    [
        113.14864193705,
        23.016849742146
    ],
    [
        113.14864410343,
        23.016921930757
    ],
    [
        113.14864951433,
        23.016955916841
    ],
    [
        113.14867359032,
        23.01703411545
    ],
    [
        113.14868657608,
        23.017093709062
    ],
    [
        113.14870632638,
        23.017198158735
    ],
    [
        113.14871985425,
        23.01726806821
    ],
    [
        113.14870822785,
        23.017343315471
    ],
    [
        113.14867063988,
        23.017484381885
    ],
    [
        113.14862845363,
        23.017607206707
    ],
    [
        113.14860979821,
        23.017707038638
    ],
    [
        113.14860061276,
        23.017837931218
    ],
    [
        113.14860873352,
        23.017910477201
    ],
    [
        113.14862144763,
        23.01792802074
    ],
    [
        113.14869069567,
        23.017982994278
    ],
    [
        113.14879050709,
        23.018016969705
    ],
    [
        113.14882837468,
        23.018013710201
    ],
    [
        113.14892601967,
        23.018004514904
    ],
    [
        113.14905233746,
        23.017990292582
    ],
    [
        113.14921814985,
        23.017977156247
    ],
    [
        113.14933744038,
        23.017978277344
    ],
    [
        113.14954518906,
        23.017986308842
    ],
    [
        113.14972832515,
        23.01798421239
    ],
    [
        113.14986006768,
        23.017993876166
    ],
    [
        113.14995961936,
        23.017995227009
    ],
    [
        113.15001967753,
        23.018016655725
    ],
    [
        113.15007838327,
        23.018035351303
    ],
    [
        113.1501176128,
        23.018067889246
    ],
    [
        113.1501568414,
        23.01808849025
    ],
    [
        113.15020445572,
        23.018099708064
    ],
    [
        113.1502185235,
        23.018101523984
    ],
    [
        113.15035243804,
        23.018107650523
    ],
    [
        113.15065815053,
        23.018121994428
    ],
    [
        113.15088703763,
        23.018139354463
    ],
    [
        113.15116571527,
        23.018157317742
    ],
    [
        113.15140462861,
        23.018172016254
    ],
    [
        113.1516822425,
        23.018183089617
    ],
    [
        113.15181347835,
        23.018202619669
    ],
    [
        113.15190385697,
        23.018219737816
    ],
    [
        113.15213223994,
        23.018224695866
    ],
    [
        113.15241935388,
        23.018243612354
    ],
    [
        113.15264179982,
        23.018249232937
    ],
    [
        113.15277657087,
        23.01826302071
    ],
    [
        113.1529508554,
        23.018265859337
    ],
    [
        113.15319145223,
        23.018280826205
    ],
    [
        113.15346724127,
        23.018287464641
    ],
    [
        113.15357766896,
        23.018296290791
    ],
    [
        113.15366319943,
        23.018320838483
    ],
    [
        113.15377823226,
        23.018335395949
    ],
    [
        113.15396039268,
        23.018344432365
    ],
    [
        113.15411386525,
        23.018344727813
    ],
    [
        113.15426300968,
        23.018337906685
    ],
    [
        113.15446629819,
        23.018353337038
    ],
    [
        113.15467662971,
        23.018354159706
    ],
    [
        113.1548653124,
        23.018364766424
    ],
    [
        113.15501204024,
        23.018380893966
    ],
    [
        113.15508919679,
        23.018400654034
    ],
    [
        113.15524188712,
        23.018428750856
    ],
    [
        113.15537427422,
        23.01843818532
    ],
    [
        113.15555891648,
        23.018447565942
    ],
    [
        113.15559492518,
        23.018450352377
    ],
    [
        113.15561820958,
        23.018456271646
    ],
    [
        113.15567046404,
        23.018466264049
    ],
    [
        113.15575277359,
        23.018491458449
    ],
    [
        113.15581558924,
        23.018508326351
    ],
    [
        113.15586594924,
        23.018510697202
    ],
    [
        113.15598887276,
        23.018517266132
    ],
    [
        113.15620169201,
        23.018517589584
    ],
    [
        113.15646921687,
        23.01852731486
    ],
    [
        113.15663331198,
        23.018534455567
    ],
    [
        113.15683180266,
        23.018543497235
    ],
    [
        113.15698236736,
        23.018549118717
    ],
    [
        113.1570530482,
        23.018558394442
    ],
    [
        113.15717870454,
        23.018570021666
    ],
    [
        113.15723530383,
        23.018566148865
    ],
    [
        113.15735202363,
        23.018549471929
    ],
    [
        113.15743651919,
        23.018545002623
    ],
    [
        113.15759034834,
        23.018543521487
    ],
    [
        113.15773416217,
        23.018555777216
    ],
    [
        113.15780999928,
        23.01857617094
    ],
    [
        113.15782245875,
        23.018583049376
    ],
    [
        113.15784358678,
        23.018603287136
    ],
    [
        113.15785198509,
        23.018621527371
    ],
    [
        113.1578831482,
        23.018751165362
    ],
    [
        113.15788614062,
        23.018851288652
    ],
    [
        113.15788669783,
        23.018964685777
    ],
    [
        113.15788997581,
        23.019156773806
    ],
    [
        113.15790056176,
        23.019306328049
    ],
    [
        113.15789004917,
        23.019609262857
    ],
    [
        113.15789548648,
        23.019724597329
    ],
    [
        113.1578987689,
        23.019899325119
    ],
    [
        113.1578928265,
        23.019983646795
    ],
    [
        113.1578904279,
        23.020179491091
    ],
    [
        113.15787746053,
        23.020338360516
    ],
    [
        113.15787832098,
        23.020557831898
    ],
    [
        113.15786995861,
        23.020705886118
    ],
    [
        113.15785810488,
        23.020971106673
    ],
    [
        113.15785705053,
        23.021087749223
    ],
    [
        113.15786682793,
        23.021194166793
    ],
    [
        113.15785738705,
        23.021341942287
    ],
    [
        113.15787636632,
        23.021418047481
    ],
    [
        113.15788585323,
        23.021445519973
    ],
    [
        113.15792297248,
        23.021495720865
    ],
    [
        113.15800423705,
        23.021534320286
    ],
    [
        113.15812341787,
        23.021556921943
    ],
    [
        113.15824882929,
        23.021573589394
    ],
    [
        113.15847608725,
        23.021580671774
    ],
    [
        113.15860963108,
        23.021591662185
    ],
    [
        113.15876674451,
        23.021601173513
    ],
    [
        113.15899646127,
        23.021608985381
    ],
    [
        113.1591809503,
        23.021631646457
    ],
    [
        113.15939226972,
        23.021668285487
    ],
    [
        113.15951202027,
        23.021686679245
    ],
    [
        113.15953261272,
        23.021695489784
    ],
    [
        113.15954237227,
        23.021718067485
    ],
    [
        113.1595426656,
        23.02179647004
    ],
    [
        113.15951995805,
        23.021966964486
    ],
    [
        113.15951106794,
        23.022134019198
    ],
    [
        113.15950405777,
        23.022243573733
    ],
    [
        113.15949839724,
        23.022335503379
    ],
    [
        113.15948950488,
        23.022485738874
    ],
    [
        113.15948927601,
        23.022614597766
    ],
    [
        113.15948578977,
        23.022722004692
    ],
    [
        113.15946684463,
        23.022778854736
    ],
    [
        113.15944577466,
        23.02295858349
    ],
    [
        113.15943254257,
        23.023080849386
    ],
    [
        113.15943853885,
        23.023182348699
    ],
    [
        113.15944589437,
        23.023295250774
    ],
    [
        113.1594332089,
        23.023424845315
    ],
    [
        113.15941917392,
        23.023565554066
    ],
    [
        113.15940863486,
        23.023635750314
    ],
    [
        113.1593848043,
        23.023661641465
    ],
    [
        113.1593382507,
        23.023774197983
    ],
    [
        113.15932501128,
        23.023864451528
    ],
    [
        113.15930582272,
        23.023980981482
    ],
    [
        113.15929285739,
        23.024076662392
    ],
    [
        113.15929450413,
        23.024129303157
    ],
    [
        113.15933815242,
        23.02420717424
    ],
    [
        113.15940701214,
        23.024323185647
    ],
    [
        113.15948588562,
        23.024411313535
    ],
    [
        113.15955472279,
        23.024467089755
    ],
    [
        113.15962003396,
        23.024511174515
    ],
    [
        113.15980647063,
        23.024598586241
    ],
    [
        113.15992164865,
        23.024668183929
    ],
    [
        113.1600162372,
        23.024737107025
    ],
    [
        113.16006962812,
        23.024770787192
    ],
    [
        113.16012436865,
        23.024791450663
    ],
    [
        113.16017449878,
        23.024801233508
    ],
    [
        113.16031837877,
        23.024807472602
    ],
    [
        113.16056821176,
        23.02481508084
    ],
    [
        113.16077957753,
        23.024824876603
    ],
    [
        113.16097143272,
        23.024817986196
    ],
    [
        113.16111262397,
        23.024825195153
    ],
    [
        113.16114731463,
        23.024831603604
    ],
    [
        113.16116195295,
        23.02484144097
    ],
    [
        113.161189603,
        23.024859479557
    ],
    [
        113.16120993826,
        23.024882365669
    ],
    [
        113.16124873016,
        23.024968821577
    ],
    [
        113.16126120792,
        23.024994653572
    ],
    [
        113.16126883975,
        23.025091812203
    ],
    [
        113.16126619055,
        23.025225546602
    ],
    [
        113.16126573567,
        23.025413821387
    ],
    [
        113.16127829854,
        23.025618435769
    ],
    [
        113.16129221622,
        23.025818444808
    ],
    [
        113.16129603294,
        23.025864854047
    ],
    [
        113.16130372697,
        23.026079212641
    ],
    [
        113.16129621246,
        23.026225947584
    ],
    [
        113.16129659123,
        23.026437016883
    ],
    [
        113.16129774433,
        23.026570228379
    ],
    [
        113.16130437449,
        23.026809271304
    ],
    [
        113.16131745921,
        23.026951763434
    ],
    [
        113.16131755379,
        23.0271259364
    ],
    [
        113.16131708354,
        23.027256428113
    ],
    [
        113.16133017391,
        23.027403804057
    ],
    [
        113.16134619604,
        23.02746193673
    ],
    [
        113.16137630894,
        23.02751660786
    ],
    [
        113.16139962686,
        23.027535978063
    ],
    [
        113.16141887493,
        23.027546918804
    ],
    [
        113.16144543294,
        23.027544599127
    ],
    [
        113.16157119175,
        23.027556562727
    ],
    [
        113.1617311041,
        23.027570559334
    ],
    [
        113.16186797829,
        23.02757602604
    ],
    [
        113.16196365959,
        23.027584833979
    ],
    [
        113.16204280821,
        23.02759248173
    ],
    [
        113.16213008499,
        23.027592288374
    ],
    [
        113.16229244889,
        23.027598345607
    ],
    [
        113.16237430647,
        23.02759458529
    ],
    [
        113.16248273424,
        23.027598783563
    ],
    [
        113.1625586438,
        23.027617234268
    ],
    [
        113.1626201852,
        23.027631559829
    ],
    [
        113.16273160815,
        23.02765039409
    ],
    [
        113.16276414751,
        23.027667596466
    ],
    [
        113.16282000272,
        23.027689216593
    ],
    [
        113.16288237006,
        23.027720350666
    ],
    [
        113.16291492006,
        23.027754369115
    ],
    [
        113.16294854841,
        23.027777538119
    ],
    [
        113.16298488119,
        23.027789048849
    ],
    [
        113.16299979237,
        23.027790995272
    ],
    [
        113.16316786068,
        23.027770895928
    ],
    [
        113.16323508628,
        23.027757260165
    ],
    [
        113.1632830697,
        23.027753331234
    ],
    [
        113.16334569676,
        23.027755139285
    ],
    [
        113.16339070641,
        23.027764219467
    ],
    [
        113.16350241645,
        23.02778270443
    ],
    [
        113.16360166169,
        23.027809013063
    ],
    [
        113.16365916101,
        23.027845244591
    ],
    [
        113.16371178414,
        23.027887429425
    ],
    [
        113.16374922848,
        23.027936356702
    ],
    [
        113.16374951179,
        23.027957247449
    ],
    [
        113.16375819195,
        23.027964051402
    ],
    [
        113.16375522076,
        23.027983306315
    ],
    [
        113.16374926048,
        23.027991159246
    ],
    [
        113.1637246212,
        23.028048342104
    ],
    [
        113.16367071435,
        23.028129053259
    ],
    [
        113.16350306786,
        23.028427042816
    ],
    [
        113.16334160947,
        23.028633053847
    ],
    [
        113.16320616105,
        23.028802764628
    ],
    [
        113.16302951951,
        23.028986166552
    ],
    [
        113.1628098356,
        23.029252144225
    ],
    [
        113.16276053833,
        23.029313835263
    ],
    [
        113.16273156873,
        23.02936962504
    ],
    [
        113.16265981132,
        23.029490107354
    ],
    [
        113.16260023298,
        23.029578885736
    ],
    [
        113.16244531024,
        23.029773936774
    ],
    [
        113.16234563727,
        23.029891040245
    ],
    [
        113.16223565683,
        23.02999344454
    ],
    [
        113.16214682125,
        23.030096464187
    ],
    [
        113.16208504662,
        23.030132301997
    ],
    [
        113.16200728395,
        23.030172140874
    ],
    [
        113.16187396272,
        23.030216083417
    ],
    [
        113.16174685969,
        23.030232363643
    ],
    [
        113.16166284351,
        23.030235525202
    ],
    [
        113.16161079947,
        23.030224443487
    ],
    [
        113.16154465699,
        23.030204614327
    ],
    [
        113.16145410296,
        23.030153741131
    ],
    [
        113.16136869406,
        23.030094474097
    ],
    [
        113.16125860723,
        23.030008495778
    ],
    [
        113.16116180174,
        23.029922299668
    ],
    [
        113.16104194457,
        23.029807223293
    ],
    [
        113.16091288337,
        23.029701854516
    ],
    [
        113.16081526179,
        23.029599888888
    ],
    [
        113.16070109928,
        23.029477209127
    ],
    [
        113.16056661702,
        23.02935468024
    ],
    [
        113.16041613875,
        23.029211699831
    ],
    [
        113.16029356956,
        23.029061802663
    ],
    [
        113.16023662281,
        23.028988772846
    ],
    [
        113.16012030704,
        23.028864937459
    ],
    [
        113.15995819292,
        23.028721286925
    ],
    [
        113.15983078595,
        23.028613634571
    ],
    [
        113.1597123351,
        23.028525827858
    ],
    [
        113.15962126085,
        23.028455271
    ],
    [
        113.15947706886,
        23.028352629824
    ],
    [
        113.15931524653,
        23.028207533935
    ],
    [
        113.15917457749,
        23.028091855425
    ],
    [
        113.15906427298,
        23.028010275741
    ],
    [
        113.15891522519,
        23.027914585846
    ],
    [
        113.15881982762,
        23.027837425308
    ],
    [
        113.15869380538,
        23.027730742548
    ],
    [
        113.1586704981,
        23.027710502899
    ],
    [
        113.15856371214,
        23.027604483832
    ],
    [
        113.15842658822,
        23.027492809974
    ],
    [
        113.1583016642,
        23.027394232111
    ],
    [
        113.15819815222,
        23.027315876366
    ],
    [
        113.15808624051,
        23.0272276817
    ],
    [
        113.15799681854,
        23.027152127339
    ],
    [
        113.1578727311,
        23.027077927384
    ],
    [
        113.15769364732,
        23.026967201228
    ],
    [
        113.15752324195,
        23.026867640883
    ],
    [
        113.15738561531,
        23.026776190409
    ],
    [
        113.15729890379,
        23.026681886636
    ],
    [
        113.15723767872,
        23.026641774691
    ],
    [
        113.1571011481,
        23.026560338847
    ],
    [
        113.15686331052,
        23.026416984708
    ],
    [
        113.1566298358,
        23.026312688888
    ],
    [
        113.15641261069,
        23.026195742881
    ],
    [
        113.1562181497,
        23.026101482894
    ],
    [
        113.15600529841,
        23.026036593742
    ],
    [
        113.15584634744,
        23.025999303886
    ],
    [
        113.15566790313,
        23.025953941191
    ],
    [
        113.1555292689,
        23.025922230284
    ],
    [
        113.15537684279,
        23.025915328989
    ],
    [
        113.15525827483,
        23.025936686054
    ],
    [
        113.15509640753,
        23.025985002338
    ],
    [
        113.15491234639,
        23.026033616909
    ],
    [
        113.1547364205,
        23.02609965147
    ],
    [
        113.15459080963,
        23.026149970032
    ],
    [
        113.15440732199,
        23.026232431085
    ],
    [
        113.15425117704,
        23.026311630116
    ],
    [
        113.15412534516,
        23.026377842083
    ],
    [
        113.15399789891,
        23.026457589533
    ],
    [
        113.15388235517,
        23.026519006441
    ],
    [
        113.15378846077,
        23.026569256316
    ],
    [
        113.15369024684,
        23.026637628859
    ],
    [
        113.1535341393,
        23.026752284906
    ],
    [
        113.15346867728,
        23.026818835565
    ],
    [
        113.15337535588,
        23.02691572634
    ],
    [
        113.15328662356,
        23.026987703589
    ],
    [
        113.15323660137,
        23.027072866108
    ],
    [
        113.15317492546,
        23.027127237639
    ],
    [
        113.1530456127,
        23.0272196263
    ],
    [
        113.15290224357,
        23.027335985569
    ],
    [
        113.1527104601,
        23.027493271744
    ],
    [
        113.15254735933,
        23.027635408207
    ],
    [
        113.1523983161,
        23.027745138515
    ],
    [
        113.1522866053,
        23.027830072179
    ],
    [
        113.15217517115,
        23.027921783063
    ],
    [
        113.15203290992,
        23.028044851608
    ],
    [
        113.15192445033,
        23.028125185241
    ],
    [
        113.15182816164,
        23.028193181418
    ],
    [
        113.15172699901,
        23.028252971939
    ],
    [
        113.1516631649,
        23.028291245599
    ],
    [
        113.15156553632,
        23.028374129585
    ],
    [
        113.15148141411,
        23.028417838756
    ],
    [
        113.15139325278,
        23.02849160643
    ],
    [
        113.15126345465,
        23.028612588839
    ],
    [
        113.15113014363,
        23.028735957019
    ],
    [
        113.15110742232,
        23.028745161449
    ],
    [
        113.15104494784,
        23.028784511782
    ],
    [
        113.15093054532,
        23.028852218014
    ],
    [
        113.15075908822,
        23.028966107675
    ],
    [
        113.15060629888,
        23.029073712826
    ],
    [
        113.1505062476,
        23.029149715665
    ],
    [
        113.15038779943,
        23.029222483781
    ],
    [
        113.1502347489,
        23.029331406424
    ],
    [
        113.15012007881,
        23.029382772619
    ],
    [
        113.14998919804,
        23.029462940805
    ],
    [
        113.14978880043,
        23.029547848777
    ],
    [
        113.14959110922,
        23.02962680118
    ],
    [
        113.1494631941,
        23.029677939493
    ],
    [
        113.14921303115,
        23.029751237222
    ],
    [
        113.14906077207,
        23.029793594397
    ],
    [
        113.14891012508,
        23.029815613428
    ],
    [
        113.14869807616,
        23.029829147257
    ],
    [
        113.14852525278,
        23.02984539064
    ],
    [
        113.14832564709,
        23.029847664552
    ],
    [
        113.14813415503,
        23.029842981238
    ],
    [
        113.14797676233,
        23.029864823871
    ],
    [
        113.147805051,
        23.029905433055
    ],
    [
        113.14767634305,
        23.029944494722
    ],
    [
        113.14744705474,
        23.030017044427
    ],
    [
        113.14716157283,
        23.030164413097
    ],
    [
        113.14700453913,
        23.030291176289
    ],
    [
        113.14684698033,
        23.030436096727
    ],
    [
        113.1467894406,
        23.030523120521
    ],
    [
        113.14671843602,
        23.030689157189
    ],
    [
        113.14655426509,
        23.03103200632
    ],
    [
        113.14646166784,
        23.031247079831
    ],
    [
        113.1463855313,
        23.031411670363
    ],
    [
        113.14629544963,
        23.031730686087
    ],
    [
        113.146187216,
        23.031997868179
    ],
    [
        113.14612812452,
        23.032166242678
    ],
    [
        113.14602150757,
        23.032418249376
    ],
    [
        113.14600753485,
        23.032532522268
    ],
    [
        113.14592800257,
        23.032835683133
    ],
    [
        113.14582124477,
        23.033240425508
    ],
    [
        113.14572145465,
        23.033559811524
    ],
    [
        113.14567970887,
        23.033763448222
    ],
    [
        113.14565629125,
        23.033893849288
    ],
    [
        113.14558915625,
        23.034128012706
    ],
    [
        113.14556089422,
        23.034283568199
    ],
    [
        113.14552838799,
        23.034535913911
    ],
    [
        113.14551855071,
        23.03473408578
    ],
    [
        113.14546201042,
        23.035018064563
    ],
    [
        113.14541792585,
        23.035319604485
    ],
    [
        113.14539590583,
        23.035494792721
    ],
    [
        113.14536602169,
        23.03564272449
    ],
    [
        113.14531424143,
        23.035795733128
    ],
    [
        113.14525332201,
        23.036008826124
    ],
    [
        113.14515758879,
        23.036293801035
    ],
    [
        113.145046892,
        23.036472177572
    ],
    [
        113.14494402054,
        23.036631140712
    ],
    [
        113.14482391144,
        23.036861719435
    ],
    [
        113.14472289046,
        23.036970510589
    ],
    [
        113.14462076562,
        23.037053505058
    ],
    [
        113.14456108927,
        23.037136100487
    ],
    [
        113.14450063379,
        23.037253138756
    ],
    [
        113.14437785563,
        23.03751268433
    ],
    [
        113.14426180995,
        23.03774059088
    ],
    [
        113.14424372309,
        23.037770139399
    ],
    [
        113.14404987113,
        23.03805645126
    ],
    [
        113.14392511418,
        23.038214472684
    ],
    [
        113.14382925656,
        23.038340408484
    ],
    [
        113.1437082548,
        23.038463754143
    ],
    [
        113.14353402623,
        23.038619310775
    ],
    [
        113.14333813604,
        23.038736240191
    ],
    [
        113.1432141153,
        23.038806608797
    ],
    [
        113.14286444336,
        23.038960814652
    ],
    [
        113.14267178585,
        23.039056051633
    ],
    [
        113.14261342321,
        23.039086537326
    ],
    [
        113.14235831087,
        23.039169032565
    ],
    [
        113.1422799488,
        23.039203242436
    ],
    [
        113.14215350832,
        23.039278142468
    ],
    [
        113.14203138756,
        23.039346329016
    ],
    [
        113.14184014535,
        23.039497164488
    ],
    [
        113.14161568696,
        23.03967943491
    ],
    [
        113.14144065711,
        23.039818320461
    ],
    [
        113.14135423351,
        23.039897411036
    ],
    [
        113.14123138427,
        23.040044242192
    ],
    [
        113.1411163702,
        23.04018605054
    ],
    [
        113.14103164281,
        23.040339233601
    ],
    [
        113.14101462607,
        23.040352233196
    ],
    [
        113.14092852849,
        23.040485584502
    ],
    [
        113.14086404815,
        23.040610898887
    ],
    [
        113.14075336172,
        23.040752230791
    ],
    [
        113.14066212685,
        23.040882232216
    ],
    [
        113.14060793718,
        23.041025358042
    ],
    [
        113.14052805577,
        23.0411550122
    ],
    [
        113.1404487799,
        23.041349520605
    ],
    [
        113.1403978491,
        23.041506538417
    ],
    [
        113.14039758204,
        23.041509789566
    ],
    [
        113.1402789435,
        23.041804267006
    ],
    [
        113.14023421408,
        23.041944570109
    ],
    [
        113.14022917264,
        23.042038629265
    ],
    [
        113.14020067202,
        23.042189254794
    ],
    [
        113.14017625572,
        23.042369254071
    ],
    [
        113.14017211476,
        23.04255177877
    ],
    [
        113.14018980384,
        23.042670383146
    ],
    [
        113.14024322646,
        23.042842248374
    ],
    [
        113.14030630246,
        23.042937227415
    ],
    [
        113.14038126501,
        23.043025359057
    ],
    [
        113.14041867197,
        23.043129384587
    ],
    [
        113.14049638868,
        23.043267485313
    ],
    [
        113.14057872416,
        23.043428456148
    ],
    [
        113.1407043129,
        23.043593434324
    ],
    [
        113.1408444736,
        23.043733429804
    ],
    [
        113.14109554866,
        23.043958638062
    ],
    [
        113.14125598441,
        23.044097615437
    ],
    [
        113.14143615831,
        23.044240454288
    ],
    [
        113.14165115353,
        23.044333147224
    ],
    [
        113.14184776216,
        23.044418730594
    ],
    [
        113.14203946817,
        23.044466235483
    ],
    [
        113.14232930678,
        23.044515943036
    ],
    [
        113.14250585793,
        23.044542273964
    ],
    [
        113.14264074497,
        23.044534519154
    ],
    [
        113.14269292053,
        23.044535943817
    ],
    [
        113.14287648248,
        23.044540939612
    ],
    [
        113.14310085128,
        23.044529787833
    ],
    [
        113.14314060661,
        23.044544834223
    ],
    [
        113.14315686002,
        23.044577122222
    ],
    [
        113.14316905161,
        23.044602830448
    ],
    [
        113.14319699452,
        23.044698531384
    ],
    [
        113.14318606652,
        23.044851101173
    ],
    [
        113.14317028127,
        23.045012271808
    ],
    [
        113.14313095807,
        23.045155412183
    ],
    [
        113.14311102785,
        23.045228605599
    ],
    [
        113.14309597747,
        23.045315175388
    ],
    [
        113.14307797252,
        23.045420416571
    ],
    [
        113.14306612381,
        23.045465528078
    ],
    [
        113.14305316095,
        23.045478605156
    ],
    [
        113.14298587897,
        23.045510033353
    ],
    [
        113.14292318002,
        23.04552878524
    ],
    [
        113.14291345108,
        23.045531877349
    ],
    [
        113.14290940959,
        23.045545103975
    ],
    [
        113.14289646715,
        23.045577987071
    ],
    [
        113.14289600625,
        23.045655847964
    ],
    [
        113.1428882623,
        23.045749322757
    ],
    [
        113.14286728003,
        23.045850714149
    ],
    [
        113.14278912381,
        23.04608571587
    ],
    [
        113.14273979957,
        23.046228954051
    ],
    [
        113.14262839844,
        23.046469088194
    ],
    [
        113.142587939,
        23.04655712492
    ],
    [
        113.14258740778,
        23.046566340784
    ],
    [
        113.14259930754,
        23.046571425964
    ],
    [
        113.14260147134,
        23.046572547864
    ],
    [
        113.14273533916,
        23.046624733666
    ],
    [
        113.14298251487,
        23.046711921598
    ],
    [
        113.14318911533,
        23.046771821985
    ],
    [
        113.14342977596,
        23.046825764685
    ],
    [
        113.1436158018,
        23.046852192244
    ],
    [
        113.14385834032,
        23.046884968275
    ],
    [
        113.14407357311,
        23.046914018901
    ],
    [
        113.14428310524,
        23.046917184056
    ],
    [
        113.14444425217,
        23.046927141475
    ],
    [
        113.14451158583,
        23.046939362325
    ],
    [
        113.14476309249,
        23.047000963182
    ],
    [
        113.14500730444,
        23.047062964418
    ],
    [
        113.14516389385,
        23.047101834151
    ],
    [
        113.14519229408,
        23.047111785017
    ],
    [
        113.14519067787,
        23.04711772818
    ],
    [
        113.14520339797,
        23.047129598467
    ],
    [
        113.14520990029,
        23.047142454509
    ],
    [
        113.14520804034,
        23.04717444046
    ],
    [
        113.14518541672,
        23.047260900681
    ],
    [
        113.14517871728,
        23.047319669768
    ],
    [
        113.14517576357,
        23.047339700122
    ],
    [
        113.14519173688,
        23.047360033459
    ],
    [
        113.14520582277,
        23.047385491565
    ],
    [
        113.14524265585,
        23.047445228206
    ],
    [
        113.1453192553,
        23.047524319977
    ],
    [
        113.14532792854,
        23.047544807271
    ],
    [
        113.145330141,
        23.04759313742
    ],
    [
        113.14533207004,
        23.047628711031
    ],
    [
        113.14531397808,
        23.047652027264
    ],
    [
        113.14529425356,
        23.047665278481
    ],
    [
        113.14518151984,
        23.047680840852
    ],
    [
        113.14513421875,
        23.047696091011
    ],
    [
        113.14510017303,
        23.047717793275
    ],
    [
        113.14506938863,
        23.047755826589
    ],
    [
        113.14506239329,
        23.047789629196
    ],
    [
        113.14504973929,
        23.047842333251
    ],
    [
        113.1450473972,
        23.047931831023
    ],
    [
        113.14505572336,
        23.048142508563
    ],
    [
        113.14504938949,
        23.048294888268
    ],
    [
        113.14504080933,
        23.048365564753
    ],
    [
        113.14503517823,
        23.048411598543
    ],
    [
        113.1450227641,
        23.048434461162
    ],
    [
        113.14499627522,
        23.048442446132
    ],
    [
        113.14496330691,
        23.048459822691
    ],
    [
        113.14488818263,
        23.048499310071
    ],
    [
        113.1448692721,
        23.048514741515
    ],
    [
        113.14487037099,
        23.048531852354
    ],
    [
        113.14486419006,
        23.048568923339
    ],
    [
        113.14488044727,
        23.048603100538
    ],
    [
        113.14489483167,
        23.048656782409
    ],
    [
        113.14495665929,
        23.048836035308
    ],
    [
        113.14501476209,
        23.049074916924
    ],
    [
        113.1450275475,
        23.049151634397
    ],
    [
        113.14502654639,
        23.049231114754
    ],
    [
        113.14501469786,
        23.049278676413
    ],
    [
        113.14496476584,
        23.049365509111
    ],
    [
        113.14485731656,
        23.049524126488
    ],
    [
        113.14481115222,
        23.049593109834
    ],
    [
        113.14473956281,
        23.049651913401
    ],
    [
        113.14469442376,
        23.049664748229
    ],
    [
        113.14447760181,
        23.049678047121
    ],
    [
        113.14426510691,
        23.049688957017
    ],
    [
        113.14413563119,
        23.049715594205
    ],
    [
        113.14401209509,
        23.049732826882
    ],
    [
        113.14388452057,
        23.049765723858
    ],
    [
        113.1437885778,
        23.049798053204
    ],
    [
        113.1436996979,
        23.049863325914
    ],
    [
        113.14364108502,
        23.049916074975
    ],
    [
        113.14359951383,
        23.049978330745
    ],
    [
        113.14357765367,
        23.050016223509
    ],
    [
        113.14352364778,
        23.050079628147
    ],
    [
        113.14346041968,
        23.050112490558
    ],
    [
        113.14342042257,
        23.050126475334
    ],
    [
        113.14332418687,
        23.050133280584
    ],
    [
        113.14328633251,
        23.050126950492
    ],
    [
        113.1432517322,
        23.050130441811
    ],
    [
        113.14320526557,
        23.050162493867
    ],
    [
        113.14308209304,
        23.050264887152
    ],
    [
        113.14301805922,
        23.050301254012
    ],
    [
        113.14300401689,
        23.050316483221
    ],
    [
        113.14286451825,
        23.050311422964
    ],
    [
        113.14283342188,
        23.050303573355
    ],
    [
        113.14279936514,
        23.050308968106
    ],
    [
        113.14277505775,
        23.050331620071
    ],
    [
        113.14276076238,
        23.050363936991
    ],
    [
        113.14273295745,
        23.050403351327
    ],
    [
        113.14271295817,
        23.050408711221
    ],
    [
        113.14264915953,
        23.05040844682
    ],
    [
        113.14257535548,
        23.050404755974
    ],
    [
        113.14249611688,
        23.050372754297
    ],
    [
        113.1424425578,
        23.050338744873
    ],
    [
        113.14242330692,
        23.050281169965
    ],
    [
        113.14241725176,
        23.050173353853
    ],
    [
        113.14241343666,
        23.050142901436
    ],
    [
        113.14238692181,
        23.050120202998
    ],
    [
        113.14234365378,
        23.050104545172
    ],
    [
        113.14226984288,
        23.05009270815
    ],
    [
        113.14210171165,
        23.050103136957
    ],
    [
        113.14194924697,
        23.05009998891
    ],
    [
        113.14192328378,
        23.050087606617
    ],
    [
        113.14189887943,
        23.050012305014
    ],
    [
        113.14188361155,
        23.049882896076
    ],
    [
        113.14191495344,
        23.049331299716
    ],
    [
        113.14194016655,
        23.048869675547
    ],
    [
        113.14196570991,
        23.048468560663
    ],
    [
        113.14197285657,
        23.048319186165
    ],
    [
        113.14193409888,
        23.048219220381
    ],
    [
        113.14188966302,
        23.048117800366
    ],
    [
        113.14181111908,
        23.047969399651
    ],
    [
        113.14174857534,
        23.04787119464
    ],
    [
        113.14164783024,
        23.047687952037
    ],
    [
        113.14160993264,
        23.047635749915
    ],
    [
        113.14159478249,
        23.04762355133
    ],
    [
        113.14156502785,
        23.047604047122
    ],
    [
        113.14154583652,
        23.047605073453
    ],
    [
        113.14154259157,
        23.047603932325
    ],
    [
        113.14152016058,
        23.047608972557
    ],
    [
        113.14138970203,
        23.047709825539
    ],
    [
        113.141203598,
        23.047847697193
    ],
    [
        113.14111394183,
        23.047932696623
    ],
    [
        113.14105586033,
        23.047966962128
    ],
    [
        113.14091616128,
        23.048016090106
    ],
    [
        113.14080320829,
        23.048050484956
    ],
    [
        113.1407002548,
        23.048082609273
    ],
    [
        113.14062323585,
        23.048099989351
    ],
    [
        113.14048702262,
        23.048119049106
    ],
    [
        113.14028379739,
        23.048159453494
    ],
    [
        113.14014433814,
        23.048174377829
    ],
    [
        113.14002245257,
        23.048192862622
    ],
    [
        113.13974729279,
        23.048194544164
    ],
    [
        113.13962026349,
        23.048203434255
    ],
    [
        113.13944915438,
        23.048190111066
    ],
    [
        113.13930207758,
        23.048152788973
    ],
    [
        113.13913713646,
        23.048090187028
    ],
    [
        113.13900901605,
        23.048087108846
    ],
    [
        113.13896416414,
        23.048102866161
    ],
    [
        113.13895092611,
        23.048108872354
    ],
    [
        113.1389015003,
        23.048145168656
    ],
    [
        113.13883859528,
        23.048215954891
    ],
    [
        113.13870961399,
        23.048428284001
    ],
    [
        113.13859519818,
        23.04861102441
    ],
    [
        113.13849885554,
        23.048758269952
    ],
    [
        113.13842276352,
        23.048884982379
    ],
    [
        113.13831238532,
        23.049051240681
    ],
    [
        113.1382265546,
        23.049169639215
    ],
    [
        113.13815718546,
        23.049262554354
    ],
    [
        113.13813968467,
        23.049329530343
    ],
    [
        113.13813653136,
        23.049418738041
    ],
    [
        113.13813497233,
        23.049480842227
    ],
    [
        113.13814419939,
        23.04951790547
    ],
    [
        113.13815962557,
        23.049537714483
    ],
    [
        113.13818153432,
        23.049553297555
    ],
    [
        113.1383646462,
        23.04968135566
    ],
    [
        113.1385888289,
        23.049796301648
    ],
    [
        113.13904169136,
        23.04992586937
    ],
    [
        113.13931931935,
        23.04996550069
    ],
    [
        113.13934175612,
        23.049968066991
    ],
    [
        113.13937557749,
        23.050002849503
    ],
    [
        113.13942969919,
        23.050065935426
    ],
    [
        113.13948682139,
        23.050156205579
    ],
    [
        113.13958071852,
        23.050261502523
    ],
    [
        113.13971624431,
        23.050369972011
    ],
    [
        113.13984365286,
        23.05046961387
    ],
    [
        113.13997699928,
        23.050560132395
    ],
    [
        113.14010169705,
        23.050651039017
    ],
    [
        113.14016446493,
        23.05070992886
    ],
    [
        113.14019882913,
        23.05074634427
    ],
    [
        113.14020916488,
        23.050811098733
    ],
    [
        113.14021762462,
        23.050892099396
    ],
    [
        113.14021661421,
        23.050963438229
    ],
    [
        113.1402110177,
        23.051043921598
    ],
    [
        113.1401846155,
        23.051131909034
    ],
    [
        113.14015332603,
        23.051197834054
    ],
    [
        113.14008044579,
        23.051299386836
    ],
    [
        113.14001616978,
        23.05135496559
    ],
    [
        113.13993918008,
        23.05140055315
    ],
    [
        113.13985568382,
        23.051426219305
    ],
    [
        113.13981758964,
        23.051443999843
    ],
    [
        113.13972576542,
        23.051521339497
    ],
    [
        113.13967961654,
        23.051594054938
    ],
    [
        113.13964345672,
        23.051654736514
    ],
    [
        113.13961868187,
        23.051748718891
    ],
    [
        113.1395917631,
        23.051861655589
    ],
    [
        113.13958296047,
        23.051981422653
    ],
    [
        113.13956303996,
        23.052064637508
    ],
    [
        113.13955252188,
        23.052088599504
    ],
    [
        113.13949499922,
        23.052139679239
    ],
    [
        113.13945853894,
        23.052169695643
    ],
    [
        113.13942232944,
        23.052179638848
    ],
    [
        113.13937529623,
        23.052177181778
    ],
    [
        113.13919797742,
        23.052169169279
    ],
    [
        113.13908228784,
        23.052163598555
    ],
    [
        113.13902444859,
        23.05216637464
    ],
    [
        113.13900905874,
        23.052183466801
    ],
    [
        113.13898853014,
        23.052197212264
    ],
    [
        113.1389682882,
        23.052227784366
    ],
    [
        113.13895480174,
        23.052256576692
    ],
    [
        113.13895350956,
        23.05231760003
    ],
    [
        113.13894373026,
        23.05254614668
    ],
    [
        113.13893068536,
        23.052752658779
    ],
    [
        113.13892158257,
        23.052843117268
    ],
    [
        113.13889621803,
        23.052887435607
    ],
    [
        113.13885354431,
        23.052920594879
    ],
    [
        113.13881409902,
        23.052938074777
    ],
    [
        113.13877112722,
        23.052942197571
    ],
    [
        113.13871057398,
        23.052932985549
    ],
    [
        113.13863758976,
        23.052925994659
    ],
    [
        113.13837615791,
        23.052858141128
    ],
    [
        113.13812905178,
        23.052789721939
    ],
    [
        113.13808685017,
        23.052750987693
    ],
    [
        113.13786242228,
        23.052655020768
    ],
    [
        113.13764234572,
        23.05258625954
    ],
    [
        113.13754935024,
        23.052567239434
    ],
    [
        113.13747636942,
        23.052562412517
    ],
    [
        113.13741717877,
        23.052563528658
    ],
    [
        113.13734580849,
        23.052547063399
    ],
    [
        113.13704812072,
        23.052435401702
    ],
    [
        113.13691266267,
        23.052386591471
    ],
    [
        113.13687049654,
        23.052384211691
    ],
    [
        113.13682266206,
        23.05238959897
    ],
    [
        113.13678348881,
        23.052407621219
    ],
    [
        113.13677620634,
        23.052423227691
    ],
    [
        113.13676408631,
        23.052467236092
    ],
    [
        113.13676153081,
        23.052619670175
    ],
    [
        113.13676414475,
        23.052808010067
    ],
    [
        113.13680002444,
        23.053019190955
    ],
    [
        113.13682288481,
        23.053183201921
    ],
    [
        113.13683814542,
        23.053314248101
    ],
    [
        113.13683358722,
        23.053352693598
    ],
    [
        113.13681876845,
        23.053401808729
    ],
    [
        113.13679638242,
        23.053451602847
    ],
    [
        113.13676830619,
        23.053486373137
    ],
    [
        113.13674102615,
        23.053505692646
    ],
    [
        113.13669102541,
        23.053506971457
    ],
    [
        113.13648020904,
        23.053509723162
    ],
    [
        113.13618776159,
        23.05350586423
    ],
    [
        113.1360585646,
        23.053503017867
    ],
    [
        113.13595584115,
        23.05348545017
    ],
    [
        113.13591202269,
        23.053450754632
    ],
    [
        113.13590281573,
        23.053432412389
    ],
    [
        113.13589249797,
        23.053382849089
    ],
    [
        113.13589483171,
        23.053278976911
    ],
    [
        113.13589129706,
        23.053256937356
    ],
    [
        113.13588019285,
        23.053233134978
    ],
    [
        113.13586530824,
        23.053213063634
    ],
    [
        113.13583935174,
        23.05320310494
    ],
    [
        113.13571553952,
        23.053178650544
    ],
    [
        113.13548498286,
        23.05317210151
    ],
    [
        113.13534334397,
        23.053160626208
    ],
    [
        113.13528196778,
        23.053137557195
    ],
    [
        113.13524490316,
        23.053099998663
    ],
    [
        113.13523268963,
        23.053046874784
    ],
    [
        113.13522528845,
        23.052938759445
    ],
    [
        113.13527035768,
        23.05258712212
    ],
    [
        113.13531297411,
        23.05221699133
    ],
    [
        113.13531882912,
        23.052123220061
    ],
    [
        113.1353302684,
        23.051935672629
    ],
    [
        113.13532723744,
        23.051876471647
    ],
    [
        113.13530613541,
        23.051856018603
    ],
    [
        113.13526827713,
        23.05183689527
    ],
    [
        113.13523528453,
        23.05181840124
    ],
    [
        113.13516824204,
        23.051805813081
    ],
    [
        113.1350468705,
        23.051791173773
    ],
    [
        113.13488981424,
        23.051769389761
    ],
    [
        113.13470058513,
        23.05173889698
    ],
    [
        113.13439108194,
        23.051712515216
    ],
    [
        113.13414455394,
        23.051686172417
    ],
    [
        113.13398588877,
        23.051680381597
    ],
    [
        113.13379074694,
        23.051688058404
    ],
    [
        113.13347422621,
        23.051678950954
    ],
    [
        113.13281572075,
        23.051613399067
    ],
    [
        113.13237699353,
        23.051584848795
    ],
    [
        113.1320890915,
        23.051557595843
    ],
    [
        113.1319858178,
        23.051541153703
    ],
    [
        113.13194528788,
        23.051557815746
    ],
    [
        113.13191908504,
        23.051575268858
    ],
    [
        113.13189721998,
        23.051605820428
    ],
    [
        113.13189293329,
        23.051644815864
    ],
    [
        113.13189219762,
        23.051721585816
    ],
    [
        113.13187796976,
        23.051822269419
    ],
    [
        113.13186669691,
        23.051904283316
    ],
    [
        113.13185249227,
        23.052029114528
    ],
    [
        113.13185013238,
        23.052103957081
    ],
    [
        113.13184911499,
        23.052169598082
    ],
    [
        113.13184184919,
        23.052203115633
    ],
    [
        113.13183810299,
        23.052242391718
    ],
    [
        113.13182629311,
        23.052328737385
    ],
    [
        113.13183565869,
        23.05250959602
    ],
    [
        113.13181633006,
        23.0526481756
    ],
    [
        113.13180073381,
        23.052733099164
    ],
    [
        113.13176078347,
        23.052791012897
    ],
    [
        113.13173971447,
        23.052806927838
    ],
    [
        113.13170782759,
        23.052817229753
    ],
    [
        113.13157970166,
        23.052819631669
    ],
    [
        113.13143265383,
        23.052823068604
    ],
    [
        113.13141400539,
        23.0528265463
    ],
    [
        113.13137401149,
        23.052839967181
    ],
    [
        113.13136699174,
        23.052848799968
    ],
    [
        113.1313526754,
        23.052859677927
    ],
    [
        113.13134971957,
        23.052878076625
    ],
    [
        113.13134276507,
        23.052955010851
    ],
    [
        113.13132942822,
        23.053142260928
    ],
    [
        113.13133564498,
        23.053425892383
    ],
    [
        113.13133637867,
        23.053629934036
    ],
    [
        113.13133190776,
        23.053761987673
    ],
    [
        113.13131713752,
        23.053865376315
    ],
    [
        113.13131393084,
        23.05390493322
    ],
    [
        113.13131212859,
        23.054000947703
    ],
    [
        113.13130892839,
        23.054047558882
    ],
    [
        113.13131141781,
        23.054108104788
    ],
    [
        113.13131061597,
        23.054117858345
    ],
    [
        113.13130172522,
        23.054149720821
    ],
    [
        113.13128339391,
        23.054203669061
    ],
    [
        113.13127831158,
        23.054261371815
    ],
    [
        113.13127349976,
        23.054319350519
    ],
    [
        113.13126276239,
        23.054400560568
    ],
    [
        113.1312615278,
        23.054526971798
    ],
    [
        113.13126457423,
        23.054605976462
    ],
    [
        113.13124786175,
        23.054657239402
    ],
    [
        113.13123140928,
        23.05469738299
    ],
    [
        113.13120008874,
        23.054737000439
    ],
    [
        113.13116711875,
        23.054746745352
    ],
    [
        113.13104657743,
        23.054770185538
    ],
    [
        113.13078060391,
        23.054796847754
    ],
    [
        113.1307205872,
        23.054792027865
    ],
    [
        113.13069328904,
        23.054797261171
    ],
    [
        113.13067871134,
        23.05481898974
    ],
    [
        113.13066199357,
        23.054865371547
    ],
    [
        113.13058516573,
        23.055101466086
    ],
    [
        113.13056875953,
        23.055193705527
    ],
    [
        113.13057174156,
        23.055202980782
    ],
    [
        113.13058284366,
        23.055223517691
    ],
    [
        113.13060394532,
        23.05524123995
    ],
    [
        113.13070724409,
        23.05527853736
    ],
    [
        113.1309414008,
        23.0553400459
    ],
    [
        113.1311268802,
        23.055383100178
    ],
    [
        113.13116393736,
        23.055408966972
    ],
    [
        113.13117611122,
        23.055419485448
    ],
    [
        113.13118071382,
        23.055427432394
    ],
    [
        113.1311845343,
        23.055467380873
    ],
    [
        113.13116785163,
        23.055553101201
    ],
    [
        113.13114519267,
        23.05560643299
    ],
    [
        113.13112089099,
        23.055636675194
    ],
    [
        113.13107982888,
        23.055666359433
    ],
    [
        113.13105362192,
        23.05568218989
    ],
    [
        113.13101253851,
        23.055688270291
    ],
    [
        113.13098036362,
        23.055680937686
    ],
    [
        113.13085868427,
        23.055643047751
    ],
    [
        113.13082894061,
        23.055634130048
    ],
    [
        113.13080190505,
        23.055630684974
    ],
    [
        113.13077866914,
        23.055644126192
    ],
    [
        113.13074517572,
        23.055674214366
    ],
    [
        113.13072114718,
        23.055708262229
    ],
    [
        113.13069391628,
        23.055788921558
    ],
    [
        113.13068530634,
        23.055834355669
    ],
    [
        113.13068505196,
        23.055852257967
    ],
    [
        113.13069967228,
        23.055877738621
    ],
    [
        113.13071213717,
        23.055911322042
    ],
    [
        113.13076408489,
        23.055962127476
    ],
    [
        113.13090718053,
        23.056068207603
    ],
    [
        113.13096426176,
        23.056116932969
    ],
    [
        113.13099834852,
        23.056146545675
    ],
    [
        113.13101814451,
        23.056217425119
    ],
    [
        113.13104308226,
        23.056294904045
    ],
    [
        113.13104207072,
        23.0563743811
    ],
    [
        113.13104049795,
        23.056430515726
    ],
    [
        113.131033497,
        23.056461868171
    ],
    [
        113.13102487313,
        23.056492107634
    ],
    [
        113.13099331243,
        23.056568892019
    ],
    [
        113.13095824739,
        23.056657283183
    ],
    [
        113.130938586,
        23.056740511349
    ],
    [
        113.13092863883,
        23.056803828359
    ],
    [
        113.13090845182,
        23.056904954174
    ],
    [
        113.13090095009,
        23.056983235029
    ],
    [
        113.13091075913,
        23.057073477576
    ],
    [
        113.13090972517,
        23.05712880731
    ],
    [
        113.13097449484,
        23.057319559116
    ],
    [
        113.13100486447,
        23.057429958642
    ],
    [
        113.13101193329,
        23.057477830033
    ],
    [
        113.13101006435,
        23.057505471719
    ],
    [
        113.1309938592,
        23.057522287329
    ],
    [
        113.13097386306,
        23.057531441572
    ],
    [
        113.13095332099,
        23.057534346471
    ],
    [
        113.13091383861,
        23.057516308663
    ],
    [
        113.13087111953,
        23.057506898003
    ],
    [
        113.13065776695,
        23.057429198371
    ],
    [
        113.13041927619,
        23.057357868896
    ],
    [
        113.13024840194,
        23.057329478207
    ],
    [
        113.13019514415,
        23.057327223482
    ],
    [
        113.13017298096,
        23.057332276171
    ],
    [
        113.13012434446,
        23.057360487232
    ],
    [
        113.13009815524,
        23.057399929063
    ],
    [
        113.1300835853,
        23.057433326403
    ],
    [
        113.13006614235,
        23.057586323223
    ],
    [
        113.13004947086,
        23.057692939004
    ],
    [
        113.13003070201,
        23.057878470643
    ],
    [
        113.13001644866,
        23.057968305875
    ],
    [
        113.13002121417,
        23.058174038312
    ],
    [
        113.12999963805,
        23.058236076923
    ],
    [
        113.12997830502,
        23.05826502006
    ],
    [
        113.12996101798,
        23.058282907575
    ],
    [
        113.12989723006,
        23.05829784488
    ],
    [
        113.12972204803,
        23.058297083764
    ],
    [
        113.12948278417,
        23.058287127343
    ],
    [
        113.12915240059,
        23.058268901663
    ],
    [
        113.12876820723,
        23.058250647132
    ],
    [
        113.1287100719,
        23.058241556718
    ],
    [
        113.12865270891,
        23.058185543719
    ],
    [
        113.12859910639,
        23.058100020562
    ],
    [
        113.12856839339,
        23.057904448424
    ],
    [
        113.12851188683,
        23.057580669511
    ],
    [
        113.12849552559,
        23.05741544669
    ],
    [
        113.12849086361,
        23.057337776082
    ],
    [
        113.12848895399,
        23.057317668046
    ],
    [
        113.12847731744,
        23.057304998506
    ],
    [
        113.12846703619,
        23.05729642071
    ],
    [
        113.12844730296,
        23.057300712243
    ],
    [
        113.12841918447,
        23.057300526774
    ],
    [
        113.12834349373,
        23.05731557735
    ],
    [
        113.12821565803,
        23.057374824523
    ],
    [
        113.12807051222,
        23.057428644496
    ],
    [
        113.12786913318,
        23.057491609975
    ],
    [
        113.1277596664,
        23.057536795555
    ],
    [
        113.12765046278,
        23.057574664944
    ],
    [
        113.12756801027,
        23.057593158725
    ],
    [
        113.12745796265,
        23.057594125432
    ],
    [
        113.12735225306,
        23.057610359255
    ],
    [
        113.12728277636,
        23.057627711656
    ],
    [
        113.12722114969,
        23.057655770828
    ],
    [
        113.12716222394,
        23.057680618399
    ],
    [
        113.12715222885,
        23.057692127661
    ],
    [
        113.12712466804,
        23.057715841377
    ],
    [
        113.12711549634,
        23.057742014463
    ],
    [
        113.12711442061,
        23.057749051636
    ],
    [
        113.1271087632,
        23.057774194665
    ],
    [
        113.12711176339,
        23.057805171068
    ],
    [
        113.12713241515,
        23.057927313327
    ],
    [
        113.12714660605,
        23.058084895707
    ],
    [
        113.12713164976,
        23.058311746563
    ],
    [
        113.12712666832,
        23.058503754982
    ],
    [
        113.12712897911,
        23.058686653186
    ],
    [
        113.12713585918,
        23.058836523355
    ],
    [
        113.12715057066,
        23.058974578882
    ],
    [
        113.12715743662,
        23.05910844147
    ],
    [
        113.12715138966,
        23.059327562847
    ],
    [
        113.12716661299,
        23.059431441397
    ],
    [
        113.12719431006,
        23.059581638314
    ],
    [
        113.1272272543,
        23.059876253009
    ],
    [
        113.12725071504,
        23.060149013705
    ],
    [
        113.1272719723,
        23.060371276616
    ],
    [
        113.12726644667,
        23.060577381398
    ],
    [
        113.12726306482,
        23.060759102271
    ],
    [
        113.12726064588,
        23.060779140686
    ],
    [
        113.12724537291,
        23.060971526133
    ],
    [
        113.12724601713,
        23.061115327408
    ],
    [
        113.12725044305,
        23.06125484725
    ],
    [
        113.12724811762,
        23.061407554456
    ],
    [
        113.12722739957,
        23.061553460572
    ],
    [
        113.12720990924,
        23.061676085476
    ],
    [
        113.12719811893,
        23.061831085059
    ],
    [
        113.12717964769,
        23.062103724542
    ],
    [
        113.12717412006,
        23.062327732808
    ],
    [
        113.12717558354,
        23.062495419987
    ],
    [
        113.12718349938,
        23.062608134342
    ],
    [
        113.12720219738,
        23.062670013709
    ],
    [
        113.12724262656,
        23.062885520103
    ],
    [
        113.12725456796,
        23.06295380456
    ],
    [
        113.12725218757,
        23.063036784861
    ],
    [
        113.12725249914,
        23.063101359135
    ],
    [
        113.1272506494,
        23.063169154921
    ],
    [
        113.12725854221,
        23.063250397843
    ],
    [
        113.12727598782,
        23.06347476596
    ],
    [
        113.12729888004,
        23.063766230424
    ],
    [
        113.12731735321,
        23.063908953453
    ],
    [
        113.12733364078,
        23.064015559351
    ],
    [
        113.12734394884,
        23.064071066873
    ],
    [
        113.12736209712,
        23.064124799213
    ],
    [
        113.12738000473,
        23.064229260472
    ],
    [
        113.12742364368,
        23.064410363388
    ],
    [
        113.12743106075,
        23.064612868114
    ],
    [
        113.12743608314,
        23.064888041897
    ],
    [
        113.12742618495,
        23.065079962459
    ],
    [
        113.12742166016,
        23.065211469013
    ],
    [
        113.12741010737,
        23.065348561403
    ],
    [
        113.12739205384,
        23.065466017671
    ],
    [
        113.12737779631,
        23.065604694913
    ],
    [
        113.12734219188,
        23.065772605863
    ],
    [
        113.12732307086,
        23.0659223293
    ],
    [
        113.12731796991,
        23.065994141513
    ],
    [
        113.12732912582,
        23.066132405773
    ],
    [
        113.12732488106,
        23.06629647084
    ],
    [
        113.12729575015,
        23.066443051612
    ],
    [
        113.12727119889,
        23.066556335851
    ],
    [
        113.12720637457,
        23.066705068024
    ],
    [
        113.12715965695,
        23.066835367198
    ],
    [
        113.12712271835,
        23.067065113078
    ],
    [
        113.12706523477,
        23.067313256055
    ],
    [
        113.12700343382,
        23.067590089085
    ],
    [
        113.12698104716,
        23.067722941991
    ],
    [
        113.1269394802,
        23.067902157041
    ],
    [
        113.12690788295,
        23.06799932775
    ],
    [
        113.12684983584,
        23.068221964354
    ],
    [
        113.12681284537,
        23.068361644293
    ],
    [
        113.12676234819,
        23.06853990888
    ],
    [
        113.12671590017,
        23.068704401536
    ],
    [
        113.12666404191,
        23.068867725996
    ],
    [
        113.12660894758,
        23.06906030027
    ],
    [
        113.1265373481,
        23.069230918097
    ],
    [
        113.12647142433,
        23.069398370022
    ],
    [
        113.12644495932,
        23.069504577564
    ],
    [
        113.12642361088,
        23.06954819732
    ],
    [
        113.12640873878,
        23.069550952858
    ],
    [
        113.12639576366,
        23.069565945433
    ],
    [
        113.12636574732,
        23.069566569713
    ],
    [
        113.12628894697,
        23.069564036097
    ],
    [
        113.12623593956,
        23.069550203606
    ],
    [
        113.12613485429,
        23.069713059283
    ],
    [
        113.12604890967,
        23.069872894259
    ],
    [
        113.12569612891,
        23.070314097106
    ],
    [
        113.12565503735,
        23.070365837947
    ],
    [
        113.1254273843,
        23.070574308479
    ],
    [
        113.12537141307,
        23.070614439995
    ],
    [
        113.1253616785,
        23.070619992369
    ],
    [
        113.1251483466,
        23.07081704286
    ],
    [
        113.12449529412,
        23.071274680496
    ],
    [
        113.12400417415,
        23.071587253013
    ],
    [
        113.12365097158,
        23.071875017525
    ],
    [
        113.12344217721,
        23.072040592236
    ],
    [
        113.12327559142,
        23.07228652475
    ],
    [
        113.123179315,
        23.072429801579
    ],
    [
        113.12308225546,
        23.072754828122
    ],
    [
        113.12305900228,
        23.072825587259
    ],
    [
        113.12304603299,
        23.07292496975
    ],
    [
        113.12302793355,
        23.073094000511
    ],
    [
        113.12306152299,
        23.073421612036
    ],
    [
        113.12335589663,
        23.073882992281
    ],
    [
        113.12364942425,
        23.074191684575
    ],
    [
        113.12387666053,
        23.074425438247
    ],
    [
        113.12453396132,
        23.074855523417
    ],
    [
        113.12515333559,
        23.075142056344
    ],
    [
        113.12538782007,
        23.075241284096
    ],
    [
        113.12542352001,
        23.075270026846
    ],
    [
        113.12588029897,
        23.075484124883
    ],
    [
        113.12643386541,
        23.075758135186
    ],
    [
        113.12745761851,
        23.076310143401
    ],
    [
        113.12904767249,
        23.076982544698
    ],
    [
        113.12908362929,
        23.07699859925
    ],
    [
        113.1302898824,
        23.077511616538
    ],
    [
        113.13068833906,
        23.077679497216
    ],
    [
        113.13145413523,
        23.078009700621
    ],
    [
        113.13271397825,
        23.078631041126
    ],
    [
        113.13371591902,
        23.079025960101
    ],
    [
        113.13445108862,
        23.079190596565
    ],
    [
        113.13469840309,
        23.079196611702
    ],
    [
        113.13491165799,
        23.079214776206
    ],
    [
        113.13515195429,
        23.079155031558
    ],
    [
        113.13583742513,
        23.079008009224
    ],
    [
        113.13668101291,
        23.078829643883
    ],
    [
        113.13750865222,
        23.078656956383
    ],
    [
        113.13876415731,
        23.078552042694
    ],
    [
        113.13952124988,
        23.078564331599
    ],
    [
        113.14000913147,
        23.078626073592
    ],
    [
        113.14018131159,
        23.078643195907
    ],
    [
        113.1401837445,
        23.078641882195
    ],
    [
        113.14099490577,
        23.078858378537
    ],
    [
        113.1418058206,
        23.079094528205
    ],
    [
        113.14296524897,
        23.07923548044
    ],
    [
        113.14360191135,
        23.079256431816
    ],
    [
        113.14424103378,
        23.079285422846
    ],
    [
        113.14461711692,
        23.079283420398
    ],
    [
        113.1448691073,
        23.079279905525
    ],
    [
        113.14530712911,
        23.079271204513
    ],
    [
        113.14665133323,
        23.079114321504
    ],
    [
        113.14684090668,
        23.079072196083
    ],
    [
        113.14695854595,
        23.079050932136
    ],
    [
        113.14706753347,
        23.079024918854
    ],
    [
        113.14852532081,
        23.078692478549
    ],
    [
        113.14971985643,
        23.078372634687
    ],
    [
        113.15032557522,
        23.078191214274
    ],
    [
        113.15058421588,
        23.078117604551
    ],
    [
        113.15077495161,
        23.078098133798
    ],
    [
        113.15217328996,
        23.07791121598
    ],
    [
        113.1531826866,
        23.078002039322
    ],
    [
        113.15397947109,
        23.078199433099
    ],
    [
        113.15458306797,
        23.078419861938
    ],
    [
        113.1553418369,
        23.07869091189
    ],
    [
        113.15625121141,
        23.079140290504
    ],
    [
        113.15695080983,
        23.079747277581
    ],
    [
        113.1572247996,
        23.080076984202
    ],
    [
        113.15757243369,
        23.080527384389
    ],
    [
        113.1587319432,
        23.081643610109
    ],
    [
        113.15944721514,
        23.082210162242
    ],
    [
        113.15945344576,
        23.082211558272
    ],
    [
        113.15974380715,
        23.082422779613
    ],
    [
        113.15981694314,
        23.082470151646
    ],
    [
        113.15988900444,
        23.082492557521
    ],
    [
        113.16002066452,
        23.082542978535
    ],
    [
        113.16024932131,
        23.082614283239
    ],
    [
        113.1606150886,
        23.082711510679
    ],
    [
        113.16081450974,
        23.082763827371
    ],
    [
        113.16098603502,
        23.082789657507
    ],
    [
        113.16112315094,
        23.082809596885
    ],
    [
        113.16140878877,
        23.082810960694
    ],
    [
        113.16165162195,
        23.082805823609
    ],
    [
        113.16187116504,
        23.082777207587
    ],
    [
        113.1621370817,
        23.082702078894
    ],
    [
        113.1623862108,
        23.082610819156
    ],
    [
        113.16262559179,
        23.082521367027
    ],
    [
        113.16277931185,
        23.082460326959
    ],
    [
        113.16286173046,
        23.082430495428
    ],
    [
        113.1630778139,
        23.082352530141
    ],
    [
        113.1635211238,
        23.082190262355
    ],
    [
        113.16384678314,
        23.082069307667
    ],
    [
        113.16397314687,
        23.082024035885
    ],
    [
        113.16405910854,
        23.081992765309
    ],
    [
        113.16432079904,
        23.081894851299
    ],
    [
        113.16449842981,
        23.081829817035
    ],
    [
        113.16463538373,
        23.081786385652
    ],
    [
        113.16478020638,
        23.081739422853
    ],
    [
        113.16499365305,
        23.081661341934
    ],
    [
        113.16512166962,
        23.081618650266
    ],
    [
        113.16520791912,
        23.081592170917
    ],
    [
        113.16551631478,
        23.081491035572
    ],
    [
        113.16583259059,
        23.08140148012
    ],
    [
        113.16614319114,
        23.081302607301
    ],
    [
        113.1664416014,
        23.081207713343
    ],
    [
        113.16716300503,
        23.080990747385
    ],
    [
        113.16793848703,
        23.080835612378
    ],
    [
        113.16867852857,
        23.080687588596
    ],
    [
        113.16868368623,
        23.080681610333
    ],
    [
        113.16918633414,
        23.080574392776
    ],
    [
        113.17016652844,
        23.080341716049
    ],
    [
        113.17148005428,
        23.080072766848
    ],
    [
        113.17234550257,
        23.079888321499
    ],
    [
        113.17406537054,
        23.079616268111
    ],
    [
        113.17406835922,
        23.079613263701
    ],
    [
        113.17407732344,
        23.079614286957
    ],
    [
        113.175012167,
        23.079480251054
    ],
    [
        113.17509992647,
        23.079468451879
    ],
    [
        113.17511324016,
        23.079465364686
    ],
    [
        113.17522165075,
        23.07945203971
    ],
    [
        113.17523197607,
        23.079448432167
    ],
    [
        113.17593384439,
        23.079340985164
    ],
    [
        113.17599390027,
        23.079327998657
    ],
    [
        113.17695921744,
        23.07915151534
    ],
    [
        113.17802499159,
        23.078939107592
    ],
    [
        113.17842405606,
        23.07886286435
    ],
    [
        113.1784235131,
        23.078857716066
    ],
    [
        113.1784387367,
        23.078855116402
    ],
    [
        113.17894087998,
        23.078643368654
    ],
    [
        113.17949009695,
        23.078415176769
    ],
    [
        113.18100965328,
        23.077467224005
    ],
    [
        113.18286295995,
        23.07621433871
    ],
    [
        113.18382211948,
        23.075653511409
    ],
    [
        113.18382483987,
        23.075652117045
    ],
    [
        113.183979902,
        23.075539536514
    ],
    [
        113.18408055685,
        23.075449684223
    ]
];

let jiujiang = [
    [
        112.92091308026,
        22.882468708066
    ],
    [
        112.92092554805,
        22.882465516205
    ],
    [
        112.92100495003,
        22.8824642862
    ],
    [
        112.9211239152,
        22.882468939489
    ],
    [
        112.92112825047,
        22.882470045485
    ],
    [
        112.92301658407,
        22.882557623255
    ],
    [
        112.92488980466,
        22.882708639709
    ],
    [
        112.92553737525,
        22.882812432536
    ],
    [
        112.92555174625,
        22.882818140062
    ],
    [
        112.92569710899,
        22.882840488349
    ],
    [
        112.92570497396,
        22.882841578522
    ],
    [
        112.92616305421,
        22.882914746254
    ],
    [
        112.92635481631,
        22.882942169204
    ],
    [
        112.92678637109,
        22.883008560296
    ],
    [
        112.92695564293,
        22.883028831675
    ],
    [
        112.92738014879,
        22.883161440051
    ],
    [
        112.92736024441,
        22.883311991068
    ],
    [
        112.92699463903,
        22.88442755835
    ],
    [
        112.92693756955,
        22.884590328058
    ],
    [
        112.92694567454,
        22.884647283424
    ],
    [
        112.92696981852,
        22.884649441216
    ],
    [
        112.92726695169,
        22.884554858515
    ],
    [
        112.92738743774,
        22.884516784082
    ],
    [
        112.92754979031,
        22.884346290799
    ],
    [
        112.9277393585,
        22.884052329172
    ],
    [
        112.92774234352,
        22.884051783045
    ],
    [
        112.92785424478,
        22.883874795915
    ],
    [
        112.9279547175,
        22.883754230186
    ],
    [
        112.92810724844,
        22.883702739286
    ],
    [
        112.92829938758,
        22.883675027064
    ],
    [
        112.92854263379,
        22.883519159917
    ],
    [
        112.92887679375,
        22.883384734019
    ],
    [
        112.92975898398,
        22.883240787697
    ],
    [
        112.93025136527,
        22.883282013741
    ],
    [
        112.93051980721,
        22.88334314502
    ],
    [
        112.93058603682,
        22.883359438134
    ],
    [
        112.93065145509,
        22.883372204435
    ],
    [
        112.93083712806,
        22.88340808209
    ],
    [
        112.93083712561,
        22.883411879338
    ],
    [
        112.9308387563,
        22.8834091604
    ],
    [
        112.93104610801,
        22.883519232193
    ],
    [
        112.93111423061,
        22.883557455478
    ],
    [
        112.93120679387,
        22.883589329143
    ],
    [
        112.93123284931,
        22.883604132087
    ],
    [
        112.9313045156,
        22.883624155567
    ],
    [
        112.931601331,
        22.883556062864
    ],
    [
        112.93196334878,
        22.883463423378
    ],
    [
        112.93202609293,
        22.883437336591
    ],
    [
        112.93205352666,
        22.883426075181
    ],
    [
        112.932068733,
        22.883426810469
    ],
    [
        112.93207878496,
        22.883419706518
    ],
    [
        112.93209562279,
        22.883417178233
    ],
    [
        112.93210268422,
        22.883415514199
    ],
    [
        112.9321037734,
        22.883410897613
    ],
    [
        112.93211979542,
        22.883410271822
    ],
    [
        112.93216243481,
        22.883401912019
    ],
    [
        112.93220073451,
        22.883385979059
    ],
    [
        112.93230936788,
        22.883371296299
    ],
    [
        112.93248699536,
        22.883335881236
    ],
    [
        112.93259997901,
        22.8833219603
    ],
    [
        112.93267440261,
        22.883304722469
    ],
    [
        112.93269504033,
        22.883308401952
    ],
    [
        112.93270997912,
        22.883305604178
    ],
    [
        112.93272003314,
        22.883297138394
    ],
    [
        112.93293081417,
        22.88325197047
    ],
    [
        112.9331397005,
        22.883208945227
    ],
    [
        112.93342356141,
        22.883163781187
    ],
    [
        112.93357513823,
        22.883143551665
    ],
    [
        112.93362702755,
        22.883129652801
    ],
    [
        112.9336308403,
        22.883114439028
    ],
    [
        112.93363083852,
        22.883117151342
    ],
    [
        112.93363763739,
        22.883104630357
    ],
    [
        112.93364986596,
        22.8830964135
    ],
    [
        112.93367677197,
        22.883073725033
    ],
    [
        112.93369171015,
        22.883075796688
    ],
    [
        112.93369822748,
        22.883078466092
    ],
    [
        112.93375446067,
        22.883069686315
    ],
    [
        112.93379303852,
        22.883060479193
    ],
    [
        112.93382537204,
        22.883046701702
    ],
    [
        112.93387943642,
        22.88303331951
    ],
    [
        112.93394029145,
        22.883021244866
    ],
    [
        112.93399979106,
        22.883005921577
    ],
    [
        112.93401391352,
        22.883010435761
    ],
    [
        112.93403321002,
        22.88299565691
    ],
    [
        112.93405467868,
        22.882982490159
    ],
    [
        112.93406201368,
        22.88298162591
    ],
    [
        112.93407941386,
        22.882959264945
    ],
    [
        112.9342095447,
        22.882943169566
    ],
    [
        112.9342554571,
        22.882938777854
    ],
    [
        112.9342755577,
        22.882941619291
    ],
    [
        112.93428561298,
        22.882935581028
    ],
    [
        112.93430897701,
        22.882933245402
    ],
    [
        112.93432853124,
        22.882940971953
    ],
    [
        112.93434184293,
        22.882940334608
    ],
    [
        112.934396451,
        22.88293370551
    ],
    [
        112.93442661681,
        22.882916672302
    ],
    [
        112.93443885506,
        22.882896513066
    ],
    [
        112.9344611437,
        22.882878179649
    ],
    [
        112.93446224013,
        22.882863525321
    ],
    [
        112.93446768304,
        22.882849110764
    ],
    [
        112.93449515183,
        22.88280334503
    ],
    [
        112.93451312683,
        22.882736220704
    ],
    [
        112.93453002419,
        22.882656085011
    ],
    [
        112.93452948012,
        22.882657173895
    ],
    [
        112.93453247196,
        22.882651998723
    ],
    [
        112.93456351455,
        22.882545178924
    ],
    [
        112.93458205401,
        22.88244848566
    ],
    [
        112.9346087245,
        22.882380211359
    ],
    [
        112.93462782082,
        22.882265069908
    ],
    [
        112.93462320256,
        22.882264832728
    ],
    [
        112.93463274004,
        22.88222299327
    ],
    [
        112.93463192351,
        22.882225169119
    ],
    [
        112.93464799783,
        22.882159413251
    ],
    [
        112.93468854021,
        22.882069065276
    ],
    [
        112.9347244702,
        22.881970884793
    ],
    [
        112.93476202683,
        22.881878386905
    ],
    [
        112.93478382577,
        22.881787091185
    ],
    [
        112.9348028822,
        22.881732431392
    ],
    [
        112.93481921753,
        22.881684030043
    ],
    [
        112.93484071886,
        22.881630164951
    ],
    [
        112.93485570055,
        22.881575535158
    ],
    [
        112.93488562622,
        22.881519164509
    ],
    [
        112.93489325551,
        22.881488457996
    ],
    [
        112.93491147766,
        22.881461739254
    ],
    [
        112.93494302574,
        22.881416746376
    ],
    [
        112.93497536533,
        22.881404564979
    ],
    [
        112.9350389512,
        22.881389972154
    ],
    [
        112.93510931775,
        22.881392410501
    ],
    [
        112.93516012542,
        22.881391471877
    ],
    [
        112.93522857833,
        22.881412090368
    ],
    [
        112.93529240602,
        22.881442505802
    ],
    [
        112.93534292434,
        22.881468141948
    ],
    [
        112.93535487257,
        22.881477539582
    ],
    [
        112.93541353823,
        22.881509345954
    ],
    [
        112.93547004291,
        22.881524350913
    ],
    [
        112.93549232353,
        22.881523899574
    ],
    [
        112.9355580792,
        22.881522280732
    ],
    [
        112.93566595471,
        22.881516786252
    ],
    [
        112.93578416438,
        22.881501974498
    ],
    [
        112.93589803668,
        22.881476067626
    ],
    [
        112.93599967558,
        22.881460560947
    ],
    [
        112.9362070439,
        22.881416739406
    ],
    [
        112.93642173465,
        22.881403195792
    ],
    [
        112.93659730452,
        22.881382373164
    ],
    [
        112.93665627936,
        22.881378858279
    ],
    [
        112.93680087685,
        22.88135421826
    ],
    [
        112.93739075884,
        22.881196527368
    ],
    [
        112.9379532353,
        22.881048606512
    ],
    [
        112.9381071173,
        22.881006639644
    ],
    [
        112.93836595396,
        22.880933195161
    ],
    [
        112.93845700913,
        22.880947166638
    ],
    [
        112.93850512061,
        22.880952902525
    ],
    [
        112.93854154611,
        22.880954690896
    ],
    [
        112.93859101845,
        22.880959053314
    ],
    [
        112.93862689591,
        22.880967354534
    ],
    [
        112.93867067547,
        22.880950889765
    ],
    [
        112.93871472337,
        22.880939574001
    ],
    [
        112.93872886591,
        22.880931015864
    ],
    [
        112.93880228559,
        22.880904467548
    ],
    [
        112.93884661026,
        22.88088772006
    ],
    [
        112.93883899927,
        22.880886445433
    ],
    [
        112.93894885134,
        22.880857057708
    ],
    [
        112.93895075336,
        22.880858393315
    ],
    [
        112.93895510819,
        22.880851565723
    ],
    [
        112.93901003435,
        22.880837681971
    ],
    [
        112.93905924412,
        22.880834164672
    ],
    [
        112.93911389422,
        22.880827060372
    ],
    [
        112.93916961085,
        22.88084869201
    ],
    [
        112.93922261285,
        22.880865469181
    ],
    [
        112.9392652903,
        22.880873950132
    ],
    [
        112.93937050297,
        22.880877397986
    ],
    [
        112.93943520024,
        22.880890240126
    ],
    [
        112.93949093744,
        22.880887719652
    ],
    [
        112.93951540193,
        22.880894226592
    ],
    [
        112.93952382511,
        22.880901184103
    ],
    [
        112.93952491064,
        22.880903884188
    ],
    [
        112.93952789533,
        22.880911987485
    ],
    [
        112.93953603018,
        22.880941188565
    ],
    [
        112.93954174337,
        22.880936242467
    ],
    [
        112.93956022436,
        22.880945799182
    ],
    [
        112.93955695651,
        22.880952887705
    ],
    [
        112.93955804606,
        22.880950163229
    ],
    [
        112.93957348749,
        22.881025932703
    ],
    [
        112.93957184917,
        22.881035443977
    ],
    [
        112.93957753523,
        22.881067384603
    ],
    [
        112.93958293611,
        22.881117500489
    ],
    [
        112.939605207,
        22.881149796904
    ],
    [
        112.93962611738,
        22.881183735663
    ],
    [
        112.93962530151,
        22.881184016086
    ],
    [
        112.93964024172,
        22.881202562106
    ],
    [
        112.9397911665,
        22.881166947812
    ],
    [
        112.93981183113,
        22.88116589859
    ],
    [
        112.93992168716,
        22.881151893768
    ],
    [
        112.94003481115,
        22.881133231873
    ],
    [
        112.9400636275,
        22.881140492696
    ],
    [
        112.9401000518,
        22.881155258948
    ],
    [
        112.94027788048,
        22.881153997438
    ],
    [
        112.9403812078,
        22.881153595284
    ],
    [
        112.94043858521,
        22.881149391043
    ],
    [
        112.94045897941,
        22.881148878173
    ],
    [
        112.94046767591,
        22.881155555666
    ],
    [
        112.94049026443,
        22.881129249967
    ],
    [
        112.94048890065,
        22.881134961886
    ],
    [
        112.94049298524,
        22.881127047851
    ],
    [
        112.94051749087,
        22.881082275679
    ],
    [
        112.94052812038,
        22.881048788557
    ],
    [
        112.94053439138,
        22.881025931031
    ],
    [
        112.94053983464,
        22.881019356817
    ],
    [
        112.94054802255,
        22.880978304361
    ],
    [
        112.94056409935,
        22.880933089435
    ],
    [
        112.94057338236,
        22.880882259729
    ],
    [
        112.94059082748,
        22.880825636801
    ],
    [
        112.94061316762,
        22.880768683928
    ],
    [
        112.94063851093,
        22.880695963787
    ],
    [
        112.94063878326,
        22.880695418077
    ],
    [
        112.94064477054,
        22.880688836976
    ],
    [
        112.94066057163,
        22.880649591329
    ],
    [
        112.9406717386,
        22.880625589673
    ],
    [
        112.94068752433,
        22.880606956941
    ],
    [
        112.94073020671,
        22.880620547297
    ],
    [
        112.94073510126,
        22.880620759582
    ],
    [
        112.940782672,
        22.88064323993
    ],
    [
        112.94080714149,
        22.880648911173
    ],
    [
        112.94080877594,
        22.880645094275
    ],
    [
        112.94086858896,
        22.88066118563
    ],
    [
        112.94096403253,
        22.880668703705
    ],
    [
        112.94100779985,
        22.880688239793
    ],
    [
        112.94103009396,
        22.880694747649
    ],
    [
        112.94109834131,
        22.880707743089
    ],
    [
        112.94118426625,
        22.880719974891
    ],
    [
        112.94124489779,
        22.880736583605
    ],
    [
        112.94125577396,
        22.880738889897
    ],
    [
        112.94129166173,
        22.88075146355
    ],
    [
        112.94128868322,
        22.880734142192
    ],
    [
        112.94129849131,
        22.880710152719
    ],
    [
        112.94131975313,
        22.880643709926
    ],
    [
        112.94133857923,
        22.880561837445
    ],
    [
        112.94137809855,
        22.880447431291
    ],
    [
        112.94137728022,
        22.880450696175
    ],
    [
        112.94137837461,
        22.880442003383
    ],
    [
        112.94138136242,
        22.880446848138
    ],
    [
        112.94150839606,
        22.880405931032
    ],
    [
        112.94154076605,
        22.880396573901
    ],
    [
        112.94155381748,
        22.880399935604
    ],
    [
        112.94156497591,
        22.880389217431
    ],
    [
        112.94160604544,
        22.880384360153
    ],
    [
        112.94162427314,
        22.880375993339
    ],
    [
        112.94166970021,
        22.880363485082
    ],
    [
        112.94169282323,
        22.880355326705
    ],
    [
        112.94175266768,
        22.880339107322
    ],
    [
        112.94177633077,
        22.8803363653
    ],
    [
        112.94184678522,
        22.880316752553
    ],
    [
        112.94186011553,
        22.880311700209
    ],
    [
        112.94187398713,
        22.880310166727
    ],
    [
        112.94190255479,
        22.880295968695
    ],
    [
        112.94192757553,
        22.880296732898
    ],
    [
        112.94198470496,
        22.880276742361
    ],
    [
        112.9420328521,
        22.880266629604
    ],
    [
        112.94204645348,
        22.880263199529
    ],
    [
        112.94205624801,
        22.880258733584
    ],
    [
        112.94210004226,
        22.880250844743
    ],
    [
        112.94213132603,
        22.880242574356
    ],
    [
        112.94216151453,
        22.880244081582
    ],
    [
        112.94217946578,
        22.880243306164
    ],
    [
        112.94221755673,
        22.880225452893
    ],
    [
        112.94225781524,
        22.880218690602
    ],
    [
        112.94228284313,
        22.88021158366
    ],
    [
        112.942310581,
        22.880217459613
    ],
    [
        112.94232064184,
        22.880220854027
    ],
    [
        112.94232281712,
        22.880221639259
    ],
    [
        112.9423209159,
        22.880218138218
    ],
    [
        112.94242702189,
        22.880177420439
    ],
    [
        112.94245475568,
        22.880189260864
    ],
    [
        112.94250778914,
        22.880195342925
    ],
    [
        112.94255620525,
        22.880193347613
    ],
    [
        112.94257252562,
        22.880192318157
    ],
    [
        112.9425839476,
        22.880194608042
    ],
    [
        112.94260135561,
        22.880194106348
    ],
    [
        112.94261440878,
        22.880197459306
    ],
    [
        112.94261767296,
        22.880197144821
    ],
    [
        112.94262881698,
        22.880207303533
    ],
    [
        112.9426527462,
        22.880215665148
    ],
    [
        112.94268674592,
        22.880215484637
    ],
    [
        112.9426978915,
        22.880223744302
    ],
    [
        112.94273406742,
        22.880223533862
    ],
    [
        112.94275773118,
        22.880223760807
    ],
    [
        112.94275882479,
        22.880216423207
    ],
    [
        112.94276997586,
        22.880217630522
    ],
    [
        112.94280697413,
        22.880209542052
    ],
    [
        112.94282112188,
        22.880204742058
    ],
    [
        112.94282438801,
        22.880201986134
    ],
    [
        112.94284968282,
        22.880203817277
    ],
    [
        112.94286600981,
        22.880194919369
    ],
    [
        112.94287145304,
        22.880190778054
    ],
    [
        112.94298354425,
        22.880158080734
    ],
    [
        112.94299796516,
        22.88015219067
    ],
    [
        112.94319793225,
        22.880101204824
    ],
    [
        112.943215076,
        22.880092292422
    ],
    [
        112.94328581231,
        22.88007641081
    ],
    [
        112.94326355627,
        22.880012434883
    ],
    [
        112.94328042858,
        22.880002983088
    ],
    [
        112.94327881512,
        22.879978866343
    ],
    [
        112.94329025925,
        22.87995375766
    ],
    [
        112.94331312113,
        22.879937714409
    ],
    [
        112.94332156701,
        22.879920511946
    ],
    [
        112.94333763351,
        22.879898051959
    ],
    [
        112.94335423651,
        22.879885348467
    ],
    [
        112.94336213568,
        22.879871679182
    ],
    [
        112.94342263007,
        22.879735780997
    ],
    [
        112.9435169115,
        22.879529982657
    ],
    [
        112.94351717925,
        22.879535403388
    ],
    [
        112.94352670919,
        22.879523880669
    ],
    [
        112.9435754123,
        22.879510460779
    ],
    [
        112.9437634776,
        22.879392582281
    ],
    [
        112.94397720119,
        22.879171802153
    ],
    [
        112.9441168626,
        22.8790415473
    ],
    [
        112.94428266182,
        22.878888399058
    ],
    [
        112.94432023262,
        22.878853690762
    ],
    [
        112.94433058094,
        22.87884079605
    ],
    [
        112.94434934399,
        22.878851106241
    ],
    [
        112.94442178192,
        22.879098509677
    ],
    [
        112.94447144335,
        22.879253750814
    ],
    [
        112.94458954178,
        22.879220594091
    ],
    [
        112.94522142253,
        22.879041886269
    ],
    [
        112.945329728,
        22.879018320628
    ],
    [
        112.94553819551,
        22.878952036138
    ],
    [
        112.94598860359,
        22.87882947523
    ],
    [
        112.946021527,
        22.878829791617
    ],
    [
        112.94640038111,
        22.878720969123
    ],
    [
        112.94643002989,
        22.878734347776
    ],
    [
        112.94642213735,
        22.878736095863
    ],
    [
        112.94647218531,
        22.87876055295
    ],
    [
        112.94668649664,
        22.878899106348
    ],
    [
        112.94673408989,
        22.878932274375
    ],
    [
        112.94673028155,
        22.878930705863
    ],
    [
        112.94673898824,
        22.878931927509
    ],
    [
        112.9467498638,
        22.878943150745
    ],
    [
        112.94679773562,
        22.878968718967
    ],
    [
        112.94688477268,
        22.879019173751
    ],
    [
        112.94692338838,
        22.879050578468
    ],
    [
        112.94694161433,
        22.87905816079
    ],
    [
        112.9469669212,
        22.879058581183
    ],
    [
        112.94705774628,
        22.879137991022
    ],
    [
        112.94705964857,
        22.879141216015
    ],
    [
        112.94711159232,
        22.879181088853
    ],
    [
        112.94714503833,
        22.879212841771
    ],
    [
        112.94720160166,
        22.879261590703
    ],
    [
        112.94723911576,
        22.879311179175
    ],
    [
        112.9472682084,
        22.879342727317
    ],
    [
        112.9473019218,
        22.879381254345
    ],
    [
        112.94730952692,
        22.879399578006
    ],
    [
        112.94732746388,
        22.879429401936
    ],
    [
        112.94735955012,
        22.879461173192
    ],
    [
        112.94734212739,
        22.879469312322
    ],
    [
        112.94732742173,
        22.879482833079
    ],
    [
        112.94730345506,
        22.879507347911
    ],
    [
        112.94726260715,
        22.879543789653
    ],
    [
        112.94716704434,
        22.879602784355
    ],
    [
        112.94709815132,
        22.879660816742
    ],
    [
        112.94701129369,
        22.879725364882
    ],
    [
        112.94688414057,
        22.879819013325
    ],
    [
        112.94687461272,
        22.879823771841
    ],
    [
        112.94686916418,
        22.879831721738
    ],
    [
        112.9468639846,
        22.879843735777
    ],
    [
        112.94685854259,
        22.879843277681
    ],
    [
        112.94685146428,
        22.879847455692
    ],
    [
        112.94684601659,
        22.879854320635
    ],
    [
        112.94683594622,
        22.879856917621
    ],
    [
        112.94682069905,
        22.87986800258
    ],
    [
        112.94681471639,
        22.879862941981
    ],
    [
        112.94679157419,
        22.879878759699
    ],
    [
        112.94656121697,
        22.880071895051
    ],
    [
        112.94656066733,
        22.880078955269
    ],
    [
        112.94656066587,
        22.880080853846
    ],
    [
        112.94658649844,
        22.880104324343
    ],
    [
        112.94662347456,
        22.88014498126
    ],
    [
        112.94666370984,
        22.880193995235
    ],
    [
        112.94677084303,
        22.88029920326
    ],
    [
        112.94681433986,
        22.880354402267
    ],
    [
        112.94681896365,
        22.880357314142
    ],
    [
        112.94660977924,
        22.880623357657
    ],
    [
        112.94660187351,
        22.880642736136
    ],
    [
        112.94654958664,
        22.880698326958
    ],
    [
        112.94636653431,
        22.880595624956
    ],
    [
        112.94609998781,
        22.880443726592
    ],
    [
        112.9458690761,
        22.88031431296
    ],
    [
        112.94582964366,
        22.880286698458
    ],
    [
        112.94579748685,
        22.880352545846
    ],
    [
        112.94574732079,
        22.880486739568
    ],
    [
        112.94570508551,
        22.880568467501
    ],
    [
        112.94571542358,
        22.88057021139
    ],
    [
        112.94573364644,
        22.880579702654
    ],
    [
        112.94612835813,
        22.880710722625
    ],
    [
        112.94612915991,
        22.880730238556
    ],
    [
        112.94614488531,
        22.880806213865
    ],
    [
        112.94614760675,
        22.880805630128
    ],
    [
        112.94597077128,
        22.88076735096
    ],
    [
        112.94595472169,
        22.880761897362
    ],
    [
        112.9459541789,
        22.880760006982
    ],
    [
        112.94593132144,
        22.880761978893
    ],
    [
        112.94590737786,
        22.880760983447
    ],
    [
        112.9458779916,
        22.880761154503
    ],
    [
        112.94586982871,
        22.880761277284
    ],
    [
        112.94587254423,
        22.880768559479
    ],
    [
        112.94585485718,
        22.880769910325
    ],
    [
        112.94583444517,
        22.880776726428
    ],
    [
        112.94583389756,
        22.880781345455
    ],
    [
        112.94582136408,
        22.880804587705
    ],
    [
        112.94580282248,
        22.880857754668
    ],
    [
        112.94578864372,
        22.88089837975
    ],
    [
        112.94578125561,
        22.880954905138
    ],
    [
        112.94576655537,
        22.880964889602
    ],
    [
        112.94575456353,
        22.880991920497
    ],
    [
        112.94573250231,
        22.88102181436
    ],
    [
        112.94571152854,
        22.881053047842
    ],
    [
        112.94570845237,
        22.881167008094
    ],
    [
        112.94569994468,
        22.881267488458
    ],
    [
        112.94572877702,
        22.881280075802
    ],
    [
        112.94599919807,
        22.881334865338
    ],
    [
        112.9460454612,
        22.88132575819
    ],
    [
        112.94606314465,
        22.881329830266
    ],
    [
        112.94610478937,
        22.881311027601
    ],
    [
        112.94624168391,
        22.881272876005
    ],
    [
        112.94634185283,
        22.881225241206
    ],
    [
        112.94637696514,
        22.881210601298
    ],
    [
        112.94647550889,
        22.881154577185
    ],
    [
        112.9465171023,
        22.88120872669
    ],
    [
        112.94652444503,
        22.881214580946
    ],
    [
        112.94653097044,
        22.881221803847
    ],
    [
        112.94643054353,
        22.88124748217
    ],
    [
        112.94643461833,
        22.881256912664
    ],
    [
        112.94643375045,
        22.881328258049
    ],
    [
        112.9464594772,
        22.881500363209
    ],
    [
        112.94648297692,
        22.88174519093
    ],
    [
        112.94648079525,
        22.881752005016
    ],
    [
        112.9464921717,
        22.881826146489
    ],
    [
        112.94652181946,
        22.881843592601
    ],
    [
        112.94654901885,
        22.881860262242
    ],
    [
        112.94660698441,
        22.88185204806
    ],
    [
        112.94676210178,
        22.8818347386
    ],
    [
        112.94681247177,
        22.881794360553
    ],
    [
        112.9469006701,
        22.881749055104
    ],
    [
        112.94690175744,
        22.881750665585
    ],
    [
        112.94698015776,
        22.881708763786
    ],
    [
        112.94701282234,
        22.881694694267
    ],
    [
        112.94713478338,
        22.881624714925
    ],
    [
        112.94723006299,
        22.881574946646
    ],
    [
        112.94731037037,
        22.881533546293
    ],
    [
        112.94737570866,
        22.881495633314
    ],
    [
        112.94739040391,
        22.881495402229
    ],
    [
        112.94742823123,
        22.881493993294
    ],
    [
        112.94753463582,
        22.881493400577
    ],
    [
        112.94756266235,
        22.881498111194
    ],
    [
        112.94757025882,
        22.881530809402
    ],
    [
        112.94758331337,
        22.881541994522
    ],
    [
        112.94760206761,
        22.881574516227
    ],
    [
        112.94763660642,
        22.881606245517
    ],
    [
        112.94770215526,
        22.881657553468
    ],
    [
        112.94779408276,
        22.88173637679
    ],
    [
        112.94786371166,
        22.881792226487
    ],
    [
        112.94789444754,
        22.881815333547
    ],
    [
        112.94792246567,
        22.881833330281
    ],
    [
        112.9479551191,
        22.881838776342
    ],
    [
        112.94811293395,
        22.881881276355
    ],
    [
        112.94816925524,
        22.881900444132
    ],
    [
        112.94830829135,
        22.881947301774
    ],
    [
        112.94841931097,
        22.881974262391
    ],
    [
        112.94848160912,
        22.882010685489
    ],
    [
        112.94850282584,
        22.882027158535
    ],
    [
        112.94852075814,
        22.882070535961
    ],
    [
        112.94854550892,
        22.882092918491
    ],
    [
        112.94870502765,
        22.882441841942
    ],
    [
        112.94864639248,
        22.882621803964
    ],
    [
        112.9486710304,
        22.882815332156
    ],
    [
        112.94867316071,
        22.882886630618
    ],
    [
        112.94871070045,
        22.882914499973
    ],
    [
        112.94871307385,
        22.883030818479
    ],
    [
        112.94871683902,
        22.883100191882
    ],
    [
        112.94872768833,
        22.883157516117
    ],
    [
        112.94873392149,
        22.883198641628
    ],
    [
        112.94873878102,
        22.883259860438
    ],
    [
        112.94875882934,
        22.883403286072
    ],
    [
        112.94878461383,
        22.883515155732
    ],
    [
        112.94880033255,
        22.883621222082
    ],
    [
        112.948898298,
        22.883642408931
    ],
    [
        112.94906133654,
        22.883624284324
    ],
    [
        112.9493242781,
        22.883583351701
    ],
    [
        112.94945139184,
        22.883569322451
    ],
    [
        112.94949739465,
        22.883560968458
    ],
    [
        112.94959076806,
        22.88353392902
    ],
    [
        112.94968773864,
        22.883850204737
    ],
    [
        112.94971402892,
        22.884031764735
    ],
    [
        112.94972644768,
        22.884199722205
    ],
    [
        112.94972090252,
        22.884369876609
    ],
    [
        112.94969221857,
        22.884548280796
    ],
    [
        112.94969657618,
        22.884543597582
    ],
    [
        112.94966353984,
        22.884720175348
    ],
    [
        112.94963704826,
        22.884877387089
    ],
    [
        112.94962392516,
        22.884980401967
    ],
    [
        112.94961871392,
        22.885051009054
    ],
    [
        112.94962168077,
        22.885099239576
    ],
    [
        112.94962467354,
        22.885101359889
    ],
    [
        112.94963092655,
        22.885114004332
    ],
    [
        112.9496423589,
        22.885112458795
    ],
    [
        112.94966086508,
        22.885115949445
    ],
    [
        112.94969380085,
        22.885112148655
    ],
    [
        112.94971938185,
        22.885119047676
    ],
    [
        112.94975937509,
        22.885149847071
    ],
    [
        112.94978031624,
        22.885179877543
    ],
    [
        112.94979907593,
        22.885217267461
    ],
    [
        112.94979851186,
        22.885252808541
    ],
    [
        112.94980417595,
        22.88534656159
    ],
    [
        112.94980032585,
        22.885418774025
    ],
    [
        112.94979749255,
        22.885624688609
    ],
    [
        112.94978506735,
        22.885959328927
    ],
    [
        112.9497650847,
        22.886179091284
    ],
    [
        112.94979929955,
        22.886336654244
    ],
    [
        112.94981015706,
        22.886395874831
    ],
    [
        112.9498106754,
        22.886447943848
    ],
    [
        112.94980270663,
        22.886600512004
    ],
    [
        112.94975711595,
        22.886882001175
    ],
    [
        112.94973364167,
        22.88702262147
    ],
    [
        112.94970170421,
        22.887220613779
    ],
    [
        112.94967736749,
        22.887467845962
    ],
    [
        112.94966478729,
        22.88760204745
    ],
    [
        112.9496628603,
        22.887651174022
    ],
    [
        112.94965576009,
        22.887704726207
    ],
    [
        112.94965166229,
        22.88773924176
    ],
    [
        112.94964620153,
        22.887778662249
    ],
    [
        112.94963530098,
        22.887809493122
    ],
    [
        112.94964101102,
        22.887822689375
    ],
    [
        112.94964263625,
        22.887840835643
    ],
    [
        112.94966031726,
        22.887865496921
    ],
    [
        112.94970059395,
        22.887879205006
    ],
    [
        112.94970140887,
        22.887882988876
    ],
    [
        112.94970140887,
        22.887882988876
    ],
    [
        112.94977870175,
        22.887897980513
    ],
    [
        112.94979312515,
        22.887903165748
    ],
    [
        112.94982442327,
        22.887909697885
    ],
    [
        112.94986606831,
        22.887907106607
    ],
    [
        112.94986279931,
        22.887913670798
    ],
    [
        112.94986307196,
        22.887912581294
    ],
    [
        112.94993927125,
        22.887940878095
    ],
    [
        112.94993410689,
        22.887924147126
    ],
    [
        112.9499683975,
        22.887934967885
    ],
    [
        112.95004460068,
        22.887955396141
    ],
    [
        112.95010937921,
        22.88795973906
    ],
    [
        112.95017660449,
        22.887971634558
    ],
    [
        112.95022831826,
        22.887976464985
    ],
    [
        112.95023131236,
        22.887976414841
    ],
    [
        112.95022586808,
        22.887977590986
    ],
    [
        112.95023594099,
        22.887973082413
    ],
    [
        112.95026969537,
        22.887966278315
    ],
    [
        112.95026914926,
        22.887970356099
    ],
    [
        112.95030208897,
        22.887959225461
    ],
    [
        112.95034482862,
        22.887945760132
    ],
    [
        112.95039790861,
        22.887939444144
    ],
    [
        112.95049998095,
        22.887939084415
    ],
    [
        112.9505571409,
        22.887940834629
    ],
    [
        112.95065404045,
        22.887945168703
    ],
    [
        112.95081708757,
        22.887942414711
    ],
    [
        112.95107867231,
        22.887941236438
    ],
    [
        112.95118646292,
        22.887945100607
    ],
    [
        112.95121313745,
        22.887948444206
    ],
    [
        112.95121940026,
        22.887943455281
    ],
    [
        112.95123899552,
        22.887951530284
    ],
    [
        112.95126921688,
        22.887935826193
    ],
    [
        112.95127574892,
        22.887937884888
    ],
    [
        112.95135142227,
        22.887937137877
    ],
    [
        112.95139035054,
        22.887930506661
    ],
    [
        112.9515275423,
        22.887931961444
    ],
    [
        112.95169304603,
        22.887930485728
    ],
    [
        112.9517101969,
        22.887926665754
    ],
    [
        112.95171809441,
        22.887918664415
    ],
    [
        112.95172109083,
        22.887913730713
    ],
    [
        112.95172136501,
        22.887909114901
    ],
    [
        112.95173007557,
        22.887909508109
    ],
    [
        112.95174967848,
        22.887900763603
    ],
    [
        112.95176709999,
        22.887900736158
    ],
    [
        112.95180275853,
        22.887903379491
    ],
    [
        112.95184059323,
        22.88790978258
    ],
    [
        112.95188387378,
        22.887912565692
    ],
    [
        112.95194621132,
        22.887910681046
    ],
    [
        112.95197452183,
        22.88790992317
    ],
    [
        112.95202161181,
        22.887916979368
    ],
    [
        112.9520855821,
        22.887917234711
    ],
    [
        112.95212178963,
        22.887910372669
    ],
    [
        112.95216343971,
        22.887907756443
    ],
    [
        112.95223094992,
        22.887906321405
    ],
    [
        112.95230526452,
        22.887907751661
    ],
    [
        112.95234528079,
        22.887907060797
    ],
    [
        112.95236814565,
        22.88791046329
    ],
    [
        112.95237740355,
        22.887904607289
    ],
    [
        112.95239646278,
        22.887895327024
    ],
    [
        112.95238965843,
        22.88789273217
    ],
    [
        112.95239565353,
        22.887877981526
    ],
    [
        112.95240300894,
        22.887865106064
    ],
    [
        112.95240492017,
        22.88785178219
    ],
    [
        112.95241064029,
        22.887843546088
    ],
    [
        112.95241119021,
        22.887830788223
    ],
    [
        112.95242181089,
        22.887821111211
    ],
    [
        112.95243081405,
        22.88777484452
    ],
    [
        112.95243789672,
        22.887763329945
    ],
    [
        112.95243817294,
        22.887754102958
    ],
    [
        112.95244226107,
        22.887742911386
    ],
    [
        112.95244880144,
        22.887726523828
    ],
    [
        112.95245370732,
        22.88771287694
    ],
    [
        112.95245044551,
        22.887701812438
    ],
    [
        112.95245780424,
        22.88768161335
    ],
    [
        112.95246517428,
        22.887635646146
    ],
    [
        112.95246708102,
        22.887632900763
    ],
    [
        112.95249974161,
        22.887645897947
    ],
    [
        112.95254846382,
        22.887657532001
    ],
    [
        112.95260589534,
        22.887673354647
    ],
    [
        112.95274118599,
        22.887680774654
    ],
    [
        112.95294915278,
        22.887707000661
    ],
    [
        112.95308716076,
        22.887729554839
    ],
    [
        112.95321973258,
        22.88773429871
    ],
    [
        112.9532760732,
        22.88775799982
    ],
    [
        112.95330600141,
        22.887796808084
    ],
    [
        112.95329890319,
        22.887844127906
    ],
    [
        112.95327055591,
        22.887927893353
    ],
    [
        112.95323567084,
        22.888022893613
    ],
    [
        112.95320759364,
        22.888113706545
    ],
    [
        112.95319696292,
        22.888147254578
    ],
    [
        112.95320131129,
        22.888164809606
    ],
    [
        112.95321082699,
        22.888194480539
    ],
    [
        112.95327479356,
        22.888210725362
    ],
    [
        112.95334012141,
        22.888226945817
    ],
    [
        112.95347866142,
        22.888285828977
    ],
    [
        112.95348002059,
        22.888290687619
    ],
    [
        112.95349417559,
        22.888292881618
    ],
    [
        112.95355110947,
        22.888199664479
    ],
    [
        112.95357753632,
        22.888149565271
    ],
    [
        112.95361865683,
        22.88811602618
    ],
    [
        112.95364808754,
        22.888044174853
    ],
    [
        112.95369114559,
        22.887935467429
    ],
    [
        112.95373882815,
        22.887836172429
    ],
    [
        112.95377751911,
        22.887756564007
    ],
    [
        112.95381728578,
        22.887708129382
    ],
    [
        112.95381129795,
        22.887705250558
    ],
    [
        112.95382055847,
        22.887694510014
    ],
    [
        112.95382028458,
        22.887698312189
    ],
    [
        112.95389051592,
        22.887708203155
    ],
    [
        112.95402824,
        22.887766547587
    ],
    [
        112.95416787106,
        22.887823228909
    ],
    [
        112.95422748331,
        22.887839270775
    ],
    [
        112.95422884182,
        22.887845485486
    ],
    [
        112.95432409922,
        22.887902943376
    ],
    [
        112.95443433641,
        22.887944947505
    ],
    [
        112.9545279686,
        22.887984530075
    ],
    [
        112.95458240585,
        22.888007984383
    ],
    [
        112.95459792056,
        22.888014492503
    ],
    [
        112.95462214359,
        22.888028713409
    ],
    [
        112.95463167248,
        22.888027189532
    ],
    [
        112.95463521418,
        22.888020888637
    ],
    [
        112.95465264706,
        22.887997526272
    ],
    [
        112.95473216066,
        22.887948388101
    ],
    [
        112.95473270457,
        22.887949734736
    ],
    [
        112.95480652433,
        22.887846719183
    ],
    [
        112.95480761317,
        22.887846971249
    ],
    [
        112.95483268094,
        22.887795536304
    ],
    [
        112.95485093271,
        22.887767819416
    ],
    [
        112.95489559709,
        22.887727160095
    ],
    [
        112.95490297272,
        22.887668984485
    ],
    [
        112.95494300949,
        22.887627864093
    ],
    [
        112.95496590782,
        22.887558565328
    ],
    [
        112.95496538658,
        22.887505953769
    ],
    [
        112.95498311131,
        22.887440001127
    ],
    [
        112.95499185907,
        22.887359288503
    ],
    [
        112.95497691235,
        22.887300964009
    ],
    [
        112.95497501738,
        22.887277399504
    ],
    [
        112.95500689954,
        22.887210654998
    ],
    [
        112.9550156112,
        22.887210501444
    ],
    [
        112.95502650041,
        22.88721112322
    ],
    [
        112.95506488124,
        22.88722129622
    ],
    [
        112.95512122819,
        22.887234949682
    ],
    [
        112.95515171523,
        22.887242820494
    ],
    [
        112.95517376124,
        22.887254366248
    ],
    [
        112.95518328964,
        22.887254198191
    ],
    [
        112.95520914358,
        22.887273271459
    ],
    [
        112.95525895322,
        22.887295176957
    ],
    [
        112.95529079995,
        22.88730654965
    ],
    [
        112.95533353509,
        22.88732044255
    ],
    [
        112.95536919189,
        22.887334731516
    ],
    [
        112.95539042495,
        22.887338154137
    ],
    [
        112.95539886356,
        22.88733990388
    ],
    [
        112.95540566787,
        22.887343581148
    ],
    [
        112.95540376255,
        22.887342801056
    ],
    [
        112.95539422546,
        22.887362227459
    ],
    [
        112.9553868538,
        22.887409553421
    ],
    [
        112.95538275796,
        22.887437021016
    ],
    [
        112.95538112004,
        22.887447085831
    ],
    [
        112.95534951723,
        22.887499179319
    ],
    [
        112.95529448138,
        22.887598339725
    ],
    [
        112.95519204545,
        22.887769672713
    ],
    [
        112.95510921482,
        22.887934692345
    ],
    [
        112.95505936236,
        22.88801314659
    ],
    [
        112.95506072481,
        22.888010138905
    ],
    [
        112.9550394737,
        22.888049843689
    ],
    [
        112.95501059896,
        22.88809212402
    ],
    [
        112.95500869037,
        22.888099209969
    ],
    [
        112.9549743637,
        22.888159217122
    ],
    [
        112.95495881763,
        22.888228929269
    ],
    [
        112.95494273942,
        22.888268814083
    ],
    [
        112.9549301982,
        22.888314061436
    ],
    [
        112.95491249271,
        22.888339056539
    ],
    [
        112.95490323189,
        22.888350883166
    ],
    [
        112.95489805924,
        22.888351245542
    ],
    [
        112.9549535701,
        22.888415094619
    ],
    [
        112.95496880914,
        22.888430829437
    ],
    [
        112.95497969343,
        22.888443928553
    ],
    [
        112.95502188786,
        22.888449965944
    ],
    [
        112.95503685588,
        22.88846272179
    ],
    [
        112.95504855843,
        22.888472009021
    ],
    [
        112.95508339708,
        22.888491738093
    ],
    [
        112.95509591466,
        22.888505350821
    ],
    [
        112.95517920423,
        22.88854429736
    ],
    [
        112.95521676362,
        22.888568589308
    ],
    [
        112.95528644648,
        22.888594755618
    ],
    [
        112.95534360805,
        22.88861680272
    ],
    [
        112.95537382277,
        22.888626576769
    ],
    [
        112.95545302915,
        22.888665865345
    ],
    [
        112.95546010637,
        22.888668452853
    ],
    [
        112.9555229829,
        22.88869636593
    ],
    [
        112.95558150697,
        22.88871567587
    ],
    [
        112.95558504715,
        22.888712900909
    ],
    [
        112.95558804191,
        22.88871257678
    ],
    [
        112.95559892876,
        22.888719708126
    ],
    [
        112.95561988979,
        22.88872340662
    ],
    [
        112.95564629815,
        22.888720499021
    ],
    [
        112.95566318034,
        22.888711792271
    ],
    [
        112.95565528575,
        22.888710846728
    ],
    [
        112.95565937124,
        22.88870589217
    ],
    [
        112.95567544192,
        22.888683637527
    ],
    [
        112.95570650027,
        22.88862395768
    ],
    [
        112.95574574005,
        22.888528329107
    ],
    [
        112.95577217172,
        22.888466289823
    ],
    [
        112.9557994119,
        22.888425393272
    ],
    [
        112.95580922329,
        22.888398366818
    ],
    [
        112.9558206726,
        22.888360190449
    ],
    [
        112.95582284837,
        22.888365576876
    ],
    [
        112.95582747572,
        22.888367393824
    ],
    [
        112.95584897719,
        22.888381118587
    ],
    [
        112.95589089682,
        22.888394482554
    ],
    [
        112.95597936274,
        22.888424925995
    ],
    [
        112.95607027775,
        22.88845830965
    ],
    [
        112.95616908096,
        22.888509184571
    ],
    [
        112.95623250384,
        22.888532475424
    ],
    [
        112.95629456186,
        22.888565283902
    ],
    [
        112.95631987175,
        22.888587078494
    ],
    [
        112.95632584783,
        22.888621149614
    ],
    [
        112.9563157525,
        22.888679374358
    ],
    [
        112.95631056629,
        22.88871499906
    ],
    [
        112.95632798545,
        22.888726083396
    ],
    [
        112.95646109702,
        22.888763060672
    ],
    [
        112.95658657974,
        22.888816447493
    ],
    [
        112.95664863908,
        22.888847086047
    ],
    [
        112.95670743398,
        22.888871272468
    ],
    [
        112.95679780316,
        22.888910633025
    ],
    [
        112.95684679941,
        22.888929567867
    ],
    [
        112.9569050474,
        22.888960545271
    ],
    [
        112.95695758024,
        22.888986470098
    ],
    [
        112.95701038575,
        22.889011305194
    ],
    [
        112.95702753312,
        22.889021580741
    ],
    [
        112.95709067654,
        22.889066305442
    ],
    [
        112.95708604497,
        22.889075880877
    ],
    [
        112.95702938342,
        22.889174530605
    ],
    [
        112.95696672114,
        22.889306921108
    ],
    [
        112.95692857879,
        22.889388969144
    ],
    [
        112.95686102624,
        22.889495949323
    ],
    [
        112.95686619735,
        22.889500197873
    ],
    [
        112.95680001299,
        22.889588166771
    ],
    [
        112.95674989844,
        22.889654423211
    ],
    [
        112.95669896486,
        22.889728289139
    ],
    [
        112.95665729151,
        22.889790599046
    ],
    [
        112.95665048492,
        22.889792346859
    ],
    [
        112.95663195845,
        22.889835531525
    ],
    [
        112.95660254571,
        22.88986860124
    ],
    [
        112.95656032692,
        22.889935260883
    ],
    [
        112.95651702687,
        22.88997834109
    ],
    [
        112.9564876141,
        22.890012224614
    ],
    [
        112.95644920964,
        22.890070950729
    ],
    [
        112.95640126662,
        22.890162937862
    ],
    [
        112.95635387437,
        22.890235656655
    ],
    [
        112.95631437677,
        22.890310405927
    ],
    [
        112.95628549159,
        22.890402870118
    ],
    [
        112.95623646797,
        22.89047154915
    ],
    [
        112.95622202764,
        22.890511135643
    ],
    [
        112.95622175571,
        22.89051005545
    ],
    [
        112.95620378078,
        22.890534243185
    ],
    [
        112.95616946805,
        22.890570112217
    ],
    [
        112.95621492668,
        22.89058965243
    ],
    [
        112.95623779201,
        22.890599826999
    ],
    [
        112.9562345244,
        22.890602326012
    ],
    [
        112.95640302334,
        22.890666617397
    ],
    [
        112.95722808718,
        22.89102744609
    ],
    [
        112.95726755924,
        22.891038141396
    ],
    [
        112.95727490841,
        22.891043165362
    ],
    [
        112.95729831679,
        22.891059569497
    ],
    [
        112.95736012437,
        22.891025113927
    ],
    [
        112.95740098108,
        22.890947085753
    ],
    [
        112.95740806991,
        22.890907629139
    ],
    [
        112.95751455802,
        22.890752763449
    ],
    [
        112.9576022582,
        22.890613691425
    ],
    [
        112.95763547636,
        22.890596287676
    ],
    [
        112.95767305185,
        22.890573653351
    ],
    [
        112.95769241554,
        22.890453690432
    ],
    [
        112.95775424986,
        22.890331622208
    ],
    [
        112.95761733734,
        22.890252663108
    ],
    [
        112.95760944367,
        22.890248462429
    ],
    [
        112.95748069719,
        22.890173700289
    ],
    [
        112.95732555697,
        22.890056005363
    ],
    [
        112.95726296905,
        22.889969497598
    ],
    [
        112.95724638484,
        22.889899266012
    ],
    [
        112.95721672343,
        22.889859645278
    ],
    [
        112.95716582556,
        22.889825553491
    ],
    [
        112.95715521963,
        22.889790478656
    ],
    [
        112.95715576846,
        22.889777177819
    ],
    [
        112.95714379667,
        22.889756503264
    ],
    [
        112.95714543584,
        22.889739114453
    ],
    [
        112.95714244816,
        22.889718009928
    ],
    [
        112.95714572414,
        22.889690556049
    ],
    [
        112.95714572531,
        22.889687029811
    ],
    [
        112.95714599963,
        22.889680786273
    ],
    [
        112.95716315728,
        22.889661224567
    ],
    [
        112.95718385518,
        22.88963834536
    ],
    [
        112.95725952859,
        22.889666303256
    ],
    [
        112.95735997059,
        22.889710098789
    ],
    [
        112.95745578504,
        22.889752348985
    ],
    [
        112.95750778034,
        22.889759839693
    ],
    [
        112.95752574211,
        22.889778238704
    ],
    [
        112.95755214187,
        22.889801100004
    ],
    [
        112.95757255349,
        22.889820540814
    ],
    [
        112.95757718247,
        22.889817746633
    ],
    [
        112.95757854341,
        22.889818536356
    ],
    [
        112.95758071992,
        22.889822837907
    ],
    [
        112.95772117053,
        22.889899563923
    ],
    [
        112.95803664271,
        22.890064074268
    ],
    [
        112.95807338134,
        22.890107369238
    ],
    [
        112.95814278671,
        22.890156598908
    ],
    [
        112.95820430475,
        22.890181284201
    ],
    [
        112.95827643766,
        22.89021364919
    ],
    [
        112.95835102075,
        22.890245700276
    ],
    [
        112.95841798108,
        22.890278157197
    ],
    [
        112.95846425216,
        22.890308265851
    ],
    [
        112.9584923039,
        22.890270068935
    ],
    [
        112.95855985187,
        22.890159568097
    ],
    [
        112.95863855376,
        22.890075454261
    ],
    [
        112.95871071649,
        22.890009629617
    ],
    [
        112.95874229977,
        22.889996597629
    ],
    [
        112.958818512,
        22.890038930919
    ],
    [
        112.95894344512,
        22.89010970533
    ],
    [
        112.95912362949,
        22.890219116246
    ],
    [
        112.95917915193,
        22.890261544003
    ],
    [
        112.95920908923,
        22.89028868744
    ],
    [
        112.95922596513,
        22.890296800841
    ],
    [
        112.9592458364,
        22.890302149376
    ],
    [
        112.95925510001,
        22.890276218605
    ],
    [
        112.95928179691,
        22.890215534238
    ],
    [
        112.95931121306,
        22.890165381166
    ],
    [
        112.95935615221,
        22.89009651193
    ],
    [
        112.95940899397,
        22.890002821303
    ],
    [
        112.95946074405,
        22.889918915169
    ],
    [
        112.95951167397,
        22.889846687479
    ],
    [
        112.95952475485,
        22.889803601913
    ],
    [
        112.95953945993,
        22.889788969068
    ],
    [
        112.95954735645,
        22.889783135026
    ],
    [
        112.9595601562,
        22.889767721742
    ],
    [
        112.95959772771,
        22.889755402463
    ],
    [
        112.95966087371,
        22.88978874952
    ],
    [
        112.95967121665,
        22.88979399413
    ],
    [
        112.96015949163,
        22.890101775195
    ],
    [
        112.96023597249,
        22.890146560613
    ],
    [
        112.96025692999,
        22.890158403399
    ],
    [
        112.96032878966,
        22.890181027813
    ],
    [
        112.96072016356,
        22.890442798445
    ],
    [
        112.9610208115,
        22.890036443499
    ],
    [
        112.96104398307,
        22.889929715823
    ],
    [
        112.96105215681,
        22.889906519264
    ],
    [
        112.96107585459,
        22.88985864371
    ],
    [
        112.96107231459,
        22.88986250199
    ],
    [
        112.96108130166,
        22.88984987021
    ],
    [
        112.96108592965,
        22.889848705733
    ],
    [
        112.96108920178,
        22.889831289655
    ],
    [
        112.96109519311,
        22.889823049323
    ],
    [
        112.96111289166,
        22.889808369288
    ],
    [
        112.96111071429,
        22.889807321678
    ],
    [
        112.96114067088,
        22.889766391508
    ],
    [
        112.9611461163,
        22.889762771833
    ],
    [
        112.96114530292,
        22.889752749618
    ],
    [
        112.96114856886,
        22.889754592308
    ],
    [
        112.96114965842,
        22.889752403627
    ],
    [
        112.9611978561,
        22.889702752199
    ],
    [
        112.9612318852,
        22.889694573816
    ],
    [
        112.96133341912,
        22.889696360745
    ],
    [
        112.96134757136,
        22.889704527184
    ],
    [
        112.96134865994,
        22.889705322296
    ],
    [
        112.96139710471,
        22.889731346969
    ],
    [
        112.96144337217,
        22.889756053173
    ],
    [
        112.96148609953,
        22.889784889082
    ],
    [
        112.96150460652,
        22.889794609148
    ],
    [
        112.96154161865,
        22.88981974577
    ],
    [
        112.9615571288,
        22.889837383426
    ],
    [
        112.96156093989,
        22.889836775892
    ],
    [
        112.96167905419,
        22.889909626497
    ],
    [
        112.96170790278,
        22.889925952531
    ],
    [
        112.96172615124,
        22.88989200701
    ],
    [
        112.96181438965,
        22.889753796669
    ],
    [
        112.9619494745,
        22.889533961584
    ],
    [
        112.96195219835,
        22.88952849042
    ],
    [
        112.9619946851,
        22.889459144223
    ],
    [
        112.96205105585,
        22.889384952107
    ],
    [
        112.96205323263,
        22.889387356452
    ],
    [
        112.962065759,
        22.889372225685
    ],
    [
        112.96208073277,
        22.889364105935
    ],
    [
        112.96217598187,
        22.889424067261
    ],
    [
        112.96224537959,
        22.889461411591
    ],
    [
        112.96232675099,
        22.889506963929
    ],
    [
        112.96240676033,
        22.889554982289
    ],
    [
        112.96241683032,
        22.889558610137
    ],
    [
        112.96246255189,
        22.88957981142
    ],
    [
        112.96248486245,
        22.889607917008
    ],
    [
        112.96250363629,
        22.889630657271
    ],
    [
        112.96250853767,
        22.889624878643
    ],
    [
        112.96252622103,
        22.889652791076
    ],
    [
        112.96252266971,
        22.889691910461
    ],
    [
        112.96251858441,
        22.889699302839
    ],
    [
        112.96253790332,
        22.889720135408
    ],
    [
        112.9625417121,
        22.889726038847
    ],
    [
        112.96255314231,
        22.889731814214
    ],
    [
        112.96255858223,
        22.889743928966
    ],
    [
        112.96256375365,
        22.889744655823
    ],
    [
        112.96259777188,
        22.889762529328
    ],
    [
        112.96259395995,
        22.889766390808
    ],
    [
        112.96264838735,
        22.889800197054
    ],
    [
        112.96277031316,
        22.889848063453
    ],
    [
        112.9628769854,
        22.889928738939
    ],
    [
        112.96293820749,
        22.889992545005
    ],
    [
        112.96299507725,
        22.890047744854
    ],
    [
        112.96305957214,
        22.890089798782
    ],
    [
        112.9631020396,
        22.89006766318
    ],
    [
        112.96313988928,
        22.890014953797
    ],
    [
        112.96316685404,
        22.889954830812
    ],
    [
        112.96320253342,
        22.88987991593
    ],
    [
        112.96323358382,
        22.889811588299
    ],
    [
        112.96324610612,
        22.889805413012
    ],
    [
        112.96333374105,
        22.889827558584
    ],
    [
        112.96334163481,
        22.889825800332
    ],
    [
        112.96346328426,
        22.889870442461
    ],
    [
        112.96362929061,
        22.889936329739
    ],
    [
        112.96381761244,
        22.890005115102
    ],
    [
        112.96398987329,
        22.890076887676
    ],
    [
        112.96402144042,
        22.890090748067
    ],
    [
        112.96415424172,
        22.890141475531
    ],
    [
        112.96432350475,
        22.89021467368
    ],
    [
        112.96445330954,
        22.890266006721
    ],
    [
        112.96460270728,
        22.890321098847
    ],
    [
        112.96475863083,
        22.890391013373
    ],
    [
        112.96484598344,
        22.890418092982
    ],
    [
        112.96484843023,
        22.890427005022
    ],
    [
        112.9648802738,
        22.89041971357
    ],
    [
        112.96492165166,
        22.890380533681
    ],
    [
        112.96496331365,
        22.890300119946
    ],
    [
        112.96503330134,
        22.890144932483
    ],
    [
        112.9650992076,
        22.889990083487
    ],
    [
        112.96514142055,
        22.889891490601
    ],
    [
        112.96518551633,
        22.889863935707
    ],
    [
        112.9652663387,
        22.889875401066
    ],
    [
        112.96538470942,
        22.889906618676
    ],
    [
        112.96561028048,
        22.890000169274
    ],
    [
        112.96580809825,
        22.890068677767
    ],
    [
        112.9659610199,
        22.890112404248
    ],
    [
        112.96614359799,
        22.890165175171
    ],
    [
        112.96618522953,
        22.890174295732
    ],
    [
        112.96631692963,
        22.89018989345
    ],
    [
        112.96646060468,
        22.890193380224
    ],
    [
        112.9665310833,
        22.890187146089
    ],
    [
        112.96662387217,
        22.890188168435
    ],
    [
        112.96680482169,
        22.890190295433
    ],
    [
        112.9670660427,
        22.890172511152
    ],
    [
        112.96729650711,
        22.890167425577
    ],
    [
        112.96736752107,
        22.890171790264
    ],
    [
        112.96744152965,
        22.890168789154
    ],
    [
        112.96762192372,
        22.890159874893
    ],
    [
        112.96766881776,
        22.889845075485
    ],
    [
        112.96768818931,
        22.889675530557
    ],
    [
        112.96768874759,
        22.889631851368
    ],
    [
        112.96768576327,
        22.889605584335
    ],
    [
        112.9676808745,
        22.889579074168
    ],
    [
        112.967690155,
        22.889488611726
    ],
    [
        112.96770325876,
        22.889357405939
    ],
    [
        112.96772807979,
        22.889176932097
    ],
    [
        112.96775944294,
        22.888966525559
    ],
    [
        112.96787714778,
        22.88851100327
    ],
    [
        112.96791609124,
        22.888414412296
    ],
    [
        112.9679136431,
        22.888413091907
    ],
    [
        112.9680078607,
        22.888205840764
    ],
    [
        112.96810941969,
        22.888012321377
    ],
    [
        112.96820471964,
        22.8878243233
    ],
    [
        112.9683122659,
        22.887629643839
    ],
    [
        112.96831308071,
        22.887632886991
    ],
    [
        112.96837162254,
        22.887518121588
    ],
    [
        112.96850422105,
        22.887272913623
    ],
    [
        112.968637899,
        22.887049128388
    ],
    [
        112.96883281349,
        22.88676969566
    ],
    [
        112.96884642175,
        22.886756754939
    ],
    [
        112.96885350127,
        22.88674309287
    ],
    [
        112.96886738397,
        22.886724994875
    ],
    [
        112.96892400825,
        22.886641196526
    ],
    [
        112.96897736168,
        22.886570736759
    ],
    [
        112.96902228291,
        22.88649795585
    ],
    [
        112.96914966753,
        22.886349974099
    ],
    [
        112.96921172049,
        22.886289978364
    ],
    [
        112.96929555058,
        22.88619957486
    ],
    [
        112.96929773218,
        22.886188695035
    ],
    [
        112.97004850647,
        22.885129018711
    ],
    [
        112.970241581,
        22.884720937583
    ],
    [
        112.97004822043,
        22.884661413597
    ],
    [
        112.96985104928,
        22.884598437689
    ],
    [
        112.96982902221,
        22.884587887231
    ],
    [
        112.96984210445,
        22.884542684828
    ],
    [
        112.9700442783,
        22.88395219139
    ],
    [
        112.96920254169,
        22.883678926437
    ],
    [
        112.96917969514,
        22.883671921803
    ],
    [
        112.96939742968,
        22.88305483069
    ],
    [
        112.96940533776,
        22.883024343585
    ],
    [
        112.96940887929,
        22.88301615773
    ],
    [
        112.96941189659,
        22.882976787686
    ],
    [
        112.96940322399,
        22.882926187585
    ],
    [
        112.96936271377,
        22.882892030715
    ],
    [
        112.96932491364,
        22.882873568523
    ],
    [
        112.96929581197,
        22.882865021832
    ],
    [
        112.96929608591,
        22.882862034503
    ],
    [
        112.96928901672,
        22.882856436863
    ],
    [
        112.96925855477,
        22.882847909688
    ],
    [
        112.96914432051,
        22.882817497085
    ],
    [
        112.96901839824,
        22.882769897293
    ],
    [
        112.96894496,
        22.882750587948
    ],
    [
        112.96894387446,
        22.882746534799
    ],
    [
        112.96894006795,
        22.882743333667
    ],
    [
        112.96891476964,
        22.882740977942
    ],
    [
        112.96882719239,
        22.882709125084
    ],
    [
        112.96878231545,
        22.882692944449
    ],
    [
        112.96873553288,
        22.882678419361
    ],
    [
        112.9687159592,
        22.88265727033
    ],
    [
        112.96872576394,
        22.882640314819
    ],
    [
        112.96874918353,
        22.88260418005
    ],
    [
        112.96877532731,
        22.882562311161
    ],
    [
        112.96878050829,
        22.882543794151
    ],
    [
        112.96882660163,
        22.882364944166
    ],
    [
        112.96874011637,
        22.882326841947
    ],
    [
        112.96855816447,
        22.88225267685
    ],
    [
        112.96882094128,
        22.881881696421
    ],
    [
        112.96890480573,
        22.881771749308
    ],
    [
        112.96889800852,
        22.881766149447
    ],
    [
        112.96893067636,
        22.881732870307
    ],
    [
        112.96894293118,
        22.88171398299
    ],
    [
        112.96894947853,
        22.881687310551
    ],
    [
        112.96893044765,
        22.88166994892
    ],
    [
        112.96892610337,
        22.881657804949
    ],
    [
        112.968882598,
        22.881626956424
    ],
    [
        112.96886709666,
        22.881619581023
    ],
    [
        112.96883200853,
        22.881611669082
    ],
    [
        112.96883201041,
        22.88160895679
    ],
    [
        112.96880915432,
        22.881615247283
    ],
    [
        112.96878603214,
        22.881612862587
    ],
    [
        112.96878087225,
        22.881599916854
    ],
    [
        112.96879502607,
        22.881589138429
    ],
    [
        112.96881762709,
        22.881558440989
    ],
    [
        112.96883969305,
        22.881514732541
    ],
    [
        112.96884814557,
        22.881487219155
    ],
    [
        112.96885005008,
        22.881486921002
    ],
    [
        112.96886774782,
        22.881465515233
    ],
    [
        112.96886449199,
        22.881453084829
    ],
    [
        112.96888382181,
        22.881431927389
    ],
    [
        112.96890779859,
        22.881378971155
    ],
    [
        112.96892116114,
        22.881332674298
    ],
    [
        112.96893587594,
        22.881297749989
    ],
    [
        112.96892989652,
        22.881289968702
    ],
    [
        112.96892582103,
        22.881282703048
    ],
    [
        112.96892282548,
        22.881287084889
    ],
    [
        112.96892174917,
        22.881270284064
    ],
    [
        112.96887986254,
        22.881259212371
    ],
    [
        112.96883471729,
        22.881239508527
    ],
    [
        112.96882411168,
        22.881233691626
    ],
    [
        112.96881486247,
        22.881233280097
    ],
    [
        112.96876210012,
        22.881212872248
    ],
    [
        112.96872946765,
        22.881194349693
    ],
    [
        112.96872675715,
        22.881180284467
    ],
    [
        112.96872214674,
        22.881160008055
    ],
    [
        112.96873358459,
        22.881143300821
    ],
    [
        112.96873987087,
        22.881102256515
    ],
    [
        112.96876031538,
        22.881044737802
    ],
    [
        112.96877860031,
        22.880963924605
    ],
    [
        112.96880367473,
        22.880899560185
    ],
    [
        112.96881158834,
        22.88086581623
    ],
    [
        112.96881295406,
        22.880858202597
    ],
    [
        112.96881269141,
        22.880845187525
    ],
    [
        112.96880643843,
        22.880839580351
    ],
    [
        112.9688010014,
        22.880834232864
    ],
    [
        112.9687947443,
        22.880834321509
    ],
    [
        112.96879039389,
        22.880831128457
    ],
    [
        112.96875422517,
        22.880812655639
    ],
    [
        112.96871750102,
        22.880809651244
    ],
    [
        112.9687011884,
        22.880795508232
    ],
    [
        112.96869765842,
        22.880786336794
    ],
    [
        112.96869576173,
        22.880775786009
    ],
    [
        112.96870693764,
        22.880745521156
    ],
    [
        112.96870886347,
        22.880715930304
    ],
    [
        112.96872194715,
        22.880681027622
    ],
    [
        112.96872932929,
        22.880630475014
    ],
    [
        112.96881202627,
        22.880268031935
    ],
    [
        112.9688311304,
        22.880186123277
    ],
    [
        112.9688417465,
        22.880177565178
    ],
    [
        112.96883930679,
        22.880165937082
    ],
    [
        112.96886796048,
        22.880047007487
    ],
    [
        112.96892713736,
        22.879856587592
    ],
    [
        112.96892769771,
        22.879835153105
    ],
    [
        112.96892852745,
        22.879817240718
    ],
    [
        112.9689383173,
        22.879821984763
    ],
    [
        112.96893886737,
        22.879814111558
    ],
    [
        112.96893805165,
        22.879813580606
    ],
    [
        112.96896398672,
        22.879693877497
    ],
    [
        112.96897521112,
        22.879601503988
    ],
    [
        112.9689738609,
        22.879588504323
    ],
    [
        112.96896842131,
        22.879586953533
    ],
    [
        112.96896108366,
        22.879577292815
    ],
    [
        112.96893850784,
        22.87957272876
    ],
    [
        112.96894503938,
        22.87956938208
    ],
    [
        112.96893279931,
        22.879567113537
    ],
    [
        112.9689105011,
        22.879555222927
    ],
    [
        112.96885419277,
        22.87954950872
    ],
    [
        112.96876144069,
        22.87952993819
    ],
    [
        112.96870323648,
        22.879512050589
    ],
    [
        112.96864856921,
        22.87949330078
    ],
    [
        112.96857431142,
        22.879477815889
    ],
    [
        112.96848047772,
        22.879446070098
    ],
    [
        112.96847041223,
        22.879445400807
    ],
    [
        112.96841166524,
        22.879423461907
    ],
    [
        112.9683431239,
        22.879401394797
    ],
    [
        112.96829769459,
        22.879395540868
    ],
    [
        112.96826832082,
        22.879384302688
    ],
    [
        112.96826831851,
        22.879387286159
    ],
    [
        112.96826695861,
        22.879386763373
    ],
    [
        112.96824628112,
        22.879387876045
    ],
    [
        112.96817228252,
        22.879384879633
    ],
    [
        112.96813747186,
        22.879367484263
    ],
    [
        112.96812469649,
        22.879352481444
    ],
    [
        112.96811574187,
        22.879322234773
    ],
    [
        112.96811520259,
        22.879316004519
    ],
    [
        112.96811575327,
        22.879307588651
    ],
    [
        112.96811766683,
        22.879295898319
    ],
    [
        112.96812504291,
        22.879257006479
    ],
    [
        112.96814520047,
        22.879225252029
    ],
    [
        112.96814358207,
        22.879207374928
    ],
    [
        112.96816293705,
        22.879158274179
    ],
    [
        112.96816650157,
        22.879122963722
    ],
    [
        112.96817522367,
        22.879102495624
    ],
    [
        112.96819022251,
        22.879057526689
    ],
    [
        112.96819978136,
        22.879011009384
    ],
    [
        112.96820607249,
        22.878968336571
    ],
    [
        112.96820800613,
        22.878931422545
    ],
    [
        112.96821348418,
        22.878884964472
    ],
    [
        112.9682328484,
        22.878824744378
    ],
    [
        112.96826094276,
        22.87873429281
    ],
    [
        112.96828199803,
        22.878601090633
    ],
    [
        112.96831336684,
        22.878499201452
    ],
    [
        112.9683172219,
        22.878441918456
    ],
    [
        112.96831017021,
        22.878414898249
    ],
    [
        112.96829332318,
        22.878389375604
    ],
    [
        112.9682582402,
        22.878373609406
    ],
    [
        112.96822124758,
        22.878364109562
    ],
    [
        112.96818508069,
        22.878342664812
    ],
    [
        112.96815545607,
        22.878305395062
    ],
    [
        112.96813943455,
        22.878268199399
    ],
    [
        112.96813048261,
        22.87823605433
    ],
    [
        112.96813567599,
        22.878206415992
    ],
    [
        112.96814632915,
        22.878154187205
    ],
    [
        112.96816952167,
        22.878072213674
    ],
    [
        112.96817720525,
        22.877992092648
    ],
    [
        112.96819794819,
        22.877911782394
    ],
    [
        112.96820968756,
        22.87786252173
    ],
    [
        112.96822984011,
        22.877838362674
    ],
    [
        112.96824454214,
        22.877825402643
    ],
    [
        112.96828507266,
        22.877833224474
    ],
    [
        112.96839197666,
        22.877851210913
    ],
    [
        112.96849806213,
        22.877870571304
    ],
    [
        112.96855790501,
        22.877881105791
    ],
    [
        112.96858455986,
        22.877888590173
    ],
    [
        112.96858727748,
        22.877892077196
    ],
    [
        112.96859298144,
        22.877903115699
    ],
    [
        112.96858834667,
        22.877915115515
    ],
    [
        112.96863322317,
        22.877929392123
    ],
    [
        112.96870340109,
        22.877942224988
    ],
    [
        112.96870748095,
        22.877943251851
    ],
    [
        112.96871646487,
        22.877935530013
    ],
    [
        112.96872463577,
        22.877924022709
    ],
    [
        112.96874014595,
        22.877919734116
    ],
    [
        112.96876788847,
        22.877927205726
    ],
    [
        112.96880569845,
        22.877932365387
    ],
    [
        112.96888267748,
        22.877943481542
    ],
    [
        112.96893408492,
        22.877953605087
    ],
    [
        112.96895557566,
        22.877954116007
    ],
    [
        112.96899391911,
        22.877971205738
    ],
    [
        112.9689955556,
        22.877966029572
    ],
    [
        112.96900752453,
        22.877966946222
    ],
    [
        112.96905349693,
        22.877969284228
    ],
    [
        112.96909183929,
        22.877987189738
    ],
    [
        112.96910082146,
        22.877981097153
    ],
    [
        112.96910272239,
        22.877985138826
    ],
    [
        112.96912639125,
        22.877982909127
    ],
    [
        112.96912911051,
        22.877984227195
    ],
    [
        112.96914651843,
        22.877986967266
    ],
    [
        112.9691742617,
        22.877992004189
    ],
    [
        112.96926648322,
        22.877988549628
    ],
    [
        112.96939730901,
        22.878012501117
    ],
    [
        112.96954689762,
        22.878042171282
    ],
    [
        112.96959095854,
        22.87804997405
    ],
    [
        112.96961925064,
        22.878047416398
    ],
    [
        112.96962170552,
        22.878039246189
    ],
    [
        112.96964237693,
        22.878041675289
    ],
    [
        112.96966061768,
        22.878022711573
    ],
    [
        112.96968215454,
        22.877964918686
    ],
    [
        112.96977072924,
        22.877759482793
    ],
    [
        112.96978494101,
        22.877678737467
    ],
    [
        112.96981438246,
        22.877601853567
    ],
    [
        112.96982637966,
        22.877567517084
    ],
    [
        112.96985712276,
        22.877560590603
    ],
    [
        112.97001054439,
        22.877550108997
    ],
    [
        112.97006710964,
        22.877564264937
    ],
    [
        112.97012259147,
        22.877572470517
    ],
    [
        112.97013564365,
        22.877577177542
    ],
    [
        112.9701525204,
        22.877562034529
    ],
    [
        112.97024489285,
        22.877365794711
    ],
    [
        112.97031497923,
        22.877148972529
    ],
    [
        112.97032562493,
        22.877104351419
    ],
    [
        112.97031558055,
        22.877081431367
    ],
    [
        112.97028515328,
        22.877038712387
    ],
    [
        112.97019355301,
        22.876964535381
    ],
    [
        112.96975194529,
        22.8768102052
    ],
    [
        112.96946585083,
        22.876729236338
    ],
    [
        112.96944898398,
        22.876730825129
    ],
    [
        112.96936059167,
        22.876712248511
    ],
    [
        112.96930646988,
        22.876698624583
    ],
    [
        112.96928552152,
        22.876701085275
    ],
    [
        112.96926402228,
        22.876711419164
    ],
    [
        112.96923900103,
        22.87670498691
    ],
    [
        112.96921480633,
        22.876686338745
    ],
    [
        112.9691900785,
        22.876654951171
    ],
    [
        112.96918955152,
        22.876635159714
    ],
    [
        112.96918359227,
        22.876605680254
    ],
    [
        112.96919476121,
        22.876587624157
    ],
    [
        112.96920593695,
        22.876561702762
    ],
    [
        112.96921492091,
        22.876553712267
    ],
    [
        112.96924241565,
        22.876531089582
    ],
    [
        112.96929354941,
        22.876540142336
    ],
    [
        112.96934849953,
        22.876539651111
    ],
    [
        112.96940125451,
        22.87656061807
    ],
    [
        112.9694289939,
        22.876568913606
    ],
    [
        112.96947495549,
        22.876581026513
    ],
    [
        112.96953287373,
        22.876607079418
    ],
    [
        112.96968331361,
        22.875968744124
    ],
    [
        112.96969698454,
        22.875889362437
    ],
    [
        112.96971687961,
        22.875846510014
    ],
    [
        112.9697372882,
        22.875838095174
    ],
    [
        112.96973891958,
        22.875838886578
    ],
    [
        112.96975181005,
        22.875719647396
    ],
    [
        112.96975756753,
        22.87566885173
    ],
    [
        112.96976001689,
        22.87566746229
    ],
    [
        112.96980964559,
        22.875530365891
    ],
    [
        112.96984886283,
        22.875477217632
    ],
    [
        112.96985076548,
        22.875478819105
    ],
    [
        112.96984641543,
        22.875476437198
    ],
    [
        112.96985022655,
        22.875473130907
    ],
    [
        112.96991092053,
        22.875433253579
    ],
    [
        112.9699802963,
        22.875417941836
    ],
    [
        112.97000097756,
        22.875408170443
    ],
    [
        112.97015300514,
        22.875433249749
    ],
    [
        112.97033466516,
        22.875472052462
    ],
    [
        112.97036620745,
        22.875482211354
    ],
    [
        112.97036975045,
        22.875474299154
    ],
    [
        112.9704078732,
        22.875425518012
    ],
    [
        112.97043130714,
        22.875378016721
    ],
    [
        112.97048006185,
        22.875301975322
    ],
    [
        112.97048688462,
        22.875276391182
    ],
    [
        112.97048715125,
        22.875282354388
    ],
    [
        112.97051820628,
        22.875228787203
    ],
    [
        112.97054983783,
        22.875139141528
    ],
    [
        112.97055859255,
        22.875082613881
    ],
    [
        112.97057959797,
        22.875013720796
    ],
    [
        112.97088120758,
        22.875033656676
    ],
    [
        112.97088800584,
        22.875034924799
    ],
    [
        112.97098781355,
        22.875042587023
    ],
    [
        112.97099026895,
        22.875034147775
    ],
    [
        112.9710069542,
        22.874929515635
    ],
    [
        112.9711885897,
        22.874973296751
    ],
    [
        112.97133594921,
        22.875022414042
    ],
    [
        112.97148196431,
        22.875051492365
    ],
    [
        112.97153499038,
        22.875057065474
    ],
    [
        112.97161069424,
        22.874945464032
    ],
    [
        112.97162322529,
        22.87492198338
    ],
    [
        112.97180759691,
        22.874633023445
    ],
    [
        112.97180487993,
        22.874630344841
    ],
    [
        112.97179321975,
        22.874593874943
    ],
    [
        112.97176522902,
        22.874572523817
    ],
    [
        112.97172040147,
        22.87452507415
    ],
    [
        112.97172040098,
        22.874525616583
    ],
    [
        112.97163965011,
        22.874506278954
    ],
    [
        112.97159996259,
        22.874487517502
    ],
    [
        112.97155509873,
        22.874478585509
    ],
    [
        112.97152492903,
        22.874459978204
    ],
    [
        112.97148578585,
        22.874440128044
    ],
    [
        112.97148714664,
        22.874439026108
    ],
    [
        112.97146268084,
        22.874427942426
    ],
    [
        112.97146240788,
        22.874429030711
    ],
    [
        112.97146050391,
        22.874429325854
    ],
    [
        112.97145778832,
        22.874425020573
    ],
    [
        112.97144990024,
        22.874426475822
    ],
    [
        112.97143033461,
        22.874409906767
    ],
    [
        112.97140395891,
        22.874405357187
    ],
    [
        112.97139444525,
        22.874400052875
    ],
    [
        112.97138928298,
        22.87439469372
    ],
    [
        112.97127645,
        22.874361405938
    ],
    [
        112.97124301089,
        22.874347998693
    ],
    [
        112.9712052219,
        22.874332749059
    ],
    [
        112.97111224272,
        22.874296508364
    ],
    [
        112.9710013121,
        22.874260504007
    ],
    [
        112.97090425614,
        22.874218632584
    ],
    [
        112.97092769804,
        22.874162459866
    ],
    [
        112.97092443229,
        22.874164671735
    ],
    [
        112.97092743033,
        22.874157852699
    ],
    [
        112.97093995188,
        22.874146300141
    ],
    [
        112.97095848307,
        22.874106464044
    ],
    [
        112.97095903332,
        22.874099676626
    ],
    [
        112.97098601795,
        22.874035865173
    ],
    [
        112.97107420053,
        22.873967200404
    ],
    [
        112.97108128496,
        22.873953006546
    ],
    [
        112.97118825953,
        22.873855087754
    ],
    [
        112.97131402608,
        22.873727376036
    ],
    [
        112.97137579836,
        22.873687540349
    ],
    [
        112.97141441868,
        22.87368515478
    ],
    [
        112.97142230809,
        22.873682343272
    ],
    [
        112.97148454768,
        22.873723327394
    ],
    [
        112.97160847773,
        22.873809378274
    ],
    [
        112.97174001695,
        22.873899141959
    ],
    [
        112.97184765471,
        22.873955038426
    ],
    [
        112.97189062269,
        22.873953696219
    ],
    [
        112.9719365972,
        22.873935774393
    ],
    [
        112.97193904493,
        22.873935473181
    ],
    [
        112.97196625119,
        22.873922121791
    ],
    [
        112.97198066683,
        22.873918962115
    ],
    [
        112.97198855739,
        22.873914255035
    ],
    [
        112.97200922304,
        22.873915901092
    ],
    [
        112.97201764607,
        22.873923392248
    ],
    [
        112.972051095,
        22.873922442031
    ],
    [
        112.97210057133,
        22.873939197848
    ],
    [
        112.97212367701,
        22.873948409815
    ],
    [
        112.97214244227,
        22.87394628379
    ],
    [
        112.9721440716,
        22.873948704962
    ],
    [
        112.97217207472,
        22.873954875
    ],
    [
        112.97217724145,
        22.873954812496
    ],
    [
        112.97219574273,
        22.873944011519
    ],
    [
        112.97219383339,
        22.873950272491
    ],
    [
        112.97221154941,
        22.873906664426
    ],
    [
        112.97221540123,
        22.873858613236
    ],
    [
        112.97221546253,
        22.873792978978
    ],
    [
        112.97224434405,
        22.873731878991
    ],
    [
        112.97224625036,
        22.87372887268
    ],
    [
        112.97225932536,
        22.873704848472
    ],
    [
        112.97231490137,
        22.873594881651
    ],
    [
        112.97231545312,
        22.873586467438
    ],
    [
        112.97234349605,
        22.873549517421
    ],
    [
        112.97237041701,
        22.873548923849
    ],
    [
        112.9723753104,
        22.87355022137
    ],
    [
        112.97252480329,
        22.873617328786
    ],
    [
        112.97264247835,
        22.873685639609
    ],
    [
        112.97269411596,
        22.873712967211
    ],
    [
        112.97271366706,
        22.873741215097
    ],
    [
        112.97271612037,
        22.873734677214
    ],
    [
        112.97270846926,
        22.873774906475
    ],
    [
        112.9727035657,
        22.873784727684
    ],
    [
        112.97270519845,
        22.873783352457
    ],
    [
        112.9727002698,
        22.873820024054
    ],
    [
        112.97269588551,
        22.873856146856
    ],
    [
        112.97269424416,
        22.873866743438
    ],
    [
        112.97268416008,
        22.873891813492
    ],
    [
        112.97268470998,
        22.873885297917
    ],
    [
        112.97270454298,
        22.873902965083
    ],
    [
        112.97271106915,
        22.873902617294
    ],
    [
        112.97273634412,
        22.873916152868
    ],
    [
        112.97275835026,
        22.873935965026
    ],
    [
        112.97278036291,
        22.873948725903
    ],
    [
        112.97280264514,
        22.873963924891
    ],
    [
        112.97281677684,
        22.873971896466
    ],
    [
        112.97281569375,
        22.873967027256
    ],
    [
        112.9728249278,
        22.873978581793
    ],
    [
        112.97282764714,
        22.873978278895
    ],
    [
        112.972829551,
        22.873977714288
    ],
    [
        112.9728556302,
        22.874003175973
    ],
    [
        112.97288279619,
        22.874029439155
    ],
    [
        112.97290344794,
        22.87404330258
    ],
    [
        112.97292708103,
        22.874067437878
    ],
    [
        112.972950208,
        22.874050897421
    ],
    [
        112.97298069518,
        22.874013931357
    ],
    [
        112.97297933541,
        22.874014218268
    ],
    [
        112.9730275044,
        22.873968099143
    ],
    [
        112.97304387273,
        22.873909599981
    ],
    [
        112.97305122515,
        22.87389758207
    ],
    [
        112.97306239453,
        22.873874400609
    ],
    [
        112.97307274947,
        22.873849872522
    ],
    [
        112.97309646848,
        22.873781254748
    ],
    [
        112.97316022006,
        22.873644105294
    ],
    [
        112.97317930566,
        22.873587475235
    ],
    [
        112.97323814257,
        22.873472082459
    ],
    [
        112.97328388962,
        22.873398064748
    ],
    [
        112.97330321737,
        22.873372894324
    ],
    [
        112.97331247673,
        22.873356788025
    ],
    [
        112.97349213265,
        22.873419316073
    ],
    [
        112.97349457627,
        22.873422814514
    ],
    [
        112.97352855001,
        22.873434639639
    ],
    [
        112.97355681156,
        22.873449241321
    ],
    [
        112.97358424612,
        22.873475786129
    ],
    [
        112.97359646765,
        22.87348948217
    ],
    [
        112.97359619194,
        22.873493553424
    ],
    [
        112.97359944913,
        22.873499212715
    ],
    [
        112.97359560637,
        22.873538038822
    ],
    [
        112.97352968699,
        22.873671395727
    ],
    [
        112.97352559861,
        22.873682289859
    ],
    [
        112.97350217387,
        22.873728386434
    ],
    [
        112.97341064206,
        22.873920888777
    ],
    [
        112.97339293789,
        22.873954989549
    ],
    [
        112.97338775943,
        22.873968608497
    ],
    [
        112.97336979041,
        22.873995118576
    ],
    [
        112.97334963391,
        22.874034943023
    ],
    [
        112.97334336184,
        22.874055083601
    ],
    [
        112.97332946933,
        22.874083446687
    ],
    [
        112.97331830954,
        22.874096862275
    ],
    [
        112.97331721469,
        22.874104739844
    ],
    [
        112.97329408568,
        22.874124800132
    ],
    [
        112.97328374579,
        22.874133596083
    ],
    [
        112.97327474701,
        22.874162175491
    ],
    [
        112.97326386056,
        22.874173961134
    ],
    [
        112.97326711723,
        22.874180433317
    ],
    [
        112.97326684333,
        22.874182606132
    ],
    [
        112.97324777652,
        22.874219978785
    ],
    [
        112.97322003142,
        22.874233312383
    ],
    [
        112.97322002415,
        22.874241177661
    ],
    [
        112.9732091211,
        22.874270864018
    ],
    [
        112.97319195622,
        22.874309571858
    ],
    [
        112.97317998735,
        22.874315675
    ],
    [
        112.97317835098,
        22.874321117936
    ],
    [
        112.97316636258,
        22.874348376088
    ],
    [
        112.9731560243,
        22.874355274464
    ],
    [
        112.97313668444,
        22.874393736615
    ],
    [
        112.97313203524,
        22.874423080876
    ],
    [
        112.973116248,
        22.874441975288
    ],
    [
        112.97311325363,
        22.874445806567
    ],
    [
        112.97311162125,
        22.874446910115
    ],
    [
        112.97314503516,
        22.874478531096
    ],
    [
        112.97315047184,
        22.874479825044
    ],
    [
        112.9731556274,
        22.874491157139
    ],
    [
        112.97317084558,
        22.874499662262
    ],
    [
        112.97319937063,
        22.874525373617
    ],
    [
        112.97321702954,
        22.874540631791
    ],
    [
        112.97323007196,
        22.874549704738
    ],
    [
        112.97323333467,
        22.874549667651
    ],
    [
        112.97327083664,
        22.874570125385
    ],
    [
        112.97332083764,
        22.874598850413
    ],
    [
        112.97332902015,
        22.874570551675
    ],
    [
        112.9733333838,
        22.87455585682
    ],
    [
        112.97333229475,
        22.874557496406
    ],
    [
        112.97333774994,
        22.874538449811
    ],
    [
        112.97336088309,
        22.874513508306
    ],
    [
        112.97336660468,
        22.874500425531
    ],
    [
        112.97337069196,
        22.874490615763
    ],
    [
        112.9733856739,
        22.87445979984
    ],
    [
        112.97341534442,
        22.874421496175
    ],
    [
        112.97342377587,
        22.874418146891
    ],
    [
        112.97343766772,
        22.874390055913
    ],
    [
        112.97345428315,
        22.874356781483
    ],
    [
        112.97346027684,
        22.874343424835
    ],
    [
        112.97348887062,
        22.874293201405
    ],
    [
        112.97352072993,
        22.874239687554
    ],
    [
        112.9735338186,
        22.874198045836
    ],
    [
        112.97356867552,
        22.874136905693
    ],
    [
        112.97358500764,
        22.874115840614
    ],
    [
        112.97359753241,
        22.874095902864
    ],
    [
        112.97360325771,
        22.874078752837
    ],
    [
        112.97361169751,
        22.87406618334
    ],
    [
        112.97364300017,
        22.874026239181
    ],
    [
        112.97367103492,
        22.873992027333
    ],
    [
        112.97367592842,
        22.873992244464
    ],
    [
        112.97369089416,
        22.873978518501
    ],
    [
        112.97369687717,
        22.873976553971
    ],
    [
        112.97369416171,
        22.873973058165
    ],
    [
        112.97369687642,
        22.873977367619
    ],
    [
        112.97371481885,
        22.873978525805
    ],
    [
        112.97375993715,
        22.873991589908
    ],
    [
        112.97378548475,
        22.874000259429
    ],
    [
        112.9738143005,
        22.874002655725
    ],
    [
        112.97382599064,
        22.874002798979
    ],
    [
        112.97383959192,
        22.873994242609
    ],
    [
        112.97384067611,
        22.873997756531
    ],
    [
        112.97384584288,
        22.873996343996
    ],
    [
        112.9739791617,
        22.87388261131
    ],
    [
        112.97401312532,
        22.873902856107
    ],
    [
        112.97405090315,
        22.873914110596
    ],
    [
        112.97409627464,
        22.873944811884
    ],
    [
        112.97409164648,
        22.873951913168
    ],
    [
        112.97409925902,
        22.873951288943
    ],
    [
        112.97414298143,
        22.874000994452
    ],
    [
        112.97414700562,
        22.874058719839
    ],
    [
        112.97413203664,
        22.874077051507
    ],
    [
        112.97405252406,
        22.874218123521
    ],
    [
        112.97387558436,
        22.874467660015
    ],
    [
        112.97386932866,
        22.874470711605
    ],
    [
        112.97386851505,
        22.874468550769
    ],
    [
        112.97385001507,
        22.874482855868
    ],
    [
        112.97384104017,
        22.874486479722
    ],
    [
        112.9738160561,
        22.874456377062
    ],
    [
        112.97375789042,
        22.874441013494
    ],
    [
        112.97372937297,
        22.874409595182
    ],
    [
        112.97372585184,
        22.87439525962
    ],
    [
        112.9736899702,
        22.874389417363
    ],
    [
        112.97369894581,
        22.874385250094
    ],
    [
        112.97368589557,
        22.874385665358
    ],
    [
        112.97368752907,
        22.874383206395
    ],
    [
        112.9736567994,
        22.874391953672
    ],
    [
        112.97365162875,
        22.874397435166
    ],
    [
        112.9736407497,
        22.874401895035
    ],
    [
        112.97361353128,
        22.874435556069
    ],
    [
        112.97356072722,
        22.87450096307
    ],
    [
        112.97355610252,
        22.874503997918
    ],
    [
        112.97355936881,
        22.874499893337
    ],
    [
        112.9735435771,
        22.874524749726
    ],
    [
        112.97354194681,
        22.874523683041
    ],
    [
        112.97353949765,
        22.874526151268
    ],
    [
        112.9735090069,
        22.874570156981
    ],
    [
        112.97340393461,
        22.874708026519
    ],
    [
        112.97340310657,
        22.874721596546
    ],
    [
        112.9733859604,
        22.874740774468
    ],
    [
        112.97338786386,
        22.874740481827
    ],
    [
        112.97339574362,
        22.87474581744
    ],
    [
        112.9733916673,
        22.874743693592
    ],
    [
        112.973413129,
        22.874762437243
    ],
    [
        112.97344111958,
        22.874777039751
    ],
    [
        112.97348187943,
        22.874801534821
    ],
    [
        112.97353568639,
        22.874829140114
    ],
    [
        112.97357045006,
        22.874869435094
    ],
    [
        112.97361500194,
        22.874908808689
    ],
    [
        112.97366335541,
        22.874953023541
    ],
    [
        112.97370574702,
        22.874975608645
    ],
    [
        112.97375411072,
        22.875007893119
    ],
    [
        112.97376578845,
        22.875021867964
    ],
    [
        112.97378697184,
        22.875046587199
    ],
    [
        112.97382229879,
        22.875064100322
    ],
    [
        112.97383479056,
        22.875079694137
    ],
    [
        112.97386440413,
        22.875101610268
    ],
    [
        112.97389754768,
        22.875128099252
    ],
    [
        112.97393287385,
        22.875145886447
    ],
    [
        112.97394809216,
        22.875152501588
    ],
    [
        112.97395270529,
        22.87516194406
    ],
    [
        112.97397145095,
        22.87517611522
    ],
    [
        112.97398584846,
        22.875188435192
    ],
    [
        112.97398965185,
        22.875191377394
    ],
    [
        112.97403993725,
        22.875200869101
    ],
    [
        112.9740962122,
        22.875200263337
    ],
    [
        112.9741236657,
        22.875204579317
    ],
    [
        112.97416879485,
        22.875203011259
    ],
    [
        112.97416988496,
        22.875200016239
    ],
    [
        112.97421289495,
        22.875136364037
    ],
    [
        112.97426242456,
        22.875077797038
    ],
    [
        112.97429235294,
        22.875050086772
    ],
    [
        112.97433127163,
        22.87500085613
    ],
    [
        112.97434596399,
        22.874986868944
    ],
    [
        112.97442651031,
        22.874898147196
    ],
    [
        112.97446378279,
        22.874864939366
    ],
    [
        112.97446950234,
        22.874852946033
    ],
    [
        112.97452636472,
        22.874800278778
    ],
    [
        112.97453425527,
        22.874792331312
    ],
    [
        112.97455927641,
        22.874779052527
    ],
    [
        112.97457205138,
        22.874780547001
    ],
    [
        112.97458808863,
        22.874781736518
    ],
    [
        112.97461198864,
        22.874805355548
    ],
    [
        112.97463208878,
        22.874822505167
    ],
    [
        112.97486418403,
        22.875174601998
    ],
    [
        112.97492852983,
        22.875259381883
    ],
    [
        112.97515873679,
        22.875587954759
    ],
    [
        112.97518944453,
        22.875595786128
    ],
    [
        112.97527777625,
        22.875602777758
    ],
    [
        112.97528810839,
        22.875598878937
    ],
    [
        112.97543179673,
        22.8754016539
    ],
    [
        112.97551397162,
        22.875299421623
    ],
    [
        112.97554252828,
        22.875279346924
    ],
    [
        112.97557243699,
        22.875266853873
    ],
    [
        112.97560915045,
        22.875243176328
    ],
    [
        112.975673865,
        22.875211909277
    ],
    [
        112.97573585004,
        22.875192876115
    ],
    [
        112.97578779005,
        22.875160922614
    ],
    [
        112.97579404386,
        22.875157880086
    ],
    [
        112.97581471483,
        22.875140869409
    ],
    [
        112.97584979062,
        22.87512345217
    ],
    [
        112.9758875821,
        22.87510818013
    ],
    [
        112.97597027013,
        22.875033907512
    ],
    [
        112.97599555861,
        22.875019297685
    ],
    [
        112.97600154829,
        22.875007579744
    ],
    [
        112.97602004639,
        22.874988422879
    ],
    [
        112.97602250417,
        22.874975381743
    ],
    [
        112.97604127228,
        22.874958121191
    ],
    [
        112.97606411083,
        22.874947603657
    ],
    [
        112.97608913088,
        22.874928929951
    ],
    [
        112.97611278557,
        22.874917320905
    ],
    [
        112.97612937531,
        22.87490442116
    ],
    [
        112.9761543833,
        22.874898767181
    ],
    [
        112.97616389704,
        22.87489678143
    ],
    [
        112.97618890391,
        22.874892213005
    ],
    [
        112.97619732731,
        22.874893763276
    ],
    [
        112.97621607843,
        22.874894676886
    ],
    [
        112.97625522982,
        22.874875877592
    ],
    [
        112.97628324078,
        22.874854739597
    ],
    [
        112.97632728723,
        22.874831829918
    ],
    [
        112.97636291366,
        22.874803573308
    ],
    [
        112.97637624656,
        22.874785281857
    ],
    [
        112.97639800751,
        22.874763117819
    ],
    [
        112.97641758293,
        22.87475344964
    ],
    [
        112.97641596201,
        22.87474288679
    ],
    [
        112.97656171176,
        22.874645307071
    ],
    [
        112.97657639762,
        22.874632972513
    ],
    [
        112.97658563871,
        22.87463126358
    ],
    [
        112.97660930424,
        22.874605831829
    ],
    [
        112.97663703702,
        22.874590128504
    ],
    [
        112.97667781911,
        22.874568344726
    ],
    [
        112.97669957488,
        22.874550796648
    ],
    [
        112.97673844937,
        22.874534455827
    ],
    [
        112.97677162694,
        22.874507317081
    ],
    [
        112.97679229617,
        22.87448896642
    ],
    [
        112.97681296932,
        22.874466276635
    ],
    [
        112.97684722627,
        22.874446995807
    ],
    [
        112.97687903986,
        22.87442502478
    ],
    [
        112.97691411491,
        22.874402212983
    ],
    [
        112.97693260308,
        22.874391206149
    ],
    [
        112.97694837182,
        22.874382392529
    ],
    [
        112.97695136417,
        22.87437884119
    ],
    [
        112.97698917166,
        22.874339192902
    ],
    [
        112.97721557669,
        22.874574600758
    ],
    [
        112.97736895471,
        22.87473172355
    ],
    [
        112.97738687795,
        22.874742696597
    ],
    [
        112.97748598087,
        22.874822169511
    ],
    [
        112.9776092321,
        22.874936986376
    ],
    [
        112.97778513543,
        22.875112967205
    ],
    [
        112.97778648708,
        22.875120550633
    ],
    [
        112.97780280489,
        22.875102793592
    ],
    [
        112.97804532209,
        22.874915947989
    ],
    [
        112.97809997697,
        22.874864814545
    ],
    [
        112.97816816698,
        22.874867011
    ],
    [
        112.97842889705,
        22.875252913774
    ],
    [
        112.97850050531,
        22.875377422806
    ],
    [
        112.97885201593,
        22.875391469276
    ],
    [
        112.97885620145,
        22.875267765524
    ],
    [
        112.97885541962,
        22.875230885557
    ],
    [
        112.97905028841,
        22.875119161697
    ],
    [
        112.97908099837,
        22.875102680688
    ],
    [
        112.9789071388,
        22.874812583371
    ],
    [
        112.97887378333,
        22.874749892328
    ],
    [
        112.97892543342,
        22.874708852767
    ],
    [
        112.97903196975,
        22.874651167847
    ],
    [
        112.9791137768,
        22.874602880212
    ],
    [
        112.97912275025,
        22.874592513639
    ],
    [
        112.97914180153,
        22.874552245788
    ],
    [
        112.9791138654,
        22.874506055761
    ],
    [
        112.97907835242,
        22.874428185472
    ],
    [
        112.97904417288,
        22.874377157523
    ],
    [
        112.97898041732,
        22.874290261166
    ],
    [
        112.97893810552,
        22.874220307037
    ],
    [
        112.97892589597,
        22.874204660695
    ],
    [
        112.97887571764,
        22.87412228724
    ],
    [
        112.97880680062,
        22.874034080195
    ],
    [
        112.97876069866,
        22.873949242291
    ],
    [
        112.97873954264,
        22.873913862236
    ],
    [
        112.97871458413,
        22.87387769582
    ],
    [
        112.97870427482,
        22.873863123227
    ],
    [
        112.97865409598,
        22.873779945743
    ],
    [
        112.97860741702,
        22.873730375893
    ],
    [
        112.97856890744,
        22.873659594378
    ],
    [
        112.97856809701,
        22.87365471836
    ],
    [
        112.97852332476,
        22.873599171435
    ],
    [
        112.97851682055,
        22.87358240326
    ],
    [
        112.97847368512,
        22.873519252395
    ],
    [
        112.97845446983,
        22.873441554063
    ],
    [
        112.97847732233,
        22.873406943441
    ],
    [
        112.97853029926,
        22.87340438948
    ],
    [
        112.97860580806,
        22.873418220225
    ],
    [
        112.97869785844,
        22.873462314358
    ],
    [
        112.97869295638,
        22.87347536738
    ],
    [
        112.97870516234,
        22.873495079473
    ],
    [
        112.97873467006,
        22.873604441261
    ],
    [
        112.97875471716,
        22.873663424599
    ],
    [
        112.97876068467,
        22.873672875091
    ],
    [
        112.97878758623,
        22.873664278496
    ],
    [
        112.97882100628,
        22.873656721827
    ],
    [
        112.97950046773,
        22.8735436879
    ],
    [
        112.97968845744,
        22.873508055423
    ],
    [
        112.98047652184,
        22.873314372274
    ],
    [
        112.98050478524,
        22.873293061017
    ],
    [
        112.98050110159,
        22.873167780551
    ],
    [
        112.98052040518,
        22.873144349567
    ],
    [
        112.98057228359,
        22.873134843453
    ],
    [
        112.98071324114,
        22.873117537441
    ],
    [
        112.98080883901,
        22.873107266955
    ],
    [
        112.98084388276,
        22.873093251297
    ],
    [
        112.98086100403,
        22.873079058797
    ],
    [
        112.98084772307,
        22.873052549153
    ],
    [
        112.98084856808,
        22.873020541512
    ],
    [
        112.98083615357,
        22.872939513533
    ],
    [
        112.98083813365,
        22.872856240587
    ],
    [
        112.98082405721,
        22.872809665611
    ],
    [
        112.98081188167,
        22.872763080826
    ],
    [
        112.98081384495,
        22.87269770807
    ],
    [
        112.98082254147,
        22.872690610856
    ],
    [
        112.98082989083,
        22.87267240102
    ],
    [
        112.98088122257,
        22.872663725555
    ],
    [
        112.98091948495,
        22.872691191185
    ],
    [
        112.98104843749,
        22.872724705879
    ],
    [
        112.98108019777,
        22.872735394573
    ],
    [
        112.98109676316,
        22.872733955489
    ],
    [
        112.98126051469,
        22.872718502463
    ],
    [
        112.98162574956,
        22.872681801005
    ],
    [
        112.98162662115,
        22.872622130076
    ],
    [
        112.981627756,
        22.8725711368
    ],
    [
        112.98162916736,
        22.872514989229
    ],
    [
        112.98164072438,
        22.872355192303
    ],
    [
        112.98164209604,
        22.872340540592
    ],
    [
        112.98164728457,
        22.872309598859
    ],
    [
        112.98169779609,
        22.872299065937
    ],
    [
        112.98176460713,
        22.872278699662
    ],
    [
        112.98214265682,
        22.872150983361
    ],
    [
        112.98221760503,
        22.872132780951
    ],
    [
        112.98227599668,
        22.872109495796
    ],
    [
        112.982374854,
        22.872069784072
    ],
    [
        112.98246832967,
        22.871978842212
    ],
    [
        112.98253031722,
        22.871883956694
    ],
    [
        112.98253494433,
        22.871871463706
    ],
    [
        112.98257951991,
        22.871815158003
    ],
    [
        112.98262897789,
        22.871762633365
    ],
    [
        112.98271130944,
        22.871682329939
    ],
    [
        112.98279035592,
        22.87162916539
    ],
    [
        112.98284438382,
        22.871620842228
    ],
    [
        112.982911687,
        22.871638513316
    ],
    [
        112.98292470614,
        22.871649318016
    ],
    [
        112.98298141814,
        22.871670825993
    ],
    [
        112.98306593214,
        22.87157399792
    ],
    [
        112.98308087824,
        22.871556863328
    ],
    [
        112.98308251696,
        22.87154655197
    ],
    [
        112.98312490411,
        22.871503293653
    ],
    [
        112.9831585972,
        22.871467929468
    ],
    [
        112.98316131081,
        22.871468734571
    ],
    [
        112.98316566391,
        22.87145841481
    ],
    [
        112.98318386597,
        22.871442356258
    ],
    [
        112.98321209182,
        22.871446065442
    ],
    [
        112.98325062599,
        22.871455981632
    ],
    [
        112.98327721997,
        22.871462680835
    ],
    [
        112.98329757855,
        22.871461534323
    ],
    [
        112.98330219662,
        22.87145772341
    ],
    [
        112.98331306001,
        22.871451452815
    ],
    [
        112.98335299805,
        22.871412821308
    ],
    [
        112.98339810011,
        22.871366853388
    ],
    [
        112.98341332951,
        22.871336704298
    ],
    [
        112.98345569589,
        22.871312172536
    ],
    [
        112.98348747644,
        22.87128767249
    ],
    [
        112.98351273125,
        22.871274853915
    ],
    [
        112.98354069511,
        22.871267181384
    ],
    [
        112.9835843828,
        22.871278179778
    ],
    [
        112.98361043468,
        22.871282447664
    ],
    [
        112.98361287239,
        22.871287594045
    ],
    [
        112.98363105067,
        22.87129432487
    ],
    [
        112.98366739935,
        22.871315652619
    ],
    [
        112.98374660349,
        22.871364803877
    ],
    [
        112.98380057703,
        22.87140236302
    ],
    [
        112.98392912263,
        22.871504560182
    ],
    [
        112.98394242312,
        22.871502629312
    ],
    [
        112.98396818865,
        22.871520467107
    ],
    [
        112.98400209202,
        22.871542354365
    ],
    [
        112.98406041309,
        22.871572050943
    ],
    [
        112.98412389897,
        22.87159251772
    ],
    [
        112.98418684,
        22.871614345476
    ],
    [
        112.98424788351,
        22.871633197611
    ],
    [
        112.98431897907,
        22.871640098831
    ],
    [
        112.98436537244,
        22.871653021483
    ],
    [
        112.98440771878,
        22.871641273804
    ],
    [
        112.98443244177,
        22.871612747259
    ],
    [
        112.98447373011,
        22.871572255653
    ],
    [
        112.98450631971,
        22.871546698915
    ],
    [
        112.98454218145,
        22.871504864228
    ],
    [
        112.98454625412,
        22.87150268689
    ],
    [
        112.98458980564,
        22.871366999698
    ],
    [
        112.98461968865,
        22.871333586164
    ],
    [
        112.98464086766,
        22.871320801144
    ],
    [
        112.98469407011,
        22.871305248347
    ],
    [
        112.98470274999,
        22.871309030297
    ],
    [
        112.98476622896,
        22.87132872103
    ],
    [
        112.9848671162,
        22.871387139363
    ],
    [
        112.98505425504,
        22.871480971637
    ],
    [
        112.98514947192,
        22.871505522687
    ],
    [
        112.98518609282,
        22.871515510063
    ],
    [
        112.98521510575,
        22.871536085512
    ],
    [
        112.98525417006,
        22.871544173646
    ],
    [
        112.98528373455,
        22.871555257805
    ],
    [
        112.98531735985,
        22.871575559315
    ],
    [
        112.98534339803,
        22.871585293136
    ],
    [
        112.98536591093,
        22.8715928618
    ],
    [
        112.98538706551,
        22.871602059699
    ],
    [
        112.98539194729,
        22.871604224076
    ],
    [
        112.98541907649,
        22.871607720628
    ],
    [
        112.98543643364,
        22.871615567479
    ],
    [
        112.98544999907,
        22.871616366982
    ],
    [
        112.9854554237,
        22.87161825987
    ],
    [
        112.98545840826,
        22.871618256797
    ],
    [
        112.98546737646,
        22.871603330875
    ],
    [
        112.98547689074,
        22.871584878701
    ],
    [
        112.98547907665,
        22.871569146115
    ],
    [
        112.98548477707,
        22.871566428245
    ],
    [
        112.98548206993,
        22.871560193057
    ],
    [
        112.98552764794,
        22.87156421636
    ],
    [
        112.98552357919,
        22.871563135436
    ],
    [
        112.98555755444,
        22.871501266438
    ],
    [
        112.98556813348,
        22.871503697506
    ],
    [
        112.98557119584,
        22.871423957952
    ],
    [
        112.98557559712,
        22.871362388483
    ],
    [
        112.98561096813,
        22.871260380365
    ],
    [
        112.98562786308,
        22.871185510685
    ],
    [
        112.98564418107,
        22.871145628265
    ],
    [
        112.98567974415,
        22.871124172567
    ],
    [
        112.98573589407,
        22.871135789965
    ],
    [
        112.98583790202,
        22.871139241897
    ],
    [
        112.98587207907,
        22.871146542073
    ],
    [
        112.98587751098,
        22.871140571895
    ],
    [
        112.98588076155,
        22.87114572287
    ],
    [
        112.98589731015,
        22.871146526099
    ],
    [
        112.98591901767,
        22.871142987059
    ],
    [
        112.98592173174,
        22.871141900578
    ],
    [
        112.9859285699,
        22.871085212963
    ],
    [
        112.98593020943,
        22.871073278617
    ],
    [
        112.98592995945,
        22.871051581718
    ],
    [
        112.98593573036,
        22.870976723522
    ],
    [
        112.98593329987,
        22.870965334002
    ],
    [
        112.9859560948,
        22.870684344276
    ],
    [
        112.98596187628,
        22.870599180206
    ],
    [
        112.98595865855,
        22.870560941027
    ],
    [
        112.98596192621,
        22.870548734615
    ],
    [
        112.98596791947,
        22.870523779697
    ],
    [
        112.98597121535,
        22.87048309597
    ],
    [
        112.98600324369,
        22.870467619602
    ],
    [
        112.98600867095,
        22.870466260711
    ],
    [
        112.98605371364,
        22.870458373127
    ],
    [
        112.98607162596,
        22.870451313207
    ],
    [
        112.98607705503,
        22.870448056171
    ],
    [
        112.98609333873,
        22.870441810992
    ],
    [
        112.98614380702,
        22.870433382377
    ],
    [
        112.98622139047,
        22.870437965287
    ],
    [
        112.98627700249,
        22.870439033719
    ],
    [
        112.98630763844,
        22.870458010791
    ],
    [
        112.98633855545,
        22.870466953806
    ],
    [
        112.98633909505,
        22.870469937031
    ],
    [
        112.98636485868,
        22.870477797055
    ],
    [
        112.9863840914,
        22.870505999742
    ],
    [
        112.98638110574,
        22.87050762753
    ],
    [
        112.98639219933,
        22.870536645439
    ],
    [
        112.98639049356,
        22.870615568646
    ],
    [
        112.98639149528,
        22.870699915687
    ],
    [
        112.98638738354,
        22.870743039219
    ],
    [
        112.98637638881,
        22.870888682485
    ],
    [
        112.98637627133,
        22.87100801627
    ],
    [
        112.98638456124,
        22.871129789564
    ],
    [
        112.98638291654,
        22.871147147492
    ],
    [
        112.98639508539,
        22.871186471414
    ],
    [
        112.98639480932,
        22.871191353297
    ],
    [
        112.98640457578,
        22.871190809359
    ],
    [
        112.98648327009,
        22.871165306365
    ],
    [
        112.98657365675,
        22.871110246891
    ],
    [
        112.98667379856,
        22.871064145977
    ],
    [
        112.98674922558,
        22.871047069715
    ],
    [
        112.9868352691,
        22.870990675416
    ],
    [
        112.98691534834,
        22.870929675422
    ],
    [
        112.98694875814,
        22.870882766887
    ],
    [
        112.98696290952,
        22.870835580914
    ],
    [
        112.98696861426,
        22.870826904209
    ],
    [
        112.98697813009,
        22.870804397116
    ],
    [
        112.98699229698,
        22.870741481184
    ],
    [
        112.98701405257,
        22.870684806476
    ],
    [
        112.98702934147,
        22.870584464123
    ],
    [
        112.98707419962,
        22.870480338564
    ],
    [
        112.98711636292,
        22.870358313469
    ],
    [
        112.98719589304,
        22.870300317457
    ],
    [
        112.98724451534,
        22.870228475572
    ],
    [
        112.98728903345,
        22.870192161999
    ],
    [
        112.98731999249,
        22.870153128572
    ],
    [
        112.98731783318,
        22.870142549767
    ],
    [
        112.98733520963,
        22.870124661986
    ],
    [
        112.98735179152,
        22.870087517802
    ],
    [
        112.98734478717,
        22.870039779286
    ],
    [
        112.98733287829,
        22.870014547971
    ],
    [
        112.98732909515,
        22.870000442229
    ],
    [
        112.98731965464,
        22.86994782034
    ],
    [
        112.98729961181,
        22.869919600408
    ],
    [
        112.98726329667,
        22.869889742933
    ],
    [
        112.98724759582,
        22.869859085879
    ],
    [
        112.98724303933,
        22.869804569294
    ],
    [
        112.98724901187,
        22.869799148809
    ],
    [
        112.98729275172,
        22.869727577297
    ],
    [
        112.98733674891,
        22.869669568373
    ],
    [
        112.98735900992,
        22.869649243577
    ],
    [
        112.9873693331,
        22.869632707258
    ],
    [
        112.9873964812,
        22.869607233852
    ],
    [
        112.98741820252,
        22.869583926529
    ],
    [
        112.98745893024,
        22.869539751858
    ],
    [
        112.9874600067,
        22.869548160334
    ],
    [
        112.98749064216,
        22.869560661935
    ],
    [
        112.98753104239,
        22.869572088253
    ],
    [
        112.98759880436,
        22.869614188957
    ],
    [
        112.9876058592,
        22.869610941188
    ],
    [
        112.98776201196,
        22.869675380471
    ],
    [
        112.98784604237,
        22.869718328561
    ],
    [
        112.98787640361,
        22.869731654458
    ],
    [
        112.98799566377,
        22.869798524345
    ],
    [
        112.98806424244,
        22.869831705433
    ],
    [
        112.98807345832,
        22.869836328898
    ],
    [
        112.98813904103,
        22.869881443925
    ],
    [
        112.98816560024,
        22.869898569416
    ],
    [
        112.98818864096,
        22.869908638726
    ],
    [
        112.98824697079,
        22.869883234103
    ],
    [
        112.98826162216,
        22.869875663091
    ],
    [
        112.98830558904,
        22.869839933053
    ],
    [
        112.98831210735,
        22.869829908717
    ],
    [
        112.988354741,
        22.869771125438
    ],
    [
        112.98840147182,
        22.869682517412
    ],
    [
        112.98845634589,
        22.86958551807
    ],
    [
        112.98845607988,
        22.869580364563
    ],
    [
        112.9885003548,
        22.869506402017
    ],
    [
        112.98851911601,
        22.869455990282
    ],
    [
        112.9885389526,
        22.869414802072
    ],
    [
        112.98852381707,
        22.86936514259
    ],
    [
        112.988521394,
        22.869347780591
    ],
    [
        112.98849948333,
        22.869294041009
    ],
    [
        112.98847379095,
        22.869225649711
    ],
    [
        112.98847275893,
        22.869173303882
    ],
    [
        112.98847250113,
        22.869160014017
    ],
    [
        112.98848745478,
        22.869120985961
    ],
    [
        112.98848908071,
        22.869122073709
    ],
    [
        112.98852489734,
        22.869099898739
    ],
    [
        112.98853493954,
        22.869090967012
    ],
    [
        112.98854958992,
        22.869083671117
    ],
    [
        112.98860520822,
        22.869054483877
    ],
    [
        112.98867543637,
        22.86905733103
    ],
    [
        112.98870743287,
        22.869057665275
    ],
    [
        112.98877414887,
        22.869046408825
    ],
    [
        112.98882486444,
        22.86903675015
    ],
    [
        112.98889047661,
        22.869043127371
    ],
    [
        112.98892788494,
        22.869053243453
    ],
    [
        112.98893818141,
        22.86906031756
    ],
    [
        112.98894627838,
        22.869097491502
    ],
    [
        112.98894539204,
        22.869169903295
    ],
    [
        112.98892332576,
        22.869272644438
    ],
    [
        112.98892167325,
        22.869298134816
    ],
    [
        112.9889020645,
        22.869383795383
    ],
    [
        112.98888954673,
        22.869428518446
    ],
    [
        112.9888962713,
        22.869482504276
    ],
    [
        112.98889678122,
        22.869514779692
    ],
    [
        112.98889596234,
        22.869520202178
    ],
    [
        112.98890651184,
        22.869545447796
    ],
    [
        112.98891218773,
        22.869563631378
    ],
    [
        112.98891892403,
        22.869605955242
    ],
    [
        112.98894437136,
        22.869646421743
    ],
    [
        112.98895925044,
        22.869680356247
    ],
    [
        112.98898417921,
        22.869696955811
    ],
    [
        112.98903730938,
        22.869710908037
    ],
    [
        112.98911458009,
        22.869715155941
    ],
    [
        112.98919701289,
        22.869707759767
    ],
    [
        112.98931930626,
        22.869694504085
    ],
    [
        112.98941828147,
        22.869680115486
    ],
    [
        112.98946194583,
        22.869666399827
    ],
    [
        112.98949393763,
        22.869666757291
    ],
    [
        112.98956796985,
        22.869649602864
    ],
    [
        112.98960320243,
        22.869661905925
    ],
    [
        112.98962080736,
        22.869679313192
    ],
    [
        112.98962840148,
        22.869676351347
    ],
    [
        112.98963273112,
        22.869684500018
    ],
    [
        112.98963949588,
        22.869697537465
    ],
    [
        112.98964166314,
        22.869699170911
    ],
    [
        112.98963488481,
        22.869699694063
    ],
    [
        112.98964596726,
        22.869732813589
    ],
    [
        112.98964618114,
        22.869790040157
    ],
    [
        112.98965187609,
        22.869788429129
    ],
    [
        112.98966507078,
        22.869878238437
    ],
    [
        112.98966720093,
        22.869917028031
    ],
    [
        112.98967094667,
        22.869966942016
    ],
    [
        112.98967797982,
        22.869982692617
    ],
    [
        112.98967332823,
        22.87002553092
    ],
    [
        112.98967276059,
        22.870051023334
    ],
    [
        112.98966889724,
        22.870119086766
    ],
    [
        112.98967021121,
        22.870160857392
    ],
    [
        112.98966560099,
        22.870162200222
    ],
    [
        112.98966530343,
        22.870188778276
    ],
    [
        112.98966693387,
        22.870184985968
    ],
    [
        112.98965742694,
        22.870203130017
    ],
    [
        112.9896400354,
        22.870243762395
    ],
    [
        112.98961961445,
        22.870331848834
    ],
    [
        112.98961032286,
        22.870406135097
    ],
    [
        112.98960318438,
        22.870496429103
    ],
    [
        112.98960561956,
        22.870501317798
    ],
    [
        112.98960614781,
        22.87051542239
    ],
    [
        112.98960633702,
        22.87059814307
    ],
    [
        112.98961030984,
        22.870693079043
    ],
    [
        112.98961974813,
        22.870744365082
    ],
    [
        112.98962323403,
        22.870783429724
    ],
    [
        112.98962917199,
        22.870810296714
    ],
    [
        112.98963714258,
        22.87097548859
    ],
    [
        112.98964685694,
        22.871021893842
    ],
    [
        112.98964814425,
        22.871091328298
    ],
    [
        112.98966431341,
        22.87119063891
    ],
    [
        112.98966884438,
        22.871270117661
    ],
    [
        112.98970593181,
        22.871325823758
    ],
    [
        112.9897405645,
        22.8713964407
    ],
    [
        112.98974057086,
        22.871389931576
    ],
    [
        112.98976084042,
        22.87145481156
    ],
    [
        112.98974507738,
        22.871494633565
    ],
    [
        112.9897537472,
        22.871500354618
    ],
    [
        112.98975155692,
        22.871522316523
    ],
    [
        112.98974992764,
        22.871525023863
    ],
    [
        112.98975453458,
        22.871526935954
    ],
    [
        112.98976374844,
        22.871530760193
    ],
    [
        112.98976104083,
        22.871527226394
    ],
    [
        112.98976943952,
        22.871532946772
    ],
    [
        112.98979139577,
        22.87153626668
    ],
    [
        112.99021619116,
        22.871544669303
    ],
    [
        112.99024031609,
        22.871546107061
    ],
    [
        112.99025738013,
        22.871560539531
    ],
    [
        112.99026008062,
        22.871571126118
    ],
    [
        112.99027765268,
        22.871620547326
    ],
    [
        112.99028604978,
        22.871627085321
    ],
    [
        112.9902952358,
        22.871658577847
    ],
    [
        112.99029225421,
        22.871658296358
    ],
    [
        112.9903266454,
        22.871695029342
    ],
    [
        112.99036863888,
        22.87171904301
    ],
    [
        112.99037811751,
        22.871728297663
    ],
    [
        112.99041579138,
        22.87173385533
    ],
    [
        112.99041849577,
        22.871740374108
    ],
    [
        112.99046348456,
        22.871749756487
    ],
    [
        112.99047133977,
        22.871755751526
    ],
    [
        112.99048460713,
        22.87177125872
    ],
    [
        112.99051357504,
        22.871808791617
    ],
    [
        112.99052623333,
        22.871893185681
    ],
    [
        112.99055379639,
        22.871981702941
    ],
    [
        112.99054890986,
        22.871989278973
    ],
    [
        112.99055892274,
        22.872006402403
    ],
    [
        112.99057375497,
        22.872085380795
    ],
    [
        112.99058265843,
        22.872128536997
    ],
    [
        112.99057504718,
        22.872150748431
    ],
    [
        112.99057287997,
        22.872149384332
    ],
    [
        112.99053952223,
        22.872166619155
    ],
    [
        112.99046495481,
        22.872191028565
    ],
    [
        112.99031366503,
        22.872222497359
    ],
    [
        112.98987956121,
        22.872316547279
    ],
    [
        112.98988336051,
        22.872312490712
    ],
    [
        112.98987549786,
        22.872313280241
    ],
    [
        112.98988254251,
        22.872317370073
    ],
    [
        112.98988281857,
        22.872312217833
    ],
    [
        112.98986654245,
        22.872322745373
    ],
    [
        112.98985298041,
        22.872330026829
    ],
    [
        112.98984590728,
        22.872355499557
    ],
    [
        112.98982527754,
        22.872382558632
    ],
    [
        112.98983339364,
        22.872400212144
    ],
    [
        112.98982388869,
        22.872417269994
    ],
    [
        112.9898089523,
        22.872444075355
    ],
    [
        112.9897948422,
        22.872457322627
    ],
    [
        112.98974357901,
        22.872482664806
    ],
    [
        112.98968282914,
        22.872505269816
    ],
    [
        112.98961422077,
        22.872523245335
    ],
    [
        112.98957137966,
        22.872528549504
    ],
    [
        112.98955266598,
        22.872535549153
    ],
    [
        112.98953450174,
        22.872534956607
    ],
    [
        112.98951984924,
        22.872547663522
    ],
    [
        112.98952335818,
        22.872563946052
    ],
    [
        112.98951901563,
        22.872568816037
    ],
    [
        112.98952930769,
        22.872579692863
    ],
    [
        112.98954228753,
        22.872614986582
    ],
    [
        112.98956124849,
        22.872632939257
    ],
    [
        112.98957017324,
        22.872656017376
    ],
    [
        112.9895861485,
        22.872677487983
    ],
    [
        112.98959940379,
        22.872708172507
    ],
    [
        112.98961483754,
        22.872728828373
    ],
    [
        112.98962809977,
        22.872752190453
    ],
    [
        112.98964624818,
        22.872769057455
    ],
    [
        112.98966573476,
        22.87280410005
    ],
    [
        112.98967466975,
        22.872816330447
    ],
    [
        112.98969038708,
        22.872823698645
    ],
    [
        112.98970204112,
        22.872827529456
    ],
    [
        112.98973267983,
        22.872823821869
    ],
    [
        112.98976657885,
        22.872812530766
    ],
    [
        112.98982000065,
        22.872797502347
    ],
    [
        112.98985117857,
        22.872796240659
    ],
    [
        112.98987125055,
        22.872785182055
    ],
    [
        112.98989701604,
        22.872773598932
    ],
    [
        112.98991193029,
        22.872769576791
    ],
    [
        112.98991844024,
        22.872765799956
    ],
    [
        112.98992280107,
        22.872741404091
    ],
    [
        112.98993337901,
        22.872736012699
    ],
    [
        112.98996564893,
        22.872726078786
    ],
    [
        112.99001037831,
        22.872727305312
    ],
    [
        112.99004860866,
        22.872720647453
    ],
    [
        112.9900849375,
        22.872717781759
    ],
    [
        112.99010391289,
        22.872718657352
    ],
    [
        112.99012695399,
        22.872720089093
    ],
    [
        112.99014999189,
        22.872724775896
    ],
    [
        112.99017275395,
        22.872734344147
    ],
    [
        112.99018685367,
        22.872730865474
    ],
    [
        112.99019986514,
        22.872731451559
    ],
    [
        112.99021938126,
        22.872733415837
    ],
    [
        112.99024621726,
        22.872734591705
    ],
    [
        112.99027197243,
        22.872731967506
    ],
    [
        112.99029935239,
        22.872730976815
    ],
    [
        112.99030694257,
        22.872731003042
    ],
    [
        112.99031397945,
        22.87274268968
    ],
    [
        112.99064118549,
        22.872716750814
    ],
    [
        112.99065825685,
        22.872722510728
    ],
    [
        112.99067532946,
        22.872726914834
    ],
    [
        112.99068535164,
        22.872734275737
    ],
    [
        112.99070051926,
        22.872746538248
    ],
    [
        112.99074486608,
        22.872858449386
    ],
    [
        112.99076245421,
        22.872890520866
    ],
    [
        112.99076298214,
        22.872905439791
    ],
    [
        112.99077029339,
        22.872913062191
    ],
    [
        112.99077300728,
        22.87290954692
    ],
    [
        112.99078465589,
        22.872916643837
    ],
    [
        112.99079414998,
        22.872909086803
    ],
    [
        112.99080770571,
        22.872905885202
    ],
    [
        112.99082125625,
        22.872908108067
    ],
    [
        112.9908399575,
        22.872909537756
    ],
    [
        112.99088386884,
        22.872908355762
    ],
    [
        112.99089255013,
        22.872900253906
    ],
    [
        112.99092480632,
        22.872898755858
    ],
    [
        112.99093564507,
        22.872902054092
    ],
    [
        112.99095325169,
        22.872914058718
    ],
    [
        112.99095458449,
        22.87293765991
    ],
    [
        112.99095726017,
        22.872974284918
    ],
    [
        112.99096076109,
        22.872998166125
    ],
    [
        112.99096291556,
        22.873012820534
    ],
    [
        112.99096669783,
        22.873025854258
    ],
    [
        112.99097048628,
        22.873032378833
    ],
    [
        112.99097697128,
        22.873053560064
    ],
    [
        112.99099701591,
        22.873066931402
    ],
    [
        112.99100216033,
        22.873072647981
    ],
    [
        112.99101435518,
        22.873074867678
    ],
    [
        112.99101408234,
        22.873076765073
    ],
    [
        112.99102247179,
        22.873090360336
    ],
    [
        112.99103112766,
        22.873108838654
    ],
    [
        112.99104114488,
        22.873120813468
    ],
    [
        112.99103976093,
        22.873151183983
    ],
    [
        112.99103052502,
        22.873172843221
    ],
    [
        112.99101586672,
        22.873196107567
    ],
    [
        112.99099849771,
        22.873219632238
    ],
    [
        112.99098952461,
        22.873249971824
    ],
    [
        112.99098328831,
        22.873252387341
    ],
    [
        112.99097325047,
        22.873262110275
    ],
    [
        112.99097595553,
        22.873267816822
    ],
    [
        112.99096836886,
        22.873265073819
    ],
    [
        112.99095534412,
        22.873280480334
    ],
    [
        112.99095398276,
        22.873286984016
    ],
    [
        112.99095099513,
        22.87329348112
    ],
    [
        112.99094122521,
        22.873306460028
    ],
    [
        112.99094216825,
        22.873456446591
    ],
    [
        112.99094807956,
        22.87351152746
    ],
    [
        112.99093407823,
        22.873701593924
    ],
    [
        112.99091206447,
        22.873764698964
    ],
    [
        112.99092121131,
        22.873838506723
    ],
    [
        112.99091792821,
        22.873871310802
    ],
    [
        112.99092440432,
        22.873902526801
    ],
    [
        112.99092433101,
        22.873981450714
    ],
    [
        112.99092236103,
        22.874059824593
    ],
    [
        112.9909165895,
        22.874145777321
    ],
    [
        112.99092173162,
        22.874154205721
    ],
    [
        112.99092199716,
        22.874160173573
    ],
    [
        112.99091549279,
        22.874159333791
    ],
    [
        112.99091380742,
        22.87422333436
    ],
    [
        112.99089667019,
        22.874289714036
    ],
    [
        112.99089041861,
        22.8743086743
    ],
    [
        112.99088742086,
        22.874326291486
    ],
    [
        112.9908800978,
        22.874331415436
    ],
    [
        112.99087630038,
        22.874334383715
    ],
    [
        112.99087684148,
        22.874335470738
    ],
    [
        112.9908546042,
        22.874347587271
    ],
    [
        112.99083699415,
        22.874338567509
    ],
    [
        112.99070118848,
        22.874346176926
    ],
    [
        112.99064074155,
        22.874346761356
    ],
    [
        112.99064127743,
        22.874353543814
    ],
    [
        112.99062986671,
        22.874381978766
    ],
    [
        112.99062525443,
        22.874386572159
    ],
    [
        112.99061949792,
        22.87445652476
    ],
    [
        112.99062211616,
        22.874557427608
    ],
    [
        112.99060982748,
        22.874656918617
    ],
    [
        112.99060842101,
        22.874713055504
    ],
    [
        112.99059981052,
        22.874941660368
    ],
    [
        112.99059681288,
        22.874959278395
    ],
    [
        112.99059376625,
        22.875031139949
    ],
    [
        112.99058395685,
        22.87508778816
    ],
    [
        112.99058230579,
        22.875115175111
    ],
    [
        112.99058283717,
        22.875127110705
    ],
    [
        112.99059852028,
        22.875170021595
    ],
    [
        112.99061313156,
        22.875199096553
    ],
    [
        112.99061691619,
        22.875210501904
    ],
    [
        112.99066648376,
        22.87525137141
    ],
    [
        112.99069681776,
        22.875278879866
    ],
    [
        112.99071714122,
        22.87528546687
    ],
    [
        112.99072472109,
        22.875296344722
    ],
    [
        112.99073065761,
        22.875326201629
    ],
    [
        112.9907219382,
        22.875377157291
    ],
    [
        112.99071943621,
        22.875447122213
    ],
    [
        112.99071181881,
        22.875478283214
    ],
    [
        112.99068984213,
        22.875501795328
    ],
    [
        112.99068032998,
        22.875529965925
    ],
    [
        112.9906732728,
        22.875540787889
    ],
    [
        112.99066294193,
        22.875575193578
    ],
    [
        112.99068038585,
        22.875772707521
    ],
    [
        112.99069255594,
        22.875803944114
    ],
    [
        112.99077707946,
        22.875856343833
    ],
    [
        112.9907811381,
        22.875864496221
    ],
    [
        112.99082258502,
        22.875892051576
    ],
    [
        112.9908670058,
        22.875928028121
    ],
    [
        112.99088784963,
        22.87595875895
    ],
    [
        112.9909049104,
        22.87597618524
    ],
    [
        112.99092902119,
        22.875990385532
    ],
    [
        112.99097943127,
        22.875995471694
    ],
    [
        112.99099405715,
        22.876007465053
    ],
    [
        112.99101356507,
        22.876015681554
    ],
    [
        112.99102630142,
        22.876018717326
    ],
    [
        112.99104038153,
        22.876034777356
    ],
    [
        112.99104606863,
        22.876040225254
    ],
    [
        112.99103820109,
        22.876048600579
    ],
    [
        112.99103873225,
        22.876061078895
    ],
    [
        112.99105823433,
        22.876075805448
    ],
    [
        112.99105279526,
        22.876096666867
    ],
    [
        112.99106253752,
        22.876114065336
    ],
    [
        112.99107471155,
        22.876140153055
    ],
    [
        112.99107686281,
        22.876159689864
    ],
    [
        112.99109038423,
        22.876194733641
    ],
    [
        112.99109062549,
        22.876228908411
    ],
    [
        112.99109601982,
        22.876259307627
    ],
    [
        112.99110630015,
        22.876281319496
    ],
    [
        112.9911117011,
        22.876304124653
    ],
    [
        112.99111296387,
        22.876410719631
    ],
    [
        112.9912638783,
        22.876470489139
    ],
    [
        112.99143212797,
        22.876537408591
    ],
    [
        112.99158493184,
        22.876596145494
    ],
    [
        112.99176590193,
        22.876671582318
    ],
    [
        112.99194714303,
        22.876740269399
    ],
    [
        112.9920969354,
        22.876818589692
    ],
    [
        112.99225404246,
        22.876894527248
    ],
    [
        112.99241438401,
        22.876985692615
    ],
    [
        112.99255062773,
        22.877050168731
    ],
    [
        112.99266844133,
        22.877116456748
    ],
    [
        112.99280765524,
        22.877186133791
    ],
    [
        112.99291352715,
        22.87727000872
    ],
    [
        112.9930456926,
        22.877337504414
    ],
    [
        112.993184621,
        22.877414006709
    ],
    [
        112.99327075162,
        22.87744599236
    ],
    [
        112.99338096497,
        22.877512308036
    ],
    [
        112.99350717302,
        22.877563818173
    ],
    [
        112.99365341381,
        22.877630117374
    ],
    [
        112.99375200538,
        22.877654896712
    ],
    [
        112.99384462394,
        22.877693477322
    ],
    [
        112.99399358254,
        22.877738953559
    ],
    [
        112.99404178815,
        22.877756095712
    ],
    [
        112.99411437029,
        22.877777475006
    ],
    [
        112.99421891063,
        22.877805860854
    ],
    [
        112.99429041172,
        22.87782154795
    ],
    [
        112.99437924888,
        22.877836548373
    ],
    [
        112.99445778452,
        22.877859889816
    ],
    [
        112.99457313927,
        22.877905743077
    ],
    [
        112.99459828275,
        22.87796369619
    ],
    [
        112.9946031424,
        22.877983259633
    ],
    [
        112.99462341693,
        22.878033041204
    ],
    [
        112.99466049423,
        22.878071825833
    ],
    [
        112.99473302929,
        22.878141792399
    ],
    [
        112.99482399078,
        22.878201051797
    ],
    [
        112.99490683917,
        22.878243169988
    ],
    [
        112.99501025527,
        22.878304978637
    ],
    [
        112.99520194651,
        22.878389720082
    ],
    [
        112.99541014789,
        22.878480319348
    ],
    [
        112.99549787329,
        22.878510041244
    ],
    [
        112.99556366895,
        22.878529285614
    ],
    [
        112.99560048791,
        22.878545857186
    ],
    [
        112.99561592412,
        22.878546796162
    ],
    [
        112.99562892855,
        22.878540663702
    ],
    [
        112.99567036948,
        22.878534220893
    ],
    [
        112.99568391565,
        22.878527822227
    ],
    [
        112.99568419016,
        22.878523213648
    ],
    [
        112.99570236129,
        22.878490544212
    ],
    [
        112.99571485352,
        22.878447521897
    ],
    [
        112.99572299679,
        22.87842426341
    ],
    [
        112.9957558392,
        22.878333130835
    ],
    [
        112.99577971388,
        22.878280167763
    ],
    [
        112.99581253551,
        22.878214802958
    ],
    [
        112.99581606378,
        22.878205339343
    ],
    [
        112.99582961915,
        22.878187279747
    ],
    [
        112.99585237636,
        22.878176348657
    ],
    [
        112.99587812365,
        22.878151610486
    ],
    [
        112.9959325582,
        22.878149624703
    ],
    [
        112.99596478928,
        22.878143657241
    ],
    [
        112.99600458706,
        22.878157011441
    ],
    [
        112.99603924506,
        22.878163271548
    ],
    [
        112.99608391147,
        22.878183178994
    ],
    [
        112.99611450681,
        22.878189677903
    ],
    [
        112.99620573909,
        22.878223006917
    ],
    [
        112.99625961589,
        22.878237304416
    ],
    [
        112.9963592418,
        22.878269090199
    ],
    [
        112.99645102784,
        22.878282914148
    ],
    [
        112.99650083704,
        22.878301797228
    ],
    [
        112.99652221081,
        22.878324226999
    ],
    [
        112.99653763568,
        22.878336297762
    ],
    [
        112.99654304187,
        22.878348008446
    ],
    [
        112.99654575011,
        22.878347490059
    ],
    [
        112.99655765042,
        22.878364954256
    ],
    [
        112.99657496433,
        22.878384907817
    ],
    [
        112.99659227406,
        22.878410014859
    ],
    [
        112.99660037492,
        22.878438023349
    ],
    [
        112.99662255511,
        22.87846751393
    ],
    [
        112.99663715896,
        22.878490156379
    ],
    [
        112.99664203228,
        22.87849101373
    ],
    [
        112.99665472438,
        22.878533981139
    ],
    [
        112.99666013532,
        22.87853972544
    ],
    [
        112.99666742909,
        22.878561217742
    ],
    [
        112.99667526464,
        22.878582443735
    ],
    [
        112.99670448545,
        22.87861118546
    ],
    [
        112.99671828426,
        22.878624599969
    ],
    [
        112.99672235082,
        22.878618398497
    ],
    [
        112.99673155751,
        22.878617939207
    ],
    [
        112.99674997019,
        22.878617834503
    ],
    [
        112.99676160576,
        22.878627432761
    ],
    [
        112.99680679336,
        22.878666628239
    ],
    [
        112.99680516724,
        22.878668512026
    ],
    [
        112.99685744763,
        22.878641052429
    ],
    [
        112.99687072015,
        22.878634935594
    ],
    [
        112.99688209598,
        22.878630428883
    ],
    [
        112.99691730965,
        22.878612850968
    ],
    [
        112.99697040643,
        22.878579165425
    ],
    [
        112.99708282135,
        22.878517826014
    ],
    [
        112.99727353371,
        22.878391870398
    ],
    [
        112.9973610428,
        22.878320827415
    ],
    [
        112.99754365236,
        22.878161745951
    ],
    [
        112.99756261582,
        22.878147283554
    ],
    [
        112.99771323942,
        22.878030770235
    ],
    [
        112.99773545317,
        22.878013901292
    ],
    [
        112.99779288734,
        22.877965646833
    ],
    [
        112.99784327802,
        22.877922478357
    ],
    [
        112.99785276984,
        22.877902501906
    ],
    [
        112.99786226523,
        22.877878185975
    ],
    [
        112.99786633589,
        22.877866292537
    ],
    [
        112.997830912,
        22.877816307137
    ],
    [
        112.99780197576,
        22.877778049464
    ],
    [
        112.9977600726,
        22.877705761663
    ],
    [
        112.9977728269,
        22.877669543356
    ],
    [
        112.99777149397,
        22.877644577619
    ],
    [
        112.99777990768,
        22.877619165559
    ],
    [
        112.99779563416,
        22.87759002864
    ],
    [
        112.99782517641,
        22.877550450905
    ],
    [
        112.99787638388,
        22.877502138658
    ],
    [
        112.99790402946,
        22.877464171238
    ],
    [
        112.99798285608,
        22.877408544409
    ],
    [
        112.99803349719,
        22.877388711205
    ],
    [
        112.99806085308,
        22.877372713338
    ],
    [
        112.99813752503,
        22.877301885704
    ],
    [
        112.99818005741,
        22.87726570261
    ],
    [
        112.9982185367,
        22.877220257955
    ],
    [
        112.9982624295,
        22.8771754123
    ],
    [
        112.99828355716,
        22.877160711493
    ],
    [
        112.99827950163,
        22.877154703006
    ],
    [
        112.99833123877,
        22.877116720683
    ],
    [
        112.99835724899,
        22.877090137505
    ],
    [
        112.99838026807,
        22.877079254887
    ],
    [
        112.99840734045,
        22.877076822523
    ],
    [
        112.99843170181,
        22.877078973402
    ],
    [
        112.99847121182,
        22.877093487176
    ],
    [
        112.99848905624,
        22.877119167788
    ],
    [
        112.99850526498,
        22.877158392755
    ],
    [
        112.99853447443,
        22.87718907451
    ],
    [
        112.99853933434,
        22.877204042557
    ],
    [
        112.99854608226,
        22.877227167056
    ],
    [
        112.99857502181,
        22.877256762007
    ],
    [
        112.99858827228,
        22.877272903054
    ],
    [
        112.99862479013,
        22.877303663479
    ],
    [
        112.99868754939,
        22.877352873747
    ],
    [
        112.9986926795,
        22.877368387673
    ],
    [
        112.99870375428,
        22.877396440741
    ],
    [
        112.99870698208,
        22.877420884995
    ],
    [
        112.99869586207,
        22.877446804918
    ],
    [
        112.99868987722,
        22.877482271995
    ],
    [
        112.99868364934,
        22.877484647244
    ],
    [
        112.99867985131,
        22.87749464243
    ],
    [
        112.99867171207,
        22.877516796897
    ],
    [
        112.99862971462,
        22.877564903615
    ],
    [
        112.99862077933,
        22.877567793137
    ],
    [
        112.9986210455,
        22.877573220412
    ],
    [
        112.99857876743,
        22.877632988438
    ],
    [
        112.99857633434,
        22.87762916581
    ],
    [
        112.99847745611,
        22.877717908753
    ],
    [
        112.99843789357,
        22.877766589391
    ],
    [
        112.99838993533,
        22.877819795245
    ],
    [
        112.99832817344,
        22.877869877309
    ],
    [
        112.9982620608,
        22.877942971818
    ],
    [
        112.9982609733,
        22.877948656398
    ],
    [
        112.99822954816,
        22.877976542419
    ],
    [
        112.99819920151,
        22.878009593456
    ],
    [
        112.9981726529,
        22.878032648513
    ],
    [
        112.99814637823,
        22.878051638525
    ],
    [
        112.99808814164,
        22.878092003689
    ],
    [
        112.99800335624,
        22.878154345097
    ],
    [
        112.99796786243,
        22.878190604597
    ],
    [
        112.99794916695,
        22.878209945743
    ],
    [
        112.99794835215,
        22.878213192295
    ],
    [
        112.9979050151,
        22.878239611054
    ],
    [
        112.99784568271,
        22.878293537483
    ],
    [
        112.99783728171,
        22.878304031969
    ],
    [
        112.99782102179,
        22.878324212798
    ],
    [
        112.99779853362,
        22.878346230855
    ],
    [
        112.9977627778,
        22.878370559542
    ],
    [
        112.99775844594,
        22.878370788094
    ],
    [
        112.99771401041,
        22.878415103338
    ],
    [
        112.9977056095,
        22.878425327467
    ],
    [
        112.9977064182,
        22.878429675001
    ],
    [
        112.99769964908,
        22.878430693522
    ],
    [
        112.99761241045,
        22.878508225322
    ],
    [
        112.99760347428,
        22.878510579382
    ],
    [
        112.99760049468,
        22.878512448975
    ],
    [
        112.99758207255,
        22.878527458547
    ],
    [
        112.99755282137,
        22.878541820967
    ],
    [
        112.99753927521,
        22.878553352481
    ],
    [
        112.9975398182,
        22.878551459159
    ],
    [
        112.99753548359,
        22.878554943142
    ],
    [
        112.99751245267,
        22.878577503449
    ],
    [
        112.99750648906,
        22.878586667534
    ],
    [
        112.9974975573,
        22.878583326647
    ],
    [
        112.99746532046,
        22.878606612723
    ],
    [
        112.99745853896,
        22.878622821027
    ],
    [
        112.99745339598,
        22.878621415461
    ],
    [
        112.99745041523,
        22.878624641522
    ],
    [
        112.99744932102,
        22.878638734733
    ],
    [
        112.99744822811,
        22.878651200606
    ],
    [
        112.99745309646,
        22.878657485571
    ],
    [
        112.99745660183,
        22.878675420149
    ],
    [
        112.99745904173,
        22.878671375224
    ],
    [
        112.99746959735,
        22.878675545147
    ],
    [
        112.99749177466,
        22.878705051128
    ],
    [
        112.99750474553,
        22.878736095969
    ],
    [
        112.99752663633,
        22.878785399284
    ],
    [
        112.9975477437,
        22.878798351146
    ],
    [
        112.99755476888,
        22.878816048881
    ],
    [
        112.99759750129,
        22.878871793773
    ],
    [
        112.9975969564,
        22.87887612809
    ],
    [
        112.9976193429,
        22.878983480241
    ],
    [
        112.9975689318,
        22.879052424067
    ],
    [
        112.99749254401,
        22.879102675791
    ],
    [
        112.99742264304,
        22.879166013151
    ],
    [
        112.99737684991,
        22.879213853266
    ],
    [
        112.9973651841,
        22.879244390497
    ],
    [
        112.99735271321,
        22.879265698463
    ],
    [
        112.99738432807,
        22.8793462833
    ],
    [
        112.99738459693,
        22.87934872691
    ],
    [
        112.99747553421,
        22.879390825739
    ],
    [
        112.99755997885,
        22.879424731314
    ],
    [
        112.99758297214,
        22.87944990732
    ],
    [
        112.99765251079,
        22.879502389006
    ],
    [
        112.99786302939,
        22.879644686994
    ],
    [
        112.99789198489,
        22.87966043485
    ],
    [
        112.99795990242,
        22.8797047803
    ],
    [
        112.99802484513,
        22.879744217316
    ],
    [
        112.99806841278,
        22.87976771054
    ],
    [
        112.99815690038,
        22.879815257576
    ],
    [
        112.9982305086,
        22.879848554722
    ],
    [
        112.99844972513,
        22.879920789113
    ],
    [
        112.99858719211,
        22.87998379222
    ],
    [
        112.99880936356,
        22.880070763737
    ],
    [
        112.99894573882,
        22.880136233438
    ],
    [
        112.99911835584,
        22.880236557021
    ],
    [
        112.99918870677,
        22.880268515814
    ],
    [
        112.99938513654,
        22.880368591685
    ],
    [
        112.99951201808,
        22.88044730368
    ],
    [
        112.99959669916,
        22.880493818897
    ],
    [
        112.99966218345,
        22.880512457244
    ],
    [
        112.99969220302,
        22.880543445149
    ],
    [
        112.99971057914,
        22.880581896323
    ],
    [
        112.99970759114,
        22.880596780129
    ],
    [
        112.99969998063,
        22.880641175673
    ],
    [
        112.99969347208,
        22.880659003231
    ],
    [
        112.99968694445,
        22.880703139878
    ],
    [
        112.99965711561,
        22.880782273446
    ],
    [
        112.99957667487,
        22.880861110145
    ],
    [
        112.99947405691,
        22.880915564758
    ],
    [
        112.99939524322,
        22.880987649524
    ],
    [
        112.99937357242,
        22.881012633824
    ],
    [
        112.99911489322,
        22.881283194651
    ],
    [
        112.99909162253,
        22.881272906095
    ],
    [
        112.99904346106,
        22.881246345573
    ],
    [
        112.99901883981,
        22.881231703963
    ],
    [
        112.99898339392,
        22.881213420033
    ],
    [
        112.9989503828,
        22.881196790619
    ],
    [
        112.9989268384,
        22.881190027972
    ],
    [
        112.99891790658,
        22.881189118367
    ],
    [
        112.99891926284,
        22.881185064469
    ],
    [
        112.99891330159,
        22.881193951089
    ],
    [
        112.99888432967,
        22.88120665955
    ],
    [
        112.99886537877,
        22.881211067639
    ],
    [
        112.99882447945,
        22.88124806063
    ],
    [
        112.99873888604,
        22.8813285197
    ],
    [
        112.99865733664,
        22.88143126787
    ],
    [
        112.99858068241,
        22.881500439766
    ],
    [
        112.9984758569,
        22.881595632205
    ],
    [
        112.99844795747,
        22.881620838013
    ],
    [
        112.99844633571,
        22.88161729517
    ],
    [
        112.99841464675,
        22.881641919893
    ],
    [
        112.99840244942,
        22.881664848299
    ],
    [
        112.99839783151,
        22.881688126429
    ],
    [
        112.99843191681,
        22.881721840907
    ],
    [
        112.9984716844,
        22.881758870138
    ],
    [
        112.99854473767,
        22.881810352214
    ],
    [
        112.99867487842,
        22.881902853137
    ],
    [
        112.99881855731,
        22.881986289262
    ],
    [
        112.99890025837,
        22.882053614686
    ],
    [
        112.99897033438,
        22.882098578769
    ],
    [
        112.99901146515,
        22.882116923905
    ],
    [
        112.99904068947,
        22.882129987923
    ],
    [
        112.99904420896,
        22.882128941103
    ],
    [
        112.99908937658,
        22.882181507648
    ],
    [
        112.99912343445,
        22.882252127308
    ],
    [
        112.99915478907,
        22.882317564943
    ],
    [
        112.99915855213,
        22.882357477247
    ],
    [
        112.99916747367,
        22.882373577395
    ],
    [
        112.99918340407,
        22.882433151503
    ],
    [
        112.99919555588,
        22.882476410483
    ],
    [
        112.99925614407,
        22.882540000898
    ],
    [
        112.99932105985,
        22.882607710295
    ],
    [
        112.99939732889,
        22.882697247381
    ],
    [
        112.99948333719,
        22.882792864525
    ],
    [
        112.99955636866,
        22.882864473058
    ],
    [
        112.99959830421,
        22.882889354702
    ],
    [
        112.99961345981,
        22.882890881252
    ],
    [
        112.99963158718,
        22.88290084969
    ],
    [
        112.99965621837,
        22.882897872464
    ],
    [
        112.99968328566,
        22.882894380729
    ],
    [
        112.99970846004,
        22.882888155761
    ],
    [
        112.99975556355,
        22.882871330613
    ],
    [
        112.99978942203,
        22.882828046641
    ],
    [
        112.99981732697,
        22.882783610721
    ],
    [
        112.99980869795,
        22.882734419089
    ],
    [
        112.9997886997,
        22.882688624208
    ],
    [
        112.9997535566,
        22.882625298724
    ],
    [
        112.99969381305,
        22.882518027246
    ],
    [
        112.99963161383,
        22.882440837668
    ],
    [
        112.99958564913,
        22.882370342707
    ],
    [
        112.99952319005,
        22.88227606753
    ],
    [
        112.99948586967,
        22.88223035486
    ],
    [
        112.99947155141,
        22.882190324018
    ],
    [
        112.99946371719,
        22.882167995662
    ],
    [
        112.99947780636,
        22.88214564036
    ],
    [
        112.99949676406,
        22.882128221728
    ],
    [
        112.99954171434,
        22.88209644755
    ],
    [
        112.99956255955,
        22.882089357796
    ],
    [
        112.99956417802,
        22.882097512913
    ],
    [
        112.99957769504,
        22.882120990518
    ],
    [
        112.99960907378,
        22.882146567608
    ],
    [
        112.99964234785,
        22.882170810612
    ],
    [
        112.99966912478,
        22.882197150931
    ],
    [
        112.99970131548,
        22.882222196835
    ],
    [
        112.99975026326,
        22.882281880089
    ],
    [
        112.99979838405,
        22.882364068028
    ],
    [
        112.99985327722,
        22.88243657062
    ],
    [
        112.99986490038,
        22.8824586733
    ],
    [
        112.99987463812,
        22.882466921621
    ],
    [
        112.99988706452,
        22.88250232411
    ],
    [
        112.99990840914,
        22.882557628935
    ],
    [
        112.99992623024,
        22.88262103069
    ],
    [
        112.99995379249,
        22.882687528192
    ],
    [
        112.99996756753,
        22.882730270274
    ],
    [
        112.99999296587,
        22.882795116315
    ],
    [
        113.00001918105,
        22.88285237772
    ],
    [
        113.00003053282,
        22.882875834892
    ],
    [
        113.00010845559,
        22.882907386309
    ],
    [
        113.00016634531,
        22.882947659377
    ],
    [
        113.00021800453,
        22.88299681278
    ],
    [
        113.0002553162,
        22.883052309686
    ],
    [
        113.00028370743,
        22.883091428884
    ],
    [
        113.00028964753,
        22.883113197328
    ],
    [
        113.00034647214,
        22.883123900745
    ],
    [
        113.00041061002,
        22.883123572197
    ],
    [
        113.00045526403,
        22.88312111693
    ],
    [
        113.00051291943,
        22.88309955988
    ],
    [
        113.00054946529,
        22.883079652169
    ],
    [
        113.00059657841,
        22.883038444045
    ],
    [
        113.00065857488,
        22.882997415822
    ],
    [
        113.00078120132,
        22.882934337286
    ],
    [
        113.00083398998,
        22.882902427427
    ],
    [
        113.00088595714,
        22.882885156159
    ],
    [
        113.00094494067,
        22.882897536753
    ],
    [
        113.00097495541,
        22.882932078313
    ],
    [
        113.00101604633,
        22.88299550681
    ],
    [
        113.00103820437,
        22.883044600268
    ],
    [
        113.00104684736,
        22.883070202214
    ],
    [
        113.00104493679,
        22.883096217335
    ],
    [
        113.00102192688,
        22.88311058225
    ],
    [
        113.00097184484,
        22.883144145813
    ],
    [
        113.00090795525,
        22.883188121293
    ],
    [
        113.00080237845,
        22.883253565128
    ],
    [
        113.00074147301,
        22.883283479779
    ],
    [
        113.00068651714,
        22.883318893123
    ],
    [
        113.00064265563,
        22.883354983871
    ],
    [
        113.00062099031,
        22.883381305601
    ],
    [
        113.00059094414,
        22.883394237024
    ],
    [
        113.0005814428,
        22.883442674733
    ],
    [
        113.00060602918,
        22.8835072512
    ],
    [
        113.00062547156,
        22.883575835099
    ],
    [
        113.0006624995,
        22.883651682198
    ],
    [
        113.0007214551,
        22.88371396092
    ],
    [
        113.00075580249,
        22.883747194162
    ],
    [
        113.0007936782,
        22.883762840496
    ],
    [
        113.00086728785,
        22.883754780889
    ],
    [
        113.00093765313,
        22.883740718277
    ],
    [
        113.00096715908,
        22.883723447615
    ],
    [
        113.00098772815,
        22.883717731516
    ],
    [
        113.00101479837,
        22.883700703302
    ],
    [
        113.00111575774,
        22.883656645362
    ],
    [
        113.00120562031,
        22.883614627
    ],
    [
        113.00129331932,
        22.883569061149
    ],
    [
        113.0013479975,
        22.883537193007
    ],
    [
        113.00141649198,
        22.883477833521
    ],
    [
        113.00142000888,
        22.88347896244
    ],
    [
        113.00141514189,
        22.883473205636
    ],
    [
        113.00141028906,
        22.883444394002
    ],
    [
        113.00142869983,
        22.883426451452
    ],
    [
        113.00147497837,
        22.883412113216
    ],
    [
        113.00148661013,
        22.883417412621
    ],
    [
        113.0014882276,
        22.883427197399
    ],
    [
        113.00149985984,
        22.883431683206
    ],
    [
        113.00152015893,
        22.883422716263
    ],
    [
        113.00157429735,
        22.883386238606
    ],
    [
        113.00163411615,
        22.883352004609
    ],
    [
        113.00168147711,
        22.88333551651
    ],
    [
        113.00170503944,
        22.883299469899
    ],
    [
        113.0017169623,
        22.883271141596
    ],
    [
        113.00170075047,
        22.88323486149
    ],
    [
        113.00167183973,
        22.883169669685
    ],
    [
        113.00163939693,
        22.883127759973
    ],
    [
        113.00160180203,
        22.883103416172
    ],
    [
        113.00156528431,
        22.883086952691
    ],
    [
        113.00151063356,
        22.883076771767
    ],
    [
        113.00150224681,
        22.883074767762
    ],
    [
        113.00147382927,
        22.883084989261
    ],
    [
        113.00145948919,
        22.883083724549
    ],
    [
        113.00143189042,
        22.883082565241
    ],
    [
        113.00135641295,
        22.883057482782
    ],
    [
        113.00131126586,
        22.882992638199
    ],
    [
        113.00128100288,
        22.882924996111
    ],
    [
        113.00125614497,
        22.8828679998
    ],
    [
        113.00125130337,
        22.882822643679
    ],
    [
        113.00124647372,
        22.882758843824
    ],
    [
        113.00127165675,
        22.882730676462
    ],
    [
        113.00130848127,
        22.882692889776
    ],
    [
        113.00138265859,
        22.88263658335
    ],
    [
        113.0014611639,
        22.882581419788
    ],
    [
        113.00151205288,
        22.882551409013
    ],
    [
        113.00154398572,
        22.882544758555
    ],
    [
        113.00158186402,
        22.882549033091
    ],
    [
        113.00164651928,
        22.882568565056
    ],
    [
        113.00169275869,
        22.882613090788
    ],
    [
        113.00173114572,
        22.882666197594
    ],
    [
        113.00176140981,
        22.882728152679
    ],
    [
        113.00180113163,
        22.882809215407
    ],
    [
        113.00183086386,
        22.882856789737
    ],
    [
        113.00184382283,
        22.882901166553
    ],
    [
        113.00186680698,
        22.882923430555
    ],
    [
        113.0018678927,
        22.882918019763
    ],
    [
        113.00190386996,
        22.882930957485
    ],
    [
        113.00196448556,
        22.882917089329
    ],
    [
        113.00204027442,
        22.882868430159
    ],
    [
        113.00214148646,
        22.882833394893
    ],
    [
        113.00215285799,
        22.882820794492
    ],
    [
        113.00216530739,
        22.882814989034
    ],
    [
        113.00219832329,
        22.882802670323
    ],
    [
        113.00221429086,
        22.882795283637
    ],
    [
        113.00223539648,
        22.882791761369
    ],
    [
        113.00224216396,
        22.882786153693
    ],
    [
        113.00226163573,
        22.882798884523
    ],
    [
        113.00228541071,
        22.882851543266
    ],
    [
        113.00229510913,
        22.882916495061
    ],
    [
        113.00230426471,
        22.88298442343
    ],
    [
        113.00231124272,
        22.883073479706
    ],
    [
        113.00233228983,
        22.883162449066
    ],
    [
        113.00235550515,
        22.883245751264
    ],
    [
        113.00237168426,
        22.883332487564
    ],
    [
        113.00238895706,
        22.883401065674
    ],
    [
        113.00239409545,
        22.883404388
    ],
    [
        113.00240299095,
        22.883457395833
    ],
    [
        113.00240866294,
        22.883472930826
    ],
    [
        113.00241783509,
        22.883516177921
    ],
    [
        113.00248808395,
        22.8836698093
    ],
    [
        113.00249886818,
        22.883732064747
    ],
    [
        113.00252101979,
        22.88378714713
    ],
    [
        113.00255156607,
        22.883829321595
    ],
    [
        113.00255993908,
        22.883852487555
    ],
    [
        113.00255749593,
        22.883866288268
    ],
    [
        113.00256748511,
        22.883901410087
    ],
    [
        113.00258180315,
        22.883936318121
    ],
    [
        113.00259937736,
        22.883954995282
    ],
    [
        113.00262858282,
        22.883977081965
    ],
    [
        113.00264670156,
        22.883989799675
    ],
    [
        113.00265534325,
        22.884016224581
    ],
    [
        113.00268185022,
        22.884026341927
    ],
    [
        113.00268482134,
        22.884034518608
    ],
    [
        113.00271726757,
        22.884065872149
    ],
    [
        113.00272997464,
        22.884079874807
    ],
    [
        113.00278026014,
        22.884138591568
    ],
    [
        113.00281108055,
        22.884173993829
    ],
    [
        113.00281808864,
        22.884218299427
    ],
    [
        113.00282619864,
        22.884228715166
    ],
    [
        113.00284130663,
        22.884301066974
    ],
    [
        113.00286480224,
        22.88437190418
    ],
    [
        113.00289777449,
        22.884429036089
    ],
    [
        113.00294021728,
        22.884482770217
    ],
    [
        113.00299996633,
        22.884549758698
    ],
    [
        113.00304673819,
        22.884601926727
    ],
    [
        113.00309133748,
        22.8846687135
    ],
    [
        113.00311917493,
        22.88471628699
    ],
    [
        113.00315376984,
        22.884773988741
    ],
    [
        113.0031670186,
        22.884786374825
    ],
    [
        113.00322324817,
        22.884856849769
    ],
    [
        113.00356716359,
        22.885188151595
    ],
    [
        113.00362341397,
        22.885217140784
    ],
    [
        113.00363720295,
        22.885230080606
    ],
    [
        113.00397814127,
        22.885036575907
    ],
    [
        113.00399382584,
        22.885044391725
    ],
    [
        113.00399139154,
        22.885044086158
    ],
    [
        113.00416385905,
        22.88524344651
    ],
    [
        113.00421387217,
        22.88529515045
    ],
    [
        113.00420873319,
        22.885294534864
    ],
    [
        113.00422927999,
        22.885314085285
    ],
    [
        113.00426306761,
        22.885358236251
    ],
    [
        113.00428712692,
        22.885384889669
    ],
    [
        113.00433416162,
        22.885441708126
    ],
    [
        113.00435632801,
        22.885467250477
    ],
    [
        113.00436768518,
        22.88547338029
    ],
    [
        113.00449715959,
        22.885640152448
    ],
    [
        113.00456608771,
        22.885726043708
    ],
    [
        113.00460176947,
        22.885767787346
    ],
    [
        113.00466695819,
        22.885760592799
    ],
    [
        113.00474432077,
        22.885747610002
    ],
    [
        113.00475866428,
        22.885731272636
    ],
    [
        113.00478327996,
        22.88572620561
    ],
    [
        113.00479924122,
        22.885719656761
    ],
    [
        113.00482900383,
        22.885698933268
    ],
    [
        113.00483361681,
        22.885669977695
    ],
    [
        113.0048355257,
        22.885639897776
    ],
    [
        113.00483445665,
        22.885615199293
    ],
    [
        113.00482312139,
        22.885568109545
    ],
    [
        113.00473608953,
        22.885452923123
    ],
    [
        113.00466770387,
        22.885368660945
    ],
    [
        113.00460688279,
        22.885300513797
    ],
    [
        113.00457201715,
        22.885251729769
    ],
    [
        113.00431361117,
        22.884928228998
    ],
    [
        113.00440614458,
        22.884878831358
    ],
    [
        113.00443645522,
        22.884849158586
    ],
    [
        113.00444918411,
        22.884820047512
    ],
    [
        113.00444918501,
        22.884818420092
    ],
    [
        113.00445298489,
        22.88479487688
    ],
    [
        113.00446165267,
        22.884772759798
    ],
    [
        113.00445977857,
        22.884738285562
    ],
    [
        113.00395706053,
        22.88405249802
    ],
    [
        113.00396572312,
        22.884041228061
    ],
    [
        113.00399603721,
        22.884010191829
    ],
    [
        113.00401254348,
        22.884000117693
    ],
    [
        113.00403663466,
        22.883971435496
    ],
    [
        113.00404827699,
        22.883952884654
    ],
    [
        113.00405992514,
        22.883924569449
    ],
    [
        113.0040786011,
        22.883904762097
    ],
    [
        113.00409430211,
        22.883884099112
    ],
    [
        113.00410487043,
        22.883852242855
    ],
    [
        113.00412435522,
        22.883836787243
    ],
    [
        113.00415033696,
        22.883812744464
    ],
    [
        113.00417929125,
        22.883793355322
    ],
    [
        113.00419607463,
        22.883771894928
    ],
    [
        113.00421771828,
        22.883764608142
    ],
    [
        113.00422665338,
        22.883749817297
    ],
    [
        113.00424127182,
        22.883729953942
    ],
    [
        113.00426238227,
        22.883709640764
    ],
    [
        113.00427808938,
        22.883678672548
    ],
    [
        113.00429082001,
        22.883649560656
    ],
    [
        113.00428866668,
        22.883632170814
    ],
    [
        113.00429218944,
        22.883621642873
    ],
    [
        113.00431411413,
        22.88359673093
    ],
    [
        113.00432737286,
        22.883588783272
    ],
    [
        113.00432873042,
        22.883580394354
    ],
    [
        113.00435119355,
        22.88355955911
    ],
    [
        113.00508826698,
        22.88442356263
    ],
    [
        113.00509096849,
        22.884429027116
    ],
    [
        113.00512313474,
        22.88446204899
    ],
    [
        113.00513340604,
        22.884473049766
    ],
    [
        113.00516233072,
        22.884498972384
    ],
    [
        113.00520153448,
        22.884522063564
    ],
    [
        113.00521559941,
        22.884520372606
    ],
    [
        113.00523101352,
        22.884524126457
    ],
    [
        113.0053037847,
        22.884493197269
    ],
    [
        113.00530351858,
        22.884485598658
    ],
    [
        113.00540931387,
        22.88440417034
    ],
    [
        113.00545854695,
        22.884386187753
    ],
    [
        113.00549911569,
        22.884384893886
    ],
    [
        113.00552129322,
        22.884384139913
    ],
    [
        113.00552994401,
        22.884390507558
    ],
    [
        113.00557266292,
        22.884412031315
    ],
    [
        113.00556589984,
        22.884415185034
    ],
    [
        113.00557725679,
        22.884418609738
    ],
    [
        113.00557536366,
        22.884418581421
    ],
    [
        113.0056310309,
        22.884497802644
    ],
    [
        113.00568804001,
        22.884595218609
    ],
    [
        113.00574854392,
        22.884730119804
    ],
    [
        113.00581305852,
        22.884948896341
    ],
    [
        113.00587600975,
        22.885061868305
    ],
    [
        113.00596871577,
        22.885163358497
    ],
    [
        113.00597033428,
        22.885170977738
    ],
    [
        113.00602168737,
        22.885227089572
    ],
    [
        113.00606385925,
        22.885257566585
    ],
    [
        113.00610522478,
        22.885278538802
    ],
    [
        113.00612225744,
        22.885287477812
    ],
    [
        113.00613955978,
        22.885297777273
    ],
    [
        113.00615469661,
        22.885311841226
    ],
    [
        113.00620849659,
        22.885342498536
    ],
    [
        113.0062549992,
        22.885364637188
    ],
    [
        113.00629042358,
        22.885368705384
    ],
    [
        113.00634802999,
        22.885359823528
    ],
    [
        113.00647733311,
        22.885287762237
    ],
    [
        113.00652764586,
        22.885262498586
    ],
    [
        113.00657633178,
        22.885244805716
    ],
    [
        113.00659716139,
        22.885231836795
    ],
    [
        113.00668209597,
        22.885191109014
    ],
    [
        113.00674863101,
        22.885169628099
    ],
    [
        113.00682246172,
        22.885157756116
    ],
    [
        113.00688331105,
        22.885147582917
    ],
    [
        113.00699228553,
        22.885152539086
    ],
    [
        113.00711423368,
        22.885166655028
    ],
    [
        113.00720508121,
        22.885185170433
    ],
    [
        113.00726970145,
        22.88519839368
    ],
    [
        113.00728430314,
        22.885198895079
    ],
    [
        113.00736785845,
        22.885198857704
    ],
    [
        113.00747791983,
        22.885185410073
    ],
    [
        113.00758473541,
        22.885171916033
    ],
    [
        113.00764855587,
        22.885160183036
    ],
    [
        113.00768588044,
        22.885142333298
    ],
    [
        113.00776944144,
        22.885126578397
    ],
    [
        113.00785056435,
        22.885118110842
    ],
    [
        113.007907349,
        22.88511413807
    ],
    [
        113.00798630937,
        22.885102927975
    ],
    [
        113.00802713656,
        22.885106025202
    ],
    [
        113.00807688858,
        22.885105198161
    ],
    [
        113.00807310466,
        22.885102424855
    ],
    [
        113.00816449809,
        22.885097930342
    ],
    [
        113.00827536503,
        22.885081548308
    ],
    [
        113.00836080879,
        22.885076693409
    ],
    [
        113.00843545069,
        22.88504644064
    ],
    [
        113.0084511365,
        22.885039643179
    ],
    [
        113.00847142408,
        22.885023155979
    ],
    [
        113.0085274162,
        22.884980397054
    ],
    [
        113.00856205738,
        22.88492128839
    ],
    [
        113.00860182834,
        22.884875554549
    ],
    [
        113.00862673689,
        22.884814931944
    ],
    [
        113.0086611091,
        22.884753650361
    ],
    [
        113.00866923666,
        22.884724760499
    ],
    [
        113.00867114965,
        22.884688716982
    ],
    [
        113.00867873285,
        22.884666328004
    ],
    [
        113.00870881033,
        22.884550729286
    ],
    [
        113.00874238646,
        22.884464210718
    ],
    [
        113.00876975185,
        22.88436457156
    ],
    [
        113.0088344313,
        22.884261204235
    ],
    [
        113.00889830158,
        22.884154841641
    ],
    [
        113.00895999528,
        22.884071771262
    ],
    [
        113.00902249105,
        22.884003904796
    ],
    [
        113.00902681546,
        22.884006417101
    ],
    [
        113.00910743941,
        22.883915795851
    ],
    [
        113.00916803052,
        22.883867701606
    ],
    [
        113.00924727499,
        22.883822358206
    ],
    [
        113.00933570136,
        22.883793714555
    ],
    [
        113.00946090075,
        22.883757818315
    ],
    [
        113.00955608185,
        22.883734175798
    ],
    [
        113.00963936576,
        22.88371196539
    ],
    [
        113.00972940393,
        22.883696650976
    ],
    [
        113.00979401426,
        22.883704240285
    ],
    [
        113.00988565757,
        22.883715267228
    ],
    [
        113.00999754946,
        22.883771119477
    ],
    [
        113.01010214147,
        22.883826581672
    ],
    [
        113.01019672575,
        22.883889202057
    ],
    [
        113.01029238109,
        22.883968388742
    ],
    [
        113.01033047939,
        22.884002665312
    ],
    [
        113.01037560703,
        22.884036247407
    ],
    [
        113.01045343429,
        22.88408991245
    ],
    [
        113.0106418534,
        22.88410585451
    ],
    [
        113.01075618996,
        22.884134921319
    ],
    [
        113.01083861366,
        22.884184875832
    ],
    [
        113.0108748211,
        22.88421505764
    ],
    [
        113.01097289264,
        22.884318444551
    ],
    [
        113.01102284548,
        22.884420198102
    ],
    [
        113.01104849487,
        22.884476240186
    ],
    [
        113.01108365367,
        22.884449717382
    ],
    [
        113.01112828581,
        22.884403014136
    ],
    [
        113.01116346256,
        22.884345571259
    ],
    [
        113.01120974567,
        22.884249531982
    ],
    [
        113.01124252274,
        22.884136173848
    ],
    [
        113.01129883107,
        22.884002876897
    ],
    [
        113.01134541807,
        22.883853139788
    ],
    [
        113.01135380151,
        22.883847858971
    ],
    [
        113.01139011698,
        22.883697946239
    ],
    [
        113.01142316532,
        22.883587035887
    ],
    [
        113.01145973867,
        22.883459641113
    ],
    [
        113.01149032813,
        22.883391815737
    ],
    [
        113.01157819234,
        22.883379766321
    ],
    [
        113.01157197725,
        22.883375861979
    ],
    [
        113.01180475215,
        22.883337564391
    ],
    [
        113.0121510211,
        22.88379842328
    ],
    [
        113.01216393637,
        22.883897648872
    ],
    [
        113.01210067609,
        22.883906315911
    ],
    [
        113.012111442,
        22.88398434767
    ],
    [
        113.01215441945,
        22.883990246792
    ],
    [
        113.01220793789,
        22.883998499234
    ],
    [
        113.01220415264,
        22.883999789692
    ],
    [
        113.0122359777,
        22.884121585499
    ],
    [
        113.01223868296,
        22.884118106405
    ],
    [
        113.01245466501,
        22.884121863065
    ],
    [
        113.01249656289,
        22.884123949081
    ],
    [
        113.0126227964,
        22.884130761072
    ],
    [
        113.01261094434,
        22.882762711085
    ],
    [
        113.01274718141,
        22.882765360755
    ],
    [
        113.0128198924,
        22.882770700069
    ],
    [
        113.01288341744,
        22.882768556283
    ],
    [
        113.01290314582,
        22.882775411101
    ],
    [
        113.01309830935,
        22.882778015811
    ],
    [
        113.01309632283,
        22.882923362807
    ],
    [
        113.01310875717,
        22.882923309582
    ],
    [
        113.01311524438,
        22.882923694567
    ],
    [
        113.01312333874,
        22.882946891475
    ],
    [
        113.01316090869,
        22.882951890192
    ],
    [
        113.013158196,
        22.882966760528
    ],
    [
        113.01315981976,
        22.882963805428
    ],
    [
        113.01317061704,
        22.882987321058
    ],
    [
        113.01316710182,
        22.882989158033
    ],
    [
        113.01317223313,
        22.882996300167
    ],
    [
        113.01320548055,
        22.882997426034
    ],
    [
        113.01321088896,
        22.882993994897
    ],
    [
        113.01324900222,
        22.882994663927
    ],
    [
        113.01327359994,
        22.882995367067
    ],
    [
        113.01331063468,
        22.882991677769
    ],
    [
        113.01332847453,
        22.882992533648
    ],
    [
        113.01333414049,
        22.883008907301
    ],
    [
        113.01335300454,
        22.883098746378
    ],
    [
        113.01337159793,
        22.883189665758
    ],
    [
        113.01337105783,
        22.883188842559
    ],
    [
        113.01336808775,
        22.883183636884
    ],
    [
        113.01329482778,
        22.883193470378
    ],
    [
        113.0131161497,
        22.883198471684
    ],
    [
        113.01311018264,
        22.883230372844
    ],
    [
        113.0131136927,
        22.883236672808
    ],
    [
        113.01311189166,
        22.883522523824
    ],
    [
        113.01308864771,
        22.883518047754
    ],
    [
        113.01307527886,
        22.883718528318
    ],
    [
        113.01307820985,
        22.88378801628
    ],
    [
        113.01307874683,
        22.883793992901
    ],
    [
        113.01308279881,
        22.883798403718
    ],
    [
        113.01308847808,
        22.883793892252
    ],
    [
        113.01309766079,
        22.883806801366
    ],
    [
        113.01313226068,
        22.883806594368
    ],
    [
        113.01318307764,
        22.883808841988
    ],
    [
        113.01364227552,
        22.883900456496
    ],
    [
        113.01365038397,
        22.883901684285
    ],
    [
        113.01384799354,
        22.883874789673
    ],
    [
        113.0139344958,
        22.883866823066
    ],
    [
        113.01393395733,
        22.88386328748
    ],
    [
        113.01396013583,
        22.883931016459
    ],
    [
        113.01399223574,
        22.884041163147
    ],
    [
        113.01399547805,
        22.884043390311
    ],
    [
        113.01394599722,
        22.884068826542
    ],
    [
        113.01394843155,
        22.88406615715
    ],
    [
        113.0139454584,
        22.884065833418
    ],
    [
        113.0139557164,
        22.88408852724
    ],
    [
        113.01395245548,
        22.884117492065
    ],
    [
        113.01395271464,
        22.884136212026
    ],
    [
        113.01395161747,
        22.884163045167
    ],
    [
        113.01394998086,
        22.884187970127
    ],
    [
        113.01394375526,
        22.884202507038
    ],
    [
        113.01394185305,
        22.884219561425
    ],
    [
        113.01394076847,
        22.884225238267
    ],
    [
        113.01394616505,
        22.884241336572
    ],
    [
        113.01393669362,
        22.884259613515
    ],
    [
        113.013935599,
        22.884282378163
    ],
    [
        113.01393530655,
        22.884320075061
    ],
    [
        113.01393800351,
        22.884330429716
    ],
    [
        113.0139417766,
        22.884349482986
    ],
    [
        113.01390176566,
        22.884359626191
    ],
    [
        113.01390041114,
        22.884364755805
    ],
    [
        113.01390041034,
        22.884366111981
    ],
    [
        113.01389604534,
        22.884434929407
    ],
    [
        113.0139036059,
        22.884448624761
    ],
    [
        113.01392247829,
        22.884533041758
    ],
    [
        113.01396377028,
        22.884645249815
    ],
    [
        113.01400111744,
        22.885044630804
    ],
    [
        113.01402487105,
        22.885104451864
    ],
    [
        113.01404539401,
        22.885140889323
    ],
    [
        113.01404997898,
        22.885159414636
    ],
    [
        113.01406212285,
        22.885195432868
    ],
    [
        113.01405913605,
        22.885220062919
    ],
    [
        113.01406102015,
        22.885234743167
    ],
    [
        113.01405750269,
        22.885241190772
    ],
    [
        113.01404532409,
        22.885268642067
    ],
    [
        113.01403421657,
        22.885314827874
    ],
    [
        113.01408685784,
        22.885440528575
    ],
    [
        113.01421103798,
        22.88574054649
    ],
    [
        113.01425182487,
        22.885795516238
    ],
    [
        113.01427262577,
        22.885819211022
    ],
    [
        113.01435717991,
        22.885916184516
    ],
    [
        113.01437068591,
        22.885933783086
    ],
    [
        113.01442174738,
        22.885983239507
    ],
    [
        113.01450171366,
        22.886066842297
    ],
    [
        113.01454521245,
        22.886105315732
    ],
    [
        113.01465138542,
        22.886214067276
    ],
    [
        113.01470298729,
        22.886264619747
    ],
    [
        113.014754593,
        22.886307577754
    ],
    [
        113.01475729219,
        22.88631522043
    ],
    [
        113.01483752471,
        22.886408595375
    ],
    [
        113.01497557384,
        22.88655833112
    ],
    [
        113.01511229018,
        22.886670613221
    ],
    [
        113.01517281608,
        22.886713731532
    ],
    [
        113.01520117321,
        22.886764144334
    ],
    [
        113.01528355173,
        22.886895263253
    ],
    [
        113.01539917664,
        22.887028059002
    ],
    [
        113.01553128901,
        22.887163590176
    ],
    [
        113.01573769207,
        22.88739104051
    ],
    [
        113.01576902265,
        22.8874442198
    ],
    [
        113.01583520503,
        22.88753463778
    ],
    [
        113.01582087355,
        22.887547944876
    ],
    [
        113.0157470518,
        22.887619324375
    ],
    [
        113.01564377076,
        22.887684483627
    ],
    [
        113.01555669793,
        22.887772173931
    ],
    [
        113.01545340609,
        22.887863644816
    ],
    [
        113.01542582627,
        22.887886481382
    ],
    [
        113.01539932479,
        22.887916118329
    ],
    [
        113.01536092803,
        22.887951239942
    ],
    [
        113.01534767716,
        22.887966465333
    ],
    [
        113.01531928293,
        22.887997967484
    ],
    [
        113.01532468858,
        22.8879986061
    ],
    [
        113.0151973313,
        22.888114062915
    ],
    [
        113.01513920406,
        22.88814693569
    ],
    [
        113.01511541214,
        22.888161160239
    ],
    [
        113.01504728147,
        22.888200094321
    ],
    [
        113.01503593215,
        22.888192297797
    ],
    [
        113.0149613428,
        22.888161135866
    ],
    [
        113.01473704148,
        22.888049198487
    ],
    [
        113.01465052756,
        22.888093775993
    ],
    [
        113.01465403741,
        22.888103603114
    ],
    [
        113.01461022458,
        22.888163314324
    ],
    [
        113.0145355842,
        22.888256656519
    ],
    [
        113.01446229134,
        22.888360873097
    ],
    [
        113.01440145014,
        22.888420826196
    ],
    [
        113.01436819523,
        22.88844112343
    ],
    [
        113.01433412634,
        22.888469272556
    ],
    [
        113.01416351998,
        22.888588858211
    ],
    [
        113.01412187713,
        22.888631521648
    ],
    [
        113.01410456963,
        22.888652915558
    ],
    [
        113.01409374428,
        22.888687715235
    ],
    [
        113.01409454281,
        22.888720279138
    ],
    [
        113.01409830764,
        22.888771611619
    ],
    [
        113.0141028651,
        22.888872325383
    ],
    [
        113.01408444896,
        22.88896883571
    ],
    [
        113.01408930869,
        22.888984382787
    ],
    [
        113.01406037184,
        22.889024287515
    ],
    [
        113.01404495468,
        22.88905168251
    ],
    [
        113.01404062584,
        22.889062727242
    ],
    [
        113.01401953869,
        22.889072662169
    ],
    [
        113.01398952818,
        22.889091933268
    ],
    [
        113.01396357706,
        22.889097713699
    ],
    [
        113.01389815748,
        22.889115274951
    ],
    [
        113.01381759848,
        22.889139350913
    ],
    [
        113.01374028519,
        22.889157246217
    ],
    [
        113.01364809383,
        22.889206616401
    ],
    [
        113.01360429827,
        22.889224018713
    ],
    [
        113.01348993476,
        22.889293073035
    ],
    [
        113.01336260209,
        22.88934562639
    ],
    [
        113.01334232158,
        22.889367241233
    ],
    [
        113.01332691013,
        22.889378634191
    ],
    [
        113.01332230689,
        22.889401880816
    ],
    [
        113.01332093224,
        22.889469397944
    ],
    [
        113.01333037289,
        22.889528696371
    ],
    [
        113.01335358535,
        22.889630009438
    ],
    [
        113.01341193611,
        22.889737636681
    ],
    [
        113.01349028995,
        22.889845345206
    ],
    [
        113.01351972134,
        22.889945412316
    ],
    [
        113.0135334993,
        22.88996952493
    ],
    [
        113.01357346816,
        22.890085781714
    ],
    [
        113.01357697557,
        22.890107001108
    ],
    [
        113.01361262181,
        22.890218299621
    ],
    [
        113.01401807052,
        22.890238742813
    ],
    [
        113.01404290069,
        22.89036450005
    ],
    [
        113.01405802496,
        22.890407353931
    ],
    [
        113.01409529077,
        22.890530618743
    ],
    [
        113.01409663279,
        22.890563735322
    ],
    [
        113.0140971301,
        22.890717544667
    ],
    [
        113.01411221209,
        22.890919081455
    ],
    [
        113.01410027101,
        22.891101424424
    ],
    [
        113.01408809881,
        22.891135116091
    ],
    [
        113.0140607929,
        22.891156605152
    ],
    [
        113.01403537917,
        22.891177856482
    ],
    [
        113.01403212926,
        22.89120275449
    ],
    [
        113.01404049246,
        22.891267189618
    ],
    [
        113.01409992959,
        22.89138569337
    ],
    [
        113.01416234329,
        22.89149312883
    ],
    [
        113.01419419995,
        22.891659700628
    ],
    [
        113.01428875175,
        22.891898993758
    ],
    [
        113.01434033494,
        22.892107960659
    ],
    [
        113.01435787957,
        22.892230879493
    ],
    [
        113.01435679768,
        22.892234386684
    ],
    [
        113.01441460472,
        22.892425290576
    ],
    [
        113.01444810524,
        22.892514042756
    ],
    [
        113.01452104888,
        22.892720948912
    ],
    [
        113.01462047985,
        22.892952467648
    ],
    [
        113.0147085599,
        22.893191110484
    ],
    [
        113.01476798188,
        22.893500587582
    ],
    [
        113.01477661024,
        22.893666481094
    ],
    [
        113.01478715052,
        22.893676976044
    ],
    [
        113.01481066584,
        22.893680919727
    ],
    [
        113.01483120792,
        22.893684539425
    ],
    [
        113.01497608532,
        22.893694978118
    ],
    [
        113.015401535,
        22.893651000316
    ],
    [
        113.01583022584,
        22.893611430118
    ],
    [
        113.01648785496,
        22.893561296402
    ],
    [
        113.01664138312,
        22.893546942149
    ],
    [
        113.01673652497,
        22.893556232366
    ],
    [
        113.01679950241,
        22.89356223692
    ],
    [
        113.01680787749,
        22.893593038578
    ],
    [
        113.01679570031,
        22.893704038672
    ],
    [
        113.01678514615,
        22.893809913829
    ],
    [
        113.01677622095,
        22.893857496863
    ],
    [
        113.01675432378,
        22.893887759353
    ],
    [
        113.01671729366,
        22.893887913478
    ],
    [
        113.01669648067,
        22.893891882893
    ],
    [
        113.01666837063,
        22.893888398242
    ],
    [
        113.01665080139,
        22.893890255341
    ],
    [
        113.01664323383,
        22.893884695292
    ],
    [
        113.01661674563,
        22.893880425738
    ],
    [
        113.01657376987,
        22.893873692354
    ],
    [
        113.01653755094,
        22.893871148263
    ],
    [
        113.01650349383,
        22.893873254131
    ],
    [
        113.01645213827,
        22.893872881721
    ],
    [
        113.01635293956,
        22.893884406271
    ],
    [
        113.01627185054,
        22.893895168454
    ],
    [
        113.01613697346,
        22.893904158793
    ],
    [
        113.01602398907,
        22.893921948473
    ],
    [
        113.01594857602,
        22.893933897235
    ],
    [
        113.01588586599,
        22.893952582631
    ],
    [
        113.01587342991,
        22.893976503495
    ],
    [
        113.01587315466,
        22.894023155654
    ],
    [
        113.01588259918,
        22.894179028359
    ],
    [
        113.01590501254,
        22.894410272089
    ],
    [
        113.01590797798,
        22.894505267017
    ],
    [
        113.01591148548,
        22.894586979773
    ],
    [
        113.01591472768,
        22.89460466964
    ],
    [
        113.01589850784,
        22.894635576127
    ],
    [
        113.01584850325,
        22.894641196056
    ],
    [
        113.01569497529,
        22.894662062745
    ],
    [
        113.01550847253,
        22.894666067817
    ],
    [
        113.01518655075,
        22.89468719807
    ],
    [
        113.01488462974,
        22.894705706117
    ],
    [
        113.01482435314,
        22.894714672979
    ],
    [
        113.0148043506,
        22.894724083503
    ],
    [
        113.01476353451,
        22.894744789114
    ],
    [
        113.01475596527,
        22.894759303078
    ],
    [
        113.01477055338,
        22.894888683685
    ],
    [
        113.01485540931,
        22.895242562673
    ],
    [
        113.01485865103,
        22.895291447991
    ],
    [
        113.01484108099,
        22.895314464966
    ],
    [
        113.01480864451,
        22.895343185984
    ],
    [
        113.01477620903,
        22.895341796625
    ],
    [
        113.0146532231,
        22.895375150885
    ],
    [
        113.01441454991,
        22.895397776555
    ],
    [
        113.01415587338,
        22.895422495725
    ],
    [
        113.01401369567,
        22.89542161056
    ],
    [
        113.01372366239,
        22.895419476398
    ],
    [
        113.01360148526,
        22.89542844565
    ],
    [
        113.01359499763,
        22.895441623433
    ],
    [
        113.0135925634,
        22.895501801628
    ],
    [
        113.01359742713,
        22.895583538412
    ],
    [
        113.0135998583,
        22.895678524489
    ],
    [
        113.01358093669,
        22.895707488095
    ],
    [
        113.01356093401,
        22.895726667127
    ],
    [
        113.01345767777,
        22.895739769773
    ],
    [
        113.01329981944,
        22.895762222801
    ],
    [
        113.01320899644,
        22.895782871981
    ],
    [
        113.01317385648,
        22.89579771755
    ],
    [
        113.01310438752,
        22.895804365825
    ],
    [
        113.01301004994,
        22.895833365626
    ],
    [
        113.01292436207,
        22.895843529651
    ],
    [
        113.01289814201,
        22.89586205947
    ],
    [
        113.0128805719,
        22.895864735981
    ],
    [
        113.01286435324,
        22.895920875829
    ],
    [
        113.01286462409,
        22.896061668385
    ],
    [
        113.01289490518,
        22.896430851596
    ],
    [
        113.01290085216,
        22.89643719484
    ],
    [
        113.01290572085,
        22.89654009092
    ],
    [
        113.01293736907,
        22.897019435691
    ],
    [
        113.01295740814,
        22.897520552632
    ],
    [
        113.01297262025,
        22.898234537076
    ],
    [
        113.01297510354,
        22.898611651436
    ],
    [
        113.0129932682,
        22.898964084495
    ],
    [
        113.01299761206,
        22.89907836761
    ],
    [
        113.01298901307,
        22.899366583535
    ],
    [
        113.01297685668,
        22.899406790845
    ],
    [
        113.01292577925,
        22.899463949799
    ],
    [
        113.01289739804,
        22.899469963742
    ],
    [
        113.01282144796,
        22.89950471506
    ],
    [
        113.01269143154,
        22.899517634766
    ],
    [
        113.01251897498,
        22.899527647567
    ],
    [
        113.01234948784,
        22.899522797569
    ],
    [
        113.01213458802,
        22.899526117398
    ],
    [
        113.01201024194,
        22.899524775474
    ],
    [
        113.01195942513,
        22.899540172066
    ],
    [
        113.01194537149,
        22.899555120306
    ],
    [
        113.01193861732,
        22.899574535355
    ],
    [
        113.0119132227,
        22.899651952479
    ],
    [
        113.01190243756,
        22.89978740465
    ],
    [
        113.01188868317,
        22.89993826852
    ],
    [
        113.01189140772,
        22.900036247086
    ],
    [
        113.01190628917,
        22.900098898555
    ],
    [
        113.01194766454,
        22.900172588497
    ],
    [
        113.01206176182,
        22.900273581667
    ],
    [
        113.01214180015,
        22.900378327116
    ],
    [
        113.01221561996,
        22.9004767266
    ],
    [
        113.01224320788,
        22.900541227784
    ],
    [
        113.01225376744,
        22.900610858864
    ],
    [
        113.01225946061,
        22.900676607531
    ],
    [
        113.01222704708,
        22.900771263745
    ],
    [
        113.01216787766,
        22.900884445424
    ],
    [
        113.01210572759,
        22.900969091784
    ],
    [
        113.01209790025,
        22.901012903533
    ],
    [
        113.01210982163,
        22.901113212994
    ],
    [
        113.01212794546,
        22.901158831348
    ],
    [
        113.01216775031,
        22.901399063725
    ],
    [
        113.0121736972,
        22.901398895668
    ],
    [
        113.01217585997,
        22.901399747056
    ],
    [
        113.01222857481,
        22.901411513689
    ],
    [
        113.01222859656,
        22.901485574062
    ],
    [
        113.01225565945,
        22.901591030452
    ],
    [
        113.01225648227,
        22.901630380704
    ],
    [
        113.01225270164,
        22.90164279401
    ],
    [
        113.01226000528,
        22.901659740434
    ],
    [
        113.01223578172,
        22.901994354094
    ],
    [
        113.01222956498,
        22.901995873806
    ],
    [
        113.01200439626,
        22.902009330145
    ],
    [
        113.01178814935,
        22.902033531762
    ],
    [
        113.01177652588,
        22.902034416137
    ],
    [
        113.01170923536,
        22.90209347948
    ],
    [
        113.01170114674,
        22.902157362897
    ],
    [
        113.01173793661,
        22.902236398869
    ],
    [
        113.01175389487,
        22.902264345346
    ],
    [
        113.01174579966,
        22.902307068493
    ],
    [
        113.01175418542,
        22.902324304179
    ],
    [
        113.01175771121,
        22.902358546884
    ],
    [
        113.01175528637,
        22.902382106763
    ],
    [
        113.01176475273,
        22.902397190863
    ],
    [
        113.01175880891,
        22.902406583188
    ],
    [
        113.01175421782,
        22.902419254291
    ],
    [
        113.01174989939,
        22.902438712224
    ],
    [
        113.01174287056,
        22.902437234457
    ],
    [
        113.01172611519,
        22.902450238191
    ],
    [
        113.01170151793,
        22.902455782001
    ],
    [
        113.01168395025,
        22.902464973902
    ],
    [
        113.01166718931,
        22.902461971977
    ],
    [
        113.01164664805,
        22.902471112754
    ],
    [
        113.01163069767,
        22.902467039809
    ],
    [
        113.01159744967,
        22.902471621269
    ],
    [
        113.01158555599,
        22.902473044083
    ],
    [
        113.01156501099,
        22.902471605091
    ],
    [
        113.01155798031,
        22.90246497319
    ],
    [
        113.01153906353,
        22.902481738439
    ],
    [
        113.01153988054,
        22.902499114727
    ],
    [
        113.01153934159,
        22.902503988575
    ],
    [
        113.01154042392,
        22.90250699134
    ],
    [
        113.01154204634,
        22.902508375694
    ],
    [
        113.01154340014,
        22.902514638551
    ],
    [
        113.0115385378,
        22.902524592384
    ],
    [
        113.01153259512,
        22.902537240477
    ],
    [
        113.01152773203,
        22.902545024033
    ],
    [
        113.01152367935,
        22.902551193833
    ],
    [
        113.01151611464,
        22.902563542751
    ],
    [
        113.01150124801,
        22.902566813642
    ],
    [
        113.0114901665,
        22.902571777409
    ],
    [
        113.0114842224,
        22.902580356278
    ],
    [
        113.01147962993,
        22.902588958404
    ],
    [
        113.01146854621,
        22.902587682637
    ],
    [
        113.01147666785,
        22.902621461662
    ],
    [
        113.0113731409,
        22.902641927757
    ],
    [
        113.01139541775,
        22.902945607623
    ],
    [
        113.01141111756,
        22.903002033565
    ],
    [
        113.01143414823,
        22.903142955642
    ],
    [
        113.01161368807,
        22.903261613739
    ],
    [
        113.01164349689,
        22.903449586791
    ],
    [
        113.01165247044,
        22.903582401003
    ],
    [
        113.01168989905,
        22.903886075047
    ],
    [
        113.01175756065,
        22.9040795863
    ],
    [
        113.01176810215,
        22.904077326725
    ],
    [
        113.01176972408,
        22.904077354733
    ],
    [
        113.01177837818,
        22.904086456716
    ],
    [
        113.01178298257,
        22.904107425475
    ],
    [
        113.01179272354,
        22.904129568125
    ],
    [
        113.01184226446,
        22.904297266945
    ],
    [
        113.01190773874,
        22.904427532938
    ],
    [
        113.0119242601,
        22.904499439258
    ],
    [
        113.01192022523,
        22.904543860966
    ],
    [
        113.01192537263,
        22.904569179993
    ],
    [
        113.01191268866,
        22.904615622399
    ],
    [
        113.01190593804,
        22.904631783011
    ],
    [
        113.01187731249,
        22.904693684618
    ],
    [
        113.01186541977,
        22.904696463161
    ],
    [
        113.01186785252,
        22.904696233935
    ],
    [
        113.01187515885,
        22.904713180271
    ],
    [
        113.01187705667,
        22.904725421153
    ],
    [
        113.01188571238,
        22.90473750762
    ],
    [
        113.01189464289,
        22.904759365311
    ],
    [
        113.01190167818,
        22.90477467927
    ],
    [
        113.01189951937,
        22.904782780638
    ],
    [
        113.01189303644,
        22.904792977535
    ],
    [
        113.01187736113,
        22.904799759981
    ],
    [
        113.01186141112,
        22.904797042566
    ],
    [
        113.01183221601,
        22.904795452724
    ],
    [
        113.01182140656,
        22.904802590759
    ],
    [
        113.0118076212,
        22.904804522884
    ],
    [
        113.01180384372,
        22.904819649888
    ],
    [
        113.01179655573,
        22.904842583679
    ],
    [
        113.0117760268,
        22.904875597836
    ],
    [
        113.01175712174,
        22.904912709498
    ],
    [
        113.01173199424,
        22.904938862219
    ],
    [
        113.0116738915,
        22.904973127566
    ],
    [
        113.01165145891,
        22.904981693342
    ],
    [
        113.01151931107,
        22.905065144999
    ],
    [
        113.01146823176,
        22.905089767633
    ],
    [
        113.01145417652,
        22.905093052733
    ],
    [
        113.01142309824,
        22.905111780179
    ],
    [
        113.01141012724,
        22.905121323766
    ],
    [
        113.01135256404,
        22.905154517786
    ],
    [
        113.01129095128,
        22.905199037425
    ],
    [
        113.01125960369,
        22.905220203165
    ],
    [
        113.01123853157,
        22.905247784971
    ],
    [
        113.01122043426,
        22.905277859495
    ],
    [
        113.01119476763,
        22.905307533162
    ],
    [
        113.01118693534,
        22.905322320062
    ],
    [
        113.01106100917,
        22.905417559263
    ],
    [
        113.01079698392,
        22.905594550031
    ],
    [
        113.01075481489,
        22.905600343497
    ],
    [
        113.01075859972,
        22.905600679172
    ],
    [
        113.01064886619,
        22.905644662585
    ],
    [
        113.01049969827,
        22.905758517405
    ],
    [
        113.01046079407,
        22.905806420114
    ],
    [
        113.01037921409,
        22.905927664739
    ],
    [
        113.0103522132,
        22.905991504994
    ],
    [
        113.01034927558,
        22.906060906501
    ],
    [
        113.01035174631,
        22.906132841061
    ],
    [
        113.01036174938,
        22.906133823949
    ],
    [
        113.01037259105,
        22.906187180745
    ],
    [
        113.01037015826,
        22.906187682219
    ],
    [
        113.01037352912,
        22.906425392859
    ],
    [
        113.01037948599,
        22.906442856382
    ],
    [
        113.0103781872,
        22.906540500477
    ],
    [
        113.00997429581,
        22.906540209743
    ],
    [
        113.00996681933,
        22.906710186221
    ],
    [
        113.00995071445,
        22.906918270916
    ],
    [
        113.00994558606,
        22.906932834875
    ],
    [
        113.00993725454,
        22.907020052395
    ],
    [
        113.00994347087,
        22.907017172374
    ],
    [
        113.00992211193,
        22.907014372627
    ],
    [
        113.00988756039,
        22.907107390765
    ],
    [
        113.00987621019,
        22.907115068247
    ],
    [
        113.00982487064,
        22.907161414403
    ],
    [
        113.00980541719,
        22.907181707506
    ],
    [
        113.00979246059,
        22.907216759354
    ],
    [
        113.00977846892,
        22.907331826416
    ],
    [
        113.0097774859,
        22.907500285249
    ],
    [
        113.00975973022,
        22.907648116714
    ],
    [
        113.00972118905,
        22.907846605294
    ],
    [
        113.00970339268,
        22.907923899366
    ],
    [
        113.00970339482,
        22.907927426274
    ],
    [
        113.0096712233,
        22.907927703364
    ],
    [
        113.0096747542,
        22.907954620754
    ],
    [
        113.00962753327,
        22.908102776055
    ],
    [
        113.00954384064,
        22.90829129133
    ],
    [
        113.0095184817,
        22.908378227718
    ],
    [
        113.00951066535,
        22.908416350891
    ],
    [
        113.00951121867,
        22.908436436214
    ],
    [
        113.00951852426,
        22.908446053158
    ],
    [
        113.00953961833,
        22.908456442079
    ],
    [
        113.0097248454,
        22.908514331731
    ],
    [
        113.00972187153,
        22.908514282075
    ],
    [
        113.00971079993,
        22.908534444671
    ],
    [
        113.00968437077,
        22.908637097326
    ],
    [
        113.00965007553,
        22.908698652896
    ],
    [
        113.00961794617,
        22.908764857069
    ],
    [
        113.00957098299,
        22.90888588852
    ],
    [
        113.00951240524,
        22.909022463096
    ],
    [
        113.00950191588,
        22.909105577902
    ],
    [
        113.00948275124,
        22.909151923055
    ],
    [
        113.00946710632,
        22.909205923233
    ],
    [
        113.00937880558,
        22.909364525176
    ],
    [
        113.00932909758,
        22.909420674565
    ],
    [
        113.00929074303,
        22.909474571015
    ],
    [
        113.00920836686,
        22.90959773606
    ],
    [
        113.00917001092,
        22.909649463766
    ],
    [
        113.0091381232,
        22.909671184235
    ],
    [
        113.0091084002,
        22.909695653774
    ],
    [
        113.00907487837,
        22.909699984717
    ],
    [
        113.00903972651,
        22.909692894555
    ],
    [
        113.00902864356,
        22.909695696438
    ],
    [
        113.00897049624,
        22.909667338539
    ],
    [
        113.00889747718,
        22.909636838649
    ],
    [
        113.00885961678,
        22.909623195091
    ],
    [
        113.00883393081,
        22.909621417515
    ],
    [
        113.00880582121,
        22.909633979469
    ],
    [
        113.00875747142,
        22.909701556048
    ],
    [
        113.00871700147,
        22.909826235714
    ],
    [
        113.00861690971,
        22.910137141835
    ],
    [
        113.00861342123,
        22.910174796016
    ],
    [
        113.0086053317,
        22.910205592629
    ],
    [
        113.00860290824,
        22.910219660864
    ],
    [
        113.00859246616,
        22.910364909018
    ],
    [
        113.00859113774,
        22.910397986344
    ],
    [
        113.00858384302,
        22.910405463957
    ],
    [
        113.00860043573,
        22.910545998172
    ],
    [
        113.00861207849,
        22.91056952008
    ],
    [
        113.00860966242,
        22.910593626695
    ],
    [
        113.0086145677,
        22.910647424781
    ],
    [
        113.00860108298,
        22.910694411766
    ],
    [
        113.00856521341,
        22.910818627053
    ],
    [
        113.00853070335,
        22.910952632017
    ],
    [
        113.00848407412,
        22.911150468391
    ],
    [
        113.0084422281,
        22.911234164212
    ],
    [
        113.00842114449,
        22.911241689732
    ],
    [
        113.00839140552,
        22.911244734136
    ],
    [
        113.00837924191,
        22.911249149044
    ],
    [
        113.00837032425,
        22.911255515766
    ],
    [
        113.0083741434,
        22.9113011569
    ],
    [
        113.00836558741,
        22.911429888063
    ],
    [
        113.00834344173,
        22.911463442308
    ],
    [
        113.00832777721,
        22.911486520808
    ],
    [
        113.00830507263,
        22.911495920178
    ],
    [
        113.00828100817,
        22.911494716845
    ],
    [
        113.00822233787,
        22.911497024044
    ],
    [
        113.00820800334,
        22.911491095108
    ],
    [
        113.0081966483,
        22.91149226829
    ],
    [
        113.00817121644,
        22.911470696031
    ],
    [
        113.00814255337,
        22.911466978077
    ],
    [
        113.00811281011,
        22.911465142183
    ],
    [
        113.00809009801,
        22.91146504768
    ],
    [
        113.0080568325,
        22.911453660059
    ],
    [
        113.0080324988,
        22.911454625213
    ],
    [
        113.00803222658,
        22.91145217909
    ],
    [
        113.00802141053,
        22.911451191292
    ],
    [
        113.00800679929,
        22.911437119907
    ],
    [
        113.00799083591,
        22.911422755587
    ],
    [
        113.00796756759,
        22.911402305386
    ],
    [
        113.00794836438,
        22.911394400661
    ],
    [
        113.00791537519,
        22.911391429841
    ],
    [
        113.00787535436,
        22.911386447711
    ],
    [
        113.00785345217,
        22.911385283138
    ],
    [
        113.00784940139,
        22.911392000933
    ],
    [
        113.00783318284,
        22.911398252749
    ],
    [
        113.00780642206,
        22.911408405696
    ],
    [
        113.00778669405,
        22.911422198268
    ],
    [
        113.00776480308,
        22.911436227766
    ],
    [
        113.00774156276,
        22.911453762899
    ],
    [
        113.00771425165,
        22.911451428051
    ],
    [
        113.00769722277,
        22.911459024388
    ],
    [
        113.00767964575,
        22.911456845124
    ],
    [
        113.00766612136,
        22.911450389651
    ],
    [
        113.00764989485,
        22.911446332981
    ],
    [
        113.00761716708,
        22.911432518193
    ],
    [
        113.00754549664,
        22.911410760009
    ],
    [
        113.00751466362,
        22.911399961084
    ],
    [
        113.00748545697,
        22.911394614447
    ],
    [
        113.00744946757,
        22.911358774582
    ],
    [
        113.00707230722,
        22.911423643512
    ],
    [
        113.00707690091,
        22.91141937462
    ],
    [
        113.00706852577,
        22.911429281668
    ],
    [
        113.00705770719,
        22.911426127818
    ],
    [
        113.00698796166,
        22.911451895617
    ],
    [
        113.00699174476,
        22.911448427792
    ],
    [
        113.0069660643,
        22.911459421257
    ],
    [
        113.00696553794,
        22.911478675714
    ],
    [
        113.00696014114,
        22.911493784508
    ],
    [
        113.00696853469,
        22.911508294823
    ],
    [
        113.0069791353,
        22.911580899042
    ],
    [
        113.00703979253,
        22.911694711037
    ],
    [
        113.0070980691,
        22.911877670461
    ],
    [
        113.00711486243,
        22.911914560206
    ],
    [
        113.00719179508,
        22.912094016803
    ],
    [
        113.00729179252,
        22.912376122455
    ],
    [
        113.00729478927,
        22.912404656942
    ],
    [
        113.00740323075,
        22.912761782048
    ],
    [
        113.0075136058,
        22.913165337389
    ],
    [
        113.00761448049,
        22.913519098239
    ],
    [
        113.0076394077,
        22.913581353281
    ],
    [
        113.00766569434,
        22.913652583458
    ],
    [
        113.0077231706,
        22.913837989846
    ],
    [
        113.0077966228,
        22.914049970111
    ],
    [
        113.00779447422,
        22.914067299597
    ],
    [
        113.00783213922,
        22.914163945466
    ],
    [
        113.00781782747,
        22.9141862353
    ],
    [
        113.00779971813,
        22.914194085097
    ],
    [
        113.00770942061,
        22.914208650891
    ],
    [
        113.00746233971,
        22.914277163839
    ],
    [
        113.00733586234,
        22.914357913442
    ],
    [
        113.00710019019,
        22.91449637198
    ],
    [
        113.00697965766,
        22.914576420808
    ],
    [
        113.00692290679,
        22.914617045152
    ],
    [
        113.00692427394,
        22.91463470168
    ],
    [
        113.0069378187,
        22.91466312938
    ],
    [
        113.00699846897,
        22.914755237355
    ],
    [
        113.007004701,
        22.9147699856
    ],
    [
        113.00711972095,
        22.914883567522
    ],
    [
        113.00717843711,
        22.914928441978
    ],
    [
        113.00722330584,
        22.914907714028
    ],
    [
        113.00735087149,
        22.914834843164
    ],
    [
        113.00744603071,
        22.914811115966
    ],
    [
        113.00765120483,
        22.914747902341
    ],
    [
        113.0077855543,
        22.91470826316
    ],
    [
        113.00795397563,
        22.91467433285
    ],
    [
        113.00803426449,
        22.914656902019
    ],
    [
        113.00821377021,
        22.914625609493
    ],
    [
        113.00831864259,
        22.914900786588
    ],
    [
        113.00843571281,
        22.915210080315
    ],
    [
        113.00850544655,
        22.915184353662
    ],
    [
        113.00874332034,
        22.915125288797
    ],
    [
        113.00884310198,
        22.915453581379
    ],
    [
        113.00892252463,
        22.915687127205
    ],
    [
        113.00908782565,
        22.91611417861
    ],
    [
        113.00910841297,
        22.916158741882
    ],
    [
        113.00918167743,
        22.916155609636
    ],
    [
        113.00918762808,
        22.916158692335
    ],
    [
        113.00919249825,
        22.916162842453
    ],
    [
        113.0092046621,
        22.916160330242
    ],
    [
        113.00927575467,
        22.9161476686
    ],
    [
        113.00937496906,
        22.916140901055
    ],
    [
        113.00945309883,
        22.916138127698
    ],
    [
        113.0095012177,
        22.916133772182
    ],
    [
        113.00953096635,
        22.916144847991
    ],
    [
        113.00958319166,
        22.91619780906
    ],
    [
        113.00963540563,
        22.916238290477
    ],
    [
        113.00965406613,
        22.916245384356
    ],
    [
        113.00969002456,
        22.916247611966
    ],
    [
        113.00974895916,
        22.916246154014
    ],
    [
        113.00986167982,
        22.916230674924
    ],
    [
        113.01013901966,
        22.916194632936
    ],
    [
        113.01047715693,
        22.916132512085
    ],
    [
        113.01063017179,
        22.916138904219
    ],
    [
        113.01054785426,
        22.916288357793
    ],
    [
        113.0103128643,
        22.91651255702
    ],
    [
        113.0101355312,
        22.916820221957
    ],
    [
        113.00997663546,
        22.917185996156
    ],
    [
        113.00991504018,
        22.917524377266
    ],
    [
        113.00994350765,
        22.917611674992
    ],
    [
        113.01004602693,
        22.917963662531
    ],
    [
        113.01004332831,
        22.91796877218
    ],
    [
        113.01023362875,
        22.918234878395
    ],
    [
        113.01065094851,
        22.918437285351
    ],
    [
        113.01121698913,
        22.918693565416
    ],
    [
        113.01128676843,
        22.918731117726
    ],
    [
        113.01129569545,
        22.918737782399
    ],
    [
        113.01129624078,
        22.918742675429
    ],
    [
        113.0113197473,
        22.918730598168
    ],
    [
        113.01136947391,
        22.918717343271
    ],
    [
        113.01140945702,
        22.918691712396
    ],
    [
        113.01144270058,
        22.918685500778
    ],
    [
        113.01153782273,
        22.91865349378
    ],
    [
        113.01156457236,
        22.918640931137
    ],
    [
        113.01160347901,
        22.918620709939
    ],
    [
        113.01163266897,
        22.918616057918
    ],
    [
        113.01171995149,
        22.918584462618
    ],
    [
        113.01176669796,
        22.918565192153
    ],
    [
        113.01177317947,
        22.918558792502
    ],
    [
        113.01182749841,
        22.918543451871
    ],
    [
        113.01187667883,
        22.918525581226
    ],
    [
        113.01194422743,
        22.918493920586
    ],
    [
        113.01199557247,
        22.918478530554
    ],
    [
        113.01203934104,
        22.918455141683
    ],
    [
        113.01213608134,
        22.91842181928
    ],
    [
        113.01218229101,
        22.918407427509
    ],
    [
        113.012248221,
        22.918380084289
    ],
    [
        113.01211008402,
        22.918085751877
    ],
    [
        113.01219600248,
        22.918042475784
    ],
    [
        113.01263370172,
        22.917827887499
    ],
    [
        113.01276311394,
        22.917759062744
    ],
    [
        113.01287794039,
        22.917702195049
    ],
    [
        113.01290765332,
        22.917680195823
    ],
    [
        113.01334047296,
        22.917460695493
    ],
    [
        113.01347466137,
        22.917298095799
    ],
    [
        113.01368076669,
        22.917154672424
    ],
    [
        113.01388745299,
        22.917056031994
    ],
    [
        113.01389366492,
        22.917050715355
    ],
    [
        113.01390987297,
        22.917040148887
    ],
    [
        113.01421345189,
        22.916785866171
    ],
    [
        113.01440547917,
        22.916619422704
    ],
    [
        113.01428456248,
        22.916513640834
    ],
    [
        113.01426725558,
        22.916504652599
    ],
    [
        113.01436556334,
        22.916417130642
    ],
    [
        113.01444362593,
        22.916359366824
    ],
    [
        113.01450628134,
        22.916301059333
    ],
    [
        113.01452817388,
        22.916299819374
    ],
    [
        113.0145940636,
        22.916231259882
    ],
    [
        113.01458839055,
        22.91623468638
    ],
    [
        113.01460135308,
        22.91622189317
    ],
    [
        113.01468587676,
        22.916135215384
    ],
    [
        113.01482056923,
        22.916233106823
    ],
    [
        113.01524605761,
        22.91659147163
    ],
    [
        113.01559960503,
        22.916900274076
    ],
    [
        113.01576248882,
        22.917086852331
    ],
    [
        113.01605849108,
        22.917421497878
    ],
    [
        113.01630172602,
        22.917687919853
    ],
    [
        113.01653875306,
        22.917962100207
    ],
    [
        113.01707302842,
        22.918449673456
    ],
    [
        113.01759247124,
        22.918965463812
    ],
    [
        113.01778779595,
        22.919149632905
    ],
    [
        113.01818655601,
        22.919516479839
    ],
    [
        113.01860120284,
        22.919816037592
    ],
    [
        113.01881111352,
        22.919983898412
    ],
    [
        113.01895154122,
        22.920132620121
    ],
    [
        113.01919125882,
        22.920373711111
    ],
    [
        113.01939229299,
        22.920581012925
    ],
    [
        113.01927318019,
        22.920670619475
    ],
    [
        113.01920591132,
        22.920706061244
    ],
    [
        113.0190246625,
        22.920827125866
    ],
    [
        113.01892742422,
        22.920895679284
    ],
    [
        113.01865271216,
        22.921073688334
    ],
    [
        113.01854196417,
        22.921146068185
    ],
    [
        113.01833099746,
        22.921277716467
    ],
    [
        113.0183082557,
        22.921240142696
    ],
    [
        113.01823166194,
        22.921137854029
    ],
    [
        113.01822031682,
        22.921144978304
    ],
    [
        113.01817438474,
        22.921162341503
    ],
    [
        113.0181722275,
        22.921167458246
    ],
    [
        113.01817276351,
        22.921162855366
    ],
    [
        113.01817980626,
        22.921178174113
    ],
    [
        113.01820801856,
        22.921280961343
    ],
    [
        113.0182166804,
        22.921293595629
    ],
    [
        113.01822752864,
        22.921330415942
    ],
    [
        113.01823188657,
        22.921363865291
    ],
    [
        113.01823922721,
        22.921406863666
    ],
    [
        113.01830527511,
        22.921774856482
    ],
    [
        113.01831641397,
        22.92183175941
    ],
    [
        113.01832105246,
        22.921875252493
    ],
    [
        113.01832429981,
        22.921879108528
    ],
    [
        113.01832268266,
        22.92188369225
    ],
    [
        113.01833108112,
        22.921903104739
    ],
    [
        113.0183316247,
        22.921906098873
    ],
    [
        113.01833243341,
        22.921903942672
    ],
    [
        113.01834163651,
        22.921917129116
    ],
    [
        113.01838007777,
        22.921976957956
    ],
    [
        113.01839334648,
        22.922001340463
    ],
    [
        113.01838983808,
        22.922006704622
    ],
    [
        113.01838634928,
        22.922031604004
    ],
    [
        113.01838610948,
        22.922061987341
    ],
    [
        113.01838881298,
        22.922062577905
    ],
    [
        113.01838802061,
        22.922081013466
    ],
    [
        113.01840888788,
        22.922135646938
    ],
    [
        113.01846256496,
        22.922294233954
    ],
    [
        113.01848504678,
        22.922341570326
    ],
    [
        113.01848613179,
        22.922345388001
    ],
    [
        113.01850619874,
        22.92241031721
    ],
    [
        113.01850594895,
        22.922430661631
    ],
    [
        113.01851001324,
        22.922440501083
    ],
    [
        113.01851140273,
        22.922478238898
    ],
    [
        113.01850707662,
        22.922476805665
    ],
    [
        113.01849385781,
        22.922502075355
    ],
    [
        113.01847956002,
        22.922529496454
    ],
    [
        113.01847418667,
        22.922561688085
    ],
    [
        113.01847337386,
        22.922559774456
    ],
    [
        113.01847718621,
        22.922587787767
    ],
    [
        113.01850778665,
        22.922644764103
    ],
    [
        113.01860388009,
        22.92278321041
    ],
    [
        113.0185998218,
        22.922779340095
    ],
    [
        113.01858091419,
        22.922792028545
    ],
    [
        113.0185784796,
        22.922790086203
    ],
    [
        113.01859986733,
        22.922824379713
    ],
    [
        113.0186147515,
        22.92284227894
    ],
    [
        113.01869053957,
        22.92294726407
    ],
    [
        113.01875956492,
        22.923046702603
    ],
    [
        113.01875686084,
        22.923045569494
    ],
    [
        113.018760923,
        22.923053238266
    ],
    [
        113.01923922832,
        22.922938778727
    ],
    [
        113.01932051989,
        22.92313881652
    ],
    [
        113.01932053254,
        22.923151297385
    ],
    [
        113.01994255741,
        22.922949786573
    ],
    [
        113.02002848464,
        22.922921175451
    ],
    [
        113.02004226594,
        22.922917075651
    ],
    [
        113.02009252703,
        22.922901947596
    ],
    [
        113.02019440269,
        22.922873341715
    ],
    [
        113.02036385227,
        22.922841843712
    ],
    [
        113.02036278063,
        22.92285132115
    ],
    [
        113.02042872385,
        22.923106967945
    ],
    [
        113.02051038804,
        22.923404399632
    ],
    [
        113.02057376776,
        22.923530038553
    ],
    [
        113.0207118931,
        22.923793178309
    ],
    [
        113.02099238745,
        22.924236224831
    ],
    [
        113.02130160415,
        22.924742153251
    ],
    [
        113.02138505883,
        22.924934600608
    ],
    [
        113.02142796293,
        22.925123906344
    ],
    [
        113.02143889146,
        22.925236963221
    ],
    [
        113.02141709867,
        22.925337518589
    ],
    [
        113.02136507177,
        22.925478522008
    ],
    [
        113.02122971992,
        22.925817234912
    ],
    [
        113.02106030941,
        22.926155896922
    ],
    [
        113.02102876395,
        22.926235118665
    ],
    [
        113.02098803133,
        22.9263177082
    ],
    [
        113.02094351435,
        22.92640023178
    ],
    [
        113.02080268258,
        22.926400773261
    ],
    [
        113.02081708636,
        22.926476178678
    ],
    [
        113.02083232557,
        22.926575474621
    ],
    [
        113.02086874759,
        22.926770913639
    ],
    [
        113.02090030111,
        22.926963554751
    ],
    [
        113.02093873391,
        22.927010887932
    ],
    [
        113.02114428588,
        22.927121888457
    ],
    [
        113.02135091576,
        22.927227742935
    ],
    [
        113.02168169684,
        22.927403820616
    ],
    [
        113.0217774962,
        22.927506665237
    ],
    [
        113.02202501317,
        22.927672604454
    ],
    [
        113.02210644661,
        22.927736125634
    ],
    [
        113.02206489246,
        22.927810843647
    ],
    [
        113.02190456094,
        22.928048222277
    ],
    [
        113.02193431744,
        22.928068537323
    ],
    [
        113.02202818089,
        22.928127660239
    ],
    [
        113.02221103901,
        22.928241746289
    ],
    [
        113.02223485193,
        22.928265213581
    ],
    [
        113.02240850679,
        22.928365567085
    ],
    [
        113.02237424717,
        22.92843688522
    ],
    [
        113.02200267909,
        22.9291020727
    ],
    [
        113.02199727522,
        22.929104693604
    ],
    [
        113.02204298209,
        22.929126094087
    ],
    [
        113.0221376421,
        22.929170847905
    ],
    [
        113.02223531001,
        22.929249022609
    ],
    [
        113.02224883196,
        22.929254407678
    ],
    [
        113.02244332055,
        22.929373292015
    ],
    [
        113.02255611726,
        22.929440047591
    ],
    [
        113.02259777398,
        22.929464899542
    ],
    [
        113.02259831466,
        22.929464908684
    ],
    [
        113.02261617547,
        22.929483388967
    ],
    [
        113.02300663465,
        22.929840509197
    ],
    [
        113.02311649602,
        22.929941924997
    ],
    [
        113.02467916592,
        22.931292524886
    ],
    [
        113.02491311334,
        22.931090915439
    ],
    [
        113.02511625322,
        22.930901813819
    ],
    [
        113.02539266587,
        22.930706807387
    ],
    [
        113.02565746923,
        22.930523523256
    ],
    [
        113.02589853294,
        22.930390301534
    ],
    [
        113.02614557059,
        22.930276953204
    ],
    [
        113.02641910669,
        22.930155847007
    ],
    [
        113.02658320674,
        22.93011225156
    ],
    [
        113.0267640626,
        22.930055604907
    ],
    [
        113.02696867759,
        22.92995724903
    ],
    [
        113.02718600977,
        22.92986150625
    ],
    [
        113.02752688434,
        22.929710879514
    ],
    [
        113.02785755184,
        22.929618104953
    ],
    [
        113.02825632445,
        22.929461960266
    ],
    [
        113.02873008858,
        22.92935645137
    ],
    [
        113.02914545553,
        22.929255153624
    ],
    [
        113.02917492726,
        22.929243085916
    ],
    [
        113.0296395368,
        22.929130148764
    ],
    [
        113.03009092682,
        22.929027215053
    ],
    [
        113.03048853552,
        22.928954648448
    ],
    [
        113.03088236687,
        22.92887243738
    ],
    [
        113.03096269003,
        22.928841460639
    ],
    [
        113.03108792248,
        22.928806172734
    ],
    [
        113.03130811622,
        22.928761500637
    ],
    [
        113.03154428969,
        22.928725950502
    ],
    [
        113.03178805514,
        22.928698325418
    ],
    [
        113.03199748376,
        22.928690861319
    ],
    [
        113.03217417425,
        22.928681886246
    ],
    [
        113.03238496575,
        22.92867302656
    ],
    [
        113.03258600134,
        22.928644485759
    ],
    [
        113.03279542217,
        22.928606247007
    ],
    [
        113.03302161212,
        22.928551891122
    ],
    [
        113.03320589137,
        22.928528224356
    ],
    [
        113.03339937409,
        22.928501109426
    ],
    [
        113.03362697778,
        22.928486554912
    ],
    [
        113.0337463376,
        22.928485700528
    ],
    [
        113.03406141711,
        22.928507302859
    ],
    [
        113.03456816951,
        22.92853707279
    ],
    [
        113.03492580107,
        22.928569491946
    ],
    [
        113.03521142238,
        22.928584553085
    ],
    [
        113.03534628035,
        22.928620606575
    ],
    [
        113.03555556921,
        22.928632672703
    ],
    [
        113.03582063991,
        22.928645500976
    ],
    [
        113.03589725814,
        22.928641334678
    ],
    [
        113.03599448501,
        22.928666928612
    ],
    [
        113.03611850308,
        22.928677024013
    ],
    [
        113.03656203714,
        22.928686432784
    ],
    [
        113.03708385737,
        22.928687386168
    ],
    [
        113.03727992977,
        22.928693353024
    ],
    [
        113.03742642819,
        22.928679624256
    ],
    [
        113.03765554634,
        22.928678742425
    ],
    [
        113.03789466459,
        22.928648319653
    ],
    [
        113.03808017331,
        22.928627213287
    ],
    [
        113.03823345902,
        22.928609366646
    ],
    [
        113.03830252306,
        22.928604178656
    ],
    [
        113.03856199037,
        22.928580553267
    ],
    [
        113.03879331662,
        22.928575939383
    ],
    [
        113.03919640196,
        22.928570523875
    ],
    [
        113.03951038356,
        22.928565765254
    ],
    [
        113.03977670966,
        22.928572027488
    ],
    [
        113.03995931054,
        22.928561998502
    ],
    [
        113.04008312733,
        22.928557569334
    ],
    [
        113.04026544298,
        22.928523613127
    ],
    [
        113.04045021541,
        22.928501579149
    ],
    [
        113.04068349461,
        22.928475702031
    ],
    [
        113.04091517397,
        22.92846577633
    ],
    [
        113.04110541119,
        22.928466453265
    ],
    [
        113.04122440416,
        22.928490092296
    ],
    [
        113.04136344731,
        22.928506758013
    ],
    [
        113.04170710416,
        22.928512378757
    ],
    [
        113.04192067564,
        22.928510575635
    ],
    [
        113.04216352863,
        22.928508575748
    ],
    [
        113.04244433396,
        22.928499337219
    ],
    [
        113.04277829467,
        22.928499161623
    ],
    [
        113.04304449004,
        22.928487006475
    ],
    [
        113.04321147633,
        22.928476936457
    ],
    [
        113.04337279019,
        22.92848229014
    ],
    [
        113.04377460125,
        22.928492038798
    ],
    [
        113.04420411001,
        22.928511463977
    ],
    [
        113.04443513263,
        22.928506762884
    ],
    [
        113.04460948127,
        22.928493778009
    ],
    [
        113.04470086501,
        22.92849121599
    ],
    [
        113.04475862118,
        22.928486152429
    ],
    [
        113.04482613843,
        22.92847892984
    ],
    [
        113.04506886745,
        22.928491746552
    ],
    [
        113.0453766876,
        22.928493993089
    ],
    [
        113.04579544731,
        22.928484285251
    ],
    [
        113.04597446525,
        22.928484377074
    ],
    [
        113.0463995176,
        22.928480677211
    ],
    [
        113.04669060464,
        22.928491500816
    ],
    [
        113.04704166482,
        22.928502756265
    ],
    [
        113.04725057729,
        22.928511029563
    ],
    [
        113.0474223353,
        22.928527165394
    ],
    [
        113.04759274056,
        22.928541647364
    ],
    [
        113.04769204703,
        22.928541536158
    ],
    [
        113.04778998846,
        22.928531378546
    ],
    [
        113.04797692065,
        22.928509421543
    ],
    [
        113.0480737924,
        22.928509550013
    ],
    [
        113.04819807239,
        22.9285090827
    ],
    [
        113.04854869237,
        22.928522832977
    ],
    [
        113.04886865618,
        22.92852487238
    ],
    [
        113.04916070101,
        22.928543439046
    ],
    [
        113.04935044,
        22.928565192561
    ],
    [
        113.04946741519,
        22.928558630432
    ],
    [
        113.04965008684,
        22.928559730966
    ],
    [
        113.04999291045,
        22.928554046272
    ],
    [
        113.05010908301,
        22.928545247556
    ],
    [
        113.05033060155,
        22.928551800069
    ],
    [
        113.05047014142,
        22.928556173929
    ],
    [
        113.05051494693,
        22.928568216031
    ],
    [
        113.05050978837,
        22.928567692759
    ],
    [
        113.05051033049,
        22.92856687675
    ],
    [
        113.05072036705,
        22.928478973014
    ],
    [
        113.05087860188,
        22.928436010866
    ],
    [
        113.05122719785,
        22.928423135504
    ],
    [
        113.0514061241,
        22.928420705618
    ],
    [
        113.05174745299,
        22.928438089043
    ],
    [
        113.05213769803,
        22.928470308824
    ],
    [
        113.05239843325,
        22.928505005494
    ],
    [
        113.05259237705,
        22.928544631751
    ],
    [
        113.05279637514,
        22.928583081447
    ],
    [
        113.05295745283,
        22.928606284719
    ],
    [
        113.05317856777,
        22.928637238782
    ],
    [
        113.0533491796,
        22.928676879475
    ],
    [
        113.05347522272,
        22.928689105208
    ],
    [
        113.05372946887,
        22.928692337908
    ],
    [
        113.0538693648,
        22.928695475545
    ],
    [
        113.05393890011,
        22.928690664727
    ],
    [
        113.05416514828,
        22.92865627778
    ],
    [
        113.05461577436,
        22.928592270974
    ],
    [
        113.05490289658,
        22.928547796882
    ],
    [
        113.05535192836,
        22.92846317429
    ],
    [
        113.0557305908,
        22.928353193996
    ],
    [
        113.0560848248,
        22.928247647204
    ],
    [
        113.05642658582,
        22.928149163638
    ],
    [
        113.05687346648,
        22.927975822599
    ],
    [
        113.05712423071,
        22.927886394185
    ],
    [
        113.05743178626,
        22.927772493461
    ],
    [
        113.05770154915,
        22.927633658721
    ],
    [
        113.05799655707,
        22.927449745016
    ],
    [
        113.05830301372,
        22.927283554639
    ],
    [
        113.05865646543,
        22.927068772792
    ],
    [
        113.05894717516,
        22.926893376037
    ],
    [
        113.05925638652,
        22.926719341618
    ],
    [
        113.05951422663,
        22.926546899343
    ],
    [
        113.05979462648,
        22.926357330226
    ],
    [
        113.05999974767,
        22.926195708875
    ],
    [
        113.06018664431,
        22.926022061097
    ],
    [
        113.06043385197,
        22.925789069416
    ],
    [
        113.06078296204,
        22.925476123388
    ],
    [
        113.0610774541,
        22.925189271276
    ],
    [
        113.06133445753,
        22.92493131785
    ],
    [
        113.06150886267,
        22.924741921256
    ],
    [
        113.06151430159,
        22.924741581597
    ],
    [
        113.06152598149,
        22.924727325783
    ],
    [
        113.06152269442,
        22.924704304303
    ],
    [
        113.0615077175,
        22.924685770932
    ],
    [
        113.06136914497,
        22.924544244598
    ],
    [
        113.06100855887,
        22.924299077671
    ],
    [
        113.06067732155,
        22.924016571527
    ],
    [
        113.06040404374,
        22.923758269113
    ],
    [
        113.06016458656,
        22.923591230019
    ],
    [
        113.05977543625,
        22.923270121986
    ],
    [
        113.05939171499,
        22.922917915694
    ],
    [
        113.05913430647,
        22.922707218416
    ],
    [
        113.05914924539,
        22.922693217511
    ],
    [
        113.05947898852,
        22.922375648229
    ],
    [
        113.05950751049,
        22.922349553291
    ],
    [
        113.05926614488,
        22.922144127675
    ],
    [
        113.05892709044,
        22.921840411092
    ],
    [
        113.05864707774,
        22.921568546927
    ],
    [
        113.0583725664,
        22.921348933596
    ],
    [
        113.05804505257,
        22.921121118906
    ],
    [
        113.05757232498,
        22.920807552747
    ],
    [
        113.05756769337,
        22.920796473634
    ],
    [
        113.05758885584,
        22.920757196431
    ],
    [
        113.05773894931,
        22.920534321306
    ],
    [
        113.05782828916,
        22.920444441035
    ],
    [
        113.05801353316,
        22.920302038677
    ],
    [
        113.05821581838,
        22.920066914442
    ],
    [
        113.05837303499,
        22.919883507491
    ],
    [
        113.05839991533,
        22.919850398482
    ],
    [
        113.05841649967,
        22.919852396737
    ],
    [
        113.05842438829,
        22.919857741158
    ],
    [
        113.05863845954,
        22.919988988141
    ],
    [
        113.0589362988,
        22.92014806091
    ],
    [
        113.05897464616,
        22.920162841028
    ],
    [
        113.05900509201,
        22.920159526996
    ],
    [
        113.05902464729,
        22.920139779709
    ],
    [
        113.05929054352,
        22.919863375551
    ],
    [
        113.05957303001,
        22.919579950981
    ],
    [
        113.05959911348,
        22.919561207488
    ],
    [
        113.05961433297,
        22.919554524244
    ],
    [
        113.05964126487,
        22.919569685813
    ],
    [
        113.05988366629,
        22.919715884326
    ],
    [
        113.06013480909,
        22.919894498729
    ],
    [
        113.06049588003,
        22.920136341797
    ],
    [
        113.06074075321,
        22.920275855395
    ],
    [
        113.06086536149,
        22.920338380543
    ],
    [
        113.06104682034,
        22.920412951595
    ],
    [
        113.06111401793,
        22.920440072647
    ],
    [
        113.06113849255,
        22.92043922864
    ],
    [
        113.06114964131,
        22.920438005934
    ],
    [
        113.06127680715,
        22.920327360388
    ],
    [
        113.06129963763,
        22.920313239285
    ],
    [
        113.06132951914,
        22.920278680763
    ],
    [
        113.06134230256,
        22.920280149535
    ],
    [
        113.06144786273,
        22.920321157655
    ],
    [
        113.06164595975,
        22.920430449451
    ],
    [
        113.06165685241,
        22.920444691785
    ],
    [
        113.06167805884,
        22.92043736872
    ],
    [
        113.06169600041,
        22.920428730162
    ],
    [
        113.06180081988,
        22.920262974286
    ],
    [
        113.06200911454,
        22.919941769333
    ],
    [
        113.06225883581,
        22.919700309287
    ],
    [
        113.06225745389,
        22.919677536102
    ],
    [
        113.06227074645,
        22.919641276606
    ],
    [
        113.06210004885,
        22.919473375192
    ],
    [
        113.06199436067,
        22.919307604353
    ],
    [
        113.06198264359,
        22.919284692698
    ],
    [
        113.06198424456,
        22.919252384608
    ],
    [
        113.06214020131,
        22.919083234507
    ],
    [
        113.06235782568,
        22.918831594001
    ],
    [
        113.06262112431,
        22.918548930825
    ],
    [
        113.06267711052,
        22.918499620318
    ],
    [
        113.06272387767,
        22.918480818955
    ],
    [
        113.06274754267,
        22.918481317295
    ],
    [
        113.0627657789,
        22.918493826004
    ],
    [
        113.06288610156,
        22.91859423199
    ],
    [
        113.06290840546,
        22.918593118373
    ],
    [
        113.0629279691,
        22.918570606826
    ],
    [
        113.06326412905,
        22.918223098961
    ],
    [
        113.06329074925,
        22.918182308277
    ],
    [
        113.06327931804,
        22.918175681431
    ],
    [
        113.06312740557,
        22.918042360291
    ],
    [
        113.06311079191,
        22.918020337287
    ],
    [
        113.06320099318,
        22.917902714366
    ],
    [
        113.0631988057,
        22.917890534663
    ],
    [
        113.06311090081,
        22.917844790502
    ],
    [
        113.06300011298,
        22.917761637058
    ],
    [
        113.06281743874,
        22.917594516616
    ],
    [
        113.06258990842,
        22.917448591528
    ],
    [
        113.06233923719,
        22.917271464854
    ],
    [
        113.06219281751,
        22.91717380073
    ],
    [
        113.06199224807,
        22.91704480563
    ],
    [
        113.0617976585,
        22.916905670064
    ],
    [
        113.06166050753,
        22.916819776695
    ],
    [
        113.06165315566,
        22.916810102264
    ],
    [
        113.06155871442,
        22.916733697493
    ],
    [
        113.06154210866,
        22.916715999504
    ],
    [
        113.06156629423,
        22.9166945319
    ],
    [
        113.0617703485,
        22.916477603883
    ],
    [
        113.06201572854,
        22.916235969709
    ],
    [
        113.06229265258,
        22.915975978799
    ],
    [
        113.06250193465,
        22.915800943217
    ],
    [
        113.06260877713,
        22.91573983972
    ],
    [
        113.06271969217,
        22.915668364875
    ],
    [
        113.06273736359,
        22.915658090451
    ],
    [
        113.06274361563,
        22.915653394623
    ],
    [
        113.06271686784,
        22.915548479781
    ],
    [
        113.0627006175,
        22.915314820065
    ],
    [
        113.06265885736,
        22.915147701307
    ],
    [
        113.06259203079,
        22.914929635071
    ],
    [
        113.06251298016,
        22.914728006883
    ],
    [
        113.06246148139,
        22.914619616685
    ],
    [
        113.06242960697,
        22.914558989976
    ],
    [
        113.06241953052,
        22.914543928745
    ],
    [
        113.06242522644,
        22.914524861703
    ],
    [
        113.06242820404,
        22.914507729609
    ],
    [
        113.06248828325,
        22.914469496718
    ],
    [
        113.06265820068,
        22.914370387018
    ],
    [
        113.06289148855,
        22.914257115186
    ],
    [
        113.06311905118,
        22.914119741283
    ],
    [
        113.063289791,
        22.914011060023
    ],
    [
        113.06344313187,
        22.913911012005
    ],
    [
        113.06359211248,
        22.913797716315
    ],
    [
        113.06363587638,
        22.91375641252
    ],
    [
        113.06364484351,
        22.913744078928
    ],
    [
        113.06362605521,
        22.913722091692
    ],
    [
        113.06354709154,
        22.913630937646
    ],
    [
        113.06351384767,
        22.913561668829
    ],
    [
        113.06352251974,
        22.913520851904
    ],
    [
        113.06354232106,
        22.913450036592
    ],
    [
        113.0635539678,
        22.913386930645
    ],
    [
        113.06355557998,
        22.913361947425
    ],
    [
        113.06355067172,
        22.913347364295
    ],
    [
        113.06352969533,
        22.91330994141
    ],
    [
        113.06348801899,
        22.91324024607
    ],
    [
        113.0633275732,
        22.912960555376
    ],
    [
        113.06321805798,
        22.912753954068
    ],
    [
        113.0631464134,
        22.91262117165
    ],
    [
        113.06313305351,
        22.912581198809
    ],
    [
        113.06314172887,
        22.91254336851
    ],
    [
        113.06314252398,
        22.912516226438
    ],
    [
        113.06320149486,
        22.912441627304
    ],
    [
        113.06328031157,
        22.912350747638
    ],
    [
        113.06333111469,
        22.912265131888
    ],
    [
        113.06334356783,
        22.912186280782
    ],
    [
        113.06332881484,
        22.912102376173
    ],
    [
        113.06328849561,
        22.912023433487
    ],
    [
        113.06321826102,
        22.911953308543
    ],
    [
        113.06315563169,
        22.911867070013
    ],
    [
        113.06309330566,
        22.911821793104
    ],
    [
        113.06306855157,
        22.911821043228
    ],
    [
        113.06289418209,
        22.91180928706
    ],
    [
        113.06286425379,
        22.91179965041
    ],
    [
        113.06284383591,
        22.911776591507
    ],
    [
        113.06279291625,
        22.911703748085
    ],
    [
        113.06275204479,
        22.911608521543
    ],
    [
        113.06272969456,
        22.911546418342
    ],
    [
        113.06273611599,
        22.911400910313
    ],
    [
        113.0627343868,
        22.911267448819
    ],
    [
        113.06271096924,
        22.911232762071
    ],
    [
        113.06269817475,
        22.911218553099
    ],
    [
        113.062622806,
        22.911185370116
    ],
    [
        113.06249222842,
        22.911160509613
    ],
    [
        113.06229800798,
        22.911137014442
    ],
    [
        113.06206326121,
        22.911105609521
    ],
    [
        113.0618464859,
        22.911093745732
    ],
    [
        113.06161449488,
        22.91109343931
    ],
    [
        113.06149647986,
        22.911117716291
    ],
    [
        113.06140241777,
        22.911168002
    ],
    [
        113.06135377047,
        22.911213918028
    ],
    [
        113.06124533079,
        22.911311038565
    ],
    [
        113.06121271415,
        22.911335317831
    ],
    [
        113.06120101975,
        22.911334648581
    ],
    [
        113.06118361721,
        22.911337848121
    ],
    [
        113.06116974312,
        22.911331508054
    ],
    [
        113.06114524205,
        22.911296268791
    ],
    [
        113.0610929505,
        22.911189202765
    ],
    [
        113.06102098408,
        22.910948349436
    ],
    [
        113.06088916556,
        22.91066752593
    ],
    [
        113.06084115288,
        22.910450248648
    ],
    [
        113.06081961356,
        22.910368846108
    ],
    [
        113.06081412894,
        22.910302170885
    ],
    [
        113.06081166477,
        22.910277783057
    ],
    [
        113.06081138781,
        22.910270461111
    ],
    [
        113.06083284337,
        22.910230318986
    ],
    [
        113.06085484681,
        22.910195867366
    ],
    [
        113.06091112689,
        22.910179176071
    ],
    [
        113.06093995185,
        22.910178010916
    ],
    [
        113.06099706784,
        22.910189793442
    ],
    [
        113.06103596743,
        22.910206680745
    ],
    [
        113.06108140819,
        22.910244377338
    ],
    [
        113.06112877247,
        22.91031053616
    ],
    [
        113.0611595741,
        22.910414067182
    ],
    [
        113.06120968069,
        22.910511661447
    ],
    [
        113.06125022597,
        22.910546700553
    ],
    [
        113.06127307573,
        22.910554827579
    ],
    [
        113.06132011158,
        22.910537150457
    ],
    [
        113.06137474777,
        22.910498215006
    ],
    [
        113.06146686429,
        22.910386097464
    ],
    [
        113.06151900525,
        22.910276105615
    ],
    [
        113.06152794501,
        22.910224987357
    ],
    [
        113.06151295012,
        22.910170914495
    ],
    [
        113.06143947598,
        22.910105366261
    ],
    [
        113.0613298374,
        22.910047048014
    ],
    [
        113.06121173834,
        22.909941619271
    ],
    [
        113.06111131064,
        22.909824840451
    ],
    [
        113.06106095982,
        22.909763872854
    ],
    [
        113.0610364586,
        22.909724562722
    ],
    [
        113.06103318017,
        22.909701813198
    ],
    [
        113.0610464937,
        22.909684015058
    ],
    [
        113.06116307402,
        22.909554795481
    ],
    [
        113.06125329507,
        22.909452753447
    ],
    [
        113.06131986576,
        22.909363480736
    ],
    [
        113.06144511058,
        22.909165491796
    ],
    [
        113.06146792643,
        22.909120440475
    ],
    [
        113.0614668052,
        22.909068092739
    ],
    [
        113.06146297449,
        22.909031514669
    ],
    [
        113.06143111262,
        22.908964359111
    ],
    [
        113.06135791078,
        22.908892835617
    ],
    [
        113.0612417489,
        22.908833507868
    ],
    [
        113.06100372448,
        22.908721678114
    ],
    [
        113.0609210316,
        22.908685519228
    ],
    [
        113.06077602905,
        22.908589066845
    ],
    [
        113.06071045642,
        22.908529628535
    ],
    [
        113.06065275821,
        22.908450016444
    ],
    [
        113.06059233473,
        22.908359311343
    ],
    [
        113.06053927058,
        22.908295917653
    ],
    [
        113.0604764372,
        22.908264923175
    ],
    [
        113.0603627514,
        22.908227473276
    ],
    [
        113.06018027015,
        22.908184850843
    ],
    [
        113.05988250391,
        22.908137563573
    ],
    [
        113.05971200129,
        22.908099356166
    ],
    [
        113.05952435921,
        22.908036089426
    ],
    [
        113.05934024822,
        22.907958108146
    ],
    [
        113.05921377643,
        22.907874586737
    ],
    [
        113.05910033152,
        22.907746961001
    ],
    [
        113.05900157954,
        22.907635987549
    ],
    [
        113.05894687185,
        22.907525888745
    ],
    [
        113.05887284543,
        22.907384524752
    ],
    [
        113.05880591602,
        22.907291643696
    ],
    [
        113.05872863207,
        22.907153291309
    ],
    [
        113.0586488988,
        22.907006821648
    ],
    [
        113.0585544958,
        22.906875423145
    ],
    [
        113.05848265659,
        22.906741340804
    ],
    [
        113.05834312143,
        22.906589508931
    ],
    [
        113.05823841687,
        22.906498889918
    ],
    [
        113.05810708209,
        22.906421827471
    ],
    [
        113.05795914726,
        22.906302325508
    ],
    [
        113.05782371781,
        22.90617834185
    ],
    [
        113.05769591158,
        22.906072174757
    ],
    [
        113.0575952898,
        22.905967357394
    ],
    [
        113.05755285226,
        22.905895064502
    ],
    [
        113.05748755806,
        22.905770089519
    ],
    [
        113.05741600896,
        22.90563486252
    ],
    [
        113.05734310591,
        22.905506698387
    ],
    [
        113.0572767275,
        22.9053784681
    ],
    [
        113.05723945398,
        22.905297163386
    ],
    [
        113.05718502263,
        22.90513815882
    ],
    [
        113.05712949233,
        22.904949049008
    ],
    [
        113.05708294634,
        22.90478996637
    ],
    [
        113.05705488923,
        22.904644816546
    ],
    [
        113.05704261156,
        22.904534515515
    ],
    [
        113.05704310608,
        22.904418940561
    ],
    [
        113.05705908386,
        22.90428151753
    ],
    [
        113.05706938327,
        22.904212784358
    ],
    [
        113.05706829313,
        22.904205469716
    ],
    [
        113.05707535404,
        22.904192110256
    ],
    [
        113.0570636629,
        22.9041813682
    ],
    [
        113.05703566396,
        22.90416860824
    ],
    [
        113.05696580561,
        22.904142944052
    ],
    [
        113.05678398059,
        22.904126172725
    ],
    [
        113.05665053063,
        22.904098358385
    ],
    [
        113.05648828593,
        22.904092490124
    ],
    [
        113.05618990024,
        22.904088874248
    ],
    [
        113.05602930882,
        22.904109247042
    ],
    [
        113.05584181201,
        22.904109206902
    ],
    [
        113.0557179047,
        22.904110240358
    ],
    [
        113.05541386,
        22.904128729114
    ],
    [
        113.05500658305,
        22.904137903464
    ],
    [
        113.05465557363,
        22.904153848859
    ],
    [
        113.05448686588,
        22.904155358055
    ],
    [
        113.05423612606,
        22.904166377324
    ],
    [
        113.0539845744,
        22.904158358396
    ],
    [
        113.05384086865,
        22.90413979956
    ],
    [
        113.05372649792,
        22.904109363751
    ],
    [
        113.05372079146,
        22.904103975697
    ],
    [
        113.05364553899,
        22.904077070638
    ],
    [
        113.05359364249,
        22.904038072262
    ],
    [
        113.05356511049,
        22.904009772025
    ],
    [
        113.05352733563,
        22.903961726552
    ],
    [
        113.053492526,
        22.903855333544
    ],
    [
        113.05342592328,
        22.903711433025
    ],
    [
        113.05337968488,
        22.903544612112
    ],
    [
        113.05331908442,
        22.903463335609
    ],
    [
        113.05326689487,
        22.903354874864
    ],
    [
        113.05318914998,
        22.903176034612
    ],
    [
        113.05310788348,
        22.903015929708
    ],
    [
        113.05303207837,
        22.902934188403
    ],
    [
        113.05298968916,
        22.902876387315
    ],
    [
        113.05296249642,
        22.902779157702
    ],
    [
        113.05286494373,
        22.902627543065
    ],
    [
        113.05280298308,
        22.9025107097
    ],
    [
        113.05277388987,
        22.902406976195
    ],
    [
        113.05269781042,
        22.902294017096
    ],
    [
        113.05261683136,
        22.902139031643
    ],
    [
        113.05254047431,
        22.901993509825
    ],
    [
        113.05248122219,
        22.901826457131
    ],
    [
        113.05241084018,
        22.901667872411
    ],
    [
        113.05240566967,
        22.901629649762
    ],
    [
        113.0524032168,
        22.901598194328
    ],
    [
        113.05241353138,
        22.901579961922
    ],
    [
        113.05252594504,
        22.901517759509
    ],
    [
        113.05283577299,
        22.901342097798
    ],
    [
        113.05305844171,
        22.901191840243
    ],
    [
        113.05312931326,
        22.901126844795
    ],
    [
        113.05323901602,
        22.901022269153
    ],
    [
        113.05327622014,
        22.900996266201
    ],
    [
        113.05339707635,
        22.900948032598
    ],
    [
        113.05351060074,
        22.900896849482
    ],
    [
        113.05367490577,
        22.900776959696
    ],
    [
        113.05376343706,
        22.900688207992
    ],
    [
        113.05379221544,
        22.900623180195
    ],
    [
        113.05379192629,
        22.900545324697
    ],
    [
        113.05380573886,
        22.900358049313
    ],
    [
        113.05381794286,
        22.900264918789
    ],
    [
        113.05385432753,
        22.900193599364
    ],
    [
        113.05395372219,
        22.90006569647
    ],
    [
        113.05419978287,
        22.899788103835
    ],
    [
        113.0543372089,
        22.899605103215
    ],
    [
        113.05449745173,
        22.899371192396
    ],
    [
        113.05457838758,
        22.899232792268
    ],
    [
        113.05459740013,
        22.899203354644
    ],
    [
        113.05461125001,
        22.899167444172
    ],
    [
        113.05462428506,
        22.899132082122
    ],
    [
        113.05461096765,
        22.899095558133
    ],
    [
        113.05458732169,
        22.899023572883
    ],
    [
        113.05451097131,
        22.898945733168
    ],
    [
        113.05441723537,
        22.898865301309
    ],
    [
        113.05430530387,
        22.898813746818
    ],
    [
        113.05416947082,
        22.898774827897
    ],
    [
        113.05402711939,
        22.898719119115
    ],
    [
        113.05385624628,
        22.898636457968
    ],
    [
        113.05376904326,
        22.898570850767
    ],
    [
        113.05371824086,
        22.898510151152
    ],
    [
        113.05364597191,
        22.89837173463
    ],
    [
        113.05356962817,
        22.898209468228
    ],
    [
        113.05351909689,
        22.898112407837
    ],
    [
        113.05346340366,
        22.897990963842
    ],
    [
        113.05338109006,
        22.897827638781
    ],
    [
        113.05327432954,
        22.897597185428
    ],
    [
        113.05320913574,
        22.897474432674
    ],
    [
        113.05315806752,
        22.897362712005
    ],
    [
        113.05316295575,
        22.897350474864
    ],
    [
        113.05315724971,
        22.897305207689
    ],
    [
        113.05316974313,
        22.897296992952
    ],
    [
        113.0532449767,
        22.897265061294
    ],
    [
        113.0534125589,
        22.89720270236
    ],
    [
        113.05348100547,
        22.897173782392
    ],
    [
        113.0534864371,
        22.897155843757
    ],
    [
        113.053487794,
        22.897127080451
    ],
    [
        113.05341771221,
        22.897017663666
    ],
    [
        113.0533321484,
        22.896851644869
    ],
    [
        113.05328923151,
        22.896758597112
    ],
    [
        113.05327727974,
        22.896713098536
    ],
    [
        113.05328053868,
        22.89669164801
    ],
    [
        113.0533997763,
        22.896654548426
    ],
    [
        113.05357551404,
        22.896612459683
    ],
    [
        113.05364287716,
        22.896600627269
    ],
    [
        113.05367329977,
        22.896617788825
    ],
    [
        113.05371377335,
        22.896664451454
    ],
    [
        113.05389550129,
        22.89684715638
    ],
    [
        113.05394439796,
        22.896895381728
    ],
    [
        113.05397672327,
        22.896889464599
    ],
    [
        113.05403159464,
        22.89685762109
    ],
    [
        113.05416497269,
        22.89678942101
    ],
    [
        113.05430922114,
        22.896756664716
    ],
    [
        113.05446922984,
        22.896723505318
    ],
    [
        113.05452301963,
        22.896701141211
    ],
    [
        113.05454638294,
        22.896685779432
    ],
    [
        113.05455589097,
        22.896661024386
    ],
    [
        113.05451133608,
        22.896585123572
    ],
    [
        113.054402125,
        22.896389787848
    ],
    [
        113.05425977637,
        22.89614123782
    ],
    [
        113.05416768887,
        22.895942233641
    ],
    [
        113.05414650241,
        22.895846896048
    ],
    [
        113.05414922168,
        22.895754646707
    ],
    [
        113.0541600896,
        22.895700046408
    ],
    [
        113.05418807202,
        22.895640714607
    ],
    [
        113.05427717761,
        22.895575253817
    ],
    [
        113.05451733388,
        22.8954400643
    ],
    [
        113.05469039411,
        22.895347644587
    ],
    [
        113.05479553707,
        22.895290434792
    ],
    [
        113.05481183835,
        22.895284072897
    ],
    [
        113.05482297675,
        22.895294296889
    ],
    [
        113.05487975503,
        22.895361140392
    ],
    [
        113.05495419314,
        22.895442494394
    ],
    [
        113.05499277213,
        22.895462000576
    ],
    [
        113.05503868821,
        22.895457848789
    ],
    [
        113.05515796373,
        22.895432506978
    ],
    [
        113.05542478141,
        22.895351992917
    ],
    [
        113.05549488509,
        22.895314805832
    ],
    [
        113.05552776404,
        22.895287683634
    ],
    [
        113.05553781895,
        22.895262374225
    ],
    [
        113.05554515963,
        22.895189886929
    ],
    [
        113.05555250172,
        22.895100581289
    ],
    [
        113.05557424466,
        22.895019295977
    ],
    [
        113.05563321243,
        22.894952353072
    ],
    [
        113.05568430009,
        22.894897950609
    ],
    [
        113.05583484313,
        22.89480799434
    ],
    [
        113.05594272504,
        22.894752561037
    ],
    [
        113.05598022729,
        22.894718877363
    ],
    [
        113.05598838162,
        22.894693038053
    ],
    [
        113.05598376262,
        22.894687380849
    ],
    [
        113.05596583154,
        22.894649285286
    ],
    [
        113.05589465465,
        22.894470041053
    ],
    [
        113.05578598579,
        22.89425638515
    ],
    [
        113.05567949083,
        22.894077694767
    ],
    [
        113.05561510735,
        22.893963752996
    ],
    [
        113.05556295221,
        22.893851878277
    ],
    [
        113.05555480528,
        22.893818037291
    ],
    [
        113.05554992077,
        22.893771420467
    ],
    [
        113.05556459514,
        22.893759094052
    ],
    [
        113.05559530034,
        22.893750705157
    ],
    [
        113.05573660179,
        22.893703968035
    ],
    [
        113.0559746449,
        22.893647444535
    ],
    [
        113.05618389187,
        22.893595465203
    ],
    [
        113.05632846556,
        22.893567620001
    ],
    [
        113.05639341574,
        22.893557824851
    ],
    [
        113.05641896085,
        22.893556242523
    ],
    [
        113.05643771383,
        22.893543598347
    ],
    [
        113.05642712195,
        22.893500019622
    ],
    [
        113.05641464124,
        22.893371282391
    ],
    [
        113.05633480163,
        22.8930394247
    ],
    [
        113.05628756105,
        22.892799505409
    ],
    [
        113.05627018062,
        22.892739438469
    ],
    [
        113.05625224709,
        22.892730101087
    ],
    [
        113.056210939,
        22.892744023618
    ],
    [
        113.05603700453,
        22.892849685666
    ],
    [
        113.05583536096,
        22.892945790776
    ],
    [
        113.05568346147,
        22.892974452294
    ],
    [
        113.05565275852,
        22.892966025373
    ],
    [
        113.05556880675,
        22.892915446467
    ],
    [
        113.05542129733,
        22.892751447144
    ],
    [
        113.05522598,
        22.892554986163
    ],
    [
        113.05512004059,
        22.892443245806
    ],
    [
        113.05506300217,
        22.892360413815
    ],
    [
        113.05504752733,
        22.89230601135
    ],
    [
        113.05503640619,
        22.892222279544
    ],
    [
        113.05501417327,
        22.892019281462
    ],
    [
        113.05498893387,
        22.891900395226
    ],
    [
        113.05495960446,
        22.891845827091
    ],
    [
        113.05489984672,
        22.89179013408
    ],
    [
        113.0547428322,
        22.891717538363
    ],
    [
        113.05459695596,
        22.89166382781
    ],
    [
        113.05451682379,
        22.89162209939
    ],
    [
        113.05451682886,
        22.891602026623
    ],
    [
        113.054522,
        22.891564827237
    ],
    [
        113.05463670826,
        22.891323112361
    ],
    [
        113.05474109417,
        22.891095026904
    ],
    [
        113.05475712644,
        22.89108351429
    ],
    [
        113.05477994348,
        22.89109799065
    ],
    [
        113.05490300619,
        22.891132864856
    ],
    [
        113.05512225311,
        22.891160470027
    ],
    [
        113.05519805177,
        22.891178592818
    ],
    [
        113.05522549561,
        22.891170781679
    ],
    [
        113.05527007521,
        22.891096648883
    ],
    [
        113.05531303589,
        22.890984823458
    ],
    [
        113.05531195131,
        22.890976965804
    ],
    [
        113.05533753093,
        22.890840594002
    ],
    [
        113.05533726892,
        22.890807503501
    ],
    [
        113.05530956277,
        22.890781141649
    ],
    [
        113.05525279043,
        22.89073520808
    ],
    [
        113.05506508065,
        22.890624651437
    ],
    [
        113.05485238735,
        22.890498522596
    ],
    [
        113.05476139213,
        22.890440618412
    ],
    [
        113.05470707312,
        22.890387859545
    ],
    [
        113.05469186959,
        22.890355151568
    ],
    [
        113.05468889029,
        22.890326421296
    ],
    [
        113.05472396549,
        22.890236376438
    ],
    [
        113.05472778245,
        22.890194846836
    ],
    [
        113.05471692807,
        22.890155868027
    ],
    [
        113.0546615155,
        22.890127527781
    ],
    [
        113.05453899446,
        22.890118664892
    ],
    [
        113.05437030885,
        22.890063195155
    ],
    [
        113.05413100073,
        22.890002227903
    ],
    [
        113.0539294649,
        22.889928478522
    ],
    [
        113.05369099334,
        22.889858735862
    ],
    [
        113.05344357447,
        22.889771912813
    ],
    [
        113.0532768216,
        22.889720884308
    ],
    [
        113.05304462453,
        22.889651783309
    ],
    [
        113.05282030333,
        22.88961052794
    ],
    [
        113.05273150194,
        22.889590698926
    ],
    [
        113.05268587912,
        22.889582280675
    ],
    [
        113.05263564479,
        22.88956005315
    ],
    [
        113.05261255933,
        22.889563710054
    ],
    [
        113.05259109945,
        22.889578478473
    ],
    [
        113.05250903839,
        22.889706966504
    ],
    [
        113.05247182206,
        22.889738366305
    ],
    [
        113.05246829116,
        22.889739742054
    ],
    [
        113.05244982416,
        22.889740386414
    ],
    [
        113.05242919122,
        22.889722326272
    ],
    [
        113.05235317946,
        22.889645706685
    ],
    [
        113.0522019713,
        22.889501670474
    ],
    [
        113.05210641618,
        22.889412660319
    ],
    [
        113.05202228379,
        22.889281540399
    ],
    [
        113.05194004912,
        22.889164238329
    ],
    [
        113.0519042146,
        22.889139735563
    ],
    [
        113.05189172061,
        22.889147664411
    ],
    [
        113.05184284482,
        22.889143297214
    ],
    [
        113.05164271244,
        22.889171941189
    ],
    [
        113.05141297857,
        22.889235405117
    ],
    [
        113.05115692258,
        22.889287273209
    ],
    [
        113.05101463844,
        22.889331825954
    ],
    [
        113.05074666034,
        22.889371443822
    ],
    [
        113.05052239797,
        22.889424123358
    ],
    [
        113.05037225482,
        22.88947757446
    ],
    [
        113.05027640774,
        22.889532440618
    ],
    [
        113.05007549373,
        22.889630786761
    ],
    [
        113.04989114751,
        22.88972388948
    ],
    [
        113.04961206446,
        22.88985684757
    ],
    [
        113.04936773477,
        22.889999405181
    ],
    [
        113.04916602289,
        22.890157261804
    ],
    [
        113.04900015635,
        22.890277834925
    ],
    [
        113.04882424883,
        22.890415494098
    ],
    [
        113.0486133262,
        22.890597953198
    ],
    [
        113.04852103796,
        22.890663779925
    ],
    [
        113.04851723823,
        22.89066541484
    ],
    [
        113.04850773906,
        22.890668959567
    ],
    [
        113.04848088017,
        22.89064568378
    ],
    [
        113.04841145574,
        22.890494728027
    ],
    [
        113.04830053489,
        22.890280640224
    ],
    [
        113.04818362121,
        22.890149824841
    ],
    [
        113.04806452742,
        22.890056975174
    ],
    [
        113.04789144219,
        22.889955507809
    ],
    [
        113.04776093465,
        22.889935877526
    ],
    [
        113.04770883865,
        22.889935127581
    ],
    [
        113.0476195554,
        22.889980258365
    ],
    [
        113.04752131051,
        22.890053872162
    ],
    [
        113.04737639301,
        22.890151932155
    ],
    [
        113.04731507047,
        22.890168260086
    ],
    [
        113.04723503317,
        22.890169680218
    ],
    [
        113.04708094547,
        22.890128014066
    ],
    [
        113.0469423242,
        22.890092014653
    ],
    [
        113.04685199288,
        22.890065201383
    ],
    [
        113.0467554185,
        22.890053572471
    ],
    [
        113.04667267463,
        22.890061461616
    ],
    [
        113.04663007632,
        22.890083713364
    ],
    [
        113.04661677846,
        22.890099448382
    ],
    [
        113.04658014441,
        22.890134717
    ],
    [
        113.04654132166,
        22.890227489537
    ],
    [
        113.04650222437,
        22.89033273828
    ],
    [
        113.04645880365,
        22.890387262129
    ],
    [
        113.04642624262,
        22.890414930442
    ],
    [
        113.04637442759,
        22.890424694695
    ],
    [
        113.04631502123,
        22.890423334511
    ],
    [
        113.04628681225,
        22.89041627899
    ],
    [
        113.04623012176,
        22.890407590686
    ],
    [
        113.04619839326,
        22.890380459728
    ],
    [
        113.04613766083,
        22.890290933253
    ],
    [
        113.04600127918,
        22.890116475844
    ],
    [
        113.04589744605,
        22.889957750063
    ],
    [
        113.04581883407,
        22.889819643693
    ],
    [
        113.04576541828,
        22.889768889244
    ],
    [
        113.04572067991,
        22.889725732765
    ],
    [
        113.04564528978,
        22.889692046597
    ],
    [
        113.04552704635,
        22.889661575567
    ],
    [
        113.04542534239,
        22.889651993015
    ],
    [
        113.04522601866,
        22.889604051322
    ],
    [
        113.04498792378,
        22.889549783296
    ],
    [
        113.04475985708,
        22.88954077655
    ],
    [
        113.04462400668,
        22.889511264196
    ],
    [
        113.04446945417,
        22.889467867469
    ],
    [
        113.04435233915,
        22.889390072594
    ],
    [
        113.04429406726,
        22.889315095086
    ],
    [
        113.04423986536,
        22.889235511521
    ],
    [
        113.04420193163,
        22.88916111255
    ],
    [
        113.0441439169,
        22.88912925587
    ],
    [
        113.04406909176,
        22.889097088356
    ],
    [
        113.04399398711,
        22.889089598494
    ],
    [
        113.04384485762,
        22.889095220471
    ],
    [
        113.04365097293,
        22.889161738639
    ],
    [
        113.04353435836,
        22.889244434971
    ],
    [
        113.04348363861,
        22.88929881899
    ],
    [
        113.04341770781,
        22.88943263405
    ],
    [
        113.04334064404,
        22.889619849511
    ],
    [
        113.04324542238,
        22.889797241747
    ],
    [
        113.04317164375,
        22.889907963347
    ],
    [
        113.04305394836,
        22.890020171768
    ],
    [
        113.04299538433,
        22.890042230359
    ],
    [
        113.04292815032,
        22.89005150914
    ],
    [
        113.04285794428,
        22.89003364906
    ],
    [
        113.04254542721,
        22.889922990866
    ],
    [
        113.04229880577,
        22.889783472575
    ],
    [
        113.04201913392,
        22.889629660596
    ],
    [
        113.04174651607,
        22.889498864318
    ],
    [
        113.0414760807,
        22.889368282152
    ],
    [
        113.0411763927,
        22.889233153723
    ],
    [
        113.04092060559,
        22.889141838042
    ],
    [
        113.0406008715,
        22.889072909533
    ],
    [
        113.0402868508,
        22.888991987313
    ],
    [
        113.03998095622,
        22.888962833797
    ],
    [
        113.03959435016,
        22.888911399005
    ],
    [
        113.03937111717,
        22.88889479897
    ],
    [
        113.03921101186,
        22.888884538437
    ],
    [
        113.03881983588,
        22.888877026154
    ],
    [
        113.03853650003,
        22.888855509262
    ],
    [
        113.03842192905,
        22.888832986489
    ],
    [
        113.03836830993,
        22.888799505377
    ],
    [
        113.03830359602,
        22.888740443354
    ],
    [
        113.0381936604,
        22.888653104454
    ],
    [
        113.03812541847,
        22.888616791171
    ],
    [
        113.03804822779,
        22.888608616008
    ],
    [
        113.03796994527,
        22.888623754655
    ],
    [
        113.03792497276,
        22.888652163374
    ],
    [
        113.03791060824,
        22.888675923007
    ],
    [
        113.03789650714,
        22.88871840049
    ],
    [
        113.03789507274,
        22.888921553194
    ],
    [
        113.03787494781,
        22.889135683744
    ],
    [
        113.03784781917,
        22.889252924866
    ],
    [
        113.03777435328,
        22.889435719181
    ],
    [
        113.03775563352,
        22.889523457857
    ],
    [
        113.03774504854,
        22.889585491211
    ],
    [
        113.03779566808,
        22.889664004869
    ],
    [
        113.03784789536,
        22.889794608677
    ],
    [
        113.03788170549,
        22.889927781362
    ],
    [
        113.03788791965,
        22.88997312782
    ],
    [
        113.03787870906,
        22.889978481995
    ],
    [
        113.03785324707,
        22.889985880844
    ],
    [
        113.03764606535,
        22.889952528384
    ],
    [
        113.03738852425,
        22.88989920303
    ],
    [
        113.03717757076,
        22.889856245309
    ],
    [
        113.03692599396,
        22.88984301547
    ],
    [
        113.03669094726,
        22.889826079719
    ],
    [
        113.03648271289,
        22.889821542622
    ],
    [
        113.03635950697,
        22.889823701486
    ],
    [
        113.03612717388,
        22.889853066099
    ],
    [
        113.03589972275,
        22.889883789166
    ],
    [
        113.03574051469,
        22.889897214747
    ],
    [
        113.03555423158,
        22.889924737154
    ],
    [
        113.03537091992,
        22.889988608658
    ],
    [
        113.03518895391,
        22.890093425981
    ],
    [
        113.03498697057,
        22.890167094466
    ],
    [
        113.03475820853,
        22.890194617087
    ],
    [
        113.03448885778,
        22.890197536316
    ],
    [
        113.03422222763,
        22.89019229188
    ],
    [
        113.03410528994,
        22.890198640618
    ],
    [
        113.03385870595,
        22.89019028291
    ],
    [
        113.03368494367,
        22.890169121597
    ],
    [
        113.03351253222,
        22.89016938194
    ],
    [
        113.03327814301,
        22.890179771072
    ],
    [
        113.03306431957,
        22.890223991507
    ],
    [
        113.03297906175,
        22.890244711646
    ],
    [
        113.03295010306,
        22.89024654763
    ],
    [
        113.03292033832,
        22.890230471137
    ],
    [
        113.03289572256,
        22.890193296109
    ],
    [
        113.03287654011,
        22.890093253553
    ],
    [
        113.03286873206,
        22.889971371587
    ],
    [
        113.03289609757,
        22.889877565073
    ],
    [
        113.03289693032,
        22.889816272257
    ],
    [
        113.03285746182,
        22.889688869746
    ],
    [
        113.03279799866,
        22.889474705003
    ],
    [
        113.0327482579,
        22.889323038992
    ],
    [
        113.03272420695,
        22.889228363249
    ],
    [
        113.03270312039,
        22.889168441677
    ],
    [
        113.0327042251,
        22.889109322559
    ],
    [
        113.03270535236,
        22.888991614236
    ],
    [
        113.03269810085,
        22.888848310593
    ],
    [
        113.03268217887,
        22.888733928808
    ],
    [
        113.03264295187,
        22.888699562078
    ],
    [
        113.03260695856,
        22.888700494488
    ],
    [
        113.03249167586,
        22.8886961472
    ],
    [
        113.03235988627,
        22.888695119521
    ],
    [
        113.03229223451,
        22.888691867598
    ],
    [
        113.03221836233,
        22.888681213855
    ],
    [
        113.03211285343,
        22.88861239737
    ],
    [
        113.03204306555,
        22.888543737498
    ],
    [
        113.03201251092,
        22.888486403324
    ],
    [
        113.03187506335,
        22.888446745696
    ],
    [
        113.03171138388,
        22.888376370596
    ],
    [
        113.03158342778,
        22.888300185435
    ],
    [
        113.03145899807,
        22.888208843968
    ],
    [
        113.03135483624,
        22.888183118822
    ],
    [
        113.031317228,
        22.888178845544
    ],
    [
        113.03127610114,
        22.888177781631
    ],
    [
        113.03124742661,
        22.888163041406
    ],
    [
        113.03122092321,
        22.888133138525
    ],
    [
        113.03120361953,
        22.888102809928
    ],
    [
        113.03120526462,
        22.888052107985
    ],
    [
        113.03121397834,
        22.887923648723
    ],
    [
        113.03126356746,
        22.887754208802
    ],
    [
        113.0312836541,
        22.88761043297
    ],
    [
        113.03130806355,
        22.887482986483
    ],
    [
        113.03131487416,
        22.887382170061
    ],
    [
        113.03131001385,
        22.887360408995
    ],
    [
        113.03129135083,
        22.887346067754
    ],
    [
        113.03119395983,
        22.887313365262
    ],
    [
        113.03100241014,
        22.887287313634
    ],
    [
        113.03083198209,
        22.887232760773
    ],
    [
        113.0305663284,
        22.887169073967
    ],
    [
        113.03038724439,
        22.887132261138
    ],
    [
        113.03022709579,
        22.887108701061
    ],
    [
        113.03011159551,
        22.887069993371
    ],
    [
        113.02993550501,
        22.887017709764
    ],
    [
        113.02978565177,
        22.886980683523
    ],
    [
        113.02961334839,
        22.886943606804
    ],
    [
        113.0294394324,
        22.886892385454
    ],
    [
        113.02935071619,
        22.88686945609
    ],
    [
        113.02928554587,
        22.886824065847
    ],
    [
        113.02921849536,
        22.886752607608
    ],
    [
        113.02914739467,
        22.886667799196
    ],
    [
        113.02909251105,
        22.886610882372
    ],
    [
        113.02904735191,
        22.886582038574
    ],
    [
        113.02898676169,
        22.886579286559
    ],
    [
        113.02894347729,
        22.886589254117
    ],
    [
        113.02892886538,
        22.886599626094
    ],
    [
        113.02891369894,
        22.886637385563
    ],
    [
        113.02887713292,
        22.886737498932
    ],
    [
        113.02887302345,
        22.886844310281
    ],
    [
        113.02885188687,
        22.886923213626
    ],
    [
        113.02879505997,
        22.886972315741
    ],
    [
        113.02871658929,
        22.887032228647
    ],
    [
        113.02859972129,
        22.887069346771
    ],
    [
        113.02850014876,
        22.887142510125
    ],
    [
        113.02848092787,
        22.88717803787
    ],
    [
        113.02849091065,
        22.88723161643
    ],
    [
        113.02856066567,
        22.887295275432
    ],
    [
        113.02863475379,
        22.887348957705
    ],
    [
        113.02867422628,
        22.887389394575
    ],
    [
        113.02868204778,
        22.88743887265
    ],
    [
        113.02867365012,
        22.887466419674
    ],
    [
        113.02865957477,
        22.887488460679
    ],
    [
        113.02854971999,
        22.887572058684
    ],
    [
        113.02843607225,
        22.887673497559
    ],
    [
        113.02833595584,
        22.887762376686
    ],
    [
        113.02824042232,
        22.887889562526
    ],
    [
        113.02817977223,
        22.888038408593
    ],
    [
        113.02811320727,
        22.888106606576
    ],
    [
        113.02802041212,
        22.888164111177
    ],
    [
        113.02797307111,
        22.888186202404
    ],
    [
        113.02794981664,
        22.888172841532
    ],
    [
        113.02789898759,
        22.888129238183
    ],
    [
        113.02779949541,
        22.888039346933
    ],
    [
        113.02767998399,
        22.887965157564
    ],
    [
        113.02748800088,
        22.887872250384
    ],
    [
        113.02738902333,
        22.887854768279
    ],
    [
        113.02722567711,
        22.887845264791
    ],
    [
        113.02712885217,
        22.88785899528
    ],
    [
        113.02698603628,
        22.887912439708
    ],
    [
        113.02679073163,
        22.888028274025
    ],
    [
        113.02664844453,
        22.888122661258
    ],
    [
        113.02657376291,
        22.888225944884
    ],
    [
        113.026528011,
        22.88834621733
    ],
    [
        113.02650632305,
        22.888478523183
    ],
    [
        113.02651493919,
        22.888571964805
    ],
    [
        113.02651139211,
        22.88865138565
    ],
    [
        113.02647946294,
        22.888699447173
    ],
    [
        113.02636694159,
        22.888763352251
    ],
    [
        113.02633043124,
        22.888772009844
    ],
    [
        113.02626715115,
        22.888776183122
    ],
    [
        113.0261725211,
        22.888733755138
    ],
    [
        113.02608276047,
        22.888688686531
    ],
    [
        113.02601786189,
        22.888686317416
    ],
    [
        113.02596025192,
        22.888716881415
    ],
    [
        113.02580526705,
        22.888818881287
    ],
    [
        113.02568787906,
        22.88890030645
    ],
    [
        113.02555156291,
        22.888985766144
    ],
    [
        113.02543796229,
        22.889071307402
    ],
    [
        113.02530868795,
        22.889135707463
    ],
    [
        113.02512371285,
        22.889203820821
    ],
    [
        113.02491062163,
        22.88926875533
    ],
    [
        113.02459910885,
        22.889351336142
    ],
    [
        113.02436927715,
        22.889378521286
    ],
    [
        113.02410646009,
        22.889417351873
    ],
    [
        113.02403561329,
        22.889444941347
    ],
    [
        113.02401018735,
        22.889476802229
    ],
    [
        113.02401558433,
        22.889506457152
    ],
    [
        113.02404067776,
        22.889653615664
    ],
    [
        113.02404468785,
        22.889787679166
    ],
    [
        113.02402629501,
        22.889810704544
    ],
    [
        113.02398383077,
        22.889859645317
    ],
    [
        113.02377182847,
        22.889966007073
    ],
    [
        113.02354279477,
        22.89008020803
    ],
    [
        113.0232637557,
        22.890175111776
    ],
    [
        113.0231388516,
        22.890177092802
    ],
    [
        113.02308802564,
        22.890176241816
    ],
    [
        113.02306289369,
        22.890142185541
    ],
    [
        113.02298589018,
        22.88999713092
    ],
    [
        113.02292725712,
        22.889896597213
    ],
    [
        113.02290131576,
        22.88985981364
    ],
    [
        113.02286941976,
        22.889844358519
    ],
    [
        113.0228015646,
        22.889838062725
    ],
    [
        113.02260663755,
        22.889862170558
    ],
    [
        113.02242793274,
        22.889887898412
    ],
    [
        113.02223732306,
        22.889950033508
    ],
    [
        113.02208456468,
        22.890005751452
    ],
    [
        113.02192424776,
        22.890032310016
    ],
    [
        113.02163984274,
        22.890083858961
    ],
    [
        113.02136166363,
        22.890122203591
    ],
    [
        113.02132057106,
        22.890132074071
    ],
    [
        113.02131083497,
        22.890146011268
    ],
    [
        113.02131110086,
        22.890160120934
    ],
    [
        113.02135917898,
        22.890288166813
    ],
    [
        113.02142209621,
        22.890516017441
    ],
    [
        113.02146909795,
        22.890635906364
    ],
    [
        113.02148179073,
        22.890679525202
    ],
    [
        113.02146421149,
        22.890707433047
    ],
    [
        113.02140311044,
        22.890732963976
    ],
    [
        113.02132822041,
        22.890767750172
    ],
    [
        113.02118548074,
        22.890798108536
    ],
    [
        113.02099895587,
        22.890807631535
    ],
    [
        113.02086379163,
        22.890822649298
    ],
    [
        113.02082811007,
        22.890820673999
    ],
    [
        113.02082109048,
        22.890789629311
    ],
    [
        113.02078359073,
        22.890530474367
    ],
    [
        113.02076793186,
        22.890464288117
    ],
    [
        113.02073766359,
        22.890439620941
    ],
    [
        113.0206492595,
        22.890474160978
    ],
    [
        113.02036866906,
        22.890484463846
    ],
    [
        113.02025865314,
        22.890479017182
    ],
    [
        113.02023054463,
        22.890465506055
    ],
    [
        113.02022839192,
        22.890432646904
    ],
    [
        113.02012899445,
        22.890179187514
    ],
    [
        113.02001013051,
        22.889949527473
    ],
    [
        113.01994935868,
        22.88980280127
    ],
    [
        113.01992016629,
        22.889799577219
    ],
    [
        113.01988124203,
        22.88979862367
    ],
    [
        113.01984123345,
        22.889807144627
    ],
    [
        113.01983015363,
        22.889798541516
    ],
    [
        113.01974667521,
        22.889658196394
    ],
    [
        113.01965563514,
        22.889501171241
    ],
    [
        113.0196564469,
        22.889498744253
    ],
    [
        113.01965212783,
        22.889481850874
    ],
    [
        113.0197789442,
        22.889362015242
    ],
    [
        113.01994063111,
        22.889244144508
    ],
    [
        113.02011393064,
        22.889160378757
    ],
    [
        113.0202428888,
        22.889107840702
    ],
    [
        113.02036129914,
        22.889072475527
    ],
    [
        113.02054675634,
        22.889015761825
    ],
    [
        113.0207327662,
        22.888931112322
    ],
    [
        113.02091418208,
        22.888847461066
    ],
    [
        113.02105638946,
        22.888799200502
    ],
    [
        113.02120508092,
        22.888763253587
    ],
    [
        113.02135755007,
        22.888747981544
    ],
    [
        113.02150947374,
        22.888748155732
    ],
    [
        113.02157219348,
        22.888738926412
    ],
    [
        113.02167844748,
        22.888701419657
    ],
    [
        113.02177658591,
        22.888680045917
    ],
    [
        113.02189471419,
        22.888698071242
    ],
    [
        113.02199447257,
        22.888684857068
    ],
    [
        113.02212506704,
        22.888627681095
    ],
    [
        113.02233514314,
        22.888568595886
    ],
    [
        113.02243571724,
        22.888549958484
    ],
    [
        113.02261848518,
        22.888509380656
    ],
    [
        113.02275123822,
        22.8884758164
    ],
    [
        113.02306432195,
        22.888427643039
    ],
    [
        113.02331981145,
        22.888415639462
    ],
    [
        113.02358991142,
        22.888387310652
    ],
    [
        113.02368157649,
        22.888357093632
    ],
    [
        113.02372511655,
        22.888328790652
    ],
    [
        113.02375352772,
        22.888272841082
    ],
    [
        113.02376599634,
        22.888195741883
    ],
    [
        113.02375903281,
        22.888038303978
    ],
    [
        113.0237542753,
        22.887784068082
    ],
    [
        113.02372949946,
        22.887562322409
    ],
    [
        113.02371357455,
        22.887502927638
    ],
    [
        113.02365710693,
        22.887417907103
    ],
    [
        113.02358009105,
        22.887335799658
    ],
    [
        113.02349416999,
        22.887219094263
    ],
    [
        113.02347986706,
        22.887162709029
    ],
    [
        113.02344314831,
        22.887055499605
    ],
    [
        113.02342779416,
        22.88693643947
    ],
    [
        113.02341785056,
        22.886811773332
    ],
    [
        113.02340819807,
        22.886646154488
    ],
    [
        113.02337315885,
        22.8864291195
    ],
    [
        113.02333298572,
        22.886210913954
    ],
    [
        113.02328520759,
        22.886064731555
    ],
    [
        113.02323258657,
        22.885875882858
    ],
    [
        113.02319293371,
        22.885707050947
    ],
    [
        113.02316871125,
        22.885503486919
    ],
    [
        113.02315199891,
        22.885412341959
    ],
    [
        113.02315127769,
        22.885249043615
    ],
    [
        113.02313921039,
        22.885072264917
    ],
    [
        113.02313094906,
        22.884861102832
    ],
    [
        113.02310104828,
        22.884672633997
    ],
    [
        113.02308730613,
        22.884593744767
    ],
    [
        113.02306464144,
        22.884516875906
    ],
    [
        113.02302708096,
        22.884485325077
    ],
    [
        113.02297383672,
        22.884459749012
    ],
    [
        113.0229043544,
        22.884463464052
    ],
    [
        113.02278729342,
        22.884463121579
    ],
    [
        113.02260829541,
        22.884511636529
    ],
    [
        113.02246417155,
        22.884563716632
    ],
    [
        113.0223676308,
        22.884612801204
    ],
    [
        113.02233086351,
        22.884614346982
    ],
    [
        113.02229247428,
        22.884615864818
    ],
    [
        113.02228220634,
        22.884607281958
    ],
    [
        113.0222641037,
        22.884589886275
    ],
    [
        113.02225384576,
        22.884564215509
    ],
    [
        113.02225548792,
        22.884529796206
    ],
    [
        113.02227147122,
        22.884473107959
    ],
    [
        113.0223264315,
        22.884335710495
    ],
    [
        113.02231971018,
        22.884273211742
    ],
    [
        113.02230220827,
        22.884156011207
    ],
    [
        113.02228496283,
        22.884062683899
    ],
    [
        113.02227906849,
        22.883975245477
    ],
    [
        113.02223130691,
        22.883830678072
    ],
    [
        113.0221605572,
        22.883702806697
    ],
    [
        113.02208601816,
        22.883583820249
    ],
    [
        113.02202421088,
        22.883425178057
    ],
    [
        113.02196078114,
        22.883269219664
    ],
    [
        113.02193111559,
        22.883158048867
    ],
    [
        113.02193009858,
        22.883058488282
    ],
    [
        113.02195829861,
        22.882927692559
    ],
    [
        113.02197076713,
        22.882877184695
    ],
    [
        113.02200299365,
        22.88279121123
    ],
    [
        113.02203736292,
        22.882735923554
    ],
    [
        113.0221782783,
        22.882631458938
    ],
    [
        113.0222837643,
        22.882551340513
    ],
    [
        113.0222878279,
        22.882538661584
    ],
    [
        113.02235357434,
        22.882458950579
    ],
    [
        113.02236712474,
        22.882409544838
    ],
    [
        113.02238121795,
        22.882357164706
    ],
    [
        113.0223539522,
        22.882300014251
    ],
    [
        113.02231182766,
        22.882228507128
    ],
    [
        113.02219377045,
        22.882109598444
    ],
    [
        113.02209729207,
        22.882062388072
    ],
    [
        113.02208485313,
        22.882067329443
    ],
    [
        113.02205944395,
        22.882063641358
    ],
    [
        113.0220256313,
        22.882093442566
    ],
    [
        113.0219958799,
        22.882114362128
    ],
    [
        113.02186848987,
        22.882204946694
    ],
    [
        113.02159859744,
        22.882352753369
    ],
    [
        113.02143822045,
        22.882458760228
    ],
    [
        113.0213062651,
        22.882511546957
    ],
    [
        113.02125165143,
        22.882523081465
    ],
    [
        113.02121326396,
        22.882524859859
    ],
    [
        113.02117786192,
        22.882509059298
    ],
    [
        113.02113922755,
        22.882476114863
    ],
    [
        113.02106142784,
        22.882396382903
    ],
    [
        113.02099956171,
        22.882340251644
    ],
    [
        113.02088932742,
        22.882255886535
    ],
    [
        113.02083878769,
        22.882240634524
    ],
    [
        113.0207766163,
        22.882237114268
    ],
    [
        113.02058114949,
        22.882275214856
    ],
    [
        113.02054087165,
        22.882275869848
    ],
    [
        113.02051142231,
        22.882253387084
    ],
    [
        113.02045633946,
        22.882162649168
    ],
    [
        113.02041423227,
        22.882071865763
    ],
    [
        113.02037052649,
        22.881947963802
    ],
    [
        113.02031656426,
        22.881802726439
    ],
    [
        113.02028095577,
        22.881698222795
    ],
    [
        113.02023426191,
        22.881597865043
    ],
    [
        113.02016375385,
        22.881535605563
    ],
    [
        113.02006299302,
        22.881442437865
    ],
    [
        113.01998411101,
        22.881373248847
    ],
    [
        113.01990145696,
        22.881287447558
    ],
    [
        113.01985040752,
        22.881232577437
    ],
    [
        113.01984581014,
        22.88123548035
    ],
    [
        113.01980203281,
        22.881217353593
    ],
    [
        113.01965120849,
        22.881205212329
    ],
    [
        113.01938171599,
        22.881198302053
    ],
    [
        113.01913707032,
        22.881223825166
    ],
    [
        113.01896028829,
        22.881227484954
    ],
    [
        113.01876917724,
        22.881236312135
    ],
    [
        113.01853076131,
        22.881249179582
    ],
    [
        113.01847995715,
        22.881231734439
    ],
    [
        113.01844861488,
        22.88121409149
    ],
    [
        113.01842971844,
        22.881179852694
    ],
    [
        113.01833525851,
        22.880979094557
    ],
    [
        113.01821269817,
        22.880765903201
    ],
    [
        113.01811691785,
        22.880527961868
    ],
    [
        113.01805164602,
        22.88033992571
    ],
    [
        113.01800630701,
        22.880245275162
    ],
    [
        113.01799148032,
        22.880192664555
    ],
    [
        113.01798751194,
        22.880079220216
    ],
    [
        113.01796977763,
        22.87994112085
    ],
    [
        113.01794797599,
        22.879820579205
    ],
    [
        113.01792694693,
        22.879750228636
    ],
    [
        113.01791831719,
        22.879724579837
    ],
    [
        113.01788431462,
        22.879653456304
    ],
    [
        113.01783192224,
        22.879594753656
    ],
    [
        113.01776303505,
        22.879544708181
    ],
    [
        113.01764792847,
        22.879492755665
    ],
    [
        113.0175560583,
        22.879452878557
    ],
    [
        113.01739582498,
        22.879384932989
    ],
    [
        113.01723019599,
        22.879304413766
    ],
    [
        113.01707485442,
        22.879204005923
    ],
    [
        113.01695761063,
        22.879121905788
    ],
    [
        113.01686524422,
        22.879027500815
    ],
    [
        113.01680583868,
        22.878952668797
    ],
    [
        113.01673375241,
        22.87884913201
    ],
    [
        113.01667251062,
        22.878705646833
    ],
    [
        113.01660209277,
        22.878545724674
    ],
    [
        113.01654571922,
        22.878400427846
    ],
    [
        113.01647013327,
        22.878281911474
    ],
    [
        113.01643585247,
        22.8782248857
    ],
    [
        113.01639750397,
        22.878184061043
    ],
    [
        113.01632112591,
        22.878043832673
    ],
    [
        113.01625606552,
        22.877946117282
    ],
    [
        113.01624152981,
        22.877873712324
    ],
    [
        113.01625644961,
        22.877809697659
    ],
    [
        113.01630842558,
        22.877715423469
    ],
    [
        113.01641365682,
        22.877613418909
    ],
    [
        113.01650456792,
        22.877505192383
    ],
    [
        113.01661015848,
        22.877299315302
    ],
    [
        113.01665598191,
        22.877131701203
    ],
    [
        113.01665146143,
        22.877044828873
    ],
    [
        113.01662046324,
        22.876945008568
    ],
    [
        113.01656160428,
        22.876868830898
    ],
    [
        113.01648733363,
        22.876798345605
    ],
    [
        113.016329015,
        22.876711445698
    ],
    [
        113.01620041647,
        22.876639179078
    ],
    [
        113.01603910522,
        22.876574738019
    ],
    [
        113.01584106444,
        22.876474926965
    ],
    [
        113.01573625142,
        22.876403627753
    ],
    [
        113.01563068223,
        22.876270205392
    ],
    [
        113.01559667734,
        22.876210473575
    ],
    [
        113.01557701996,
        22.876126315836
    ],
    [
        113.01560790845,
        22.876042243943
    ],
    [
        113.01566852776,
        22.875960599837
    ],
    [
        113.01577510124,
        22.875875163201
    ],
    [
        113.01594792073,
        22.87576405563
    ],
    [
        113.01608561815,
        22.87563469389
    ],
    [
        113.0162297971,
        22.87551195741
    ],
    [
        113.01628932054,
        22.87544765323
    ],
    [
        113.01637702851,
        22.8753022134
    ],
    [
        113.01643472784,
        22.875163562083
    ],
    [
        113.01647376976,
        22.875032986341
    ],
    [
        113.01652818425,
        22.874940384334
    ],
    [
        113.01654144823,
        22.874919194143
    ],
    [
        113.01657824065,
        22.874884319609
    ],
    [
        113.01672830005,
        22.874836003287
    ],
    [
        113.01713439398,
        22.87471983038
    ],
    [
        113.01742613883,
        22.874618976056
    ],
    [
        113.01779277709,
        22.874497209114
    ],
    [
        113.01792986772,
        22.87444485855
    ],
    [
        113.01803050555,
        22.874352261173
    ],
    [
        113.01811252973,
        22.874220276897
    ],
    [
        113.01814450636,
        22.874133511464
    ],
    [
        113.01816190953,
        22.874022619954
    ],
    [
        113.01814748972,
        22.873834950818
    ],
    [
        113.01812861166,
        22.87378932198
    ],
    [
        113.01807380036,
        22.873725968335
    ],
    [
        113.01803517542,
        22.87369626197
    ],
    [
        113.01796249298,
        22.873666221804
    ],
    [
        113.01792492853,
        22.873658502787
    ],
    [
        113.01764230505,
        22.873542279067
    ],
    [
        113.01748559831,
        22.873471957896
    ],
    [
        113.01739483693,
        22.873409860901
    ],
    [
        113.01733922965,
        22.873331844858
    ],
    [
        113.01730216992,
        22.873078951041
    ],
    [
        113.01730642335,
        22.872871543955
    ],
    [
        113.01730518254,
        22.872756524934
    ],
    [
        113.01726749527,
        22.872596377282
    ],
    [
        113.01718924418,
        22.872456391348
    ],
    [
        113.0171050515,
        22.872311688752
    ],
    [
        113.016998232,
        22.872087115998
    ],
    [
        113.01693945819,
        22.871932288346
    ],
    [
        113.01692441252,
        22.87183926368
    ],
    [
        113.01693347045,
        22.871698391499
    ],
    [
        113.01695852591,
        22.871507086513
    ],
    [
        113.01700702493,
        22.871389699205
    ],
    [
        113.01704600766,
        22.871329098176
    ],
    [
        113.01712146133,
        22.871288131794
    ],
    [
        113.01715363592,
        22.871278940836
    ],
    [
        113.01715580175,
        22.871275453566
    ],
    [
        113.01718418928,
        22.871269178544
    ],
    [
        113.01720093035,
        22.871286834545
    ],
    [
        113.01738651867,
        22.871395099364
    ],
    [
        113.01762610527,
        22.871566432052
    ],
    [
        113.01772061197,
        22.871666293506
    ],
    [
        113.01774086546,
        22.871685638851
    ],
    [
        113.01775675378,
        22.871746131747
    ],
    [
        113.01776177482,
        22.871863116091
    ],
    [
        113.01775906683,
        22.871868221101
    ],
    [
        113.01782441459,
        22.87193447503
    ],
    [
        113.01783224971,
        22.871938140116
    ],
    [
        113.01784306392,
        22.871935891334
    ],
    [
        113.01785578744,
        22.871916047278
    ],
    [
        113.01793482,
        22.871808964156
    ],
    [
        113.01803544886,
        22.871730470836
    ],
    [
        113.01814095184,
        22.8716433843
    ],
    [
        113.01819914087,
        22.871567933457
    ],
    [
        113.01819970843,
        22.8715405505
    ],
    [
        113.01819784091,
        22.8715155653
    ],
    [
        113.01818193481,
        22.871473244246
    ],
    [
        113.01811447592,
        22.871355151991
    ],
    [
        113.01805050729,
        22.871261259776
    ],
    [
        113.01801948652,
        22.87119670151
    ],
    [
        113.01799396421,
        22.871038941932
    ],
    [
        113.01799292176,
        22.870999868067
    ],
    [
        113.01800538876,
        22.870966458491
    ],
    [
        113.01800052477,
        22.870965016019
    ],
    [
        113.0180628077,
        22.870850583314
    ],
    [
        113.01814568501,
        22.870684713347
    ],
    [
        113.01817683647,
        22.870617733064
    ],
    [
        113.01817819959,
        22.870606094905
    ],
    [
        113.01818043369,
        22.870534261939
    ],
    [
        113.01814548895,
        22.87033972137
    ],
    [
        113.01807485819,
        22.870151870108
    ],
    [
        113.01803123109,
        22.869990806141
    ],
    [
        113.01801726593,
        22.8699007853
    ],
    [
        113.01798250827,
        22.869790325114
    ],
    [
        113.01794755676,
        22.869604191907
    ],
    [
        113.01794815839,
        22.869543721236
    ],
    [
        113.01795169359,
        22.869522629121
    ],
    [
        113.01795872649,
        22.869517600931
    ],
    [
        113.01798278476,
        22.869516129745
    ],
    [
        113.01806306001,
        22.869520267484
    ],
    [
        113.01835576191,
        22.869555023685
    ],
    [
        113.01849765721,
        22.869568658559
    ],
    [
        113.01871334084,
        22.869587394472
    ],
    [
        113.0188706438,
        22.869601838904
    ],
    [
        113.0189357907,
        22.869598650808
    ],
    [
        113.01911263976,
        22.869530714943
    ],
    [
        113.01936382984,
        22.869457575692
    ],
    [
        113.01943874777,
        22.869415771429
    ],
    [
        113.01956400337,
        22.869314912839
    ],
    [
        113.01965708838,
        22.869218097418
    ],
    [
        113.01970879778,
        22.869139268092
    ],
    [
        113.0197611327,
        22.868976914644
    ],
    [
        113.01978261453,
        22.868851718469
    ],
    [
        113.01981514245,
        22.868762787846
    ],
    [
        113.01982056212,
        22.86874959333
    ],
    [
        113.01989094188,
        22.868652918591
    ],
    [
        113.02004167208,
        22.8684906599
    ],
    [
        113.02044514312,
        22.868070543439
    ],
    [
        113.02052606221,
        22.867978926372
    ],
    [
        113.02060054369,
        22.867838648313
    ],
    [
        113.02068857131,
        22.86766931335
    ],
    [
        113.0208434894,
        22.867382616657
    ],
    [
        113.02096562388,
        22.867169660196
    ],
    [
        113.02103303157,
        22.867075359643
    ],
    [
        113.02106396476,
        22.86696225558
    ],
    [
        113.02111063487,
        22.866792739382
    ],
    [
        113.02115157072,
        22.866679265278
    ],
    [
        113.02121927532,
        22.866559743997
    ],
    [
        113.02130160384,
        22.866414979679
    ],
    [
        113.02139773963,
        22.866250652924
    ],
    [
        113.02144020862,
        22.866224262789
    ],
    [
        113.02145886641,
        22.866219430897
    ],
    [
        113.02155373495,
        22.866236793345
    ],
    [
        113.02164805269,
        22.866264450323
    ],
    [
        113.02185885922,
        22.866317696081
    ],
    [
        113.02246374908,
        22.866447061878
    ],
    [
        113.02317623099,
        22.866606601211
    ],
    [
        113.02320354526,
        22.866598650336
    ],
    [
        113.02322490791,
        22.866594396777
    ],
    [
        113.02323410383,
        22.866590753434
    ],
    [
        113.02324197418,
        22.866561593641
    ],
    [
        113.02315621287,
        22.866354849301
    ],
    [
        113.02288828631,
        22.865833688123
    ],
    [
        113.02287592082,
        22.865764862532
    ],
    [
        113.02287458859,
        22.865745855016
    ],
    [
        113.02308000873,
        22.865530162149
    ],
    [
        113.02309895197,
        22.865512308124
    ],
    [
        113.02317548413,
        22.865491620922
    ],
    [
        113.02329711488,
        22.865521317329
    ],
    [
        113.02359358806,
        22.865632296123
    ],
    [
        113.02361575231,
        22.865637816853
    ],
    [
        113.02362413266,
        22.865638769459
    ],
    [
        113.02367120671,
        22.865609173411
    ],
    [
        113.02381500876,
        22.865378577468
    ],
    [
        113.023825864,
        22.865339159218
    ],
    [
        113.02383185435,
        22.865298033327
    ],
    [
        113.02375982754,
        22.865140623152
    ],
    [
        113.02362804222,
        22.86472727819
    ],
    [
        113.02355030534,
        22.864338149678
    ],
    [
        113.02353106607,
        22.864116246715
    ],
    [
        113.02353635058,
        22.863971776376
    ],
    [
        113.02361030139,
        22.863833327556
    ],
    [
        113.02390464444,
        22.863388518041
    ],
    [
        113.02390388382,
        22.863338872941
    ],
    [
        113.02389743116,
        22.86330323725
    ],
    [
        113.0238104626,
        22.863214199351
    ],
    [
        113.02353918817,
        22.863043450547
    ],
    [
        113.0234454368,
        22.862979783313
    ],
    [
        113.02339843344,
        22.862940759225
    ],
    [
        113.02338816978,
        22.862930824453
    ],
    [
        113.0233814378,
        22.862904133077
    ],
    [
        113.02338741065,
        22.862879551899
    ],
    [
        113.0234672882,
        22.862760190339
    ],
    [
        113.02354683454,
        22.862701302403
    ],
    [
        113.02362039003,
        22.862685165192
    ],
    [
        113.02377528918,
        22.862705901148
    ],
    [
        113.02379069937,
        22.86270669825
    ],
    [
        113.02383292722,
        22.862656949411
    ],
    [
        113.02393043062,
        22.862488504588
    ],
    [
        113.02394289732,
        22.862459147328
    ],
    [
        113.02395535938,
        22.862434400616
    ],
    [
        113.02391321171,
        22.862404414938
    ],
    [
        113.02386781676,
        22.862377358443
    ],
    [
        113.02385380177,
        22.86233346133
    ],
    [
        113.02384822898,
        22.862229222151
    ],
    [
        113.02389840506,
        22.862072472828
    ],
    [
        113.02393825431,
        22.861968168561
    ],
    [
        113.02394104639,
        22.861880069056
    ],
    [
        113.02392514449,
        22.861830174399
    ],
    [
        113.02390137236,
        22.861809712571
    ],
    [
        113.02384976675,
        22.861774688063
    ],
    [
        113.02355710922,
        22.86162501353
    ],
    [
        113.02322202662,
        22.861459684006
    ],
    [
        113.02321230741,
        22.861445960665
    ],
    [
        113.02321016433,
        22.861426125974
    ],
    [
        113.02320913724,
        22.861371594126
    ],
    [
        113.02324235639,
        22.861134834149
    ],
    [
        113.02326819954,
        22.860974433863
    ],
    [
        113.02331059805,
        22.860749488559
    ],
    [
        113.02333751622,
        22.860594801037
    ],
    [
        113.0233877031,
        22.860421786952
    ],
    [
        113.02340477898,
        22.860377862879
    ],
    [
        113.02348694414,
        22.860127268648
    ],
    [
        113.02356227416,
        22.85995412695
    ],
    [
        113.02364430825,
        22.85983750781
    ],
    [
        113.02375335227,
        22.859748726194
    ],
    [
        113.02380420331,
        22.85972624189
    ],
    [
        113.02391317238,
        22.859715835086
    ],
    [
        113.02420896716,
        22.859709574378
    ],
    [
        113.02444771771,
        22.859703437921
    ],
    [
        113.02459727525,
        22.859666542405
    ],
    [
        113.02472927457,
        22.859613894822
    ],
    [
        113.02486158626,
        22.85951920654
    ],
    [
        113.02495980511,
        22.859450000142
    ],
    [
        113.02508427973,
        22.859353004201
    ],
    [
        113.02515355926,
        22.859292547336
    ],
    [
        113.02526590816,
        22.859153309049
    ],
    [
        113.02538205006,
        22.859007074098
    ],
    [
        113.02551523075,
        22.858858120166
    ],
    [
        113.0255796597,
        22.858782114426
    ],
    [
        113.02573036474,
        22.858689839002
    ],
    [
        113.0258472378,
        22.858631467282
    ],
    [
        113.0262132487,
        22.858487202701
    ],
    [
        113.02652784498,
        22.85839036277
    ],
    [
        113.02671746203,
        22.858343369667
    ],
    [
        113.02681511062,
        22.858320723677
    ],
    [
        113.0269389717,
        22.858320440503
    ],
    [
        113.02709392031,
        22.858336079796
    ],
    [
        113.02729374424,
        22.85837462198
    ],
    [
        113.0275568242,
        22.858449888029
    ],
    [
        113.02777963578,
        22.858500114137
    ],
    [
        113.0280879479,
        22.858522273902
    ],
    [
        113.02832622228,
        22.858537674057
    ],
    [
        113.02846281619,
        22.858536663939
    ],
    [
        113.02855371032,
        22.858524681603
    ],
    [
        113.02866602937,
        22.858454146527
    ],
    [
        113.02887089148,
        22.858348846985
    ],
    [
        113.02904411933,
        22.858233043315
    ],
    [
        113.02917673561,
        22.85815869311
    ],
    [
        113.02925037946,
        22.858088121014
    ],
    [
        113.02933324135,
        22.857995976464
    ],
    [
        113.02938876982,
        22.857917009625
    ],
    [
        113.02945701931,
        22.857830894154
    ],
    [
        113.02953962274,
        22.857727344665
    ],
    [
        113.02957974155,
        22.857638666169
    ],
    [
        113.02962202148,
        22.857553271034
    ],
    [
        113.02967028585,
        22.857432155813
    ],
    [
        113.02973667368,
        22.857312643205
    ],
    [
        113.02976947681,
        22.857236607317
    ],
    [
        113.0297890544,
        22.857127572642
    ],
    [
        113.02982134331,
        22.857021965581
    ],
    [
        113.02984066422,
        22.856897195876
    ],
    [
        113.02987326621,
        22.85674412825
    ],
    [
        113.02990528317,
        22.856639329336
    ],
    [
        113.02992510873,
        22.856553892388
    ],
    [
        113.02997833989,
        22.856322719033
    ],
    [
        113.03003080768,
        22.856035932857
    ],
    [
        113.0300292589,
        22.855951833062
    ],
    [
        113.03001039537,
        22.855868313038
    ],
    [
        113.0299672516,
        22.855707708245
    ],
    [
        113.02993684335,
        22.855522864815
    ],
    [
        113.02991204137,
        22.855423260788
    ],
    [
        113.02985859815,
        22.855283397127
    ],
    [
        113.0297465284,
        22.855053498585
    ],
    [
        113.0297170732,
        22.855016480428
    ],
    [
        113.02972140894,
        22.855007860617
    ],
    [
        113.02973007809,
        22.854993333167
    ],
    [
        113.02980963898,
        22.854961872939
    ],
    [
        113.02983154896,
        22.854964883748
    ],
    [
        113.02994625458,
        22.854962644995
    ],
    [
        113.03021544924,
        22.854947013863
    ],
    [
        113.03026631051,
        22.854947151455
    ],
    [
        113.03031342023,
        22.854905469
    ],
    [
        113.03034050815,
        22.854865959832
    ],
    [
        113.03035972665,
        22.854854281642
    ],
    [
        113.03041194386,
        22.854851720425
    ],
    [
        113.0305988809,
        22.854865580435
    ],
    [
        113.03084019833,
        22.854886906488
    ],
    [
        113.03095571724,
        22.85489979457
    ],
    [
        113.03112560146,
        22.854936967837
    ],
    [
        113.03140720299,
        22.855015135437
    ],
    [
        113.03152948454,
        22.855040270669
    ],
    [
        113.03156060309,
        22.855038762118
    ],
    [
        113.03161257346,
        22.85501798538
    ],
    [
        113.03163640466,
        22.854995228804
    ],
    [
        113.03165671575,
        22.854975411453
    ],
    [
        113.03165948693,
        22.854898960931
    ],
    [
        113.03165198282,
        22.854813974419
    ],
    [
        113.03163203296,
        22.854727205271
    ],
    [
        113.03163560109,
        22.854667580514
    ],
    [
        113.03164784021,
        22.854593417733
    ],
    [
        113.03168443106,
        22.854520642862
    ],
    [
        113.03175458883,
        22.854431738766
    ],
    [
        113.03178059411,
        22.854397886561
    ],
    [
        113.03179197754,
        22.854375786995
    ],
    [
        113.03178687418,
        22.85433042938
    ],
    [
        113.03178941596,
        22.854202714032
    ],
    [
        113.03178137926,
        22.854104973669
    ],
    [
        113.03177800687,
        22.85392890689
    ],
    [
        113.0317792685,
        22.853710043647
    ],
    [
        113.03175640083,
        22.853546753801
    ],
    [
        113.03173778108,
        22.853483598534
    ],
    [
        113.0317137545,
        22.853414137658
    ],
    [
        113.0316823799,
        22.853396931597
    ],
    [
        113.03166724254,
        22.853377486123
    ],
    [
        113.03147894604,
        22.853338785224
    ],
    [
        113.0313864143,
        22.853330295426
    ],
    [
        113.031354233,
        22.853308461468
    ],
    [
        113.03134699524,
        22.853223747196
    ],
    [
        113.03135550344,
        22.853072781738
    ],
    [
        113.03138784015,
        22.852898520679
    ],
    [
        113.03138353421,
        22.852868902507
    ],
    [
        113.03135839074,
        22.852843089109
    ],
    [
        113.03120990541,
        22.852766072439
    ],
    [
        113.03118827345,
        22.85274843782
    ],
    [
        113.03117530016,
        22.852730371102
    ],
    [
        113.03116454076,
        22.852649136591
    ],
    [
        113.03114827735,
        22.852337287891
    ],
    [
        113.03116058557,
        22.852164130516
    ],
    [
        113.03116603803,
        22.852110225778
    ],
    [
        113.03123570482,
        22.851938884662
    ],
    [
        113.03128914936,
        22.851750517974
    ],
    [
        113.0313433687,
        22.851610709054
    ],
    [
        113.03134446367,
        22.851593635473
    ],
    [
        113.03136178208,
        22.851591684921
    ],
    [
        113.03149518673,
        22.851580077204
    ],
    [
        113.03154525868,
        22.85156117716
    ],
    [
        113.03157504,
        22.851538224433
    ],
    [
        113.03157532,
        22.851525480151
    ],
    [
        113.03157400351,
        22.851476099893
    ],
    [
        113.03157559129,
        22.851154712298
    ],
    [
        113.03156437441,
        22.850949792891
    ],
    [
        113.03156792228,
        22.850907525327
    ],
    [
        113.03157550713,
        22.850895686117
    ],
    [
        113.03169162203,
        22.850849669411
    ],
    [
        113.03195172328,
        22.850765274078
    ],
    [
        113.03222128843,
        22.850704001776
    ],
    [
        113.03251224476,
        22.850639407698
    ],
    [
        113.03261944878,
        22.850585888196
    ],
    [
        113.03264680202,
        22.850557188998
    ],
    [
        113.03264791812,
        22.850509194195
    ],
    [
        113.03265207945,
        22.850362778168
    ],
    [
        113.0326562278,
        22.850233991894
    ],
    [
        113.03262735542,
        22.85011078345
    ],
    [
        113.0325862838,
        22.850018079366
    ],
    [
        113.03250385266,
        22.849857888682
    ],
    [
        113.03241171921,
        22.849637634638
    ],
    [
        113.03235824073,
        22.84948130675
    ],
    [
        113.03236366332,
        22.849465640175
    ],
    [
        113.03237721139,
        22.849439221523
    ],
    [
        113.03268397221,
        22.849212583418
    ],
    [
        113.03274161615,
        22.849212175034
    ],
    [
        113.03290987156,
        22.849331851949
    ],
    [
        113.03292746168,
        22.849333683242
    ],
    [
        113.03294776631,
        22.849323068968
    ],
    [
        113.0330728943,
        22.849179943449
    ],
    [
        113.03308832811,
        22.849168728729
    ],
    [
        113.03314650356,
        22.849188652433
    ],
    [
        113.03327312167,
        22.849257631021
    ],
    [
        113.03344576198,
        22.849313281866
    ],
    [
        113.03392203345,
        22.84946636141
    ],
    [
        113.03393746184,
        22.849466528918
    ],
    [
        113.03395235266,
        22.84946099452
    ],
    [
        113.03401660837,
        22.849300034291
    ],
    [
        113.03402149588,
        22.849276489687
    ],
    [
        113.03399011356,
        22.849251197214
    ],
    [
        113.03385132368,
        22.849148247874
    ],
    [
        113.03374663577,
        22.849052440361
    ],
    [
        113.03359972355,
        22.848959953932
    ],
    [
        113.03355968626,
        22.848927503229
    ],
    [
        113.03355997033,
        22.848906350083
    ],
    [
        113.03367403704,
        22.848719377792
    ],
    [
        113.03367946945,
        22.848688788214
    ],
    [
        113.03368353498,
        22.848679882338
    ],
    [
        113.0336521521,
        22.848657023012
    ],
    [
        113.0336031774,
        22.848632340427
    ],
    [
        113.03349765464,
        22.848576375715
    ],
    [
        113.0333426403,
        22.848461258206
    ],
    [
        113.03305351255,
        22.848143330621
    ],
    [
        113.03290993783,
        22.847918444946
    ],
    [
        113.03290939641,
        22.847918709903
    ],
    [
        113.03290858979,
        22.847909749726
    ],
    [
        113.03290995384,
        22.847891321428
    ],
    [
        113.03294759127,
        22.847858937755
    ],
    [
        113.03302608835,
        22.847838416137
    ],
    [
        113.0333433119,
        22.847792667837
    ],
    [
        113.0337260785,
        22.847699832042
    ],
    [
        113.03410996272,
        22.847583302807
    ],
    [
        113.03442915186,
        22.84750179018
    ],
    [
        113.034710479,
        22.847381567641
    ],
    [
        113.03493195966,
        22.847313572906
    ],
    [
        113.03511285877,
        22.847210147027
    ],
    [
        113.0353327852,
        22.8470392687
    ],
    [
        113.03551424441,
        22.846920059749
    ],
    [
        113.03572358351,
        22.846822788664
    ],
    [
        113.03609867335,
        22.846655408932
    ],
    [
        113.03650977707,
        22.846529192993
    ],
    [
        113.03677436266,
        22.846484311317
    ],
    [
        113.03713377102,
        22.846385919254
    ],
    [
        113.03769203698,
        22.846199223314
    ],
    [
        113.03807885589,
        22.846099950571
    ],
    [
        113.03808508485,
        22.846101353812
    ],
    [
        113.03811812931,
        22.846101331548
    ],
    [
        113.03812814632,
        22.846110629028
    ],
    [
        113.03825185622,
        22.846254224441
    ],
    [
        113.03829462439,
        22.846309331014
    ],
    [
        113.03872154086,
        22.846790324377
    ],
    [
        113.03873914499,
        22.846796686079
    ],
    [
        113.03875648267,
        22.846794908485
    ],
    [
        113.03910712189,
        22.846605264276
    ],
    [
        113.03913394543,
        22.84659757704
    ],
    [
        113.03961941856,
        22.847113616105
    ],
    [
        113.03964460908,
        22.847124079772
    ],
    [
        113.03972049944,
        22.847070029364
    ],
    [
        113.04016748686,
        22.846696478024
    ],
    [
        113.04059526028,
        22.846330240938
    ],
    [
        113.04091025775,
        22.846102418474
    ],
    [
        113.04092299603,
        22.846098957081
    ],
    [
        113.04092841006,
        22.846110376654
    ],
    [
        113.041320532,
        22.84666209945
    ],
    [
        113.04132947242,
        22.846667566391
    ],
    [
        113.0413367904,
        22.846666244651
    ],
    [
        113.04183201542,
        22.846540439308
    ],
    [
        113.04195508432,
        22.846506780366
    ],
    [
        113.04198138681,
        22.846484918733
    ],
    [
        113.04200717488,
        22.846410162641
    ],
    [
        113.04211310589,
        22.845972538942
    ],
    [
        113.04212261637,
        22.845924838599
    ],
    [
        113.04215650646,
        22.845907071579
    ],
    [
        113.04222644987,
        22.845883206203
    ],
    [
        113.04248586159,
        22.845870083001
    ],
    [
        113.04251243384,
        22.845854719324
    ],
    [
        113.04252709212,
        22.84581300147
    ],
    [
        113.04255944938,
        22.845607788652
    ],
    [
        113.04255114404,
        22.845402699877
    ],
    [
        113.04252030915,
        22.845259643561
    ],
    [
        113.04246862998,
        22.845053852527
    ],
    [
        113.04238873985,
        22.844890267105
    ],
    [
        113.04239337621,
        22.844826813502
    ],
    [
        113.0423942054,
        22.844790741198
    ],
    [
        113.04242322771,
        22.844748806823
    ],
    [
        113.042505417,
        22.844620268771
    ],
    [
        113.04254262589,
        22.844451961083
    ],
    [
        113.04255539267,
        22.84438962086
    ],
    [
        113.04253101621,
        22.844342607427
    ],
    [
        113.04246570968,
        22.844293002209
    ],
    [
        113.04245324905,
        22.8442728841
    ],
    [
        113.04245948854,
        22.844260972353
    ],
    [
        113.04256147884,
        22.844094799257
    ],
    [
        113.04258779011,
        22.844052308007
    ],
    [
        113.04258319575,
        22.844018114623
    ],
    [
        113.04252874189,
        22.843940342181
    ],
    [
        113.04234206605,
        22.843718583598
    ],
    [
        113.04231415744,
        22.843691623869
    ],
    [
        113.04231199981,
        22.843663677209
    ],
    [
        113.0424126132,
        22.843534130078
    ],
    [
        113.04259725144,
        22.84342603356
    ],
    [
        113.04263141641,
        22.843400115045
    ],
    [
        113.04279163437,
        22.843371645883
    ],
    [
        113.04309092822,
        22.84334305248
    ],
    [
        113.04359169367,
        22.843274242831
    ],
    [
        113.0440325618,
        22.843260946461
    ],
    [
        113.04408842581,
        22.843239370662
    ],
    [
        113.04410578521,
        22.843223133747
    ],
    [
        113.0441182697,
        22.843191153625
    ],
    [
        113.04413212489,
        22.843117675357
    ],
    [
        113.04423616565,
        22.842569971848
    ],
    [
        113.04435434859,
        22.841838103304
    ],
    [
        113.04448955543,
        22.841239432986
    ],
    [
        113.04453134486,
        22.841126395716
    ],
    [
        113.04454056674,
        22.841118274531
    ],
    [
        113.04455683844,
        22.841112606991
    ],
    [
        113.04456443172,
        22.841110721565
    ],
    [
        113.04459344714,
        22.841110772083
    ],
    [
        113.04477648876,
        22.841123550456
    ],
    [
        113.04490746947,
        22.84113107042
    ],
    [
        113.04525810835,
        22.841207739311
    ],
    [
        113.04562611337,
        22.841340456843
    ],
    [
        113.04589351625,
        22.841458624259
    ],
    [
        113.04620840011,
        22.841580805697
    ],
    [
        113.04664888419,
        22.841763910934
    ],
    [
        113.04706497806,
        22.841973432167
    ],
    [
        113.0470761014,
        22.841973154536
    ],
    [
        113.04710785385,
        22.841938686808
    ],
    [
        113.04725631367,
        22.841747896573
    ],
    [
        113.04729865281,
        22.841696326332
    ],
    [
        113.04749812382,
        22.841504647284
    ],
    [
        113.04753041701,
        22.841483186529
    ],
    [
        113.0475504955,
        22.841480996238
    ],
    [
        113.04762699488,
        22.841532724764
    ],
    [
        113.04780303988,
        22.841706662283
    ],
    [
        113.0479096464,
        22.841808785261
    ],
    [
        113.0480184298,
        22.841895704372
    ],
    [
        113.04802331026,
        22.841908446075
    ],
    [
        113.04797552637,
        22.841998298731
    ],
    [
        113.04796466088,
        22.842036831646
    ],
    [
        113.0481353038,
        22.842151860258
    ],
    [
        113.04815999749,
        22.842150193927
    ],
    [
        113.04817058243,
        22.84214339585
    ],
    [
        113.04826884052,
        22.842056434622
    ],
    [
        113.04860055828,
        22.84169912974
    ],
    [
        113.04861549024,
        22.841677399775
    ],
    [
        113.04863367209,
        22.841678990686
    ],
    [
        113.04876037726,
        22.841782616524
    ],
    [
        113.04896303977,
        22.842003233914
    ],
    [
        113.04915106752,
        22.842172854577
    ],
    [
        113.04947230763,
        22.842522459447
    ],
    [
        113.04956347586,
        22.842612255725
    ],
    [
        113.04957487546,
        22.842613036623
    ],
    [
        113.0495770455,
        22.842617099091
    ],
    [
        113.04970273569,
        22.842561122702
    ],
    [
        113.04991150218,
        22.842466080934
    ],
    [
        113.0500716804,
        22.842389607669
    ],
    [
        113.05028915332,
        22.84227466349
    ],
    [
        113.05049115933,
        22.84216298887
    ],
    [
        113.0506700909,
        22.842068998266
    ],
    [
        113.05078902372,
        22.841992851016
    ],
    [
        113.05087538293,
        22.841906516435
    ],
    [
        113.05090635194,
        22.841842374736
    ],
    [
        113.05091667751,
        22.841812223504
    ],
    [
        113.05091587359,
        22.841776150394
    ],
    [
        113.05090339911,
        22.841727376305
    ],
    [
        113.05087110585,
        22.841678140302
    ],
    [
        113.05082605961,
        22.841604542079
    ],
    [
        113.05080353034,
        22.841589713682
    ],
    [
        113.05081004939,
        22.841577752476
    ],
    [
        113.05083394339,
        22.841566806315
    ],
    [
        113.05109545574,
        22.841338140421
    ],
    [
        113.0511288636,
        22.841289171871
    ],
    [
        113.05115764454,
        22.841283351493
    ],
    [
        113.05116904818,
        22.841281674611
    ],
    [
        113.05121872037,
        22.841331911202
    ],
    [
        113.05133544707,
        22.841415753461
    ],
    [
        113.05148937178,
        22.841507820934
    ],
    [
        113.05148882867,
        22.841508094696
    ],
    [
        113.0515026764,
        22.841507488115
    ],
    [
        113.05153717483,
        22.841452806068
    ],
    [
        113.05161160437,
        22.841336089184
    ],
    [
        113.05166973488,
        22.841247926823
    ],
    [
        113.05173710349,
        22.841137473916
    ],
    [
        113.05174824175,
        22.841116533432
    ],
    [
        113.0517493313,
        22.84110323674
    ],
    [
        113.05174118842,
        22.841091069841
    ],
    [
        113.05168906733,
        22.841040054364
    ],
    [
        113.05167277983,
        22.841023043463
    ],
    [
        113.05167006474,
        22.841022242692
    ],
    [
        113.05171297665,
        22.840982162366
    ],
    [
        113.05182405488,
        22.84089888897
    ],
    [
        113.05183762963,
        22.840907502216
    ],
    [
        113.05188865946,
        22.840985912905
    ],
    [
        113.05195055771,
        22.841038497498
    ],
    [
        113.05202711217,
        22.841121655593
    ],
    [
        113.05212049681,
        22.841230219051
    ],
    [
        113.05215904971,
        22.841258771331
    ],
    [
        113.0521758847,
        22.841263837162
    ],
    [
        113.05219951057,
        22.841261543264
    ],
    [
        113.05224486637,
        22.841239332597
    ],
    [
        113.05236681879,
        22.84115621956
    ],
    [
        113.05246297161,
        22.841084356547
    ],
    [
        113.05254798253,
        22.841047267775
    ],
    [
        113.05264575364,
        22.841030444643
    ],
    [
        113.05275438883,
        22.841017077068
    ],
    [
        113.05284346854,
        22.841016833299
    ],
    [
        113.05298224183,
        22.841052636325
    ],
    [
        113.0532201436,
        22.841125792668
    ],
    [
        113.0533667964,
        22.841185370939
    ],
    [
        113.05355555844,
        22.841227299965
    ],
    [
        113.05375138934,
        22.841267795263
    ],
    [
        113.05382581207,
        22.841283847481
    ],
    [
        113.05384346799,
        22.841284814553
    ],
    [
        113.0538537904,
        22.841283660469
    ],
    [
        113.05397958305,
        22.841190856733
    ],
    [
        113.05410429537,
        22.841082585424
    ],
    [
        113.05424041742,
        22.840981273206
    ],
    [
        113.0543678487,
        22.840881363436
    ],
    [
        113.05451241157,
        22.840721097222
    ],
    [
        113.05460371346,
        22.840629018491
    ],
    [
        113.05461675414,
        22.840626752748
    ],
    [
        113.05462328047,
        22.840599850612
    ],
    [
        113.05462138521,
        22.840571925331
    ],
    [
        113.05456110801,
        22.840424532923
    ],
    [
        113.05445140208,
        22.840208595476
    ],
    [
        113.05437944094,
        22.840068601251
    ],
    [
        113.0543063908,
        22.839940002901
    ],
    [
        113.05427678709,
        22.839905762613
    ],
    [
        113.05421730211,
        22.839869561252
    ],
    [
        113.05408257313,
        22.839824383845
    ],
    [
        113.05394241231,
        22.839790349254
    ],
    [
        113.05364580304,
        22.839722878312
    ],
    [
        113.05342226923,
        22.839673859717
    ],
    [
        113.05313763708,
        22.839605097722
    ],
    [
        113.0528394404,
        22.839531732758
    ],
    [
        113.05281798971,
        22.83950527407
    ],
    [
        113.05280495904,
        22.839473883636
    ],
    [
        113.05282697462,
        22.839372034258
    ],
    [
        113.05287860798,
        22.839173985867
    ],
    [
        113.05289844727,
        22.839087066759
    ],
    [
        113.05291963377,
        22.839070395429
    ],
    [
        113.05293158511,
        22.839061373459
    ],
    [
        113.05315402056,
        22.839073060538
    ],
    [
        113.05333191719,
        22.839106684327
    ],
    [
        113.0533650541,
        22.839104035555
    ],
    [
        113.05339656435,
        22.839082679211
    ],
    [
        113.05357478437,
        22.838810011668
    ],
    [
        113.05370165921,
        22.838609809444
    ],
    [
        113.05371768744,
        22.838592343436
    ],
    [
        113.0537717404,
        22.838602836994
    ],
    [
        113.05386816089,
        22.838675434485
    ],
    [
        113.05399038713,
        22.838758698822
    ],
    [
        113.05401238935,
        22.83876424518
    ],
    [
        113.05404335637,
        22.838766203299
    ],
    [
        113.05409578686,
        22.83874332798
    ],
    [
        113.05428269582,
        22.838639486577
    ],
    [
        113.0544783033,
        22.838536908858
    ],
    [
        113.05454024889,
        22.838487903857
    ],
    [
        113.05456198468,
        22.838467672125
    ],
    [
        113.05453047968,
        22.838395746222
    ],
    [
        113.05445578953,
        22.83823597155
    ],
    [
        113.0543900557,
        22.838156963891
    ],
    [
        113.05437430145,
        22.83813727436
    ],
    [
        113.05437647638,
        22.838120711856
    ],
    [
        113.05443461626,
        22.838074723219
    ],
    [
        113.0545835059,
        22.83788999867
    ],
    [
        113.05462589217,
        22.837822414654
    ],
    [
        113.05462100668,
        22.837766841671
    ],
    [
        113.05458813989,
        22.837700352002
    ],
    [
        113.05454739572,
        22.837620084358
    ],
    [
        113.05448274358,
        22.837560061873
    ],
    [
        113.05432953586,
        22.837426341701
    ],
    [
        113.05416112181,
        22.837237098094
    ],
    [
        113.05403644351,
        22.83708496565
    ],
    [
        113.05397478558,
        22.836968199917
    ],
    [
        113.05382729264,
        22.836787445426
    ],
    [
        113.05330741629,
        22.836126465272
    ],
    [
        113.05329953929,
        22.836086366602
    ],
    [
        113.05328324252,
        22.836060154801
    ],
    [
        113.05325852565,
        22.836011208307
    ],
    [
        113.05326640192,
        22.835988373046
    ],
    [
        113.05356951942,
        22.835792771469
    ],
    [
        113.05389112088,
        22.83556142967
    ],
    [
        113.05400411993,
        22.83548877749
    ],
    [
        113.05408778436,
        22.83544452908
    ],
    [
        113.05422822126,
        22.835323379542
    ],
    [
        113.05456995594,
        22.83507570382
    ],
    [
        113.05492284414,
        22.834799089349
    ],
    [
        113.05530671772,
        22.834462987363
    ],
    [
        113.05539447064,
        22.834386061359
    ],
    [
        113.05551998629,
        22.834251585032
    ],
    [
        113.05567430254,
        22.834089189071
    ],
    [
        113.05583378127,
        22.833903943102
    ],
    [
        113.05606173002,
        22.833649189249
    ],
    [
        113.05645515818,
        22.833256485879
    ],
    [
        113.0568776656,
        22.83276898502
    ],
    [
        113.05727057409,
        22.832329095868
    ],
    [
        113.05739584513,
        22.832210435361
    ],
    [
        113.05756052006,
        22.832051230339
    ],
    [
        113.0577659703,
        22.83189594214
    ],
    [
        113.05778825505,
        22.831879716092
    ],
    [
        113.05802550137,
        22.831671171605
    ],
    [
        113.05820947853,
        22.83147506589
    ],
    [
        113.05856061713,
        22.831190109964
    ],
    [
        113.05876310057,
        22.831030898492
    ],
    [
        113.05899929365,
        22.830850674868
    ],
    [
        113.05921863431,
        22.83066001492
    ],
    [
        113.05936784936,
        22.83051431775
    ],
    [
        113.0597361531,
        22.830196040469
    ],
    [
        113.05980519102,
        22.8301249927
    ],
    [
        113.05992994515,
        22.829983039866
    ],
    [
        113.06000577613,
        22.82989508439
    ],
    [
        113.06011396458,
        22.829808106013
    ],
    [
        113.0603477436,
        22.829621983181
    ],
    [
        113.06050106298,
        22.829501617789
    ],
    [
        113.06067152049,
        22.829392967406
    ],
    [
        113.06085123501,
        22.829305888135
    ],
    [
        113.06104644713,
        22.829199607128
    ],
    [
        113.06129006567,
        22.829079678955
    ],
    [
        113.06151493051,
        22.828970798629
    ],
    [
        113.06163320777,
        22.828904199842
    ],
    [
        113.06187357892,
        22.82878177784
    ],
    [
        113.0620476148,
        22.828711720723
    ],
    [
        113.06221350068,
        22.828656400044
    ],
    [
        113.06245309966,
        22.828602536166
    ],
    [
        113.06268346731,
        22.828572633069
    ],
    [
        113.06291356403,
        22.828529136693
    ],
    [
        113.06319344292,
        22.828478421352
    ],
    [
        113.06342682294,
        22.82844728927
    ],
    [
        113.06361887146,
        22.828442470817
    ],
    [
        113.06382533625,
        22.828423051495
    ],
    [
        113.06397413714,
        22.828413371489
    ],
    [
        113.0641629276,
        22.828394703547
    ],
    [
        113.06432368983,
        22.828349286044
    ],
    [
        113.06448501262,
        22.828337215181
    ],
    [
        113.0648158333,
        22.828324306995
    ],
    [
        113.06505388704,
        22.828307817093
    ],
    [
        113.06527752841,
        22.828295850989
    ],
    [
        113.06548376317,
        22.828287915996
    ],
    [
        113.06572890732,
        22.82827042487
    ],
    [
        113.06589759755,
        22.828251343587
    ],
    [
        113.06609867171,
        22.828235013613
    ],
    [
        113.06625593085,
        22.828194915619
    ],
    [
        113.06656338582,
        22.828126187668
    ],
    [
        113.06684854141,
        22.828071597993
    ],
    [
        113.06710158873,
        22.828006350428
    ],
    [
        113.06732416463,
        22.82794562307
    ],
    [
        113.06760877738,
        22.827850796059
    ],
    [
        113.06803871011,
        22.827727028307
    ],
    [
        113.06823054919,
        22.82766589554
    ],
    [
        113.06833965704,
        22.827607710664
    ],
    [
        113.06855352633,
        22.827504419741
    ],
    [
        113.06885012187,
        22.827368836739
    ],
    [
        113.06918753936,
        22.827213018704
    ],
    [
        113.06950427997,
        22.827061029913
    ],
    [
        113.06965910956,
        22.826975450649
    ],
    [
        113.06980169289,
        22.826891423653
    ],
    [
        113.06990292762,
        22.826854470692
    ],
    [
        113.07003845687,
        22.826814229114
    ],
    [
        113.07013724265,
        22.826775953212
    ],
    [
        113.07029398291,
        22.82669085367
    ],
    [
        113.07047739962,
        22.82660638323
    ],
    [
        113.07063225022,
        22.826548158341
    ],
    [
        113.07078248044,
        22.826501670644
    ],
    [
        113.07101926934,
        22.826449910267
    ],
    [
        113.07116297936,
        22.826423051361
    ],
    [
        113.07132629156,
        22.826400736316
    ],
    [
        113.0714702776,
        22.826377117202
    ],
    [
        113.07150456816,
        22.826361609759
    ],
    [
        113.07151137035,
        22.826355524924
    ],
    [
        113.07168168729,
        22.826183591169
    ],
    [
        113.07187540208,
        22.825987374257
    ],
    [
        113.0720465352,
        22.825814597933
    ],
    [
        113.07209877627,
        22.82576811994
    ],
    [
        113.07209631833,
        22.825752969557
    ],
    [
        113.07197102027,
        22.825604555735
    ],
    [
        113.07180838758,
        22.825380544138
    ],
    [
        113.07177816143,
        22.825361258031
    ],
    [
        113.07173541796,
        22.825350054103
    ],
    [
        113.07156447011,
        22.825351354735
    ],
    [
        113.07145122991,
        22.825349221329
    ],
    [
        113.07138044609,
        22.825331438977
    ],
    [
        113.07115472241,
        22.825213471247
    ],
    [
        113.07104278007,
        22.825093559922
    ],
    [
        113.07101171753,
        22.825037385447
    ],
    [
        113.07102175429,
        22.824975629788
    ],
    [
        113.07101794089,
        22.824971082407
    ],
    [
        113.07102525563,
        22.824909644206
    ],
    [
        113.07109268285,
        22.824770677859
    ],
    [
        113.07117724859,
        22.824614869148
    ],
    [
        113.0713072002,
        22.824337012692
    ],
    [
        113.07144833887,
        22.824107252201
    ],
    [
        113.07172922411,
        22.823604059324
    ],
    [
        113.0720493483,
        22.823173694433
    ],
    [
        113.07219377147,
        22.822981291274
    ],
    [
        113.07219403664,
        22.822970434459
    ],
    [
        113.0723363216,
        22.822839378843
    ],
    [
        113.07244840625,
        22.822732716602
    ],
    [
        113.07252428098,
        22.822619353652
    ],
    [
        113.07261049159,
        22.822493601538
    ],
    [
        113.07267059191,
        22.822402756837
    ],
    [
        113.07274999547,
        22.822275763766
    ],
    [
        113.07281169587,
        22.822136868058
    ],
    [
        113.07287803574,
        22.822015797229
    ],
    [
        113.07291283455,
        22.821948993064
    ],
    [
        113.0729547255,
        22.821902956066
    ],
    [
        113.07300939319,
        22.821831193395
    ],
    [
        113.07310758496,
        22.821713363598
    ],
    [
        113.07320575833,
        22.821569758041
    ],
    [
        113.07330555262,
        22.821409301295
    ],
    [
        113.07343688398,
        22.821191859407
    ],
    [
        113.07354374593,
        22.821019337437
    ],
    [
        113.07363155109,
        22.82084714707
    ],
    [
        113.07371395885,
        22.820740164622
    ],
    [
        113.07378874295,
        22.820631958174
    ],
    [
        113.07387767849,
        22.820517805287
    ],
    [
        113.07394811406,
        22.820419983196
    ],
    [
        113.07402265673,
        22.820353831869
    ],
    [
        113.07410402051,
        22.8203079085
    ],
    [
        113.07420527309,
        22.820282525988
    ],
    [
        113.07427140127,
        22.820249077766
    ],
    [
        113.07427439522,
        22.820248211206
    ],
    [
        113.07432690523,
        22.820206319935
    ],
    [
        113.07433038793,
        22.820131919073
    ],
    [
        113.07432734448,
        22.820067671485
    ],
    [
        113.07429682874,
        22.820034565192
    ],
    [
        113.07424262127,
        22.819992107901
    ],
    [
        113.07415082413,
        22.819922093993
    ],
    [
        113.0740636422,
        22.819835447975
    ],
    [
        113.07391923816,
        22.819680619692
    ],
    [
        113.07374434746,
        22.819530663628
    ],
    [
        113.07361034105,
        22.819443746997
    ],
    [
        113.07350931277,
        22.819405087961
    ],
    [
        113.07347773077,
        22.819401027621
    ],
    [
        113.0734170482,
        22.819432746336
    ],
    [
        113.07334630799,
        22.819483360741
    ],
    [
        113.07323965398,
        22.819560104308
    ],
    [
        113.07321651399,
        22.819559422574
    ],
    [
        113.07318901525,
        22.819554747032
    ],
    [
        113.07309343523,
        22.819518971145
    ],
    [
        113.07305828716,
        22.819479700058
    ],
    [
        113.07300267418,
        22.819379467923
    ],
    [
        113.07285830449,
        22.819265584588
    ],
    [
        113.07269379185,
        22.819153403556
    ],
    [
        113.0725306153,
        22.8190091792
    ],
    [
        113.07247473866,
        22.81892034126
    ],
    [
        113.07246490266,
        22.818875473164
    ],
    [
        113.07246649799,
        22.818828236706
    ],
    [
        113.07247896225,
        22.818756393744
    ],
    [
        113.0725202984,
        22.818704942167
    ],
    [
        113.0726445953,
        22.818570657748
    ],
    [
        113.07277381657,
        22.818466129613
    ],
    [
        113.07279963786,
        22.81841711567
    ],
    [
        113.0728186758,
        22.818395351039
    ],
    [
        113.07281484158,
        22.818367200759
    ],
    [
        113.07277642944,
        22.818332596717
    ],
    [
        113.0726783584,
        22.818247206078
    ],
    [
        113.07255738517,
        22.81811879974
    ],
    [
        113.07251841315,
        22.818065482662
    ],
    [
        113.07250503863,
        22.818022574856
    ],
    [
        113.07251477977,
        22.81795186381
    ],
    [
        113.07254004039,
        22.81788468239
    ],
    [
        113.0725767409,
        22.817825442138
    ],
    [
        113.0726311627,
        22.817798181173
    ],
    [
        113.07270845337,
        22.81777323609
    ],
    [
        113.07279116472,
        22.817719707464
    ],
    [
        113.07289807519,
        22.817631570967
    ],
    [
        113.07297015574,
        22.817561131475
    ],
    [
        113.0729807403,
        22.817522962852
    ],
    [
        113.0729831648,
        22.817492804396
    ],
    [
        113.07296107287,
        22.817443808875
    ],
    [
        113.07282350725,
        22.817336316402
    ],
    [
        113.07268866391,
        22.817228501978
    ],
    [
        113.07254803385,
        22.817038846199
    ],
    [
        113.07246655073,
        22.816936070544
    ],
    [
        113.07244749244,
        22.816932873173
    ],
    [
        113.07244395291,
        22.816932120455
    ],
    [
        113.07241210676,
        22.816936469786
    ],
    [
        113.0722904611,
        22.816979269956
    ],
    [
        113.0720099042,
        22.817095619168
    ],
    [
        113.07179822334,
        22.817215382048
    ],
    [
        113.07177619059,
        22.81723475248
    ],
    [
        113.0717603771,
        22.817205450132
    ],
    [
        113.07166220626,
        22.817002830566
    ],
    [
        113.07163198202,
        22.81699276692
    ],
    [
        113.07157727179,
        22.81699777342
    ],
    [
        113.07135465812,
        22.817060453706
    ],
    [
        113.07134186498,
        22.817061214596
    ],
    [
        113.07132877652,
        22.817035119945
    ],
    [
        113.07131160873,
        22.817013435904
    ],
    [
        113.07107403211,
        22.816456120604
    ],
    [
        113.07079857194,
        22.815851948953
    ],
    [
        113.07053674693,
        22.815281711551
    ],
    [
        113.07028748688,
        22.814763878814
    ],
    [
        113.07010178407,
        22.814396091192
    ],
    [
        113.06998964242,
        22.814104664324
    ],
    [
        113.06995197781,
        22.813995135408
    ],
    [
        113.06994102036,
        22.813920704229
    ],
    [
        113.0699273834,
        22.813891357305
    ],
    [
        113.06990467538,
        22.813767740936
    ],
    [
        113.06981703462,
        22.813483496072
    ],
    [
        113.06973486971,
        22.813234158315
    ],
    [
        113.06958527198,
        22.812773488426
    ],
    [
        113.06948226655,
        22.812366577216
    ],
    [
        113.06938416099,
        22.811962565679
    ],
    [
        113.06930005924,
        22.811685571569
    ],
    [
        113.06928801173,
        22.811612511976
    ],
    [
        113.06926340823,
        22.811503029933
    ],
    [
        113.06925381035,
        22.811430201184
    ],
    [
        113.06923894737,
        22.811262494903
    ],
    [
        113.06918999317,
        22.811025075189
    ],
    [
        113.06914107021,
        22.810819670482
    ],
    [
        113.06908919737,
        22.810658810721
    ],
    [
        113.06904652223,
        22.810441906081
    ],
    [
        113.0689951137,
        22.810201538145
    ],
    [
        113.06896005883,
        22.809985049957
    ],
    [
        113.06891976603,
        22.809702714322
    ],
    [
        113.06889562195,
        22.80951100898
    ],
    [
        113.06888216842,
        22.80939482921
    ],
    [
        113.06885857779,
        22.809212610857
    ],
    [
        113.06883095094,
        22.809076312367
    ],
    [
        113.06883245907,
        22.808953105155
    ],
    [
        113.06880477524,
        22.808760913815
    ],
    [
        113.06878505862,
        22.808642122181
    ],
    [
        113.06877598517,
        22.808551646519
    ],
    [
        113.06877364583,
        22.808392415303
    ],
    [
        113.06874242634,
        22.808203265355
    ],
    [
        113.06871802676,
        22.808029741137
    ],
    [
        113.06869257276,
        22.807889878453
    ],
    [
        113.06867854968,
        22.807750101159
    ],
    [
        113.06867126449,
        22.807545638305
    ],
    [
        113.06865548308,
        22.807283520522
    ],
    [
        113.06863264313,
        22.807038882158
    ],
    [
        113.06860434436,
        22.80677913775
    ],
    [
        113.06860771504,
        22.80661574362
    ],
    [
        113.06858107078,
        22.806377135688
    ],
    [
        113.06856237108,
        22.806189137111
    ],
    [
        113.06856775748,
        22.806133698908
    ],
    [
        113.06856130725,
        22.805682313612
    ],
    [
        113.06855146974,
        22.805112141602
    ],
    [
        113.06854564236,
        22.804470274279
    ],
    [
        113.06855285957,
        22.80434181933
    ],
    [
        113.06848571158,
        22.804415893519
    ],
    [
        113.06843841983,
        22.804478520818
    ],
    [
        113.06835934294,
        22.804597010977
    ],
    [
        113.06829110825,
        22.804671911756
    ],
    [
        113.06823048165,
        22.804734478685
    ],
    [
        113.06816905528,
        22.804813065379
    ],
    [
        113.06809075029,
        22.804886223255
    ],
    [
        113.06801245995,
        22.804973216215
    ],
    [
        113.06793879323,
        22.805056877011
    ],
    [
        113.06786920049,
        22.80513205956
    ],
    [
        113.06780585434,
        22.805194388374
    ],
    [
        113.06773190898,
        22.80527045031
    ],
    [
        113.0676459984,
        22.805354839485
    ],
    [
        113.06756389916,
        22.805439979347
    ],
    [
        113.06750600955,
        22.805514152528
    ],
    [
        113.06743534169,
        22.80559992148
    ],
    [
        113.06737417965,
        22.805666817178
    ],
    [
        113.06731303156,
        22.80574700614
    ],
    [
        113.06722221466,
        22.80582060402
    ],
    [
        113.06713902911,
        22.805904932191
    ],
    [
        113.06708249226,
        22.805969305996
    ],
    [
        113.06702947772,
        22.80601842916
    ],
    [
        113.06694084171,
        22.806093609935
    ],
    [
        113.06686717266,
        22.806168283786
    ],
    [
        113.0667524184,
        22.806247389425
    ],
    [
        113.0666890609,
        22.80629259455
    ],
    [
        113.06662381761,
        22.806356005872
    ],
    [
        113.06655531438,
        22.806424349269
    ],
    [
        113.0664454794,
        22.806520999608
    ],
    [
        113.06630817656,
        22.806631358697
    ],
    [
        113.06618446025,
        22.806721695566
    ],
    [
        113.06608251273,
        22.806811152827
    ],
    [
        113.0659329792,
        22.806930355286
    ],
    [
        113.06575922898,
        22.807047196909
    ],
    [
        113.06568337525,
        22.807106125674
    ],
    [
        113.06559500612,
        22.807165238282
    ],
    [
        113.06549060401,
        22.807243306942
    ],
    [
        113.06536255564,
        22.807344782999
    ],
    [
        113.06524619099,
        22.807429256275
    ],
    [
        113.06513472225,
        22.807510937476
    ],
    [
        113.06505043463,
        22.807565624519
    ],
    [
        113.06495937459,
        22.807648353408
    ],
    [
        113.06485798828,
        22.807742352506
    ],
    [
        113.06477154763,
        22.807817679406
    ],
    [
        113.06466198572,
        22.807896320765
    ],
    [
        113.0646002841,
        22.80795174701
    ],
    [
        113.06450594235,
        22.808013609016
    ],
    [
        113.06442167328,
        22.808081020038
    ],
    [
        113.06429472562,
        22.808180780412
    ],
    [
        113.06417128643,
        22.808251178898
    ],
    [
        113.06406391289,
        22.808334637424
    ],
    [
        113.063960899,
        22.808423726134
    ],
    [
        113.06383152513,
        22.808538953494
    ],
    [
        113.06369126445,
        22.808646996814
    ],
    [
        113.06357384319,
        22.808741960835
    ],
    [
        113.06340912308,
        22.808868498282
    ],
    [
        113.06329251169,
        22.80895366422
    ],
    [
        113.06318405842,
        22.809034912654
    ],
    [
        113.06305847456,
        22.809120998449
    ],
    [
        113.06293452923,
        22.809211665338
    ],
    [
        113.06284484477,
        22.809288840676
    ],
    [
        113.06275432688,
        22.809347843391
    ],
    [
        113.06269916135,
        22.809398231223
    ],
    [
        113.06255836398,
        22.809495334527
    ],
    [
        113.06242707599,
        22.809579819681
    ],
    [
        113.06230993737,
        22.809668179188
    ],
    [
        113.06220530605,
        22.809750941011
    ],
    [
        113.06207403161,
        22.809843265508
    ],
    [
        113.06194902419,
        22.809944995039
    ],
    [
        113.06180633834,
        22.810044498172
    ],
    [
        113.06167642719,
        22.810133787407
    ],
    [
        113.06154299058,
        22.810230978524
    ],
    [
        113.06145467335,
        22.810300461116
    ],
    [
        113.06133647129,
        22.810399071328
    ],
    [
        113.06123647402,
        22.810480082239
    ],
    [
        113.06114216877,
        22.81054093834
    ],
    [
        113.06104353286,
        22.81062110569
    ],
    [
        113.06094325386,
        22.810688534257
    ],
    [
        113.06084245742,
        22.810781195583
    ],
    [
        113.06073213372,
        22.810862840457
    ],
    [
        113.06059953408,
        22.810965092843
    ],
    [
        113.06045062544,
        22.811071325099
    ],
    [
        113.06030036742,
        22.811184883704
    ],
    [
        113.0601816329,
        22.8112771673
    ],
    [
        113.06001206828,
        22.811383866375
    ],
    [
        113.05990556833,
        22.811470559223
    ],
    [
        113.05980504912,
        22.811554733968
    ],
    [
        113.05971431365,
        22.811633092856
    ],
    [
        113.05962167793,
        22.811713366558
    ],
    [
        113.0594977842,
        22.811801309704
    ],
    [
        113.05937716545,
        22.811899787122
    ],
    [
        113.05921660417,
        22.812019585021
    ],
    [
        113.05909164074,
        22.812118627776
    ],
    [
        113.05896152021,
        22.812223955208
    ],
    [
        113.05882541859,
        22.812326620902
    ],
    [
        113.05868414812,
        22.812422815864
    ],
    [
        113.05857955983,
        22.812498533045
    ],
    [
        113.05847443677,
        22.812581844687
    ],
    [
        113.05833399619,
        22.812685591102
    ],
    [
        113.05821367477,
        22.812790202164
    ],
    [
        113.05811398552,
        22.812865018593
    ],
    [
        113.05797490054,
        22.812957588806
    ],
    [
        113.05786815953,
        22.813044938279
    ],
    [
        113.05775379178,
        22.813113904483
    ],
    [
        113.05766496501,
        22.81317148592
    ],
    [
        113.0574905693,
        22.813279001935
    ],
    [
        113.05734578013,
        22.813361792346
    ],
    [
        113.05718578343,
        22.813454477715
    ],
    [
        113.05700486757,
        22.813551407605
    ],
    [
        113.05687041539,
        22.813632962519
    ],
    [
        113.05672836397,
        22.813722440482
    ],
    [
        113.05659690118,
        22.813797969935
    ],
    [
        113.05644071251,
        22.813874790031
    ],
    [
        113.05627773122,
        22.813948665277
    ],
    [
        113.0561036144,
        22.814024242644
    ],
    [
        113.05596021134,
        22.814103062951
    ],
    [
        113.05589719081,
        22.81412584322
    ],
    [
        113.05588551464,
        22.814134623694
    ],
    [
        113.05584695454,
        22.81416180799
    ],
    [
        113.05570001377,
        22.814228689342
    ],
    [
        113.05561039306,
        22.814278806175
    ],
    [
        113.05547215462,
        22.814347759367
    ],
    [
        113.05536486797,
        22.814389046853
    ],
    [
        113.05524508655,
        22.814432051247
    ],
    [
        113.05513155039,
        22.814468483438
    ],
    [
        113.05500687814,
        22.814506075766
    ],
    [
        113.05481618765,
        22.814541711607
    ],
    [
        113.05464287842,
        22.814564436827
    ],
    [
        113.05449103097,
        22.814581826317
    ],
    [
        113.05437911069,
        22.814587515949
    ],
    [
        113.05424003121,
        22.81459772747
    ],
    [
        113.05413624226,
        22.814578646674
    ],
    [
        113.05398901532,
        22.814584543933
    ],
    [
        113.05374153669,
        22.814566128091
    ],
    [
        113.05345793503,
        22.814538665209
    ],
    [
        113.05332102817,
        22.814524605844
    ],
    [
        113.05311620675,
        22.814492223267
    ],
    [
        113.05292877019,
        22.814455089217
    ],
    [
        113.05274839181,
        22.814408116416
    ],
    [
        113.05253324793,
        22.81435072737
    ],
    [
        113.05230941437,
        22.814284933288
    ],
    [
        113.05211520879,
        22.814240375894
    ],
    [
        113.05197885331,
        22.814200377151
    ],
    [
        113.05185200321,
        22.814158415592
    ],
    [
        113.05170968524,
        22.814123568827
    ],
    [
        113.05151740387,
        22.814081883443
    ],
    [
        113.05127407494,
        22.814029811244
    ],
    [
        113.05106361885,
        22.813988942145
    ],
    [
        113.05086646689,
        22.813940653438
    ],
    [
        113.05067801883,
        22.813902334574
    ],
    [
        113.05050478044,
        22.813864740696
    ],
    [
        113.0503041097,
        22.813806054696
    ],
    [
        113.05010805918,
        22.813745417235
    ],
    [
        113.04997068418,
        22.813723082607
    ],
    [
        113.0498354664,
        22.81368200291
    ],
    [
        113.04969400336,
        22.813634956261
    ],
    [
        113.04957182987,
        22.813603300907
    ],
    [
        113.04942468776,
        22.813570887113
    ],
    [
        113.0492938297,
        22.813533526846
    ],
    [
        113.04909051956,
        22.813506369834
    ],
    [
        113.04893172135,
        22.813474731936
    ],
    [
        113.04873900985,
        22.813448569971
    ],
    [
        113.04864808142,
        22.813432480545
    ],
    [
        113.04849472805,
        22.813405380009
    ],
    [
        113.04837205311,
        22.813388513437
    ],
    [
        113.04823906492,
        22.813367037766
    ],
    [
        113.04812562881,
        22.813357453456
    ],
    [
        113.0480029566,
        22.813334575976
    ],
    [
        113.04781786909,
        22.813301184637
    ],
    [
        113.04757173119,
        22.813259145123
    ],
    [
        113.04739669178,
        22.813219973214
    ],
    [
        113.0472010484,
        22.81319082646
    ],
    [
        113.04703932613,
        22.813163525103
    ],
    [
        113.04688574665,
        22.813135382163
    ],
    [
        113.04666814492,
        22.813102620257
    ],
    [
        113.04641310416,
        22.813056248002
    ],
    [
        113.04626659617,
        22.813028830819
    ],
    [
        113.04613392209,
        22.812997327928
    ],
    [
        113.04604386123,
        22.812991058041
    ],
    [
        113.04594674228,
        22.812977180429
    ],
    [
        113.04584066434,
        22.81295297892
    ],
    [
        113.0456727316,
        22.812911631364
    ],
    [
        113.0455281411,
        22.812882758398
    ],
    [
        113.04535262053,
        22.812837555953
    ],
    [
        113.04519745619,
        22.812802930108
    ],
    [
        113.04502031978,
        22.812758214288
    ],
    [
        113.04487629291,
        22.812733053054
    ],
    [
        113.04477592467,
        22.812702243288
    ],
    [
        113.04454236727,
        22.812625344451
    ],
    [
        113.04444661242,
        22.812591798991
    ],
    [
        113.04440267211,
        22.812579778639
    ],
    [
        113.04410023333,
        22.812476604957
    ],
    [
        113.04401290098,
        22.812452535565
    ],
    [
        113.04387429505,
        22.812397679103
    ],
    [
        113.04376254966,
        22.812358337214
    ],
    [
        113.04370017337,
        22.812341358647
    ],
    [
        113.04368905078,
        22.812334818642
    ],
    [
        113.04358870136,
        22.81230064295
    ],
    [
        113.04345878378,
        22.812247655592
    ],
    [
        113.04333511116,
        22.81220118238
    ],
    [
        113.04319408092,
        22.812144604221
    ],
    [
        113.04304383811,
        22.812089064162
    ],
    [
        113.04292640223,
        22.812034695872
    ],
    [
        113.04280002681,
        22.81198408337
    ],
    [
        113.04266551056,
        22.81192176111
    ],
    [
        113.04253939597,
        22.811854568884
    ],
    [
        113.04238970303,
        22.811788630777
    ],
    [
        113.0422760801,
        22.811738548131
    ],
    [
        113.04215676662,
        22.811687617298
    ],
    [
        113.04197724657,
        22.811598442492
    ],
    [
        113.04180209183,
        22.811532590695
    ],
    [
        113.0416369652,
        22.811461329156
    ],
    [
        113.04148702795,
        22.811397709338
    ],
    [
        113.04135444643,
        22.811341204937
    ],
    [
        113.04121778847,
        22.811270013866
    ],
    [
        113.04105809042,
        22.811190010095
    ],
    [
        113.04083225165,
        22.811085226217
    ],
    [
        113.04065684264,
        22.810999929125
    ],
    [
        113.04048984045,
        22.810916007112
    ],
    [
        113.04035183637,
        22.810832493657
    ],
    [
        113.04020978937,
        22.810767118777
    ],
    [
        113.0400834607,
        22.810701546194
    ],
    [
        113.03993193818,
        22.81063689536
    ],
    [
        113.03976577428,
        22.810557212652
    ],
    [
        113.03957819819,
        22.810463534699
    ],
    [
        113.03938005728,
        22.81036460309
    ],
    [
        113.03920848756,
        22.810281277623
    ],
    [
        113.03904640822,
        22.810201788901
    ],
    [
        113.0389274281,
        22.810145091747
    ],
    [
        113.03877865047,
        22.810086005235
    ],
    [
        113.0386721334,
        22.810026383922
    ],
    [
        113.03851849059,
        22.809971299764
    ],
    [
        113.03837242577,
        22.809905940559
    ],
    [
        113.03824208987,
        22.809855873712
    ],
    [
        113.03813397344,
        22.809812199586
    ],
    [
        113.03803914117,
        22.809778926464
    ],
    [
        113.0379098941,
        22.80972693197
    ],
    [
        113.03780178727,
        22.809686754769
    ],
    [
        113.03770694909,
        22.809642330933
    ],
    [
        113.03761239966,
        22.809614181088
    ],
    [
        113.03751324106,
        22.809579475136
    ],
    [
        113.03739321719,
        22.809531297097
    ],
    [
        113.03725287313,
        22.809471815812
    ],
    [
        113.0371407143,
        22.809429917744
    ],
    [
        113.03704616143,
        22.809389513991
    ],
    [
        113.03692262666,
        22.809341531059
    ],
    [
        113.03681344831,
        22.809295287013
    ],
    [
        113.03669101485,
        22.809260584819
    ],
    [
        113.03657481332,
        22.809227281806
    ],
    [
        113.0364315265,
        22.809184502014
    ],
    [
        113.03629827596,
        22.809155904783
    ],
    [
        113.03616042604,
        22.809128065255
    ],
    [
        113.03599549937,
        22.809096432988
    ],
    [
        113.03584709202,
        22.809063848699
    ],
    [
        113.03567539501,
        22.809022343391
    ],
    [
        113.0355399922,
        22.80899120321
    ],
    [
        113.03545360925,
        22.808973818998
    ],
    [
        113.03537993992,
        22.808944614766
    ],
    [
        113.03529979451,
        22.808935691833
    ],
    [
        113.03521883103,
        22.808919972809
    ],
    [
        113.03512784378,
        22.808896280813
    ],
    [
        113.03494669824,
        22.808861637994
    ],
    [
        113.03478425437,
        22.80884452535
    ],
    [
        113.03462965203,
        22.808814721404
    ],
    [
        113.034502683,
        22.808803365886
    ],
    [
        113.03438438771,
        22.808801042881
    ],
    [
        113.03428042454,
        22.808782581902
    ],
    [
        113.03409038651,
        22.808764006084
    ],
    [
        113.03395395418,
        22.808752496609
    ],
    [
        113.03381779612,
        22.808741790277
    ],
    [
        113.03365781984,
        22.808728365434
    ],
    [
        113.0334826875,
        22.808711767995
    ],
    [
        113.03329106653,
        22.808711240946
    ],
    [
        113.03303286802,
        22.808704768185
    ],
    [
        113.03277495193,
        22.80870042167
    ],
    [
        113.0325941737,
        22.808698297952
    ],
    [
        113.03229621284,
        22.808683352333
    ],
    [
        113.03207105669,
        22.80866977611
    ],
    [
        113.03183510496,
        22.808676923774
    ],
    [
        113.03165164466,
        22.80867492112
    ],
    [
        113.03142596241,
        22.808656627731
    ],
    [
        113.03121977664,
        22.80864696013
    ],
    [
        113.03092134054,
        22.808642043178
    ],
    [
        113.03070002423,
        22.808638893279
    ],
    [
        113.03041917276,
        22.808613761344
    ],
    [
        113.03005015371,
        22.808603401584
    ],
    [
        113.02987349161,
        22.808594227221
    ],
    [
        113.02971496505,
        22.808592065246
    ],
    [
        113.02958213115,
        22.808581017205
    ],
    [
        113.02940089552,
        22.808586652375
    ],
    [
        113.0292707915,
        22.80859515275
    ],
    [
        113.02917963276,
        22.808595235442
    ],
    [
        113.02904356761,
        22.808590340537
    ],
    [
        113.02880552891,
        22.808584259729
    ],
    [
        113.02866514399,
        22.808581444671
    ],
    [
        113.02854775764,
        22.808584104046
    ],
    [
        113.02840063189,
        22.808597993305
    ],
    [
        113.02821156706,
        22.808593625496
    ],
    [
        113.028013308,
        22.808586933129
    ],
    [
        113.0278361418,
        22.808573205299
    ],
    [
        113.02762138809,
        22.808561616147
    ],
    [
        113.02742233886,
        22.808563532745
    ],
    [
        113.02727603932,
        22.808574633675
    ],
    [
        113.02715110119,
        22.808580348687
    ],
    [
        113.02698613041,
        22.808576495283
    ],
    [
        113.02686145557,
        22.808571614969
    ],
    [
        113.02668865827,
        22.808578742433
    ],
    [
        113.02644986191,
        22.808567202373
    ],
    [
        113.0261732175,
        22.808560202076
    ],
    [
        113.02598932207,
        22.80854512356
    ],
    [
        113.02587087614,
        22.808538112444
    ],
    [
        113.02572566605,
        22.808535557193
    ],
    [
        113.02558885249,
        22.808545063601
    ],
    [
        113.02539931189,
        22.8085531815
    ],
    [
        113.02521544685,
        22.80855567721
    ],
    [
        113.0250231923,
        22.808547985422
    ],
    [
        113.02474685997,
        22.808548145578
    ],
    [
        113.02459977333,
        22.808547933949
    ],
    [
        113.02448054244,
        22.808553051046
    ],
    [
        113.0243177883,
        22.808563692587
    ],
    [
        113.02414988223,
        22.808557689318
    ],
    [
        113.02393816682,
        22.808539559102
    ],
    [
        113.02386841733,
        22.808543835787
    ],
    [
        113.0237340483,
        22.808544600634
    ],
    [
        113.02360779749,
        22.808551462868
    ],
    [
        113.02339369031,
        22.808566082218
    ],
    [
        113.02319741777,
        22.808569317932
    ],
    [
        113.02286976115,
        22.808574131639
    ],
    [
        113.02273108785,
        22.80858698919
    ],
    [
        113.02262619673,
        22.808588474012
    ],
    [
        113.02247427726,
        22.808599740444
    ],
    [
        113.02235453441,
        22.808616159068
    ],
    [
        113.02220612621,
        22.80862204706
    ],
    [
        113.02207773355,
        22.808637495204
    ],
    [
        113.02186824552,
        22.808655621879
    ],
    [
        113.02164336912,
        22.808691379936
    ],
    [
        113.02146929741,
        22.808708736471
    ],
    [
        113.02121766239,
        22.808743196413
    ],
    [
        113.02106332615,
        22.808759249124
    ],
    [
        113.02083927096,
        22.808796606516
    ],
    [
        113.02058277835,
        22.80883203213
    ],
    [
        113.02053142267,
        22.80883575031
    ],
    [
        113.02033438544,
        22.808855376684
    ],
    [
        113.02013519433,
        22.808882012371
    ],
    [
        113.01998438465,
        22.808903791067
    ],
    [
        113.01973815517,
        22.808922805894
    ],
    [
        113.01956463524,
        22.808937935082
    ],
    [
        113.01932678736,
        22.808955996361
    ],
    [
        113.01913382377,
        22.808986779933
    ],
    [
        113.0189705863,
        22.80900994435
    ],
    [
        113.01864466734,
        22.809069568129
    ],
    [
        113.01850035,
        22.809090345559
    ],
    [
        113.01831469967,
        22.809132636053
    ],
    [
        113.01816092411,
        22.809154597753
    ],
    [
        113.01795365013,
        22.809195684812
    ],
    [
        113.01776124258,
        22.809236490454
    ],
    [
        113.01758478274,
        22.809277306155
    ],
    [
        113.01742831449,
        22.809307894554
    ],
    [
        113.01730291959,
        22.809328182248
    ],
    [
        113.01715832966,
        22.809344057797
    ],
    [
        113.01704725602,
        22.809359986921
    ],
    [
        113.01691212913,
        22.809378471796
    ],
    [
        113.016757805,
        22.809390374025
    ],
    [
        113.01666564237,
        22.809396871741
    ],
    [
        113.0164310542,
        22.809420909548
    ],
    [
        113.01625701224,
        22.809446026102
    ],
    [
        113.01609998324,
        22.809455980939
    ],
    [
        113.0159402665,
        22.809481082208
    ],
    [
        113.01577702591,
        22.809496354022
    ],
    [
        113.01569027525,
        22.809509189658
    ],
    [
        113.01553244275,
        22.809527001113
    ],
    [
        113.01539946422,
        22.809532232529
    ],
    [
        113.01525838587,
        22.809546545725
    ],
    [
        113.0151278355,
        22.809547752643
    ],
    [
        113.0150102751,
        22.809564927844
    ],
    [
        113.01492595855,
        22.809579981039
    ],
    [
        113.01484623916,
        22.809597286917
    ],
    [
        113.01472299428,
        22.809606766979
    ],
    [
        113.01460407613,
        22.809618495614
    ],
    [
        113.0144705557,
        22.809624269249
    ],
    [
        113.0143470432,
        22.80963727607
    ],
    [
        113.01424406953,
        22.809646849352
    ],
    [
        113.01411029063,
        22.809665375447
    ],
    [
        113.0140202981,
        22.809682235059
    ],
    [
        113.01389192018,
        22.80969651898
    ],
    [
        113.01371733319,
        22.80972355641
    ],
    [
        113.01350165942,
        22.809750689041
    ],
    [
        113.01325031648,
        22.809790225569
    ],
    [
        113.013075476,
        22.809837352723
    ],
    [
        113.01296413531,
        22.809863076936
    ],
    [
        113.01289250843,
        22.809867792481
    ],
    [
        113.01283466491,
        22.809870308036
    ],
    [
        113.01273624545,
        22.809843627035
    ],
    [
        113.01263835699,
        22.809807732289
    ],
    [
        113.01254832234,
        22.809786898711
    ],
    [
        113.01244637374,
        22.809746324403
    ],
    [
        113.01237281991,
        22.809717912654
    ],
    [
        113.0122635834,
        22.809688610665
    ],
    [
        113.01218571836,
        22.809674506685
    ],
    [
        113.01208812422,
        22.809664674343
    ],
    [
        113.01196510427,
        22.809639481444
    ],
    [
        113.01185072691,
        22.809607386998
    ],
    [
        113.01172661749,
        22.80957539892
    ],
    [
        113.01167334539,
        22.809556844458
    ],
    [
        113.01162359315,
        22.809544048983
    ],
    [
        113.0115230207,
        22.809532007325
    ],
    [
        113.01143947224,
        22.809514020332
    ],
    [
        113.0113845774,
        22.809495441699
    ],
    [
        113.01133265906,
        22.809479899384
    ],
    [
        113.01127830815,
        22.809464858679
    ],
    [
        113.0112225972,
        22.809441655892
    ],
    [
        113.01112579861,
        22.809421006705
    ],
    [
        113.01104954064,
        22.809396369757
    ],
    [
        113.01098734121,
        22.809373330867
    ],
    [
        113.01088593798,
        22.809345012347
    ],
    [
        113.01079130006,
        22.809324137324
    ],
    [
        113.01072938489,
        22.809315758822
    ],
    [
        113.01065989364,
        22.809301012452
    ],
    [
        113.01058147834,
        22.809283674271
    ],
    [
        113.01050116178,
        22.809257894807
    ],
    [
        113.01043789577,
        22.809251397824
    ],
    [
        113.01034109592,
        22.809233754243
    ],
    [
        113.01024943156,
        22.809215657391
    ],
    [
        113.01018967088,
        22.809201084647
    ],
    [
        113.01012422742,
        22.80918126237
    ],
    [
        113.01006879244,
        22.809167307238
    ],
    [
        113.01000200331,
        22.809153976468
    ],
    [
        113.00990897508,
        22.8091258276
    ],
    [
        113.00986029023,
        22.80910412096
    ],
    [
        113.00976321377,
        22.809083776912
    ],
    [
        113.0096753239,
        22.80905870538
    ],
    [
        113.00958283438,
        22.809030575331
    ],
    [
        113.00951063756,
        22.809018793114
    ],
    [
        113.00943437891,
        22.809000976248
    ],
    [
        113.00931809364,
        22.808970289148
    ],
    [
        113.00920614126,
        22.808947546514
    ],
    [
        113.00910744072,
        22.808929639058
    ],
    [
        113.00893707938,
        22.808898890839
    ],
    [
        113.00880403201,
        22.80887310485
    ],
    [
        113.00867747015,
        22.808845260713
    ],
    [
        113.00852601205,
        22.808797211265
    ],
    [
        113.00840187543,
        22.808763993412
    ],
    [
        113.00825122743,
        22.80871814366
    ],
    [
        113.00811897204,
        22.808680467266
    ],
    [
        113.0080115926,
        22.808644553929
    ],
    [
        113.00785361876,
        22.808578532878
    ],
    [
        113.00774650624,
        22.808541550159
    ],
    [
        113.00761398017,
        22.808509051772
    ],
    [
        113.00746765017,
        22.808464675457
    ],
    [
        113.00729669967,
        22.808408524725
    ],
    [
        113.00711007156,
        22.808360823056
    ],
    [
        113.00697184445,
        22.808313620967
    ],
    [
        113.00686174792,
        22.808275547455
    ],
    [
        113.00669919245,
        22.808240464488
    ],
    [
        113.00653176159,
        22.808200163511
    ],
    [
        113.00642166689,
        22.808168352752
    ],
    [
        113.00629399407,
        22.808137363936
    ],
    [
        113.00618822188,
        22.808103732342
    ],
    [
        113.00606649164,
        22.808068778371
    ],
    [
        113.00592582376,
        22.808028390083
    ],
    [
        113.00581113162,
        22.808003054013
    ],
    [
        113.00570779697,
        22.807977895014
    ],
    [
        113.00559932489,
        22.807954835083
    ],
    [
        113.00551086488,
        22.80793180819
    ],
    [
        113.00533962817,
        22.807891819723
    ],
    [
        113.00520626034,
        22.807859459225
    ],
    [
        113.00504961834,
        22.807814828333
    ],
    [
        113.00489892684,
        22.807773010485
    ],
    [
        113.00479530821,
        22.807744369255
    ],
    [
        113.00467519541,
        22.807721464066
    ],
    [
        113.00452801318,
        22.807678913297
    ],
    [
        113.0042579803,
        22.807589039011
    ],
    [
        113.00408427822,
        22.807541806044
    ],
    [
        113.00389596813,
        22.807496827026
    ],
    [
        113.0037357866,
        22.807452260397
    ],
    [
        113.00357289612,
        22.807406857238
    ],
    [
        113.00344112212,
        22.807371936683
    ],
    [
        113.00328390824,
        22.807327996112
    ],
    [
        113.00309719258,
        22.807272545864
    ],
    [
        113.00296892067,
        22.807230655833
    ],
    [
        113.00278489565,
        22.807167951735
    ],
    [
        113.00259518943,
        22.807109534371
    ],
    [
        113.00242576352,
        22.807045165642
    ],
    [
        113.00228341227,
        22.807003416526
    ],
    [
        113.00214998937,
        22.806964237972
    ],
    [
        113.00198489228,
        22.806909197768
    ],
    [
        113.00184740594,
        22.806870264257
    ],
    [
        113.00170910456,
        22.806830518763
    ],
    [
        113.00157784241,
        22.806797386177
    ],
    [
        113.00147769562,
        22.806765197259
    ],
    [
        113.0013718582,
        22.806726161075
    ],
    [
        113.00126548561,
        22.806694451383
    ],
    [
        113.00110282091,
        22.806655545203
    ],
    [
        113.00097182029,
        22.806624096977
    ],
    [
        113.0008335062,
        22.806587959513
    ],
    [
        113.00070007302,
        22.806564103174
    ],
    [
        113.00060236258,
        22.80654448363
    ],
    [
        113.00048624005,
        22.80651624135
    ],
    [
        113.00032626684,
        22.806480167124
    ],
    [
        113.00020256185,
        22.806451587558
    ],
    [
        113.0000515291,
        22.806431113812
    ],
    [
        112.99991483265,
        22.806406479299
    ],
    [
        112.9997123612,
        22.8063765004
    ],
    [
        112.99953098307,
        22.806335119909
    ],
    [
        112.99937965184,
        22.806301963805
    ],
    [
        112.9992756953,
        22.806280197077
    ],
    [
        112.9991333154,
        22.806271314247
    ],
    [
        112.99904558756,
        22.806241873597
    ],
    [
        112.99892401987,
        22.806208548005
    ],
    [
        112.99881600211,
        22.806192742162
    ],
    [
        112.99864787629,
        22.806163830517
    ],
    [
        112.99843047116,
        22.806127103217
    ],
    [
        112.99820574905,
        22.806089794654
    ],
    [
        112.9980389653,
        22.806065044308
    ],
    [
        112.99786054275,
        22.806046711608
    ],
    [
        112.99771459891,
        22.80602465186
    ],
    [
        112.99752044682,
        22.805989119017
    ],
    [
        112.99739072985,
        22.805957485437
    ],
    [
        112.99723501918,
        22.805926705049
    ],
    [
        112.99707769125,
        22.805906781659
    ],
    [
        112.99687458665,
        22.80587370659
    ],
    [
        112.99672348132,
        22.805857683106
    ],
    [
        112.9965350083,
        22.805845144566
    ],
    [
        112.99629263597,
        22.805826468512
    ],
    [
        112.99609656441,
        22.805811218059
    ],
    [
        112.99587394222,
        22.805791165287
    ],
    [
        112.99563290563,
        22.805780499844
    ],
    [
        112.99542463516,
        22.805775026623
    ],
    [
        112.99525697491,
        22.805761495298
    ],
    [
        112.99506250177,
        22.805753479862
    ],
    [
        112.99490133627,
        22.805744389507
    ],
    [
        112.99474234273,
        22.805744562082
    ],
    [
        112.99460285065,
        22.805747882101
    ],
    [
        112.99448855508,
        22.805759538567
    ],
    [
        112.99437723557,
        22.805769870619
    ],
    [
        112.99422095028,
        22.805783427799
    ],
    [
        112.9940083307,
        22.805812632268
    ],
    [
        112.99366431768,
        22.8058472608
    ],
    [
        112.99346549568,
        22.805877739668
    ],
    [
        112.99328155855,
        22.805899119084
    ],
    [
        112.9931610101,
        22.805915752425
    ],
    [
        112.99293589234,
        22.805949964187
    ],
    [
        112.992583971,
        22.805999252238
    ],
    [
        112.99241003086,
        22.806020556691
    ],
    [
        112.99226590732,
        22.80605560944
    ],
    [
        112.99210957074,
        22.806076238504
    ],
    [
        112.99190175239,
        22.806108574346
    ],
    [
        112.99171966846,
        22.806137543198
    ],
    [
        112.99154489571,
        22.806166303946
    ],
    [
        112.99141401472,
        22.806186875985
    ],
    [
        112.99123084785,
        22.806232742141
    ],
    [
        112.99103739061,
        22.806293518966
    ],
    [
        112.99085720943,
        22.806355738743
    ],
    [
        112.9906954496,
        22.806413445499
    ],
    [
        112.99058435585,
        22.806453455336
    ],
    [
        112.9903852004,
        22.806531147774
    ],
    [
        112.99015352078,
        22.806621791739
    ],
    [
        112.9899752163,
        22.806692302371
    ],
    [
        112.98979475437,
        22.806779657722
    ],
    [
        112.98961104139,
        22.806875173513
    ],
    [
        112.98943572106,
        22.806965044803
    ],
    [
        112.98925904351,
        22.807059010865
    ],
    [
        112.98906880839,
        22.807158129391
    ],
    [
        112.98887612363,
        22.807254834192
    ],
    [
        112.98875932364,
        22.80731997979
    ],
    [
        112.98860459663,
        22.807422508398
    ],
    [
        112.98849729966,
        22.807505336256
    ],
    [
        112.98833226995,
        22.80761738184
    ],
    [
        112.98819570622,
        22.807726239293
    ],
    [
        112.98807974474,
        22.80783053017
    ],
    [
        112.98792554404,
        22.807936955426
    ],
    [
        112.98780332249,
        22.808025260167
    ],
    [
        112.98760737696,
        22.808161258307
    ],
    [
        112.98748947811,
        22.80824037786
    ],
    [
        112.98746481551,
        22.8082585358
    ],
    [
        112.98740301972,
        22.808300812805
    ],
    [
        112.98728216257,
        22.808409255663
    ],
    [
        112.98711410737,
        22.808517958721
    ],
    [
        112.98699347968,
        22.808591976132
    ],
    [
        112.98690647306,
        22.808654892677
    ],
    [
        112.98679370012,
        22.808722151874
    ],
    [
        112.98670723296,
        22.80878535597
    ],
    [
        112.98655407629,
        22.808891435241
    ],
    [
        112.98626210188,
        22.809078421917
    ],
    [
        112.98618050081,
        22.809133527263
    ],
    [
        112.98607369603,
        22.809216053841
    ],
    [
        112.98598586122,
        22.809280130515
    ],
    [
        112.98591512347,
        22.809350715479
    ],
    [
        112.98581320545,
        22.809441947233
    ],
    [
        112.98570423842,
        22.809540248698
    ],
    [
        112.9855334461,
        22.809676061755
    ],
    [
        112.98542638328,
        22.809785242363
    ],
    [
        112.98530059358,
        22.80989174237
    ],
    [
        112.9851596379,
        22.810030292916
    ],
    [
        112.98503114526,
        22.810153921176
    ],
    [
        112.98490101796,
        22.810274311377
    ],
    [
        112.98478579172,
        22.810374343205
    ],
    [
        112.98465348908,
        22.810496666038
    ],
    [
        112.9845344537,
        22.810592390251
    ],
    [
        112.98447480684,
        22.810647854534
    ],
    [
        112.98441030549,
        22.810734533879
    ],
    [
        112.98430945322,
        22.810836486839
    ],
    [
        112.98415924943,
        22.810982241388
    ],
    [
        112.98397652155,
        22.811176932437
    ],
    [
        112.98383856292,
        22.811365299346
    ],
    [
        112.98380196861,
        22.811411788724
    ],
    [
        112.98375723385,
        22.811460471108
    ],
    [
        112.98354711966,
        22.811698445997
    ],
    [
        112.98347717914,
        22.811787095019
    ],
    [
        112.98341891082,
        22.811877613614
    ],
    [
        112.98331590629,
        22.812020362897
    ],
    [
        112.9832077408,
        22.812161781277
    ],
    [
        112.98305671716,
        22.812336992582
    ],
    [
        112.98295802289,
        22.812453985871
    ],
    [
        112.98286611007,
        22.812567980227
    ],
    [
        112.9827858648,
        22.812678414198
    ],
    [
        112.98270262422,
        22.812780725069
    ],
    [
        112.9826104707,
        22.812932183783
    ],
    [
        112.98252912593,
        22.813033144158
    ],
    [
        112.98246378697,
        22.813123739551
    ],
    [
        112.98235343766,
        22.813273660771
    ],
    [
        112.98223821199,
        22.813437449726
    ],
    [
        112.98212002017,
        22.813625952854
    ],
    [
        112.98198852186,
        22.813814795849
    ],
    [
        112.98188331678,
        22.813962028659
    ],
    [
        112.98181281649,
        22.814060010064
    ],
    [
        112.98168160716,
        22.814277647627
    ],
    [
        112.9816263208,
        22.814388867052
    ],
    [
        112.98152195187,
        22.814569230759
    ],
    [
        112.9814132365,
        22.814750438612
    ],
    [
        112.98136527029,
        22.814853767848
    ],
    [
        112.98129371048,
        22.814990585255
    ],
    [
        112.98119423181,
        22.815183707322
    ],
    [
        112.98113376267,
        22.815277069227
    ],
    [
        112.98108198741,
        22.815376359556
    ],
    [
        112.98098383454,
        22.815540190937
    ],
    [
        112.9808653456,
        22.815741035946
    ],
    [
        112.98079402873,
        22.815856449249
    ],
    [
        112.98071187093,
        22.815997700148
    ],
    [
        112.98059910421,
        22.816230014676
    ],
    [
        112.98050635934,
        22.816381105447
    ],
    [
        112.98041744046,
        22.816562298247
    ],
    [
        112.98035264578,
        22.816692353246
    ],
    [
        112.98026182058,
        22.816872212141
    ],
    [
        112.98015526308,
        22.817078216275
    ],
    [
        112.9800690249,
        22.817228761271
    ],
    [
        112.979986315,
        22.817378748837
    ],
    [
        112.97988054146,
        22.817557913106
    ],
    [
        112.97978724687,
        22.817722630197
    ],
    [
        112.97970341425,
        22.817836559859
    ],
    [
        112.97961716565,
        22.817987138161
    ],
    [
        112.97952223189,
        22.818148359546
    ],
    [
        112.97949023118,
        22.818210152955
    ],
    [
        112.97943490622,
        22.818315779465
    ],
    [
        112.97937225307,
        22.818429595763
    ],
    [
        112.97930363717,
        22.818561089962
    ],
    [
        112.9792360925,
        22.818675216974
    ],
    [
        112.97912269623,
        22.81886019735
    ],
    [
        112.97903862084,
        22.819028438263
    ],
    [
        112.97895725035,
        22.819184728691
    ],
    [
        112.97885824829,
        22.819376689147
    ],
    [
        112.9787158316,
        22.819638149026
    ],
    [
        112.97859754739,
        22.819847360264
    ],
    [
        112.9784689242,
        22.820041193798
    ],
    [
        112.97833379545,
        22.820260321029
    ],
    [
        112.97826431906,
        22.820358509569
    ],
    [
        112.97819566754,
        22.820471617883
    ],
    [
        112.97814440305,
        22.820585412178
    ],
    [
        112.97802962528,
        22.820785427487
    ],
    [
        112.97797617138,
        22.820881067861
    ],
    [
        112.97789992551,
        22.821020296874
    ],
    [
        112.97781691014,
        22.821194311049
    ],
    [
        112.97775149436,
        22.821284900184
    ],
    [
        112.97768447092,
        22.821409147684
    ],
    [
        112.97759980893,
        22.821567724878
    ],
    [
        112.97751867887,
        22.821728992264
    ],
    [
        112.97743182955,
        22.821874033174
    ],
    [
        112.97736127759,
        22.822013519887
    ],
    [
        112.97724402063,
        22.822202504416
    ],
    [
        112.97718375977,
        22.822296064876
    ],
    [
        112.97712539269,
        22.822378488783
    ],
    [
        112.97704504623,
        22.822509393853
    ],
    [
        112.97697581725,
        22.822606567317
    ],
    [
        112.97691582673,
        22.822704479155
    ],
    [
        112.97684957451,
        22.822785898352
    ],
    [
        112.9768074969,
        22.822852189433
    ],
    [
        112.97675700426,
        22.822933476907
    ],
    [
        112.9766951113,
        22.823036570512
    ],
    [
        112.97664217649,
        22.823126023027
    ],
    [
        112.97656588097,
        22.823233048033
    ],
    [
        112.97647654776,
        22.823353216601
    ],
    [
        112.97639890023,
        22.82347627052
    ],
    [
        112.97632042584,
        22.823583058469
    ],
    [
        112.9762840485,
        22.823647687278
    ],
    [
        112.97624387438,
        22.823726188132
    ],
    [
        112.97618279399,
        22.823839065793
    ],
    [
        112.97613011978,
        22.823922296964
    ],
    [
        112.97608640986,
        22.823999478707
    ],
    [
        112.97603430178,
        22.824123403659
    ],
    [
        112.97595692258,
        22.824257062157
    ],
    [
        112.9758874143,
        22.824374915734
    ],
    [
        112.97578070289,
        22.824551183594
    ],
    [
        112.97570330782,
        22.824666680019
    ],
    [
        112.97562128932,
        22.824779783723
    ],
    [
        112.97550559713,
        22.824949377664
    ],
    [
        112.97540618958,
        22.825081654457
    ],
    [
        112.97534534852,
        22.825162012543
    ],
    [
        112.97527473296,
        22.825263902495
    ],
    [
        112.97522666254,
        22.825339256528
    ],
    [
        112.9751745199,
        22.825425233426
    ],
    [
        112.97510607635,
        22.825528195814
    ],
    [
        112.97500639311,
        22.825671628298
    ],
    [
        112.97491649031,
        22.825809542873
    ],
    [
        112.97483093382,
        22.825945791196
    ],
    [
        112.97474510663,
        22.826088287457
    ],
    [
        112.97464677747,
        22.826240142517
    ],
    [
        112.97455904107,
        22.826378600708
    ],
    [
        112.97444304448,
        22.826545847062
    ],
    [
        112.97444820978,
        22.826546335388
    ],
    [
        112.9743843789,
        22.826658238151
    ],
    [
        112.97431347063,
        22.826752856012
    ],
    [
        112.97420861941,
        22.826934382362
    ],
    [
        112.97413364101,
        22.827052926681
    ],
    [
        112.97407169553,
        22.827138236649
    ],
    [
        112.97401246595,
        22.827219450561
    ],
    [
        112.97395812573,
        22.827293017644
    ],
    [
        112.97388340396,
        22.827387698746
    ],
    [
        112.97380406992,
        22.827507393319
    ],
    [
        112.97372609801,
        22.827637386371
    ],
    [
        112.97365627387,
        22.827751015825
    ],
    [
        112.97355546097,
        22.827881542777
    ],
    [
        112.97345872811,
        22.828022068798
    ],
    [
        112.97334759573,
        22.828195047546
    ],
    [
        112.97327178061,
        22.828302523623
    ],
    [
        112.97320167209,
        22.828405326618
    ],
    [
        112.97312613207,
        22.828528270625
    ],
    [
        112.97304351978,
        22.828647773179
    ],
    [
        112.97294297196,
        22.828799500168
    ],
    [
        112.97287720617,
        22.828896842515
    ],
    [
        112.97282339863,
        22.828981026318
    ],
    [
        112.97275219062,
        22.829072740681
    ],
    [
        112.97267827933,
        22.829213322028
    ],
    [
        112.9726364365,
        22.829306866756
    ],
    [
        112.97259024185,
        22.829399107649
    ],
    [
        112.97252828101,
        22.829509170691
    ],
    [
        112.97247393107,
        22.82961371982
    ],
    [
        112.97240272705,
        22.829737733647
    ],
    [
        112.97235380424,
        22.829812923221
    ],
    [
        112.97229781365,
        22.829897694374
    ],
    [
        112.97224264962,
        22.830020166224
    ],
    [
        112.97217552084,
        22.830147667995
    ],
    [
        112.97211790206,
        22.830253625549
    ],
    [
        112.97204207795,
        22.830413792793
    ],
    [
        112.97195673223,
        22.830568383366
    ],
    [
        112.97187301121,
        22.830705325119
    ],
    [
        112.97182028352,
        22.830816658886
    ],
    [
        112.97175967177,
        22.830941384866
    ],
    [
        112.9717012331,
        22.831061203008
    ],
    [
        112.97162457293,
        22.83118342079
    ],
    [
        112.9715693884,
        22.831274989801
    ],
    [
        112.97149816419,
        22.83139497535
    ],
    [
        112.9714446172,
        22.831520166859
    ],
    [
        112.97139540944,
        22.831596203512
    ],
    [
        112.97134539162,
        22.831701550171
    ],
    [
        112.97124887615,
        22.831851707832
    ],
    [
        112.97113631492,
        22.832016182962
    ],
    [
        112.97105393617,
        22.832161830846
    ],
    [
        112.97098813887,
        22.832269561303
    ],
    [
        112.97091852977,
        22.832361338259
    ],
    [
        112.97082689281,
        22.832473750013
    ],
    [
        112.97074204965,
        22.832562477117
    ],
    [
        112.9706558488,
        22.832672386018
    ],
    [
        112.97056774391,
        22.832791276564
    ],
    [
        112.97049268975,
        22.832889382435
    ],
    [
        112.97042416029,
        22.832974384
    ],
    [
        112.97031972923,
        22.833080753839
    ],
    [
        112.97020904395,
        22.833214070067
    ],
    [
        112.97009427392,
        22.833330629332
    ],
    [
        112.96992157038,
        22.833504405064
    ],
    [
        112.96979863502,
        22.833628690459
    ],
    [
        112.96967488319,
        22.833772798737
    ],
    [
        112.96952283888,
        22.833926528554
    ],
    [
        112.96943117533,
        22.834020569185
    ],
    [
        112.96932427755,
        22.834124863181
    ],
    [
        112.96922009856,
        22.834233194731
    ],
    [
        112.96912054078,
        22.834321935984
    ],
    [
        112.9689921463,
        22.834426550947
    ],
    [
        112.96888279156,
        22.834517070844
    ],
    [
        112.96879030032,
        22.834582129682
    ],
    [
        112.96863904746,
        22.834689264103
    ],
    [
        112.96852805485,
        22.834779828407
    ],
    [
        112.96843447159,
        22.834858484164
    ],
    [
        112.96835095306,
        22.834932116447
    ],
    [
        112.96822689768,
        22.835044317257
    ],
    [
        112.96810066254,
        22.835132143531
    ],
    [
        112.967990749,
        22.835202378174
    ],
    [
        112.96786015631,
        22.835274278927
    ],
    [
        112.96774588568,
        22.835324517431
    ],
    [
        112.9676082146,
        22.835376194109
    ],
    [
        112.96747897589,
        22.835418531695
    ],
    [
        112.96738565084,
        22.83544949056
    ],
    [
        112.96726293925,
        22.835490930766
    ],
    [
        112.96715900083,
        22.835545930675
    ],
    [
        112.96704336121,
        22.83561576081
    ],
    [
        112.96694268541,
        22.835672349871
    ],
    [
        112.96680581884,
        22.835737902931
    ],
    [
        112.96668854189,
        22.835788246052
    ],
    [
        112.96658378054,
        22.835834063662
    ],
    [
        112.96639221397,
        22.835924623654
    ],
    [
        112.96623629123,
        22.835997016345
    ],
    [
        112.96613152507,
        22.836038243896
    ],
    [
        112.96601913843,
        22.836076068381
    ],
    [
        112.96594457631,
        22.836090521878
    ],
    [
        112.96587600034,
        22.836115192389
    ],
    [
        112.96579354535,
        22.836141981065
    ],
    [
        112.96570102062,
        22.836187105536
    ],
    [
        112.96564223951,
        22.836228990186
    ],
    [
        112.96557202874,
        22.836255322848
    ],
    [
        112.96548494532,
        22.83627242958
    ],
    [
        112.96542153722,
        22.836288351134
    ],
    [
        112.96533771809,
        22.836316533444
    ],
    [
        112.96525226567,
        22.836337149112
    ],
    [
        112.9651464017,
        22.83636650196
    ],
    [
        112.96502638448,
        22.836421041762
    ],
    [
        112.96490527735,
        22.836476147211
    ],
    [
        112.96474062403,
        22.836549590646
    ],
    [
        112.96461461412,
        22.836628388521
    ],
    [
        112.9644616593,
        22.836702474375
    ],
    [
        112.96435388155,
        22.83676606974
    ],
    [
        112.96422296885,
        22.836831673356
    ],
    [
        112.9641015802,
        22.836901739127
    ],
    [
        112.96400250909,
        22.836951642707
    ],
    [
        112.96389717642,
        22.837016029304
    ],
    [
        112.96375564266,
        22.83710135937
    ],
    [
        112.96349189752,
        22.837229403039
    ],
    [
        112.9633563469,
        22.837314652841
    ],
    [
        112.9632442033,
        22.8373867703
    ],
    [
        112.96318241493,
        22.837427130113
    ],
    [
        112.96318704256,
        22.837420542874
    ],
    [
        112.96304223295,
        22.837520065568
    ],
    [
        112.96286530511,
        22.837601957014
    ],
    [
        112.96272811549,
        22.837675595995
    ],
    [
        112.96260725544,
        22.837754391286
    ],
    [
        112.96239928601,
        22.837892979275
    ],
    [
        112.96226372329,
        22.837980171786
    ],
    [
        112.96216762998,
        22.838049069191
    ],
    [
        112.96199477243,
        22.838144769124
    ],
    [
        112.96190548248,
        22.838211387522
    ],
    [
        112.96175957011,
        22.838305826279
    ],
    [
        112.9616144714,
        22.838411106712
    ],
    [
        112.96144242157,
        22.838523363159
    ],
    [
        112.96127826497,
        22.838627353311
    ],
    [
        112.96104604609,
        22.83878080298
    ],
    [
        112.96085738486,
        22.838891468269
    ],
    [
        112.96072153588,
        22.838975459545
    ],
    [
        112.96059412497,
        22.839056867265
    ],
    [
        112.96040300982,
        22.839161352839
    ],
    [
        112.96023149506,
        22.839252484598
    ],
    [
        112.96006542532,
        22.839332405309
    ],
    [
        112.95988056669,
        22.839434629447
    ],
    [
        112.95972293026,
        22.839530416654
    ],
    [
        112.95959061355,
        22.839606506416
    ],
    [
        112.95946673302,
        22.839693030242
    ],
    [
        112.95933631423,
        22.83979892961
    ],
    [
        112.95919147038,
        22.839885010826
    ],
    [
        112.95903328288,
        22.839987061282
    ],
    [
        112.95888571252,
        22.84008350325
    ],
    [
        112.9587977709,
        22.84013170238
    ],
    [
        112.95869076393,
        22.84021875528
    ],
    [
        112.95850588796,
        22.840346781325
    ],
    [
        112.95832400407,
        22.840479097814
    ],
    [
        112.95818268806,
        22.840586018375
    ],
    [
        112.95802939293,
        22.840692337759
    ],
    [
        112.95790114402,
        22.840793334503
    ],
    [
        112.95773151266,
        22.840900758605
    ],
    [
        112.95761306642,
        22.840988021881
    ],
    [
        112.9574918996,
        22.841066653799
    ],
    [
        112.95739360394,
        22.841132133597
    ],
    [
        112.95718965981,
        22.841268377887
    ],
    [
        112.95699361668,
        22.841379257381
    ],
    [
        112.95686101349,
        22.841458907447
    ],
    [
        112.95669409871,
        22.841569544269
    ],
    [
        112.95657837601,
        22.84164075874
    ],
    [
        112.95646074343,
        22.841725026925
    ],
    [
        112.95635591305,
        22.841785469999
    ],
    [
        112.95622739197,
        22.8418645054
    ],
    [
        112.95605721397,
        22.841956754182
    ],
    [
        112.95591725293,
        22.842052808281
    ],
    [
        112.95576504104,
        22.842148264379
    ],
    [
        112.95565585266,
        22.842212579994
    ],
    [
        112.95554775663,
        22.84226629712
    ],
    [
        112.95537920644,
        22.842372346399
    ],
    [
        112.95527355301,
        22.842447989851
    ],
    [
        112.95506334388,
        22.842572672972
    ],
    [
        112.95489643359,
        22.842658615678
    ],
    [
        112.95477008746,
        22.842741400856
    ],
    [
        112.95460943365,
        22.842841334188
    ],
    [
        112.95448063604,
        22.842927685312
    ],
    [
        112.95433876977,
        22.843018061725
    ],
    [
        112.95423202808,
        22.843090459778
    ],
    [
        112.95409750441,
        22.843201318114
    ],
    [
        112.95401444851,
        22.843268958078
    ],
    [
        112.9538796584,
        22.843364085235
    ],
    [
        112.95380477229,
        22.843423985032
    ],
    [
        112.95373506275,
        22.843472943745
    ],
    [
        112.95365200749,
        22.843538680986
    ],
    [
        112.95355751989,
        22.84360136202
    ],
    [
        112.9534867161,
        22.843663899562
    ],
    [
        112.95342462912,
        22.843712450824
    ],
    [
        112.95332987203,
        22.843768623492
    ],
    [
        112.95327595553,
        22.843808079835
    ],
    [
        112.95321795355,
        22.84385276049
    ],
    [
        112.95311665739,
        22.843923419708
    ],
    [
        112.95303714547,
        22.84397878011
    ],
    [
        112.95292985854,
        22.844054422654
    ],
    [
        112.95286613536,
        22.844110320149
    ],
    [
        112.95277845307,
        22.844175040998
    ],
    [
        112.95270547566,
        22.844228113446
    ],
    [
        112.95262950261,
        22.844284220432
    ],
    [
        112.95252602244,
        22.844370910005
    ],
    [
        112.9524119341,
        22.844438793826
    ],
    [
        112.95232752023,
        22.84450046695
    ],
    [
        112.95220934663,
        22.844574112679
    ],
    [
        112.95210287932,
        22.844645926568
    ],
    [
        112.95201274762,
        22.84471176114
    ],
    [
        112.95189457709,
        22.84478051653
    ],
    [
        112.95179683019,
        22.844832644253
    ],
    [
        112.95164708163,
        22.844907359161
    ],
    [
        112.95155695438,
        22.844965860851
    ],
    [
        112.95143606598,
        22.845029225382
    ],
    [
        112.95135737687,
        22.845076949202
    ],
    [
        112.95124901619,
        22.845128431353
    ],
    [
        112.95109491962,
        22.845194249228
    ],
    [
        112.95094273103,
        22.845256773777
    ],
    [
        112.95081286656,
        22.845312947652
    ],
    [
        112.95069960579,
        22.845371006767
    ],
    [
        112.95061357274,
        22.845412600609
    ],
    [
        112.95047581693,
        22.845468352847
    ],
    [
        112.95031546726,
        22.845530716932
    ],
    [
        112.95020167181,
        22.845574393247
    ],
    [
        112.95016082955,
        22.845603827512
    ],
    [
        112.95011753487,
        22.845638998238
    ],
    [
        112.95007859255,
        22.845679520502
    ],
    [
        112.94997782795,
        22.845794035907
    ],
    [
        112.94992798104,
        22.845869185164
    ],
    [
        112.94985198276,
        22.845987623892
    ],
    [
        112.94978225634,
        22.846082630181
    ],
    [
        112.94972833488,
        22.846141298291
    ],
    [
        112.9496727649,
        22.846229828783
    ],
    [
        112.94959460271,
        22.846321173087
    ],
    [
        112.94950363436,
        22.846439036685
    ],
    [
        112.94944181063,
        22.846515189137
    ],
    [
        112.94938516793,
        22.84657308214
    ],
    [
        112.94934703146,
        22.846633653112
    ],
    [
        112.94929446187,
        22.846709107589
    ],
    [
        112.94923999498,
        22.846769945534
    ],
    [
        112.94918116822,
        22.846840347171
    ],
    [
        112.94911336541,
        22.846900858908
    ],
    [
        112.94903220931,
        22.84699277936
    ],
    [
        112.94896821624,
        22.847054852697
    ],
    [
        112.94888516249,
        22.847133780559
    ],
    [
        112.94881762502,
        22.847207571224
    ],
    [
        112.94873701203,
        22.847302457642
    ],
    [
        112.94867900051,
        22.847375818812
    ],
    [
        112.94860356163,
        22.847465463778
    ],
    [
        112.94854065054,
        22.847540257401
    ],
    [
        112.94846413043,
        22.847617439101
    ],
    [
        112.94838325271,
        22.847700384658
    ],
    [
        112.94828413603,
        22.847792029151
    ],
    [
        112.94821851163,
        22.847853839359
    ],
    [
        112.94813437931,
        22.847919199179
    ],
    [
        112.94803663353,
        22.847995623058
    ],
    [
        112.94794079572,
        22.848067944228
    ],
    [
        112.94783652594,
        22.848133886214
    ],
    [
        112.94773495982,
        22.848230158842
    ],
    [
        112.94758766643,
        22.848341254056
    ],
    [
        112.94749482175,
        22.848418121306
    ],
    [
        112.94741259796,
        22.848483154989
    ],
    [
        112.9473105016,
        22.848560431666
    ],
    [
        112.94721684577,
        22.848631333546
    ],
    [
        112.94713434971,
        22.848698802717
    ],
    [
        112.94705484743,
        22.848766222286
    ],
    [
        112.94697562675,
        22.848819259491
    ],
    [
        112.9469132799,
        22.848869048738
    ],
    [
        112.94680302445,
        22.848944530606
    ],
    [
        112.94673032554,
        22.849013732061
    ],
    [
        112.94665600208,
        22.849070750782
    ],
    [
        112.94658522523,
        22.849114151023
    ],
    [
        112.94652070135,
        22.849166674893
    ],
    [
        112.94645100783,
        22.849219004708
    ],
    [
        112.94635735948,
        22.849286615479
    ],
    [
        112.94628057962,
        22.849358033864
    ],
    [
        112.9462081682,
        22.849407413579
    ],
    [
        112.94615779869,
        22.849454558076
    ],
    [
        112.94610933582,
        22.849498960201
    ],
    [
        112.94607013509,
        22.849527218672
    ],
    [
        112.94599554911,
        22.849574996526
    ],
    [
        112.94592993515,
        22.849634028223
    ],
    [
        112.94585098379,
        22.849700852523
    ],
    [
        112.94577747853,
        22.849761896391
    ],
    [
        112.94572520966,
        22.849803362929
    ],
    [
        112.94568628399,
        22.849828897652
    ],
    [
        112.94561985665,
        22.849885761626
    ],
    [
        112.94556567718,
        22.849937016672
    ],
    [
        112.94551232172,
        22.849977137675
    ],
    [
        112.94543854583,
        22.850038715558
    ],
    [
        112.94539362097,
        22.850085217909
    ],
    [
        112.94533725974,
        22.850145178202
    ],
    [
        112.9452710966,
        22.85021585909
    ],
    [
        112.94520740097,
        22.850259649997
    ],
    [
        112.94513498144,
        22.850329333241
    ],
    [
        112.94508108019,
        22.850374332519
    ],
    [
        112.94500294992,
        22.850441110814
    ],
    [
        112.944961849,
        22.850468018986
    ],
    [
        112.9449177551,
        22.850495512258
    ],
    [
        112.94487420303,
        22.850526522579
    ],
    [
        112.94482683821,
        22.850563282924
    ],
    [
        112.94476314135,
        22.850612212316
    ],
    [
        112.94470108008,
        22.850657047549
    ],
    [
        112.94464635862,
        22.850710454251
    ],
    [
        112.94458021536,
        22.850757785263
    ],
    [
        112.94453556958,
        22.850798296296
    ],
    [
        112.94445743815,
        22.850871561228
    ],
    [
        112.94439320228,
        22.850916145979
    ],
    [
        112.94433902604,
        22.850969806952
    ],
    [
        112.94428621906,
        22.851011241713
    ],
    [
        112.94422062276,
        22.851057467036
    ],
    [
        112.94415692549,
        22.851111528655
    ],
    [
        112.94408670031,
        22.851164595138
    ],
    [
        112.94399088737,
        22.851240530024
    ],
    [
        112.94389997073,
        22.851318018573
    ],
    [
        112.94377584792,
        22.851421460112
    ],
    [
        112.94369011141,
        22.851485575655
    ],
    [
        112.94358505319,
        22.851561345372
    ],
    [
        112.94345548644,
        22.851674332012
    ],
    [
        112.94337083637,
        22.85174411245
    ],
    [
        112.94329189936,
        22.851813810744
    ],
    [
        112.94317649717,
        22.85190488494
    ],
    [
        112.94305102696,
        22.852002596518
    ],
    [
        112.94290487597,
        22.852113594877
    ],
    [
        112.9428229527,
        22.852180327618
    ],
    [
        112.94272660933,
        22.852253486323
    ],
    [
        112.94264442116,
        22.852312890661
    ],
    [
        112.94255597115,
        22.852381052647
    ],
    [
        112.94244465,
        22.852481514552
    ],
    [
        112.94237335258,
        22.852529370739
    ],
    [
        112.94229687386,
        22.852595463217
    ],
    [
        112.94223209649,
        22.852654348173
    ],
    [
        112.94220324138,
        22.85268672723
    ],
    [
        112.94209084515,
        22.85277578709
    ],
    [
        112.94201707664,
        22.852856748251
    ],
    [
        112.94195257302,
        22.852915618199
    ],
    [
        112.94183066014,
        22.85300559511
    ],
    [
        112.941757176,
        22.853073250497
    ],
    [
        112.94164804817,
        22.853162779426
    ],
    [
        112.94156531533,
        22.853234881985
    ],
    [
        112.94147822908,
        22.853310560452
    ],
    [
        112.94132555426,
        22.85344780335
    ],
    [
        112.94121669339,
        22.853549774249
    ],
    [
        112.94111027882,
        22.85365469065
    ],
    [
        112.94099081589,
        22.853755419169
    ],
    [
        112.9408860506,
        22.853841856487
    ],
    [
        112.94079761157,
        22.853916969442
    ],
    [
        112.94071407262,
        22.853986593847
    ],
    [
        112.94055080493,
        22.854124698162
    ],
    [
        112.94042075186,
        22.854217098621
    ],
    [
        112.94031299025,
        22.854318176164
    ],
    [
        112.9401992516,
        22.854414975835
    ],
    [
        112.94009939506,
        22.854495603748
    ],
    [
        112.93998375142,
        22.854597832732
    ],
    [
        112.93982213932,
        22.854723901654
    ],
    [
        112.93972854985,
        22.854793854524
    ],
    [
        112.93965154639,
        22.854863885476
    ],
    [
        112.93957917332,
        22.854924910029
    ],
    [
        112.93947767408,
        22.855027752258
    ],
    [
        112.93940883439,
        22.85509171194
    ],
    [
        112.93931115997,
        22.855175243033
    ],
    [
        112.93922055631,
        22.855257604821
    ],
    [
        112.93911908016,
        22.855338723009
    ],
    [
        112.93902576593,
        22.855414321009
    ],
    [
        112.93896128103,
        22.855476855026
    ],
    [
        112.93890496608,
        22.855523567698
    ],
    [
        112.93881900276,
        22.855589579978
    ],
    [
        112.93874770925,
        22.855668178284
    ],
    [
        112.93864053286,
        22.855746609083
    ],
    [
        112.9385608278,
        22.85580928432
    ],
    [
        112.93843976331,
        22.855918492071
    ],
    [
        112.93831107375,
        22.856045396412
    ],
    [
        112.93822157376,
        22.856122255411
    ],
    [
        112.93811656144,
        22.856220963169
    ],
    [
        112.93802324421,
        22.856313577978
    ],
    [
        112.93790327396,
        22.856424352844
    ],
    [
        112.93780643279,
        22.856509122112
    ],
    [
        112.9376810362,
        22.856612878697
    ],
    [
        112.9375722254,
        22.856712393601
    ],
    [
        112.9374582459,
        22.856818729582
    ],
    [
        112.93737636468,
        22.856897355557
    ],
    [
        112.93727870841,
        22.856989415898
    ],
    [
        112.9371971153,
        22.857052297187
    ],
    [
        112.9371160568,
        22.85712601685
    ],
    [
        112.93700888482,
        22.857225739754
    ],
    [
        112.93689409704,
        22.857333931373
    ],
    [
        112.93678230928,
        22.857432592694
    ],
    [
        112.93662727565,
        22.857572044715
    ],
    [
        112.93650461406,
        22.8576791867
    ],
    [
        112.93638358036,
        22.857791455379
    ],
    [
        112.93626009975,
        22.857907259345
    ],
    [
        112.936151854,
        22.85800664704
    ],
    [
        112.93604415646,
        22.858102766002
    ],
    [
        112.93593457072,
        22.858185873207
    ],
    [
        112.93587883371,
        22.858220786329
    ],
    [
        112.93586252134,
        22.858230144371
    ],
    [
        112.93577306176,
        22.858296524337
    ],
    [
        112.9356797937,
        22.858368895806
    ],
    [
        112.93557864184,
        22.858447019876
    ],
    [
        112.93549435175,
        22.858510082716
    ],
    [
        112.93535921818,
        22.858610973223
    ],
    [
        112.93528879419,
        22.858667130896
    ],
    [
        112.93519797502,
        22.858742971733
    ],
    [
        112.93511940064,
        22.858800539383
    ],
    [
        112.93497042146,
        22.858898781628
    ],
    [
        112.93487742582,
        22.85898248003
    ],
    [
        112.93477220933,
        22.859062736858
    ],
    [
        112.9346865463,
        22.859152060992
    ],
    [
        112.93453674803,
        22.859265171867
    ],
    [
        112.9344426639,
        22.859357251777
    ],
    [
        112.93435159472,
        22.859422995076
    ],
    [
        112.9342917903,
        22.85946464391
    ],
    [
        112.93419148037,
        22.859537491692
    ],
    [
        112.9341172686,
        22.8595911656
    ],
    [
        112.93404305535,
        22.859647275738
    ],
    [
        112.93396992773,
        22.859705272282
    ],
    [
        112.93384651479,
        22.859798045908
    ],
    [
        112.93375111229,
        22.859859703394
    ],
    [
        112.93367445119,
        22.859923671448
    ],
    [
        112.93353854805,
        22.860018121394
    ],
    [
        112.93340916065,
        22.860118752144
    ],
    [
        112.93331240783,
        22.860179568448
    ],
    [
        112.93322407662,
        22.860240053605
    ],
    [
        112.93314933267,
        22.860294482623
    ],
    [
        112.93305176477,
        22.86035989261
    ],
    [
        112.93295528299,
        22.860427186358
    ],
    [
        112.93283544355,
        22.860497320256
    ],
    [
        112.93272211547,
        22.860576625582
    ],
    [
        112.9325517377,
        22.860677664616
    ],
    [
        112.93246179783,
        22.860728607488
    ],
    [
        112.932354998,
        22.860804314648
    ],
    [
        112.93220013439,
        22.860880265613
    ],
    [
        112.93206998841,
        22.860953627556
    ],
    [
        112.93197435683,
        22.861001306439
    ],
    [
        112.93185371935,
        22.86107513769
    ],
    [
        112.9317599873,
        22.861127670767
    ],
    [
        112.93162957364,
        22.861207220974
    ],
    [
        112.93146193998,
        22.861311608271
    ],
    [
        112.93134239749,
        22.861387277951
    ],
    [
        112.93120112253,
        22.861477404249
    ],
    [
        112.93109706927,
        22.861544843471
    ],
    [
        112.93100904171,
        22.861606781562
    ],
    [
        112.93090606873,
        22.861683419564
    ],
    [
        112.93083216562,
        22.861741217377
    ],
    [
        112.9306702463,
        22.861855768398
    ],
    [
        112.93060475826,
        22.861917315201
    ],
    [
        112.93053166069,
        22.861987836796
    ],
    [
        112.93043494012,
        22.862064407389
    ],
    [
        112.93034421224,
        22.86212223437
    ],
    [
        112.93026951894,
        22.862163182289
    ],
    [
        112.93020866036,
        22.862214654399
    ],
    [
        112.93017360032,
        22.862256542221
    ],
    [
        112.93012712901,
        22.862308773822
    ],
    [
        112.93008741048,
        22.862394610957
    ],
    [
        112.93004360017,
        22.862500529891
    ],
    [
        112.93001201156,
        22.862600168985
    ],
    [
        112.92996336082,
        22.862661350791
    ],
    [
        112.92983990928,
        22.862607231865
    ],
    [
        112.92959599344,
        22.8625057238
    ],
    [
        112.92959111212,
        22.862501398645
    ],
    [
        112.92944785364,
        22.862448920215
    ],
    [
        112.92931356433,
        22.862387720401
    ],
    [
        112.92917465594,
        22.862334923287
    ],
    [
        112.92898989162,
        22.862275437366
    ],
    [
        112.92878752016,
        22.862189379714
    ],
    [
        112.92854363931,
        22.862099840278
    ],
    [
        112.92836757428,
        22.862046198063
    ],
    [
        112.92822897271,
        22.861982159647
    ],
    [
        112.92801143179,
        22.861898422944
    ],
    [
        112.92784922788,
        22.861839251785
    ],
    [
        112.92770926748,
        22.861790607551
    ],
    [
        112.92747221978,
        22.861699462242
    ],
    [
        112.92731163833,
        22.861661905673
    ],
    [
        112.92722538079,
        22.861642987181
    ],
    [
        112.92706860711,
        22.86160322191
    ],
    [
        112.92695631002,
        22.86158348313
    ],
    [
        112.92680415151,
        22.861548287751
    ],
    [
        112.92663897545,
        22.86151361578
    ],
    [
        112.92637834587,
        22.861451524764
    ],
    [
        112.9262473654,
        22.861412725896
    ],
    [
        112.92609333941,
        22.86136630995
    ],
    [
        112.92594528949,
        22.861315535302
    ],
    [
        112.92578638646,
        22.861272598928
    ],
    [
        112.92566165279,
        22.861239699216
    ],
    [
        112.92551144449,
        22.861189405739
    ],
    [
        112.92535635455,
        22.8611431546
    ],
    [
        112.92519775794,
        22.861082231561
    ],
    [
        112.92507684495,
        22.861038962391
    ],
    [
        112.9250220976,
        22.86100417639
    ],
    [
        112.92494999986,
        22.860963939474
    ],
    [
        112.92487463702,
        22.860935626393
    ],
    [
        112.924778948,
        22.860895614712
    ],
    [
        112.92466508642,
        22.860860989038
    ],
    [
        112.92453930242,
        22.860819550048
    ],
    [
        112.92438233594,
        22.860779664623
    ],
    [
        112.92421942709,
        22.860721030423
    ],
    [
        112.92411829998,
        22.860708070398
    ],
    [
        112.92398600021,
        22.860687978906
    ],
    [
        112.92391144664,
        22.860677500621
    ],
    [
        112.92375962916,
        22.860658691662
    ],
    [
        112.92359047422,
        22.860629509714
    ],
    [
        112.92343730569,
        22.86061526278
    ],
    [
        112.92329877839,
        22.860604020305
    ],
    [
        112.92315184653,
        22.860596802898
    ],
    [
        112.92301277744,
        22.860592574006
    ],
    [
        112.92292441444,
        22.860579272095
    ],
    [
        112.9228352407,
        22.860564875479
    ],
    [
        112.92272357521,
        22.860543885445
    ],
    [
        112.92259998959,
        22.860517959949
    ],
    [
        112.92247504665,
        22.860496897413
    ],
    [
        112.92237017919,
        22.860461521861
    ],
    [
        112.92221247878,
        22.860404776804
    ],
    [
        112.92199571064,
        22.860332038318
    ],
    [
        112.92176323252,
        22.860257833609
    ],
    [
        112.92168113001,
        22.860237678312
    ],
    [
        112.92156190982,
        22.860205959933
    ],
    [
        112.9214402475,
        22.860179913033
    ],
    [
        112.92133673624,
        22.860163430629
    ],
    [
        112.92122401673,
        22.860142826283
    ],
    [
        112.92112538779,
        22.860126076405
    ],
    [
        112.92101862018,
        22.860120125957
    ],
    [
        112.92088014976,
        22.860113190455
    ],
    [
        112.92072108509,
        22.860109384678
    ],
    [
        112.92055931817,
        22.860102558463
    ],
    [
        112.92045364505,
        22.860096831373
    ],
    [
        112.92037507389,
        22.860087448063
    ],
    [
        112.92026779279,
        22.860067049018
    ],
    [
        112.92014914377,
        22.860036268322
    ],
    [
        112.9199660477,
        22.85996875331
    ],
    [
        112.91974016187,
        22.859888743561
    ],
    [
        112.91963698254,
        22.859841730849
    ],
    [
        112.9195148326,
        22.859802725862
    ],
    [
        112.9193978282,
        22.859768351506
    ],
    [
        112.9192875908,
        22.859742416951
    ],
    [
        112.91916544541,
        22.859706358228
    ],
    [
        112.91906794925,
        22.859675876119
    ],
    [
        112.91894607074,
        22.85964874613
    ],
    [
        112.91885695989,
        22.859634847418
    ],
    [
        112.91868037075,
        22.859603786391
    ],
    [
        112.91852355324,
        22.85958070564
    ],
    [
        112.91836755205,
        22.859558152279
    ],
    [
        112.91823157961,
        22.859555525556
    ],
    [
        112.91805580396,
        22.859543090472
    ],
    [
        112.91793988463,
        22.85953732695
    ],
    [
        112.91782531237,
        22.859541326352
    ],
    [
        112.91770668685,
        22.859537960076
    ],
    [
        112.91750545693,
        22.859537719568
    ],
    [
        112.91731289978,
        22.859537787518
    ],
    [
        112.91714229212,
        22.859530142264
    ],
    [
        112.91697195985,
        22.859522746552
    ],
    [
        112.91682247536,
        22.859524185049
    ],
    [
        112.91672607784,
        22.859517658457
    ],
    [
        112.91661398059,
        22.859506376309
    ],
    [
        112.9164691273,
        22.85948801345
    ],
    [
        112.91633674643,
        22.859455913562
    ],
    [
        112.91615402424,
        22.859403813687
    ],
    [
        112.91601814195,
        22.85935944317
    ],
    [
        112.91588552783,
        22.85929827296
    ],
    [
        112.91576320055,
        22.859241796533
    ],
    [
        112.91566227023,
        22.859179545209
    ],
    [
        112.91559788055,
        22.859129298199
    ],
    [
        112.91549560814,
        22.859057528128
    ],
    [
        112.91537328664,
        22.859002641394
    ],
    [
        112.91524071755,
        22.858908044327
    ],
    [
        112.91517066578,
        22.858837649847
    ],
    [
        112.91509464254,
        22.858784278813
    ],
    [
        112.9150381212,
        22.858721334636
    ],
    [
        112.91498428764,
        22.858679298756
    ],
    [
        112.91493995112,
        22.85861457405
    ],
    [
        112.91491185918,
        22.858548384653
    ],
    [
        112.91488299278,
        22.858442317705
    ],
    [
        112.91488010137,
        22.858350616636
    ],
    [
        112.91488698016,
        22.858232706221
    ],
    [
        112.91488407002,
        22.858160532632
    ],
    [
        112.91487978436,
        22.858111669895
    ],
    [
        112.91486302355,
        22.858086547986
    ],
    [
        112.91482136777,
        22.858050052979
    ],
    [
        112.91476832525,
        22.858031883314
    ],
    [
        112.9147204225,
        22.858018103667
    ],
    [
        112.91464381946,
        22.858010536098
    ],
    [
        112.91451309532,
        22.8579834168
    ],
    [
        112.91443218435,
        22.85795355214
    ],
    [
        112.91435915069,
        22.857895558642
    ],
    [
        112.9142993858,
        22.857833090631
    ],
    [
        112.91424941642,
        22.857716479961
    ],
    [
        112.91418996939,
        22.857603834765
    ],
    [
        112.91414321062,
        22.857528208312
    ],
    [
        112.9141080493,
        22.857498269325
    ],
    [
        112.91405636096,
        22.857485238733
    ],
    [
        112.91399003625,
        22.857494016999
    ],
    [
        112.91392613623,
        22.857515836834
    ],
    [
        112.91388496043,
        22.857551733134
    ],
    [
        112.913848386,
        22.857587949564
    ],
    [
        112.91384401136,
        22.857635365274
    ],
    [
        112.91383337454,
        22.857722310666
    ],
    [
        112.91385650037,
        22.857885836789
    ],
    [
        112.91386991751,
        22.858010743661
    ],
    [
        112.91387010166,
        22.858103231317
    ],
    [
        112.91383973216,
        22.858160941248
    ],
    [
        112.91379474382,
        22.85822147404
    ],
    [
        112.91375898693,
        22.858251730102
    ],
    [
        112.91370184461,
        22.858285004594
    ],
    [
        112.91359898322,
        22.858294174692
    ],
    [
        112.91348962202,
        22.858309231325
    ],
    [
        112.91342898413,
        22.858320486686
    ],
    [
        112.91334504731,
        22.858356429155
    ],
    [
        112.91326218666,
        22.858400244061
    ],
    [
        112.9132107583,
        22.858405627339
    ],
    [
        112.91316313238,
        22.858397219914
    ],
    [
        112.91309762556,
        22.858408676489
    ],
    [
        112.91305107094,
        22.858413024779
    ],
    [
        112.91300179133,
        22.858437410328
    ],
    [
        112.91296819737,
        22.858474180058
    ],
    [
        112.91292105978,
        22.858523539594
    ],
    [
        112.91288468813,
        22.858635945131
    ],
    [
        112.91283290077,
        22.858737321687
    ],
    [
        112.91282760285,
        22.858901075863
    ],
    [
        112.91285695884,
        22.85905085836
    ],
    [
        112.91286660053,
        22.859156474115
    ],
    [
        112.91286843407,
        22.859219960381
    ],
    [
        112.91286838171,
        22.859274474551
    ],
    [
        112.91286130514,
        22.859316159917
    ],
    [
        112.91284342888,
        22.859331140387
    ],
    [
        112.91281580765,
        22.859348448135
    ],
    [
        112.91277790317,
        22.859365092913
    ],
    [
        112.91274136247,
        22.859370903925
    ],
    [
        112.91270916972,
        22.859358322161
    ],
    [
        112.91266480216,
        22.859342342027
    ],
    [
        112.91263316744,
        22.859312678381
    ],
    [
        112.91259882845,
        22.859281083601
    ],
    [
        112.91256316125,
        22.859223706591
    ],
    [
        112.91252696905,
        22.859149506945
    ],
    [
        112.9125224148,
        22.859101176175
    ],
    [
        112.91250463394,
        22.859017430167
    ],
    [
        112.91249958183,
        22.85892352874
    ],
    [
        112.91246427546,
        22.858771498274
    ],
    [
        112.91245655021,
        22.858642306406
    ],
    [
        112.91244881025,
        22.858528302498
    ],
    [
        112.91245047344,
        22.858486554623
    ],
    [
        112.9124264558,
        22.858415209252
    ],
    [
        112.91241302987,
        22.858303849449
    ],
    [
        112.91238697972,
        22.858091173992
    ],
    [
        112.91237767479,
        22.857912871763
    ],
    [
        112.91238290106,
        22.857822075728
    ],
    [
        112.91238728937,
        22.857759205241
    ],
    [
        112.91239790673,
        22.857690984715
    ],
    [
        112.91241394029,
        22.857618489192
    ],
    [
        112.91245327298,
        22.857517792865
    ],
    [
        112.91253591075,
        22.857410828464
    ],
    [
        112.91263344016,
        22.857296711752
    ],
    [
        112.91271230485,
        22.857174233091
    ],
    [
        112.91276489388,
        22.857079107728
    ],
    [
        112.91279368154,
        22.856968514638
    ],
    [
        112.91281844742,
        22.856816106102
    ],
    [
        112.9128269015,
        22.85674487349
    ],
    [
        112.91281640182,
        22.856683997783
    ],
    [
        112.91279838792,
        22.856552516938
    ],
    [
        112.91277034653,
        22.856436378296
    ],
    [
        112.91276205316,
        22.856328877797
    ],
    [
        112.91275022419,
        22.856240592571
    ],
    [
        112.91275328771,
        22.856143259874
    ],
    [
        112.91274579507,
        22.856047431011
    ],
    [
        112.91274478189,
        22.85596903607
    ],
    [
        112.91276837961,
        22.855909100671
    ],
    [
        112.91279143485,
        22.855850514643
    ],
    [
        112.91282858878,
        22.855762529184
    ],
    [
        112.91287547735,
        22.855683877281
    ],
    [
        112.91292369932,
        22.855628021895
    ],
    [
        112.91299330935,
        22.855563732334
    ],
    [
        112.91307128404,
        22.855529098492
    ],
    [
        112.91315576042,
        22.855488296363
    ],
    [
        112.91328841577,
        22.855444780231
    ],
    [
        112.9134489679,
        22.855382035963
    ],
    [
        112.91350880579,
        22.855356124726
    ],
    [
        112.91356160306,
        22.855334743443
    ],
    [
        112.9136293164,
        22.855279622394
    ],
    [
        112.91369893409,
        22.855213941263
    ],
    [
        112.91374743103,
        22.855158873794
    ],
    [
        112.91376860315,
        22.855089130522
    ],
    [
        112.91377245617,
        22.855014857641
    ],
    [
        112.91375928361,
        22.85490920741
    ],
    [
        112.91373606452,
        22.854840604261
    ],
    [
        112.91370556893,
        22.854734762986
    ],
    [
        112.91368941236,
        22.854636130866
    ],
    [
        112.9136846724,
        22.854479311254
    ],
    [
        112.91370154628,
        22.85436883775
    ],
    [
        112.91369347573,
        22.85430962199
    ],
    [
        112.91365076969,
        22.854238632509
    ],
    [
        112.91355612545,
        22.854132890925
    ],
    [
        112.9134425782,
        22.853976212106
    ],
    [
        112.91333385929,
        22.853873823236
    ],
    [
        112.91326357576,
        22.853769149498
    ],
    [
        112.91317976768,
        22.853655367706
    ],
    [
        112.91308433276,
        22.853528971223
    ],
    [
        112.91299779905,
        22.853440642305
    ],
    [
        112.91295210705,
        22.853383700192
    ],
    [
        112.91292100243,
        22.853360557519
    ],
    [
        112.91287851832,
        22.853353555697
    ],
    [
        112.91276185251,
        22.853382574255
    ],
    [
        112.91264032657,
        22.853400134523
    ],
    [
        112.91250527989,
        22.853407488693
    ],
    [
        112.91241407273,
        22.853418337353
    ],
    [
        112.91230691798,
        22.853407562038
    ],
    [
        112.91221248353,
        22.853396661162
    ],
    [
        112.91215810601,
        22.85337837413
    ],
    [
        112.91210942701,
        22.853340897213
    ],
    [
        112.91206103019,
        22.853289318341
    ],
    [
        112.91203321543,
        22.853217646972
    ],
    [
        112.9120075818,
        22.853125388465
    ],
    [
        112.91197113481,
        22.853019435861
    ],
    [
        112.91194687494,
        22.852900341521
    ],
    [
        112.91193456018,
        22.852731216158
    ],
    [
        112.91192144927,
        22.852540653759
    ],
    [
        112.91192480231,
        22.852403724927
    ],
    [
        112.91190571601,
        22.85223939778
    ],
    [
        112.91189903678,
        22.852127027276
    ],
    [
        112.91187312355,
        22.85204262793
    ],
    [
        112.91183287488,
        22.85194991455
    ],
    [
        112.91179368035,
        22.851894642612
    ],
    [
        112.91173798161,
        22.851836995346
    ],
    [
        112.9116646926,
        22.851782381968
    ],
    [
        112.91158191273,
        22.851755854222
    ],
    [
        112.91151997918,
        22.851715208286
    ],
    [
        112.91142420868,
        22.851694475959
    ],
    [
        112.91132709478,
        22.851662600161
    ],
    [
        112.91122753972,
        22.85164045134
    ],
    [
        112.91116422991,
        22.851635033153
    ],
    [
        112.91112229034,
        22.851636666762
    ],
    [
        112.91106789089,
        22.851657125412
    ],
    [
        112.91098833738,
        22.851666680272
    ],
    [
        112.91092339712,
        22.851673436515
    ],
    [
        112.91083953234,
        22.851661229674
    ],
    [
        112.91074214945,
        22.851637179204
    ],
    [
        112.91065747757,
        22.851621426112
    ],
    [
        112.91054248963,
        22.851626425401
    ],
    [
        112.91045834246,
        22.851635621684
    ],
    [
        112.91038583953,
        22.851631406604
    ],
    [
        112.91030900984,
        22.851625503264
    ],
    [
        112.91023948677,
        22.851617795279
    ],
    [
        112.91017158771,
        22.851609834842
    ],
    [
        112.91009747062,
        22.851596905839
    ],
    [
        112.91000685075,
        22.851585378118
    ],
    [
        112.90990920647,
        22.851562629738
    ],
    [
        112.90979804627,
        22.851527486106
    ],
    [
        112.90972906659,
        22.851522476181
    ],
    [
        112.90965171028,
        22.85150541443
    ],
    [
        112.90956407774,
        22.851484681676
    ],
    [
        112.9094975434,
        22.851467761788
    ],
    [
        112.9094483252,
        22.851447010512
    ],
    [
        112.90939666452,
        22.851437344366
    ],
    [
        112.9093598948,
        22.851410524809
    ],
    [
        112.90932447337,
        22.851389690268
    ],
    [
        112.90929610151,
        22.85134671231
    ],
    [
        112.90926773721,
        22.85129342723
    ],
    [
        112.90925588133,
        22.851229794028
    ],
    [
        112.90924755269,
        22.851151292263
    ],
    [
        112.90925031545,
        22.851071589041
    ],
    [
        112.90925795426,
        22.850981918247
    ],
    [
        112.90927424483,
        22.850898063821
    ],
    [
        112.90926750142,
        22.850871117954
    ],
    [
        112.90926185413,
        22.850824387474
    ],
    [
        112.90924267057,
        22.850792928269
    ],
    [
        112.90921835516,
        22.850750547909
    ],
    [
        112.9091818566,
        22.850722914493
    ],
    [
        112.90912642277,
        22.850695557325
    ],
    [
        112.90909450538,
        22.850692939582
    ],
    [
        112.90904689962,
        22.850689558136
    ],
    [
        112.90897440393,
        22.850692333906
    ],
    [
        112.90891705877,
        22.850692066248
    ],
    [
        112.90887811548,
        22.850680665773
    ],
    [
        112.90882511586,
        22.85065631708
    ],
    [
        112.90876752072,
        22.85062837541
    ],
    [
        112.90872859069,
        22.85059907055
    ],
    [
        112.90868048808,
        22.850535729947
    ],
    [
        112.90863483681,
        22.850448283445
    ],
    [
        112.90858729737,
        22.850353214173
    ],
    [
        112.90854598004,
        22.850256605491
    ],
    [
        112.90850950582,
        22.850196953014
    ],
    [
        112.90846761717,
        22.850144273888
    ],
    [
        112.90842112992,
        22.850092341165
    ],
    [
        112.90839355731,
        22.850068346111
    ],
    [
        112.90834191146,
        22.850045358769
    ],
    [
        112.90829188946,
        22.850021308571
    ],
    [
        112.90822781808,
        22.849975083125
    ],
    [
        112.90817645128,
        22.849940703397
    ],
    [
        112.90813699878,
        22.849886695911
    ],
    [
        112.90808430507,
        22.849815135329
    ],
    [
        112.90804297707,
        22.849734788778
    ],
    [
        112.90801515582,
        22.8496793213
    ],
    [
        112.90794650066,
        22.849613761362
    ],
    [
        112.90788595664,
        22.849552929188
    ],
    [
        112.90785920207,
        22.849520529899
    ],
    [
        112.90784515849,
        22.849489402432
    ],
    [
        112.9078438339,
        22.849447341658
    ],
    [
        112.90785874885,
        22.849387347343
    ],
    [
        112.90788694676,
        22.849280895993
    ],
    [
        112.9079237798,
        22.849204406792
    ],
    [
        112.90795089681,
        22.849095497352
    ],
    [
        112.9079806927,
        22.849026226999
    ],
    [
        112.90798369455,
        22.84898450082
    ],
    [
        112.90797940049,
        22.848932089518
    ],
    [
        112.90796915746,
        22.848877421074
    ],
    [
        112.90794244082,
        22.848783181684
    ],
    [
        112.90791029879,
        22.848714087032
    ],
    [
        112.9078665134,
        22.848666248076
    ],
    [
        112.90781920622,
        22.848627849422
    ],
    [
        112.90777648486,
        22.848609046282
    ],
    [
        112.90771239277,
        22.848597520635
    ],
    [
        112.90764721085,
        22.848599538478
    ],
    [
        112.907580123,
        22.848622682181
    ],
    [
        112.90753467754,
        22.848636923948
    ],
    [
        112.90750898695,
        22.84863274392
    ],
    [
        112.90747762659,
        22.848613018528
    ],
    [
        112.90743464507,
        22.8485800997
    ],
    [
        112.90738626734,
        22.84852675647
    ],
    [
        112.90727950591,
        22.848419644882
    ],
    [
        112.90722330762,
        22.848330376919
    ],
    [
        112.90718385679,
        22.848274179367
    ],
    [
        112.9071695474,
        22.848234363153
    ],
    [
        112.90715445092,
        22.848154391909
    ],
    [
        112.90712774519,
        22.848040883121
    ],
    [
        112.90711322715,
        22.847896636926
    ],
    [
        112.90709004506,
        22.847767720065
    ],
    [
        112.90708279868,
        22.847672677294
    ],
    [
        112.90706363118,
        22.847614342492
    ],
    [
        112.90704337586,
        22.847566298062
    ],
    [
        112.90702256663,
        22.847540757794
    ],
    [
        112.906994714,
        22.847535995871
    ],
    [
        112.90696360837,
        22.84754474611
    ],
    [
        112.90688949244,
        22.847572099906
    ],
    [
        112.90680915092,
        22.847609934369
    ],
    [
        112.90675503815,
        22.847654405075
    ],
    [
        112.90670389334,
        22.847710854245
    ],
    [
        112.90665597624,
        22.847797187752
    ],
    [
        112.90662346925,
        22.847890808742
    ],
    [
        112.90660260877,
        22.847953686926
    ],
    [
        112.90656985376,
        22.848009058728
    ],
    [
        112.90652682009,
        22.848068340427
    ],
    [
        112.90648732189,
        22.848094584787
    ],
    [
        112.90646784253,
        22.848108931414
    ],
    [
        112.90641997299,
        22.848115787645
    ],
    [
        112.90636399152,
        22.848121703682
    ],
    [
        112.90632262055,
        22.848115367612
    ],
    [
        112.90627665996,
        22.84809675394
    ],
    [
        112.90620610114,
        22.84806175431
    ],
    [
        112.9061739441,
        22.848023552551
    ],
    [
        112.90613232514,
        22.847980863224
    ],
    [
        112.90608667307,
        22.847899323278
    ],
    [
        112.90605752813,
        22.847797697128
    ],
    [
        112.90603080765,
        22.847711297689
    ],
    [
        112.90600568886,
        22.847660183837
    ],
    [
        112.90597380783,
        22.847612218785
    ],
    [
        112.90591651195,
        22.847557345545
    ],
    [
        112.90587542485,
        22.847530391403
    ],
    [
        112.90576946886,
        22.847452237907
    ],
    [
        112.90569216691,
        22.847391348125
    ],
    [
        112.90561000777,
        22.847313290936
    ],
    [
        112.90555649298,
        22.847268504106
    ],
    [
        112.90550650683,
        22.84720017415
    ],
    [
        112.90545786404,
        22.847147325033
    ],
    [
        112.90545707983,
        22.847099032013
    ],
    [
        112.90545062992,
        22.847027593727
    ],
    [
        112.90545174858,
        22.84696061532
    ],
    [
        112.90544989427,
        22.846890606064
    ],
    [
        112.9054482897,
        22.846858031828
    ],
    [
        112.90543370356,
        22.84682959137
    ],
    [
        112.9054112683,
        22.846814859385
    ],
    [
        112.9053615179,
        22.846808915034
    ],
    [
        112.90531662848,
        22.846814710375
    ],
    [
        112.90521737154,
        22.846853271213
    ],
    [
        112.90511866788,
        22.846870408879
    ],
    [
        112.90506053021,
        22.846875987374
    ],
    [
        112.90500592273,
        22.846854497185
    ],
    [
        112.90495184676,
        22.84685037368
    ],
    [
        112.9048718108,
        22.846851527061
    ],
    [
        112.9047782579,
        22.846849204844
    ],
    [
        112.90466388494,
        22.846848983389
    ],
    [
        112.9045784386,
        22.846858448377
    ],
    [
        112.90448731013,
        22.846876497866
    ],
    [
        112.90442241237,
        22.84688846161
    ],
    [
        112.90434642223,
        22.846913533624
    ],
    [
        112.90429800632,
        22.846946919768
    ],
    [
        112.90425175681,
        22.846974373169
    ],
    [
        112.90423254079,
        22.847009320168
    ],
    [
        112.90422712761,
        22.84701953875
    ],
    [
        112.90423684732,
        22.847044380472
    ],
    [
        112.90428522758,
        22.847075007377
    ],
    [
        112.9043874027,
        22.84712441225
    ],
    [
        112.90455525663,
        22.847217464479
    ],
    [
        112.90464417443,
        22.847285088367
    ],
    [
        112.9047460709,
        22.847353190098
    ],
    [
        112.90480768585,
        22.847411416129
    ],
    [
        112.90487064009,
        22.84749190375
    ],
    [
        112.90493465214,
        22.847613363712
    ],
    [
        112.90501567452,
        22.847775780616
    ],
    [
        112.90507590245,
        22.847893649829
    ],
    [
        112.90509694695,
        22.847971289604
    ],
    [
        112.90513013766,
        22.848084384357
    ],
    [
        112.90515520312,
        22.848218776341
    ],
    [
        112.90516914773,
        22.848408322404
    ],
    [
        112.90515718069,
        22.848520965348
    ],
    [
        112.90515579009,
        22.848583056164
    ],
    [
        112.90515439848,
        22.848646503111
    ],
    [
        112.90516681394,
        22.848682775978
    ],
    [
        112.9051824768,
        22.848714760895
    ],
    [
        112.90522031073,
        22.848748998393
    ],
    [
        112.90529679223,
        22.848813958483
    ],
    [
        112.9053865156,
        22.848891603435
    ],
    [
        112.90547379417,
        22.848987378932
    ],
    [
        112.90554322984,
        22.849077715305
    ],
    [
        112.90565777809,
        22.849237926637
    ],
    [
        112.90571827811,
        22.849347102992
    ],
    [
        112.90575472197,
        22.849440438883
    ],
    [
        112.90575708838,
        22.849542188876
    ],
    [
        112.90574621604,
        22.849626371487
    ],
    [
        112.90573049027,
        22.849689321352
    ],
    [
        112.90568148612,
        22.849779141155
    ],
    [
        112.90564816911,
        22.849863511596
    ],
    [
        112.90561942144,
        22.849988096171
    ],
    [
        112.90563502416,
        22.850106328864
    ],
    [
        112.90564517997,
        22.8502798068
    ],
    [
        112.90566621251,
        22.850365034393
    ],
    [
        112.90567376057,
        22.85039851501
    ],
    [
        112.90568915318,
        22.850428050792
    ],
    [
        112.90571779583,
        22.850457523989
    ],
    [
        112.9057772605,
        22.850493720083
    ],
    [
        112.90587727818,
        22.850542756376
    ],
    [
        112.90592538805,
        22.850576329385
    ],
    [
        112.90597943642,
        22.850625183198
    ],
    [
        112.90605428275,
        22.850708264244
    ],
    [
        112.90612262194,
        22.850815652215
    ],
    [
        112.90619854331,
        22.850908509326
    ],
    [
        112.90625610258,
        22.850964734047
    ],
    [
        112.90631286858,
        22.850996262926
    ],
    [
        112.9063907154,
        22.85104520364
    ],
    [
        112.90649153325,
        22.851115922673
    ],
    [
        112.90660994268,
        22.851169005723
    ],
    [
        112.9067605117,
        22.851254036306
    ],
    [
        112.90682294767,
        22.851301369435
    ],
    [
        112.90689646322,
        22.8513605321
    ],
    [
        112.90693185499,
        22.851409077797
    ],
    [
        112.90694777415,
        22.851458954672
    ],
    [
        112.90695531552,
        22.85150083858
    ],
    [
        112.90693688566,
        22.851554804709
    ],
    [
        112.9069255201,
        22.85156439632
    ],
    [
        112.90689115869,
        22.851585572312
    ],
    [
        112.90683760846,
        22.851590452878
    ],
    [
        112.90674834538,
        22.851616485046
    ],
    [
        112.90661743546,
        22.851644044667
    ],
    [
        112.90651951696,
        22.851674816408
    ],
    [
        112.90642726706,
        22.851720588748
    ],
    [
        112.90635368647,
        22.851753898146
    ],
    [
        112.90628902245,
        22.851797649938
    ],
    [
        112.90622354525,
        22.851844370692
    ],
    [
        112.90616944589,
        22.851864685963
    ],
    [
        112.90611886524,
        22.851880986264
    ],
    [
        112.90608181453,
        22.851885562295
    ],
    [
        112.9060290814,
        22.851887994289
    ],
    [
        112.90595850648,
        22.851883365227
    ],
    [
        112.90585873231,
        22.851872308949
    ],
    [
        112.9057703159,
        22.851861698175
    ],
    [
        112.90567567127,
        22.851863733544
    ],
    [
        112.9055574961,
        22.851873800977
    ],
    [
        112.90541038826,
        22.851885030419
    ],
    [
        112.90529005732,
        22.851888811891
    ],
    [
        112.9051989364,
        22.851884645936
    ],
    [
        112.9051013227,
        22.851885797184
    ],
    [
        112.90506428794,
        22.85187354104
    ],
    [
        112.9050023789,
        22.851858986566
    ],
    [
        112.90493776751,
        22.851842759717
    ],
    [
        112.90484207757,
        22.851805417064
    ],
    [
        112.90475017226,
        22.851770030507
    ],
    [
        112.90467476413,
        22.851730567964
    ],
    [
        112.90462070733,
        22.851703654581
    ],
    [
        112.9045588077,
        22.851679325103
    ],
    [
        112.90450473534,
        22.851673836191
    ],
    [
        112.90447281389,
        22.851695829405
    ],
    [
        112.90446469586,
        22.851704647973
    ],
    [
        112.90444925408,
        22.851744810013
    ],
    [
        112.90445680124,
        22.85177612419
    ],
    [
        112.90449054052,
        22.851853701958
    ],
    [
        112.90457886879,
        22.851968509944
    ],
    [
        112.9046169292,
        22.852052394323
    ],
    [
        112.90464875825,
        22.852152450933
    ],
    [
        112.90465708837,
        22.852220121774
    ],
    [
        112.90467734057,
        22.852254895605
    ],
    [
        112.90472272396,
        22.85230879037
    ],
    [
        112.90475351944,
        22.852345903798
    ],
    [
        112.90482054421,
        22.85238658481
    ],
    [
        112.90491515042,
        22.852425538063
    ],
    [
        112.90501597036,
        22.852472181831
    ],
    [
        112.90510786246,
        22.852526001717
    ],
    [
        112.90518325968,
        22.852581453223
    ],
    [
        112.90523486678,
        22.852631098305
    ],
    [
        112.9053048399,
        22.852707886423
    ],
    [
        112.90539559883,
        22.852829484161
    ],
    [
        112.90554581904,
        22.852986194748
    ],
    [
        112.90559958597,
        22.853041290485
    ],
    [
        112.90562821177,
        22.853088122521
    ],
    [
        112.90564495106,
        22.853120662805
    ],
    [
        112.90566841747,
        22.853194535581
    ],
    [
        112.90567132494,
        22.85327811932
    ],
    [
        112.90566451641,
        22.853338224271
    ],
    [
        112.90564366667,
        22.853373425978
    ],
    [
        112.90560902177,
        22.853414105348
    ],
    [
        112.90555029074,
        22.853479627249
    ],
    [
        112.90542341018,
        22.853555186859
    ],
    [
        112.90533927946,
        22.853599415594
    ],
    [
        112.90527597787,
        22.853633938077
    ],
    [
        112.90522187816,
        22.853658570413
    ],
    [
        112.90516752511,
        22.853662584295
    ],
    [
        112.90512615221,
        22.853665448565
    ],
    [
        112.90503530465,
        22.85365938235
    ],
    [
        112.90495582645,
        22.853638306854
    ],
    [
        112.90484093615,
        22.8536068942
    ],
    [
        112.90473765504,
        22.853598175683
    ],
    [
        112.90465925184,
        22.853587414781
    ],
    [
        112.90454975436,
        22.85357750314
    ],
    [
        112.90444350894,
        22.853559503016
    ],
    [
        112.90436402492,
        22.853550071765
    ],
    [
        112.90431969641,
        22.853533346449
    ],
    [
        112.90425995147,
        22.853522877977
    ],
    [
        112.90422156555,
        22.853513571246
    ],
    [
        112.90419751055,
        22.853503142367
    ],
    [
        112.90415943232,
        22.853448002497
    ],
    [
        112.90408028255,
        22.853361539958
    ],
    [
        112.90402221128,
        22.853288440317
    ],
    [
        112.90395360966,
        22.853197807678
    ],
    [
        112.9038833714,
        22.853125318562
    ],
    [
        112.90383880999,
        22.853063286652
    ],
    [
        112.90380396726,
        22.853019586668
    ],
    [
        112.90375262893,
        22.852979953391
    ],
    [
        112.90370291485,
        22.852937905002
    ],
    [
        112.90364373929,
        22.852894342945
    ],
    [
        112.90355376043,
        22.852828028122
    ],
    [
        112.90345944899,
        22.852770860259
    ],
    [
        112.90334190573,
        22.852689976811
    ],
    [
        112.90323436307,
        22.852613324184
    ],
    [
        112.90314790253,
        22.852544614813
    ],
    [
        112.90303982142,
        22.852466318994
    ],
    [
        112.90297388863,
        22.852423172965
    ],
    [
        112.90294768387,
        22.85239805137
    ],
    [
        112.902889599,
        22.852345271097
    ],
    [
        112.90282232975,
        22.852282842237
    ],
    [
        112.90276479247,
        22.852221389591
    ],
    [
        112.90270428749,
        22.852152020241
    ],
    [
        112.90264325304,
        22.852067994453
    ],
    [
        112.90258004263,
        22.852001289413
    ],
    [
        112.90252817866,
        22.851945353043
    ],
    [
        112.9024703787,
        22.851874126524
    ],
    [
        112.90238151515,
        22.851768468723
    ],
    [
        112.90233209879,
        22.851693313522
    ],
    [
        112.90226322308,
        22.851611046293
    ],
    [
        112.90220190614,
        22.851543281444
    ],
    [
        112.90213031828,
        22.851472899594
    ],
    [
        112.90202712137,
        22.851374854347
    ],
    [
        112.90198715244,
        22.851319112721
    ],
    [
        112.90192771711,
        22.85126629297
    ],
    [
        112.9018564033,
        22.851191299489
    ],
    [
        112.90177211841,
        22.851109573051
    ],
    [
        112.90168377888,
        22.85102750401
    ],
    [
        112.9016286535,
        22.85099645195
    ],
    [
        112.90162757787,
        22.850988567793
    ],
    [
        112.90160920081,
        22.850980929209
    ],
    [
        112.90156325166,
        22.850970918515
    ],
    [
        112.9015102602,
        22.85098004369
    ],
    [
        112.90143400117,
        22.85101589105
    ],
    [
        112.90133798581,
        22.851082859498
    ],
    [
        112.90127306686,
        22.851138156652
    ],
    [
        112.90120218739,
        22.851211793631
    ],
    [
        112.9011018155,
        22.851322078433
    ],
    [
        112.90101443686,
        22.851408446211
    ],
    [
        112.90091110275,
        22.851503486484
    ],
    [
        112.90084294396,
        22.85155383898
    ],
    [
        112.90074854679,
        22.851627332124
    ],
    [
        112.90066306252,
        22.851711284989
    ],
    [
        112.90056595183,
        22.85179883132
    ],
    [
        112.90049291752,
        22.851862655502
    ],
    [
        112.90038471072,
        22.851967635021
    ],
    [
        112.90028976193,
        22.852056298603
    ],
    [
        112.90020509771,
        22.852128595104
    ],
    [
        112.90012312771,
        22.852212600206
    ],
    [
        112.90006306792,
        22.852277458809
    ],
    [
        112.89999056544,
        22.852352948166
    ],
    [
        112.89993294469,
        22.852409711193
    ],
    [
        112.89985637085,
        22.852506554594
    ],
    [
        112.89975979131,
        22.852606572108
    ],
    [
        112.89967158122,
        22.852719482696
    ],
    [
        112.8995847428,
        22.852806649451
    ],
    [
        112.89955687724,
        22.85283653744
    ],
    [
        112.89950851581,
        22.852806123751
    ],
    [
        112.89947150277,
        22.852781605035
    ],
    [
        112.89944799945,
        22.852764375629
    ],
    [
        112.89939341405,
        22.852742802186
    ],
    [
        112.89934261084,
        22.852724007167
    ],
    [
        112.89928045108,
        22.852709893925
    ],
    [
        112.89924639235,
        22.852709836567
    ],
    [
        112.8991871935,
        22.852711777146
    ],
    [
        112.89914149858,
        22.852728330396
    ],
    [
        112.8990744609,
        22.852730403155
    ],
    [
        112.89905445638,
        22.852732762614
    ],
    [
        112.89902283783,
        22.85272352556
    ],
    [
        112.89899473109,
        22.852717062632
    ],
    [
        112.89895608815,
        22.852703361718
    ],
    [
        112.89890096494,
        22.852679062985
    ],
    [
        112.898872323,
        22.852665809492
    ],
    [
        112.89883802156,
        22.852631028913
    ],
    [
        112.89880182694,
        22.852597570884
    ],
    [
        112.89877321429,
        22.85254688808
    ],
    [
        112.89874459967,
        22.852498646189
    ],
    [
        112.8987170567,
        22.852462628417
    ],
    [
        112.89866871511,
        22.852407528034
    ],
    [
        112.8986360431,
        22.852362739991
    ],
    [
        112.89859445093,
        22.852318065254
    ],
    [
        112.89856284872,
        22.852287942216
    ],
    [
        112.89852341221,
        22.852251984621
    ],
    [
        112.89846234926,
        22.852218898768
    ],
    [
        112.8984158758,
        22.852194750236
    ],
    [
        112.89836589181,
        22.852166199656
    ],
    [
        112.89826484063,
        22.8521117909
    ],
    [
        112.89818378387,
        22.852067771208
    ],
    [
        112.89811164469,
        22.852026892635
    ],
    [
        112.89802625932,
        22.851987948488
    ],
    [
        112.89792763258,
        22.851944700352
    ],
    [
        112.89783980562,
        22.851917645803
    ],
    [
        112.89778737516,
        22.851907493086
    ],
    [
        112.89770143792,
        22.851883726065
    ],
    [
        112.89764711548,
        22.851873539296
    ],
    [
        112.89759603558,
        22.851864766124
    ],
    [
        112.89754846051,
        22.851867989193
    ],
    [
        112.89751007961,
        22.851865950962
    ],
    [
        112.89748630369,
        22.851852238149
    ],
    [
        112.897453332,
        22.85184595628
    ],
    [
        112.89742658387,
        22.851830834419
    ],
    [
        112.89740578305,
        22.851814733334
    ],
    [
        112.8973874202,
        22.851791623601
    ],
    [
        112.89736689743,
        22.851765220694
    ],
    [
        112.89733258164,
        22.851749150482
    ],
    [
        112.89727529325,
        22.851729416965
    ],
    [
        112.89721394474,
        22.851717205549
    ],
    [
        112.89714071104,
        22.851694475871
    ],
    [
        112.89707314152,
        22.851687849345
    ],
    [
        112.8969920565,
        22.851682067161
    ],
    [
        112.89690799625,
        22.851678944183
    ],
    [
        112.89682582624,
        22.851678295774
    ],
    [
        112.89676149015,
        22.851685287826
    ],
    [
        112.89667147208,
        22.85169724739
    ],
    [
        112.89658470284,
        22.851702212736
    ],
    [
        112.89648252767,
        22.851705818967
    ],
    [
        112.89640791288,
        22.851722663482
    ],
    [
        112.8962711276,
        22.851742198893
    ],
    [
        112.89621489295,
        22.851759099373
    ],
    [
        112.89613677859,
        22.851756895746
    ],
    [
        112.89607514723,
        22.851761495002
    ],
    [
        112.89594675502,
        22.851762465641
    ],
    [
        112.89585431004,
        22.851766517135
    ],
    [
        112.89577051913,
        22.851764484521
    ],
    [
        112.89569943797,
        22.851754812482
    ],
    [
        112.89563619306,
        22.85174826348
    ],
    [
        112.89556051414,
        22.851742036106
    ],
    [
        112.89552754038,
        22.851738466534
    ],
    [
        112.89551429735,
        22.851736332572
    ],
    [
        112.89547887599,
        22.851752519345
    ],
    [
        112.89544560488,
        22.85178474693
    ],
    [
        112.89541961527,
        22.851838802292
    ],
    [
        112.89536900845,
        22.85191900083
    ],
    [
        112.895342176,
        22.852014539344
    ],
    [
        112.89532778909,
        22.852094296377
    ],
    [
        112.89532580631,
        22.852212245724
    ],
    [
        112.89532818032,
        22.852288231929
    ],
    [
        112.8953294485,
        22.85239566096
    ],
    [
        112.89533859189,
        22.852455764841
    ],
    [
        112.89537205859,
        22.852520369192
    ],
    [
        112.89540063342,
        22.852618518957
    ],
    [
        112.89543164399,
        22.852712372336
    ],
    [
        112.89546883881,
        22.852847019758
    ],
    [
        112.89549092997,
        22.852939358472
    ],
    [
        112.89550327134,
        22.85305512067
    ],
    [
        112.89550474061,
        22.853245005795
    ],
    [
        112.89550464063,
        22.853368683485
    ],
    [
        112.89551357071,
        22.853687533367
    ],
    [
        112.89553280589,
        22.853961813535
    ],
    [
        112.89554094727,
        22.85424701635
    ],
    [
        112.89553736829,
        22.854324523185
    ],
    [
        112.89552274474,
        22.854357081542
    ],
    [
        112.89547786204,
        22.854372557441
    ],
    [
        112.89541569983,
        22.854364672295
    ],
    [
        112.89529840571,
        22.854345772796
    ],
    [
        112.89522868946,
        22.854320666967
    ],
    [
        112.89511682193,
        22.854276912403
    ],
    [
        112.8950379338,
        22.854229675414
    ],
    [
        112.89495203185,
        22.854165498486
    ],
    [
        112.89488747183,
        22.854115261782
    ],
    [
        112.89483127417,
        22.854085244328
    ],
    [
        112.89475452385,
        22.854066796849
    ],
    [
        112.89461479636,
        22.854044251056
    ],
    [
        112.89448776082,
        22.854036035402
    ],
    [
        112.89435045626,
        22.854024385082
    ],
    [
        112.89416908568,
        22.854019823968
    ],
    [
        112.89402121985,
        22.854030232674
    ],
    [
        112.89388496454,
        22.854055223658
    ],
    [
        112.89378521489,
        22.854062687801
    ],
    [
        112.89368221364,
        22.854079317725
    ],
    [
        112.8935867736,
        22.854104490076
    ],
    [
        112.89352512514,
        22.854125917969
    ],
    [
        112.89345211053,
        22.854162877833
    ],
    [
        112.89338421268,
        22.854222440015
    ],
    [
        112.893249494,
        22.854345653716
    ],
    [
        112.89309124587,
        22.85448201948
    ],
    [
        112.89291592329,
        22.854669081121
    ],
    [
        112.89281366817,
        22.854757883858
    ],
    [
        112.89272791013,
        22.854836940889
    ],
    [
        112.89265271694,
        22.854889332179
    ],
    [
        112.89258646506,
        22.854917198843
    ],
    [
        112.8925253814,
        22.854907456135
    ],
    [
        112.89244755991,
        22.854871927981
    ],
    [
        112.89231274888,
        22.854779810222
    ],
    [
        112.89214308328,
        22.854666479044
    ],
    [
        112.89198586098,
        22.854541435231
    ],
    [
        112.89190940619,
        22.854485597596
    ],
    [
        112.89186024402,
        22.854441623814
    ],
    [
        112.8918064855,
        22.854398384946
    ],
    [
        112.89174055328,
        22.854365514654
    ],
    [
        112.89167110272,
        22.854337195606
    ],
    [
        112.89155488979,
        22.854302920178
    ],
    [
        112.89147596545,
        22.854288273976
    ],
    [
        112.89138352937,
        22.854267430593
    ],
    [
        112.89129406785,
        22.854245012941
    ],
    [
        112.89123271648,
        22.854227689081
    ],
    [
        112.8911878647,
        22.854199256852
    ],
    [
        112.89112680716,
        22.854153461042
    ],
    [
        112.89104577119,
        22.85407559188
    ],
    [
        112.89098799769,
        22.853981033733
    ],
    [
        112.89090942138,
        22.853869848632
    ],
    [
        112.8908259615,
        22.853778924041
    ],
    [
        112.89075791046,
        22.853687991789
    ],
    [
        112.89065499802,
        22.853580738397
    ],
    [
        112.89054908872,
        22.853500559859
    ],
    [
        112.89042941601,
        22.853389503454
    ],
    [
        112.89034268587,
        22.853326200029
    ],
    [
        112.89029702419,
        22.853292611863
    ],
    [
        112.89025219334,
        22.853234356685
    ],
    [
        112.89017737647,
        22.853147390174
    ],
    [
        112.89009149843,
        22.853030675887
    ],
    [
        112.8900291213,
        22.852937683336
    ],
    [
        112.88994322052,
        22.852847552778
    ],
    [
        112.88987352187,
        22.852780749691
    ],
    [
        112.8898113785,
        22.852731975307
    ],
    [
        112.88975434044,
        22.852722615305
    ],
    [
        112.88968891771,
        22.852717456312
    ],
    [
        112.88965511182,
        22.852731268384
    ],
    [
        112.88960398667,
        22.852765406031
    ],
    [
        112.88952928922,
        22.852863162644
    ],
    [
        112.88945349531,
        22.852978803874
    ],
    [
        112.88939498142,
        22.853122398212
    ],
    [
        112.88937384712,
        22.853179277134
    ],
    [
        112.88936101368,
        22.853335291212
    ],
    [
        112.88934952659,
        22.85349702322
    ],
    [
        112.88932015811,
        22.853702940432
    ],
    [
        112.88931060248,
        22.853815341116
    ],
    [
        112.88927970354,
        22.853908403289
    ],
    [
        112.88925123392,
        22.854005845454
    ],
    [
        112.88923005492,
        22.854113985937
    ],
    [
        112.88921805857,
        22.854233398223
    ],
    [
        112.88918982019,
        22.854375867936
    ],
    [
        112.88916291038,
        22.854544939706
    ],
    [
        112.88916341858,
        22.854583190725
    ],
    [
        112.88916771509,
        22.854617707031
    ],
    [
        112.88924039158,
        22.854679388811
    ],
    [
        112.8892725477,
        22.854699990395
    ],
    [
        112.88931954839,
        22.854750401186
    ],
    [
        112.889368406,
        22.854842069524
    ],
    [
        112.88942886205,
        22.854964850353
    ],
    [
        112.88949742302,
        22.855093733772
    ],
    [
        112.88955951466,
        22.855199457192
    ],
    [
        112.88960591957,
        22.855311159043
    ],
    [
        112.88965177022,
        22.855437769598
    ],
    [
        112.88968303276,
        22.855550847799
    ],
    [
        112.88972811216,
        22.855631067397
    ],
    [
        112.88980101589,
        22.855736433348
    ],
    [
        112.88984256192,
        22.855836937266
    ],
    [
        112.88988573209,
        22.855934756629
    ],
    [
        112.88989237901,
        22.856060443794
    ],
    [
        112.88991095692,
        22.856146189612
    ],
    [
        112.88994894243,
        22.856296268825
    ],
    [
        112.88999424385,
        22.856427485453
    ],
    [
        112.89003283088,
        22.856508956457
    ],
    [
        112.89004571482,
        22.856611694369
    ],
    [
        112.8900458306,
        22.856781752229
    ],
    [
        112.89003493647,
        22.856869445235
    ],
    [
        112.89001022077,
        22.856993521376
    ],
    [
        112.88999202472,
        22.857083261812
    ],
    [
        112.88999817645,
        22.857155509704
    ],
    [
        112.89000969128,
        22.857275311138
    ],
    [
        112.89002775612,
        22.857328230859
    ],
    [
        112.89004419526,
        22.857384920491
    ],
    [
        112.8900646908,
        22.857440322158
    ],
    [
        112.89010032148,
        22.857500588806
    ],
    [
        112.8901753657,
        22.857622814169
    ],
    [
        112.89020989174,
        22.857707473239
    ],
    [
        112.89025899593,
        22.85781407574
    ],
    [
        112.89028645967,
        22.857933604025
    ],
    [
        112.89028694844,
        22.85798894116
    ],
    [
        112.89028420422,
        22.85803229013
    ],
    [
        112.89025713959,
        22.858063838206
    ],
    [
        112.89022927814,
        22.858080184772
    ],
    [
        112.89018763713,
        22.858087620746
    ],
    [
        112.89010573969,
        22.858067258948
    ],
    [
        112.88997195451,
        22.858024874428
    ],
    [
        112.88987924874,
        22.857997014457
    ],
    [
        112.8898100522,
        22.857981212217
    ],
    [
        112.88972708278,
        22.857948637435
    ],
    [
        112.88964088234,
        22.85790136524
    ],
    [
        112.88952822686,
        22.857810260818
    ],
    [
        112.88945693898,
        22.85771604926
    ],
    [
        112.88940242353,
        22.857610725914
    ],
    [
        112.88934601459,
        22.857505914657
    ],
    [
        112.88928612461,
        22.857364160924
    ],
    [
        112.88921297781,
        22.857231139898
    ],
    [
        112.88914606284,
        22.857082763745
    ],
    [
        112.889085861,
        22.856983861779
    ],
    [
        112.88902051696,
        22.85689002978
    ],
    [
        112.88894571615,
        22.856788721172
    ],
    [
        112.88888794262,
        22.856693660311
    ],
    [
        112.88881691965,
        22.856599197562
    ],
    [
        112.88874751514,
        22.85650828895
    ],
    [
        112.88865648494,
        22.856411605166
    ],
    [
        112.88853356615,
        22.856295691795
    ],
    [
        112.88843414097,
        22.856211355421
    ],
    [
        112.8883474177,
        22.856132923952
    ],
    [
        112.88823745035,
        22.856043271377
    ],
    [
        112.88816233773,
        22.855981035622
    ],
    [
        112.88805127068,
        22.855909545308
    ],
    [
        112.88798804809,
        22.855854015081
    ],
    [
        112.88793049152,
        22.855811867078
    ],
    [
        112.8878783528,
        22.855758144473
    ],
    [
        112.88781890285,
        22.855715968813
    ],
    [
        112.88778000494,
        22.855671410068
    ],
    [
        112.88775163935,
        22.855641665797
    ],
    [
        112.88771516967,
        22.855602842464
    ],
    [
        112.88767464628,
        22.855561242978
    ],
    [
        112.88761950358,
        22.855539482446
    ],
    [
        112.88758301171,
        22.85552534205
    ],
    [
        112.88753003247,
        22.855502804261
    ],
    [
        112.88749219973,
        22.855475625331
    ],
    [
        112.88744895714,
        22.855450260042
    ],
    [
        112.88738788082,
        22.855409696769
    ],
    [
        112.8873113946,
        22.855364824015
    ],
    [
        112.88723922698,
        22.855328429593
    ],
    [
        112.8871719222,
        22.855296724526
    ],
    [
        112.88711164978,
        22.855262690573
    ],
    [
        112.88705056647,
        22.855227831883
    ],
    [
        112.88695191348,
        22.85517150466
    ],
    [
        112.88686461416,
        22.855118613017
    ],
    [
        112.88676136761,
        22.855055984732
    ],
    [
        112.88670244738,
        22.855018999402
    ],
    [
        112.8866421871,
        22.854967620124
    ],
    [
        112.88657084629,
        22.854907663765
    ],
    [
        112.8865030125,
        22.854856985319
    ],
    [
        112.88644247925,
        22.854806963553
    ],
    [
        112.8863781647,
        22.854750918641
    ],
    [
        112.88632033651,
        22.854699043245
    ],
    [
        112.88626331226,
        22.854655318429
    ],
    [
        112.88623576039,
        22.854617197813
    ],
    [
        112.88619847906,
        22.854571606237
    ],
    [
        112.88614094054,
        22.854495601252
    ],
    [
        112.88608311982,
        22.854432883552
    ],
    [
        112.88601420794,
        22.85437325413
    ],
    [
        112.8859547689,
        22.854304277356
    ],
    [
        112.88591127214,
        22.854251273929
    ],
    [
        112.88586912572,
        22.854200190354
    ],
    [
        112.88584777992,
        22.854177085807
    ],
    [
        112.88581156217,
        22.854150774188
    ],
    [
        112.88578751109,
        22.854128443249
    ],
    [
        112.88573480818,
        22.854087239102
    ],
    [
        112.8856696766,
        22.854031204043
    ],
    [
        112.88561129599,
        22.85398693467
    ],
    [
        112.88556103075,
        22.853940075834
    ],
    [
        112.88550534464,
        22.85390697002
    ],
    [
        112.88542019198,
        22.853857425776
    ],
    [
        112.88534557551,
        22.853821060071
    ],
    [
        112.88526581588,
        22.853789232118
    ],
    [
        112.88520038886,
        22.853758974722
    ],
    [
        112.8851362982,
        22.853747453751
    ],
    [
        112.88508249124,
        22.853728220261
    ],
    [
        112.88504166115,
        22.853715416544
    ],
    [
        112.88499541438,
        22.853711213693
    ],
    [
        112.88491237986,
        22.853711086066
    ],
    [
        112.88483746456,
        22.853704028318
    ],
    [
        112.88477011563,
        22.853704677628
    ],
    [
        112.88470087175,
        22.85370665811
    ],
    [
        112.88464163277,
        22.853711497837
    ],
    [
        112.88456697318,
        22.853719643399
    ],
    [
        112.88449933808,
        22.853736843283
    ],
    [
        112.88445199207,
        22.853750267931
    ],
    [
        112.8844100649,
        22.853752379881
    ],
    [
        112.88436029682,
        22.853750312461
    ],
    [
        112.88431000027,
        22.853732779062
    ],
    [
        112.88426619583,
        22.853714525747
    ],
    [
        112.88423240598,
        22.853688278999
    ],
    [
        112.88417943282,
        22.853635451984
    ],
    [
        112.88411837008,
        22.853551321206
    ],
    [
        112.88406298575,
        22.853468899976
    ],
    [
        112.88399488463,
        22.8533898274
    ],
    [
        112.88390139681,
        22.8532599534
    ],
    [
        112.88380763737,
        22.8531295381
    ],
    [
        112.88374306497,
        22.853031809932
    ],
    [
        112.88366848171,
        22.852935572493
    ],
    [
        112.88361604221,
        22.852886024565
    ],
    [
        112.88357469734,
        22.852831478308
    ],
    [
        112.88351822184,
        22.85275367
    ],
    [
        112.88346605527,
        22.852699519567
    ],
    [
        112.88338633061,
        22.852600782553
    ],
    [
        112.88334011326,
        22.852548073721
    ],
    [
        112.88330714973,
        22.852497174617
    ],
    [
        112.88326337282,
        22.85243636442
    ],
    [
        112.88321363325,
        22.852389306768
    ],
    [
        112.88319852004,
        22.852342992479
    ],
    [
        112.88315311952,
        22.852281620592
    ],
    [
        112.88312664884,
        22.852228914553
    ],
    [
        112.88308692346,
        22.852174402095
    ],
    [
        112.8830361158,
        22.852107264406
    ],
    [
        112.88298206278,
        22.852038185945
    ],
    [
        112.88292909218,
        22.851968038875
    ],
    [
        112.88287394912,
        22.851907899811
    ],
    [
        112.88282800519,
        22.851845987028
    ],
    [
        112.88277961364,
        22.851800316548
    ],
    [
        112.88270931409,
        22.851746490286
    ],
    [
        112.88266714821,
        22.851695481419
    ],
    [
        112.88260929324,
        22.851640739857
    ],
    [
        112.88254737099,
        22.851597338266
    ],
    [
        112.88248895773,
        22.851564020723
    ],
    [
        112.88247084601,
        22.851543982686
    ],
    [
        112.88243029119,
        22.851507105098
    ],
    [
        112.88236891249,
        22.851458292988
    ],
    [
        112.88232863001,
        22.851418166807
    ],
    [
        112.88227021855,
        22.851379975208
    ],
    [
        112.88223722244,
        22.851364085666
    ],
    [
        112.88219178059,
        22.851348035261
    ],
    [
        112.88214741382,
        22.851341221882
    ],
    [
        112.88210277846,
        22.851331422775
    ],
    [
        112.88204110089,
        22.851316794457
    ],
    [
        112.88197941958,
        22.851306508209
    ],
    [
        112.88187390934,
        22.851291053132
    ],
    [
        112.8817599972,
        22.851292586025
    ],
    [
        112.88167016821,
        22.851289549475
    ],
    [
        112.88154868081,
        22.85128557787
    ],
    [
        112.8814014839,
        22.851284007758
    ],
    [
        112.88126727986,
        22.851272577302
    ],
    [
        112.88112576871,
        22.851259170628
    ],
    [
        112.88099966715,
        22.851261967768
    ],
    [
        112.88091794257,
        22.851265042292
    ],
    [
        112.88087816306,
        22.851265645072
    ],
    [
        112.88083892394,
        22.851267069149
    ],
    [
        112.88079508328,
        22.851269794974
    ],
    [
        112.88073905626,
        22.85128403854
    ],
    [
        112.88067924145,
        22.851296611551
    ],
    [
        112.88063078888,
        22.851313391043
    ],
    [
        112.88057745256,
        22.851346658991
    ],
    [
        112.88049218063,
        22.85138253395
    ],
    [
        112.88042693301,
        22.851419463687
    ],
    [
        112.88035355443,
        22.851471760908
    ],
    [
        112.88027530594,
        22.851521021445
    ],
    [
        112.88021763273,
        22.851559405412
    ],
    [
        112.88016969414,
        22.851607940176
    ],
    [
        112.8801147047,
        22.851674838427
    ],
    [
        112.88008408973,
        22.851718423341
    ],
    [
        112.88004481215,
        22.851764621322
    ],
    [
        112.88002393926,
        22.851808862281
    ],
    [
        112.87999901495,
        22.851842207861
    ],
    [
        112.87997649718,
        22.851913553356
    ],
    [
        112.87995560758,
        22.851978950833
    ],
    [
        112.87994501338,
        22.852029820199
    ],
    [
        112.87994089661,
        22.852103818099
    ],
    [
        112.87993537311,
        22.852246420304
    ],
    [
        112.87994099268,
        22.852328395159
    ],
    [
        112.87995412792,
        22.852489383044
    ],
    [
        112.87997512774,
        22.852629034239
    ],
    [
        112.87997235467,
        22.85271308254
    ],
    [
        112.87998688124,
        22.852823638283
    ],
    [
        112.88000034808,
        22.852905160762
    ],
    [
        112.88001244425,
        22.853008094387
    ],
    [
        112.88002618402,
        22.85308609423
    ],
    [
        112.88004448921,
        22.853207542831
    ],
    [
        112.88007500865,
        22.85328465165
    ],
    [
        112.88009415717,
        22.853366511643
    ],
    [
        112.88011058509,
        22.853465427538
    ],
    [
        112.88012162386,
        22.853535260102
    ],
    [
        112.88015347854,
        22.853632727783
    ],
    [
        112.88017749033,
        22.853723053137
    ],
    [
        112.88018528468,
        22.853788237583
    ],
    [
        112.88019795203,
        22.853851308941
    ],
    [
        112.88020436603,
        22.853948753053
    ],
    [
        112.88020677067,
        22.853985938738
    ],
    [
        112.8801991792,
        22.85400239505
    ],
    [
        112.88018183959,
        22.854025247437
    ],
    [
        112.88015204541,
        22.854054464849
    ],
    [
        112.88010927139,
        22.8540707851
    ],
    [
        112.88007137216,
        22.854082823337
    ],
    [
        112.87999179667,
        22.854091942165
    ],
    [
        112.87990220585,
        22.854101764725
    ],
    [
        112.87980451137,
        22.854091430438
    ],
    [
        112.8797249394,
        22.854092699024
    ],
    [
        112.87965512133,
        22.854080520655
    ],
    [
        112.87962210955,
        22.854070928174
    ],
    [
        112.87959127807,
        22.854043188907
    ],
    [
        112.87955341711,
        22.854006150159
    ],
    [
        112.87950258497,
        22.853944286564
    ],
    [
        112.8794474385,
        22.853862306375
    ],
    [
        112.87940500412,
        22.85379050426
    ],
    [
        112.87935986718,
        22.853713249134
    ],
    [
        112.87929174803,
        22.853605636989
    ],
    [
        112.87926122457,
        22.853530172952
    ],
    [
        112.87923149278,
        22.853479128449
    ],
    [
        112.87920527992,
        22.853427580547
    ],
    [
        112.87918962677,
        22.853371537436
    ],
    [
        112.87913018365,
        22.853242601063
    ],
    [
        112.87909913632,
        22.853143538238
    ],
    [
        112.87905103796,
        22.85304185073
    ],
    [
        112.87902052835,
        22.852946050114
    ],
    [
        112.87899865894,
        22.852876652002
    ],
    [
        112.87898300428,
        22.852820611088
    ],
    [
        112.87896330097,
        22.852749880662
    ],
    [
        112.87895794838,
        22.852673066256
    ],
    [
        112.87895694126,
        22.852577583859
    ],
    [
        112.87895808474,
        22.852500567877
    ],
    [
        112.87897438921,
        22.852419646291
    ],
    [
        112.87900831713,
        22.852300942832
    ],
    [
        112.87902978001,
        22.852199192908
    ],
    [
        112.87903037103,
        22.852135189726
    ],
    [
        112.87902961418,
        22.852063848846
    ],
    [
        112.87902127737,
        22.851993511104
    ],
    [
        112.87901805491,
        22.851960115412
    ],
    [
        112.87899185457,
        22.851887686799
    ],
    [
        112.87895321119,
        22.851804004764
    ],
    [
        112.87890511451,
        22.851692557441
    ],
    [
        112.87887755121,
        22.851631236704
    ],
    [
        112.87887244822,
        22.851578292799
    ],
    [
        112.87886709118,
        22.851503105478
    ],
    [
        112.87885420209,
        22.851364641655
    ],
    [
        112.87885075538,
        22.85126777636
    ],
    [
        112.87884467096,
        22.8510767665
    ],
    [
        112.87882990665,
        22.850908447313
    ],
    [
        112.87881620315,
        22.850768889696
    ],
    [
        112.87879733555,
        22.850657485166
    ],
    [
        112.87878658665,
        22.850548065493
    ],
    [
        112.8787733688,
        22.850483915098
    ],
    [
        112.87875446458,
        22.850422145701
    ],
    [
        112.87873257798,
        22.850366854566
    ],
    [
        112.87871448831,
        22.850301025834
    ],
    [
        112.87868585239,
        22.850219626093
    ],
    [
        112.87867344122,
        22.850161723341
    ],
    [
        112.87865289073,
        22.850130044554
    ],
    [
        112.87863803112,
        22.850089203928
    ],
    [
        112.87859504422,
        22.850012266453
    ],
    [
        112.87855477991,
        22.84991203284
    ],
    [
        112.87850529798,
        22.849830961991
    ],
    [
        112.87843582737,
        22.849685675468
    ],
    [
        112.87838039203,
        22.849599123004
    ],
    [
        112.8783201041,
        22.849481602618
    ],
    [
        112.87827251213,
        22.849403271982
    ],
    [
        112.87822465592,
        22.849314362278
    ],
    [
        112.87816760744,
        22.849206374798
    ],
    [
        112.8781262381,
        22.849130824741
    ],
    [
        112.8780724132,
        22.84905840538
    ],
    [
        112.87803159204,
        22.848970929512
    ],
    [
        112.87796101047,
        22.848853322002
    ],
    [
        112.8779158479,
        22.848778825562
    ],
    [
        112.8778782572,
        22.848716611198
    ],
    [
        112.87784527211,
        22.848648747509
    ],
    [
        112.87781146133,
        22.848601490269
    ],
    [
        112.87778415586,
        22.848541549882
    ],
    [
        112.87774656807,
        22.848472558425
    ],
    [
        112.87773089435,
        22.84842710867
    ],
    [
        112.87770601172,
        22.848387807414
    ],
    [
        112.87768927012,
        22.848317936593
    ],
    [
        112.87767658656,
        22.84825244528
    ],
    [
        112.8776603723,
        22.848204549924
    ],
    [
        112.87763850386,
        22.848105878828
    ],
    [
        112.87761716724,
        22.848022131127
    ],
    [
        112.87760124596,
        22.847936808801
    ],
    [
        112.87757909064,
        22.847862546928
    ],
    [
        112.87757669016,
        22.847802851869
    ],
    [
        112.8775696953,
        22.847729279323
    ],
    [
        112.87757002422,
        22.847632180036
    ],
    [
        112.8775684558,
        22.847538045923
    ],
    [
        112.87756096296,
        22.847389064693
    ],
    [
        112.87756538318,
        22.84723748605
    ],
    [
        112.87756278337,
        22.847050578507
    ],
    [
        112.87755472604,
        22.846936580905
    ],
    [
        112.87755561161,
        22.846806395308
    ],
    [
        112.8775510589,
        22.846717114019
    ],
    [
        112.87754837307,
        22.846678301026
    ],
    [
        112.87753919528,
        22.846628847094
    ],
    [
        112.87752622957,
        22.84657474565
    ],
    [
        112.87749594106,
        22.846511798062
    ],
    [
        112.87745401283,
        22.846444128558
    ],
    [
        112.87739826689,
        22.846393416632
    ],
    [
        112.87730950195,
        22.846318525159
    ],
    [
        112.87720666056,
        22.846235641773
    ],
    [
        112.87709244361,
        22.846155915836
    ],
    [
        112.87700069829,
        22.846075051003
    ],
    [
        112.87689758253,
        22.84598757914
    ],
    [
        112.87684778267,
        22.845946167907
    ],
    [
        112.8767950085,
        22.845895780795
    ],
    [
        112.87676064745,
        22.845843392053
    ],
    [
        112.87673953402,
        22.845829910877
    ],
    [
        112.87672763661,
        22.845797526154
    ],
    [
        112.87672522207,
        22.845753834734
    ],
    [
        112.87673960304,
        22.845695376284
    ],
    [
        112.87674666441,
        22.845653668878
    ],
    [
        112.87676863244,
        22.84558388702
    ],
    [
        112.87682879021,
        22.84549166749
    ],
    [
        112.8768572529,
        22.845427913392
    ],
    [
        112.87690440714,
        22.845346157469
    ],
    [
        112.87694641432,
        22.845268153406
    ],
    [
        112.87696592909,
        22.84522791761
    ],
    [
        112.87699465479,
        22.845177188506
    ],
    [
        112.87700604639,
        22.84513687848
    ],
    [
        112.87701961624,
        22.845071091899
    ],
    [
        112.87705243593,
        22.84495069258
    ],
    [
        112.87707442121,
        22.844836974487
    ],
    [
        112.87708691541,
        22.844753005198
    ],
    [
        112.8770880354,
        22.844673270159
    ],
    [
        112.87709429762,
        22.844597651489
    ],
    [
        112.87707890592,
        22.844506370763
    ],
    [
        112.87706621003,
        22.844440340804
    ],
    [
        112.87704701906,
        22.844366655974
    ],
    [
        112.87702510607,
        22.844324681789
    ],
    [
        112.87699236158,
        22.844284506855
    ],
    [
        112.87696394715,
        22.844248712451
    ],
    [
        112.87693064993,
        22.844232946006
    ],
    [
        112.87687325662,
        22.844211535656
    ],
    [
        112.87677281334,
        22.844182414606
    ],
    [
        112.87666749393,
        22.844154342981
    ],
    [
        112.87654268004,
        22.844117699031
    ],
    [
        112.87639999363,
        22.84407602904
    ],
    [
        112.87626786502,
        22.84403392413
    ],
    [
        112.87613817287,
        22.843986700559
    ],
    [
        112.87609485361,
        22.843965446361
    ],
    [
        112.87604746731,
        22.843955009132
    ],
    [
        112.87600116526,
        22.843941327924
    ],
    [
        112.87595675225,
        22.843942311511
    ],
    [
        112.87589068075,
        22.843927384182
    ],
    [
        112.8758427512,
        22.843916950412
    ],
    [
        112.8757728855,
        22.843905524283
    ],
    [
        112.87570627835,
        22.843871615462
    ],
    [
        112.87564453708,
        22.843857008177
    ],
    [
        112.87558415774,
        22.843822342901
    ],
    [
        112.87553542129,
        22.843792656416
    ],
    [
        112.87547829557,
        22.843746359001
    ],
    [
        112.87543389292,
        22.843713185002
    ],
    [
        112.87541819589,
        22.843685935954
    ],
    [
        112.87538165093,
        22.843643061336
    ],
    [
        112.87534620607,
        22.843558424634
    ],
    [
        112.87531427322,
        22.843494431132
    ],
    [
        112.87528613761,
        22.843415820826
    ],
    [
        112.87523877532,
        22.843328381596
    ],
    [
        112.87522497871,
        22.843287044953
    ],
    [
        112.87521714392,
        22.843237074797
    ],
    [
        112.87521337776,
        22.843171403899
    ],
    [
        112.87521043591,
        22.843074545961
    ],
    [
        112.87520208146,
        22.842965168636
    ],
    [
        112.8752080943,
        22.842820369068
    ],
    [
        112.87520786563,
        22.842705900719
    ],
    [
        112.87520490326,
        22.842659494354
    ],
    [
        112.87519706002,
        22.842628511335
    ],
    [
        112.87518975763,
        22.842599702527
    ],
    [
        112.87518001438,
        22.84257982609
    ],
    [
        112.87514021555,
        22.842536662043
    ],
    [
        112.8750852605,
        22.842460562253
    ],
    [
        112.87504085926,
        22.842408957594
    ],
    [
        112.87499483132,
        22.842360597243
    ],
    [
        112.87495124545,
        22.842298152103
    ],
    [
        112.87492309508,
        22.842243961813
    ],
    [
        112.87488980062,
        22.84218240994
    ],
    [
        112.87487167058,
        22.842130737063
    ],
    [
        112.87485598566,
        22.842056297689
    ],
    [
        112.87482513531,
        22.841972523256
    ],
    [
        112.8748118876,
        22.841897559954
    ],
    [
        112.87480134461,
        22.841833738036
    ],
    [
        112.87478863572,
        22.841766102646
    ],
    [
        112.87479245043,
        22.841694520722
    ],
    [
        112.87479950134,
        22.841667447841
    ],
    [
        112.87481224189,
        22.841635263407
    ],
    [
        112.8748282363,
        22.841591439478
    ],
    [
        112.87485289622,
        22.841553647791
    ],
    [
        112.87485832486,
        22.841516255597
    ],
    [
        112.87485183654,
        22.841475790825
    ],
    [
        112.87484480674,
        22.841434237036
    ],
    [
        112.87480717181,
        22.841385132278
    ],
    [
        112.87475409731,
        22.841335914871
    ],
    [
        112.87470454083,
        22.841295676898
    ],
    [
        112.87464496211,
        22.841254011803
    ],
    [
        112.87459079784,
        22.841220255134
    ],
    [
        112.87450196826,
        22.841161297356
    ],
    [
        112.87444915549,
        22.841132439404
    ],
    [
        112.8743744007,
        22.841103971606
    ],
    [
        112.87428230833,
        22.841075116478
    ],
    [
        112.87421567484,
        22.841057836756
    ],
    [
        112.87416691718,
        22.841048549728
    ],
    [
        112.87407779617,
        22.841037905068
    ],
    [
        112.8739808186,
        22.841023959524
    ],
    [
        112.87383101368,
        22.841006418557
    ],
    [
        112.87368797314,
        22.841005215775
    ],
    [
        112.87355955755,
        22.841008192155
    ],
    [
        112.87337126405,
        22.841011082863
    ],
    [
        112.87324148472,
        22.841020867752
    ],
    [
        112.87314936167,
        22.841036045753
    ],
    [
        112.87303827451,
        22.841038641874
    ],
    [
        112.8729662016,
        22.841042288963
    ],
    [
        112.87289358861,
        22.841036172434
    ],
    [
        112.87280986498,
        22.841031896138
    ],
    [
        112.87271503248,
        22.841021324987
    ],
    [
        112.87262643238,
        22.841004286111
    ],
    [
        112.87253972727,
        22.840988620756
    ],
    [
        112.87244299825,
        22.840960430714
    ],
    [
        112.87237390737,
        22.84093185248
    ],
    [
        112.87230725203,
        22.840911971314
    ],
    [
        112.87223436504,
        22.840885551794
    ],
    [
        112.87214142395,
        22.840859034782
    ],
    [
        112.87208289395,
        22.840844904608
    ],
    [
        112.87202381919,
        22.840838641106
    ],
    [
        112.87196528521,
        22.840834553411
    ],
    [
        112.87189401647,
        22.840819827869
    ],
    [
        112.8718249127,
        22.840812983605
    ],
    [
        112.87173439613,
        22.840814722351
    ],
    [
        112.87162002861,
        22.840817442981
    ],
    [
        112.87147910167,
        22.840809205567
    ],
    [
        112.87137936344,
        22.840815000586
    ],
    [
        112.87127257953,
        22.840809924086
    ],
    [
        112.87122758828,
        22.840809459912
    ],
    [
        112.87116254402,
        22.840793994081
    ],
    [
        112.8711045447,
        22.840783443883
    ],
    [
        112.87100372463,
        22.840755090389
    ],
    [
        112.87091645281,
        22.840735480111
    ],
    [
        112.8708318929,
        22.840705308468
    ],
    [
        112.87072646227,
        22.840667197177
    ],
    [
        112.87068119787,
        22.840657531631
    ],
    [
        112.87061452498,
        22.840625274259
    ],
    [
        112.87050746993,
        22.840562493851
    ],
    [
        112.87041206523,
        22.840513598809
    ],
    [
        112.87028115305,
        22.840441805152
    ],
    [
        112.87015701549,
        22.840366523088
    ],
    [
        112.87006892225,
        22.840323107032
    ],
    [
        112.86996619468,
        22.840253340645
    ],
    [
        112.86991659104,
        22.840223349044
    ],
    [
        112.8698455687,
        22.840198177599
    ],
    [
        112.86977048426,
        22.84014994219
    ],
    [
        112.86971491345,
        22.840123468508
    ],
    [
        112.8696541885,
        22.84010729071
    ],
    [
        112.86959563404,
        22.840081357158
    ],
    [
        112.86954683769,
        22.840061692256
    ],
    [
        112.86949695765,
        22.840036601526
    ],
    [
        112.86942348807,
        22.840017418579
    ],
    [
        112.86935110247,
        22.839996073323
    ],
    [
        112.86928576483,
        22.839976649231
    ],
    [
        112.86921527453,
        22.839958572806
    ],
    [
        112.86914478176,
        22.839947282324
    ],
    [
        112.86906669708,
        22.839931638901
    ],
    [
        112.86899864314,
        22.839918193465
    ],
    [
        112.86894387463,
        22.839904509925
    ],
    [
        112.86886931154,
        22.839890787177
    ],
    [
        112.86880315074,
        22.839888208216
    ],
    [
        112.86873943213,
        22.839873974183
    ],
    [
        112.86869469333,
        22.839862764551
    ],
    [
        112.86864940897,
        22.839864575977
    ],
    [
        112.86859083689,
        22.839867449601
    ],
    [
        112.86849864013,
        22.839865926312
    ],
    [
        112.86837471237,
        22.839872766837
    ],
    [
        112.86825566459,
        22.839872576459
    ],
    [
        112.86813607346,
        22.839864803275
    ],
    [
        112.86801159598,
        22.839866802071
    ],
    [
        112.86792860856,
        22.839871849726
    ],
    [
        112.86785836717,
        22.839873392362
    ],
    [
        112.86782690787,
        22.839871999546
    ],
    [
        112.86777754516,
        22.839886863093
    ],
    [
        112.86770974147,
        22.839893843194
    ],
    [
        112.86767610972,
        22.839900861431
    ],
    [
        112.86762864579,
        22.839908138561
    ],
    [
        112.8675971855,
        22.839905124915
    ],
    [
        112.86755270565,
        22.839906169312
    ],
    [
        112.86750578445,
        22.839907213469
    ],
    [
        112.86747676559,
        22.839899051567
    ],
    [
        112.86745046096,
        22.839881127424
    ],
    [
        112.86740381817,
        22.839845556794
    ],
    [
        112.86734280422,
        22.839789633893
    ],
    [
        112.86727202784,
        22.839720687933
    ],
    [
        112.86721345757,
        22.839643615883
    ],
    [
        112.86714105133,
        22.83957549125
    ],
    [
        112.86709603288,
        22.839539120895
    ],
    [
        112.86705399585,
        22.839511705139
    ],
    [
        112.86701168671,
        22.839486732215
    ],
    [
        112.86697235806,
        22.839476138581
    ],
    [
        112.86692109106,
        22.839480733007
    ],
    [
        112.86684432599,
        22.839483967294
    ],
    [
        112.86678139042,
        22.839504841059
    ],
    [
        112.8666772208,
        22.83953303832
    ],
    [
        112.86659312446,
        22.839553650329
    ],
    [
        112.86647348692,
        22.839589733775
    ],
    [
        112.86635140431,
        22.839629628612
    ],
    [
        112.86623664684,
        22.839653801999
    ],
    [
        112.86606735559,
        22.839685065361
    ],
    [
        112.86595177693,
        22.839714423314
    ],
    [
        112.86580987778,
        22.83974950876
    ],
    [
        112.86567448745,
        22.839779453454
    ],
    [
        112.86552986552,
        22.839824071949
    ],
    [
        112.86543950896,
        22.839850747652
    ],
    [
        112.86538768231,
        22.839865180753
    ],
    [
        112.86536353264,
        22.839871446834
    ],
    [
        112.86533666697,
        22.839889380574
    ],
    [
        112.86531360052,
        22.839904055414
    ],
    [
        112.86528049206,
        22.839930135601
    ],
    [
        112.86527071768,
        22.839958358022
    ],
    [
        112.86525415759,
        22.839996625334
    ],
    [
        112.86523678148,
        22.840043031544
    ],
    [
        112.86523459087,
        22.840128750688
    ],
    [
        112.86522616191,
        22.840202813709
    ],
    [
        112.86519954387,
        22.840314604321
    ],
    [
        112.86516288282,
        22.840436987584
    ],
    [
        112.86513110601,
        22.840555025261
    ],
    [
        112.86508928636,
        22.840681486486
    ],
    [
        112.86504827366,
        22.840829919437
    ],
    [
        112.86503332102,
        22.840934372975
    ],
    [
        112.86501865836,
        22.840970199488
    ],
    [
        112.86499557938,
        22.841021771194
    ],
    [
        112.86496137351,
        22.841077971382
    ],
    [
        112.86492173469,
        22.84115343985
    ],
    [
        112.86488480961,
        22.841226192905
    ],
    [
        112.8648353997,
        22.841305477412
    ],
    [
        112.86479006126,
        22.841378518543
    ],
    [
        112.86473956991,
        22.841439635314
    ],
    [
        112.86469260298,
        22.841509428207
    ],
    [
        112.86463830807,
        22.841580592555
    ],
    [
        112.86457777095,
        22.841651499934
    ],
    [
        112.86452782532,
        22.841694180387
    ],
    [
        112.86449524881,
        22.841731404297
    ],
    [
        112.86445018546,
        22.841778961319
    ],
    [
        112.8644110956,
        22.841815115647
    ],
    [
        112.86435001917,
        22.841864879197
    ],
    [
        112.86429518465,
        22.841911920387
    ],
    [
        112.86421728011,
        22.841963354712
    ],
    [
        112.86415810237,
        22.842008513569
    ],
    [
        112.86410001325,
        22.84204228067
    ],
    [
        112.86404328379,
        22.842066011455
    ],
    [
        112.86399957977,
        22.842092968891
    ],
    [
        112.86395126254,
        22.842116955585
    ],
    [
        112.86389507661,
        22.842133640284
    ],
    [
        112.86385246528,
        22.842135917273
    ],
    [
        112.86381826451,
        22.8421463118
    ],
    [
        112.86377104052,
        22.84214290758
    ],
    [
        112.86370997387,
        22.842140084653
    ],
    [
        112.86364510954,
        22.842128866766
    ],
    [
        112.86354849268,
        22.84210445029
    ],
    [
        112.86348308854,
        22.842078324864
    ],
    [
        112.86343152648,
        22.842051891642
    ],
    [
        112.86337317606,
        22.842031719701
    ],
    [
        112.86332432226,
        22.842020202162
    ],
    [
        112.86325185481,
        22.842003605554
    ],
    [
        112.86320163939,
        22.842002133883
    ],
    [
        112.86314002717,
        22.841987952025
    ],
    [
        112.86306457213,
        22.841968936059
    ],
    [
        112.86300838569,
        22.84195962644
    ],
    [
        112.86297635449,
        22.841960275173
    ],
    [
        112.86290876538,
        22.841953178682
    ],
    [
        112.86284307545,
        22.841946622283
    ],
    [
        112.86279530036,
        22.841942177024
    ],
    [
        112.86275078317,
        22.841935281072
    ],
    [
        112.86270381961,
        22.841937075637
    ],
    [
        112.86267314269,
        22.841941525832
    ],
    [
        112.86262182793,
        22.841964768251
    ],
    [
        112.86259141297,
        22.841996615889
    ],
    [
        112.8625528496,
        22.842040700788
    ],
    [
        112.86253165993,
        22.842085264488
    ],
    [
        112.86251725993,
        22.842120851908
    ],
    [
        112.8625017777,
        22.842145322393
    ],
    [
        112.86250475388,
        22.842174877265
    ],
    [
        112.86251151579,
        22.842247817617
    ],
    [
        112.86254812672,
        22.842356993725
    ],
    [
        112.86259124609,
        22.84248296429
    ],
    [
        112.86262975986,
        22.842579929721
    ],
    [
        112.86267069408,
        22.842736833198
    ],
    [
        112.86268614593,
        22.842795366812
    ],
    [
        112.86268965345,
        22.8428531297
    ],
    [
        112.86269750013,
        22.84292172685
    ],
    [
        112.86271129854,
        22.843043195685
    ],
    [
        112.86271722165,
        22.843170117508
    ],
    [
        112.86269981246,
        22.843260775675
    ],
    [
        112.86270387178,
        22.843292768072
    ],
    [
        112.86268268713,
        22.843319154854
    ],
    [
        112.86266638431,
        22.843356645434
    ],
    [
        112.86263569364,
        22.843394188518
    ],
    [
        112.8626079915,
        22.84342521161
    ],
    [
        112.86256101718,
        22.843450339291
    ],
    [
        112.86248932576,
        22.843506483814
    ],
    [
        112.86242171141,
        22.843547970118
    ],
    [
        112.86234187434,
        22.843601985444
    ],
    [
        112.86226773761,
        22.843654898858
    ],
    [
        112.86219549644,
        22.843716760594
    ],
    [
        112.86214145309,
        22.84375712422
    ],
    [
        112.86209229397,
        22.843802352659
    ],
    [
        112.86204041681,
        22.84385356196
    ],
    [
        112.8620167832,
        22.843885125184
    ],
    [
        112.86198771598,
        22.843924849142
    ],
    [
        112.86196162631,
        22.843984904429
    ],
    [
        112.86193771515,
        22.844029218891
    ],
    [
        112.86189342677,
        22.844106441863
    ],
    [
        112.86186869923,
        22.844153744939
    ],
    [
        112.86182876566,
        22.844204369761
    ],
    [
        112.86180267947,
        22.8442530364
    ],
    [
        112.86176030207,
        22.844302589385
    ],
    [
        112.86171819501,
        22.844353770198
    ],
    [
        112.86167880656,
        22.844396260586
    ],
    [
        112.86164077102,
        22.844448239672
    ],
    [
        112.86160545053,
        22.844499665136
    ],
    [
        112.86157475184,
        22.844537237121
    ],
    [
        112.86154839998,
        22.844568822536
    ],
    [
        112.86150792242,
        22.844614307533
    ],
    [
        112.86146445918,
        22.844656553084
    ],
    [
        112.86143647947,
        22.844683808875
    ],
    [
        112.86138759064,
        22.844713877138
    ],
    [
        112.86135472546,
        22.844735733405
    ],
    [
        112.86132919508,
        22.844749689307
    ],
    [
        112.86129769085,
        22.844763674697
    ],
    [
        112.86125233776,
        22.844778542218
    ],
    [
        112.86120834998,
        22.844776316669
    ],
    [
        112.86112905877,
        22.844780235814
    ],
    [
        112.86107855043,
        22.844783472723
    ],
    [
        112.86098948659,
        22.844776872556
    ],
    [
        112.8609378928,
        22.844775781462
    ],
    [
        112.86085805831,
        22.844771856472
    ],
    [
        112.86079804338,
        22.844774341981
    ],
    [
        112.86073178128,
        22.844778220238
    ],
    [
        112.86070081792,
        22.844789778226
    ],
    [
        112.86063618164,
        22.844798806913
    ],
    [
        112.86059951636,
        22.844807143733
    ],
    [
        112.86053378395,
        22.844834628599
    ],
    [
        112.86046669914,
        22.844848834004
    ],
    [
        112.86042921954,
        22.844853925961
    ],
    [
        112.86038521761,
        22.84486800691
    ],
    [
        112.86035344127,
        22.844871712956
    ],
    [
        112.86027766928,
        22.84487404423
    ],
    [
        112.86019890613,
        22.844882093957
    ],
    [
        112.86013344889,
        22.844891969626
    ],
    [
        112.86003349746,
        22.844904223865
    ],
    [
        112.85998134734,
        22.844912401596
    ],
    [
        112.85991154441,
        22.844917162434
    ],
    [
        112.85983685112,
        22.844923313656
    ],
    [
        112.85977790619,
        22.844937509537
    ],
    [
        112.85973200111,
        22.844944846274
    ],
    [
        112.85966843496,
        22.844964772526
    ],
    [
        112.8595975337,
        22.844986376142
    ],
    [
        112.85952175057,
        22.844990927189
    ],
    [
        112.85946063184,
        22.844999999569
    ],
    [
        112.85940548676,
        22.845012019969
    ],
    [
        112.85935142622,
        22.845027019524
    ],
    [
        112.85928215089,
        22.845048360498
    ],
    [
        112.85921776411,
        22.845069673014
    ],
    [
        112.85914766476,
        22.845106488123
    ],
    [
        112.85905012643,
        22.845148376086
    ],
    [
        112.85896942971,
        22.845187443895
    ],
    [
        112.85889172152,
        22.84522324162
    ],
    [
        112.85880097224,
        22.845260492076
    ],
    [
        112.8586996195,
        22.845312742912
    ],
    [
        112.85861701102,
        22.84536188422
    ],
    [
        112.85855179752,
        22.845391376237
    ],
    [
        112.85847243962,
        22.845454879761
    ],
    [
        112.85838602026,
        22.845511930806
    ],
    [
        112.85831509224,
        22.845554497324
    ],
    [
        112.85824035828,
        22.845600080155
    ],
    [
        112.8581591073,
        22.845637037234
    ],
    [
        112.85810503256,
        22.845656433699
    ],
    [
        112.85805476632,
        22.845665225195
    ],
    [
        112.85798548547,
        22.845666027915
    ],
    [
        112.8579066897,
        22.845676401818
    ],
    [
        112.8577958457,
        22.845660993401
    ],
    [
        112.85770999197,
        22.845654076382
    ],
    [
        112.85762169495,
        22.845640675277
    ],
    [
        112.85754290264,
        22.845634798563
    ],
    [
        112.85747932473,
        22.845629888292
    ],
    [
        112.85740433281,
        22.845627515796
    ],
    [
        112.85729782841,
        22.845609404954
    ],
    [
        112.85721713142,
        22.845600310155
    ],
    [
        112.85712936853,
        22.845591008786
    ],
    [
        112.85704812911,
        22.845575419919
    ],
    [
        112.85696063906,
        22.845559076058
    ],
    [
        112.85691009714,
        22.845556796386
    ],
    [
        112.85686309796,
        22.845533602873
    ],
    [
        112.85683050076,
        22.845510286531
    ],
    [
        112.85681991718,
        22.845481626792
    ],
    [
        112.85680797794,
        22.845446740389
    ],
    [
        112.85679631238,
        22.845407783134
    ],
    [
        112.85679768778,
        22.845374137584
    ],
    [
        112.85681047931,
        22.845334425824
    ],
    [
        112.85684556295,
        22.845275534768
    ],
    [
        112.85687358493,
        22.845208568277
    ],
    [
        112.85688936935,
        22.84516015183
    ],
    [
        112.85688179523,
        22.845088609727
    ],
    [
        112.85687040349,
        22.845044224483
    ],
    [
        112.85682886558,
        22.844963753494
    ],
    [
        112.85675663506,
        22.844851273061
    ],
    [
        112.85669281114,
        22.844773441848
    ],
    [
        112.85663224388,
        22.844702908664
    ],
    [
        112.85657058665,
        22.844636999115
    ],
    [
        112.85650402655,
        22.844593920477
    ],
    [
        112.85639807018,
        22.844529499717
    ],
    [
        112.85633584959,
        22.844501037964
    ],
    [
        112.85623748429,
        22.844470467221
    ],
    [
        112.85612769986,
        22.844446790237
    ],
    [
        112.85601764402,
        22.844417971682
    ],
    [
        112.85590676684,
        22.844398121306
    ],
    [
        112.85582877515,
        22.844375257236
    ],
    [
        112.85574670381,
        22.844356505304
    ],
    [
        112.85570104848,
        22.844344462952
    ],
    [
        112.85565077871,
        22.844318090605
    ],
    [
        112.85559045312,
        22.844289375796
    ],
    [
        112.8554967028,
        22.844244441787
    ],
    [
        112.85540566585,
        22.844206811567
    ],
    [
        112.85531925715,
        22.844148799019
    ],
    [
        112.85524479625,
        22.844115085725
    ],
    [
        112.85515321161,
        22.84407802099
    ],
    [
        112.85506298261,
        22.8440458314
    ],
    [
        112.85501270977,
        22.844014058787
    ],
    [
        112.85494612197,
        22.843994387754
    ],
    [
        112.85489176613,
        22.843973510761
    ],
    [
        112.8548308843,
        22.843956499984
    ],
    [
        112.85476239177,
        22.843936857619
    ],
    [
        112.85468737137,
        22.843924609645
    ],
    [
        112.85462974471,
        22.84391923793
    ],
    [
        112.8545655927,
        22.843915564038
    ],
    [
        112.85450279283,
        22.843927068676
    ],
    [
        112.85443455892,
        22.843930496027
    ],
    [
        112.85435599478,
        22.843932408435
    ],
    [
        112.85432445811,
        22.843937895475
    ],
    [
        112.85426899757,
        22.843945535937
    ],
    [
        112.85423175135,
        22.843951628297
    ],
    [
        112.85417846176,
        22.843966572882
    ],
    [
        112.85413278618,
        22.843975741771
    ],
    [
        112.8540876598,
        22.84397134415
    ],
    [
        112.8540305696,
        22.843970874576
    ],
    [
        112.85398898114,
        22.843956134785
    ],
    [
        112.85395364739,
        22.843936445967
    ],
    [
        112.8539047277,
        22.843899003941
    ],
    [
        112.85383000065,
        22.84381275091
    ],
    [
        112.85376423835,
        22.843740507912
    ],
    [
        112.85367183629,
        22.843656627661
    ],
    [
        112.85360769686,
        22.843599834908
    ],
    [
        112.85355089129,
        22.843558152954
    ],
    [
        112.85349082892,
        22.843500777587
    ],
    [
        112.85343103861,
        22.843441231752
    ],
    [
        112.85337912793,
        22.843392720617
    ],
    [
        112.85334217213,
        22.843340244943
    ],
    [
        112.85334135797,
        22.843336456719
    ],
    [
        112.85333211245,
        22.843339816123
    ],
    [
        112.85327529092,
        22.843331508456
    ],
    [
        112.85319426704,
        22.843331887357
    ],
    [
        112.853122216,
        22.843329184419
    ],
    [
        112.8529819174,
        22.843326186734
    ],
    [
        112.85280517284,
        22.84334234359
    ],
    [
        112.85266268771,
        22.843351879795
    ],
    [
        112.85254766537,
        22.843356764376
    ],
    [
        112.85245928922,
        22.843362425394
    ],
    [
        112.852298296,
        22.843397714605
    ],
    [
        112.85218026438,
        22.843433314662
    ],
    [
        112.85210764563,
        22.843464845571
    ],
    [
        112.85200430007,
        22.843489160216
    ],
    [
        112.85194256222,
        22.843508089013
    ],
    [
        112.85184655925,
        22.843526357143
    ],
    [
        112.85177203378,
        22.843557113987
    ],
    [
        112.85168689979,
        22.843592074911
    ],
    [
        112.85159060755,
        22.84364453946
    ],
    [
        112.85144726652,
        22.843694075098
    ],
    [
        112.85132050891,
        22.84375209369
    ],
    [
        112.8512263884,
        22.843802112161
    ],
    [
        112.85110287774,
        22.843890486243
    ],
    [
        112.85100358143,
        22.843953061426
    ],
    [
        112.85090999291,
        22.84402099386
    ],
    [
        112.85081150585,
        22.844092521498
    ],
    [
        112.85075246548,
        22.844139671665
    ],
    [
        112.85070620506,
        22.844193166934
    ],
    [
        112.85064497658,
        22.844265846269
    ],
    [
        112.85059436242,
        22.844321571597
    ],
    [
        112.85052333477,
        22.844408217336
    ],
    [
        112.85041857266,
        22.844508874048
    ],
    [
        112.85031571097,
        22.844613309463
    ],
    [
        112.85024549717,
        22.844696701282
    ],
    [
        112.85016385136,
        22.844795167165
    ],
    [
        112.85009662456,
        22.844885034911
    ],
    [
        112.85004517139,
        22.844978761582
    ],
    [
        112.85001930807,
        22.845026576656
    ],
    [
        112.85001466712,
        22.845061900294
    ],
    [
        112.85001192249,
        22.845113201495
    ],
    [
        112.85001814841,
        22.845176045096
    ],
    [
        112.85001211923,
        22.845268890023
    ],
    [
        112.85000529715,
        22.84531373634
    ],
    [
        112.84999765588,
        22.845364832195
    ],
    [
        112.84999518105,
        22.845419113249
    ],
    [
        112.84998589869,
        22.845487861712
    ],
    [
        112.84996737711,
        22.845538019461
    ],
    [
        112.84995075414,
        22.845598730014
    ],
    [
        112.84992378312,
        22.845682093353
    ],
    [
        112.84989600548,
        22.845746210118
    ],
    [
        112.84986278505,
        22.845814740899
    ],
    [
        112.84982792939,
        22.845888719235
    ],
    [
        112.84979389712,
        22.845947769001
    ],
    [
        112.84976636972,
        22.846051213629
    ],
    [
        112.84974592737,
        22.846129608261
    ],
    [
        112.8497091735,
        22.846189510382
    ],
    [
        112.84967160426,
        22.846247525754
    ],
    [
        112.8496340376,
        22.84630011716
    ],
    [
        112.84957904631,
        22.846380614518
    ],
    [
        112.84954365703,
        22.846429651874
    ],
    [
        112.84948159658,
        22.846501841133
    ],
    [
        112.84942823931,
        22.846575810952
    ],
    [
        112.84936779747,
        22.846670223073
    ],
    [
        112.84932832066,
        22.846729356968
    ],
    [
        112.84926841942,
        22.846827562158
    ],
    [
        112.84920469908,
        22.846943181522
    ],
    [
        112.84915895721,
        22.847014340707
    ],
    [
        112.84914316476,
        22.847039786121
    ],
    [
        112.84911347824,
        22.847100686435
    ],
    [
        112.8490848849,
        22.84715234995
    ],
    [
        112.84903313197,
        22.847266722556
    ],
    [
        112.84900208301,
        22.847329813581
    ],
    [
        112.84896722453,
        22.847394043651
    ],
    [
        112.84893098019,
        22.847501419904
    ],
    [
        112.84888630212,
        22.847608373372
    ],
    [
        112.84885934483,
        22.847650523993
    ],
    [
        112.84881168653,
        22.847735280245
    ],
    [
        112.84876592497,
        22.847831673741
    ],
    [
        112.84875094658,
        22.847857924542
    ],
    [
        112.84871662696,
        22.847926762398
    ],
    [
        112.84866706502,
        22.848007480791
    ],
    [
        112.84861995967,
        22.84807406139
    ],
    [
        112.84856414195,
        22.84815080323
    ],
    [
        112.84849199572,
        22.848235103925
    ],
    [
        112.84839834545,
        22.848336532859
    ],
    [
        112.84832783474,
        22.848412679317
    ],
    [
        112.84828482829,
        22.848446118937
    ],
    [
        112.84819338654,
        22.848492195036
    ],
    [
        112.84809976761,
        22.848537764716
    ],
    [
        112.84802954866,
        22.84857838675
    ],
    [
        112.8479332136,
        22.848613968613
    ],
    [
        112.84781864393,
        22.848656874968
    ],
    [
        112.84767712339,
        22.848721341535
    ],
    [
        112.84753587271,
        22.848785814186
    ],
    [
        112.84741067984,
        22.848839479615
    ],
    [
        112.84729419851,
        22.848883258263
    ],
    [
        112.84716711517,
        22.848910115246
    ],
    [
        112.84707323117,
        22.848928614238
    ],
    [
        112.84697526586,
        22.848945551736
    ],
    [
        112.84687812208,
        22.84895298835
    ],
    [
        112.84678043424,
        22.848958810321
    ],
    [
        112.84668083475,
        22.848973887692
    ],
    [
        112.84659892389,
        22.848984902089
    ],
    [
        112.84649469254,
        22.849006568319
    ],
    [
        112.84641741166,
        22.849009110482
    ],
    [
        112.84624869265,
        22.849022829562
    ],
    [
        112.84614910025,
        22.849019487402
    ],
    [
        112.84605820356,
        22.849033373259
    ],
    [
        112.84598798192,
        22.849055620353
    ],
    [
        112.84594986495,
        22.849086048748
    ],
    [
        112.84590085476,
        22.849128852884
    ],
    [
        112.84584911265,
        22.849187431945
    ],
    [
        112.84579328555,
        22.849250144432
    ],
    [
        112.84576876518,
        22.84929392455
    ],
    [
        112.84572873615,
        22.849333608182
    ],
    [
        112.8456884243,
        22.849389028132
    ],
    [
        112.84559609808,
        22.849500053978
    ],
    [
        112.84551602132,
        22.849604109564
    ],
    [
        112.84543676811,
        22.849696220723
    ],
    [
        112.84536268561,
        22.849786896457
    ],
    [
        112.84531554886,
        22.849870366762
    ],
    [
        112.84524392287,
        22.849948530621
    ],
    [
        112.84513935672,
        22.85004186657
    ],
    [
        112.84501383332,
        22.850136626096
    ],
    [
        112.84490466459,
        22.850192073461
    ],
    [
        112.84479548643,
        22.850259459523
    ],
    [
        112.8446844103,
        22.850315217958
    ],
    [
        112.84460328439,
        22.850350427469
    ],
    [
        112.84458258526,
        22.850372459211
    ],
    [
        112.84457305195,
        22.850383733201
    ],
    [
        112.84459587487,
        22.850437339044
    ],
    [
        112.844638563,
        22.850493337323
    ],
    [
        112.844689659,
        22.850589342316
    ],
    [
        112.84474618598,
        22.850701263241
    ],
    [
        112.84478750525,
        22.850767049889
    ],
    [
        112.84482120595,
        22.850830247061
    ],
    [
        112.84487039846,
        22.85092140381
    ],
    [
        112.84493293683,
        22.850997159433
    ],
    [
        112.84501776545,
        22.851107006172
    ],
    [
        112.84509471543,
        22.8511971818
    ],
    [
        112.84514610041,
        22.851264441024
    ],
    [
        112.84520673261,
        22.85133860619
    ],
    [
        112.84524587869,
        22.851394941655
    ],
    [
        112.84530569016,
        22.85147373298
    ],
    [
        112.84533722386,
        22.851519341527
    ],
    [
        112.84536467083,
        22.851570982007
    ],
    [
        112.84541278092,
        22.851647791177
    ],
    [
        112.8454619816,
        22.851721329375
    ],
    [
        112.84550738187,
        22.851781909748
    ],
    [
        112.84554841321,
        22.851861545278
    ],
    [
        112.84561609291,
        22.851967342326
    ],
    [
        112.84565249542,
        22.852049222047
    ],
    [
        112.84570793441,
        22.852146805881
    ],
    [
        112.8457533042,
        22.852244277343
    ],
    [
        112.84578782167,
        22.852299066364
    ],
    [
        112.84583210443,
        22.852393572811
    ],
    [
        112.84587504436,
        22.852464775984
    ],
    [
        112.84591222705,
        22.852589771362
    ],
    [
        112.84594153933,
        22.852687225297
    ],
    [
        112.84597710319,
        22.852793261308
    ],
    [
        112.84601837963,
        22.852901107543
    ],
    [
        112.84603845255,
        22.852981076806
    ],
    [
        112.84612645709,
        22.853182312762
    ],
    [
        112.84618325207,
        22.85327798766
    ],
    [
        112.84626748038,
        22.853434535972
    ],
    [
        112.84636369189,
        22.853576799496
    ],
    [
        112.84644140784,
        22.853707688534
    ],
    [
        112.84652403348,
        22.853823045569
    ],
    [
        112.84660558226,
        22.853923233881
    ],
    [
        112.84666237875,
        22.854011326508
    ],
    [
        112.84670068963,
        22.854078004654
    ],
    [
        112.84674799813,
        22.854122577938
    ],
    [
        112.84677842974,
        22.85417473153
    ],
    [
        112.84681076978,
        22.854222245866
    ],
    [
        112.84683739297,
        22.854272830781
    ],
    [
        112.84688005538,
        22.854340530907
    ],
    [
        112.84689360311,
        22.854408130072
    ],
    [
        112.8469120729,
        22.85444690578
    ],
    [
        112.84691908326,
        22.854522469298
    ],
    [
        112.84691220659,
        22.854609634017
    ],
    [
        112.84691104683,
        22.854693186368
    ],
    [
        112.84689791278,
        22.854778818441
    ],
    [
        112.84688205911,
        22.854862593224
    ],
    [
        112.84687410413,
        22.854937027039
    ],
    [
        112.84684817896,
        22.85502475163
    ],
    [
        112.84681383524,
        22.855093076699
    ],
    [
        112.84679119058,
        22.855162580636
    ],
    [
        112.84675220596,
        22.85524779252
    ],
    [
        112.84669661966,
        22.855336512499
    ],
    [
        112.84662222979,
        22.855456981881
    ],
    [
        112.84651762801,
        22.855585510286
    ],
    [
        112.84646724237,
        22.855637271054
    ],
    [
        112.84643481998,
        22.855684146423
    ],
    [
        112.84636533317,
        22.855795598937
    ],
    [
        112.8463118954,
        22.855912501697
    ],
    [
        112.84628164045,
        22.855969109559
    ],
    [
        112.84625383851,
        22.856021069301
    ],
    [
        112.84623884829,
        22.856047879759
    ],
    [
        112.84623037699,
        22.856087879119
    ],
    [
        112.84622679844,
        22.856133769632
    ],
    [
        112.84621234553,
        22.85616816595
    ],
    [
        112.84619758564,
        22.856241350736
    ],
    [
        112.84615937979,
        22.856363174455
    ],
    [
        112.84614296886,
        22.856456183685
    ],
    [
        112.84612109879,
        22.856567448884
    ],
    [
        112.8461077181,
        22.856619186847
    ],
    [
        112.8460965138,
        22.856671433553
    ],
    [
        112.84610489924,
        22.856726631107
    ],
    [
        112.84611520897,
        22.856760372994
    ],
    [
        112.84613585455,
        22.856799107873
    ],
    [
        112.84616166069,
        22.85684834038
    ],
    [
        112.84620459707,
        22.856911682618
    ],
    [
        112.84623532339,
        22.856936430711
    ],
    [
        112.8462695864,
        22.856961938294
    ],
    [
        112.8463106599,
        22.856978933835
    ],
    [
        112.84634521043,
        22.856987351721
    ],
    [
        112.84640860746,
        22.856992614584
    ],
    [
        112.84646438521,
        22.856997724926
    ],
    [
        112.84649431457,
        22.857000520567
    ],
    [
        112.84652121877,
        22.857038078218
    ],
    [
        112.84654788413,
        22.857039297303
    ],
    [
        112.84662243193,
        22.857049277597
    ],
    [
        112.84666814458,
        22.857050207442
    ],
    [
        112.84672391948,
        22.857056951771
    ],
    [
        112.84676198982,
        22.857082951545
    ],
    [
        112.84682371955,
        22.857123238369
    ],
    [
        112.84687101923,
        22.85717269559
    ],
    [
        112.84693246362,
        22.857226550534
    ],
    [
        112.84697051756,
        22.857269369479
    ],
    [
        112.84699795822,
        22.857313705304
    ],
    [
        112.84702839184,
        22.857357996357
    ],
    [
        112.84705502475,
        22.857392852651
    ],
    [
        112.84708384893,
        22.857411945973
    ],
    [
        112.84708872982,
        22.857430043767
    ],
    [
        112.84709577186,
        22.857464924236
    ],
    [
        112.84713243977,
        22.857534345763
    ],
    [
        112.84715117673,
        22.857574474958
    ],
    [
        112.8471612306,
        22.857588969474
    ],
    [
        112.84716937272,
        22.857611086674
    ],
    [
        112.84719003796,
        22.857625693314
    ],
    [
        112.84724171136,
        22.857650955353
    ],
    [
        112.84726565546,
        22.857650596986
    ],
    [
        112.84733394036,
        22.857660153798
    ],
    [
        112.84745502768,
        22.857649671095
    ],
    [
        112.84758020008,
        22.857633439734
    ],
    [
        112.84771762126,
        22.857609712969
    ],
    [
        112.84790214448,
        22.857547607042
    ],
    [
        112.84807224592,
        22.857484101176
    ],
    [
        112.84818082706,
        22.857454317938
    ],
    [
        112.84829785847,
        22.85740543401
    ],
    [
        112.84838738043,
        22.85738922723
    ],
    [
        112.84846113224,
        22.85736240241
    ],
    [
        112.84852887587,
        22.857359804423
    ],
    [
        112.848666533,
        22.857360009255
    ],
    [
        112.84874597121,
        22.857359422501
    ],
    [
        112.8488128747,
        22.857380442421
    ],
    [
        112.84890833559,
        22.857408384572
    ],
    [
        112.84898828478,
        22.8574411604
    ],
    [
        112.84908100419,
        22.857489762423
    ],
    [
        112.8491329322,
        22.857522666204
    ],
    [
        112.8492770004,
        22.857639178239
    ],
    [
        112.84935365357,
        22.857702120883
    ],
    [
        112.84942676884,
        22.857765929364
    ],
    [
        112.84955234276,
        22.857873227032
    ],
    [
        112.84963087817,
        22.857956496906
    ],
    [
        112.84971269199,
        22.858023724094
    ],
    [
        112.84977358263,
        22.85806683071
    ],
    [
        112.84985731409,
        22.858118037206
    ],
    [
        112.84993207672,
        22.858160419031
    ],
    [
        112.84999704808,
        22.858201037607
    ],
    [
        112.85008324495,
        22.858231338763
    ],
    [
        112.85015937751,
        22.858260965355
    ],
    [
        112.85027492098,
        22.85832017493
    ],
    [
        112.85039155587,
        22.858373953899
    ],
    [
        112.85050818051,
        22.858436691282
    ],
    [
        112.85060330696,
        22.858509482299
    ],
    [
        112.85064762767,
        22.858523004927
    ],
    [
        112.85074876776,
        22.858562366807
    ],
    [
        112.85089260506,
        22.858603623381
    ],
    [
        112.85103916047,
        22.858643773209
    ],
    [
        112.85119495873,
        22.858685174941
    ],
    [
        112.85128060459,
        22.858709037886
    ],
    [
        112.85133389051,
        22.858728432675
    ],
    [
        112.8513822714,
        22.858757654781
    ],
    [
        112.85146298768,
        22.858815220194
    ],
    [
        112.85157958585,
        22.858888342758
    ],
    [
        112.85169047895,
        22.858953408657
    ],
    [
        112.85180598978,
        22.859022222579
    ],
    [
        112.85189267067,
        22.859093568815
    ],
    [
        112.85194866187,
        22.859122986574
    ],
    [
        112.85198967921,
        22.859169946806
    ],
    [
        112.85204779751,
        22.859248702681
    ],
    [
        112.85208581372,
        22.859305194464
    ],
    [
        112.85213091231,
        22.85934885441
    ],
    [
        112.8521526474,
        22.85936893188
    ],
    [
        112.85218472007,
        22.859384545299
    ],
    [
        112.8522741802,
        22.85938889086
    ],
    [
        112.85242237244,
        22.859395252276
    ],
    [
        112.85254554406,
        22.859403009575
    ],
    [
        112.85266326975,
        22.859416536729
    ],
    [
        112.85272960172,
        22.859431217074
    ],
    [
        112.85282716425,
        22.859485133118
    ],
    [
        112.85287228964,
        22.85949627024
    ],
    [
        112.85289484946,
        22.859504687079
    ],
    [
        112.85294759984,
        22.859503262418
    ],
    [
        112.85306234058,
        22.859503838513
    ],
    [
        112.85317136123,
        22.85951316783
    ],
    [
        112.85323550852,
        22.859532778296
    ],
    [
        112.85327219475,
        22.859552160306
    ],
    [
        112.85330234751,
        22.859579753511
    ],
    [
        112.85336184907,
        22.859622475211
    ],
    [
        112.85340421942,
        22.859667290405
    ],
    [
        112.85346234847,
        22.859722507478
    ],
    [
        112.85351527843,
        22.859811415119
    ],
    [
        112.85354645055,
        22.859907618467
    ],
    [
        112.85357491711,
        22.85999002083
    ],
    [
        112.85361316363,
        22.860079909118
    ],
    [
        112.85365195941,
        22.860163825726
    ],
    [
        112.85365758789,
        22.860246211413
    ],
    [
        112.85365370993,
        22.860319209892
    ],
    [
        112.85365777127,
        22.86033625121
    ],
    [
        112.85366509219,
        22.860356239809
    ],
    [
        112.853681925,
        22.860379920307
    ],
    [
        112.85372619407,
        22.860426622684
    ],
    [
        112.85379845728,
        22.860481426891
    ],
    [
        112.85390221185,
        22.860580912625
    ],
    [
        112.85398451647,
        22.860651347497
    ],
    [
        112.8540820039,
        22.860762305453
    ],
    [
        112.85417922756,
        22.860863509604
    ],
    [
        112.85428652728,
        22.860945357913
    ],
    [
        112.85439220406,
        22.861017197027
    ],
    [
        112.85449219277,
        22.861066593429
    ],
    [
        112.8545391839,
        22.861103801345
    ],
    [
        112.85457830591,
        22.861126447283
    ],
    [
        112.85463318911,
        22.861154084206
    ],
    [
        112.85471604402,
        22.861208285226
    ],
    [
        112.85479128308,
        22.861266094983
    ],
    [
        112.85488087585,
        22.861376106577
    ],
    [
        112.85496478524,
        22.861459874243
    ],
    [
        112.85514348996,
        22.861610502112
    ],
    [
        112.85533629873,
        22.861785695917
    ],
    [
        112.85552260295,
        22.861936301049
    ],
    [
        112.85562305897,
        22.862043817511
    ],
    [
        112.85573520874,
        22.862142823118
    ],
    [
        112.85585441983,
        22.862244755347
    ],
    [
        112.85598235039,
        22.862321937425
    ],
    [
        112.85607307329,
        22.862371540985
    ],
    [
        112.85619283004,
        22.862464821115
    ],
    [
        112.85630227128,
        22.862544374293
    ],
    [
        112.85639676805,
        22.862619731765
    ],
    [
        112.85648229039,
        22.86270005807
    ],
    [
        112.85656861468,
        22.862792316319
    ],
    [
        112.85667502024,
        22.862910982956
    ],
    [
        112.85674885345,
        22.862991429933
    ],
    [
        112.8568699399,
        22.863099950846
    ],
    [
        112.85699371615,
        22.863233140746
    ],
    [
        112.85704963358,
        22.863291518949
    ],
    [
        112.85715683199,
        22.863423509475
    ],
    [
        112.8573373929,
        22.863555175129
    ],
    [
        112.85747880898,
        22.863699659779
    ],
    [
        112.85759117598,
        22.863817814825
    ],
    [
        112.85769076437,
        22.863942319373
    ],
    [
        112.85781747882,
        22.864107843264
    ],
    [
        112.85790134626,
        22.864192078173
    ],
    [
        112.85800637466,
        22.864305175801
    ],
    [
        112.85811788666,
        22.864452405812
    ],
    [
        112.85826658976,
        22.864625404542
    ],
    [
        112.85839112083,
        22.864788293246
    ],
    [
        112.85847657662,
        22.86490510192
    ],
    [
        112.85858158644,
        22.865026115406
    ],
    [
        112.8586683838,
        22.865156488739
    ],
    [
        112.85876225424,
        22.865275699119
    ],
    [
        112.85889461817,
        22.865471944512
    ],
    [
        112.85896706584,
        22.865551451992
    ],
    [
        112.85903733141,
        22.865638843852
    ],
    [
        112.85910515555,
        22.865722188256
    ],
    [
        112.85916240678,
        22.865784453002
    ],
    [
        112.85923891473,
        22.865874527328
    ],
    [
        112.85932490616,
        22.865986512442
    ],
    [
        112.85940303115,
        22.866086892924
    ],
    [
        112.85948223546,
        22.866193238347
    ],
    [
        112.8595598398,
        22.866269495129
    ],
    [
        112.85966321795,
        22.866373258806
    ],
    [
        112.85974434742,
        22.866452760434
    ],
    [
        112.85985152941,
        22.866551906903
    ],
    [
        112.85995164981,
        22.866649207326
    ],
    [
        112.86003492966,
        22.866746616368
    ],
    [
        112.86009595564,
        22.866826804812
    ],
    [
        112.86015969214,
        22.866911591275
    ],
    [
        112.8602120103,
        22.86700729566
    ],
    [
        112.86026894712,
        22.867100806287
    ],
    [
        112.86035382285,
        22.867226706468
    ],
    [
        112.8604202419,
        22.867341325411
    ],
    [
        112.86051322419,
        22.867504890295
    ],
    [
        112.86059537942,
        22.867632179643
    ],
    [
        112.86065313422,
        22.867718924891
    ],
    [
        112.86073639144,
        22.86782886113
    ],
    [
        112.86077788011,
        22.867887493628
    ],
    [
        112.86084895119,
        22.867962516579
    ],
    [
        112.86089094939,
        22.868053424566
    ],
    [
        112.86093810788,
        22.868143222739
    ],
    [
        112.86098444974,
        22.868234654327
    ],
    [
        112.86100716317,
        22.868329733403
    ],
    [
        112.86103154268,
        22.868388462363
    ],
    [
        112.86107761155,
        22.868480712842
    ],
    [
        112.86110009881,
        22.868530774079
    ],
    [
        112.86116356989,
        22.868599074737
    ],
    [
        112.86124004712,
        22.868693894121
    ],
    [
        112.86131112096,
        22.868760810055
    ],
    [
        112.86144162218,
        22.868863249683
    ],
    [
        112.86154715346,
        22.868953072262
    ],
    [
        112.86173272396,
        22.869097331556
    ],
    [
        112.86186756341,
        22.869196004861
    ],
    [
        112.86193671914,
        22.869272732557
    ],
    [
        112.86198988319,
        22.869322139385
    ],
    [
        112.86204385008,
        22.869382665075
    ],
    [
        112.86212790368,
        22.86949134581
    ],
    [
        112.86219025773,
        22.869579507997
    ],
    [
        112.86226344449,
        22.869693667069
    ],
    [
        112.86233227832,
        22.869816255511
    ],
    [
        112.86238158205,
        22.869921836989
    ],
    [
        112.86243090116,
        22.870011690381
    ],
    [
        112.86247236364,
        22.870085031677
    ],
    [
        112.8624709952,
        22.870096156502
    ],
    [
        112.8625417432,
        22.870202749457
    ],
    [
        112.86264856773,
        22.870337151041
    ],
    [
        112.8627318018,
        22.870442897671
    ],
    [
        112.86278195419,
        22.870511067036
    ],
    [
        112.86284947051,
        22.870588129085
    ],
    [
        112.86291048274,
        22.870653555085
    ],
    [
        112.86297337761,
        22.87073606461
    ],
    [
        112.86302951004,
        22.870793919496
    ],
    [
        112.86307910082,
        22.870878648288
    ],
    [
        112.86312652745,
        22.870955521058
    ],
    [
        112.86316065374,
        22.871031895181
    ],
    [
        112.86318040778,
        22.871093940928
    ],
    [
        112.86321779805,
        22.871163255157
    ],
    [
        112.8632519506,
        22.871212510851
    ],
    [
        112.86329259797,
        22.871281546497
    ],
    [
        112.86334113758,
        22.871329134355
    ],
    [
        112.86343250452,
        22.871435724007
    ],
    [
        112.86356185894,
        22.871552521375
    ],
    [
        112.8636613647,
        22.871659378934
    ],
    [
        112.8637665584,
        22.87177653699
    ],
    [
        112.8638619968,
        22.871876100737
    ],
    [
        112.86397562321,
        22.87196966249
    ],
    [
        112.86408436072,
        22.87206487464
    ],
    [
        112.86419470672,
        22.872178536704
    ],
    [
        112.8643178179,
        22.872279436366
    ],
    [
        112.86447105239,
        22.872376765444
    ],
    [
        112.86454668574,
        22.872459341703
    ],
    [
        112.86464186166,
        22.87253646401
    ],
    [
        112.86475139421,
        22.872638522204
    ],
    [
        112.86486824739,
        22.872744648216
    ],
    [
        112.86498181162,
        22.872882795041
    ],
    [
        112.8650902484,
        22.872989228764
    ],
    [
        112.86518107273,
        22.873067760744
    ],
    [
        112.86524964372,
        22.873149039439
    ],
    [
        112.86536623134,
        22.873238675776
    ],
    [
        112.86553298135,
        22.87335973657
    ],
    [
        112.86565605916,
        22.873465942273
    ],
    [
        112.86575368124,
        22.873519022686
    ],
    [
        112.86580437451,
        22.873562922677
    ],
    [
        112.86588647552,
        22.873674066339
    ],
    [
        112.86598919361,
        22.873785747565
    ],
    [
        112.86609760105,
        22.873903945362
    ],
    [
        112.86619542645,
        22.874022157709
    ],
    [
        112.86629163621,
        22.874125733745
    ],
    [
        112.86640598771,
        22.874264302565
    ],
    [
        112.86653984069,
        22.874433259316
    ],
    [
        112.86668210972,
        22.874591656308
    ],
    [
        112.86681164289,
        22.874732168895
    ],
    [
        112.86696285203,
        22.874896029722
    ],
    [
        112.86710914003,
        22.875098964801
    ],
    [
        112.86725599838,
        22.875267475673
    ],
    [
        112.86740176994,
        22.875434378591
    ],
    [
        112.86750469494,
        22.875590956768
    ],
    [
        112.86761006072,
        22.875746191208
    ],
    [
        112.86768996626,
        22.875861811164
    ],
    [
        112.86775196327,
        22.875986638654
    ],
    [
        112.8677957981,
        22.876101413735
    ],
    [
        112.86786458913,
        22.876209711294
    ],
    [
        112.86798702066,
        22.87638236203
    ],
    [
        112.86807716449,
        22.876571525402
    ],
    [
        112.86813753097,
        22.876698000651
    ],
    [
        112.86823959837,
        22.876896145765
    ],
    [
        112.86830565437,
        22.877028063978
    ],
    [
        112.86836656988,
        22.877145603003
    ],
    [
        112.86843154243,
        22.87727535755
    ],
    [
        112.86850765188,
        22.877382082326
    ],
    [
        112.86861247862,
        22.877519243633
    ],
    [
        112.86866448076,
        22.87759257373
    ],
    [
        112.86868669065,
        22.877622994144
    ],
    [
        112.86871241655,
        22.877664270913
    ],
    [
        112.86871401681,
        22.877696549544
    ],
    [
        112.86869773747,
        22.877708450947
    ],
    [
        112.86866736138,
        22.877715985415
    ],
    [
        112.86861257785,
        22.877726728691
    ],
    [
        112.86856376209,
        22.877734231142
    ],
    [
        112.86850735027,
        22.877745247944
    ],
    [
        112.86841186252,
        22.877788475339
    ],
    [
        112.86821649358,
        22.877935431298
    ],
    [
        112.86806481142,
        22.878043969163
    ],
    [
        112.86796087471,
        22.878129535453
    ],
    [
        112.86785883901,
        22.878209689617
    ],
    [
        112.86774186597,
        22.878313704602
    ],
    [
        112.86768050234,
        22.878401244115
    ],
    [
        112.86757300103,
        22.878527256507
    ],
    [
        112.86744646027,
        22.878719171225
    ],
    [
        112.86736527314,
        22.878834377585
    ],
    [
        112.86730905454,
        22.878928994191
    ],
    [
        112.86724145091,
        22.879014656111
    ],
    [
        112.86714476083,
        22.879181944689
    ],
    [
        112.86703534857,
        22.879314248411
    ],
    [
        112.8669098861,
        22.879505142622
    ],
    [
        112.86683381354,
        22.879665414674
    ],
    [
        112.86678112356,
        22.879753279582
    ],
    [
        112.86676861094,
        22.879799385434
    ],
    [
        112.86674384793,
        22.879903802831
    ],
    [
        112.86674296162,
        22.880000630367
    ],
    [
        112.86674914228,
        22.880078744587
    ],
    [
        112.86676428046,
        22.880148994998
    ],
    [
        112.86677508611,
        22.880209209396
    ],
    [
        112.8668002746,
        22.88026101904
    ],
    [
        112.86684418213,
        22.880309308153
    ],
    [
        112.86690869084,
        22.880376049011
    ],
    [
        112.86699410268,
        22.880418391594
    ],
    [
        112.86711530636,
        22.880475133923
    ],
    [
        112.86722756205,
        22.880524561186
    ],
    [
        112.86737832388,
        22.880581894394
    ],
    [
        112.86751417596,
        22.880623504195
    ],
    [
        112.8676033835,
        22.880654778223
    ],
    [
        112.86774058109,
        22.880703198587
    ],
    [
        112.86780293622,
        22.88073391756
    ],
    [
        112.86785742271,
        22.880768970276
    ],
    [
        112.86788316862,
        22.880794225824
    ],
    [
        112.86790537584,
        22.88083764984
    ],
    [
        112.86795006623,
        22.880917718942
    ],
    [
        112.8679879624,
        22.881017851814
    ],
    [
        112.86803260431,
        22.881166545248
    ],
    [
        112.86807020314,
        22.881304652869
    ],
    [
        112.8681050979,
        22.881432180127
    ],
    [
        112.86811100629,
        22.881515727291
    ],
    [
        112.86811665606,
        22.88158137301
    ],
    [
        112.86812714013,
        22.881716189444
    ],
    [
        112.86812239853,
        22.881910112124
    ],
    [
        112.86812587146,
        22.881988231548
    ],
    [
        112.86813580633,
        22.882136609259
    ],
    [
        112.86812888823,
        22.882346260807
    ],
    [
        112.86812712624,
        22.882553207942
    ],
    [
        112.86814735227,
        22.882728724718
    ],
    [
        112.86816840423,
        22.882886613251
    ],
    [
        112.86819355113,
        22.883002738751
    ],
    [
        112.86823008153,
        22.88312946066
    ],
    [
        112.8683026561,
        22.88329367195
    ],
    [
        112.86834651389,
        22.883412544237
    ],
    [
        112.86837925938,
        22.883522177627
    ],
    [
        112.8684350416,
        22.883653821996
    ],
    [
        112.86848649611,
        22.88376728892
    ],
    [
        112.86855639829,
        22.883866688249
    ],
    [
        112.8686257548,
        22.883970973375
    ],
    [
        112.86873387452,
        22.88409568327
    ],
    [
        112.86883441897,
        22.884188382265
    ],
    [
        112.86904986514,
        22.8843890308
    ],
    [
        112.86919728064,
        22.884535849095
    ],
    [
        112.86933277572,
        22.884660686704
    ],
    [
        112.86946581606,
        22.884807233731
    ],
    [
        112.86957690778,
        22.884928239313
    ],
    [
        112.86973053162,
        22.885105255482
    ],
    [
        112.86982968892,
        22.885230320789
    ],
    [
        112.8699326224,
        22.885389854371
    ],
    [
        112.86998787465,
        22.885487945535
    ],
    [
        112.87003741828,
        22.885616400013
    ],
    [
        112.87004662188,
        22.885642739897
    ],
    [
        112.87008668085,
        22.885765198961
    ],
    [
        112.87010937608,
        22.885916896415
    ],
    [
        112.87012342519,
        22.886012419234
    ],
    [
        112.87012041572,
        22.886068284862
    ],
    [
        112.87011250159,
        22.886175941386
    ],
    [
        112.87008940397,
        22.886290058171
    ],
    [
        112.87004597374,
        22.886407093436
    ],
    [
        112.87001690596,
        22.88653638229
    ],
    [
        112.87001143767,
        22.886635910584
    ],
    [
        112.87000082571,
        22.886721046765
    ],
    [
        112.8700100001,
        22.886814383398
    ],
    [
        112.87002297667,
        22.88689335651
    ],
    [
        112.87005789649,
        22.887006577265
    ],
    [
        112.87011963591,
        22.887161658747
    ],
    [
        112.87013399763,
        22.887174997074
    ],
    [
        112.87021390977,
        22.887307359902
    ],
    [
        112.87033338169,
        22.887480010197
    ],
    [
        112.87048944431,
        22.88765850222
    ],
    [
        112.87067531421,
        22.887852590614
    ],
    [
        112.87083626607,
        22.887988565584
    ],
    [
        112.87104436632,
        22.888147542893
    ],
    [
        112.87105981218,
        22.888156286751
    ],
    [
        112.87119448802,
        22.88823144649
    ],
    [
        112.87141750466,
        22.888332782679
    ],
    [
        112.87165433885,
        22.888422022328
    ],
    [
        112.87195131891,
        22.888526527227
    ],
    [
        112.87218271112,
        22.888616394767
    ],
    [
        112.87240758726,
        22.888715768844
    ],
    [
        112.87260047683,
        22.888827216779
    ],
    [
        112.87278253546,
        22.888900932584
    ],
    [
        112.87299301838,
        22.889030179053
    ],
    [
        112.87324332385,
        22.889152654207
    ],
    [
        112.8734700491,
        22.88927422197
    ],
    [
        112.87364340734,
        22.889362125849
    ],
    [
        112.87381946258,
        22.889472044934
    ],
    [
        112.87392699185,
        22.88953134926
    ],
    [
        112.87397709269,
        22.889579696769
    ],
    [
        112.87405536295,
        22.8896385452
    ],
    [
        112.87415692134,
        22.889721429158
    ],
    [
        112.87432970272,
        22.889862326187
    ],
    [
        112.87448380202,
        22.889961884726
    ],
    [
        112.87460025777,
        22.89002538428
    ],
    [
        112.87466985649,
        22.890073089865
    ],
    [
        112.87475624576,
        22.890128247505
    ],
    [
        112.87486727205,
        22.890217502351
    ],
    [
        112.87506278658,
        22.89036003468
    ],
    [
        112.87519168152,
        22.89045705217
    ],
    [
        112.87530216268,
        22.890534137376
    ],
    [
        112.87545787025,
        22.890612949592
    ],
    [
        112.87565554849,
        22.890702431181
    ],
    [
        112.87589627951,
        22.890791490316
    ],
    [
        112.87608799004,
        22.890866887677
    ],
    [
        112.87628213324,
        22.890936911209
    ],
    [
        112.87647681708,
        22.890986626208
    ],
    [
        112.876611931,
        22.891008441516
    ],
    [
        112.87675326848,
        22.891035210438
    ],
    [
        112.87681554289,
        22.891045811967
    ],
    [
        112.87701617282,
        22.891070710355
    ],
    [
        112.87730992989,
        22.891111982955
    ],
    [
        112.87747507681,
        22.891138516855
    ],
    [
        112.87763210399,
        22.891137867551
    ],
    [
        112.87777071679,
        22.891141667244
    ],
    [
        112.87787007795,
        22.8911204073
    ],
    [
        112.87797512227,
        22.891100839421
    ],
    [
        112.87812375715,
        22.891050797756
    ],
    [
        112.87826941679,
        22.890977414748
    ],
    [
        112.87839070986,
        22.890906237334
    ],
    [
        112.87856940493,
        22.890770569786
    ],
    [
        112.87871534585,
        22.890624272105
    ],
    [
        112.87884667315,
        22.890458846865
    ],
    [
        112.87899316372,
        22.890270541756
    ],
    [
        112.87920328022,
        22.890015134495
    ],
    [
        112.87943180428,
        22.889740977131
    ],
    [
        112.87966871316,
        22.889471564385
    ],
    [
        112.87987907904,
        22.889248544175
    ],
    [
        112.88003448419,
        22.889077543116
    ],
    [
        112.88026108792,
        22.888835781131
    ],
    [
        112.88041348916,
        22.888725275596
    ],
    [
        112.88057428193,
        22.888601052758
    ],
    [
        112.8807082782,
        22.888485748298
    ],
    [
        112.88092157205,
        22.888337512374
    ],
    [
        112.8809857238,
        22.888287299261
    ],
    [
        112.88112944977,
        22.888187071093
    ],
    [
        112.88144315927,
        22.887942500617
    ],
    [
        112.88164914789,
        22.887752235493
    ],
    [
        112.88184889403,
        22.887598808198
    ],
    [
        112.88208842173,
        22.887414727794
    ],
    [
        112.88227408012,
        22.887284500813
    ],
    [
        112.88249842873,
        22.887141514808
    ],
    [
        112.88273224728,
        22.886984310905
    ],
    [
        112.88293819806,
        22.886821883244
    ],
    [
        112.88314657211,
        22.886675518021
    ],
    [
        112.88330298571,
        22.886564542672
    ],
    [
        112.88343098239,
        22.88647570394
    ],
    [
        112.88359279783,
        22.886373238618
    ],
    [
        112.88374568928,
        22.886260085841
    ],
    [
        112.88393834801,
        22.886134756893
    ],
    [
        112.88411801002,
        22.886028523463
    ],
    [
        112.88430335595,
        22.885908827407
    ],
    [
        112.88440508992,
        22.88584708206
    ],
    [
        112.88452252,
        22.88576739505
    ],
    [
        112.88459665329,
        22.885724793107
    ],
    [
        112.88476358297,
        22.885635800486
    ],
    [
        112.88492347432,
        22.885553501238
    ],
    [
        112.88502790278,
        22.885499967164
    ],
    [
        112.88514071836,
        22.885439238826
    ],
    [
        112.88528194272,
        22.885356424261
    ],
    [
        112.88541396033,
        22.885291385136
    ],
    [
        112.88557275719,
        22.885214820376
    ],
    [
        112.88569773679,
        22.885155120153
    ],
    [
        112.88584380879,
        22.885096830666
    ],
    [
        112.88599339539,
        22.885036977621
    ],
    [
        112.8861697471,
        22.884987850311
    ],
    [
        112.88631148456,
        22.884931969518
    ],
    [
        112.88647700962,
        22.884890839801
    ],
    [
        112.88665984355,
        22.884841853489
    ],
    [
        112.88674747483,
        22.884815001912
    ],
    [
        112.88687757176,
        22.884768742888
    ],
    [
        112.88698710976,
        22.884733291171
    ],
    [
        112.88705364586,
        22.884707478649
    ],
    [
        112.88713450556,
        22.88469545463
    ],
    [
        112.88718156805,
        22.884675579066
    ],
    [
        112.88724754829,
        22.884674446254
    ],
    [
        112.88734570842,
        22.884669754196
    ],
    [
        112.88751363357,
        22.884661288588
    ],
    [
        112.88764613251,
        22.884655797422
    ],
    [
        112.88769074926,
        22.884653795024
    ],
    [
        112.88774862711,
        22.884630848283
    ],
    [
        112.88788114333,
        22.884590380642
    ],
    [
        112.88807177773,
        22.884574722956
    ],
    [
        112.88819642141,
        22.884583239859
    ],
    [
        112.88833754596,
        22.884611558746
    ],
    [
        112.88846190895,
        22.884633646027
    ],
    [
        112.88859058907,
        22.884669371463
    ],
    [
        112.88872763835,
        22.88472504027
    ],
    [
        112.88886738958,
        22.884781574073
    ],
    [
        112.88908444222,
        22.884878716172
    ],
    [
        112.88934448971,
        22.884957599732
    ],
    [
        112.88960480999,
        22.885024034126
    ],
    [
        112.88985674487,
        22.885090622051
    ],
    [
        112.89010084391,
        22.885142180508
    ],
    [
        112.8903316909,
        22.88519651745
    ],
    [
        112.89050603616,
        22.885245573928
    ],
    [
        112.89070417894,
        22.885277412592
    ],
    [
        112.8909461092,
        22.885318145565
    ],
    [
        112.89114613895,
        22.88535112546
    ],
    [
        112.89132967983,
        22.885377865755
    ],
    [
        112.89149619681,
        22.885388861224
    ],
    [
        112.89172081899,
        22.88542500511
    ],
    [
        112.89189463456,
        22.88543044614
    ],
    [
        112.89199654565,
        22.885431394461
    ],
    [
        112.89215171297,
        22.885425673212
    ],
    [
        112.89228822456,
        22.885425057916
    ],
    [
        112.89256557773,
        22.885410352091
    ],
    [
        112.892840764,
        22.885398335594
    ],
    [
        112.89312946016,
        22.88539172287
    ],
    [
        112.89327407291,
        22.885396970444
    ],
    [
        112.89349194794,
        22.885384250488
    ],
    [
        112.89391660893,
        22.885363517815
    ],
    [
        112.89418637842,
        22.885350377438
    ],
    [
        112.89437343809,
        22.885330086078
    ],
    [
        112.89457481664,
        22.885321443975
    ],
    [
        112.8947610649,
        22.885299518009
    ],
    [
        112.89497974969,
        22.885275186763
    ],
    [
        112.89519086466,
        22.885252352115
    ],
    [
        112.89529412829,
        22.885233842913
    ],
    [
        112.89533846487,
        22.885219441021
    ],
    [
        112.89551011895,
        22.885190756026
    ],
    [
        112.8956733955,
        22.88515866863
    ],
    [
        112.89593074088,
        22.885115507318
    ],
    [
        112.89612428731,
        22.885088571942
    ],
    [
        112.89637136168,
        22.885044416801
    ],
    [
        112.89652842506,
        22.885005169897
    ],
    [
        112.89669331379,
        22.884989660033
    ],
    [
        112.89690415692,
        22.884966830386
    ],
    [
        112.89702688385,
        22.884944059828
    ],
    [
        112.89727666108,
        22.884901577947
    ],
    [
        112.89744696791,
        22.884865818469
    ],
    [
        112.8976270026,
        22.88483565523
    ],
    [
        112.89775054611,
        22.88480448714
    ],
    [
        112.89789463013,
        22.884777480022
    ],
    [
        112.89802385255,
        22.884742613176
    ],
    [
        112.89816225822,
        22.884720384856
    ],
    [
        112.8983963566,
        22.884687372862
    ],
    [
        112.89853369097,
        22.884649660467
    ],
    [
        112.89861073476,
        22.884635834014
    ],
    [
        112.89879321977,
        22.88458182836
    ],
    [
        112.8990089625,
        22.884511588949
    ],
    [
        112.8991476427,
        22.884487452795
    ],
    [
        112.89932958611,
        22.884439935448
    ],
    [
        112.89959264514,
        22.884354780149
    ],
    [
        112.89975782098,
        22.884325943701
    ],
    [
        112.89990678392,
        22.884288953138
    ],
    [
        112.9000105981,
        22.884264459941
    ],
    [
        112.90008279046,
        22.88423263131
    ],
    [
        112.90024475067,
        22.88416168339
    ],
    [
        112.90045373535,
        22.884110264997
    ],
    [
        112.90054485214,
        22.884077132258
    ],
    [
        112.90072303099,
        22.884012690114
    ],
    [
        112.90093472941,
        22.88395126298
    ],
    [
        112.90116617212,
        22.88387606269
    ],
    [
        112.90136490245,
        22.883809780517
    ],
    [
        112.90154093196,
        22.883735775876
    ],
    [
        112.90166343125,
        22.883671967137
    ],
    [
        112.9018024152,
        22.883618743635
    ],
    [
        112.90202198317,
        22.883529188038
    ],
    [
        112.90220612514,
        22.883462615072
    ],
    [
        112.90234672972,
        22.883418892186
    ],
    [
        112.90253710312,
        22.883336947421
    ],
    [
        112.90269719156,
        22.883268314758
    ],
    [
        112.90287513689,
        22.88318098806
    ],
    [
        112.9029633063,
        22.883126593838
    ],
    [
        112.9032099541,
        22.88299510414
    ],
    [
        112.90333489835,
        22.882934803669
    ],
    [
        112.90362102571,
        22.882804209424
    ],
    [
        112.90383385956,
        22.882719032225
    ],
    [
        112.90411675796,
        22.882582097283
    ],
    [
        112.90426794529,
        22.882510523171
    ],
    [
        112.90446160422,
        22.882409253139
    ],
    [
        112.90464526443,
        22.882304823545
    ],
    [
        112.90480945598,
        22.882206034298
    ],
    [
        112.90491224175,
        22.882150458853
    ],
    [
        112.90505207765,
        22.882087064844
    ],
    [
        112.90531364113,
        22.881955896335
    ],
    [
        112.90553842383,
        22.88184229035
    ],
    [
        112.90583325949,
        22.881711861671
    ],
    [
        112.90612135079,
        22.881570711789
    ],
    [
        112.90635425619,
        22.881468272025
    ],
    [
        112.90655093567,
        22.881357385323
    ],
    [
        112.90671867954,
        22.881251191857
    ],
    [
        112.90694135226,
        22.881108389402
    ],
    [
        112.90700712317,
        22.881034526773
    ],
    [
        112.90706802263,
        22.880966284282
    ],
    [
        112.9072323043,
        22.88080141127
    ],
    [
        112.90735113061,
        22.880667850083
    ],
    [
        112.90743612814,
        22.880566595964
    ],
    [
        112.90749541959,
        22.880483941516
    ],
    [
        112.90759992878,
        22.880334149793
    ],
    [
        112.90760915534,
        22.880293331181
    ],
    [
        112.90761487123,
        22.880245679743
    ],
    [
        112.90761088133,
        22.880158013737
    ],
    [
        112.90761747783,
        22.880020598843
    ],
    [
        112.90764163715,
        22.879905956359
    ],
    [
        112.90766253844,
        22.879808081535
    ],
    [
        112.90769154301,
        22.879724159068
    ],
    [
        112.90773300726,
        22.879617094768
    ],
    [
        112.90775550452,
        22.879554773481
    ],
    [
        112.90778585642,
        22.879478463985
    ],
    [
        112.90781998047,
        22.87942065305
    ],
    [
        112.9078660197,
        22.879344573334
    ],
    [
        112.90793858294,
        22.879246098678
    ],
    [
        112.9080360465,
        22.879127372145
    ],
    [
        112.90817895581,
        22.879002792436
    ],
    [
        112.90830508592,
        22.878893419005
    ],
    [
        112.90842986492,
        22.878785102445
    ],
    [
        112.90862500915,
        22.878631947386
    ],
    [
        112.90880850552,
        22.878505186119
    ],
    [
        112.90912596977,
        22.878299191594
    ],
    [
        112.90917687432,
        22.878239149581
    ],
    [
        112.90939011454,
        22.878143120346
    ],
    [
        112.90966343456,
        22.878024562982
    ],
    [
        112.91001254006,
        22.877873352877
    ],
    [
        112.91032563452,
        22.877774750292
    ],
    [
        112.91050099497,
        22.877719029341
    ],
    [
        112.91078896307,
        22.877601832937
    ],
    [
        112.9110920782,
        22.877503220898
    ],
    [
        112.91145826406,
        22.877389340802
    ],
    [
        112.91170213004,
        22.877310475351
    ],
    [
        112.91198502377,
        22.877170208322
    ],
    [
        112.91232722476,
        22.876993712213
    ],
    [
        112.91258878589,
        22.876829476559
    ],
    [
        112.91278160776,
        22.876675513646
    ],
    [
        112.91292869422,
        22.876525607744
    ],
    [
        112.9131094063,
        22.87630582486
    ],
    [
        112.91325006034,
        22.876094787357
    ],
    [
        112.91340081264,
        22.875795160008
    ],
    [
        112.91354910256,
        22.875530747956
    ],
    [
        112.91366871309,
        22.875259495216
    ],
    [
        112.91376336906,
        22.875049797375
    ],
    [
        112.9139507717,
        22.874653686754
    ],
    [
        112.91407179071,
        22.874337392612
    ],
    [
        112.91424517614,
        22.873895256131
    ],
    [
        112.91429296917,
        22.873735742941
    ],
    [
        112.91441622886,
        22.873354079168
    ],
    [
        112.91449386963,
        22.873124083423
    ],
    [
        112.91457747772,
        22.87288383882
    ],
    [
        112.91464636586,
        22.872750568382
    ],
    [
        112.91479424598,
        22.872397601671
    ],
    [
        112.91495627737,
        22.871975058499
    ],
    [
        112.91506705368,
        22.871648538632
    ],
    [
        112.91525803701,
        22.871254182323
    ],
    [
        112.91537985409,
        22.870995819779
    ],
    [
        112.9155161043,
        22.870657033899
    ],
    [
        112.91559021246,
        22.870462741075
    ],
    [
        112.91567378686,
        22.870279653767
    ],
    [
        112.91573781925,
        22.870145466469
    ],
    [
        112.91583224367,
        22.869945384781
    ],
    [
        112.91600397129,
        22.869612846083
    ],
    [
        112.91613964129,
        22.869330401441
    ],
    [
        112.9162785587,
        22.869053395807
    ],
    [
        112.91645375526,
        22.86878564735
    ],
    [
        112.91663029214,
        22.868536599696
    ],
    [
        112.91705628769,
        22.867982087317
    ],
    [
        112.91737839869,
        22.867611826263
    ],
    [
        112.91771759844,
        22.867233748209
    ],
    [
        112.91803811661,
        22.866867637511
    ],
    [
        112.91834749725,
        22.86654963498
    ],
    [
        112.91846058639,
        22.866417832326
    ],
    [
        112.91862598469,
        22.866259810725
    ],
    [
        112.91892043054,
        22.866006642842
    ],
    [
        112.91924473069,
        22.865715354861
    ],
    [
        112.91953729524,
        22.865478019559
    ],
    [
        112.9199096158,
        22.865158367495
    ],
    [
        112.92016315186,
        22.864964575661
    ],
    [
        112.92037441152,
        22.864787308763
    ],
    [
        112.92075435005,
        22.864491017442
    ],
    [
        112.92114108522,
        22.864198427726
    ],
    [
        112.92147409468,
        22.863994146808
    ],
    [
        112.92195416398,
        22.86365531946
    ],
    [
        112.9223485203,
        22.86341278647
    ],
    [
        112.92266667771,
        22.863223007041
    ],
    [
        112.92304289423,
        22.863007011477
    ],
    [
        112.92340039672,
        22.862823379432
    ],
    [
        112.92377556479,
        22.862621231308
    ],
    [
        112.92412386361,
        22.862469613066
    ],
    [
        112.92451749646,
        22.862291657005
    ],
    [
        112.92464582103,
        22.862232482506
    ],
    [
        112.92481558932,
        22.862223530358
    ],
    [
        112.92503550511,
        22.862243366552
    ],
    [
        112.92524890899,
        22.862275084089
    ],
    [
        112.92550081563,
        22.862325507255
    ],
    [
        112.92585414823,
        22.862403595
    ],
    [
        112.92622103256,
        22.862515742316
    ],
    [
        112.92652635942,
        22.862631297056
    ],
    [
        112.9268216836,
        22.862729411173
    ],
    [
        112.92715578363,
        22.862863761496
    ],
    [
        112.92748068286,
        22.86299476255
    ],
    [
        112.92784629258,
        22.863135376857
    ],
    [
        112.92810477471,
        22.863243764048
    ],
    [
        112.92838579347,
        22.863351235326
    ],
    [
        112.92860686006,
        22.86345089063
    ],
    [
        112.92887513577,
        22.863571821011
    ],
    [
        112.9290785887,
        22.863664097064
    ],
    [
        112.92931785558,
        22.863776038647
    ],
    [
        112.929455131,
        22.863836144433
    ],
    [
        112.92957231044,
        22.863909851862
    ],
    [
        112.92963985205,
        22.863952776652
    ],
    [
        112.92971008056,
        22.864023352628
    ],
    [
        112.92973150085,
        22.864045798159
    ],
    [
        112.92981474236,
        22.864133142791
    ],
    [
        112.92988226807,
        22.864194494953
    ],
    [
        112.9299080274,
        22.864221533793
    ],
    [
        112.92987976432,
        22.864253898003
    ],
    [
        112.92978168187,
        22.864344789553
    ],
    [
        112.92962217388,
        22.864517760341
    ],
    [
        112.92943630147,
        22.864730920444
    ],
    [
        112.92925121661,
        22.864976049719
    ],
    [
        112.92909764754,
        22.865194763053
    ],
    [
        112.92893923049,
        22.865381463173
    ],
    [
        112.92886364575,
        22.865515342414
    ],
    [
        112.92878485393,
        22.865602032776
    ],
    [
        112.92866174288,
        22.865771528903
    ],
    [
        112.92846011663,
        22.866029847075
    ],
    [
        112.92828240364,
        22.866262864565
    ],
    [
        112.92817589217,
        22.866397833363
    ],
    [
        112.92806936607,
        22.866549064362
    ],
    [
        112.92796231923,
        22.866681029688
    ],
    [
        112.92783351492,
        22.866864000506
    ],
    [
        112.92769304928,
        22.867044257601
    ],
    [
        112.92756290108,
        22.867221231195
    ],
    [
        112.92747623641,
        22.867330887677
    ],
    [
        112.92730832481,
        22.867562651144
    ],
    [
        112.92714500188,
        22.867822591495
    ],
    [
        112.92708114789,
        22.867918098075
    ],
    [
        112.9270197411,
        22.868008988972
    ],
    [
        112.92693851338,
        22.868116700965
    ],
    [
        112.92682658885,
        22.868265913835
    ],
    [
        112.92664155482,
        22.868549652603
    ],
    [
        112.92650517837,
        22.868741959325
    ],
    [
        112.92648533185,
        22.868784811892
    ],
    [
        112.92643425327,
        22.868863193315
    ],
    [
        112.92628998669,
        22.869084221361
    ],
    [
        112.92614954758,
        22.869280008531
    ],
    [
        112.92602835585,
        22.869490701527
    ],
    [
        112.92587970357,
        22.869768899084
    ],
    [
        112.9257810815,
        22.869929944043
    ],
    [
        112.92569088744,
        22.870073357082
    ],
    [
        112.92560067789,
        22.870233849001
    ],
    [
        112.92551482823,
        22.870375894718
    ],
    [
        112.92548222779,
        22.870429566577
    ],
    [
        112.92545126143,
        22.870476729844
    ],
    [
        112.92533743233,
        22.870665926753
    ],
    [
        112.92531568945,
        22.87071173942
    ],
    [
        112.92524992996,
        22.870838325737
    ],
    [
        112.92518851969,
        22.870955963094
    ],
    [
        112.92506792548,
        22.87113698766
    ],
    [
        112.92498561797,
        22.871272487046
    ],
    [
        112.92494349485,
        22.871361116497
    ],
    [
        112.92487720457,
        22.871481712965
    ],
    [
        112.92484105566,
        22.871563295526
    ],
    [
        112.9247631005,
        22.87168956331
    ],
    [
        112.92468865919,
        22.87182884947
    ],
    [
        112.92462019709,
        22.871955936006
    ],
    [
        112.92452321302,
        22.872133956457
    ],
    [
        112.92442677992,
        22.872305460223
    ],
    [
        112.92433199642,
        22.87245607522
    ],
    [
        112.92426163282,
        22.872592628201
    ],
    [
        112.92418881584,
        22.87274381719
    ],
    [
        112.92410513955,
        22.872910166083
    ],
    [
        112.92406221329,
        22.872997675206
    ],
    [
        112.92402229186,
        22.873062678521
    ],
    [
        112.92396305847,
        22.873191100782
    ],
    [
        112.92388072999,
        22.873370725322
    ],
    [
        112.92378947443,
        22.873531065681
    ],
    [
        112.92368296197,
        22.873770826049
    ],
    [
        112.92361502283,
        22.87393636418
    ],
    [
        112.92351964709,
        22.874159864977
    ],
    [
        112.92344901092,
        22.874313994696
    ],
    [
        112.92339522312,
        22.87442775607
    ],
    [
        112.92335448198,
        22.874506836277
    ],
    [
        112.92333354678,
        22.874570512504
    ],
    [
        112.92330530269,
        22.874622504935
    ],
    [
        112.92329604498,
        22.874665330435
    ],
    [
        112.9232835224,
        22.874720622359
    ],
    [
        112.92324820021,
        22.874804596366
    ],
    [
        112.92318028739,
        22.874951665529
    ],
    [
        112.92310610561,
        22.875136681812
    ],
    [
        112.92301431123,
        22.87531431494
    ],
    [
        112.92293145351,
        22.875504716689
    ],
    [
        112.92284455187,
        22.875672859078
    ],
    [
        112.92273429648,
        22.875888378608
    ],
    [
        112.92268321572,
        22.876018930695
    ],
    [
        112.92254640733,
        22.876226745522
    ],
    [
        112.92245651302,
        22.876417629577
    ],
    [
        112.9223606895,
        22.876572683266
    ],
    [
        112.92230367552,
        22.87667580275
    ],
    [
        112.92223660094,
        22.87681576647
    ],
    [
        112.92216546268,
        22.876954896614
    ],
    [
        112.92213152182,
        22.877022839133
    ],
    [
        112.92205472654,
        22.877124240234
    ],
    [
        112.92198713469,
        22.877241133315
    ],
    [
        112.92191846648,
        22.877350423692
    ],
    [
        112.92185683919,
        22.87746814738
    ],
    [
        112.9217786387,
        22.877634074392
    ],
    [
        112.9217045291,
        22.877772349216
    ],
    [
        112.92164372753,
        22.877879758522
    ],
    [
        112.92155607975,
        22.878006030247
    ],
    [
        112.92144154001,
        22.87820757216
    ],
    [
        112.92137041155,
        22.878354246778
    ],
    [
        112.92135325351,
        22.878455604322
    ],
    [
        112.9213366428,
        22.878550997319
    ],
    [
        112.9213319723,
        22.878627731647
    ],
    [
        112.92131861253,
        22.878725309475
    ],
    [
        112.92132450411,
        22.878811586178
    ],
    [
        112.92132004964,
        22.878956669997
    ],
    [
        112.92130805522,
        22.879042862902
    ],
    [
        112.92129059082,
        22.879191140297
    ],
    [
        112.9212859272,
        22.879261365403
    ],
    [
        112.9212853543,
        22.879299876571
    ],
    [
        112.92127760159,
        22.879505970702
    ],
    [
        112.92127260853,
        22.879651052462
    ],
    [
        112.9212592433,
        22.879760021691
    ],
    [
        112.92125944158,
        22.879852781725
    ],
    [
        112.92124529329,
        22.879924318083
    ],
    [
        112.92122490534,
        22.880004503755
    ],
    [
        112.92120992436,
        22.88010207346
    ],
    [
        112.92119766215,
        22.880188807035
    ],
    [
        112.92117996124,
        22.880300195958
    ],
    [
        112.92117254983,
        22.88042356831
    ],
    [
        112.92116022072,
        22.880600077447
    ],
    [
        112.92114408738,
        22.880791756978
    ],
    [
        112.92111630263,
        22.880983108633
    ],
    [
        112.92109558688,
        22.881145201823
    ],
    [
        112.92107953566,
        22.881230017643
    ],
    [
        112.92106861277,
        22.881343608708
    ],
    [
        112.92104955596,
        22.881463397955
    ],
    [
        112.92103238019,
        22.881606250756
    ],
    [
        112.92101680999,
        22.881778946642
    ],
    [
        112.92099367898,
        22.881914988911
    ],
    [
        112.92097570317,
        22.882043190945
    ],
    [
        112.92096509137,
        22.882104707091
    ],
    [
        112.92095773259,
        22.882164883324
    ],
    [
        112.92095143482,
        22.882258426193
    ],
    [
        112.920934046,
        22.882323976588
    ],
    [
        112.92091366404,
        22.88240768409
    ],
    [
        112.92090738984,
        22.882468136846
    ]
];

let xiqiao = [
    [
        112.98654856932,
        22.985420496226
    ],
    [
        112.98654206248,
        22.985416970651
    ],
    [
        112.98656761441,
        22.985365440191
    ],
    [
        112.98662332885,
        22.985262923712
    ],
    [
        112.98671412023,
        22.985077423637
    ],
    [
        112.98680655501,
        22.984874845249
    ],
    [
        112.98692151264,
        22.984661704576
    ],
    [
        112.98700386322,
        22.984502533555
    ],
    [
        112.98707396809,
        22.98438106136
    ],
    [
        112.98717013374,
        22.984237097317
    ],
    [
        112.98725242738,
        22.984129746484
    ],
    [
        112.98730023654,
        22.984058720381
    ],
    [
        112.98730837427,
        22.984057912272
    ],
    [
        112.98741101611,
        22.98394218005
    ],
    [
        112.98753970778,
        22.983811835225
    ],
    [
        112.98764393639,
        22.983731384022
    ],
    [
        112.98784477853,
        22.983585419414
    ],
    [
        112.98807163599,
        22.983450647682
    ],
    [
        112.98826780839,
        22.983347335456
    ],
    [
        112.98845611752,
        22.983236179931
    ],
    [
        112.98862024576,
        22.983165150347
    ],
    [
        112.98883046877,
        22.983090444158
    ],
    [
        112.98893709278,
        22.983029107425
    ],
    [
        112.9890212,
        22.982977493488
    ],
    [
        112.98911373091,
        22.982906378599
    ],
    [
        112.98921412303,
        22.982835290791
    ],
    [
        112.9893215702,
        22.982756636247
    ],
    [
        112.98943986028,
        22.982677749822
    ],
    [
        112.98957034621,
        22.982600537285
    ],
    [
        112.98965064063,
        22.982556012967
    ],
    [
        112.98971763154,
        22.98252935579
    ],
    [
        112.98987168889,
        22.982459570888
    ],
    [
        112.990036299,
        22.982405029356
    ],
    [
        112.99019195942,
        22.982349397804
    ],
    [
        112.99035845693,
        22.982295182284
    ],
    [
        112.99050977611,
        22.982234427686
    ],
    [
        112.99061688796,
        22.982193597828
    ],
    [
        112.9906887267,
        22.982186003079
    ],
    [
        112.99077846441,
        22.982168176215
    ],
    [
        112.99086848177,
        22.982140322902
    ],
    [
        112.99094656512,
        22.982118937877
    ],
    [
        112.9910477226,
        22.98206103953
    ],
    [
        112.99111607303,
        22.98201277633
    ],
    [
        112.99116434756,
        22.981982874761
    ],
    [
        112.99125790175,
        22.9819352696
    ],
    [
        112.99137747752,
        22.981882905234
    ],
    [
        112.99149541937,
        22.981835699406
    ],
    [
        112.99163287202,
        22.981788054243
    ],
    [
        112.99175866013,
        22.981748235611
    ],
    [
        112.99191292291,
        22.98168578848
    ],
    [
        112.99202109609,
        22.981639946521
    ],
    [
        112.99212086952,
        22.981591088897
    ],
    [
        112.99225018241,
        22.981538054052
    ],
    [
        112.99236866573,
        22.981472500725
    ],
    [
        112.9924866048,
        22.981406685703
    ],
    [
        112.99260156287,
        22.981338696853
    ],
    [
        112.99273305853,
        22.981259150518
    ],
    [
        112.99287946703,
        22.981165873352
    ],
    [
        112.99300281984,
        22.9810941766
    ],
    [
        112.99311397523,
        22.981024861287
    ],
    [
        112.99326794611,
        22.980945239933
    ],
    [
        112.99339805685,
        22.980880136305
    ],
    [
        112.99352083952,
        22.980825307226
    ],
    [
        112.9936314249,
        22.980773938689
    ],
    [
        112.99374580991,
        22.980713384247
    ],
    [
        112.99383390611,
        22.980661617532
    ],
    [
        112.9939260644,
        22.980609884634
    ],
    [
        112.99403610557,
        22.980552855705
    ],
    [
        112.99413257095,
        22.980525306485
    ],
    [
        112.99425831668,
        22.980471118479
    ],
    [
        112.99437484736,
        22.980419319857
    ],
    [
        112.99446456557,
        22.980360831996
    ],
    [
        112.99447702309,
        22.980363633133
    ],
    [
        112.99465158749,
        22.980238236659
    ],
    [
        112.99480336216,
        22.980145513606
    ],
    [
        112.99495703613,
        22.980045230364
    ],
    [
        112.99511448128,
        22.979961811364
    ],
    [
        112.99529657874,
        22.979867757639
    ],
    [
        112.99546268024,
        22.979785266148
    ],
    [
        112.99566184992,
        22.979669164609
    ],
    [
        112.99580383419,
        22.979591134633
    ],
    [
        112.99596506005,
        22.979494840026
    ],
    [
        112.99613007336,
        22.979397785428
    ],
    [
        112.99622628598,
        22.979315618019
    ],
    [
        112.9963650287,
        22.979215114528
    ],
    [
        112.99651326418,
        22.979095182989
    ],
    [
        112.99665149045,
        22.978961347449
    ],
    [
        112.99682112953,
        22.978820218404
    ],
    [
        112.99696747304,
        22.978684321928
    ],
    [
        112.99711082772,
        22.978555466245
    ],
    [
        112.9972520192,
        22.978419825979
    ],
    [
        112.99736286265,
        22.978306423059
    ],
    [
        112.99745420608,
        22.978197724417
    ],
    [
        112.99756832876,
        22.978047756386
    ],
    [
        112.99763581192,
        22.977973284432
    ],
    [
        112.99768947384,
        22.977912784096
    ],
    [
        112.99775477594,
        22.977852942805
    ],
    [
        112.99791326384,
        22.977731648846
    ],
    [
        112.99805468167,
        22.977621864756
    ],
    [
        112.99820639206,
        22.977502436879
    ],
    [
        112.99836080355,
        22.977385224125
    ],
    [
        112.99843773609,
        22.977327706585
    ],
    [
        112.99854285637,
        22.977230889435
    ],
    [
        112.99871977251,
        22.977063506878
    ],
    [
        112.99883246698,
        22.976966521407
    ],
    [
        112.99896331668,
        22.976845601934
    ],
    [
        112.99910257769,
        22.976699020542
    ],
    [
        112.99924889222,
        22.97653083311
    ],
    [
        112.99934509832,
        22.976398179755
    ],
    [
        112.99945594366,
        22.976237217588
    ],
    [
        112.99955864777,
        22.976097599549
    ],
    [
        112.99967163853,
        22.975953494221
    ],
    [
        112.99977784657,
        22.975825323058
    ],
    [
        112.99988971312,
        22.97572299059
    ],
    [
        113.00005982324,
        22.975553804413
    ],
    [
        113.00017412368,
        22.975447454283
    ],
    [
        113.00031145474,
        22.975307209301
    ],
    [
        113.00038703487,
        22.975219950594
    ],
    [
        113.00048726948,
        22.975099085049
    ],
    [
        113.00059155273,
        22.97498830992
    ],
    [
        113.00069067244,
        22.974900805468
    ],
    [
        113.00079846642,
        22.974794155592
    ],
    [
        113.00092575923,
        22.974667137551
    ],
    [
        113.00105007486,
        22.974537653032
    ],
    [
        113.00115355152,
        22.974409007147
    ],
    [
        113.00127057361,
        22.974259109461
    ],
    [
        113.0013415554,
        22.974154755652
    ],
    [
        113.00149105111,
        22.973995243879
    ],
    [
        113.00161590354,
        22.97385631992
    ],
    [
        113.00174616128,
        22.973721543141
    ],
    [
        113.0018433861,
        22.973612121638
    ],
    [
        113.00189728813,
        22.973540122486
    ],
    [
        113.00199560923,
        22.973410382638
    ],
    [
        113.00206929639,
        22.97329443435
    ],
    [
        113.0021519278,
        22.973157449823
    ],
    [
        113.00223862753,
        22.973006147548
    ],
    [
        113.00234099324,
        22.972885160944
    ],
    [
        113.00240139351,
        22.972800245079
    ],
    [
        113.00246423701,
        22.972703972125
    ],
    [
        113.00255767497,
        22.972577457253
    ],
    [
        113.00262647576,
        22.9724717764
    ],
    [
        113.00269041419,
        22.972355455862
    ],
    [
        113.00276299731,
        22.972253899433
    ],
    [
        113.00284694148,
        22.97215276965
    ],
    [
        113.00290572426,
        22.972052661934
    ],
    [
        113.00300052482,
        22.971902593622
    ],
    [
        113.00307338166,
        22.971791018963
    ],
    [
        113.0031324279,
        22.971696347257
    ],
    [
        113.00317198721,
        22.971613075262
    ],
    [
        113.00322590491,
        22.971501520847
    ],
    [
        113.00327522263,
        22.971390447691
    ],
    [
        113.00331506412,
        22.971289281653
    ],
    [
        113.00336896773,
        22.971193733938
    ],
    [
        113.00342665739,
        22.971098782415
    ],
    [
        113.00347082124,
        22.971003103906
    ],
    [
        113.00353500388,
        22.970905261911
    ],
    [
        113.00360868259,
        22.970767140589
    ],
    [
        113.00366799169,
        22.970672761895
    ],
    [
        113.00370591076,
        22.970605481631
    ],
    [
        113.00376009763,
        22.970484996582
    ],
    [
        113.00382727117,
        22.970359541357
    ],
    [
        113.00385627261,
        22.970277493043
    ],
    [
        113.00389096989,
        22.970173012839
    ],
    [
        113.00394815535,
        22.970014602915
    ],
    [
        113.00399719852,
        22.969894052439
    ],
    [
        113.00404411838,
        22.96971271723
    ],
    [
        113.0041089131,
        22.969495833136
    ],
    [
        113.00413981235,
        22.969401610353
    ],
    [
        113.00417854552,
        22.969322145773
    ],
    [
        113.00421404176,
        22.969228531859
    ],
    [
        113.00424304317,
        22.969138894683
    ],
    [
        113.00428289861,
        22.968995708239
    ],
    [
        113.00438612958,
        22.968723235573
    ],
    [
        113.00444899396,
        22.968546748541
    ],
    [
        113.00449613179,
        22.968429166702
    ],
    [
        113.00453919557,
        22.968337294702
    ],
    [
        113.00455818428,
        22.968248602846
    ],
    [
        113.00459801957,
        22.968127120916
    ],
    [
        113.00463487751,
        22.968007766616
    ],
    [
        113.0046860559,
        22.967911403969
    ],
    [
        113.00473403338,
        22.967739321259
    ],
    [
        113.00479768687,
        22.967583741508
    ],
    [
        113.00484266425,
        22.96744904831
    ],
    [
        113.00489656282,
        22.967319910896
    ],
    [
        113.00495721881,
        22.967196298422
    ],
    [
        113.00502059253,
        22.967047773682
    ],
    [
        113.00505445761,
        22.966946827006
    ],
    [
        113.00507939404,
        22.966850903268
    ],
    [
        113.00512165667,
        22.966724041999
    ],
    [
        113.00516877651,
        22.966615697345
    ],
    [
        113.00520372767,
        22.966502291939
    ],
    [
        113.00525383137,
        22.96637473516
    ],
    [
        113.00527606455,
        22.966270636383
    ],
    [
        113.00532834496,
        22.966114904474
    ],
    [
        113.00537980753,
        22.965968926302
    ],
    [
        113.0054282968,
        22.965817209045
    ],
    [
        113.00548355171,
        22.9656542014
    ],
    [
        113.00550874427,
        22.965573204263
    ],
    [
        113.00553340874,
        22.965465617797
    ],
    [
        113.00554997114,
        22.96533349877
    ],
    [
        113.00559765631,
        22.965155462308
    ],
    [
        113.00563207707,
        22.965000283785
    ],
    [
        113.00565404525,
        22.964868246006
    ],
    [
        113.00570440883,
        22.964737176687
    ],
    [
        113.0057271701,
        22.964641226767
    ],
    [
        113.00576401213,
        22.964504802035
    ],
    [
        113.00578190618,
        22.964404439446
    ],
    [
        113.0058044187,
        22.964255051117
    ],
    [
        113.00580988012,
        22.964133886761
    ],
    [
        113.00582457261,
        22.963925791456
    ],
    [
        113.00583305152,
        22.963696444992
    ],
    [
        113.00583663074,
        22.963539989638
    ],
    [
        113.00584588497,
        22.963391214535
    ],
    [
        113.00587544816,
        22.963172221258
    ],
    [
        113.00589282305,
        22.962996172358
    ],
    [
        113.00591803426,
        22.962833261657
    ],
    [
        113.00593677385,
        22.962613562084
    ],
    [
        113.00595955316,
        22.962435424556
    ],
    [
        113.00597664442,
        22.962278629605
    ],
    [
        113.0059975177,
        22.962130300624
    ],
    [
        113.00601675666,
        22.962014496962
    ],
    [
        113.00603383021,
        22.961902458017
    ],
    [
        113.0060601146,
        22.961736851136
    ],
    [
        113.00610451039,
        22.961591592247
    ],
    [
        113.006128888,
        22.961462847064
    ],
    [
        113.00615270667,
        22.961392955278
    ],
    [
        113.006163281,
        22.961298449202
    ],
    [
        113.00616384493,
        22.961217895732
    ],
    [
        113.00618415622,
        22.961115129098
    ],
    [
        113.00621582865,
        22.960998973205
    ],
    [
        113.00625858675,
        22.960887055811
    ],
    [
        113.00630757547,
        22.960730477582
    ],
    [
        113.00635845177,
        22.960589390698
    ],
    [
        113.00640769839,
        22.960472150263
    ],
    [
        113.00649021858,
        22.960302527855
    ],
    [
        113.0065713806,
        22.96014997653
    ],
    [
        113.00666281825,
        22.959990263076
    ],
    [
        113.0067721012,
        22.959830558879
    ],
    [
        113.00686515385,
        22.959685797659
    ],
    [
        113.00697794737,
        22.959526700419
    ],
    [
        113.00699958635,
        22.959495030015
    ],
    [
        113.00707775558,
        22.959384765789
    ],
    [
        113.00713969774,
        22.959282658568
    ],
    [
        113.00718459807,
        22.959210937406
    ],
    [
        113.007228962,
        22.959111269024
    ],
    [
        113.00731038192,
        22.95894220037
    ],
    [
        113.0073923388,
        22.958784264439
    ],
    [
        113.00749539714,
        22.95854121846
    ],
    [
        113.00753435013,
        22.958428449081
    ],
    [
        113.00758276519,
        22.958323154485
    ],
    [
        113.00763064032,
        22.958204560401
    ],
    [
        113.00771124013,
        22.958016774136
    ],
    [
        113.00783213796,
        22.957707566009
    ],
    [
        113.00792760516,
        22.957491541123
    ],
    [
        113.00802009123,
        22.957322942724
    ],
    [
        113.00811690224,
        22.957138683822
    ],
    [
        113.00815124866,
        22.957017710705
    ],
    [
        113.00819911718,
        22.95682235823
    ],
    [
        113.00822210859,
        22.956622806893
    ],
    [
        113.00824049832,
        22.956518937855
    ],
    [
        113.00825537047,
        22.956482014668
    ],
    [
        113.00829755124,
        22.95643305479
    ],
    [
        113.00839218701,
        22.956304379219
    ],
    [
        113.00858821318,
        22.956032499547
    ],
    [
        113.00870609569,
        22.955800318066
    ],
    [
        113.00887237032,
        22.955585210042
    ],
    [
        113.00895672133,
        22.955426274213
    ],
    [
        113.00904323356,
        22.955273344188
    ],
    [
        113.00915840204,
        22.955113836092
    ],
    [
        113.00924788496,
        22.954972896772
    ],
    [
        113.00940954442,
        22.954712711823
    ],
    [
        113.00949361479,
        22.954560838974
    ],
    [
        113.00958173909,
        22.954413647351
    ],
    [
        113.00964256049,
        22.954316730953
    ],
    [
        113.00968499982,
        22.954248806506
    ],
    [
        113.00971230035,
        22.954193922348
    ],
    [
        113.00979285277,
        22.954068311839
    ],
    [
        113.00987529437,
        22.95392401708
    ],
    [
        113.00993638031,
        22.953808935177
    ],
    [
        113.00997719061,
        22.953704636492
    ],
    [
        113.01000935039,
        22.953610230198
    ],
    [
        113.01005718704,
        22.953495741826
    ],
    [
        113.0101731368,
        22.95329016633
    ],
    [
        113.01026880811,
        22.953086151549
    ],
    [
        113.01033366974,
        22.952956219731
    ],
    [
        113.01037718123,
        22.952873944104
    ],
    [
        113.01041501339,
        22.952781264496
    ],
    [
        113.01044879337,
        22.95270859112
    ],
    [
        113.01048716354,
        22.952606426596
    ],
    [
        113.01052526348,
        22.95250832697
    ],
    [
        113.01056498823,
        22.952428430751
    ],
    [
        113.01061174217,
        22.952353265838
    ],
    [
        113.0106711905,
        22.952222433868
    ],
    [
        113.01072307194,
        22.952109107201
    ],
    [
        113.01076927752,
        22.952005179375
    ],
    [
        113.01080467093,
        22.951909748965
    ],
    [
        113.01082600825,
        22.951822217904
    ],
    [
        113.01085544679,
        22.951697659656
    ],
    [
        113.01088974275,
        22.951540088201
    ],
    [
        113.01091890549,
        22.951400876332
    ],
    [
        113.01096455216,
        22.951241057099
    ],
    [
        113.01099777869,
        22.951145590887
    ],
    [
        113.01102182068,
        22.951077909942
    ],
    [
        113.01102910405,
        22.951018081325
    ],
    [
        113.01104691376,
        22.950896851735
    ],
    [
        113.01105606933,
        22.950765165558
    ],
    [
        113.01106144931,
        22.950668952604
    ],
    [
        113.01107440625,
        22.950601896168
    ],
    [
        113.01109953163,
        22.95054861181
    ],
    [
        113.01113735406,
        22.95046706014
    ],
    [
        113.01117031127,
        22.950389223471
    ],
    [
        113.01121597221,
        22.950307264034
    ],
    [
        113.01129244607,
        22.950213082931
    ],
    [
        113.01137350322,
        22.950081816143
    ],
    [
        113.01145834291,
        22.949948174294
    ],
    [
        113.01153751781,
        22.949855671691
    ],
    [
        113.01159858267,
        22.949769912012
    ],
    [
        113.01166937772,
        22.949681879312
    ],
    [
        113.01174152664,
        22.94960255218
    ],
    [
        113.01183500753,
        22.94945685869
    ],
    [
        113.01195037557,
        22.94929119926
    ],
    [
        113.01205304709,
        22.949154350103
    ],
    [
        113.01217624897,
        22.948984491106
    ],
    [
        113.01225486402,
        22.948859707852
    ],
    [
        113.01232942486,
        22.948738924563
    ],
    [
        113.01238885034,
        22.948626017574
    ],
    [
        113.01248909042,
        22.948509481222
    ],
    [
        113.01257661708,
        22.948373192402
    ],
    [
        113.01268521603,
        22.948210957722
    ],
    [
        113.01278921897,
        22.948051086304
    ],
    [
        113.01285917649,
        22.947926431317
    ],
    [
        113.01294481178,
        22.947804221724
    ],
    [
        113.01300856665,
        22.947717440228
    ],
    [
        113.01325170124,
        22.947400767574
    ],
    [
        113.01346482465,
        22.947081947943
    ],
    [
        113.0136463353,
        22.946802185921
    ],
    [
        113.01374789322,
        22.946646626254
    ],
    [
        113.01396047431,
        22.946354125418
    ],
    [
        113.01407338748,
        22.946212605861
    ],
    [
        113.01417306598,
        22.946092828398
    ],
    [
        113.0144259102,
        22.945799150874
    ],
    [
        113.01462739331,
        22.945505111186
    ],
    [
        113.01475028475,
        22.94533556099
    ],
    [
        113.01498471613,
        22.945006300082
    ],
    [
        113.01520269228,
        22.944744031387
    ],
    [
        113.01543741295,
        22.944465242636
    ],
    [
        113.01560863898,
        22.944232260618
    ],
    [
        113.01581362276,
        22.943957015412
    ],
    [
        113.0160007998,
        22.943740054363
    ],
    [
        113.01615421855,
        22.943571054967
    ],
    [
        113.01628602503,
        22.94342120428
    ],
    [
        113.01645074301,
        22.943173186979
    ],
    [
        113.01658388605,
        22.943004368934
    ],
    [
        113.01671024208,
        22.942791750359
    ],
    [
        113.0169046373,
        22.942472094211
    ],
    [
        113.01716652825,
        22.942047016848
    ],
    [
        113.01752209106,
        22.94146434789
    ],
    [
        113.01788627185,
        22.940855506816
    ],
    [
        113.0179920958,
        22.940679411238
    ],
    [
        113.01808303399,
        22.940478090285
    ],
    [
        113.01823498102,
        22.940176925463
    ],
    [
        113.01833460543,
        22.940028389391
    ],
    [
        113.01841290526,
        22.939917728413
    ],
    [
        113.01852115355,
        22.93973760042
    ],
    [
        113.01862073704,
        22.939538868782
    ],
    [
        113.01871459802,
        22.939282788807
    ],
    [
        113.01885761248,
        22.938979283926
    ],
    [
        113.01898820856,
        22.938697803994
    ],
    [
        113.01910370533,
        22.938464619206
    ],
    [
        113.01925999363,
        22.938205020781
    ],
    [
        113.01936877349,
        22.938024075528
    ],
    [
        113.01946998169,
        22.937840010747
    ],
    [
        113.0195730625,
        22.937633729806
    ],
    [
        113.01972743686,
        22.937354009053
    ],
    [
        113.01980654004,
        22.937242803982
    ],
    [
        113.0198899854,
        22.937152022264
    ],
    [
        113.01999367641,
        22.937029850693
    ],
    [
        113.02016835208,
        22.93678628643
    ],
    [
        113.02037111066,
        22.936510377806
    ],
    [
        113.02054331208,
        22.936221177212
    ],
    [
        113.02070663458,
        22.935979566937
    ],
    [
        113.02089180813,
        22.935689222359
    ],
    [
        113.02105836878,
        22.935442500583
    ],
    [
        113.0212522327,
        22.935197600375
    ],
    [
        113.02146286986,
        22.934967088258
    ],
    [
        113.02157465796,
        22.934831726437
    ],
    [
        113.02169939411,
        22.934666467756
    ],
    [
        113.02185789654,
        22.934474922989
    ],
    [
        113.0220393857,
        22.93429244597
    ],
    [
        113.0222788948,
        22.934001064395
    ],
    [
        113.02246090469,
        22.933794970419
    ],
    [
        113.02277983346,
        22.933437884184
    ],
    [
        113.02298341215,
        22.933167280515
    ],
    [
        113.02317729229,
        22.932930687125
    ],
    [
        113.02333476536,
        22.932785993166
    ],
    [
        113.02346763631,
        22.932639796522
    ],
    [
        113.02364315679,
        22.932424301488
    ],
    [
        113.02380867495,
        22.932208359171
    ],
    [
        113.02396612308,
        22.932032971746
    ],
    [
        113.02421380598,
        22.931787969079
    ],
    [
        113.02444634166,
        22.93153265815
    ],
    [
        113.02466592726,
        22.9313023492
    ],
    [
        113.02467402576,
        22.931289457145
    ],
    [
        113.02311568878,
        22.92994570993
    ],
    [
        113.02300771495,
        22.929839442056
    ],
    [
        113.02261725492,
        22.929481507984
    ],
    [
        113.02259696296,
        22.929464885829
    ],
    [
        113.02260210518,
        22.929470670459
    ],
    [
        113.02255774286,
        22.929443602236
    ],
    [
        113.0224435865,
        22.92936895543
    ],
    [
        113.02225018308,
        22.929253888022
    ],
    [
        113.02223476467,
        22.929244400919
    ],
    [
        113.02214142291,
        22.929167113869
    ],
    [
        113.02204676427,
        22.929123716762
    ],
    [
        113.02200403295,
        22.929104266366
    ],
    [
        113.02200619092,
        22.929099690801
    ],
    [
        113.02237290459,
        22.92844581595
    ],
    [
        113.0224077013,
        22.928370979796
    ],
    [
        113.02223511674,
        22.92825979171
    ],
    [
        113.02221077005,
        22.928243098305
    ],
    [
        113.02202790945,
        22.92812657033
    ],
    [
        113.02193270237,
        22.928075292685
    ],
    [
        113.02190294699,
        22.92805606292
    ],
    [
        113.02205759432,
        22.927811533097
    ],
    [
        113.02210861094,
        22.927737790444
    ],
    [
        113.02202393213,
        22.927672857319
    ],
    [
        113.02178290359,
        22.927507571844
    ],
    [
        113.02168169684,
        22.927403820616
    ],
    [
        113.02134334229,
        22.92722327126
    ],
    [
        113.02114833956,
        22.927120873258
    ],
    [
        113.02093846887,
        22.927016038398
    ],
    [
        113.02090111928,
        22.926970623232
    ],
    [
        113.02086658673,
        22.926772504066
    ],
    [
        113.02083232974,
        22.926579544478
    ],
    [
        113.02081438432,
        22.926477217048
    ],
    [
        113.02080240976,
        22.926398326653
    ],
    [
        113.02094757106,
        22.926402201322
    ],
    [
        113.02098965074,
        22.92631529438
    ],
    [
        113.02102767989,
        22.926232386706
    ],
    [
        113.02105976877,
        22.926155887566
    ],
    [
        113.02122782211,
        22.92581177576
    ],
    [
        113.02136047378,
        22.925476000884
    ],
    [
        113.02141412901,
        22.925341265906
    ],
    [
        113.02143483494,
        22.925235265458
    ],
    [
        113.02142823158,
        22.925122283056
    ],
    [
        113.02138776317,
        22.924935732482
    ],
    [
        113.02129943769,
        22.924738317413
    ],
    [
        113.02099616692,
        22.924231406555
    ],
    [
        113.02071161836,
        22.923788832436
    ],
    [
        113.02057106021,
        22.923525650322
    ],
    [
        113.02051417159,
        22.923403651588
    ],
    [
        113.02043142559,
        22.923105658462
    ],
    [
        113.02036710643,
        22.922852210585
    ],
    [
        113.02035762799,
        22.922834680827
    ],
    [
        113.02020116289,
        22.922875901746
    ],
    [
        113.02008738651,
        22.922897245232
    ],
    [
        113.0200371257,
        22.922912644564
    ],
    [
        113.02002009961,
        22.92291560226
    ],
    [
        113.01993633377,
        22.922943165866
    ],
    [
        113.01932810291,
        22.92315333
    ],
    [
        113.01932429778,
        22.923132642765
    ],
    [
        113.0192443591,
        22.922933985459
    ],
    [
        113.01876227477,
        22.923053533497
    ],
    [
        113.01876145343,
        22.923043208874
    ],
    [
        113.01875874825,
        22.923040990473
    ],
    [
        113.01868918424,
        22.922943441629
    ],
    [
        113.01861312999,
        22.922842521548
    ],
    [
        113.01859904849,
        22.922816496987
    ],
    [
        113.01858145807,
        22.922795293994
    ],
    [
        113.0185844264,
        22.922790462834
    ],
    [
        113.01860577079,
        22.922781887297
    ],
    [
        113.01860116971,
        22.922775836827
    ],
    [
        113.01850346382,
        22.922646586743
    ],
    [
        113.01847988835,
        22.922587021693
    ],
    [
        113.0184728371,
        22.922563563397
    ],
    [
        113.01847283683,
        22.922563292074
    ],
    [
        113.0184714547,
        22.922532879964
    ],
    [
        113.0185006144,
        22.922501381111
    ],
    [
        113.01850653712,
        22.922477881379
    ],
    [
        113.01850680687,
        22.922477343522
    ],
    [
        113.01851704039,
        22.92244008294
    ],
    [
        113.01851324832,
        22.922432147539
    ],
    [
        113.0185026879,
        22.922413239506
    ],
    [
        113.01848504514,
        22.922339942389
    ],
    [
        113.01848369421,
        22.922340461088
    ],
    [
        113.0184701267,
        22.922287856323
    ],
    [
        113.0184113219,
        22.922137046672
    ],
    [
        113.01839531642,
        22.922078972261
    ],
    [
        113.01838259672,
        22.922063010337
    ],
    [
        113.01838799692,
        22.9220574084
    ],
    [
        113.01837769981,
        22.922031450662
    ],
    [
        113.01838767,
        22.922000968514
    ],
    [
        113.0183922574,
        22.921993452942
    ],
    [
        113.01838143279,
        22.921980509109
    ],
    [
        113.01834839634,
        22.92191969084
    ],
    [
        113.01833351296,
        22.92190233391
    ],
    [
        113.01833108003,
        22.921902019449
    ],
    [
        113.0183348639,
        22.921901815231
    ],
    [
        113.01832997629,
        22.92187948051
    ],
    [
        113.01832241101,
        22.921882330844
    ],
    [
        113.01832348811,
        22.921878280181
    ],
    [
        113.01831262984,
        22.9218316923
    ],
    [
        113.01831392782,
        22.921778265749
    ],
    [
        113.01824057869,
        22.921406887643
    ],
    [
        113.01822675393,
        22.921366758718
    ],
    [
        113.01822807031,
        22.921331510821
    ],
    [
        113.01821370338,
        22.921289744365
    ],
    [
        113.01820963601,
        22.921276648966
    ],
    [
        113.01817277483,
        22.921174250889
    ],
    [
        113.01817573891,
        22.921165078707
    ],
    [
        113.01816844149,
        22.921165491835
    ],
    [
        113.01817302654,
        22.921155534469
    ],
    [
        113.01821841883,
        22.92113897565
    ],
    [
        113.01823220226,
        22.921137592298
    ],
    [
        113.01830933985,
        22.921243146413
    ],
    [
        113.01833856466,
        22.921276765386
    ],
    [
        113.01854628838,
        22.921145602145
    ],
    [
        113.01865109656,
        22.92107990003
    ],
    [
        113.01892661172,
        22.920894037024
    ],
    [
        113.01902655326,
        22.920825802669
    ],
    [
        113.01920835125,
        22.920713429829
    ],
    [
        113.01926993604,
        22.920670019658
    ],
    [
        113.01939175692,
        22.92058561587
    ],
    [
        113.0191858512,
        22.920371987834
    ],
    [
        113.01894748144,
        22.920127122065
    ],
    [
        113.01880597918,
        22.919985164196
    ],
    [
        113.01860121022,
        22.919823634575
    ],
    [
        113.0181865623,
        22.919522991532
    ],
    [
        113.01778455113,
        22.919148218651
    ],
    [
        113.01759328601,
        22.918969548035
    ],
    [
        113.01707248655,
        22.918448307233
    ],
    [
        113.01653091386,
        22.917961146603
    ],
    [
        113.01629469871,
        22.917688065977
    ],
    [
        113.01606146278,
        22.917419922924
    ],
    [
        113.01576924637,
        22.917087243945
    ],
    [
        113.0156036609,
        22.916901974133
    ],
    [
        113.0152525476,
        22.916594842758
    ],
    [
        113.01482246153,
        22.916233411717
    ],
    [
        113.01468533738,
        22.916136562379
    ],
    [
        113.01459594741,
        22.916222068657
    ],
    [
        113.01459163142,
        22.916231759393
    ],
    [
        113.01458919779,
        22.916230631005
    ],
    [
        113.01452682118,
        22.916298438842
    ],
    [
        113.01450357837,
        22.916301011442
    ],
    [
        113.01444551678,
        22.916358043752
    ],
    [
        113.01437069777,
        22.916415864979
    ],
    [
        113.01426644346,
        22.916503281667
    ],
    [
        113.01427915334,
        22.916510018056
    ],
    [
        113.01440250222,
        22.916615300297
    ],
    [
        113.01420778107,
        22.916791734759
    ],
    [
        113.01391825103,
        22.917038940203
    ],
    [
        113.01389069584,
        22.917055275283
    ],
    [
        113.0138939392,
        22.91705506121
    ],
    [
        113.01367671142,
        22.91715378703
    ],
    [
        113.01347466413,
        22.917301080298
    ],
    [
        113.01334236383,
        22.917459372147
    ],
    [
        113.0129117082,
        22.917680538093
    ],
    [
        113.01287928991,
        22.917700048143
    ],
    [
        113.01276230251,
        22.917758505938
    ],
    [
        113.01262666931,
        22.917823152456
    ],
    [
        113.01220384215,
        22.918043154522
    ],
    [
        113.0121111635,
        22.918083871395
    ],
    [
        113.01224768012,
        22.918379803578
    ],
    [
        113.0121817442,
        22.918400906457
    ],
    [
        113.01213878064,
        22.918417796383
    ],
    [
        113.01204069752,
        22.918460320173
    ],
    [
        113.01199827076,
        22.918473422295
    ],
    [
        113.01194854995,
        22.918491282243
    ],
    [
        113.01187451318,
        22.918522287998
    ],
    [
        113.01183127593,
        22.918536191637
    ],
    [
        113.01177318102,
        22.918560420419
    ],
    [
        113.01176858711,
        22.918561968989
    ],
    [
        113.01171427293,
        22.918582465432
    ],
    [
        113.01163725825,
        22.918609625448
    ],
    [
        113.01160483373,
        22.918623989061
    ],
    [
        113.01156402784,
        22.918636852032
    ],
    [
        113.01153836131,
        22.918651332528
    ],
    [
        113.01144945715,
        22.918683989026
    ],
    [
        113.01140973305,
        22.918697686076
    ],
    [
        113.01136730586,
        22.918711608423
    ],
    [
        113.0113243426,
        22.9187304057
    ],
    [
        113.01130218434,
        22.91873897896
    ],
    [
        113.01129542228,
        22.918734793244
    ],
    [
        113.01128893468,
        22.918734953292
    ],
    [
        113.0112223957,
        22.918693658043
    ],
    [
        113.01064987103,
        22.918441336785
    ],
    [
        113.01022740726,
        22.918230975123
    ],
    [
        113.01004819327,
        22.917967497328
    ],
    [
        113.01004413552,
        22.917964716018
    ],
    [
        113.00993728711,
        22.917608857562
    ],
    [
        113.00991666127,
        22.917523319174
    ],
    [
        113.00997744626,
        22.917185738445
    ],
    [
        113.01013391112,
        22.916822365205
    ],
    [
        113.01031313071,
        22.91650822051
    ],
    [
        113.01055191227,
        22.916291682328
    ],
    [
        113.01062854369,
        22.916132093775
    ],
    [
        113.01047716374,
        22.91614010895
    ],
    [
        113.01014361528,
        22.916194438959
    ],
    [
        113.00985978371,
        22.916226573493
    ],
    [
        113.00974787483,
        22.91624288015
    ],
    [
        113.0096978643,
        22.916247200153
    ],
    [
        113.00964676634,
        22.916244991345
    ],
    [
        113.00963513869,
        22.916242084405
    ],
    [
        113.00958454855,
        22.916203529216
    ],
    [
        113.00953691125,
        22.91614169112
    ],
    [
        113.00950095075,
        22.91613756612
    ],
    [
        113.00945255131,
        22.916130521855
    ],
    [
        113.00937172135,
        22.916137048839
    ],
    [
        113.00928143759,
        22.916153731503
    ],
    [
        113.00920168471,
        22.916156482682
    ],
    [
        113.00919573846,
        22.916158283653
    ],
    [
        113.00918411264,
        22.916157820347
    ],
    [
        113.00918276619,
        22.916163766992
    ],
    [
        113.00911652388,
        22.916158875607
    ],
    [
        113.00908944565,
        22.916111763492
    ],
    [
        113.00892090267,
        22.915687371887
    ],
    [
        113.00884742502,
        22.915450396496
    ],
    [
        113.00874440442,
        22.915128290949
    ],
    [
        113.00850410011,
        22.915190571925
    ],
    [
        113.00843165762,
        22.915210557098
    ],
    [
        113.00832134685,
        22.914901372997
    ],
    [
        113.00820863203,
        22.914624441274
    ],
    [
        113.00803561782,
        22.914658551642
    ],
    [
        113.00795343555,
        22.914675138116
    ],
    [
        113.00778339443,
        22.914712027003
    ],
    [
        113.00765417823,
        22.914746864438
    ],
    [
        113.00744494281,
        22.914803773347
    ],
    [
        113.00735087055,
        22.914833757906
    ],
    [
        113.00722005747,
        22.914903593247
    ],
    [
        113.00717572977,
        22.914924601074
    ],
    [
        113.00712485845,
        22.914883376828
    ],
    [
        113.00700713282,
        22.914767853146
    ],
    [
        113.00699901539,
        22.91476175736
    ],
    [
        113.00693700839,
        22.914664201975
    ],
    [
        113.00692751819,
        22.914633938371
    ],
    [
        113.00692804461,
        22.914617125322
    ],
    [
        113.00698560367,
        22.914572986703
    ],
    [
        113.00709694507,
        22.914496049781
    ],
    [
        113.00733045338,
        22.914356742823
    ],
    [
        113.00746991272,
        22.914279454291
    ],
    [
        113.00770347127,
        22.914207742106
    ],
    [
        113.00779890901,
        22.914196513954
    ],
    [
        113.00782539658,
        22.914184185863
    ],
    [
        113.00783348706,
        22.914159083449
    ],
    [
        113.00779393435,
        22.914068376208
    ],
    [
        113.00779608201,
        22.914049961468
    ],
    [
        113.00772262734,
        22.913834996777
    ],
    [
        113.00766164268,
        22.913657673804
    ],
    [
        113.00763102144,
        22.91357633626
    ],
    [
        113.00762043231,
        22.913522991236
    ],
    [
        113.00752036772,
        22.913167886436
    ],
    [
        113.00739863092,
        22.912757910998
    ],
    [
        113.00729478672,
        22.912401401217
    ],
    [
        113.0072912532,
        22.912378013101
    ],
    [
        113.00719395602,
        22.912091066411
    ],
    [
        113.00710864015,
        22.911910664303
    ],
    [
        113.0071007765,
        22.911882053818
    ],
    [
        113.00703303374,
        22.91169650437
    ],
    [
        113.0069850829,
        22.911579092866
    ],
    [
        113.00696799469,
        22.911509371607
    ],
    [
        113.00696743918,
        22.911489828938
    ],
    [
        113.00695850074,
        22.911469884011
    ],
    [
        113.00697065722,
        22.911454066911
    ],
    [
        113.00698498389,
        22.911447508182
    ],
    [
        113.00699309559,
        22.911446821081
    ],
    [
        113.00705716597,
        22.91142557673
    ],
    [
        113.00706392639,
        22.911425953941
    ],
    [
        113.0070758207,
        22.911421256827
    ],
    [
        113.00708041926,
        22.911423499344
    ],
    [
        113.00745027978,
        22.911360143969
    ],
    [
        113.00748382911,
        22.911387263405
    ],
    [
        113.00751331021,
        22.911398040478
    ],
    [
        113.00754523031,
        22.911416181884
    ],
    [
        113.00761825314,
        22.911438504184
    ],
    [
        113.00765043624,
        22.911447155516
    ],
    [
        113.00766936914,
        22.911454510962
    ],
    [
        113.00767531598,
        22.91145216395
    ],
    [
        113.00769802947,
        22.911453068532
    ],
    [
        113.00771290253,
        22.911455204809
    ],
    [
        113.00774399466,
        22.911451631269
    ],
    [
        113.0077667005,
        22.911442498087
    ],
    [
        113.00778858882,
        22.911424941595
    ],
    [
        113.00781291266,
        22.911410137296
    ],
    [
        113.0078348064,
        22.911399906553
    ],
    [
        113.00784534067,
        22.911385424627
    ],
    [
        113.00785534369,
        22.911383685583
    ],
    [
        113.00787291882,
        22.911383695657
    ],
    [
        113.00791294088,
        22.911390305598
    ],
    [
        113.0079556681,
        22.911398858739
    ],
    [
        113.00797054307,
        22.911403980982
    ],
    [
        113.00798813001,
        22.911419999075
    ],
    [
        113.00800842547,
        22.911442300836
    ],
    [
        113.00802033061,
        22.911453344375
    ],
    [
        113.00802654949,
        22.911453444343
    ],
    [
        113.0080316852,
        22.911451356469
    ],
    [
        113.00806170514,
        22.911461335003
    ],
    [
        113.00809117772,
        22.911462623318
    ],
    [
        113.00811713463,
        22.911463041417
    ],
    [
        113.00814687666,
        22.911463249511
    ],
    [
        113.00817419534,
        22.911476984115
    ],
    [
        113.00820259346,
        22.911488023393
    ],
    [
        113.00821043597,
        22.911490049172
    ],
    [
        113.00822152265,
        22.91149158477
    ],
    [
        113.00828181707,
        22.911491745573
    ],
    [
        113.008313182,
        22.911493338404
    ],
    [
        113.00832939562,
        22.911481392221
    ],
    [
        113.00834344356,
        22.911465884085
    ],
    [
        113.00836315238,
        22.91142767815
    ],
    [
        113.00837468234,
        22.911298723894
    ],
    [
        113.00837222032,
        22.911260158689
    ],
    [
        113.00837869975,
        22.911247241119
    ],
    [
        113.00839951566,
        22.911243237872
    ],
    [
        113.00842168806,
        22.911245496822
    ],
    [
        113.00844871575,
        22.911232370449
    ],
    [
        113.00847974669,
        22.911148498914
    ],
    [
        113.00853043456,
        22.910954798077
    ],
    [
        113.00856791853,
        22.910820570241
    ],
    [
        113.0086054074,
        22.910692311832
    ],
    [
        113.00861159437,
        22.910648461513
    ],
    [
        113.00860452629,
        22.910594899477
    ],
    [
        113.00861126523,
        22.910566522482
    ],
    [
        113.00860016574,
        22.910546536377
    ],
    [
        113.00859276056,
        22.910398826702
    ],
    [
        113.00858734731,
        22.910390599389
    ],
    [
        113.0085884117,
        22.91036647076
    ],
    [
        113.00860885627,
        22.910219486532
    ],
    [
        113.00860776335,
        22.910203190549
    ],
    [
        113.00861288258,
        22.910177771562
    ],
    [
        113.00862150246,
        22.910132061984
    ],
    [
        113.00871672923,
        22.909823518244
    ],
    [
        113.00876044753,
        22.909704589057
    ],
    [
        113.00880716883,
        22.909627761605
    ],
    [
        113.0088344756,
        22.909627395077
    ],
    [
        113.00886475379,
        22.909623279331
    ],
    [
        113.00889477166,
        22.909634081233
    ],
    [
        113.00897752964,
        22.909673151497
    ],
    [
        113.00903701916,
        22.909687423953
    ],
    [
        113.0090383745,
        22.909692600996
    ],
    [
        113.00907136234,
        22.909698027679
    ],
    [
        113.00911516077,
        22.909697935659
    ],
    [
        113.0091475885,
        22.909675138631
    ],
    [
        113.0091681158,
        22.909645634258
    ],
    [
        113.00920701597,
        22.909599070247
    ],
    [
        113.00928506747,
        22.909477461395
    ],
    [
        113.00932368893,
        22.909418414569
    ],
    [
        113.00938096555,
        22.909360220178
    ],
    [
        113.00946602705,
        22.909209160911
    ],
    [
        113.00948086446,
        22.909160573319
    ],
    [
        113.00950623659,
        22.909098053321
    ],
    [
        113.00951835219,
        22.909021205483
    ],
    [
        113.00956286935,
        22.908881141365
    ],
    [
        113.00962605628,
        22.908764178316
    ],
    [
        113.0096503445,
        22.908696486985
    ],
    [
        113.00968301573,
        22.90863192003
    ],
    [
        113.00971512695,
        22.908536687299
    ],
    [
        113.00971701084,
        22.908523153793
    ],
    [
        113.00971673312,
        22.908511483293
    ],
    [
        113.00954069958,
        22.908456188768
    ],
    [
        113.00952528282,
        22.908445622959
    ],
    [
        113.00951148749,
        22.908433998993
    ],
    [
        113.00951499343,
        22.908420221042
    ],
    [
        113.00951063934,
        22.908374841727
    ],
    [
        113.00954843331,
        22.908285941773
    ],
    [
        113.00962942608,
        22.908103350198
    ],
    [
        113.00966961616,
        22.907952364665
    ],
    [
        113.00967609377,
        22.907934567056
    ],
    [
        113.00970258788,
        22.907934195252
    ],
    [
        113.00970285313,
        22.907925789445
    ],
    [
        113.00972389225,
        22.907846107835
    ],
    [
        113.0097597307,
        22.907648930614
    ],
    [
        113.00977234922,
        22.907500199393
    ],
    [
        113.00978252703,
        22.90733677759
    ],
    [
        113.00979084114,
        22.907221344314
    ],
    [
        113.00980487431,
        22.90717790028
    ],
    [
        113.00982000479,
        22.907162146887
    ],
    [
        113.00987323913,
        22.90711990182
    ],
    [
        113.00988377272,
        22.907102443993
    ],
    [
        113.00992589974,
        22.90701959074
    ],
    [
        113.00993698481,
        22.907021133056
    ],
    [
        113.00994292802,
        22.90701336513
    ],
    [
        113.00995234706,
        22.906937017693
    ],
    [
        113.00995314683,
        22.906916955232
    ],
    [
        113.00997276728,
        22.906710828599
    ],
    [
        113.00997132257,
        22.906541245037
    ],
    [
        113.0103781872,
        22.906540500477
    ],
    [
        113.01038002389,
        22.906437710879
    ],
    [
        113.01037893828,
        22.906429824991
    ],
    [
        113.0103771837,
        22.9061812899
    ],
    [
        113.01036664282,
        22.906185723754
    ],
    [
        113.0103704006,
        22.906134512728
    ],
    [
        113.01034931595,
        22.906137954585
    ],
    [
        113.0103438679,
        22.906059187391
    ],
    [
        113.0103457226,
        22.905986783359
    ],
    [
        113.01037569741,
        22.905923264609
    ],
    [
        113.01046809463,
        22.905809256622
    ],
    [
        113.01050699647,
        22.905756741977
    ],
    [
        113.01065075651,
        22.905640625296
    ],
    [
        113.01076130498,
        22.905604523288
    ],
    [
        113.01075562726,
        22.90560307024
    ],
    [
        113.0107964442,
        22.905596439891
    ],
    [
        113.01106398281,
        22.905417610094
    ],
    [
        113.01118612634,
        22.905326375583
    ],
    [
        113.01119963381,
        22.905308159098
    ],
    [
        113.01121719031,
        22.905277803911
    ],
    [
        113.01124177616,
        22.905249197042
    ],
    [
        113.01126311992,
        22.905224332826
    ],
    [
        113.01129203012,
        22.905193901392
    ],
    [
        113.01135094039,
        22.905150963123
    ],
    [
        113.01141499156,
        22.905118151856
    ],
    [
        113.01142282778,
        22.90511150424
    ],
    [
        113.01145390633,
        22.905093319379
    ],
    [
        113.01146715266,
        22.905094361026
    ],
    [
        113.01151471839,
        22.905071034369
    ],
    [
        113.01164740407,
        22.904981623434
    ],
    [
        113.01167281212,
        22.904977178314
    ],
    [
        113.01172685825,
        22.904939044865
    ],
    [
        113.01175712288,
        22.904915151135
    ],
    [
        113.01177657085,
        22.90488293208
    ],
    [
        113.01180060979,
        22.904841025971
    ],
    [
        113.01179708532,
        22.90481871926
    ],
    [
        113.01181221678,
        22.904804873577
    ],
    [
        113.01181789052,
        22.904798460644
    ],
    [
        113.01183221639,
        22.904796266602
    ],
    [
        113.01185951975,
        22.904798908898
    ],
    [
        113.01187168491,
        22.904800746985
    ],
    [
        113.01189033337,
        22.904793202072
    ],
    [
        113.01189735719,
        22.904783557107
    ],
    [
        113.01190762372,
        22.90477152664
    ],
    [
        113.01189437269,
        22.904759631928
    ],
    [
        113.01188706584,
        22.904741600383
    ],
    [
        113.01187192133,
        22.90472696009
    ],
    [
        113.01187380799,
        22.904714784653
    ],
    [
        113.01187244896,
        22.904698483737
    ],
    [
        113.01187299059,
        22.904700663425
    ],
    [
        113.01187298824,
        22.90469550887
    ],
    [
        113.01190810306,
        22.904637246267
    ],
    [
        113.01190728337,
        22.904617970493
    ],
    [
        113.01192375279,
        22.904573763892
    ],
    [
        113.01192238912,
        22.904546882597
    ],
    [
        113.01192561133,
        22.904498648771
    ],
    [
        113.01190692766,
        22.904427247617
    ],
    [
        113.01184956145,
        22.904293595033
    ],
    [
        113.01179056155,
        22.904130887223
    ],
    [
        113.01178812192,
        22.904115110331
    ],
    [
        113.01177621561,
        22.904086419367
    ],
    [
        113.01177188503,
        22.904073594009
    ],
    [
        113.01176945549,
        22.904081419426
    ],
    [
        113.0117616164,
        22.904081826638
    ],
    [
        113.01169314224,
        22.903884503264
    ],
    [
        113.01165625845,
        22.903591147516
    ],
    [
        113.01164187774,
        22.903456612344
    ],
    [
        113.01161774177,
        22.903258699443
    ],
    [
        113.01143333591,
        22.903139414956
    ],
    [
        113.01141084714,
        22.903001757633
    ],
    [
        113.01140082498,
        22.902947599521
    ],
    [
        113.01136827425,
        22.9026396739
    ],
    [
        113.01147126106,
        22.902620554817
    ],
    [
        113.01147179069,
        22.902589366145
    ],
    [
        113.01147584327,
        22.902582925004
    ],
    [
        113.01148341066,
        22.902578172035
    ],
    [
        113.01149151908,
        22.902574513527
    ],
    [
        113.01150205851,
        22.902565471162
    ],
    [
        113.01151503143,
        22.902558098412
    ],
    [
        113.01152800245,
        22.902545299972
    ],
    [
        113.01152746256,
        22.902547460959
    ],
    [
        113.01153232337,
        22.902533166526
    ],
    [
        113.01154016155,
        22.902529774749
    ],
    [
        113.01154718629,
        22.902519315576
    ],
    [
        113.01154015682,
        22.902516210425
    ],
    [
        113.0115420453,
        22.902505391544
    ],
    [
        113.01154312537,
        22.902501883435
    ],
    [
        113.0115401502,
        22.902497220376
    ],
    [
        113.01153771436,
        22.902488768617
    ],
    [
        113.01155744032,
        22.902466862885
    ],
    [
        113.0115728503,
        22.902471468813
    ],
    [
        113.01159096322,
        22.902475307508
    ],
    [
        113.01159717878,
        22.902469988894
    ],
    [
        113.01163231858,
        22.902464083617
    ],
    [
        113.01164151107,
        22.902468582632
    ],
    [
        113.01166232406,
        22.902463515786
    ],
    [
        113.01168232597,
        22.902458163768
    ],
    [
        113.0117012462,
        22.902451708043
    ],
    [
        113.01171827482,
        22.902447118751
    ],
    [
        113.01173827462,
        22.902435798698
    ],
    [
        113.01175124876,
        22.90243222469
    ],
    [
        113.01176097661,
        22.902421541267
    ],
    [
        113.01175908072,
        22.902410928433
    ],
    [
        113.01175745321,
        22.902394623261
    ],
    [
        113.01175988211,
        22.902382999967
    ],
    [
        113.01175176164,
        22.902351119483
    ],
    [
        113.01175283555,
        22.902329435276
    ],
    [
        113.01174309543,
        22.902304037683
    ],
    [
        113.01175037914,
        22.902259672817
    ],
    [
        113.01174686014,
        22.902245234005
    ],
    [
        113.01169898416,
        22.902157325587
    ],
    [
        113.01170436796,
        22.902088512389
    ],
    [
        113.01177030717,
        22.902030239486
    ],
    [
        113.01178030775,
        22.902026342947
    ],
    [
        113.01200655846,
        22.902008282465
    ],
    [
        113.01222523957,
        22.901994713542
    ],
    [
        113.01223740545,
        22.902000079253
    ],
    [
        113.01225919383,
        22.901658098639
    ],
    [
        113.01225053911,
        22.901642756437
    ],
    [
        113.01225080564,
        22.901630282072
    ],
    [
        113.01225106408,
        22.901590950607
    ],
    [
        113.01223751715,
        22.901486271583
    ],
    [
        113.01222262826,
        22.901412766812
    ],
    [
        113.01217856282,
        22.901398708847
    ],
    [
        113.01217315759,
        22.901402412966
    ],
    [
        113.01216558785,
        22.901399297474
    ],
    [
        113.01212659539,
        22.901164233552
    ],
    [
        113.01211117472,
        22.901118662087
    ],
    [
        113.01209844206,
        22.901017253423
    ],
    [
        113.01210734986,
        22.900970476325
    ],
    [
        113.012164634,
        22.900884931686
    ],
    [
        113.01222650554,
        22.900767727696
    ],
    [
        113.01225702756,
        22.900675751415
    ],
    [
        113.01225268706,
        22.900614366731
    ],
    [
        113.01224402016,
        22.90054666749
    ],
    [
        113.01221156383,
        22.900470959289
    ],
    [
        113.01214990856,
        22.90037385607
    ],
    [
        113.01205878813,
        22.900272716284
    ],
    [
        113.01195333995,
        22.900166989886
    ],
    [
        113.01191115481,
        22.900098440177
    ],
    [
        113.01189005641,
        22.900037580105
    ],
    [
        113.01188868335,
        22.899939082357
    ],
    [
        113.0119078448,
        22.899791567361
    ],
    [
        113.01191376416,
        22.899656031007
    ],
    [
        113.0119378054,
        22.899569638315
    ],
    [
        113.01194699298,
        22.899552978156
    ],
    [
        113.01196645338,
        22.899540022468
    ],
    [
        113.0120097013,
        22.899524766108
    ],
    [
        113.01213837199,
        22.899523741559
    ],
    [
        113.01234272997,
        22.899522680022
    ],
    [
        113.01252140837,
        22.899530674024
    ],
    [
        113.01268737812,
        22.899524074637
    ],
    [
        113.01281712243,
        22.899501655384
    ],
    [
        113.0128963167,
        22.899469402267
    ],
    [
        113.01292577853,
        22.899460151912
    ],
    [
        113.01297901884,
        22.89940520105
    ],
    [
        113.01298712151,
        22.899369805724
    ],
    [
        113.01300653218,
        22.899078252585
    ],
    [
        113.01299948489,
        22.898961751906
    ],
    [
        113.01297213062,
        22.898614854669
    ],
    [
        113.0129796476,
        22.89822923467
    ],
    [
        113.01295308393,
        22.897528886341
    ],
    [
        113.01293601723,
        22.897014529163
    ],
    [
        113.01290977547,
        22.89653961934
    ],
    [
        113.01289977094,
        22.896437989725
    ],
    [
        113.01290112231,
        22.896431502925
    ],
    [
        113.01286894904,
        22.896062286577
    ],
    [
        113.01286056891,
        22.895918639493
    ],
    [
        113.01287813912,
        22.895862523282
    ],
    [
        113.01290057481,
        22.89585938937
    ],
    [
        113.01292219958,
        22.89584728954
    ],
    [
        113.01301113121,
        22.895827145426
    ],
    [
        113.01311276701,
        22.89581048063
    ],
    [
        113.0131703425,
        22.895796028295
    ],
    [
        113.01320899643,
        22.895784228316
    ],
    [
        113.01330036009,
        22.895757892028
    ],
    [
        113.01345551534,
        22.89573946047
    ],
    [
        113.01356012308,
        22.895728822984
    ],
    [
        113.01358877552,
        22.895704913456
    ],
    [
        113.0136031019,
        22.895681294276
    ],
    [
        113.01359688653,
        22.895583257626
    ],
    [
        113.01359229323,
        22.895496100282
    ],
    [
        113.01358823994,
        22.895445573426
    ],
    [
        113.01360662096,
        22.895430977488
    ],
    [
        113.01372204034,
        22.895427857049
    ],
    [
        113.01401720953,
        22.895423028962
    ],
    [
        113.01415857642,
        22.895420915925
    ],
    [
        113.01441617152,
        22.895404044387
    ],
    [
        113.01464943908,
        22.895371014799
    ],
    [
        113.01477566841,
        22.895342600829
    ],
    [
        113.01481188835,
        22.89533456305
    ],
    [
        113.01484459472,
        22.895317782518
    ],
    [
        113.01485567778,
        22.895291395216
    ],
    [
        113.01485216564,
        22.895245760283
    ],
    [
        113.01477028294,
        22.894891120266
    ],
    [
        113.01474974842,
        22.89475973531
    ],
    [
        113.01475623655,
        22.894744117105
    ],
    [
        113.01479786336,
        22.894726138495
    ],
    [
        113.01482164975,
        22.894721135336
    ],
    [
        113.01488949526,
        22.89470280859
    ],
    [
        113.01518682087,
        22.894689644245
    ],
    [
        113.01550009315,
        22.89466998769
    ],
    [
        113.01569065016,
        22.894668224824
    ],
    [
        113.01584525995,
        22.894638154406
    ],
    [
        113.01589526443,
        22.894634162053
    ],
    [
        113.01591229565,
        22.894596488424
    ],
    [
        113.01590959343,
        22.89458694608
    ],
    [
        113.01590851859,
        22.89450500538
    ],
    [
        113.01590501286,
        22.894406474411
    ],
    [
        113.01587962591,
        22.89417951794
    ],
    [
        113.01587585733,
        22.894025645137
    ],
    [
        113.01587640392,
        22.89396923238
    ],
    [
        113.01587937896,
        22.893952467119
    ],
    [
        113.01594803588,
        22.893929818689
    ],
    [
        113.01602561128,
        22.893917908439
    ],
    [
        113.01613291874,
        22.893907070447
    ],
    [
        113.01626509318,
        22.893895590599
    ],
    [
        113.01635780479,
        22.893884764208
    ],
    [
        113.01645402973,
        22.89387806939
    ],
    [
        113.01651268413,
        22.893870162722
    ],
    [
        113.01653457767,
        22.893871637816
    ],
    [
        113.01657512154,
        22.893871817603
    ],
    [
        113.01661431257,
        22.893884180055
    ],
    [
        113.01665134232,
        22.8938872811
    ],
    [
        113.01665080146,
        22.893889712819
    ],
    [
        113.01666674878,
        22.893889183134
    ],
    [
        113.01670134587,
        22.893892512087
    ],
    [
        113.01671594217,
        22.893888160664
    ],
    [
        113.01675783829,
        22.893881582942
    ],
    [
        113.01677243627,
        22.893862583413
    ],
    [
        113.01678487595,
        22.893809095232
    ],
    [
        113.01679786291,
        22.893701907106
    ],
    [
        113.01680706732,
        22.89358759893
    ],
    [
        113.01679842139,
        22.893561132621
    ],
    [
        113.016738147,
        22.893554091175
    ],
    [
        113.01663949065,
        22.893550163563
    ],
    [
        113.01648461159,
        22.893560153577
    ],
    [
        113.01582860392,
        22.893612757544
    ],
    [
        113.01540721083,
        22.893653813881
    ],
    [
        113.01497851877,
        22.893688511066
    ],
    [
        113.01482877569,
        22.893680969863
    ],
    [
        113.01481309856,
        22.893680420377
    ],
    [
        113.01478769095,
        22.893678341939
    ],
    [
        113.0147752596,
        22.893659675601
    ],
    [
        113.01476608999,
        22.893499197711
    ],
    [
        113.01470342415,
        22.893191833168
    ],
    [
        113.01462048055,
        22.892948127513
    ],
    [
        113.01451942724,
        22.892720106401
    ],
    [
        113.0144467542,
        22.892511577503
    ],
    [
        113.01441487466,
        22.892427194162
    ],
    [
        113.01435923079,
        22.892232259701
    ],
    [
        113.01435463777,
        22.892221870609
    ],
    [
        113.01433763223,
        22.892106556531
    ],
    [
        113.01428550887,
        22.891895681293
    ],
    [
        113.01419284808,
        22.891661304255
    ],
    [
        113.01415991175,
        22.891488203238
    ],
    [
        113.01409776779,
        22.891383213864
    ],
    [
        113.01403832932,
        22.891270135203
    ],
    [
        113.01403753431,
        22.891206647548
    ],
    [
        113.01403835151,
        22.891181706561
    ],
    [
        113.01406079429,
        22.891151180086
    ],
    [
        113.01408566757,
        22.891129376778
    ],
    [
        113.01409945906,
        22.891105478889
    ],
    [
        113.01411518669,
        22.890914251466
    ],
    [
        113.01409875205,
        22.890717030828
    ],
    [
        113.01409284929,
        22.890561227174
    ],
    [
        113.01408745075,
        22.890535091478
    ],
    [
        113.01405316019,
        22.89040509795
    ],
    [
        113.01404749652,
        22.890362139979
    ],
    [
        113.01401455416,
        22.890246818261
    ],
    [
        113.01361370327,
        22.890217504912
    ],
    [
        113.01357400114,
        22.890110475012
    ],
    [
        113.01356752022,
        22.890089745771
    ],
    [
        113.01353755429,
        22.889968240044
    ],
    [
        113.01352404895,
        22.889936808432
    ],
    [
        113.01348947957,
        22.889843703441
    ],
    [
        113.01341761305,
        22.889736108993
    ],
    [
        113.01335277416,
        22.889630808934
    ],
    [
        113.0133303717,
        22.889532222605
    ],
    [
        113.01332336268,
        22.889476221899
    ],
    [
        113.01332149541,
        22.889403494059
    ],
    [
        113.01332042485,
        22.889372552751
    ],
    [
        113.01334070181,
        22.889361245272
    ],
    [
        113.01336665489,
        22.889350851367
    ],
    [
        113.01348885363,
        22.889292782764
    ],
    [
        113.01359780811,
        22.889232041907
    ],
    [
        113.01365160844,
        22.889204779572
    ],
    [
        113.01374028239,
        22.889165112401
    ],
    [
        113.01382111357,
        22.889136157928
    ],
    [
        113.01390464393,
        22.889117559436
    ],
    [
        113.01396357823,
        22.889094458729
    ],
    [
        113.01398790491,
        22.889095973336
    ],
    [
        113.01402359104,
        22.889078701239
    ],
    [
        113.01403224428,
        22.889068817891
    ],
    [
        113.01404198098,
        22.889052714966
    ],
    [
        113.01405955965,
        22.889027799401
    ],
    [
        113.0140860646,
        22.888985681697
    ],
    [
        113.01408850087,
        22.888975959793
    ],
    [
        113.014102055,
        22.888870141075
    ],
    [
        113.01409614544,
        22.888771030906
    ],
    [
        113.01409048646,
        22.888725089915
    ],
    [
        113.01410050188,
        22.888687563425
    ],
    [
        113.01410267525,
        22.888658849533
    ],
    [
        113.01412268606,
        22.888636689662
    ],
    [
        113.01416216513,
        22.88859751419
    ],
    [
        113.01433710015,
        22.888467968958
    ],
    [
        113.01437089821,
        22.888441171286
    ],
    [
        113.01440064095,
        22.888416471907
    ],
    [
        113.01446959154,
        22.888355577471
    ],
    [
        113.01453234348,
        22.888249546664
    ],
    [
        113.01460428125,
        22.888155342799
    ],
    [
        113.01465295711,
        22.888101413983
    ],
    [
        113.01465782335,
        22.888099330301
    ],
    [
        113.01473812155,
        22.888051930113
    ],
    [
        113.01496702033,
        22.888157981727
    ],
    [
        113.01503593226,
        22.888192026552
    ],
    [
        113.01504511899,
        22.888200327153
    ],
    [
        113.0151129817,
        22.888155692116
    ],
    [
        113.01514217841,
        22.888144276078
    ],
    [
        113.0152019253,
        22.888116585792
    ],
    [
        113.01532225899,
        22.887991239243
    ],
    [
        113.0153160429,
        22.88798950123
    ],
    [
        113.01535389381,
        22.887966847134
    ],
    [
        113.01536579196,
        22.8879545814
    ],
    [
        113.01540527137,
        22.887915952852
    ],
    [
        113.01543204394,
        22.887884422012
    ],
    [
        113.01545313534,
        22.887864724984
    ],
    [
        113.01555669724,
        22.887773801394
    ],
    [
        113.01564538994,
        22.88769047985
    ],
    [
        113.01574056465,
        22.887619480137
    ],
    [
        113.01582925097,
        22.887551891469
    ],
    [
        113.01583898651,
        22.887540672507
    ],
    [
        113.01576767335,
        22.887439313367
    ],
    [
        113.01573904184,
        22.887394861967
    ],
    [
        113.01553453067,
        22.887167716522
    ],
    [
        113.01540404281,
        22.887026246845
    ],
    [
        113.01527625557,
        22.886891336118
    ],
    [
        113.01520873759,
        22.886772416095
    ],
    [
        113.01516849395,
        22.886708229849
    ],
    [
        113.0151171577,
        22.886666088577
    ],
    [
        113.01498125176,
        22.886554905797
    ],
    [
        113.0148331985,
        22.886411502262
    ],
    [
        113.01476404758,
        22.88631940892
    ],
    [
        113.01475567216,
        22.886311665537
    ],
    [
        113.01469920706,
        22.886256686671
    ],
    [
        113.01465084347,
        22.886216770088
    ],
    [
        113.01455169753,
        22.886109499295
    ],
    [
        113.01449522982,
        22.886060217613
    ],
    [
        113.01441391054,
        22.885979574576
    ],
    [
        113.01436879326,
        22.885934834543
    ],
    [
        113.01435771912,
        22.885918906476
    ],
    [
        113.01426829789,
        22.885825101752
    ],
    [
        113.01424966078,
        22.885798732846
    ],
    [
        113.01421103713,
        22.885742173922
    ],
    [
        113.01408631797,
        22.885439162832
    ],
    [
        113.01403368068,
        22.885306138723
    ],
    [
        113.01404910712,
        22.885270878827
    ],
    [
        113.01405912479,
        22.885240676955
    ],
    [
        113.01405723313,
        22.88523982981
    ],
    [
        113.01405615978,
        22.885225435127
    ],
    [
        113.01406212285,
        22.885195432868
    ],
    [
        113.01404592298,
        22.885162055369
    ],
    [
        113.01404107129,
        22.885137015593
    ],
    [
        113.01402541075,
        22.885106088836
    ],
    [
        113.01399949248,
        22.885050298133
    ],
    [
        113.01396377106,
        22.884643893636
    ],
    [
        113.01393031828,
        22.884531010255
    ],
    [
        113.01389684789,
        22.884449319195
    ],
    [
        113.01389982909,
        22.884435809905
    ],
    [
        113.01389743655,
        22.884366873207
    ],
    [
        113.01390419631,
        22.884363195187
    ],
    [
        113.01390338271,
        22.884367791872
    ],
    [
        113.01394015797,
        22.884344029649
    ],
    [
        113.01393827143,
        22.884334503015
    ],
    [
        113.01393665869,
        22.884319013981
    ],
    [
        113.01393559725,
        22.884285361748
    ],
    [
        113.01394020706,
        22.884260489258
    ],
    [
        113.01394399959,
        22.884246451855
    ],
    [
        113.01394860689,
        22.884225919137
    ],
    [
        113.01393941569,
        22.884227384285
    ],
    [
        113.01394321225,
        22.884206566015
    ],
    [
        113.01395160524,
        22.884183659006
    ],
    [
        113.01395161747,
        22.884163045167
    ],
    [
        113.01395758118,
        22.884134399293
    ],
    [
        113.01395623921,
        22.884118372587
    ],
    [
        113.01395220038,
        22.884091991244
    ],
    [
        113.01395464718,
        22.884068436796
    ],
    [
        113.01395140844,
        22.88406024249
    ],
    [
        113.01394573081,
        22.884062312143
    ],
    [
        113.01398736837,
        22.88404433203
    ],
    [
        113.01398736837,
        22.88404433203
    ],
    [
        113.01396122097,
        22.883924525931
    ],
    [
        113.01393989952,
        22.883870715785
    ],
    [
        113.01394125004,
        22.883872367051
    ],
    [
        113.01383906898,
        22.883882226851
    ],
    [
        113.0136528167,
        22.883901727143
    ],
    [
        113.01364578815,
        22.883902688271
    ],
    [
        113.01318740305,
        22.883808104174
    ],
    [
        113.01312658917,
        22.883798357801
    ],
    [
        113.01310198688,
        22.883804978556
    ],
    [
        113.01308766567,
        22.883796319141
    ],
    [
        113.01308388219,
        22.883794896632
    ],
    [
        113.01308631512,
        22.883794668045
    ],
    [
        113.01307172212,
        22.883788445034
    ],
    [
        113.01308068486,
        22.883718894316
    ],
    [
        113.01308161802,
        22.883520636885
    ],
    [
        113.01311108158,
        22.883521153439
    ],
    [
        113.01311423142,
        22.883239665846
    ],
    [
        113.01310829444,
        22.883224101318
    ],
    [
        113.01311642225,
        22.883194950402
    ],
    [
        113.01328969489,
        22.883188769223
    ],
    [
        113.01337295221,
        22.883185349794
    ],
    [
        113.01336943703,
        22.883187186659
    ],
    [
        113.01336456947,
        22.883190355936
    ],
    [
        113.01335354134,
        22.883104722987
    ],
    [
        113.01333576302,
        22.883007850869
    ],
    [
        113.01333280065,
        22.882990711011
    ],
    [
        113.01330630647,
        22.882996755205
    ],
    [
        113.01326684367,
        22.882993078545
    ],
    [
        113.0132535997,
        22.88299121859
    ],
    [
        113.01321683606,
        22.882993556805
    ],
    [
        113.0132030525,
        22.882990060076
    ],
    [
        113.01317277548,
        22.882993597332
    ],
    [
        113.01316845336,
        22.882989181743
    ],
    [
        113.01316791781,
        22.882981306532
    ],
    [
        113.01315900989,
        22.882962163811
    ],
    [
        113.01315414611,
        22.882959366141
    ],
    [
        113.01316496452,
        22.882950062698
    ],
    [
        113.01312414773,
        22.882949889247
    ],
    [
        113.0131209205,
        22.88292433657
    ],
    [
        113.01310767577,
        22.882923561856
    ],
    [
        113.01309470098,
        22.882923334373
    ],
    [
        113.01309155448,
        22.882773557634
    ],
    [
        113.01289720148,
        22.882771509801
    ],
    [
        113.01288287434,
        22.882772344066
    ],
    [
        113.0128201643,
        22.882768263711
    ],
    [
        113.01274177253,
        22.882769334779
    ],
    [
        113.01260580805,
        22.882763163953
    ],
    [
        113.01261684888,
        22.884131742255
    ],
    [
        113.012501969,
        22.884124314514
    ],
    [
        113.01245141963,
        22.884124518922
    ],
    [
        113.01223733347,
        22.884114556876
    ],
    [
        113.01223354678,
        22.884118288424
    ],
    [
        113.01220821,
        22.88399552035
    ],
    [
        113.01220956126,
        22.883996086289
    ],
    [
        113.01214684877,
        22.883993099029
    ],
    [
        113.01211063186,
        22.883982977433
    ],
    [
        113.01210554297,
        22.883904501657
    ],
    [
        113.01216420522,
        22.883900094671
    ],
    [
        113.01215156388,
        22.883794906621
    ],
    [
        113.01181259285,
        22.88333552997
    ],
    [
        113.01157819251,
        22.883379495088
    ],
    [
        113.01157278754,
        22.883376960877
    ],
    [
        113.01148573089,
        22.883394449017
    ],
    [
        113.01146001018,
        22.883457747129
    ],
    [
        113.01142289432,
        22.883588116175
    ],
    [
        113.01138849302,
        22.883701173182
    ],
    [
        113.01134542086,
        22.883848528809
    ],
    [
        113.01135217742,
        22.883851357168
    ],
    [
        113.0112966699,
        22.884000398689
    ],
    [
        113.01124089867,
        22.884139672099
    ],
    [
        113.01120569248,
        22.88424647893
    ],
    [
        113.01116751768,
        22.884345369446
    ],
    [
        113.01112558235,
        22.884403239117
    ],
    [
        113.01107527213,
        22.884451743981
    ],
    [
        113.01104822516,
        22.884475150624
    ],
    [
        113.01102528114,
        22.884415628663
    ],
    [
        113.01097667619,
        22.884320407802
    ],
    [
        113.01087887612,
        22.884215126751
    ],
    [
        113.01083482897,
        22.884184811369
    ],
    [
        113.01075889124,
        22.884138493357
    ],
    [
        113.01063860725,
        22.884109325485
    ],
    [
        113.01044803101,
        22.884083853788
    ],
    [
        113.01038236656,
        22.884034734232
    ],
    [
        113.01033615675,
        22.884002489955
    ],
    [
        113.01029237898,
        22.883971914789
    ],
    [
        113.01019375391,
        22.883885897149
    ],
    [
        113.01010673917,
        22.883823675394
    ],
    [
        113.01000241474,
        22.883772828566
    ],
    [
        113.00988781872,
        22.883718015793
    ],
    [
        113.00979320585,
        22.883699886983
    ],
    [
        113.00973453799,
        22.883701076501
    ],
    [
        113.00964531406,
        22.883711250843
    ],
    [
        113.00956149112,
        22.883730739749
    ],
    [
        113.00945386881,
        22.883762041309
    ],
    [
        113.00933137346,
        22.883797168935
    ],
    [
        113.00924402999,
        22.883823389494
    ],
    [
        113.00916640866,
        22.883867132358
    ],
    [
        113.00910257365,
        22.883914359447
    ],
    [
        113.00902546346,
        22.884006666087
    ],
    [
        113.00901924681,
        22.88400358017
    ],
    [
        113.00896323873,
        22.884073451993
    ],
    [
        113.00889668065,
        22.884152645139
    ],
    [
        113.00883659284,
        22.884263680801
    ],
    [
        113.00877272483,
        22.88436651888
    ],
    [
        113.00873833057,
        22.884464686863
    ],
    [
        113.00871665253,
        22.884548416312
    ],
    [
        113.00868333011,
        22.884664775654
    ],
    [
        113.00867168917,
        22.884690895701
    ],
    [
        113.0086654502,
        22.884726868589
    ],
    [
        113.00865759653,
        22.88474952444
    ],
    [
        113.0086340376,
        22.884813966085
    ],
    [
        113.00859371935,
        22.884871353779
    ],
    [
        113.00856665196,
        22.884924618097
    ],
    [
        113.00853039289,
        22.884975834429
    ],
    [
        113.0084760205,
        22.885023230687
    ],
    [
        113.00844518848,
        22.885039004082
    ],
    [
        113.00843653176,
        22.885047271914
    ],
    [
        113.00836649108,
        22.885068919577
    ],
    [
        113.00826995666,
        22.885082817022
    ],
    [
        113.0081717995,
        22.885096149467
    ],
    [
        113.00807202297,
        22.885102678683
    ],
    [
        113.00807608157,
        22.88509759046
    ],
    [
        113.00803011423,
        22.885099834566
    ],
    [
        113.00799090641,
        22.885102188094
    ],
    [
        113.0079089709,
        22.885114977787
    ],
    [
        113.00784731877,
        22.885119686334
    ],
    [
        113.00777349644,
        22.885128270606
    ],
    [
        113.00768506807,
        22.885144490269
    ],
    [
        113.00764477372,
        22.885153884307
    ],
    [
        113.00758690197,
        22.885165711956
    ],
    [
        113.00747142832,
        22.885188833313
    ],
    [
        113.00736677596,
        22.885200468038
    ],
    [
        113.00728646637,
        22.885198929185
    ],
    [
        113.00727403101,
        22.885192765879
    ],
    [
        113.00720994616,
        22.885189586806
    ],
    [
        113.00711342422,
        22.885163387451
    ],
    [
        113.00699337116,
        22.885145232589
    ],
    [
        113.00688844832,
        22.885148747957
    ],
    [
        113.00682029913,
        22.885156366269
    ],
    [
        113.00675187498,
        22.885171577144
    ],
    [
        113.00668939625,
        22.885193120824
    ],
    [
        113.00660445968,
        22.885237645645
    ],
    [
        113.00657525083,
        22.885243432821
    ],
    [
        113.00653170104,
        22.885264731053
    ],
    [
        113.0064746312,
        22.885283380791
    ],
    [
        113.00635560615,
        22.885352073782
    ],
    [
        113.00628312142,
        22.885369678556
    ],
    [
        113.00625689091,
        22.885367107282
    ],
    [
        113.00620930441,
        22.885349020636
    ],
    [
        113.00615821383,
        22.885308911209
    ],
    [
        113.00613712313,
        22.885302893705
    ],
    [
        113.00612847857,
        22.885285402647
    ],
    [
        113.00611279838,
        22.885275941697
    ],
    [
        113.00606061578,
        22.885254262404
    ],
    [
        113.00602412086,
        22.885227940234
    ],
    [
        113.00597682478,
        22.885171076113
    ],
    [
        113.00597060942,
        22.885162302237
    ],
    [
        113.00586952052,
        22.885059329117
    ],
    [
        113.00581170661,
        22.88494833348
    ],
    [
        113.00575313918,
        22.884734257525
    ],
    [
        113.00568857813,
        22.884600108979
    ],
    [
        113.00563454779,
        22.884495956683
    ],
    [
        113.00557428374,
        22.884415310412
    ],
    [
        113.0055780697,
        22.884415909518
    ],
    [
        113.00557401703,
        22.884408796712
    ],
    [
        113.00556779329,
        22.884414670871
    ],
    [
        113.005523454,
        22.884389054456
    ],
    [
        113.00551480195,
        22.884384856724
    ],
    [
        113.00550020077,
        22.884379214078
    ],
    [
        113.00546124959,
        22.884389482873
    ],
    [
        113.0054076924,
        22.884401976322
    ],
    [
        113.00530973875,
        22.884486233312
    ],
    [
        113.00530107874,
        22.884495598318
    ],
    [
        113.00522884908,
        22.884525450659
    ],
    [
        113.00521938505,
        22.884521784721
    ],
    [
        113.00520423768,
        22.88452454462
    ],
    [
        113.00517044591,
        22.884496650906
    ],
    [
        113.00513692064,
        22.884475542676
    ],
    [
        113.00512259397,
        22.88446176979
    ],
    [
        113.00509042523,
        22.884433087697
    ],
    [
        113.00509070021,
        22.884425225839
    ],
    [
        113.00435578978,
        22.883562879691
    ],
    [
        113.00433143377,
        22.883582874115
    ],
    [
        113.00432087891,
        22.883592487787
    ],
    [
        113.00430843312,
        22.883598005978
    ],
    [
        113.00428678038,
        22.883620480745
    ],
    [
        113.00428947979,
        22.883629470054
    ],
    [
        113.00428459538,
        22.883655167802
    ],
    [
        113.00427430143,
        22.883680517179
    ],
    [
        113.00425832235,
        22.883713922679
    ],
    [
        113.004238834,
        22.883735615188
    ],
    [
        113.004232601,
        22.883755055457
    ],
    [
        113.00421203901,
        22.883762899922
    ],
    [
        113.00419715757,
        22.883770282906
    ],
    [
        113.00418172305,
        22.883797729657
    ],
    [
        113.00415466285,
        22.883816060696
    ],
    [
        113.00412814031,
        22.883839824508
    ],
    [
        113.00410703355,
        22.88385362968
    ],
    [
        113.00409132832,
        22.883881344641
    ],
    [
        113.00407887305,
        22.883902324815
    ],
    [
        113.00406182085,
        22.883920798939
    ],
    [
        113.00405179744,
        22.88394615349
    ],
    [
        113.00403690274,
        22.883975507837
    ],
    [
        113.00401471258,
        22.883991468723
    ],
    [
        113.00400090627,
        22.884009989268
    ],
    [
        113.00397492238,
        22.884037289109
    ],
    [
        113.00395597919,
        22.884051397846
    ],
    [
        113.00446275036,
        22.884744566742
    ],
    [
        113.00445949065,
        22.884769473876
    ],
    [
        113.00445352388,
        22.884798410725
    ],
    [
        113.00444756228,
        22.884818125553
    ],
    [
        113.00445215578,
        22.884826599916
    ],
    [
        113.00444159678,
        22.88484489256
    ],
    [
        113.00440316657,
        22.884883670974
    ],
    [
        113.00431063703,
        22.884926016608
    ],
    [
        113.00456958228,
        22.885252779603
    ],
    [
        113.00461201806,
        22.885307640227
    ],
    [
        113.00466446106,
        22.885363189192
    ],
    [
        113.00473230449,
        22.885449884539
    ],
    [
        113.00482663962,
        22.885564092176
    ],
    [
        113.00483418816,
        22.885611398011
    ],
    [
        113.00483903984,
        22.885643746352
    ],
    [
        113.00483659015,
        22.885673547147
    ],
    [
        113.0048225148,
        22.885694498902
    ],
    [
        113.00479734779,
        22.885719900453
    ],
    [
        113.00478815025,
        22.885722750307
    ],
    [
        113.00475812292,
        22.885732078494
    ],
    [
        113.00474215978,
        22.885742153804
    ],
    [
        113.00466776975,
        22.885760333309
    ],
    [
        113.00460555516,
        22.885769740714
    ],
    [
        113.004568789,
        22.885732863697
    ],
    [
        113.00449824025,
        22.88564260916
    ],
    [
        113.00436552174,
        22.885472535604
    ],
    [
        113.00435200156,
        22.88546474742
    ],
    [
        113.0043384908,
        22.885439057614
    ],
    [
        113.00428848265,
        22.88537867049
    ],
    [
        113.0042598199,
        22.885361716079
    ],
    [
        113.00423035962,
        22.885318440495
    ],
    [
        113.00420927648,
        22.885290202753
    ],
    [
        113.00420927474,
        22.885293457608
    ],
    [
        113.00417062128,
        22.88524354254
    ],
    [
        113.0039957165,
        22.885049571936
    ],
    [
        113.00399247263,
        22.885045728839
    ],
    [
        113.00397597849,
        22.885034375513
    ],
    [
        113.00363693317,
        22.885228720658
    ],
    [
        113.00362314361,
        22.88521686579
    ],
    [
        113.00357068137,
        22.88518603042
    ],
    [
        113.00322244021,
        22.884850329008
    ],
    [
        113.00316377325,
        22.884784703207
    ],
    [
        113.00315458261,
        22.884771829892
    ],
    [
        113.00311917098,
        22.884723339139
    ],
    [
        113.00308511649,
        22.884666730423
    ],
    [
        113.0030467359,
        22.88460599527
    ],
    [
        113.00299482539,
        22.884551316657
    ],
    [
        113.00294157008,
        22.884482517212
    ],
    [
        113.00289723048,
        22.88443418229
    ],
    [
        113.00286209381,
        22.884377292558
    ],
    [
        113.00284238625,
        22.884305421261
    ],
    [
        113.00282809331,
        22.884227113146
    ],
    [
        113.00282403974,
        22.88421946415
    ],
    [
        113.00280431895,
        22.884170919637
    ],
    [
        113.00278079708,
        22.88414565092
    ],
    [
        113.00273186839,
        22.884079900087
    ],
    [
        113.00271185683,
        22.884065799976
    ],
    [
        113.00269131312,
        22.884036503753
    ],
    [
        113.00267697606,
        22.884033871651
    ],
    [
        113.00265480057,
        22.884018929732
    ],
    [
        113.00264210449,
        22.883986212477
    ],
    [
        113.0026283118,
        22.883977892074
    ],
    [
        113.00259558689,
        22.88395982726
    ],
    [
        113.00258342608,
        22.883936882109
    ],
    [
        113.0025720798,
        22.883909065587
    ],
    [
        113.0025629058,
        22.883867987328
    ],
    [
        113.00255587997,
        22.883854061227
    ],
    [
        113.00254696604,
        22.883830616893
    ],
    [
        113.00252372164,
        22.883793150046
    ],
    [
        113.00250401097,
        22.883728064117
    ],
    [
        113.00248997809,
        22.883669291826
    ],
    [
        113.00242351375,
        22.883520863631
    ],
    [
        113.00240649889,
        22.883472359905
    ],
    [
        113.0023989294,
        22.883462767168
    ],
    [
        113.00238841512,
        22.883402414734
    ],
    [
        113.00239409964,
        22.883397607167
    ],
    [
        113.00237059988,
        22.883335999393
    ],
    [
        113.00235875005,
        22.883248506171
    ],
    [
        113.00232823464,
        22.883157513724
    ],
    [
        113.00231449275,
        22.883068097541
    ],
    [
        113.00229966724,
        22.882981379717
    ],
    [
        113.00229429574,
        22.882919196771
    ],
    [
        113.00227756141,
        22.882856594157
    ],
    [
        113.00226244843,
        22.882797267727
    ],
    [
        113.00224297806,
        22.882782367032
    ],
    [
        113.00222971486,
        22.882791687308
    ],
    [
        113.00221320847,
        22.882795540775
    ],
    [
        113.00218939446,
        22.882803367857
    ],
    [
        113.00216341071,
        22.882819304141
    ],
    [
        113.00215502087,
        22.882823263685
    ],
    [
        113.0021444664,
        22.882827466413
    ],
    [
        113.00204189847,
        22.882867366192
    ],
    [
        113.00196394686,
        22.882913285117
    ],
    [
        113.00190224467,
        22.882933920223
    ],
    [
        113.00187086426,
        22.882925381132
    ],
    [
        113.0018700574,
        22.882917776239
    ],
    [
        113.00184328257,
        22.882899803474
    ],
    [
        113.00182436486,
        22.882865114982
    ],
    [
        113.0018022146,
        22.882808144285
    ],
    [
        113.00176276178,
        22.882729526061
    ],
    [
        113.00172817102,
        22.882663718681
    ],
    [
        113.00168761729,
        22.882613839276
    ],
    [
        113.00164868122,
        22.882572660923
    ],
    [
        113.00157780998,
        22.882541929892
    ],
    [
        113.00154073843,
        22.882545260151
    ],
    [
        113.0015147569,
        22.882554155331
    ],
    [
        113.00146468057,
        22.882582820033
    ],
    [
        113.0013864494,
        22.882632562158
    ],
    [
        113.00130388323,
        22.882689849054
    ],
    [
        113.00127760845,
        22.882732648948
    ],
    [
        113.00124998718,
        22.882765396974
    ],
    [
        113.00124481133,
        22.882819308432
    ],
    [
        113.00125722975,
        22.882864215967
    ],
    [
        113.00128965891,
        22.882929443327
    ],
    [
        113.0013104541,
        22.882992628107
    ],
    [
        113.00135587332,
        22.883055034945
    ],
    [
        113.00144082132,
        22.883079964674
    ],
    [
        113.00145894649,
        22.883086158861
    ],
    [
        113.0014689602,
        22.883082758327
    ],
    [
        113.0015041395,
        22.883076961414
    ],
    [
        113.00150927827,
        22.883080552024
    ],
    [
        113.00156284622,
        22.883091532959
    ],
    [
        113.00159801534,
        22.883101198488
    ],
    [
        113.00163641925,
        22.883129892185
    ],
    [
        113.00166913332,
        22.883170720331
    ],
    [
        113.00170616614,
        22.883228149354
    ],
    [
        113.00171290406,
        22.883270547585
    ],
    [
        113.00169908854,
        22.883296682018
    ],
    [
        113.00168472515,
        22.883333659046
    ],
    [
        113.00163140554,
        22.883359836154
    ],
    [
        113.00157889347,
        22.883392263739
    ],
    [
        113.00151123201,
        22.883419077999
    ],
    [
        113.00149986268,
        22.883427072238
    ],
    [
        113.00149282711,
        22.883427797604
    ],
    [
        113.00148687887,
        22.883420399584
    ],
    [
        113.00147659734,
        22.88341945688
    ],
    [
        113.0014346578,
        22.883418117705
    ],
    [
        113.00140947882,
        22.883441942755
    ],
    [
        113.00141270915,
        22.883469106689
    ],
    [
        113.00141324516,
        22.883477521693
    ],
    [
        113.00141324449,
        22.883478606627
    ],
    [
        113.00135367895,
        22.883538619973
    ],
    [
        113.00128980219,
        22.88356820376
    ],
    [
        113.00120751164,
        22.883619261392
    ],
    [
        113.00111359283,
        22.883656889969
    ],
    [
        113.00101940016,
        22.883698047241
    ],
    [
        113.00098962381,
        22.883715313546
    ],
    [
        113.00096445211,
        22.883725042008
    ],
    [
        113.00093305685,
        22.883734152632
    ],
    [
        113.00086972294,
        22.883755352906
    ],
    [
        113.00079720063,
        22.883755288444
    ],
    [
        113.00075769918,
        22.883743148486
    ],
    [
        113.0007290336,
        22.883711610999
    ],
    [
        113.00066764175,
        22.883650658925
    ],
    [
        113.0006254737,
        22.88357230906
    ],
    [
        113.00060359666,
        22.883502339888
    ],
    [
        113.00058144347,
        22.883441589799
    ],
    [
        113.00058579965,
        22.883398786601
    ],
    [
        113.00062153521,
        22.883375344942
    ],
    [
        113.00064644737,
        22.883349875821
    ],
    [
        113.0006835359,
        22.883326180679
    ],
    [
        113.00075013446,
        22.883280329315
    ],
    [
        113.00080643786,
        22.883253071732
    ],
    [
        113.00090633113,
        22.88318891525
    ],
    [
        113.00097779869,
        22.883143133543
    ],
    [
        113.00102138484,
        22.88311193179
    ],
    [
        113.0010479142,
        22.883094897646
    ],
    [
        113.00104468601,
        22.883064751036
    ],
    [
        113.00103793463,
        22.883043240791
    ],
    [
        113.00102173007,
        22.882993677711
    ],
    [
        113.00097143435,
        22.882937188795
    ],
    [
        113.00094196529,
        22.882895601861
    ],
    [
        113.00088785101,
        22.882885721629
    ],
    [
        113.00083344929,
        22.882901607177
    ],
    [
        113.00078418229,
        22.882927592418
    ],
    [
        113.00065559902,
        22.882996023977
    ],
    [
        113.00060063674,
        22.883039848702
    ],
    [
        113.00054648921,
        22.883078531781
    ],
    [
        113.00052130852,
        22.883099659627
    ],
    [
        113.00046202811,
        22.883123366957
    ],
    [
        113.00041196244,
        22.883124673117
    ],
    [
        113.00034051487,
        22.883129526565
    ],
    [
        113.00029587172,
        22.883113541591
    ],
    [
        113.00028722435,
        22.883093368772
    ],
    [
        113.00025802126,
        22.883054239997
    ],
    [
        113.0002258522,
        22.882997718168
    ],
    [
        113.0001666168,
        22.882946306366
    ],
    [
        113.00010602267,
        22.882903018335
    ],
    [
        113.00003432274,
        22.882874251255
    ],
    [
        113.00001647626,
        22.882849905405
    ],
    [
        112.99998728565,
        22.882790168676
    ],
    [
        112.99996431709,
        22.882734572632
    ],
    [
        112.99994946194,
        22.882688020898
    ],
    [
        112.99992542079,
        22.882617224133
    ],
    [
        112.999909223,
        22.882554654694
    ],
    [
        112.99989058355,
        22.882501279455
    ],
    [
        112.99987869826,
        22.882466154357
    ],
    [
        112.9998654422,
        22.882457865792
    ],
    [
        112.99985489911,
        22.882439572708
    ],
    [
        112.99980650371,
        22.882363617994
    ],
    [
        112.99974755644,
        22.882282391845
    ],
    [
        112.99969644112,
        22.882226210202
    ],
    [
        112.99966777388,
        22.882193609659
    ],
    [
        112.99964208118,
        22.88216484049
    ],
    [
        112.99961773461,
        22.882146665018
    ],
    [
        112.99958283888,
        22.882118878387
    ],
    [
        112.99956309704,
        22.882095059703
    ],
    [
        112.9995582291,
        22.882089309257
    ],
    [
        112.99953954783,
        22.882098321925
    ],
    [
        112.99949162323,
        22.882125723261
    ],
    [
        112.9994864679,
        22.882144923254
    ],
    [
        112.99946372008,
        22.882163655972
    ],
    [
        112.9994688425,
        22.882193819857
    ],
    [
        112.9994893882,
        22.882230394112
    ],
    [
        112.99952589246,
        22.882282336105
    ],
    [
        112.99957888229,
        22.882371080451
    ],
    [
        112.99963702523,
        22.882443339712
    ],
    [
        112.99969381234,
        22.882519112171
    ],
    [
        112.99975382742,
        22.882625030564
    ],
    [
        112.99979221597,
        22.882691919012
    ],
    [
        112.9998119441,
        22.882736897166
    ],
    [
        112.99981759675,
        22.882784969965
    ],
    [
        112.99979158839,
        22.882826172646
    ],
    [
        112.99975772802,
        22.882872440119
    ],
    [
        112.999703858,
        22.882889731096
    ],
    [
        112.99967597712,
        22.882895925581
    ],
    [
        112.99965215794,
        22.882898911611
    ],
    [
        112.99963646233,
        22.882895479913
    ],
    [
        112.99961968409,
        22.882892036211
    ],
    [
        112.99959262191,
        22.882887120991
    ],
    [
        112.99956016057,
        22.88286017581
    ],
    [
        112.99948577066,
        22.882796688943
    ],
    [
        112.99939786828,
        22.882700236934
    ],
    [
        112.99931347953,
        22.88261033901
    ],
    [
        112.99925262472,
        22.882541047171
    ],
    [
        112.99919555588,
        22.882476410483
    ],
    [
        112.9991815126,
        22.882428248629
    ],
    [
        112.99916368163,
        22.882377604482
    ],
    [
        112.99915827914,
        22.882361000296
    ],
    [
        112.99915073154,
        22.882313723415
    ],
    [
        112.99912614008,
        22.882253784167
    ],
    [
        112.9990904571,
        22.882184774177
    ],
    [
        112.99905016595,
        22.882125750838
    ],
    [
        112.99904096087,
        22.882128905931
    ],
    [
        112.99901552563,
        22.882116425321
    ],
    [
        112.99896952471,
        22.882095044024
    ],
    [
        112.99890350743,
        22.882052293366
    ],
    [
        112.99882234778,
        22.881984973518
    ],
    [
        112.99867433576,
        22.881904746034
    ],
    [
        112.99854527813,
        22.881811714023
    ],
    [
        112.99846924349,
        22.881765625546
    ],
    [
        112.99843110267,
        22.881724816012
    ],
    [
        112.99840459845,
        22.881689010135
    ],
    [
        112.99840136475,
        22.88166754939
    ],
    [
        112.9984165452,
        22.881636786159
    ],
    [
        112.99844552081,
        22.881621355181
    ],
    [
        112.99845093982,
        22.881614088195
    ],
    [
        112.99847287792,
        22.881597499838
    ],
    [
        112.99857851593,
        22.881501773214
    ],
    [
        112.99865625142,
        22.881434782435
    ],
    [
        112.99874456722,
        22.881333190862
    ],
    [
        112.99882718551,
        22.881249174416
    ],
    [
        112.99887160501,
        22.881210320557
    ],
    [
        112.99888433388,
        22.881200692524
    ],
    [
        112.99891086949,
        22.88118822915
    ],
    [
        112.99891276386,
        22.881188791938
    ],
    [
        112.99892196542,
        22.881191060558
    ],
    [
        112.99893036009,
        22.881185997348
    ],
    [
        112.99895606512,
        22.881199564074
    ],
    [
        112.99898149708,
        22.881216383116
    ],
    [
        112.99902451825,
        22.881239902279
    ],
    [
        112.9990467059,
        22.881250991634
    ],
    [
        112.99908485592,
        22.881272561367
    ],
    [
        112.99912166037,
        22.881282725843
    ],
    [
        112.99937195078,
        22.881009361108
    ],
    [
        112.99939605869,
        22.880982776423
    ],
    [
        112.99947162236,
        22.880913639017
    ],
    [
        112.99956855451,
        22.880862103979
    ],
    [
        112.9996571162,
        22.880781459764
    ],
    [
        112.99968369706,
        22.880702560728
    ],
    [
        112.99970023886,
        22.880658266053
    ],
    [
        112.99969483813,
        22.880641388755
    ],
    [
        112.99970948844,
        22.880593004386
    ],
    [
        112.99971030869,
        22.880581622033
    ],
    [
        112.99968868678,
        22.880540421886
    ],
    [
        112.99966975984,
        22.880514983802
    ],
    [
        112.99959994698,
        22.880493855387
    ],
    [
        112.99950931113,
        22.880447815898
    ],
    [
        112.99938594632,
        22.880371584176
    ],
    [
        112.99918275408,
        22.880265738445
    ],
    [
        112.9991186255,
        22.880237916099
    ],
    [
        112.9989400568,
        22.880133188826
    ],
    [
        112.99880205692,
        22.880068244862
    ],
    [
        112.99858503105,
        22.879977802543
    ],
    [
        112.99844431157,
        22.879920190465
    ],
    [
        112.99822888969,
        22.879841486263
    ],
    [
        112.99814959386,
        22.879811657414
    ],
    [
        112.99806516441,
        22.879767406539
    ],
    [
        112.99802944463,
        22.879747789539
    ],
    [
        112.99795611215,
        22.879705013606
    ],
    [
        112.99789875128,
        22.879662672039
    ],
    [
        112.99786492839,
        22.879639552535
    ],
    [
        112.99765170276,
        22.879496956572
    ],
    [
        112.99758107929,
        22.879446905439
    ],
    [
        112.99755726856,
        22.879428502217
    ],
    [
        112.99747282116,
        22.879398122744
    ],
    [
        112.99737810223,
        22.879344596455
    ],
    [
        112.99738107831,
        22.879347337154
    ],
    [
        112.99734757011,
        22.879264293317
    ],
    [
        112.99736356637,
        22.879235695813
    ],
    [
        112.99736953624,
        22.879218394285
    ],
    [
        112.99741911705,
        22.879174116145
    ],
    [
        112.99750038886,
        22.879111159471
    ],
    [
        112.99756269957,
        22.879059144274
    ],
    [
        112.99762016107,
        22.87897589388
    ],
    [
        112.99759018525,
        22.878879588204
    ],
    [
        112.99759723013,
        22.878872333589
    ],
    [
        112.9975547691,
        22.878815777657
    ],
    [
        112.99754097658,
        22.878796658269
    ],
    [
        112.99753340713,
        22.878782481282
    ],
    [
        112.99750826103,
        22.878741283191
    ],
    [
        112.99749258882,
        22.878702617948
    ],
    [
        112.99746120355,
        22.878676549298
    ],
    [
        112.99746499844,
        22.878670890063
    ],
    [
        112.99746337271,
        22.878672501778
    ],
    [
        112.9974544519,
        22.878655328794
    ],
    [
        112.99744822875,
        22.878650386935
    ],
    [
        112.99744769636,
        22.87863899035
    ],
    [
        112.99745637131,
        22.878624969991
    ],
    [
        112.99745447894,
        22.87862142587
    ],
    [
        112.99745664248,
        22.878624430147
    ],
    [
        112.99746315281,
        22.878608761675
    ],
    [
        112.99750107321,
        22.878587971396
    ],
    [
        112.9975024295,
        22.878584729778
    ],
    [
        112.99751922589,
        22.87857160192
    ],
    [
        112.99753846365,
        22.878552530951
    ],
    [
        112.99754197953,
        22.878557175812
    ],
    [
        112.99754279413,
        22.878554200219
    ],
    [
        112.99755444427,
        22.878543735269
    ],
    [
        112.99757910012,
        22.878520377825
    ],
    [
        112.99760374567,
        22.878509768346
    ],
    [
        112.99760970508,
        22.878505757959
    ],
    [
        112.99760564472,
        22.878504904768
    ],
    [
        112.99769694287,
        22.878429310869
    ],
    [
        112.9976980247,
        22.878430677598
    ],
    [
        112.99770967394,
        22.878421027736
    ],
    [
        112.99772131683,
        22.878419243447
    ],
    [
        112.99775817237,
        22.878374311325
    ],
    [
        112.99775844572,
        22.878371059317
    ],
    [
        112.99779528995,
        22.878339960635
    ],
    [
        112.99781425366,
        22.878324145824
    ],
    [
        112.99783592984,
        22.878301848772
    ],
    [
        112.99785028523,
        22.878293311911
    ],
    [
        112.9979074527,
        22.878238279218
    ],
    [
        112.99794456274,
        22.878212340745
    ],
    [
        112.99794997999,
        22.878208868972
    ],
    [
        112.99796488474,
        22.878190303564
    ],
    [
        112.99801039069,
        22.878159569005
    ],
    [
        112.998088954,
        22.878091740673
    ],
    [
        112.99814367112,
        22.878051611053
    ],
    [
        112.99816967841,
        22.8780285499
    ],
    [
        112.99820596612,
        22.878013459546
    ],
    [
        112.99823225412,
        22.87797792618
    ],
    [
        112.99825285434,
        22.877945861065
    ],
    [
        112.99826287225,
        22.877943793799
    ],
    [
        112.99832925402,
        22.877872600669
    ],
    [
        112.99839074677,
        22.877820617304
    ],
    [
        112.99843545212,
        22.877772802227
    ],
    [
        112.99848016128,
        22.877720106686
    ],
    [
        112.99857362133,
        22.877636460437
    ],
    [
        112.99857498291,
        22.877626710637
    ],
    [
        112.99862050366,
        22.877573757165
    ],
    [
        112.99862429447,
        22.877572440892
    ],
    [
        112.99863025487,
        22.877566265416
    ],
    [
        112.99866684147,
        22.877514575738
    ],
    [
        112.9986831023,
        22.877491422062
    ],
    [
        112.99869068588,
        22.877486348892
    ],
    [
        112.99869312639,
        22.877481221422
    ],
    [
        112.99870154902,
        22.877443881561
    ],
    [
        112.99870671117,
        22.877421153353
    ],
    [
        112.99870023716,
        22.877394233772
    ],
    [
        112.99869674119,
        22.877366803246
    ],
    [
        112.99868836442,
        22.877349356449
    ],
    [
        112.9986247915,
        22.877302036153
    ],
    [
        112.99858746455,
        22.877267741341
    ],
    [
        112.99858097637,
        22.877257638066
    ],
    [
        112.99854716824,
        22.877223381282
    ],
    [
        112.99853338112,
        22.87720153936
    ],
    [
        112.99852635564,
        22.877186548728
    ],
    [
        112.99850878358,
        22.877158971878
    ],
    [
        112.99849176068,
        22.877122179398
    ],
    [
        112.99846796207,
        22.877095080732
    ],
    [
        112.99843927748,
        22.877083662749
    ],
    [
        112.99840599155,
        22.877071384105
    ],
    [
        112.99837946056,
        22.877073822087
    ],
    [
        112.99835995647,
        22.877089622976
    ],
    [
        112.99832826172,
        22.877115876384
    ],
    [
        112.99828329586,
        22.877149588665
    ],
    [
        112.9982757106,
        22.877156020267
    ],
    [
        112.99826324139,
        22.877175691835
    ],
    [
        112.99821826622,
        22.877219983972
    ],
    [
        112.998180324,
        22.877270587341
    ],
    [
        112.99814239373,
        22.877306817111
    ],
    [
        112.99806139519,
        22.877371905134
    ],
    [
        112.99803214498,
        22.877387070259
    ],
    [
        112.99798204325,
        22.877409349933
    ],
    [
        112.99790754611,
        22.877467460958
    ],
    [
        112.99787313611,
        22.877501021483
    ],
    [
        112.99782463112,
        22.877555056309
    ],
    [
        112.99779617109,
        22.877595458419
    ],
    [
        112.99777774637,
        22.877613719763
    ],
    [
        112.9977695955,
        22.877648627261
    ],
    [
        112.99776957953,
        22.877667883997
    ],
    [
        112.99776331728,
        22.877710675659
    ],
    [
        112.99780793329,
        22.877776209787
    ],
    [
        112.99783361678,
        22.877819317397
    ],
    [
        112.9978601048,
        22.877871655143
    ],
    [
        112.9978576645,
        22.87787624173
    ],
    [
        112.99785358201,
        22.877902509965
    ],
    [
        112.99784570963,
        22.877928469404
    ],
    [
        112.99779315139,
        22.877973786173
    ],
    [
        112.99773518311,
        22.878013084964
    ],
    [
        112.99771296825,
        22.878031310023
    ],
    [
        112.99756261648,
        22.878146469887
    ],
    [
        112.99754771341,
        22.878161785274
    ],
    [
        112.99736672843,
        22.878320881657
    ],
    [
        112.9972719125,
        22.878387786672
    ],
    [
        112.99708309297,
        22.878516743644
    ],
    [
        112.99696607359,
        22.878579939125
    ],
    [
        112.99692245286,
        22.878614525574
    ],
    [
        112.99687938941,
        22.878629047974
    ],
    [
        112.99687451433,
        22.878630630704
    ],
    [
        112.996858532,
        22.878639434985
    ],
    [
        112.99680733749,
        22.878663378484
    ],
    [
        112.99679921335,
        22.87866466073
    ],
    [
        112.99675321338,
        22.878625458172
    ],
    [
        112.99674915809,
        22.878617555928
    ],
    [
        112.99672911667,
        22.878622799209
    ],
    [
        112.99672207962,
        22.878618938499
    ],
    [
        112.99671747367,
        22.87862242285
    ],
    [
        112.99669906934,
        22.878611950324
    ],
    [
        112.99667797108,
        22.878584095423
    ],
    [
        112.99666851349,
        22.878559600134
    ],
    [
        112.99665850915,
        22.878541609416
    ],
    [
        112.99665255405,
        22.878539114942
    ],
    [
        112.99663553801,
        22.878485531029
    ],
    [
        112.99663878819,
        22.878484475251
    ],
    [
        112.99662499493,
        22.87846400984
    ],
    [
        112.99660660825,
        22.878431298407
    ],
    [
        112.99659200175,
        22.878411911003
    ],
    [
        112.99657144377,
        22.878385418903
    ],
    [
        112.99655737768,
        22.878367392854
    ],
    [
        112.99654385137,
        22.87835154156
    ],
    [
        112.99654494171,
        22.878342600829
    ],
    [
        112.99653790778,
        22.878334672829
    ],
    [
        112.99652139891,
        22.87832367735
    ],
    [
        112.99649569108,
        22.878303107821
    ],
    [
        112.99645103289,
        22.878276676024
    ],
    [
        112.99636411445,
        22.878271031343
    ],
    [
        112.99626069972,
        22.878236500122
    ],
    [
        112.99619978115,
        22.878223498085
    ],
    [
        112.99611044328,
        22.878191541799
    ],
    [
        112.99608282871,
        22.878182627332
    ],
    [
        112.9960400557,
        22.878165448213
    ],
    [
        112.99600784002,
        22.87815297055
    ],
    [
        112.99596505524,
        22.878149626415
    ],
    [
        112.99593960515,
        22.878142360757
    ],
    [
        112.99587811836,
        22.878158119827
    ],
    [
        112.99585237813,
        22.878174178876
    ],
    [
        112.99583449509,
        22.878185692883
    ],
    [
        112.99581715165,
        22.878199652648
    ],
    [
        112.99581307867,
        22.878212908887
    ],
    [
        112.99577077787,
        22.878279009092
    ],
    [
        112.99575042595,
        22.878329289099
    ],
    [
        112.99571784886,
        22.878427204617
    ],
    [
        112.99571756409,
        22.878444560669
    ],
    [
        112.99570507186,
        22.878487582955
    ],
    [
        112.99568716504,
        22.878528391262
    ],
    [
        112.99569041768,
        22.878524891958
    ],
    [
        112.99566820466,
        22.878532033411
    ],
    [
        112.99563109425,
        22.878541766221
    ],
    [
        112.99561835956,
        22.878549256975
    ],
    [
        112.99560346652,
        22.878546423799
    ],
    [
        112.99556177188,
        22.878530897636
    ],
    [
        112.99549028991,
        22.878510251632
    ],
    [
        112.99541447923,
        22.878482794824
    ],
    [
        112.99520465666,
        22.878387571367
    ],
    [
        112.99500890278,
        22.87830279854
    ],
    [
        112.99491523609,
        22.87824269079
    ],
    [
        112.99482751744,
        22.878194297501
    ],
    [
        112.99472977871,
        22.878142039633
    ],
    [
        112.9946607651,
        22.878071827815
    ],
    [
        112.99461962234,
        22.878035997017
    ],
    [
        112.99460666413,
        22.877982742798
    ],
    [
        112.99459665731,
        22.877963955603
    ],
    [
        112.99457747407,
        22.877904689598
    ],
    [
        112.99445778563,
        22.877858533706
    ],
    [
        112.99438249987,
        22.877836028947
    ],
    [
        112.9942863478,
        22.877822333166
    ],
    [
        112.99421593334,
        22.87780285673
    ],
    [
        112.99411409693,
        22.877780456591
    ],
    [
        112.99404314173,
        22.877757189797
    ],
    [
        112.99400035362,
        22.877740626611
    ],
    [
        112.99384326897,
        22.8776940108
    ],
    [
        112.99374983407,
        22.877659764533
    ],
    [
        112.99364854051,
        22.877626288812
    ],
    [
        112.99350310448,
        22.877569488125
    ],
    [
        112.99338340534,
        22.877509882202
    ],
    [
        112.99326506025,
        22.877448127328
    ],
    [
        112.99318245284,
        22.877414807275
    ],
    [
        112.99303864628,
        22.877339632488
    ],
    [
        112.99291677306,
        22.877276536906
    ],
    [
        112.99280765616,
        22.877185048907
    ],
    [
        112.99266898646,
        22.877112662686
    ],
    [
        112.9925503586,
        22.87704799748
    ],
    [
        112.99241546951,
        22.876983799885
    ],
    [
        112.9922532279,
        22.876896421548
    ],
    [
        112.9920982878,
        22.876821579999
    ],
    [
        112.99194118391,
        22.876736985283
    ],
    [
        112.99176563628,
        22.876665342961
    ],
    [
        112.99158899425,
        22.876599418927
    ],
    [
        112.99143592484,
        22.876534442191
    ],
    [
        112.99126577316,
        22.876473209556
    ],
    [
        112.99111214771,
        22.876414242076
    ],
    [
        112.99110438639,
        22.876300296914
    ],
    [
        112.99110088459,
        22.876275329975
    ],
    [
        112.99110306845,
        22.876257438566
    ],
    [
        112.99108927644,
        22.87622185105
    ],
    [
        112.99108225355,
        22.87619415729
    ],
    [
        112.99107415148,
        22.876160763463
    ],
    [
        112.99107986507,
        22.876135834983
    ],
    [
        112.99106823054,
        22.876112732871
    ],
    [
        112.99105957055,
        22.8760975086
    ],
    [
        112.991060949,
        22.876070934742
    ],
    [
        112.9910327703,
        22.876059969423
    ],
    [
        112.99104389389,
        22.876047539207
    ],
    [
        112.99104362618,
        22.87604374102
    ],
    [
        112.99104064996,
        22.876037761885
    ],
    [
        112.99102792529,
        22.876021436212
    ],
    [
        112.99101519846,
        22.876007551659
    ],
    [
        112.99100029161,
        22.876006948111
    ],
    [
        112.99097563285,
        22.875999795747
    ],
    [
        112.99093092351,
        22.875984697577
    ],
    [
        112.99089868131,
        22.875970464685
    ],
    [
        112.99089327226,
        22.875956882064
    ],
    [
        112.99086076928,
        22.875930715568
    ],
    [
        112.99082475319,
        22.875892331322
    ],
    [
        112.99078140915,
        22.875864497276
    ],
    [
        112.99078086728,
        22.875864223947
    ],
    [
        112.99068794603,
        22.875806096304
    ],
    [
        112.9906811983,
        22.875773524269
    ],
    [
        112.99065968656,
        22.875578164671
    ],
    [
        112.99066975482,
        22.875534265281
    ],
    [
        112.99067545189,
        22.875528862514
    ],
    [
        112.99069498547,
        22.875509409075
    ],
    [
        112.99071479899,
        22.875479921948
    ],
    [
        112.9907221492,
        22.875444420435
    ],
    [
        112.99071705894,
        22.875377409788
    ],
    [
        112.99073444632,
        22.875332996687
    ],
    [
        112.99071902355,
        22.875302289664
    ],
    [
        112.99072553863,
        22.875291465922
    ],
    [
        112.99069383685,
        22.875278054837
    ],
    [
        112.99066431115,
        22.875255973901
    ],
    [
        112.99062071739,
        22.875203464452
    ],
    [
        112.99061530615,
        22.87519232422
    ],
    [
        112.99059201672,
        22.875167827627
    ],
    [
        112.99058907236,
        22.875126320215
    ],
    [
        112.99058122178,
        22.875114899869
    ],
    [
        112.99059100693,
        22.875085102177
    ],
    [
        112.99058618309,
        22.875023788847
    ],
    [
        112.99060304536,
        22.874961471378
    ],
    [
        112.99059980831,
        22.874944101326
    ],
    [
        112.99060625251,
        22.874713047406
    ],
    [
        112.99061498286,
        22.874651242315
    ],
    [
        112.99061506707,
        22.874559028519
    ],
    [
        112.99062139461,
        22.874457345518
    ],
    [
        112.99061847864,
        22.874385733113
    ],
    [
        112.99062716332,
        22.874374103306
    ],
    [
        112.99063667563,
        22.874346746057
    ],
    [
        112.99064372645,
        22.874343246767
    ],
    [
        112.99069712711,
        22.874341279503
    ],
    [
        112.99083807262,
        22.874344809768
    ],
    [
        112.99086002919,
        22.874343269279
    ],
    [
        112.99088090496,
        22.874337927875
    ],
    [
        112.99088253275,
        22.874336307053
    ],
    [
        112.99088850131,
        22.874330364062
    ],
    [
        112.99088958849,
        22.874327113788
    ],
    [
        112.99089285754,
        22.874309226473
    ],
    [
        112.99090534796,
        22.874285138057
    ],
    [
        112.99091516841,
        22.874217101819
    ],
    [
        112.99091602937,
        22.87416530273
    ],
    [
        112.99092172736,
        22.874158816401
    ],
    [
        112.99092010309,
        22.874156640133
    ],
    [
        112.99091740465,
        22.874143610855
    ],
    [
        112.99092751066,
        22.874060116526
    ],
    [
        112.99092216516,
        22.873978729832
    ],
    [
        112.99092711478,
        22.873902537706
    ],
    [
        112.99091684175,
        22.873873747393
    ],
    [
        112.9909190442,
        22.873837141929
    ],
    [
        112.99091938678,
        22.873760388885
    ],
    [
        112.99093299658,
        22.873698877396
    ],
    [
        112.99095078747,
        22.873514250579
    ],
    [
        112.99093999811,
        22.873458336347
    ],
    [
        112.99094475239,
        22.873302677242
    ],
    [
        112.99094909909,
        22.873292117369
    ],
    [
        112.9909501848,
        22.873290494461
    ],
    [
        112.99095696963,
        22.873281300567
    ],
    [
        112.99097405541,
        22.873270792474
    ],
    [
        112.99097840235,
        22.873259961502
    ],
    [
        112.99097406513,
        22.873260486289
    ],
    [
        112.99097542752,
        22.87325289777
    ],
    [
        112.99098221207,
        22.873243975247
    ],
    [
        112.99100581254,
        22.873223187984
    ],
    [
        112.99101315553,
        22.873196910091
    ],
    [
        112.99103432216,
        22.873170146699
    ],
    [
        112.99104382449,
        22.873153370488
    ],
    [
        112.99103544532,
        22.873128926448
    ],
    [
        112.99103004169,
        22.873110732696
    ],
    [
        112.9910295217,
        22.873087405957
    ],
    [
        112.99101354257,
        22.873074321912
    ],
    [
        112.99101353846,
        22.873078661355
    ],
    [
        112.99100460793,
        22.87306397908
    ],
    [
        112.99099620432,
        22.873065300788
    ],
    [
        112.99097778133,
        22.873056817955
    ],
    [
        112.99097319467,
        22.87303455957
    ],
    [
        112.99096289781,
        22.873031534377
    ],
    [
        112.99095831088,
        22.873009547272
    ],
    [
        112.99095452346,
        22.87300193788
    ],
    [
        112.99095346193,
        22.872978066564
    ],
    [
        112.99095295745,
        22.872938466972
    ],
    [
        112.99095297781,
        22.872917040986
    ],
    [
        112.99093618484,
        22.872904497213
    ],
    [
        112.99092046828,
        22.872900094501
    ],
    [
        112.99089715124,
        22.872907323901
    ],
    [
        112.99088251515,
        22.872906723073
    ],
    [
        112.99083941927,
        22.872905467393
    ],
    [
        112.9908253228,
        22.872907310398
    ],
    [
        112.99081176324,
        22.872914580008
    ],
    [
        112.99079713001,
        22.872910725734
    ],
    [
        112.99079170328,
        22.872916671305
    ],
    [
        112.99077816066,
        22.872906041138
    ],
    [
        112.99077192642,
        22.872906016914
    ],
    [
        112.99076894843,
        22.872902208332
    ],
    [
        112.99075405203,
        22.872889945915
    ],
    [
        112.99074676295,
        22.872858999138
    ],
    [
        112.9906975327,
        22.872751679951
    ],
    [
        112.9906869811,
        22.872731027347
    ],
    [
        112.99066963773,
        22.872726350818
    ],
    [
        112.99065446564,
        22.872718699386
    ],
    [
        112.99064796692,
        22.872711623258
    ],
    [
        112.99030937527,
        22.872738334283
    ],
    [
        112.9903069392,
        22.872734528835
    ],
    [
        112.99029501903,
        22.872726893629
    ],
    [
        112.99027685936,
        22.872724119009
    ],
    [
        112.99024459802,
        22.872726992156
    ],
    [
        112.99022669969,
        22.872734254237
    ],
    [
        112.99019633925,
        22.872733338224
    ],
    [
        112.99018983714,
        22.872729248176
    ],
    [
        112.99018115859,
        22.872733287356
    ],
    [
        112.99014918174,
        22.872721518622
    ],
    [
        112.99013021039,
        22.872716574022
    ],
    [
        112.99010987836,
        22.872717049601
    ],
    [
        112.99007625981,
        22.872720736912
    ],
    [
        112.99004806078,
        22.872726612432
    ],
    [
        112.99001254342,
        22.872731109234
    ],
    [
        112.98996456093,
        22.872729872382
    ],
    [
        112.98993202766,
        22.872731669038
    ],
    [
        112.98991845964,
        22.872745458843
    ],
    [
        112.98991221225,
        22.872758186608
    ],
    [
        112.98990542576,
        22.872767658154
    ],
    [
        112.98989918302,
        22.872775504126
    ],
    [
        112.98987124874,
        22.872787080559
    ],
    [
        112.98985308196,
        22.872790279705
    ],
    [
        112.98982298252,
        22.872797782552
    ],
    [
        112.98977037483,
        22.872811999593
    ],
    [
        112.98973186263,
        22.872827887708
    ],
    [
        112.98969851723,
        22.872826976794
    ],
    [
        112.9896906569,
        22.872825055504
    ],
    [
        112.98967060466,
        22.872814691455
    ],
    [
        112.98966167303,
        22.872798935297
    ],
    [
        112.98964326182,
        22.872773388387
    ],
    [
        112.98962890845,
        22.872757074627
    ],
    [
        112.98960995648,
        22.872729899458
    ],
    [
        112.98959832478,
        22.872702473949
    ],
    [
        112.98958370822,
        22.872677752373
    ],
    [
        112.98957559242,
        22.872659287059
    ],
    [
        112.98956314241,
        22.872637012747
    ],
    [
        112.98954472705,
        22.872615535744
    ],
    [
        112.9895317441,
        22.872583496571
    ],
    [
        112.98951711496,
        22.872571794206
    ],
    [
        112.98951955838,
        22.872568275091
    ],
    [
        112.98952689983,
        22.872546055552
    ],
    [
        112.98953070482,
        22.872536302246
    ],
    [
        112.9895453534,
        22.872527663697
    ],
    [
        112.98957219509,
        22.872526382052
    ],
    [
        112.98961286651,
        22.872521885435
    ],
    [
        112.98968066313,
        22.872502280197
    ],
    [
        112.98974439441,
        22.872480497484
    ],
    [
        112.98979808815,
        22.872464926365
    ],
    [
        112.98980705458,
        22.872444069658
    ],
    [
        112.98982280272,
        22.87241889401
    ],
    [
        112.9898290555,
        22.87240074146
    ],
    [
        112.98983368663,
        22.87237743095
    ],
    [
        112.98984319732,
        22.872354406471
    ],
    [
        112.98985704769,
        22.872329225568
    ],
    [
        112.98986600807,
        22.872314607285
    ],
    [
        112.98987684944,
        22.87231735261
    ],
    [
        112.9898809214,
        22.872311669579
    ],
    [
        112.9898809214,
        22.872311669579
    ],
    [
        112.98987658069,
        22.87231491085
    ],
    [
        112.9898795646,
        22.872313021492
    ],
    [
        112.99031826942,
        22.872226581548
    ],
    [
        112.99046034087,
        22.872196978687
    ],
    [
        112.99054331741,
        22.872166361877
    ],
    [
        112.99057612803,
        22.872154278231
    ],
    [
        112.99057504665,
        22.872151290859
    ],
    [
        112.99058590544,
        22.872134515781
    ],
    [
        112.99057511501,
        22.872080503958
    ],
    [
        112.99055323142,
        22.872005296568
    ],
    [
        112.99055596097,
        22.871985779141
    ],
    [
        112.99054810901,
        22.871976528921
    ],
    [
        112.99052921007,
        22.871898349658
    ],
    [
        112.99050679809,
        22.87180903814
    ],
    [
        112.99048732071,
        22.871768285184
    ],
    [
        112.99046781403,
        22.871757637314
    ],
    [
        112.99045914876,
        22.871748384809
    ],
    [
        112.99041741649,
        22.871735217187
    ],
    [
        112.99041362175,
        22.871734932473
    ],
    [
        112.99037567811,
        22.871728017857
    ],
    [
        112.99037107855,
        22.871719051587
    ],
    [
        112.99032962566,
        22.871696666993
    ],
    [
        112.99029252159,
        22.871662094285
    ],
    [
        112.9902922616,
        22.871650702374
    ],
    [
        112.99028117538,
        22.871621915492
    ],
    [
        112.99028280634,
        22.871617310445
    ],
    [
        112.9902617071,
        22.871571131674
    ],
    [
        112.99025494835,
        22.871552394798
    ],
    [
        112.9902319139,
        22.871544722478
    ],
    [
        112.99021374719,
        22.87154900049
    ],
    [
        112.98979464874,
        22.871536547612
    ],
    [
        112.98976347496,
        22.871533200314
    ],
    [
        112.98976293804,
        22.871527774436
    ],
    [
        112.98975941579,
        22.871525594302
    ],
    [
        112.98975833005,
        22.871526947165
    ],
    [
        112.98975724404,
        22.871528571242
    ],
    [
        112.98974803387,
        22.871520950067
    ],
    [
        112.98974616339,
        22.871493009475
    ],
    [
        112.98975077775,
        22.871487327569
    ],
    [
        112.98976219912,
        22.871451561008
    ],
    [
        112.98973189361,
        22.871391804608
    ],
    [
        112.9897367775,
        22.871387750719
    ],
    [
        112.98970240051,
        22.871332865068
    ],
    [
        112.98967778912,
        22.871272041895
    ],
    [
        112.98966566364,
        22.871196067067
    ],
    [
        112.98965139598,
        22.871092964866
    ],
    [
        112.98963791135,
        22.871020783505
    ],
    [
        112.9896319912,
        22.870975745168
    ],
    [
        112.98962754452,
        22.870811105741
    ],
    [
        112.9896243233,
        22.87077855096
    ],
    [
        112.98961920189,
        22.870748431743
    ],
    [
        112.98960489509,
        22.870685469811
    ],
    [
        112.98960010276,
        22.87059676947
    ],
    [
        112.98959801818,
        22.870511602547
    ],
    [
        112.98960561956,
        22.870501317798
    ],
    [
        112.98960074167,
        22.870499134373
    ],
    [
        112.98961005202,
        22.87040586312
    ],
    [
        112.98962476126,
        22.870336202811
    ],
    [
        112.98963705237,
        22.87024456755
    ],
    [
        112.98965172715,
        22.870209622842
    ],
    [
        112.98966178386,
        22.870183886345
    ],
    [
        112.98966991716,
        22.870183909682
    ],
    [
        112.98966397514,
        22.870161381919
    ],
    [
        112.98966912785,
        22.870159769427
    ],
    [
        112.98967512871,
        22.870123172881
    ],
    [
        112.98966788359,
        22.870048025975
    ],
    [
        112.98967007626,
        22.870024165506
    ],
    [
        112.98967662725,
        22.869979705377
    ],
    [
        112.98967392968,
        22.869966136953
    ],
    [
        112.98966883138,
        22.869913235728
    ],
    [
        112.98966073031,
        22.869880938128
    ],
    [
        112.9896521491,
        22.869786531417
    ],
    [
        112.9896478116,
        22.869786247823
    ],
    [
        112.98964379674,
        22.869734434682
    ],
    [
        112.98963461506,
        22.869698337231
    ],
    [
        112.9896408536,
        22.869695371624
    ],
    [
        112.98963868689,
        22.869693195756
    ],
    [
        112.98963517004,
        22.869685591796
    ],
    [
        112.98962514298,
        22.869681495163
    ],
    [
        112.98962406532,
        22.869674711787
    ],
    [
        112.98960266264,
        22.869659463491
    ],
    [
        112.98957258178,
        22.869646632347
    ],
    [
        112.98949909187,
        22.869663787933
    ],
    [
        112.98945760139,
        22.869672897298
    ],
    [
        112.98941774058,
        22.869678757993
    ],
    [
        112.98932256006,
        22.869694241174
    ],
    [
        112.98920026812,
        22.869706140428
    ],
    [
        112.98912054539,
        22.869714898831
    ],
    [
        112.98903704638,
        22.869702771048
    ],
    [
        112.98898607967,
        22.869694519156
    ],
    [
        112.98896413215,
        22.869679282235
    ],
    [
        112.98893759162,
        22.869647491671
    ],
    [
        112.98891484948,
        22.869613269109
    ],
    [
        112.98891760525,
        22.869569067428
    ],
    [
        112.98890461543,
        22.869543816408
    ],
    [
        112.98889596152,
        22.869521015815
    ],
    [
        112.98890438072,
        22.869507473391
    ],
    [
        112.98889654625,
        22.869478707892
    ],
    [
        112.98889172164,
        22.869422827666
    ],
    [
        112.98889908214,
        22.869383517718
    ],
    [
        112.98891462369,
        22.869297848237
    ],
    [
        112.98892142773,
        22.869272640294
    ],
    [
        112.98894187151,
        22.869165556138
    ],
    [
        112.98894491992,
        22.869100200632
    ],
    [
        112.9889444145,
        22.869063585829
    ],
    [
        112.98892354795,
        22.869051877908
    ],
    [
        112.98889102082,
        22.869041230056
    ],
    [
        112.98882513531,
        22.86903702193
    ],
    [
        112.98876980574,
        22.869051010557
    ],
    [
        112.98870472293,
        22.869056032625
    ],
    [
        112.98867815371,
        22.869051640885
    ],
    [
        112.98859842449,
        22.869059081687
    ],
    [
        112.98854443885,
        22.869082576808
    ],
    [
        112.98853033107,
        22.869089602548
    ],
    [
        112.9885202935,
        22.869093923715
    ],
    [
        112.98849016593,
        22.869121533219
    ],
    [
        112.98849043874,
        22.869119906431
    ],
    [
        112.98847439659,
        22.869162729493
    ],
    [
        112.9884771012,
        22.869169785805
    ],
    [
        112.98846864389,
        22.869220487582
    ],
    [
        112.98850056746,
        22.869294585378
    ],
    [
        112.98852247377,
        22.869352664375
    ],
    [
        112.98852517645,
        22.869361619295
    ],
    [
        112.9885386828,
        22.869413445515
    ],
    [
        112.9885258982,
        22.869453019247
    ],
    [
        112.98850415388,
        22.869503696711
    ],
    [
        112.98846096231,
        22.869579017068
    ],
    [
        112.98845037469,
        22.869590931873
    ],
    [
        112.98840526989,
        22.869680896608
    ],
    [
        112.9883506796,
        22.869764880814
    ],
    [
        112.9883069536,
        22.869831256446
    ],
    [
        112.98830912195,
        22.869832344801
    ],
    [
        112.98825999263,
        22.869878101444
    ],
    [
        112.98824886445,
        22.869887847676
    ],
    [
        112.9881886434,
        22.869906197815
    ],
    [
        112.98816371088,
        22.869889616592
    ],
    [
        112.98813741716,
        22.869878187003
    ],
    [
        112.98806911331,
        22.86984228951
    ],
    [
        112.98806315497,
        22.869834416049
    ],
    [
        112.987995398,
        22.869793099739
    ],
    [
        112.98787884333,
        22.869732742277
    ],
    [
        112.98784848183,
        22.869719687523
    ],
    [
        112.98776119915,
        22.869674565932
    ],
    [
        112.98760585947,
        22.869610669976
    ],
    [
        112.98760666849,
        22.869615281368
    ],
    [
        112.98753267024,
        22.869571547286
    ],
    [
        112.9874882077,
        22.869554150752
    ],
    [
        112.98746190933,
        22.869544093727
    ],
    [
        112.98746245776,
        22.86953812751
    ],
    [
        112.98742688031,
        22.869585289483
    ],
    [
        112.98739702446,
        22.869606420634
    ],
    [
        112.9873739434,
        22.869633253127
    ],
    [
        112.98735467545,
        22.869644087363
    ],
    [
        112.98733810912,
        22.869665501159
    ],
    [
        112.98728976818,
        22.869727575291
    ],
    [
        112.98724684499,
        22.869796164102
    ],
    [
        112.98724222862,
        22.869801585448
    ],
    [
        112.9872418956,
        22.869863421693
    ],
    [
        112.98726709662,
        22.869887033271
    ],
    [
        112.98729934113,
        22.869919057799
    ],
    [
        112.98731964706,
        22.869955414288
    ],
    [
        112.98733289316,
        22.869999631286
    ],
    [
        112.98733531609,
        22.87001780426
    ],
    [
        112.98734939668,
        22.870041138689
    ],
    [
        112.9873493529,
        22.870085075113
    ],
    [
        112.98732761713,
        22.870122758106
    ],
    [
        112.98731728479,
        22.870148516065
    ],
    [
        112.98732026803,
        22.870148789361
    ],
    [
        112.98729527498,
        22.870188911651
    ],
    [
        112.98724776797,
        22.870230647326
    ],
    [
        112.98719426751,
        22.870298418018
    ],
    [
        112.98711554193,
        22.870365635797
    ],
    [
        112.9870690506,
        22.87047572553
    ],
    [
        112.98703259291,
        22.870587991295
    ],
    [
        112.98701324527,
        22.870678297028
    ],
    [
        112.98698957783,
        22.870748260439
    ],
    [
        112.98697813303,
        22.870801413772
    ],
    [
        112.98697295768,
        22.87082338007
    ],
    [
        112.98697077193,
        22.870839380823
    ],
    [
        112.98694713092,
        22.870882495097
    ],
    [
        112.98691806217,
        22.870928320239
    ],
    [
        112.98683390857,
        22.870995014489
    ],
    [
        112.98675519378,
        22.871046528319
    ],
    [
        112.98666972164,
        22.871072281975
    ],
    [
        112.98657772335,
        22.871112687846
    ],
    [
        112.98647458966,
        22.871165035856
    ],
    [
        112.98639914575,
        22.871195420815
    ],
    [
        112.98640430344,
        22.871191894253
    ],
    [
        112.98639915612,
        22.871184843494
    ],
    [
        112.98637803702,
        22.871143622562
    ],
    [
        112.98638049103,
        22.871130875112
    ],
    [
        112.98637654154,
        22.871009101075
    ],
    [
        112.98638100292,
        22.870886240763
    ],
    [
        112.98638738997,
        22.870736530108
    ],
    [
        112.98639448119,
        22.870698016715
    ],
    [
        112.98639509774,
        22.870623161862
    ],
    [
        112.9863965419,
        22.870534475041
    ],
    [
        112.98638191071,
        22.870516577412
    ],
    [
        112.98638626537,
        22.870502202396
    ],
    [
        112.98636404996,
        22.870472644165
    ],
    [
        112.98634099131,
        22.870472648759
    ],
    [
        112.98633611018,
        22.870470751306
    ],
    [
        112.98630682218,
        22.870460451902
    ],
    [
        112.98627781257,
        22.870442830479
    ],
    [
        112.98622871596,
        22.870437149322
    ],
    [
        112.9861497759,
        22.870432837622
    ],
    [
        112.98609035829,
        22.870438015331
    ],
    [
        112.98607353334,
        22.870442904739
    ],
    [
        112.98607000197,
        22.870447516979
    ],
    [
        112.98605045785,
        22.870458645897
    ],
    [
        112.98600351606,
        22.870466534609
    ],
    [
        112.9860102955,
        22.870469514421
    ],
    [
        112.98597473953,
        22.870485806152
    ],
    [
        112.98596629061,
        22.870524865455
    ],
    [
        112.98596165625,
        22.870547378703
    ],
    [
        112.98595811622,
        22.870560670121
    ],
    [
        112.98595780734,
        22.870598640075
    ],
    [
        112.98595148675,
        22.870680278707
    ],
    [
        112.98593520084,
        22.870963434395
    ],
    [
        112.98593491246,
        22.870980792197
    ],
    [
        112.98593104678,
        22.871049411371
    ],
    [
        112.98592369823,
        22.871073282484
    ],
    [
        112.9859255856,
        22.871085214735
    ],
    [
        112.98591658103,
        22.871137835477
    ],
    [
        112.98592553154,
        22.871140271031
    ],
    [
        112.9858940588,
        22.871142188714
    ],
    [
        112.98588320726,
        22.871141653118
    ],
    [
        112.98586909394,
        22.871147357641
    ],
    [
        112.98587370848,
        22.871144913744
    ],
    [
        112.98583817386,
        22.871138699287
    ],
    [
        112.98573942189,
        22.871134973611
    ],
    [
        112.98568625857,
        22.87112118388
    ],
    [
        112.98564228347,
        22.871144002613
    ],
    [
        112.98562297701,
        22.871187955872
    ],
    [
        112.98561124025,
        22.871259566484
    ],
    [
        112.98557722608,
        22.871361302133
    ],
    [
        112.98557010792,
        22.871426671091
    ],
    [
        112.98556379265,
        22.871503430323
    ],
    [
        112.98556135237,
        22.871501805316
    ],
    [
        112.98552955061,
        22.871560688753
    ],
    [
        112.9855227684,
        22.87155988166
    ],
    [
        112.98548505236,
        22.871562359767
    ],
    [
        112.985485595,
        22.871562359223
    ],
    [
        112.98547555078,
        22.871567793612
    ],
    [
        112.98547200243,
        22.871589494282
    ],
    [
        112.98546710303,
        22.871605500861
    ],
    [
        112.98545461369,
        22.871614192504
    ],
    [
        112.98545407368,
        22.871611480926
    ],
    [
        112.9854451155,
        22.871616100838
    ],
    [
        112.98542856812,
        22.871612592407
    ],
    [
        112.98542043047,
        22.871610431322
    ],
    [
        112.98539574877,
        22.871601236592
    ],
    [
        112.98539195257,
        22.871598799802
    ],
    [
        112.98536943291,
        22.87159828215
    ],
    [
        112.9853368877,
        22.871583673263
    ],
    [
        112.98531817225,
        22.871577185654
    ],
    [
        112.9852861739,
        22.871557967038
    ],
    [
        112.98525009714,
        22.871547161959
    ],
    [
        112.9852208038,
        22.871536078384
    ],
    [
        112.98517876432,
        22.871517960392
    ],
    [
        112.98515218188,
        22.871509044901
    ],
    [
        112.98504882736,
        22.871481792903
    ],
    [
        112.98486603423,
        22.871383615298
    ],
    [
        112.98476378142,
        22.871334149378
    ],
    [
        112.98470356434,
        22.871308757677
    ],
    [
        112.98469759225,
        22.871310937712
    ],
    [
        112.98464141304,
        22.871318088041
    ],
    [
        112.98461941676,
        22.871334129081
    ],
    [
        112.98458546136,
        22.871369448583
    ],
    [
        112.98453919717,
        22.87150405619
    ],
    [
        112.98454733404,
        22.871508380345
    ],
    [
        112.98450550612,
        22.871546158042
    ],
    [
        112.98447373011,
        22.871572255653
    ],
    [
        112.98443189637,
        22.871615460469
    ],
    [
        112.98440012629,
        22.871635051111
    ],
    [
        112.98436917782,
        22.871646775828
    ],
    [
        112.98432195793,
        22.871646601751
    ],
    [
        112.98424734127,
        22.871632656349
    ],
    [
        112.98418548438,
        22.871612992398
    ],
    [
        112.98412525645,
        22.871591972225
    ],
    [
        112.98405661885,
        22.871566635491
    ],
    [
        112.98400833205,
        22.871544509277
    ],
    [
        112.98396710623,
        22.871517215155
    ],
    [
        112.98393319311,
        22.871505092681
    ],
    [
        112.98392884805,
        22.871507815408
    ],
    [
        112.98379921946,
        22.87140290892
    ],
    [
        112.98374306852,
        22.871371593423
    ],
    [
        112.98367120154,
        22.871313201517
    ],
    [
        112.98362996819,
        22.871291073256
    ],
    [
        112.98361097592,
        22.871284073461
    ],
    [
        112.98361070397,
        22.87128461663
    ],
    [
        112.98358764859,
        22.87126922076
    ],
    [
        112.9835450328,
        22.8712723223
    ],
    [
        112.98351272939,
        22.871276752409
    ],
    [
        112.983489378,
        22.871286039804
    ],
    [
        112.9834581411,
        22.871309724595
    ],
    [
        112.983417398,
        22.871339675791
    ],
    [
        112.98338914377,
        22.871366066007
    ],
    [
        112.98335136549,
        22.871416894347
    ],
    [
        112.98331387511,
        22.871450636728
    ],
    [
        112.98330599853,
        22.871455813464
    ],
    [
        112.98329784468,
        22.871466957775
    ],
    [
        112.98327070396,
        22.871464327926
    ],
    [
        112.98325577769,
        22.871461661336
    ],
    [
        112.98320747738,
        22.871446079745
    ],
    [
        112.98319037573,
        22.871447217774
    ],
    [
        112.98317300152,
        22.871449441775
    ],
    [
        112.98315833106,
        22.87146250605
    ],
    [
        112.98315452692,
        22.871466586218
    ],
    [
        112.9831211026,
        22.871504661801
    ],
    [
        112.98308143436,
        22.871543300899
    ],
    [
        112.98307952446,
        22.871553341917
    ],
    [
        112.98306864844,
        22.871572090658
    ],
    [
        112.98298059904,
        22.871675710535
    ],
    [
        112.98292498445,
        22.871642265547
    ],
    [
        112.98291222753,
        22.871640952409
    ],
    [
        112.98284058555,
        22.871618685569
    ],
    [
        112.98278275534,
        22.871628920666
    ],
    [
        112.98271837062,
        22.871679050316
    ],
    [
        112.98263468343,
        22.871757730848
    ],
    [
        112.98257761647,
        22.871818419551
    ],
    [
        112.98254336099,
        22.871870347632
    ],
    [
        112.98253682885,
        22.871887729488
    ],
    [
        112.98246534187,
        22.871980480769
    ],
    [
        112.98237567211,
        22.872065983932
    ],
    [
        112.98228224108,
        22.87210919995
    ],
    [
        112.98221516531,
        22.872128993729
    ],
    [
        112.98214157086,
        22.872150987779
    ],
    [
        112.98176542036,
        22.872280052143
    ],
    [
        112.98169236635,
        22.872298547783
    ],
    [
        112.98164809468,
        22.872314205827
    ],
    [
        112.98163964822,
        22.872344891065
    ],
    [
        112.98163474608,
        22.872360372386
    ],
    [
        112.98163405101,
        22.872518764108
    ],
    [
        112.9816337265,
        22.872574093116
    ],
    [
        112.98163286602,
        22.872622101796
    ],
    [
        112.98162683615,
        22.872681253654
    ],
    [
        112.98125508401,
        22.872718528861
    ],
    [
        112.98109024226,
        22.872738056342
    ],
    [
        112.98108047449,
        22.872729968914
    ],
    [
        112.98104137189,
        22.872730437044
    ],
    [
        112.98091975054,
        22.872697427722
    ],
    [
        112.98088583819,
        22.872664515225
    ],
    [
        112.98082825761,
        22.872676477781
    ],
    [
        112.98082580091,
        22.872689780118
    ],
    [
        112.98080949668,
        22.872701256703
    ],
    [
        112.98081567983,
        22.872766857855
    ],
    [
        112.98082677587,
        22.87280639679
    ],
    [
        112.98083677562,
        22.872856518908
    ],
    [
        112.98083995379,
        22.872941120927
    ],
    [
        112.98084042454,
        22.873017329518
    ],
    [
        112.9808553253,
        22.873053865529
    ],
    [
        112.98085557321,
        22.873078815906
    ],
    [
        112.9808441502,
        22.87309758932
    ],
    [
        112.98081046603,
        22.873109699324
    ],
    [
        112.98071677554,
        22.873113179139
    ],
    [
        112.98057526595,
        22.873139980212
    ],
    [
        112.98051687476,
        22.873144369038
    ],
    [
        112.98050462663,
        22.873173456552
    ],
    [
        112.98050424057,
        22.873294691311
    ],
    [
        112.98047136324,
        22.873313044856
    ],
    [
        112.97969198303,
        22.873513728925
    ],
    [
        112.97949693388,
        22.873546693885
    ],
    [
        112.97882942518,
        22.873659103984
    ],
    [
        112.9787851411,
        22.87366456686
    ],
    [
        112.97875281076,
        22.87366859109
    ],
    [
        112.97875987808,
        22.873663930703
    ],
    [
        112.97873711419,
        22.873605237655
    ],
    [
        112.97870760445,
        22.873498045531
    ],
    [
        112.97869377364,
        22.873472920659
    ],
    [
        112.97869895042,
        22.873456611128
    ],
    [
        112.97860472244,
        22.873417143151
    ],
    [
        112.97853274628,
        22.87340220208
    ],
    [
        112.97847134744,
        22.873405088431
    ],
    [
        112.97845773317,
        22.873438004484
    ],
    [
        112.97846906524,
        22.873520913313
    ],
    [
        112.97850894199,
        22.873582731557
    ],
    [
        112.97852794179,
        22.873600494103
    ],
    [
        112.97857244591,
        22.873652246135
    ],
    [
        112.97856754481,
        22.873664214825
    ],
    [
        112.97861176664,
        22.873727090165
    ],
    [
        112.97865817137,
        22.873779374282
    ],
    [
        112.97870508727,
        22.873865829615
    ],
    [
        112.97871213746,
        22.873879611632
    ],
    [
        112.97873737318,
        22.873909809325
    ],
    [
        112.97875825529,
        22.873947632197
    ],
    [
        112.9788111478,
        22.874033236147
    ],
    [
        112.97887409252,
        22.874117145437
    ],
    [
        112.97893458639,
        22.874207041744
    ],
    [
        112.9789451628,
        22.8742262252
    ],
    [
        112.97898585544,
        22.874284528426
    ],
    [
        112.97904362561,
        22.874381500682
    ],
    [
        112.97907318879,
        22.874430932563
    ],
    [
        112.97912066205,
        22.874499772064
    ],
    [
        112.97913854016,
        22.874554166182
    ],
    [
        112.97911840579,
        22.874590644361
    ],
    [
        112.97910589807,
        22.874604289369
    ],
    [
        112.97902518242,
        22.874647145815
    ],
    [
        112.97892488889,
        22.874710212599
    ],
    [
        112.97886807969,
        22.874748847054
    ],
    [
        112.9789068706,
        22.874808788206
    ],
    [
        112.97908208248,
        22.875105385519
    ],
    [
        112.97905164637,
        22.875119423696
    ],
    [
        112.97886058583,
        22.87522542532
    ],
    [
        112.97885674694,
        22.875265320785
    ],
    [
        112.97885228976,
        22.875389026423
    ],
    [
        112.97850566333,
        22.875381453643
    ],
    [
        112.97843378613,
        22.875253962886
    ],
    [
        112.97817033748,
        22.874870249235
    ],
    [
        112.97810704274,
        22.874862591204
    ],
    [
        112.9780453216,
        22.874916490424
    ],
    [
        112.97780362097,
        22.875101702333
    ],
    [
        112.97779029209,
        22.875119164684
    ],
    [
        112.97779219838,
        22.875114267839
    ],
    [
        112.97761140551,
        22.874937240209
    ],
    [
        112.9774925037,
        22.874820218185
    ],
    [
        112.97737954504,
        22.874738959603
    ],
    [
        112.97736923014,
        22.874727653065
    ],
    [
        112.97721150652,
        22.874568396694
    ],
    [
        112.97698509388,
        22.874341126097
    ],
    [
        112.97694674888,
        22.874374269951
    ],
    [
        112.97694483749,
        22.874384321216
    ],
    [
        112.97693640541,
        22.874393343354
    ],
    [
        112.97690487829,
        22.874399580001
    ],
    [
        112.97688256924,
        22.874428520239
    ],
    [
        112.97684532458,
        22.874446469774
    ],
    [
        112.97681704223,
        22.874469767207
    ],
    [
        112.97679393186,
        22.874483256739
    ],
    [
        112.97676755275,
        22.874505182742
    ],
    [
        112.97673682163,
        22.874531486642
    ],
    [
        112.97670202284,
        22.874548334323
    ],
    [
        112.97667130234,
        22.874562706302
    ],
    [
        112.97663893878,
        22.874590654218
    ],
    [
        112.97660685748,
        22.874606938252
    ],
    [
        112.9765837419,
        22.874625313606
    ],
    [
        112.97657041805,
        22.874634110238
    ],
    [
        112.97655926251,
        22.874649125758
    ],
    [
        112.97642275577,
        22.874743097105
    ],
    [
        112.97641866997,
        22.874753439894
    ],
    [
        112.97639909653,
        22.874760938319
    ],
    [
        112.97637516223,
        22.87478230825
    ],
    [
        112.97635557779,
        22.874801740913
    ],
    [
        112.97633109439,
        22.874829083367
    ],
    [
        112.97628487089,
        22.87485526724
    ],
    [
        112.9762582205,
        22.874874494322
    ],
    [
        112.97620738304,
        22.874893400189
    ],
    [
        112.97619678475,
        22.874892683375
    ],
    [
        112.97618754112,
        22.874896564913
    ],
    [
        112.9761638963,
        22.874897595083
    ],
    [
        112.97615574684,
        22.874893601586
    ],
    [
        112.97613616841,
        22.874905714798
    ],
    [
        112.97611224203,
        22.874917325909
    ],
    [
        112.97608586467,
        22.874934384392
    ],
    [
        112.97606547561,
        22.874941081875
    ],
    [
        112.97603937156,
        22.874956240293
    ],
    [
        112.97601950897,
        22.874981647486
    ],
    [
        112.97601162397,
        22.8749855177
    ],
    [
        112.97600181786,
        22.875010018175
    ],
    [
        112.97599610094,
        22.875020648719
    ],
    [
        112.97597054387,
        22.875031735238
    ],
    [
        112.97588568524,
        22.875101959978
    ],
    [
        112.97585468764,
        22.875117981773
    ],
    [
        112.97581797114,
        22.875146534194
    ],
    [
        112.97579649043,
        22.87515731452
    ],
    [
        112.97578941956,
        22.875162263274
    ],
    [
        112.97573476434,
        22.87519125914
    ],
    [
        112.97567304548,
        22.875216527767
    ],
    [
        112.97561186962,
        22.875241794147
    ],
    [
        112.97556727894,
        22.875260123164
    ],
    [
        112.97554334636,
        22.875276355657
    ],
    [
        112.97552131678,
        22.875292027761
    ],
    [
        112.97543777712,
        22.875400782029
    ],
    [
        112.9752799529,
        22.875600315362
    ],
    [
        112.97527805192,
        22.875598435586
    ],
    [
        112.97519814183,
        22.875596513491
    ],
    [
        112.97515275687,
        22.875588014259
    ],
    [
        112.97493206525,
        22.875257447591
    ],
    [
        112.97486663682,
        22.875167525455
    ],
    [
        112.97463589597,
        22.874820838493
    ],
    [
        112.97460927199,
        22.874803485197
    ],
    [
        112.97459624106,
        22.874784635284
    ],
    [
        112.97457368316,
        22.874779716402
    ],
    [
        112.97455927963,
        22.874775526704
    ],
    [
        112.97453942394,
        22.874788209246
    ],
    [
        112.97452473047,
        22.874803821608
    ],
    [
        112.97446786561,
        22.874859201106
    ],
    [
        112.97447140007,
        22.874858621678
    ],
    [
        112.9744281399,
        22.874899757375
    ],
    [
        112.9743432455,
        22.874986897653
    ],
    [
        112.97433317605,
        22.874999208712
    ],
    [
        112.97428800358,
        22.875049861665
    ],
    [
        112.97426133029,
        22.875085402681
    ],
    [
        112.97420799963,
        22.875138585941
    ],
    [
        112.97416363741,
        22.875194387519
    ],
    [
        112.97416282062,
        22.87519575233
    ],
    [
        112.97412447907,
        22.875207011532
    ],
    [
        112.97408859722,
        22.875203599753
    ],
    [
        112.97404021229,
        22.875197340338
    ],
    [
        112.97398856294,
        22.875193016469
    ],
    [
        112.9739910075,
        22.87519543095
    ],
    [
        112.97397063169,
        22.875180192323
    ],
    [
        112.97394916788,
        22.875165508237
    ],
    [
        112.97394618935,
        22.875152251023
    ],
    [
        112.97393477323,
        22.875149934041
    ],
    [
        112.97389319782,
        22.875128146624
    ],
    [
        112.97386087327,
        22.875097851795
    ],
    [
        112.97383968959,
        22.875073673849
    ],
    [
        112.97382174892,
        22.875070886712
    ],
    [
        112.97378561469,
        22.875044161153
    ],
    [
        112.97376388142,
        22.87502622835
    ],
    [
        112.97375057491,
        22.875009559282
    ],
    [
        112.97370112294,
        22.87497810058
    ],
    [
        112.97366635047,
        22.874948108558
    ],
    [
        112.97361989722,
        22.874907127104
    ],
    [
        112.97357425958,
        22.874865866928
    ],
    [
        112.97353323477,
        22.874834320528
    ],
    [
        112.97348378236,
        22.874801784745
    ],
    [
        112.97344112403,
        22.874772157842
    ],
    [
        112.97341231606,
        22.874759463021
    ],
    [
        112.97338840664,
        22.874741560574
    ],
    [
        112.9733930302,
        22.874739881254
    ],
    [
        112.97339003994,
        22.874739372477
    ],
    [
        112.97339520405,
        22.874741212866
    ],
    [
        112.97339522459,
        22.874718701846
    ],
    [
        112.97339876853,
        22.874708355834
    ],
    [
        112.97350329613,
        22.874571576851
    ],
    [
        112.97353541769,
        22.874528095256
    ],
    [
        112.97354221297,
        22.874529917998
    ],
    [
        112.97354330323,
        22.874526922491
    ],
    [
        112.97355827855,
        22.874502888831
    ],
    [
        112.97355392996,
        22.874501309973
    ],
    [
        112.97356372188,
        22.87449659031
    ],
    [
        112.97360591869,
        22.87443564055
    ],
    [
        112.97364074995,
        22.874401623819
    ],
    [
        112.97365380401,
        22.874397139879
    ],
    [
        112.97365679765,
        22.874393852188
    ],
    [
        112.97368725919,
        22.874381039664
    ],
    [
        112.97368426333,
        22.874386768239
    ],
    [
        112.97369867544,
        22.874383625794
    ],
    [
        112.97369567907,
        22.874389896778
    ],
    [
        112.97372530785,
        22.874395536826
    ],
    [
        112.97372937746,
        22.874404713281
    ],
    [
        112.97375571993,
        22.874436155499
    ],
    [
        112.97380789701,
        22.874459720985
    ],
    [
        112.97384077378,
        22.874480515924
    ],
    [
        112.97385572829,
        22.874478454044
    ],
    [
        112.97386769322,
        22.874475340087
    ],
    [
        112.97387068999,
        22.874468527041
    ],
    [
        112.97387802543,
        22.87447387132
    ],
    [
        112.97404816752,
        22.874225493248
    ],
    [
        112.9741382891,
        22.87407725572
    ],
    [
        112.97415352816,
        22.874060819725
    ],
    [
        112.97414570276,
        22.873997981961
    ],
    [
        112.97410741301,
        22.873953099868
    ],
    [
        112.97409926407,
        22.873945864621
    ],
    [
        112.97409029097,
        22.873947859536
    ],
    [
        112.97405307778,
        22.873914358374
    ],
    [
        112.97401448842,
        22.873898773179
    ],
    [
        112.97397590415,
        22.873877493541
    ],
    [
        112.97384312268,
        22.873998001003
    ],
    [
        112.97383496561,
        22.873999175032
    ],
    [
        112.97383279191,
        22.873997842736
    ],
    [
        112.97382952545,
        22.87400221788
    ],
    [
        112.97381131044,
        22.874002146043
    ],
    [
        112.97378521188,
        22.874001347277
    ],
    [
        112.97376836417,
        22.873992582178
    ],
    [
        112.97371400247,
        22.873979348444
    ],
    [
        112.97369279855,
        22.873977141412
    ],
    [
        112.9736976938,
        22.873975460106
    ],
    [
        112.97369442879,
        22.873978208271
    ],
    [
        112.97369062027,
        22.873980691231
    ],
    [
        112.97367809813,
        22.873997915971
    ],
    [
        112.9736688589,
        22.873993136242
    ],
    [
        112.97364381706,
        22.874024874068
    ],
    [
        112.97361088036,
        22.874067819688
    ],
    [
        112.97359945594,
        22.874073913209
    ],
    [
        112.97359073495,
        22.874096520804
    ],
    [
        112.97357820915,
        22.874117543481
    ],
    [
        112.97357030529,
        22.874138514841
    ],
    [
        112.97353328035,
        22.874192085139
    ],
    [
        112.97352018566,
        22.874240236056
    ],
    [
        112.9734796256,
        22.87429438969
    ],
    [
        112.97346055273,
        22.874339082323
    ],
    [
        112.9734515648,
        22.874356269528
    ],
    [
        112.97344337779,
        22.874389449425
    ],
    [
        112.97342024186,
        22.874417644157
    ],
    [
        112.97341452727,
        22.874423132641
    ],
    [
        112.97338730822,
        22.874456526874
    ],
    [
        112.97336959669,
        22.87449903574
    ],
    [
        112.97336551464,
        22.874503149958
    ],
    [
        112.97335816421,
        22.874513538965
    ],
    [
        112.97333883526,
        22.874540878483
    ],
    [
        112.97332876194,
        22.874555637818
    ],
    [
        112.97333093233,
        22.874560766365
    ],
    [
        112.97332494256,
        22.874569784108
    ],
    [
        112.97331621477,
        22.87459971632
    ],
    [
        112.97326594607,
        22.874566383853
    ],
    [
        112.97324040587,
        22.874547417585
    ],
    [
        112.9732319762,
        22.874548598236
    ],
    [
        112.97321947982,
        22.874537078133
    ],
    [
        112.97319691885,
        22.874530554611
    ],
    [
        112.9731727466,
        22.874502081498
    ],
    [
        112.97316324247,
        22.874488900477
    ],
    [
        112.97314475928,
        22.874482873672
    ],
    [
        112.97314041666,
        22.874474515677
    ],
    [
        112.97311162075,
        22.874447452549
    ],
    [
        112.97311488227,
        22.874448771271
    ],
    [
        112.97311597435,
        22.874443876918
    ],
    [
        112.97312659256,
        22.874428296201
    ],
    [
        112.97313614514,
        22.874388860933
    ],
    [
        112.97315574965,
        22.874358260953
    ],
    [
        112.97316527775,
        22.874345405119
    ],
    [
        112.97318161371,
        22.874321080728
    ],
    [
        112.97318025674,
        22.874318384065
    ],
    [
        112.97319685157,
        22.874308160013
    ],
    [
        112.97320612626,
        22.874275237531
    ],
    [
        112.97321730597,
        22.874240394944
    ],
    [
        112.97321785753,
        22.874231981046
    ],
    [
        112.97324288346,
        22.874218949505
    ],
    [
        112.9732654894,
        22.874176654792
    ],
    [
        112.97326004905,
        22.87417942865
    ],
    [
        112.9732668476,
        22.874177995453
    ],
    [
        112.97327773781,
        22.874162141588
    ],
    [
        112.97328347039,
        22.874137396192
    ],
    [
        112.97330061608,
        22.874119301933
    ],
    [
        112.97331150299,
        22.874106974144
    ],
    [
        112.97331205105,
        22.874102357317
    ],
    [
        112.9733237657,
        22.874077002017
    ],
    [
        112.97333602135,
        22.874054624055
    ],
    [
        112.97335316694,
        22.874036530442
    ],
    [
        112.97336434988,
        22.873998163245
    ],
    [
        112.97338667466,
        22.873965637362
    ],
    [
        112.97340028135,
        22.873952194799
    ],
    [
        112.97340548103,
        22.873915793748
    ],
    [
        112.97349863762,
        22.873730324448
    ],
    [
        112.97353321383,
        22.873679492776
    ],
    [
        112.9735280524,
        22.873674939731
    ],
    [
        112.97359642328,
        22.873536673684
    ],
    [
        112.97360407387,
        22.873496178022
    ],
    [
        112.97360381066,
        22.873486959711
    ],
    [
        112.97359864013,
        22.873492170168
    ],
    [
        112.97358370211,
        22.87347606339
    ],
    [
        112.973553815,
        22.873455512586
    ],
    [
        112.9735244672,
        22.873439567023
    ],
    [
        112.97348641953,
        22.87342317695
    ],
    [
        112.97348642081,
        22.873421820872
    ],
    [
        112.97331465773,
        22.873350525471
    ],
    [
        112.97329506271,
        22.873370816936
    ],
    [
        112.97328117659,
        22.873391857603
    ],
    [
        112.97323569094,
        22.873476992147
    ],
    [
        112.97318800553,
        22.87358818968
    ],
    [
        112.97315858971,
        22.873643039059
    ],
    [
        112.97309266317,
        22.873779942309
    ],
    [
        112.97307248112,
        22.87384607862
    ],
    [
        112.97305859148,
        22.873870647316
    ],
    [
        112.97305149199,
        22.873903003265
    ],
    [
        112.97304522844,
        22.873913652589
    ],
    [
        112.9730204375,
        22.873965468378
    ],
    [
        112.97298232332,
        22.874017438335
    ],
    [
        112.97298260076,
        22.874011468441
    ],
    [
        112.97295347084,
        22.874050859689
    ],
    [
        112.9729295259,
        22.874069850485
    ],
    [
        112.97290126615,
        22.874050379432
    ],
    [
        112.97287436431,
        22.87403252044
    ],
    [
        112.97285209616,
        22.874002403443
    ],
    [
        112.97283280684,
        22.873985270333
    ],
    [
        112.97282248213,
        22.873976983014
    ],
    [
        112.9728175903,
        22.873974327901
    ],
    [
        112.97281867768,
        22.873974586438
    ],
    [
        112.97281188829,
        22.873965715563
    ],
    [
        112.9727993855,
        22.873960437157
    ],
    [
        112.97278199867,
        22.873944096169
    ],
    [
        112.97276406671,
        22.873929117834
    ],
    [
        112.97274042457,
        22.873914206584
    ],
    [
        112.97271106182,
        22.873910482559
    ],
    [
        112.9727026358,
        22.873907055663
    ],
    [
        112.97269014395,
        22.873889844702
    ],
    [
        112.97269122959,
        22.873892001655
    ],
    [
        112.97268825801,
        22.873871153155
    ],
    [
        112.97269398414,
        22.873853999479
    ],
    [
        112.97269564828,
        22.873818993462
    ],
    [
        112.97270791403,
        22.873787117571
    ],
    [
        112.97270655573,
        22.873785777445
    ],
    [
        112.97271010556,
        22.873769734231
    ],
    [
        112.97271639101,
        22.873736030104
    ],
    [
        112.97271557172,
        22.873739836693
    ],
    [
        112.97268786372,
        22.873711142157
    ],
    [
        112.97263894929,
        22.873679443288
    ],
    [
        112.97252778703,
        22.87362515857
    ],
    [
        112.97237286179,
        22.873551606725
    ],
    [
        112.97236470759,
        22.873547907324
    ],
    [
        112.97234077703,
        22.873549278795
    ],
    [
        112.97231708291,
        22.873588346365
    ],
    [
        112.97231572047,
        22.873591346056
    ],
    [
        112.97225877998,
        22.873706482316
    ],
    [
        112.97224597868,
        22.873728604741
    ],
    [
        112.97224951784,
        22.873724222696
    ],
    [
        112.97222198204,
        22.873800223049
    ],
    [
        112.97221485104,
        22.8738654002
    ],
    [
        112.97220991428,
        22.873910481149
    ],
    [
        112.97219710062,
        22.873945893603
    ],
    [
        112.97219710214,
        22.873944266307
    ],
    [
        112.97218512776,
        22.873954445914
    ],
    [
        112.97217098926,
        22.873952447216
    ],
    [
        112.97214053494,
        22.873950375101
    ],
    [
        112.97213945074,
        22.87394659126
    ],
    [
        112.97212286474,
        22.873944622687
    ],
    [
        112.97210628072,
        22.873940484571
    ],
    [
        112.97204456975,
        22.87392116546
    ],
    [
        112.97201574755,
        22.873917991157
    ],
    [
        112.97200351332,
        22.873914885956
    ],
    [
        112.97198964009,
        22.873919666062
    ],
    [
        112.97197467959,
        22.873923917168
    ],
    [
        112.97196815074,
        22.873926437955
    ],
    [
        112.9719401289,
        22.873939528092
    ],
    [
        112.97193850079,
        22.873935751062
    ],
    [
        112.97189578684,
        22.873956616118
    ],
    [
        112.97184167444,
        22.873952399959
    ],
    [
        112.97173812064,
        22.873891300275
    ],
    [
        112.97161065184,
        22.873810978434
    ],
    [
        112.97149189461,
        22.873718895776
    ],
    [
        112.97142284768,
        22.873686947089
    ],
    [
        112.97141850191,
        22.87368103515
    ],
    [
        112.97137852281,
        22.873682352918
    ],
    [
        112.97131756009,
        22.87372895856
    ],
    [
        112.97118281712,
        22.87385841168
    ],
    [
        112.97108563146,
        22.873958375116
    ],
    [
        112.97107120604,
        22.87397022213
    ],
    [
        112.97098410983,
        22.874040500358
    ],
    [
        112.97095794642,
        22.874098605785
    ],
    [
        112.97095412766,
        22.874110588391
    ],
    [
        112.97093723512,
        22.874143080639
    ],
    [
        112.97093069332,
        22.874158624215
    ],
    [
        112.97092606466,
        22.874164108232
    ],
    [
        112.97092715986,
        22.874156228913
    ],
    [
        112.9709080646,
        22.874217769725
    ],
    [
        112.97100240377,
        22.874256421766
    ],
    [
        112.97111550363,
        22.874299449996
    ],
    [
        112.97120277894,
        22.874327627115
    ],
    [
        112.97124056919,
        22.874341520607
    ],
    [
        112.97128216153,
        22.874361062266
    ],
    [
        112.97139145767,
        22.874395751141
    ],
    [
        112.97139281498,
        22.874398446156
    ],
    [
        112.97140614059,
        22.874398820563
    ],
    [
        112.97142679787,
        22.874411307362
    ],
    [
        112.97145289479,
        22.874423183602
    ],
    [
        112.97146350121,
        22.874423050272
    ],
    [
        112.9714629498,
        22.874431193608
    ],
    [
        112.9714618682,
        22.874424426863
    ],
    [
        112.97146376817,
        22.874428471188
    ],
    [
        112.97148523968,
        22.874442575822
    ],
    [
        112.97148061939,
        22.874439379265
    ],
    [
        112.97152601711,
        22.87445969336
    ],
    [
        112.97155836245,
        22.874478273477
    ],
    [
        112.97159533588,
        22.874491372234
    ],
    [
        112.97164100539,
        22.874511143925
    ],
    [
        112.97172175973,
        22.874526684591
    ],
    [
        112.97171985309,
        22.874529962797
    ],
    [
        112.9717723039,
        22.874567825684
    ],
    [
        112.97179920084,
        22.874595699577
    ],
    [
        112.97181059503,
        22.874625663671
    ],
    [
        112.9718127716,
        22.874624551959
    ],
    [
        112.97161452327,
        22.874921549428
    ],
    [
        112.97160499108,
        22.87493685631
    ],
    [
        112.9715330857,
        22.87505817418
    ],
    [
        112.97147842124,
        22.8750599445
    ],
    [
        112.97133077821,
        22.875026547676
    ],
    [
        112.97118831552,
        22.874975741173
    ],
    [
        112.97100667779,
        22.874934401044
    ],
    [
        112.97098238017,
        22.875035876611
    ],
    [
        112.97098454984,
        22.875042629036
    ],
    [
        112.97089236414,
        22.875027545645
    ],
    [
        112.97088583221,
        22.875032511987
    ],
    [
        112.97058123089,
        22.875012614504
    ],
    [
        112.97056457831,
        22.875080365525
    ],
    [
        112.97054602947,
        22.875139734024
    ],
    [
        112.97051711905,
        22.875227987873
    ],
    [
        112.97048851609,
        22.875276912103
    ],
    [
        112.97048715393,
        22.875279370992
    ],
    [
        112.97047516572,
        22.875302311115
    ],
    [
        112.97043211801,
        22.875383701513
    ],
    [
        112.97040433482,
        22.875428276985
    ],
    [
        112.97037601026,
        22.87546987675
    ],
    [
        112.97036539437,
        22.875478967556
    ],
    [
        112.97033684188,
        22.875471209918
    ],
    [
        112.9701562687,
        22.875433748492
    ],
    [
        112.97000424118,
        22.875408668887
    ],
    [
        112.96997594413,
        22.875418000555
    ],
    [
        112.96990874321,
        22.875434639118
    ],
    [
        112.96985049929,
        22.875472313562
    ],
    [
        112.96984722977,
        22.875478324651
    ],
    [
        112.96985104186,
        22.875473933489
    ],
    [
        112.96985512208,
        22.875473878136
    ],
    [
        112.96980610405,
        22.875536380758
    ],
    [
        112.96975838141,
        22.875671281579
    ],
    [
        112.96976273176,
        22.875673392045
    ],
    [
        112.9697537149,
        22.875718807797
    ],
    [
        112.96974272615,
        22.875840733194
    ],
    [
        112.96974326803,
        22.875843166745
    ],
    [
        112.96970790154,
        22.875848259847
    ],
    [
        112.96970622792,
        22.875895202956
    ],
    [
        112.96968467371,
        22.875968725538
    ],
    [
        112.96953396206,
        22.876606793234
    ],
    [
        112.96948121022,
        22.876583110024
    ],
    [
        112.96942246922,
        22.876564393065
    ],
    [
        112.96939799533,
        22.876554696383
    ],
    [
        112.96935012889,
        22.876542883127
    ],
    [
        112.96929382309,
        22.876538240019
    ],
    [
        112.96924295948,
        22.876531353228
    ],
    [
        112.96922145397,
        22.876548739341
    ],
    [
        112.96920348488,
        22.87656607641
    ],
    [
        112.96918959699,
        22.876582543078
    ],
    [
        112.96918522425,
        22.876605928699
    ],
    [
        112.96918547496,
        22.876630605905
    ],
    [
        112.96918871293,
        22.876661208203
    ],
    [
        112.96921371538,
        22.876689608548
    ],
    [
        112.96923518811,
        22.876710193114
    ],
    [
        112.96926402415,
        22.876709249404
    ],
    [
        112.9692871612,
        22.876692383559
    ],
    [
        112.96931272941,
        22.87669528309
    ],
    [
        112.96936250032,
        22.876707068955
    ],
    [
        112.96945578653,
        22.876728561522
    ],
    [
        112.969466938,
        22.876730306211
    ],
    [
        112.96975520438,
        22.87681612757
    ],
    [
        112.9701940991,
        22.876962087129
    ],
    [
        112.97028651582,
        22.877035710866
    ],
    [
        112.97031258926,
        22.877080657466
    ],
    [
        112.97032780299,
        22.877101881534
    ],
    [
        112.97031987429,
        22.87714999236
    ],
    [
        112.97024271296,
        22.877370434478
    ],
    [
        112.97015823113,
        22.877563585403
    ],
    [
        112.97013591543,
        22.87757744512
    ],
    [
        112.97011497486,
        22.877573115067
    ],
    [
        112.97007282247,
        22.877563374525
    ],
    [
        112.97001054484,
        22.877549566554
    ],
    [
        112.96985141318,
        22.877557413431
    ],
    [
        112.96982093845,
        22.877568675862
    ],
    [
        112.96981030698,
        22.877596213365
    ],
    [
        112.96978358657,
        22.877671975433
    ],
    [
        112.96977590251,
        22.877753445564
    ],
    [
        112.9696832415,
        22.877966259928
    ],
    [
        112.96966279519,
        22.878021054476
    ],
    [
        112.96964265028,
        22.878040044232
    ],
    [
        112.96961517098,
        22.878046658646
    ],
    [
        112.96961436026,
        22.878040160498
    ],
    [
        112.96958932773,
        22.878048369109
    ],
    [
        112.9695409162,
        22.878038456435
    ],
    [
        112.96940166481,
        22.878008372593
    ],
    [
        112.96926593826,
        22.877989642082
    ],
    [
        112.96918079168,
        22.877990556962
    ],
    [
        112.96913862601,
        22.877991145854
    ],
    [
        112.96913373492,
        22.877984433755
    ],
    [
        112.96912502504,
        22.877990251146
    ],
    [
        112.96910381322,
        22.87798186893
    ],
    [
        112.96910571659,
        22.877982927163
    ],
    [
        112.96909265986,
        22.877981753867
    ],
    [
        112.96904832527,
        22.877972882619
    ],
    [
        112.96899936016,
        22.87797085803
    ],
    [
        112.96899419227,
        22.877969845803
    ],
    [
        112.96900045347,
        22.877964604627
    ],
    [
        112.96895747795,
        22.877956530192
    ],
    [
        112.96893898416,
        22.877950552642
    ],
    [
        112.96887886818,
        22.877944348995
    ],
    [
        112.96880460959,
        22.877933194466
    ],
    [
        112.96877740994,
        22.877927341909
    ],
    [
        112.96874422871,
        22.877917235176
    ],
    [
        112.96873225763,
        22.877918490054
    ],
    [
        112.96871483525,
        22.87793229855
    ],
    [
        112.96870748453,
        22.877938912299
    ],
    [
        112.96870040876,
        22.877941996323
    ],
    [
        112.96862424342,
        22.877931961152
    ],
    [
        112.96859160685,
        22.877920493328
    ],
    [
        112.96858617315,
        22.877911620718
    ],
    [
        112.96858700633,
        22.877890996195
    ],
    [
        112.96858346873,
        22.877892131603
    ],
    [
        112.96855926842,
        22.877877289234
    ],
    [
        112.96849126206,
        22.877869041463
    ],
    [
        112.96839931824,
        22.877855987225
    ],
    [
        112.96829187132,
        22.877836652113
    ],
    [
        112.96824562456,
        22.877832438664
    ],
    [
        112.96822984325,
        22.877834565569
    ],
    [
        112.96821676596,
        22.877856723615
    ],
    [
        112.96819141615,
        22.877914860475
    ],
    [
        112.96817748,
        22.877988834038
    ],
    [
        112.9681646218,
        22.878075539391
    ],
    [
        112.96814659877,
        22.8781571667
    ],
    [
        112.96813785607,
        22.87820204482
    ],
    [
        112.96813266003,
        22.878234937822
    ],
    [
        112.96813807642,
        22.87826550693
    ],
    [
        112.9681600801,
        22.878306684049
    ],
    [
        112.96818100322,
        22.878338384423
    ],
    [
        112.96822070301,
        22.878364659886
    ],
    [
        112.96825987588,
        22.878369517461
    ],
    [
        112.96828869702,
        22.878390798517
    ],
    [
        112.96831398413,
        22.878408605157
    ],
    [
        112.96831831541,
        22.878435393406
    ],
    [
        112.96830900991,
        22.878504146287
    ],
    [
        112.96828743429,
        22.878607250162
    ],
    [
        112.96825740571,
        22.878734615174
    ],
    [
        112.96822413758,
        22.878830837322
    ],
    [
        112.96821647324,
        22.878889531932
    ],
    [
        112.96821398963,
        22.87893377686
    ],
    [
        112.96820634842,
        22.8789634506
    ],
    [
        112.9681951556,
        22.879011890082
    ],
    [
        112.96818559974,
        22.879054610275
    ],
    [
        112.96817087274,
        22.879099846523
    ],
    [
        112.96817193886,
        22.879128038044
    ],
    [
        112.9681623859,
        22.879167232473
    ],
    [
        112.96814249507,
        22.879205763384
    ],
    [
        112.9681457463,
        22.879223074334
    ],
    [
        112.9681274966,
        22.879250461517
    ],
    [
        112.96812283697,
        22.879294738298
    ],
    [
        112.96811466331,
        22.879309774265
    ],
    [
        112.96811465782,
        22.879316826101
    ],
    [
        112.96812254294,
        22.879322949597
    ],
    [
        112.96812905315,
        22.87934780738
    ],
    [
        112.96813856224,
        22.879364756212
    ],
    [
        112.96817038122,
        22.879380838889
    ],
    [
        112.96824057367,
        22.879380364413
    ],
    [
        112.96826152134,
        22.879381688767
    ],
    [
        112.96825934167,
        22.879385788605
    ],
    [
        112.96827240409,
        22.879381260234
    ],
    [
        112.96829796602,
        22.879396350614
    ],
    [
        112.96834094341,
        22.87940657944
    ],
    [
        112.96841574298,
        22.879427471608
    ],
    [
        112.9684679677,
        22.879440282665
    ],
    [
        112.96848455732,
        22.879447638928
    ],
    [
        112.96856778358,
        22.879476010631
    ],
    [
        112.96864884063,
        22.879494110578
    ],
    [
        112.96869915948,
        22.879507226573
    ],
    [
        112.96876823898,
        22.879533638858
    ],
    [
        112.9688580037,
        22.879546471409
    ],
    [
        112.96891104226,
        22.879559012403
    ],
    [
        112.96893035384,
        22.879563350893
    ],
    [
        112.96893605945,
        22.879572763258
    ],
    [
        112.96893796626,
        22.879569481726
    ],
    [
        112.96895373976,
        22.879575768878
    ],
    [
        112.96897141523,
        22.879585012847
    ],
    [
        112.96897685066,
        22.879591988147
    ],
    [
        112.96897303478,
        22.879601534608
    ],
    [
        112.96896616223,
        22.879694931767
    ],
    [
        112.96893533472,
        22.879809008105
    ],
    [
        112.9689383239,
        22.879813305547
    ],
    [
        112.96893478651,
        22.879814440281
    ],
    [
        112.96893804361,
        22.8798241584
    ],
    [
        112.96893504001,
        22.879838846743
    ],
    [
        112.968921423,
        22.879858566708
    ],
    [
        112.96887257954,
        22.880054536478
    ],
    [
        112.96883713204,
        22.880163798057
    ],
    [
        112.96883412798,
        22.880179300283
    ],
    [
        112.96883357578,
        22.880190157029
    ],
    [
        112.96882100584,
        22.880265192577
    ],
    [
        112.96873695163,
        22.880623586148
    ],
    [
        112.96872086132,
        22.880677788358
    ],
    [
        112.9687118578,
        22.880713446718
    ],
    [
        112.96870775222,
        22.880747679372
    ],
    [
        112.96870392463,
        22.880773771352
    ],
    [
        112.96869030971,
        22.880791052142
    ],
    [
        112.96870499318,
        22.880800878624
    ],
    [
        112.9687139679,
        22.880804819413
    ],
    [
        112.96875775945,
        22.880815860184
    ],
    [
        112.96878957637,
        22.880833038616
    ],
    [
        112.9687966455,
        22.880838634168
    ],
    [
        112.96880752819,
        22.880837395119
    ],
    [
        112.96880616266,
        22.880844737527
    ],
    [
        112.96881214438,
        22.880849263643
    ],
    [
        112.96881785306,
        22.880855149767
    ],
    [
        112.96881730075,
        22.880866549029
    ],
    [
        112.96880340307,
        22.880899021583
    ],
    [
        112.96877969279,
        22.880957942165
    ],
    [
        112.96875542121,
        22.881041010092
    ],
    [
        112.96874531166,
        22.881102450496
    ],
    [
        112.96873168062,
        22.881142785412
    ],
    [
        112.96872214924,
        22.881156482088
    ],
    [
        112.96871859181,
        22.881185824994
    ],
    [
        112.96872919406,
        22.881196523383
    ],
    [
        112.96875829144,
        22.881212926284
    ],
    [
        112.96881404498,
        22.88123519025
    ],
    [
        112.96882547153,
        22.881234214832
    ],
    [
        112.96883852498,
        22.881240810794
    ],
    [
        112.96888503293,
        22.881256969559
    ],
    [
        112.96892446999,
        22.881269703255
    ],
    [
        112.96892446004,
        22.881283807137
    ],
    [
        112.96892391194,
        22.881289510605
    ],
    [
        112.96892581089,
        22.88129707816
    ],
    [
        112.96893043239,
        22.88130162386
    ],
    [
        112.96892796185,
        22.881333120883
    ],
    [
        112.96890317022,
        22.881384189742
    ],
    [
        112.96887811227,
        22.881427125942
    ],
    [
        112.96886965896,
        22.881455724089
    ],
    [
        112.96886257895,
        22.881465588267
    ],
    [
        112.96884896663,
        22.881480155664
    ],
    [
        112.96885222551,
        22.881488246379
    ],
    [
        112.96883479867,
        22.88151127583
    ],
    [
        112.96881654116,
        22.881555201644
    ],
    [
        112.96879720377,
        22.881587208991
    ],
    [
        112.96878739839,
        22.881604163975
    ],
    [
        112.9687901123,
        22.881613618442
    ],
    [
        112.96880616406,
        22.881612034911
    ],
    [
        112.96882656872,
        22.881610118693
    ],
    [
        112.96882493644,
        22.881610141792
    ],
    [
        112.96886437395,
        22.881622874212
    ],
    [
        112.96888422895,
        22.881628831982
    ],
    [
        112.96892093229,
        22.881661132567
    ],
    [
        112.96893072306,
        22.881665062958
    ],
    [
        112.96895328825,
        22.881685629544
    ],
    [
        112.96894238878,
        22.881711549589
    ],
    [
        112.96893801799,
        22.881737920166
    ],
    [
        112.96890344439,
        22.881773395876
    ],
    [
        112.96890235584,
        22.881773953687
    ],
    [
        112.96882257356,
        22.881881673318
    ],
    [
        112.96856115563,
        22.88225480391
    ],
    [
        112.96873767045,
        22.882323079482
    ],
    [
        112.96882633048,
        22.882363591862
    ],
    [
        112.96878513223,
        22.882545084752
    ],
    [
        112.96877805187,
        22.882556034269
    ],
    [
        112.96875190313,
        22.882605497597
    ],
    [
        112.96872820939,
        22.882644890974
    ],
    [
        112.9687192194,
        22.882664004727
    ],
    [
        112.96873526295,
        22.882675168445
    ],
    [
        112.96878040953,
        22.882695412528
    ],
    [
        112.96882447069,
        22.882711062203
    ],
    [
        112.96891477104,
        22.882738808089
    ],
    [
        112.96894034157,
        22.882740888749
    ],
    [
        112.96894061222,
        22.882743054771
    ],
    [
        112.96894713915,
        22.882746217588
    ],
    [
        112.96902166151,
        22.882771750073
    ],
    [
        112.96915302535,
        22.882817917934
    ],
    [
        112.96926426764,
        22.882847559013
    ],
    [
        112.96928493606,
        22.88285676478
    ],
    [
        112.96929690392,
        22.882859039618
    ],
    [
        112.96929526912,
        22.882863130764
    ],
    [
        112.96932410172,
        22.882867070274
    ],
    [
        112.96935754589,
        22.882891017371
    ],
    [
        112.96939805509,
        22.882926801514
    ],
    [
        112.96941080865,
        22.882976531492
    ],
    [
        112.96941323365,
        22.88301311402
    ],
    [
        112.96940424878,
        22.883025714789
    ],
    [
        112.96939525499,
        22.883052419693
    ],
    [
        112.96917697462,
        22.883672230994
    ],
    [
        112.96919873632,
        22.883673826086
    ],
    [
        112.97004400661,
        22.883951652579
    ],
    [
        112.96984509723,
        22.884541559287
    ],
    [
        112.96982766659,
        22.884580039849
    ],
    [
        112.96984751478,
        22.884595502057
    ],
    [
        112.97004876536,
        22.884659778865
    ],
    [
        112.97023586866,
        22.884721556205
    ],
    [
        112.97004823431,
        22.885129293606
    ],
    [
        112.96929500972,
        22.886193072651
    ],
    [
        112.9692922854,
        22.886201247633
    ],
    [
        112.96920410272,
        22.886291711955
    ],
    [
        112.96914640138,
        22.88635354583
    ],
    [
        112.96902744832,
        22.886504935551
    ],
    [
        112.96898008313,
        22.886568528568
    ],
    [
        112.96892890696,
        22.886637058892
    ],
    [
        112.96886874408,
        22.886725246902
    ],
    [
        112.96884914626,
        22.886748036747
    ],
    [
        112.96884206875,
        22.886757358967
    ],
    [
        112.96883254258,
        22.886767258333
    ],
    [
        112.96864061903,
        22.887050174585
    ],
    [
        112.96850775742,
        22.88727367669
    ],
    [
        112.96837243977,
        22.887515668646
    ],
    [
        112.96831036054,
        22.887631841269
    ],
    [
        112.96831498549,
        22.887632045783
    ],
    [
        112.96820308578,
        22.887827873124
    ],
    [
        112.96811513411,
        22.888009797134
    ],
    [
        112.96801221201,
        22.888210388436
    ],
    [
        112.96791990111,
        22.888412186583
    ],
    [
        112.96791527554,
        22.888413068013
    ],
    [
        112.96788639761,
        22.888512766439
    ],
    [
        112.96775944197,
        22.888969238034
    ],
    [
        112.96771964655,
        22.88917353015
    ],
    [
        112.96769890373,
        22.889362623858
    ],
    [
        112.96769205785,
        22.889493737362
    ],
    [
        112.96768740257,
        22.889584674055
    ],
    [
        112.96768902814,
        22.889605807416
    ],
    [
        112.96768738878,
        22.889626988948
    ],
    [
        112.96768574102,
        22.889674210436
    ],
    [
        112.96766092834,
        22.889842208232
    ],
    [
        112.96762355734,
        22.890156053243
    ],
    [
        112.96744479518,
        22.890167113078
    ],
    [
        112.96737269262,
        22.890165474402
    ],
    [
        112.96728888759,
        22.890170794487
    ],
    [
        112.96706604157,
        22.890176308664
    ],
    [
        112.96680046866,
        22.890188191543
    ],
    [
        112.96661679693,
        22.890189632735
    ],
    [
        112.96652563889,
        22.890194553208
    ],
    [
        112.96645897208,
        22.890193134028
    ],
    [
        112.96631583939,
        22.890195877744
    ],
    [
        112.96618659224,
        22.890167222162
    ],
    [
        112.96614414264,
        22.890163810487
    ],
    [
        112.96596374108,
        22.890112633133
    ],
    [
        112.96580891431,
        22.890069750005
    ],
    [
        112.96561409027,
        22.890000380638
    ],
    [
        112.96538117119,
        22.889908030874
    ],
    [
        112.96527015031,
        22.889870186886
    ],
    [
        112.96518741963,
        22.889869330428
    ],
    [
        112.96514196263,
        22.889898534441
    ],
    [
        112.96509893495,
        22.889991715324
    ],
    [
        112.96503112515,
        22.890141712213
    ],
    [
        112.96496140964,
        22.890296624131
    ],
    [
        112.96492600606,
        22.890380464016
    ],
    [
        112.96488435551,
        22.890421546953
    ],
    [
        112.96485224182,
        22.890421790177
    ],
    [
        112.96484326091,
        22.890421662877
    ],
    [
        112.96475563637,
        22.890393773976
    ],
    [
        112.96460543058,
        22.890315087444
    ],
    [
        112.96445902497,
        22.890265643012
    ],
    [
        112.96432704359,
        22.890212175014
    ],
    [
        112.96415233542,
        22.890145304072
    ],
    [
        112.96402388985,
        22.890090979306
    ],
    [
        112.96398334331,
        22.890070213193
    ],
    [
        112.96381189758,
        22.890002767623
    ],
    [
        112.96362575259,
        22.889935574264
    ],
    [
        112.96346083474,
        22.889870211691
    ],
    [
        112.96334245204,
        22.889823616809
    ],
    [
        112.96333129238,
        22.889824615419
    ],
    [
        112.96324937075,
        22.889810241307
    ],
    [
        112.96323113392,
        22.889812442709
    ],
    [
        112.96319981073,
        22.889882673634
    ],
    [
        112.96316984772,
        22.889955866054
    ],
    [
        112.96313907323,
        22.890013339873
    ],
    [
        112.96310176849,
        22.890064141454
    ],
    [
        112.96306147694,
        22.890091394557
    ],
    [
        112.96299126772,
        22.890044282135
    ],
    [
        112.96293657428,
        22.889992843513
    ],
    [
        112.96287671211,
        22.889932269737
    ],
    [
        112.96277004175,
        22.889845626762
    ],
    [
        112.96264621225,
        22.889792638596
    ],
    [
        112.96259695565,
        22.889761458041
    ],
    [
        112.96259042301,
        22.889761567737
    ],
    [
        112.96256947112,
        22.889740219803
    ],
    [
        112.9625670205,
        22.889742973452
    ],
    [
        112.96255069107,
        22.88973646662
    ],
    [
        112.96254334456,
        22.889728181394
    ],
    [
        112.96253436374,
        22.889723449879
    ],
    [
        112.96251912774,
        22.889702548678
    ],
    [
        112.9625223977,
        22.889691372538
    ],
    [
        112.96252404134,
        22.889659337666
    ],
    [
        112.96251125827,
        22.889628901608
    ],
    [
        112.96250635859,
        22.889629526498
    ],
    [
        112.96249139675,
        22.88960292463
    ],
    [
        112.96245982867,
        22.889583654716
    ],
    [
        112.96240812014,
        22.8895584856
    ],
    [
        112.96240512923,
        22.889548771075
    ],
    [
        112.96232266629,
        22.889512186527
    ],
    [
        112.96225409132,
        22.889457195757
    ],
    [
        112.9621762525,
        22.889428673884
    ],
    [
        112.96207855563,
        22.889362786568
    ],
    [
        112.96206684781,
        22.889372207243
    ],
    [
        112.96205649793,
        22.889390556098
    ],
    [
        112.96205241695,
        22.889384657801
    ],
    [
        112.96199250693,
        22.88946080864
    ],
    [
        112.96196009351,
        22.889524559006
    ],
    [
        112.96195301323,
        22.889533630293
    ],
    [
        112.96181847483,
        22.889747217261
    ],
    [
        112.96172315723,
        22.889891244238
    ],
    [
        112.96169892005,
        22.889925834261
    ],
    [
        112.96167606,
        22.889909406259
    ],
    [
        112.96156012283,
        22.889838146076
    ],
    [
        112.96155876353,
        22.889832744309
    ],
    [
        112.96153889674,
        22.889819249737
    ],
    [
        112.9615127707,
        22.889800979678
    ],
    [
        112.96148609865,
        22.889787601577
    ],
    [
        112.96144309988,
        22.889756329075
    ],
    [
        112.96139057078,
        22.889734171208
    ],
    [
        112.96134920321,
        22.889708839219
    ],
    [
        112.96134947639,
        22.889705850818
    ],
    [
        112.96132851896,
        22.889697529623
    ],
    [
        112.96123787299,
        22.889697183657
    ],
    [
        112.96120248248,
        22.889706470331
    ],
    [
        112.96114775222,
        22.889754606321
    ],
    [
        112.96115183649,
        22.88975128126
    ],
    [
        112.96114911373,
        22.889753226718
    ],
    [
        112.96114992782,
        22.889761078938
    ],
    [
        112.96114312142,
        22.889764450716
    ],
    [
        112.96111697653,
        22.889803145447
    ],
    [
        112.96111371022,
        22.889802387777
    ],
    [
        112.96109600888,
        22.889825747796
    ],
    [
        112.9610913788,
        22.889833422254
    ],
    [
        112.96108239043,
        22.889850122758
    ],
    [
        112.96108429654,
        22.889848191284
    ],
    [
        112.96107531094,
        22.889856211813
    ],
    [
        112.96107422027,
        22.889861926761
    ],
    [
        112.96105896261,
        22.889905046094
    ],
    [
        112.96104779442,
        22.88992856534
    ],
    [
        112.96102054046,
        22.890032650675
    ],
    [
        112.96072016379,
        22.890441984691
    ],
    [
        112.96031953285,
        22.890185256942
    ],
    [
        112.96025012415,
        22.890159335158
    ],
    [
        112.96023869506,
        22.890145428401
    ],
    [
        112.96016112523,
        22.890100933095
    ],
    [
        112.95967312252,
        22.889793147155
    ],
    [
        112.95965733578,
        22.88978555624
    ],
    [
        112.95959473371,
        22.889753827214
    ],
    [
        112.95955552723,
        22.889771057506
    ],
    [
        112.95954136757,
        22.889782697067
    ],
    [
        112.95954436148,
        22.889784543543
    ],
    [
        112.95952502664,
        22.889804953408
    ],
    [
        112.95950759042,
        22.889847030026
    ],
    [
        112.9594555715,
        22.889919548017
    ],
    [
        112.95940327584,
        22.890006989955
    ],
    [
        112.95935261404,
        22.890093861296
    ],
    [
        112.95931066777,
        22.890168103193
    ],
    [
        112.95928533543,
        22.89021709984
    ],
    [
        112.95926054367,
        22.890279378361
    ],
    [
        112.95924447499,
        22.890302986944
    ],
    [
        112.95922269858,
        22.890296044255
    ],
    [
        112.95920555053,
        22.890287664375
    ],
    [
        112.95918350708,
        22.890263366511
    ],
    [
        112.959115462,
        22.890220886777
    ],
    [
        112.95894126632,
        22.890112727272
    ],
    [
        112.95881333995,
        22.890037665439
    ],
    [
        112.95874665511,
        22.889997877407
    ],
    [
        112.95871453044,
        22.89000115394
    ],
    [
        112.95864209401,
        22.890071594586
    ],
    [
        112.95856148454,
        22.890161980642
    ],
    [
        112.95849067269,
        22.890262773884
    ],
    [
        112.95846261793,
        22.890311007084
    ],
    [
        112.95841607533,
        22.890278461968
    ],
    [
        112.95834285337,
        22.890246657735
    ],
    [
        112.95826745462,
        22.890211094821
    ],
    [
        112.95820811443,
        22.890186642102
    ],
    [
        112.95814469113,
        22.8901606341
    ],
    [
        112.95807855623,
        22.8900996831
    ],
    [
        112.95803255887,
        22.890064959976
    ],
    [
        112.95771953821,
        22.889896066494
    ],
    [
        112.95757718194,
        22.889819374129
    ],
    [
        112.95757908666,
        22.889822324238
    ],
    [
        112.95757663719,
        22.889820197488
    ],
    [
        112.95757173774,
        22.889817571486
    ],
    [
        112.95755241296,
        22.88980462144
    ],
    [
        112.95752764594,
        22.889783901299
    ],
    [
        112.95750859537,
        22.889764979011
    ],
    [
        112.95746095656,
        22.88975551265
    ],
    [
        112.95736214736,
        22.889713586565
    ],
    [
        112.95725816738,
        22.8896663273
    ],
    [
        112.95718249369,
        22.889639183156
    ],
    [
        112.95716615139,
        22.889662799152
    ],
    [
        112.95714817693,
        22.889682646536
    ],
    [
        112.95715307575,
        22.88968717119
    ],
    [
        112.95714599458,
        22.88969597622
    ],
    [
        112.95714163018,
        22.889721821847
    ],
    [
        112.95714516333,
        22.889739933011
    ],
    [
        112.95714434232,
        22.889752967404
    ],
    [
        112.95714705574,
        22.88978031548
    ],
    [
        112.95715766892,
        22.88979314786
    ],
    [
        112.95716283258,
        22.88982045266
    ],
    [
        112.9572167244,
        22.889856661533
    ],
    [
        112.95724556681,
        22.889903349184
    ],
    [
        112.95726296844,
        22.889971396347
    ],
    [
        112.95732474042,
        22.890055477287
    ],
    [
        112.95748042511,
        22.890173162594
    ],
    [
        112.95761434417,
        22.890247833446
    ],
    [
        112.95761570291,
        22.890255946943
    ],
    [
        112.95775071025,
        22.890333312145
    ],
    [
        112.95769513691,
        22.890457168665
    ],
    [
        112.9576703303,
        22.890570717621
    ],
    [
        112.95762948769,
        22.890594223356
    ],
    [
        112.95760851974,
        22.890613580917
    ],
    [
        112.95751673542,
        22.890754623766
    ],
    [
        112.95740861614,
        22.890901109464
    ],
    [
        112.95740261301,
        22.890952753214
    ],
    [
        112.95735876309,
        22.891025409219
    ],
    [
        112.95730321784,
        22.891056770414
    ],
    [
        112.95726755682,
        22.891047363994
    ],
    [
        112.95726320202,
        22.891043372143
    ],
    [
        112.95722754256,
        22.891027998215
    ],
    [
        112.95640084563,
        22.890665842144
    ],
    [
        112.95623316537,
        22.89059475503
    ],
    [
        112.95623643111,
        22.890598766055
    ],
    [
        112.95622309473,
        22.890586795543
    ],
    [
        112.95617028462,
        22.890570640284
    ],
    [
        112.95620133138,
        22.890531573982
    ],
    [
        112.95621549477,
        22.890507996124
    ],
    [
        112.95621767263,
        22.890508228876
    ],
    [
        112.9562410949,
        22.890475536107
    ],
    [
        112.95629039324,
        22.890398443475
    ],
    [
        112.95631410273,
        22.890316378256
    ],
    [
        112.95635578023,
        22.890235080465
    ],
    [
        112.95640017798,
        22.890161872112
    ],
    [
        112.95644893909,
        22.89006553054
    ],
    [
        112.95648598081,
        22.890011710991
    ],
    [
        112.95651675367,
        22.889981329651
    ],
    [
        112.95656141433,
        22.889940124127
    ],
    [
        112.9566055402,
        22.889869090799
    ],
    [
        112.95662760319,
        22.889833709782
    ],
    [
        112.95665919446,
        22.889798974086
    ],
    [
        112.95665674863,
        22.889785726183
    ],
    [
        112.95669787777,
        22.889722612158
    ],
    [
        112.9567577951,
        22.88964940117
    ],
    [
        112.95680082971,
        22.889588152335
    ],
    [
        112.95686320306,
        22.88949916581
    ],
    [
        112.95686075214,
        22.889501379105
    ],
    [
        112.95692177245,
        22.889389903178
    ],
    [
        112.95697162312,
        22.889302223288
    ],
    [
        112.95703237682,
        22.889178003904
    ],
    [
        112.95709012801,
        22.889077436204
    ],
    [
        112.95708686584,
        22.889064474058
    ],
    [
        112.95702154687,
        22.889013277919
    ],
    [
        112.95701447087,
        22.889007164321
    ],
    [
        112.95696193702,
        22.888983951891
    ],
    [
        112.95691266828,
        22.888965564237
    ],
    [
        112.95684652456,
        22.8889366251
    ],
    [
        112.95680107087,
        22.888908405303
    ],
    [
        112.95670743378,
        22.888871814962
    ],
    [
        112.95665381239,
        22.888845095879
    ],
    [
        112.95659066368,
        22.888815561562
    ],
    [
        112.95646300261,
        22.888763298228
    ],
    [
        112.95632607934,
        22.88872720207
    ],
    [
        112.95630430554,
        22.888712939781
    ],
    [
        112.95631030589,
        22.888684081797
    ],
    [
        112.95633238217,
        22.888619677879
    ],
    [
        112.95632422773,
        22.888586730245
    ],
    [
        112.95629265532,
        22.888567487558
    ],
    [
        112.95622678814,
        22.888529050289
    ],
    [
        112.956172077,
        22.888505605443
    ],
    [
        112.9560694607,
        22.888459137822
    ],
    [
        112.95598480779,
        22.88842428728
    ],
    [
        112.95589143936,
        22.888399355351
    ],
    [
        112.95584925171,
        22.888375417624
    ],
    [
        112.95582557133,
        22.88836417255
    ],
    [
        112.95582285032,
        22.88836069446
    ],
    [
        112.95581930836,
        22.888367809368
    ],
    [
        112.95580976637,
        22.888401883389
    ],
    [
        112.95579396416,
        22.888432813096
    ],
    [
        112.95576808703,
        22.888469074422
    ],
    [
        112.95574465257,
        22.888524550903
    ],
    [
        112.95570187342,
        22.888620784478
    ],
    [
        112.95567435316,
        22.888683114268
    ],
    [
        112.955663727,
        22.888706086482
    ],
    [
        112.95565692034,
        22.888707834169
    ],
    [
        112.95566018724,
        22.888707776469
    ],
    [
        112.95564629669,
        22.888724296469
    ],
    [
        112.95562696931,
        22.888720026657
    ],
    [
        112.9556051872,
        22.888727734938
    ],
    [
        112.95558559132,
        22.888713705033
    ],
    [
        112.95558559194,
        22.888712077556
    ],
    [
        112.95557524511,
        22.88871660018
    ],
    [
        112.95552352957,
        22.888690660146
    ],
    [
        112.95545384409,
        22.888670462112
    ],
    [
        112.95545248696,
        22.888659907541
    ],
    [
        112.95537354822,
        22.888632548987
    ],
    [
        112.95534143012,
        22.888616841154
    ],
    [
        112.95528535995,
        22.888588536175
    ],
    [
        112.95522465986,
        22.88856519509
    ],
    [
        112.95518056426,
        22.888547257056
    ],
    [
        112.95509128829,
        22.888501092492
    ],
    [
        112.95507849794,
        22.888488840789
    ],
    [
        112.95505318575,
        22.888473826152
    ],
    [
        112.95503522352,
        22.888460038129
    ],
    [
        112.95501753106,
        22.888452483934
    ],
    [
        112.95497914971,
        22.88844203943
    ],
    [
        112.95496962737,
        22.888427017607
    ],
    [
        112.95494894204,
        22.888415176175
    ],
    [
        112.95489642613,
        22.888350460584
    ],
    [
        112.95490758696,
        22.888352705139
    ],
    [
        112.95491222233,
        22.888334450167
    ],
    [
        112.95492965613,
        22.888308103636
    ],
    [
        112.95494110609,
        22.888268571621
    ],
    [
        112.95495990648,
        22.888229181324
    ],
    [
        112.95497599591,
        22.888162172027
    ],
    [
        112.95501359405,
        22.888090986257
    ],
    [
        112.95500950877,
        22.888095126904
    ],
    [
        112.95503293781,
        22.888055112511
    ],
    [
        112.95505773142,
        22.888007208011
    ],
    [
        112.95506644366,
        22.888005698205
    ],
    [
        112.95510785408,
        22.88793363137
    ],
    [
        112.95519667166,
        22.887773930981
    ],
    [
        112.95529284782,
        22.887598639789
    ],
    [
        112.95535360168,
        22.887497208552
    ],
    [
        112.9553827536,
        22.887446785759
    ],
    [
        112.95538547891,
        22.887440227882
    ],
    [
        112.95538766943,
        22.887411980191
    ],
    [
        112.95540266541,
        22.887360993531
    ],
    [
        112.95539804488,
        22.887344258176
    ],
    [
        112.95539967809,
        22.887344771831
    ],
    [
        112.95540757466,
        22.887341106328
    ],
    [
        112.95538742994,
        22.887339020719
    ],
    [
        112.95536483432,
        22.887338605786
    ],
    [
        112.95533625848,
        22.887318224569
    ],
    [
        112.95529352125,
        22.887308942798
    ],
    [
        112.95525677358,
        22.887299012775
    ],
    [
        112.95520506207,
        22.88726873237
    ],
    [
        112.95518247144,
        22.887257467504
    ],
    [
        112.95517131305,
        22.887250069584
    ],
    [
        112.95515443948,
        22.887238703848
    ],
    [
        112.95512149969,
        22.887236572335
    ],
    [
        112.95506515211,
        22.887224275085
    ],
    [
        112.955030855,
        22.88721375886
    ],
    [
        112.95500934808,
        22.88721413796
    ],
    [
        112.95500825801,
        22.887216598334
    ],
    [
        112.95497991571,
        22.88728165302
    ],
    [
        112.95497418836,
        22.887304538139
    ],
    [
        112.95499240318,
        22.887360092634
    ],
    [
        112.95498583274,
        22.887442123089
    ],
    [
        112.95496566038,
        22.887502422813
    ],
    [
        112.95495746792,
        22.887559799026
    ],
    [
        112.95494083063,
        22.887630072417
    ],
    [
        112.95490651017,
        22.88767271954
    ],
    [
        112.95488661273,
        22.887728403342
    ],
    [
        112.95484957291,
        22.887764588468
    ],
    [
        112.95482723628,
        22.887795360957
    ],
    [
        112.95480842907,
        22.887848855574
    ],
    [
        112.95480080732,
        22.887846819863
    ],
    [
        112.95473188911,
        22.887946765428
    ],
    [
        112.95473161642,
        22.887947855198
    ],
    [
        112.95465291987,
        22.88799616526
    ],
    [
        112.95463085588,
        22.888026932658
    ],
    [
        112.95462976546,
        22.888030477996
    ],
    [
        112.95462350365,
        22.888031401903
    ],
    [
        112.95459492447,
        22.888018071363
    ],
    [
        112.95457832115,
        22.888010768661
    ],
    [
        112.95452660833,
        22.887982384059
    ],
    [
        112.95443215783,
        22.887946613252
    ],
    [
        112.95432818299,
        22.887902329154
    ],
    [
        112.95422121992,
        22.887843991845
    ],
    [
        112.95422339792,
        22.887843682367
    ],
    [
        112.95416732624,
        22.887824052195
    ],
    [
        112.954025792,
        22.887761708161
    ],
    [
        112.95388969793,
        22.88771120114
    ],
    [
        112.95382709088,
        22.887697108055
    ],
    [
        112.95382409478,
        22.887700686651
    ],
    [
        112.95381374781,
        22.887705750151
    ],
    [
        112.95381265923,
        22.887704955484
    ],
    [
        112.95377860734,
        22.887758172409
    ],
    [
        112.95373420043,
        22.887835710918
    ],
    [
        112.95369087084,
        22.887941439561
    ],
    [
        112.95364046698,
        22.888039696978
    ],
    [
        112.9536164819,
        22.888109011893
    ],
    [
        112.95357018664,
        22.888148337495
    ],
    [
        112.95354539295,
        22.888198950628
    ],
    [
        112.95350234086,
        22.888296807661
    ],
    [
        112.95347566568,
        22.888288864961
    ],
    [
        112.95348410493,
        22.888288446352
    ],
    [
        112.95334066343,
        22.888232903708
    ],
    [
        112.95327479434,
        22.888208826648
    ],
    [
        112.95321300816,
        22.888186305255
    ],
    [
        112.95319749808,
        22.8881697584
    ],
    [
        112.95320023123,
        22.888143400247
    ],
    [
        112.95320405659,
        22.888109157039
    ],
    [
        112.95324002559,
        22.888024987666
    ],
    [
        112.95327273293,
        22.8879297541
    ],
    [
        112.95329971942,
        22.887845198643
    ],
    [
        112.95330682078,
        22.887790555239
    ],
    [
        112.95327797681,
        22.887762577743
    ],
    [
        112.95322626512,
        22.887736354823
    ],
    [
        112.9530901542,
        22.88773194392
    ],
    [
        112.9529456149,
        22.887704620972
    ],
    [
        112.95274472478,
        22.887680984521
    ],
    [
        112.95260153967,
        22.88767370132
    ],
    [
        112.95255390659,
        22.887661235174
    ],
    [
        112.95249592909,
        22.88764921879
    ],
    [
        112.95246817002,
        22.887632610691
    ],
    [
        112.95246108966,
        22.887638700428
    ],
    [
        112.95246107219,
        22.88767857319
    ],
    [
        112.95244990024,
        22.887703720555
    ],
    [
        112.95245534159,
        22.887710678752
    ],
    [
        112.95245070946,
        22.887720794771
    ],
    [
        112.95244280752,
        22.887738290834
    ],
    [
        112.95243599741,
        22.887748986977
    ],
    [
        112.9524376218,
        22.887769573253
    ],
    [
        112.95242890792,
        22.887776233676
    ],
    [
        112.95242398994,
        22.887818089891
    ],
    [
        112.95241826934,
        22.88782741098
    ],
    [
        112.95240873638,
        22.887839781605
    ],
    [
        112.9524057366,
        22.887852310565
    ],
    [
        112.95239946682,
        22.887872762042
    ],
    [
        112.95239619427,
        22.887886651923
    ],
    [
        112.95238938702,
        22.887890838166
    ],
    [
        112.95239020195,
        22.887894892715
    ],
    [
        112.95237686143,
        22.887899191815
    ],
    [
        112.95236460679,
        22.887910524416
    ],
    [
        112.95234582743,
        22.887901897761
    ],
    [
        112.95230553628,
        22.887908831939
    ],
    [
        112.95223503135,
        22.887910590887
    ],
    [
        112.95216479907,
        22.887911801648
    ],
    [
        112.95211906642,
        22.887912860748
    ],
    [
        112.95208285947,
        22.88791836655
    ],
    [
        112.95201508013,
        22.887913565577
    ],
    [
        112.95197751366,
        22.887915839055
    ],
    [
        112.9519481159,
        22.887912818249
    ],
    [
        112.95188578032,
        22.887910091774
    ],
    [
        112.95183977797,
        22.887906541669
    ],
    [
        112.9518079307,
        22.887903019519
    ],
    [
        112.95177254367,
        22.887901999023
    ],
    [
        112.9517461389,
        22.887902722974
    ],
    [
        112.95173116674,
        22.887904064569
    ],
    [
        112.95172136593,
        22.88790694495
    ],
    [
        112.95171836951,
        22.887911878652
    ],
    [
        112.95171646137,
        22.887918149914
    ],
    [
        112.95170284775,
        22.887925435458
    ],
    [
        112.95169957866,
        22.887931458787
    ],
    [
        112.9515291766,
        22.887929492333
    ],
    [
        112.9513857215,
        22.887934111771
    ],
    [
        112.95134489136,
        22.887932366865
    ],
    [
        112.95127901586,
        22.887936744279
    ],
    [
        112.95126567474,
        22.887944023773
    ],
    [
        112.95124062853,
        22.887952044971
    ],
    [
        112.95122538695,
        22.887947693273
    ],
    [
        112.95121395569,
        22.887944632895
    ],
    [
        112.95119027472,
        22.887942865835
    ],
    [
        112.95108247947,
        22.88794985153
    ],
    [
        112.95081790406,
        22.887942672143
    ],
    [
        112.95065866873,
        22.887942920692
    ],
    [
        112.9505604091,
        22.887936439714
    ],
    [
        112.95049589791,
        22.887939424354
    ],
    [
        112.95040607361,
        22.887941205685
    ],
    [
        112.95034863943,
        22.887945424938
    ],
    [
        112.95029501151,
        22.887960429102
    ],
    [
        112.95027677155,
        22.887968058411
    ],
    [
        112.9502702401,
        22.88796545546
    ],
    [
        112.95024328773,
        22.887978655436
    ],
    [
        112.95023104086,
        22.887974791936
    ],
    [
        112.95022641339,
        22.887975411917
    ],
    [
        112.95022124107,
        22.887977125984
    ],
    [
        112.95018341074,
        22.887967994524
    ],
    [
        112.95011482138,
        22.887963445496
    ],
    [
        112.95004405746,
        22.887952692788
    ],
    [
        112.94997002946,
        22.887937653102
    ],
    [
        112.94993111122,
        22.887927994415
    ],
    [
        112.9499436268,
        22.887939449319
    ],
    [
        112.94987178129,
        22.887913792601
    ],
    [
        112.94986552232,
        22.887910913077
    ],
    [
        112.94986007885,
        22.887910461152
    ],
    [
        112.94982224929,
        22.887901596769
    ],
    [
        112.94979421389,
        22.887903147659
    ],
    [
        112.94978414647,
        22.887895448896
    ],
    [
        112.94969759983,
        22.887879525904
    ],
    [
        112.94970385909,
        22.887881592028
    ],
    [
        112.94970059512,
        22.887876492568
    ],
    [
        112.94966712308,
        22.887862400467
    ],
    [
        112.94963937078,
        22.887839262289
    ],
    [
        112.94964019671,
        22.887817549274
    ],
    [
        112.94964074519,
        22.887808046731
    ],
    [
        112.94963721932,
        22.887779353532
    ],
    [
        112.94965329301,
        22.887744639568
    ],
    [
        112.94966202133,
        22.887702181276
    ],
    [
        112.94966612815,
        22.887647322486
    ],
    [
        112.9496675109,
        22.887597933693
    ],
    [
        112.94967818538,
        22.887464848757
    ],
    [
        112.94970823432,
        22.887225387787
    ],
    [
        112.94972901342,
        22.887025139429
    ],
    [
        112.94975439308,
        22.886884216292
    ],
    [
        112.94980433613,
        22.886607808357
    ],
    [
        112.94981639289,
        22.886444593967
    ],
    [
        112.94980907172,
        22.886389111929
    ],
    [
        112.94980365681,
        22.886331970805
    ],
    [
        112.94976562837,
        22.886180438441
    ],
    [
        112.94978316221,
        22.885959089337
    ],
    [
        112.94978932879,
        22.885621569417
    ],
    [
        112.94979978164,
        22.885418511833
    ],
    [
        112.94980363113,
        22.885347384347
    ],
    [
        112.94980068828,
        22.885254671019
    ],
    [
        112.94979771501,
        22.885217290073
    ],
    [
        112.94978113445,
        22.885176880376
    ],
    [
        112.94975393401,
        22.885145326425
    ],
    [
        112.94972210246,
        22.885121172411
    ],
    [
        112.94969135106,
        22.885112460511
    ],
    [
        112.94966005203,
        22.885109724535
    ],
    [
        112.94964235707,
        22.885115713635
    ],
    [
        112.94963201451,
        22.885115342483
    ],
    [
        112.94963338332,
        22.88510121564
    ],
    [
        112.94962739519,
        22.88510158605
    ],
    [
        112.94962007573,
        22.885049359101
    ],
    [
        112.94962256103,
        22.884986120465
    ],
    [
        112.94963214591,
        22.884882892958
    ],
    [
        112.94966571917,
        22.884716884433
    ],
    [
        112.94969358044,
        22.884546630818
    ],
    [
        112.94969439635,
        22.884547702218
    ],
    [
        112.94971627913,
        22.884363714974
    ],
    [
        112.94973080569,
        22.884194496489
    ],
    [
        112.94971430011,
        22.884033387624
    ],
    [
        112.9496877353,
        22.883855629408
    ],
    [
        112.94959267674,
        22.883528472833
    ],
    [
        112.94949004737,
        22.883558648745
    ],
    [
        112.94944621945,
        22.883571035189
    ],
    [
        112.94932291519,
        22.883586628897
    ],
    [
        112.94906950691,
        22.883615742417
    ],
    [
        112.94890129488,
        22.883637477894
    ],
    [
        112.94879679186,
        22.883625348172
    ],
    [
        112.94877726847,
        22.883510393117
    ],
    [
        112.94875474601,
        22.883404708628
    ],
    [
        112.94874177552,
        22.883258726839
    ],
    [
        112.94873065466,
        22.883200050874
    ],
    [
        112.94872932254,
        22.883155590953
    ],
    [
        112.94871983158,
        22.883102041857
    ],
    [
        112.94871334672,
        22.883029729131
    ],
    [
        112.9487066148,
        22.882919448459
    ],
    [
        112.94867779032,
        22.882882215809
    ],
    [
        112.9486664006,
        22.882820018182
    ],
    [
        112.94864802654,
        22.882620150088
    ],
    [
        112.94870339376,
        22.88244322462
    ],
    [
        112.94855040686,
        22.882094195343
    ],
    [
        112.94852674789,
        22.882067184345
    ],
    [
        112.94850391222,
        22.882030395685
    ],
    [
        112.94848297029,
        22.882010121037
    ],
    [
        112.94841822442,
        22.881971296438
    ],
    [
        112.94831101724,
        22.881941019694
    ],
    [
        112.9481733343,
        22.881904989531
    ],
    [
        112.94811048346,
        22.88188294297
    ],
    [
        112.94795403146,
        22.88183743757
    ],
    [
        112.94792355558,
        22.88183141432
    ],
    [
        112.94789907383,
        22.881815531049
    ],
    [
        112.94786861104,
        22.881791063568
    ],
    [
        112.94779626163,
        22.881733901126
    ],
    [
        112.94769590004,
        22.881651956916
    ],
    [
        112.947636607,
        22.881605431831
    ],
    [
        112.94760369871,
        22.881576931456
    ],
    [
        112.94757950246,
        22.88154341089
    ],
    [
        112.947578152,
        22.8815290573
    ],
    [
        112.94755477189,
        22.881496066051
    ],
    [
        112.94752946501,
        22.881493753437
    ],
    [
        112.94743639452,
        22.881494949656
    ],
    [
        112.94739067392,
        22.881498381458
    ],
    [
        112.94736944978,
        22.881495460484
    ],
    [
        112.94730846757,
        22.881530592678
    ],
    [
        112.9472325139,
        22.881572467235
    ],
    [
        112.94713070396,
        22.881621252709
    ],
    [
        112.94701227924,
        22.881693075367
    ],
    [
        112.94697852386,
        22.88171041655
    ],
    [
        112.94690366842,
        22.881741956707
    ],
    [
        112.94689495648,
        22.881747787627
    ],
    [
        112.94681464549,
        22.881798937746
    ],
    [
        112.94676863474,
        22.881831654134
    ],
    [
        112.94660562042,
        22.881856951114
    ],
    [
        112.94655364232,
        22.881863717162
    ],
    [
        112.94651855239,
        22.881846083772
    ],
    [
        112.94649516437,
        22.881826914278
    ],
    [
        112.94647834643,
        22.881751771325
    ],
    [
        112.94647563047,
        22.881744489855
    ],
    [
        112.94645158384,
        22.881503467584
    ],
    [
        112.94643810658,
        22.881324936671
    ],
    [
        112.94642672436,
        22.881260830625
    ],
    [
        112.94643870392,
        22.88125142563
    ],
    [
        112.9465263396,
        22.881228655544
    ],
    [
        112.94652172626,
        22.881211367978
    ],
    [
        112.94651465801,
        22.881202254807
    ],
    [
        112.94647877147,
        22.881158324323
    ],
    [
        112.94638322248,
        22.881212133023
    ],
    [
        112.94634266306,
        22.8812336368
    ],
    [
        112.94623923673,
        22.88127047222
    ],
    [
        112.94610941433,
        22.881312042416
    ],
    [
        112.94606423599,
        22.881325745379
    ],
    [
        112.94605008144,
        22.881333282603
    ],
    [
        112.94599130425,
        22.881339052908
    ],
    [
        112.9457274142,
        22.881283350901
    ],
    [
        112.94569477376,
        22.88126919314
    ],
    [
        112.94571144617,
        22.881165878404
    ],
    [
        112.94572023609,
        22.881052103866
    ],
    [
        112.94572923919,
        22.881019150974
    ],
    [
        112.94575211967,
        22.880985176511
    ],
    [
        112.94576138839,
        22.880961169908
    ],
    [
        112.94577608144,
        22.880960949654
    ],
    [
        112.94579381371,
        22.88089803097
    ],
    [
        112.94580744688,
        22.880859312608
    ],
    [
        112.94582517281,
        22.880805344181
    ],
    [
        112.94584124514,
        22.880779878949
    ],
    [
        112.94583389514,
        22.880784600175
    ],
    [
        112.94585295069,
        22.880772379995
    ],
    [
        112.94586737944,
        22.880761856566
    ],
    [
        112.94586765113,
        22.880762394927
    ],
    [
        112.94588044127,
        22.880760032755
    ],
    [
        112.94590193974,
        22.880755912078
    ],
    [
        112.94593431996,
        22.880754610669
    ],
    [
        112.94595553698,
        22.880763241185
    ],
    [
        112.94596016346,
        22.880762086514
    ],
    [
        112.94597403728,
        22.880766216785
    ],
    [
        112.94614977815,
        22.88081292022
    ],
    [
        112.94614733344,
        22.880807261617
    ],
    [
        112.94612480727,
        22.880728948437
    ],
    [
        112.94612073844,
        22.880711923045
    ],
    [
        112.94573391853,
        22.88057969858
    ],
    [
        112.94571950069,
        22.880575846062
    ],
    [
        112.94570889357,
        22.880570037872
    ],
    [
        112.94574324185,
        22.880483545989
    ],
    [
        112.94579585449,
        22.880352299115
    ],
    [
        112.94582420341,
        22.880284610382
    ],
    [
        112.94587288257,
        22.880318052828
    ],
    [
        112.94610080187,
        22.880446697711
    ],
    [
        112.94636517966,
        22.880587780176
    ],
    [
        112.94654768043,
        22.880700254799
    ],
    [
        112.94660051881,
        22.880634891501
    ],
    [
        112.94660569224,
        22.880630472343
    ],
    [
        112.94681868742,
        22.880362742871
    ],
    [
        112.94681407184,
        22.880348981963
    ],
    [
        112.94677138562,
        22.880301364652
    ],
    [
        112.94667132704,
        22.880196590057
    ],
    [
        112.94661721942,
        22.880140466757
    ],
    [
        112.94658704496,
        22.880101332497
    ],
    [
        112.94656120781,
        22.880083828962
    ],
    [
        112.94655495876,
        22.880071448751
    ],
    [
        112.94655441245,
        22.880074169364
    ],
    [
        112.94678694752,
        22.879879644925
    ],
    [
        112.94681716505,
        22.879863446521
    ],
    [
        112.94682097411,
        22.87986420122
    ],
    [
        112.94683050086,
        22.879860799054
    ],
    [
        112.9468381295,
        22.879848747159
    ],
    [
        112.94684330211,
        22.879845683598
    ],
    [
        112.94685745663,
        22.879840039852
    ],
    [
        112.9468566369,
        22.8798443921
    ],
    [
        112.94686344625,
        22.879836149919
    ],
    [
        112.94687596912,
        22.87982917524
    ],
    [
        112.94688658883,
        22.879820060239
    ],
    [
        112.94700503248,
        22.879728445764
    ],
    [
        112.94709488834,
        22.879657612998
    ],
    [
        112.94716867712,
        22.87960275883
    ],
    [
        112.94726043159,
        22.879541925204
    ],
    [
        112.94729856266,
        22.87949983049
    ],
    [
        112.94732823899,
        22.879481735364
    ],
    [
        112.94734294036,
        22.879473639084
    ],
    [
        112.94735736813,
        22.879467445557
    ],
    [
        112.94732147803,
        22.879428139809
    ],
    [
        112.94730762349,
        22.879397709333
    ],
    [
        112.9473035488,
        22.879388551772
    ],
    [
        112.9472635798,
        22.879345783296
    ],
    [
        112.94723748018,
        22.879314730659
    ],
    [
        112.94719697049,
        22.879267901232
    ],
    [
        112.94714286065,
        22.879213689452
    ],
    [
        112.94711159406,
        22.879178919064
    ],
    [
        112.94706400628,
        22.87913653735
    ],
    [
        112.94705121764,
        22.879135109342
    ],
    [
        112.94696447339,
        22.879056991914
    ],
    [
        112.94694460595,
        22.879060284075
    ],
    [
        112.946919851,
        22.879050362168
    ],
    [
        112.94688694595,
        22.879023750782
    ],
    [
        112.94679664277,
        22.878974160269
    ],
    [
        112.94674904613,
        22.878944790696
    ],
    [
        112.94673816707,
        22.878937907025
    ],
    [
        112.94672756058,
        22.878930476654
    ],
    [
        112.9467275608,
        22.878930205431
    ],
    [
        112.94668676679,
        22.878901543159
    ],
    [
        112.94646674484,
        22.878758466553
    ],
    [
        112.94642975425,
        22.878738691504
    ],
    [
        112.94642105134,
        22.878733129066
    ],
    [
        112.94640065322,
        22.878720964962
    ],
    [
        112.94601500056,
        22.878825008281
    ],
    [
        112.94598697121,
        22.878829228652
    ],
    [
        112.94554227375,
        22.878955772544
    ],
    [
        112.94533109256,
        22.879013147292
    ],
    [
        112.9452195158,
        22.879044626528
    ],
    [
        112.94459743585,
        22.879215056106
    ],
    [
        112.94446301046,
        22.879252786687
    ],
    [
        112.94441661201,
        22.879099668454
    ],
    [
        112.94434172102,
        22.878857995387
    ],
    [
        112.94432350429,
        22.87884496514
    ],
    [
        112.94432159992,
        22.87884499226
    ],
    [
        112.94428619936,
        22.878887263875
    ],
    [
        112.94411767437,
        22.879046960234
    ],
    [
        112.94397991575,
        22.879179086963
    ],
    [
        112.94376375372,
        22.879387425239
    ],
    [
        112.94357622989,
        22.879508550931
    ],
    [
        112.94352562215,
        22.879522539558
    ],
    [
        112.94352207724,
        22.879533437297
    ],
    [
        112.94351473507,
        22.879530283886
    ],
    [
        112.94342317052,
        22.879740384342
    ],
    [
        112.94336104802,
        22.879871151637
    ],
    [
        112.94334743934,
        22.879881101985
    ],
    [
        112.94334361903,
        22.87989661393
    ],
    [
        112.94332673373,
        22.879922611058
    ],
    [
        112.9433131226,
        22.879935815835
    ],
    [
        112.94329706017,
        22.879953122324
    ],
    [
        112.94327881617,
        22.879977510218
    ],
    [
        112.9432741757,
        22.879998457658
    ],
    [
        112.94326844843,
        22.880017792585
    ],
    [
        112.94328499897,
        22.880072896025
    ],
    [
        112.94320827473,
        22.880093469881
    ],
    [
        112.94319630682,
        22.880092547818
    ],
    [
        112.9429957897,
        22.880151406335
    ],
    [
        112.94298762461,
        22.880157754521
    ],
    [
        112.94286872966,
        22.880195154129
    ],
    [
        112.9428692772,
        22.880190536004
    ],
    [
        112.94284261172,
        22.880202555868
    ],
    [
        112.94282900794,
        22.880207348765
    ],
    [
        112.94282493119,
        22.880203063757
    ],
    [
        112.94280316297,
        22.880213661341
    ],
    [
        112.94276453498,
        22.880218788024
    ],
    [
        112.94275501303,
        22.880221356061
    ],
    [
        112.94274984312,
        22.880223866014
    ],
    [
        112.94272917617,
        22.880217360912
    ],
    [
        112.9426948995,
        22.880223784104
    ],
    [
        112.9426938171,
        22.880216475489
    ],
    [
        112.94265982253,
        22.880209875511
    ],
    [
        112.94262854851,
        22.880202696308
    ],
    [
        112.94261331705,
        22.880202355781
    ],
    [
        112.94261740096,
        22.880197148426
    ],
    [
        112.9425934652,
        22.880197465507
    ],
    [
        112.94258150129,
        22.880192470633
    ],
    [
        112.94257034695,
        22.880195872867
    ],
    [
        112.94255484569,
        22.880192823137
    ],
    [
        112.94250914516,
        22.880200478272
    ],
    [
        112.94245747581,
        22.880188953857
    ],
    [
        112.94242674532,
        22.880183390969
    ],
    [
        112.94232146174,
        22.880215690078
    ],
    [
        112.94231792383,
        22.880218448549
    ],
    [
        112.94232499862,
        22.880214287726
    ],
    [
        112.94231466517,
        22.88021171057
    ],
    [
        112.94228828327,
        22.880210970222
    ],
    [
        112.94226053738,
        22.880215671673
    ],
    [
        112.94221646713,
        22.880227636848
    ],
    [
        112.94217430122,
        22.880239304869
    ],
    [
        112.94215308226,
        22.880245275838
    ],
    [
        112.94212534452,
        22.880239939598
    ],
    [
        112.94209269901,
        22.88025066848
    ],
    [
        112.94204999189,
        22.880259627983
    ],
    [
        112.94204047017,
        22.880263005481
    ],
    [
        112.9420255085,
        22.88026699548
    ],
    [
        112.94199041542,
        22.880278025022
    ],
    [
        112.94192649218,
        22.880290779887
    ],
    [
        112.94190418126,
        22.880302999657
    ],
    [
        112.94186610201,
        22.880307555334
    ],
    [
        112.94185494869,
        22.880310952574
    ],
    [
        112.94184053278,
        22.880313035284
    ],
    [
        112.94177551259,
        22.880339359167
    ],
    [
        112.94175511477,
        22.880339889879
    ],
    [
        112.94169064668,
        22.880356439183
    ],
    [
        112.94166589476,
        22.880360821024
    ],
    [
        112.94162182691,
        22.880374125672
    ],
    [
        112.94160849455,
        22.880382430684
    ],
    [
        112.94156633489,
        22.88039028521
    ],
    [
        112.94155381872,
        22.880398308249
    ],
    [
        112.94153967862,
        22.880396045131
    ],
    [
        112.94150866349,
        22.880411894585
    ],
    [
        112.94138353703,
        22.88044817713
    ],
    [
        112.94137374626,
        22.880448841678
    ],
    [
        112.94137347533,
        22.880447488939
    ],
    [
        112.94137211453,
        22.880448862021
    ],
    [
        112.94134048515,
        22.880558830266
    ],
    [
        112.94132029601,
        22.880645059295
    ],
    [
        112.94129821652,
        22.880713953266
    ],
    [
        112.94128759481,
        22.880734969373
    ],
    [
        112.94128404831,
        22.880749930702
    ],
    [
        112.94125659001,
        22.880738608561
    ],
    [
        112.9412468061,
        22.880730321823
    ],
    [
        112.94118780116,
        22.880720473702
    ],
    [
        112.94109779843,
        22.880706393639
    ],
    [
        112.94102954602,
        22.880700178833
    ],
    [
        112.9410143238,
        22.880691685925
    ],
    [
        112.9409602205,
        22.880675259567
    ],
    [
        112.94087511603,
        22.88066029275
    ],
    [
        112.94080605681,
        22.880644855931
    ],
    [
        112.94080116364,
        22.880642745297
    ],
    [
        112.94078403573,
        22.880637798986
    ],
    [
        112.94073537177,
        22.880622654891
    ],
    [
        112.9407266706,
        22.880621945986
    ],
    [
        112.94069105676,
        22.880610440417
    ],
    [
        112.94066901769,
        22.880627792112
    ],
    [
        112.94065758225,
        22.880647186163
    ],
    [
        112.94064966523,
        22.880688778319
    ],
    [
        112.94063823697,
        22.880698679307
    ],
    [
        112.94063633551,
        22.880695989842
    ],
    [
        112.94061561638,
        22.880766756068
    ],
    [
        112.94059273257,
        22.880823444249
    ],
    [
        112.94056658405,
        22.880882612067
    ],
    [
        112.94056410216,
        22.88092929226
    ],
    [
        112.94054176591,
        22.880981633599
    ],
    [
        112.94053167634,
        22.88102026764
    ],
    [
        112.94053438938,
        22.881028643301
    ],
    [
        112.94052975052,
        22.881050667726
    ],
    [
        112.94051531768,
        22.881079318057
    ],
    [
        112.94049923388,
        22.881134567906
    ],
    [
        112.94049461399,
        22.88113082565
    ],
    [
        112.94049733023,
        22.881134861751
    ],
    [
        112.94046713266,
        22.881154748435
    ],
    [
        112.9404611516,
        22.881153192017
    ],
    [
        112.94043124219,
        22.881151105327
    ],
    [
        112.94038719435,
        22.881147557668
    ],
    [
        112.9402721699,
        22.881154606868
    ],
    [
        112.94009815143,
        22.881151212632
    ],
    [
        112.94005954515,
        22.881145693248
    ],
    [
        112.94003481075,
        22.881133774327
    ],
    [
        112.93991379969,
        22.881155239019
    ],
    [
        112.93981645316,
        22.88116611709
    ],
    [
        112.93978518442,
        22.881167558393
    ],
    [
        112.93964975566,
        22.881205438192
    ],
    [
        112.939623127,
        22.881183226924
    ],
    [
        112.93963019788,
        22.881180706177
    ],
    [
        112.93961036989,
        22.881153807138
    ],
    [
        112.93958048814,
        22.881118884135
    ],
    [
        112.93957100956,
        22.881068000384
    ],
    [
        112.93957157849,
        22.88103381967
    ],
    [
        112.93957674753,
        22.881029421988
    ],
    [
        112.93956185266,
        22.880949849268
    ],
    [
        112.93956375807,
        22.880946844402
    ],
    [
        112.93955886332,
        22.880947984258
    ],
    [
        112.93954038174,
        22.880939241205
    ],
    [
        112.93954255903,
        22.88093623332
    ],
    [
        112.93952952724,
        22.880911155526
    ],
    [
        112.93953035074,
        22.880900568544
    ],
    [
        112.93952518212,
        22.880904423596
    ],
    [
        112.93951159737,
        22.88089182816
    ],
    [
        112.93949718774,
        22.880891718141
    ],
    [
        112.9394346599,
        22.880885635328
    ],
    [
        112.93937430423,
        22.88088413643
    ],
    [
        112.93926556298,
        22.880872862231
    ],
    [
        112.93922451515,
        22.880866533181
    ],
    [
        112.93916933756,
        22.880850593572
    ],
    [
        112.93911280695,
        22.880826801005
    ],
    [
        112.93905434912,
        22.880836116423
    ],
    [
        112.9390132939,
        22.880841443808
    ],
    [
        112.93895130213,
        22.880851606785
    ],
    [
        112.93894749445,
        22.880853817649
    ],
    [
        112.93895021407,
        22.880852432195
    ],
    [
        112.938841449,
        22.880882350839
    ],
    [
        112.93883872902,
        22.88088427853
    ],
    [
        112.93880663448,
        22.880905506002
    ],
    [
        112.93872805257,
        22.880928041034
    ],
    [
        112.93870874444,
        22.880937196422
    ],
    [
        112.93866687459,
        22.880944149359
    ],
    [
        112.93862281758,
        22.880968211222
    ],
    [
        112.93858585055,
        22.880962904826
    ],
    [
        112.93853746724,
        22.880956361005
    ],
    [
        112.93851164144,
        22.880957445135
    ],
    [
        112.93844912012,
        22.880954843126
    ],
    [
        112.93836677048,
        22.880931830583
    ],
    [
        112.93810847643,
        22.881006625836
    ],
    [
        112.93795541506,
        22.881041532771
    ],
    [
        112.93738178697,
        22.881200139492
    ],
    [
        112.93680087292,
        22.881359642812
    ],
    [
        112.93664975878,
        22.881376476137
    ],
    [
        112.93660056095,
        22.881388853315
    ],
    [
        112.93641358104,
        22.881404624031
    ],
    [
        112.93620813127,
        22.881416187521
    ],
    [
        112.93600402042,
        22.881464592369
    ],
    [
        112.93589721523,
        22.881484753784
    ],
    [
        112.93578416516,
        22.881500889586
    ],
    [
        112.93566405345,
        22.881515717003
    ],
    [
        112.93555672101,
        22.881521749344
    ],
    [
        112.93549014807,
        22.881526358215
    ],
    [
        112.93546352359,
        22.8815219625
    ],
    [
        112.93541190563,
        22.881512613776
    ],
    [
        112.93535134195,
        22.881475397941
    ],
    [
        112.93534292081,
        22.881473024049
    ],
    [
        112.93528887564,
        22.881440092751
    ],
    [
        112.93522993605,
        22.88141316458
    ],
    [
        112.93515822649,
        22.881387418331
    ],
    [
        112.93510361471,
        22.881388928897
    ],
    [
        112.93503623605,
        22.881387552071
    ],
    [
        112.93497672476,
        22.881403198427
    ],
    [
        112.93494356637,
        22.881420539413
    ],
    [
        112.93491093664,
        22.881458488657
    ],
    [
        112.93489325903,
        22.881483575895
    ],
    [
        112.93488806924,
        22.881522129455
    ],
    [
        112.93485814687,
        22.881573889289
    ],
    [
        112.93483936006,
        22.881630717666
    ],
    [
        112.93481486868,
        22.88168677507
    ],
    [
        112.93479771717,
        22.881736809858
    ],
    [
        112.93478111012,
        22.881785484201
    ],
    [
        112.93476583015,
        22.881878629651
    ],
    [
        112.9347320789,
        22.881968386995
    ],
    [
        112.93469125565,
        22.882070943703
    ],
    [
        112.93464827177,
        22.882156156491
    ],
    [
        112.93463681627,
        22.882221335818
    ],
    [
        112.93462948014,
        22.882222746091
    ],
    [
        112.93462265978,
        22.882264023044
    ],
    [
        112.93462564612,
        22.88226698454
    ],
    [
        112.93461388609,
        22.882380444595
    ],
    [
        112.93458966062,
        22.882448701061
    ],
    [
        112.93457003464,
        22.882545131176
    ],
    [
        112.93453084506,
        22.882647399696
    ],
    [
        112.93453246665,
        22.882659864404
    ],
    [
        112.93453518517,
        22.88265713228
    ],
    [
        112.93450660115,
        22.882744676287
    ],
    [
        112.93449460777,
        22.882804433899
    ],
    [
        112.93446795181,
        22.88285344849
    ],
    [
        112.93447093344,
        22.88286346239
    ],
    [
        112.93445353725,
        22.882877963423
    ],
    [
        112.9344396668,
        22.882901389342
    ],
    [
        112.93441982305,
        22.882919975989
    ],
    [
        112.93439808152,
        22.882932880113
    ],
    [
        112.93433640883,
        22.882941729509
    ],
    [
        112.93433478139,
        22.882937943894
    ],
    [
        112.93431250389,
        22.882940272308
    ],
    [
        112.9342861572,
        22.882934221023
    ],
    [
        112.93427121227,
        22.882940022659
    ],
    [
        112.93425083733,
        22.88294125153
    ],
    [
        112.93421171938,
        22.882940984457
    ],
    [
        112.93407968137,
        22.882965501382
    ],
    [
        112.93405494979,
        22.882983301981
    ],
    [
        112.93406201404,
        22.882981083448
    ],
    [
        112.93402913264,
        22.882999753369
    ],
    [
        112.93401228491,
        22.883008548315
    ],
    [
        112.93400033471,
        22.883005375397
    ],
    [
        112.93393893611,
        22.883016914391
    ],
    [
        112.93387482305,
        22.883026569846
    ],
    [
        112.93382754817,
        22.883042076222
    ],
    [
        112.93379412827,
        22.883055589787
    ],
    [
        112.93375608707,
        22.883074828897
    ],
    [
        112.93370366561,
        22.883070022137
    ],
    [
        112.93368953426,
        22.883080150684
    ],
    [
        112.93368247529,
        22.88307504372
    ],
    [
        112.93364905072,
        22.883096961295
    ],
    [
        112.93363763364,
        22.883110326215
    ],
    [
        112.93363355942,
        22.883110081594
    ],
    [
        112.93362703432,
        22.883119346007
    ],
    [
        112.93362350122,
        22.883122352583
    ],
    [
        112.93357378029,
        22.883143289232
    ],
    [
        112.93342682223,
        22.883161590639
    ],
    [
        112.93314513239,
        22.883209183297
    ],
    [
        112.93293081205,
        22.883255225251
    ],
    [
        112.93271677274,
        22.883299326939
    ],
    [
        112.93270509257,
        22.883302648617
    ],
    [
        112.93268580796,
        22.883306284827
    ],
    [
        112.93267032942,
        22.883303931971
    ],
    [
        112.93259454764,
        22.883321719641
    ],
    [
        112.93249188014,
        22.883341278822
    ],
    [
        112.9323139841,
        22.883371813937
    ],
    [
        112.93219964828,
        22.883385984794
    ],
    [
        112.93215998941,
        22.883404094693
    ],
    [
        112.93211762281,
        22.883410554366
    ],
    [
        112.93210648859,
        22.88341142597
    ],
    [
        112.93210078055,
        22.883419863781
    ],
    [
        112.93209833604,
        22.883420690162
    ],
    [
        112.93207633785,
        22.883424601332
    ],
    [
        112.93206601958,
        22.883423569701
    ],
    [
        112.93205433904,
        22.883429597002
    ],
    [
        112.93202202371,
        22.883431119121
    ],
    [
        112.93195519804,
        22.88347024545
    ],
    [
        112.93159508203,
        22.883562059606
    ],
    [
        112.93129989762,
        22.883627702267
    ],
    [
        112.93123230473,
        22.883606575578
    ],
    [
        112.93120624532,
        22.883598010968
    ],
    [
        112.93111341852,
        22.883553661736
    ],
    [
        112.93104637951,
        22.883519231039
    ],
    [
        112.93083495508,
        22.883409718301
    ],
    [
        112.93084391603,
        22.883406969574
    ],
    [
        112.93084309929,
        22.883410498903
    ],
    [
        112.93064629922,
        22.883368698494
    ],
    [
        112.93059173998,
        22.883356161475
    ],
    [
        112.93052225013,
        22.883343678258
    ],
    [
        112.93025543579,
        22.883284169208
    ],
    [
        112.92976766626,
        22.883246456748
    ],
    [
        112.92887652236,
        22.883384734636
    ],
    [
        112.92854642853,
        22.883526204477
    ],
    [
        112.9282993893,
        22.883672314738
    ],
    [
        112.92810805958,
        22.883707348967
    ],
    [
        112.92795390072,
        22.88375857107
    ],
    [
        112.92784882035,
        22.883871005862
    ],
    [
        112.92774342685,
        22.884055036514
    ],
    [
        112.92773800183,
        22.884052330833
    ],
    [
        112.92755060363,
        22.884347374881
    ],
    [
        112.92738092663,
        22.884515976213
    ],
    [
        112.92727237596,
        22.884558109045
    ],
    [
        112.9269679188,
        22.884650527126
    ],
    [
        112.926944856,
        22.884655149635
    ],
    [
        112.92693648744,
        22.884585175119
    ],
    [
        112.92699626796,
        22.884425658837
    ],
    [
        112.92735644899,
        22.883307383438
    ],
    [
        112.92737770801,
        22.883159814837
    ],
    [
        112.92695021255,
        22.883035615141
    ],
    [
        112.92677959127,
        22.883005036581
    ],
    [
        112.92635183078,
        22.882944610098
    ],
    [
        112.92616766681,
        22.882912848727
    ],
    [
        112.92570388722,
        22.882844290108
    ],
    [
        112.92570307861,
        22.882836695107
    ],
    [
        112.92554957864,
        22.882814883543
    ],
    [
        112.92554116819,
        22.882818673946
    ],
    [
        112.92488546197,
        22.882714058147
    ],
    [
        112.92301387257,
        22.88255842841
    ],
    [
        112.92112852277,
        22.882468148193
    ],
    [
        112.9211198489,
        22.882470818324
    ],
    [
        112.92100196891,
        22.882464542613
    ],
    [
        112.92092094306,
        22.882462780677
    ],
    [
        112.92091199463,
        22.882471143659
    ],
    [
        112.92090272935,
        22.882546770241
    ],
    [
        112.92088530216,
        22.882670363321
    ],
    [
        112.92087112077,
        22.882804008343
    ],
    [
        112.92085502271,
        22.882968563992
    ],
    [
        112.92083730844,
        22.88312009221
    ],
    [
        112.9208160888,
        22.883246377706
    ],
    [
        112.92081141806,
        22.883344811162
    ],
    [
        112.92079238188,
        22.883448866562
    ],
    [
        112.92078390055,
        22.883574946201
    ],
    [
        112.92076241083,
        22.883703942107
    ],
    [
        112.92075121581,
        22.883838415949
    ],
    [
        112.92072265724,
        22.884007517312
    ],
    [
        112.92071366743,
        22.88408422968
    ],
    [
        112.92069954409,
        22.884136775254
    ],
    [
        112.92068917785,
        22.884249554529
    ],
    [
        112.92068774105,
        22.884384622027
    ],
    [
        112.92066974462,
        22.884571137338
    ],
    [
        112.92065907079,
        22.884749825481
    ],
    [
        112.9206484149,
        22.884900034072
    ],
    [
        112.92062420313,
        22.885064275212
    ],
    [
        112.92060350814,
        22.885241282955
    ],
    [
        112.92059422783,
        22.885360577935
    ],
    [
        112.92057464155,
        22.885497177087
    ],
    [
        112.92054394127,
        22.885642938446
    ],
    [
        112.92053274897,
        22.885794500455
    ],
    [
        112.92052620461,
        22.885870683239
    ],
    [
        112.92049307383,
        22.886006123515
    ],
    [
        112.92046644505,
        22.886145938252
    ],
    [
        112.9204473985,
        22.886297186067
    ],
    [
        112.92042213249,
        22.886425615495
    ],
    [
        112.92040799533,
        22.886517759541
    ],
    [
        112.92039928799,
        22.886589861597
    ],
    [
        112.92039763008,
        22.886653865258
    ],
    [
        112.92040001113,
        22.88676969822
    ],
    [
        112.92039642985,
        22.886889024611
    ],
    [
        112.92038636582,
        22.886967629139
    ],
    [
        112.92038902267,
        22.887076954181
    ],
    [
        112.92037381362,
        22.887150105511
    ],
    [
        112.92036210868,
        22.887262877465
    ],
    [
        112.92035474218,
        22.887370519876
    ],
    [
        112.92035090991,
        22.887454041356
    ],
    [
        112.92034354615,
        22.887557886503
    ],
    [
        112.92034455025,
        22.887733928953
    ],
    [
        112.92032905279,
        22.887851833755
    ],
    [
        112.92033090269,
        22.887958171673
    ],
    [
        112.92033330905,
        22.888032234721
    ],
    [
        112.92033625236,
        22.888118506803
    ],
    [
        112.92033784966,
        22.888184970605
    ],
    [
        112.92036544082,
        22.888296062793
    ],
    [
        112.92036838548,
        22.888381792526
    ],
    [
        112.92037806695,
        22.888559240542
    ],
    [
        112.92038587053,
        22.888693550299
    ],
    [
        112.92037468559,
        22.888883360904
    ],
    [
        112.92037759946,
        22.889055347427
    ],
    [
        112.92037563612,
        22.889230833508
    ],
    [
        112.92037965668,
        22.889348848415
    ],
    [
        112.92038880596,
        22.8895230401
    ],
    [
        112.92040149137,
        22.889663074149
    ],
    [
        112.92039386726,
        22.88976881917
    ],
    [
        112.92039817558,
        22.889847233852
    ],
    [
        112.92038243484,
        22.889919570607
    ],
    [
        112.92037564785,
        22.88995750803
    ],
    [
        112.9203802376,
        22.890006900781
    ],
    [
        112.92038235862,
        22.890147419837
    ],
    [
        112.92038202452,
        22.890342446859
    ],
    [
        112.92037711628,
        22.890440069957
    ],
    [
        112.92039036373,
        22.890535894603
    ],
    [
        112.92040171749,
        22.890623299981
    ],
    [
        112.92040302354,
        22.890785786766
    ],
    [
        112.92040730495,
        22.890971346608
    ],
    [
        112.92040075457,
        22.8911386733
    ],
    [
        112.9203977347,
        22.891281878163
    ],
    [
        112.92039552139,
        22.891453298029
    ],
    [
        112.92038898761,
        22.891571799871
    ],
    [
        112.92036455651,
        22.891748522557
    ],
    [
        112.92036073227,
        22.89187517723
    ],
    [
        112.92035204233,
        22.891955691738
    ],
    [
        112.92033928169,
        22.892064936677
    ],
    [
        112.92032815821,
        22.892126449755
    ],
    [
        112.92030565049,
        22.892206344593
    ],
    [
        112.92025767448,
        22.892279585822
    ],
    [
        112.92021511829,
        22.892352855802
    ],
    [
        112.92014600299,
        22.892455810607
    ],
    [
        112.920031635,
        22.892586709132
    ],
    [
        112.91994301408,
        22.892695776883
    ],
    [
        112.91985467215,
        22.892773373686
    ],
    [
        112.91975955771,
        22.892855534009
    ],
    [
        112.91965333108,
        22.892970711522
    ],
    [
        112.91950863176,
        22.893110322574
    ],
    [
        112.91941487595,
        22.89321172244
    ],
    [
        112.91936365761,
        22.893302266745
    ],
    [
        112.91929429116,
        22.893379399829
    ],
    [
        112.91916965593,
        22.893487361186
    ],
    [
        112.91903418203,
        22.893636196871
    ],
    [
        112.91890657297,
        22.893752519312
    ],
    [
        112.91878980321,
        22.893867275253
    ],
    [
        112.9186787277,
        22.89396144371
    ],
    [
        112.91856440289,
        22.894066971577
    ],
    [
        112.91845495846,
        22.89415706163
    ],
    [
        112.91835634917,
        22.894265666263
    ],
    [
        112.91826722432,
        22.894356429271
    ],
    [
        112.9181870411,
        22.894433146409
    ],
    [
        112.91808085491,
        22.894532720375
    ],
    [
        112.91790532788,
        22.894699028846
    ],
    [
        112.91780781643,
        22.8947837256
    ],
    [
        112.91764665471,
        22.894941698323
    ],
    [
        112.9175133953,
        22.895081426899
    ],
    [
        112.91735874448,
        22.895229376609
    ],
    [
        112.91724851573,
        22.895320435362
    ],
    [
        112.91716618369,
        22.895401136058
    ],
    [
        112.9170941447,
        22.895464827388
    ],
    [
        112.91698581744,
        22.895560489816
    ],
    [
        112.91677594012,
        22.895753200686
    ],
    [
        112.91666112081,
        22.895860714467
    ],
    [
        112.9165295151,
        22.895996281766
    ],
    [
        112.91640928633,
        22.896100740788
    ],
    [
        112.91632615688,
        22.896176224481
    ],
    [
        112.91616288075,
        22.896328558817
    ],
    [
        112.91603589218,
        22.896462217493
    ],
    [
        112.91590322121,
        22.896589571461
    ],
    [
        112.91580656348,
        22.896692564428
    ],
    [
        112.91566685936,
        22.896810875946
    ],
    [
        112.91555829352,
        22.896902343811
    ],
    [
        112.91540912134,
        22.897041153002
    ],
    [
        112.91527105332,
        22.897173000823
    ],
    [
        112.915112685,
        22.897304361429
    ],
    [
        112.91504284289,
        22.897376909501
    ],
    [
        112.91493320737,
        22.897462346353
    ],
    [
        112.91479407002,
        22.89759630315
    ],
    [
        112.91467713155,
        22.897692495207
    ],
    [
        112.91459295045,
        22.897789286722
    ],
    [
        112.91442513251,
        22.897960886538
    ],
    [
        112.91429954195,
        22.898071874977
    ],
    [
        112.91421022412,
        22.898162620334
    ],
    [
        112.91407597935,
        22.898294384083
    ],
    [
        112.91394904392,
        22.898403697887
    ],
    [
        112.91386812051,
        22.898470910646
    ],
    [
        112.91379315346,
        22.898541710228
    ],
    [
        112.9136762411,
        22.89866440054
    ],
    [
        112.91354092791,
        22.898795014968
    ],
    [
        112.91340940495,
        22.898907483263
    ],
    [
        112.91330602999,
        22.899002081412
    ],
    [
        112.9131450172,
        22.899143489646
    ],
    [
        112.91302270652,
        22.899261452061
    ],
    [
        112.91289119968,
        22.899393946437
    ],
    [
        112.9127485986,
        22.89951490563
    ],
    [
        112.91266066197,
        22.899608551763
    ],
    [
        112.91259842943,
        22.899666958322
    ],
    [
        112.91250399722,
        22.899742071565
    ],
    [
        112.91241552188,
        22.899826744295
    ],
    [
        112.91229728745,
        22.899944693572
    ],
    [
        112.91219204167,
        22.900047327228
    ],
    [
        112.9120943757,
        22.900154114509
    ],
    [
        112.91195585564,
        22.900280199884
    ],
    [
        112.91182112827,
        22.900410388279
    ],
    [
        112.91168829976,
        22.900546556291
    ],
    [
        112.91153788523,
        22.90067571087
    ],
    [
        112.91140614383,
        22.900802644296
    ],
    [
        112.91129523311,
        22.900903244925
    ],
    [
        112.91119677353,
        22.901015118623
    ],
    [
        112.91107207075,
        22.901125293732
    ],
    [
        112.91095954781,
        22.901242940427
    ],
    [
        112.91091437678,
        22.901289289432
    ],
    [
        112.91087570794,
        22.901366918636
    ],
    [
        112.91079673152,
        22.901461114675
    ],
    [
        112.91072640973,
        22.901539956569
    ],
    [
        112.91065825623,
        22.901629132448
    ],
    [
        112.91058604311,
        22.901709842442
    ],
    [
        112.9104770506,
        22.901836453798
    ],
    [
        112.91036832306,
        22.901936746923
    ],
    [
        112.91027096008,
        22.902037184182
    ],
    [
        112.91017549729,
        22.902152832953
    ],
    [
        112.91010193755,
        22.902231604533
    ],
    [
        112.91002729773,
        22.90231361371
    ],
    [
        112.90988775091,
        22.90244981173
    ],
    [
        112.90973820871,
        22.902617059503
    ],
    [
        112.90956704026,
        22.902814923463
    ],
    [
        112.90948726374,
        22.90288435906
    ],
    [
        112.90937126535,
        22.903024094745
    ],
    [
        112.90931097034,
        22.903100845578
    ],
    [
        112.90925418795,
        22.903164892835
    ],
    [
        112.90911196676,
        22.903332188324
    ],
    [
        112.90888972474,
        22.903606043649
    ],
    [
        112.90882510545,
        22.903677291122
    ],
    [
        112.90875507854,
        22.903751986149
    ],
    [
        112.90869912139,
        22.903836102776
    ],
    [
        112.90858558115,
        22.903991557154
    ],
    [
        112.90844338039,
        22.90416476871
    ],
    [
        112.90830063764,
        22.90432656743
    ],
    [
        112.90818629139,
        22.904473847208
    ],
    [
        112.90805005576,
        22.904657153406
    ],
    [
        112.90784218019,
        22.904903150438
    ],
    [
        112.90778407477,
        22.90499806013
    ],
    [
        112.90767918859,
        22.905108282534
    ],
    [
        112.90757296723,
        22.905251305732
    ],
    [
        112.90747620954,
        22.905385511744
    ],
    [
        112.907354588,
        22.905551353618
    ],
    [
        112.90724241798,
        22.905682876126
    ],
    [
        112.90714944545,
        22.905802744981
    ],
    [
        112.90695592303,
        22.906022822187
    ],
    [
        112.9068656538,
        22.906131596328
    ],
    [
        112.90676835572,
        22.906242158445
    ],
    [
        112.90665187955,
        22.906392302744
    ],
    [
        112.90653890623,
        22.906514008691
    ],
    [
        112.90642054873,
        22.906677405077
    ],
    [
        112.90631677584,
        22.906803039514
    ],
    [
        112.90621002597,
        22.906921026638
    ],
    [
        112.90614273613,
        22.906999470871
    ],
    [
        112.90611058676,
        22.907053229817
    ],
    [
        112.90605492213,
        22.907125341256
    ],
    [
        112.90595088985,
        22.90725963623
    ],
    [
        112.90584767492,
        22.907401535628
    ],
    [
        112.90575606764,
        22.907505902786
    ],
    [
        112.90567121603,
        22.907600606144
    ],
    [
        112.90554124736,
        22.907761061093
    ],
    [
        112.90544452479,
        22.907895991864
    ],
    [
        112.9054023764,
        22.907952024305
    ],
    [
        112.90534779204,
        22.908011113917
    ],
    [
        112.90530376533,
        22.908090175104
    ],
    [
        112.905257025,
        22.908152371813
    ],
    [
        112.90516298685,
        22.90824745349
    ],
    [
        112.90504842799,
        22.908387509723
    ],
    [
        112.90489955209,
        22.90855929366
    ],
    [
        112.90475959205,
        22.908715477488
    ],
    [
        112.90470798372,
        22.90876971785
    ],
    [
        112.90465854889,
        22.908839999017
    ],
    [
        112.90460937348,
        22.9088923777
    ],
    [
        112.90454263695,
        22.908965089413
    ],
    [
        112.90433623525,
        22.909218653949
    ],
    [
        112.90419304513,
        22.90938045268
    ],
    [
        112.90399531125,
        22.909643357767
    ],
    [
        112.90388295954,
        22.909821111369
    ],
    [
        112.90374843706,
        22.909993611239
    ],
    [
        112.90361634269,
        22.910155021835
    ],
    [
        112.9034993592,
        22.910271370015
    ],
    [
        112.90339128023,
        22.91036100287
    ],
    [
        112.90317893038,
        22.910568536273
    ],
    [
        112.90309192845,
        22.910639248216
    ],
    [
        112.90303572999,
        22.910686599257
    ],
    [
        112.90288712824,
        22.910809719891
    ],
    [
        112.90268045468,
        22.911001308899
    ],
    [
        112.90245189009,
        22.9111957705
    ],
    [
        112.90220390429,
        22.911441977651
    ],
    [
        112.90199697324,
        22.911633251051
    ],
    [
        112.90173737475,
        22.911880585891
    ],
    [
        112.90160092899,
        22.91197021973
    ],
    [
        112.90144992188,
        22.912105449313
    ],
    [
        112.90121733738,
        22.912314690213
    ],
    [
        112.90102148854,
        22.912483587087
    ],
    [
        112.90091534258,
        22.912596241568
    ],
    [
        112.90079136224,
        22.9127156384
    ],
    [
        112.90068548454,
        22.912823137666
    ],
    [
        112.90060364418,
        22.912903921858
    ],
    [
        112.90053340841,
        22.912960488973
    ],
    [
        112.90044050515,
        22.913064953169
    ],
    [
        112.90036055478,
        22.913141154243
    ],
    [
        112.90027141625,
        22.913219635622
    ],
    [
        112.90019389348,
        22.913288280006
    ],
    [
        112.90010665114,
        22.913370590184
    ],
    [
        112.90001643174,
        22.913447692128
    ],
    [
        112.89995296268,
        22.91351223817
    ],
    [
        112.89980522356,
        22.913655343092
    ],
    [
        112.89963451866,
        22.913808622523
    ],
    [
        112.89947433957,
        22.91394064923
    ],
    [
        112.89936009022,
        22.914045807027
    ],
    [
        112.89927473565,
        22.914117558194
    ],
    [
        112.8990592189,
        22.914333249858
    ],
    [
        112.89894201033,
        22.914451914823
    ],
    [
        112.89882180585,
        22.91454285169
    ],
    [
        112.89868865208,
        22.914662316899
    ],
    [
        112.89853579921,
        22.914818601236
    ],
    [
        112.89836512621,
        22.91499572999
    ],
    [
        112.89817259579,
        22.91521289409
    ],
    [
        112.89803435283,
        22.915380825911
    ],
    [
        112.89783316892,
        22.91558914983
    ],
    [
        112.89771949123,
        22.915718988708
    ],
    [
        112.897558264,
        22.915872128795
    ],
    [
        112.89739409322,
        22.916057501445
    ],
    [
        112.89728283854,
        22.916174086812
    ],
    [
        112.89718615943,
        22.91626786945
    ],
    [
        112.89710379513,
        22.916349697385
    ],
    [
        112.89693123094,
        22.916515655175
    ],
    [
        112.89679945431,
        22.916652222543
    ],
    [
        112.89664363293,
        22.916800028298
    ],
    [
        112.89648700698,
        22.916954059867
    ],
    [
        112.89640464409,
        22.917035615938
    ],
    [
        112.89630227957,
        22.917116544811
    ],
    [
        112.89617022634,
        22.917243882766
    ],
    [
        112.89598472924,
        22.917449765197
    ],
    [
        112.89590562055,
        22.917541961202
    ],
    [
        112.89575249398,
        22.917677879199
    ],
    [
        112.89553563957,
        22.917877780781
    ],
    [
        112.89541709884,
        22.918001292759
    ],
    [
        112.89523131101,
        22.918182757883
    ],
    [
        112.89504443384,
        22.918355252581
    ],
    [
        112.89490590195,
        22.918488995187
    ],
    [
        112.89473063247,
        22.918645692753
    ],
    [
        112.89458318274,
        22.918781180418
    ],
    [
        112.89442305552,
        22.918944120104
    ],
    [
        112.89428263346,
        22.919079736602
    ],
    [
        112.89412601877,
        22.919241387006
    ],
    [
        112.89402019381,
        22.919376533511
    ],
    [
        112.8938914184,
        22.91953705184
    ],
    [
        112.89376315753,
        22.919670721146
    ],
    [
        112.89369242565,
        22.919759010082
    ],
    [
        112.89363520543,
        22.919844010346
    ],
    [
        112.8935064218,
        22.919996124651
    ],
    [
        112.89334982228,
        22.92017379957
    ],
    [
        112.89321645785,
        22.920340761701
    ],
    [
        112.89297071615,
        22.920577387859
    ],
    [
        112.89279683371,
        22.920772953331
    ],
    [
        112.89262508603,
        22.920941158568
    ],
    [
        112.89241419702,
        22.921163766243
    ],
    [
        112.89228160713,
        22.921296307537
    ],
    [
        112.89208203565,
        22.921485211426
    ],
    [
        112.89189056406,
        22.921665853087
    ],
    [
        112.8916952931,
        22.921832871732
    ],
    [
        112.89148921042,
        22.922002426807
    ],
    [
        112.89136686496,
        22.922111567062
    ],
    [
        112.89114675763,
        22.922315899277
    ],
    [
        112.89097497456,
        22.922458664564
    ],
    [
        112.89087260714,
        22.922544556562
    ],
    [
        112.89072321217,
        22.922640776684
    ],
    [
        112.89057949613,
        22.922740083784
    ],
    [
        112.89039984988,
        22.922864565183
    ],
    [
        112.8902253345,
        22.922985344074
    ],
    [
        112.89011889655,
        22.923060065883
    ],
    [
        112.89004407913,
        22.923126096745
    ],
    [
        112.88991062783,
        22.923222620495
    ],
    [
        112.88969396732,
        22.923376909549
    ],
    [
        112.88951324381,
        22.92351471753
    ],
    [
        112.88941140423,
        22.92359632307
    ],
    [
        112.88921635687,
        22.923742322893
    ],
    [
        112.88907289811,
        22.923841703564
    ],
    [
        112.88886596393,
        22.924001098062
    ],
    [
        112.88858716575,
        22.924216314834
    ],
    [
        112.88837425459,
        22.924354758539
    ],
    [
        112.88824890399,
        22.92445583322
    ],
    [
        112.88807356834,
        22.924592466973
    ],
    [
        112.8878609377,
        22.924749136875
    ],
    [
        112.8877090799,
        22.924846288147
    ],
    [
        112.88765801363,
        22.924882646286
    ],
    [
        112.88753049544,
        22.92498643646
    ],
    [
        112.88740381298,
        22.925115479483
    ],
    [
        112.88725548434,
        22.92523197949
    ],
    [
        112.88708905655,
        22.925367740725
    ],
    [
        112.88692344087,
        22.925506782802
    ],
    [
        112.88672973509,
        22.925680130829
    ],
    [
        112.88657142869,
        22.925832336151
    ],
    [
        112.88642742036,
        22.925953570904
    ],
    [
        112.88619475079,
        22.926113888992
    ],
    [
        112.88601046833,
        22.926259771886
    ],
    [
        112.88587672403,
        22.926376588014
    ],
    [
        112.88570649931,
        22.926523253326
    ],
    [
        112.88557651259,
        22.926616269788
    ],
    [
        112.88547493254,
        22.926720570169
    ],
    [
        112.88538090041,
        22.92680192562
    ],
    [
        112.88526524647,
        22.926898160013
    ],
    [
        112.88521852372,
        22.926962044444
    ],
    [
        112.88514772376,
        22.92701960663
    ],
    [
        112.8850172045,
        22.927128389477
    ],
    [
        112.88483695319,
        22.927271457589
    ],
    [
        112.88467831972,
        22.927398847818
    ],
    [
        112.88453319701,
        22.927516407181
    ],
    [
        112.88444673766,
        22.927606872033
    ],
    [
        112.88434323784,
        22.927697911669
    ],
    [
        112.88424619902,
        22.927760289272
    ],
    [
        112.88410000812,
        22.927898488758
    ],
    [
        112.8839970395,
        22.927984129705
    ],
    [
        112.88381654009,
        22.92817016507
    ],
    [
        112.88368036843,
        22.928326446868
    ],
    [
        112.8835390807,
        22.928508172856
    ],
    [
        112.8834396417,
        22.928613702216
    ],
    [
        112.88333887641,
        22.928746351223
    ],
    [
        112.88325109379,
        22.928878369363
    ],
    [
        112.88316815141,
        22.928982783314
    ],
    [
        112.88307524431,
        22.929132105525
    ],
    [
        112.88300418603,
        22.929219866771
    ],
    [
        112.88296503646,
        22.92929530848
    ],
    [
        112.88292721133,
        22.929343094361
    ],
    [
        112.88292073618,
        22.929360371756
    ],
    [
        112.88282215108,
        22.929516143614
    ],
    [
        112.88272653084,
        22.929662464755
    ],
    [
        112.88264847211,
        22.929787047661
    ],
    [
        112.88256715123,
        22.929896939986
    ],
    [
        112.88247048073,
        22.930078805199
    ],
    [
        112.88239300473,
        22.93024817579
    ],
    [
        112.88232387211,
        22.930375062082
    ],
    [
        112.88225854776,
        22.93052343515
    ],
    [
        112.88217944831,
        22.93069577946
    ],
    [
        112.88209410598,
        22.930849054754
    ],
    [
        112.88203093163,
        22.930985798284
    ],
    [
        112.88196478353,
        22.931125761993
    ],
    [
        112.88191159299,
        22.931236863266
    ],
    [
        112.88185652984,
        22.931370190527
    ],
    [
        112.88179847084,
        22.931484218008
    ],
    [
        112.88178095132,
        22.931552638576
    ],
    [
        112.88175316866,
        22.93163992123
    ],
    [
        112.88172861297,
        22.93170716777
    ],
    [
        112.88168514761,
        22.931805376853
    ],
    [
        112.88166899806,
        22.931891994267
    ],
    [
        112.88162504347,
        22.932044191032
    ],
    [
        112.88160996044,
        22.932115086051
    ],
    [
        112.88156274406,
        22.932252863594
    ],
    [
        112.8815376976,
        22.932373556441
    ],
    [
        112.88150560554,
        22.932483579961
    ],
    [
        112.88147917516,
        22.932572783565
    ],
    [
        112.88143141927,
        22.932714356708
    ],
    [
        112.8814095824,
        22.932797649852
    ],
    [
        112.88138208933,
        22.932908275847
    ],
    [
        112.88137133166,
        22.932976785071
    ],
    [
        112.88135566944,
        22.933009690881
    ],
    [
        112.8813262309,
        22.933067115581
    ],
    [
        112.88131114305,
        22.933135028817
    ],
    [
        112.88128931777,
        22.933231618247
    ],
    [
        112.88126907764,
        22.933288072755
    ],
    [
        112.88125614506,
        22.933346517097
    ],
    [
        112.8812464489,
        22.933393877571
    ],
    [
        112.88120974693,
        22.933497067173
    ],
    [
        112.8811898242,
        22.9336037201
    ],
    [
        112.88113853657,
        22.93373549122
    ],
    [
        112.8811042844,
        22.933855534988
    ],
    [
        112.88107761016,
        22.933977571485
    ],
    [
        112.88104628654,
        22.934047187657
    ],
    [
        112.88102956855,
        22.934110199902
    ],
    [
        112.88101202425,
        22.934157737257
    ],
    [
        112.8810028714,
        22.934208632909
    ],
    [
        112.88098697871,
        22.934286578005
    ],
    [
        112.88096865724,
        22.934371819193
    ],
    [
        112.88095138612,
        22.934422616329
    ],
    [
        112.88091871799,
        22.934502800038
    ],
    [
        112.88089202327,
        22.934605304657
    ],
    [
        112.88087692023,
        22.934660198623
    ],
    [
        112.88086450841,
        22.934699117721
    ],
    [
        112.88083757044,
        22.934832278865
    ],
    [
        112.88080626863,
        22.934928489018
    ],
    [
        112.88079033561,
        22.934964110465
    ],
    [
        112.88077497212,
        22.935030940099
    ],
    [
        112.88076311405,
        22.935084246325
    ],
    [
        112.88073857303,
        22.93517674078
    ],
    [
        112.88069562545,
        22.93526358863
    ],
    [
        112.8806397675,
        22.935438460483
    ],
    [
        112.88057226662,
        22.935607226878
    ],
    [
        112.88052883,
        22.935754847935
    ],
    [
        112.88049103407,
        22.935855871092
    ],
    [
        112.88045892254,
        22.935959132877
    ],
    [
        112.88042517561,
        22.936049624323
    ],
    [
        112.88039900039,
        22.936134236794
    ],
    [
        112.880357424,
        22.936246613917
    ],
    [
        112.8802912686,
        22.936414052147
    ],
    [
        112.88020916549,
        22.93660518303
    ],
    [
        112.88013812883,
        22.936764703228
    ],
    [
        112.88007655467,
        22.936914840209
    ],
    [
        112.88004252047,
        22.936990957486
    ],
    [
        112.8800252479,
        22.937046920051
    ],
    [
        112.88000202122,
        22.937102814352
    ],
    [
        112.87998205099,
        22.937169327554
    ],
    [
        112.87995316267,
        22.937251203527
    ],
    [
        112.87993698735,
        22.93732535753
    ],
    [
        112.87984491569,
        22.937581509277
    ],
    [
        112.87977445603,
        22.937794230507
    ],
    [
        112.87970695254,
        22.937984198351
    ],
    [
        112.87963132838,
        22.938174891999
    ],
    [
        112.8795413818,
        22.938395273668
    ],
    [
        112.87946685701,
        22.938612305148
    ],
    [
        112.8794279451,
        22.938690010451
    ],
    [
        112.87939094773,
        22.938793241018
    ],
    [
        112.87933314741,
        22.938944807549
    ],
    [
        112.87926615945,
        22.939116895078
    ],
    [
        112.87921538562,
        22.939258233637
    ],
    [
        112.87919000708,
        22.939340162951
    ],
    [
        112.87916759881,
        22.939413443188
    ],
    [
        112.87913465682,
        22.9395159105
    ],
    [
        112.87911682945,
        22.939563467061
    ],
    [
        112.87908471844,
        22.939691718699
    ],
    [
        112.87904042163,
        22.939813599337
    ],
    [
        112.87899154222,
        22.939961477479
    ],
    [
        112.87893399527,
        22.940103024301
    ],
    [
        112.87888348435,
        22.940244105954
    ],
    [
        112.87885807678,
        22.940292670027
    ],
    [
        112.8788462156,
        22.940358199732
    ],
    [
        112.87881863861,
        22.94040185791
    ],
    [
        112.87877514547,
        22.940519143075
    ],
    [
        112.8787254301,
        22.940642332573
    ],
    [
        112.87866600639,
        22.940816969703
    ],
    [
        112.878644689,
        22.940909532075
    ],
    [
        112.87860986038,
        22.941035052358
    ],
    [
        112.87854500292,
        22.941186847969
    ],
    [
        112.87850771873,
        22.94128765642
    ],
    [
        112.87847500467,
        22.941344290671
    ],
    [
        112.87845934429,
        22.941401102229
    ],
    [
        112.8784423255,
        22.941451117301
    ],
    [
        112.87839691679,
        22.941549131641
    ],
    [
        112.87835853603,
        22.941633383234
    ],
    [
        112.87830746308,
        22.941763084805
    ],
    [
        112.87824422335,
        22.94191626753
    ],
    [
        112.87818475731,
        22.942047787217
    ],
    [
        112.87812718373,
        22.942177429489
    ],
    [
        112.87811585815,
        22.942243512884
    ],
    [
        112.8780823276,
        22.942299877009
    ],
    [
        112.87804987726,
        22.942352725897
    ],
    [
        112.87802204351,
        22.942427868591
    ],
    [
        112.87798150654,
        22.942534627161
    ],
    [
        112.87791987882,
        22.942681329641
    ],
    [
        112.87790474769,
        22.942726215296
    ],
    [
        112.87788203747,
        22.942772925063
    ],
    [
        112.87786175519,
        22.94280663679
    ],
    [
        112.87783958836,
        22.942856879567
    ],
    [
        112.87776929005,
        22.942997263321
    ],
    [
        112.87772819887,
        22.943090458914
    ],
    [
        112.8776790146,
        22.943230511714
    ],
    [
        112.87764144226,
        22.943325100748
    ],
    [
        112.87761874487,
        22.943395960759
    ],
    [
        112.87759631541,
        22.943462754235
    ],
    [
        112.87756008649,
        22.943542979633
    ],
    [
        112.8775195372,
        22.943642697941
    ],
    [
        112.87745246406,
        22.94375762719
    ],
    [
        112.87738081893,
        22.94392596217
    ],
    [
        112.87728697719,
        22.944105485605
    ],
    [
        112.87718502625,
        22.944312883434
    ],
    [
        112.87712255671,
        22.944441437537
    ],
    [
        112.87702870171,
        22.944611755208
    ],
    [
        112.87697814067,
        22.944737442019
    ],
    [
        112.87689564686,
        22.944896208077
    ],
    [
        112.87682965561,
        22.945033154164
    ],
    [
        112.87674093576,
        22.945202725353
    ],
    [
        112.87666682317,
        22.945349915785
    ],
    [
        112.87662544271,
        22.945440429968
    ],
    [
        112.87657488757,
        22.945592990497
    ],
    [
        112.87649781035,
        22.945776517675
    ],
    [
        112.87643319093,
        22.945968568572
    ],
    [
        112.8763482617,
        22.946163972628
    ],
    [
        112.87630392726,
        22.946316597383
    ],
    [
        112.87625794836,
        22.946431228384
    ],
    [
        112.87624633525,
        22.946495695986
    ],
    [
        112.87624662225,
        22.946529610018
    ],
    [
        112.87623555143,
        22.946596252671
    ],
    [
        112.87619200434,
        22.946703853183
    ],
    [
        112.87616497213,
        22.946805356404
    ],
    [
        112.8761122828,
        22.947059107493
    ],
    [
        112.87608527505,
        22.947220296325
    ],
    [
        112.87605960939,
        22.947357352022
    ],
    [
        112.87605585462,
        22.947441148962
    ],
    [
        112.87604397021,
        22.94751266913
    ],
    [
        112.87604291901,
        22.947587536255
    ],
    [
        112.87605296356,
        22.947646219671
    ],
    [
        112.87604268796,
        22.94768140052
    ],
    [
        112.87603782606,
        22.947711201326
    ],
    [
        112.87603323299,
        22.947736392492
    ],
    [
        112.87603027712,
        22.947791439293
    ],
    [
        112.87603356546,
        22.947885061768
    ],
    [
        112.87603171988,
        22.948007668754
    ],
    [
        112.8760339252,
        22.948104266076
    ],
    [
        112.876026934,
        22.94822927101
    ],
    [
        112.8760177625,
        22.948320617782
    ],
    [
        112.87601589811,
        22.948401174542
    ],
    [
        112.87601430791,
        22.948491499898
    ],
    [
        112.87601543514,
        22.948607891618
    ],
    [
        112.87601492108,
        22.948681677353
    ],
    [
        112.87600925739,
        22.948744296937
    ],
    [
        112.87600361303,
        22.948860631397
    ],
    [
        112.87600013143,
        22.948968574062
    ],
    [
        112.87599799561,
        22.949054825064
    ],
    [
        112.87600045068,
        22.949105576154
    ],
    [
        112.87600699721,
        22.949241816576
    ],
    [
        112.87600892594,
        22.949338952933
    ],
    [
        112.8760100279,
        22.949394575645
    ],
    [
        112.87601167311,
        22.949455628597
    ],
    [
        112.87600872995,
        22.949563846421
    ],
    [
        112.87601417116,
        22.94964120828
    ],
    [
        112.87600795725,
        22.949686460458
    ],
    [
        112.87601584992,
        22.949810503695
    ],
    [
        112.8760180546,
        22.949933413781
    ],
    [
        112.87601512383,
        22.950091547285
    ],
    [
        112.87601382024,
        22.950262173244
    ],
    [
        112.87601115646,
        22.95041623925
    ],
    [
        112.8760022544,
        22.950539326422
    ],
    [
        112.87600064868,
        22.950608761063
    ],
    [
        112.87599741597,
        22.950671128662
    ],
    [
        112.87598742023,
        22.950760838843
    ],
    [
        112.87598742955,
        22.950796105482
    ],
    [
        112.87598203634,
        22.950883683998
    ],
    [
        112.87597637852,
        22.950997303186
    ],
    [
        112.87597939289,
        22.951139750704
    ],
    [
        112.87598295476,
        22.951311500837
    ],
    [
        112.8759949067,
        22.951468672062
    ],
    [
        112.87599006529,
        22.951615935962
    ],
    [
        112.87598631028,
        22.951783554667
    ],
    [
        112.87598579758,
        22.951922444837
    ],
    [
        112.87600286798,
        22.951970333185
    ],
    [
        112.8760169565,
        22.952003818912
    ],
    [
        112.87600911825,
        22.952079710707
    ],
    [
        112.87601888761,
        22.952185319886
    ],
    [
        112.87602324534,
        22.9523182824
    ],
    [
        112.87603139678,
        22.952470537367
    ],
    [
        112.8760349492,
        22.952658019238
    ],
    [
        112.87604093402,
        22.952826531995
    ],
    [
        112.87603174916,
        22.952973214472
    ],
    [
        112.8760209345,
        22.953093026865
    ],
    [
        112.8760220276,
        22.95316329622
    ],
    [
        112.87601418436,
        22.953236745561
    ],
    [
        112.87602774147,
        22.953365715008
    ],
    [
        112.87602396923,
        22.953518952923
    ],
    [
        112.8760164076,
        22.953700371101
    ],
    [
        112.87601262439,
        22.953774668051
    ],
    [
        112.87600071739,
        22.953855135906
    ],
    [
        112.87600343163,
        22.953917008871
    ],
    [
        112.87599965216,
        22.954040677264
    ],
    [
        112.87599316453,
        22.954172732182
    ],
    [
        112.87599588712,
        22.954354506956
    ],
    [
        112.87598614185,
        22.954404610276
    ],
    [
        112.87599643467,
        22.954435892894
    ],
    [
        112.87599833581,
        22.954516205054
    ],
    [
        112.87600213816,
        22.954696089374
    ],
    [
        112.87600377146,
        22.95485750878
    ],
    [
        112.87600730002,
        22.95504552825
    ],
    [
        112.87601543075,
        22.955248234606
    ],
    [
        112.87601191377,
        22.95539767394
    ],
    [
        112.87600947903,
        22.955569637385
    ],
    [
        112.87601949956,
        22.955686909348
    ],
    [
        112.87602220756,
        22.955830975067
    ],
    [
        112.87600758257,
        22.9560093455
    ],
    [
        112.87599864317,
        22.956168503659
    ],
    [
        112.87598618263,
        22.956304574472
    ],
    [
        112.87598617688,
        22.956473030274
    ],
    [
        112.87599050659,
        22.956550919714
    ],
    [
        112.87598183891,
        22.956594520608
    ],
    [
        112.87597912902,
        22.956634373801
    ],
    [
        112.8759850839,
        22.956692474411
    ],
    [
        112.87598833125,
        22.956737260321
    ],
    [
        112.87599076366,
        22.95682489913
    ],
    [
        112.87598777825,
        22.956933379689
    ],
    [
        112.87598397335,
        22.957131912728
    ],
    [
        112.87598098344,
        22.957274029528
    ],
    [
        112.87597854096,
        22.957336942021
    ],
    [
        112.87597311822,
        22.957413121353
    ],
    [
        112.87597771098,
        22.95753170153
    ],
    [
        112.87597958594,
        22.957736791276
    ],
    [
        112.87596792397,
        22.957893482597
    ],
    [
        112.87595707793,
        22.958010576524
    ],
    [
        112.87595976853,
        22.958150569554
    ],
    [
        112.87593997998,
        22.958299054648
    ],
    [
        112.87594591346,
        22.958471354225
    ],
    [
        112.87595536976,
        22.958618184645
    ],
    [
        112.87596401069,
        22.958776129694
    ],
    [
        112.87596967999,
        22.958883324327
    ],
    [
        112.87596477878,
        22.959038985461
    ],
    [
        112.87597829471,
        22.959174998912
    ],
    [
        112.87598936674,
        22.95934055883
    ],
    [
        112.87599122018,
        22.959554596037
    ],
    [
        112.87600145873,
        22.959803152745
    ],
    [
        112.87599168297,
        22.959925406904
    ],
    [
        112.87599624424,
        22.960112068834
    ],
    [
        112.87599647155,
        22.960295710199
    ],
    [
        112.87599536053,
        22.960409356425
    ],
    [
        112.87600858992,
        22.960568422471
    ],
    [
        112.87601776434,
        22.960695446359
    ],
    [
        112.87602802586,
        22.960804847867
    ],
    [
        112.87603124899,
        22.960902797355
    ],
    [
        112.87603014908,
        22.960963548693
    ],
    [
        112.87603499782,
        22.961055815441
    ],
    [
        112.87604634979,
        22.961132675649
    ],
    [
        112.87603901633,
        22.961208564326
    ],
    [
        112.87603463206,
        22.961383755961
    ],
    [
        112.87603296486,
        22.961524250078
    ],
    [
        112.87604676507,
        22.961559357932
    ],
    [
        112.87610146326,
        22.961571484884
    ],
    [
        112.87626880431,
        22.961607908433
    ],
    [
        112.87657693389,
        22.961687640455
    ],
    [
        112.87695003146,
        22.961765873713
    ],
    [
        112.8773073988,
        22.961856818042
    ],
    [
        112.87767070115,
        22.961948463575
    ],
    [
        112.8779801179,
        22.962014717839
    ],
    [
        112.87832118877,
        22.962090321315
    ],
    [
        112.87859782032,
        22.962155844258
    ],
    [
        112.87893831115,
        22.962248418868
    ],
    [
        112.87929583826,
        22.9623342143
    ],
    [
        112.87970232785,
        22.962435844775
    ],
    [
        112.87997619295,
        22.962506500693
    ],
    [
        112.88027548247,
        22.962586458183
    ],
    [
        112.88060939653,
        22.962668789719
    ],
    [
        112.88099227159,
        22.962755049136
    ],
    [
        112.88134644334,
        22.962843492811
    ],
    [
        112.88164676069,
        22.96291316618
    ],
    [
        112.88201037222,
        22.962996460084
    ],
    [
        112.88239073533,
        22.963092264893
    ],
    [
        112.88275349363,
        22.963190910171
    ],
    [
        112.88324743078,
        22.963307151917
    ],
    [
        112.88357066679,
        22.963377501595
    ],
    [
        112.8839174196,
        22.96345746481
    ],
    [
        112.88452000966,
        22.963599200519
    ],
    [
        112.88485428244,
        22.963679438967
    ],
    [
        112.88512580391,
        22.963740641197
    ],
    [
        112.88555145249,
        22.963854355081
    ],
    [
        112.88587352071,
        22.963928080443
    ],
    [
        112.88622288513,
        22.964017463079
    ],
    [
        112.8865292502,
        22.964083457713
    ],
    [
        112.88676475854,
        22.964146498205
    ],
    [
        112.88712599116,
        22.964234043367
    ],
    [
        112.88719115026,
        22.964254594624
    ],
    [
        112.88741475122,
        22.964306396186
    ],
    [
        112.88763510464,
        22.964354370298
    ],
    [
        112.88773297982,
        22.964371659242
    ],
    [
        112.88780353619,
        22.964408045781
    ],
    [
        112.88802277333,
        22.964517067834
    ],
    [
        112.88830120726,
        22.964653104415
    ],
    [
        112.88863451439,
        22.964801727796
    ],
    [
        112.88889265845,
        22.964931801128
    ],
    [
        112.88918972289,
        22.965075017338
    ],
    [
        112.88927513533,
        22.965121181979
    ],
    [
        112.88939406651,
        22.965178211209
    ],
    [
        112.8894781273,
        22.965221104515
    ],
    [
        112.8896592254,
        22.965304401825
    ],
    [
        112.88979626601,
        22.965362562345
    ],
    [
        112.8898768135,
        22.965397542041
    ],
    [
        112.89032765187,
        22.965598778476
    ],
    [
        112.89100440242,
        22.965942525141
    ],
    [
        112.89160624772,
        22.966278052159
    ],
    [
        112.89193459296,
        22.966457578811
    ],
    [
        112.8921199814,
        22.96655056666
    ],
    [
        112.89217187124,
        22.966570995013
    ],
    [
        112.89218755123,
        22.966568011926
    ],
    [
        112.89219944814,
        22.966562522139
    ],
    [
        112.89221080632,
        22.966553496919
    ],
    [
        112.89222491441,
        22.966457722564
    ],
    [
        112.89224457886,
        22.966075885489
    ],
    [
        112.89225853212,
        22.965749281506
    ],
    [
        112.89227981305,
        22.965352551914
    ],
    [
        112.89232758374,
        22.964942176252
    ],
    [
        112.89234526156,
        22.964708942043
    ],
    [
        112.89235131691,
        22.96446736817
    ],
    [
        112.89235602126,
        22.964217904187
    ],
    [
        112.89237934276,
        22.964043355771
    ],
    [
        112.89239051068,
        22.963839572597
    ],
    [
        112.89241570757,
        22.963698419712
    ],
    [
        112.89242003564,
        22.963690900032
    ],
    [
        112.89243841485,
        22.963696101998
    ],
    [
        112.89243571217,
        22.96369497002
    ],
    [
        112.89248435874,
        22.96371914327
    ],
    [
        112.89265867028,
        22.963816301167
    ],
    [
        112.89318105129,
        22.964116206797
    ],
    [
        112.89369235426,
        22.964376088402
    ],
    [
        112.8946438427,
        22.964895235321
    ],
    [
        112.89503837121,
        22.965114341739
    ],
    [
        112.89555179023,
        22.965403382671
    ],
    [
        112.89599359275,
        22.96565806987
    ],
    [
        112.89632677628,
        22.965829727298
    ],
    [
        112.89670831927,
        22.966042661171
    ],
    [
        112.89696016205,
        22.966175982187
    ],
    [
        112.89702150188,
        22.966207452523
    ],
    [
        112.89703744427,
        22.966216687103
    ],
    [
        112.89706231019,
        22.966218485674
    ],
    [
        112.89707393632,
        22.966211640229
    ],
    [
        112.89710881343,
        22.966193545018
    ],
    [
        112.89715233245,
        22.966189708025
    ],
    [
        112.89722477318,
        22.966185029147
    ],
    [
        112.89727099131,
        22.966188563499
    ],
    [
        112.89731396725,
        22.96618959895
    ],
    [
        112.89735694914,
        22.966179242306
    ],
    [
        112.89741401653,
        22.966110547874
    ],
    [
        112.8975511286,
        22.965967328227
    ],
    [
        112.8977074703,
        22.965745246316
    ],
    [
        112.89791980829,
        22.965425695351
    ],
    [
        112.89813240066,
        22.96513082806
    ],
    [
        112.89826870315,
        22.964972939226
    ],
    [
        112.89829195101,
        22.964967655072
    ],
    [
        112.89831168092,
        22.964971259595
    ],
    [
        112.8983446527,
        22.964980523555
    ],
    [
        112.89854219599,
        22.965073531766
    ],
    [
        112.89892025033,
        22.965269271272
    ],
    [
        112.89896402795,
        22.965292014784
    ],
    [
        112.89898265728,
        22.965336556231
    ],
    [
        112.89900778659,
        22.96535435924
    ],
    [
        112.89906020903,
        22.96538701951
    ],
    [
        112.89912615127,
        22.965409881803
    ],
    [
        112.89913263226,
        22.965422744484
    ],
    [
        112.89913046619,
        22.965430301102
    ],
    [
        112.89913613325,
        22.965449388017
    ],
    [
        112.89909961659,
        22.965502992767
    ],
    [
        112.8990857613,
        22.965645422083
    ],
    [
        112.89910841143,
        22.965756217136
    ],
    [
        112.89914731509,
        22.965795419395
    ],
    [
        112.89918730319,
        22.965828130745
    ],
    [
        112.89925703307,
        22.965843735045
    ],
    [
        112.89932054344,
        22.965864654042
    ],
    [
        112.89934162709,
        22.965864482691
    ],
    [
        112.89939138524,
        22.965819789667
    ],
    [
        112.89947662409,
        22.965632232984
    ],
    [
        112.89951426008,
        22.965502155626
    ],
    [
        112.89954538229,
        22.965425398343
    ],
    [
        112.89956837508,
        22.965390269494
    ],
    [
        112.89962327349,
        22.965334815181
    ],
    [
        112.8996803226,
        22.965303810034
    ],
    [
        112.89973655102,
        22.965293404473
    ],
    [
        112.89977979979,
        22.965293620549
    ],
    [
        112.89983412447,
        22.965307863877
    ],
    [
        112.89989465792,
        22.965339575059
    ],
    [
        112.89993545697,
        22.965375551231
    ],
    [
        112.89995409297,
        22.965407070489
    ],
    [
        112.89995001818,
        22.965448770577
    ],
    [
        112.89992404322,
        22.965501208118
    ],
    [
        112.89987049098,
        22.965565639558
    ],
    [
        112.89971989936,
        22.965629182356
    ],
    [
        112.89961581523,
        22.965663159315
    ],
    [
        112.89959039327,
        22.965690108303
    ],
    [
        112.89957821108,
        22.965727325752
    ],
    [
        112.89956952073,
        22.965808545748
    ],
    [
        112.89957003171,
        22.965867414252
    ],
    [
        112.89959269789,
        22.965945116364
    ],
    [
        112.89963238991,
        22.966028813401
    ],
    [
        112.89971722669,
        22.966104622676
    ],
    [
        112.89981745734,
        22.966206468564
    ],
    [
        112.89994929425,
        22.966345483717
    ],
    [
        112.89998225043,
        22.966385933031
    ],
    [
        112.90000871679,
        22.966430879682
    ],
    [
        112.90002002991,
        22.966505668792
    ],
    [
        112.90004374864,
        22.966633024218
    ],
    [
        112.90004072175,
        22.966731702665
    ],
    [
        112.9000792605,
        22.96694177376
    ],
    [
        112.90011213523,
        22.967126248749
    ],
    [
        112.90017205215,
        22.967288411692
    ],
    [
        112.9002281892,
        22.967441014439
    ],
    [
        112.90030513511,
        22.967600760428
    ],
    [
        112.90033560829,
        22.967723620236
    ],
    [
        112.90035259033,
        22.967804202713
    ],
    [
        112.90036496731,
        22.967900707805
    ],
    [
        112.9003843623,
        22.968013338113
    ],
    [
        112.90038891734,
        22.968080141815
    ],
    [
        112.90038536208,
        22.968148160305
    ],
    [
        112.90037587504,
        22.96819112158
    ],
    [
        112.90035559013,
        22.968210025741
    ],
    [
        112.90033936665,
        22.968217879948
    ],
    [
        112.90023151439,
        22.968214913112
    ],
    [
        112.90008609545,
        22.968202336637
    ],
    [
        112.89991473231,
        22.968182249985
    ],
    [
        112.89981284666,
        22.968149272495
    ],
    [
        112.8997106989,
        22.968103269351
    ],
    [
        112.89956938559,
        22.968010195061
    ],
    [
        112.89950373935,
        22.967947470604
    ],
    [
        112.89944646851,
        22.967891402479
    ],
    [
        112.89939136873,
        22.967820725232
    ],
    [
        112.89931278025,
        22.967702981143
    ],
    [
        112.89926039404,
        22.967613635138
    ],
    [
        112.89924637424,
        22.967552088407
    ],
    [
        112.89924017927,
        22.967514277181
    ],
    [
        112.89925919153,
        22.967356208852
    ],
    [
        112.89926629908,
        22.967216374859
    ],
    [
        112.89927609489,
        22.9671012708
    ],
    [
        112.89926564192,
        22.96694214048
    ],
    [
        112.89925384788,
        22.966761829602
    ],
    [
        112.89924658129,
        22.966703927498
    ],
    [
        112.89922362443,
        22.966669346845
    ],
    [
        112.89920201316,
        22.96664563943
    ],
    [
        112.89915769856,
        22.96661827693
    ],
    [
        112.89911418815,
        22.966603405402
    ],
    [
        112.89905607542,
        22.966599939407
    ],
    [
        112.89897633826,
        22.966597447579
    ],
    [
        112.89891200159,
        22.966607432726
    ],
    [
        112.89889740308,
        22.966611786041
    ],
    [
        112.89888334444,
        22.966617505066
    ],
    [
        112.89887982047,
        22.966636158407
    ],
    [
        112.89886818186,
        22.966665246796
    ],
    [
        112.89885219277,
        22.966741454078
    ],
    [
        112.89884592783,
        22.966829225123
    ],
    [
        112.89885588647,
        22.966906161847
    ],
    [
        112.89885071308,
        22.966974151578
    ],
    [
        112.89889198054,
        22.967131927915
    ],
    [
        112.89893408268,
        22.967246049145
    ],
    [
        112.89894724506,
        22.967390037972
    ],
    [
        112.89895773565,
        22.967478646853
    ],
    [
        112.89898334449,
        22.96759844361
    ],
    [
        112.8990175747,
        22.967765045167
    ],
    [
        112.89904290482,
        22.967896499746
    ],
    [
        112.89906633917,
        22.968032802936
    ],
    [
        112.89911573273,
        22.968150848307
    ],
    [
        112.89919214096,
        22.968293238151
    ],
    [
        112.89927343873,
        22.968395570218
    ],
    [
        112.89934556681,
        22.968464377885
    ],
    [
        112.89943798817,
        22.968500179706
    ],
    [
        112.89948123796,
        22.968498227872
    ],
    [
        112.89951178483,
        22.968494153847
    ],
    [
        112.89958235135,
        22.968466642796
    ],
    [
        112.89962722684,
        22.96845875139
    ],
    [
        112.89966155117,
        22.96846586369
    ],
    [
        112.89972099646,
        22.968501082685
    ],
    [
        112.89975151023,
        22.968550440456
    ],
    [
        112.89975121804,
        22.96858542476
    ],
    [
        112.89974904252,
        22.968606271759
    ],
    [
        112.89970846386,
        22.968658450822
    ],
    [
        112.89968166953,
        22.968712498967
    ],
    [
        112.89967839655,
        22.968758822796
    ],
    [
        112.89970675318,
        22.968798920816
    ],
    [
        112.89974673332,
        22.96883840889
    ],
    [
        112.89987021716,
        22.968910823627
    ],
    [
        112.89993129483,
        22.968929252515
    ],
    [
        112.89995156299,
        22.968936930744
    ],
    [
        112.89997940839,
        22.968931179777
    ],
    [
        112.90000292877,
        22.968925624232
    ],
    [
        112.90002374958,
        22.96891459666
    ],
    [
        112.90005729193,
        22.968876939235
    ],
    [
        112.900113279,
        22.96882502727
    ],
    [
        112.90012923398,
        22.968814456722
    ],
    [
        112.9001697836,
        22.968809469317
    ],
    [
        112.90020249231,
        22.968807599515
    ],
    [
        112.90022573063,
        22.968820753359
    ],
    [
        112.90023599679,
        22.968829612124
    ],
    [
        112.90023788308,
        22.968838867055
    ],
    [
        112.90024921594,
        22.968870528178
    ],
    [
        112.90024403081,
        22.968947468454
    ],
    [
        112.90024914035,
        22.968988514136
    ],
    [
        112.9002575061,
        22.96901008772
    ],
    [
        112.90027425627,
        22.96902421303
    ],
    [
        112.90036559057,
        22.969072187273
    ],
    [
        112.90040991002,
        22.969090318769
    ],
    [
        112.90042504331,
        22.969096820851
    ],
    [
        112.9004450478,
        22.969094728227
    ],
    [
        112.90044640585,
        22.969084716195
    ],
    [
        112.90044939258,
        22.969064154373
    ],
    [
        112.90046946415,
        22.968957908603
    ],
    [
        112.90048060793,
        22.968862627872
    ],
    [
        112.90048957734,
        22.968785481964
    ],
    [
        112.90050446554,
        22.968752379186
    ],
    [
        112.90054071955,
        22.968701746618
    ],
    [
        112.90058074608,
        22.968669894649
    ],
    [
        112.90061536247,
        22.968644186722
    ],
    [
        112.9006707856,
        22.96863050323
    ],
    [
        112.90072188044,
        22.968622168675
    ],
    [
        112.90077918391,
        22.968627774344
    ],
    [
        112.90084106905,
        22.968655428866
    ],
    [
        112.90092538261,
        22.968695947947
    ],
    [
        112.90105428883,
        22.968752697258
    ],
    [
        112.90114184839,
        22.968790827334
    ],
    [
        112.90122697382,
        22.96883135479
    ],
    [
        112.90131939884,
        22.968870921424
    ],
    [
        112.90136507967,
        22.968876861836
    ],
    [
        112.90137643106,
        22.968880312133
    ],
    [
        112.90138995367,
        22.968870238017
    ],
    [
        112.9014513752,
        22.968779074966
    ],
    [
        112.90151606056,
        22.968655961225
    ],
    [
        112.9015958829,
        22.968534191158
    ],
    [
        112.90165025243,
        22.968479791942
    ],
    [
        112.90168837829,
        22.968464171542
    ],
    [
        112.90171784507,
        22.968462506687
    ],
    [
        112.90173190148,
        22.968463561232
    ],
    [
        112.90174433191,
        22.968471097543
    ],
    [
        112.90174405452,
        22.968482484708
    ],
    [
        112.90175268505,
        22.968514638381
    ],
    [
        112.90177291601,
        22.96858469245
    ],
    [
        112.9017801902,
        22.96862414618
    ],
    [
        112.90178636458,
        22.968692874509
    ],
    [
        112.90175141897,
        22.968808636188
    ],
    [
        112.90171782257,
        22.968927404157
    ],
    [
        112.90172426864,
        22.96899261102
    ],
    [
        112.90173587397,
        22.969021831984
    ],
    [
        112.90178667758,
        22.969050096682
    ],
    [
        112.90187423615,
        22.969093907131
    ],
    [
        112.90207395855,
        22.96917543174
    ],
    [
        112.90220719993,
        22.969226793497
    ],
    [
        112.9024137021,
        22.96928074887
    ],
    [
        112.90261291122,
        22.969328872941
    ],
    [
        112.90279887106,
        22.969384085588
    ],
    [
        112.90280752217,
        22.969383959976
    ],
    [
        112.90281780249,
        22.969373012393
    ],
    [
        112.90282674463,
        22.969341428461
    ],
    [
        112.90284088541,
        22.969214728674
    ],
    [
        112.90285202967,
        22.969122153884
    ],
    [
        112.90287856357,
        22.969060216027
    ],
    [
        112.90292078285,
        22.968989861908
    ],
    [
        112.90295811745,
        22.968948176131
    ],
    [
        112.90299247082,
        22.968918103012
    ],
    [
        112.90302464936,
        22.968906979518
    ],
    [
        112.9030933204,
        22.968903247774
    ],
    [
        112.90325443701,
        22.96892302897
    ],
    [
        112.90352611603,
        22.968966338028
    ],
    [
        112.90367532397,
        22.96901329378
    ],
    [
        112.90379912497,
        22.969051414286
    ],
    [
        112.90384857606,
        22.969090745492
    ],
    [
        112.90387722293,
        22.969108847984
    ],
    [
        112.90389181227,
        22.969124819985
    ],
    [
        112.90391396103,
        22.969157461709
    ],
    [
        112.90392503057,
        22.969181241373
    ],
    [
        112.90392556302,
        22.969193998162
    ],
    [
        112.90391960483,
        22.96920963167
    ],
    [
        112.90389008624,
        22.96928454867
    ],
    [
        112.90382648674,
        22.96938222941
    ],
    [
        112.90380292701,
        22.969440155961
    ],
    [
        112.90376691573,
        22.969520389052
    ],
    [
        112.9037555183,
        22.9695839407
    ],
    [
        112.90375277164,
        22.969648448925
    ],
    [
        112.90377271146,
        22.969748321008
    ],
    [
        112.90380941486,
        22.969846028483
    ],
    [
        112.90385961329,
        22.969977319569
    ],
    [
        112.90390928835,
        22.970082562682
    ],
    [
        112.9039708924,
        22.970139721658
    ],
    [
        112.90402333321,
        22.970154687703
    ],
    [
        112.90413713731,
        22.970185034261
    ],
    [
        112.90421175674,
        22.970188968276
    ],
    [
        112.90428447333,
        22.970208329411
    ],
    [
        112.90431420217,
        22.970225902408
    ],
    [
        112.90432851546,
        22.970249733185
    ],
    [
        112.90438336215,
        22.97030623007
    ],
    [
        112.90445060748,
        22.970418258878
    ],
    [
        112.90450351693,
        22.970538461156
    ],
    [
        112.90455834573,
        22.970620449757
    ],
    [
        112.90458346279,
        22.970660185806
    ],
    [
        112.90459562489,
        22.970667163813
    ],
    [
        112.90461671978,
        22.970659640038
    ],
    [
        112.90473626001,
        22.970614380173
    ],
    [
        112.90489284835,
        22.97056293053
    ],
    [
        112.90505538458,
        22.970515092452
    ],
    [
        112.90514354398,
        22.970497517962
    ],
    [
        112.90516409537,
        22.970495134285
    ],
    [
        112.90523061161,
        22.97049538307
    ],
    [
        112.905264676,
        22.970502707274
    ],
    [
        112.90533740078,
        22.970518783541
    ],
    [
        112.9053590194,
        22.970537300029
    ],
    [
        112.90544551747,
        22.970578274108
    ],
    [
        112.90552875181,
        22.970646858941
    ],
    [
        112.90563711805,
        22.970737807416
    ],
    [
        112.90571522581,
        22.970792200534
    ],
    [
        112.90576847519,
        22.970820704357
    ],
    [
        112.90585146184,
        22.970859980595
    ],
    [
        112.90597256958,
        22.970909343401
    ],
    [
        112.90608530542,
        22.970945278827
    ],
    [
        112.90612314747,
        22.970967295671
    ],
    [
        112.90622234787,
        22.971025525427
    ],
    [
        112.90631208667,
        22.97108062062
    ],
    [
        112.90639533983,
        22.97113045852
    ],
    [
        112.90645050401,
        22.971132937327
    ],
    [
        112.90652216317,
        22.971137024751
    ],
    [
        112.90662411101,
        22.971140489677
    ],
    [
        112.90675526947,
        22.971139513982
    ],
    [
        112.9068282813,
        22.971145781491
    ],
    [
        112.90686587002,
        22.971147710228
    ],
    [
        112.90694156843,
        22.971179510286
    ],
    [
        112.90699455529,
        22.971204996269
    ],
    [
        112.90706888837,
        22.971256028244
    ],
    [
        112.90714781835,
        22.971308482975
    ],
    [
        112.90722645512,
        22.971392664083
    ],
    [
        112.90731536684,
        22.971479979742
    ],
    [
        112.90739129876,
        22.971565741039
    ],
    [
        112.90747018753,
        22.97167622536
    ],
    [
        112.90749285644,
        22.97174165855
    ],
    [
        112.90753363488,
        22.971821193875
    ],
    [
        112.90755871432,
        22.971917582222
    ],
    [
        112.90757650306,
        22.971998401756
    ],
    [
        112.90758507175,
        22.972111360255
    ],
    [
        112.90759960317,
        22.972207048609
    ],
    [
        112.90760679791,
        22.97234710925
    ],
    [
        112.907599981,
        22.972419154645
    ],
    [
        112.9075828782,
        22.97250216745
    ],
    [
        112.90756120751,
        22.972546597778
    ],
    [
        112.90753142736,
        22.972585753782
    ],
    [
        112.90744100833,
        22.97269940572
    ],
    [
        112.90735546064,
        22.972809329221
    ],
    [
        112.90731161819,
        22.972847728664
    ],
    [
        112.90721096012,
        22.972914836429
    ],
    [
        112.90708759057,
        22.972976171423
    ],
    [
        112.90704888389,
        22.973018982334
    ],
    [
        112.90701532331,
        22.973052106299
    ],
    [
        112.90697633405,
        22.973110371457
    ],
    [
        112.90695007333,
        22.973146046091
    ],
    [
        112.90694761084,
        22.973181810628
    ],
    [
        112.90693701711,
        22.973240234703
    ],
    [
        112.90693287263,
        22.973349747246
    ],
    [
        112.90695784759,
        22.973566836201
    ],
    [
        112.90696452408,
        22.973670545829
    ],
    [
        112.90696938723,
        22.973676315363
    ],
    [
        112.90698467362,
        22.973833315687
    ],
    [
        112.90699487314,
        22.973927043128
    ],
    [
        112.90700291138,
        22.974017754231
    ],
    [
        112.90700093071,
        22.974123502027
    ],
    [
        112.90698381153,
        22.97422169716
    ],
    [
        112.90697507026,
        22.974326257368
    ],
    [
        112.90695031431,
        22.974500550342
    ],
    [
        112.90691396062,
        22.974637237655
    ],
    [
        112.90689138852,
        22.974785796519
    ],
    [
        112.90687395467,
        22.974933619542
    ],
    [
        112.90685651413,
        22.975088494008
    ],
    [
        112.90684420826,
        22.975246701097
    ],
    [
        112.90683189059,
        22.975417655282
    ],
    [
        112.90681120754,
        22.975567055088
    ],
    [
        112.90680349587,
        22.975726416468
    ],
    [
        112.90679691495,
        22.975829380664
    ],
    [
        112.90680418591,
        22.975864208049
    ],
    [
        112.90682309772,
        22.975885109307
    ],
    [
        112.90699532784,
        22.975926783373
    ],
    [
        112.90728650896,
        22.976021493385
    ],
    [
        112.90754336665,
        22.976098563185
    ],
    [
        112.90769827316,
        22.97617029543
    ],
    [
        112.90782587003,
        22.976237002136
    ],
    [
        112.90787884554,
        22.976276024382
    ],
    [
        112.90790046768,
        22.976292615611
    ],
    [
        112.90794396799,
        22.976342074382
    ],
    [
        112.9079590873,
        22.976371859357
    ],
    [
        112.90795717416,
        22.976394071469
    ],
    [
        112.90794741596,
        22.976418067033
    ],
    [
        112.90792843024,
        22.976477457097
    ],
    [
        112.90787508208,
        22.976552072596
    ],
    [
        112.9078309543,
        22.976599429096
    ],
    [
        112.90773352237,
        22.97667339054
    ],
    [
        112.90765261043,
        22.976723724571
    ],
    [
        112.90755139601,
        22.976795179692
    ],
    [
        112.90744967168,
        22.976833532953
    ],
    [
        112.90731035613,
        22.976872131021
    ],
    [
        112.90722380374,
        22.976883306861
    ],
    [
        112.90714185447,
        22.976889123984
    ],
    [
        112.90706748448,
        22.976888000661
    ],
    [
        112.90700799208,
        22.976883574218
    ],
    [
        112.90691309074,
        22.976859622701
    ],
    [
        112.90685443787,
        22.976825099005
    ],
    [
        112.9067938901,
        22.976792985717
    ],
    [
        112.90673711979,
        22.976770692358
    ],
    [
        112.90669657014,
        22.976754341385
    ],
    [
        112.90664465546,
        22.976745952093
    ],
    [
        112.90655488291,
        22.976735895083
    ],
    [
        112.90648619821,
        22.976732397273
    ],
    [
        112.90637719791,
        22.976754583077
    ],
    [
        112.90631172643,
        22.97678747298
    ],
    [
        112.90621405717,
        22.976840745183
    ],
    [
        112.90612503396,
        22.976902826719
    ],
    [
        112.90606601938,
        22.976973509489
    ],
    [
        112.90605002938,
        22.977012587101
    ],
    [
        112.90603403268,
        22.977058987451
    ],
    [
        112.90602802915,
        22.977118562323
    ],
    [
        112.906025005,
        22.977172759269
    ],
    [
        112.90605361759,
        22.97722853488
    ],
    [
        112.90609629525,
        22.977280461003
    ],
    [
        112.90613547163,
        22.977317143444
    ],
    [
        112.90617332501,
        22.977322343027
    ],
    [
        112.90625417926,
        22.977322784915
    ],
    [
        112.9063539735,
        22.97731239673
    ],
    [
        112.90641890285,
        22.977281667012
    ],
    [
        112.90645570072,
        22.977259452098
    ],
    [
        112.90654770858,
        22.977190079977
    ],
    [
        112.90663838114,
        22.977103054024
    ],
    [
        112.90672145737,
        22.977043301302
    ],
    [
        112.9067961331,
        22.977002945036
    ],
    [
        112.90686511128,
        22.976983383371
    ],
    [
        112.90693217664,
        22.976986030463
    ],
    [
        112.90698869727,
        22.976986616967
    ],
    [
        112.9070186976,
        22.977006599504
    ],
    [
        112.9070597846,
        22.977028105437
    ],
    [
        112.90707409986,
        22.977047849829
    ],
    [
        112.90709623794,
        22.97708940999
    ],
    [
        112.90710621482,
        22.977121564752
    ],
    [
        112.90710158315,
        22.977158923251
    ],
    [
        112.90709371467,
        22.977187011326
    ],
    [
        112.90706446734,
        22.977230506936
    ],
    [
        112.90699514772,
        22.977325740646
    ],
    [
        112.90686064232,
        22.977433270418
    ],
    [
        112.9067713027,
        22.977538226768
    ],
    [
        112.90672986539,
        22.977604585133
    ],
    [
        112.90670846504,
        22.977643856026
    ],
    [
        112.90670056657,
        22.977704217273
    ],
    [
        112.90670052096,
        22.977753307403
    ],
    [
        112.9067115693,
        22.977795515521
    ],
    [
        112.90677774805,
        22.977877892677
    ],
    [
        112.90688631201,
        22.978038481694
    ],
    [
        112.90700840003,
        22.978197371279
    ],
    [
        112.90705404606,
        22.978259086741
    ],
    [
        112.90712731199,
        22.978283789935
    ],
    [
        112.90745663405,
        22.978369014055
    ],
    [
        112.90770079668,
        22.978429056991
    ],
    [
        112.90795281374,
        22.978484031
    ],
    [
        112.90819753058,
        22.978543475944
    ],
    [
        112.90866475955,
        22.978709143299
    ],
    [
        112.9088827177,
        22.978767571402
    ],
    [
        112.90911310672,
        22.978844318619
    ],
    [
        112.90940543088,
        22.978938981394
    ],
    [
        112.90960713264,
        22.979043471354
    ],
    [
        112.90973367057,
        22.979110297368
    ],
    [
        112.90985802903,
        22.979194984541
    ],
    [
        112.91002647326,
        22.979292191041
    ],
    [
        112.91009404351,
        22.979356837076
    ],
    [
        112.91013214774,
        22.979399116461
    ],
    [
        112.91021483212,
        22.979501659492
    ],
    [
        112.91027130711,
        22.97957103164
    ],
    [
        112.91033206949,
        22.979683311178
    ],
    [
        112.91036365438,
        22.979753704967
    ],
    [
        112.91044956801,
        22.979875806331
    ],
    [
        112.91053036738,
        22.9799717988
    ],
    [
        112.91056091626,
        22.979995254391
    ],
    [
        112.91069121558,
        22.980103280075
    ],
    [
        112.91076612274,
        22.980140058082
    ],
    [
        112.91098465165,
        22.980223711517
    ],
    [
        112.91130653059,
        22.9803219371
    ],
    [
        112.91143040708,
        22.98036988014
    ],
    [
        112.91148316152,
        22.980378408815
    ],
    [
        112.91149452679,
        22.980377466626
    ],
    [
        112.9115040108,
        22.980363482351
    ],
    [
        112.91152813045,
        22.9803247295
    ],
    [
        112.91154059138,
        22.980310239851
    ],
    [
        112.91156224616,
        22.980301831867
    ],
    [
        112.91156359401,
        22.98030700184
    ],
    [
        112.91157333646,
        22.98030549633
    ],
    [
        112.91162392116,
        22.980320230945
    ],
    [
        112.91163527283,
        22.980333390793
    ],
    [
        112.91172154342,
        22.980380840989
    ],
    [
        112.91181427476,
        22.98046335284
    ],
    [
        112.91194515696,
        22.980550123659
    ],
    [
        112.91204168463,
        22.980627243356
    ],
    [
        112.91216608939,
        22.980700625932
    ],
    [
        112.91227480109,
        22.98077380929
    ],
    [
        112.91239594822,
        22.980861507451
    ],
    [
        112.91260284565,
        22.980987637167
    ],
    [
        112.91280027865,
        22.981111999276
    ],
    [
        112.91301880248,
        22.981260714702
    ],
    [
        112.91318213796,
        22.981392767119
    ],
    [
        112.91336793084,
        22.981535088091
    ],
    [
        112.9134512219,
        22.981605182492
    ],
    [
        112.91345714021,
        22.98164132035
    ],
    [
        112.91347145414,
        22.981672127711
    ],
    [
        112.91347359442,
        22.98169710344
    ],
    [
        112.91352139532,
        22.981802325784
    ],
    [
        112.9135567525,
        22.981901170263
    ],
    [
        112.91356291777,
        22.981960906101
    ],
    [
        112.91355304789,
        22.982086640262
    ],
    [
        112.91353830904,
        22.982209336795
    ],
    [
        112.91352849672,
        22.98227757378
    ],
    [
        112.91346746947,
        22.982406262594
    ],
    [
        112.9134254398,
        22.982483902102
    ],
    [
        112.91334736843,
        22.982606427714
    ],
    [
        112.91326957338,
        22.982724070163
    ],
    [
        112.91316499527,
        22.982831910792
    ],
    [
        112.91301167937,
        22.982963864261
    ],
    [
        112.91285997946,
        22.983106668325
    ],
    [
        112.9126777041,
        22.983247470165
    ],
    [
        112.91252090967,
        22.983350580803
    ],
    [
        112.91244184754,
        22.983391951226
    ],
    [
        112.91231294723,
        22.983479098098
    ],
    [
        112.9121932621,
        22.983554140163
    ],
    [
        112.91207307778,
        22.983589840211
    ],
    [
        112.91196669214,
        22.983629225034
    ],
    [
        112.91193285803,
        22.983638574543
    ],
    [
        112.91183861997,
        22.983708474971
    ],
    [
        112.91178039071,
        22.983759558567
    ],
    [
        112.91173782097,
        22.983845006956
    ],
    [
        112.91171290999,
        22.983861513517
    ],
    [
        112.91164631854,
        22.983888078827
    ],
    [
        112.91162251289,
        22.983882358044
    ],
    [
        112.91157028565,
        22.983886859323
    ],
    [
        112.91145475335,
        22.983881342815
    ],
    [
        112.9113373042,
        22.98389993133
    ],
    [
        112.911242538,
        22.983964363391
    ],
    [
        112.91118913723,
        22.984060778379
    ],
    [
        112.91117121369,
        22.984125370068
    ],
    [
        112.91117166913,
        22.984209181186
    ],
    [
        112.91115967911,
        22.98429229102
    ],
    [
        112.91113902548,
        22.984380714341
    ],
    [
        112.91110215116,
        22.98445618268
    ],
    [
        112.91106040495,
        22.984533486128
    ],
    [
        112.91102433624,
        22.984615200873
    ],
    [
        112.91100825231,
        22.984732972327
    ],
    [
        112.91103686571,
        22.98479761801
    ],
    [
        112.91109580631,
        22.984839056252
    ],
    [
        112.91116014779,
        22.984891138558
    ],
    [
        112.91135029439,
        22.984954577537
    ],
    [
        112.91156050036,
        22.984987325218
    ],
    [
        112.91180402069,
        22.984994960837
    ],
    [
        112.91198639837,
        22.984998013821
    ],
    [
        112.91219775065,
        22.984986206289
    ],
    [
        112.91225864179,
        22.98498178705
    ],
    [
        112.9123022352,
        22.98495708793
    ],
    [
        112.91235694969,
        22.984907297663
    ],
    [
        112.91238705298,
        22.984843650922
    ],
    [
        112.9124589357,
        22.984677982038
    ],
    [
        112.91249658986,
        22.984640459346
    ],
    [
        112.9125363908,
        22.984620861222
    ],
    [
        112.91262925143,
        22.984583987534
    ],
    [
        112.91275266592,
        22.984574586629
    ],
    [
        112.91292182675,
        22.984558110889
    ],
    [
        112.91300817145,
        22.984546359927
    ],
    [
        112.91310942034,
        22.984517145219
    ],
    [
        112.91320528955,
        22.984456943638
    ],
    [
        112.91326622777,
        22.984415054223
    ],
    [
        112.91331956954,
        22.98439151901
    ],
    [
        112.91334826697,
        22.984383163633
    ],
    [
        112.91340266533,
        22.984385673669
    ],
    [
        112.91344163673,
        22.984388280174
    ],
    [
        112.91347329185,
        22.984399482716
    ],
    [
        112.91350303839,
        22.984424495169
    ],
    [
        112.91353574225,
        22.984469067293
    ],
    [
        112.9135935962,
        22.98453452987
    ],
    [
        112.91361816712,
        22.98459229934
    ],
    [
        112.91362785133,
        22.984650446257
    ],
    [
        112.91362589082,
        22.984714702291
    ],
    [
        112.9136123048,
        22.98476635384
    ],
    [
        112.91360847192,
        22.984808891999
    ],
    [
        112.91361793298,
        22.984820658919
    ],
    [
        112.91366202283,
        22.984847996244
    ],
    [
        112.91377583797,
        22.984979429853
    ],
    [
        112.91385800879,
        22.985089083813
    ],
    [
        112.91390557323,
        22.985160930113
    ],
    [
        112.91396823655,
        22.985290435307
    ],
    [
        112.91399684203,
        22.985374277976
    ],
    [
        112.91399896282,
        22.985417695051
    ],
    [
        112.91399784835,
        22.985448601403
    ],
    [
        112.91399566735,
        22.985463765851
    ],
    [
        112.9139880715,
        22.98548022794
    ],
    [
        112.91392547217,
        22.985551693797
    ],
    [
        112.91387939702,
        22.985610860676
    ],
    [
        112.91383629309,
        22.985676296307
    ],
    [
        112.91375579648,
        22.98578146078
    ],
    [
        112.91367344888,
        22.985845104381
    ],
    [
        112.91361656919,
        22.98588461582
    ],
    [
        112.91357619525,
        22.985928918756
    ],
    [
        112.91353392083,
        22.985979166065
    ],
    [
        112.91353768182,
        22.986006600498
    ],
    [
        112.91354416164,
        22.986022131743
    ],
    [
        112.91354415383,
        22.986029725643
    ],
    [
        112.91361041051,
        22.986083076161
    ],
    [
        112.91362150721,
        22.986083470166
    ],
    [
        112.91363666576,
        22.986082010475
    ],
    [
        112.91370194896,
        22.986030114844
    ],
    [
        112.91375663952,
        22.986014442655
    ],
    [
        112.91377666586,
        22.986017374182
    ],
    [
        112.91378180682,
        22.986019057736
    ],
    [
        112.91378288557,
        22.986022866534
    ],
    [
        112.91377989626,
        22.98603449601
    ],
    [
        112.91375225115,
        22.986070535792
    ],
    [
        112.9137411442,
        22.986079906434
    ],
    [
        112.9137080623,
        22.986138938818
    ],
    [
        112.91366281174,
        22.986187258882
    ],
    [
        112.91357909719,
        22.986265256065
    ],
    [
        112.91348373584,
        22.986352610672
    ],
    [
        112.91342305831,
        22.986402106623
    ],
    [
        112.9133114802,
        22.986470011318
    ],
    [
        112.91319125624,
        22.986525332891
    ],
    [
        112.91308836712,
        22.986569180428
    ],
    [
        112.91300094079,
        22.986579025495
    ],
    [
        112.9129275928,
        22.986584688531
    ],
    [
        112.91288400718,
        22.986598015854
    ],
    [
        112.91285855695,
        22.986608569153
    ],
    [
        112.91285231019,
        22.986630193728
    ],
    [
        112.91285146902,
        22.986658661423
    ],
    [
        112.91285143862,
        22.986688223391
    ],
    [
        112.91287897214,
        22.986757160066
    ],
    [
        112.91293891785,
        22.986888307822
    ],
    [
        112.91296323147,
        22.986930626675
    ],
    [
        112.91295753761,
        22.98694086711
    ],
    [
        112.91295780099,
        22.986947921712
    ],
    [
        112.91287977193,
        22.987032180302
    ],
    [
        112.91272647899,
        22.987145931721
    ],
    [
        112.9125365816,
        22.98733191921
    ],
    [
        112.91231745795,
        22.98752322703
    ],
    [
        112.91213326075,
        22.987702991889
    ],
    [
        112.91199296162,
        22.987827671328
    ],
    [
        112.9118873367,
        22.987917777046
    ],
    [
        112.91179825973,
        22.987968482269
    ],
    [
        112.91159280155,
        22.988048923942
    ],
    [
        112.91152756065,
        22.988078755576
    ],
    [
        112.91150887942,
        22.988089641307
    ],
    [
        112.91151265806,
        22.98809890996
    ],
    [
        112.91150963508,
        22.988144436098
    ],
    [
        112.91151529167,
        22.988169458722
    ],
    [
        112.91154824945,
        22.988221402106
    ],
    [
        112.91155553066,
        22.988245360043
    ],
    [
        112.91158277624,
        22.988326793613
    ],
    [
        112.91159434769,
        22.988389046171
    ],
    [
        112.9115929305,
        22.988451950255
    ],
    [
        112.91158615021,
        22.988467324856
    ],
    [
        112.9115747648,
        22.988487794985
    ],
    [
        112.91156528234,
        22.988499609947
    ],
    [
        112.91154634044,
        22.988500729172
    ],
    [
        112.91152632431,
        22.988493969483
    ],
    [
        112.91146140423,
        22.988475254895
    ],
    [
        112.9114154085,
        22.988472777685
    ],
    [
        112.91136644092,
        22.988466193329
    ],
    [
        112.91133938212,
        22.988467478642
    ],
    [
        112.91132558606,
        22.988464320739
    ],
    [
        112.91130177368,
        22.988466188897
    ],
    [
        112.91127983708,
        22.988485980643
    ],
    [
        112.91126683733,
        22.988498020327
    ],
    [
        112.91124923877,
        22.988509187831
    ],
    [
        112.91124026685,
        22.988551383287
    ],
    [
        112.91125160936,
        22.988572410958
    ],
    [
        112.91128184437,
        22.988640056013
    ],
    [
        112.91134426885,
        22.988716515462
    ],
    [
        112.91137155343,
        22.988759169683
    ],
    [
        112.91141180879,
        22.988818530988
    ],
    [
        112.91142153148,
        22.988836282409
    ],
    [
        112.91141339796,
        22.988852181631
    ],
    [
        112.91140040022,
        22.988862052773
    ],
    [
        112.91136305514,
        22.988867548242
    ],
    [
        112.91130001688,
        22.988862140033
    ],
    [
        112.91119124734,
        22.988862113829
    ],
    [
        112.91111846831,
        22.988858472469
    ],
    [
        112.91106731744,
        22.988872191718
    ],
    [
        112.91097448873,
        22.988897306287
    ],
    [
        112.91087324194,
        22.988953767236
    ],
    [
        112.91075060316,
        22.98902947055
    ],
    [
        112.91066530701,
        22.989100500179
    ],
    [
        112.91058703744,
        22.989180025162
    ],
    [
        112.91050579716,
        22.989255167697
    ],
    [
        112.91046354104,
        22.989305598522
    ],
    [
        112.91045588501,
        22.989385234608
    ],
    [
        112.91045936215,
        22.98942460674
    ],
    [
        112.91046690894,
        22.989452641585
    ],
    [
        112.91050259393,
        22.989479149124
    ],
    [
        112.91057535505,
        22.989494752391
    ],
    [
        112.91061429148,
        22.989516960694
    ],
    [
        112.91073409861,
        22.989563277798
    ],
    [
        112.91084576767,
        22.989632533549
    ],
    [
        112.91087685996,
        22.989654091184
    ],
    [
        112.91089684808,
        22.989686895656
    ],
    [
        112.91091141939,
        22.989725325391
    ],
    [
        112.9109057284,
        22.989734473143
    ],
    [
        112.91090163662,
        22.989767508492
    ],
    [
        112.91088564536,
        22.989795508012
    ],
    [
        112.91085774923,
        22.989823895572
    ],
    [
        112.91078762298,
        22.989875601
    ],
    [
        112.91069801928,
        22.989925692954
    ],
    [
        112.91057893331,
        22.989969426074
    ],
    [
        112.91050342728,
        22.98999284181
    ],
    [
        112.91044875131,
        22.990018699156
    ],
    [
        112.91042166651,
        22.990048988266
    ],
    [
        112.91039727927,
        22.990087177914
    ],
    [
        112.91040158247,
        22.990112457964
    ],
    [
        112.91040292041,
        22.990127121324
    ],
    [
        112.91045672542,
        22.990159836571
    ],
    [
        112.91048024795,
        22.990174521617
    ],
    [
        112.91053404341,
        22.990217269104
    ],
    [
        112.91058213765,
        22.990280009852
    ],
    [
        112.91064618464,
        22.990352721861
    ],
    [
        112.91065941446,
        22.99037974537
    ],
    [
        112.91065695013,
        22.990409004406
    ],
    [
        112.91063989372,
        22.990420714592
    ],
    [
        112.91060416729,
        22.990434620698
    ],
    [
        112.91058360182,
        22.990438418982
    ],
    [
        112.91054383411,
        22.990435726496
    ],
    [
        112.91041700856,
        22.990376283755
    ],
    [
        112.91033560034,
        22.990351879502
    ],
    [
        112.91028988104,
        22.99035018646
    ],
    [
        112.91026037981,
        22.990362811683
    ],
    [
        112.9102295135,
        22.990387894059
    ],
    [
        112.91022083333,
        22.990410831452
    ],
    [
        112.91022190811,
        22.990418168634
    ],
    [
        112.91022756478,
        22.990442653602
    ],
    [
        112.91025352719,
        22.990451679028
    ],
    [
        112.91036410517,
        22.990523666332
    ],
    [
        112.91044577747,
        22.99055485302
    ],
    [
        112.91053584859,
        22.990575026262
    ],
    [
        112.91062891332,
        22.99057868947
    ],
    [
        112.9106881753,
        22.990567260228
    ],
    [
        112.91077154225,
        22.990530648362
    ],
    [
        112.91091851797,
        22.990467462387
    ],
    [
        112.91103518616,
        22.990411467597
    ],
    [
        112.91108229698,
        22.99037898369
    ],
    [
        112.9111083238,
        22.990326701168
    ],
    [
        112.9111297599,
        22.990265680643
    ],
    [
        112.91115586914,
        22.99013176256
    ],
    [
        112.91118597945,
        22.990055121504
    ],
    [
        112.9112356066,
        22.98994319894
    ],
    [
        112.91131172673,
        22.989854663834
    ],
    [
        112.91136507414,
        22.989810859224
    ],
    [
        112.91139376276,
        22.98980335603
    ],
    [
        112.91141892443,
        22.989805300411
    ],
    [
        112.91145950541,
        22.989810964021
    ],
    [
        112.91149492345,
        22.989838530215
    ],
    [
        112.91154167418,
        22.989897698374
    ],
    [
        112.9115662191,
        22.989975030396
    ],
    [
        112.91160836228,
        22.990042275365
    ],
    [
        112.91169049331,
        22.990168327335
    ],
    [
        112.91176966397,
        22.990279421377
    ],
    [
        112.91189622383,
        22.990356378079
    ],
    [
        112.91196383629,
        22.990392735633
    ],
    [
        112.91206474454,
        22.990417833066
    ],
    [
        112.91222762847,
        22.990437433606
    ],
    [
        112.91235776884,
        22.990460150507
    ],
    [
        112.91246004416,
        22.990476829191
    ],
    [
        112.91249442293,
        22.99046638884
    ],
    [
        112.91255450983,
        22.990456794237
    ],
    [
        112.91261705377,
        22.990426342479
    ],
    [
        112.91267636118,
        22.990385543828
    ],
    [
        112.91277009153,
        22.990292257901
    ],
    [
        112.91287140192,
        22.990197968888
    ],
    [
        112.91294263029,
        22.990146448747
    ],
    [
        112.91295482101,
        22.9901343848
    ],
    [
        112.91296889333,
        22.990135089548
    ],
    [
        112.91298567419,
        22.990133655634
    ],
    [
        112.91300731639,
        22.990142312398
    ],
    [
        112.91306330148,
        22.990179026824
    ],
    [
        112.91313549096,
        22.990250097097
    ],
    [
        112.91313817197,
        22.990275350685
    ],
    [
        112.91314111381,
        22.990310370986
    ],
    [
        112.91314565251,
        22.990372259788
    ],
    [
        112.91313909668,
        22.990432394773
    ],
    [
        112.91312200288,
        22.990475594092
    ],
    [
        112.91307890649,
        22.9905399217
    ],
    [
        112.91304689694,
        22.990613867778
    ],
    [
        112.91296965141,
        22.990727703447
    ],
    [
        112.91285905485,
        22.990905968699
    ],
    [
        112.91276693451,
        22.991012569033
    ],
    [
        112.91269894297,
        22.991077136771
    ],
    [
        112.91265454925,
        22.99108854928
    ],
    [
        112.9126044839,
        22.991088773729
    ],
    [
        112.91247568704,
        22.991070976977
    ],
    [
        112.91235393429,
        22.991047286201
    ],
    [
        112.91222948354,
        22.991017585921
    ],
    [
        112.91214099743,
        22.991015703643
    ],
    [
        112.91198730473,
        22.991007054398
    ],
    [
        112.91186960589,
        22.990996662234
    ],
    [
        112.91168534077,
        22.99098977517
    ],
    [
        112.91164909267,
        22.990979289697
    ],
    [
        112.91157493783,
        22.990994095887
    ],
    [
        112.91150103836,
        22.991024903354
    ],
    [
        112.9114206475,
        22.991053998184
    ],
    [
        112.91134755861,
        22.99108752052
    ],
    [
        112.91130125598,
        22.991122192622
    ],
    [
        112.91124165943,
        22.991193308581
    ],
    [
        112.91117988328,
        22.991280124979
    ],
    [
        112.9111191771,
        22.991379970976
    ],
    [
        112.91103408862,
        22.991512318799
    ],
    [
        112.9109589678,
        22.991689541251
    ],
    [
        112.91089352949,
        22.991926553097
    ],
    [
        112.9108746443,
        22.992147350338
    ],
    [
        112.91087341933,
        22.992293249157
    ],
    [
        112.91086958336,
        22.992342560974
    ],
    [
        112.91085494565,
        22.992370849135
    ],
    [
        112.9107572317,
        22.992415415479
    ],
    [
        112.91066274048,
        22.992485783539
    ],
    [
        112.9106337532,
        22.992525272999
    ],
    [
        112.91063509115,
        22.992540478688
    ],
    [
        112.91064886791,
        22.992562356466
    ],
    [
        112.91073161549,
        22.992604662499
    ],
    [
        112.91085304515,
        22.992655602497
    ],
    [
        112.9110209984,
        22.992722048619
    ],
    [
        112.91115948171,
        22.992769657908
    ],
    [
        112.91123684989,
        22.992784746632
    ],
    [
        112.91125469474,
        22.992797991794
    ],
    [
        112.9112760628,
        22.992805314666
    ],
    [
        112.9112776555,
        22.992837067299
    ],
    [
        112.91129062234,
        22.992858386679
    ],
    [
        112.9112897907,
        22.992878988658
    ],
    [
        112.91127760434,
        22.992889954039
    ],
    [
        112.91121695447,
        22.992933391946
    ],
    [
        112.91109186059,
        22.993028348532
    ],
    [
        112.91099573668,
        22.993104954046
    ],
    [
        112.91094861108,
        22.993154793406
    ],
    [
        112.91093940172,
        22.993165523301
    ],
    [
        112.91094506646,
        22.993183225544
    ],
    [
        112.91095585278,
        22.993220792708
    ],
    [
        112.91096691751,
        22.993250226856
    ],
    [
        112.91102533216,
        22.993278100301
    ],
    [
        112.91112592148,
        22.993341498362
    ],
    [
        112.91122734105,
        22.993387000026
    ],
    [
        112.91134444865,
        22.9934394738
    ],
    [
        112.91135741326,
        22.993463504803
    ],
    [
        112.91136606066,
        22.993475005167
    ],
    [
        112.91136545477,
        22.993542802016
    ],
    [
        112.91138945736,
        22.993625283974
    ],
    [
        112.91140507857,
        22.993701150753
    ],
    [
        112.91144963337,
        22.99379636667
    ],
    [
        112.91148988896,
        22.993860337267
    ],
    [
        112.91152018535,
        22.993869395993
    ],
    [
        112.91155778287,
        22.993883427316
    ],
    [
        112.91157943872,
        22.993873662759
    ],
    [
        112.91161082603,
        22.993874054291
    ],
    [
        112.91161922844,
        22.993858970766
    ],
    [
        112.91164252957,
        22.993826443459
    ],
    [
        112.91167179187,
        22.993785310879
    ],
    [
        112.91167749266,
        22.993765853978
    ],
    [
        112.9116792108,
        22.993666338251
    ],
    [
        112.91167124381,
        22.993508390404
    ],
    [
        112.91163864134,
        22.993363697099
    ],
    [
        112.91162007525,
        22.99325497882
    ],
    [
        112.91161366965,
        22.993162956223
    ],
    [
        112.91161803809,
        22.993122328019
    ],
    [
        112.91163510953,
        22.993096774955
    ],
    [
        112.91165812886,
        22.993076448791
    ],
    [
        112.91167842886,
        22.993070191816
    ],
    [
        112.91169222339,
        22.993075787418
    ],
    [
        112.91170628567,
        22.993084369605
    ],
    [
        112.91175873795,
        22.99312787148
    ],
    [
        112.91178954728,
        22.993167307451
    ],
    [
        112.91182221388,
        22.993245278578
    ],
    [
        112.91185757209,
        22.993338470302
    ],
    [
        112.91190024128,
        22.993426869008
    ],
    [
        112.91192448234,
        22.993544603573
    ],
    [
        112.91195655599,
        22.99367816426
    ],
    [
        112.91198109134,
        22.993771763182
    ],
    [
        112.91200724359,
        22.99387270434
    ],
    [
        112.91203851979,
        22.993992421533
    ],
    [
        112.91202872682,
        22.994046817171
    ],
    [
        112.91200865922,
        22.994092679715
    ],
    [
        112.9119631326,
        22.994162911832
    ],
    [
        112.91193737391,
        22.99421819649
    ],
    [
        112.9119086017,
        22.994313041697
    ],
    [
        112.91191094502,
        22.994411251647
    ],
    [
        112.91191598358,
        22.994521157092
    ],
    [
        112.91192893582,
        22.994560100128
    ],
    [
        112.9119475951,
        22.99457280465
    ],
    [
        112.91198791235,
        22.994574653543
    ],
    [
        112.9120198459,
        22.994571517235
    ],
    [
        112.91205177832,
        22.994569736313
    ],
    [
        112.91208207237,
        22.994583936723
    ],
    [
        112.91209100111,
        22.994585130013
    ],
    [
        112.91210939047,
        22.994597557983
    ],
    [
        112.91213072213,
        22.99464690716
    ],
    [
        112.91216120344,
        22.994751152969
    ],
    [
        112.91219759572,
        22.994901576813
    ],
    [
        112.91226375273,
        22.995055070118
    ],
    [
        112.91233961125,
        22.995253970345
    ],
    [
        112.912404963,
        22.995403108262
    ],
    [
        112.91251819288,
        22.995576678526
    ],
    [
        112.91257196595,
        22.995664918516
    ],
    [
        112.91260382148,
        22.995750728656
    ],
    [
        112.91262057114,
        22.995782658718
    ],
    [
        112.91261270067,
        22.995807518331
    ],
    [
        112.91260889218,
        22.995829442333
    ],
    [
        112.91257529768,
        22.995871085385
    ],
    [
        112.91256148889,
        22.995879058946
    ],
    [
        112.91255011861,
        22.995883806555
    ],
    [
        112.91252711432,
        22.995885704202
    ],
    [
        112.91246273752,
        22.995852394256
    ],
    [
        112.91240213641,
        22.995834043587
    ],
    [
        112.91232963643,
        22.995807411323
    ],
    [
        112.91228390975,
        22.995800353767
    ],
    [
        112.9122406122,
        22.995800646961
    ],
    [
        112.91220921237,
        22.995811117527
    ],
    [
        112.91219892188,
        22.995819401254
    ],
    [
        112.9121883515,
        22.995837987912
    ],
    [
        112.9121820922,
        22.995877239332
    ],
    [
        112.9121682261,
        22.995949758973
    ],
    [
        112.91214787694,
        22.996009723926
    ],
    [
        112.91210398284,
        22.996072657873
    ],
    [
        112.91208041866,
        22.996097052976
    ],
    [
        112.91205849101,
        22.996107092892
    ],
    [
        112.91204090268,
        22.996106336465
    ],
    [
        112.912032786,
        22.996104881539
    ],
    [
        112.91197787211,
        22.996085226312
    ],
    [
        112.91191836635,
        22.996056833697
    ],
    [
        112.91185588997,
        22.996022435293
    ],
    [
        112.91178123114,
        22.995995206839
    ],
    [
        112.91171170081,
        22.995982955358
    ],
    [
        112.91161753239,
        22.995988023256
    ],
    [
        112.91152011215,
        22.99599982504
    ],
    [
        112.91144460438,
        22.996017863047
    ],
    [
        112.91130412466,
        22.99607494527
    ],
    [
        112.91129247002,
        22.996097308966
    ],
    [
        112.91127919807,
        22.996112871538
    ],
    [
        112.91124662724,
        22.996227455937
    ],
    [
        112.91118745366,
        22.996440696847
    ],
    [
        112.91115374129,
        22.996624155276
    ],
    [
        112.91108884823,
        22.996883970069
    ],
    [
        112.91102911333,
        22.997126490525
    ],
    [
        112.91095336979,
        22.997424674652
    ],
    [
        112.91089334094,
        22.997700547347
    ],
    [
        112.91083362626,
        22.997927873175
    ],
    [
        112.91080381419,
        22.997988511636
    ],
    [
        112.91077266346,
        22.99803258747
    ],
    [
        112.91065056,
        22.998133788323
    ],
    [
        112.9104886858,
        22.998238524171
    ],
    [
        112.91039336323,
        22.998349008733
    ],
    [
        112.91031239374,
        22.998443676373
    ],
    [
        112.91026009603,
        22.998545774316
    ],
    [
        112.91024948359,
        22.99862076216
    ],
    [
        112.91026186397,
        22.998699311314
    ],
    [
        112.9102658629,
        22.998771781776
    ],
    [
        112.91028846307,
        22.99892559645
    ],
    [
        112.91031505938,
        22.999157577173
    ],
    [
        112.91037866217,
        22.999464364853
    ],
    [
        112.9104042183,
        22.999648595155
    ],
    [
        112.91042900128,
        22.999785079059
    ],
    [
        112.91046220118,
        22.999883702027
    ],
    [
        112.91054212832,
        23.00008275143
    ],
    [
        112.91064773431,
        23.000315223142
    ],
    [
        112.91074634454,
        23.000500945739
    ],
    [
        112.91080631763,
        23.00062025254
    ],
    [
        112.91082138938,
        23.000726227387
    ],
    [
        112.91082349741,
        23.000801927603
    ],
    [
        112.91081345594,
        23.000843566556
    ],
    [
        112.91077470059,
        23.000932839843
    ],
    [
        112.91072459205,
        23.001009216474
    ],
    [
        112.9106887913,
        23.001129175214
    ],
    [
        112.91069325027,
        23.001322077842
    ],
    [
        112.91073752339,
        23.001456914224
    ],
    [
        112.91077180917,
        23.001560699331
    ],
    [
        112.91078580318,
        23.001665576291
    ],
    [
        112.91077900686,
        23.001711325928
    ],
    [
        112.9107419186,
        23.001743119713
    ],
    [
        112.91070863991,
        23.001744313252
    ],
    [
        112.91063640936,
        23.001735503483
    ],
    [
        112.91055661542,
        23.00171085963
    ],
    [
        112.91049844865,
        23.001710365274
    ],
    [
        112.91044568656,
        23.001719162063
    ],
    [
        112.91040399558,
        23.00175821035
    ],
    [
        112.91040289618,
        23.001782606579
    ],
    [
        112.91042073027,
        23.001813220476
    ],
    [
        112.91053295152,
        23.001890103335
    ],
    [
        112.91066547623,
        23.001952054942
    ],
    [
        112.91071850059,
        23.001957087026
    ],
    [
        112.91080373818,
        23.001937853951
    ],
    [
        112.91094256239,
        23.001897067343
    ],
    [
        112.91102185631,
        23.001869066289
    ],
    [
        112.91107922775,
        23.001851900992
    ],
    [
        112.91109167226,
        23.001853958963
    ],
    [
        112.91110627861,
        23.001859841723
    ],
    [
        112.91112331378,
        23.001874706013
    ],
    [
        112.91114112624,
        23.001938672873
    ],
    [
        112.91114080146,
        23.002016240865
    ],
    [
        112.91116755219,
        23.002067031252
    ],
    [
        112.91124487316,
        23.002155894281
    ],
    [
        112.91127620719,
        23.002231423111
    ],
    [
        112.91128938517,
        23.002347948631
    ],
    [
        112.91129714091,
        23.002481221867
    ],
    [
        112.91131710522,
        23.00256691281
    ],
    [
        112.91135597075,
        23.002711157374
    ],
    [
        112.91142296005,
        23.002881251168
    ],
    [
        112.91144427056,
        23.002979705598
    ],
    [
        112.91144968027,
        23.002982485919
    ],
    [
        112.91145183934,
        23.002990921281
    ],
    [
        112.91144317166,
        23.003004916485
    ],
    [
        112.91144560701,
        23.003004675862
    ],
    [
        112.91146509574,
        23.002993800116
    ],
    [
        112.91147700571,
        23.00298689754
    ],
    [
        112.91150110113,
        23.002965772263
    ],
    [
        112.91152356637,
        23.002954933062
    ],
    [
        112.91155063367,
        23.002940896257
    ],
    [
        112.91157255792,
        23.002930049566
    ],
    [
        112.91161748446,
        23.002915149481
    ],
    [
        112.91163426159,
        23.002913730937
    ],
    [
        112.911682433,
        23.002902666542
    ],
    [
        112.91195982752,
        23.002843971019
    ],
    [
        112.9122447922,
        23.002811623937
    ],
    [
        112.91273273111,
        23.002784049083
    ],
    [
        112.91289647347,
        23.002765882386
    ],
    [
        112.91328809299,
        23.002759239416
    ],
    [
        112.91381123066,
        23.00282390508
    ],
    [
        112.91419285179,
        23.002871412145
    ],
    [
        112.91476696824,
        23.002914276668
    ],
    [
        112.91506445932,
        23.002949280275
    ],
    [
        112.91520739022,
        23.002965614244
    ],
    [
        112.91525801083,
        23.002973706508
    ],
    [
        112.91526531758,
        23.002978117913
    ],
    [
        112.91589686129,
        23.003126281314
    ],
    [
        112.91591553767,
        23.003135134512
    ],
    [
        112.91592501321,
        23.00313657872
    ],
    [
        112.91594666621,
        23.003148171427
    ],
    [
        112.91595424846,
        23.003146614299
    ],
    [
        112.91605413382,
        23.0031852371
    ],
    [
        112.91610475094,
        23.00320929826
    ],
    [
        112.91618487971,
        23.003237151721
    ],
    [
        112.91627258216,
        23.003278901184
    ],
    [
        112.91639358462,
        23.003331248549
    ],
    [
        112.91644447092,
        23.003362350367
    ],
    [
        112.91652405996,
        23.003394516898
    ],
    [
        112.91657034847,
        23.003418792205
    ],
    [
        112.91664750111,
        23.003452556809
    ],
    [
        112.91671571852,
        23.003486510547
    ],
    [
        112.91680261494,
        23.003530927777
    ],
    [
        112.91682456925,
        23.003499924068
    ],
    [
        112.91686904601,
        23.003397235324
    ],
    [
        112.91687474517,
        23.00337802633
    ],
    [
        112.91693573916,
        23.003279273154
    ],
    [
        112.91698019468,
        23.003211840653
    ],
    [
        112.91704623692,
        23.003264472607
    ],
    [
        112.91712690788,
        23.003310713096
    ],
    [
        112.91715884516,
        23.00333918643
    ],
    [
        112.91721190339,
        23.003371901714
    ],
    [
        112.91728336904,
        23.003418055897
    ],
    [
        112.91735132231,
        23.003452785517
    ],
    [
        112.91743443222,
        23.003503636325
    ],
    [
        112.91749860028,
        23.003531275067
    ],
    [
        112.91753488085,
        23.003547567731
    ],
    [
        112.91757738485,
        23.003573130668
    ],
    [
        112.91760228724,
        23.003595298047
    ],
    [
        112.91764452095,
        23.00362085647
    ],
    [
        112.91767700615,
        23.003644438223
    ],
    [
        112.91773710382,
        23.003688848726
    ],
    [
        112.91778665108,
        23.003714730438
    ],
    [
        112.91779882654,
        23.003734353753
    ],
    [
        112.91784485735,
        23.003753967398
    ],
    [
        112.91788059835,
        23.003770516655
    ],
    [
        112.91791471673,
        23.003783526373
    ],
    [
        112.91795098915,
        23.003817165334
    ],
    [
        112.91797615911,
        23.003847464005
    ],
    [
        112.91806826021,
        23.003828903203
    ],
    [
        112.91808155852,
        23.003786690705
    ],
    [
        112.91810948596,
        23.00373997679
    ],
    [
        112.91814635255,
        23.003692244029
    ],
    [
        112.91815693895,
        23.00365597764
    ],
    [
        112.91817213171,
        23.003617033107
    ],
    [
        112.91818813249,
        23.003585417699
    ],
    [
        112.91821171913,
        23.003551145951
    ],
    [
        112.91824721146,
        23.003536219188
    ],
    [
        112.91827456463,
        23.003542387753
    ],
    [
        112.91832980445,
        23.00356828855
    ],
    [
        112.91836149032,
        23.003576927841
    ],
    [
        112.91837882629,
        23.003576240192
    ],
    [
        112.91838125839,
        23.003585208563
    ],
    [
        112.9184329942,
        23.003585583111
    ],
    [
        112.91848337784,
        23.003583233342
    ],
    [
        112.91852454876,
        23.003586240341
    ],
    [
        112.91858306,
        23.003583130583
    ],
    [
        112.91864075972,
        23.003579198485
    ],
    [
        112.91866973989,
        23.003585640519
    ],
    [
        112.91868977403,
        23.003603139838
    ],
    [
        112.91873146303,
        23.003645743276
    ],
    [
        112.91875312051,
        23.003666778853
    ],
    [
        112.91880402657,
        23.00369940803
    ],
    [
        112.91885818364,
        23.003732328506
    ],
    [
        112.9188738814,
        23.003754405923
    ],
    [
        112.91891124473,
        23.003785852781
    ],
    [
        112.91894753091,
        23.003807526721
    ],
    [
        112.91900033398,
        23.00384205882
    ],
    [
        112.91903796967,
        23.003872689745
    ],
    [
        112.91905530259,
        23.003880129039
    ],
    [
        112.91909538948,
        23.003890431925
    ],
    [
        112.91917286116,
        23.003901251317
    ],
    [
        112.91922866317,
        23.003908940564
    ],
    [
        112.91925412409,
        23.003916158717
    ],
    [
        112.91929070088,
        23.00390988668
    ],
    [
        112.91932537442,
        23.003914993042
    ],
    [
        112.9193782026,
        23.003915061308
    ],
    [
        112.91944295349,
        23.00391221931
    ],
    [
        112.91949226217,
        23.003910090116
    ],
    [
        112.91953668996,
        23.003915522788
    ],
    [
        112.91957787191,
        23.003913067734
    ],
    [
        112.91961986153,
        23.003919295692
    ],
    [
        112.91966781323,
        23.003923388925
    ],
    [
        112.9197190182,
        23.003924787677
    ],
    [
        112.91982304991,
        23.003935996306
    ],
    [
        112.9199048739,
        23.003935129375
    ],
    [
        112.91992925126,
        23.003946937061
    ],
    [
        112.91994197739,
        23.00396003159
    ],
    [
        112.91996907496,
        23.003954766749
    ],
    [
        112.91995529526,
        23.003893115415
    ],
    [
        112.91995854673,
        23.003892863356
    ],
    [
        112.91995475337,
        23.003893112218
    ],
    [
        112.91998346873,
        23.003900604578
    ],
    [
        112.92000161063,
        23.003918883682
    ],
    [
        112.92001650852,
        23.003925480477
    ],
    [
        112.9200221955,
        23.003930124682
    ],
    [
        112.92004576204,
        23.003939484027
    ],
    [
        112.9200557896,
        23.003935473826
    ],
    [
        112.92008288621,
        23.003932647374
    ],
    [
        112.92011079242,
        23.003935249621
    ],
    [
        112.92016200026,
        23.003938527102
    ],
    [
        112.92017337857,
        23.003941304435
    ],
    [
        112.92019966441,
        23.003936029459
    ],
    [
        112.92025060684,
        23.003931706874
    ],
    [
        112.92027390845,
        23.003932922961
    ],
    [
        112.92028772544,
        23.003935984076
    ],
    [
        112.92029991942,
        23.003934696198
    ],
    [
        112.92030209385,
        23.003923859001
    ],
    [
        112.92030236903,
        23.00391707969
    ],
    [
        112.92029696255,
        23.003896706891
    ],
    [
        112.92029616305,
        23.003875274936
    ],
    [
        112.92029779763,
        23.003861179924
    ],
    [
        112.92029997379,
        23.00384763041
    ],
    [
        112.92029944683,
        23.003823758887
    ],
    [
        112.92029811265,
        23.003790932138
    ],
    [
        112.92030193904,
        23.003738605454
    ],
    [
        112.92030764511,
        23.003713412636
    ],
    [
        112.92030223399,
        23.003700634408
    ],
    [
        112.9203155158,
        23.00369311408
    ],
    [
        112.92033122975,
        23.003695914012
    ],
    [
        112.92033475155,
        23.003697018548
    ],
    [
        112.92035019477,
        23.003699545476
    ],
    [
        112.9203542549,
        23.003706348843
    ],
    [
        112.92035669819,
        23.003699039089
    ],
    [
        112.92034830817,
        23.003683532228
    ],
    [
        112.92034587399,
        23.00367646664
    ],
    [
        112.92034832227,
        23.003661291166
    ],
    [
        112.92034020498,
        23.003643073429
    ],
    [
        112.9203477936,
        23.00364040326
    ],
    [
        112.92033778357,
        23.003615936632
    ],
    [
        112.92033454033,
        23.003602899392
    ],
    [
        112.92033889039,
        23.003579868764
    ],
    [
        112.92033620382,
        23.003543779809
    ],
    [
        112.92033621526,
        23.003525878488
    ],
    [
        112.92033813006,
        23.0034976809
    ],
    [
        112.92034030836,
        23.003481147799
    ],
    [
        112.92034356842,
        23.003467875503
    ],
    [
        112.92035035971,
        23.00344106116
    ],
    [
        112.92036256608,
        23.003420786383
    ],
    [
        112.92036420217,
        23.003404792708
    ],
    [
        112.92036962981,
        23.003391803582
    ],
    [
        112.92036692965,
        23.003377142067
    ],
    [
        112.92037616096,
        23.003348442467
    ],
    [
        112.92038649325,
        23.003293439313
    ],
    [
        112.9203873312,
        23.00325492892
    ],
    [
        112.92038871786,
        23.003206114735
    ],
    [
        112.92039497628,
        23.003166006861
    ],
    [
        112.92040042508,
        23.003121012329
    ],
    [
        112.92040125402,
        23.003096606
    ],
    [
        112.92040532919,
        23.003080354504
    ],
    [
        112.92040425266,
        23.003069228066
    ],
    [
        112.92049068311,
        23.00308136338
    ],
    [
        112.92071938182,
        23.003087192154
    ],
    [
        112.92088304911,
        23.003098070694
    ],
    [
        112.92116705005,
        23.003101104031
    ],
    [
        112.92142830385,
        23.003098807516
    ],
    [
        112.92145003226,
        23.003027301798
    ],
    [
        112.92147346207,
        23.002843242366
    ],
    [
        112.92150202731,
        23.002681989362
    ],
    [
        112.92150503803,
        23.002638334788
    ],
    [
        112.92151731604,
        23.002517421286
    ],
    [
        112.92155615295,
        23.002399067986
    ],
    [
        112.92156565433,
        23.002376327104
    ],
    [
        112.9215941572,
        23.002310273835
    ],
    [
        112.92165106024,
        23.002327883751
    ],
    [
        112.9216930568,
        23.002346239685
    ],
    [
        112.92176296663,
        23.002369324974
    ],
    [
        112.92190635803,
        23.002349316972
    ],
    [
        112.92200584073,
        23.002333994774
    ],
    [
        112.92224737405,
        23.002293452611
    ],
    [
        112.92225685799,
        23.00229782875
    ],
    [
        112.92225956667,
        23.002300551449
    ],
    [
        112.92226254735,
        23.002301919034
    ],
    [
        112.9222796252,
        23.002300085781
    ],
    [
        112.9222839698,
        23.002288981934
    ],
    [
        112.92226800731,
        23.002245795349
    ],
    [
        112.92225773616,
        23.002203986561
    ],
    [
        112.92224340778,
        23.002149956729
    ],
    [
        112.92223881214,
        23.002132309084
    ],
    [
        112.92221854756,
        23.002040012684
    ],
    [
        112.92218285216,
        23.001921075318
    ],
    [
        112.92217341444,
        23.001851603729
    ],
    [
        112.92215232543,
        23.001776932957
    ],
    [
        112.92214448351,
        23.001750864091
    ],
    [
        112.92212905844,
        23.001716085876
    ],
    [
        112.92211036557,
        23.001702721549
    ],
    [
        112.92209222534,
        23.001674712757
    ],
    [
        112.92207325788,
        23.001666500054
    ],
    [
        112.92205701455,
        23.001639311975
    ],
    [
        112.92203751895,
        23.0016118393
    ],
    [
        112.92203158326,
        23.001573843304
    ],
    [
        112.92203593324,
        23.00155541735
    ],
    [
        112.92203895129,
        23.00150470982
    ],
    [
        112.92209641912,
        23.001496532313
    ],
    [
        112.92214223653,
        23.001482610122
    ],
    [
        112.9222295182,
        23.00147888253
    ],
    [
        112.92235044425,
        23.001431607133
    ],
    [
        112.92244343641,
        23.00140754189
    ],
    [
        112.92249328015,
        23.001452476374
    ],
    [
        112.92254934141,
        23.001521841396
    ],
    [
        112.92261142233,
        23.001514467138
    ],
    [
        112.9226748474,
        23.001523638944
    ],
    [
        112.9227320472,
        23.001520580609
    ],
    [
        112.92274072214,
        23.001520067678
    ],
    [
        112.92278601911,
        23.001483604917
    ],
    [
        112.92283863107,
        23.001453674008
    ],
    [
        112.92289912835,
        23.001391761361
    ],
    [
        112.92297832801,
        23.001335058411
    ],
    [
        112.92300842522,
        23.001327016944
    ],
    [
        112.92305095881,
        23.001365935894
    ],
    [
        112.92309210014,
        23.001456111016
    ],
    [
        112.92313675957,
        23.001555788324
    ],
    [
        112.92322096298,
        23.001708471209
    ],
    [
        112.92325483213,
        23.001735151338
    ],
    [
        112.92329577236,
        23.001730930816
    ],
    [
        112.92339857344,
        23.001660974988
    ],
    [
        112.92344906847,
        23.001566727569
    ],
    [
        112.92352803063,
        23.001474181859
    ],
    [
        112.92357034844,
        23.001442560683
    ],
    [
        112.92362808905,
        23.001454645565
    ],
    [
        112.92364435499,
        23.001456857331
    ],
    [
        112.92364733168,
        23.001464730592
    ],
    [
        112.9236985488,
        23.001500663027
    ],
    [
        112.92375517756,
        23.001552608892
    ],
    [
        112.92387141951,
        23.001656770089
    ],
    [
        112.92393404303,
        23.001670206373
    ],
    [
        112.92395762686,
        23.001677854849
    ],
    [
        112.92396986516,
        23.001626349322
    ],
    [
        112.92400549117,
        23.001478881531
    ],
    [
        112.92401172827,
        23.001477810562
    ],
    [
        112.92400312738,
        23.001373368592
    ],
    [
        112.92405254973,
        23.001272039051
    ],
    [
        112.92411119838,
        23.001162047858
    ],
    [
        112.92413157955,
        23.001101065169
    ],
    [
        112.92410800754,
        23.001076604445
    ],
    [
        112.92401804538,
        23.000997209536
    ],
    [
        112.92387767519,
        23.000888125859
    ],
    [
        112.92377742581,
        23.000793498091
    ],
    [
        112.92361810572,
        23.000655584395
    ],
    [
        112.92342383348,
        23.000496124176
    ],
    [
        112.92335068574,
        23.000426756131
    ],
    [
        112.92318053695,
        23.000287662911
    ],
    [
        112.92289089919,
        23.000076013882
    ],
    [
        112.92279875508,
        23.000043704708
    ],
    [
        112.92280309451,
        23.000041006973
    ],
    [
        112.92279985436,
        23.000024451389
    ],
    [
        112.92280177196,
        22.999998691403
    ],
    [
        112.92281264483,
        22.999960756186
    ],
    [
        112.92282869738,
        22.999885680248
    ],
    [
        112.92283550525,
        22.999846375206
    ],
    [
        112.92284421269,
        22.999804635391
    ],
    [
        112.92284803534,
        22.999769660017
    ],
    [
        112.92286756353,
        22.999756976774
    ],
    [
        112.9228762481,
        22.999744528927
    ],
    [
        112.92288520079,
        22.999735879036
    ],
    [
        112.92288845512,
        22.999734262321
    ],
    [
        112.92290826374,
        22.999709916608
    ],
    [
        112.92292020552,
        22.999692325723
    ],
    [
        112.92293813165,
        22.999648987661
    ],
    [
        112.9229606716,
        22.999599154705
    ],
    [
        112.92299107619,
        22.999545820361
    ],
    [
        112.9230044095,
        22.999483209759
    ],
    [
        112.92302124212,
        22.999452072033
    ],
    [
        112.92303806726,
        22.999430426877
    ],
    [
        112.92305895501,
        22.999413676141
    ],
    [
        112.92306817985,
        22.999404211948
    ],
    [
        112.92307251912,
        22.999402055605
    ],
    [
        112.92309122352,
        22.999403740727
    ],
    [
        112.92311236786,
        22.999405433
    ],
    [
        112.92311996079,
        22.999402743975
    ],
    [
        112.92312727874,
        22.999404936093
    ],
    [
        112.92312511969,
        22.999392724428
    ],
    [
        112.92312186888,
        22.999389731046
    ],
    [
        112.92323895226,
        22.999431036975
    ],
    [
        112.92338149428,
        22.999508203865
    ],
    [
        112.92353516136,
        22.999578872524
    ],
    [
        112.92366877668,
        22.999640518138
    ],
    [
        112.92377285034,
        22.999691497488
    ],
    [
        112.92384467539,
        22.99972394708
    ],
    [
        112.92397015536,
        22.999797198844
    ],
    [
        112.92405553285,
        22.999839429282
    ],
    [
        112.92409348456,
        22.99985090329
    ],
    [
        112.92414390079,
        22.999873522575
    ],
    [
        112.92415474683,
        22.999873545424
    ],
    [
        112.92416505039,
        22.999873838253
    ],
    [
        112.92419872134,
        22.999812611392
    ],
    [
        112.92421474008,
        22.999786335503
    ],
    [
        112.92424565583,
        22.999781245056
    ],
    [
        112.92429147566,
        22.999788659599
    ],
    [
        112.92433564723,
        22.999823733923
    ],
    [
        112.92438065649,
        22.999828430876
    ],
    [
        112.92444842813,
        22.999853509703
    ],
    [
        112.92450617056,
        22.999874498141
    ],
    [
        112.92461623682,
        22.999912659559
    ],
    [
        112.92468509499,
        22.999939352722
    ],
    [
        112.92476452427,
        22.999973652099
    ],
    [
        112.92477238076,
        22.999983699469
    ],
    [
        112.92487918853,
        23.000034576685
    ],
    [
        112.92488216676,
        23.000040819117
    ],
    [
        112.92489328487,
        23.000041648618
    ],
    [
        112.92489196074,
        23.000000691781
    ],
    [
        112.92489201122,
        22.999935869128
    ],
    [
        112.92492946573,
        22.999897136517
    ],
    [
        112.92499212713,
        22.999876879628
    ],
    [
        112.92503443572,
        22.999874222688
    ],
    [
        112.92506915916,
        22.999861248059
    ],
    [
        112.92510850237,
        22.999836615302
    ],
    [
        112.92512316463,
        22.999814392669
    ],
    [
        112.92515899734,
        22.999771039361
    ],
    [
        112.92520514874,
        22.999711694351
    ],
    [
        112.92520788495,
        22.999681049103
    ],
    [
        112.92522202984,
        22.999627633798
    ],
    [
        112.92522584775,
        22.999601058087
    ],
    [
        112.92523645251,
        22.999566081915
    ],
    [
        112.92528583432,
        22.999538470288
    ],
    [
        112.92532379923,
        22.999544205363
    ],
    [
        112.92535824424,
        22.999542883809
    ],
    [
        112.92542472761,
        22.999497924256
    ],
    [
        112.92550370572,
        22.999430731004
    ],
    [
        112.92553791337,
        22.999388448745
    ],
    [
        112.92553847034,
        22.999370277225
    ],
    [
        112.92552140115,
        22.999348022759
    ],
    [
        112.92549431689,
        22.999300806889
    ],
    [
        112.92548809885,
        22.999275848964
    ],
    [
        112.92548812957,
        22.999237606502
    ],
    [
        112.92549168619,
        22.999199367101
    ],
    [
        112.92552942435,
        22.999151663766
    ],
    [
        112.92557338041,
        22.999129459013
    ],
    [
        112.92561190772,
        22.999112944084
    ],
    [
        112.92567050688,
        22.999095628308
    ],
    [
        112.92569439308,
        22.999073404433
    ],
    [
        112.92574812637,
        22.999037095541
    ],
    [
        112.92579831658,
        22.999022479757
    ],
    [
        112.92584579093,
        22.999012742196
    ],
    [
        112.92589029506,
        22.998986998938
    ],
    [
        112.92589142546,
        22.99893112762
    ],
    [
        112.92589037475,
        22.998889087597
    ],
    [
        112.92588904178,
        22.99886060857
    ],
    [
        112.92589451803,
        22.998797687657
    ],
    [
        112.92589158083,
        22.998741000741
    ],
    [
        112.92588754986,
        22.998695162183
    ],
    [
        112.92587482367,
        22.998668304788
    ],
    [
        112.92585776263,
        22.998635478094
    ],
    [
        112.92585156014,
        22.998591808067
    ],
    [
        112.92585674211,
        22.998557365607
    ],
    [
        112.92585514137,
        22.998525089351
    ],
    [
        112.92586876825,
        22.99844671333
    ],
    [
        112.92589326055,
        22.998349628282
    ],
    [
        112.92591312198,
        22.99827667927
    ],
    [
        112.92593380033,
        22.998200204421
    ],
    [
        112.92596126209,
        22.998121291154
    ],
    [
        112.92597158829,
        22.998098784174
    ],
    [
        112.92603750404,
        22.998095283914
    ],
    [
        112.9262092021,
        22.998100756114
    ],
    [
        112.92627809396,
        22.998109989104
    ],
    [
        112.92631227308,
        22.998109721939
    ],
    [
        112.92640424487,
        22.998093996642
    ],
    [
        112.9265146709,
        22.998070939112
    ],
    [
        112.92657408876,
        22.998060354795
    ],
    [
        112.92673142437,
        22.998067915411
    ],
    [
        112.92685460306,
        22.998050514948
    ],
    [
        112.92685382073,
        22.998013086782
    ],
    [
        112.9268327273,
        22.997933627328
    ],
    [
        112.92679563742,
        22.997843324325
    ],
    [
        112.92678293166,
        22.997790711865
    ],
    [
        112.92673609829,
        22.997674644165
    ],
    [
        112.92668845817,
        22.997551251758
    ],
    [
        112.92665515357,
        22.997478030028
    ],
    [
        112.92660780703,
        22.997330495562
    ],
    [
        112.92655860953,
        22.997128986689
    ],
    [
        112.92650257423,
        22.996993382573
    ],
    [
        112.92634631691,
        22.996692600735
    ],
    [
        112.92630813979,
        22.996612316545
    ],
    [
        112.92625862632,
        22.996468835429
    ],
    [
        112.92623563302,
        22.996397229975
    ],
    [
        112.92620751513,
        22.996293076843
    ],
    [
        112.92617262385,
        22.996180513706
    ],
    [
        112.92612635224,
        22.996054927946
    ],
    [
        112.92610311375,
        22.995955926741
    ],
    [
        112.9260801562,
        22.995846618902
    ],
    [
        112.92608810229,
        22.995758475709
    ],
    [
        112.9261505969,
        22.995641056313
    ],
    [
        112.9262237172,
        22.995473731465
    ],
    [
        112.92628976476,
        22.995329996811
    ],
    [
        112.92635223604,
        22.99524185741
    ],
    [
        112.92642910291,
        22.995134729319
    ],
    [
        112.92653500585,
        22.995018371895
    ],
    [
        112.9266178194,
        22.994937809053
    ],
    [
        112.92668894966,
        22.994878397665
    ],
    [
        112.92676605274,
        22.994815182707
    ],
    [
        112.92682602926,
        22.994791295078
    ],
    [
        112.92693486814,
        22.994736192296
    ],
    [
        112.92706974173,
        22.994694352876
    ],
    [
        112.92721763877,
        22.994655470477
    ],
    [
        112.92736146974,
        22.994617113776
    ],
    [
        112.92748741157,
        22.994563567604
    ],
    [
        112.92761741038,
        22.994527088859
    ],
    [
        112.92776586527,
        22.994488401971
    ],
    [
        112.92789368446,
        22.994468708056
    ],
    [
        112.9282559256,
        22.994482799997
    ],
    [
        112.92842065966,
        22.994466235182
    ],
    [
        112.9285047933,
        22.99445712634
    ],
    [
        112.92868013095,
        22.994427754526
    ],
    [
        112.92883317933,
        22.994442069928
    ],
    [
        112.92894173617,
        22.994442365069
    ],
    [
        112.92902585056,
        22.994462507141
    ],
    [
        112.92914092328,
        22.994464665221
    ],
    [
        112.92916318195,
        22.994461083308
    ],
    [
        112.92919222567,
        22.99445775482
    ],
    [
        112.92934531772,
        22.994441079563
    ],
    [
        112.92947207765,
        22.994433407354
    ],
    [
        112.92960725897,
        22.994421356289
    ],
    [
        112.92971257021,
        22.994425923672
    ],
    [
        112.93007873883,
        22.994435328803
    ],
    [
        112.93045278973,
        22.994460855609
    ],
    [
        112.93070960493,
        22.994463941727
    ],
    [
        112.93071123333,
        22.994464477739
    ],
    [
        112.93071014841,
        22.994463397156
    ],
    [
        112.93088771644,
        22.994448037575
    ],
    [
        112.93098522418,
        22.994404510287
    ],
    [
        112.93098739669,
        22.994403958756
    ],
    [
        112.93105882868,
        22.994374637148
    ],
    [
        112.93133289353,
        22.99425464536
    ],
    [
        112.93142797158,
        22.994204852376
    ],
    [
        112.93154125486,
        22.994143032717
    ],
    [
        112.93169313161,
        22.994045758341
    ],
    [
        112.93174991977,
        22.994006157012
    ],
    [
        112.93182491536,
        22.993952088692
    ],
    [
        112.93195560799,
        22.993867088013
    ],
    [
        112.9320672967,
        22.993780543065
    ],
    [
        112.93219229856,
        22.993689306464
    ],
    [
        112.93237572097,
        22.993565466164
    ],
    [
        112.93247789618,
        22.993497103734
    ],
    [
        112.93258795977,
        22.993417568158
    ],
    [
        112.93271595224,
        22.993335749764
    ],
    [
        112.93289258221,
        22.993233291132
    ],
    [
        112.93299366572,
        22.993180619423
    ],
    [
        112.93314283407,
        22.993118154163
    ],
    [
        112.93331375219,
        22.993038176346
    ],
    [
        112.93341564961,
        22.992994412585
    ],
    [
        112.93362105407,
        22.992933426538
    ],
    [
        112.93383678268,
        22.99287803059
    ],
    [
        112.93406640327,
        22.992791852176
    ],
    [
        112.93431368022,
        22.992716623309
    ],
    [
        112.9343998151,
        22.992697565961
    ],
    [
        112.93460333321,
        22.992657033596
    ],
    [
        112.93460631687,
        22.992661893483
    ],
    [
        112.93477045934,
        22.992610230359
    ],
    [
        112.93493652968,
        22.992536561834
    ],
    [
        112.93505313077,
        22.992489289737
    ],
    [
        112.93505612496,
        22.992483571165
    ],
    [
        112.93508115138,
        22.992452188221
    ],
    [
        112.93529712415,
        22.992202879787
    ],
    [
        112.93580944622,
        22.991510920634
    ],
    [
        112.93620417988,
        22.991063049417
    ],
    [
        112.93623682042,
        22.991031848201
    ],
    [
        112.93636840184,
        22.990976726809
    ],
    [
        112.93669159312,
        22.990906581853
    ],
    [
        112.93693131344,
        22.990888387066
    ],
    [
        112.93760590622,
        22.990880616812
    ],
    [
        112.93788746459,
        22.990918788216
    ],
    [
        112.93818585832,
        22.990987374042
    ],
    [
        112.93830562615,
        22.991097883943
    ],
    [
        112.93856647191,
        22.991493035979
    ],
    [
        112.93877331265,
        22.991805452511
    ],
    [
        112.93899881138,
        22.992228561146
    ],
    [
        112.93932968906,
        22.992774144186
    ],
    [
        112.93949399719,
        22.992959182186
    ],
    [
        112.93953310199,
        22.99300729145
    ],
    [
        112.93954831462,
        22.993020681502
    ],
    [
        112.93960726096,
        22.993075617556
    ],
    [
        112.93978443811,
        22.993175045146
    ],
    [
        112.93981405673,
        22.993193692523
    ],
    [
        112.93994121313,
        22.993289330606
    ],
    [
        112.94005234348,
        22.993370497455
    ],
    [
        112.94010478423,
        22.993409215436
    ],
    [
        112.94023876727,
        22.99348061004
    ],
    [
        112.94029231115,
        22.993504662867
    ],
    [
        112.9403686638,
        22.993562888883
    ],
    [
        112.94045398099,
        22.993631310763
    ],
    [
        112.94050045806,
        22.99365381237
    ],
    [
        112.94058094754,
        22.9936536676
    ],
    [
        112.94067612067,
        22.993654969568
    ],
    [
        112.94083956223,
        22.993643778152
    ],
    [
        112.94109464896,
        22.993635785545
    ],
    [
        112.9411354378,
        22.993638809855
    ],
    [
        112.94130812312,
        22.993641014131
    ],
    [
        112.9413712087,
        22.99364890801
    ],
    [
        112.94144870946,
        22.99365580534
    ],
    [
        112.94155259302,
        22.993660739799
    ],
    [
        112.94191267349,
        22.993664846796
    ],
    [
        112.94214141808,
        22.993652678421
    ],
    [
        112.94226517057,
        22.993652697526
    ],
    [
        112.94234377012,
        22.993657637818
    ],
    [
        112.94245499488,
        22.993677875809
    ],
    [
        112.94273705592,
        22.993677667689
    ],
    [
        112.94279471658,
        22.993681780231
    ],
    [
        112.94285319083,
        22.993688863193
    ],
    [
        112.94292907913,
        22.993690557133
    ],
    [
        112.94299271564,
        22.993704888519
    ],
    [
        112.94308601764,
        22.993702814804
    ],
    [
        112.94315674101,
        22.99370321227
    ],
    [
        112.94331123718,
        22.993713854892
    ],
    [
        112.94337189775,
        22.993714109684
    ],
    [
        112.94364281947,
        22.99373207336
    ],
    [
        112.94376414089,
        22.993737710617
    ],
    [
        112.94384574669,
        22.993743081279
    ],
    [
        112.94402853867,
        22.993763299447
    ],
    [
        112.94405682593,
        22.993768867708
    ],
    [
        112.94417269949,
        22.993787843202
    ],
    [
        112.94431879303,
        22.993784955608
    ],
    [
        112.94434816816,
        22.993791859892
    ],
    [
        112.94438707646,
        22.993786965567
    ],
    [
        112.9444382384,
        22.993770504338
    ],
    [
        112.94453863042,
        22.99376743862
    ],
    [
        112.94458162616,
        22.99375651487
    ],
    [
        112.94467602863,
        22.993759494501
    ],
    [
        112.94469748667,
        22.99379634072
    ],
    [
        112.94468732442,
        22.993897649316
    ],
    [
        112.94472211853,
        22.993929420914
    ],
    [
        112.94465445262,
        22.994135433756
    ],
    [
        112.9445920346,
        22.994258920424
    ],
    [
        112.94453859615,
        22.994381462561
    ],
    [
        112.94448594595,
        22.994534638941
    ],
    [
        112.9444009236,
        22.994686106851
    ],
    [
        112.94438893643,
        22.994704178038
    ],
    [
        112.94433038229,
        22.994771731274
    ],
    [
        112.94419874293,
        22.995030440094
    ],
    [
        112.94414070276,
        22.995132695371
    ],
    [
        112.94401482592,
        22.995342491417
    ],
    [
        112.94386878465,
        22.995592429478
    ],
    [
        112.94376704982,
        22.995885947208
    ],
    [
        112.94371029884,
        22.996073061219
    ],
    [
        112.94364343372,
        22.996316726539
    ],
    [
        112.94356358135,
        22.996483272718
    ],
    [
        112.94345975163,
        22.996695980803
    ],
    [
        112.94332981708,
        22.996900903724
    ],
    [
        112.94324699032,
        22.997053373306
    ],
    [
        112.94319329366,
        22.997179406348
    ],
    [
        112.9430088694,
        22.997494345997
    ],
    [
        112.94289739478,
        22.997756214684
    ],
    [
        112.94282438901,
        22.997884122921
    ],
    [
        112.94275709537,
        22.998013307971
    ],
    [
        112.94266421072,
        22.998171308425
    ],
    [
        112.94260830064,
        22.9983521392
    ],
    [
        112.94257613416,
        22.998437727735
    ],
    [
        112.94251591008,
        22.998574946466
    ],
    [
        112.94248265881,
        22.998657835413
    ],
    [
        112.94241587257,
        22.998839345882
    ],
    [
        112.94236982009,
        22.998945454397
    ],
    [
        112.94227859117,
        22.999085240502
    ],
    [
        112.94220670193,
        22.999191138939
    ],
    [
        112.94209607642,
        22.99944290993
    ],
    [
        112.94205517614,
        22.999573624386
    ],
    [
        112.94200908291,
        22.999737765036
    ],
    [
        112.94194008772,
        22.999975699757
    ],
    [
        112.94190381365,
        23.000107165134
    ],
    [
        112.94182317803,
        23.000279066145
    ],
    [
        112.94174581103,
        23.000446853361
    ],
    [
        112.94166274406,
        23.000601961617
    ],
    [
        112.9416009017,
        23.000744050495
    ],
    [
        112.94154202367,
        23.000924613601
    ],
    [
        112.94148369143,
        23.001104896662
    ],
    [
        112.94142045259,
        23.001303139961
    ],
    [
        112.941345012,
        23.00145379728
    ],
    [
        112.94127038618,
        23.001608238123
    ],
    [
        112.94121318671,
        23.001734523893
    ],
    [
        112.94117796769,
        23.001929699275
    ],
    [
        112.94113132864,
        23.002124743552
    ],
    [
        112.94108657978,
        23.002342004152
    ],
    [
        112.94103476982,
        23.002548501203
    ],
    [
        112.94097864514,
        23.002703787385
    ],
    [
        112.94091762926,
        23.002855605229
    ],
    [
        112.94088682226,
        23.002973421781
    ],
    [
        112.94085904481,
        23.003033971746
    ],
    [
        112.94081787738,
        23.003194766915
    ],
    [
        112.94078729429,
        23.003390422012
    ],
    [
        112.94077252065,
        23.003530012653
    ],
    [
        112.9407468898,
        23.003639085172
    ],
    [
        112.94070136328,
        23.003820544087
    ],
    [
        112.94068196297,
        23.003970768015
    ],
    [
        112.94068812532,
        23.004120685034
    ],
    [
        112.94070161839,
        23.004291127764
    ],
    [
        112.94074448846,
        23.004449825133
    ],
    [
        112.9407998685,
        23.004609184016
    ],
    [
        112.94080275421,
        23.004789519198
    ],
    [
        112.9408097279,
        23.004956786018
    ],
    [
        112.9408213521,
        23.005077615741
    ],
    [
        112.94086637251,
        23.005292430312
    ],
    [
        112.94089564375,
        23.005469191286
    ],
    [
        112.94092547871,
        23.00561231191
    ],
    [
        112.9409670074,
        23.00575691692
    ],
    [
        112.94098002607,
        23.005821312198
    ],
    [
        112.94101369431,
        23.005920173203
    ],
    [
        112.9410386448,
        23.006049790106
    ],
    [
        112.94103256653,
        23.006233491994
    ],
    [
        112.94105176858,
        23.006441024684
    ],
    [
        112.94106528042,
        23.006611196486
    ],
    [
        112.94110986501,
        23.00664048512
    ],
    [
        112.94117593925,
        23.006658929107
    ],
    [
        112.94127165881,
        23.006673476696
    ],
    [
        112.94134125071,
        23.006730928203
    ],
    [
        112.94141464342,
        23.006803518445
    ],
    [
        112.94142684464,
        23.006879312805
    ],
    [
        112.94146755336,
        23.007056464899
    ],
    [
        112.94148434915,
        23.007195400285
    ],
    [
        112.94150767754,
        23.007324489014
    ],
    [
        112.94152555576,
        23.007479413938
    ],
    [
        112.94152581155,
        23.007514943258
    ],
    [
        112.94153341164,
        23.007547667847
    ],
    [
        112.94150944227,
        23.007629070123
    ],
    [
        112.94149062299,
        23.007750008729
    ],
    [
        112.94146555469,
        23.007858819697
    ],
    [
        112.94143122668,
        23.00799948156
    ],
    [
        112.94138411496,
        23.00814681225
    ],
    [
        112.94136965002,
        23.008268509426
    ],
    [
        112.9412841904,
        23.008427164844
    ],
    [
        112.94124197303,
        23.008586365792
    ],
    [
        112.9411777356,
        23.008729291872
    ],
    [
        112.94117229775,
        23.00872637529
    ],
    [
        112.94112982236,
        23.008857367364
    ],
    [
        112.94107673039,
        23.009019139482
    ],
    [
        112.94101901309,
        23.009191545198
    ],
    [
        112.94099695961,
        23.009261796303
    ],
    [
        112.94094688345,
        23.009367650959
    ],
    [
        112.94091501226,
        23.009518038337
    ],
    [
        112.94090711844,
        23.009539291602
    ],
    [
        112.94087281875,
        23.009639527197
    ],
    [
        112.94084369603,
        23.009712303409
    ],
    [
        112.94080256235,
        23.009921119438
    ],
    [
        112.94076795951,
        23.010123888537
    ],
    [
        112.9407594589,
        23.010344787567
    ],
    [
        112.94077054955,
        23.010534528272
    ],
    [
        112.94081426338,
        23.010761849937
    ],
    [
        112.94083052112,
        23.010965362335
    ],
    [
        112.94088293377,
        23.011224856637
    ],
    [
        112.9408747187,
        23.011441144271
    ],
    [
        112.94088584124,
        23.011547068928
    ],
    [
        112.94090239767,
        23.011675441566
    ],
    [
        112.94092924868,
        23.011975121238
    ],
    [
        112.94093440833,
        23.01200679512
    ],
    [
        112.94095041234,
        23.012188611772
    ],
    [
        112.94096642604,
        23.012332724042
    ],
    [
        112.94096450602,
        23.012411411483
    ],
    [
        112.94093372051,
        23.012692807769
    ],
    [
        112.94093641452,
        23.012827860646
    ],
    [
        112.94090431324,
        23.012894709276
    ],
    [
        112.9408556136,
        23.013020892724
    ],
    [
        112.94075334035,
        23.013167252356
    ],
    [
        112.9407430045,
        23.013181211109
    ],
    [
        112.94058498873,
        23.01332578884
    ],
    [
        112.94053141035,
        23.013380679535
    ],
    [
        112.94035327473,
        23.013551512955
    ],
    [
        112.94020342829,
        23.013692156108
    ],
    [
        112.94018085617,
        23.013715747957
    ],
    [
        112.94007044621,
        23.013819025565
    ],
    [
        112.93998831806,
        23.013911660999
    ],
    [
        112.93994698281,
        23.013956352543
    ],
    [
        112.93987437439,
        23.014040191683
    ],
    [
        112.93981808209,
        23.014114889451
    ],
    [
        112.93976315204,
        23.0141719376
    ],
    [
        112.93959726824,
        23.014437752019
    ],
    [
        112.93956572264,
        23.014502395828
    ],
    [
        112.93953363527,
        23.014549413021
    ],
    [
        112.93950616872,
        23.014613196044
    ],
    [
        112.93947407708,
        23.014715820769
    ],
    [
        112.9394498746,
        23.014771699727
    ],
    [
        112.93937345853,
        23.01499200164
    ],
    [
        112.93925626182,
        23.015253167995
    ],
    [
        112.93912574887,
        23.015517183321
    ],
    [
        112.93902406151,
        23.01573367453
    ],
    [
        112.93893923309,
        23.01598741181
    ],
    [
        112.93886174984,
        23.016167552408
    ],
    [
        112.93879595913,
        23.016338341072
    ],
    [
        112.93878263863,
        23.016458654841
    ],
    [
        112.93875599744,
        23.016544388219
    ],
    [
        112.93876170649,
        23.016547853902
    ],
    [
        112.93870733788,
        23.016706310202
    ],
    [
        112.93865215533,
        23.016859076558
    ],
    [
        112.93858202468,
        23.017062996962
    ],
    [
        112.93852439934,
        23.017213614245
    ],
    [
        112.93846731902,
        23.017357441862
    ],
    [
        112.93840752129,
        23.017492343572
    ],
    [
        112.93834201659,
        23.017629472014
    ],
    [
        112.93829309283,
        23.017729805002
    ],
    [
        112.9382650999,
        23.017811474737
    ],
    [
        112.93816698451,
        23.018011865246
    ],
    [
        112.93811127143,
        23.018144271491
    ],
    [
        112.93802675834,
        23.018390901828
    ],
    [
        112.93798382667,
        23.018538094163
    ],
    [
        112.9379137199,
        23.018730589465
    ],
    [
        112.93781482529,
        23.019078266418
    ],
    [
        112.93803826878,
        23.019110206808
    ],
    [
        112.93814645869,
        23.019119959456
    ],
    [
        112.93858739467,
        23.019176971574
    ],
    [
        112.93912842424,
        23.019330680905
    ],
    [
        112.93929291579,
        23.019369837569
    ],
    [
        112.93946937443,
        23.019409112438
    ],
    [
        112.93960586668,
        23.019431725318
    ],
    [
        112.93967003681,
        23.019451346843
    ],
    [
        112.93969720354,
        23.019313230591
    ],
    [
        112.93974556665,
        23.019091320236
    ],
    [
        112.93985674802,
        23.018914537009
    ],
    [
        112.93993123962,
        23.018842879854
    ],
    [
        112.93997855006,
        23.018834468305
    ],
    [
        112.94000411061,
        23.018843939355
    ],
    [
        112.94011886055,
        23.018872992841
    ],
    [
        112.94027467888,
        23.01895147064
    ],
    [
        112.94042097967,
        23.019002645533
    ],
    [
        112.94054743291,
        23.019054585052
    ],
    [
        112.94055368677,
        23.019051255179
    ],
    [
        112.94071195885,
        23.01910361463
    ],
    [
        112.94074187122,
        23.019100270393
    ],
    [
        112.94079571429,
        23.019097450295
    ],
    [
        112.94085227719,
        23.019094866542
    ],
    [
        112.94091672455,
        23.019076993243
    ],
    [
        112.94100021106,
        23.019075161101
    ],
    [
        112.94105867994,
        23.019077700482
    ],
    [
        112.94111171144,
        23.019087900212
    ],
    [
        112.9411704557,
        23.019107250999
    ],
    [
        112.94125666684,
        23.019120019948
    ],
    [
        112.94144622777,
        23.019158892561
    ],
    [
        112.9415514852,
        23.019206943558
    ],
    [
        112.94158086457,
        23.019251334122
    ],
    [
        112.941657292,
        23.019278852815
    ],
    [
        112.94182455868,
        23.019301413117
    ],
    [
        112.94192165846,
        23.019325670849
    ],
    [
        112.9419284573,
        23.019321785761
    ],
    [
        112.94203997405,
        23.019349377785
    ],
    [
        112.94226056145,
        23.019385852141
    ],
    [
        112.94249992212,
        23.019416894491
    ],
    [
        112.94276213754,
        23.019441357408
    ],
    [
        112.94304285997,
        23.019473395782
    ],
    [
        112.94311059383,
        23.019480888637
    ],
    [
        112.94335378695,
        23.019504973855
    ],
    [
        112.94358746863,
        23.019544347754
    ],
    [
        112.94368730742,
        23.019552187297
    ],
    [
        112.9437058068,
        23.019556541969
    ],
    [
        112.94372238848,
        23.019484151509
    ],
    [
        112.94372971515,
        23.019376352416
    ],
    [
        112.94374355768,
        23.019182739239
    ],
    [
        112.94377347669,
        23.019148141592
    ],
    [
        112.94402892971,
        23.019167349676
    ],
    [
        112.9442144735,
        23.019196466559
    ],
    [
        112.94436410506,
        23.019198678269
    ],
    [
        112.9443861422,
        23.019200805218
    ],
    [
        112.94460733482,
        23.019234527179
    ],
    [
        112.94489247094,
        23.019272719256
    ],
    [
        112.94488948213,
        23.01929717768
    ],
    [
        112.94488077675,
        23.019303272403
    ],
    [
        112.94483373556,
        23.01946617986
    ],
    [
        112.94485903931,
        23.019471509148
    ],
    [
        112.94496052469,
        23.01947898384
    ],
    [
        112.94504160907,
        23.019508453905
    ],
    [
        112.94512024509,
        23.019535786269
    ],
    [
        112.94509878032,
        23.019698867894
    ],
    [
        112.94492363914,
        23.020092340022
    ],
    [
        112.9449002511,
        23.020142596011
    ],
    [
        112.9449516872,
        23.020207767764
    ],
    [
        112.9451500619,
        23.020340505308
    ],
    [
        112.94519142442,
        23.020367296875
    ],
    [
        112.94549674434,
        23.020532334251
    ],
    [
        112.94577785056,
        23.020664592345
    ],
    [
        112.94585949577,
        23.020726846163
    ],
    [
        112.94572049423,
        23.020897126428
    ],
    [
        112.94564569487,
        23.021005943838
    ],
    [
        112.94556164368,
        23.021107843051
    ],
    [
        112.94538074502,
        23.021267872782
    ],
    [
        112.94526295236,
        23.021346385837
    ],
    [
        112.94517538862,
        23.021518040849
    ],
    [
        112.94521730764,
        23.021581990001
    ],
    [
        112.94518086131,
        23.021627287966
    ],
    [
        112.9451506749,
        23.021678732912
    ],
    [
        112.94509709592,
        23.021751409315
    ],
    [
        112.94505874637,
        23.021798360676
    ],
    [
        112.94493824787,
        23.021906464238
    ],
    [
        112.94494887202,
        23.021949986317
    ],
    [
        112.94497962719,
        23.021984262237
    ],
    [
        112.9451464547,
        23.022121261095
    ],
    [
        112.9452686502,
        23.022215227322
    ],
    [
        112.94526620126,
        23.022214720853
    ],
    [
        112.9452792573,
        23.022201777887
    ],
    [
        112.94553002253,
        23.021871435603
    ],
    [
        112.94567779727,
        23.021960383924
    ],
    [
        112.94588055691,
        23.022106007572
    ],
    [
        112.94599350528,
        23.022185419498
    ],
    [
        112.94629289738,
        23.022405773526
    ],
    [
        112.94668729018,
        23.022680779617
    ],
    [
        112.9468051465,
        23.022756004471
    ],
    [
        112.94687047524,
        23.022807893635
    ],
    [
        112.94680057916,
        23.022924002565
    ],
    [
        112.94670590789,
        23.023004139237
    ],
    [
        112.94655956774,
        23.023175134459
    ],
    [
        112.94651849533,
        23.023223512096
    ],
    [
        112.94654625948,
        23.023244788974
    ],
    [
        112.94657102789,
        23.023259329318
    ],
    [
        112.9466091322,
        23.02327881871
    ],
    [
        112.94662791361,
        23.023292094093
    ],
    [
        112.94665921743,
        23.023317926985
    ],
    [
        112.94669922718,
        23.023337928051
    ],
    [
        112.9467395084,
        23.02335575389
    ],
    [
        112.9467748944,
        23.023381250821
    ],
    [
        112.94679911878,
        23.023394711895
    ],
    [
        112.94681572266,
        23.023405577796
    ],
    [
        112.94714374294,
        23.023669324717
    ],
    [
        112.94721724745,
        23.023739524559
    ],
    [
        112.94736724553,
        23.023863321738
    ],
    [
        112.94741080397,
        23.023902516435
    ],
    [
        112.94747913117,
        23.023950272579
    ],
    [
        112.94761932868,
        23.024054675692
    ],
    [
        112.94768547827,
        23.02409757729
    ],
    [
        112.94772386484,
        23.024130337418
    ],
    [
        112.94775244905,
        23.02415077319
    ],
    [
        112.94777123226,
        23.024162411716
    ],
    [
        112.94795418704,
        23.024324715576
    ],
    [
        112.94800234607,
        23.024295460773
    ],
    [
        112.94807988904,
        23.024244302706
    ],
    [
        112.94822901308,
        23.024199046799
    ],
    [
        112.9483841323,
        23.0241675216
    ],
    [
        112.94855150786,
        23.024152609059
    ],
    [
        112.9487246174,
        23.024176659058
    ],
    [
        112.94884492444,
        23.024193420371
    ],
    [
        112.94893938235,
        23.024225519815
    ],
    [
        112.94904800878,
        23.024292109724
    ],
    [
        112.94911552608,
        23.02433251167
    ],
    [
        112.94921871043,
        23.02439864184
    ],
    [
        112.94926281686,
        23.024429115732
    ],
    [
        112.94950209756,
        23.024501405584
    ],
    [
        112.94973268094,
        23.024593354218
    ],
    [
        112.9497060378,
        23.02466460392
    ],
    [
        112.9496198281,
        23.024830436871
    ],
    [
        112.94966261209,
        23.024941501464
    ],
    [
        112.94965771508,
        23.024946737215
    ],
    [
        112.94974021371,
        23.02500179836
    ],
    [
        112.94991334883,
        23.025047753167
    ],
    [
        112.95013191983,
        23.025044106331
    ],
    [
        112.95026100646,
        23.025183290589
    ],
    [
        112.95039388512,
        23.025278727871
    ],
    [
        112.95039633671,
        23.025282484836
    ],
    [
        112.95059566224,
        23.02543539787
    ],
    [
        112.95070157373,
        23.025484343906
    ],
    [
        112.95085932089,
        23.025205227045
    ],
    [
        112.95112291656,
        23.025407213055
    ],
    [
        112.95141536353,
        23.025590241465
    ],
    [
        112.95132040833,
        23.025688171104
    ],
    [
        112.95137051407,
        23.025724755907
    ],
    [
        112.95139420689,
        23.025744970368
    ],
    [
        112.95140428433,
        23.025755921622
    ],
    [
        112.95141708514,
        23.025769268055
    ],
    [
        112.95142253212,
        23.025774601043
    ],
    [
        112.95142960564,
        23.025766341403
    ],
    [
        112.9514532852,
        23.02575969734
    ],
    [
        112.95208301314,
        23.025367728448
    ],
    [
        112.95218751907,
        23.025307870921
    ],
    [
        112.9522190862,
        23.025284537861
    ],
    [
        112.95261753017,
        23.02507526542
    ],
    [
        112.95307339229,
        23.024797141707
    ],
    [
        112.95307856066,
        23.02478809906
    ],
    [
        112.95311802794,
        23.024773033592
    ],
    [
        112.95311503252,
        23.02477118667
    ],
    [
        112.95310958785,
        23.024771281437
    ],
    [
        112.95311122223,
        23.024773423346
    ],
    [
        112.95321192115,
        23.0247106286
    ],
    [
        112.95332086884,
        23.024828099225
    ],
    [
        112.95343203322,
        23.025027189341
    ],
    [
        112.95343423257,
        23.02507327115
    ],
    [
        112.95342089365,
        23.025074860444
    ],
    [
        112.95341001347,
        23.025094854889
    ],
    [
        112.95336891518,
        23.025115376554
    ],
    [
        112.95336048186,
        23.025128274558
    ],
    [
        112.95335422198,
        23.025131639299
    ],
    [
        112.95333491038,
        23.02516832973
    ],
    [
        112.95333464556,
        23.025184069495
    ],
    [
        112.95338258758,
        23.025243732157
    ],
    [
        112.95339321404,
        23.025263080047
    ],
    [
        112.95343597884,
        23.02531225217
    ],
    [
        112.95343353118,
        23.025317449518
    ],
    [
        112.95344062152,
        23.025342827586
    ],
    [
        112.95345506044,
        23.025364279219
    ],
    [
        112.9534937211,
        23.025370115283
    ],
    [
        112.95350270086,
        23.025361548278
    ],
    [
        112.95369375576,
        23.025241823005
    ],
    [
        112.95378638537,
        23.025383717848
    ],
    [
        112.95383024148,
        23.025436124177
    ],
    [
        112.95379160292,
        23.025476681183
    ],
    [
        112.95378835985,
        23.025525571336
    ],
    [
        112.95385212021,
        23.025639484894
    ],
    [
        112.95395074016,
        23.025777204037
    ],
    [
        112.95404932004,
        23.02583326231
    ],
    [
        112.95403463615,
        23.025867431988
    ],
    [
        112.95400498612,
        23.025915700215
    ],
    [
        112.95392771377,
        23.026003055906
    ],
    [
        112.95390159211,
        23.026029558157
    ],
    [
        112.95372263281,
        23.025838713181
    ],
    [
        112.95367988818,
        23.025832949735
    ],
    [
        112.95344583749,
        23.025981369726
    ],
    [
        112.95346848905,
        23.026090307395
    ],
    [
        112.95361119606,
        23.026194163273
    ],
    [
        112.95362998834,
        23.02620902748
    ],
    [
        112.95369617237,
        23.026265928031
    ],
    [
        112.95369890056,
        23.02627700356
    ],
    [
        112.9541787968,
        23.026663064036
    ],
    [
        112.95420276638,
        23.026685432522
    ],
    [
        112.95439344437,
        23.026880675375
    ],
    [
        112.95441169495,
        23.026899074377
    ],
    [
        112.95443240039,
        23.026925840519
    ],
    [
        112.95445582409,
        23.026944962423
    ],
    [
        112.95447189651,
        23.026962857017
    ],
    [
        112.95449341803,
        23.026988252202
    ],
    [
        112.95451112078,
        23.027000420761
    ],
    [
        112.95452065276,
        23.027006493062
    ],
    [
        112.95460918271,
        23.027095821689
    ],
    [
        112.95463860486,
        23.027130573158
    ],
    [
        112.95527389545,
        23.026384155237
    ],
    [
        112.95532943846,
        23.026392128089
    ],
    [
        112.95565588056,
        23.026420277436
    ],
    [
        112.95662377296,
        23.026498126299
    ],
    [
        112.95707273511,
        23.026536854557
    ],
    [
        112.95716217206,
        23.026286492834
    ],
    [
        112.95716081011,
        23.026285160401
    ],
    [
        112.95759611157,
        23.024554740359
    ],
    [
        112.95760800417,
        23.024358927643
    ],
    [
        112.9576766972,
        23.023238365239
    ],
    [
        112.95772667003,
        23.021223719132
    ],
    [
        112.95777338266,
        23.020798336624
    ],
    [
        112.95782707733,
        23.019897006948
    ],
    [
        112.95789519168,
        23.018656337046
    ],
    [
        112.9580284004,
        23.016286054479
    ],
    [
        112.95805643882,
        23.015934268667
    ],
    [
        112.95819942537,
        23.014485637092
    ],
    [
        112.95860651633,
        23.013617222176
    ],
    [
        112.95908773549,
        23.012503674278
    ],
    [
        112.95925278532,
        23.012121027001
    ],
    [
        112.95931243631,
        23.01197052222
    ],
    [
        112.9593546622,
        23.011834156736
    ],
    [
        112.95939796819,
        23.011741173443
    ],
    [
        112.95955483858,
        23.011466909085
    ],
    [
        112.9599993295,
        23.010660601225
    ],
    [
        112.96092652648,
        23.00897258899
    ],
    [
        112.96211682186,
        23.007183765431
    ],
    [
        112.96334068546,
        23.005364416916
    ],
    [
        112.96399736926,
        23.004524719069
    ],
    [
        112.96547388542,
        23.002628145399
    ],
    [
        112.9659271344,
        23.001998841223
    ],
    [
        112.96651463624,
        23.00122381899
    ],
    [
        112.9672150397,
        23.000094945676
    ],
    [
        112.96775688845,
        22.999223867683
    ],
    [
        112.96796226242,
        22.99893363257
    ],
    [
        112.96846901147,
        22.998391448199
    ],
    [
        112.96877152974,
        22.998064653175
    ],
    [
        112.9687750682,
        22.998062433243
    ],
    [
        112.9689076743,
        22.997917625398
    ],
    [
        112.96893925222,
        22.997892499306
    ],
    [
        112.97123830997,
        22.995918112402
    ],
    [
        112.97353115501,
        22.993856070334
    ],
    [
        112.97356217405,
        22.993829688239
    ],
    [
        112.97376408057,
        22.993643301734
    ],
    [
        112.97376163522,
        22.993641701326
    ],
    [
        112.97381061861,
        22.99359207444
    ],
    [
        112.97389932663,
        22.993508114601
    ],
    [
        112.973911295,
        22.993501475231
    ],
    [
        112.97454390638,
        22.992918141876
    ],
    [
        112.97483607823,
        22.992685957103
    ],
    [
        112.97825136009,
        22.988956672058
    ],
    [
        112.97829105944,
        22.988922474997
    ],
    [
        112.97871953905,
        22.988592287398
    ],
    [
        112.97944669353,
        22.988079664148
    ],
    [
        112.98054140151,
        22.987372314244
    ],
    [
        112.98128481414,
        22.986933449413
    ],
    [
        112.98151249095,
        22.986799748623
    ],
    [
        112.98153368137,
        22.98678825972
    ],
    [
        112.98154699344,
        22.986780875639
    ],
    [
        112.98264379996,
        22.986275708994
    ],
    [
        112.98359424293,
        22.985889731247
    ],
    [
        112.98362111891,
        22.985884233379
    ],
    [
        112.98604851752,
        22.985499274541
    ],
    [
        112.98629949159,
        22.985466907594
    ],
    [
        112.986541784,
        22.985424022138
    ]
];

let danzao = [
    [
        112.99361235109,
        23.034629496226
    ],
    [
        112.99363907224,
        23.034514359875
    ],
    [
        112.99367318026,
        23.034165671707
    ],
    [
        112.99369511544,
        23.033834270212
    ],
    [
        112.99372441857,
        23.033563420268
    ],
    [
        112.99374113616,
        23.033138384675
    ],
    [
        112.99375141426,
        23.032783577703
    ],
    [
        112.99379368785,
        23.032459910905
    ],
    [
        112.9938003556,
        23.032327284444
    ],
    [
        112.99381026036,
        23.032176230454
    ],
    [
        112.99380659164,
        23.031987646612
    ],
    [
        112.99380325113,
        23.031871775843
    ],
    [
        112.99380859647,
        23.031777395732
    ],
    [
        112.99381993358,
        23.031724294074
    ],
    [
        112.99382854577,
        23.03165028382
    ],
    [
        112.9938189825,
        23.03154305404
    ],
    [
        112.99381480633,
        23.031394349871
    ],
    [
        112.99382421011,
        23.031291043786
    ],
    [
        112.9938240508,
        23.031077795321
    ],
    [
        112.99380958767,
        23.030935535153
    ],
    [
        112.9938130051,
        23.030793664379
    ],
    [
        112.99380448914,
        23.030631909765
    ],
    [
        112.99379352901,
        23.030460372326
    ],
    [
        112.99377715594,
        23.030294497087
    ],
    [
        112.99376432179,
        23.03015143509
    ],
    [
        112.99376371562,
        23.030060272654
    ],
    [
        112.99375604286,
        23.029935693543
    ],
    [
        112.99374646099,
        23.029791839515
    ],
    [
        112.99373880523,
        23.029690050428
    ],
    [
        112.99374203107,
        23.029653716756
    ],
    [
        112.99373944614,
        23.029439098592
    ],
    [
        112.99373261719,
        23.029356035159
    ],
    [
        112.99372276571,
        23.029209195891
    ],
    [
        112.99372265481,
        23.029042886516
    ],
    [
        112.99371911018,
        23.029008407988
    ],
    [
        112.99371522786,
        23.028872460181
    ],
    [
        112.99369835897,
        23.028761387896
    ],
    [
        112.99367770518,
        23.028661686112
    ],
    [
        112.99366462431,
        23.028541957403
    ],
    [
        112.99365344645,
        23.028431736791
    ],
    [
        112.99362676715,
        23.028226461216
    ],
    [
        112.99359983158,
        23.028042075097
    ],
    [
        112.99357727954,
        23.027935038429
    ],
    [
        112.99357476068,
        23.027803713111
    ],
    [
        112.99357226098,
        23.027702773626
    ],
    [
        112.99355103285,
        23.02754230026
    ],
    [
        112.99351790749,
        23.027418919982
    ],
    [
        112.99350590688,
        23.027283194547
    ],
    [
        112.99348009446,
        23.027154707267
    ],
    [
        112.99347136535,
        23.027051830208
    ],
    [
        112.99345828875,
        23.026925865646
    ],
    [
        112.99344333457,
        23.026831902704
    ],
    [
        112.99344407887,
        23.0267109087
    ],
    [
        112.99342801675,
        23.026571903872
    ],
    [
        112.99339430541,
        23.026359810539
    ],
    [
        112.99339371064,
        23.026262682734
    ],
    [
        112.99338007614,
        23.02609873504
    ],
    [
        112.99337458964,
        23.025970920659
    ],
    [
        112.99335987317,
        23.025806153029
    ],
    [
        112.99335358274,
        23.025692170139
    ],
    [
        112.99334239411,
        23.025534749967
    ],
    [
        112.99333149267,
        23.02540744555
    ],
    [
        112.99331219728,
        23.025288228459
    ],
    [
        112.99330130032,
        23.025167164397
    ],
    [
        112.99328903293,
        23.025012180512
    ],
    [
        112.99329028662,
        23.024801664943
    ],
    [
        112.99328802236,
        23.024595468863
    ],
    [
        112.99330067949,
        23.024429516027
    ],
    [
        112.99330713579,
        23.024328364023
    ],
    [
        112.99331575102,
        23.024207149919
    ],
    [
        112.99333788816,
        23.024028777222
    ],
    [
        112.99334839516,
        23.023892654451
    ],
    [
        112.99335888652,
        23.023717466123
    ],
    [
        112.99337725202,
        23.023580578927
    ],
    [
        112.99338641398,
        23.023460726082
    ],
    [
        112.9934037121,
        23.023360185707
    ],
    [
        112.99341583692,
        23.02319369024
    ],
    [
        112.99344205258,
        23.023031352826
    ],
    [
        112.99345285975,
        23.022954646229
    ],
    [
        112.99347585239,
        23.0228617393
    ],
    [
        112.99350669722,
        23.022756132107
    ],
    [
        112.99351885398,
        23.022663428957
    ],
    [
        112.99353043939,
        23.022488251268
    ],
    [
        112.99355233654,
        23.022356816712
    ],
    [
        112.99356231669,
        23.022232360086
    ],
    [
        112.9935668871,
        23.022130657135
    ],
    [
        112.99355275895,
        23.022011201472
    ],
    [
        112.99356219434,
        23.021871278571
    ],
    [
        112.993567574,
        23.021753032799
    ],
    [
        112.99356942423,
        23.021608721373
    ],
    [
        112.99356341924,
        23.021465173858
    ],
    [
        112.99356553476,
        23.021295092628
    ],
    [
        112.99356845576,
        23.021094904457
    ],
    [
        112.99357408857,
        23.020896904286
    ],
    [
        112.99355588422,
        23.020703635407
    ],
    [
        112.99355088533,
        23.020227776796
    ],
    [
        112.99353539513,
        23.020027473587
    ],
    [
        112.99349715265,
        23.019839234456
    ],
    [
        112.99345376549,
        23.019656661465
    ],
    [
        112.99340657759,
        23.019428763274
    ],
    [
        112.99336725059,
        23.019210139789
    ],
    [
        112.99330164807,
        23.01900329235
    ],
    [
        112.9932666711,
        23.018848992546
    ],
    [
        112.99321624671,
        23.018661775674
    ],
    [
        112.99320728608,
        23.018536934424
    ],
    [
        112.99320184726,
        23.01840451906
    ],
    [
        112.99318530405,
        23.01829265354
    ],
    [
        112.99317092059,
        23.018119222138
    ],
    [
        112.99314759832,
        23.017949535237
    ],
    [
        112.99313863684,
        23.017777765152
    ],
    [
        112.99312886229,
        23.01758890038
    ],
    [
        112.99312315314,
        23.017394363724
    ],
    [
        112.9931220535,
        23.017218301602
    ],
    [
        112.99310984816,
        23.017055736848
    ],
    [
        112.99309682979,
        23.016869567089
    ],
    [
        112.99308300362,
        23.016737918358
    ],
    [
        112.99305644552,
        23.016630879872
    ],
    [
        112.9930656541,
        23.016566914881
    ],
    [
        112.99306673294,
        23.01646438134
    ],
    [
        112.99306456213,
        23.01638787044
    ],
    [
        112.99309056825,
        23.016284129249
    ],
    [
        112.99312199241,
        23.01614054474
    ],
    [
        112.99317427932,
        23.01599057674
    ],
    [
        112.99323713333,
        23.015845829843
    ],
    [
        112.99329836224,
        23.015712469866
    ],
    [
        112.99339779174,
        23.015579893533
    ],
    [
        112.99349857527,
        23.015423463126
    ],
    [
        112.99362319886,
        23.015256615596
    ],
    [
        112.99371802063,
        23.015118341446
    ],
    [
        112.99385645867,
        23.014936961496
    ],
    [
        112.99392662625,
        23.014822412919
    ],
    [
        112.99400085871,
        23.014675887006
    ],
    [
        112.99410624361,
        23.014531206698
    ],
    [
        112.99419618709,
        23.014389412973
    ],
    [
        112.99434058482,
        23.014146556841
    ],
    [
        112.99441535842,
        23.014006843811
    ],
    [
        112.99451993106,
        23.013833713643
    ],
    [
        112.99456057068,
        23.013740150608
    ],
    [
        112.99461611407,
        23.013591360279
    ],
    [
        112.99467382826,
        23.013415191388
    ],
    [
        112.99472233228,
        23.013254690757
    ],
    [
        112.99475810454,
        23.013111729888
    ],
    [
        112.99479252417,
        23.012963335065
    ],
    [
        112.99480744521,
        23.012801233076
    ],
    [
        112.9948280463,
        23.01269749458
    ],
    [
        112.99485976017,
        23.01254962467
    ],
    [
        112.99489310291,
        23.012385763874
    ],
    [
        112.99493077385,
        23.012258556752
    ],
    [
        112.99496194432,
        23.012135099296
    ],
    [
        112.99499555365,
        23.012008677549
    ],
    [
        112.99502374708,
        23.011880316768
    ],
    [
        112.99505979299,
        23.011765308534
    ],
    [
        112.99509584569,
        23.011620734699
    ],
    [
        112.99512756498,
        23.011479926281
    ],
    [
        112.99514519666,
        23.011359896485
    ],
    [
        112.99516338223,
        23.011191045553
    ],
    [
        112.99518780233,
        23.011006782143
    ],
    [
        112.99521194289,
        23.010863205443
    ],
    [
        112.99524126131,
        23.010602488555
    ],
    [
        112.99525321009,
        23.010484315791
    ],
    [
        112.99526678633,
        23.010359917239
    ],
    [
        112.99528605178,
        23.010232308643
    ],
    [
        112.99530098175,
        23.010114702718
    ],
    [
        112.99531185014,
        23.009996251372
    ],
    [
        112.99532599152,
        23.009805130838
    ],
    [
        112.99533092171,
        23.009628856879
    ],
    [
        112.99533341201,
        23.009464770233
    ],
    [
        112.99533807052,
        23.009300158481
    ],
    [
        112.99532918602,
        23.009143577559
    ],
    [
        112.99531489075,
        23.00897366313
    ],
    [
        112.99529433903,
        23.008883989429
    ],
    [
        112.99527459712,
        23.008802731204
    ],
    [
        112.99526488082,
        23.008709345733
    ],
    [
        112.99522949007,
        23.008469286148
    ],
    [
        112.99521599834,
        23.008337083612
    ],
    [
        112.99518660226,
        23.008016241581
    ],
    [
        112.99513847055,
        23.007823012862
    ],
    [
        112.99511224809,
        23.007703191282
    ],
    [
        112.9950849433,
        23.007582277123
    ],
    [
        112.99502272213,
        23.007409289057
    ],
    [
        112.99499163574,
        23.007267733988
    ],
    [
        112.9949535113,
        23.007118803029
    ],
    [
        112.99489618989,
        23.006897306981
    ],
    [
        112.99484967687,
        23.006735568402
    ],
    [
        112.99481236102,
        23.006601295892
    ],
    [
        112.99475664892,
        23.006421590945
    ],
    [
        112.99472693297,
        23.006257541288
    ],
    [
        112.99468207887,
        23.006034522096
    ],
    [
        112.99463233874,
        23.005836152272
    ],
    [
        112.9945790582,
        23.00567790274
    ],
    [
        112.9945590627,
        23.005582823898
    ],
    [
        112.99452852001,
        23.005456205593
    ],
    [
        112.99447552722,
        23.005269483306
    ],
    [
        112.9944165687,
        23.005096825676
    ],
    [
        112.99435407062,
        23.004958864774
    ],
    [
        112.99435028364,
        23.004949073461
    ],
    [
        112.9942618357,
        23.004712204274
    ],
    [
        112.99416882428,
        23.004403975494
    ],
    [
        112.99413313378,
        23.004287097892
    ],
    [
        112.99407472396,
        23.004109580624
    ],
    [
        112.99401276568,
        23.003978966344
    ],
    [
        112.99395620838,
        23.003877142776
    ],
    [
        112.99389422408,
        23.003790203821
    ],
    [
        112.99381628107,
        23.003661663878
    ],
    [
        112.99370638325,
        23.003512036032
    ],
    [
        112.99360568217,
        23.003383905357
    ],
    [
        112.99352447768,
        23.003269468892
    ],
    [
        112.99345977581,
        23.003192029752
    ],
    [
        112.99336259885,
        23.003056348406
    ],
    [
        112.99327867954,
        23.002947608768
    ],
    [
        112.99324159731,
        23.002891779246
    ],
    [
        112.99321807714,
        23.002811622312
    ],
    [
        112.99316582632,
        23.002749736126
    ],
    [
        112.99306644342,
        23.002669669913
    ],
    [
        112.99301959568,
        23.002630606178
    ],
    [
        112.99297545477,
        23.002595086279
    ],
    [
        112.99295272072,
        23.002555895737
    ],
    [
        112.9929345892,
        23.00252215712
    ],
    [
        112.99293271638,
        23.002485529848
    ],
    [
        112.99293706211,
        23.002469281238
    ],
    [
        112.9929403239,
        23.002453297556
    ],
    [
        112.99301892325,
        23.002414430022
    ],
    [
        112.9933229959,
        23.002287972327
    ],
    [
        112.99349237063,
        23.002216610684
    ],
    [
        112.99358585685,
        23.002187098228
    ],
    [
        112.99371672575,
        23.002159734803
    ],
    [
        112.99394296986,
        23.00210074545
    ],
    [
        112.99417924574,
        23.002015288945
    ],
    [
        112.99434261949,
        23.001969235176
    ],
    [
        112.99449486652,
        23.001947535144
    ],
    [
        112.99458129101,
        23.001922663215
    ],
    [
        112.99462790215,
        23.001890183316
    ],
    [
        112.99465664406,
        23.001845640185
    ],
    [
        112.99467428368,
        23.001796405367
    ],
    [
        112.99469030187,
        23.0017417343
    ],
    [
        112.99469087804,
        23.001691289597
    ],
    [
        112.99466683673,
        23.001595639987
    ],
    [
        112.99460353447,
        23.001479091214
    ],
    [
        112.9945177493,
        23.001363197557
    ],
    [
        112.99442304182,
        23.00122256483
    ],
    [
        112.99434727972,
        23.001103771792
    ],
    [
        112.99435296854,
        23.001103269478
    ],
    [
        112.99426396453,
        23.000939906974
    ],
    [
        112.99417224894,
        23.00077978751
    ],
    [
        112.99406777246,
        23.000658916601
    ],
    [
        112.99395599562,
        23.000517121583
    ],
    [
        112.99386616515,
        23.000368973564
    ],
    [
        112.99374193641,
        23.000210572086
    ],
    [
        112.99362338976,
        23.00005927263
    ],
    [
        112.99349537623,
        22.999885413904
    ],
    [
        112.99332538896,
        22.999682831237
    ],
    [
        112.99308959135,
        22.999439467258
    ],
    [
        112.99292687647,
        22.999280926645
    ],
    [
        112.99272516341,
        22.999092354155
    ],
    [
        112.99257272489,
        22.998948569014
    ],
    [
        112.99236179572,
        22.99875024716
    ],
    [
        112.99213977677,
        22.99851773413
    ],
    [
        112.99187279167,
        22.9982522271
    ],
    [
        112.99161204619,
        22.997965929307
    ],
    [
        112.99142331064,
        22.997767346962
    ],
    [
        112.99129494363,
        22.997647984326
    ],
    [
        112.9912326656,
        22.997577196714
    ],
    [
        112.99110540203,
        22.997430196338
    ],
    [
        112.99101605238,
        22.997318624706
    ],
    [
        112.99091125387,
        22.997204828531
    ],
    [
        112.99075854724,
        22.997008404504
    ],
    [
        112.99065187834,
        22.996858282414
    ],
    [
        112.99052541585,
        22.996713251384
    ],
    [
        112.99042221786,
        22.996620934605
    ],
    [
        112.99021395737,
        22.996392115203
    ],
    [
        112.99000352416,
        22.996160345487
    ],
    [
        112.9898800012,
        22.996049844003
    ],
    [
        112.98979523966,
        22.995943811426
    ],
    [
        112.98966008668,
        22.995797228138
    ],
    [
        112.98950404145,
        22.995665792907
    ],
    [
        112.98934827965,
        22.995515938059
    ],
    [
        112.98930548064,
        22.995472162213
    ],
    [
        112.98917357289,
        22.995323207181
    ],
    [
        112.98903679264,
        22.995162323551
    ],
    [
        112.98896637837,
        22.995070221385
    ],
    [
        112.98890434226,
        22.995007704759
    ],
    [
        112.98884283286,
        22.994961737113
    ],
    [
        112.98875313429,
        22.994902968099
    ],
    [
        112.98866615252,
        22.994836888972
    ],
    [
        112.98859355541,
        22.994755113266
    ],
    [
        112.98851635604,
        22.994664112738
    ],
    [
        112.98844784882,
        22.994556046264
    ],
    [
        112.9883457551,
        22.994404533394
    ],
    [
        112.98820954677,
        22.994192496319
    ],
    [
        112.98807199362,
        22.993965829128
    ],
    [
        112.98797692911,
        22.993832261798
    ],
    [
        112.98792629125,
        22.993750831715
    ],
    [
        112.98788839336,
        22.993675928823
    ],
    [
        112.98784536178,
        22.99358040877
    ],
    [
        112.98777876303,
        22.993455301132
    ],
    [
        112.98765880011,
        22.993261524615
    ],
    [
        112.98758027281,
        22.993129637015
    ],
    [
        112.98750552529,
        22.993015116292
    ],
    [
        112.98739586962,
        22.992815954264
    ],
    [
        112.98730000682,
        22.992656952694
    ],
    [
        112.98720251249,
        22.992500942178
    ],
    [
        112.98712129274,
        22.99234332161
    ],
    [
        112.98700702858,
        22.992135789836
    ],
    [
        112.98693094326,
        22.991996086131
    ],
    [
        112.98686787833,
        22.991855306614
    ],
    [
        112.98682675744,
        22.991742470972
    ],
    [
        112.98676394279,
        22.991622581196
    ],
    [
        112.98672012984,
        22.991488323388
    ],
    [
        112.9866776352,
        22.991392851064
    ],
    [
        112.98663433135,
        22.991292498567
    ],
    [
        112.9866054238,
        22.991172349721
    ],
    [
        112.98654540189,
        22.990969481929
    ],
    [
        112.98650463451,
        22.990772311808
    ],
    [
        112.98646357114,
        22.990600366156
    ],
    [
        112.98642441673,
        22.99041838705
    ],
    [
        112.98637771661,
        22.990186236505
    ],
    [
        112.98633595661,
        22.989897132533
    ],
    [
        112.98630141653,
        22.989713258805
    ],
    [
        112.98628610909,
        22.989557858302
    ],
    [
        112.98627830496,
        22.989224812373
    ],
    [
        112.98626825236,
        22.988970418684
    ],
    [
        112.98627321682,
        22.988621097008
    ],
    [
        112.98626783013,
        22.988314629776
    ],
    [
        112.98625071313,
        22.988072985578
    ],
    [
        112.98622974114,
        22.987887754843
    ],
    [
        112.98623204407,
        22.987757301623
    ],
    [
        112.98625993724,
        22.987538968404
    ],
    [
        112.98630222529,
        22.987304088398
    ],
    [
        112.98633115361,
        22.987134845999
    ],
    [
        112.98634879261,
        22.98686336019
    ],
    [
        112.98638237424,
        22.986653436637
    ],
    [
        112.98638584471,
        22.986442976492
    ],
    [
        112.98639448063,
        22.986221667083
    ],
    [
        112.98640651166,
        22.986128911105
    ],
    [
        112.98644144185,
        22.985926583116
    ],
    [
        112.98649404169,
        22.985687912589
    ],
    [
        112.98652322417,
        22.985534948016
    ],
    [
        112.98653332942,
        22.985468229762
    ],
    [
        112.98654883615,
        22.985424835592
    ],
    [
        112.98629949659,
        22.9854620258
    ],
    [
        112.98605312674,
        22.985501984414
    ],
    [
        112.98362465179,
        22.985879884385
    ],
    [
        112.98359696128,
        22.985885655616
    ],
    [
        112.98264271409,
        22.986275712925
    ],
    [
        112.9815445514,
        22.986779259637
    ],
    [
        112.9815374849,
        22.986786072477
    ],
    [
        112.98151521172,
        22.986794311813
    ],
    [
        112.98128970038,
        22.986934781811
    ],
    [
        112.98054085588,
        22.98737475813
    ],
    [
        112.97944370319,
        22.988082124335
    ],
    [
        112.9787211712,
        22.988590106177
    ],
    [
        112.97828752352,
        22.988926569439
    ],
    [
        112.97825543802,
        22.98895392951
    ],
    [
        112.97483580406,
        22.992688400804
    ],
    [
        112.97454282546,
        22.992911372834
    ],
    [
        112.9739107556,
        22.993496870486
    ],
    [
        112.97390530088,
        22.993515372301
    ],
    [
        112.97381795994,
        22.993591180411
    ],
    [
        112.97376326977,
        22.993638157601
    ],
    [
        112.97376326647,
        22.993641683402
    ],
    [
        112.97356217329,
        22.993830501886
    ],
    [
        112.97353822603,
        22.993853821775
    ],
    [
        112.97123586008,
        22.995920584485
    ],
    [
        112.96893245461,
        22.997888255599
    ],
    [
        112.96890522452,
        22.997919287271
    ],
    [
        112.96877043841,
        22.998068465717
    ],
    [
        112.96877206828,
        22.998071426008
    ],
    [
        112.96847690389,
        22.998388080348
    ],
    [
        112.96796280228,
        22.998939049089
    ],
    [
        112.96775471455,
        22.999220373813
    ],
    [
        112.96721694459,
        23.000094645898
    ],
    [
        112.96651245815,
        23.001225479716
    ],
    [
        112.96592087502,
        23.00199948124
    ],
    [
        112.96547688394,
        23.002620503697
    ],
    [
        112.96399056447,
        23.004525643992
    ],
    [
        112.96333877886,
        23.005366889616
    ],
    [
        112.96211682112,
        23.007185392885
    ],
    [
        112.96092489335,
        23.008972074602
    ],
    [
        112.95999715324,
        23.010654942794
    ],
    [
        112.95955483858,
        23.011466909085
    ],
    [
        112.95940341249,
        23.011742977081
    ],
    [
        112.95935575269,
        23.011827085065
    ],
    [
        112.95931243636,
        23.011970250965
    ],
    [
        112.95924843074,
        23.012115135576
    ],
    [
        112.95907847928,
        23.01250437893
    ],
    [
        112.95860433891,
        23.013613191538
    ],
    [
        112.95820350847,
        23.014492618025
    ],
    [
        112.95805671106,
        23.015935077672
    ],
    [
        112.9580218664,
        23.016279116641
    ],
    [
        112.95789383045,
        23.018656361045
    ],
    [
        112.9578202721,
        23.01990146744
    ],
    [
        112.95777610644,
        23.020803442952
    ],
    [
        112.95772884814,
        23.021224223275
    ],
    [
        112.95767724211,
        23.023239440786
    ],
    [
        112.95760855067,
        23.024363529988
    ],
    [
        112.9575917549,
        23.024553189485
    ],
    [
        112.95716407408,
        23.026279405457
    ],
    [
        112.95715536401,
        23.026283086228
    ],
    [
        112.95707600179,
        23.026536254236
    ],
    [
        112.95662758312,
        23.026495617248
    ],
    [
        112.9556605105,
        23.026423451255
    ],
    [
        112.95533325092,
        23.026393959909
    ],
    [
        112.95527961549,
        23.026389480302
    ],
    [
        112.95464024,
        23.027133528699
    ],
    [
        112.95461081511,
        23.027093893862
    ],
    [
        112.95452147297,
        23.027012718557
    ],
    [
        112.95451248169,
        23.026999854229
    ],
    [
        112.95449287173,
        23.026985006199
    ],
    [
        112.95447516192,
        23.026960086602
    ],
    [
        112.95445800249,
        23.02694573803
    ],
    [
        112.95443375935,
        23.026921747123
    ],
    [
        112.95440842984,
        23.026902387366
    ],
    [
        112.95438772548,
        23.026877520266
    ],
    [
        112.95420195054,
        23.026687074642
    ],
    [
        112.95417253613,
        23.02666480171
    ],
    [
        112.95369944362,
        23.026274281073
    ],
    [
        112.95369780778,
        23.026269697608
    ],
    [
        112.95362754018,
        23.026212868459
    ],
    [
        112.95361473881,
        23.026201155107
    ],
    [
        112.95347393573,
        23.02609401047
    ],
    [
        112.9534537362,
        23.025988828179
    ],
    [
        112.95367988804,
        23.02583267844
    ],
    [
        112.9537223633,
        23.025844143847
    ],
    [
        112.9538969607,
        23.026023128134
    ],
    [
        112.95392553336,
        23.025998210745
    ],
    [
        112.95401070247,
        23.025914243514
    ],
    [
        112.95403082629,
        23.025870483063
    ],
    [
        112.95404850318,
        23.025833005337
    ],
    [
        112.95394992657,
        23.025783458135
    ],
    [
        112.95385266321,
        23.025636491118
    ],
    [
        112.95378863262,
        23.025526651748
    ],
    [
        112.95379677387,
        23.025473335111
    ],
    [
        112.95382779553,
        23.025444848488
    ],
    [
        112.95379346096,
        23.025378168073
    ],
    [
        112.95369484664,
        23.025245873362
    ],
    [
        112.95350270073,
        23.025361276984
    ],
    [
        112.95349671375,
        23.025365993578
    ],
    [
        112.95345315713,
        23.025369195778
    ],
    [
        112.9534479715,
        23.025341885393
    ],
    [
        112.95343407656,
        23.025319339071
    ],
    [
        112.9534294457,
        23.025313451388
    ],
    [
        112.95339321095,
        23.025256569
    ],
    [
        112.95337959337,
        23.025244598285
    ],
    [
        112.9533319241,
        23.025186016027
    ],
    [
        112.95333518427,
        23.025171851796
    ],
    [
        112.95335857635,
        23.025128579093
    ],
    [
        112.95335939203,
        23.0251263945
    ],
    [
        112.95337544959,
        23.025116890328
    ],
    [
        112.9534040215,
        23.025088990956
    ],
    [
        112.95342497858,
        23.025077773397
    ],
    [
        112.95343232553,
        23.025070320188
    ],
    [
        112.95343012581,
        23.025023424502
    ],
    [
        112.95332604105,
        23.02482746644
    ],
    [
        112.95321655022,
        23.024712989602
    ],
    [
        112.95310985837,
        23.024767478607
    ],
    [
        112.95311421618,
        23.024772014762
    ],
    [
        112.95311176388,
        23.024767174146
    ],
    [
        112.95311067813,
        23.0247742467
    ],
    [
        112.95307638415,
        23.024791121171
    ],
    [
        112.95307747369,
        23.024792458685
    ],
    [
        112.95261290128,
        23.025073175228
    ],
    [
        112.95222262808,
        23.025290716592
    ],
    [
        112.95218588573,
        23.025307899074
    ],
    [
        112.95207974894,
        23.025372939265
    ],
    [
        112.95145627889,
        23.02575828974
    ],
    [
        112.95142797519,
        23.025772066472
    ],
    [
        112.95142906472,
        23.025773404362
    ],
    [
        112.9514208956,
        23.025768117839
    ],
    [
        112.95140918418,
        23.025755838019
    ],
    [
        112.95138876288,
        23.02574560583
    ],
    [
        112.95137351259,
        23.025733114979
    ],
    [
        112.95132122457,
        23.025687343303
    ],
    [
        112.9514115528,
        23.025590849085
    ],
    [
        112.95112155538,
        23.025406964888
    ],
    [
        112.95085986849,
        23.025212000166
    ],
    [
        112.95070729001,
        23.025484247405
    ],
    [
        112.95059538822,
        23.025431604341
    ],
    [
        112.9504001484,
        23.025284319884
    ],
    [
        112.950396064,
        23.025281404233
    ],
    [
        112.95025964497,
        23.025182228221
    ],
    [
        112.95013137469,
        23.025042487674
    ],
    [
        112.94991117143,
        23.025048060718
    ],
    [
        112.94974239209,
        23.025003661268
    ],
    [
        112.94965553833,
        23.024948401053
    ],
    [
        112.94966479094,
        23.024944449596
    ],
    [
        112.9496198303,
        23.024835320133
    ],
    [
        112.94971257114,
        23.024666394606
    ],
    [
        112.94973294943,
        23.024584939659
    ],
    [
        112.94950128148,
        23.024502504239
    ],
    [
        112.94926336298,
        23.02443317615
    ],
    [
        112.94921462682,
        23.02439653857
    ],
    [
        112.94912097158,
        23.024337034389
    ],
    [
        112.94905182004,
        23.024293946391
    ],
    [
        112.94893665959,
        23.024223122641
    ],
    [
        112.94884383405,
        23.024189368753
    ],
    [
        112.94872788206,
        23.02417335049
    ],
    [
        112.94855287004,
        23.024155842514
    ],
    [
        112.94838576414,
        23.024164782361
    ],
    [
        112.94823500046,
        23.0241986793
    ],
    [
        112.94807281426,
        23.024247400176
    ],
    [
        112.94800615611,
        23.024295128598
    ],
    [
        112.94795146736,
        23.024329099664
    ],
    [
        112.94777313617,
        23.024159668546
    ],
    [
        112.94775952434,
        23.024149304369
    ],
    [
        112.94772440823,
        23.024128158459
    ],
    [
        112.94768057929,
        23.024096841067
    ],
    [
        112.94761470322,
        23.024057190512
    ],
    [
        112.94748348687,
        23.023953730691
    ],
    [
        112.94740916959,
        23.023898744077
    ],
    [
        112.94737132871,
        23.02386597046
    ],
    [
        112.94721588667,
        23.023739274573
    ],
    [
        112.94714292984,
        23.023677747434
    ],
    [
        112.94681599479,
        23.023405573583
    ],
    [
        112.94679258962,
        23.023399696134
    ],
    [
        112.94676999667,
        23.023382682998
    ],
    [
        112.94673570122,
        23.023362594941
    ],
    [
        112.94670303802,
        23.023340853437
    ],
    [
        112.94666030531,
        23.023316282481
    ],
    [
        112.94662383219,
        23.023293242089
    ],
    [
        112.94660341958,
        23.023284061111
    ],
    [
        112.94657701725,
        23.023266562063
    ],
    [
        112.94654190577,
        23.02324539842
    ],
    [
        112.94651767907,
        23.023223795913
    ],
    [
        112.94655739108,
        23.023175981772
    ],
    [
        112.94671244031,
        23.02300810775
    ],
    [
        112.94680003481,
        23.0229237397
    ],
    [
        112.94687156223,
        23.02280353617
    ],
    [
        112.9467964397,
        23.022759665948
    ],
    [
        112.94669055492,
        23.022678558958
    ],
    [
        112.94628582192,
        23.022404253644
    ],
    [
        112.94599241634,
        23.022183808225
    ],
    [
        112.94588110001,
        23.022102472683
    ],
    [
        112.94567371681,
        23.021963700341
    ],
    [
        112.94552675612,
        23.021867143625
    ],
    [
        112.94527789448,
        23.022194201974
    ],
    [
        112.94526919333,
        23.02221196388
    ],
    [
        112.94526592814,
        23.022211469445
    ],
    [
        112.94514890242,
        23.022117969728
    ],
    [
        112.94497935429,
        23.021981553365
    ],
    [
        112.94494479203,
        23.021953843788
    ],
    [
        112.94493498183,
        23.021902713838
    ],
    [
        112.94505439439,
        23.021802764924
    ],
    [
        112.94509899985,
        23.021749211133
    ],
    [
        112.94514713855,
        23.021681226394
    ],
    [
        112.9451803166,
        23.021625396981
    ],
    [
        112.94520860144,
        23.021583745819
    ],
    [
        112.94517185223,
        23.021520534373
    ],
    [
        112.94525941415,
        23.021342368736
    ],
    [
        112.94537258333,
        23.021271520243
    ],
    [
        112.94556028173,
        23.021102166391
    ],
    [
        112.94564623886,
        23.021005121867
    ],
    [
        112.9457251209,
        23.020901126398
    ],
    [
        112.94586711428,
        23.020725375181
    ],
    [
        112.94578111762,
        23.020672410509
    ],
    [
        112.94549728759,
        23.020528256964
    ],
    [
        112.94519577757,
        23.02036641902
    ],
    [
        112.94515359848,
        23.020338283134
    ],
    [
        112.94494434069,
        23.020205704624
    ],
    [
        112.94489372132,
        23.02014269103
    ],
    [
        112.94492445413,
        23.020086359999
    ],
    [
        112.94509061823,
        23.019700615176
    ],
    [
        112.94511697998,
        23.019535020324
    ],
    [
        112.9450386155,
        23.019504428523
    ],
    [
        112.94495970884,
        23.01948116596
    ],
    [
        112.94486094368,
        23.01947066764
    ],
    [
        112.94483645609,
        23.019465055249
    ],
    [
        112.94488377023,
        23.019307298023
    ],
    [
        112.94489056949,
        23.019291465041
    ],
    [
        112.94489410418,
        23.01927757848
    ],
    [
        112.94461032768,
        23.019235297915
    ],
    [
        112.94439239978,
        23.019202072238
    ],
    [
        112.94436165709,
        23.019202239792
    ],
    [
        112.94421800973,
        23.019193432348
    ],
    [
        112.94403817995,
        23.019171017259
    ],
    [
        112.94377374844,
        23.019146238868
    ],
    [
        112.94375008735,
        23.019187260025
    ],
    [
        112.94373161933,
        23.019375783365
    ],
    [
        112.94372510826,
        23.019480587066
    ],
    [
        112.94370308589,
        23.019553595732
    ],
    [
        112.9436835001,
        23.019559022124
    ],
    [
        112.9435907329,
        23.019543488764
    ],
    [
        112.9433554193,
        23.019506036606
    ],
    [
        112.94310950547,
        23.019479275723
    ],
    [
        112.94303986765,
        23.019472622387
    ],
    [
        112.94276186521,
        23.0194394621
    ],
    [
        112.94249611441,
        23.01941857236
    ],
    [
        112.94226164932,
        23.019385295402
    ],
    [
        112.9420492224,
        23.019354955275
    ],
    [
        112.94193090564,
        23.019325009673
    ],
    [
        112.94192301813,
        23.019324297026
    ],
    [
        112.94182836588,
        23.019298651751
    ],
    [
        112.94165647648,
        23.019281304627
    ],
    [
        112.94158195343,
        23.019257559761
    ],
    [
        112.94155012525,
        23.019206146846
    ],
    [
        112.94144649948,
        23.019157261501
    ],
    [
        112.9412634657,
        23.01911993566
    ],
    [
        112.94117208688,
        23.01910370428
    ],
    [
        112.94110926374,
        23.01908684521
    ],
    [
        112.94106139998,
        23.019081464988
    ],
    [
        112.94100809718,
        23.019073165737
    ],
    [
        112.94091699735,
        23.019082686724
    ],
    [
        112.94085526799,
        23.019091303681
    ],
    [
        112.94078837227,
        23.019099437963
    ],
    [
        112.94073697639,
        23.019100329377
    ],
    [
        112.94071712642,
        23.019108977972
    ],
    [
        112.94055939803,
        23.019056341312
    ],
    [
        112.94054824813,
        23.019050777469
    ],
    [
        112.94042125175,
        23.019003727418
    ],
    [
        112.94026978398,
        23.018948815305
    ],
    [
        112.94011695754,
        23.018875727717
    ],
    [
        112.94001281135,
        23.018841668677
    ],
    [
        112.93998235741,
        23.01883930737
    ],
    [
        112.93993069555,
        23.01884098718
    ],
    [
        112.93986055483,
        23.018915849827
    ],
    [
        112.93974964552,
        23.019093986644
    ],
    [
        112.93969883513,
        23.01931456849
    ],
    [
        112.93966405482,
        23.019449515543
    ],
    [
        112.93960314749,
        23.01943012828
    ],
    [
        112.93946882949,
        23.019402065318
    ],
    [
        112.93929400246,
        23.019364671309
    ],
    [
        112.93913195749,
        23.019323860394
    ],
    [
        112.93858902665,
        23.019182651203
    ],
    [
        112.93814781867,
        23.019125371116
    ],
    [
        112.93803881276,
        23.019112371517
    ],
    [
        112.93781074813,
        23.019079120773
    ],
    [
        112.93791888506,
        23.01873460684
    ],
    [
        112.93797757511,
        23.01854168367
    ],
    [
        112.93803219464,
        23.018388676704
    ],
    [
        112.93811480529,
        23.018144778105
    ],
    [
        112.93816752773,
        23.018006976792
    ],
    [
        112.93826346931,
        23.017816916946
    ],
    [
        112.93829961717,
        23.01773272175
    ],
    [
        112.93834174473,
        23.017629203554
    ],
    [
        112.93840724964,
        23.017495330377
    ],
    [
        112.93846487249,
        23.017358823741
    ],
    [
        112.93852684634,
        23.017221184174
    ],
    [
        112.93857849072,
        23.017065204291
    ],
    [
        112.93865242727,
        23.016862057644
    ],
    [
        112.93871576552,
        23.016711646112
    ],
    [
        112.93875925974,
        23.016545709818
    ],
    [
        112.93875654115,
        23.016544111161
    ],
    [
        112.93877747334,
        23.016461151345
    ],
    [
        112.93879731843,
        23.016336698952
    ],
    [
        112.93887072127,
        23.016169083752
    ],
    [
        112.93893651448,
        23.015985270991
    ],
    [
        112.93902922713,
        23.015729820781
    ],
    [
        112.93912656464,
        23.015513647968
    ],
    [
        112.93925979607,
        23.015255841708
    ],
    [
        112.93936747741,
        23.014987999055
    ],
    [
        112.93944525246,
        23.014772836319
    ],
    [
        112.9394740769,
        23.014717990871
    ],
    [
        112.93950779999,
        23.014613720308
    ],
    [
        112.93953254756,
        23.014551052788
    ],
    [
        112.93956191618,
        23.01450243859
    ],
    [
        112.93959509295,
        23.014439404076
    ],
    [
        112.93976451159,
        23.014171379612
    ],
    [
        112.9398101971,
        23.014114165649
    ],
    [
        112.93986920835,
        23.014039437064
    ],
    [
        112.93995024581,
        23.013955229959
    ],
    [
        112.93998940645,
        23.013905680726
    ],
    [
        112.94007370941,
        23.013816817659
    ],
    [
        112.94017432972,
        23.013719621724
    ],
    [
        112.94020750656,
        23.013695363565
    ],
    [
        112.94035572254,
        23.013547957736
    ],
    [
        112.94052733212,
        23.013376387964
    ],
    [
        112.94058254175,
        23.013323376745
    ],
    [
        112.94074137325,
        23.013179060707
    ],
    [
        112.94075470097,
        23.013161539536
    ],
    [
        112.94086377079,
        23.01302649017
    ],
    [
        112.94090703329,
        23.012891149856
    ],
    [
        112.94093723065,
        23.012826223164
    ],
    [
        112.94094106249,
        23.012695159626
    ],
    [
        112.94096967334,
        23.012409449639
    ],
    [
        112.94095745219,
        23.012331477244
    ],
    [
        112.94094524566,
        23.012187589735
    ],
    [
        112.94093739944,
        23.012007843699
    ],
    [
        112.94092652914,
        23.011975696861
    ],
    [
        112.94090239641,
        23.01168059539
    ],
    [
        112.94088556746,
        23.011554396077
    ],
    [
        112.9408771656,
        23.01144328458
    ],
    [
        112.94088211773,
        23.011225680304
    ],
    [
        112.94083215298,
        23.010964528817
    ],
    [
        112.94081372053,
        23.010758330251
    ],
    [
        112.94077055062,
        23.010531002014
    ],
    [
        112.9407580999,
        23.010342633968
    ],
    [
        112.94077040614,
        23.010126300242
    ],
    [
        112.94080147433,
        23.009921946338
    ],
    [
        112.94084777474,
        23.009713338959
    ],
    [
        112.94086955405,
        23.009643635529
    ],
    [
        112.94090358427,
        23.009536350869
    ],
    [
        112.94091609993,
        23.009518296349
    ],
    [
        112.94094688237,
        23.00937063468
    ],
    [
        112.94099396903,
        23.009259662885
    ],
    [
        112.94101819584,
        23.009195352637
    ],
    [
        112.94107319435,
        23.0090210816
    ],
    [
        112.94112982341,
        23.008854654905
    ],
    [
        112.94118072953,
        23.0087230163
    ],
    [
        112.94117855209,
        23.008727654329
    ],
    [
        112.94124550733,
        23.008589034456
    ],
    [
        112.94128636415,
        23.008431748999
    ],
    [
        112.94136556838,
        23.00827398517
    ],
    [
        112.94138112112,
        23.008152274455
    ],
    [
        112.94143367187,
        23.008005147058
    ],
    [
        112.94146746009,
        23.007854998435
    ],
    [
        112.94149279761,
        23.007752422616
    ],
    [
        112.94150291833,
        23.007622099776
    ],
    [
        112.94152878985,
        23.007544199827
    ],
    [
        112.94152962212,
        23.007508114336
    ],
    [
        112.94152718458,
        23.00748590324
    ],
    [
        112.94151039504,
        23.007329065969
    ],
    [
        112.94148271699,
        23.007196234475
    ],
    [
        112.94146755194,
        23.007059448552
    ],
    [
        112.94143445861,
        23.006881116245
    ],
    [
        112.94140594085,
        23.006803355939
    ],
    [
        112.94134234027,
        23.006727388536
    ],
    [
        112.94127247186,
        23.006679162618
    ],
    [
        112.94117294738,
        23.00665977974
    ],
    [
        112.94110959064,
        23.006645370784
    ],
    [
        112.94106881613,
        23.006610339394
    ],
    [
        112.94104932395,
        23.006435358655
    ],
    [
        112.94103311154,
        23.006231315422
    ],
    [
        112.94103973557,
        23.006044080773
    ],
    [
        112.94101315013,
        23.005920722332
    ],
    [
        112.94097893873,
        23.005820511766
    ],
    [
        112.94096455947,
        23.005757760494
    ],
    [
        112.94092846711,
        23.005617700239
    ],
    [
        112.94089782167,
        23.005464825052
    ],
    [
        112.94086719272,
        23.005284554552
    ],
    [
        112.9408213484,
        23.005084125406
    ],
    [
        112.94080999921,
        23.004957867672
    ],
    [
        112.94080683311,
        23.004789741108
    ],
    [
        112.94079578896,
        23.004610047025
    ],
    [
        112.94074992764,
        23.004448945875
    ],
    [
        112.94070352193,
        23.004291104878
    ],
    [
        112.94068812317,
        23.004124211073
    ],
    [
        112.94067516433,
        23.003971392106
    ],
    [
        112.94070190951,
        23.003816740286
    ],
    [
        112.94075395874,
        23.003641169799
    ],
    [
        112.94077496963,
        23.00352754202
    ],
    [
        112.94078974067,
        23.003392019838
    ],
    [
        112.94081787597,
        23.003196936768
    ],
    [
        112.94086393935,
        23.003034454835
    ],
    [
        112.94088328901,
        23.002970481176
    ],
    [
        112.9409217037,
        23.002862607593
    ],
    [
        112.94097919339,
        23.002697271215
    ],
    [
        112.94103749221,
        23.00254412822
    ],
    [
        112.94108494773,
        23.002342566646
    ],
    [
        112.94112997134,
        23.00212123431
    ],
    [
        112.94117198991,
        23.001922449917
    ],
    [
        112.94121862806,
        23.001731201901
    ],
    [
        112.94126576257,
        23.001608837903
    ],
    [
        112.94134365495,
        23.001450017021
    ],
    [
        112.94141500888,
        23.001309446165
    ],
    [
        112.94148314592,
        23.001107073299
    ],
    [
        112.94154066365,
        23.000924901931
    ],
    [
        112.94159736351,
        23.000747621036
    ],
    [
        112.94166056893,
        23.000601175473
    ],
    [
        112.94174826165,
        23.000443025092
    ],
    [
        112.94182453707,
        23.000280133696
    ],
    [
        112.94190245231,
        23.000109081128
    ],
    [
        112.9419414495,
        22.999973241283
    ],
    [
        112.94200989631,
        22.999741009221
    ],
    [
        112.94205816901,
        22.999572229654
    ],
    [
        112.94209417383,
        22.999441307206
    ],
    [
        112.94220969662,
        22.99918757414
    ],
    [
        112.94228321587,
        22.999084095285
    ],
    [
        112.94237389933,
        22.998946214607
    ],
    [
        112.94241152066,
        22.998839403017
    ],
    [
        112.94248728498,
        22.998655062281
    ],
    [
        112.94250829837,
        22.998569893694
    ],
    [
        112.94257585858,
        22.998442070883
    ],
    [
        112.94261074596,
        22.998355361428
    ],
    [
        112.94266393962,
        22.998170227152
    ],
    [
        112.94276498901,
        22.99800669343
    ],
    [
        112.94282221568,
        22.997880897382
    ],
    [
        112.94290419712,
        22.997753682406
    ],
    [
        112.94301566814,
        22.997496152793
    ],
    [
        112.94319492391,
        22.997181553911
    ],
    [
        112.94324563138,
        22.997052035746
    ],
    [
        112.94333661629,
        22.996902438005
    ],
    [
        112.94346328658,
        22.996697559474
    ],
    [
        112.94356413236,
        22.99647539986
    ],
    [
        112.94365186464,
        22.996319050606
    ],
    [
        112.94370622337,
        22.996067422344
    ],
    [
        112.94375970282,
        22.99588821925
    ],
    [
        112.94387776278,
        22.995591490235
    ],
    [
        112.94401129006,
        22.995341727519
    ],
    [
        112.94414369631,
        22.995131568191
    ],
    [
        112.94419738367,
        22.995029374503
    ],
    [
        112.94432874995,
        22.994771754523
    ],
    [
        112.94438458954,
        22.994697730981
    ],
    [
        112.94440826943,
        22.994685730715
    ],
    [
        112.94449002383,
        22.99453783506
    ],
    [
        112.94453995012,
        22.994388223427
    ],
    [
        112.94458795517,
        22.994257351828
    ],
    [
        112.94465744841,
        22.99413213602
    ],
    [
        112.94472401993,
        22.993932647969
    ],
    [
        112.94469031972,
        22.993894893961
    ],
    [
        112.94470211233,
        22.993795731495
    ],
    [
        112.9446719466,
        22.993760638241
    ],
    [
        112.94458707001,
        22.993753724474
    ],
    [
        112.94453890351,
        22.993766349854
    ],
    [
        112.94444585504,
        22.993771480241
    ],
    [
        112.94439033704,
        22.993791258407
    ],
    [
        112.94435089387,
        22.993786396814
    ],
    [
        112.94431825046,
        22.993783336064
    ],
    [
        112.9441781418,
        22.993786410096
    ],
    [
        112.94405900746,
        22.993763412736
    ],
    [
        112.94403234784,
        22.993762703402
    ],
    [
        112.94383732114,
        22.993735062648
    ],
    [
        112.94376822276,
        22.993736297707
    ],
    [
        112.94364472784,
        22.99372770753
    ],
    [
        112.94337597788,
        22.993714324988
    ],
    [
        112.94331042136,
        22.993713594829
    ],
    [
        112.94315565191,
        22.9937043119
    ],
    [
        112.9430881961,
        22.993700344418
    ],
    [
        112.94299299101,
        22.993701359058
    ],
    [
        112.94292254492,
        22.993696882801
    ],
    [
        112.94285836519,
        22.993682284804
    ],
    [
        112.94279879204,
        22.99368660759
    ],
    [
        112.94273705076,
        22.993683091988
    ],
    [
        112.94245200474,
        22.99367601665
    ],
    [
        112.94234566915,
        22.993662765992
    ],
    [
        112.94227305903,
        22.993651781057
    ],
    [
        112.94213679692,
        22.993650026171
    ],
    [
        112.94190914063,
        22.993661908727
    ],
    [
        112.94155857467,
        22.993662291804
    ],
    [
        112.94144653068,
        22.993659087141
    ],
    [
        112.94137310956,
        22.993651867648
    ],
    [
        112.94130784652,
        22.993645899376
    ],
    [
        112.94113951729,
        22.993638488431
    ],
    [
        112.94109518872,
        22.993640118304
    ],
    [
        112.94084119282,
        22.993644843253
    ],
    [
        112.9406744896,
        22.993654446716
    ],
    [
        112.94058067355,
        22.993655840565
    ],
    [
        112.94050073334,
        22.993650283346
    ],
    [
        112.9404564314,
        22.993628027187
    ],
    [
        112.9403719196,
        22.993570444424
    ],
    [
        112.94029556793,
        22.99351113372
    ],
    [
        112.94024066964,
        22.993481672628
    ],
    [
        112.94010940514,
        22.993410789065
    ],
    [
        112.94005397051,
        22.993375089226
    ],
    [
        112.93994175563,
        22.993290680429
    ],
    [
        112.93981188388,
        22.993191276395
    ],
    [
        112.93978634243,
        22.993173938624
    ],
    [
        112.93961432829,
        22.993077436468
    ],
    [
        112.93955375683,
        22.993016009872
    ],
    [
        112.93953990416,
        22.993002062215
    ],
    [
        112.93949237033,
        22.992954589775
    ],
    [
        112.93933186567,
        22.992772492852
    ],
    [
        112.93900533617,
        22.992228490555
    ],
    [
        112.93877032329,
        22.991804399506
    ],
    [
        112.93857462361,
        22.991496747322
    ],
    [
        112.93831160198,
        22.99110243293
    ],
    [
        112.93818368988,
        22.990981158362
    ],
    [
        112.93788664913,
        22.990918796359
    ],
    [
        112.93760970828,
        22.990883834177
    ],
    [
        112.93692642061,
        22.990889245917
    ],
    [
        112.93668615721,
        22.990907173483
    ],
    [
        112.93636106259,
        22.990978689822
    ],
    [
        112.93623736878,
        22.991026961653
    ],
    [
        112.9362049962,
        22.991061957502
    ],
    [
        112.93581161763,
        22.991513343406
    ],
    [
        112.93530310434,
        22.992200120263
    ],
    [
        112.93508169345,
        22.992453540079
    ],
    [
        112.9350572083,
        22.992487088545
    ],
    [
        112.93505448686,
        22.992491720167
    ],
    [
        112.93493979022,
        22.992536265752
    ],
    [
        112.93477480545,
        22.992611011444
    ],
    [
        112.93460767682,
        22.992660256216
    ],
    [
        112.93459925573,
        22.992659504454
    ],
    [
        112.93440415724,
        22.992702145398
    ],
    [
        112.93431639472,
        22.992718773722
    ],
    [
        112.9340647747,
        22.992790507339
    ],
    [
        112.93383570113,
        22.9928728848
    ],
    [
        112.93361698254,
        22.992930469707
    ],
    [
        112.9334172767,
        22.992997114402
    ],
    [
        112.93331755372,
        22.993039237444
    ],
    [
        112.93314853359,
        22.993122458794
    ],
    [
        112.93299963564,
        22.993186008031
    ],
    [
        112.93289177135,
        22.993229227708
    ],
    [
        112.93271677221,
        22.99333032081
    ],
    [
        112.93259203109,
        22.993419986213
    ],
    [
        112.93248007006,
        22.993495735672
    ],
    [
        112.93237436157,
        22.99356710082
    ],
    [
        112.93219909193,
        22.993684660045
    ],
    [
        112.93206892137,
        22.993785416534
    ],
    [
        112.93195262665,
        22.99386113638
    ],
    [
        112.93183034592,
        22.993952333066
    ],
    [
        112.93175860613,
        22.994009098002
    ],
    [
        112.93169448517,
        22.994050091237
    ],
    [
        112.93154206457,
        22.99414818199
    ],
    [
        112.93142308753,
        22.994201348978
    ],
    [
        112.93133859563,
        22.994254348467
    ],
    [
        112.93105855514,
        22.994376808029
    ],
    [
        112.9309884837,
        22.994402869342
    ],
    [
        112.9309873972,
        22.994403416325
    ],
    [
        112.93088826095,
        22.994446408054
    ],
    [
        112.93071666787,
        22.994459303224
    ],
    [
        112.93071259101,
        22.994464201172
    ],
    [
        112.93070661961,
        22.994462868627
    ],
    [
        112.93045251622,
        22.994463026341
    ],
    [
        112.93008280936,
        22.994436671159
    ],
    [
        112.92971283707,
        22.99443080473
    ],
    [
        112.92960997225,
        22.994422433173
    ],
    [
        112.92947506458,
        22.994432042869
    ],
    [
        112.9293420625,
        22.994439189837
    ],
    [
        112.9291995527,
        22.994458820914
    ],
    [
        112.92916426554,
        22.994463250285
    ],
    [
        112.92914526019,
        22.994470621055
    ],
    [
        112.92902721061,
        22.994459249288
    ],
    [
        112.9289460752,
        22.994445880756
    ],
    [
        112.92883481149,
        22.994437998063
    ],
    [
        112.92867606098,
        22.994426949368
    ],
    [
        112.9285058821,
        22.994453598445
    ],
    [
        112.92841577348,
        22.994467871492
    ],
    [
        112.92825484015,
        22.994482801838
    ],
    [
        112.92789150914,
        22.994473592891
    ],
    [
        112.92776558987,
        22.99449274176
    ],
    [
        112.92761280161,
        22.99452302571
    ],
    [
        112.92748822884,
        22.994560040996
    ],
    [
        112.92736119893,
        22.99461657158
    ],
    [
        112.92721763649,
        22.994657911421
    ],
    [
        112.92707001505,
        22.994692182986
    ],
    [
        112.92693622006,
        22.994741073544
    ],
    [
        112.9268341722,
        22.994786681349
    ],
    [
        112.92676984972,
        22.994816266365
    ],
    [
        112.92669111864,
        22.994879753213
    ],
    [
        112.92661456835,
        22.994933198952
    ],
    [
        112.92654016381,
        22.995014303113
    ],
    [
        112.92643290341,
        22.995131745917
    ],
    [
        112.92634599822,
        22.995240500884
    ],
    [
        112.9262884097,
        22.995328640555
    ],
    [
        112.92622751356,
        22.995475088255
    ],
    [
        112.92615059813,
        22.995639700227
    ],
    [
        112.92609487962,
        22.995762817288
    ],
    [
        112.92607825671,
        22.995847431945
    ],
    [
        112.92610202288,
        22.995962435641
    ],
    [
        112.92612527211,
        22.996049503288
    ],
    [
        112.92616611448,
        22.996179698509
    ],
    [
        112.92621185306,
        22.996295518673
    ],
    [
        112.92624187461,
        22.996394247649
    ],
    [
        112.92625835747,
        22.996466123203
    ],
    [
        112.92631221135,
        22.996609333571
    ],
    [
        112.9263514702,
        22.996693414751
    ],
    [
        112.92650230462,
        22.996991484058
    ],
    [
        112.92656050869,
        22.99712871523
    ],
    [
        112.92661350596,
        22.997328053595
    ],
    [
        112.92665949963,
        22.997471519805
    ],
    [
        112.92669062935,
        22.997550166341
    ],
    [
        112.92673691237,
        22.997674372708
    ],
    [
        112.92678374529,
        22.997790982813
    ],
    [
        112.92679455665,
        22.997838171508
    ],
    [
        112.92682648538,
        22.997936341891
    ],
    [
        112.92685571885,
        22.998014170905
    ],
    [
        112.92686138713,
        22.998048342441
    ],
    [
        112.92673631272,
        22.998061675918
    ],
    [
        112.92657137235,
        22.998064694709
    ],
    [
        112.92651521391,
        22.998070396624
    ],
    [
        112.92640912789,
        22.998093725495
    ],
    [
        112.92631933022,
        22.99810456944
    ],
    [
        112.9262751158,
        22.998103208172
    ],
    [
        112.92620703068,
        22.998102383007
    ],
    [
        112.92604184105,
        22.998098811333
    ],
    [
        112.92597348723,
        22.998098513747
    ],
    [
        112.9259585533,
        22.99811695045
    ],
    [
        112.92592593408,
        22.998200472041
    ],
    [
        112.92591501727,
        22.998280748488
    ],
    [
        112.92589570306,
        22.998348002151
    ],
    [
        112.92587093996,
        22.99844454467
    ],
    [
        112.92585513845,
        22.998528615235
    ],
    [
        112.92586026934,
        22.998556011344
    ],
    [
        112.92585481478,
        22.99859208101
    ],
    [
        112.92586264157,
        22.998639548974
    ],
    [
        112.92587699358,
        22.998668305889
    ],
    [
        112.92589053127,
        22.998697875883
    ],
    [
        112.92589104324,
        22.998735033585
    ],
    [
        112.92589559944,
        22.998802027746
    ],
    [
        112.92589663673,
        22.998860341083
    ],
    [
        112.92589389689,
        22.998893971338
    ],
    [
        112.92588572632,
        22.998934921912
    ],
    [
        112.925887309,
        22.998989980909
    ],
    [
        112.92584796436,
        22.999008403793
    ],
    [
        112.9258034716,
        22.999020584171
    ],
    [
        112.92574704166,
        22.999036823638
    ],
    [
        112.92569466146,
        22.999076930513
    ],
    [
        112.92567186413,
        22.99909427314
    ],
    [
        112.92561434766,
        22.999114302032
    ],
    [
        112.92557120864,
        22.999131898307
    ],
    [
        112.92553132728,
        22.99914624088
    ],
    [
        112.92549629911,
        22.999196658845
    ],
    [
        112.92548460567,
        22.99923516243
    ],
    [
        112.92548348659,
        22.999277743518
    ],
    [
        112.92549458659,
        22.999302705685
    ],
    [
        112.92552086023,
        22.999346123742
    ],
    [
        112.92554416059,
        22.999377062467
    ],
    [
        112.92553736811,
        22.999391974204
    ],
    [
        112.925509131,
        22.999429650722
    ],
    [
        112.92543096645,
        22.999496845119
    ],
    [
        112.92535878559,
        22.999544240463
    ],
    [
        112.92532136113,
        22.999540676964
    ],
    [
        112.92529505501,
        22.999539022422
    ],
    [
        112.92524322817,
        22.999571785053
    ],
    [
        112.92522692978,
        22.9996045852
    ],
    [
        112.92521904528,
        22.999629257814
    ],
    [
        112.92521114412,
        22.999675085839
    ],
    [
        112.92519836691,
        22.999713856464
    ],
    [
        112.92516686137,
        22.999772133448
    ],
    [
        112.92512913084,
        22.999814671068
    ],
    [
        112.92511257462,
        22.999831195769
    ],
    [
        112.92506970134,
        22.999861519964
    ],
    [
        112.92503253819,
        22.999873135345
    ],
    [
        112.92498995863,
        22.999875520626
    ],
    [
        112.9249251307,
        22.999891977237
    ],
    [
        112.92489960685,
        22.999932896412
    ],
    [
        112.92488951793,
        23.000003400559
    ],
    [
        112.92489246668,
        23.000047614405
    ],
    [
        112.92487891165,
        23.000041899362
    ],
    [
        112.9248751167,
        23.000039724123
    ],
    [
        112.92477156553,
        22.99998586802
    ],
    [
        112.92476424612,
        22.99998260209
    ],
    [
        112.92467994365,
        22.999937988286
    ],
    [
        112.92461623872,
        22.99991021854
    ],
    [
        112.92450834501,
        22.99986799261
    ],
    [
        112.92445222276,
        22.999855686439
    ],
    [
        112.92438662378,
        22.999826272358
    ],
    [
        112.92434134416,
        22.999820490233
    ],
    [
        112.92428875876,
        22.999795434843
    ],
    [
        112.92424484279,
        22.999780700966
    ],
    [
        112.92421554907,
        22.999792032874
    ],
    [
        112.9241992594,
        22.999818036994
    ],
    [
        112.92416668069,
        22.999869502067
    ],
    [
        112.92414878426,
        22.999870006955
    ],
    [
        112.9241444433,
        22.999873252496
    ],
    [
        112.92409646592,
        22.999852537068
    ],
    [
        112.92406393478,
        22.999844058496
    ],
    [
        112.9239658222,
        22.999790679599
    ],
    [
        112.92384250503,
        22.999725569243
    ],
    [
        112.92377257494,
        22.999696921302
    ],
    [
        112.92367446585,
        22.999646228342
    ],
    [
        112.92353733246,
        22.999576166081
    ],
    [
        112.92338501658,
        22.999510926013
    ],
    [
        112.92323597097,
        22.999429943295
    ],
    [
        112.92312295111,
        22.999392446589
    ],
    [
        112.92312484447,
        22.999397876846
    ],
    [
        112.92312321398,
        22.999402753906
    ],
    [
        112.92311941665,
        22.99940518333
    ],
    [
        112.92311236722,
        22.999406246671
    ],
    [
        112.92309881685,
        22.999400509402
    ],
    [
        112.92307469028,
        22.999399078863
    ],
    [
        112.92306899379,
        22.9994034008
    ],
    [
        112.92305488922,
        22.999412849817
    ],
    [
        112.92303996644,
        22.999428534249
    ],
    [
        112.92301852989,
        22.999453690846
    ],
    [
        112.92300766521,
        22.999479965351
    ],
    [
        112.92298945373,
        22.999540661951
    ],
    [
        112.92296473903,
        22.99959781159
    ],
    [
        112.92293677513,
        22.999650339415
    ],
    [
        112.92291993572,
        22.999690697501
    ],
    [
        112.92290039855,
        22.999714501856
    ],
    [
        112.92289062382,
        22.999734269401
    ],
    [
        112.92289116706,
        22.99973291505
    ],
    [
        112.92287841615,
        22.999745349704
    ],
    [
        112.92286404303,
        22.999752354382
    ],
    [
        112.92284858135,
        22.999764779773
    ],
    [
        112.9228477385,
        22.999802477243
    ],
    [
        112.92283414898,
        22.99984745561
    ],
    [
        112.92282761093,
        22.99988838889
    ],
    [
        112.92281264525,
        22.999960213737
    ],
    [
        112.92279770424,
        23.000000576366
    ],
    [
        112.92279253513,
        23.00002442687
    ],
    [
        112.92279983921,
        23.000043979562
    ],
    [
        112.92280417758,
        23.000042637946
    ],
    [
        112.92289713736,
        23.00007196584
    ],
    [
        112.92318351532,
        23.0002925539
    ],
    [
        112.92334390694,
        23.000428092977
    ],
    [
        112.92343196506,
        23.000498587741
    ],
    [
        112.92361186639,
        23.00066017903
    ],
    [
        112.92378230274,
        23.000798120876
    ],
    [
        112.92387334225,
        23.000881063743
    ],
    [
        112.92401560588,
        23.000996119192
    ],
    [
        112.92411072043,
        23.001074711668
    ],
    [
        112.92412940555,
        23.001107570006
    ],
    [
        112.92411417565,
        23.001169377366
    ],
    [
        112.92405742958,
        23.001273134661
    ],
    [
        112.92401180122,
        23.00137718518
    ],
    [
        112.92400983143,
        23.001476178957
    ],
    [
        112.92401226683,
        23.001482965096
    ],
    [
        112.92396796736,
        23.001626073782
    ],
    [
        112.92396006131,
        23.001685997255
    ],
    [
        112.92392699339,
        23.001670190108
    ],
    [
        112.92386789686,
        23.001653778252
    ],
    [
        112.92375734173,
        23.001559394937
    ],
    [
        112.92369855076,
        23.001497950752
    ],
    [
        112.92364814741,
        23.001461477951
    ],
    [
        112.92364570453,
        23.001465268868
    ],
    [
        112.92363432571,
        23.001453576763
    ],
    [
        112.92357088832,
        23.001445816844
    ],
    [
        112.92353535302,
        23.001471217935
    ],
    [
        112.92345015645,
        23.001561848452
    ],
    [
        112.92339315215,
        23.001659603669
    ],
    [
        112.92330363411,
        23.001731495975
    ],
    [
        112.92325456122,
        23.001734879316
    ],
    [
        112.92322556884,
        23.001712553261
    ],
    [
        112.92313703028,
        23.001556331603
    ],
    [
        112.92309237262,
        23.001454213257
    ],
    [
        112.92305258163,
        23.001371094281
    ],
    [
        112.92301357224,
        23.0013321865
    ],
    [
        112.9229791407,
        23.001335874681
    ],
    [
        112.92290265624,
        23.001386619506
    ],
    [
        112.92283673289,
        23.001454481407
    ],
    [
        112.92278194739,
        23.001491185626
    ],
    [
        112.9227447903,
        23.001517369217
    ],
    [
        112.92273313093,
        23.001521397986
    ],
    [
        112.92267593288,
        23.001522015329
    ],
    [
        112.92261575461,
        23.001521263078
    ],
    [
        112.92254689787,
        23.001527257227
    ],
    [
        112.92249626699,
        23.001445435265
    ],
    [
        112.92244859098,
        23.00140159378
    ],
    [
        112.92235369776,
        23.001430534433
    ],
    [
        112.92223358107,
        23.001482966651
    ],
    [
        112.92214386047,
        23.001485871266
    ],
    [
        112.92209506662,
        23.001492729724
    ],
    [
        112.92203678097,
        23.001507413337
    ],
    [
        112.92203267699,
        23.001560557529
    ],
    [
        112.92203619179,
        23.001572777021
    ],
    [
        112.92204429468,
        23.001612409107
    ],
    [
        112.92204888475,
        23.001637109419
    ],
    [
        112.92207624153,
        23.00166352849
    ],
    [
        112.92209547655,
        23.001676624325
    ],
    [
        112.92210900723,
        23.001707055812
    ],
    [
        112.92212661687,
        23.001719059731
    ],
    [
        112.92214475263,
        23.001753577441
    ],
    [
        112.92215368029,
        23.001777480745
    ],
    [
        112.92216826524,
        23.001850498636
    ],
    [
        112.92218475258,
        23.001916743074
    ],
    [
        112.92221448575,
        23.002034301117
    ],
    [
        112.92224044073,
        23.002129060607
    ],
    [
        112.92224557376,
        23.002153491057
    ],
    [
        112.92226179672,
        23.002211596578
    ],
    [
        112.92226421121,
        23.002247679413
    ],
    [
        112.92227881934,
        23.002289504731
    ],
    [
        112.92228396099,
        23.002301729712
    ],
    [
        112.92226634513,
        23.00229759391
    ],
    [
        112.92225523053,
        23.00229944988
    ],
    [
        112.92226119732,
        23.002294319414
    ],
    [
        112.92225035566,
        23.002293464082
    ],
    [
        112.92200557324,
        23.002328840312
    ],
    [
        112.92191015518,
        23.002345535531
    ],
    [
        112.92175998678,
        23.002367142352
    ],
    [
        112.92168763289,
        23.002351098219
    ],
    [
        112.92165241256,
        23.002331958138
    ],
    [
        112.92159768255,
        23.002307305949
    ],
    [
        112.92156727579,
        23.002383115102
    ],
    [
        112.92155832558,
        23.002392568175
    ],
    [
        112.92152138095,
        23.002517982069
    ],
    [
        112.92150097607,
        23.002633434264
    ],
    [
        112.9215017594,
        23.002677377223
    ],
    [
        112.92147806681,
        23.002847060539
    ],
    [
        112.92145192686,
        23.003031107698
    ],
    [
        112.92143670727,
        23.003095862495
    ],
    [
        112.9211613642,
        23.003093210864
    ],
    [
        112.92088575648,
        23.003101881686
    ],
    [
        112.92071504383,
        23.003090695503
    ],
    [
        112.92048824636,
        23.003078366602
    ],
    [
        112.92041183876,
        23.003070625948
    ],
    [
        112.92040505823,
        23.003080353013
    ],
    [
        112.92040179684,
        23.003095252828
    ],
    [
        112.92040584186,
        23.003124839395
    ],
    [
        112.92039389474,
        23.003162474881
    ],
    [
        112.92039387006,
        23.003200176036
    ],
    [
        112.92038787277,
        23.003255474373
    ],
    [
        112.92038676792,
        23.003287744946
    ],
    [
        112.92036965646,
        23.003350576353
    ],
    [
        112.92037045356,
        23.003374991708
    ],
    [
        112.92036529179,
        23.00339584806
    ],
    [
        112.92035823926,
        23.003407471995
    ],
    [
        112.92035742078,
        23.003416146908
    ],
    [
        112.920354153,
        23.003441353442
    ],
    [
        112.92034952556,
        23.003474146948
    ],
    [
        112.92034735055,
        23.003485526657
    ],
    [
        112.92034138002,
        23.003500140067
    ],
    [
        112.92033702884,
        23.003524798081
    ],
    [
        112.92033782732,
        23.003547314871
    ],
    [
        112.92033618096,
        23.003579582461
    ],
    [
        112.92033616696,
        23.003601552276
    ],
    [
        112.92034157478,
        23.003619483744
    ],
    [
        112.92034373436,
        23.003632243712
    ],
    [
        112.92034101269,
        23.003651214921
    ],
    [
        112.92034073519,
        23.003661520247
    ],
    [
        112.92034669117,
        23.003669690344
    ],
    [
        112.9203539975,
        23.00368491997
    ],
    [
        112.92035724389,
        23.003693074979
    ],
    [
        112.9203610274,
        23.003708827492
    ],
    [
        112.92035480026,
        23.003700927198
    ],
    [
        112.92034152385,
        23.003699768546
    ],
    [
        112.92033366994,
        23.003693486494
    ],
    [
        112.92031090537,
        23.003699597941
    ],
    [
        112.92030711142,
        23.003700390445
    ],
    [
        112.92030737587,
        23.003710698796
    ],
    [
        112.92030600805,
        23.0037313049
    ],
    [
        112.92030461464,
        23.003792595911
    ],
    [
        112.92029538671,
        23.003816955316
    ],
    [
        112.92029807945,
        23.003843822536
    ],
    [
        112.92029373155,
        23.003863869498
    ],
    [
        112.92029670463,
        23.003875820436
    ],
    [
        112.92029831395,
        23.003902139134
    ],
    [
        112.92030399445,
        23.003917631248
    ],
    [
        112.92030398954,
        23.003925497006
    ],
    [
        112.92029748315,
        23.003930885287
    ],
    [
        112.92028366293,
        23.00393297772
    ],
    [
        112.92027445088,
        23.003932112306
    ],
    [
        112.92024572658,
        23.003936561558
    ],
    [
        112.92020047896,
        23.003933321747
    ],
    [
        112.92017663439,
        23.003934270925
    ],
    [
        112.92016010225,
        23.003940686123
    ],
    [
        112.92011377354,
        23.003934181858
    ],
    [
        112.92008667678,
        23.003937009047
    ],
    [
        112.92005741613,
        23.003934127105
    ],
    [
        112.92004549447,
        23.003934057789
    ],
    [
        112.92001840261,
        23.003929560057
    ],
    [
        112.92001786055,
        23.003929828123
    ],
    [
        112.9199972789,
        23.003913433617
    ],
    [
        112.91998536668,
        23.003898445853
    ],
    [
        112.91996044739,
        23.003886364946
    ],
    [
        112.91995448413,
        23.00389039829
    ],
    [
        112.91996016968,
        23.003897212668
    ],
    [
        112.91997584398,
        23.003962129898
    ],
    [
        112.91994225255,
        23.003953252363
    ],
    [
        112.91993114548,
        23.003950745555
    ],
    [
        112.91990595344,
        23.003941916643
    ],
    [
        112.9198260297,
        23.003936827928
    ],
    [
        112.91971928676,
        23.003928586594
    ],
    [
        112.91966971125,
        23.003920959492
    ],
    [
        112.91961932272,
        23.003914410141
    ],
    [
        112.91957380586,
        23.00391656844
    ],
    [
        112.91953344025,
        23.00391333255
    ],
    [
        112.91949036404,
        23.00391279049
    ],
    [
        112.91944132968,
        23.003909496661
    ],
    [
        112.91938199743,
        23.003911830792
    ],
    [
        112.91933242066,
        23.003910969952
    ],
    [
        112.91928744708,
        23.003914476572
    ],
    [
        112.91925250236,
        23.003910181005
    ],
    [
        112.91923137123,
        23.003910585659
    ],
    [
        112.91917665264,
        23.003903174904
    ],
    [
        112.91910108127,
        23.003885858774
    ],
    [
        112.91905367855,
        23.003877948311
    ],
    [
        112.91903255561,
        23.003866415083
    ],
    [
        112.91899924938,
        23.003843678923
    ],
    [
        112.91895565585,
        23.003810565325
    ],
    [
        112.91891476565,
        23.003786961681
    ],
    [
        112.91887686205,
        23.003753070138
    ],
    [
        112.91885520164,
        23.003735834104
    ],
    [
        112.91881107307,
        23.003694031955
    ],
    [
        112.9187544794,
        23.003659736213
    ],
    [
        112.91873254622,
        23.003646293285
    ],
    [
        112.91869356154,
        23.003610760877
    ],
    [
        112.918666485,
        23.003592398519
    ],
    [
        112.91864806914,
        23.003586030759
    ],
    [
        112.91858956121,
        23.003582905422
    ],
    [
        112.91851723586,
        23.003585103173
    ],
    [
        112.91848824939,
        23.003589777889
    ],
    [
        112.91843543565,
        23.003579904826
    ],
    [
        112.91838099219,
        23.003577883324
    ],
    [
        112.91838017717,
        23.003581674675
    ],
    [
        112.91836663419,
        23.003581033773
    ],
    [
        112.91833278569,
        23.00356559799
    ],
    [
        112.918275646,
        23.003545650505
    ],
    [
        112.91824206164,
        23.003541605863
    ],
    [
        112.91821090516,
        23.00355330979
    ],
    [
        112.91819679891,
        23.003587109423
    ],
    [
        112.91817294325,
        23.003618666546
    ],
    [
        112.91815043668,
        23.003658641504
    ],
    [
        112.91814229177,
        23.003688958919
    ],
    [
        112.91811625869,
        23.003737857642
    ],
    [
        112.91808345637,
        23.003783721392
    ],
    [
        112.91806744578,
        23.003831880648
    ],
    [
        112.91797507131,
        23.003854507821
    ],
    [
        112.91795018001,
        23.003811734481
    ],
    [
        112.91791877702,
        23.003787354731
    ],
    [
        112.91788249545,
        23.003768632594
    ],
    [
        112.91785298313,
        23.003753216361
    ],
    [
        112.91780722446,
        23.003731435267
    ],
    [
        112.91778719053,
        23.003718260667
    ],
    [
        112.91774441711,
        23.003687820854
    ],
    [
        112.91767294639,
        23.003640066581
    ],
    [
        112.91764533379,
        23.00362032041
    ],
    [
        112.91760607749,
        23.003597497924
    ],
    [
        112.91757250906,
        23.003574448116
    ],
    [
        112.91753406559,
        23.003551900967
    ],
    [
        112.91750157936,
        23.003531298912
    ],
    [
        112.91743362096,
        23.003501731153
    ],
    [
        112.91735674078,
        23.003449574743
    ],
    [
        112.91727930785,
        23.003416395254
    ],
    [
        112.91721109078,
        23.003372166249
    ],
    [
        112.91715938678,
        23.003339190919
    ],
    [
        112.91712040917,
        23.00330957412
    ],
    [
        112.91704325894,
        23.003263091483
    ],
    [
        112.91697937644,
        23.00322078444
    ],
    [
        112.91693330231,
        23.003278710043
    ],
    [
        112.91688286665,
        23.003381892769
    ],
    [
        112.91686877609,
        23.003395876856
    ],
    [
        112.91682565556,
        23.003495051163
    ],
    [
        112.91680532115,
        23.003533663329
    ],
    [
        112.91671517694,
        23.003486505862
    ],
    [
        112.91665183127,
        23.00345639177
    ],
    [
        112.91657468101,
        23.003418830189
    ],
    [
        112.91652514065,
        23.003398323682
    ],
    [
        112.91644907468,
        23.003361577498
    ],
    [
        112.9163935848,
        23.003330977317
    ],
    [
        112.91626391997,
        23.003275025846
    ],
    [
        112.91619002234,
        23.00324018197
    ],
    [
        112.91610448318,
        23.00320468485
    ],
    [
        112.9160557552,
        23.003190134186
    ],
    [
        112.91595478873,
        23.003148517935
    ],
    [
        112.9159434175,
        23.00314759884
    ],
    [
        112.91592663827,
        23.003135780113
    ],
    [
        112.91591066621,
        23.003131834425
    ],
    [
        112.91590011194,
        23.003123870478
    ],
    [
        112.91527208593,
        23.002977913043
    ],
    [
        112.91525828031,
        23.002975607781
    ],
    [
        112.91520684716,
        23.002968049987
    ],
    [
        112.91506419201,
        23.002944124191
    ],
    [
        112.91476561777,
        23.002909651948
    ],
    [
        112.91419339315,
        23.002871417898
    ],
    [
        112.91381258344,
        23.002824733538
    ],
    [
        112.91328457642,
        23.002756487373
    ],
    [
        112.91290161616,
        23.002764856964
    ],
    [
        112.91272623707,
        23.002782616995
    ],
    [
        112.91224722854,
        23.002810297078
    ],
    [
        112.91195847293,
        23.002846395556
    ],
    [
        112.91168243336,
        23.002902124081
    ],
    [
        112.91163209873,
        23.002910991691
    ],
    [
        112.91161991969,
        23.002915179809
    ],
    [
        112.91157580022,
        23.002937142103
    ],
    [
        112.91155631547,
        23.002941509729
    ],
    [
        112.91152139925,
        23.0029587032
    ],
    [
        112.91150164389,
        23.002963337965
    ],
    [
        112.91147673567,
        23.002986080452
    ],
    [
        112.91145779395,
        23.002988012519
    ],
    [
        112.91144993728,
        23.003003102882
    ],
    [
        112.91143505585,
        23.003002644579
    ],
    [
        112.91143315666,
        23.003010486462
    ],
    [
        112.91140581498,
        23.003031027315
    ],
    [
        112.91132813914,
        23.003063137489
    ],
    [
        112.91120822153,
        23.003147054869
    ],
    [
        112.91104283501,
        23.003256418577
    ],
    [
        112.91095594818,
        23.003313345267
    ],
    [
        112.91076349984,
        23.003442672879
    ],
    [
        112.91061083789,
        23.003555411286
    ],
    [
        112.91047116696,
        23.00366586545
    ],
    [
        112.91025353876,
        23.003849859738
    ],
    [
        112.90989792053,
        23.004082139662
    ],
    [
        112.909496052,
        23.004332692811
    ],
    [
        112.90915186564,
        23.004508826467
    ],
    [
        112.90890563353,
        23.004647763346
    ],
    [
        112.9086242618,
        23.00476039653
    ],
    [
        112.90845626936,
        23.004802742101
    ],
    [
        112.90823608479,
        23.004835365012
    ],
    [
        112.90792477841,
        23.004835434617
    ],
    [
        112.90773221755,
        23.004825547523
    ],
    [
        112.9074439314,
        23.004798754512
    ],
    [
        112.90711185129,
        23.004757154444
    ],
    [
        112.90678953225,
        23.00469069463
    ],
    [
        112.90650886201,
        23.00463540392
    ],
    [
        112.90622468548,
        23.004577580601
    ],
    [
        112.90588995322,
        23.00451486038
    ],
    [
        112.90566231117,
        23.004449712424
    ],
    [
        112.90541250193,
        23.004383647796
    ],
    [
        112.90516649304,
        23.00430188572
    ],
    [
        112.90492401702,
        23.004199270256
    ],
    [
        112.90468533578,
        23.004089640424
    ],
    [
        112.90448207882,
        23.003979750399
    ],
    [
        112.90425097897,
        23.003867220161
    ],
    [
        112.90409421441,
        23.003787081688
    ],
    [
        112.90391933705,
        23.003707721269
    ],
    [
        112.90375445268,
        23.003648857672
    ],
    [
        112.90365930579,
        23.003617177868
    ],
    [
        112.9035409001,
        23.00359948476
    ],
    [
        112.90337166202,
        23.003592604474
    ],
    [
        112.90307103806,
        23.003582433087
    ],
    [
        112.90277312012,
        23.003577431994
    ],
    [
        112.90253657684,
        23.0035688309
    ],
    [
        112.90230327442,
        23.003570575362
    ],
    [
        112.90221730215,
        23.003579693521
    ],
    [
        112.90217431082,
        23.003592795664
    ],
    [
        112.90216403486,
        23.003598045605
    ],
    [
        112.90206911312,
        23.003653931796
    ],
    [
        112.90198766829,
        23.003774870885
    ],
    [
        112.90183702305,
        23.003891099766
    ],
    [
        112.90171611017,
        23.004016240565
    ],
    [
        112.90160193611,
        23.004175940496
    ],
    [
        112.90153319363,
        23.00430983662
    ],
    [
        112.90145201265,
        23.004451655021
    ],
    [
        112.90137571412,
        23.004566974722
    ],
    [
        112.90126559558,
        23.00473568671
    ],
    [
        112.90118688727,
        23.004814344563
    ],
    [
        112.90111304939,
        23.004885761735
    ],
    [
        112.90104162326,
        23.004995464094
    ],
    [
        112.90098128384,
        23.005099932477
    ],
    [
        112.9008992945,
        23.005250135936
    ],
    [
        112.90084785555,
        23.005394086708
    ],
    [
        112.90080211237,
        23.005504502094
    ],
    [
        112.90077394709,
        23.005602202555
    ],
    [
        112.90073279438,
        23.005724089205
    ],
    [
        112.90065676095,
        23.005867069131
    ],
    [
        112.90060860466,
        23.005944892287
    ],
    [
        112.90053366856,
        23.006060223045
    ],
    [
        112.90045981249,
        23.006179640239
    ],
    [
        112.90037028942,
        23.006278982838
    ],
    [
        112.90028132159,
        23.006350666993
    ],
    [
        112.90016017245,
        23.006452980612
    ],
    [
        112.90000413693,
        23.006591841756
    ],
    [
        112.89982189396,
        23.006709353976
    ],
    [
        112.89971670987,
        23.006783729149
    ],
    [
        112.89961124671,
        23.006877898488
    ],
    [
        112.89949955216,
        23.007004505935
    ],
    [
        112.89945141378,
        23.007057366044
    ],
    [
        112.89943330438,
        23.007055691419
    ],
    [
        112.89941330289,
        23.007053983471
    ],
    [
        112.89932385181,
        23.007014435637
    ],
    [
        112.89925198402,
        23.006946173283
    ],
    [
        112.89924226213,
        23.006927286279
    ],
    [
        112.89923984753,
        23.006888998427
    ],
    [
        112.89924581069,
        23.006854113044
    ],
    [
        112.89933614441,
        23.006742323599
    ],
    [
        112.89940105127,
        23.006670501141
    ],
    [
        112.89949704585,
        23.006593257208
    ],
    [
        112.89962249922,
        23.006525751444
    ],
    [
        112.89979418623,
        23.00643626952
    ],
    [
        112.89996669217,
        23.006333506363
    ],
    [
        112.90010269465,
        23.006257495839
    ],
    [
        112.900124063,
        23.006229660082
    ],
    [
        112.90013596934,
        23.006204371374
    ],
    [
        112.90013436059,
        23.006178575307
    ],
    [
        112.90011814931,
        23.006164458741
    ],
    [
        112.90005466131,
        23.006097437337
    ],
    [
        112.90000602587,
        23.006058884204
    ],
    [
        112.89991064475,
        23.005987234667
    ],
    [
        112.8997428303,
        23.005900751773
    ],
    [
        112.89955473831,
        23.005825842879
    ],
    [
        112.89942177045,
        23.005786345878
    ],
    [
        112.8993798747,
        23.005784524034
    ],
    [
        112.89932500269,
        23.005786270953
    ],
    [
        112.89928065701,
        23.00581749679
    ],
    [
        112.89922684535,
        23.005859405292
    ],
    [
        112.89917976384,
        23.005954324024
    ],
    [
        112.89910617983,
        23.006075899537
    ],
    [
        112.89899150249,
        23.006214922787
    ],
    [
        112.89891199001,
        23.006304114382
    ],
    [
        112.89890522747,
        23.006314302202
    ],
    [
        112.89889657721,
        23.006315776945
    ],
    [
        112.8988298353,
        23.006272827128
    ],
    [
        112.89864447145,
        23.006154815982
    ],
    [
        112.89854935235,
        23.006105666263
    ],
    [
        112.89846666047,
        23.006069483975
    ],
    [
        112.89841423206,
        23.006052281332
    ],
    [
        112.89837801415,
        23.006049198831
    ],
    [
        112.89834233018,
        23.006059145258
    ],
    [
        112.89829554391,
        23.00610876739
    ],
    [
        112.89819302206,
        23.006267796982
    ],
    [
        112.89812754476,
        23.006400629814
    ],
    [
        112.89800068211,
        23.006594488159
    ],
    [
        112.89786813691,
        23.006806146837
    ],
    [
        112.89780107363,
        23.006871139687
    ],
    [
        112.89778620129,
        23.006884437801
    ],
    [
        112.89774917355,
        23.006879711657
    ],
    [
        112.89762486802,
        23.006819457697
    ],
    [
        112.8974754226,
        23.006765808428
    ],
    [
        112.897406229,
        23.006764036046
    ],
    [
        112.89735540197,
        23.006789985554
    ],
    [
        112.89732025416,
        23.006811060116
    ],
    [
        112.89721859049,
        23.006883844275
    ],
    [
        112.89707393935,
        23.006981631606
    ],
    [
        112.89702392145,
        23.007012206102
    ],
    [
        112.89698469765,
        23.007080675491
    ],
    [
        112.89693384103,
        23.007172264915
    ],
    [
        112.89691734828,
        23.007183363728
    ],
    [
        112.89690329085,
        23.007188538494
    ],
    [
        112.89687112998,
        23.007180642656
    ],
    [
        112.89680384158,
        23.007150693437
    ],
    [
        112.89673168532,
        23.007126624898
    ],
    [
        112.8966668261,
        23.007104313627
    ],
    [
        112.8966162815,
        23.00710531282
    ],
    [
        112.89659357787,
        23.007103823794
    ],
    [
        112.89656519458,
        23.007110099763
    ],
    [
        112.8965341043,
        23.007125278609
    ],
    [
        112.89651111967,
        23.007147111572
    ],
    [
        112.89651327116,
        23.007170748109
    ],
    [
        112.89647560636,
        23.007379749783
    ],
    [
        112.89644876159,
        23.007574297174
    ],
    [
        112.89641085798,
        23.007719552634
    ],
    [
        112.89636566491,
        23.007847590071
    ],
    [
        112.89635347114,
        23.007920338235
    ],
    [
        112.89634909755,
        23.008037438771
    ],
    [
        112.89635057863,
        23.008383304803
    ],
    [
        112.89632129126,
        23.008628533863
    ],
    [
        112.89627582311,
        23.008784506074
    ],
    [
        112.89627149124,
        23.008803687612
    ],
    [
        112.89626365455,
        23.008799208179
    ],
    [
        112.89616987285,
        23.008776381949
    ],
    [
        112.89605419756,
        23.008753980061
    ],
    [
        112.89583933595,
        23.008705401791
    ],
    [
        112.89561230722,
        23.008666916128
    ],
    [
        112.89544825277,
        23.008636332874
    ],
    [
        112.89538176257,
        23.00863298145
    ],
    [
        112.89533256738,
        23.00863888867
    ],
    [
        112.89528634493,
        23.00864593382
    ],
    [
        112.89525930821,
        23.008665797227
    ],
    [
        112.89522793787,
        23.008709182308
    ],
    [
        112.89518789677,
        23.0088096469
    ],
    [
        112.89511431603,
        23.008975158487
    ],
    [
        112.89498610993,
        23.009218363752
    ],
    [
        112.89490521317,
        23.009445863504
    ],
    [
        112.89484842325,
        23.00952948647
    ],
    [
        112.89482030612,
        23.009549331728
    ],
    [
        112.8948024671,
        23.009548472982
    ],
    [
        112.89474975997,
        23.009548623757
    ],
    [
        112.89470895379,
        23.009524844369
    ],
    [
        112.89461274454,
        23.009480282523
    ],
    [
        112.89453545447,
        23.009439582711
    ],
    [
        112.89440301872,
        23.009414996551
    ],
    [
        112.89434922973,
        23.009415943925
    ],
    [
        112.89426731598,
        23.009457624434
    ],
    [
        112.8941751097,
        23.009562053918
    ],
    [
        112.89412264136,
        23.00965443735
    ],
    [
        112.89410612938,
        23.009726840945
    ],
    [
        112.89410448644,
        23.009791640877
    ],
    [
        112.89411930318,
        23.009945973129
    ],
    [
        112.89415873657,
        23.010040793808
    ],
    [
        112.89423274967,
        23.010196172428
    ],
    [
        112.8942462553,
        23.010226248824
    ],
    [
        112.89424733033,
        23.010246611725
    ],
    [
        112.89423380689,
        23.010275396704
    ],
    [
        112.8941559358,
        23.010362449144
    ],
    [
        112.89414943364,
        23.010413601007
    ],
    [
        112.89414699274,
        23.010441768159
    ],
    [
        112.8941683083,
        23.010572888483
    ],
    [
        112.89418314979,
        23.010660494137
    ],
    [
        112.89416449189,
        23.010687289859
    ],
    [
        112.89410852152,
        23.010756284721
    ],
    [
        112.89403309155,
        23.010819511467
    ],
    [
        112.89389683209,
        23.010930220599
    ],
    [
        112.89381761411,
        23.011008844163
    ],
    [
        112.89380976496,
        23.011049122716
    ],
    [
        112.89380676788,
        23.011141567618
    ],
    [
        112.89380594603,
        23.011184682598
    ],
    [
        112.89378593934,
        23.011203046669
    ],
    [
        112.8937718839,
        23.011202799062
    ],
    [
        112.89375918035,
        23.011200947766
    ],
    [
        112.89373728778,
        23.011194594586
    ],
    [
        112.89372053428,
        23.011174769235
    ],
    [
        112.89369406096,
        23.011112185863
    ],
    [
        112.89364623952,
        23.011029154094
    ],
    [
        112.8936184099,
        23.010986348758
    ],
    [
        112.89355274475,
        23.010919550273
    ],
    [
        112.89350436147,
        23.010917885856
    ],
    [
        112.89347787381,
        23.010911181468
    ],
    [
        112.89344651915,
        23.010910359255
    ],
    [
        112.89342949448,
        23.010894327442
    ],
    [
        112.89340003645,
        23.010876449779
    ],
    [
        112.89337462825,
        23.010876003597
    ],
    [
        112.89333246242,
        23.010871465806
    ],
    [
        112.89330462175,
        23.010869892188
    ],
    [
        112.89329596958,
        23.010879234247
    ],
    [
        112.89327893344,
        23.010905789469
    ],
    [
        112.89328189845,
        23.010937035681
    ],
    [
        112.89329432047,
        23.01098201053
    ],
    [
        112.89333511563,
        23.011060305136
    ],
    [
        112.89335997,
        23.011112279755
    ],
    [
        112.89337158425,
        23.011146390469
    ],
    [
        112.89338156999,
        23.01120732682
    ],
    [
        112.89337776565,
        23.01128809392
    ],
    [
        112.89336423593,
        23.011347803694
    ],
    [
        112.89333205632,
        23.011404473608
    ],
    [
        112.89329447309,
        23.011451554964
    ],
    [
        112.89323715526,
        23.01150968317
    ],
    [
        112.89318173816,
        23.011531225756
    ],
    [
        112.89309469567,
        23.01155194362
    ],
    [
        112.89300684784,
        23.011547693146
    ],
    [
        112.89289116239,
        23.01152586825
    ],
    [
        112.89283980646,
        23.011516561909
    ],
    [
        112.89273601637,
        23.01148409781
    ],
    [
        112.89263249707,
        23.011448114101
    ],
    [
        112.89250438203,
        23.011400582763
    ],
    [
        112.89237599851,
        23.011343284797
    ],
    [
        112.89225518266,
        23.011288291564
    ],
    [
        112.89223599103,
        23.011286059705
    ],
    [
        112.89222707075,
        23.011285904918
    ],
    [
        112.89221517671,
        23.011287054829
    ],
    [
        112.89220544349,
        23.011295023624
    ],
    [
        112.89216730762,
        23.011384418894
    ],
    [
        112.89213052964,
        23.011448611339
    ],
    [
        112.89211079578,
        23.011452609457
    ],
    [
        112.89204375907,
        23.011447379576
    ],
    [
        112.89199888561,
        23.011452299289
    ],
    [
        112.89198455851,
        23.011453950202
    ],
    [
        112.89196346191,
        23.011504852554
    ],
    [
        112.89197183274,
        23.011543244357
    ],
    [
        112.89198534218,
        23.011570603602
    ],
    [
        112.89202966589,
        23.011605277557
    ],
    [
        112.89204019897,
        23.01164560574
    ],
    [
        112.89203667876,
        23.011672670385
    ],
    [
        112.89203153664,
        23.011699978219
    ],
    [
        112.89200476343,
        23.011754037319
    ],
    [
        112.89192310843,
        23.011844038444
    ],
    [
        112.89183632541,
        23.011897061705
    ],
    [
        112.89182361905,
        23.011903894999
    ],
    [
        112.89180199443,
        23.011900266659
    ],
    [
        112.89179685847,
        23.011899906766
    ],
    [
        112.89174847726,
        23.01187330274
    ],
    [
        112.89168658383,
        23.011829105997
    ],
    [
        112.89165522833,
        23.011822055649
    ],
    [
        112.89163982064,
        23.011819620238
    ],
    [
        112.89163225096,
        23.01182301622
    ],
    [
        112.89161467665,
        23.011839260279
    ],
    [
        112.89161170126,
        23.011847889262
    ],
    [
        112.89159682532,
        23.011886694133
    ],
    [
        112.89155437531,
        23.011932348622
    ],
    [
        112.891535181,
        23.0119396137
    ],
    [
        112.8915240957,
        23.011949730845
    ],
    [
        112.8915127434,
        23.011944110546
    ],
    [
        112.89150976964,
        23.011945144454
    ],
    [
        112.89150409332,
        23.011943148087
    ],
    [
        112.89149517612,
        23.011926990687
    ],
    [
        112.89147789159,
        23.011851826885
    ],
    [
        112.89146925564,
        23.011785763237
    ],
    [
        112.89145979738,
        23.011772037949
    ],
    [
        112.89143898438,
        23.011763814059
    ],
    [
        112.89141925223,
        23.011757507625
    ],
    [
        112.89140060004,
        23.011757187456
    ],
    [
        112.89137653983,
        23.011763827244
    ],
    [
        112.89133004246,
        23.011771709959
    ],
    [
        112.89131327556,
        23.01180288824
    ],
    [
        112.89129948314,
        23.01183004873
    ],
    [
        112.89128974582,
        23.011856193734
    ],
    [
        112.89129730831,
        23.011886975301
    ],
    [
        112.89131243496,
        23.011941214606
    ],
    [
        112.89134594855,
        23.011972441201
    ],
    [
        112.89136297304,
        23.012000672638
    ],
    [
        112.89137080778,
        23.012023050096
    ],
    [
        112.89138242217,
        23.012069363034
    ],
    [
        112.8913940394,
        23.012102113223
    ],
    [
        112.89139295336,
        23.012125693949
    ],
    [
        112.89137754158,
        23.012142518695
    ],
    [
        112.89134833905,
        23.012180807547
    ],
    [
        112.89132103538,
        23.01218576453
    ],
    [
        112.89121750076,
        23.012187517332
    ],
    [
        112.89111180597,
        23.012174045561
    ],
    [
        112.8910609889,
        23.012151748149
    ],
    [
        112.89098746946,
        23.012103023451
    ],
    [
        112.89092016756,
        23.012053592381
    ],
    [
        112.89082745909,
        23.01198175843
    ],
    [
        112.89078826788,
        23.011949083589
    ],
    [
        112.89075826435,
        23.011933383214
    ],
    [
        112.89072717683,
        23.011930142482
    ],
    [
        112.8906944644,
        23.011940437266
    ],
    [
        112.89068797347,
        23.011954432427
    ],
    [
        112.89065985269,
        23.011983793444
    ],
    [
        112.8906349768,
        23.012008869615
    ],
    [
        112.89061334668,
        23.012025320773
    ],
    [
        112.89059144806,
        23.012032816039
    ],
    [
        112.89056306239,
        23.012035318931
    ],
    [
        112.89054116649,
        23.012029251716
    ],
    [
        112.89050035063,
        23.012005775269
    ],
    [
        112.89043980589,
        23.011954568849
    ],
    [
        112.8903649352,
        23.011893627686
    ],
    [
        112.89032682084,
        23.011877794133
    ],
    [
        112.89031384913,
        23.011856417328
    ],
    [
        112.89029547647,
        23.011808095138
    ],
    [
        112.89025846556,
        23.01169137371
    ],
    [
        112.89023279984,
        23.011617431024
    ],
    [
        112.89024119154,
        23.011568475079
    ],
    [
        112.89025715469,
        23.011511780328
    ],
    [
        112.89029988106,
        23.011457435634
    ],
    [
        112.89031853777,
        23.011443373734
    ],
    [
        112.89037720724,
        23.011418052067
    ],
    [
        112.89045074244,
        23.011403832924
    ],
    [
        112.89052508897,
        23.011386916547
    ],
    [
        112.89062160443,
        23.011362511188
    ],
    [
        112.89069729925,
        23.01135674281
    ],
    [
        112.89076299105,
        23.01135270481
    ],
    [
        112.89084247211,
        23.011337781181
    ],
    [
        112.89095548082,
        23.011293592667
    ],
    [
        112.89106065545,
        23.011225132153
    ],
    [
        112.89111392289,
        23.011173147459
    ],
    [
        112.89112825772,
        23.011143283212
    ],
    [
        112.89112989198,
        23.011094756604
    ],
    [
        112.89112881761,
        23.011067612806
    ],
    [
        112.8911090894,
        23.011045575286
    ],
    [
        112.89106989609,
        23.011029444238
    ],
    [
        112.89099961395,
        23.01101712317
    ],
    [
        112.89094501017,
        23.011006698151
    ],
    [
        112.89091365692,
        23.010987447333
    ],
    [
        112.89089338649,
        23.010970826806
    ],
    [
        112.89089068767,
        23.010953691839
    ],
    [
        112.89089179039,
        23.010872605704
    ],
    [
        112.8909020864,
        23.010785166128
    ],
    [
        112.89088857922,
        23.010750758136
    ],
    [
        112.89086669055,
        23.010721090073
    ],
    [
        112.89084317425,
        23.010712009704
    ],
    [
        112.89080911326,
        23.010709260209
    ],
    [
        112.89075288342,
        23.010712101839
    ],
    [
        112.89072152104,
        23.010725945484
    ],
    [
        112.89062796936,
        23.010785661157
    ],
    [
        112.89053549294,
        23.010867097859
    ],
    [
        112.89046491188,
        23.010955417377
    ],
    [
        112.89044678066,
        23.011027264416
    ],
    [
        112.89041648284,
        23.011105687371
    ],
    [
        112.89033616648,
        23.011209035549
    ],
    [
        112.89032400174,
        23.011206931541
    ],
    [
        112.89029318285,
        23.011207768082
    ],
    [
        112.89024344786,
        23.011177363191
    ],
    [
        112.89016884656,
        23.011126196578
    ],
    [
        112.89009207405,
        23.011107545745
    ],
    [
        112.88997988255,
        23.011102679289
    ],
    [
        112.889920946,
        23.011107659469
    ],
    [
        112.88989390705,
        23.011124838368
    ],
    [
        112.88986442398,
        23.011185919863
    ],
    [
        112.88983520635,
        23.011267621478
    ],
    [
        112.88980894963,
        23.011404708954
    ],
    [
        112.88978001449,
        23.011438132526
    ],
    [
        112.88974405285,
        23.0114605889
    ],
    [
        112.8897332402,
        23.011454983373
    ],
    [
        112.8897124232,
        23.011455449894
    ],
    [
        112.88968620346,
        23.011437652386
    ],
    [
        112.88965269003,
        23.01139532063
    ],
    [
        112.88959160486,
        23.011335983849
    ],
    [
        112.88953158801,
        23.011330374576
    ],
    [
        112.88948022233,
        23.011324367601
    ],
    [
        112.88933099364,
        23.011293954881
    ],
    [
        112.88925178422,
        23.011272300978
    ],
    [
        112.8891495976,
        23.011235080094
    ],
    [
        112.88904552254,
        23.011178572761
    ],
    [
        112.88897388997,
        23.011124229485
    ],
    [
        112.88886738709,
        23.011042191092
    ],
    [
        112.88876332406,
        23.010933071388
    ],
    [
        112.888680075,
        23.010840028034
    ],
    [
        112.88857277069,
        23.010717842875
    ],
    [
        112.88848843134,
        23.010655982096
    ],
    [
        112.88841868287,
        23.010626639768
    ],
    [
        112.88837082789,
        23.010621252879
    ],
    [
        112.88832486372,
        23.010621865041
    ],
    [
        112.88828240628,
        23.010651558799
    ],
    [
        112.88825509426,
        23.010665493918
    ],
    [
        112.8882153363,
        23.010710422601
    ],
    [
        112.88818719501,
        23.010791344702
    ],
    [
        112.88818852359,
        23.01087925234
    ],
    [
        112.88817657848,
        23.01106676758
    ],
    [
        112.88816817266,
        23.011162656167
    ],
    [
        112.88814409531,
        23.011217332898
    ],
    [
        112.88809432688,
        23.011292483047
    ],
    [
        112.88802887735,
        23.011363313489
    ],
    [
        112.88793611967,
        23.011430724134
    ],
    [
        112.8877873795,
        23.011549325051
    ],
    [
        112.8876986604,
        23.011689234668
    ],
    [
        112.88756990975,
        23.011894427335
    ],
    [
        112.88746549978,
        23.012078583279
    ],
    [
        112.88730429222,
        23.012341055694
    ],
    [
        112.88714444085,
        23.012587557129
    ],
    [
        112.88696186747,
        23.012889866368
    ],
    [
        112.88670951633,
        23.013287677994
    ],
    [
        112.88661647498,
        23.013429464098
    ],
    [
        112.88661944045,
        23.013502207821
    ],
    [
        112.88664728442,
        23.013575336178
    ],
    [
        112.88666322874,
        23.013662386402
    ],
    [
        112.88667052564,
        23.013700204646
    ],
    [
        112.88665348317,
        23.013757177173
    ],
    [
        112.88656585082,
        23.013923192126
    ],
    [
        112.88632974192,
        23.014272746842
    ],
    [
        112.88618856279,
        23.014499535763
    ],
    [
        112.88589160547,
        23.01491277644
    ],
    [
        112.88586888661,
        23.014963160004
    ],
    [
        112.88587835112,
        23.014979850016
    ],
    [
        112.88589782155,
        23.015000760165
    ],
    [
        112.88600869489,
        23.015110130228
    ],
    [
        112.88625640022,
        23.015344747367
    ],
    [
        112.88643757978,
        23.015536324892
    ],
    [
        112.88653438833,
        23.015681857281
    ],
    [
        112.88658198141,
        23.01576749787
    ],
    [
        112.88657765471,
        23.015801068229
    ],
    [
        112.88656521558,
        23.015838853729
    ],
    [
        112.88645434495,
        23.015985258407
    ],
    [
        112.88638106156,
        23.016038657857
    ],
    [
        112.88623151902,
        23.01614596161
    ],
    [
        112.88621962044,
        23.016153646757
    ],
    [
        112.8861493108,
        23.016216322931
    ],
    [
        112.88613957632,
        23.016254966104
    ],
    [
        112.88613795515,
        23.016308381335
    ],
    [
        112.88615607449,
        23.016332257614
    ],
    [
        112.88635754534,
        23.016466087668
    ],
    [
        112.8865498165,
        23.016539573535
    ],
    [
        112.8866258043,
        23.016560549173
    ],
    [
        112.88670584694,
        23.016561516373
    ],
    [
        112.88680670977,
        23.016541379643
    ],
    [
        112.88690784071,
        23.016484087867
    ],
    [
        112.88708495417,
        23.016413069763
    ],
    [
        112.88716039608,
        23.016397705247
    ],
    [
        112.88719879315,
        23.0163996646
    ],
    [
        112.88729289354,
        23.016436952635
    ],
    [
        112.88743188145,
        23.016541686176
    ],
    [
        112.88749542805,
        23.016634381026
    ],
    [
        112.88749732357,
        23.016695175437
    ],
    [
        112.88750814303,
        23.016770488587
    ],
    [
        112.88748056748,
        23.016856858154
    ],
    [
        112.8874448795,
        23.016927908632
    ],
    [
        112.88737268787,
        23.016994042747
    ],
    [
        112.8871704372,
        23.017112116328
    ],
    [
        112.88691870156,
        23.017261174882
    ],
    [
        112.88665776827,
        23.017421513406
    ],
    [
        112.88650769661,
        23.017524721939
    ],
    [
        112.88648525394,
        23.017546620768
    ],
    [
        112.88648092949,
        23.017570426167
    ],
    [
        112.8864841768,
        23.017594348081
    ],
    [
        112.88651419777,
        23.01764092653
    ],
    [
        112.88666159635,
        23.01785099662
    ],
    [
        112.88681765414,
        23.018108684618
    ],
    [
        112.88689690379,
        23.018264001261
    ],
    [
        112.88695127598,
        23.018413778471
    ],
    [
        112.88694911933,
        23.018460675299
    ],
    [
        112.88693587302,
        23.018485968478
    ],
    [
        112.88691829893,
        23.018502513488
    ],
    [
        112.88672632349,
        23.018607496713
    ],
    [
        112.88641671739,
        23.018739442581
    ],
    [
        112.88619930933,
        23.018814242625
    ],
    [
        112.88597459964,
        23.018914997416
    ],
    [
        112.88576908605,
        23.019012810464
    ],
    [
        112.88556870218,
        23.019082779913
    ],
    [
        112.88531314915,
        23.019187760576
    ],
    [
        112.88523202334,
        23.019239731161
    ],
    [
        112.88521120458,
        23.019272519625
    ],
    [
        112.88521391523,
        23.019305112845
    ],
    [
        112.88521797789,
        23.019336098373
    ],
    [
        112.885238,
        23.019381154693
    ],
    [
        112.88532052112,
        23.019551652302
    ],
    [
        112.88550176906,
        23.019784660378
    ],
    [
        112.88560565499,
        23.019948978642
    ],
    [
        112.88577094586,
        23.020179061035
    ],
    [
        112.88591324281,
        23.020380325594
    ],
    [
        112.8860898922,
        23.020612777054
    ],
    [
        112.88622325321,
        23.020769438233
    ],
    [
        112.88633929358,
        23.020877554757
    ],
    [
        112.88639311585,
        23.020909034714
    ],
    [
        112.88643341163,
        23.020921047229
    ],
    [
        112.8864869544,
        23.020920785395
    ],
    [
        112.88663188597,
        23.020879073117
    ],
    [
        112.88682467614,
        23.020829704348
    ],
    [
        112.88704531338,
        23.020775633699
    ],
    [
        112.88721159817,
        23.020729139523
    ],
    [
        112.88740222136,
        23.020702574154
    ],
    [
        112.88753038596,
        23.02069510802
    ],
    [
        112.88763584001,
        23.020701394232
    ],
    [
        112.88770262823,
        23.020709781719
    ],
    [
        112.88777238575,
        23.020700585218
    ],
    [
        112.88796678505,
        23.02067358303
    ],
    [
        112.88812196501,
        23.020601745779
    ],
    [
        112.88825281022,
        23.020532780388
    ],
    [
        112.88845341495,
        23.020482314924
    ],
    [
        112.88853344052,
        23.020465439192
    ],
    [
        112.88859291607,
        23.020442263054
    ],
    [
        112.88861806449,
        23.020459220726
    ],
    [
        112.88864295185,
        23.020513882282
    ],
    [
        112.88866109129,
        23.020612652701
    ],
    [
        112.88866790158,
        23.020809984647
    ],
    [
        112.88866527949,
        23.021109978761
    ],
    [
        112.88864856121,
        23.021266778236
    ],
    [
        112.8886275265,
        23.021451178511
    ],
    [
        112.88859270782,
        23.021645663558
    ],
    [
        112.88855598991,
        23.021813261478
    ],
    [
        112.88850060692,
        23.021947188955
    ],
    [
        112.88847062066,
        23.022023746518
    ],
    [
        112.88845602436,
        23.022035174779
    ],
    [
        112.88843007035,
        23.02204017934
    ],
    [
        112.88839383755,
        23.022031182077
    ],
    [
        112.88826485661,
        23.021992471655
    ],
    [
        112.88806368,
        23.021943653724
    ],
    [
        112.8878557389,
        23.021889589488
    ],
    [
        112.88769647106,
        23.021856935254
    ],
    [
        112.88758750359,
        23.02185493105
    ],
    [
        112.88739633371,
        23.021847833762
    ],
    [
        112.88728248373,
        23.021806430513
    ],
    [
        112.8871629308,
        23.021690069235
    ],
    [
        112.88708556025,
        23.021574103391
    ],
    [
        112.88700114755,
        23.021418694331
    ],
    [
        112.88691485652,
        23.02131127634
    ],
    [
        112.88675419668,
        23.021182903299
    ],
    [
        112.88660110221,
        23.021037839608
    ],
    [
        112.88654971713,
        23.021015615487
    ],
    [
        112.88647238038,
        23.021024733178
    ],
    [
        112.88642371146,
        23.021047857876
    ],
    [
        112.88635990212,
        23.021082959231
    ],
    [
        112.88634178878,
        23.021100314957
    ],
    [
        112.88632422595,
        23.021151860768
    ],
    [
        112.88632099356,
        23.021196301496
    ],
    [
        112.88634237258,
        23.021250885314
    ],
    [
        112.88638241946,
        23.021335325412
    ],
    [
        112.88645572209,
        23.021399659892
    ],
    [
        112.8865712196,
        23.021498286566
    ],
    [
        112.88663208184,
        23.021560807611
    ],
    [
        112.88667725726,
        23.021614406506
    ],
    [
        112.88671920077,
        23.02171000517
    ],
    [
        112.88673328353,
        23.021778044277
    ],
    [
        112.8867451969,
        23.021826246176
    ],
    [
        112.88672763023,
        23.021857713984
    ],
    [
        112.88668195063,
        23.02191994421
    ],
    [
        112.88650999806,
        23.022015494077
    ],
    [
        112.88643537165,
        23.022042559712
    ],
    [
        112.88629370635,
        23.022148087703
    ],
    [
        112.88623991426,
        23.022213730227
    ],
    [
        112.88622208518,
        23.022269342664
    ],
    [
        112.88621885895,
        23.022324364234
    ],
    [
        112.88622673269,
        23.022415093588
    ],
    [
        112.88625923109,
        23.022550147413
    ],
    [
        112.88627442197,
        23.022681681821
    ],
    [
        112.88629555654,
        23.022795673824
    ],
    [
        112.88631831698,
        23.022917015784
    ],
    [
        112.88637649784,
        23.023024251573
    ],
    [
        112.88649147765,
        23.023160033758
    ],
    [
        112.88661590974,
        23.02326558415
    ],
    [
        112.88676034387,
        23.02335246196
    ],
    [
        112.88693452594,
        23.023451478475
    ],
    [
        112.88714901107,
        23.023589121078
    ],
    [
        112.88732266754,
        23.023737262899
    ],
    [
        112.88742437373,
        23.023827851295
    ],
    [
        112.88749687507,
        23.023913640759
    ],
    [
        112.88759291175,
        23.024026392528
    ],
    [
        112.88767760058,
        23.024159043057
    ],
    [
        112.88769846128,
        23.024252698788
    ],
    [
        112.88777070405,
        23.024365079239
    ],
    [
        112.88787700361,
        23.02445142021
    ],
    [
        112.88798032457,
        23.024529308091
    ],
    [
        112.88809094594,
        23.024608945522
    ],
    [
        112.88820155889,
        23.02467176775
    ],
    [
        112.88831298566,
        23.024742204153
    ],
    [
        112.88835491275,
        23.024783847566
    ],
    [
        112.88836708539,
        23.024796524063
    ],
    [
        112.88837115235,
        23.024821006116
    ],
    [
        112.88836575194,
        23.024836110944
    ],
    [
        112.88831038989,
        23.024973302139
    ],
    [
        112.88826878816,
        23.025048862516
    ],
    [
        112.88823231022,
        23.025096291999
    ],
    [
        112.88819095309,
        23.025117870626
    ],
    [
        112.88817959968,
        23.025122842101
    ],
    [
        112.88814716218,
        23.025138868143
    ],
    [
        112.88812877665,
        23.025139114617
    ],
    [
        112.88807360439,
        23.025107570882
    ],
    [
        112.88794459391,
        23.025025468748
    ],
    [
        112.88783045245,
        23.024941169395
    ],
    [
        112.88776499623,
        23.024892105673
    ],
    [
        112.88775850617,
        23.024890374392
    ],
    [
        112.8877439098,
        23.024899908088
    ],
    [
        112.88771742578,
        23.024929327977
    ],
    [
        112.88770662354,
        23.024957370172
    ],
    [
        112.88770123155,
        23.024990653126
    ],
    [
        112.88760501554,
        23.025079191383
    ],
    [
        112.88748341416,
        23.025233526735
    ],
    [
        112.88733884523,
        23.025420603925
    ],
    [
        112.88733480123,
        23.025444685177
    ],
    [
        112.88734076102,
        23.025467025171
    ],
    [
        112.88735646568,
        23.025510679774
    ],
    [
        112.88746223396,
        23.025599164985
    ],
    [
        112.88762695907,
        23.025712465297
    ],
    [
        112.88770379339,
        23.025799145284
    ],
    [
        112.88782551596,
        23.02589468345
    ],
    [
        112.88790341855,
        23.025956970559
    ],
    [
        112.88793102612,
        23.026011942785
    ],
    [
        112.88793159983,
        23.026074892168
    ],
    [
        112.88791351621,
        23.026135643661
    ],
    [
        112.88787003126,
        23.026223660863
    ],
    [
        112.88776517858,
        23.026329147116
    ],
    [
        112.8877005797,
        23.026372609714
    ],
    [
        112.88763221109,
        23.02644558528
    ],
    [
        112.88754737419,
        23.026565506931
    ],
    [
        112.88744771579,
        23.026775538676
    ],
    [
        112.8873196688,
        23.026988654216
    ],
    [
        112.88725810018,
        23.027132014108
    ],
    [
        112.88720330462,
        23.027296914708
    ],
    [
        112.88720548628,
        23.027328690732
    ],
    [
        112.88722957247,
        23.027364337972
    ],
    [
        112.8873112762,
        23.027439417041
    ],
    [
        112.88737188769,
        23.027512538194
    ],
    [
        112.88737381239,
        23.027566556768
    ],
    [
        112.88735463997,
        23.027609661765
    ],
    [
        112.88732626131,
        23.027631189248
    ],
    [
        112.88728407676,
        23.027626455041
    ],
    [
        112.88723053799,
        23.027626155092
    ],
    [
        112.88720513005,
        23.027642033544
    ],
    [
        112.88714728747,
        23.027680192202
    ],
    [
        112.8870657005,
        23.027803439424
    ],
    [
        112.88700065339,
        23.02800074126
    ],
    [
        112.88695962715,
        23.028122998952
    ],
    [
        112.88691151611,
        23.028156974953
    ],
    [
        112.88683934503,
        23.028201158394
    ],
    [
        112.88678476179,
        23.028264065552
    ],
    [
        112.88674613547,
        23.028331562293
    ],
    [
        112.88672081507,
        23.028487438245
    ],
    [
        112.88666713487,
        23.028693880138
    ],
    [
        112.88663126225,
        23.028836843247
    ],
    [
        112.886582234,
        23.029122850895
    ],
    [
        112.88655399614,
        23.029357090875
    ],
    [
        112.88648793861,
        23.029644738474
    ],
    [
        112.88641307487,
        23.030097205682
    ],
    [
        112.88636867706,
        23.030410965105
    ],
    [
        112.88630084189,
        23.030842656225
    ],
    [
        112.88625510048,
        23.031156399225
    ],
    [
        112.88620502414,
        23.031454613393
    ],
    [
        112.88621425307,
        23.03150060484
    ],
    [
        112.88623698147,
        23.031517772678
    ],
    [
        112.88648910532,
        23.031641825636
    ],
    [
        112.88658568027,
        23.031690792403
    ],
    [
        112.88664382223,
        23.031695217443
    ],
    [
        112.88670873285,
        23.031711143739
    ],
    [
        112.88683533156,
        23.031773880945
    ],
    [
        112.88700034628,
        23.031862999375
    ],
    [
        112.88708825392,
        23.031898559
    ],
    [
        112.88713018009,
        23.031917122231
    ],
    [
        112.88725108909,
        23.031970840825
    ],
    [
        112.88739421271,
        23.032081077081
    ],
    [
        112.88753027654,
        23.032154855191
    ],
    [
        112.88764172038,
        23.032211428576
    ],
    [
        112.88770178822,
        23.032265560606
    ],
    [
        112.88778565735,
        23.032329569673
    ],
    [
        112.88787845255,
        23.032398607996
    ],
    [
        112.88796069437,
        23.032457442288
    ],
    [
        112.88805402692,
        23.032523511543
    ],
    [
        112.88809515127,
        23.032557814876
    ],
    [
        112.88810139784,
        23.032593185343
    ],
    [
        112.88810791333,
        23.032626661009
    ],
    [
        112.888104707,
        23.032674902172
    ],
    [
        112.88806584982,
        23.032771948038
    ],
    [
        112.88802590979,
        23.032867078028
    ],
    [
        112.88796842338,
        23.032997197365
    ],
    [
        112.88787825037,
        23.033163421648
    ],
    [
        112.88782344638,
        23.033266456686
    ],
    [
        112.88774781755,
        23.033362920796
    ],
    [
        112.88770730007,
        23.033412195947
    ],
    [
        112.88761370797,
        23.033365127177
    ],
    [
        112.88753012746,
        23.033327716614
    ],
    [
        112.88732022546,
        23.033231882178
    ],
    [
        112.88716118752,
        23.03317647563
    ],
    [
        112.88701215351,
        23.033122593109
    ],
    [
        112.88694586786,
        23.03307679235
    ],
    [
        112.88677841345,
        23.032985740347
    ],
    [
        112.88658336799,
        23.032886407352
    ],
    [
        112.88640914532,
        23.032792023885
    ],
    [
        112.8862930895,
        23.032734084968
    ],
    [
        112.88622249273,
        23.032712929673
    ],
    [
        112.8861765257,
        23.032719011424
    ],
    [
        112.8861511103,
        23.032724593081
    ],
    [
        112.88613705628,
        23.032734688853
    ],
    [
        112.88612732994,
        23.03274593579
    ],
    [
        112.88610192524,
        23.03276508362
    ],
    [
        112.88608815825,
        23.032796074816
    ],
    [
        112.88606171537,
        23.032869740325
    ],
    [
        112.8860345699,
        23.033078235877
    ],
    [
        112.88602337592,
        23.033280462466
    ],
    [
        112.88602809999,
        23.033435722901
    ],
    [
        112.88602103282,
        23.033720219355
    ],
    [
        112.88600941547,
        23.034057824152
    ],
    [
        112.88600997313,
        23.034398055975
    ],
    [
        112.88600335218,
        23.034562098731
    ],
    [
        112.88599277833,
        23.034845458782
    ],
    [
        112.88599227354,
        23.034887233105
    ],
    [
        112.88592926513,
        23.034888992799
    ],
    [
        112.88570401016,
        23.034907034042
    ],
    [
        112.88560613265,
        23.034931071217
    ],
    [
        112.88541223446,
        23.03494066152
    ],
    [
        112.8852334629,
        23.034933401807
    ],
    [
        112.88505444263,
        23.0349551855
    ],
    [
        112.8849644124,
        23.034991579407
    ],
    [
        112.88471705089,
        23.03511820905
    ],
    [
        112.88445728495,
        23.035294615545
    ],
    [
        112.88420078396,
        23.035500407749
    ],
    [
        112.88402509261,
        23.035639004123
    ],
    [
        112.88393429136,
        23.035731871657
    ],
    [
        112.8837629176,
        23.035864043748
    ],
    [
        112.88364779652,
        23.035987245767
    ],
    [
        112.88347535121,
        23.03613652469
    ],
    [
        112.88337647557,
        23.036279775163
    ],
    [
        112.88330924162,
        23.036415053483
    ],
    [
        112.88322366129,
        23.036603533335
    ],
    [
        112.88310697982,
        23.036800820425
    ],
    [
        112.88298761165,
        23.037018970974
    ],
    [
        112.88291362239,
        23.037163399506
    ],
    [
        112.88283093273,
        23.037261048739
    ],
    [
        112.88273721278,
        23.037425298704
    ],
    [
        112.88266138162,
        23.037626148127
    ],
    [
        112.88259010895,
        23.037783651134
    ],
    [
        112.88251152267,
        23.037931564866
    ],
    [
        112.88237137518,
        23.038208363835
    ],
    [
        112.88226552662,
        23.038422948225
    ],
    [
        112.88213126883,
        23.038636357804
    ],
    [
        112.88205804398,
        23.038734713157
    ],
    [
        112.88200779067,
        23.038807049766
    ],
    [
        112.88196211941,
        23.038861539936
    ],
    [
        112.88192912454,
        23.038874953733
    ],
    [
        112.88186878746,
        23.0388720108
    ],
    [
        112.88173023988,
        23.038850711343
    ],
    [
        112.88160195059,
        23.038807848381
    ],
    [
        112.88127637701,
        23.038731608675
    ],
    [
        112.88102766708,
        23.038687036359
    ],
    [
        112.88060924712,
        23.038606827191
    ],
    [
        112.88032370689,
        23.038558680162
    ],
    [
        112.88009390726,
        23.038513947599
    ],
    [
        112.87985843452,
        23.038487908663
    ],
    [
        112.87974935697,
        23.03847635872
    ],
    [
        112.87968873271,
        23.038475401986
    ],
    [
        112.8796798183,
        23.038492937039
    ],
    [
        112.87966305725,
        23.038512554271
    ],
    [
        112.87966470186,
        23.038534278176
    ],
    [
        112.87965389785,
        23.038556947141
    ],
    [
        112.87967783597,
        23.03868392205
    ],
    [
        112.87978345321,
        23.039035659278
    ],
    [
        112.87982899561,
        23.039113773893
    ],
    [
        112.87986772515,
        23.039143517675
    ],
    [
        112.87990047188,
        23.039143620461
    ],
    [
        112.88003634672,
        23.039162816559
    ],
    [
        112.88021526704,
        23.039202061907
    ],
    [
        112.88041990999,
        23.039260896788
    ],
    [
        112.88067406936,
        23.03932170989
    ],
    [
        112.88103325084,
        23.039425630799
    ],
    [
        112.88118618631,
        23.039481500741
    ],
    [
        112.88132099525,
        23.039542858881
    ],
    [
        112.88145147969,
        23.039611500678
    ],
    [
        112.88147016798,
        23.03963072678
    ],
    [
        112.88146260774,
        23.039646911227
    ],
    [
        112.88144316304,
        23.039684381216
    ],
    [
        112.88133079297,
        23.039878058364
    ],
    [
        112.88116894989,
        23.040117258034
    ],
    [
        112.88097633122,
        23.040431798133
    ],
    [
        112.88089153652,
        23.040604953884
    ],
    [
        112.88078105139,
        23.040795169205
    ],
    [
        112.88057997129,
        23.041044272428
    ],
    [
        112.88040893721,
        23.041306238691
    ],
    [
        112.88035866521,
        23.041368321451
    ],
    [
        112.88033918722,
        23.04137460421
    ],
    [
        112.8803197051,
        23.041376817396
    ],
    [
        112.87996758758,
        23.041339900606
    ],
    [
        112.87969719865,
        23.041315659181
    ],
    [
        112.87963603995,
        23.041322024469
    ],
    [
        112.87962007941,
        23.041329442049
    ],
    [
        112.87949494005,
        23.041498973509
    ],
    [
        112.87929082291,
        23.041723809278
    ],
    [
        112.87929490873,
        23.041749629587
    ],
    [
        112.87931821356,
        23.041777831974
    ],
    [
        112.87947678583,
        23.042016449714
    ],
    [
        112.87960224691,
        23.042166534935
    ],
    [
        112.87975264037,
        23.04235191408
    ],
    [
        112.87987565672,
        23.042497655312
    ],
    [
        112.87998354621,
        23.042673350017
    ],
    [
        112.88008954732,
        23.042856356849
    ],
    [
        112.88013433356,
        23.042987380733
    ],
    [
        112.88013355895,
        23.043023999999
    ],
    [
        112.88012139869,
        23.043041494829
    ],
    [
        112.8800810931,
        23.04305866407
    ],
    [
        112.87978683828,
        23.043247116406
    ],
    [
        112.87930619592,
        23.04353802629
    ],
    [
        112.87895130282,
        23.043750953599
    ],
    [
        112.87869838995,
        23.043916480364
    ],
    [
        112.87845085158,
        23.044053079648
    ],
    [
        112.87832911678,
        23.044128878952
    ],
    [
        112.87826960009,
        23.044164897408
    ],
    [
        112.87826314327,
        23.044203901649
    ],
    [
        112.87826807044,
        23.044257130958
    ],
    [
        112.87832510245,
        23.04443787252
    ],
    [
        112.87836875877,
        23.044510221574
    ],
    [
        112.87842242361,
        23.044575892507
    ],
    [
        112.87844629744,
        23.044627419304
    ],
    [
        112.8784945751,
        23.044719626856
    ],
    [
        112.878516829,
        23.044775479229
    ],
    [
        112.87851770907,
        23.044841690766
    ],
    [
        112.87852505119,
        23.044874325785
    ],
    [
        112.87851778627,
        23.044916847546
    ],
    [
        112.87850453852,
        23.044932446296
    ],
    [
        112.87847829468,
        23.044945196964
    ],
    [
        112.87844879711,
        23.044952759336
    ],
    [
        112.87839872117,
        23.044954954684
    ],
    [
        112.87832347062,
        23.044957707237
    ],
    [
        112.87826012595,
        23.044956515877
    ],
    [
        112.87818787468,
        23.044981826534
    ],
    [
        112.87810643105,
        23.045019257788
    ],
    [
        112.87803337651,
        23.045054879119
    ],
    [
        112.87794166294,
        23.045110938789
    ],
    [
        112.87781858042,
        23.045201695232
    ],
    [
        112.87771361912,
        23.045277989467
    ],
    [
        112.87755103095,
        23.045393346815
    ],
    [
        112.8774347168,
        23.045491531302
    ],
    [
        112.87728243648,
        23.045633068605
    ],
    [
        112.87717047164,
        23.045753024232
    ],
    [
        112.87704577315,
        23.045866902671
    ],
    [
        112.87700250661,
        23.04591941013
    ],
    [
        112.87699468451,
        23.045948369339
    ],
    [
        112.87698145338,
        23.045983247808
    ],
    [
        112.87698420141,
        23.046022614771
    ],
    [
        112.87699235845,
        23.046056062552
    ],
    [
        112.877005654,
        23.046083860081
    ],
    [
        112.87702138884,
        23.046114122202
    ],
    [
        112.87704198552,
        23.046133034048
    ],
    [
        112.87709266283,
        23.046178543969
    ],
    [
        112.87719291619,
        23.046253008973
    ],
    [
        112.87740210401,
        23.046423751413
    ],
    [
        112.87753731388,
        23.046534392377
    ],
    [
        112.87768552436,
        23.046653585581
    ],
    [
        112.87779770891,
        23.046756432238
    ],
    [
        112.8778949961,
        23.04685344282
    ],
    [
        112.8779833535,
        23.046955526463
    ],
    [
        112.8780798251,
        23.047052000106
    ],
    [
        112.87812887302,
        23.047100790464
    ],
    [
        112.87815679459,
        23.047138786828
    ],
    [
        112.87817415237,
        23.047170707462
    ],
    [
        112.87817039169,
        23.047199158025
    ],
    [
        112.87816825942,
        23.047231694934
    ],
    [
        112.87814311842,
        23.047265355275
    ],
    [
        112.87809632947,
        23.047307479783
    ],
    [
        112.87795349575,
        23.047406164047
    ],
    [
        112.87786559894,
        23.047489670781
    ],
    [
        112.87774686167,
        23.0475956713
    ],
    [
        112.87765787566,
        23.047675925681
    ],
    [
        112.87762382595,
        23.047736370113
    ],
    [
        112.87761057183,
        23.047747636804
    ],
    [
        112.87760951443,
        23.047772588082
    ],
    [
        112.87760870806,
        23.047778277995
    ],
    [
        112.87762036943,
        23.047797926414
    ],
    [
        112.87763501241,
        23.047821131126
    ],
    [
        112.87767973196,
        23.047869862252
    ],
    [
        112.87778675903,
        23.047959633969
    ],
    [
        112.87792113172,
        23.048054570246
    ],
    [
        112.87809535268,
        23.048205542633
    ],
    [
        112.87817096433,
        23.048288789149
    ],
    [
        112.87821328479,
        23.048377941135
    ],
    [
        112.87821763761,
        23.048399148471
    ],
    [
        112.87821603023,
        23.048415682676
    ],
    [
        112.87819171069,
        23.048458575327
    ],
    [
        112.87815520591,
        23.048498089042
    ],
    [
        112.87804891865,
        23.048596862345
    ],
    [
        112.87797861043,
        23.048672127331
    ],
    [
        112.8779351068,
        23.048752004067
    ],
    [
        112.87792889767,
        23.04876903542
    ],
    [
        112.87792701642,
        23.048782582722
    ],
    [
        112.87792540451,
        23.048794776105
    ],
    [
        112.87794627309,
        23.04881804631
    ],
    [
        112.87805166665,
        23.048903753689
    ],
    [
        112.87819713145,
        23.048998287263
    ],
    [
        112.87847938353,
        23.049182157663
    ],
    [
        112.8786137364,
        23.049272823548
    ],
    [
        112.87871557842,
        23.049337383924
    ],
    [
        112.87879440992,
        23.049400622275
    ],
    [
        112.87880849405,
        23.04940945414
    ],
    [
        112.87881119921,
        23.049407854973
    ],
    [
        112.87881793608,
        23.049378081379
    ],
    [
        112.87882380388,
        23.049291863954
    ],
    [
        112.87884676249,
        23.049243542096
    ],
    [
        112.87888271954,
        23.04920132849
    ],
    [
        112.878892994,
        23.049190314169
    ],
    [
        112.87891491244,
        23.049184308326
    ],
    [
        112.87893629248,
        23.049181281592
    ],
    [
        112.87897311538,
        23.04919280112
    ],
    [
        112.87901590766,
        23.049219037307
    ],
    [
        112.87910285129,
        23.049278040179
    ],
    [
        112.87919307021,
        23.049365301676
    ],
    [
        112.87928220027,
        23.049447673432
    ],
    [
        112.87943122408,
        23.049610210616
    ],
    [
        112.87952659566,
        23.049712473841
    ],
    [
        112.87957943564,
        23.049776010677
    ],
    [
        112.87959355189,
        23.049818494703
    ],
    [
        112.87957149003,
        23.049949023783
    ],
    [
        112.87956159707,
        23.050069650392
    ],
    [
        112.87955409442,
        23.050144993376
    ],
    [
        112.87956955482,
        23.050178538595
    ],
    [
        112.87961426603,
        23.050233303526
    ],
    [
        112.87980635239,
        23.050435977482
    ],
    [
        112.87991767222,
        23.050525425335
    ],
    [
        112.8800160058,
        23.05062070151
    ],
    [
        112.88010515511,
        23.050734599237
    ],
    [
        112.88022897735,
        23.050883635286
    ],
    [
        112.8802899468,
        23.050964657974
    ],
    [
        112.88034953705,
        23.051019891758
    ],
    [
        112.88041184791,
        23.051090353948
    ],
    [
        112.88044222623,
        23.051160983978
    ],
    [
        112.88046093263,
        23.051195662514
    ],
    [
        112.88050162063,
        23.051293547578
    ],
    [
        112.88051468855,
        23.051373470191
    ],
    [
        112.8805613422,
        23.051484450946
    ],
    [
        112.88057444276,
        23.051598017922
    ],
    [
        112.88057750345,
        23.051683790955
    ],
    [
        112.88056805628,
        23.051708368489
    ],
    [
        112.88056511036,
        23.051739806364
    ],
    [
        112.88054131972,
        23.051763128243
    ],
    [
        112.88048319673,
        23.051822400297
    ],
    [
        112.88043805928,
        23.051878300828
    ],
    [
        112.88039968161,
        23.051928856028
    ],
    [
        112.88036996662,
        23.051982769913
    ],
    [
        112.88034429859,
        23.052024251289
    ],
    [
        112.88034325465,
        23.052063851467
    ],
    [
        112.88034870842,
        23.052106512434
    ],
    [
        112.88035500957,
        23.052185811292
    ],
    [
        112.88037265604,
        23.052244080751
    ],
    [
        112.88039569738,
        23.052284506967
    ],
    [
        112.88041038471,
        23.05236119163
    ],
    [
        112.88042804815,
        23.052437368901
    ],
    [
        112.88044922393,
        23.052507890191
    ],
    [
        112.88050125989,
        23.052589629858
    ],
    [
        112.8805522043,
        23.052662404934
    ],
    [
        112.88061207362,
        23.052730404503
    ],
    [
        112.88069168953,
        23.052791317454
    ],
    [
        112.88076671022,
        23.05285841975
    ],
    [
        112.88084225851,
        23.052912237736
    ],
    [
        112.88093458656,
        23.052970061828
    ],
    [
        112.88100228965,
        23.053027862517
    ],
    [
        112.88105188415,
        23.053108235362
    ],
    [
        112.88108252139,
        23.053172098492
    ],
    [
        112.88112857452,
        23.053228283298
    ],
    [
        112.8811461919,
        23.053259158553
    ],
    [
        112.88119737742,
        23.053306726446
    ],
    [
        112.88125208116,
        23.053355424854
    ],
    [
        112.88129216195,
        23.053392277384
    ],
    [
        112.8813254949,
        23.053446954093
    ],
    [
        112.88134260307,
        23.053512282509
    ],
    [
        112.8813494467,
        23.053596204311
    ],
    [
        112.88137495049,
        23.053670048234
    ],
    [
        112.8814053278,
        23.053747480425
    ],
    [
        112.88143649063,
        23.053797248775
    ],
    [
        112.8815310151,
        23.053898276396
    ],
    [
        112.88163201004,
        23.053976058345
    ],
    [
        112.88169238724,
        23.054019960525
    ],
    [
        112.88179578907,
        23.054070109569
    ],
    [
        112.8818385816,
        23.054117320964
    ],
    [
        112.88184590675,
        23.054138848327
    ],
    [
        112.88184998235,
        23.054157349786
    ],
    [
        112.8818405263,
        23.054171880202
    ],
    [
        112.88179945488,
        23.054229689796
    ],
    [
        112.88171540987,
        23.054337420007
    ],
    [
        112.88161245027,
        23.054473675719
    ],
    [
        112.88152190451,
        23.054576722262
    ],
    [
        112.88142023977,
        23.054653589198
    ],
    [
        112.88133157681,
        23.054747445914
    ],
    [
        112.88127994184,
        23.054797270246
    ],
    [
        112.88112343925,
        23.054977935521
    ],
    [
        112.88096613714,
        23.055176785582
    ],
    [
        112.8808377535,
        23.05534127323
    ],
    [
        112.88073881882,
        23.055457289029
    ],
    [
        112.88066127371,
        23.055588489447
    ],
    [
        112.88060695535,
        23.05567032025
    ],
    [
        112.88050232464,
        23.055776245566
    ],
    [
        112.88038281681,
        23.055891770637
    ],
    [
        112.88029195859,
        23.055969385436
    ],
    [
        112.88020461329,
        23.056042705895
    ],
    [
        112.88014729269,
        23.056100914824
    ],
    [
        112.88008513883,
        23.056203022944
    ],
    [
        112.88007866161,
        23.056223296597
    ],
    [
        112.88008084496,
        23.056244212928
    ],
    [
        112.88009872927,
        23.056270465705
    ],
    [
        112.88013641912,
        23.056353923872
    ],
    [
        112.88019229688,
        23.056502438185
    ],
    [
        112.8802232368,
        23.056605083251
    ],
    [
        112.88022929962,
        23.056731314202
    ],
    [
        112.88023966254,
        23.056823409906
    ],
    [
        112.88022947789,
        23.056938598794
    ],
    [
        112.8801998174,
        23.057064684708
    ],
    [
        112.8801766061,
        23.057137668988
    ],
    [
        112.88018176159,
        23.057153736294
    ],
    [
        112.88019152438,
        23.057177725233
    ],
    [
        112.88023756402,
        23.057217872935
    ],
    [
        112.88029065623,
        23.057277910361
    ],
    [
        112.88035430983,
        23.057347298337
    ],
    [
        112.88041472149,
        23.05742397631
    ],
    [
        112.88046890538,
        23.057497056097
    ],
    [
        112.88049223639,
        23.057566787807
    ],
    [
        112.88051422817,
        23.057653325261
    ],
    [
        112.88052430393,
        23.057729140471
    ],
    [
        112.88054439865,
        23.057812942688
    ],
    [
        112.88056936451,
        23.057897345696
    ],
    [
        112.88062249211,
        23.058004874895
    ],
    [
        112.88070784545,
        23.058142636125
    ],
    [
        112.88076126502,
        23.058278661277
    ],
    [
        112.88080490585,
        23.058370075563
    ],
    [
        112.88085638716,
        23.058453717917
    ],
    [
        112.88090326136,
        23.058529438203
    ],
    [
        112.88094984897,
        23.058585893513
    ],
    [
        112.88098588346,
        23.058642764315
    ],
    [
        112.8810157279,
        23.05874188464
    ],
    [
        112.88103501967,
        23.058841961809
    ],
    [
        112.88103781785,
        23.058958116097
    ],
    [
        112.8810168184,
        23.059092971318
    ],
    [
        112.88101284992,
        23.059207957585
    ],
    [
        112.8810013126,
        23.059333432491
    ],
    [
        112.88101138114,
        23.059406265768
    ],
    [
        112.8810439246,
        23.059499992927
    ],
    [
        112.88107427904,
        23.0595627649
    ],
    [
        112.88113930946,
        23.059679139271
    ],
    [
        112.88121488959,
        23.059792933431
    ],
    [
        112.88129911743,
        23.059894087059
    ],
    [
        112.88140201758,
        23.060000361444
    ],
    [
        112.88153332007,
        23.060098859743
    ],
    [
        112.8816001947,
        23.060157217318
    ],
    [
        112.88166598715,
        23.06021664937
    ],
    [
        112.88168089823,
        23.060256719854
    ],
    [
        112.88169254946,
        23.060279385637
    ],
    [
        112.88169472837,
        23.060298675936
    ],
    [
        112.88168499862,
        23.060312932059
    ],
    [
        112.88165767966,
        23.060323981621
    ],
    [
        112.88157220288,
        23.060354647238
    ],
    [
        112.88152568261,
        23.060378751856
    ],
    [
        112.88147511204,
        23.060414473384
    ],
    [
        112.88142726308,
        23.060472206323
    ],
    [
        112.88140348122,
        23.060511249095
    ],
    [
        112.88138674467,
        23.060564487822
    ],
    [
        112.88137433983,
        23.060621307576
    ],
    [
        112.88133135705,
        23.060674763166
    ],
    [
        112.88127023713,
        23.060717414563
    ],
    [
        112.88123642638,
        23.060733817554
    ],
    [
        112.88115229538,
        23.06076208192
    ],
    [
        112.88105543296,
        23.060772831812
    ],
    [
        112.88096587649,
        23.060785304773
    ],
    [
        112.88087956115,
        23.060791039813
    ],
    [
        112.88079082884,
        23.060823610042
    ],
    [
        112.88067422814,
        23.060862905874
    ],
    [
        112.88058983429,
        23.060911275997
    ],
    [
        112.88047162461,
        23.060975800373
    ],
    [
        112.88036856952,
        23.061043496863
    ],
    [
        112.88026794658,
        23.061108787444
    ],
    [
        112.88021385978,
        23.061161061009
    ],
    [
        112.88014708226,
        23.061254427653
    ],
    [
        112.88007111632,
        23.061367496506
    ],
    [
        112.87998757549,
        23.061486451053
    ],
    [
        112.87991649286,
        23.061620745851
    ],
    [
        112.87988326546,
        23.061708268708
    ],
    [
        112.87983112249,
        23.061838714287
    ],
    [
        112.8797846366,
        23.061932057323
    ],
    [
        112.87974435826,
        23.062001054786
    ],
    [
        112.87968841745,
        23.062122238212
    ],
    [
        112.87963515971,
        23.062210083732
    ],
    [
        112.87960815391,
        23.062297953974
    ],
    [
        112.87958763768,
        23.062377486958
    ],
    [
        112.87957792791,
        23.062428111756
    ],
    [
        112.87957795388,
        23.062467450814
    ],
    [
        112.87958392191,
        23.062488407832
    ],
    [
        112.87959123299,
        23.062493915712
    ],
    [
        112.87962372996,
        23.062523580557
    ],
    [
        112.87968843188,
        23.062551166946
    ],
    [
        112.87976099331,
        23.0625964799
    ],
    [
        112.87981541859,
        23.06263779228
    ],
    [
        112.87986823314,
        23.062699978615
    ],
    [
        112.87989371537,
        23.062765652859
    ],
    [
        112.87990838345,
        23.062849109793
    ],
    [
        112.87992172438,
        23.062973789354
    ],
    [
        112.87991800279,
        23.063079554014
    ],
    [
        112.87990912035,
        23.06315623049
    ],
    [
        112.87987966709,
        23.063229145312
    ],
    [
        112.87981885405,
        23.063357320546
    ],
    [
        112.87976046081,
        23.063461651335
    ],
    [
        112.8797199274,
        23.063563473024
    ],
    [
        112.8796669756,
        23.063717788055
    ],
    [
        112.8796313361,
        23.063859548118
    ],
    [
        112.87957213944,
        23.063984767396
    ],
    [
        112.87954591736,
        23.064036563697
    ],
    [
        112.87952834835,
        23.064075705923
    ],
    [
        112.87953188601,
        23.064108301157
    ],
    [
        112.87953190661,
        23.064143298841
    ],
    [
        112.87954221043,
        23.064175969565
    ],
    [
        112.87957064785,
        23.064209114298
    ],
    [
        112.87960854875,
        23.064226901675
    ],
    [
        112.8796591693,
        23.064244019181
    ],
    [
        112.87979774707,
        23.064260505907
    ],
    [
        112.87988002728,
        23.064272022483
    ],
    [
        112.87997341649,
        23.0643078168
    ],
    [
        112.88001673007,
        23.06432974686
    ],
    [
        112.88006222344,
        23.064377747954
    ],
    [
        112.88010851831,
        23.06440839674
    ],
    [
        112.88012937799,
        23.064445805932
    ],
    [
        112.88014457163,
        23.064513263708
    ],
    [
        112.88014379301,
        23.064571583554
    ],
    [
        112.88013110543,
        23.064627594995
    ],
    [
        112.88010784975,
        23.064659610123
    ],
    [
        112.88008052992,
        23.064683439787
    ],
    [
        112.88003750944,
        23.064700035346
    ],
    [
        112.88000260779,
        23.064716996799
    ],
    [
        112.87996931693,
        23.064711188671
    ],
    [
        112.87983589058,
        23.064704510193
    ],
    [
        112.87968324727,
        23.064700069601
    ],
    [
        112.87953331374,
        23.064707613138
    ],
    [
        112.87952411208,
        23.064708324421
    ],
    [
        112.8795138345,
        23.064720960837
    ],
    [
        112.87948976324,
        23.064750535529
    ],
    [
        112.87946137928,
        23.064812075742
    ],
    [
        112.87941841181,
        23.064931512397
    ],
    [
        112.87941600164,
        23.064978148659
    ],
    [
        112.87942392072,
        23.065106288028
    ],
    [
        112.87946864081,
        23.065221542067
    ],
    [
        112.87951577975,
        23.065306710615
    ],
    [
        112.87961949963,
        23.065422899243
    ],
    [
        112.87969587193,
        23.065518982501
    ],
    [
        112.87974462066,
        23.065582473218
    ],
    [
        112.879764927,
        23.065598438058
    ],
    [
        112.87984450511,
        23.065618603202
    ],
    [
        112.87989565863,
        23.065625154688
    ],
    [
        112.87998524028,
        23.065629435716
    ],
    [
        112.880033423,
        23.065649794159
    ],
    [
        112.88006563713,
        23.065667799577
    ],
    [
        112.88009244611,
        23.065700393154
    ],
    [
        112.88010302651,
        23.065750704899
    ],
    [
        112.88012228089,
        23.065828517791
    ],
    [
        112.88012989481,
        23.065899956261
    ],
    [
        112.88012367948,
        23.065917789678
    ],
    [
        112.88010338654,
        23.065925693686
    ],
    [
        112.88007524572,
        23.065934321253
    ],
    [
        112.88005359605,
        23.065935427973
    ],
    [
        112.87999351445,
        23.065931752394
    ],
    [
        112.87992232626,
        23.0659081479
    ],
    [
        112.87986602237,
        23.065884716543
    ],
    [
        112.87983624889,
        23.065877866563
    ],
    [
        112.87981000161,
        23.065886792298
    ],
    [
        112.87977455974,
        23.065909992912
    ],
    [
        112.87975129792,
        23.065936045086
    ],
    [
        112.87973156242,
        23.065978143807
    ],
    [
        112.87971669045,
        23.06600456265
    ],
    [
        112.87971616973,
        23.066045522101
    ],
    [
        112.87972998962,
        23.066079861121
    ],
    [
        112.87973406428,
        23.066110020721
    ],
    [
        112.87978335349,
        23.066175960201
    ],
    [
        112.87984456103,
        23.066264011684
    ],
    [
        112.87991957138,
        23.066354936443
    ],
    [
        112.8800127181,
        23.066456925281
    ],
    [
        112.88007581489,
        23.066540938999
    ],
    [
        112.8801140077,
        23.066613272832
    ],
    [
        112.88013976489,
        23.066714491707
    ],
    [
        112.8801387188,
        23.066792340311
    ],
    [
        112.88014008783,
        23.066826538916
    ],
    [
        112.88011900217,
        23.06687648363
    ],
    [
        112.88007898825,
        23.066960935246
    ],
    [
        112.88006141631,
        23.067002240019
    ],
    [
        112.88005249813,
        23.06702980888
    ],
    [
        112.88004385703,
        23.067071759403
    ],
    [
        112.88005201003,
        23.067147543501
    ],
    [
        112.88005311694,
        23.067202085686
    ],
    [
        112.88005882033,
        23.067247456964
    ],
    [
        112.88007182328,
        23.067276363756
    ],
    [
        112.88011516714,
        23.067375343017
    ],
    [
        112.88015174132,
        23.067466648873
    ],
    [
        112.88017154441,
        23.067577022329
    ],
    [
        112.88020243992,
        23.067681556578
    ],
    [
        112.88021710021,
        23.067792684497
    ],
    [
        112.88022607085,
        23.067889367847
    ],
    [
        112.88021852637,
        23.067969581442
    ],
    [
        112.88020584235,
        23.068056246128
    ],
    [
        112.88019938066,
        23.068138913892
    ],
    [
        112.88019805414,
        23.06820563534
    ],
    [
        112.88019782735,
        23.068316860735
    ],
    [
        112.88020734284,
        23.068429284493
    ],
    [
        112.88021467293,
        23.068489866891
    ],
    [
        112.88024123881,
        23.068608186313
    ],
    [
        112.88027266833,
        23.0687083867
    ],
    [
        112.88031843875,
        23.068805228888
    ],
    [
        112.88035283607,
        23.0688843053
    ],
    [
        112.88036611313,
        23.068930851158
    ],
    [
        112.88037316383,
        23.068971626919
    ],
    [
        112.88035531461,
        23.069003700279
    ],
    [
        112.8803334118,
        23.069052003469
    ],
    [
        112.88028093566,
        23.069119753149
    ],
    [
        112.88018164304,
        23.069192928313
    ],
    [
        112.88009885004,
        23.069245954636
    ],
    [
        112.88005501851,
        23.069275561319
    ],
    [
        112.87997059895,
        23.069325592264
    ],
    [
        112.87989185534,
        23.069357245657
    ],
    [
        112.87983502206,
        23.069358225964
    ],
    [
        112.87977250595,
        23.069362399637
    ],
    [
        112.87972946885,
        23.069346992195
    ],
    [
        112.87964446544,
        23.069284181692
    ],
    [
        112.87958490579,
        23.069233326142
    ],
    [
        112.8794999005,
        23.069171338316
    ],
    [
        112.87947391476,
        23.069162096959
    ],
    [
        112.87944089162,
        23.069151964208
    ],
    [
        112.87939650939,
        23.069166393643
    ],
    [
        112.87935050395,
        23.06918379077
    ],
    [
        112.87930287731,
        23.069210124058
    ],
    [
        112.87922059962,
        23.069218989069
    ],
    [
        112.87910475752,
        23.069225595883
    ],
    [
        112.87904548446,
        23.069234992341
    ],
    [
        112.87901923323,
        23.069245831939
    ],
    [
        112.87899163253,
        23.069268322803
    ],
    [
        112.87896538829,
        23.069300323772
    ],
    [
        112.87896133522,
        23.069320897944
    ],
    [
        112.8789705431,
        23.069335646187
    ],
    [
        112.87898489815,
        23.069363471491
    ],
    [
        112.87900899357,
        23.069380279095
    ],
    [
        112.87910103219,
        23.069413556122
    ],
    [
        112.87920308875,
        23.069461055486
    ],
    [
        112.87929757064,
        23.06952502768
    ],
    [
        112.87942778529,
        23.069613274716
    ],
    [
        112.87956774467,
        23.069714935876
    ],
    [
        112.87969389592,
        23.069810487249
    ],
    [
        112.87981517675,
        23.069918473758
    ],
    [
        112.87989206227,
        23.069998563786
    ],
    [
        112.87998220984,
        23.070086134764
    ],
    [
        112.88003825447,
        23.070166536249
    ],
    [
        112.88011866323,
        23.070275977623
    ],
    [
        112.88018011879,
        23.070357532368
    ],
    [
        112.88027650736,
        23.070523594893
    ],
    [
        112.88033418676,
        23.070659639603
    ],
    [
        112.88038400985,
        23.070769279776
    ],
    [
        112.8804665852,
        23.070913489652
    ],
    [
        112.88051291194,
        23.071118583424
    ],
    [
        112.88055544176,
        23.0712989467
    ],
    [
        112.88057521851,
        23.07139304454
    ],
    [
        112.88062152494,
        23.071533847449
    ],
    [
        112.88066132181,
        23.071612722244
    ],
    [
        112.88069596649,
        23.071645418965
    ],
    [
        112.88073142163,
        23.071672971935
    ],
    [
        112.88076768402,
        23.071680732128
    ],
    [
        112.880845885,
        23.071669738473
    ],
    [
        112.88093706719,
        23.071629337192
    ],
    [
        112.88103338437,
        23.071566759379
    ],
    [
        112.88110182304,
        23.071476175433
    ],
    [
        112.88114968094,
        23.07132186212
    ],
    [
        112.8812375712,
        23.071116771892
    ],
    [
        112.88135144427,
        23.070951887281
    ],
    [
        112.88143151433,
        23.070870957348
    ],
    [
        112.88156624023,
        23.070795329231
    ],
    [
        112.8817226092,
        23.070721614807
    ],
    [
        112.88188330639,
        23.070658280362
    ],
    [
        112.88209162299,
        23.07061538024
    ],
    [
        112.88226449457,
        23.070580727147
    ],
    [
        112.88233673071,
        23.07058275444
    ],
    [
        112.88235215499,
        23.070594621158
    ],
    [
        112.88236162959,
        23.070614819914
    ],
    [
        112.88235000625,
        23.070651290915
    ],
    [
        112.88225887742,
        23.070817753948
    ],
    [
        112.88216801827,
        23.07099073623
    ],
    [
        112.88206742919,
        23.071215141233
    ],
    [
        112.88201471369,
        23.071392964516
    ],
    [
        112.88200526693,
        23.071490503639
    ],
    [
        112.88200879237,
        23.07152635781
    ],
    [
        112.8820277433,
        23.071579500971
    ],
    [
        112.88208106317,
        23.071672422815
    ],
    [
        112.88210921444,
        23.071735451653
    ],
    [
        112.88212438353,
        23.071820015317
    ],
    [
        112.882126834,
        23.071893563407
    ],
    [
        112.88209600274,
        23.071949862131
    ],
    [
        112.88203974729,
        23.07204679682
    ],
    [
        112.8818769142,
        23.072265257387
    ],
    [
        112.88174572053,
        23.072423912319
    ],
    [
        112.88168567177,
        23.072519183732
    ],
    [
        112.88161749332,
        23.072547078459
    ],
    [
        112.88155986275,
        23.072553135328
    ],
    [
        112.88148978424,
        23.072553070475
    ],
    [
        112.8814378293,
        23.072527734993
    ],
    [
        112.88128953716,
        23.072444779866
    ],
    [
        112.88112391451,
        23.072310355346
    ],
    [
        112.88100754729,
        23.072239213905
    ],
    [
        112.88097182554,
        23.072221145839
    ],
    [
        112.88095017453,
        23.072202978279
    ],
    [
        112.8809250099,
        23.072206741859
    ],
    [
        112.88090363272,
        23.072206211333
    ],
    [
        112.8808792806,
        23.07221459726
    ],
    [
        112.88084681585,
        23.072251369667
    ],
    [
        112.88078269244,
        23.072297798613
    ],
    [
        112.88069259348,
        23.072361280801
    ],
    [
        112.88058571562,
        23.072425653885
    ],
    [
        112.88049533907,
        23.072466357772
    ],
    [
        112.88041930037,
        23.072487161777
    ],
    [
        112.88025206294,
        23.072513413494
    ],
    [
        112.88010349357,
        23.072532847465
    ],
    [
        112.87996276714,
        23.072539636991
    ],
    [
        112.87986100665,
        23.072529250939
    ],
    [
        112.87982528464,
        23.072541594551
    ],
    [
        112.87981446003,
        23.072546897117
    ],
    [
        112.87981202918,
        23.072575353528
    ],
    [
        112.87980689264,
        23.072608119642
    ],
    [
        112.87981420559,
        23.072641840904
    ],
    [
        112.87985075334,
        23.072711703047
    ],
    [
        112.87991085137,
        23.072815744411
    ],
    [
        112.87998908053,
        23.072918911187
    ],
    [
        112.88005621013,
        23.073006491541
    ],
    [
        112.88019830671,
        23.073128040363
    ],
    [
        112.88030656811,
        23.073219366661
    ],
    [
        112.88046841159,
        23.073330051325
    ],
    [
        112.88064513408,
        23.073440931768
    ],
    [
        112.88079127005,
        23.073521624954
    ],
    [
        112.88090032806,
        23.073577197115
    ],
    [
        112.88099395853,
        23.07361631297
    ],
    [
        112.88108677457,
        23.073643488784
    ],
    [
        112.88114820203,
        23.073677066283
    ],
    [
        112.88119285238,
        23.073708540682
    ],
    [
        112.88123452835,
        23.073761681537
    ],
    [
        112.8813119259,
        23.073863552477
    ],
    [
        112.88137038121,
        23.073961936382
    ],
    [
        112.88142883578,
        23.074062763912
    ],
    [
        112.88148349862,
        23.074133434992
    ],
    [
        112.88155520768,
        23.074213545226
    ],
    [
        112.88162069224,
        23.074289240002
    ],
    [
        112.88170511349,
        23.074337236173
    ],
    [
        112.88176085263,
        23.074369681453
    ],
    [
        112.88180685011,
        23.074390068839
    ],
    [
        112.88185826188,
        23.074456100216
    ],
    [
        112.88190155733,
        23.074537491915
    ],
    [
        112.88194025701,
        23.074688813675
    ],
    [
        112.88196597051,
        23.074879303677
    ],
    [
        112.88199222348,
        23.075079566361
    ],
    [
        112.88200277977,
        23.075207741025
    ],
    [
        112.8820154982,
        23.07528358854
    ],
    [
        112.88203065105,
        23.075348887954
    ],
    [
        112.88204607308,
        23.075364548811
    ],
    [
        112.88208043415,
        23.075392932395
    ],
    [
        112.88211235985,
        23.075412333403
    ],
    [
        112.88215835444,
        23.075450634727
    ],
    [
        112.88216701249,
        23.075473262152
    ],
    [
        112.88216998882,
        23.075489034276
    ],
    [
        112.88216349612,
        23.075520145987
    ],
    [
        112.88214861611,
        23.075540569663
    ],
    [
        112.88213887635,
        23.075547496578
    ],
    [
        112.88206393326,
        23.075554666729
    ],
    [
        112.88196680397,
        23.075582172096
    ],
    [
        112.88189916442,
        23.075601108449
    ],
    [
        112.88183910014,
        23.075635064029
    ],
    [
        112.88180311555,
        23.075671226967
    ],
    [
        112.88177714166,
        23.075716198448
    ],
    [
        112.8817224876,
        23.075812890067
    ],
    [
        112.88168163165,
        23.075905146382
    ],
    [
        112.88163915119,
        23.076033190419
    ],
    [
        112.881603976,
        23.076106531629
    ],
    [
        112.88157800032,
        23.076153133883
    ],
    [
        112.8815341665,
        23.076204395222
    ],
    [
        112.88146381571,
        23.076261294022
    ],
    [
        112.8813869707,
        23.07629939789
    ],
    [
        112.88132717133,
        23.076341243523
    ],
    [
        112.88127738233,
        23.076402746485
    ],
    [
        112.88120459198,
        23.076492992817
    ],
    [
        112.88112774279,
        23.07655525251
    ],
    [
        112.88103168038,
        23.076621350468
    ],
    [
        112.88095022908,
        23.076677595332
    ],
    [
        112.88090774364,
        23.076715870542
    ],
    [
        112.88087229178,
        23.076785698737
    ],
    [
        112.88086741915,
        23.076820090382
    ],
    [
        112.8808622764,
        23.076844713248
    ],
    [
        112.88087120532,
        23.076859469513
    ],
    [
        112.88090502877,
        23.076881308966
    ],
    [
        112.88096022883,
        23.076907206647
    ],
    [
        112.88102300586,
        23.076919364359
    ],
    [
        112.88112934814,
        23.076916596746
    ],
    [
        112.88123000677,
        23.076910782725
    ],
    [
        112.88132146363,
        23.076915169409
    ],
    [
        112.88135853244,
        23.076927836513
    ],
    [
        112.88141832828,
        23.076962488839
    ],
    [
        112.88145728817,
        23.077013158915
    ],
    [
        112.8815200573,
        23.077078505219
    ],
    [
        112.88159121362,
        23.07714070444
    ],
    [
        112.88163558419,
        23.077182495428
    ],
    [
        112.88173677303,
        23.077231246047
    ],
    [
        112.8818512195,
        23.077260098899
    ],
    [
        112.88200137828,
        23.077282637213
    ],
    [
        112.88206712278,
        23.077289451251
    ],
    [
        112.88221998129,
        23.077330220183
    ],
    [
        112.88226137319,
        23.077354629601
    ],
    [
        112.88228572115,
        23.077370137465
    ],
    [
        112.88229951661,
        23.077398799928
    ],
    [
        112.88231709996,
        23.077423714262
    ],
    [
        112.88231439161,
        23.077456772969
    ],
    [
        112.88230681341,
        23.077489496865
    ],
    [
        112.88228110455,
        23.077564843909
    ],
    [
        112.88223456004,
        23.077670844191
    ],
    [
        112.88218476237,
        23.077829970849
    ],
    [
        112.88216608774,
        23.077890220111
    ],
    [
        112.88213767617,
        23.077922674889
    ],
    [
        112.88208247933,
        23.077957768209
    ],
    [
        112.88198696579,
        23.078020556396
    ],
    [
        112.88192148625,
        23.078056879713
    ],
    [
        112.88187007573,
        23.078089587679
    ],
    [
        112.88182921204,
        23.078160136921
    ],
    [
        112.88176859356,
        23.078254035869
    ],
    [
        112.88166331636,
        23.078448552439
    ],
    [
        112.88161216569,
        23.078538236781
    ],
    [
        112.88160215214,
        23.078554657519
    ],
    [
        112.88158754121,
        23.078555016162
    ],
    [
        112.8815374852,
        23.078555201064
    ],
    [
        112.88140003475,
        23.078539377263
    ],
    [
        112.88119304026,
        23.07853084569
    ],
    [
        112.88099686227,
        23.07853169759
    ],
    [
        112.88077632527,
        23.078529298542
    ],
    [
        112.88054360508,
        23.078519193022
    ],
    [
        112.88040883973,
        23.078517599494
    ],
    [
        112.88039043637,
        23.078527419476
    ],
    [
        112.88037284409,
        23.078542131899
    ],
    [
        112.88033928165,
        23.078581070496
    ],
    [
        112.88032033081,
        23.078630760087
    ],
    [
        112.88029947561,
        23.078743359735
    ],
    [
        112.88024396857,
        23.078925268506
    ],
    [
        112.88020200356,
        23.079033011841
    ],
    [
        112.88018466454,
        23.07914104223
    ],
    [
        112.88017626222,
        23.079212556686
    ],
    [
        112.88016055526,
        23.079270423492
    ],
    [
        112.88016215936,
        23.079374604951
    ],
    [
        112.88015726899,
        23.079473014552
    ],
    [
        112.88016509652,
        23.079576454236
    ],
    [
        112.88017536001,
        23.07967558204
    ],
    [
        112.88019915951,
        23.079749640351
    ],
    [
        112.88022485963,
        23.079792797952
    ],
    [
        112.88023297436,
        23.079811337911
    ],
    [
        112.88026138944,
        23.079812754366
    ],
    [
        112.88028709779,
        23.079816038533
    ],
    [
        112.88043350411,
        23.07980745012
    ],
    [
        112.88056015004,
        23.0798119333
    ],
    [
        112.88064024883,
        23.079818854987
    ],
    [
        112.88069084967,
        23.079830852739
    ],
    [
        112.88070735679,
        23.079829965461
    ],
    [
        112.88073441517,
        23.079839512719
    ],
    [
        112.88074279923,
        23.079861042608
    ],
    [
        112.88075740244,
        23.079904076495
    ],
    [
        112.88075252192,
        23.079947961279
    ],
    [
        112.88073788984,
        23.080035129837
    ],
    [
        112.88072650551,
        23.0801182686
    ],
    [
        112.88072623159,
        23.080132641841
    ],
    [
        112.88072731432,
        23.080131298557
    ],
    [
        112.88073840792,
        23.080136314305
    ],
    [
        112.88077737497,
        23.080135426416
    ],
    [
        112.88083149376,
        23.080141775021
    ],
    [
        112.88086531403,
        23.080161985277
    ],
    [
        112.88087694431,
        23.080185453919
    ],
    [
        112.88090452985,
        23.080251160474
    ],
    [
        112.88092859704,
        23.080317909818
    ],
    [
        112.88095780583,
        23.080382280721
    ],
    [
        112.88098268384,
        23.080450396998
    ],
    [
        112.88099159517,
        23.080523744169
    ],
    [
        112.88099373784,
        23.080610842824
    ],
    [
        112.88099750798,
        23.080681414757
    ],
    [
        112.88097368464,
        23.080723711509
    ],
    [
        112.88095582078,
        23.080741125734
    ],
    [
        112.88093011216,
        23.080748679802
    ],
    [
        112.88090034664,
        23.080748047546
    ],
    [
        112.88085109897,
        23.080743111536
    ],
    [
        112.88076289041,
        23.080714651659
    ],
    [
        112.88064275433,
        23.080666014024
    ],
    [
        112.88046308567,
        23.080599863974
    ],
    [
        112.88040950654,
        23.080589195512
    ],
    [
        112.88039814136,
        23.080586349157
    ],
    [
        112.88038569045,
        23.080596239058
    ],
    [
        112.8803661972,
        23.080630459166
    ],
    [
        112.88035698725,
        23.080665071485
    ],
    [
        112.88035617047,
        23.080684049656
    ],
    [
        112.88035427084,
        23.08070437138
    ],
    [
        112.88037320817,
        23.080727107868
    ],
    [
        112.88042163997,
        23.080759957067
    ],
    [
        112.88046574221,
        23.080790315445
    ],
    [
        112.88053717991,
        23.080805809124
    ],
    [
        112.88060834815,
        23.080814250556
    ],
    [
        112.88071658668,
        23.080829920898
    ],
    [
        112.88075771559,
        23.080840722314
    ],
    [
        112.88082211239,
        23.080864825577
    ],
    [
        112.88088352752,
        23.080905442027
    ],
    [
        112.88092058806,
        23.08094712164
    ],
    [
        112.88095602334,
        23.080993936224
    ],
    [
        112.88097927964,
        23.081047655923
    ],
    [
        112.8809822464,
        23.081082683638
    ],
    [
        112.88097844534,
        23.081127936554
    ],
    [
        112.88097789454,
        23.081161836413
    ],
    [
        112.8809500134,
        23.081196217643
    ],
    [
        112.88091158033,
        23.081225317611
    ],
    [
        112.88087747806,
        23.081249317194
    ],
    [
        112.88080792577,
        23.08127722983
    ],
    [
        112.88072268228,
        23.081289496098
    ],
    [
        112.88062228082,
        23.081311622842
    ],
    [
        112.88052809942,
        23.081342510395
    ],
    [
        112.88047423754,
        23.081376050282
    ],
    [
        112.88044527441,
        23.081400934546
    ],
    [
        112.88041603548,
        23.081442633743
    ],
    [
        112.88030337913,
        23.081701169521
    ],
    [
        112.88022889842,
        23.081889090247
    ],
    [
        112.88017256169,
        23.082032740098
    ],
    [
        112.8801405924,
        23.082139241709
    ],
    [
        112.88013759022,
        23.082214343078
    ],
    [
        112.88014651232,
        23.082239672692
    ],
    [
        112.88015245916,
        23.082260085357
    ],
    [
        112.88019898663,
        23.082318944337
    ],
    [
        112.88026931709,
        23.082410361278
    ],
    [
        112.88032774648,
        23.082481027171
    ],
    [
        112.88039077058,
        23.082565854401
    ],
    [
        112.88042188103,
        23.082595244371
    ],
    [
        112.88051089384,
        23.082649189817
    ],
    [
        112.88061803818,
        23.082697660631
    ],
    [
        112.88072923467,
        23.082760292919
    ],
    [
        112.88083934224,
        23.082835397962
    ],
    [
        112.8808715309,
        23.082869693044
    ],
    [
        112.88089370455,
        23.08291119116
    ],
    [
        112.88090451207,
        23.08295499301
    ],
    [
        112.88089746441,
        23.08298718607
    ],
    [
        112.88087959156,
        23.083022503053
    ],
    [
        112.88083005295,
        23.083072085042
    ],
    [
        112.88074747891,
        23.083177148359
    ],
    [
        112.8806519131,
        23.083285044701
    ],
    [
        112.8805492941,
        23.083431651709
    ],
    [
        112.88046211863,
        23.083526368969
    ],
    [
        112.8803922654,
        23.083610716576
    ],
    [
        112.8803492048,
        23.083689414327
    ],
    [
        112.88032780589,
        23.083737716312
    ],
    [
        112.88031153213,
        23.083825409191
    ],
    [
        112.88027927191,
        23.083958755673
    ],
    [
        112.88025514708,
        23.084050968436
    ],
    [
        112.88021559402,
        23.084148155466
    ],
    [
        112.88018471607,
        23.084209368797
    ],
    [
        112.88013137143,
        23.084280358391
    ],
    [
        112.88006610349,
        23.084384846599
    ],
    [
        112.88001059154,
        23.084457443105
    ],
    [
        112.87992230802,
        23.084582830379
    ],
    [
        112.87985027112,
        23.084686165974
    ],
    [
        112.87981478945,
        23.084746521001
    ],
    [
        112.87979284169,
        23.084802147952
    ],
    [
        112.87977549816,
        23.084850232577
    ],
    [
        112.87977412189,
        23.084899311908
    ],
    [
        112.87977220807,
        23.084940247854
    ],
    [
        112.87977866337,
        23.085024677369
    ],
    [
        112.87980457874,
        23.085162491016
    ],
    [
        112.87984129945,
        23.085339486644
    ],
    [
        112.87987694123,
        23.085505892256
    ],
    [
        112.87988714264,
        23.085670380599
    ],
    [
        112.87989330472,
        23.08579305165
    ],
    [
        112.87989055435,
        23.085878460956
    ],
    [
        112.87987510773,
        23.085917614589
    ],
    [
        112.87984261283,
        23.085952776947
    ],
    [
        112.87981418833,
        23.085966829557
    ],
    [
        112.87979117877,
        23.085976604305
    ],
    [
        112.87975951089,
        23.085981941574
    ],
    [
        112.87967020545,
        23.085968185442
    ],
    [
        112.87956167699,
        23.085965340976
    ],
    [
        112.87951566865,
        23.085960759026
    ],
    [
        112.87949509224,
        23.085973820695
    ],
    [
        112.87947964837,
        23.086005655258
    ],
    [
        112.8794414486,
        23.086077109741
    ],
    [
        112.87942436906,
        23.086130625927
    ],
    [
        112.87940213233,
        23.086211480437
    ],
    [
        112.87939398821,
        23.086257229839
    ],
    [
        112.87937420547,
        23.086303393234
    ],
    [
        112.87934573665,
        23.086395571793
    ],
    [
        112.87932051404,
        23.086489956478
    ],
    [
        112.87925434219,
        23.086726835099
    ],
    [
        112.87919626997,
        23.086993912118
    ],
    [
        112.87916778072,
        23.087115387222
    ],
    [
        112.87913901453,
        23.087246353077
    ],
    [
        112.87906363858,
        23.087468763914
    ],
    [
        112.87896821128,
        23.087721883932
    ],
    [
        112.87886276143,
        23.087980327988
    ],
    [
        112.87876384279,
        23.088175379999
    ],
    [
        112.8786727574,
        23.088391948881
    ],
    [
        112.87854783204,
        23.088608984145
    ],
    [
        112.87842454908,
        23.088791058684
    ],
    [
        112.87831862575,
        23.088914193523
    ],
    [
        112.87823385314,
        23.08897923699
    ],
    [
        112.87815966152,
        23.089006691694
    ],
    [
        112.87812581867,
        23.0890131302
    ],
    [
        112.87804706383,
        23.088979246629
    ],
    [
        112.87797671956,
        23.088915616185
    ],
    [
        112.8779375057,
        23.088853926509
    ],
    [
        112.87795415238,
        23.08864768385
    ],
    [
        112.8779764632,
        23.088471604571
    ],
    [
        112.87801202841,
        23.088310304727
    ],
    [
        112.87801018303,
        23.088230814589
    ],
    [
        112.87800561882,
        23.088169741138
    ],
    [
        112.87799318129,
        23.088144934366
    ],
    [
        112.87795665546,
        23.088111207792
    ],
    [
        112.87792634499,
        23.088095174312
    ],
    [
        112.87789467225,
        23.088092960994
    ],
    [
        112.87783890094,
        23.088097562244
    ],
    [
        112.87778392037,
        23.088136078016
    ],
    [
        112.87772999029,
        23.088225869725
    ],
    [
        112.87769528339,
        23.088312053977
    ],
    [
        112.87761613005,
        23.088471311312
    ],
    [
        112.87752472356,
        23.088736507445
    ],
    [
        112.87751167982,
        23.088811513416
    ],
    [
        112.8775024344,
        23.088873808052
    ],
    [
        112.87747662303,
        23.089013787412
    ],
    [
        112.87744802869,
        23.089266301835
    ],
    [
        112.87741705915,
        23.089423591404
    ],
    [
        112.87740344794,
        23.089533581508
    ],
    [
        112.87738767989,
        23.089629447084
    ],
    [
        112.87736947422,
        23.089726103283
    ],
    [
        112.87734776546,
        23.089798044389
    ],
    [
        112.87729841177,
        23.089911493608
    ],
    [
        112.87723009399,
        23.090040497543
    ],
    [
        112.87716339911,
        23.090169791441
    ],
    [
        112.87708316444,
        23.090300047838
    ],
    [
        112.87704953197,
        23.090383003479
    ],
    [
        112.87699802622,
        23.090469863508
    ],
    [
        112.87696387744,
        23.090516200615
    ],
    [
        112.8769291859,
        23.090563889808
    ],
    [
        112.8769072253,
        23.090604101906
    ],
    [
        112.87688847907,
        23.090692351261
    ],
    [
        112.87687894705,
        23.090768750805
    ],
    [
        112.87689297069,
        23.090845907797
    ],
    [
        112.87692830819,
        23.091026869285
    ],
    [
        112.87698288797,
        23.09118115699
    ],
    [
        112.87703044839,
        23.091306360628
    ],
    [
        112.87707554951,
        23.091460293253
    ],
    [
        112.87710527109,
        23.091541937683
    ],
    [
        112.87711525369,
        23.091588681705
    ],
    [
        112.87711414423,
        23.091623659684
    ],
    [
        112.87709243165,
        23.091692620596
    ],
    [
        112.87703414466,
        23.09179053556
    ],
    [
        112.8769606777,
        23.091910011694
    ],
    [
        112.87686555152,
        23.092025226045
    ],
    [
        112.8767788388,
        23.092112587312
    ],
    [
        112.87674251185,
        23.092169216777
    ],
    [
        112.87672135714,
        23.09221377854
    ],
    [
        112.87670882564,
        23.092311307168
    ],
    [
        112.87670707643,
        23.092470229689
    ],
    [
        112.87669852571,
        23.092668689823
    ],
    [
        112.87669361609,
        23.092713669114
    ],
    [
        112.87666458899,
        23.09278202883
    ],
    [
        112.87662011777,
        23.092862456496
    ],
    [
        112.87655263529,
        23.092936172168
    ],
    [
        112.87648730871,
        23.093021573127
    ],
    [
        112.87644800011,
        23.09307764214
    ],
    [
        112.87641896463,
        23.09315387287
    ],
    [
        112.8764126997,
        23.093199383708
    ],
    [
        112.87641667589,
        23.093304653444
    ],
    [
        112.87641766623,
        23.09341830492
    ],
    [
        112.87640836821,
        23.093529696503
    ],
    [
        112.87640748261,
        23.093618650072
    ],
    [
        112.87639119241,
        23.093670853834
    ],
    [
        112.87636326732,
        23.093712107473
    ],
    [
        112.87633154609,
        23.093759295676
    ],
    [
        112.87628819448,
        23.093789839432
    ],
    [
        112.87624377042,
        23.093807085546
    ],
    [
        112.87618501046,
        23.093804411125
    ],
    [
        112.87609158327,
        23.093807140477
    ],
    [
        112.87597350692,
        23.093815365596
    ],
    [
        112.87576094102,
        23.09379217403
    ],
    [
        112.87556083133,
        23.093761797022
    ],
    [
        112.87537345417,
        23.093719077489
    ],
    [
        112.8752285882,
        23.093681870164
    ],
    [
        112.87510484301,
        23.093646469541
    ],
    [
        112.87501523488,
        23.09359560954
    ],
    [
        112.87492347588,
        23.093523584718
    ],
    [
        112.87483604249,
        23.093459464645
    ],
    [
        112.87477673673,
        23.093444650015
    ],
    [
        112.87473557154,
        23.09343783714
    ],
    [
        112.87468761162,
        23.093458911992
    ],
    [
        112.87462256699,
        23.093504003516
    ],
    [
        112.8745539918,
        23.093559379675
    ],
    [
        112.87451085181,
        23.093646132421
    ],
    [
        112.87448072613,
        23.093717248609
    ],
    [
        112.87447094552,
        23.0937524378
    ],
    [
        112.874439214,
        23.093799675955
    ],
    [
        112.87441644479,
        23.093818500028
    ],
    [
        112.87438365939,
        23.09382965959
    ],
    [
        112.87435873894,
        23.093829212796
    ],
    [
        112.87429348552,
        23.093794581527
    ],
    [
        112.87425423788,
        23.093757964442
    ],
    [
        112.87421746918,
        23.0936714608
    ],
    [
        112.87418205757,
        23.093581170494
    ],
    [
        112.87414420193,
        23.093497645054
    ],
    [
        112.87405785839,
        23.093411350236
    ],
    [
        112.87397122115,
        23.093351097287
    ],
    [
        112.87394440572,
        23.093346849552
    ],
    [
        112.87394034514,
        23.093343296538
    ],
    [
        112.87391270313,
        23.093355859873
    ],
    [
        112.87387637488,
        23.093389521758
    ],
    [
        112.87378770307,
        23.09349471528
    ],
    [
        112.87373043963,
        23.093618562193
    ],
    [
        112.8736856516,
        23.093724862819
    ],
    [
        112.87365631607,
        23.093817703218
    ],
    [
        112.87366005328,
        23.093884447984
    ],
    [
        112.87366597485,
        23.093930593895
    ],
    [
        112.87368432914,
        23.094011536438
    ],
    [
        112.87372380626,
        23.094101837628
    ],
    [
        112.87375735583,
        23.094153045518
    ],
    [
        112.8738528945,
        23.094260804737
    ],
    [
        112.87400858909,
        23.094346463932
    ],
    [
        112.87412366634,
        23.094407998246
    ],
    [
        112.87418593439,
        23.094450735987
    ],
    [
        112.87429497856,
        23.094594154587
    ],
    [
        112.87436828467,
        23.094713734773
    ],
    [
        112.87444562913,
        23.094860470298
    ],
    [
        112.8744909492,
        23.09507614276
    ],
    [
        112.874515441,
        23.095256951
    ],
    [
        112.87454481386,
        23.095430471742
    ],
    [
        112.87455934835,
        23.095535538588
    ],
    [
        112.87455034914,
        23.095604092419
    ],
    [
        112.87450743774,
        23.095732613681
    ],
    [
        112.8744303303,
        23.095934122477
    ],
    [
        112.87436622431,
        23.096134100298
    ],
    [
        112.87431761518,
        23.096269368488
    ],
    [
        112.87421930164,
        23.096549938146
    ],
    [
        112.87413137659,
        23.096722913064
    ],
    [
        112.8740898855,
        23.096771991659
    ],
    [
        112.87406522504,
        23.096782130374
    ],
    [
        112.87401619129,
        23.096784239691
    ],
    [
        112.8739471373,
        23.096757196767
    ],
    [
        112.87388596082,
        23.09670580052
    ],
    [
        112.87374550845,
        23.096544045382
    ],
    [
        112.87364616016,
        23.096460410226
    ],
    [
        112.87353567343,
        23.096408716908
    ],
    [
        112.87352322523,
        23.096393178771
    ],
    [
        112.87349586032,
        23.096395447257
    ],
    [
        112.87346984325,
        23.096405047745
    ],
    [
        112.87332293134,
        23.096483060836
    ],
    [
        112.87324435167,
        23.096493972214
    ],
    [
        112.87323513387,
        23.096500696745
    ],
    [
        112.87321158494,
        23.096476144545
    ],
    [
        112.87314178167,
        23.096367779922
    ],
    [
        112.8730452062,
        23.09620149176
    ],
    [
        112.87298950179,
        23.096079116187
    ],
    [
        112.87292721248,
        23.096047563482
    ],
    [
        112.87287465403,
        23.096041293431
    ],
    [
        112.87283021826,
        23.09604103896
    ],
    [
        112.87274755456,
        23.096066335998
    ],
    [
        112.87259005503,
        23.096146282783
    ],
    [
        112.87243931509,
        23.096237407667
    ],
    [
        112.87234113896,
        23.096330184753
    ],
    [
        112.87227714835,
        23.096374328892
    ],
    [
        112.87217358914,
        23.096423155101
    ],
    [
        112.8719277639,
        23.096463961025
    ],
    [
        112.87173397404,
        23.096490420233
    ],
    [
        112.87167325952,
        23.096500169662
    ],
    [
        112.87163528727,
        23.096534166168
    ],
    [
        112.87159431881,
        23.096584423231
    ],
    [
        112.87158235653,
        23.096625864526
    ],
    [
        112.87157985094,
        23.096698810603
    ],
    [
        112.87159007537,
        23.096779951709
    ],
    [
        112.87160707416,
        23.096861937797
    ],
    [
        112.87167089278,
        23.097014387351
    ],
    [
        112.87170741533,
        23.097083447918
    ],
    [
        112.87173204934,
        23.09711339808
    ],
    [
        112.8717512849,
        23.09711972724
    ],
    [
        112.87179816638,
        23.097122120553
    ],
    [
        112.8719420796,
        23.097108444653
    ],
    [
        112.87205699355,
        23.097094370064
    ],
    [
        112.87215265301,
        23.09709349842
    ],
    [
        112.87227702055,
        23.097107972536
    ],
    [
        112.87231549603,
        23.097111699776
    ],
    [
        112.87234203786,
        23.097126756443
    ],
    [
        112.87235881325,
        23.097153966805
    ],
    [
        112.87235687362,
        23.097200334706
    ],
    [
        112.87234545083,
        23.097245567632
    ],
    [
        112.8723237525,
        23.097267421895
    ],
    [
        112.87228010567,
        23.097288348123
    ],
    [
        112.87223455333,
        23.097318216336
    ],
    [
        112.87210822565,
        23.097370998816
    ],
    [
        112.87192737381,
        23.097478854934
    ],
    [
        112.87174133957,
        23.097615735843
    ],
    [
        112.87153844693,
        23.097804644268
    ],
    [
        112.87147660338,
        23.097859692279
    ],
    [
        112.87147088578,
        23.097887601831
    ],
    [
        112.87149034729,
        23.097942746404
    ],
    [
        112.87156850528,
        23.098118578789
    ],
    [
        112.8717359326,
        23.098464616755
    ],
    [
        112.87182649786,
        23.098696396162
    ],
    [
        112.8718586547,
        23.098792832982
    ],
    [
        112.87188537795,
        23.098903076204
    ],
    [
        112.87188341431,
        23.098972497737
    ],
    [
        112.8718540803,
        23.09904124397
    ],
    [
        112.87179027115,
        23.099169763984
    ],
    [
        112.87169533092,
        23.09926125562
    ],
    [
        112.87155893005,
        23.099346326825
    ],
    [
        112.87139921915,
        23.099429955059
    ],
    [
        112.87118557175,
        23.099509850413
    ],
    [
        112.8709643253,
        23.099591112308
    ],
    [
        112.87077181691,
        23.099656527586
    ],
    [
        112.87050174174,
        23.099758035622
    ],
    [
        112.87027912682,
        23.099823699712
    ],
    [
        112.87002181528,
        23.099876822197
    ],
    [
        112.86978614033,
        23.099970208831
    ],
    [
        112.86943195782,
        23.100082311801
    ],
    [
        112.8691954492,
        23.100169585987
    ],
    [
        112.86903401041,
        23.100283658722
    ],
    [
        112.86897729472,
        23.1003312647
    ],
    [
        112.86894713389,
        23.100396018028
    ],
    [
        112.86892997851,
        23.100470292904
    ],
    [
        112.86891767072,
        23.100577937734
    ],
    [
        112.86891869881,
        23.100635165904
    ],
    [
        112.86896710543,
        23.100765182979
    ],
    [
        112.86910938056,
        23.101113202088
    ],
    [
        112.86920082946,
        23.10130896472
    ],
    [
        112.86929474598,
        23.101475179041
    ],
    [
        112.86942035084,
        23.101672402599
    ],
    [
        112.86954107903,
        23.101862846926
    ],
    [
        112.86964146952,
        23.102054602807
    ],
    [
        112.86972915157,
        23.102210801975
    ],
    [
        112.86984716042,
        23.102401543411
    ],
    [
        112.86991451079,
        23.102553356735
    ],
    [
        112.86994881576,
        23.102676322189
    ],
    [
        112.86995655354,
        23.10279893414
    ],
    [
        112.86994529483,
        23.102941014037
    ],
    [
        112.86990721425,
        23.10306646715
    ],
    [
        112.86984307311,
        23.103226015179
    ],
    [
        112.8697675538,
        23.103376583286
    ],
    [
        112.86973330482,
        23.103464897688
    ],
    [
        112.86967107468,
        23.103609002225
    ],
    [
        112.86965939935,
        23.103626326384
    ],
    [
        112.86965315888,
        23.103631190402
    ],
    [
        112.86960919789,
        23.10367147661
    ],
    [
        112.86950097862,
        23.103715114418
    ],
    [
        112.8691291312,
        23.103844894858
    ],
    [
        112.86870708741,
        23.103980940036
    ],
    [
        112.8683807524,
        23.10410049062
    ],
    [
        112.86816482306,
        23.104169038027
    ],
    [
        112.86810864701,
        23.104208553397
    ],
    [
        112.86808529683,
        23.104235912715
    ],
    [
        112.86807849606,
        23.104256515233
    ],
    [
        112.86808090743,
        23.104285266962
    ],
    [
        112.86808116284,
        23.104300726343
    ],
    [
        112.86809279215,
        23.104331931924
    ],
    [
        112.86811795868,
        23.10438485381
    ],
    [
        112.86825087058,
        23.104619649836
    ],
    [
        112.86839817029,
        23.104835772935
    ],
    [
        112.86849431947,
        23.104949848507
    ],
    [
        112.86850623312,
        23.104967227293
    ],
    [
        112.86852140213,
        23.104983256031
    ],
    [
        112.86854065855,
        23.104979765243
    ],
    [
        112.86868172814,
        23.104916297176
    ],
    [
        112.86883690214,
        23.104844740636
    ],
    [
        112.8690805,
        23.104737608159
    ],
    [
        112.8692559868,
        23.104676193703
    ],
    [
        112.86929612044,
        23.104669785056
    ],
    [
        112.86931645662,
        23.104668209239
    ],
    [
        112.86932350118,
        23.104672837741
    ],
    [
        112.86933026908,
        23.104682889806
    ],
    [
        112.86935544628,
        23.104719567863
    ],
    [
        112.8693681686,
        23.104739670329
    ],
    [
        112.86936788195,
        23.104754857414
    ],
    [
        112.8693450834,
        23.104778394052
    ],
    [
        112.86926664902,
        23.104855219602
    ],
    [
        112.86915997537,
        23.104971308397
    ],
    [
        112.86907013321,
        23.105064935924
    ],
    [
        112.86895343488,
        23.105169630963
    ],
    [
        112.86886551721,
        23.105233988855
    ],
    [
        112.8687124575,
        23.105360058825
    ],
    [
        112.86862103348,
        23.105402190283
    ],
    [
        112.86857790886,
        23.105411601642
    ],
    [
        112.86856569731,
        23.105420528971
    ],
    [
        112.86857300821,
        23.105430848519
    ],
    [
        112.86857408454,
        23.105438986843
    ],
    [
        112.86861709681,
        23.105539415546
    ],
    [
        112.86864711884,
        23.105614598291
    ],
    [
        112.86866416502,
        23.10565070226
    ],
    [
        112.86870912376,
        23.105703134075
    ],
    [
        112.86880040669,
        23.105797428907
    ],
    [
        112.86886379525,
        23.105856956852
    ],
    [
        112.86891142437,
        23.105947914719
    ],
    [
        112.86895632026,
        23.106059751896
    ],
    [
        112.86898173815,
        23.106127882308
    ],
    [
        112.86904130197,
        23.106213448396
    ],
    [
        112.8691192916,
        23.106309638315
    ],
    [
        112.86923115794,
        23.106419206093
    ],
    [
        112.86931595181,
        23.106487220994
    ],
    [
        112.86939614745,
        23.106543297201
    ],
    [
        112.86951619803,
        23.106597588722
    ],
    [
        112.86964303751,
        23.106638352204
    ],
    [
        112.86975064584,
        23.106659275328
    ],
    [
        112.86984390177,
        23.106662536822
    ],
    [
        112.86987724966,
        23.106659926116
    ],
    [
        112.86994125242,
        23.106636528208
    ],
    [
        112.87000556598,
        23.106573538179
    ],
    [
        112.87004817867,
        23.106523228933
    ],
    [
        112.8700590541,
        23.106492074619
    ],
    [
        112.87008133099,
        23.10644549828
    ],
    [
        112.87008110039,
        23.106405900677
    ],
    [
        112.87008985199,
        23.106330803548
    ],
    [
        112.87007775791,
        23.106228246423
    ],
    [
        112.87008523456,
        23.10607449385
    ],
    [
        112.87008918876,
        23.105919102611
    ],
    [
        112.87011204409,
        23.10583700009
    ],
    [
        112.87014736643,
        23.105757651257
    ],
    [
        112.87022227249,
        23.105672469625
    ],
    [
        112.87038072444,
        23.105532798916
    ],
    [
        112.87051635982,
        23.105434563144
    ],
    [
        112.87067067453,
        23.105356212967
    ],
    [
        112.87084588084,
        23.105253286244
    ],
    [
        112.87102543946,
        23.105129521886
    ],
    [
        112.87115512137,
        23.105006388805
    ],
    [
        112.87124087452,
        23.104901794932
    ],
    [
        112.87131056926,
        23.104862228378
    ],
    [
        112.87139189237,
        23.104846855511
    ],
    [
        112.87146073858,
        23.104840111241
    ],
    [
        112.87157591805,
        23.104842533267
    ],
    [
        112.87166808526,
        23.104819636591
    ],
    [
        112.87176434646,
        23.104766933749
    ],
    [
        112.87185766294,
        23.1046770689
    ],
    [
        112.87202548363,
        23.104604125795
    ],
    [
        112.87226108875,
        23.104487893819
    ],
    [
        112.87260482912,
        23.104342197862
    ],
    [
        112.8730057522,
        23.104162496608
    ],
    [
        112.8732708448,
        23.104048546766
    ],
    [
        112.87340314061,
        23.103966913018
    ],
    [
        112.87346201865,
        23.103880763805
    ],
    [
        112.87355067388,
        23.103817316785
    ],
    [
        112.87369162712,
        23.103740653023
    ],
    [
        112.87391555302,
        23.103585090935
    ],
    [
        112.87417168118,
        23.103453659969
    ],
    [
        112.87422911968,
        23.103443208169
    ],
    [
        112.87427542229,
        23.103461430066
    ],
    [
        112.87443461939,
        23.103539846322
    ],
    [
        112.87467099995,
        23.103626982222
    ],
    [
        112.87486321331,
        23.103722242392
    ],
    [
        112.87506759799,
        23.103827661697
    ],
    [
        112.87525246538,
        23.103942727462
    ],
    [
        112.87535016713,
        23.104011025518
    ],
    [
        112.87548577525,
        23.104086956769
    ],
    [
        112.87561353756,
        23.104151991252
    ],
    [
        112.8757055893,
        23.104177963302
    ],
    [
        112.87571805089,
        23.10417399708
    ],
    [
        112.87572672964,
        23.104161592381
    ],
    [
        112.87573005353,
        23.104088934575
    ],
    [
        112.87572360518,
        23.104038707346
    ],
    [
        112.87569983938,
        23.10397396421
    ],
    [
        112.87569257465,
        23.103927527452
    ],
    [
        112.87570589015,
        23.103882886136
    ],
    [
        112.87572461856,
        23.103841543856
    ],
    [
        112.87574521083,
        23.103831406655
    ],
    [
        112.87580641766,
        23.103828384954
    ],
    [
        112.87591446825,
        23.103830638416
    ],
    [
        112.87601518815,
        23.103849654862
    ],
    [
        112.87609965226,
        23.103874779226
    ],
    [
        112.87618897256,
        23.103916495066
    ],
    [
        112.8762731272,
        23.103977157681
    ],
    [
        112.87637945477,
        23.104067581679
    ],
    [
        112.87652255779,
        23.104205801951
    ],
    [
        112.87665427997,
        23.104348818703
    ],
    [
        112.87676192433,
        23.104468849667
    ],
    [
        112.87679623148,
        23.104547540844
    ],
    [
        112.87681679904,
        23.104558033609
    ],
    [
        112.87682761629,
        23.104571150147
    ],
    [
        112.87685604942,
        23.104568425666
    ],
    [
        112.87689260608,
        23.104564962455
    ],
    [
        112.87696060011,
        23.104532769323
    ],
    [
        112.87709092257,
        23.104446373133
    ],
    [
        112.87721880719,
        23.10435834022
    ],
    [
        112.87729739783,
        23.104285854211
    ],
    [
        112.87740006024,
        23.104236113365
    ],
    [
        112.87746776962,
        23.104212081224
    ],
    [
        112.87750540171,
        23.104212443078
    ],
    [
        112.87754519888,
        23.104213369387
    ],
    [
        112.87763856472,
        23.104249532587
    ],
    [
        112.87767832035,
        23.104290330991
    ],
    [
        112.87769508957,
        23.104305954021
    ],
    [
        112.87768882965,
        23.104338438414
    ],
    [
        112.87767769389,
        23.104373587345
    ],
    [
        112.87766928365,
        23.104390862893
    ],
    [
        112.87764244565,
        23.104425858989
    ],
    [
        112.87757388607,
        23.104488928311
    ],
    [
        112.8775199697,
        23.104528275649
    ],
    [
        112.877444647,
        23.10458477759
    ],
    [
        112.87743758762,
        23.104604508521
    ],
    [
        112.87743432881,
        23.104614240987
    ],
    [
        112.87744081262,
        23.104627863744
    ],
    [
        112.87745245123,
        23.104630958639
    ],
    [
        112.87748141409,
        23.104636932173
    ],
    [
        112.87762166638,
        23.104625269739
    ],
    [
        112.87775811239,
        23.104626332287
    ],
    [
        112.87777246456,
        23.104622676438
    ],
    [
        112.87779492115,
        23.104635915827
    ],
    [
        112.87781355043,
        23.104685460396
    ],
    [
        112.87785647726,
        23.104800879265
    ],
    [
        112.87788427495,
        23.104885502205
    ],
    [
        112.8779260995,
        23.105019354949
    ],
    [
        112.8779763303,
        23.105139189978
    ],
    [
        112.87803146677,
        23.10522653062
    ],
    [
        112.87810745367,
        23.105307846106
    ],
    [
        112.87818399271,
        23.10537778069
    ],
    [
        112.87824403858,
        23.105427481595
    ],
    [
        112.87831355614,
        23.105479452084
    ],
    [
        112.8783281586,
        23.10549451867
    ],
    [
        112.87835495935,
        23.105493166854
    ],
    [
        112.87846431567,
        23.105498635919
    ],
    [
        112.87866599633,
        23.105483385397
    ],
    [
        112.87879755282,
        23.105479623344
    ],
    [
        112.8788592684,
        23.105479195506
    ],
    [
        112.87887660332,
        23.105467989601
    ],
    [
        112.87887770573,
        23.105448745228
    ],
    [
        112.87887207734,
        23.105394171224
    ],
    [
        112.87883808843,
        23.105280170302
    ],
    [
        112.87875650301,
        23.105123355981
    ],
    [
        112.87870192522,
        23.105025142214
    ],
    [
        112.87866987201,
        23.104870212793
    ],
    [
        112.87867107843,
        23.104749264319
    ],
    [
        112.87867982377,
        23.104667721175
    ],
    [
        112.87869313688,
        23.104619314275
    ],
    [
        112.87874650892,
        23.104573229373
    ],
    [
        112.87876520251,
        23.104557154546
    ],
    [
        112.8788020138,
        23.104558630027
    ],
    [
        112.8788861497,
        23.104603192022
    ],
    [
        112.87893728937,
        23.104621097259
    ],
    [
        112.8789594751,
        23.104630556677
    ],
    [
        112.87900466306,
        23.10464487478
    ],
    [
        112.87903336292,
        23.104636505542
    ],
    [
        112.87911187923,
        23.104615116136
    ],
    [
        112.87919015027,
        23.104567963325
    ],
    [
        112.87927488185,
        23.104554516405
    ],
    [
        112.87934714859,
        23.10455422669
    ],
    [
        112.8794085837,
        23.104558431438
    ],
    [
        112.87951220674,
        23.104595383108
    ],
    [
        112.87959687797,
        23.104637011837
    ],
    [
        112.87966666221,
        23.104679020458
    ],
    [
        112.87970208148,
        23.104713592722
    ],
    [
        112.87978100812,
        23.104812665203
    ],
    [
        112.87988618154,
        23.104915838662
    ],
    [
        112.87997429553,
        23.105026689249
    ],
    [
        112.88011405782,
        23.105177468652
    ],
    [
        112.88022757258,
        23.105322531284
    ],
    [
        112.88036053512,
        23.10550173325
    ],
    [
        112.88045944219,
        23.105637421513
    ],
    [
        112.88055106725,
        23.105747807145
    ],
    [
        112.88067623497,
        23.105869448528
    ],
    [
        112.88075707206,
        23.105941748186
    ],
    [
        112.88082549099,
        23.105984339988
    ],
    [
        112.8809442271,
        23.10604002189
    ],
    [
        112.88102861077,
        23.106081190161
    ],
    [
        112.88115873314,
        23.106112619338
    ],
    [
        112.88127019251,
        23.106134607481
    ],
    [
        112.88139817065,
        23.106141893059
    ],
    [
        112.88157431881,
        23.106139488856
    ],
    [
        112.88172909041,
        23.106134664107
    ],
    [
        112.88183568968,
        23.106138461095
    ],
    [
        112.88190441823,
        23.106133101408
    ],
    [
        112.88193037764,
        23.106147265836
    ],
    [
        112.88196280921,
        23.106182126044
    ],
    [
        112.88203656718,
        23.106284237569
    ],
    [
        112.88208300317,
        23.106381660052
    ],
    [
        112.88211832744,
        23.106497382672
    ],
    [
        112.88214011215,
        23.10662459287
    ],
    [
        112.88214159813,
        23.10675886308
    ],
    [
        112.88214716265,
        23.106873387516
    ],
    [
        112.88214680033,
        23.106963154687
    ],
    [
        112.88216242069,
        23.107033330408
    ],
    [
        112.88217555956,
        23.107149038064
    ],
    [
        112.88218144404,
        23.107215290685
    ],
    [
        112.88220387046,
        23.107244059426
    ],
    [
        112.88222386826,
        23.107266558972
    ],
    [
        112.88233253716,
        23.107356392022
    ],
    [
        112.88245692847,
        23.107414436045
    ],
    [
        112.88260025714,
        23.107470842032
    ],
    [
        112.88274547387,
        23.107530269394
    ],
    [
        112.88275683857,
        23.107527980054
    ],
    [
        112.88277523891,
        23.107523886229
    ],
    [
        112.88289111919,
        23.107432140044
    ],
    [
        112.8829940123,
        23.107340769306
    ],
    [
        112.88306687308,
        23.107252524135
    ],
    [
        112.88313780085,
        23.107202225949
    ],
    [
        112.88315267477,
        23.107206767358
    ],
    [
        112.8831732375,
        23.107203521023
    ],
    [
        112.88318459356,
        23.107209099749
    ],
    [
        112.88321648509,
        23.107238011389
    ],
    [
        112.88323427883,
        23.107297107392
    ],
    [
        112.88324413609,
        23.107445867283
    ],
    [
        112.88324870602,
        23.107474135917
    ],
    [
        112.8832397628,
        23.107490015587
    ],
    [
        112.88320723819,
        23.107551409263
    ],
    [
        112.88316190667,
        23.107703486319
    ],
    [
        112.88312117575,
        23.107853728532
    ],
    [
        112.88311058198,
        23.107896436747
    ],
    [
        112.88311787682,
        23.107905485751
    ],
    [
        112.88312704069,
        23.107938698238
    ],
    [
        112.88314380108,
        23.107950316753
    ],
    [
        112.88316624776,
        23.107956588429
    ],
    [
        112.88319627787,
        23.107954013529
    ],
    [
        112.88323279465,
        23.107956951881
    ],
    [
        112.88328065535,
        23.107977132487
    ],
    [
        112.88329687192,
        23.107991186049
    ],
    [
        112.88329604438,
        23.10800690518
    ],
    [
        112.88329305194,
        23.108023408362
    ],
    [
        112.88327298725,
        23.108069240696
    ],
    [
        112.88324590989,
        23.108094636507
    ],
    [
        112.88322615063,
        23.108106029322
    ],
    [
        112.88318773333,
        23.108109845617
    ],
    [
        112.88314364163,
        23.10810707659
    ],
    [
        112.88308682851,
        23.108110916745
    ],
    [
        112.88305001463,
        23.108133471762
    ],
    [
        112.8830272508,
        23.108172761426
    ],
    [
        112.88300854609,
        23.108210750114
    ],
    [
        112.8830031029,
        23.108242951191
    ],
    [
        112.88301308653,
        23.108268308895
    ],
    [
        112.88302523926,
        23.108288814097
    ],
    [
        112.88304685049,
        23.108318939757
    ],
    [
        112.88306792697,
        23.108342820529
    ],
    [
        112.8831176812,
        23.108364106934
    ],
    [
        112.88317070029,
        23.108366725411
    ],
    [
        112.8832321253,
        23.108349390273
    ],
    [
        112.88336501551,
        23.108282589885
    ],
    [
        112.8834453899,
        23.108250334501
    ],
    [
        112.88350029875,
        23.108254616721
    ],
    [
        112.88353841874,
        23.108275755229
    ],
    [
        112.88356626254,
        23.108293769071
    ],
    [
        112.8836019191,
        23.108343081267
    ],
    [
        112.88363491513,
        23.108348420521
    ],
    [
        112.88368387095,
        23.108353439754
    ],
    [
        112.88374527674,
        23.108351311046
    ],
    [
        112.88382076178,
        23.108335549348
    ],
    [
        112.88388085073,
        23.1082973355
    ],
    [
        112.88395454641,
        23.108177950528
    ],
    [
        112.88400170182,
        23.108089655596
    ],
    [
        112.88410057932,
        23.107943510164
    ],
    [
        112.88434590444,
        23.107682290554
    ],
    [
        112.88448588536,
        23.107541635767
    ],
    [
        112.88457032332,
        23.107492946414
    ],
    [
        112.88458141812,
        23.107487681945
    ],
    [
        112.88460792162,
        23.107490504941
    ],
    [
        112.88463819029,
        23.107514266211
    ],
    [
        112.8846597909,
        23.107550649786
    ],
    [
        112.88465328834,
        23.107561675627
    ],
    [
        112.88463973453,
        23.107591313466
    ],
    [
        112.88462050501,
        23.107616801277
    ],
    [
        112.88453600756,
        23.107724341024
    ],
    [
        112.88442630806,
        23.107877901275
    ],
    [
        112.88437725626,
        23.107971310879
    ],
    [
        112.88436555238,
        23.108043286718
    ],
    [
        112.88436003033,
        23.108153863439
    ],
    [
        112.88436855797,
        23.108279557735
    ],
    [
        112.88440631798,
        23.108385057904
    ],
    [
        112.88446164109,
        23.108508168458
    ],
    [
        112.88451482382,
        23.108607925486
    ],
    [
        112.88457964475,
        23.108699715291
    ],
    [
        112.88462798703,
        23.108771199573
    ],
    [
        112.88464362341,
        23.10882160013
    ],
    [
        112.88464899079,
        23.108863173566
    ],
    [
        112.88463541229,
        23.108917491694
    ],
    [
        112.88461694153,
        23.108995335048
    ],
    [
        112.88459307043,
        23.10906415064
    ],
    [
        112.88456404014,
        23.109152962178
    ],
    [
        112.8845152862,
        23.109220878238
    ],
    [
        112.88443163575,
        23.109293448415
    ],
    [
        112.88434310971,
        23.109372190813
    ],
    [
        112.88426837566,
        23.109452761167
    ],
    [
        112.88421635409,
        23.109540979995
    ],
    [
        112.8842019859,
        23.109573321776
    ],
    [
        112.88420438919,
        23.109604274453
    ],
    [
        112.8842124783,
        23.109629612366
    ],
    [
        112.88428758296,
        23.109719096995
    ],
    [
        112.8844048807,
        23.109809730617
    ],
    [
        112.88454216415,
        23.109928323356
    ],
    [
        112.88454594558,
        23.109933530864
    ],
    [
        112.88454403465,
        23.109951132382
    ],
    [
        112.88448232075,
        23.109996623294
    ],
    [
        112.88428611949,
        23.11010040524
    ],
    [
        112.88414675776,
        23.110162703477
    ],
    [
        112.88403958772,
        23.110219499782
    ],
    [
        112.88391506668,
        23.11031457166
    ],
    [
        112.8837837468,
        23.110444544383
    ],
    [
        112.88365026625,
        23.110569344034
    ],
    [
        112.88354030864,
        23.110703429122
    ],
    [
        112.88348720146,
        23.11079219743
    ],
    [
        112.88344462447,
        23.110900639852
    ],
    [
        112.88343996483,
        23.110962413014
    ],
    [
        112.88342065811,
        23.111064395999
    ],
    [
        112.88340590556,
        23.111211734915
    ],
    [
        112.88339605997,
        23.111320899881
    ],
    [
        112.88339216596,
        23.111429875428
    ],
    [
        112.88339858669,
        23.111502920844
    ],
    [
        112.88340544126,
        23.111685815012
    ],
    [
        112.88341797277,
        23.111873126807
    ],
    [
        112.88343153853,
        23.112110356975
    ],
    [
        112.88343812496,
        23.112292705516
    ],
    [
        112.88344345659,
        23.112374144064
    ],
    [
        112.88346448336,
        23.112449831976
    ],
    [
        112.8835052025,
        23.112582476227
    ],
    [
        112.88353112445,
        23.112631110818
    ],
    [
        112.88355922675,
        23.112662689255
    ],
    [
        112.88357760601,
        23.112678402939
    ],
    [
        112.88365195212,
        23.112722557159
    ],
    [
        112.88370468046,
        23.112742817734
    ],
    [
        112.88379771215,
        23.112763642459
    ],
    [
        112.88382774183,
        23.112758909068
    ],
    [
        112.8839362251,
        23.112743343035
    ],
    [
        112.88404341225,
        23.112667555134
    ],
    [
        112.88418767558,
        23.112570059744
    ],
    [
        112.88428804707,
        23.112547077463
    ],
    [
        112.88432213353,
        23.112541054243
    ],
    [
        112.88435350676,
        23.112543671876
    ],
    [
        112.88439028208,
        23.112553961423
    ],
    [
        112.88442704267,
        23.112579439701
    ],
    [
        112.88444352048,
        23.112601644468
    ],
    [
        112.88444592013,
        23.112637750823
    ],
    [
        112.88444832344,
        23.11267006019
    ],
    [
        112.88444614093,
        23.112689556578
    ],
    [
        112.88442933493,
        23.112727557423
    ],
    [
        112.88434055128,
        23.112797075439
    ],
    [
        112.88424499656,
        23.112875180513
    ],
    [
        112.88408613483,
        23.112965955675
    ],
    [
        112.88390967664,
        23.113068974193
    ],
    [
        112.88379762212,
        23.113141990237
    ],
    [
        112.88369638869,
        23.113212451877
    ],
    [
        112.88359946214,
        23.113304134194
    ],
    [
        112.88352932979,
        23.113379918831
    ],
    [
        112.88346728221,
        23.113487550299
    ],
    [
        112.88340034058,
        23.113621425056
    ],
    [
        112.88334288236,
        23.113738616895
    ],
    [
        112.88331792297,
        23.113815843652
    ],
    [
        112.88329133172,
        23.113902541155
    ],
    [
        112.88326363731,
        23.114012006444
    ],
    [
        112.88325838623,
        23.114131813589
    ],
    [
        112.88325900279,
        23.114342559392
    ],
    [
        112.88324775698,
        23.114510561998
    ],
    [
        112.88322279519,
        23.114591587467
    ],
    [
        112.8832111301,
        23.11462750073
    ],
    [
        112.88313555646,
        23.114736045669
    ],
    [
        112.88301990124,
        23.114892871802
    ],
    [
        112.88290561334,
        23.115032366454
    ],
    [
        112.8828243748,
        23.115121050684
    ],
    [
        112.88268171883,
        23.115216243927
    ],
    [
        112.88250144966,
        23.115318005101
    ],
    [
        112.88232714874,
        23.115397353435
    ],
    [
        112.88216747698,
        23.115450873622
    ],
    [
        112.88201807553,
        23.115512950218
    ],
    [
        112.88188733545,
        23.115580161865
    ],
    [
        112.88177959396,
        23.115644422474
    ],
    [
        112.88173193746,
        23.11568585601
    ],
    [
        112.88168535599,
        23.115735170062
    ],
    [
        112.88164608274,
        23.115781052019
    ],
    [
        112.88161277024,
        23.11581751745
    ],
    [
        112.88157860712,
        23.115897910738
    ],
    [
        112.88155825267,
        23.115967629626
    ],
    [
        112.88154926799,
        23.116030982422
    ],
    [
        112.88155056321,
        23.1160966343
    ],
    [
        112.88158186049,
        23.116198465059
    ],
    [
        112.88162995987,
        23.116269860541
    ],
    [
        112.88176540796,
        23.116392270686
    ],
    [
        112.88192821344,
        23.116476801155
    ],
    [
        112.88204477538,
        23.116532815833
    ],
    [
        112.88207154316,
        23.116552689313
    ],
    [
        112.88208126591,
        23.116572614139
    ],
    [
        112.88207854891,
        23.116585868926
    ],
    [
        112.88207691038,
        23.116603477207
    ],
    [
        112.88206848538,
        23.116647306409
    ],
    [
        112.88204030402,
        23.116697932564
    ],
    [
        112.88201454923,
        23.116758354504
    ],
    [
        112.88197446062,
        23.116812083252
    ],
    [
        112.88192408214,
        23.116875716342
    ],
    [
        112.88189290339,
        23.11695098809
    ],
    [
        112.88186011379,
        23.117011593877
    ],
    [
        112.88181673661,
        23.117114104918
    ],
    [
        112.8818061312,
        23.117177164715
    ],
    [
        112.88178356903,
        23.117301911277
    ],
    [
        112.88179079461,
        23.117396660245
    ],
    [
        112.88178127083,
        23.117461090207
    ],
    [
        112.88178986757,
        23.117534430036
    ],
    [
        112.88181683893,
        23.117636482634
    ],
    [
        112.88186625212,
        23.117756723273
    ],
    [
        112.88192755676,
        23.117893120265
    ],
    [
        112.88200805973,
        23.118043328105
    ],
    [
        112.88208775621,
        23.118187020455
    ],
    [
        112.8821447605,
        23.118288382814
    ],
    [
        112.88223826875,
        23.118414632558
    ],
    [
        112.88229989545,
        23.118486768585
    ],
    [
        112.88241124828,
        23.118625738355
    ],
    [
        112.88250072645,
        23.118714521875
    ],
    [
        112.88258370608,
        23.118809462613
    ],
    [
        112.88263234309,
        23.118884423293
    ],
    [
        112.88268934246,
        23.118989874085
    ],
    [
        112.88273119115,
        23.119096481029
    ],
    [
        112.88278084868,
        23.119250115698
    ],
    [
        112.88280538376,
        23.119357035926
    ],
    [
        112.88283665969,
        23.119493339444
    ],
    [
        112.8828936251,
        23.119644092414
    ],
    [
        112.88298298674,
        23.119883162011
    ],
    [
        112.88312312936,
        23.120226263444
    ],
    [
        112.88328032651,
        23.120555235482
    ],
    [
        112.88336487316,
        23.12072455547
    ],
    [
        112.88339512414,
        23.120788167262
    ],
    [
        112.88339402251,
        23.120815275106
    ],
    [
        112.88338995472,
        23.120829323185
    ],
    [
        112.88336992998,
        23.120839083795
    ],
    [
        112.88335098663,
        23.12084967316
    ],
    [
        112.88324845084,
        23.120865900427
    ],
    [
        112.88303850785,
        23.120895866982
    ],
    [
        112.88271109641,
        23.120999964402
    ],
    [
        112.88254790947,
        23.121076455551
    ],
    [
        112.88231896565,
        23.12116918974
    ],
    [
        112.88218851135,
        23.121240450379
    ],
    [
        112.88209646723,
        23.121320897612
    ],
    [
        112.88208643935,
        23.121345721172
    ],
    [
        112.88208533928,
        23.121371202643
    ],
    [
        112.88209261723,
        23.121409811516
    ],
    [
        112.88211396478,
        23.121447246345
    ],
    [
        112.88215533295,
        23.121484941047
    ],
    [
        112.88217696718,
        23.121499054607
    ],
    [
        112.88219401281,
        23.121497648656
    ],
    [
        112.88226868951,
        23.121489941553
    ],
    [
        112.88239964839,
        23.121468058091
    ],
    [
        112.88260988482,
        23.12142824844
    ],
    [
        112.88278844669,
        23.121412995824
    ],
    [
        112.88292156306,
        23.121388471566
    ],
    [
        112.88306088452,
        23.121384926918
    ],
    [
        112.88329624908,
        23.121362633881
    ],
    [
        112.88346992066,
        23.121356067732
    ],
    [
        112.88354349471,
        23.121360880512
    ],
    [
        112.8836535721,
        23.121385189264
    ],
    [
        112.88371875044,
        23.12140236965
    ],
    [
        112.88377526433,
        23.121431094466
    ],
    [
        112.883916691,
        23.121491118066
    ],
    [
        112.8840402768,
        23.121531643895
    ],
    [
        112.88406812847,
        23.121543971354
    ],
    [
        112.88421116855,
        23.121611093636
    ],
    [
        112.88432041992,
        23.121644383484
    ],
    [
        112.88442020526,
        23.121674832058
    ],
    [
        112.88450646373,
        23.12170834646
    ],
    [
        112.88458243241,
        23.121757990515
    ],
    [
        112.88470272153,
        23.121860084359
    ],
    [
        112.88483191886,
        23.121985641738
    ],
    [
        112.88497353886,
        23.122136885771
    ],
    [
        112.88513761002,
        23.122281147615
    ],
    [
        112.8852678919,
        23.122396444516
    ],
    [
        112.88535709387,
        23.122466929715
    ],
    [
        112.88553956328,
        23.122591427973
    ],
    [
        112.88571041306,
        23.122697324998
    ],
    [
        112.88582152087,
        23.122761922023
    ],
    [
        112.88596563343,
        23.122806139514
    ],
    [
        112.88614626072,
        23.122836276202
    ],
    [
        112.88619115347,
        23.122833162889
    ],
    [
        112.88630150045,
        23.122811522075
    ],
    [
        112.88643920118,
        23.1227241261
    ],
    [
        112.8866047591,
        23.122627675954
    ],
    [
        112.88680925528,
        23.122529130914
    ],
    [
        112.88693802269,
        23.122448409087
    ],
    [
        112.88706871121,
        23.122323242619
    ],
    [
        112.88715230914,
        23.122257829444
    ],
    [
        112.88723561967,
        23.122217097058
    ],
    [
        112.88735352735,
        23.122195899658
    ],
    [
        112.88747223716,
        23.12218638399
    ],
    [
        112.88759904463,
        23.122195989256
    ],
    [
        112.88771097646,
        23.122209975249
    ],
    [
        112.88772234063,
        23.122198222066
    ],
    [
        112.88775181838,
        23.122190012532
    ],
    [
        112.8877926662,
        23.122161099923
    ],
    [
        112.88789381508,
        23.12212420177
    ],
    [
        112.88794682758,
        23.122098470063
    ],
    [
        112.8880122628,
        23.122094366291
    ],
    [
        112.8880925662,
        23.122093758174
    ],
    [
        112.88812987097,
        23.122104936634
    ],
    [
        112.88819015255,
        23.122123809341
    ],
    [
        112.8883250367,
        23.122173453737
    ],
    [
        112.88846557326,
        23.122258999756
    ],
    [
        112.88858717608,
        23.122354551983
    ],
    [
        112.88880716083,
        23.122495928819
    ],
    [
        112.88899986505,
        23.12259347784
    ],
    [
        112.88913447563,
        23.122636649259
    ],
    [
        112.88920368613,
        23.122638061903
    ],
    [
        112.88929777543,
        23.122629580648
    ],
    [
        112.88944701965,
        23.122615507235
    ],
    [
        112.88958706275,
        23.122613222593
    ],
    [
        112.88968194406,
        23.12262999153
    ],
    [
        112.88978384376,
        23.122662069723
    ],
    [
        112.88992706395,
        23.122757769249
    ],
    [
        112.89003435381,
        23.122813272061
    ],
    [
        112.89014785713,
        23.122874578884
    ],
    [
        112.89022704419,
        23.122909001929
    ],
    [
        112.89029760045,
        23.122911818159
    ],
    [
        112.89038168632,
        23.122894250484
    ],
    [
        112.89049851373,
        23.122827874061
    ],
    [
        112.8906010108,
        23.12276478477
    ],
    [
        112.89072867376,
        23.1226625257
    ],
    [
        112.89090689412,
        23.122550282763
    ],
    [
        112.89097989963,
        23.12252413245
    ],
    [
        112.89113861226,
        23.122476121729
    ],
    [
        112.89127594687,
        23.122460299323
    ],
    [
        112.89138434414,
        23.122462700207
    ],
    [
        112.89149327892,
        23.122468910521
    ],
    [
        112.89159571478,
        23.122491285891
    ],
    [
        112.89177004621,
        23.122525752753
    ],
    [
        112.89198923947,
        23.122573479261
    ],
    [
        112.89211464282,
        23.122606028621
    ],
    [
        112.8921927466,
        23.122630437458
    ],
    [
        112.89221572075,
        23.122633819542
    ],
    [
        112.89225600145,
        23.12262692397
    ],
    [
        112.89228306209,
        23.12258182645
    ],
    [
        112.89230418627,
        23.122521165676
    ],
    [
        112.89235015316,
        23.122499451795
    ],
    [
        112.89243854667,
        23.122495292611
    ],
    [
        112.89258018819,
        23.122494232229
    ],
    [
        112.89260451958,
        23.122488417801
    ],
    [
        112.89261290689,
        23.122476629689
    ],
    [
        112.89261405292,
        23.122379276849
    ],
    [
        112.89261304841,
        23.122264798914
    ],
    [
        112.89260879382,
        23.122160571289
    ],
    [
        112.89262045304,
        23.122107341613
    ],
    [
        112.89263723594,
        23.122072102658
    ],
    [
        112.8926572614,
        23.122038547697
    ],
    [
        112.89267997769,
        23.122022941101
    ],
    [
        112.8927597387,
        23.121992056063
    ],
    [
        112.8928622157,
        23.121945566361
    ],
    [
        112.8930071385,
        23.12188653075
    ],
    [
        112.89318232542,
        23.121840505831
    ],
    [
        112.89332939333,
        23.12180457038
    ],
    [
        112.89340482664,
        23.121775788
    ],
    [
        112.89351540656,
        23.121735418808
    ],
    [
        112.89362275041,
        23.121683873968
    ],
    [
        112.89373144039,
        23.121639677737
    ],
    [
        112.89384958275,
        23.12160649899
    ],
    [
        112.89393311575,
        23.121589527983
    ],
    [
        112.89403934215,
        23.121588418555
    ],
    [
        112.89410610519,
        23.121587698514
    ],
    [
        112.89414771939,
        23.12160335115
    ],
    [
        112.89419338146,
        23.121628297382
    ],
    [
        112.89423174436,
        23.121655013488
    ],
    [
        112.89424930029,
        23.121673767514
    ],
    [
        112.8942690244,
        23.12168415171
    ],
    [
        112.89430119427,
        23.121676854663
    ],
    [
        112.89435528573,
        23.121629531836
    ],
    [
        112.89440937512,
        23.121585192845
    ],
    [
        112.89445456926,
        23.121506250348
    ],
    [
        112.89450434643,
        23.1214444768
    ],
    [
        112.89451705302,
        23.121440362012
    ],
    [
        112.89455111462,
        23.12143337052
    ],
    [
        112.89465490568,
        23.12143412367
    ],
    [
        112.89474680048,
        23.121439549127
    ],
    [
        112.89483143024,
        23.121398465932
    ],
    [
        112.89489878963,
        23.121317748508
    ],
    [
        112.89495180817,
        23.121259018038
    ],
    [
        112.89498430379,
        23.121173885516
    ],
    [
        112.89504031137,
        23.121093510026
    ],
    [
        112.89511066981,
        23.120978129558
    ],
    [
        112.89514154438,
        23.120893240029
    ],
    [
        112.89514887015,
        23.120854855373
    ],
    [
        112.89515406487,
        23.120773849758
    ],
    [
        112.89515788927,
        23.120718857945
    ],
    [
        112.89517442236,
        23.120657039807
    ],
    [
        112.89520906065,
        23.120600967788
    ],
    [
        112.89525236889,
        23.120517113181
    ],
    [
        112.89529672981,
        23.12047179203
    ],
    [
        112.89535541504,
        23.1204278104
    ],
    [
        112.8954216638,
        23.120389930418
    ],
    [
        112.89546302353,
        23.120382257275
    ],
    [
        112.89553330116,
        23.120378352957
    ],
    [
        112.89559869641,
        23.120397416575
    ],
    [
        112.89569327717,
        23.120423780068
    ],
    [
        112.89579783674,
        23.120479342955
    ],
    [
        112.89591131003,
        23.120542659234
    ],
    [
        112.89597319072,
        23.120562746164
    ],
    [
        112.89602562497,
        23.120564492729
    ],
    [
        112.89607914215,
        23.120563817559
    ],
    [
        112.89614078128,
        23.120545114581
    ],
    [
        112.89619406201,
        23.120498868739
    ],
    [
        112.89624006118,
        23.120431066244
    ],
    [
        112.89628335973,
        23.120360503452
    ],
    [
        112.89629773008,
        23.120300275062
    ],
    [
        112.89632477953,
        23.120272548611
    ],
    [
        112.8963645276,
        23.120251286439
    ],
    [
        112.89640399108,
        23.120249005252
    ],
    [
        112.89647183709,
        23.120243431998
    ],
    [
        112.89651778408,
        23.120245605879
    ],
    [
        112.89657967529,
        23.120251318269
    ],
    [
        112.89664749577,
        23.120279648185
    ],
    [
        112.89673746173,
        23.120331969117
    ],
    [
        112.8968622835,
        23.120399285361
    ],
    [
        112.89699195299,
        23.120490284567
    ],
    [
        112.89715431643,
        23.12059624012
    ],
    [
        112.89732668233,
        23.120700474124
    ],
    [
        112.89743342174,
        23.120733020716
    ],
    [
        112.89753502848,
        23.120761949585
    ],
    [
        112.89759718663,
        23.120772818352
    ],
    [
        112.89763340769,
        23.120769393415
    ],
    [
        112.89768963421,
        23.120760356693
    ],
    [
        112.89775264285,
        23.120717536476
    ],
    [
        112.89781459715,
        23.120638623739
    ],
    [
        112.89786575586,
        23.120538634488
    ],
    [
        112.89790525425,
        23.120489971786
    ],
    [
        112.8979144486,
        23.120483896687
    ],
    [
        112.89792121321,
        23.12047398125
    ],
    [
        112.89794202761,
        23.120471095875
    ],
    [
        112.89802175737,
        23.120478477545
    ],
    [
        112.89820903083,
        23.120528449834
    ],
    [
        112.8983941457,
        23.120574312502
    ],
    [
        112.89856116404,
        23.120603578045
    ],
    [
        112.89873924015,
        23.120666397446
    ],
    [
        112.89890730795,
        23.120740428342
    ],
    [
        112.89922938129,
        23.120901522554
    ],
    [
        112.89962821285,
        23.121076970011
    ],
    [
        112.89988545865,
        23.121187803246
    ],
    [
        112.90010406604,
        23.121281405318
    ],
    [
        112.90035320707,
        23.121393161322
    ],
    [
        112.90065612541,
        23.121528894814
    ],
    [
        112.90080853433,
        23.121593923214
    ],
    [
        112.90102390219,
        23.121694753591
    ],
    [
        112.9011838793,
        23.121764782723
    ],
    [
        112.90131899492,
        23.121825698415
    ],
    [
        112.90141709664,
        23.121859663761
    ],
    [
        112.9014997914,
        23.121892548405
    ],
    [
        112.90161276738,
        23.121918356466
    ],
    [
        112.90169087869,
        23.1219351559
    ],
    [
        112.9017638518,
        23.121955391863
    ],
    [
        112.90182681713,
        23.121984406003
    ],
    [
        112.90187518514,
        23.122013440946
    ],
    [
        112.90192869729,
        23.122031171359
    ],
    [
        112.90205682083,
        23.122047460758
    ],
    [
        112.90214331864,
        23.122057884256
    ],
    [
        112.90224712714,
        23.122055038182
    ],
    [
        112.90231877072,
        23.122046490097
    ],
    [
        112.90237123002,
        23.122024867493
    ],
    [
        112.90241804092,
        23.121962192387
    ],
    [
        112.90249055299,
        23.12187201469
    ],
    [
        112.90253576862,
        23.121772152333
    ],
    [
        112.90257475491,
        23.121689543044
    ],
    [
        112.90260072021,
        23.121670995367
    ],
    [
        112.90263804014,
        23.121651825418
    ],
    [
        112.90266724115,
        23.121645266014
    ],
    [
        112.90269616537,
        23.121647923558
    ],
    [
        112.90271779099,
        23.121649915413
    ],
    [
        112.9027453531,
        23.121667467306
    ],
    [
        112.9027707419,
        23.12170017135
    ],
    [
        112.90279587054,
        23.121718495555
    ],
    [
        112.90281856088,
        23.121744373044
    ],
    [
        112.90284369609,
        23.121753475122
    ],
    [
        112.90290045324,
        23.121773957496
    ],
    [
        112.90296964714,
        23.121793291338
    ],
    [
        112.90300884502,
        23.121795847175
    ],
    [
        112.90304669775,
        23.121789158123
    ],
    [
        112.90307753102,
        23.121769060778
    ],
    [
        112.90311242521,
        23.121740894118
    ],
    [
        112.90315925393,
        23.121657052876
    ],
    [
        112.90320691142,
        23.121548814012
    ],
    [
        112.90325213353,
        23.121444602337
    ],
    [
        112.90328516947,
        23.121369751094
    ],
    [
        112.90332601764,
        23.121334086905
    ],
    [
        112.9033546885,
        23.121314764535
    ],
    [
        112.90340552122,
        23.121305032416
    ],
    [
        112.90347581214,
        23.121305386975
    ],
    [
        112.90351392913,
        23.121309003331
    ],
    [
        112.90358394008,
        23.121323454674
    ],
    [
        112.90365934614,
        23.121355081153
    ],
    [
        112.90376365113,
        23.12142813879
    ],
    [
        112.90390849465,
        23.121524101096
    ],
    [
        112.90399659604,
        23.121574913783
    ],
    [
        112.90407849537,
        23.121603652271
    ],
    [
        112.90414175528,
        23.121610927145
    ],
    [
        112.90422178719,
        23.121605455636
    ],
    [
        112.90425991472,
        23.121597127916
    ],
    [
        112.90428291583,
        23.121569024166
    ],
    [
        112.90429293838,
        23.121542335857
    ],
    [
        112.90429106358,
        23.121517352008
    ],
    [
        112.9042843124,
        23.121506121357
    ],
    [
        112.90425918153,
        23.121487538594
    ],
    [
        112.904160262,
        23.121439540865
    ],
    [
        112.90408081638,
        23.121381823384
    ],
    [
        112.90405407122,
        23.121352905502
    ],
    [
        112.90403949346,
        23.121322559692
    ],
    [
        112.90404168426,
        23.121283809668
    ],
    [
        112.90404547887,
        23.12127058164
    ],
    [
        112.90407522916,
        23.121256151982
    ],
    [
        112.90412443687,
        23.121253974937
    ],
    [
        112.90424097243,
        23.12124259106
    ],
    [
        112.90428127326,
        23.121220194587
    ],
    [
        112.90432780381,
        23.121182438966
    ],
    [
        112.90434269986,
        23.121146879405
    ],
    [
        112.9043454323,
        23.121107324327
    ],
    [
        112.9043360043,
        23.12105943414
    ],
    [
        112.90431522763,
        23.121002408273
    ],
    [
        112.90428903268,
        23.120960482723
    ],
    [
        112.90424311609,
        23.120898163803
    ],
    [
        112.90419827524,
        23.120843998608
    ],
    [
        112.9041645301,
        23.120775639135
    ],
    [
        112.90414244563,
        23.120660547544
    ],
    [
        112.90412145205,
        23.120533539652
    ],
    [
        112.90411850269,
        23.120500672614
    ],
    [
        112.90412473523,
        23.12048178868
    ],
    [
        112.90415369423,
        23.120441849773
    ],
    [
        112.90422401674,
        23.120405299224
    ],
    [
        112.90425944883,
        23.120386620847
    ],
    [
        112.90430595,
        23.120389278453
    ],
    [
        112.9043683986,
        23.120397890889
    ],
    [
        112.90444354903,
        23.120414302845
    ],
    [
        112.90449761095,
        23.12043064147
    ],
    [
        112.9045670744,
        23.120460247735
    ],
    [
        112.90463058132,
        23.120501418563
    ],
    [
        112.90469029671,
        23.120551477099
    ],
    [
        112.90477892286,
        23.120628310026
    ],
    [
        112.90487431411,
        23.12069873926
    ],
    [
        112.90493565993,
        23.120739867725
    ],
    [
        112.90504188474,
        23.120787681368
    ],
    [
        112.90512730435,
        23.120817256671
    ],
    [
        112.90519487826,
        23.120847900322
    ],
    [
        112.90523894429,
        23.120857553924
    ],
    [
        112.90526841906,
        23.120854226496
    ],
    [
        112.90529898968,
        23.120831658851
    ],
    [
        112.90538665395,
        23.120753582586
    ],
    [
        112.90547759008,
        23.120640295169
    ],
    [
        112.90554933813,
        23.120515309354
    ],
    [
        112.90562490861,
        23.120342916755
    ],
    [
        112.90568289671,
        23.120181094071
    ],
    [
        112.90572489457,
        23.120068653247
    ],
    [
        112.9057674261,
        23.119966255562
    ],
    [
        112.90580810975,
        23.119806599109
    ],
    [
        112.90583575306,
        23.119726478399
    ],
    [
        112.90587717582,
        23.119660948421
    ],
    [
        112.90589638377,
        23.119649044113
    ],
    [
        112.90592668563,
        23.11962782032
    ],
    [
        112.90596724652,
        23.119627640999
    ],
    [
        112.9060199636,
        23.11964311065
    ],
    [
        112.90608591935,
        23.119673431588
    ],
    [
        112.90613672979,
        23.119707312225
    ],
    [
        112.90618483771,
        23.119739522354
    ],
    [
        112.90623427789,
        23.119797518708
    ],
    [
        112.90627667724,
        23.119868966291
    ],
    [
        112.90630122963,
        23.119940408131
    ],
    [
        112.90632280563,
        23.120014515966
    ],
    [
        112.90632002657,
        23.120112115059
    ],
    [
        112.90632293041,
        23.12020464879
    ],
    [
        112.90632504311,
        23.12027113241
    ],
    [
        112.90633447044,
        23.120320099325
    ],
    [
        112.90635820938,
        23.120396139037
    ],
    [
        112.90638684586,
        23.12043265475
    ],
    [
        112.90642738311,
        23.120466098886
    ],
    [
        112.90646955324,
        23.120486005967
    ],
    [
        112.90649550902,
        23.120491830106
    ],
    [
        112.90651308727,
        23.120490473152
    ],
    [
        112.90658558575,
        23.120456055946
    ],
    [
        112.90671220395,
        23.120376084091
    ],
    [
        112.90685424826,
        23.120283049205
    ],
    [
        112.90687994238,
        23.12027855791
    ],
    [
        112.90689617247,
        23.120272837585
    ],
    [
        112.90694267062,
        23.120293614548
    ],
    [
        112.90705188066,
        23.120352226678
    ],
    [
        112.9072524453,
        23.120483269057
    ],
    [
        112.90740760783,
        23.120577268822
    ],
    [
        112.90755331288,
        23.120664063861
    ],
    [
        112.90765336018,
        23.120689145593
    ],
    [
        112.90767283159,
        23.120690518883
    ],
    [
        112.90770447341,
        23.120691800771
    ],
    [
        112.90773098268,
        23.12068514067
    ],
    [
        112.90775642236,
        23.120662190677
    ],
    [
        112.90776186624,
        23.12061561966
    ],
    [
        112.90777787366,
        23.120548048645
    ],
    [
        112.90778167771,
        23.120524507856
    ],
    [
        112.90780088015,
        23.120524248507
    ],
    [
        112.90785443783,
        23.120514187959
    ],
    [
        112.90797128465,
        23.120502070532
    ],
    [
        112.90815467531,
        23.120478981217
    ],
    [
        112.90823364538,
        23.120486909282
    ],
    [
        112.90829802835,
        23.120471568487
    ],
    [
        112.90832211378,
        23.120453473371
    ],
    [
        112.90835378447,
        23.120419485029
    ],
    [
        112.90841007931,
        23.120370933624
    ],
    [
        112.90842522952,
        23.120365998559
    ],
    [
        112.9084771638,
        23.120361592493
    ],
    [
        112.90854666353,
        23.120378050193
    ],
    [
        112.90860723894,
        23.120393292686
    ],
    [
        112.90867240263,
        23.120422160017
    ],
    [
        112.90875647688,
        23.120482485234
    ],
    [
        112.9088486529,
        23.120561093603
    ],
    [
        112.90894786255,
        23.120640067686
    ],
    [
        112.90902139655,
        23.120692637201
    ],
    [
        112.90908517062,
        23.120775986813
    ],
    [
        112.90916083044,
        23.120882012445
    ],
    [
        112.90921946134,
        23.120972608458
    ],
    [
        112.90927348954,
        23.121069919192
    ],
    [
        112.90935835213,
        23.121171996002
    ],
    [
        112.90941133697,
        23.121218296827
    ],
    [
        112.90943890406,
        23.121251768218
    ],
    [
        112.90946594956,
        23.121258651437
    ],
    [
        112.90951084978,
        23.121263881802
    ],
    [
        112.90956170078,
        23.121270006515
    ],
    [
        112.90957684912,
        23.12127021478
    ],
    [
        112.90959498172,
        23.121258529782
    ],
    [
        112.90959824947,
        23.121228739376
    ],
    [
        112.90958826696,
        23.121192528718
    ],
    [
        112.90953015096,
        23.12113314376
    ],
    [
        112.9094912438,
        23.121070495929
    ],
    [
        112.90946423629,
        23.121011808825
    ],
    [
        112.90943804409,
        23.120948250459
    ],
    [
        112.9094348271,
        23.120908877741
    ],
    [
        112.90943538956,
        23.120879863999
    ],
    [
        112.90943891993,
        23.120861198004
    ],
    [
        112.90949523298,
        23.120796609442
    ],
    [
        112.90955643024,
        23.120712557759
    ],
    [
        112.90958132955,
        23.120695812685
    ],
    [
        112.90960460286,
        23.120683113354
    ],
    [
        112.90963165363,
        23.12068348448
    ],
    [
        112.90968033429,
        23.12069879761
    ],
    [
        112.90971926997,
        23.120723198023
    ],
    [
        112.9097698482,
        23.120733923576
    ],
    [
        112.9097917543,
        23.120741545162
    ],
    [
        112.90981555911,
        23.120742411565
    ],
    [
        112.90984154388,
        23.120722151398
    ],
    [
        112.90985914114,
        23.120703946818
    ],
    [
        112.90987567729,
        23.120657791108
    ],
    [
        112.9099108662,
        23.120629246608
    ],
    [
        112.90993603209,
        23.120619280567
    ],
    [
        112.9099744535,
        23.120609493212
    ],
    [
        112.91001422159,
        23.120607859969
    ],
    [
        112.91002991283,
        23.12060671528
    ],
    [
        112.91006857837,
        23.120632731174
    ],
    [
        112.91014373816,
        23.120695037815
    ],
    [
        112.91021591856,
        23.120763268244
    ],
    [
        112.91030027828,
        23.1208254193
    ],
    [
        112.9103681564,
        23.120860495793
    ],
    [
        112.91043875416,
        23.120877161798
    ],
    [
        112.91047636067,
        23.120874946152
    ],
    [
        112.91053048307,
        23.120855588409
    ],
    [
        112.91055050496,
        23.120853139492
    ],
    [
        112.91060432718,
        23.120874459625
    ],
    [
        112.9107763431,
        23.120944513292
    ],
    [
        112.91088372047,
        23.120987404056
    ],
    [
        112.91107439252,
        23.121083432918
    ],
    [
        112.91117581482,
        23.121135991413
    ],
    [
        112.91122638936,
        23.121164843093
    ],
    [
        112.91123259233,
        23.121192316117
    ],
    [
        112.91123122291,
        23.121215081988
    ],
    [
        112.91120413465,
        23.121258676632
    ],
    [
        112.91118487556,
        23.121326238796
    ],
    [
        112.91117157373,
        23.121387367198
    ],
    [
        112.91117558916,
        23.12144708897
    ],
    [
        112.91118827184,
        23.121494173374
    ],
    [
        112.91123338843,
        23.12158886429
    ],
    [
        112.91128365447,
        23.12167222754
    ],
    [
        112.91137283003,
        23.121830940267
    ],
    [
        112.91142987576,
        23.121894855722
    ],
    [
        112.91146719233,
        23.121927058697
    ],
    [
        112.91158376841,
        23.121987646121
    ],
    [
        112.91167168559,
        23.122018304691
    ],
    [
        112.91171740951,
        23.122024838898
    ],
    [
        112.91174176072,
        23.122026767746
    ],
    [
        112.9117631322,
        23.122033541536
    ],
    [
        112.91177856036,
        23.122026680096
    ],
    [
        112.91180698795,
        23.122003704944
    ],
    [
        112.91186194697,
        23.121961255717
    ],
    [
        112.9119063347,
        23.121945526747
    ],
    [
        112.91197452174,
        23.121948531027
    ],
    [
        112.91203267869,
        23.121978261926
    ],
    [
        112.91212708237,
        23.122027958559
    ],
    [
        112.91220065951,
        23.122065463922
    ],
    [
        112.91221311105,
        23.122059918177
    ],
    [
        112.91222258186,
        23.122060303511
    ],
    [
        112.91224423255,
        23.122056766888
    ],
    [
        112.91227755799,
        23.121997767812
    ],
    [
        112.91234126537,
        23.121833894261
    ],
    [
        112.91239682205,
        23.121717928709
    ],
    [
        112.91245344646,
        23.121623943454
    ],
    [
        112.91250598027,
        23.121574931756
    ],
    [
        112.91253981857,
        23.121558787259
    ],
    [
        112.9125609217,
        23.121565546166
    ],
    [
        112.91269728221,
        23.121608919515
    ],
    [
        112.91288126285,
        23.121670462212
    ],
    [
        112.91288694463,
        23.121672426632
    ],
    [
        112.91289344873,
        23.121659754121
    ],
    [
        112.91294358292,
        23.121564860602
    ],
    [
        112.91299725966,
        23.121437187326
    ],
    [
        112.91303844395,
        23.121370666717
    ],
    [
        112.91305469208,
        23.121356749099
    ],
    [
        112.91306470962,
        23.121351168057
    ],
    [
        112.91307959405,
        23.121351880923
    ],
    [
        112.91309664358,
        23.121352618382
    ],
    [
        112.91314507784,
        23.121366190218
    ],
    [
        112.91321109589,
        23.121391080452
    ],
    [
        112.91334014753,
        23.121453836943
    ],
    [
        112.91346973373,
        23.121529606398
    ],
    [
        112.91359958942,
        23.121610791247
    ],
    [
        112.91375570595,
        23.121686555838
    ],
    [
        112.91384200484,
        23.121747168894
    ],
    [
        112.91394397425,
        23.121849715478
    ],
    [
        112.91404485989,
        23.121956582467
    ],
    [
        112.91412007118,
        23.1220089218
    ],
    [
        112.91413359795,
        23.122019101759
    ],
    [
        112.91414929226,
        23.122026321152
    ],
    [
        112.91415444023,
        23.122019052792
    ],
    [
        112.91422023745,
        23.121987747111
    ],
    [
        112.91425761569,
        23.121953425548
    ],
    [
        112.91427090346,
        23.121918848551
    ],
    [
        112.91427172847,
        23.121900413601
    ],
    [
        112.91425793727,
        23.121881010421
    ],
    [
        112.91424712532,
        23.121859197571
    ],
    [
        112.91420817344,
        23.121821897302
    ],
    [
        112.91409564664,
        23.121715189426
    ],
    [
        112.91400422247,
        23.121625515835
    ],
    [
        112.91386762143,
        23.121503611891
    ],
    [
        112.91377862535,
        23.121430223283
    ],
    [
        112.91371614124,
        23.121376377563
    ],
    [
        112.91369857397,
        23.12134092471
    ],
    [
        112.91368291755,
        23.12128325187
    ],
    [
        112.91367997744,
        23.121232228417
    ],
    [
        112.91369816362,
        23.121161095247
    ],
    [
        112.91372284088,
        23.121096813861
    ],
    [
        112.91376677111,
        23.120984192975
    ],
    [
        112.91385484004,
        23.120845471318
    ],
    [
        112.91393258147,
        23.12076548886
    ],
    [
        112.91402547901,
        23.120689191002
    ],
    [
        112.91412241824,
        23.12063951028
    ],
    [
        112.91419849525,
        23.120618080006
    ],
    [
        112.91423855542,
        23.120619047462
    ],
    [
        112.91427103369,
        23.120624002015
    ],
    [
        112.9143324551,
        23.120656112233
    ],
    [
        112.91440604525,
        23.120705434415
    ],
    [
        112.91443959494,
        23.120726669741
    ],
    [
        112.91446991825,
        23.120718849204
    ],
    [
        112.91454006354,
        23.120671299649
    ],
    [
        112.9146422122,
        23.120544063869
    ],
    [
        112.91471160785,
        23.120417027876
    ],
    [
        112.91482326332,
        23.120252988637
    ],
    [
        112.9149059155,
        23.120140994579
    ],
    [
        112.91502680723,
        23.119942314385
    ],
    [
        112.91518887568,
        23.119713924135
    ],
    [
        112.91527128697,
        23.11957288367
    ],
    [
        112.91535070308,
        23.119455676726
    ],
    [
        112.91540602565,
        23.119338231489
    ],
    [
        112.91545700943,
        23.119230777379
    ],
    [
        112.91549419334,
        23.119114780518
    ],
    [
        112.91556146369,
        23.118957031371
    ],
    [
        112.91566504095,
        23.118767619682
    ],
    [
        112.91573638728,
        23.118596339152
    ],
    [
        112.91577956043,
        23.118445674333
    ],
    [
        112.91582406083,
        23.118328109881
    ],
    [
        112.91589622004,
        23.118161168014
    ],
    [
        112.91593285296,
        23.118064410809
    ],
    [
        112.91598138292,
        23.117987561919
    ],
    [
        112.91603640934,
        23.117913483216
    ],
    [
        112.91607517753,
        23.117854984044
    ],
    [
        112.91612532264,
        23.117791163178
    ],
    [
        112.91630741292,
        23.117633062577
    ],
    [
        112.91646024062,
        23.117503697242
    ],
    [
        112.91651172859,
        23.117457231036
    ],
    [
        112.91656106807,
        23.117390673424
    ],
    [
        112.91658386766,
        23.117328221174
    ],
    [
        112.91661426016,
        23.117253358695
    ],
    [
        112.91665167647,
        23.117198084615
    ],
    [
        112.91667904178,
        23.117179879505
    ],
    [
        112.91672509724,
        23.117155326223
    ],
    [
        112.91675217825,
        23.117153119089
    ],
    [
        112.91678549485,
        23.11714255712
    ],
    [
        112.91680935653,
        23.117105875936
    ],
    [
        112.91684297445,
        23.117060598674
    ],
    [
        112.91687664584,
        23.116954296213
    ],
    [
        112.91690625033,
        23.116854196416
    ],
    [
        112.91695728194,
        23.116716035238
    ],
    [
        112.91703921038,
        23.116550467161
    ],
    [
        112.91712275252,
        23.116399553048
    ],
    [
        112.91719950589,
        23.116271359754
    ],
    [
        112.91728631603,
        23.116103917199
    ],
    [
        112.9173386983,
        23.115976329209
    ],
    [
        112.91736775683,
        23.115886520616
    ],
    [
        112.91738301084,
        23.115789005406
    ],
    [
        112.91738902188,
        23.115730470766
    ],
    [
        112.91738552288,
        23.115706575129
    ],
    [
        112.9173668576,
        23.115683098875
    ],
    [
        112.91736226552,
        23.115670043063
    ],
    [
        112.91736823779,
        23.115654360856
    ],
    [
        112.91739045866,
        23.115639352783
    ],
    [
        112.91744598732,
        23.115628138866
    ],
    [
        112.91756082152,
        23.115623633856
    ],
    [
        112.91765506985,
        23.115624380196
    ],
    [
        112.91773304868,
        23.115648045699
    ],
    [
        112.91783188558,
        23.115669155357
    ],
    [
        112.91791582214,
        23.115696380793
    ],
    [
        112.91800111441,
        23.115723339369
    ],
    [
        112.91805826657,
        23.115720245859
    ],
    [
        112.9181186737,
        23.115712563249
    ],
    [
        112.918229754,
        23.115680572466
    ],
    [
        112.91830643921,
        23.115645878635
    ],
    [
        112.91841696517,
        23.115631766599
    ],
    [
        112.91847736696,
        23.115634100664
    ],
    [
        112.91853666667,
        23.115657578821
    ],
    [
        112.91863388001,
        23.115691899458
    ],
    [
        112.91875927855,
        23.115713389546
    ],
    [
        112.91890309515,
        23.115740687487
    ],
    [
        112.91910082992,
        23.115761818137
    ],
    [
        112.9191834532,
        23.115763991882
    ],
    [
        112.91927747028,
        23.115750231879
    ],
    [
        112.91935361198,
        23.115732823563
    ],
    [
        112.91942108053,
        23.115720779358
    ],
    [
        112.91946906922,
        23.115680672533
    ],
    [
        112.91954687161,
        23.115627461085
    ],
    [
        112.91960405878,
        23.115602865659
    ],
    [
        112.91968481665,
        23.115578954823
    ],
    [
        112.91979265577,
        23.115569576951
    ],
    [
        112.9199126815,
        23.115568669137
    ],
    [
        112.92003214917,
        23.11558835801
    ],
    [
        112.92012832149,
        23.115603832287
    ],
    [
        112.92035642835,
        23.115645261723
    ],
    [
        112.92051761797,
        23.115683301821
    ],
    [
        112.92062165279,
        23.115703387323
    ],
    [
        112.92071051781,
        23.115720129252
    ],
    [
        112.92080236063,
        23.115741761435
    ],
    [
        112.92076564008,
        23.115894267609
    ],
    [
        112.92072729134,
        23.116050290056
    ],
    [
        112.92069848451,
        23.11614289617
    ],
    [
        112.92067044931,
        23.116282155364
    ],
    [
        112.92062104575,
        23.116378719148
    ],
    [
        112.92055858681,
        23.116531082013
    ],
    [
        112.92052653019,
        23.116623937748
    ],
    [
        112.92045923271,
        23.116734501323
    ],
    [
        112.92040711597,
        23.116838635346
    ],
    [
        112.92035202421,
        23.11693732611
    ],
    [
        112.92030100921,
        23.117022747282
    ],
    [
        112.92021474122,
        23.117142140496
    ],
    [
        112.92015098959,
        23.117231822209
    ],
    [
        112.92005847772,
        23.117368797265
    ],
    [
        112.91998795935,
        23.117453277407
    ],
    [
        112.91987892139,
        23.117593124297
    ],
    [
        112.91978752927,
        23.117694825535
    ],
    [
        112.91971536518,
        23.11780802855
    ],
    [
        112.9195968149,
        23.117991457404
    ],
    [
        112.91950214757,
        23.118128917106
    ],
    [
        112.91943783139,
        23.118258696962
    ],
    [
        112.91934585966,
        23.118417045327
    ],
    [
        112.91927314946,
        23.118545406075
    ],
    [
        112.91918091364,
        23.118700485198
    ],
    [
        112.91910684693,
        23.118835336172
    ],
    [
        112.91900487586,
        23.118974605887
    ],
    [
        112.91889100478,
        23.11909317255
    ],
    [
        112.91877577441,
        23.119221211602
    ],
    [
        112.91866597641,
        23.119334360181
    ],
    [
        112.91850874024,
        23.119495166871
    ],
    [
        112.91839488716,
        23.119606091426
    ],
    [
        112.9182390123,
        23.119769313219
    ],
    [
        112.91811269795,
        23.119890967667
    ],
    [
        112.91795413693,
        23.120037316086
    ],
    [
        112.91783759855,
        23.120135148058
    ],
    [
        112.9176432856,
        23.120295553683
    ],
    [
        112.91752134612,
        23.120382463309
    ],
    [
        112.91728584745,
        23.120587234137
    ],
    [
        112.91700511797,
        23.120815447661
    ],
    [
        112.91682302716,
        23.12096904416
    ],
    [
        112.91662631467,
        23.121130351897
    ],
    [
        112.91645994695,
        23.12127752248
    ],
    [
        112.91624375043,
        23.121442122842
    ],
    [
        112.91608471852,
        23.12157113735
    ],
    [
        112.91588803837,
        23.12172581959
    ],
    [
        112.91573226951,
        23.121849937981
    ],
    [
        112.9155353388,
        23.121994256476
    ],
    [
        112.91535901893,
        23.122097789654
    ],
    [
        112.91513963083,
        23.122243184775
    ],
    [
        112.91498173465,
        23.122342237829
    ],
    [
        112.91477616766,
        23.122486625194
    ],
    [
        112.91458848829,
        23.122610009191
    ],
    [
        112.91443572649,
        23.12274458099
    ],
    [
        112.91425128293,
        23.12290348255
    ],
    [
        112.91407713623,
        23.123054874637
    ],
    [
        112.91393413651,
        23.123184069327
    ],
    [
        112.91374619702,
        23.123334184725
    ],
    [
        112.91372723981,
        23.123351064564
    ],
    [
        112.91364301418,
        23.123429609264
    ],
    [
        112.91355499522,
        23.123516786212
    ],
    [
        112.91343230868,
        23.123644797756
    ],
    [
        112.91329500496,
        23.123781313111
    ],
    [
        112.91323136593,
        23.123842163607
    ],
    [
        112.91312194416,
        23.123976807894
    ],
    [
        112.91299681859,
        23.124127266129
    ],
    [
        112.91285977668,
        23.124297646699
    ],
    [
        112.91273493105,
        23.124444016791
    ],
    [
        112.91255728996,
        23.124638847315
    ],
    [
        112.91233497087,
        23.124892523172
    ],
    [
        112.91210401382,
        23.125126260375
    ],
    [
        112.91190986561,
        23.125362311893
    ],
    [
        112.91176961625,
        23.125516277226
    ],
    [
        112.9116196255,
        23.12567824546
    ],
    [
        112.9114357784,
        23.125913550797
    ],
    [
        112.91126602289,
        23.126119990411
    ],
    [
        112.91112362318,
        23.126280921663
    ],
    [
        112.91088999713,
        23.126548074671
    ],
    [
        112.9107275774,
        23.126729054309
    ],
    [
        112.91055866752,
        23.126914543324
    ],
    [
        112.91040167161,
        23.127089322746
    ],
    [
        112.91026525282,
        23.127238050771
    ],
    [
        112.91008039256,
        23.127432228673
    ],
    [
        112.9099328825,
        23.127598682291
    ],
    [
        112.90973261588,
        23.127788815758
    ],
    [
        112.90956779675,
        23.127968834626
    ],
    [
        112.90947415934,
        23.128067634283
    ],
    [
        112.90935129313,
        23.128205082946
    ],
    [
        112.90932449315,
        23.128254077626
    ],
    [
        112.90929905825,
        23.128273253841
    ],
    [
        112.90928740371,
        23.12832896841
    ],
    [
        112.90928442164,
        23.128344930438
    ],
    [
        112.90928225297,
        23.128356292598
    ],
    [
        112.90928062074,
        23.128378783314
    ],
    [
        112.90927520057,
        23.128403662528
    ],
    [
        112.90924622402,
        23.128485446595
    ],
    [
        112.90918694095,
        23.128595830508
    ],
    [
        112.90919045357,
        23.128605373212
    ],
    [
        112.90911331473,
        23.12872662635
    ],
    [
        112.90911818304,
        23.128728050798
    ],
    [
        112.90896687745,
        23.128990390652
    ],
    [
        112.90881098094,
        23.129249669267
    ],
    [
        112.9085757988,
        23.129629049872
    ],
    [
        112.9084296655,
        23.129856157813
    ],
    [
        112.90826594844,
        23.130109582443
    ],
    [
        112.90811548957,
        23.130365356368
    ],
    [
        112.9078451851,
        23.1307568843
    ],
    [
        112.90764713834,
        23.131029010719
    ],
    [
        112.90747479323,
        23.131295261956
    ],
    [
        112.90729597123,
        23.131534276152
    ],
    [
        112.90719181868,
        23.131675391669
    ],
    [
        112.90709117954,
        23.131835271639
    ],
    [
        112.90702517116,
        23.13193599484
    ],
    [
        112.90692860051,
        23.132058766619
    ],
    [
        112.90688478047,
        23.132108283454
    ],
    [
        112.90679957382,
        23.132213590386
    ],
    [
        112.90667730736,
        23.132384242692
    ],
    [
        112.90659454149,
        23.132470862117
    ],
    [
        112.90646389865,
        23.132632693709
    ],
    [
        112.90632622322,
        23.132821805894
    ],
    [
        112.90615879509,
        23.133079889722
    ],
    [
        112.90598136814,
        23.133338890318
    ],
    [
        112.90578150122,
        23.133623023537
    ],
    [
        112.90559434757,
        23.133933653155
    ],
    [
        112.90539503565,
        23.134235937782
    ],
    [
        112.90522196379,
        23.134488984109
    ],
    [
        112.90503916299,
        23.134759223638
    ],
    [
        112.90484095617,
        23.135052530984
    ],
    [
        112.90473793573,
        23.135191384815
    ],
    [
        112.90454514926,
        23.135453290946
    ],
    [
        112.90434425713,
        23.135780426554
    ],
    [
        112.90414472584,
        23.136090480523
    ],
    [
        112.90395872029,
        23.136372260097
    ],
    [
        112.90377299236,
        23.13666651102
    ],
    [
        112.90356510398,
        23.136982356337
    ],
    [
        112.90335992763,
        23.137299318174
    ],
    [
        112.90320639028,
        23.137556636158
    ],
    [
        112.90306745374,
        23.137783537899
    ],
    [
        112.90293365751,
        23.138008621393
    ],
    [
        112.90279688732,
        23.138196485376
    ],
    [
        112.90261714724,
        23.138463916006
    ],
    [
        112.90251552492,
        23.138634186936
    ],
    [
        112.90245336883,
        23.138776639566
    ],
    [
        112.90240283493,
        23.138897314924
    ],
    [
        112.90238554212,
        23.138951819473
    ],
    [
        112.90239203203,
        23.138965221928
    ],
    [
        112.90238419603,
        23.138988147532
    ],
    [
        112.90240339975,
        23.139055206641
    ],
    [
        112.90242720178,
        23.139137534995
    ],
    [
        112.90245451704,
        23.139211241896
    ],
    [
        112.90249750691,
        23.139256187262
    ],
    [
        112.90255239119,
        23.139299162914
    ],
    [
        112.90260510969,
        23.139322297978
    ],
    [
        112.90263025177,
        23.139329504246
    ],
    [
        112.90266999459,
        23.139352690589
    ],
    [
        112.90276569648,
        23.139375191308
    ],
    [
        112.90290546076,
        23.139380525178
    ],
    [
        112.9029903444,
        23.13936757172
    ],
    [
        112.903069817,
        23.139327126534
    ],
    [
        112.90312306472,
        23.13927267712
    ],
    [
        112.90318603246,
        23.139140804341
    ],
    [
        112.90328169784,
        23.138909375228
    ],
    [
        112.903396833,
        23.138688304712
    ],
    [
        112.90349223395,
        23.138447913571
    ],
    [
        112.90356681968,
        23.138188457152
    ],
    [
        112.90368493609,
        23.137931075993
    ],
    [
        112.90375439961,
        23.137745588593
    ],
    [
        112.90386820174,
        23.137537501176
    ],
    [
        112.9039219981,
        23.137478164549
    ],
    [
        112.90395660249,
        23.137461372294
    ],
    [
        112.90398877464,
        23.137457018121
    ],
    [
        112.90408529212,
        23.137451820233
    ],
    [
        112.90418911224,
        23.137477934555
    ],
    [
        112.90423750974,
        23.137516161058
    ],
    [
        112.90426617172,
        23.137564101609
    ],
    [
        112.90428212753,
        23.137621057767
    ],
    [
        112.90426888687,
        23.13770873362
    ],
    [
        112.90419320416,
        23.137917732778
    ],
    [
        112.90395047869,
        23.1384375807
    ],
    [
        112.90376641248,
        23.138778795189
    ],
    [
        112.90359993741,
        23.139180242347
    ],
    [
        112.90345670385,
        23.139477626339
    ],
    [
        112.90340347797,
        23.139653614045
    ],
    [
        112.90339780716,
        23.139687700632
    ],
    [
        112.90340970828,
        23.139718824148
    ],
    [
        112.90344405185,
        23.139769038775
    ],
    [
        112.90354193872,
        23.139877275814
    ],
    [
        112.9036349561,
        23.139963726885
    ],
    [
        112.9037293264,
        23.140051011237
    ],
    [
        112.90383531592,
        23.140105388157
    ],
    [
        112.90395267418,
        23.140219358042
    ],
    [
        112.90405408463,
        23.140340657354
    ],
    [
        112.90416549546,
        23.140442584641
    ],
    [
        112.90423256238,
        23.14051855432
    ],
    [
        112.90429394808,
        23.140576525253
    ],
    [
        112.90432722217,
        23.140658451805
    ],
    [
        112.90432696226,
        23.14070185232
    ],
    [
        112.90433211305,
        23.140758905058
    ],
    [
        112.90430456682,
        23.140882973423
    ],
    [
        112.90424566788,
        23.141039354678
    ],
    [
        112.90418378572,
        23.141155265217
    ],
    [
        112.90412433951,
        23.141277453843
    ],
    [
        112.90407056773,
        23.141384813891
    ],
    [
        112.90396624859,
        23.141521726228
    ],
    [
        112.90386030461,
        23.141643144982
    ],
    [
        112.90372489891,
        23.141781164105
    ],
    [
        112.9036297582,
        23.141855821108
    ],
    [
        112.90350569874,
        23.141954681995
    ],
    [
        112.90339326685,
        23.142057257898
    ],
    [
        112.90329273021,
        23.142155958732
    ],
    [
        112.90319138901,
        23.14227091994
    ],
    [
        112.9031168104,
        23.142378729708
    ],
    [
        112.9030843875,
        23.142432444126
    ],
    [
        112.90300764385,
        23.14252909256
    ],
    [
        112.90289900778,
        23.14264419374
    ],
    [
        112.90282415149,
        23.142720794564
    ],
    [
        112.90270281877,
        23.142854394543
    ],
    [
        112.90254392615,
        23.143026963412
    ],
    [
        112.90242475826,
        23.143155164614
    ],
    [
        112.90230423777,
        23.143276285481
    ],
    [
        112.90222425172,
        23.143356041935
    ],
    [
        112.90217453934,
        23.14342735916
    ],
    [
        112.90213807672,
        23.143507853709
    ],
    [
        112.90206512951,
        23.143609972145
    ],
    [
        112.90198380194,
        23.143708962131
    ],
    [
        112.90190544823,
        23.143806644793
    ],
    [
        112.90184763205,
        23.143885958169
    ],
    [
        112.90180737626,
        23.143938984883
    ],
    [
        112.90167739554,
        23.144040391623
    ],
    [
        112.90158606147,
        23.144118584167
    ],
    [
        112.90145447358,
        23.144248984157
    ],
    [
        112.90132558937,
        23.144376713789
    ],
    [
        112.9012356324,
        23.144506738851
    ],
    [
        112.90113215678,
        23.144626762332
    ],
    [
        112.90103787242,
        23.144745857278
    ],
    [
        112.90097359849,
        23.144876592682
    ],
    [
        112.90095657956,
        23.144899357858
    ],
    [
        112.9009231004,
        23.144983963578
    ],
    [
        112.90086883171,
        23.145119211681
    ],
    [
        112.90082212969,
        23.1452483508
    ],
    [
        112.90079136534,
        23.145354163657
    ],
    [
        112.90074281173,
        23.145563301329
    ],
    [
        112.90069857101,
        23.145744028051
    ],
    [
        112.90068835062,
        23.145846399259
    ],
    [
        112.9006916235,
        23.145904512784
    ],
    [
        112.90069843256,
        23.14600609465
    ],
    [
        112.90069419735,
        23.146180734118
    ],
    [
        112.90071022778,
        23.146339176761
    ],
    [
        112.90071438457,
        23.146532410454
    ],
    [
        112.90071717171,
        23.146688995876
    ],
    [
        112.90073294445,
        23.14686371238
    ],
    [
        112.90076223872,
        23.147047345161
    ],
    [
        112.9007882855,
        23.147221426362
    ],
    [
        112.90081594355,
        23.147374645782
    ],
    [
        112.9008560426,
        23.147538118832
    ],
    [
        112.90090829467,
        23.14768118366
    ],
    [
        112.90098597008,
        23.14784720569
    ],
    [
        112.90106417684,
        23.147995330145
    ],
    [
        112.90114021987,
        23.148139346581
    ],
    [
        112.90123600575,
        23.148298352503
    ],
    [
        112.90131582255,
        23.14842127
    ],
    [
        112.90141455417,
        23.148531489199
    ],
    [
        112.90144106337,
        23.148561516749
    ],
    [
        112.90161687459,
        23.148733827077
    ],
    [
        112.90187058299,
        23.148973659047
    ],
    [
        112.90208533531,
        23.149158551272
    ],
    [
        112.90248373673,
        23.14948680588
    ],
    [
        112.90272906163,
        23.149692524625
    ],
    [
        112.90292625163,
        23.14986757467
    ],
    [
        112.9030679611,
        23.149947000054
    ],
    [
        112.90306876991,
        23.14994375797
    ],
    [
        112.90317711534,
        23.149855226403
    ],
    [
        112.90329734133,
        23.149743557204
    ],
    [
        112.90340837166,
        23.149623591393
    ],
    [
        112.90350723779,
        23.149503419708
    ],
    [
        112.90362503501,
        23.149391697367
    ],
    [
        112.90379471182,
        23.149235248252
    ],
    [
        112.90387901042,
        23.149156604147
    ],
    [
        112.90397925753,
        23.149073064985
    ],
    [
        112.90421242391,
        23.148835972295
    ],
    [
        112.90436887486,
        23.148696635657
    ],
    [
        112.90448155075,
        23.148591576712
    ],
    [
        112.90453018444,
        23.148540005641
    ],
    [
        112.90457477679,
        23.148510885991
    ],
    [
        112.90472691471,
        23.148382039053
    ],
    [
        112.90488688035,
        23.148227264433
    ],
    [
        112.90505118597,
        23.148090454967
    ],
    [
        112.90520034471,
        23.147939014165
    ],
    [
        112.90523467054,
        23.147917857934
    ],
    [
        112.90526925902,
        23.147883411815
    ],
    [
        112.90537870878,
        23.147789113632
    ],
    [
        112.90546789089,
        23.147711852386
    ],
    [
        112.90555951723,
        23.147651446862
    ],
    [
        112.90566708051,
        23.147561446336
    ],
    [
        112.90585814766,
        23.147384308827
    ],
    [
        112.90597841388,
        23.147276858644
    ],
    [
        112.90607706539,
        23.147197280223
    ],
    [
        112.90620058211,
        23.147093938247
    ],
    [
        112.90628680872,
        23.147034504802
    ],
    [
        112.90636790553,
        23.146988010915
    ],
    [
        112.90645357728,
        23.14689980497
    ],
    [
        112.9065333189,
        23.146844602544
    ],
    [
        112.90661251867,
        23.146786133293
    ],
    [
        112.90670091423,
        23.146729158177
    ],
    [
        112.90706857367,
        23.146512013495
    ],
    [
        112.90726940468,
        23.146322690299
    ],
    [
        112.90747702154,
        23.146170615514
    ],
    [
        112.90754162807,
        23.14611433439
    ],
    [
        112.90765463278,
        23.146034623546
    ],
    [
        112.90776088785,
        23.145974610945
    ],
    [
        112.90789470405,
        23.145861824017
    ],
    [
        112.90798229274,
        23.145784976036
    ],
    [
        112.90812450051,
        23.14567853555
    ],
    [
        112.90825401706,
        23.14560879614
    ],
    [
        112.90843436355,
        23.145497458532
    ],
    [
        112.90854144331,
        23.145442839412
    ],
    [
        112.90863743848,
        23.145395380552
    ],
    [
        112.90877480055,
        23.145311066457
    ],
    [
        112.90888323323,
        23.145247493565
    ],
    [
        112.90902709468,
        23.145170034176
    ],
    [
        112.90917446991,
        23.145080946573
    ],
    [
        112.90933889033,
        23.144993982208
    ],
    [
        112.90950628869,
        23.144904330226
    ],
    [
        112.90968288732,
        23.144812888572
    ],
    [
        112.90983028825,
        23.144751958891
    ],
    [
        112.90994793432,
        23.144688986408
    ],
    [
        112.91005178534,
        23.144625006115
    ],
    [
        112.91010453061,
        23.144610522716
    ],
    [
        112.91017052092,
        23.144570713659
    ],
    [
        112.91040122056,
        23.144429187013
    ],
    [
        112.9104947964,
        23.144361244302
    ],
    [
        112.91070712083,
        23.144245203888
    ],
    [
        112.91082342512,
        23.144172926277
    ],
    [
        112.91089834549,
        23.144120723715
    ],
    [
        112.91099517036,
        23.144041128007
    ],
    [
        112.91107144524,
        23.143988120704
    ],
    [
        112.91119153517,
        23.143893889813
    ],
    [
        112.9112759239,
        23.143827140032
    ],
    [
        112.91136140173,
        23.143774777625
    ],
    [
        112.91146906297,
        23.143711023642
    ],
    [
        112.91159106274,
        23.143637674531
    ],
    [
        112.91168737155,
        23.143594923819
    ],
    [
        112.91178016322,
        23.143549681913
    ],
    [
        112.91191732031,
        23.143472695217
    ],
    [
        112.91199874773,
        23.143420246936
    ],
    [
        112.91206908802,
        23.143384208033
    ],
    [
        112.91215539097,
        23.143339406342
    ],
    [
        112.91234693727,
        23.143235364771
    ],
    [
        112.91245732396,
        23.143179438892
    ],
    [
        112.91267106642,
        23.143065851568
    ],
    [
        112.91280580408,
        23.142980071551
    ],
    [
        112.91282041255,
        23.142965592007
    ],
    [
        112.9129199835,
        23.142912488813
    ],
    [
        112.9130352473,
        23.142844095436
    ],
    [
        112.91312372661,
        23.14279356342
    ],
    [
        112.91321491671,
        23.142752280264
    ],
    [
        112.91330745594,
        23.142695000526
    ],
    [
        112.91342867934,
        23.142620673619
    ],
    [
        112.91354341253,
        23.142555216429
    ],
    [
        112.91368791406,
        23.14247135878
    ],
    [
        112.9138140169,
        23.142396237713
    ],
    [
        112.91389872224,
        23.142357822643
    ],
    [
        112.91400318687,
        23.142317173587
    ],
    [
        112.91408166999,
        23.142280850315
    ],
    [
        112.91418938644,
        23.142242120601
    ],
    [
        112.9142697635,
        23.142195497657
    ],
    [
        112.91437747305,
        23.142123656089
    ],
    [
        112.91441969021,
        23.142091544051
    ],
    [
        112.91449898462,
        23.142034587201
    ],
    [
        112.91459127482,
        23.141982100375
    ],
    [
        112.91469871896,
        23.141907245886
    ],
    [
        112.91475717831,
        23.141867150842
    ],
    [
        112.91481400623,
        23.141800179636
    ],
    [
        112.91490738181,
        23.141738458056
    ],
    [
        112.91497775975,
        23.14171610665
    ],
    [
        112.91501646686,
        23.141699945967
    ],
    [
        112.91514178852,
        23.141631744491
    ],
    [
        112.91529391057,
        23.141549144084
    ],
    [
        112.91537646932,
        23.141503288508
    ],
    [
        112.9154574063,
        23.141462566322
    ],
    [
        112.91554538017,
        23.141409427523
    ],
    [
        112.91567125505,
        23.141341450988
    ],
    [
        112.91575949934,
        23.141274193338
    ],
    [
        112.91586047492,
        23.141224681767
    ],
    [
        112.91593762892,
        23.141186335217
    ],
    [
        112.91609546215,
        23.141118341168
    ],
    [
        112.91628903679,
        23.141033558475
    ],
    [
        112.91640951319,
        23.14096681592
    ],
    [
        112.91661067649,
        23.140865502504
    ],
    [
        112.91674903012,
        23.14079101576
    ],
    [
        112.91686708211,
        23.140735601445
    ],
    [
        112.91697836529,
        23.140674421813
    ],
    [
        112.91711239643,
        23.140604740619
    ],
    [
        112.91724642881,
        23.140525821171
    ],
    [
        112.91745141755,
        23.140439321201
    ],
    [
        112.91764666176,
        23.140342401014
    ],
    [
        112.91779669114,
        23.140284163497
    ],
    [
        112.91796974847,
        23.140236119816
    ],
    [
        112.91807184825,
        23.140189147061
    ],
    [
        112.91820157466,
        23.1401296205
    ],
    [
        112.9182882383,
        23.140075190092
    ],
    [
        112.91838140564,
        23.14002839634
    ],
    [
        112.91850274005,
        23.139955754413
    ],
    [
        112.9186698539,
        23.1398744697
    ],
    [
        112.91879282125,
        23.139806692224
    ],
    [
        112.9188870812,
        23.139760679681
    ],
    [
        112.91897484326,
        23.139724924202
    ],
    [
        112.91910567575,
        23.139668017846
    ],
    [
        112.91927606318,
        23.139607827462
    ],
    [
        112.91951092809,
        23.139511667875
    ],
    [
        112.91975338988,
        23.139418490485
    ],
    [
        112.91985308675,
        23.139379485218
    ],
    [
        112.91998285714,
        23.139323015265
    ],
    [
        112.92016898509,
        23.139246779165
    ],
    [
        112.92039305371,
        23.139168009451
    ],
    [
        112.92047975401,
        23.139113686106
    ],
    [
        112.9205718765,
        23.139068065956
    ],
    [
        112.92075965096,
        23.138989571318
    ],
    [
        112.92090217827,
        23.138918684435
    ],
    [
        112.92105202451,
        23.138833437957
    ],
    [
        112.92117992555,
        23.138758917148
    ],
    [
        112.92128046181,
        23.13871273677
    ],
    [
        112.92140267983,
        23.138657695404
    ],
    [
        112.92149671547,
        23.138606582635
    ],
    [
        112.9215625663,
        23.138551267375
    ],
    [
        112.92160945064,
        23.138531943946
    ],
    [
        112.92166392292,
        23.138502343341
    ],
    [
        112.92185715502,
        23.138394933196
    ],
    [
        112.92198832974,
        23.138324402434
    ],
    [
        112.92206177676,
        23.138270173679
    ],
    [
        112.92213251579,
        23.138229493018
    ],
    [
        112.92220027498,
        23.138196120621
    ],
    [
        112.92234880776,
        23.138138092971
    ],
    [
        112.92252363633,
        23.138057624453
    ],
    [
        112.92268952406,
        23.13796109236
    ],
    [
        112.92282343122,
        23.137885588783
    ],
    [
        112.92293077571,
        23.137815409088
    ],
    [
        112.9230370383,
        23.137746029338
    ],
    [
        112.92312053281,
        23.137702883484
    ],
    [
        112.92324279528,
        23.137641399275
    ],
    [
        112.92337698959,
        23.137578849916
    ],
    [
        112.92352284514,
        23.137508991029
    ],
    [
        112.92366165594,
        23.137443435024
    ],
    [
        112.92375654744,
        23.137381551865
    ],
    [
        112.92387475905,
        23.137329481311
    ],
    [
        112.92406970564,
        23.137239318323
    ],
    [
        112.92411525768,
        23.137221241282
    ],
    [
        112.9247316095,
        23.137072095992
    ],
    [
        112.92511534103,
        23.136977682688
    ],
    [
        112.92544729847,
        23.136893395923
    ],
    [
        112.92547577624,
        23.136887181931
    ],
    [
        112.92719639391,
        23.136409603578
    ],
    [
        112.92891948357,
        23.136040768273
    ],
    [
        112.9296221773,
        23.135943969373
    ],
    [
        112.92970930799,
        23.135934213451
    ],
    [
        112.92991234694,
        23.135914859581
    ],
    [
        112.93012625211,
        23.135887564293
    ],
    [
        112.93041346315,
        23.135850465547
    ],
    [
        112.9305144522,
        23.135835983157
    ],
    [
        112.93451679006,
        23.134188627826
    ],
    [
        112.93457737599,
        23.134166212751
    ],
    [
        112.9347124074,
        23.134106350852
    ],
    [
        112.93495965505,
        23.134008999587
    ],
    [
        112.93499660837,
        23.133985930215
    ],
    [
        112.93520909702,
        23.133838068804
    ],
    [
        112.9355430169,
        23.133950682219
    ],
    [
        112.9355557869,
        23.133957359712
    ],
    [
        112.93556285155,
        23.133958115895
    ],
    [
        112.93584926288,
        23.133877894829
    ],
    [
        112.93597209249,
        23.133843764491
    ],
    [
        112.93616313624,
        23.133786519617
    ],
    [
        112.93623569731,
        23.133758493065
    ],
    [
        112.9362840717,
        23.133740981802
    ],
    [
        112.93632592416,
        23.133724882206
    ],
    [
        112.9364976854,
        23.133659074742
    ],
    [
        112.93657215522,
        23.133615821145
    ],
    [
        112.9366088454,
        23.13360491233
    ],
    [
        112.93663847214,
        23.133578061934
    ],
    [
        112.9366971767,
        23.133563967836
    ],
    [
        112.93680534979,
        23.133517952982
    ],
    [
        112.93688145379,
        23.133478192574
    ],
    [
        112.93689912067,
        23.133470705635
    ],
    [
        112.93689422874,
        23.133469937007
    ],
    [
        112.93690020925,
        23.133461201537
    ],
    [
        112.93690863431,
        23.133462208765
    ],
    [
        112.9369983313,
        23.133407396511
    ],
    [
        112.93709427852,
        23.133367438535
    ],
    [
        112.93720109846,
        23.133331168087
    ],
    [
        112.93735004562,
        23.133317271383
    ],
    [
        112.93755988769,
        23.133264518028
    ],
    [
        112.93788906868,
        23.133197522641
    ],
    [
        112.9380423848,
        23.13316315863
    ],
    [
        112.93823539407,
        23.133121859967
    ],
    [
        112.93837566882,
        23.133094372582
    ],
    [
        112.93854476646,
        23.133045681578
    ],
    [
        112.9386149074,
        23.133028668414
    ],
    [
        112.93867091363,
        23.133005562386
    ],
    [
        112.93873208748,
        23.132972362609
    ],
    [
        112.9388275178,
        23.132932283777
    ],
    [
        112.93901566932,
        23.132823924788
    ],
    [
        112.9391018615,
        23.132777416791
    ],
    [
        112.93926718243,
        23.132674968588
    ],
    [
        112.93928458368,
        23.1326704366
    ],
    [
        112.93941401846,
        23.132578402944
    ],
    [
        112.93961415807,
        23.132438635127
    ],
    [
        112.93972891371,
        23.132365183288
    ],
    [
        112.93998672105,
        23.132167743731
    ],
    [
        112.94018443494,
        23.13201897263
    ],
    [
        112.94037100576,
        23.131873832494
    ],
    [
        112.94054479811,
        23.131744011201
    ],
    [
        112.94081324907,
        23.131538703939
    ],
    [
        112.94109394252,
        23.131361408499
    ],
    [
        112.9412185267,
        23.131249201796
    ],
    [
        112.94137984002,
        23.131094212027
    ],
    [
        112.94151367115,
        23.131004108716
    ],
    [
        112.94165621598,
        23.130886487309
    ],
    [
        112.94172585581,
        23.130834609369
    ],
    [
        112.94182134141,
        23.130757986227
    ],
    [
        112.94193777505,
        23.130667797357
    ],
    [
        112.94203190644,
        23.130583041452
    ],
    [
        112.9421252185,
        23.130514294365
    ],
    [
        112.94224302128,
        23.130412673113
    ],
    [
        112.9424174117,
        23.130279378671
    ],
    [
        112.942493863,
        23.130217884233
    ],
    [
        112.94260350411,
        23.130142655672
    ],
    [
        112.94282579566,
        23.129956331781
    ],
    [
        112.94293925852,
        23.129857160178
    ],
    [
        112.94306251303,
        23.129767070975
    ],
    [
        112.9431893126,
        23.129658208595
    ],
    [
        112.94329869435,
        23.129579412098
    ],
    [
        112.94342032729,
        23.129477926988
    ],
    [
        112.9435063129,
        23.129412729666
    ],
    [
        112.94363338581,
        23.129323903297
    ],
    [
        112.94384237353,
        23.129160688443
    ],
    [
        112.94394170486,
        23.12906843013
    ],
    [
        112.9443172649,
        23.128739797075
    ],
    [
        112.94436597551,
        23.128709537138
    ],
    [
        112.94454695471,
        23.128565899355
    ],
    [
        112.94464901474,
        23.12847980247
    ],
    [
        112.94472984622,
        23.128414350492
    ],
    [
        112.9448267284,
        23.128355172035
    ],
    [
        112.9449353152,
        23.128286053423
    ],
    [
        112.9450632337,
        23.128187080403
    ],
    [
        112.94510460758,
        23.128145516747
    ],
    [
        112.94516694161,
        23.128081673801
    ],
    [
        112.94524614719,
        23.128014054293
    ],
    [
        112.9454140815,
        23.127884903339
    ],
    [
        112.94550907079,
        23.127818124489
    ],
    [
        112.9455733156,
        23.127748544488
    ],
    [
        112.94577175138,
        23.127576867042
    ],
    [
        112.94584851586,
        23.12750627705
    ],
    [
        112.94596011213,
        23.127432446715
    ],
    [
        112.94600476451,
        23.127373456028
    ],
    [
        112.94607335997,
        23.127320611849
    ],
    [
        112.94619395748,
        23.127207031904
    ],
    [
        112.9462995731,
        23.127130833497
    ],
    [
        112.94660093124,
        23.126872338452
    ],
    [
        112.94667690118,
        23.126774065028
    ],
    [
        112.94686639197,
        23.126589134563
    ],
    [
        112.947039291,
        23.126397123688
    ],
    [
        112.94720102139,
        23.126235111033
    ],
    [
        112.94742401903,
        23.12601163798
    ],
    [
        112.94751524114,
        23.125908215339
    ],
    [
        112.94775046848,
        23.125733884507
    ],
    [
        112.94798080438,
        23.125556897343
    ],
    [
        112.94806384703,
        23.125492100846
    ],
    [
        112.94826669923,
        23.125320681289
    ],
    [
        112.94828521833,
        23.125298684674
    ],
    [
        112.94888098794,
        23.124824139296
    ],
    [
        112.94947243123,
        23.124360933114
    ],
    [
        112.95003993641,
        23.123926221455
    ],
    [
        112.95103394936,
        23.123170659769
    ],
    [
        112.95248725836,
        23.122048635641
    ],
    [
        112.95260546505,
        23.121962238718
    ],
    [
        112.9540029698,
        23.120652004848
    ],
    [
        112.95414306156,
        23.120437180755
    ],
    [
        112.95428424278,
        23.120224505472
    ],
    [
        112.95454263947,
        23.119817743104
    ],
    [
        112.95528002919,
        23.118595926675
    ],
    [
        112.95598680242,
        23.117264516703
    ],
    [
        112.95676636722,
        23.11618676043
    ],
    [
        112.95721767265,
        23.115665920065
    ],
    [
        112.95816687777,
        23.114596327426
    ],
    [
        112.95855822302,
        23.114160385485
    ],
    [
        112.95905775994,
        23.113605942648
    ],
    [
        112.96038164681,
        23.112168513749
    ],
    [
        112.96128754301,
        23.111117162171
    ],
    [
        112.96131751546,
        23.111088171966
    ],
    [
        112.96131452049,
        23.111088765671
    ],
    [
        112.96222203122,
        23.110032429411
    ],
    [
        112.96307189648,
        23.108885338418
    ],
    [
        112.96397898165,
        23.107641800145
    ],
    [
        112.96420246331,
        23.107346607296
    ],
    [
        112.96475579383,
        23.106526209022
    ],
    [
        112.96674427209,
        23.102803677768
    ],
    [
        112.9668599345,
        23.101977721264
    ],
    [
        112.96758479107,
        23.100622473786
    ],
    [
        112.96822400706,
        23.099402971476
    ],
    [
        112.96905630355,
        23.098186653667
    ],
    [
        112.97000720921,
        23.097430174549
    ],
    [
        112.97373929255,
        23.092873161725
    ],
    [
        112.97381615377,
        23.09263147283
    ],
    [
        112.97385153364,
        23.092585520238
    ],
    [
        112.97388064583,
        23.09255780877
    ],
    [
        112.97393398418,
        23.092492134395
    ],
    [
        112.97405859962,
        23.092364124004
    ],
    [
        112.97431082149,
        23.092096171469
    ],
    [
        112.97430728735,
        23.092096208944
    ],
    [
        112.97456357452,
        23.091828802264
    ],
    [
        112.974997729,
        23.091423754717
    ],
    [
        112.97572322317,
        23.090639307564
    ],
    [
        112.97638553896,
        23.089887294548
    ],
    [
        112.97690383675,
        23.089397234209
    ],
    [
        112.97719758753,
        23.08898166275
    ],
    [
        112.97727109891,
        23.088331996612
    ],
    [
        112.97727056022,
        23.088324406612
    ],
    [
        112.97732502067,
        23.088139247427
    ],
    [
        112.97736393637,
        23.088043182105
    ],
    [
        112.97745053039,
        23.087735980926
    ],
    [
        112.97754580694,
        23.087440649159
    ],
    [
        112.97760596521,
        23.087253013895
    ],
    [
        112.97772900837,
        23.086849250043
    ],
    [
        112.97776629987,
        23.086727984413
    ],
    [
        112.9777728288,
        23.086713557451
    ],
    [
        112.97872733516,
        23.085520563879
    ],
    [
        112.97939922789,
        23.084714482511
    ],
    [
        112.97994411143,
        23.08405438654
    ],
    [
        112.98012291657,
        23.083834156153
    ],
    [
        112.98014574376,
        23.083802286592
    ],
    [
        112.98117286813,
        23.081378561201
    ],
    [
        112.98117476998,
        23.081375025516
    ],
    [
        112.98136197656,
        23.080967507807
    ],
    [
        112.98140028885,
        23.080871844309
    ],
    [
        112.98157226427,
        23.080494812361
    ],
    [
        112.98180861071,
        23.079963448312
    ],
    [
        112.98193032087,
        23.079617884044
    ],
    [
        112.98205039064,
        23.07928508768
    ],
    [
        112.98239452069,
        23.078365225186
    ],
    [
        112.98299977304,
        23.076824456604
    ],
    [
        112.98301687791,
        23.076763636897
    ],
    [
        112.98306248792,
        23.076637620729
    ],
    [
        112.98362734519,
        23.074901715621
    ],
    [
        112.98363602966,
        23.074880804077
    ],
    [
        112.98367239426,
        23.07476921333
    ],
    [
        112.98405850231,
        23.073533680461
    ],
    [
        112.98455920628,
        23.071855591425
    ],
    [
        112.9849076283,
        23.070678718926
    ],
    [
        112.98502500335,
        23.070249101307
    ],
    [
        112.98547895741,
        23.068637100134
    ],
    [
        112.98624165432,
        23.066254646654
    ],
    [
        112.98638571573,
        23.06573453724
    ],
    [
        112.98688228071,
        23.064039489578
    ],
    [
        112.98717433348,
        23.06302575707
    ],
    [
        112.98754615589,
        23.061747098672
    ],
    [
        112.98765006185,
        23.061399925344
    ],
    [
        112.98769685736,
        23.061223623701
    ],
    [
        112.98803192596,
        23.059925543827
    ],
    [
        112.9884428321,
        23.057950218723
    ],
    [
        112.98851818957,
        23.057590048047
    ],
    [
        112.98870454316,
        23.056708086349
    ],
    [
        112.98877313872,
        23.056387258236
    ],
    [
        112.98961696992,
        23.053479428124
    ],
    [
        112.98987627297,
        23.052196304898
    ],
    [
        112.99012154703,
        23.051024162257
    ],
    [
        112.990365383,
        23.049801328891
    ],
    [
        112.99036213203,
        23.049803216766
    ],
    [
        112.99053850543,
        23.048906585892
    ],
    [
        112.99073865851,
        23.047686114052
    ],
    [
        112.99089648655,
        23.046704000699
    ],
    [
        112.9910462823,
        23.045825250597
    ],
    [
        112.9910449285,
        23.045826601628
    ],
    [
        112.99104546863,
        23.045824704595
    ],
    [
        112.99116851182,
        23.045291255325
    ],
    [
        112.99119576415,
        23.045172802981
    ],
    [
        112.99126831078,
        23.044822565292
    ],
    [
        112.99139815821,
        23.044321187537
    ],
    [
        112.99139839972,
        23.044292428401
    ],
    [
        112.99139809752,
        23.044262038912
    ],
    [
        112.99139077241,
        23.044254680669
    ],
    [
        112.99139019084,
        23.044216150263
    ],
    [
        112.99139477178,
        23.044190394941
    ],
    [
        112.99139149196,
        23.044163519431
    ],
    [
        112.99139039869,
        23.044154560931
    ],
    [
        112.99139146136,
        23.044133673799
    ],
    [
        112.99139522728,
        23.044106015605
    ],
    [
        112.99139467356,
        23.044094617593
    ],
    [
        112.99139520336,
        23.044082681748
    ],
    [
        112.99139598861,
        23.044055552968
    ],
    [
        112.99139269463,
        23.04401483994
    ],
    [
        112.99139727308,
        23.043986642719
    ],
    [
        112.99139696786,
        23.043953268676
    ],
    [
        112.99139534118,
        23.043952718804
    ],
    [
        112.99139531727,
        23.04392938495
    ],
    [
        112.99139584486,
        23.043915278517
    ],
    [
        112.99140338733,
        23.043870272493
    ],
    [
        112.99140361972,
        23.043832559683
    ],
    [
        112.99140548992,
        23.043806249713
    ],
    [
        112.99140979904,
        23.043779679288
    ],
    [
        112.99140977043,
        23.043751732933
    ],
    [
        112.99141161065,
        23.043696120005
    ],
    [
        112.99141888574,
        23.0436546401
    ],
    [
        112.99143240261,
        23.043621327841
    ],
    [
        112.99143345588,
        23.043591215755
    ],
    [
        112.99143531362,
        23.043552696274
    ],
    [
        112.99144557714,
        23.043518284326
    ],
    [
        112.99144797859,
        23.043481395246
    ],
    [
        112.99145147466,
        23.043454821345
    ],
    [
        112.99146174371,
        23.043425836027
    ],
    [
        112.99146171017,
        23.043393005857
    ],
    [
        112.99147062024,
        23.043360215993
    ],
    [
        112.99148250623,
        23.043322284526
    ],
    [
        112.99148138615,
        23.043287007547
    ],
    [
        112.99149273591,
        23.043254771542
    ],
    [
        112.99148894001,
        23.043253126417
    ],
    [
        112.99149919961,
        23.043214916452
    ],
    [
        112.99150078862,
        23.043178566463
    ],
    [
        112.99150593682,
        23.043177504547
    ],
    [
        112.99150888784,
        23.043147943818
    ],
    [
        112.99151237065,
        23.04310834659
    ],
    [
        112.99151721547,
        23.043075538634
    ],
    [
        112.99152314877,
        23.043047076818
    ],
    [
        112.99153504191,
        23.043016200348
    ],
    [
        112.99153853608,
        23.042987727477
    ],
    [
        112.99154147772,
        23.042948941845
    ],
    [
        112.99154740246,
        23.042912069137
    ],
    [
        112.99155630643,
        23.042873310872
    ],
    [
        112.99156466781,
        23.042834007543
    ],
    [
        112.99157574567,
        23.042800957199
    ],
    [
        112.99157598798,
        23.042772740807
    ],
    [
        112.99158842199,
        23.042740782129
    ],
    [
        112.99159570511,
        23.042707171832
    ],
    [
        112.99159838793,
        23.042680323348
    ],
    [
        112.9916119032,
        23.04264565672
    ],
    [
        112.99161945761,
        23.042612319166
    ],
    [
        112.99162376291,
        23.042581951099
    ],
    [
        112.99163943384,
        23.042535085345
    ],
    [
        112.99165592409,
        23.042494464057
    ],
    [
        112.99166319206,
        23.042445931438
    ],
    [
        112.99167588074,
        23.042397966959
    ],
    [
        112.99169317434,
        23.042347853741
    ],
    [
        112.99170234706,
        23.042306927384
    ],
    [
        112.99170989621,
        23.042268435329
    ],
    [
        112.99171175535,
        23.042231001696
    ],
    [
        112.99172201238,
        23.042190351962
    ],
    [
        112.99173037676,
        23.042154034493
    ],
    [
        112.99173684878,
        23.042122320568
    ],
    [
        112.99174168791,
        23.042083815872
    ],
    [
        112.99175113714,
        23.042048317693
    ],
    [
        112.99176032249,
        23.042019872704
    ],
    [
        112.99176354055,
        23.041986244169
    ],
    [
        112.99176594671,
        23.041953697054
    ],
    [
        112.99177025127,
        23.041922515629
    ],
    [
        112.9917777972,
        23.041880768193
    ],
    [
        112.99178264624,
        23.041852031324
    ],
    [
        112.99178939176,
        23.041822760934
    ],
    [
        112.99179424327,
        23.041796466026
    ],
    [
        112.99180992827,
        23.041763711555
    ],
    [
        112.99181584739,
        23.041721142593
    ],
    [
        112.9918179646,
        23.041670686995
    ],
    [
        112.99182387093,
        23.041615365914
    ],
    [
        112.99182247473,
        23.041574389626
    ],
    [
        112.9918300262,
        23.041538069036
    ],
    [
        112.99183730067,
        23.041495778088
    ],
    [
        112.99183699071,
        23.041456977625
    ],
    [
        112.99184806329,
        23.041418774972
    ],
    [
        112.99185425163,
        23.041374308309
    ],
    [
        112.99185045302,
        23.041369677402
    ],
    [
        112.99186395753,
        23.041324432369
    ],
    [
        112.9918752916,
        23.041276735028
    ],
    [
        112.99188282248,
        23.04121979431
    ],
    [
        112.99189307286,
        23.041172363195
    ],
    [
        112.99189411587,
        23.041131398798
    ],
    [
        112.99190382862,
        23.041088306301
    ],
    [
        112.99191407958,
        23.041041418042
    ],
    [
        112.99192512647,
        23.040977440572
    ],
    [
        112.99192752483,
        23.04093675422
    ],
    [
        112.99193507265,
        23.040896635895
    ],
    [
        112.99194235706,
        23.040864113312
    ],
    [
        112.99194828433,
        23.040829413504
    ],
    [
        112.99195313332,
        23.040800406138
    ],
    [
        112.99195526319,
        23.040762160426
    ],
    [
        112.99196634721,
        23.040735354559
    ],
    [
        112.991970109,
        23.040703086034
    ],
    [
        112.99197171716,
        23.040685186839
    ],
    [
        112.9919852401,
        23.040658393272
    ],
    [
        112.99198737273,
        23.04062286086
    ],
    [
        112.99199655386,
        23.040590076779
    ],
    [
        112.99199948658,
        23.040541524991
    ],
    [
        112.99200622262,
        23.04050248843
    ],
    [
        112.99201350899,
        23.040471865605
    ],
    [
        112.99202107146,
        23.040446399306
    ],
    [
        112.99202265657,
        23.04040516651
    ],
    [
        112.99203371373,
        23.040351229151
    ],
    [
        112.99204695654,
        23.040315210059
    ],
    [
        112.99204772687,
        23.040272073974
    ],
    [
        112.99204742747,
        23.040243312496
    ],
    [
        112.99204957288,
        23.040220532374
    ],
    [
        112.99205306896,
        23.040193417931
    ],
    [
        112.99205574111,
        23.040155175214
    ],
    [
        112.9920486681,
        23.04012746492
    ],
    [
        112.99205352104,
        23.040102256558
    ],
    [
        112.9920532129,
        23.040064541479
    ],
    [
        112.99205371454,
        23.040023574641
    ],
    [
        112.99205935565,
        23.0399731375
    ],
    [
        112.99206824333,
        23.039917290382
    ],
    [
        112.99207036434,
        23.039869548746
    ],
    [
        112.99207496155,
        23.039859804455
    ],
    [
        112.9920811703,
        23.039835417052
    ],
    [
        112.99208927809,
        23.039813209871
    ],
    [
        112.99208899407,
        23.039799913747
    ],
    [
        112.99209247807,
        23.039760318682
    ],
    [
        112.99210870776,
        23.039730284589
    ],
    [
        112.99211057304,
        23.039698006998
    ],
    [
        112.99212543956,
        23.039659555301
    ],
    [
        112.99212676052,
        23.039624833089
    ],
    [
        112.99214000006,
        23.039585288017
    ],
    [
        112.99215592693,
        23.039522694701
    ],
    [
        112.99216103221,
        23.03947822445
    ],
    [
        112.99217156511,
        23.03944192172
    ],
    [
        112.99218264342,
        23.03940914906
    ],
    [
        112.99218829416,
        23.039368208918
    ],
    [
        112.99220232821,
        23.039309676347
    ],
    [
        112.99220418789,
        23.039271429902
    ],
    [
        112.99220822125,
        23.039239163742
    ],
    [
        112.99222119384,
        23.0392036881
    ],
    [
        112.9922273927,
        23.039168991378
    ],
    [
        112.99223710169,
        23.039121289614
    ],
    [
        112.99223975841,
        23.03906649692
    ],
    [
        112.99225515908,
        23.039019910242
    ],
    [
        112.99226027122,
        23.038982223545
    ],
    [
        112.99226917943,
        23.038946998597
    ],
    [
        112.99227104301,
        23.038912550805
    ],
    [
        112.99228454741,
        23.038866497279
    ],
    [
        112.99228964316,
        23.038811717549
    ],
    [
        112.99229691853,
        23.038769158663
    ],
    [
        112.9923101627,
        23.038734228184
    ],
    [
        112.9923204191,
        23.038691956488
    ],
    [
        112.99233204342,
        23.038663258069
    ],
    [
        112.99234470503,
        23.038585999191
    ],
    [
        112.99234579179,
        23.038588989456
    ],
    [
        112.99235821811,
        23.038548900181
    ],
    [
        112.99236794536,
        23.038519920762
    ],
    [
        112.99237332742,
        23.0384808795
    ],
    [
        112.99238387019,
        23.038454617755
    ],
    [
        112.99238898158,
        23.038415846454
    ],
    [
        112.99239924949,
        23.038385513615
    ],
    [
        112.9924111277,
        23.038338910385
    ],
    [
        112.99242409989,
        23.038302894585
    ],
    [
        112.9924292018,
        23.038254084657
    ],
    [
        112.99243865167,
        23.038218321437
    ],
    [
        112.99244918748,
        23.038184734703
    ],
    [
        112.9924562038,
        23.038154384892
    ],
    [
        112.99246051353,
        23.038127276327
    ],
    [
        112.9924683456,
        23.038099915506
    ],
    [
        112.99247184116,
        23.038071445998
    ],
    [
        112.99248129855,
        23.038043551434
    ],
    [
        112.99249346894,
        23.038019198819
    ],
    [
        112.99249912842,
        23.037986671386
    ],
    [
        112.99251099756,
        23.037930301794
    ],
    [
        112.99250991343,
        23.037930024572
    ],
    [
        112.99251028486,
        23.03774932882
    ],
    [
        112.99251509919,
        23.037682339542
    ],
    [
        112.99253308156,
        23.037498755616
    ],
    [
        112.9925897346,
        23.037231819066
    ],
    [
        112.99268771177,
        23.036820233351
    ],
    [
        112.9927392573,
        23.036594788011
    ],
    [
        112.99284829346,
        23.036123861966
    ],
    [
        112.9929157918,
        23.035858905245
    ],
    [
        112.99307471673,
        23.035422479295
    ],
    [
        112.99317687036,
        23.035127358564
    ],
    [
        112.99323967555,
        23.034757938535
    ],
    [
        112.99338728517,
        23.034705941058
    ],
    [
        112.99348533129,
        23.034674811472
    ],
    [
        112.99361559901,
        23.034625989998
    ]
];

let shishan = [
    [
        113.08985969543,
        23.254683334809
    ],
    [
        113.08985344118,
        23.25464273013
    ],
    [
        113.08982108123,
        23.254466577218
    ],
    [
        113.08981156134,
        23.254450973392
    ],
    [
        113.08982000199,
        23.254342895988
    ],
    [
        113.08984477014,
        23.254170850324
    ],
    [
        113.08985837602,
        23.254117498245
    ],
    [
        113.08991526082,
        23.253787958251
    ],
    [
        113.08994522657,
        23.253411585953
    ],
    [
        113.08995830774,
        23.253225867651
    ],
    [
        113.08997110807,
        23.253114749797
    ],
    [
        113.08996026631,
        23.252849605493
    ],
    [
        113.08996055512,
        23.252742997256
    ],
    [
        113.09001311754,
        23.252376362085
    ],
    [
        113.0901263966,
        23.251766141472
    ],
    [
        113.0902067545,
        23.251261618557
    ],
    [
        113.09020811476,
        23.251260786622
    ],
    [
        113.09021873279,
        23.251221041837
    ],
    [
        113.09022962053,
        23.25119105864
    ],
    [
        113.09024432391,
        23.251130644316
    ],
    [
        113.09027155819,
        23.250997367523
    ],
    [
        113.09033498036,
        23.250826448725
    ],
    [
        113.090417428,
        23.250715227337
    ],
    [
        113.09043212282,
        23.25069089155
    ],
    [
        113.0904397414,
        23.250681839513
    ],
    [
        113.09043865497,
        23.250675886349
    ],
    [
        113.09045933379,
        23.250652014212
    ],
    [
        113.09047729539,
        23.250617599411
    ],
    [
        113.09049851907,
        23.250590465584
    ],
    [
        113.09056846775,
        23.250431134369
    ],
    [
        113.09072437234,
        23.250257391616
    ],
    [
        113.09072709254,
        23.250256542383
    ],
    [
        113.09074232331,
        23.250259870048
    ],
    [
        113.09083481677,
        23.250205773449
    ],
    [
        113.09090853733,
        23.25016765735
    ],
    [
        113.09113677939,
        23.250011195572
    ],
    [
        113.09134460717,
        23.249889202808
    ],
    [
        113.09137343926,
        23.249879615855
    ],
    [
        113.09152931825,
        23.249749896441
    ],
    [
        113.0916092955,
        23.24968840791
    ],
    [
        113.09164466253,
        23.249651348453
    ],
    [
        113.09164439456,
        23.249638874371
    ],
    [
        113.09164548991,
        23.249615533383
    ],
    [
        113.09165039173,
        23.249595399976
    ],
    [
        113.0916397927,
        23.249572204658
    ],
    [
        113.09162320809,
        23.249556407744
    ],
    [
        113.09159683713,
        23.249527170789
    ],
    [
        113.09157780957,
        23.249496757501
    ],
    [
        113.09154301473,
        23.249445926999
    ],
    [
        113.0915413876,
        23.249431842499
    ],
    [
        113.09152888186,
        23.249417623043
    ],
    [
        113.09148456944,
        23.249362844504
    ],
    [
        113.09145385187,
        23.24931847483
    ],
    [
        113.09143320027,
        23.249265027836
    ],
    [
        113.09143374873,
        23.249251729822
    ],
    [
        113.09142124489,
        23.249231815061
    ],
    [
        113.09140602189,
        23.249210307214
    ],
    [
        113.0913752993,
        23.249180586575
    ],
    [
        113.09134892823,
        23.249150811511
    ],
    [
        113.09128693251,
        23.249109282421
    ],
    [
        113.09118606103,
        23.249017799304
    ],
    [
        113.09109987033,
        23.248941324478
    ],
    [
        113.09102074854,
        23.248870459706
    ],
    [
        113.09087391055,
        23.248773349987
    ],
    [
        113.09075018451,
        23.248690599904
    ],
    [
        113.09073332306,
        23.248684581041
    ],
    [
        113.0907232596,
        23.248683627316
    ],
    [
        113.09072026834,
        23.248681767625
    ],
    [
        113.0907074885,
        23.248671084615
    ],
    [
        113.09068735988,
        23.248673517498
    ],
    [
        113.0906555415,
        23.248659286385
    ],
    [
        113.09063405607,
        23.248652786603
    ],
    [
        113.09056171037,
        23.248636105127
    ],
    [
        113.09052118537,
        23.248627416055
    ],
    [
        113.090460534,
        23.248613026324
    ],
    [
        113.09045237383,
        23.24861313413
    ],
    [
        113.09037295387,
        23.24859763955
    ],
    [
        113.09036153234,
        23.248590196208
    ],
    [
        113.0902532787,
        23.248573734072
    ],
    [
        113.09021276319,
        23.248535758088
    ],
    [
        113.09021116292,
        23.248451964865
    ],
    [
        113.09021800299,
        23.248348529377
    ],
    [
        113.09023108991,
        23.248270507566
    ],
    [
        113.09024962735,
        23.248167187549
    ],
    [
        113.09028505391,
        23.248004240584
    ],
    [
        113.09028886569,
        23.247995238804
    ],
    [
        113.09028696424,
        23.247988754283
    ],
    [
        113.09032729284,
        23.247814622323
    ],
    [
        113.09037744569,
        23.247567939741
    ],
    [
        113.09065679516,
        23.246362936416
    ],
    [
        113.09066060655,
        23.246355834335
    ],
    [
        113.09068546183,
        23.246143672201
    ],
    [
        113.09071215194,
        23.246073886684
    ],
    [
        113.09072741631,
        23.24600831922
    ],
    [
        113.09074159069,
        23.245947105952
    ],
    [
        113.09075251073,
        23.245867219874
    ],
    [
        113.09075907016,
        23.245805021128
    ],
    [
        113.09076208895,
        23.245752361843
    ],
    [
        113.09077353234,
        23.245713968469
    ],
    [
        113.09080620656,
        23.245645734363
    ],
    [
        113.09080432773,
        23.24559720744
    ],
    [
        113.09080052221,
        23.245592645882
    ],
    [
        113.09079400704,
        23.245568319305
    ],
    [
        113.09077034902,
        23.245558048877
    ],
    [
        113.09077035284,
        23.245550725446
    ],
    [
        113.09082010537,
        23.245080569577
    ],
    [
        113.09082310347,
        23.245069138773
    ],
    [
        113.09083975717,
        23.24495500397
    ],
    [
        113.09086219946,
        23.244703821145
    ],
    [
        113.09110531619,
        23.244772294827
    ],
    [
        113.09134897384,
        23.244832662378
    ],
    [
        113.09164970886,
        23.244942263623
    ],
    [
        113.09206731498,
        23.245153566117
    ],
    [
        113.09245910093,
        23.24529856935
    ],
    [
        113.09408023374,
        23.245688662533
    ],
    [
        113.09468995038,
        23.245792089718
    ],
    [
        113.09577636275,
        23.245884139162
    ],
    [
        113.09624871226,
        23.245909044814
    ],
    [
        113.09644981369,
        23.24592567439
    ],
    [
        113.09707075348,
        23.245950654806
    ],
    [
        113.0976130811,
        23.246022685648
    ],
    [
        113.09777146961,
        23.246058860169
    ],
    [
        113.0978008764,
        23.245932503304
    ],
    [
        113.09787240511,
        23.245791171888
    ],
    [
        113.09799857983,
        23.24558161473
    ],
    [
        113.09813777717,
        23.245405877329
    ],
    [
        113.09816632326,
        23.245369858543
    ],
    [
        113.09843567905,
        23.245143003526
    ],
    [
        113.09847074193,
        23.245111284279
    ],
    [
        113.09850797963,
        23.245076566712
    ],
    [
        113.09853597449,
        23.245052766528
    ],
    [
        113.09856450788,
        23.245037642684
    ],
    [
        113.09861587281,
        23.245000928215
    ],
    [
        113.0986566374,
        23.244973513486
    ],
    [
        113.09867974465,
        23.244944326848
    ],
    [
        113.0987023032,
        23.244924909044
    ],
    [
        113.09874144902,
        23.244876081122
    ],
    [
        113.09880369162,
        23.244816243204
    ],
    [
        113.09884120361,
        23.2447736685
    ],
    [
        113.09887652974,
        23.244753622702
    ],
    [
        113.09890425359,
        23.244726035922
    ],
    [
        113.0989773655,
        23.244657723899
    ],
    [
        113.09901215107,
        23.244631447506
    ],
    [
        113.0990727548,
        23.244583569512
    ],
    [
        113.09910536871,
        23.24455378456
    ],
    [
        113.09913335555,
        23.244540034457
    ],
    [
        113.09914177005,
        23.244551369818
    ],
    [
        113.09916974558,
        23.244557420806
    ],
    [
        113.09919200393,
        23.244586023071
    ],
    [
        113.0992066562,
        23.244614947603
    ],
    [
        113.09924492566,
        23.244671110427
    ],
    [
        113.09927370056,
        23.244704282149
    ],
    [
        113.09930708653,
        23.24474935865
    ],
    [
        113.09933558198,
        23.244796366776
    ],
    [
        113.09938227247,
        23.244850851732
    ],
    [
        113.09941728313,
        23.244904600449
    ],
    [
        113.0994425172,
        23.244954615989
    ],
    [
        113.09949464088,
        23.245006900629
    ],
    [
        113.09951526527,
        23.245042029362
    ],
    [
        113.09954132765,
        23.245066816862
    ],
    [
        113.09959209156,
        23.245121013267
    ],
    [
        113.09964068177,
        23.245176039294
    ],
    [
        113.09969661222,
        23.245218002269
    ],
    [
        113.09971371329,
        23.245237967331
    ],
    [
        113.09974087393,
        23.245239154964
    ],
    [
        113.09973978632,
        23.245241331595
    ],
    [
        113.09980715529,
        23.245223285841
    ],
    [
        113.09988024322,
        23.245175102028
    ],
    [
        113.09989521417,
        23.245113983002
    ],
    [
        113.09987677456,
        23.245059033914
    ],
    [
        113.09978720291,
        23.244950273476
    ],
    [
        113.09941365642,
        23.244586193605
    ],
    [
        113.09939140916,
        23.244539414285
    ],
    [
        113.09940827998,
        23.244486414025
    ],
    [
        113.09937000317,
        23.244445977571
    ],
    [
        113.09912022483,
        23.244224405914
    ],
    [
        113.09904773382,
        23.244158986179
    ],
    [
        113.0990387742,
        23.244150910052
    ],
    [
        113.09904040392,
        23.244151170206
    ],
    [
        113.09920322625,
        23.243964550894
    ],
    [
        113.09921545987,
        23.243947653032
    ],
    [
        113.09922742873,
        23.243919094028
    ],
    [
        113.09932057621,
        23.243958350741
    ],
    [
        113.09934610139,
        23.243972287765
    ],
    [
        113.09934909061,
        23.243970098365
    ],
    [
        113.09937760679,
        23.243978591879
    ],
    [
        113.0994039482,
        23.243989812532
    ],
    [
        113.09942024306,
        23.24399458916
    ],
    [
        113.09941861202,
        23.243996769584
    ],
    [
        113.09943572332,
        23.243998828811
    ],
    [
        113.09945094718,
        23.24397703191
    ],
    [
        113.09946997474,
        23.243953583353
    ],
    [
        113.09948384458,
        23.243924743534
    ],
    [
        113.09953006126,
        23.243855825878
    ],
    [
        113.09960073329,
        23.243770481411
    ],
    [
        113.09963308624,
        23.243719556975
    ],
    [
        113.09969670644,
        23.243616090261
    ],
    [
        113.09983754192,
        23.243383859907
    ],
    [
        113.0999571686,
        23.243188119477
    ],
    [
        113.10005531378,
        23.243031304886
    ],
    [
        113.10019583054,
        23.242868014134
    ],
    [
        113.10022519797,
        23.242811699468
    ],
    [
        113.10025754521,
        23.242767302607
    ],
    [
        113.10031598613,
        23.242689125256
    ],
    [
        113.10032657741,
        23.2426898787
    ],
    [
        113.10034070814,
        23.242676779414
    ],
    [
        113.10042606544,
        23.242551261389
    ],
    [
        113.10043449372,
        23.242536839059
    ],
    [
        113.10065951379,
        23.242712988332
    ],
    [
        113.10069371353,
        23.242740470009
    ],
    [
        113.1007797547,
        23.242809989586
    ],
    [
        113.10093174493,
        23.242939116289
    ],
    [
        113.10100203881,
        23.242999512292
    ],
    [
        113.10109540222,
        23.24307769832
    ],
    [
        113.10114262364,
        23.243121402523
    ],
    [
        113.10121264391,
        23.243181541931
    ],
    [
        113.10140288549,
        23.243350688426
    ],
    [
        113.10156598014,
        23.243502361548
    ],
    [
        113.10157412171,
        23.243509105075
    ],
    [
        113.10159284949,
        23.243520953764
    ],
    [
        113.10159529137,
        23.243523926191
    ],
    [
        113.1017460282,
        23.243450016647
    ],
    [
        113.10193097806,
        23.243364047202
    ],
    [
        113.10201626567,
        23.243305372591
    ],
    [
        113.10207850088,
        23.243204758409
    ],
    [
        113.10212201133,
        23.243090391296
    ],
    [
        113.10212775416,
        23.243024187357
    ],
    [
        113.10214924862,
        23.242950324959
    ],
    [
        113.1021260118,
        23.242774390538
    ],
    [
        113.10213747831,
        23.242674802118
    ],
    [
        113.10215192391,
        23.242587135951
    ],
    [
        113.10213948579,
        23.242509072137
    ],
    [
        113.10215690815,
        23.242437125399
    ],
    [
        113.10221317262,
        23.242336543723
    ],
    [
        113.10227918112,
        23.242280408205
    ],
    [
        113.10236362706,
        23.242258651395
    ],
    [
        113.10250398864,
        23.242247811012
    ],
    [
        113.10264409875,
        23.242201187092
    ],
    [
        113.10280238579,
        23.242165638258
    ],
    [
        113.10285833844,
        23.242117166825
    ],
    [
        113.10288495225,
        23.242100531229
    ],
    [
        113.10314567135,
        23.241909546125
    ],
    [
        113.10311883428,
        23.241856470226
    ],
    [
        113.103140115,
        23.24169719151
    ],
    [
        113.10314478294,
        23.24161906297
    ],
    [
        113.10315954033,
        23.241474451858
    ],
    [
        113.10313305718,
        23.241304204282
    ],
    [
        113.1031111644,
        23.241169744962
    ],
    [
        113.1031117516,
        23.241106818355
    ],
    [
        113.10314981493,
        23.24102017629
    ],
    [
        113.1031617711,
        23.241002237695
    ],
    [
        113.10324003724,
        23.240873704399
    ],
    [
        113.10327128185,
        23.240832653729
    ],
    [
        113.10328948499,
        23.24080900182
    ],
    [
        113.10334433926,
        23.24077466279
    ],
    [
        113.10344401515,
        23.240689748298
    ],
    [
        113.10349320397,
        23.240605798703
    ],
    [
        113.10353641715,
        23.240527563825
    ],
    [
        113.10363964584,
        23.240405499465
    ],
    [
        113.10365730844,
        23.240377515609
    ],
    [
        113.10369343205,
        23.240342973483
    ],
    [
        113.10369505776,
        23.24034676633
    ],
    [
        113.10371162899,
        23.240326380579
    ],
    [
        113.10408306527,
        23.240484945382
    ],
    [
        113.10402979661,
        23.240588134901
    ],
    [
        113.10430596312,
        23.24073886704
    ],
    [
        113.10447472931,
        23.240782737496
    ],
    [
        113.10459656963,
        23.240790374322
    ],
    [
        113.10463375363,
        23.24078108553
    ],
    [
        113.10467310966,
        23.240769895625
    ],
    [
        113.1048503067,
        23.240771227336
    ],
    [
        113.10496805116,
        23.240802509271
    ],
    [
        113.10509880137,
        23.240856298183
    ],
    [
        113.10553257361,
        23.240977849366
    ],
    [
        113.10565191033,
        23.241038225874
    ],
    [
        113.10576202324,
        23.241094011569
    ],
    [
        113.10618513817,
        23.24124919495
    ],
    [
        113.10627762824,
        23.241274662245
    ],
    [
        113.10628467948,
        23.241277643936
    ],
    [
        113.10635059665,
        23.241283053726
    ],
    [
        113.10643901512,
        23.241307993254
    ],
    [
        113.1064840412,
        23.241315312352
    ],
    [
        113.10656622661,
        23.241328328755
    ],
    [
        113.10670289766,
        23.2413939757
    ],
    [
        113.10703348786,
        23.241487916054
    ],
    [
        113.10704189524,
        23.241489547174
    ],
    [
        113.1071731617,
        23.241508600238
    ],
    [
        113.10732016563,
        23.241513847694
    ],
    [
        113.10743459372,
        23.241555704117
    ],
    [
        113.10751133439,
        23.241576925259
    ],
    [
        113.10759701842,
        23.241606297357
    ],
    [
        113.10760271296,
        23.241607659019
    ],
    [
        113.10763719266,
        23.241555617074
    ],
    [
        113.10764805696,
        23.241532573563
    ],
    [
        113.10764860051,
        23.24153094674
    ],
    [
        113.10768905677,
        23.241464266204
    ],
    [
        113.10776291834,
        23.241329816957
    ],
    [
        113.10782864525,
        23.241192922219
    ],
    [
        113.10788729199,
        23.241096978295
    ],
    [
        113.1079502284,
        23.241070477531
    ],
    [
        113.10806788825,
        23.241123796889
    ],
    [
        113.10811289723,
        23.24113552379
    ],
    [
        113.10821727407,
        23.241176906343
    ],
    [
        113.10822133836,
        23.241181794726
    ],
    [
        113.10831732417,
        23.241198221039
    ],
    [
        113.10838350158,
        23.241182871217
    ],
    [
        113.10845026577,
        23.241103245387
    ],
    [
        113.1085547434,
        23.240992501786
    ],
    [
        113.10863126487,
        23.240916973809
    ],
    [
        113.10874601677,
        23.240843698094
    ],
    [
        113.10878154986,
        23.240826954741
    ],
    [
        113.1088368827,
        23.240801846203
    ],
    [
        113.10887405631,
        23.240765309753
    ],
    [
        113.10889874471,
        23.240745834725
    ],
    [
        113.10889360034,
        23.240735516916
    ],
    [
        113.1089150721,
        23.240664502091
    ],
    [
        113.10898432385,
        23.240512768568
    ],
    [
        113.10892577804,
        23.240483617049
    ],
    [
        113.10882494051,
        23.240443258592
    ],
    [
        113.10893298289,
        23.240272076035
    ],
    [
        113.10895416033,
        23.240233879978
    ],
    [
        113.1089739742,
        23.240206259117
    ],
    [
        113.10900082044,
        23.240201980008
    ],
    [
        113.10903390475,
        23.240195003613
    ],
    [
        113.10909136129,
        23.240228497971
    ],
    [
        113.10912962908,
        23.240177598013
    ],
    [
        113.10917061487,
        23.240117484313
    ],
    [
        113.10923649395,
        23.240125240292
    ],
    [
        113.10929395906,
        23.240144099176
    ],
    [
        113.10932648984,
        23.240149877949
    ],
    [
        113.1093528392,
        23.240082139336
    ],
    [
        113.10938194991,
        23.239947415791
    ],
    [
        113.10941620095,
        23.239827895403
    ],
    [
        113.10944419214,
        23.239740635269
    ],
    [
        113.10948220508,
        23.239666150617
    ],
    [
        113.10953325128,
        23.239565665565
    ],
    [
        113.10959054995,
        23.239442960075
    ],
    [
        113.10960277136,
        23.239415058311
    ],
    [
        113.10962232672,
        23.239369005418
    ],
    [
        113.10967004128,
        23.239369684374
    ],
    [
        113.10968062634,
        23.239354255123
    ],
    [
        113.10971183482,
        23.239313662122
    ],
    [
        113.1097604471,
        23.239204230446
    ],
    [
        113.10982861403,
        23.239049294374
    ],
    [
        113.10983594831,
        23.239030602134
    ],
    [
        113.10975653292,
        23.239008666063
    ],
    [
        113.10965163634,
        23.238981509215
    ],
    [
        113.10958008556,
        23.238953099226
    ],
    [
        113.10958852215,
        23.238912168052
    ],
    [
        113.10959481833,
        23.238835158156
    ],
    [
        113.10962707098,
        23.238847183219
    ],
    [
        113.10969511096,
        23.238857414066
    ],
    [
        113.10975772803,
        23.238867633089
    ],
    [
        113.10980249198,
        23.23882681184
    ],
    [
        113.10983695582,
        23.238783520108
    ],
    [
        113.10982886428,
        23.238731149392
    ],
    [
        113.10980720451,
        23.238695553715
    ],
    [
        113.10984548696,
        23.238623252867
    ],
    [
        113.10986395851,
        23.238576930032
    ],
    [
        113.10990089752,
        23.238489438569
    ],
    [
        113.10991099433,
        23.238406746787
    ],
    [
        113.10994197427,
        23.238313271428
    ],
    [
        113.10995012586,
        23.238289971816
    ],
    [
        113.10998732939,
        23.238210892175
    ],
    [
        113.10999520902,
        23.238188676943
    ],
    [
        113.11001559619,
        23.238120393862
    ],
    [
        113.11001451293,
        23.238119034284
    ],
    [
        113.11003460171,
        23.238084382227
    ],
    [
        113.11004851431,
        23.237977565418
    ],
    [
        113.11008358821,
        23.237851018449
    ],
    [
        113.11012487808,
        23.237747818283
    ],
    [
        113.110136277,
        23.23773158263
    ],
    [
        113.11014442246,
        23.237715878746
    ],
    [
        113.11019411489,
        23.237613794068
    ],
    [
        113.110191416,
        23.237599410244
    ],
    [
        113.11029134457,
        23.237393079721
    ],
    [
        113.11029596123,
        23.237383060472
    ],
    [
        113.11030138658,
        23.237378468469
    ],
    [
        113.11036523406,
        23.237205380889
    ],
    [
        113.1103937616,
        23.23712818364
    ],
    [
        113.11039676007,
        23.237108395142
    ],
    [
        113.11040598262,
        23.237101104931
    ],
    [
        113.11040246238,
        23.237096752885
    ],
    [
        113.11041114347,
        23.237088647131
    ],
    [
        113.11040871967,
        23.237069924261
    ],
    [
        113.11028946973,
        23.23704374046
    ],
    [
        113.11019027619,
        23.23701872173
    ],
    [
        113.11017021829,
        23.237016213565
    ],
    [
        113.11014772011,
        23.237014240106
    ],
    [
        113.11014447217,
        23.237008262473
    ],
    [
        113.11013714949,
        23.237012306523
    ],
    [
        113.11013091343,
        23.237013642004
    ],
    [
        113.11011817021,
        23.237016312181
    ],
    [
        113.11009837921,
        23.237018416967
    ],
    [
        113.11007615296,
        23.237015089769
    ],
    [
        113.11006774975,
        23.237014520017
    ],
    [
        113.11004389271,
        23.237016070157
    ],
    [
        113.11000621575,
        23.237010796131
    ],
    [
        113.10998073718,
        23.237006104406
    ],
    [
        113.10996338894,
        23.237004151067
    ],
    [
        113.1099438765,
        23.236996766809
    ],
    [
        113.10991676739,
        23.236996411004
    ],
    [
        113.10989589402,
        23.236995261452
    ],
    [
        113.10988099066,
        23.236987078904
    ],
    [
        113.10984927417,
        23.236984812077
    ],
    [
        113.10981783573,
        23.236974139172
    ],
    [
        113.10978693033,
        23.236974046373
    ],
    [
        113.10975819449,
        23.236972875993
    ],
    [
        113.10972431304,
        23.236965181984
    ],
    [
        113.10970831558,
        23.23696784742
    ],
    [
        113.10969124055,
        23.236962373348
    ],
    [
        113.10967768318,
        23.236964775094
    ],
    [
        113.10965546115,
        23.236954404761
    ],
    [
        113.10946030301,
        23.236903415637
    ],
    [
        113.10922338762,
        23.236848018176
    ],
    [
        113.1090723949,
        23.236814024511
    ],
    [
        113.10896477747,
        23.236784216104
    ],
    [
        113.10887558898,
        23.236762594444
    ],
    [
        113.10877555522,
        23.236738245596
    ],
    [
        113.10874193635,
        23.236733295051
    ],
    [
        113.10874139822,
        23.236728412001
    ],
    [
        113.10873627646,
        23.236693143053
    ],
    [
        113.10873310614,
        23.236595768731
    ],
    [
        113.1087076434,
        23.2365656123
    ],
    [
        113.1085804118,
        23.236632628757
    ],
    [
        113.10859989455,
        23.236680400153
    ],
    [
        113.10859256435,
        23.236690692658
    ],
    [
        113.10859011576,
        23.236700180738
    ],
    [
        113.1085703232,
        23.236697431432
    ],
    [
        113.10830084649,
        23.23661939347
    ],
    [
        113.10805225649,
        23.236519754083
    ],
    [
        113.10791617745,
        23.236449870802
    ],
    [
        113.10792087342,
        23.236350881685
    ],
    [
        113.10792447098,
        23.236267893178
    ],
    [
        113.10795060777,
        23.236150759988
    ],
    [
        113.10795468942,
        23.236135034568
    ],
    [
        113.10784712163,
        23.235714783218
    ],
    [
        113.10783899328,
        23.235706094561
    ],
    [
        113.10772638132,
        23.23547054962
    ],
    [
        113.10780631231,
        23.235250410285
    ],
    [
        113.10781743988,
        23.235241201807
    ],
    [
        113.10786520337,
        23.235205457851
    ],
    [
        113.10798749382,
        23.235227038996
    ],
    [
        113.10807290714,
        23.235240445126
    ],
    [
        113.10815804328,
        23.235259010754
    ],
    [
        113.10818569942,
        23.235264205238
    ],
    [
        113.10825590164,
        23.235302012641
    ],
    [
        113.10827837869,
        23.235336492885
    ],
    [
        113.10831951096,
        23.235433655217
    ],
    [
        113.10837151592,
        23.235501817062
    ],
    [
        113.10845660901,
        23.235563529917
    ],
    [
        113.10851623845,
        23.235594555346
    ],
    [
        113.10859375796,
        23.235632398134
    ],
    [
        113.1086276649,
        23.235619172937
    ],
    [
        113.10867708134,
        23.235545497491
    ],
    [
        113.10872157659,
        23.235516836654
    ],
    [
        113.10880482624,
        23.235510768736
    ],
    [
        113.10891437262,
        23.235508290151
    ],
    [
        113.10896779769,
        23.235497559374
    ],
    [
        113.10902315378,
        23.235449136324
    ],
    [
        113.10901562283,
        23.235380772209
    ],
    [
        113.10903253928,
        23.235262559847
    ],
    [
        113.1090475432,
        23.235160887685
    ],
    [
        113.10904493997,
        23.235040732293
    ],
    [
        113.10904694966,
        23.234917061779
    ],
    [
        113.10905187363,
        23.234869067677
    ],
    [
        113.10905542498,
        23.234839784422
    ],
    [
        113.10910478128,
        23.234829593444
    ],
    [
        113.10913569019,
        23.234830209215
    ],
    [
        113.10913656096,
        23.234767017688
    ],
    [
        113.10910633583,
        23.234610996143
    ],
    [
        113.1091155839,
        23.234578743192
    ],
    [
        113.10918284981,
        23.234551782888
    ],
    [
        113.10936318315,
        23.234515350643
    ],
    [
        113.10971134428,
        23.234460439788
    ],
    [
        113.10991957426,
        23.234433131769
    ],
    [
        113.11003697787,
        23.234410449572
    ],
    [
        113.11016523687,
        23.234371814344
    ],
    [
        113.11036184146,
        23.234291935979
    ],
    [
        113.11042585393,
        23.23424876805
    ],
    [
        113.11048828308,
        23.2341581352
    ],
    [
        113.11055905843,
        23.234128289246
    ],
    [
        113.11075725045,
        23.234075338186
    ],
    [
        113.11092238135,
        23.234007914867
    ],
    [
        113.11099396697,
        23.233975116811
    ],
    [
        113.11109078766,
        23.233910424963
    ],
    [
        113.11118162336,
        23.233867955867
    ],
    [
        113.11127836412,
        23.233885729948
    ],
    [
        113.11142333423,
        23.233914847263
    ],
    [
        113.11151195589,
        23.233915790025
    ],
    [
        113.1115547804,
        23.233911104115
    ],
    [
        113.1116829834,
        23.233894342857
    ],
    [
        113.11204272161,
        23.233760216285
    ],
    [
        113.11214435245,
        23.233748256553
    ],
    [
        113.11220397651,
        23.233739613561
    ],
    [
        113.112351691,
        23.233705130028
    ],
    [
        113.11248207246,
        23.233657010924
    ],
    [
        113.11260974205,
        23.233608078257
    ],
    [
        113.11273715048,
        23.233545597752
    ],
    [
        113.11283962892,
        23.233482988182
    ],
    [
        113.11290794552,
        23.233442700102
    ],
    [
        113.11300199146,
        23.233412331076
    ],
    [
        113.11303369718,
        23.233406280156
    ],
    [
        113.11305862191,
        23.233408055125
    ],
    [
        113.11310495678,
        23.233403177986
    ],
    [
        113.11314885899,
        23.233391778908
    ],
    [
        113.11331715584,
        23.233339374026
    ],
    [
        113.1133867513,
        23.233373435863
    ],
    [
        113.11340490118,
        23.233375447479
    ],
    [
        113.11342955333,
        23.233377228858
    ],
    [
        113.113461263,
        23.233364409446
    ],
    [
        113.11351760509,
        23.233373715291
    ],
    [
        113.11352004588,
        23.2333710186
    ],
    [
        113.11354497123,
        23.233369820816
    ],
    [
        113.11354741098,
        23.233368209042
    ],
    [
        113.11360810388,
        23.233359375534
    ],
    [
        113.11362815018,
        23.233360589207
    ],
    [
        113.11363518947,
        23.2333652452
    ],
    [
        113.11366798391,
        23.233349997543
    ],
    [
        113.11368750197,
        23.23333656315
    ],
    [
        113.11375797501,
        23.233296882365
    ],
    [
        113.11377776573,
        23.233281281559
    ],
    [
        113.11382762171,
        23.233270761253
    ],
    [
        113.11392679518,
        23.233244841605
    ],
    [
        113.11397041215,
        23.23324187978
    ],
    [
        113.11403462745,
        23.233227396908
    ],
    [
        113.11414299099,
        23.233218916045
    ],
    [
        113.11416981669,
        23.233210421995
    ],
    [
        113.11425053982,
        23.233210439617
    ],
    [
        113.11435292079,
        23.23322227786
    ],
    [
        113.11445014391,
        23.233244123245
    ],
    [
        113.11456279573,
        23.233275580908
    ],
    [
        113.11465757577,
        23.233299324373
    ],
    [
        113.11467219989,
        23.233301872477
    ],
    [
        113.11476563076,
        23.23331829193
    ],
    [
        113.11493221126,
        23.233311944498
    ],
    [
        113.11505492208,
        23.233293350253
    ],
    [
        113.11523963468,
        23.233292880624
    ],
    [
        113.11537317258,
        23.233273861458
    ],
    [
        113.11545767929,
        23.233264499175
    ],
    [
        113.11552540245,
        23.233246057438
    ],
    [
        113.11557442747,
        23.233239130365
    ],
    [
        113.11559961699,
        23.233235537464
    ],
    [
        113.11564566013,
        23.233231030056
    ],
    [
        113.1157036181,
        23.233227164494
    ],
    [
        113.11572447155,
        23.233226250822
    ],
    [
        113.11572718298,
        23.233222747291
    ],
    [
        113.11573692983,
        23.233225268403
    ],
    [
        113.11575399286,
        23.233223239191
    ],
    [
        113.11580381635,
        23.233229075226
    ],
    [
        113.11596442192,
        23.233209803839
    ],
    [
        113.11610850867,
        23.233186344355
    ],
    [
        113.11617756167,
        23.233185579587
    ],
    [
        113.11618704237,
        23.233182406477
    ],
    [
        113.11619169582,
        23.233129559244
    ],
    [
        113.11618629442,
        23.233114324654
    ],
    [
        113.11619091068,
        23.233100803523
    ],
    [
        113.11619443504,
        23.23309649438
    ],
    [
        113.1161987746,
        23.233089208882
    ],
    [
        113.11620557233,
        23.233059704809
    ],
    [
        113.1162023401,
        23.233041505458
    ],
    [
        113.11620751442,
        23.233010631339
    ],
    [
        113.11620319699,
        23.232994592372
    ],
    [
        113.11619808859,
        23.232956035642
    ],
    [
        113.11619107851,
        23.232923971774
    ],
    [
        113.11619434448,
        23.232906642021
    ],
    [
        113.11619220243,
        23.232881129246
    ],
    [
        113.1161960242,
        23.232848887381
    ],
    [
        113.11620690483,
        23.232797449964
    ],
    [
        113.1162158667,
        23.232770405574
    ],
    [
        113.11621969137,
        23.232735180441
    ],
    [
        113.11622352669,
        23.232688835551
    ],
    [
        113.11623060319,
        23.232651197581
    ],
    [
        113.11623389129,
        23.232610814768
    ],
    [
        113.11622742693,
        23.232574687206
    ],
    [
        113.11623153057,
        23.232531056846
    ],
    [
        113.11622912209,
        23.232501202285
    ],
    [
        113.11622401564,
        23.232461018241
    ],
    [
        113.11622782827,
        23.232438540219
    ],
    [
        113.11622028218,
        23.232401047303
    ],
    [
        113.11621572337,
        23.232354630067
    ],
    [
        113.11621331863,
        23.232320978568
    ],
    [
        113.11620383583,
        23.232326321179
    ],
    [
        113.11620711766,
        23.232292718683
    ],
    [
        113.11620848988,
        23.232273745398
    ],
    [
        113.11620875963,
        23.232274832586
    ],
    [
        113.11627185789,
        23.23227022479
    ],
    [
        113.11637744805,
        23.232286875109
    ],
    [
        113.11639342825,
        23.232282675651
    ],
    [
        113.11648655905,
        23.232300853481
    ],
    [
        113.11650307503,
        23.232302355719
    ],
    [
        113.11655829978,
        23.232316406834
    ],
    [
        113.11657538034,
        23.23229377685
    ],
    [
        113.11658929006,
        23.232189754043
    ],
    [
        113.11660161046,
        23.232049374323
    ],
    [
        113.11662534297,
        23.231868414602
    ],
    [
        113.11665018067,
        23.2316652257
    ],
    [
        113.11677445187,
        23.230848091517
    ],
    [
        113.11679015341,
        23.230850946245
    ],
    [
        113.11684918219,
        23.23084850068
    ],
    [
        113.1171137073,
        23.230852029858
    ],
    [
        113.11714944562,
        23.230852635593
    ],
    [
        113.11733354056,
        23.230864138575
    ],
    [
        113.11733706336,
        23.230860917541
    ],
    [
        113.11746241771,
        23.230858049308
    ],
    [
        113.11776700206,
        23.230842845083
    ],
    [
        113.11784983915,
        23.230846105529
    ],
    [
        113.11791860747,
        23.230839738322
    ],
    [
        113.11796733233,
        23.230843480029
    ],
    [
        113.11823146855,
        23.230918838262
    ],
    [
        113.11850430958,
        23.230939826532
    ],
    [
        113.11864082993,
        23.230844704658
    ],
    [
        113.11870047557,
        23.230748239163
    ],
    [
        113.1187165763,
        23.230616327856
    ],
    [
        113.11872260431,
        23.230542621245
    ],
    [
        113.11866065627,
        23.23050399641
    ],
    [
        113.1185854463,
        23.230463065585
    ],
    [
        113.11842416652,
        23.230410937808
    ],
    [
        113.11839009437,
        23.230375327121
    ],
    [
        113.11838538317,
        23.230213092062
    ],
    [
        113.11844170703,
        23.229922119909
    ],
    [
        113.11847084031,
        23.229752913653
    ],
    [
        113.11851451236,
        23.229662240641
    ],
    [
        113.11852644243,
        23.229642566543
    ],
    [
        113.11854302472,
        23.229572495343
    ],
    [
        113.11856372474,
        23.229445241284
    ],
    [
        113.11858139227,
        23.229372741028
    ],
    [
        113.11858413238,
        23.22933968164
    ],
    [
        113.11859561732,
        23.229224264942
    ],
    [
        113.11859672626,
        23.229198240035
    ],
    [
        113.11859807313,
        23.22920476331
    ],
    [
        113.1186043715,
        23.229132686516
    ],
    [
        113.11862210341,
        23.228996452238
    ],
    [
        113.11863845163,
        23.2288903084
    ],
    [
        113.11866484199,
        23.22875769171
    ],
    [
        113.11867977384,
        23.228713912654
    ],
    [
        113.11870097768,
        23.228624364949
    ],
    [
        113.11871590703,
        23.228583027204
    ],
    [
        113.11873658322,
        23.228479913809
    ],
    [
        113.11877227264,
        23.228252744369
    ],
    [
        113.11882042872,
        23.228010520876
    ],
    [
        113.11881311967,
        23.22801125659
    ],
    [
        113.1186780559,
        23.228005484398
    ],
    [
        113.11866451937,
        23.22800778248
    ],
    [
        113.11849508455,
        23.227992445615
    ],
    [
        113.11836136511,
        23.227989160722
    ],
    [
        113.11832995738,
        23.227995888614
    ],
    [
        113.11830016402,
        23.22801212631
    ],
    [
        113.11829203623,
        23.228018823197
    ],
    [
        113.118260092,
        23.228020394204
    ],
    [
        113.11822164834,
        23.228024340537
    ],
    [
        113.11821596254,
        23.22802536735
    ],
    [
        113.11819674336,
        23.228024628918
    ],
    [
        113.11814043705,
        23.228024327529
    ],
    [
        113.11804380187,
        23.228016841371
    ],
    [
        113.11793714639,
        23.228011703193
    ],
    [
        113.11781667704,
        23.228011861304
    ],
    [
        113.11774411726,
        23.228018196757
    ],
    [
        113.1176593738,
        23.228024688382
    ],
    [
        113.11763934185,
        23.228022865456
    ],
    [
        113.11764095848,
        23.228030475207
    ],
    [
        113.11739541841,
        23.22801616898
    ],
    [
        113.11735981962,
        23.227879679852
    ],
    [
        113.11715602579,
        23.227272947129
    ],
    [
        113.11708451792,
        23.227036865785
    ],
    [
        113.11703349456,
        23.226891021173
    ],
    [
        113.1169921958,
        23.22676696557
    ],
    [
        113.11689419352,
        23.226490239847
    ],
    [
        113.1168928536,
        23.226476666924
    ],
    [
        113.11673085929,
        23.226023080948
    ],
    [
        113.11673708411,
        23.226025849335
    ],
    [
        113.11671818633,
        23.225971164874
    ],
    [
        113.11670927077,
        23.225951828337
    ],
    [
        113.11653623714,
        23.225432534986
    ],
    [
        113.11649791785,
        23.225304454219
    ],
    [
        113.11641696016,
        23.225034426494
    ],
    [
        113.11642075052,
        23.225035002205
    ],
    [
        113.11641371691,
        23.225028431342
    ],
    [
        113.11642322691,
        23.224996511754
    ],
    [
        113.11641566951,
        23.224972578663
    ],
    [
        113.1164070348,
        23.224942940702
    ],
    [
        113.11638194292,
        23.224854034289
    ],
    [
        113.11624534143,
        23.22444656975
    ],
    [
        113.11622941953,
        23.224393003378
    ],
    [
        113.11622807999,
        23.224378888759
    ],
    [
        113.11621862982,
        23.224351957217
    ],
    [
        113.11620188329,
        23.224310317458
    ],
    [
        113.11612819014,
        23.224081595663
    ],
    [
        113.11608445129,
        23.223954023951
    ],
    [
        113.11607826033,
        23.223917357564
    ],
    [
        113.11604556841,
        23.223844123787
    ],
    [
        113.11604208452,
        23.223808294167
    ],
    [
        113.11589305603,
        23.223361709071
    ],
    [
        113.11588765346,
        23.223348374539
    ],
    [
        113.1158719865,
        23.223309189231
    ],
    [
        113.11585714375,
        23.223258348823
    ],
    [
        113.11585201084,
        23.223246101545
    ],
    [
        113.11584526631,
        23.223220822671
    ],
    [
        113.11584608065,
        23.223218930947
    ],
    [
        113.11583931987,
        23.223209653538
    ],
    [
        113.11584018181,
        23.223160842351
    ],
    [
        113.11584847451,
        23.222994657642
    ],
    [
        113.11588961602,
        23.222747925124
    ],
    [
        113.1158894639,
        23.222630488518
    ],
    [
        113.1158938759,
        23.222552144706
    ],
    [
        113.11589160091,
        23.222391296197
    ],
    [
        113.11589370082,
        23.222188446072
    ],
    [
        113.11595824225,
        23.221829086186
    ],
    [
        113.11599366991,
        23.221605904206
    ],
    [
        113.11597071866,
        23.221538992312
    ],
    [
        113.11568826894,
        23.221535564466
    ],
    [
        113.11568720547,
        23.221515757159
    ],
    [
        113.11569590668,
        23.221480570543
    ],
    [
        113.11569811162,
        23.221442076221
    ],
    [
        113.11566562922,
        23.22142662277
    ],
    [
        113.11534873021,
        23.221462591278
    ],
    [
        113.11534470513,
        23.221425132002
    ],
    [
        113.11522338269,
        23.221414145843
    ],
    [
        113.11515194126,
        23.221354195658
    ],
    [
        113.11511649604,
        23.221319206841
    ],
    [
        113.11502340792,
        23.221236858381
    ],
    [
        113.11386367201,
        23.221637583028
    ],
    [
        113.1121710305,
        23.222247881985
    ],
    [
        113.11105135829,
        23.222643000919
    ],
    [
        113.1110212621,
        23.222653725503
    ],
    [
        113.11101261816,
        23.222624670376
    ],
    [
        113.11101017552,
        23.22262791492
    ],
    [
        113.11097990637,
        23.222541274781
    ],
    [
        113.11101277831,
        23.222466011934
    ],
    [
        113.11102447867,
        23.222420767477
    ],
    [
        113.11113189478,
        23.222336053099
    ],
    [
        113.11101220076,
        23.222232224625
    ],
    [
        113.11094231963,
        23.222184749773
    ],
    [
        113.11092494365,
        23.222213699582
    ],
    [
        113.11084762353,
        23.222284991867
    ],
    [
        113.11081314299,
        23.222341810941
    ],
    [
        113.11080473335,
        23.222348829577
    ],
    [
        113.11073093483,
        23.222420415006
    ],
    [
        113.11071033773,
        23.222417352793
    ],
    [
        113.11071494374,
        23.222419268884
    ],
    [
        113.11067348073,
        23.222410703517
    ],
    [
        113.11055233514,
        23.222392351467
    ],
    [
        113.11050760524,
        23.222396527335
    ],
    [
        113.11045826519,
        23.22240231574
    ],
    [
        113.11035740528,
        23.222423655223
    ],
    [
        113.1102874495,
        23.222441855153
    ],
    [
        113.11022371615,
        23.222471471448
    ],
    [
        113.11020229673,
        23.222475467525
    ],
    [
        113.11015594232,
        23.2224747705
    ],
    [
        113.11006459868,
        23.222462538285
    ],
    [
        113.11002418625,
        23.222482478173
    ],
    [
        113.10998350598,
        23.222498892955
    ],
    [
        113.10994935572,
        23.222491462993
    ],
    [
        113.10991871469,
        23.222498690403
    ],
    [
        113.10986639969,
        23.22249202058
    ],
    [
        113.1097994368,
        23.222493174564
    ],
    [
        113.10980567568,
        23.222489667463
    ],
    [
        113.10979781977,
        23.22248367732
    ],
    [
        113.10967012061,
        23.222492253561
    ],
    [
        113.10957713317,
        23.222488736299
    ],
    [
        113.1094648912,
        23.222488700991
    ],
    [
        113.10939250792,
        23.222482814028
    ],
    [
        113.10930928382,
        23.222471751328
    ],
    [
        113.10920734764,
        23.222463361283
    ],
    [
        113.10911461773,
        23.222465308524
    ],
    [
        113.10906580344,
        23.222474687021
    ],
    [
        113.10905441123,
        23.222479000139
    ],
    [
        113.10905549688,
        23.222477917791
    ],
    [
        113.10902837879,
        23.222481923892
    ],
    [
        113.10895244523,
        23.222495314276
    ],
    [
        113.10887488559,
        23.222506808034
    ],
    [
        113.10881550267,
        23.22250776775
    ],
    [
        113.10862212298,
        23.222552132782
    ],
    [
        113.10848244289,
        23.222581709579
    ],
    [
        113.10847858489,
        23.222642725331
    ],
    [
        113.10847342803,
        23.222647326821
    ],
    [
        113.10846930677,
        23.222700477002
    ],
    [
        113.10846763123,
        23.222748478474
    ],
    [
        113.10846302053,
        23.222749284013
    ],
    [
        113.10841501643,
        23.222755981186
    ],
    [
        113.10841528651,
        23.222757066494
    ],
    [
        113.10829757157,
        23.222781551933
    ],
    [
        113.10811014958,
        23.222815440928
    ],
    [
        113.10791919642,
        23.222848273247
    ],
    [
        113.10763329168,
        23.22290192509
    ],
    [
        113.10750416716,
        23.222927299674
    ],
    [
        113.10735225397,
        23.222955113947
    ],
    [
        113.10731293745,
        23.222943695402
    ],
    [
        113.10729910695,
        23.222941516318
    ],
    [
        113.10727985015,
        23.22294096111
    ],
    [
        113.10719088572,
        23.222940906516
    ],
    [
        113.10708481927,
        23.22295305554
    ],
    [
        113.10695759809,
        23.222960596716
    ],
    [
        113.10691058415,
        23.223047368522
    ],
    [
        113.10690569533,
        23.223053604859
    ],
    [
        113.10689483047,
        23.223068246963
    ],
    [
        113.10687501787,
        23.223079360906
    ],
    [
        113.10681609873,
        23.223135757955
    ],
    [
        113.10679980444,
        23.223154467976
    ],
    [
        113.10677943878,
        23.22317561836
    ],
    [
        113.10670506661,
        23.223222255067
    ],
    [
        113.10661521504,
        23.223284897656
    ],
    [
        113.1064873413,
        23.223389587824
    ],
    [
        113.10637330121,
        23.223492663212
    ],
    [
        113.10632875993,
        23.223543388866
    ],
    [
        113.10632136448,
        23.223613091688
    ],
    [
        113.10632161259,
        23.223635873312
    ],
    [
        113.10631528235,
        23.223725103071
    ],
    [
        113.10634667047,
        23.223804018195
    ],
    [
        113.10640676921,
        23.223926594247
    ],
    [
        113.10647825593,
        23.224053783153
    ],
    [
        113.10647445839,
        23.224053512289
    ],
    [
        113.10650964875,
        23.224127007612
    ],
    [
        113.10651344266,
        23.224130804336
    ],
    [
        113.10663395765,
        23.22432580454
    ],
    [
        113.10664235327,
        23.224339094349
    ],
    [
        113.1066472183,
        23.224356452133
    ],
    [
        113.10668947238,
        23.224418020592
    ],
    [
        113.10674768993,
        23.224519189891
    ],
    [
        113.10683353679,
        23.224657524486
    ],
    [
        113.10687443444,
        23.224717743847
    ],
    [
        113.10690933959,
        23.224802100605
    ],
    [
        113.10693801992,
        23.22487262464
    ],
    [
        113.10696753683,
        23.224920639287
    ],
    [
        113.10697373863,
        23.224956712558
    ],
    [
        113.10699239554,
        23.225014487475
    ],
    [
        113.10701559975,
        23.225134642963
    ],
    [
        113.10699381002,
        23.225222777589
    ],
    [
        113.10698591504,
        23.225250980407
    ],
    [
        113.10688719167,
        23.225505342329
    ],
    [
        113.10685343298,
        23.22562602158
    ],
    [
        113.10686942243,
        23.225640128807
    ],
    [
        113.10686697811,
        23.225643111449
    ],
    [
        113.10687023591,
        23.225640400242
    ],
    [
        113.10690849837,
        23.225624681307
    ],
    [
        113.10693835601,
        23.225604892689
    ],
    [
        113.10698666712,
        23.225576433111
    ],
    [
        113.10705259746,
        23.225558831832
    ],
    [
        113.10709299798,
        23.225572953555
    ],
    [
        113.10712469915,
        23.225606057023
    ],
    [
        113.10697921973,
        23.225697390081
    ],
    [
        113.10675581543,
        23.225857614118
    ],
    [
        113.10675472707,
        23.225860868457
    ],
    [
        113.10673246918,
        23.225875239063
    ],
    [
        113.10669366209,
        23.225891777821
    ],
    [
        113.10658779796,
        23.225961472148
    ],
    [
        113.10647323712,
        23.226044738166
    ],
    [
        113.10640293079,
        23.22609003906
    ],
    [
        113.10603887056,
        23.226350791013
    ],
    [
        113.10603046207,
        23.226349167955
    ],
    [
        113.1059463119,
        23.226396132986
    ],
    [
        113.10580408383,
        23.226459959521
    ],
    [
        113.10561382684,
        23.226526016221
    ],
    [
        113.10555982343,
        23.226536914076
    ],
    [
        113.10544558777,
        23.226545706326
    ],
    [
        113.10519296461,
        23.226558747248
    ],
    [
        113.10481904677,
        23.226559291055
    ],
    [
        113.10464727444,
        23.226559584255
    ],
    [
        113.10464615876,
        23.226589148116
    ],
    [
        113.10464692076,
        23.226640134198
    ],
    [
        113.10470389223,
        23.226654950454
    ],
    [
        113.10481511752,
        23.226686766085
    ],
    [
        113.10514826264,
        23.226756788699
    ],
    [
        113.10506884995,
        23.226933725522
    ],
    [
        113.1050038683,
        23.227061015651
    ],
    [
        113.10500277738,
        23.22706644144
    ],
    [
        113.1050019578,
        23.227071866834
    ],
    [
        113.10498975402,
        23.227065104442
    ],
    [
        113.10476971275,
        23.227038600303
    ],
    [
        113.10467692079,
        23.227024927789
    ],
    [
        113.1046668847,
        23.227020606126
    ],
    [
        113.10455618432,
        23.227003178842
    ],
    [
        113.10438715598,
        23.226965538763
    ],
    [
        113.10420049024,
        23.226919827406
    ],
    [
        113.10409194764,
        23.226905968554
    ],
    [
        113.10404881472,
        23.226887355081
    ],
    [
        113.10399806979,
        23.226880965886
    ],
    [
        113.10383391145,
        23.226840959552
    ],
    [
        113.10379901763,
        23.226725513305
    ],
    [
        113.10375189538,
        23.226624474167
    ],
    [
        113.10375353189,
        23.226616604817
    ],
    [
        113.10367951498,
        23.226539234587
    ],
    [
        113.10367299904,
        23.226541150524
    ],
    [
        113.10362881697,
        23.226483502377
    ],
    [
        113.10349920406,
        23.226359649288
    ],
    [
        113.10336416797,
        23.22622742022
    ],
    [
        113.10326439911,
        23.226111100791
    ],
    [
        113.10310711885,
        23.225959173537
    ],
    [
        113.1030097594,
        23.225871075438
    ],
    [
        113.1029709851,
        23.225828895103
    ],
    [
        113.10296421182,
        23.225816170821
    ],
    [
        113.10292079249,
        23.225803298361
    ],
    [
        113.10277619177,
        23.225718907099
    ],
    [
        113.10267661848,
        23.22566610356
    ],
    [
        113.1025290585,
        23.225548939162
    ],
    [
        113.10232588659,
        23.22538671886
    ],
    [
        113.10212628107,
        23.2251808567
    ],
    [
        113.10210810499,
        23.2251670996
    ],
    [
        113.10207094814,
        23.225129826103
    ],
    [
        113.10170046482,
        23.224744136749
    ],
    [
        113.10160770255,
        23.224649361614
    ],
    [
        113.10155156104,
        23.224587241018
    ],
    [
        113.10152847755,
        23.224591144633
    ],
    [
        113.10149887372,
        23.224598604801
    ],
    [
        113.10146572212,
        23.224623439757
    ],
    [
        113.10133615186,
        23.22467260114
    ],
    [
        113.10131605048,
        23.22468029174
    ],
    [
        113.10125411082,
        23.224709069067
    ],
    [
        113.10125058386,
        23.224706102976
    ],
    [
        113.1011910962,
        23.224726193129
    ],
    [
        113.10114439739,
        23.224719915469
    ],
    [
        113.10104557506,
        23.224700070785
    ],
    [
        113.10099101607,
        23.224678109204
    ],
    [
        113.10092566859,
        23.224583522004
    ],
    [
        113.10090397375,
        23.224554615011
    ],
    [
        113.10091216061,
        23.224515247271
    ],
    [
        113.10091680752,
        23.224485390223
    ],
    [
        113.10102959093,
        23.224397753869
    ],
    [
        113.10111680687,
        23.224349310432
    ],
    [
        113.10114886996,
        23.224328809903
    ],
    [
        113.10118825952,
        23.22431315586
    ],
    [
        113.10121136797,
        23.224286192334
    ],
    [
        113.10129244519,
        23.224130393916
    ],
    [
        113.10162821216,
        23.223974499946
    ],
    [
        113.10178954293,
        23.223924689756
    ],
    [
        113.10181752162,
        23.223911820203
    ],
    [
        113.10186912531,
        23.223895051945
    ],
    [
        113.10206929207,
        23.223826672713
    ],
    [
        113.10217031502,
        23.22380022229
    ],
    [
        113.10225478327,
        23.22376598176
    ],
    [
        113.10226511033,
        23.223755634755
    ],
    [
        113.10226242968,
        23.22372201543
    ],
    [
        113.10225647763,
        23.223701698383
    ],
    [
        113.10223977276,
        23.223576466188
    ],
    [
        113.10219463968,
        23.22337405383
    ],
    [
        113.10219329324,
        23.223363210881
    ],
    [
        113.10219168687,
        23.223340978181
    ],
    [
        113.102185719,
        23.223336120516
    ],
    [
        113.10220446902,
        23.223319229891
    ],
    [
        113.10226993883,
        23.223278829276
    ],
    [
        113.10232398151,
        23.223262072471
    ],
    [
        113.10235575954,
        23.223247845545
    ],
    [
        113.10242093537,
        23.223227795729
    ],
    [
        113.10242772018,
        23.223229939445
    ],
    [
        113.1024622044,
        23.223223570317
    ],
    [
        113.10252353645,
        23.223244765012
    ],
    [
        113.10260372101,
        23.223413431944
    ],
    [
        113.1027018028,
        23.223599940421
    ],
    [
        113.10274923112,
        23.223676524238
    ],
    [
        113.10276710935,
        23.223714159386
    ],
    [
        113.10288819818,
        23.223696383053
    ],
    [
        113.10293245375,
        23.223688096989
    ],
    [
        113.10296096607,
        23.223678509102
    ],
    [
        113.10311176669,
        23.223534274937
    ],
    [
        113.103222587,
        23.223463411304
    ],
    [
        113.10327118141,
        23.223456481519
    ],
    [
        113.10334367814,
        23.223433209603
    ],
    [
        113.10339663859,
        23.223402405887
    ],
    [
        113.10341021812,
        23.223394500957
    ],
    [
        113.10341754287,
        23.223398276473
    ],
    [
        113.10343004103,
        23.223386035592
    ],
    [
        113.10347266904,
        23.223372351892
    ],
    [
        113.10351286022,
        23.223352438933
    ],
    [
        113.10357315535,
        23.223313757921
    ],
    [
        113.10360411362,
        23.223297670951
    ],
    [
        113.10365761429,
        23.223266878398
    ],
    [
        113.10365788212,
        23.223270403404
    ],
    [
        113.1036695539,
        23.223269558311
    ],
    [
        113.10373576962,
        23.223278874533
    ],
    [
        113.10381933382,
        23.223308762318
    ],
    [
        113.10387955773,
        23.223336816092
    ],
    [
        113.10395741497,
        23.223371881746
    ],
    [
        113.10402660256,
        23.223390972034
    ],
    [
        113.10406404471,
        23.223401461433
    ],
    [
        113.10408167694,
        23.223409828048
    ],
    [
        113.10412074404,
        23.223423298959
    ],
    [
        113.10414053013,
        23.223448476652
    ],
    [
        113.10418501964,
        23.223466819434
    ],
    [
        113.10424363501,
        23.223471301698
    ],
    [
        113.10434537766,
        23.223497393886
    ],
    [
        113.10439808016,
        23.223443586584
    ],
    [
        113.10441519138,
        23.22342944924
    ],
    [
        113.10458188804,
        23.22309011533
    ],
    [
        113.1048446343,
        23.22275607237
    ],
    [
        113.10493109713,
        23.22258561664
    ],
    [
        113.10499896379,
        23.222556766784
    ],
    [
        113.10506140375,
        23.222526843966
    ],
    [
        113.10515510141,
        23.222443183325
    ],
    [
        113.1051505895,
        23.222343112535
    ],
    [
        113.10515248643,
        23.222345550921
    ],
    [
        113.1051139013,
        23.222130261276
    ],
    [
        113.10508990869,
        23.221974076666
    ],
    [
        113.10512710149,
        23.221955312389
    ],
    [
        113.1052321281,
        23.221937004944
    ],
    [
        113.10541068072,
        23.221920795229
    ],
    [
        113.10541610428,
        23.221923772687
    ],
    [
        113.10569532471,
        23.2218915048
    ],
    [
        113.10571626988,
        23.221837516821
    ],
    [
        113.10578370229,
        23.221690197287
    ],
    [
        113.1057995407,
        23.221587667845
    ],
    [
        113.10580638626,
        23.22152474188
    ],
    [
        113.10581101799,
        23.22150521135
    ],
    [
        113.10582031363,
        23.221433876163
    ],
    [
        113.1058241544,
        23.221391293266
    ],
    [
        113.10584190714,
        23.221273032755
    ],
    [
        113.10586451938,
        23.221178635891
    ],
    [
        113.10610024874,
        23.221207253893
    ],
    [
        113.10625512606,
        23.221235402334
    ],
    [
        113.10646073009,
        23.221260583058
    ],
    [
        113.10663465196,
        23.221221794972
    ],
    [
        113.10656480181,
        23.221084560333
    ],
    [
        113.10609839304,
        23.220890479344
    ],
    [
        113.10551424087,
        23.220644909134
    ],
    [
        113.10550773342,
        23.220640576196
    ],
    [
        113.1054540327,
        23.220618933996
    ],
    [
        113.10502167233,
        23.220467322434
    ],
    [
        113.1047888968,
        23.220421035564
    ],
    [
        113.10400419787,
        23.220288644788
    ],
    [
        113.10338274153,
        23.220202432056
    ],
    [
        113.10306303331,
        23.220154334539
    ],
    [
        113.10263222129,
        23.220162327593
    ],
    [
        113.10248745447,
        23.220235548843
    ],
    [
        113.10245105241,
        23.220260095786
    ],
    [
        113.10231083558,
        23.220394616644
    ],
    [
        113.10230296033,
        23.220396817326
    ],
    [
        113.10223717227,
        23.220486306936
    ],
    [
        113.10206823572,
        23.220555069295
    ],
    [
        113.10165864201,
        23.220442122644
    ],
    [
        113.10132151028,
        23.22033656874
    ],
    [
        113.10092074804,
        23.220298433119
    ],
    [
        113.10070160026,
        23.22029741937
    ],
    [
        113.10045232257,
        23.220272207131
    ],
    [
        113.10028234167,
        23.22024252342
    ],
    [
        113.1001807775,
        23.220232533766
    ],
    [
        113.10020736079,
        23.219988560301
    ],
    [
        113.10021306605,
        23.219986628707
    ],
    [
        113.10019158306,
        23.219736425474
    ],
    [
        113.10018267043,
        23.219685218416
    ],
    [
        113.10017539362,
        23.219627492795
    ],
    [
        113.1001729622,
        23.219614217618
    ],
    [
        113.10011667771,
        23.219401103961
    ],
    [
        113.10006598595,
        23.219301326324
    ],
    [
        113.10006354078,
        23.219302154465
    ],
    [
        113.09996556483,
        23.219228427897
    ],
    [
        113.09990466053,
        23.219296056615
    ],
    [
        113.099885355,
        23.219318413361
    ],
    [
        113.0997830995,
        23.219453832702
    ],
    [
        113.09963442892,
        23.219554837725
    ],
    [
        113.09958332906,
        23.219591503432
    ],
    [
        113.0995564348,
        23.219595471491
    ],
    [
        113.09948503002,
        23.219562569783
    ],
    [
        113.09945191577,
        23.219537831898
    ],
    [
        113.09942829544,
        23.219526322722
    ],
    [
        113.09932187752,
        23.219463554145
    ],
    [
        113.09926866463,
        23.219435428075
    ],
    [
        113.09906016266,
        23.219314239735
    ],
    [
        113.09889365095,
        23.219305077913
    ],
    [
        113.09873689901,
        23.219311600892
    ],
    [
        113.09870239812,
        23.219311574317
    ],
    [
        113.09860675869,
        23.219325818325
    ],
    [
        113.09829400531,
        23.219385061603
    ],
    [
        113.09812794257,
        23.219450587448
    ],
    [
        113.09808197017,
        23.21950924765
    ],
    [
        113.09809280945,
        23.219538455831
    ],
    [
        113.09810065455,
        23.219573382329
    ],
    [
        113.09810661965,
        23.219585812651
    ],
    [
        113.09810334433,
        23.219601296606
    ],
    [
        113.09810979664,
        23.219671491198
    ],
    [
        113.09811000551,
        23.219736037836
    ],
    [
        113.09809067973,
        23.219772798431
    ],
    [
        113.09803171245,
        23.219783284033
    ],
    [
        113.09790453827,
        23.219804335743
    ],
    [
        113.09783931675,
        23.21981813397
    ],
    [
        113.09775725896,
        23.219821491356
    ],
    [
        113.09757437964,
        23.219840578224
    ],
    [
        113.09744421375,
        23.219854379798
    ],
    [
        113.09726948882,
        23.219860970387
    ],
    [
        113.09718062261,
        23.219871745931
    ],
    [
        113.09716350545,
        23.219869719667
    ],
    [
        113.09704937621,
        23.219870139613
    ],
    [
        113.09701677312,
        23.219864449842
    ],
    [
        113.09698742496,
        23.219864699802
    ],
    [
        113.09695944304,
        23.219857073668
    ],
    [
        113.09691952481,
        23.219828396141
    ],
    [
        113.09691032034,
        23.219792675377
    ],
    [
        113.0969481445,
        23.219739464897
    ],
    [
        113.09704096988,
        23.219572963885
    ],
    [
        113.09704967163,
        23.219566652224
    ],
    [
        113.09714272992,
        23.219438126339
    ],
    [
        113.0972366001,
        23.219311227937
    ],
    [
        113.09732746591,
        23.219198464436
    ],
    [
        113.09735358621,
        23.219162449257
    ],
    [
        113.09743820477,
        23.219045134756
    ],
    [
        113.09751493187,
        23.218938467209
    ],
    [
        113.097641975,
        23.218779057295
    ],
    [
        113.09767625069,
        23.218737017146
    ],
    [
        113.09768142072,
        23.218729110827
    ],
    [
        113.09769148544,
        23.218717097414
    ],
    [
        113.09769692017,
        23.218716511779
    ],
    [
        113.09770317287,
        23.21871293634
    ],
    [
        113.09771160288,
        23.218705546683
    ],
    [
        113.09771650195,
        23.218696829028
    ],
    [
        113.09772765653,
        23.218681552724
    ],
    [
        113.09786500507,
        23.218536729881
    ],
    [
        113.09795723535,
        23.218405831254
    ],
    [
        113.09805381067,
        23.218275177577
    ],
    [
        113.09817786814,
        23.218098217658
    ],
    [
        113.09826845429,
        23.217975762712
    ],
    [
        113.09836229836,
        23.217853832904
    ],
    [
        113.09841701037,
        23.217741689784
    ],
    [
        113.09847796529,
        23.217634656604
    ],
    [
        113.0985304821,
        23.217544231691
    ],
    [
        113.09860040595,
        23.217431172983
    ],
    [
        113.09864886233,
        23.217323424752
    ],
    [
        113.09871035838,
        23.21721504336
    ],
    [
        113.09878841326,
        23.217119024369
    ],
    [
        113.09885750221,
        23.217023073006
    ],
    [
        113.09892878398,
        23.216904599687
    ],
    [
        113.09907017464,
        23.216758259508
    ],
    [
        113.09917293481,
        23.216671048348
    ],
    [
        113.09937141191,
        23.216468763903
    ],
    [
        113.09946355171,
        23.216404700993
    ],
    [
        113.09962211398,
        23.216175324672
    ],
    [
        113.09966863472,
        23.216092582038
    ],
    [
        113.09970974515,
        23.215984651921
    ],
    [
        113.09974757701,
        23.215897627199
    ],
    [
        113.09976448922,
        23.215816428647
    ],
    [
        113.09978113417,
        23.215730078845
    ],
    [
        113.09981872596,
        23.215606172358
    ],
    [
        113.09984078642,
        23.215537961538
    ],
    [
        113.09986208692,
        23.215407104667
    ],
    [
        113.09990157595,
        23.215285901217
    ],
    [
        113.09991852443,
        23.215161038428
    ],
    [
        113.09994740816,
        23.21505319037
    ],
    [
        113.09995692629,
        23.215039300849
    ],
    [
        113.09997300166,
        23.214980621044
    ],
    [
        113.10000867084,
        23.214877073089
    ],
    [
        113.10004297098,
        23.214785739132
    ],
    [
        113.10006747966,
        23.214710194849
    ],
    [
        113.10012814118,
        23.214598365865
    ],
    [
        113.10017167355,
        23.214507523778
    ],
    [
        113.10024183706,
        23.214397814942
    ],
    [
        113.10028644999,
        23.214312124012
    ],
    [
        113.10034083001,
        23.214237499093
    ],
    [
        113.10040089814,
        23.214179931425
    ],
    [
        113.10052532337,
        23.214129060742
    ],
    [
        113.10063780235,
        23.214071488028
    ],
    [
        113.10076194847,
        23.214023085739
    ],
    [
        113.10093332644,
        23.213993708383
    ],
    [
        113.10108731934,
        23.213965258121
    ],
    [
        113.10115087928,
        23.213943242333
    ],
    [
        113.1012380614,
        23.213922470218
    ],
    [
        113.10138688358,
        23.213897612201
    ],
    [
        113.10143659061,
        23.213877306042
    ],
    [
        113.10144392306,
        23.213875915331
    ],
    [
        113.10160580719,
        23.213809528238
    ],
    [
        113.1017747619,
        23.213723605462
    ],
    [
        113.10187257276,
        23.213642353757
    ],
    [
        113.10189648472,
        23.213618925464
    ],
    [
        113.10199513439,
        23.213505134395
    ],
    [
        113.10205654702,
        23.213439783832
    ],
    [
        113.1021394194,
        23.213359160237
    ],
    [
        113.10221063317,
        23.213257705673
    ],
    [
        113.10229354513,
        23.213124747634
    ],
    [
        113.10234762436,
        23.213058357146
    ],
    [
        113.10240581004,
        23.212948557987
    ],
    [
        113.10245257151,
        23.212865113783
    ],
    [
        113.10248193764,
        23.212806960818
    ],
    [
        113.10251623325,
        23.212694545682
    ],
    [
        113.10256028734,
        23.212599724704
    ],
    [
        113.10261765142,
        23.21249400772
    ],
    [
        113.10267340973,
        23.212357651253
    ],
    [
        113.10269654454,
        23.212280811903
    ],
    [
        113.102723454,
        23.212236777533
    ],
    [
        113.10275255606,
        23.212165613726
    ],
    [
        113.10283082465,
        23.212052510704
    ],
    [
        113.10291285319,
        23.211989847994
    ],
    [
        113.10304241234,
        23.211890419529
    ],
    [
        113.10312172303,
        23.211827510024
    ],
    [
        113.10318799015,
        23.211781734237
    ],
    [
        113.10326213863,
        23.211722105759
    ],
    [
        113.10339928228,
        23.211630832731
    ],
    [
        113.10346364399,
        23.211587248982
    ],
    [
        113.10348890008,
        23.211569546715
    ],
    [
        113.10362142875,
        23.211470991626
    ],
    [
        113.10379874043,
        23.211367453974
    ],
    [
        113.10395594725,
        23.21128379336
    ],
    [
        113.10405071226,
        23.211221455937
    ],
    [
        113.10420764198,
        23.211134848785
    ],
    [
        113.10449869555,
        23.210955779339
    ],
    [
        113.10461843984,
        23.210860896085
    ],
    [
        113.10456072696,
        23.210738679945
    ],
    [
        113.1045393131,
        23.210704817096
    ],
    [
        113.10443986031,
        23.210507828742
    ],
    [
        113.10419646105,
        23.210079259112
    ],
    [
        113.10418343732,
        23.210074948412
    ],
    [
        113.1041774705,
        23.210069537167
    ],
    [
        113.10416283638,
        23.21003946366
    ],
    [
        113.10422612314,
        23.209963650647
    ],
    [
        113.10429019602,
        23.209926896466
    ],
    [
        113.10436539867,
        23.20988442727
    ],
    [
        113.10440720296,
        23.209867525768
    ],
    [
        113.10449972783,
        23.209888769652
    ],
    [
        113.10463350557,
        23.209900724093
    ],
    [
        113.10477161378,
        23.209924079357
    ],
    [
        113.10489316348,
        23.209950732923
    ],
    [
        113.10502394901,
        23.209958943193
    ],
    [
        113.10511539325,
        23.209957729387
    ],
    [
        113.10524725596,
        23.20996976244
    ],
    [
        113.10533054824,
        23.209980239866
    ],
    [
        113.10540054506,
        23.209989382166
    ],
    [
        113.1054350067,
        23.209985005062
    ],
    [
        113.10544776565,
        23.209975498485
    ],
    [
        113.10562825281,
        23.209891241663
    ],
    [
        113.10567765007,
        23.209865432047
    ],
    [
        113.10575310449,
        23.209822516759
    ],
    [
        113.10594418035,
        23.209710639241
    ],
    [
        113.10594363849,
        23.209709554649
    ],
    [
        113.10595856204,
        23.2097065623
    ],
    [
        113.1060255927,
        23.209677232457
    ],
    [
        113.10603346437,
        23.209671261334
    ],
    [
        113.10604106288,
        23.209668002697
    ],
    [
        113.10606847625,
        23.209649545539
    ],
    [
        113.10608584608,
        23.209639230588
    ],
    [
        113.10614663315,
        23.209613165947
    ],
    [
        113.10618163961,
        23.209598234556
    ],
    [
        113.10619927959,
        23.209589006247
    ],
    [
        113.10620171564,
        23.209597142249
    ],
    [
        113.10621447295,
        23.209587102264
    ],
    [
        113.10623509659,
        23.209578415969
    ],
    [
        113.10626359125,
        23.209564031853
    ],
    [
        113.10629914333,
        23.209543408296
    ],
    [
        113.10637974237,
        23.209500806672
    ],
    [
        113.10642777577,
        23.209475031653
    ],
    [
        113.10648368496,
        23.20943542527
    ],
    [
        113.10653008571,
        23.209415622018
    ],
    [
        113.10657269357,
        23.209387955146
    ],
    [
        113.10661774008,
        23.209363816008
    ],
    [
        113.10666631842,
        23.209330999647
    ],
    [
        113.10670051889,
        23.209298997554
    ],
    [
        113.10675615905,
        23.209251268338
    ],
    [
        113.1067976833,
        23.209218456794
    ],
    [
        113.10684192152,
        23.209182935178
    ],
    [
        113.1068807296,
        23.209154465867
    ],
    [
        113.10696322852,
        23.209095634504
    ],
    [
        113.10701207258,
        23.209065817308
    ],
    [
        113.10704517565,
        23.209048743352
    ],
    [
        113.10705413543,
        23.209035456898
    ],
    [
        113.10705548932,
        23.209038983485
    ],
    [
        113.10707368718,
        23.209001561715
    ],
    [
        113.10712988834,
        23.208918591935
    ],
    [
        113.10714318613,
        23.208907749482
    ],
    [
        113.10714835187,
        23.208889037222
    ],
    [
        113.10715134044,
        23.208881444315
    ],
    [
        113.10714728141,
        23.208866795718
    ],
    [
        113.10715083466,
        23.208825027977
    ],
    [
        113.10715845096,
        23.20879167055
    ],
    [
        113.10717230636,
        23.208757231616
    ],
    [
        113.10718643291,
        23.208722793
    ],
    [
        113.10722253988,
        23.208672093415
    ],
    [
        113.10724262913,
        23.208644168605
    ],
    [
        113.10724861139,
        23.20862057511
    ],
    [
        113.1072551215,
        23.208619765435
    ],
    [
        113.10725811288,
        23.208607561869
    ],
    [
        113.10726191083,
        23.208606479315
    ],
    [
        113.10726950863,
        23.208601330702
    ],
    [
        113.10726734311,
        23.208594548538
    ],
    [
        113.10727548666,
        23.208584246907
    ],
    [
        113.10730453191,
        23.208547378343
    ],
    [
        113.1073428101,
        23.208492615682
    ],
    [
        113.1073702366,
        23.208441372425
    ],
    [
        113.1073992919,
        23.208387418748
    ],
    [
        113.10739711884,
        23.208392570523
    ],
    [
        113.10741559137,
        23.208346203858
    ],
    [
        113.10742293199,
        23.208318272597
    ],
    [
        113.1074175235,
        23.208292772562
    ],
    [
        113.10742676924,
        23.208254264715
    ],
    [
        113.10744144072,
        23.208213591365
    ],
    [
        113.10745150737,
        23.208163150113
    ],
    [
        113.10745722628,
        23.208125724589
    ],
    [
        113.10746321868,
        23.208084502044
    ],
    [
        113.10747056946,
        23.208039483368
    ],
    [
        113.10747140783,
        23.207999341553
    ],
    [
        113.10746980131,
        23.207965436083
    ],
    [
        113.10747903945,
        23.207938320367
    ],
    [
        113.10749018602,
        23.207894932317
    ],
    [
        113.10749536267,
        23.207856421517
    ],
    [
        113.10750161821,
        23.207827676055
    ],
    [
        113.1075089571,
        23.20780137265
    ],
    [
        113.10750489291,
        23.207794588338
    ],
    [
        113.10754725772,
        23.207704033192
    ],
    [
        113.10756081483,
        23.207710283744
    ],
    [
        113.10759497497,
        23.207732013881
    ],
    [
        113.1076242545,
        23.207751299283
    ],
    [
        113.10765678381,
        23.207778183248
    ],
    [
        113.1076860646,
        23.20779475799
    ],
    [
        113.107705583,
        23.207809153473
    ],
    [
        113.1077345936,
        23.207823559383
    ],
    [
        113.10776794235,
        23.207839598223
    ],
    [
        113.10779234079,
        23.207856170507
    ],
    [
        113.1078503623,
        23.207882546673
    ],
    [
        113.10787856292,
        23.207889632202
    ],
    [
        113.10788642409,
        23.207895608797
    ],
    [
        113.10791922959,
        23.207911380428
    ],
    [
        113.10794877952,
        23.207928776335
    ],
    [
        113.10797506928,
        23.207955390778
    ],
    [
        113.10801763366,
        23.207976873925
    ],
    [
        113.10803904839,
        23.20799236289
    ],
    [
        113.10805856769,
        23.208002967487
    ],
    [
        113.10806534213,
        23.208011656231
    ],
    [
        113.10808458696,
        23.208027414353
    ],
    [
        113.10809516052,
        23.208032040076
    ],
    [
        113.10811359216,
        23.208046983876
    ],
    [
        113.10813528082,
        23.208057321704
    ],
    [
        113.10816292996,
        23.208076619368
    ],
    [
        113.10816509559,
        23.208082860901
    ],
    [
        113.10819301405,
        23.208104872059
    ],
    [
        113.10828789217,
        23.208162247909
    ],
    [
        113.10847183426,
        23.208023954028
    ],
    [
        113.10846641053,
        23.208024487016
    ],
    [
        113.10862972954,
        23.207898932047
    ],
    [
        113.1086050873,
        23.207843825168
    ],
    [
        113.108572301,
        23.207803350413
    ],
    [
        113.10850643433,
        23.207759019912
    ],
    [
        113.10847146565,
        23.207738886856
    ],
    [
        113.10841780363,
        23.207689158484
    ],
    [
        113.10835409835,
        23.20765460535
    ],
    [
        113.10827359111,
        23.207599958196
    ],
    [
        113.10824947011,
        23.20757632331
    ],
    [
        113.10821234316,
        23.207534225314
    ],
    [
        113.10785502101,
        23.207348220864
    ],
    [
        113.10793240869,
        23.207183946338
    ],
    [
        113.10794136402,
        23.207173921858
    ],
    [
        113.10794625215,
        23.207162536135
    ],
    [
        113.10795819781,
        23.207140038747
    ],
    [
        113.10797394796,
        23.207103984608
    ],
    [
        113.10797828896,
        23.207100735381
    ],
    [
        113.10799323054,
        23.207055729694
    ],
    [
        113.10801577269,
        23.206997986174
    ],
    [
        113.10801415651,
        23.206978726297
    ],
    [
        113.10801632977,
        23.20697221952
    ],
    [
        113.10801227637,
        23.206946717986
    ],
    [
        113.10800632382,
        23.206922570137
    ],
    [
        113.10788539177,
        23.206883902087
    ],
    [
        113.10786912388,
        23.206876559232
    ],
    [
        113.1078444655,
        23.206839370834
    ],
    [
        113.10785641763,
        23.206805209103
    ],
    [
        113.1078667414,
        23.206772944212
    ],
    [
        113.10789172446,
        23.206714658377
    ],
    [
        113.10793244006,
        23.206650425417
    ],
    [
        113.10796012305,
        23.20661275846
    ],
    [
        113.1079905275,
        23.206557465354
    ],
    [
        113.10800764792,
        23.206493475895
    ],
    [
        113.10802666186,
        23.206437897548
    ],
    [
        113.10804920653,
        23.206372288516
    ],
    [
        113.10805628599,
        23.206319678108
    ],
    [
        113.10807664461,
        23.206283902722
    ],
    [
        113.10808751598,
        23.20623970609
    ],
    [
        113.10810627067,
        23.206159988491
    ],
    [
        113.10810900002,
        23.206127172565
    ],
    [
        113.10812122335,
        23.206089759066
    ],
    [
        113.10814755847,
        23.206033108133
    ],
    [
        113.10817090558,
        23.205985404278
    ],
    [
        113.10838914138,
        23.205583771271
    ],
    [
        113.10851966495,
        23.205403894356
    ],
    [
        113.10865885547,
        23.205235170365
    ],
    [
        113.10867134117,
        23.205209969088
    ],
    [
        113.1086632171,
        23.205187982944
    ],
    [
        113.10865915551,
        23.205176040553
    ],
    [
        113.10859491793,
        23.205118687256
    ],
    [
        113.10855344325,
        23.205090673024
    ],
    [
        113.10853637064,
        23.205068129044
    ],
    [
        113.10854750073,
        23.205042652603
    ],
    [
        113.10857355278,
        23.205000657975
    ],
    [
        113.10874614475,
        23.204717000238
    ],
    [
        113.10871714699,
        23.204682494872
    ],
    [
        113.108688143,
        23.204661009866
    ],
    [
        113.10850458994,
        23.204607233142
    ],
    [
        113.10842976924,
        23.204558550349
    ],
    [
        113.10838883251,
        23.204535696823
    ],
    [
        113.10838532282,
        23.20450151446
    ],
    [
        113.10839917853,
        23.204444576797
    ],
    [
        113.10848413563,
        23.20426516039
    ],
    [
        113.1086369108,
        23.204016167591
    ],
    [
        113.10884070182,
        23.203655277258
    ],
    [
        113.10903526086,
        23.203291690538
    ],
    [
        113.10912094844,
        23.203272358695
    ],
    [
        113.10925678688,
        23.203270787488
    ],
    [
        113.10928118914,
        23.203269220654
    ],
    [
        113.10941783168,
        23.203280691421
    ],
    [
        113.10946419356,
        23.203280000246
    ],
    [
        113.10946311743,
        23.203258840224
    ],
    [
        113.10947940119,
        23.203216569403
    ],
    [
        113.10950572891,
        23.203141505161
    ],
    [
        113.10959227827,
        23.202975739918
    ],
    [
        113.10966282177,
        23.202830550343
    ],
    [
        113.10967448742,
        23.202809155126
    ],
    [
        113.10967476749,
        23.202785014954
    ],
    [
        113.10966094195,
        23.202782263051
    ],
    [
        113.10940288389,
        23.202661939344
    ],
    [
        113.10915267875,
        23.202532473113
    ],
    [
        113.10896616488,
        23.202446873999
    ],
    [
        113.10883657739,
        23.202386378993
    ],
    [
        113.10880567261,
        23.202367598883
    ],
    [
        113.10879835347,
        23.202361887647
    ],
    [
        113.10880080047,
        23.202342905304
    ],
    [
        113.10880731833,
        23.202313623905
    ],
    [
        113.10882007479,
        23.202278116723
    ],
    [
        113.10889224084,
        23.202161089198
    ],
    [
        113.10894053501,
        23.202072223891
    ],
    [
        113.10902651678,
        23.201984530195
    ],
    [
        113.10911981295,
        23.201910694101
    ],
    [
        113.10917242548,
        23.201873115193
    ],
    [
        113.10920659581,
        23.201849870133
    ],
    [
        113.10935086035,
        23.20177509372
    ],
    [
        113.10949078459,
        23.201694628504
    ],
    [
        113.10964750813,
        23.201631859971
    ],
    [
        113.1098202182,
        23.201580825463
    ],
    [
        113.11005581367,
        23.201535985767
    ],
    [
        113.11015720385,
        23.20152356698
    ],
    [
        113.11020463903,
        23.201537558369
    ],
    [
        113.11025207077,
        23.201561316818
    ],
    [
        113.11031358115,
        23.201639375764
    ],
    [
        113.11039649926,
        23.201736229502
    ],
    [
        113.11045935842,
        23.201827321245
    ],
    [
        113.11047805467,
        23.201850444506
    ],
    [
        113.11050733196,
        23.201844040147
    ],
    [
        113.11051817765,
        23.201834585739
    ],
    [
        113.11054800679,
        23.201797262005
    ],
    [
        113.11058380303,
        23.201747483583
    ],
    [
        113.1106692204,
        23.201641472178
    ],
    [
        113.11079585395,
        23.201476222743
    ],
    [
        113.11092004754,
        23.201297957795
    ],
    [
        113.11094309978,
        23.20125220872
    ],
    [
        113.11100980354,
        23.201158083258
    ],
    [
        113.11106104757,
        23.201096719325
    ],
    [
        113.1110895229,
        23.201038789265
    ],
    [
        113.11112479218,
        23.200914431521
    ],
    [
        113.11116791373,
        23.200814791849
    ],
    [
        113.11121209799,
        23.200792194055
    ],
    [
        113.11126468655,
        23.200759055354
    ],
    [
        113.1112915222,
        23.200744252426
    ],
    [
        113.11130372162,
        23.200732098988
    ],
    [
        113.11135847959,
        23.200690565315
    ],
    [
        113.11155228281,
        23.200594596554
    ],
    [
        113.11173061101,
        23.200578336739
    ],
    [
        113.11186638465,
        23.200570578349
    ],
    [
        113.11186746878,
        23.200570041102
    ],
    [
        113.11182932318,
        23.200309453142
    ],
    [
        113.11181741376,
        23.200249177411
    ],
    [
        113.11181849828,
        23.200247012592
    ],
    [
        113.11182723169,
        23.199983937691
    ],
    [
        113.11187303066,
        23.199983074203
    ],
    [
        113.1121353447,
        23.200006350909
    ],
    [
        113.11241607348,
        23.200023819771
    ],
    [
        113.11245452368,
        23.200142564177
    ],
    [
        113.11248783134,
        23.20023280024
    ],
    [
        113.1125395897,
        23.200216534774
    ],
    [
        113.11273644203,
        23.200752808732
    ],
    [
        113.11273779507,
        23.200759326415
    ],
    [
        113.11279549651,
        23.200802781874
    ],
    [
        113.11287837945,
        23.200904975398
    ],
    [
        113.11288542512,
        23.200901218421
    ],
    [
        113.11293227027,
        23.201004565066
    ],
    [
        113.11305088456,
        23.201210054503
    ],
    [
        113.11314296634,
        23.201335920181
    ],
    [
        113.1131608384,
        23.201368306207
    ],
    [
        113.11320090874,
        23.201460772778
    ],
    [
        113.11320767289,
        23.201490922482
    ],
    [
        113.1132206674,
        23.201524364934
    ],
    [
        113.11328187865,
        23.201585768603
    ],
    [
        113.11333279481,
        23.201644128373
    ],
    [
        113.11342786322,
        23.201726092405
    ],
    [
        113.11343192523,
        23.201731813999
    ],
    [
        113.11351426209,
        23.201802584524
    ],
    [
        113.11357876479,
        23.201724602207
    ],
    [
        113.1136570912,
        23.20161985855
    ],
    [
        113.11378581306,
        23.201486425189
    ],
    [
        113.11380532129,
        23.201475974318
    ],
    [
        113.11394758918,
        23.201323660249
    ],
    [
        113.11401722861,
        23.201257129037
    ],
    [
        113.11407494461,
        23.201201642164
    ],
    [
        113.11414051892,
        23.201134548146
    ],
    [
        113.11422072105,
        23.201063490202
    ],
    [
        113.11433181076,
        23.20096064638
    ],
    [
        113.11433478913,
        23.200965278582
    ],
    [
        113.1144732464,
        23.200817070181
    ],
    [
        113.11458134834,
        23.200721823601
    ],
    [
        113.11462388654,
        23.200674662771
    ],
    [
        113.11475908386,
        23.200528091547
    ],
    [
        113.11486853734,
        23.200416334611
    ],
    [
        113.1150007467,
        23.200273565944
    ],
    [
        113.11512346724,
        23.200153524193
    ],
    [
        113.11525701846,
        23.200030595666
    ],
    [
        113.1154157517,
        23.199912492945
    ],
    [
        113.11559886006,
        23.19976422749
    ],
    [
        113.11579983269,
        23.199626987362
    ],
    [
        113.11581716749,
        23.19961221155
    ],
    [
        113.1160590291,
        23.199439547373
    ],
    [
        113.11626837313,
        23.199328767361
    ],
    [
        113.11647256031,
        23.199239949445
    ],
    [
        113.11676635852,
        23.199181811238
    ],
    [
        113.11700869003,
        23.199174262221
    ],
    [
        113.11739016949,
        23.199184356251
    ],
    [
        113.11757941127,
        23.199189974457
    ],
    [
        113.11761785527,
        23.199187092658
    ],
    [
        113.11776025524,
        23.199193910598
    ],
    [
        113.11782360522,
        23.199186126316
    ],
    [
        113.11803882578,
        23.199171453962
    ],
    [
        113.11821235189,
        23.199151780629
    ],
    [
        113.11837396555,
        23.199116003327
    ],
    [
        113.11862003213,
        23.199064583025
    ],
    [
        113.11879869275,
        23.199001911067
    ],
    [
        113.11907019478,
        23.198895779361
    ],
    [
        113.11926047621,
        23.198861505776
    ],
    [
        113.11939418442,
        23.198835854018
    ],
    [
        113.11952274361,
        23.198834842398
    ],
    [
        113.11978228553,
        23.198862178732
    ],
    [
        113.12007050376,
        23.19889043749
    ],
    [
        113.12007050344,
        23.198892336297
    ],
    [
        113.12041418232,
        23.198938668495
    ],
    [
        113.12066719654,
        23.198962836157
    ],
    [
        113.12071157528,
        23.198962826099
    ],
    [
        113.12086365073,
        23.198967644873
    ],
    [
        113.12099596939,
        23.198975222036
    ],
    [
        113.12113180734,
        23.198958441181
    ],
    [
        113.12122407771,
        23.198950356323
    ],
    [
        113.1214673297,
        23.19893276807
    ],
    [
        113.12171030582,
        23.198898397723
    ],
    [
        113.12193406763,
        23.198844831384
    ],
    [
        113.1219538188,
        23.198841016121
    ],
    [
        113.12221572025,
        23.19878743861
    ],
    [
        113.12244461552,
        23.198678947124
    ],
    [
        113.12251983171,
        23.198632468494
    ],
    [
        113.12275926303,
        23.198555627577
    ],
    [
        113.12291806258,
        23.198542566217
    ],
    [
        113.12311229069,
        23.198569062346
    ],
    [
        113.12350911115,
        23.198669980281
    ],
    [
        113.1236476007,
        23.198710146602
    ],
    [
        113.12372441899,
        23.198726677552
    ],
    [
        113.12375254869,
        23.198737649041
    ],
    [
        113.12374822016,
        23.198741657521
    ],
    [
        113.12378392376,
        23.198751378935
    ],
    [
        113.12388373232,
        23.198768509726
    ],
    [
        113.12389401017,
        23.198773265394
    ],
    [
        113.12401220984,
        23.198794188256
    ],
    [
        113.12411877586,
        23.198823092031
    ],
    [
        113.12412337357,
        23.198826141028
    ],
    [
        113.12413337451,
        23.198868870434
    ],
    [
        113.12412606029,
        23.198937123977
    ],
    [
        113.12412145567,
        23.198975577454
    ],
    [
        113.12411522284,
        23.199044660067
    ],
    [
        113.12410815145,
        23.199263465203
    ],
    [
        113.12413383447,
        23.199332457323
    ],
    [
        113.12414951849,
        23.19935329532
    ],
    [
        113.12416547417,
        23.199367627129
    ],
    [
        113.12416844935,
        23.199368211878
    ],
    [
        113.12417737308,
        23.199379460145
    ],
    [
        113.12418737995,
        23.199384213664
    ],
    [
        113.1242011731,
        23.199391191117
    ],
    [
        113.12420496021,
        23.199389074896
    ],
    [
        113.12425175307,
        23.199388927006
    ],
    [
        113.12426798118,
        23.199391870802
    ],
    [
        113.12428826635,
        23.199395143871
    ],
    [
        113.12430341491,
        23.199385323491
    ],
    [
        113.12432018619,
        23.199376068929
    ],
    [
        113.12440809785,
        23.199336638025
    ],
    [
        113.12447382923,
        23.199300961461
    ],
    [
        113.12455740686,
        23.199287787574
    ],
    [
        113.12470508252,
        23.199282326984
    ],
    [
        113.12483247168,
        23.199274412667
    ],
    [
        113.12496878997,
        23.199234358121
    ],
    [
        113.12511078648,
        23.199189514403
    ],
    [
        113.12517001819,
        23.199173297582
    ],
    [
        113.12526413923,
        23.199146205612
    ],
    [
        113.12539233714,
        23.199108502802
    ],
    [
        113.12554325634,
        23.199034799159
    ],
    [
        113.12554325658,
        23.199033442869
    ],
    [
        113.12570444843,
        23.198966957837
    ],
    [
        113.12582994044,
        23.198900489591
    ],
    [
        113.1259567804,
        23.198848697585
    ],
    [
        113.12602547486,
        23.198811220484
    ],
    [
        113.12608686593,
        23.19878258614
    ],
    [
        113.1262020758,
        23.198720053399
    ],
    [
        113.12628077712,
        23.198660765587
    ],
    [
        113.12630755105,
        23.198644357448
    ],
    [
        113.12632242564,
        23.198633734967
    ],
    [
        113.12633973428,
        23.198620979836
    ],
    [
        113.12636867461,
        23.198582362392
    ],
    [
        113.12636705175,
        23.198584778824
    ],
    [
        113.1263724602,
        23.198584048054
    ],
    [
        113.1263830115,
        23.198549217513
    ],
    [
        113.1263738184,
        23.198541752361
    ],
    [
        113.12637652342,
        23.198535826166
    ],
    [
        113.12633975047,
        23.198509221018
    ],
    [
        113.12629784225,
        23.198462193357
    ],
    [
        113.12629757195,
        23.198461375437
    ],
    [
        113.12631082443,
        23.198447201632
    ],
    [
        113.12631217806,
        23.198436100701
    ],
    [
        113.12632516039,
        23.198419752762
    ],
    [
        113.12636086577,
        23.198343804889
    ],
    [
        113.12639737703,
        23.198305846433
    ],
    [
        113.12642307128,
        23.19826934984
    ],
    [
        113.12647959791,
        23.198191011456
    ],
    [
        113.12652963781,
        23.198080836903
    ],
    [
        113.12657724061,
        23.197992597939
    ],
    [
        113.12663836515,
        23.197887208411
    ],
    [
        113.12663998766,
        23.197886690996
    ],
    [
        113.12676033797,
        23.197706811311
    ],
    [
        113.12681064102,
        23.197628927085
    ],
    [
        113.12693720579,
        23.197452951059
    ],
    [
        113.12709081207,
        23.197211760084
    ],
    [
        113.12709243562,
        23.197195509725
    ],
    [
        113.12708378434,
        23.19717475803
    ],
    [
        113.12708324374,
        23.197172036917
    ],
    [
        113.12707973046,
        23.197144584198
    ],
    [
        113.12708108421,
        23.197118564091
    ],
    [
        113.1270789215,
        23.197111477326
    ],
    [
        113.12732687528,
        23.197095033109
    ],
    [
        113.12734282822,
        23.197098268896
    ],
    [
        113.12735472593,
        23.197091132696
    ],
    [
        113.12737446487,
        23.197085748068
    ],
    [
        113.1273936622,
        23.197092561924
    ],
    [
        113.12740501846,
        23.197094911659
    ],
    [
        113.12741177821,
        23.197095018606
    ],
    [
        113.12742367582,
        23.197088425288
    ],
    [
        113.12743340957,
        23.197092919595
    ],
    [
        113.12744260318,
        23.197087368622
    ],
    [
        113.12744557808,
        23.197077921494
    ],
    [
        113.12744557854,
        23.197070868637
    ],
    [
        113.12745044607,
        23.197062807809
    ],
    [
        113.12745098716,
        23.197057933626
    ],
    [
        113.12745234,
        23.197043849322
    ],
    [
        113.12744666252,
        23.197032637568
    ],
    [
        113.12744233717,
        23.197018192069
    ],
    [
        113.12744314934,
        23.197001929078
    ],
    [
        113.12744044642,
        23.196985610421
    ],
    [
        113.12743936611,
        23.1969644347
    ],
    [
        113.12743260704,
        23.196952934581
    ],
    [
        113.12744017885,
        23.196937321133
    ],
    [
        113.12742801213,
        23.196922751493
    ],
    [
        113.12742612088,
        23.196896137637
    ],
    [
        113.12741855081,
        23.196880555746
    ],
    [
        113.12741233261,
        23.196866080326
    ],
    [
        113.1274153076,
        23.196852835435
    ],
    [
        113.12740422234,
        23.196838554286
    ],
    [
        113.12739638277,
        23.196803979664
    ],
    [
        113.12739692441,
        23.196786627284
    ],
    [
        113.12739962874,
        23.196777989583
    ],
    [
        113.12740179273,
        23.196760120331
    ],
    [
        113.12740476735,
        23.196753114499
    ],
    [
        113.12740260498,
        23.196737075662
    ],
    [
        113.12740503929,
        23.196719753212
    ],
    [
        113.12741071791,
        23.196710620043
    ],
    [
        113.1274112591,
        23.196701405594
    ],
    [
        113.12719981911,
        23.196517678448
    ],
    [
        113.12707138431,
        23.196397390007
    ],
    [
        113.12734313789,
        23.196074247045
    ],
    [
        113.12736314718,
        23.196043367449
    ],
    [
        113.12742290393,
        23.195992500483
    ],
    [
        113.12750429137,
        23.195907255847
    ],
    [
        113.12772681758,
        23.195682117635
    ],
    [
        113.12798691797,
        23.195406061928
    ],
    [
        113.12822673048,
        23.195124822202
    ],
    [
        113.12836677118,
        23.194893254712
    ],
    [
        113.12846841773,
        23.194696606392
    ],
    [
        113.12857870605,
        23.194409497884
    ],
    [
        113.12861519585,
        23.194297243868
    ],
    [
        113.12863898636,
        23.194280813188
    ],
    [
        113.12868819208,
        23.194279175265
    ],
    [
        113.12872820617,
        23.194286882426
    ],
    [
        113.12874226507,
        23.194288740015
    ],
    [
        113.12883364803,
        23.194306241572
    ],
    [
        113.12887555417,
        23.194313981943
    ],
    [
        113.12934681901,
        23.194884370732
    ],
    [
        113.12936952797,
        23.194879050595
    ],
    [
        113.12938466706,
        23.194871977421
    ],
    [
        113.12941251219,
        23.19486023235
    ],
    [
        113.12943062478,
        23.19484859718
    ],
    [
        113.12946306597,
        23.194841811778
    ],
    [
        113.12949037016,
        23.194828702105
    ],
    [
        113.12953119121,
        23.194810120897
    ],
    [
        113.12955687412,
        23.194812989807
    ],
    [
        113.12957147212,
        23.194802924608
    ],
    [
        113.12959093718,
        23.194807860433
    ],
    [
        113.12960688689,
        23.194798360467
    ],
    [
        113.12961905228,
        23.194797206883
    ],
    [
        113.12965473644,
        23.194778813007
    ],
    [
        113.12969609843,
        23.194772721508
    ],
    [
        113.12973313401,
        23.194752994764
    ],
    [
        113.12977098075,
        23.194737351086
    ],
    [
        113.12980233956,
        23.194727024736
    ],
    [
        113.12984667416,
        23.194710134183
    ],
    [
        113.12988965698,
        23.19469403542
    ],
    [
        113.12993074749,
        23.194680889489
    ],
    [
        113.12997805557,
        23.194666763376
    ],
    [
        113.13000671056,
        23.194656664961
    ],
    [
        113.13003915035,
        23.194648800575
    ],
    [
        113.1300513147,
        23.194637611654
    ],
    [
        113.13007645511,
        23.194626369705
    ],
    [
        113.13009240415,
        23.194616058402
    ],
    [
        113.1301161931,
        23.194608863091
    ],
    [
        113.13012970933,
        23.194602037551
    ],
    [
        113.1301413331,
        23.194593552576
    ],
    [
        113.13014700969,
        23.1945876802
    ],
    [
        113.13015214562,
        23.194581798727
    ],
    [
        113.13015511832,
        23.194568285241
    ],
    [
        113.13014971138,
        23.19456466766
    ],
    [
        113.13015375744,
        23.194445919012
    ],
    [
        113.13014536674,
        23.194319636447
    ],
    [
        113.13013346556,
        23.194245378863
    ],
    [
        113.13013129625,
        23.194172641445
    ],
    [
        113.13014886528,
        23.19414418241
    ],
    [
        113.1302121136,
        23.194045148636
    ],
    [
        113.13034483714,
        23.193955156273
    ],
    [
        113.13039914627,
        23.193711386232
    ],
    [
        113.13040130891,
        23.193711422815
    ],
    [
        113.13043859462,
        23.193550374702
    ],
    [
        113.1305139796,
        23.193277393417
    ],
    [
        113.13052370867,
        23.19325829784
    ],
    [
        113.13053991488,
        23.19316552538
    ],
    [
        113.1305377513,
        23.193158978095
    ],
    [
        113.13058666593,
        23.193062420141
    ],
    [
        113.13061288861,
        23.193069375864
    ],
    [
        113.13066398335,
        23.193090589376
    ],
    [
        113.130678582,
        23.193097890633
    ],
    [
        113.1307210253,
        23.193113532431
    ],
    [
        113.13072778638,
        23.193133450512
    ],
    [
        113.13073887235,
        23.19315154326
    ],
    [
        113.13074752681,
        23.193179360556
    ],
    [
        113.13074752721,
        23.193182073311
    ],
    [
        113.13075483044,
        23.193212851646
    ],
    [
        113.13075969936,
        23.193234365214
    ],
    [
        113.13076483913,
        23.19325968124
    ],
    [
        113.13077349404,
        23.19329183897
    ],
    [
        113.13077620119,
        23.19331982633
    ],
    [
        113.13078539625,
        23.193349280522
    ],
    [
        113.13079026602,
        23.193378118523
    ],
    [
        113.13079540518,
        23.19340045053
    ],
    [
        113.13079649156,
        23.193438447417
    ],
    [
        113.13081028222,
        23.193470150098
    ],
    [
        113.13081812567,
        23.193501480224
    ],
    [
        113.13081975176,
        23.193533789523
    ],
    [
        113.13082840449,
        23.193552654844
    ],
    [
        113.13083435464,
        23.193576899602
    ],
    [
        113.13083624904,
        23.193594022131
    ],
    [
        113.13084490177,
        23.193613430027
    ],
    [
        113.13084896001,
        23.193641169107
    ],
    [
        113.13085112527,
        23.193663179172
    ],
    [
        113.1308470696,
        23.193656328205
    ],
    [
        113.13085734465,
        23.1936795616
    ],
    [
        113.13086302431,
        23.193703801764
    ],
    [
        113.1308632965,
        23.193719540261
    ],
    [
        113.13086816536,
        23.193745665513
    ],
    [
        113.13087168119,
        23.193759831671
    ],
    [
        113.13088060489,
        23.193786568618
    ],
    [
        113.13088331156,
        23.19381699737
    ],
    [
        113.13088763922,
        23.19383931557
    ],
    [
        113.13089196504,
        23.193845357359
    ],
    [
        113.13089575305,
        23.193877160912
    ],
    [
        113.13090035042,
        23.193894600803
    ],
    [
        113.13090792199,
        23.193918330713
    ],
    [
        113.13091306048,
        23.193940662755
    ],
    [
        113.13091252041,
        23.193946078996
    ],
    [
        113.13091901068,
        23.193970333013
    ],
    [
        113.13091847173,
        23.193986600177
    ],
    [
        113.13093144963,
        23.194010693645
    ],
    [
        113.13093226182,
        23.1940226435
    ],
    [
        113.13093172205,
        23.194031315008
    ],
    [
        113.13094145647,
        23.194059693503
    ],
    [
        113.13093848541,
        23.19408459985
    ],
    [
        113.13094335369,
        23.194110182552
    ],
    [
        113.13094497646,
        23.194118890968
    ],
    [
        113.13095389852,
        23.194134234536
    ],
    [
        113.13095903739,
        23.194163348405
    ],
    [
        113.13095687629,
        23.19417904529
    ],
    [
        113.13096498696,
        23.19419030594
    ],
    [
        113.13096039171,
        23.194192397648
    ],
    [
        113.13096606923,
        23.194200904033
    ],
    [
        113.13097174729,
        23.19421537842
    ],
    [
        113.13097201744,
        23.194213484129
    ],
    [
        113.13097850598,
        23.194222818198
    ],
    [
        113.13098472413,
        23.194231333843
    ],
    [
        113.13098202119,
        23.194234271664
    ],
    [
        113.13099364542,
        23.194239353134
    ],
    [
        113.13099040163,
        23.194239840261
    ],
    [
        113.13099391601,
        23.194242341749
    ],
    [
        113.13099526806,
        23.194247247743
    ],
    [
        113.13100770329,
        23.194252885656
    ],
    [
        113.1310109482,
        23.194264877071
    ],
    [
        113.131019599,
        23.194271264168
    ],
    [
        113.131035008,
        23.194279936989
    ],
    [
        113.13104122636,
        23.194291436717
    ],
    [
        113.13105609449,
        23.194297930201
    ],
    [
        113.1310650154,
        23.194302151846
    ],
    [
        113.13107393744,
        23.194319665848
    ],
    [
        113.13108123639,
        23.194323588514
    ],
    [
        113.13109664529,
        23.194331990309
    ],
    [
        113.13109421272,
        23.194335475217
    ],
    [
        113.13110313362,
        23.194339968222
    ],
    [
        113.13111070374,
        23.194354203909
    ],
    [
        113.13112367973,
        23.194362564172
    ],
    [
        113.13112935649,
        23.194363475172
    ],
    [
        113.1311417925,
        23.194379964399
    ],
    [
        113.13115125389,
        23.194383110413
    ],
    [
        113.13115855349,
        23.194395442655
    ],
    [
        113.1311747732,
        23.194403316106
    ],
    [
        113.13118612726,
        23.194412191334
    ],
    [
        113.13119423671,
        23.194411245215
    ],
    [
        113.13120477958,
        23.194417393881
    ],
    [
        113.13121180871,
        23.194428365227
    ],
    [
        113.13122072884,
        23.194424177803
    ],
    [
        113.13122505409,
        23.19442642213
    ],
    [
        113.13123559728,
        23.194436911228
    ],
    [
        113.13124938386,
        23.194442301824
    ],
    [
        113.13126830641,
        23.194447238039
    ],
    [
        113.1312856072,
        23.194454316685
    ],
    [
        113.13131155871,
        23.19446941078
    ],
    [
        113.1313923832,
        23.194472698074
    ],
    [
        113.13148969597,
        23.194469760259
    ],
    [
        113.13148753406,
        23.194477318645
    ],
    [
        113.1315886304,
        23.19447010798
    ],
    [
        113.1316056596,
        23.194464433565
    ],
    [
        113.13160998497,
        23.194469391024
    ],
    [
        113.13161376957,
        23.194472440262
    ],
    [
        113.13160809294,
        23.194471257302
    ],
    [
        113.1316118772,
        23.194469966192
    ],
    [
        113.13164025962,
        23.194466386585
    ],
    [
        113.13164188097,
        23.194459904039
    ],
    [
        113.13168918428,
        23.194446071589
    ],
    [
        113.13169134731,
        23.194452890709
    ],
    [
        113.131709998,
        23.194443718177
    ],
    [
        113.13172432422,
        23.194440981562
    ],
    [
        113.13174000194,
        23.194437725794
    ],
    [
        113.13177081589,
        23.194420896759
    ],
    [
        113.13179000762,
        23.194417973166
    ],
    [
        113.13180730672,
        23.194409591509
    ],
    [
        113.13183893141,
        23.194391963156
    ],
    [
        113.13187109757,
        23.194385466533
    ],
    [
        113.13187704384,
        23.194379330176
    ],
    [
        113.13190191144,
        23.194370537318
    ],
    [
        113.13192434603,
        23.194359261026
    ],
    [
        113.13195299799,
        23.194351890338
    ],
    [
        113.13195759331,
        23.194353055023
    ],
    [
        113.13196570184,
        23.194345057336
    ],
    [
        113.13197272932,
        23.194339211107
    ],
    [
        113.13197272981,
        23.194344907821
    ],
    [
        113.13197408132,
        23.194344659965
    ],
    [
        113.13198056812,
        23.194337990565
    ],
    [
        113.1320159764,
        23.194316088675
    ],
    [
        113.13203462695,
        23.194309358955
    ],
    [
        113.13202976119,
        23.194306561871
    ],
    [
        113.13200435037,
        23.194283605803
    ],
    [
        113.1319924532,
        23.19424270882
    ],
    [
        113.13199164211,
        23.19424079586
    ],
    [
        113.13197298742,
        23.194202494532
    ],
    [
        113.13193324558,
        23.194132089206
    ],
    [
        113.13191729527,
        23.194109839971
    ],
    [
        113.13189458449,
        23.194060075256
    ],
    [
        113.13186781816,
        23.194002916102
    ],
    [
        113.13184591888,
        23.193961846355
    ],
    [
        113.13182726341,
        23.193922731703
    ],
    [
        113.13180779653,
        23.19388007654
    ],
    [
        113.13177508353,
        23.193829868153
    ],
    [
        113.13174615482,
        23.19378081045
    ],
    [
        113.131722903,
        23.193736462592
    ],
    [
        113.13169748736,
        23.19368204037
    ],
    [
        113.13166125838,
        23.19362173494
    ],
    [
        113.13163205777,
        23.193565620104
    ],
    [
        113.13161718709,
        23.193537693725
    ],
    [
        113.13155959521,
        23.193419781938
    ],
    [
        113.1315220125,
        23.193351587283
    ],
    [
        113.13148794268,
        23.193277214073
    ],
    [
        113.1314598219,
        23.193220033754
    ],
    [
        113.13141682974,
        23.193136555475
    ],
    [
        113.13138924395,
        23.193046017922
    ],
    [
        113.13136544129,
        23.192950391242
    ],
    [
        113.13137003691,
        23.192952097856
    ],
    [
        113.13128405967,
        23.192846994203
    ],
    [
        113.13111751296,
        23.192661299705
    ],
    [
        113.13098692825,
        23.192545130604
    ],
    [
        113.130941508,
        23.19250963158
    ],
    [
        113.1309279886,
        23.192491225287
    ],
    [
        113.13093285419,
        23.192490223223
    ],
    [
        113.13106284498,
        23.192314486512
    ],
    [
        113.1312790317,
        23.191981805832
    ],
    [
        113.13141414775,
        23.191790162654
    ],
    [
        113.13157844233,
        23.191545855703
    ],
    [
        113.13180434916,
        23.191246464399
    ],
    [
        113.13193485425,
        23.191036581215
    ],
    [
        113.13196755007,
        23.190993471344
    ],
    [
        113.13199942935,
        23.190929730194
    ],
    [
        113.13199483283,
        23.190924767475
    ],
    [
        113.13202428288,
        23.190875090975
    ],
    [
        113.13204481705,
        23.190841536886
    ],
    [
        113.13204805182,
        23.190808767961
    ],
    [
        113.1320874946,
        23.190729424166
    ],
    [
        113.13209100392,
        23.190712665607
    ],
    [
        113.13209640997,
        23.190712488133
    ],
    [
        113.13209938349,
        23.190713082295
    ],
    [
        113.13212639424,
        23.190642475333
    ],
    [
        113.13218204899,
        23.190544152657
    ],
    [
        113.13207930477,
        23.190444978742
    ],
    [
        113.13184543033,
        23.190243976239
    ],
    [
        113.131816771,
        23.190221777998
    ],
    [
        113.13182434122,
        23.190227063268
    ],
    [
        113.13168781328,
        23.190154713613
    ],
    [
        113.13151260406,
        23.190000317154
    ],
    [
        113.13139823106,
        23.189903128996
    ],
    [
        113.13157405881,
        23.189461520541
    ],
    [
        113.13175739209,
        23.188879249907
    ],
    [
        113.13185405751,
        23.188601495875
    ],
    [
        113.13192695412,
        23.188380302007
    ],
    [
        113.1319933601,
        23.188157639948
    ],
    [
        113.13223690186,
        23.187512672859
    ],
    [
        113.13227604514,
        23.187398055283
    ],
    [
        113.13231599252,
        23.187269887386
    ],
    [
        113.13235541239,
        23.187172366316
    ],
    [
        113.13236188372,
        23.187137482491
    ],
    [
        113.1324213528,
        23.187143943955
    ],
    [
        113.1324670346,
        23.18714636773
    ],
    [
        113.13258624857,
        23.187172863193
    ],
    [
        113.13264004006,
        23.187177600388
    ],
    [
        113.13266896683,
        23.187188414677
    ],
    [
        113.13267031648,
        23.187184368898
    ],
    [
        113.13269194254,
        23.187189358678
    ],
    [
        113.13270032109,
        23.187187877346
    ],
    [
        113.132739786,
        23.187191280054
    ],
    [
        113.1327487087,
        23.187197675734
    ],
    [
        113.13281925921,
        23.187204606815
    ],
    [
        113.13289035344,
        23.187218873162
    ],
    [
        113.13296495729,
        23.187224249326
    ],
    [
        113.1331182198,
        23.187237246034
    ],
    [
        113.13322093662,
        23.187249629853
    ],
    [
        113.13323770295,
        23.18726782956
    ],
    [
        113.13324798475,
        23.187291612462
    ],
    [
        113.13328663667,
        23.187292020435
    ],
    [
        113.13337420844,
        23.187286235447
    ],
    [
        113.13344447343,
        23.187262784422
    ],
    [
        113.1334571616,
        23.187228553892
    ],
    [
        113.13348040084,
        23.187215941082
    ],
    [
        113.13350120668,
        23.187201657757
    ],
    [
        113.13348712803,
        23.18714986465
    ],
    [
        113.13348307179,
        23.18714572387
    ],
    [
        113.13348063817,
        23.187143510697
    ],
    [
        113.13345655954,
        23.187093711891
    ],
    [
        113.13348519091,
        23.18705162331
    ],
    [
        113.13346841399,
        23.1870106343
    ],
    [
        113.13344840279,
        23.186989663919
    ],
    [
        113.13341026679,
        23.186935819715
    ],
    [
        113.13339077559,
        23.186871180764
    ],
    [
        113.13338589641,
        23.186841524174
    ],
    [
        113.13339640808,
        23.186778769505
    ],
    [
        113.13342472,
        23.186635211825
    ],
    [
        113.13344386844,
        23.186547921545
    ],
    [
        113.13346517405,
        23.186450902706
    ],
    [
        113.13347245037,
        23.186407081452
    ],
    [
        113.13347296862,
        23.186361784741
    ],
    [
        113.13347293109,
        23.186286093453
    ],
    [
        113.133477795,
        23.186283466161
    ],
    [
        113.13348964638,
        23.186200659248
    ],
    [
        113.13350150551,
        23.186133858721
    ],
    [
        113.13350689049,
        23.186092717006
    ],
    [
        113.13351226628,
        23.186033669765
    ],
    [
        113.13350926925,
        23.185986954532
    ],
    [
        113.13351518519,
        23.185927645459
    ],
    [
        113.13351056197,
        23.185872762733
    ],
    [
        113.13350299352,
        23.185872086858
    ],
    [
        113.13350648976,
        23.185838236719
    ],
    [
        113.13349403928,
        23.185805190922
    ],
    [
        113.13347023731,
        23.185773573044
    ],
    [
        113.1334545537,
        23.185760546132
    ],
    [
        113.13345536047,
        23.18575269281
    ],
    [
        113.13344075503,
        23.185733987736
    ],
    [
        113.13341371298,
        23.185709095364
    ],
    [
        113.13341317083,
        23.18570610159
    ],
    [
        113.13339316417,
        23.185696254276
    ],
    [
        113.13337018442,
        23.185686626018
    ],
    [
        113.13333071746,
        23.18567806438
    ],
    [
        113.13332936528,
        23.185676684133
    ],
    [
        113.13327503125,
        23.185666233673
    ],
    [
        113.1332106945,
        23.185652352449
    ],
    [
        113.13317123376,
        23.185656000162
    ],
    [
        113.13310581675,
        23.185644271429
    ],
    [
        113.13298309174,
        23.185622043424
    ],
    [
        113.13299468275,
        23.185562290548
    ],
    [
        113.13305569871,
        23.185430426077
    ],
    [
        113.13310023618,
        23.185317534868
    ],
    [
        113.13313722266,
        23.185237338052
    ],
    [
        113.133210339,
        23.184996355102
    ],
    [
        113.13332342527,
        23.184702087233
    ],
    [
        113.13335768994,
        23.184593357324
    ],
    [
        113.1334292022,
        23.18439548364
    ],
    [
        113.13349289897,
        23.184239523884
    ],
    [
        113.13358409376,
        23.183966577084
    ],
    [
        113.13362458892,
        23.183886986592
    ],
    [
        113.13362188452,
        23.183884497235
    ],
    [
        113.13363833717,
        23.183827000754
    ],
    [
        113.13365696741,
        23.183794773433
    ],
    [
        113.13365965872,
        23.183775830001
    ],
    [
        113.13369283474,
        23.183662740991
    ],
    [
        113.13372088746,
        23.18357018036
    ],
    [
        113.13391838189,
        23.183007736446
    ],
    [
        113.13412186603,
        23.182532217397
    ],
    [
        113.13422925297,
        23.182254135084
    ],
    [
        113.13427047886,
        23.182066310331
    ],
    [
        113.13428167544,
        23.181840242545
    ],
    [
        113.13425294905,
        23.181345962369
    ],
    [
        113.134240104,
        23.181147683236
    ],
    [
        113.1341898312,
        23.180409658687
    ],
    [
        113.13415653597,
        23.179984476023
    ],
    [
        113.13414339181,
        23.179761772286
    ],
    [
        113.13412431327,
        23.179556598182
    ],
    [
        113.13409325421,
        23.179241332452
    ],
    [
        113.13408642719,
        23.179152765454
    ],
    [
        113.13403987843,
        23.178739011568
    ],
    [
        113.13399204936,
        23.178090009244
    ],
    [
        113.13390281469,
        23.177395506881
    ],
    [
        113.13385619156,
        23.176610323268
    ],
    [
        113.13384049009,
        23.176273076717
    ],
    [
        113.13384385927,
        23.176109263667
    ],
    [
        113.13382336131,
        23.175854139328
    ],
    [
        113.13378940862,
        23.175367075808
    ],
    [
        113.13378562308,
        23.175365381107
    ],
    [
        113.13375064673,
        23.174947754907
    ],
    [
        113.13370981063,
        23.174628511774
    ],
    [
        113.13371274503,
        23.174586509839
    ],
    [
        113.13368819553,
        23.174344878309
    ],
    [
        113.13367869928,
        23.174016148714
    ],
    [
        113.13367079297,
        23.173656245472
    ],
    [
        113.1336449313,
        23.173461256295
    ],
    [
        113.13363779223,
        23.173343650789
    ],
    [
        113.1336207839,
        23.173080717294
    ],
    [
        113.13353243828,
        23.172000677793
    ],
    [
        113.13352424664,
        23.171915611302
    ],
    [
        113.1335012009,
        23.171566834256
    ],
    [
        113.13348879238,
        23.171317275117
    ],
    [
        113.13346232689,
        23.171066654374
    ],
    [
        113.13344200687,
        23.170745327798
    ],
    [
        113.13340260966,
        23.170538975445
    ],
    [
        113.13336410565,
        23.170415662266
    ],
    [
        113.13332537531,
        23.170336570152
    ],
    [
        113.13330101196,
        23.170299242505
    ],
    [
        113.13326558928,
        23.170284511286
    ],
    [
        113.13325640767,
        23.170292760782
    ],
    [
        113.1332291155,
        23.170299878111
    ],
    [
        113.1331899501,
        23.170326593236
    ],
    [
        113.13313807478,
        23.170347116477
    ],
    [
        113.13311700987,
        23.170364925033
    ],
    [
        113.13311565107,
        23.170357575596
    ],
    [
        113.13309512483,
        23.170373494457
    ],
    [
        113.13299787929,
        23.170433106701
    ],
    [
        113.1329119875,
        23.170494547341
    ],
    [
        113.13289172624,
        23.170505316517
    ],
    [
        113.13288795938,
        23.170522614902
    ],
    [
        113.13286660772,
        23.170524140261
    ],
    [
        113.13276905231,
        23.170544952507
    ],
    [
        113.13265851374,
        23.170557128815
    ],
    [
        113.13246282739,
        23.170565651895
    ],
    [
        113.13240066747,
        23.170574336167
    ],
    [
        113.13239634559,
        23.170577245382
    ],
    [
        113.13238958504,
        23.17057414313
    ],
    [
        113.13230904939,
        23.170587663577
    ],
    [
        113.13229526873,
        23.170592307527
    ],
    [
        113.13219958134,
        23.170591186359
    ],
    [
        113.13203089011,
        23.170568180377
    ],
    [
        113.13202926773,
        23.170567609607
    ],
    [
        113.13186084985,
        23.170548955743
    ],
    [
        113.13164890853,
        23.170527657915
    ],
    [
        113.13151887872,
        23.170516191557
    ],
    [
        113.1313488137,
        23.170476366837
    ],
    [
        113.13109551427,
        23.170460627794
    ],
    [
        113.13074270059,
        23.170411737722
    ],
    [
        113.13035852812,
        23.170369135158
    ],
    [
        113.12969748808,
        23.170291824024
    ],
    [
        113.12969442803,
        23.170205493688
    ],
    [
        113.12968697143,
        23.170048275811
    ],
    [
        113.12968640572,
        23.170023305065
    ],
    [
        113.12966130853,
        23.169529628869
    ],
    [
        113.12965496363,
        23.16940363107
    ],
    [
        113.12965761256,
        23.169349682826
    ],
    [
        113.12966028914,
        23.169323138246
    ],
    [
        113.12966730546,
        23.169310774679
    ],
    [
        113.12967406239,
        23.169309259553
    ],
    [
        113.12968188288,
        23.169290126472
    ],
    [
        113.12968187301,
        23.169280358828
    ],
    [
        113.12968429842,
        23.169272802394
    ],
    [
        113.12969726583,
        23.16926406541
    ],
    [
        113.12972402536,
        23.169260171332
    ],
    [
        113.12974592115,
        23.16925863805
    ],
    [
        113.12979131577,
        23.169236877772
    ],
    [
        113.12985805421,
        23.16920272368
    ],
    [
        113.12989128349,
        23.169181032405
    ],
    [
        113.12992453354,
        23.169179962069
    ],
    [
        113.12992021004,
        23.169181788779
    ],
    [
        113.13006941385,
        23.169162046772
    ],
    [
        113.13035122292,
        23.169019472917
    ],
    [
        113.13036257189,
        23.169014781066
    ],
    [
        113.13038337337,
        23.169001295612
    ],
    [
        113.13046416364,
        23.168964678572
    ],
    [
        113.13050874378,
        23.168941557976
    ],
    [
        113.13054169637,
        23.168914984879
    ],
    [
        113.13054439195,
        23.168907433673
    ],
    [
        113.13056168113,
        23.168896060281
    ],
    [
        113.1305605734,
        23.168869994862
    ],
    [
        113.13052886158,
        23.168787247262
    ],
    [
        113.1305071733,
        23.168725832738
    ],
    [
        113.13046814529,
        23.168626139874
    ],
    [
        113.13036269059,
        23.168333229534
    ],
    [
        113.13033260613,
        23.168256480238
    ],
    [
        113.13026728456,
        23.168087158928
    ],
    [
        113.1302095643,
        23.167949711413
    ],
    [
        113.13013285707,
        23.167750084266
    ],
    [
        113.13012957173,
        23.167709602349
    ],
    [
        113.1300536635,
        23.167498866381
    ],
    [
        113.13002493673,
        23.167428925657
    ],
    [
        113.13000299137,
        23.167381618627
    ],
    [
        113.12997210732,
        23.167317068521
    ],
    [
        113.12994396687,
        23.167291906085
    ],
    [
        113.1299242102,
        23.167270140361
    ],
    [
        113.12990472579,
        23.167250278563
    ],
    [
        113.129894434,
        23.16723165627
    ],
    [
        113.12984248847,
        23.167191444473
    ],
    [
        113.12979404356,
        23.16713799746
    ],
    [
        113.12976833695,
        23.167113962611
    ],
    [
        113.12975562755,
        23.167110494239
    ],
    [
        113.1297266751,
        23.16708477755
    ],
    [
        113.12970800061,
        23.167064116565
    ],
    [
        113.12964983344,
        23.167020819576
    ],
    [
        113.1295764953,
        23.16694661178
    ],
    [
        113.12951046975,
        23.166885822108
    ],
    [
        113.12950127324,
        23.166881056665
    ],
    [
        113.12946581914,
        23.166842753625
    ],
    [
        113.12943714646,
        23.166826811885
    ],
    [
        113.129394652,
        23.166777539953
    ],
    [
        113.12938762405,
        23.166778508576
    ],
    [
        113.12934649733,
        23.166744996587
    ],
    [
        113.12933810453,
        23.166733190672
    ],
    [
        113.12932836359,
        23.166724889589
    ],
    [
        113.12934782403,
        23.166720599818
    ],
    [
        113.12939998772,
        23.166708170697
    ],
    [
        113.12947485844,
        23.166694220741
    ],
    [
        113.12956864265,
        23.166670548881
    ],
    [
        113.1295851273,
        23.166664583192
    ],
    [
        113.12954235289,
        23.166605536957
    ],
    [
        113.12945573147,
        23.16649638205
    ],
    [
        113.12944085373,
        23.166487723896
    ],
    [
        113.12938376794,
        23.166445535332
    ],
    [
        113.12937130293,
        23.166417111238
    ],
    [
        113.12936669475,
        23.166405096715
    ],
    [
        113.12927269143,
        23.166216599404
    ],
    [
        113.12918627626,
        23.166046680303
    ],
    [
        113.12917491225,
        23.166037538954
    ],
    [
        113.12915783377,
        23.16599221773
    ],
    [
        113.12915783182,
        23.16599031846
    ],
    [
        113.12913806372,
        23.165958518917
    ],
    [
        113.12913477825,
        23.165918309352
    ],
    [
        113.1291453067,
        23.165903560606
    ],
    [
        113.1291471755,
        23.165880529288
    ],
    [
        113.12915362887,
        23.16584644958
    ],
    [
        113.12917495777,
        23.165818584681
    ],
    [
        113.12920439331,
        23.165787055492
    ],
    [
        113.12923600135,
        23.165765058742
    ],
    [
        113.12927032398,
        23.165753960077
    ],
    [
        113.12928329496,
        23.165748477157
    ],
    [
        113.12931545913,
        23.1657416844
    ],
    [
        113.12939655415,
        23.165733533332
    ],
    [
        113.12943737085,
        23.1657285135
    ],
    [
        113.12943142571,
        23.165730856605
    ],
    [
        113.12953901343,
        23.165722607085
    ],
    [
        113.12975390334,
        23.165693634195
    ],
    [
        113.12992850808,
        23.165662372352
    ],
    [
        113.12993688134,
        23.165655458529
    ],
    [
        113.12997417966,
        23.165647945012
    ],
    [
        113.13001959053,
        23.165643010138
    ],
    [
        113.13009932085,
        23.165625901325
    ],
    [
        113.13023796408,
        23.165590795638
    ],
    [
        113.13035173618,
        23.165555817836
    ],
    [
        113.13039984539,
        23.165547135405
    ],
    [
        113.1304068712,
        23.165544541106
    ],
    [
        113.13059115466,
        23.165468710896
    ],
    [
        113.13068275151,
        23.165427398715
    ],
    [
        113.13055583498,
        23.165032100866
    ],
    [
        113.13051029346,
        23.164908149354
    ],
    [
        113.13051001757,
        23.164902718286
    ],
    [
        113.13049646439,
        23.164866674346
    ],
    [
        113.13043951441,
        23.164689351797
    ],
    [
        113.13039531045,
        23.164551858511
    ],
    [
        113.13035574597,
        23.164457312738
    ],
    [
        113.13035356943,
        23.164443709961
    ],
    [
        113.13033111579,
        23.16442759385
    ],
    [
        113.1302800238,
        23.164427544656
    ],
    [
        113.1302748872,
        23.164427186602
    ],
    [
        113.13015135822,
        23.164438397811
    ],
    [
        113.1300686369,
        23.164438361849
    ],
    [
        113.1299721368,
        23.164446778854
    ],
    [
        113.12982049892,
        23.164466213221
    ],
    [
        113.12976644096,
        23.164475347444
    ],
    [
        113.12973292078,
        23.164476957555
    ],
    [
        113.12959370775,
        23.164488199899
    ],
    [
        113.12957666324,
        23.164475435148
    ],
    [
        113.12955122771,
        23.164452491917
    ],
    [
        113.12955171785,
        23.164403119923
    ],
    [
        113.12928748267,
        23.162970234782
    ],
    [
        113.12928018128,
        23.162968214615
    ],
    [
        113.12928367766,
        23.162950365463
    ],
    [
        113.12928556764,
        23.162947954895
    ],
    [
        113.12967025384,
        23.162670280998
    ],
    [
        113.12967620249,
        23.162671465588
    ],
    [
        113.12967674428,
        23.162672559909
    ],
    [
        113.12971376397,
        23.162656085134
    ],
    [
        113.12981322255,
        23.162630887979
    ],
    [
        113.12988915795,
        23.162602315059
    ],
    [
        113.13000293946,
        23.162573565677
    ],
    [
        113.13008887665,
        23.162545436954
    ],
    [
        113.13025642982,
        23.162494539809
    ],
    [
        113.13034399562,
        23.16247431356
    ],
    [
        113.13167625673,
        23.162076268724
    ],
    [
        113.13175409257,
        23.162063775857
    ],
    [
        113.13184542862,
        23.162036595445
    ],
    [
        113.13188110187,
        23.162029615893
    ],
    [
        113.13202160621,
        23.161976158661
    ],
    [
        113.13204483278,
        23.161956755261
    ],
    [
        113.13204695137,
        23.161913109756
    ],
    [
        113.1320447369,
        23.161861249542
    ],
    [
        113.13198952661,
        23.161793005231
    ],
    [
        113.13157292835,
        23.161466461964
    ],
    [
        113.13136679001,
        23.161304192605
    ],
    [
        113.13135786362,
        23.161298070195
    ],
    [
        113.13102025381,
        23.161039143182
    ],
    [
        113.13100969861,
        23.161026210784
    ],
    [
        113.13069078363,
        23.160815927777
    ],
    [
        113.13063911954,
        23.160783033984
    ],
    [
        113.13046949775,
        23.160652907765
    ],
    [
        113.13038995789,
        23.160588072657
    ],
    [
        113.13034015826,
        23.160527811844
    ],
    [
        113.13030389601,
        23.16048894323
    ],
    [
        113.13023296477,
        23.160382203117
    ],
    [
        113.13011030689,
        23.160180446173
    ],
    [
        113.12995484576,
        23.159883996113
    ],
    [
        113.12985263555,
        23.15958220541
    ],
    [
        113.12976126401,
        23.159305560727
    ],
    [
        113.12971961529,
        23.159007772928
    ],
    [
        113.12968222005,
        23.158633003297
    ],
    [
        113.12963416667,
        23.15813379432
    ],
    [
        113.12962280442,
        23.157837871156
    ],
    [
        113.12964112697,
        23.157483296967
    ],
    [
        113.129693841,
        23.157188986849
    ],
    [
        113.12976532892,
        23.157024137499
    ],
    [
        113.12985470184,
        23.156905712943
    ],
    [
        113.12991709001,
        23.156840829668
    ],
    [
        113.12993842869,
        23.156821381808
    ],
    [
        113.12993598622,
        23.156811030891
    ],
    [
        113.12990024427,
        23.156747757784
    ],
    [
        113.12981066606,
        23.15664125838
    ],
    [
        113.12968783,
        23.15652823707
    ],
    [
        113.12965752276,
        23.156495987357
    ],
    [
        113.12953550789,
        23.156395195092
    ],
    [
        113.12939970106,
        23.156290380437
    ],
    [
        113.12919221637,
        23.156146944972
    ],
    [
        113.12903727502,
        23.156112643922
    ],
    [
        113.12888072267,
        23.156092704627
    ],
    [
        113.12871661172,
        23.156087572847
    ],
    [
        113.12825427407,
        23.156068654213
    ],
    [
        113.12778488299,
        23.156042652912
    ],
    [
        113.12758180371,
        23.156016623364
    ],
    [
        113.1274584971,
        23.156004083843
    ],
    [
        113.12706718856,
        23.155944735502
    ],
    [
        113.12670316222,
        23.15586878603
    ],
    [
        113.12647189281,
        23.155789241912
    ],
    [
        113.12622085315,
        23.155681746763
    ],
    [
        113.12597626288,
        23.155534768263
    ],
    [
        113.12579361193,
        23.155406387767
    ],
    [
        113.12563040458,
        23.155249827776
    ],
    [
        113.12552563826,
        23.155126168762
    ],
    [
        113.12546522921,
        23.155009416655
    ],
    [
        113.12541641454,
        23.154852684953
    ],
    [
        113.12539331957,
        23.154727809207
    ],
    [
        113.12540321176,
        23.154594742507
    ],
    [
        113.12542717189,
        23.154467040358
    ],
    [
        113.1254703656,
        23.154377066323
    ],
    [
        113.12550274955,
        23.154296156405
    ],
    [
        113.12557293085,
        23.154139574231
    ],
    [
        113.12568612743,
        23.154002361066
    ],
    [
        113.12578095128,
        23.153885768325
    ],
    [
        113.12595493627,
        23.153680846593
    ],
    [
        113.12613592679,
        23.153447016823
    ],
    [
        113.12613836238,
        23.153449224443
    ],
    [
        113.12630722799,
        23.153271114891
    ],
    [
        113.12655683014,
        23.152951014265
    ],
    [
        113.12678049451,
        23.152660383792
    ],
    [
        113.126884985,
        23.152463957026
    ],
    [
        113.12702404114,
        23.152208931771
    ],
    [
        113.12716099896,
        23.152037445107
    ],
    [
        113.12720365171,
        23.151947228575
    ],
    [
        113.12754972034,
        23.151191419597
    ],
    [
        113.12776531892,
        23.150591746587
    ],
    [
        113.12785376098,
        23.150250776982
    ],
    [
        113.12788045784,
        23.150150280135
    ],
    [
        113.12791709339,
        23.149955258492
    ],
    [
        113.12799228967,
        23.149607029175
    ],
    [
        113.12803243879,
        23.149404198829
    ],
    [
        113.12815356916,
        23.149000556483
    ],
    [
        113.12819969241,
        23.1488309249
    ],
    [
        113.12825882268,
        23.148705455499
    ],
    [
        113.12834653244,
        23.148453754146
    ],
    [
        113.12836811855,
        23.14838492306
    ],
    [
        113.127964966,
        23.148338530981
    ],
    [
        113.12791412983,
        23.148329846914
    ],
    [
        113.12787465571,
        23.148331384112
    ],
    [
        113.12787735612,
        23.148326001424
    ],
    [
        113.12779001091,
        23.148305340279
    ],
    [
        113.12779190223,
        23.148303200144
    ],
    [
        113.12750904813,
        23.148249315209
    ],
    [
        113.12750363783,
        23.148245159817
    ],
    [
        113.12751036186,
        23.148187751194
    ],
    [
        113.12755258958,
        23.147823254313
    ],
    [
        113.12759913416,
        23.14743332606
    ],
    [
        113.12760129423,
        23.147428205797
    ],
    [
        113.12759829125,
        23.147379053203
    ],
    [
        113.12764246494,
        23.147085942322
    ],
    [
        113.12767017446,
        23.146838419366
    ],
    [
        113.12768305687,
        23.146665809495
    ],
    [
        113.12769089085,
        23.146652912305
    ],
    [
        113.12769224113,
        23.146649949601
    ],
    [
        113.12771457534,
        23.146453345769
    ],
    [
        113.12775497884,
        23.14616641889
    ],
    [
        113.12781255321,
        23.145610373961
    ],
    [
        113.12782764891,
        23.145519461249
    ],
    [
        113.12769140227,
        23.145570185358
    ],
    [
        113.12768193785,
        23.1455681353
    ],
    [
        113.12636506183,
        23.14602823927
    ],
    [
        113.12609523249,
        23.14612069209
    ],
    [
        113.12603331195,
        23.146132771922
    ],
    [
        113.12597490703,
        23.146145720862
    ],
    [
        113.12596868804,
        23.146147254272
    ],
    [
        113.12596301265,
        23.14615395054
    ],
    [
        113.12592731621,
        23.146153680701
    ],
    [
        113.12585727179,
        23.146146923525
    ],
    [
        113.12582914189,
        23.146137003212
    ],
    [
        113.12583103535,
        23.146137845691
    ],
    [
        113.12579667825,
        23.146114267076
    ],
    [
        113.12577719519,
        23.146091455826
    ],
    [
        113.12577447843,
        23.146067812265
    ],
    [
        113.1257733937,
        23.146062098734
    ],
    [
        113.12576960577,
        23.146058514814
    ],
    [
        113.12577771478,
        23.14605104081
    ],
    [
        113.12577662778,
        23.146040986536
    ],
    [
        113.12577797752,
        23.146036394883
    ],
    [
        113.12577824383,
        23.146028531366
    ],
    [
        113.12578419008,
        23.146022381256
    ],
    [
        113.1257874225,
        23.145998013528
    ],
    [
        113.12579228065,
        23.145979638801
    ],
    [
        113.12580200137,
        23.145951299571
    ],
    [
        113.12580117906,
        23.145930126234
    ],
    [
        113.12580928119,
        23.145909358861
    ],
    [
        113.12582413879,
        23.145878384351
    ],
    [
        113.12584467562,
        23.145847767056
    ],
    [
        113.12586520994,
        23.145812266655
    ],
    [
        113.12587546639,
        23.145773626769
    ],
    [
        113.12589762154,
        23.145734624425
    ],
    [
        113.12591004775,
        23.145708225787
    ],
    [
        113.12592274593,
        23.145684815579
    ],
    [
        113.12592570839,
        23.145660715352
    ],
    [
        113.12594057222,
        23.145641678769
    ],
    [
        113.12595110563,
        23.145615523011
    ],
    [
        113.12595163978,
        23.145602237745
    ],
    [
        113.12595352881,
        23.145594398888
    ],
    [
        113.12595460806,
        23.145589531977
    ],
    [
        113.12595217516,
        23.145591394137
    ],
    [
        113.12595541785,
        23.145586560032
    ],
    [
        113.12595433531,
        23.145584915858
    ],
    [
        113.12595352553,
        23.145587887803
    ],
    [
        113.125942434,
        23.145579852145
    ],
    [
        113.12591998115,
        23.145565133394
    ],
    [
        113.12587670105,
        23.145541960971
    ],
    [
        113.1258142178,
        23.14551388755
    ],
    [
        113.12578175909,
        23.14549983322
    ],
    [
        113.12577039642,
        23.145490709258
    ],
    [
        113.12574930205,
        23.145489306252
    ],
    [
        113.12575497723,
        23.145481524246
    ],
    [
        113.12570085644,
        23.14541261517
    ],
    [
        113.1257059896,
        23.145402383244
    ],
    [
        113.12569679157,
        23.145395733901
    ],
    [
        113.12586863427,
        23.145084982466
    ],
    [
        113.12594319882,
        23.144930661235
    ],
    [
        113.12599236572,
        23.144822890581
    ],
    [
        113.1261175382,
        23.144750461131
    ],
    [
        113.12611372892,
        23.144699942939
    ],
    [
        113.12610911858,
        23.144671387127
    ],
    [
        113.1260557521,
        23.144466835257
    ],
    [
        113.12604784153,
        23.144313978551
    ],
    [
        113.12604131077,
        23.144221911961
    ],
    [
        113.12594924207,
        23.143934574915
    ],
    [
        113.12593544422,
        23.143920258731
    ],
    [
        113.12581835031,
        23.143924455927
    ],
    [
        113.12571478853,
        23.143956534999
    ],
    [
        113.12569153479,
        23.143964866537
    ],
    [
        113.12560446871,
        23.14399774201
    ],
    [
        113.12551795609,
        23.144061556606
    ],
    [
        113.12545064198,
        23.144120235446
    ],
    [
        113.1254295544,
        23.144135927221
    ],
    [
        113.12536630916,
        23.144223426373
    ],
    [
        113.12531956232,
        23.144313885382
    ],
    [
        113.12531389585,
        23.144342829325
    ],
    [
        113.12529202361,
        23.144418466136
    ],
    [
        113.12523740218,
        23.144437732461
    ],
    [
        113.12518061099,
        23.144443946362
    ],
    [
        113.12516573841,
        23.144448609981
    ],
    [
        113.12509461256,
        23.144454072317
    ],
    [
        113.12508757969,
        23.14445152716
    ],
    [
        113.12502726715,
        23.144447656077
    ],
    [
        113.12499102653,
        23.144447937964
    ],
    [
        113.12496803581,
        23.144443260194
    ],
    [
        113.12494261874,
        23.144455909762
    ],
    [
        113.12492856757,
        23.144483646974
    ],
    [
        113.1249269656,
        23.144529471635
    ],
    [
        113.12492670428,
        23.144549543319
    ],
    [
        113.1248883054,
        23.144562546276
    ],
    [
        113.12482123806,
        23.144576217028
    ],
    [
        113.12475525185,
        23.144589363352
    ],
    [
        113.12469034491,
        23.144597915754
    ],
    [
        113.12466735924,
        23.144605992452
    ],
    [
        113.12466600592,
        23.14460380251
    ],
    [
        113.12464839543,
        23.1445373524
    ],
    [
        113.12462808818,
        23.14448795477
    ],
    [
        113.12461103749,
        23.14446274934
    ],
    [
        113.12458965981,
        23.144438566697
    ],
    [
        113.12455964139,
        23.144446000532
    ],
    [
        113.1245380035,
        23.144444874429
    ],
    [
        113.12450392639,
        23.144448995163
    ],
    [
        113.12448066763,
        23.144452458336
    ],
    [
        113.12446254495,
        23.144449755987
    ],
    [
        113.12445876202,
        23.144457840299
    ],
    [
        113.12445713858,
        23.144456460502
    ],
    [
        113.12443251913,
        23.144441728268
    ],
    [
        113.12443304921,
        23.144417591034
    ],
    [
        113.12440785194,
        23.1443203786
    ],
    [
        113.1243951274,
        23.144292524431
    ],
    [
        113.12440026364,
        23.144286358444
    ],
    [
        113.12432858944,
        23.144288858296
    ],
    [
        113.12422852056,
        23.144304791928
    ],
    [
        113.12417767354,
        23.144311121561
    ],
    [
        113.1241690166,
        23.144307471686
    ],
    [
        113.12417307091,
        23.14430101837
    ],
    [
        113.12416793154,
        23.144300402715
    ],
    [
        113.1241722436,
        23.144265196313
    ],
    [
        113.1241905888,
        23.144157483884
    ],
    [
        113.12418405589,
        23.144062168263
    ],
    [
        113.12416454744,
        23.143983216898
    ],
    [
        113.12417048629,
        23.143955901111
    ],
    [
        113.12418670008,
        23.143920864124
    ],
    [
        113.12420724099,
        23.143884532464
    ],
    [
        113.12419965414,
        23.143852683629
    ],
    [
        113.12416395121,
        23.143853260906
    ],
    [
        113.12413258662,
        23.143879401664
    ],
    [
        113.12409121293,
        23.1439026882
    ],
    [
        113.12408769492,
        23.143898569003
    ],
    [
        113.12404200057,
        23.143938886698
    ],
    [
        113.12402465981,
        23.143868648885
    ],
    [
        113.12402111106,
        23.143791552657
    ],
    [
        113.12400130864,
        23.143654272093
    ],
    [
        113.12397523945,
        23.143401606095
    ],
    [
        113.12393970848,
        23.143154504801
    ],
    [
        113.12391120861,
        23.142895567114
    ],
    [
        113.12389389833,
        23.142898036495
    ],
    [
        113.12388415959,
        23.142894915434
    ],
    [
        113.12385413467,
        23.142893137251
    ],
    [
        113.12383167509,
        23.142869220179
    ],
    [
        113.12381623959,
        23.142822071207
    ],
    [
        113.12382245507,
        23.142806423724
    ],
    [
        113.12381812529,
        23.142801208587
    ],
    [
        113.12383014806,
        23.142386309863
    ],
    [
        113.12384389461,
        23.142246248313
    ],
    [
        113.12385169343,
        23.14211234311
    ],
    [
        113.12386923545,
        23.14199268173
    ],
    [
        113.12387756526,
        23.141822432401
    ],
    [
        113.12389185377,
        23.141672884698
    ],
    [
        113.1239299943,
        23.141678575758
    ],
    [
        113.12398274317,
        23.141691527118
    ],
    [
        113.12402467368,
        23.141708667646
    ],
    [
        113.12403684542,
        23.141708568468
    ],
    [
        113.12405740438,
        23.141715641445
    ],
    [
        113.12406549343,
        23.141634370949
    ],
    [
        113.12408329822,
        23.141481076932
    ],
    [
        113.12409166204,
        23.141410933227
    ],
    [
        113.12409300538,
        23.141380568613
    ],
    [
        113.12410569855,
        23.141314826939
    ],
    [
        113.12415568264,
        23.141125367749
    ],
    [
        113.12417675334,
        23.141030718684
    ],
    [
        113.12418620318,
        23.140969814758
    ],
    [
        113.12420780182,
        23.140824444142
    ],
    [
        113.12421507281,
        23.140704370241
    ],
    [
        113.12421450448,
        23.140599105258
    ],
    [
        113.12428482707,
        23.140593326328
    ],
    [
        113.12437138078,
        23.14060026163
    ],
    [
        113.12447848878,
        23.140604784003
    ],
    [
        113.12447957171,
        23.140608868796
    ],
    [
        113.12446441849,
        23.140582065283
    ],
    [
        113.12444358653,
        23.140559792044
    ],
    [
        113.12441382736,
        23.140531151424
    ],
    [
        113.12440273795,
        23.140530992261
    ],
    [
        113.12431698158,
        23.140466826723
    ],
    [
        113.12426342159,
        23.140443816552
    ],
    [
        113.12419822858,
        23.140412232685
    ],
    [
        113.12416657682,
        23.140389266166
    ],
    [
        113.12412491741,
        23.140367243266
    ],
    [
        113.12406134276,
        23.140320767055
    ],
    [
        113.12404375555,
        23.140296916818
    ],
    [
        113.12400371804,
        23.140272749519
    ],
    [
        113.12395312521,
        23.140222662773
    ],
    [
        113.12393823894,
        23.140182574928
    ],
    [
        113.12388574842,
        23.140114830301
    ],
    [
        113.1238005207,
        23.140013261116
    ],
    [
        113.12379105556,
        23.140022352045
    ],
    [
        113.12377239123,
        23.140020734414
    ],
    [
        113.12372613466,
        23.140010864372
    ],
    [
        113.12371937229,
        23.140010769954
    ],
    [
        113.12365877978,
        23.140003685726
    ],
    [
        113.12357979295,
        23.139996619542
    ],
    [
        113.12353596836,
        23.139980277715
    ],
    [
        113.12340205994,
        23.139936651102
    ],
    [
        113.12340828217,
        23.139939449601
    ],
    [
        113.12339070632,
        23.139970404616
    ],
    [
        113.12331094272,
        23.140126107759
    ],
    [
        113.12328769197,
        23.14018112994
    ],
    [
        113.12327092734,
        23.140210198451
    ],
    [
        113.12320411293,
        23.140216609331
    ],
    [
        113.12313567594,
        23.140227341286
    ],
    [
        113.12310321957,
        23.140249415976
    ],
    [
        113.12305913535,
        23.140289780537
    ],
    [
        113.12300126332,
        23.140365768619
    ],
    [
        113.12297585855,
        23.140462000765
    ],
    [
        113.1228863211,
        23.140480596491
    ],
    [
        113.12277407008,
        23.14054446792
    ],
    [
        113.12275514646,
        23.14059575791
    ],
    [
        113.1227216199,
        23.140667741616
    ],
    [
        113.12269782224,
        23.140701062696
    ],
    [
        113.12265456637,
        23.140808727183
    ],
    [
        113.12261455099,
        23.140893648383
    ],
    [
        113.12258859889,
        23.140962209126
    ],
    [
        113.12257645073,
        23.141054283676
    ],
    [
        113.12257214395,
        23.141130728047
    ],
    [
        113.12256809811,
        23.14117299439
    ],
    [
        113.12256568077,
        23.141233186989
    ],
    [
        113.12251267817,
        23.141307901467
    ],
    [
        113.12250753776,
        23.141307019626
    ],
    [
        113.12251025445,
        23.141345306402
    ],
    [
        113.12249943901,
        23.141365238298
    ],
    [
        113.12250133778,
        23.14138208293
    ],
    [
        113.12248430477,
        23.141417667145
    ],
    [
        113.12247783673,
        23.141499509158
    ],
    [
        113.12248355328,
        23.141614066177
    ],
    [
        113.12247031378,
        23.141667605453
    ],
    [
        113.12246545514,
        23.141702536893
    ],
    [
        113.12246491801,
        23.14171500885
    ],
    [
        113.12245032771,
        23.141773684909
    ],
    [
        113.1224311337,
        23.141817651134
    ],
    [
        113.12240166569,
        23.141881286122
    ],
    [
        113.12240112752,
        23.141890231415
    ],
    [
        113.12240248039,
        23.141890791785
    ],
    [
        113.12234163389,
        23.141966494414
    ],
    [
        113.12223560454,
        23.142036183334
    ],
    [
        113.12214743163,
        23.14211045201
    ],
    [
        113.12214283496,
        23.142118259532
    ],
    [
        113.12214770483,
        23.142118322817
    ],
    [
        113.12215257643,
        23.14212354055
    ],
    [
        113.12215095342,
        23.142124333306
    ],
    [
        113.12211931026,
        23.142156476475
    ],
    [
        113.12193157783,
        23.142244660511
    ],
    [
        113.1219164253,
        23.142240396489
    ],
    [
        113.12177277716,
        23.142292543438
    ],
    [
        113.12167132685,
        23.14232272203
    ],
    [
        113.12148274547,
        23.14233444805
    ],
    [
        113.12148220555,
        23.142337967978
    ],
    [
        113.12146570045,
        23.14233721816
    ],
    [
        113.12146542761,
        23.142330703887
    ],
    [
        113.12145974077,
        23.142316796971
    ],
    [
        113.12145161238,
        23.142284412058
    ],
    [
        113.12143942459,
        23.142249534749
    ],
    [
        113.12143398618,
        23.142170793938
    ],
    [
        113.12142503272,
        23.142098248728
    ],
    [
        113.12140876787,
        23.142007164768
    ],
    [
        113.12138682736,
        23.141934457448
    ],
    [
        113.12135758,
        23.14185704747
    ],
    [
        113.12132562409,
        23.141770380725
    ],
    [
        113.12129177368,
        23.141681520908
    ],
    [
        113.12128147301,
        23.141621981755
    ],
    [
        113.1212649506,
        23.141566977256
    ],
    [
        113.12126898542,
        23.141489440357
    ],
    [
        113.12123570377,
        23.141488213533
    ],
    [
        113.12107525361,
        23.141506579312
    ],
    [
        113.12097247048,
        23.141636620971
    ],
    [
        113.12087616289,
        23.141709779091
    ],
    [
        113.12074683131,
        23.141751618478
    ],
    [
        113.12066132125,
        23.141750318118
    ],
    [
        113.12058040571,
        23.141734157101
    ],
    [
        113.12040071385,
        23.141709233401
    ],
    [
        113.12021126131,
        23.141640541526
    ],
    [
        113.11978060396,
        23.141351539508
    ],
    [
        113.11940758435,
        23.141104274737
    ],
    [
        113.11934532731,
        23.141079982814
    ],
    [
        113.11923298863,
        23.141022317608
    ],
    [
        113.11909790031,
        23.14092100885
    ],
    [
        113.11902886,
        23.140846199303
    ],
    [
        113.11895521786,
        23.140771343747
    ],
    [
        113.11891189257,
        23.140704413583
    ],
    [
        113.11890810034,
        23.140693792873
    ],
    [
        113.11889997987,
        23.140692620539
    ],
    [
        113.11887885563,
        23.140648175083
    ],
    [
        113.11883633601,
        23.140557112088
    ],
    [
        113.11878164458,
        23.140499288383
    ],
    [
        113.1187407676,
        23.140481220517
    ],
    [
        113.11869177347,
        23.140476903313
    ],
    [
        113.1186338482,
        23.140479547079
    ],
    [
        113.11859351861,
        23.140488617578
    ],
    [
        113.1185572529,
        23.140512652324
    ],
    [
        113.11852829989,
        23.140553312649
    ],
    [
        113.11853482061,
        23.140645887656
    ],
    [
        113.11852914097,
        23.140664004084
    ],
    [
        113.11853537936,
        23.140711272264
    ],
    [
        113.11850805016,
        23.140749508574
    ],
    [
        113.11850453025,
        23.140745945168
    ],
    [
        113.11849993094,
        23.140754849451
    ],
    [
        113.11848964788,
        23.140766407285
    ],
    [
        113.11847151979,
        23.140796330623
    ],
    [
        113.11840115369,
        23.140846329393
    ],
    [
        113.11836164112,
        23.140877931872
    ],
    [
        113.11835704327,
        23.140892262317
    ],
    [
        113.11831076973,
        23.140947669353
    ],
    [
        113.11826827953,
        23.140980871735
    ],
    [
        113.1182268743,
        23.141022496353
    ],
    [
        113.11823852022,
        23.141042961669
    ],
    [
        113.11827101217,
        23.141071236725
    ],
    [
        113.11830701871,
        23.141084356941
    ],
    [
        113.11844783083,
        23.14126051916
    ],
    [
        113.11840670299,
        23.141318689352
    ],
    [
        113.11831578326,
        23.141430061387
    ],
    [
        113.11830657427,
        23.141412604488
    ],
    [
        113.11820396583,
        23.141367876314
    ],
    [
        113.11813735951,
        23.141322978882
    ],
    [
        113.11808104425,
        23.141294194619
    ],
    [
        113.11798900848,
        23.141311171636
    ],
    [
        113.11792106385,
        23.141324597715
    ],
    [
        113.11787585819,
        23.141336625868
    ],
    [
        113.11768745032,
        23.141378711721
    ],
    [
        113.11754072802,
        23.141416345665
    ],
    [
        113.11739291542,
        23.14144096448
    ],
    [
        113.11730628543,
        23.141461026505
    ],
    [
        113.11703041519,
        23.141525168988
    ],
    [
        113.1169960338,
        23.141538685505
    ],
    [
        113.11687772363,
        23.141571505654
    ],
    [
        113.11672826895,
        23.141590490658
    ],
    [
        113.11671825068,
        23.141590671335
    ],
    [
        113.11669713316,
        23.141597805273
    ],
    [
        113.11668251093,
        23.141595231867
    ],
    [
        113.11666681429,
        23.141620319919
    ],
    [
        113.11666737285,
        23.141674039173
    ],
    [
        113.11665763607,
        23.141708133385
    ],
    [
        113.1166151248,
        23.141706666752
    ],
    [
        113.11658371379,
        23.141701773977
    ],
    [
        113.11658398543,
        23.141704489244
    ],
    [
        113.11656557209,
        23.141701883362
    ],
    [
        113.11654932748,
        23.141707435587
    ],
    [
        113.11647702508,
        23.141690245622
    ],
    [
        113.11642990756,
        23.141683318952
    ],
    [
        113.11633215591,
        23.141684089674
    ],
    [
        113.11633675707,
        23.141677347735
    ],
    [
        113.11621842164,
        23.14167062331
    ],
    [
        113.11605269148,
        23.141653469127
    ],
    [
        113.11577321734,
        23.141633492757
    ],
    [
        113.11571336545,
        23.141624318305
    ],
    [
        113.11570551164,
        23.141623439934
    ],
    [
        113.11570226172,
        23.141622870683
    ],
    [
        113.11568411743,
        23.14162326444
    ],
    [
        113.11567653345,
        23.141619404345
    ],
    [
        113.11563022379,
        23.141617940931
    ],
    [
        113.11561261953,
        23.141613999623
    ],
    [
        113.11556657985,
        23.141611455719
    ],
    [
        113.11552053817,
        23.141603759168
    ],
    [
        113.11549345594,
        23.141603269963
    ],
    [
        113.11546420546,
        23.141597880887
    ],
    [
        113.115418706,
        23.141594533136
    ],
    [
        113.11540651892,
        23.141594707315
    ],
    [
        113.11538485058,
        23.14158748159
    ],
    [
        113.11536616382,
        23.141588418413
    ],
    [
        113.11532201724,
        23.141583457365
    ],
    [
        113.11527408047,
        23.141584165146
    ],
    [
        113.1152534959,
        23.141579934439
    ],
    [
        113.11521286993,
        23.141576904007
    ],
    [
        113.11520664106,
        23.141577940571
    ],
    [
        113.11515599463,
        23.141577546851
    ],
    [
        113.11514353497,
        23.14157392363
    ],
    [
        113.115113201,
        23.141573689168
    ],
    [
        113.11508909477,
        23.141568891569
    ],
    [
        113.11506444726,
        23.141565718008
    ],
    [
        113.11504440586,
        23.141568548473
    ],
    [
        113.1150181342,
        23.141568890129
    ],
    [
        113.11501813267,
        23.141564007007
    ],
    [
        113.11500540383,
        23.141566622712
    ],
    [
        113.11497317211,
        23.141562850671
    ],
    [
        113.11495258648,
        23.141558625174
    ],
    [
        113.1149450059,
        23.141568605234
    ],
    [
        113.11494934057,
        23.141572164766
    ],
    [
        113.1149414917,
        23.141590281337
    ],
    [
        113.11494312491,
        23.141616065686
    ],
    [
        113.11493906451,
        23.141623359613
    ],
    [
        113.11494177686,
        23.141635587931
    ],
    [
        113.11494178073,
        23.141647795746
    ],
    [
        113.11493068114,
        23.141663988803
    ],
    [
        113.11493799473,
        23.141666214408
    ],
    [
        113.11493393236,
        23.141667268805
    ],
    [
        113.11493014516,
        23.141681889508
    ],
    [
        113.11493339733,
        23.141688153643
    ],
    [
        113.11493069623,
        23.141711192377
    ],
    [
        113.11491689457,
        23.141747168903
    ],
    [
        113.11492313559,
        23.141782754309
    ],
    [
        113.11491068236,
        23.141800565057
    ],
    [
        113.11490960011,
        23.14180408359
    ],
    [
        113.1148730327,
        23.141795669733
    ],
    [
        113.11481777849,
        23.14179417073
    ],
    [
        113.11481209101,
        23.141795484699
    ],
    [
        113.11480911152,
        23.141795191186
    ],
    [
        113.11477389943,
        23.14179194492
    ],
    [
        113.11474166912,
        23.141796589027
    ],
    [
        113.11473029117,
        23.1417905366
    ],
    [
        113.11467178412,
        23.141785493706
    ],
    [
        113.11463656829,
        23.141773299135
    ],
    [
        113.11460352047,
        23.14176519068
    ],
    [
        113.11459783312,
        23.141767590825
    ],
    [
        113.11457697454,
        23.141761199622
    ],
    [
        113.1145563886,
        23.141760507741
    ],
    [
        113.11453661282,
        23.141752497395
    ],
    [
        113.11450573217,
        23.141746848924
    ],
    [
        113.11444234471,
        23.141734186382
    ],
    [
        113.11439493978,
        23.141726795151
    ],
    [
        113.11435728632,
        23.141720559925
    ],
    [
        113.11434970015,
        23.141715351881
    ],
    [
        113.11433697064,
        23.141720416388
    ],
    [
        113.11429362375,
        23.141699764983
    ],
    [
        113.11429903836,
        23.141690579336
    ],
    [
        113.11430146379,
        23.141651531441
    ],
    [
        113.1142608311,
        23.141648533816
    ],
    [
        113.11424242778,
        23.141700220596
    ],
    [
        113.11423323153,
        23.141742748136
    ],
    [
        113.1142335097,
        23.141765266687
    ],
    [
        113.11423297163,
        23.141776656889
    ],
    [
        113.11422674736,
        23.141795060891
    ],
    [
        113.11422783787,
        23.14181649997
    ],
    [
        113.11421241237,
        23.141861425932
    ],
    [
        113.1141877599,
        23.141854744034
    ],
    [
        113.1141132648,
        23.141849075881
    ],
    [
        113.11404661922,
        23.141827188831
    ],
    [
        113.11403822082,
        23.141824690133
    ],
    [
        113.11400706798,
        23.141823393589
    ],
    [
        113.11397239114,
        23.141815292
    ],
    [
        113.11394069623,
        23.141814264873
    ],
    [
        113.11389464051,
        23.141803647699
    ],
    [
        113.11385969226,
        23.141796090249
    ],
    [
        113.11383287293,
        23.14179509849
    ],
    [
        113.11382799717,
        23.141796422637
    ],
    [
        113.11380225927,
        23.1417891992
    ],
    [
        113.11380361289,
        23.141786495282
    ],
    [
        113.11378925711,
        23.14179264022
    ],
    [
        113.11379061083,
        23.141790207572
    ],
    [
        113.11377841748,
        23.141781717518
    ],
    [
        113.11376460141,
        23.141781626765
    ],
    [
        113.11368442187,
        23.141807146696
    ],
    [
        113.11366573029,
        23.141810280901
    ],
    [
        113.11366220654,
        23.141804289821
    ],
    [
        113.11366003998,
        23.141806446075
    ],
    [
        113.11363755461,
        23.141806572061
    ],
    [
        113.11362779884,
        23.141797285477
    ],
    [
        113.11362563094,
        23.141795372517
    ],
    [
        113.11361777163,
        23.141786369522
    ],
    [
        113.11360259894,
        23.141781117579
    ],
    [
        113.11359879659,
        23.141751523147
    ],
    [
        113.11360096414,
        23.141752350915
    ],
    [
        113.11360366546,
        23.141728223939
    ],
    [
        113.11360854081,
        23.141724999849
    ],
    [
        113.11367460849,
        23.141618269053
    ],
    [
        113.11360714474,
        23.141594774414
    ],
    [
        113.11357923288,
        23.141569365979
    ],
    [
        113.11349469769,
        23.141537359002
    ],
    [
        113.11340880254,
        23.141492056857
    ],
    [
        113.11336924285,
        23.141475261872
    ],
    [
        113.11335000563,
        23.141469716739
    ],
    [
        113.11331044379,
        23.141447226821
    ],
    [
        113.11324866202,
        23.141412937046
    ],
    [
        113.11320395242,
        23.141392318364
    ],
    [
        113.1131670997,
        23.141372291443
    ],
    [
        113.11314514968,
        23.141357509745
    ],
    [
        113.1130676496,
        23.141315539339
    ],
    [
        113.11304732592,
        23.141304295905
    ],
    [
        113.11299475673,
        23.141280926006
    ],
    [
        113.11298500196,
        23.141277884482
    ],
    [
        113.11298770926,
        23.141270847041
    ],
    [
        113.11295383568,
        23.141251115869
    ],
    [
        113.1129102075,
        23.141229972534
    ],
    [
        113.11290668505,
        23.141229409491
    ],
    [
        113.11290208051,
        23.14123453712
    ],
    [
        113.11282484418,
        23.141178749437
    ],
    [
        113.11276630716,
        23.141138536383
    ],
    [
        113.11274000991,
        23.141087385939
    ],
    [
        113.11272319241,
        23.141023539367
    ],
    [
        113.11272019537,
        23.140965467977
    ],
    [
        113.1127461891,
        23.140902406271
    ],
    [
        113.11278139881,
        23.140852147967
    ],
    [
        113.11281768099,
        23.140760933364
    ],
    [
        113.11287320055,
        23.140669559803
    ],
    [
        113.11294985695,
        23.140591062729
    ],
    [
        113.11303681332,
        23.140531892865
    ],
    [
        113.11313379573,
        23.140483098608
    ],
    [
        113.11323457642,
        23.140460921343
    ],
    [
        113.1132654544,
        23.140430455381
    ],
    [
        113.11329579275,
        23.140409210491
    ],
    [
        113.11336106892,
        23.140343692847
    ],
    [
        113.11341686376,
        23.140283816476
    ],
    [
        113.11351573106,
        23.140212279077
    ],
    [
        113.1135257532,
        23.140205289438
    ],
    [
        113.11354661019,
        23.140191315605
    ],
    [
        113.11357233269,
        23.140132340762
    ],
    [
        113.11357801304,
        23.140095483026
    ],
    [
        113.11357256601,
        23.139972829715
    ],
    [
        113.11356497725,
        23.139958945943
    ],
    [
        113.11357174726,
        23.13994678164
    ],
    [
        113.11356388356,
        23.139915262956
    ],
    [
        113.11353597227,
        23.139883616575
    ],
    [
        113.11352594547,
        23.139870531398
    ],
    [
        113.11350453532,
        23.139835671782
    ],
    [
        113.11348258519,
        23.13980921882
    ],
    [
        113.11346415191,
        23.139760001001
    ],
    [
        113.11342567379,
        23.139725035472
    ],
    [
        113.11338069323,
        23.139689488171
    ],
    [
        113.11333408322,
        23.139637113291
    ],
    [
        113.11330292261,
        23.13961711756
    ],
    [
        113.11326579565,
        23.139569686977
    ],
    [
        113.11325008023,
        23.139561994984
    ],
    [
        113.11322840228,
        23.139544500828
    ],
    [
        113.1132053709,
        23.139533238266
    ],
    [
        113.11315442745,
        23.139493052012
    ],
    [
        113.11303628314,
        23.139412861208
    ],
    [
        113.11298398118,
        23.139360195802
    ],
    [
        113.11285039245,
        23.139293497622
    ],
    [
        113.11274063837,
        23.139194125451
    ],
    [
        113.11266828117,
        23.139129153822
    ],
    [
        113.11253956006,
        23.139046785729
    ],
    [
        113.11247506158,
        23.138997603805
    ],
    [
        113.11238888208,
        23.138932575277
    ],
    [
        113.1122940287,
        23.138858555543
    ],
    [
        113.11220594598,
        23.138769930085
    ],
    [
        113.11218832922,
        23.13875166328
    ],
    [
        113.11216420824,
        23.138729565354
    ],
    [
        113.1121392741,
        23.138706649953
    ],
    [
        113.11211135757,
        23.138674767772
    ],
    [
        113.11205010718,
        23.138627525983
    ],
    [
        113.11191811669,
        23.138512388752
    ],
    [
        113.1118208131,
        23.138407200718
    ],
    [
        113.11172486557,
        23.138317219148
    ],
    [
        113.1116945068,
        23.138273128537
    ],
    [
        113.11166035603,
        23.138244483603
    ],
    [
        113.11158012719,
        23.138170051331
    ],
    [
        113.11150259773,
        23.138020222975
    ],
    [
        113.11126029895,
        23.137968959075
    ],
    [
        113.1112478312,
        23.137964835921
    ],
    [
        113.11121530804,
        23.137966323247
    ],
    [
        113.11121584887,
        23.137956559709
    ],
    [
        113.11120229724,
        23.137955145148
    ],
    [
        113.11112993068,
        23.137945342629
    ],
    [
        113.11106271225,
        23.137930683338
    ],
    [
        113.11106811559,
        23.137786388228
    ],
    [
        113.11113042167,
        23.137493403396
    ],
    [
        113.11120166115,
        23.137020608252
    ],
    [
        113.11126858189,
        23.136671500469
    ],
    [
        113.1113577264,
        23.136149969182
    ],
    [
        113.11140054309,
        23.135956745231
    ],
    [
        113.11144607124,
        23.135703314174
    ],
    [
        113.1114832012,
        23.135427061105
    ],
    [
        113.11152684039,
        23.135110150038
    ],
    [
        113.11155801887,
        23.134776094584
    ],
    [
        113.11169379656,
        23.134723018325
    ],
    [
        113.11170843571,
        23.134625975025
    ],
    [
        113.11172334526,
        23.134547379258
    ],
    [
        113.11172524396,
        23.134518634309
    ],
    [
        113.11172877288,
        23.134422894981
    ],
    [
        113.11173474198,
        23.134317673176
    ],
    [
        113.11173312164,
        23.134238456576
    ],
    [
        113.11173475237,
        23.134176073847
    ],
    [
        113.11173611179,
        23.134120200174
    ],
    [
        113.11172906939,
        23.134074865729
    ],
    [
        113.11172608793,
        23.134080005523
    ],
    [
        113.11173720493,
        23.134010344015
    ],
    [
        113.11174615272,
        23.133956676779
    ],
    [
        113.11175103704,
        23.133887528259
    ],
    [
        113.11175185355,
        23.133850097998
    ],
    [
        113.1117521284,
        23.133809952541
    ],
    [
        113.11174996372,
        23.133775763193
    ],
    [
        113.11174671385,
        23.133754046715
    ],
    [
        113.11174129499,
        23.133742085315
    ],
    [
        113.1117434652,
        23.133720394744
    ],
    [
        113.11174427951,
        23.133707649336
    ],
    [
        113.11174319832,
        23.133680246753
    ],
    [
        113.11174401536,
        23.133641731526
    ],
    [
        113.11174998206,
        23.133598358224
    ],
    [
        113.11174402266,
        23.133573916229
    ],
    [
        113.1117472781,
        23.133543008009
    ],
    [
        113.11174890657,
        23.133521043644
    ],
    [
        113.11174647471,
        23.133458099472
    ],
    [
        113.11175081707,
        23.133404139329
    ],
    [
        113.1117494662,
        23.133369411502
    ],
    [
        113.11174648616,
        23.133361259438
    ],
    [
        113.1117543468,
        23.133348276521
    ],
    [
        113.11175218833,
        23.133270956961
    ],
    [
        113.11174488047,
        23.133198766799
    ],
    [
        113.11174624319,
        23.133139909878
    ],
    [
        113.11174977075,
        23.133106019249
    ],
    [
        113.1117549191,
        23.133111197817
    ],
    [
        113.11174282821,
        23.132426753792
    ],
    [
        113.11174391878,
        23.132388511641
    ],
    [
        113.11174392935,
        23.132327749961
    ],
    [
        113.11173960632,
        23.132254489787
    ],
    [
        113.1117420559,
        23.132196181151
    ],
    [
        113.11174070502,
        23.132173660352
    ],
    [
        113.11173637342,
        23.132149497796
    ],
    [
        113.11173393822,
        23.132128870645
    ],
    [
        113.11173936188,
        23.132109637264
    ],
    [
        113.1117342171,
        23.132086827138
    ],
    [
        113.11173665649,
        23.132084939972
    ],
    [
        113.11173774558,
        23.132058090733
    ],
    [
        113.1117401905,
        23.132027179122
    ],
    [
        113.1117472421,
        23.131998459587
    ],
    [
        113.11175185292,
        23.131978951153
    ],
    [
        113.11175212857,
        23.13195508189
    ],
    [
        113.11174536048,
        23.13191951493
    ],
    [
        113.11175457918,
        23.131896230958
    ],
    [
        113.11175350182,
        23.13186286127
    ],
    [
        113.11175621173,
        23.131863416752
    ],
    [
        113.11175214877,
        23.13185308957
    ],
    [
        113.11175513017,
        23.131851205042
    ],
    [
        113.11173887396,
        23.131831596903
    ],
    [
        113.11172966166,
        23.131822601528
    ],
    [
        113.11171746936,
        23.131808438197
    ],
    [
        113.11170934139,
        23.131797820609
    ],
    [
        113.11139606491,
        23.131730734292
    ],
    [
        113.11136517047,
        23.131721374145
    ],
    [
        113.11086893148,
        23.131605086155
    ],
    [
        113.1108271936,
        23.131588916535
    ],
    [
        113.11075916497,
        23.131565593395
    ],
    [
        113.11073395961,
        23.131553831767
    ],
    [
        113.11071010723,
        23.131552112364
    ],
    [
        113.11069491535,
        23.131611730324
    ],
    [
        113.11069680847,
        23.131631810483
    ],
    [
        113.11068080773,
        23.131671895177
    ],
    [
        113.11067972225,
        23.131677858663
    ],
    [
        113.11068107713,
        23.13167976262
    ],
    [
        113.11067782361,
        23.131683819051
    ],
    [
        113.11065203627,
        23.131864377574
    ],
    [
        113.1106490368,
        23.131954694599
    ],
    [
        113.11064116824,
        23.131995353331
    ],
    [
        113.11059264956,
        23.131990559734
    ],
    [
        113.11056147906,
        23.131982577349
    ],
    [
        113.11050103599,
        23.131961468291
    ],
    [
        113.11037852005,
        23.131926307092
    ],
    [
        113.11033569225,
        23.131918018694
    ],
    [
        113.11032267201,
        23.131962459273
    ],
    [
        113.11031995596,
        23.131989846719
    ],
    [
        113.11030748132,
        23.132016928983
    ],
    [
        113.11027901539,
        23.132032563367
    ],
    [
        113.11025841445,
        23.132027881175
    ],
    [
        113.11023672647,
        23.132037029759
    ],
    [
        113.1102345579,
        23.132036751112
    ],
    [
        113.11022696733,
        23.132038624076
    ],
    [
        113.11015404732,
        23.132034852253
    ],
    [
        113.1101543181,
        23.132036480696
    ],
    [
        113.11014781139,
        23.132040256621
    ],
    [
        113.11010741867,
        23.132046633127
    ],
    [
        113.11008299503,
        23.132185707865
    ],
    [
        113.11012663615,
        23.132205381878
    ],
    [
        113.11016512746,
        23.132219072751
    ],
    [
        113.11020226349,
        23.132230590345
    ],
    [
        113.1102312675,
        23.132238826405
    ],
    [
        113.11023560471,
        23.132239112434
    ],
    [
        113.11022556439,
        23.13229739861
    ],
    [
        113.11014336557,
        23.132663863194
    ],
    [
        113.11014119737,
        23.132660872146
    ],
    [
        113.11005743209,
        23.132660325879
    ],
    [
        113.11005173942,
        23.132659222388
    ],
    [
        113.11000619916,
        23.132642257783
    ],
    [
        113.10989099119,
        23.132601206699
    ],
    [
        113.10977063263,
        23.132543334438
    ],
    [
        113.10981076751,
        23.132471300187
    ],
    [
        113.10981781574,
        23.132473491548
    ],
    [
        113.10980832953,
        23.132459899996
    ],
    [
        113.10970450369,
        23.132421344431
    ],
    [
        113.10967170063,
        23.132416637733
    ],
    [
        113.10967712783,
        23.132387086336
    ],
    [
        113.10971564725,
        23.132259436242
    ],
    [
        113.10963242301,
        23.132228272165
    ],
    [
        113.10957603725,
        23.132199359411
    ],
    [
        113.10952480362,
        23.132162326063
    ],
    [
        113.10949254505,
        23.132139723322
    ],
    [
        113.10947329703,
        23.132132889604
    ],
    [
        113.10943317731,
        23.13210185841
    ],
    [
        113.1094055269,
        23.132081440642
    ],
    [
        113.10935890069,
        23.132045783653
    ],
    [
        113.10928516033,
        23.132016298524
    ],
    [
        113.10926021911,
        23.132003215278
    ],
    [
        113.10918457968,
        23.131972918465
    ],
    [
        113.10915096113,
        23.131963071664
    ],
    [
        113.10910270098,
        23.13195346242
    ],
    [
        113.10910243149,
        23.131945052833
    ],
    [
        113.10905850976,
        23.131932200756
    ],
    [
        113.1090631253,
        23.131900745761
    ],
    [
        113.10906828734,
        23.131848405345
    ],
    [
        113.10907046026,
        23.13182942249
    ],
    [
        113.10908349718,
        23.131720136879
    ],
    [
        113.10908133259,
        23.131698431337
    ],
    [
        113.10908215025,
        23.131678089078
    ],
    [
        113.10908649351,
        23.13165395753
    ],
    [
        113.10909247217,
        23.131589684047
    ],
    [
        113.10901465407,
        23.131595742327
    ],
    [
        113.10890538366,
        23.131593870651
    ],
    [
        113.10888992808,
        23.131594922031
    ],
    [
        113.10882919256,
        23.131586654308
    ],
    [
        113.10881780384,
        23.131588529087
    ],
    [
        113.10880234782,
        23.131590395484
    ],
    [
        113.10868873672,
        23.131578228938
    ],
    [
        113.10867951621,
        23.131583635797
    ],
    [
        113.10857050899,
        23.131586681087
    ],
    [
        113.10847533034,
        23.131584065625
    ],
    [
        113.10843167592,
        23.131566085698
    ],
    [
        113.10842381168,
        23.131567428278
    ],
    [
        113.10839236321,
        23.131532924658
    ],
    [
        113.10836878157,
        23.131485143711
    ],
    [
        113.10836553082,
        23.131469947949
    ],
    [
        113.10836201638,
        23.131421116142
    ],
    [
        113.10837558894,
        23.131359292943
    ],
    [
        113.1083807438,
        23.131347908986
    ],
    [
        113.10840678686,
        23.131301840238
    ],
    [
        113.10841980781,
        23.131281247397
    ],
    [
        113.10842360677,
        23.131270132558
    ],
    [
        113.10843879802,
        23.131245474911
    ],
    [
        113.10846348215,
        23.131212425406
    ],
    [
        113.10847189333,
        23.131191282533
    ],
    [
        113.10847162663,
        23.131172294262
    ],
    [
        113.10847488739,
        23.131143818393
    ],
    [
        113.10848628854,
        23.131093114304
    ],
    [
        113.10849444154,
        23.13101880542
    ],
    [
        113.10850530266,
        23.130959963016
    ],
    [
        113.10850667257,
        23.130903273519
    ],
    [
        113.1085102089,
        23.130858794392
    ],
    [
        113.10848283748,
        23.130793915466
    ],
    [
        113.10848501244,
        23.130771947868
    ],
    [
        113.10848421097,
        23.130725290918
    ],
    [
        113.10848015375,
        23.130685680732
    ],
    [
        113.10848233163,
        23.130653134303
    ],
    [
        113.10849672022,
        23.130589958325
    ],
    [
        113.10849998873,
        23.130535713742
    ],
    [
        113.1085024296,
        23.130534361897
    ],
    [
        113.10850189106,
        23.1305202558
    ],
    [
        113.10850162407,
        23.130504793935
    ],
    [
        113.10850706268,
        23.130448654587
    ],
    [
        113.10850326976,
        23.130436170113
    ],
    [
        113.10852225326,
        23.130429423364
    ],
    [
        113.10852930625,
        23.130419671213
    ],
    [
        113.10857974703,
        23.130404303611
    ],
    [
        113.10861120587,
        23.130389715675
    ],
    [
        113.10860525638,
        23.13033192767
    ],
    [
        113.1086093324,
        23.130301283998
    ],
    [
        113.10861150543,
        23.130287996817
    ],
    [
        113.10861316054,
        23.130188993173
    ],
    [
        113.10860856832,
        23.130128224105
    ],
    [
        113.10860804706,
        23.130056070312
    ],
    [
        113.10860317477,
        23.13002676592
    ],
    [
        113.10850800622,
        23.12999268257
    ],
    [
        113.10845052586,
        23.129968167164
    ],
    [
        113.10839250046,
        23.129950706413
    ],
    [
        113.10837623179,
        23.129944982474
    ],
    [
        113.10824038771,
        23.129893223357
    ],
    [
        113.10812596229,
        23.129847208733
    ],
    [
        113.10800963873,
        23.129792794955
    ],
    [
        113.10790903693,
        23.129755502223
    ],
    [
        113.10789792034,
        23.12974735077
    ],
    [
        113.10784884086,
        23.12972287805
    ],
    [
        113.10786704321,
        23.129620910166
    ],
    [
        113.10786462786,
        23.129540888581
    ],
    [
        113.107857592,
        23.129493140128
    ],
    [
        113.10786007218,
        23.129372165991
    ],
    [
        113.10787338011,
        23.129314134958
    ],
    [
        113.10788370818,
        23.129246606731
    ],
    [
        113.10788996088,
        23.129201587208
    ],
    [
        113.10791721585,
        23.128812109248
    ],
    [
        113.10794360511,
        23.128582667913
    ],
    [
        113.10793628483,
        23.128577233545
    ],
    [
        113.10791242594,
        23.128559843357
    ],
    [
        113.10779666081,
        23.12845934214
    ],
    [
        113.1076971524,
        23.128395217635
    ],
    [
        113.10760659545,
        23.128322973715
    ],
    [
        113.10759357969,
        23.128316451151
    ],
    [
        113.10754015749,
        23.128297684868
    ],
    [
        113.10750327755,
        23.128283004404
    ],
    [
        113.10746449133,
        23.128287853301
    ],
    [
        113.10743736777,
        23.128291628127
    ],
    [
        113.10741132296,
        23.128311136767
    ],
    [
        113.10737469718,
        23.128338775299
    ],
    [
        113.10733997296,
        23.128358007841
    ],
    [
        113.1073342774,
        23.128357461202
    ],
    [
        113.10729412651,
        23.128381573736
    ],
    [
        113.10726346126,
        23.128424681233
    ],
    [
        113.10724337529,
        23.128464270146
    ],
    [
        113.10723496325,
        23.128474572154
    ],
    [
        113.10722790959,
        23.128478907655
    ],
    [
        113.10721570442,
        23.128478086337
    ],
    [
        113.1071891231,
        23.128479155299
    ],
    [
        113.10718451171,
        23.128480237572
    ],
    [
        113.1071649843,
        23.128476157605
    ],
    [
        113.10692739681,
        23.128421799621
    ],
    [
        113.1068183541,
        23.128421496065
    ],
    [
        113.10685431642,
        23.12801545062
    ],
    [
        113.10686140031,
        23.127936791545
    ],
    [
        113.106893578,
        23.127522610997
    ],
    [
        113.10694424211,
        23.126441998422
    ],
    [
        113.10697314776,
        23.125581093993
    ],
    [
        113.10795252006,
        23.12507443362
    ],
    [
        113.10810470237,
        23.124992999498
    ],
    [
        113.10798660282,
        23.124737601868
    ],
    [
        113.10797685365,
        23.124712635169
    ],
    [
        113.10792862729,
        23.124629031683
    ],
    [
        113.10798076129,
        23.122711474068
    ],
    [
        113.10789045974,
        23.122700780301
    ],
    [
        113.10743382532,
        23.122570391173
    ],
    [
        113.107178984,
        23.122395540709
    ],
    [
        113.10699013288,
        23.122087601333
    ],
    [
        113.106786593,
        23.121835837301
    ],
    [
        113.10667917862,
        23.121830123989
    ],
    [
        113.10629586487,
        23.121842083174
    ],
    [
        113.10624476361,
        23.121991001994
    ],
    [
        113.10636162543,
        23.122080751479
    ],
    [
        113.10637137081,
        23.12211166999
    ],
    [
        113.10633471624,
        23.12215995596
    ],
    [
        113.10627795466,
        23.122256798499
    ],
    [
        113.10591144168,
        23.122255057659
    ],
    [
        113.1059911018,
        23.122409885468
    ],
    [
        113.1063000643,
        23.122886049563
    ],
    [
        113.10628213643,
        23.122922941559
    ],
    [
        113.10621008487,
        23.123180904408
    ],
    [
        113.10620235787,
        23.123393553559
    ],
    [
        113.10617673968,
        23.123586680511
    ],
    [
        113.10615612201,
        23.123586416761
    ],
    [
        113.10610429923,
        23.123597286665
    ],
    [
        113.10603946122,
        23.123595959732
    ],
    [
        113.10595590449,
        23.123591934667
    ],
    [
        113.10592009416,
        23.123590056635
    ],
    [
        113.10580588592,
        23.12357304259
    ],
    [
        113.10567539075,
        23.123565547064
    ],
    [
        113.10553486664,
        23.123536378156
    ],
    [
        113.1054296137,
        23.123503121566
    ],
    [
        113.10534959356,
        23.123467948035
    ],
    [
        113.10526659701,
        23.123417323735
    ],
    [
        113.1051456243,
        23.123346412498
    ],
    [
        113.10502142387,
        23.123225341435
    ],
    [
        113.1049688368,
        23.123137809618
    ],
    [
        113.10488017663,
        23.123023212787
    ],
    [
        113.10483110491,
        23.122954126146
    ],
    [
        113.10481624016,
        23.122859490163
    ],
    [
        113.10479730451,
        23.122766217266
    ],
    [
        113.104812817,
        23.122695671863
    ],
    [
        113.10483946731,
        23.122606393953
    ],
    [
        113.10485413958,
        23.122576806461
    ],
    [
        113.10485903378,
        23.122561609793
    ],
    [
        113.10488785924,
        23.122466091438
    ],
    [
        113.10492646868,
        23.122347504464
    ],
    [
        113.10499359457,
        23.122191718642
    ],
    [
        113.10508976163,
        23.122025048
    ],
    [
        113.10517398441,
        23.121865453396
    ],
    [
        113.10526667477,
        23.121623130507
    ],
    [
        113.10530770449,
        23.121537916191
    ],
    [
        113.10535743587,
        23.121425028433
    ],
    [
        113.10540392347,
        23.121294787929
    ],
    [
        113.10541269083,
        23.121173539584
    ],
    [
        113.10540753753,
        23.121170832802
    ],
    [
        113.10490828993,
        23.121147614238
    ],
    [
        113.10511627005,
        23.120217278555
    ],
    [
        113.10515110284,
        23.120080805862
    ],
    [
        113.10523794205,
        23.119704506306
    ],
    [
        113.10498020965,
        23.119648981222
    ],
    [
        113.10505284953,
        23.119399893032
    ],
    [
        113.10510102205,
        23.119212410846
    ],
    [
        113.10513724643,
        23.119037694281
    ],
    [
        113.10520610835,
        23.118766382149
    ],
    [
        113.10524014867,
        23.11861092913
    ],
    [
        113.10529485484,
        23.118400665911
    ],
    [
        113.10529542868,
        23.118361880439
    ],
    [
        113.10454380897,
        23.118332648726
    ],
    [
        113.10411069805,
        23.118315102703
    ],
    [
        113.10373889153,
        23.118297296364
    ],
    [
        113.10328237101,
        23.118280955432
    ],
    [
        113.10291430537,
        23.118265588598
    ],
    [
        113.10261842988,
        23.118244927117
    ],
    [
        113.10238441855,
        23.118245803031
    ],
    [
        113.10227309846,
        23.118260883088
    ],
    [
        113.10220464559,
        23.118308076916
    ],
    [
        113.10214702851,
        23.118383980402
    ],
    [
        113.10213317103,
        23.118398140332
    ],
    [
        113.10208697495,
        23.118450675407
    ],
    [
        113.10197568408,
        23.118421847329
    ],
    [
        113.10176070709,
        23.118352799788
    ],
    [
        113.10153568001,
        23.118278144501
    ],
    [
        113.1013340074,
        23.118189047697
    ],
    [
        113.10106527656,
        23.118075099291
    ],
    [
        113.10105658861,
        23.118073244511
    ],
    [
        113.1007492823,
        23.117960380521
    ],
    [
        113.10050930246,
        23.117856447658
    ],
    [
        113.10023320009,
        23.117742467074
    ],
    [
        113.09986666857,
        23.117595469229
    ],
    [
        113.09952725951,
        23.117468214106
    ],
    [
        113.0992578909,
        23.11736663031
    ],
    [
        113.09906916937,
        23.117287342016
    ],
    [
        113.09890079583,
        23.117231539305
    ],
    [
        113.0987775045,
        23.117185207048
    ],
    [
        113.09864687934,
        23.117134600561
    ],
    [
        113.09861048228,
        23.117127809216
    ],
    [
        113.09854042548,
        23.117088986772
    ],
    [
        113.09841604937,
        23.117031580254
    ],
    [
        113.09836015603,
        23.116947371267
    ],
    [
        113.09829284719,
        23.116868674162
    ],
    [
        113.09822255411,
        23.116784307697
    ],
    [
        113.09812808256,
        23.116697416156
    ],
    [
        113.09802214245,
        23.116675983462
    ],
    [
        113.0979042441,
        23.116656551425
    ],
    [
        113.09777059226,
        23.116628304698
    ],
    [
        113.09771356137,
        23.11659702257
    ],
    [
        113.097611455,
        23.116532472138
    ],
    [
        113.09750093619,
        23.116453623906
    ],
    [
        113.09741432016,
        23.116382455634
    ],
    [
        113.09734915792,
        23.116324135435
    ],
    [
        113.09726226633,
        23.116255150045
    ],
    [
        113.09715798395,
        23.116184960343
    ],
    [
        113.09708275506,
        23.1161381299
    ],
    [
        113.09695836191,
        23.116067042219
    ],
    [
        113.0968904654,
        23.116022873149
    ],
    [
        113.09683343737,
        23.115979427516
    ],
    [
        113.09677724916,
        23.115907499516
    ],
    [
        113.09673791564,
        23.115828104212
    ],
    [
        113.09668416831,
        23.115761041114
    ],
    [
        113.09667493971,
        23.115748646062
    ],
    [
        113.09661848354,
        23.115671303391
    ],
    [
        113.09655440931,
        23.115603523384
    ],
    [
        113.09648325229,
        23.115554252541
    ],
    [
        113.09641482812,
        23.115487060999
    ],
    [
        113.09633011218,
        23.115403205111
    ],
    [
        113.09624349675,
        23.115315032846
    ],
    [
        113.09618322118,
        23.115250491943
    ],
    [
        113.09615470413,
        23.115229056301
    ],
    [
        113.09611371173,
        23.115178173776
    ],
    [
        113.09602519324,
        23.11508786444
    ],
    [
        113.09596055044,
        23.115042088623
    ],
    [
        113.09589507964,
        23.115009613403
    ],
    [
        113.09577825164,
        23.114964066652
    ],
    [
        113.09563099031,
        23.114907431212
    ],
    [
        113.09553943436,
        23.114862748886
    ],
    [
        113.0954350866,
        23.114835284195
    ],
    [
        113.09533509947,
        23.114793139501
    ],
    [
        113.09523999414,
        23.114761260334
    ],
    [
        113.09514951157,
        23.114725816251
    ],
    [
        113.09508456858,
        23.1147017846
    ],
    [
        113.09499918871,
        23.114731933649
    ],
    [
        113.09490349198,
        23.114747004955
    ],
    [
        113.09484448877,
        23.114764691846
    ],
    [
        113.09476211819,
        23.114770416277
    ],
    [
        113.09465776846,
        23.114731351323
    ],
    [
        113.09455042704,
        23.114692054511
    ],
    [
        113.0942169128,
        23.114641599253
    ],
    [
        113.09406872575,
        23.114667054851
    ],
    [
        113.09350520084,
        23.114887501923
    ],
    [
        113.09324333532,
        23.114925441798
    ],
    [
        113.09313948484,
        23.115210045435
    ],
    [
        113.09311877114,
        23.115264796762
    ],
    [
        113.09304914559,
        23.115285394946
    ],
    [
        113.09293929127,
        23.115290189122
    ],
    [
        113.09274896151,
        23.115280744396
    ],
    [
        113.09267278111,
        23.115329372771
    ],
    [
        113.09260627083,
        23.115510243682
    ],
    [
        113.09257409985,
        23.115604735734
    ],
    [
        113.09254436378,
        23.115713302858
    ],
    [
        113.09253994422,
        23.11579092283
    ],
    [
        113.09253013326,
        23.115815448607
    ],
    [
        113.09252377907,
        23.115928620862
    ],
    [
        113.0925220661,
        23.116021125715
    ],
    [
        113.09251248317,
        23.116095823847
    ],
    [
        113.09250590321,
        23.116157196806
    ],
    [
        113.09247813854,
        23.116189530497
    ],
    [
        113.09243897122,
        23.11620084586
    ],
    [
        113.09237070931,
        23.116209798261
    ],
    [
        113.092270093,
        23.11621154912
    ],
    [
        113.09214827339,
        23.116202715169
    ],
    [
        113.09203133396,
        23.116208477295
    ],
    [
        113.09193343196,
        23.116210760261
    ],
    [
        113.09193699196,
        23.116182510135
    ],
    [
        113.09191691306,
        23.116130954385
    ],
    [
        113.09189845731,
        23.116089142729
    ],
    [
        113.09186725203,
        23.116010874161
    ],
    [
        113.09180570591,
        23.115799542924
    ],
    [
        113.09177831184,
        23.115717161028
    ],
    [
        113.09170459649,
        23.115430044815
    ],
    [
        113.09166591594,
        23.115197281421
    ],
    [
        113.09157862422,
        23.114889457789
    ],
    [
        113.09154693301,
        23.114748823326
    ],
    [
        113.09151793349,
        23.114639074182
    ],
    [
        113.09147168,
        23.114364644956
    ],
    [
        113.09140366122,
        23.114100526902
    ],
    [
        113.09133073149,
        23.113854103209
    ],
    [
        113.09126540214,
        23.11362413058
    ],
    [
        113.09124912114,
        23.113584469424
    ],
    [
        113.09116096712,
        23.113332823839
    ],
    [
        113.09101662467,
        23.112964742339
    ],
    [
        113.09086901836,
        23.112596717005
    ],
    [
        113.09062325119,
        23.111918912447
    ],
    [
        113.0903787806,
        23.111305949072
    ],
    [
        113.09031338021,
        23.111151143916
    ],
    [
        113.09017424097,
        23.110746187804
    ],
    [
        113.09003750444,
        23.110386774594
    ],
    [
        113.08994552305,
        23.110154506017
    ],
    [
        113.08982338722,
        23.109882242506
    ],
    [
        113.08965591764,
        23.109515143329
    ],
    [
        113.08948025776,
        23.109175294711
    ],
    [
        113.08932420661,
        23.108811054261
    ],
    [
        113.089251476,
        23.108637951044
    ],
    [
        113.08922107049,
        23.108575997296
    ],
    [
        113.08919636845,
        23.108523185469
    ],
    [
        113.08919668973,
        23.108474634889
    ],
    [
        113.08920899193,
        23.108415068755
    ],
    [
        113.08921774877,
        23.108364230806
    ],
    [
        113.08924500449,
        23.108313134976
    ],
    [
        113.08927389762,
        23.10825686384
    ],
    [
        113.08946643185,
        23.108054043285
    ],
    [
        113.0896178825,
        23.10785479072
    ],
    [
        113.08977694152,
        23.107661143168
    ],
    [
        113.08988100503,
        23.107511920161
    ],
    [
        113.08995486886,
        23.107367451063
    ],
    [
        113.09005708854,
        23.107157242332
    ],
    [
        113.0901189874,
        23.107008059902
    ],
    [
        113.09014200203,
        23.106845840538
    ],
    [
        113.09013417274,
        23.106788178508
    ],
    [
        113.09011172604,
        23.106661012627
    ],
    [
        113.09011814166,
        23.10650525375
    ],
    [
        113.09013376801,
        23.106386255414
    ],
    [
        113.09017305439,
        23.106271821863
    ],
    [
        113.09021748157,
        23.106183898779
    ],
    [
        113.09033732452,
        23.106026628374
    ],
    [
        113.09040701913,
        23.105965766544
    ],
    [
        113.09043839449,
        23.105872598301
    ],
    [
        113.09044582911,
        23.105784086505
    ],
    [
        113.09046373507,
        23.105563358566
    ],
    [
        113.0905081422,
        23.105227831723
    ],
    [
        113.09054499483,
        23.104831926356
    ],
    [
        113.09057148185,
        23.104464634752
    ],
    [
        113.09059802944,
        23.104037405892
    ],
    [
        113.09063439605,
        23.10358238532
    ],
    [
        113.09063857117,
        23.103488764057
    ],
    [
        113.09066744529,
        23.103178666909
    ],
    [
        113.09065772836,
        23.102836530286
    ],
    [
        113.09066271043,
        23.102751305836
    ],
    [
        113.090659472,
        23.102726125942
    ],
    [
        113.09061295798,
        23.102729447979
    ],
    [
        113.09022643791,
        23.102738093793
    ],
    [
        113.08985296653,
        23.102736618008
    ],
    [
        113.08953389427,
        23.102725253483
    ],
    [
        113.08925179421,
        23.102726721468
    ],
    [
        113.08901867386,
        23.102707746845
    ],
    [
        113.08872602294,
        23.102634051347
    ],
    [
        113.08849672768,
        23.102585256962
    ],
    [
        113.08824647949,
        23.10253435358
    ],
    [
        113.08798103368,
        23.102438414025
    ],
    [
        113.08775448986,
        23.102340852221
    ],
    [
        113.08776157805,
        23.102326916135
    ],
    [
        113.08776758253,
        23.10230838552
    ],
    [
        113.08777522771,
        23.102281694522
    ],
    [
        113.08778666515,
        23.102271762554
    ],
    [
        113.08778585327,
        23.102267435193
    ],
    [
        113.08778259261,
        23.102263143905
    ],
    [
        113.08778396287,
        23.10225336025
    ],
    [
        113.08777907269,
        23.10224610969
    ],
    [
        113.08776304581,
        23.102220309962
    ],
    [
        113.08775761718,
        23.102207372035
    ],
    [
        113.087757898,
        23.102198689254
    ],
    [
        113.08775708665,
        23.102193819481
    ],
    [
        113.0877761518,
        23.102174553943
    ],
    [
        113.08778514073,
        23.102164386836
    ],
    [
        113.08778406548,
        23.102151384713
    ],
    [
        113.08778979729,
        23.10213340059
    ],
    [
        113.08779172997,
        23.102105437747
    ],
    [
        113.08779750101,
        23.102048399172
    ],
    [
        113.0877964094,
        23.102051669737
    ],
    [
        113.08782144396,
        23.102048589203
    ],
    [
        113.08781334188,
        23.101988500319
    ],
    [
        113.08784789526,
        23.101989348186
    ],
    [
        113.08784435844,
        23.101989128966
    ],
    [
        113.08785822737,
        23.101996247751
    ],
    [
        113.08786910363,
        23.102003139379
    ],
    [
        113.08787345451,
        23.102005516351
    ],
    [
        113.08787753113,
        23.102010067021
    ],
    [
        113.08788352104,
        23.102005910967
    ],
    [
        113.08789004096,
        23.102015849951
    ],
    [
        113.08789793299,
        23.102014106896
    ],
    [
        113.08791534953,
        23.102010596943
    ],
    [
        113.08791726391,
        23.102000805398
    ],
    [
        113.08798288719,
        23.101948314869
    ],
    [
        113.08803546164,
        23.101884626323
    ],
    [
        113.08807576128,
        23.101852035819
    ],
    [
        113.08811660761,
        23.101816726123
    ],
    [
        113.0881708028,
        23.101763865991
    ],
    [
        113.0881882392,
        23.101740017636
    ],
    [
        113.08820593649,
        23.101727285176
    ],
    [
        113.08821112191,
        23.10171120867
    ],
    [
        113.08824734425,
        23.101674070407
    ],
    [
        113.08829637711,
        23.101613423621
    ],
    [
        113.08834813524,
        23.101547857012
    ],
    [
        113.08838490517,
        23.101506645353
    ],
    [
        113.08842032272,
        23.101457317639
    ],
    [
        113.08851238217,
        23.101354562647
    ],
    [
        113.08852382347,
        23.101339753281
    ],
    [
        113.08854889144,
        23.101301153573
    ],
    [
        113.08857857979,
        23.101267098607
    ],
    [
        113.08860826021,
        23.10124090927
    ],
    [
        113.08871803818,
        23.101100755699
    ],
    [
        113.08874201107,
        23.101068411981
    ],
    [
        113.0887703419,
        23.101030853694
    ],
    [
        113.08881801412,
        23.100967256648
    ],
    [
        113.08881937762,
        23.10096398281
    ],
    [
        113.0889828203,
        23.100748502533
    ],
    [
        113.08899780476,
        23.10072632356
    ],
    [
        113.08916503839,
        23.100524638011
    ],
    [
        113.08923128618,
        23.100380243045
    ],
    [
        113.08925173252,
        23.100336022063
    ],
    [
        113.08929426733,
        23.100237251989
    ],
    [
        113.0892910212,
        23.100218583723
    ],
    [
        113.08927832622,
        23.100126006862
    ],
    [
        113.08926183524,
        23.100020464898
    ],
    [
        113.0892510164,
        23.09995633903
    ],
    [
        113.08923610812,
        23.099901220163
    ],
    [
        113.08923474897,
        23.099900154282
    ],
    [
        113.08923395586,
        23.099876570115
    ],
    [
        113.08921715137,
        23.099813070347
    ],
    [
        113.08921878997,
        23.099806538445
    ],
    [
        113.08920959308,
        23.099752696115
    ],
    [
        113.08920335219,
        23.099736239476
    ],
    [
        113.08920146056,
        23.099723247831
    ],
    [
        113.0891946848,
        23.099697306351
    ],
    [
        113.0891870958,
        23.099668392953
    ],
    [
        113.08919282849,
        23.099647972113
    ],
    [
        113.08919228862,
        23.0996436403
    ],
    [
        113.08919093551,
        23.099636336543
    ],
    [
        113.08919013018,
        23.099625228195
    ],
    [
        113.08917925976,
        23.099613718108
    ],
    [
        113.08917981201,
        23.099605302884
    ],
    [
        113.08917411805,
        23.099585855385
    ],
    [
        113.08915238897,
        23.099550630864
    ],
    [
        113.08915483816,
        23.09954978296
    ],
    [
        113.08914586962,
        23.099540687351
    ],
    [
        113.08914996844,
        23.099521916495
    ],
    [
        113.08911260285,
        23.099339915561
    ],
    [
        113.08909151752,
        23.099201080448
    ],
    [
        113.08907577381,
        23.099164959225
    ],
    [
        113.08905412482,
        23.099045930736
    ],
    [
        113.08904655749,
        23.098993964679
    ],
    [
        113.08902029594,
        23.098861712039
    ],
    [
        113.08901730263,
        23.098862567789
    ],
    [
        113.08901432437,
        23.098847693117
    ],
    [
        113.08897614132,
        23.098664078814
    ],
    [
        113.08891814658,
        23.098429214859
    ],
    [
        113.08889447905,
        23.098428464524
    ],
    [
        113.08889475084,
        23.098428731892
    ],
    [
        113.08889693679,
        23.098418666174
    ],
    [
        113.08883300377,
        23.098132358526
    ],
    [
        113.08877224498,
        23.097940118146
    ],
    [
        113.08876382802,
        23.097922337783
    ],
    [
        113.0886418613,
        23.097723649817
    ],
    [
        113.08857173633,
        23.09736014336
    ],
    [
        113.08851540584,
        23.097080516928
    ],
    [
        113.08845205703,
        23.096737800066
    ],
    [
        113.08837026707,
        23.09632564875
    ],
    [
        113.08815266864,
        23.095342664225
    ],
    [
        113.08795570667,
        23.094370516382
    ],
    [
        113.08787252832,
        23.093953790292
    ],
    [
        113.08786521255,
        23.093917283354
    ],
    [
        113.08793296651,
        23.093909779799
    ],
    [
        113.08797025333,
        23.093895130274
    ],
    [
        113.08809460748,
        23.093876227176
    ],
    [
        113.08857997641,
        23.093873284141
    ],
    [
        113.0887565443,
        23.093869408951
    ],
    [
        113.08899240853,
        23.093873393529
    ],
    [
        113.08916817973,
        23.093836210007
    ],
    [
        113.08977168421,
        23.093668666613
    ],
    [
        113.09019228797,
        23.093585141836
    ],
    [
        113.09057480494,
        23.09348405278
    ],
    [
        113.0909161928,
        23.093433218954
    ],
    [
        113.09124799018,
        23.093451470274
    ],
    [
        113.09127681207,
        23.093460053784
    ],
    [
        113.09163194342,
        23.093525553796
    ],
    [
        113.09193998967,
        23.093617208466
    ],
    [
        113.09196908012,
        23.09362661538
    ],
    [
        113.09196961999,
        23.0936314907
    ],
    [
        113.09221372438,
        23.093750566164
    ],
    [
        113.09253578504,
        23.093962866493
    ],
    [
        113.09277629232,
        23.094131710755
    ],
    [
        113.09292224432,
        23.094208661948
    ],
    [
        113.09309731034,
        23.094257628987
    ],
    [
        113.09310818607,
        23.094258046522
    ],
    [
        113.09330203871,
        23.094270751239
    ],
    [
        113.09339312839,
        23.094264025332
    ],
    [
        113.09368569147,
        23.094246381645
    ],
    [
        113.09430861336,
        23.094156634915
    ],
    [
        113.09481622168,
        23.094065366951
    ],
    [
        113.09519008116,
        23.093945783266
    ],
    [
        113.09569339463,
        23.093705454322
    ],
    [
        113.09582989302,
        23.093634724193
    ],
    [
        113.09617313765,
        23.093323419118
    ],
    [
        113.09630776126,
        23.093204751295
    ],
    [
        113.09640594118,
        23.093115717081
    ],
    [
        113.09649759174,
        23.093033258058
    ],
    [
        113.09660202488,
        23.092936317862
    ],
    [
        113.09669149321,
        23.092859859106
    ],
    [
        113.09692101273,
        23.09265255227
    ],
    [
        113.09714342822,
        23.092481962369
    ],
    [
        113.09722119491,
        23.092415946535
    ],
    [
        113.09732696668,
        23.092326107699
    ],
    [
        113.09748520935,
        23.092195709433
    ],
    [
        113.09757601575,
        23.092126355466
    ],
    [
        113.0976532135,
        23.092085052847
    ],
    [
        113.09779184594,
        23.092003942482
    ],
    [
        113.09799709242,
        23.091854527155
    ],
    [
        113.09818087603,
        23.091694459668
    ],
    [
        113.09838449458,
        23.091522068626
    ],
    [
        113.0985636579,
        23.09134582038
    ],
    [
        113.09872323612,
        23.091195232891
    ],
    [
        113.09898532445,
        23.090903463356
    ],
    [
        113.09913323273,
        23.090718836746
    ],
    [
        113.09916695418,
        23.090665991988
    ],
    [
        113.09918108862,
        23.090653149537
    ],
    [
        113.09918489,
        23.09065529387
    ],
    [
        113.09918979905,
        23.090628138389
    ],
    [
        113.09918600627,
        23.090614060036
    ],
    [
        113.09917459958,
        23.090611153018
    ],
    [
        113.09916428236,
        23.090604170401
    ],
    [
        113.09913985093,
        23.09058182301
    ],
    [
        113.09912356083,
        23.090570270171
    ],
    [
        113.09907305046,
        23.090549456693
    ],
    [
        113.09903747548,
        23.090535052778
    ],
    [
        113.09903584191,
        23.090540217228
    ],
    [
        113.09902796807,
        23.09053484649
    ],
    [
        113.09903095657,
        23.090534283617
    ],
    [
        113.09901276189,
        23.0905265425
    ],
    [
        113.09900461734,
        23.09051981764
    ],
    [
        113.09899565783,
        23.090513098429
    ],
    [
        113.09895030549,
        23.090495238352
    ],
    [
        113.09895166588,
        23.090492245476
    ],
    [
        113.09887726242,
        23.090452077233
    ],
    [
        113.0987260019,
        23.090379637822
    ],
    [
        113.09856170405,
        23.090297547842
    ],
    [
        113.09840880649,
        23.090222719809
    ],
    [
        113.09833657609,
        23.090172534194
    ],
    [
        113.09833168549,
        23.090173112949
    ],
    [
        113.09836595329,
        23.090121054655
    ],
    [
        113.09837955519,
        23.090095187561
    ],
    [
        113.09857726354,
        23.089801632055
    ],
    [
        113.09861752308,
        23.089724313428
    ],
    [
        113.09869695305,
        23.089571044022
    ],
    [
        113.09864997137,
        23.089547782447
    ],
    [
        113.09856197213,
        23.089518037918
    ],
    [
        113.09848403346,
        23.08947330891
    ],
    [
        113.09847995747,
        23.089474694802
    ],
    [
        113.0984878484,
        23.08945619368
    ],
    [
        113.09848675677,
        23.089463524813
    ],
    [
        113.09848893655,
        23.089454015915
    ],
    [
        113.09850199577,
        23.089425712972
    ],
    [
        113.09854934312,
        23.089310910596
    ],
    [
        113.09859698172,
        23.089165187765
    ],
    [
        113.09840334617,
        23.089066785703
    ],
    [
        113.09841231414,
        23.089062651243
    ],
    [
        113.09843407611,
        23.089019908288
    ],
    [
        113.09847432303,
        23.088959671828
    ],
    [
        113.09857493715,
        23.088811120762
    ],
    [
        113.09860241375,
        23.088751794507
    ],
    [
        113.09862088563,
        23.088753831545
    ],
    [
        113.09872504157,
        23.088583297857
    ],
    [
        113.09873917482,
        23.08857234846
    ],
    [
        113.09875901737,
        23.088554306885
    ],
    [
        113.09881910918,
        23.088466547557
    ],
    [
        113.09884221364,
        23.088444687259
    ],
    [
        113.09885091054,
        23.088438388152
    ],
    [
        113.09885852492,
        23.088425587119
    ],
    [
        113.09887130276,
        23.088409495364
    ],
    [
        113.09889904486,
        23.088356141041
    ],
    [
        113.09910162439,
        23.088029815982
    ],
    [
        113.09918645963,
        23.087893085911
    ],
    [
        113.09921365988,
        23.087832961603
    ],
    [
        113.09931808808,
        23.087632370446
    ],
    [
        113.09909188631,
        23.087512098747
    ],
    [
        113.09862045526,
        23.08724117326
    ],
    [
        113.09855961635,
        23.087216658293
    ],
    [
        113.09855473009,
        23.087210184035
    ],
    [
        113.09867983866,
        23.086961105611
    ],
    [
        113.09887320399,
        23.086572960859
    ],
    [
        113.09888354547,
        23.08653898437
    ],
    [
        113.09888789326,
        23.086536512996
    ],
    [
        113.09902168461,
        23.08627845809
    ],
    [
        113.09925420714,
        23.085764252004
    ],
    [
        113.09941707124,
        23.085453698589
    ],
    [
        113.09949565455,
        23.085284750831
    ],
    [
        113.09950983176,
        23.085176706428
    ],
    [
        113.09950738556,
        23.085179977017
    ],
    [
        113.09950304381,
        23.085171325258
    ],
    [
        113.09951665874,
        23.085101529234
    ],
    [
        113.0995226577,
        23.085053210078
    ],
    [
        113.09952836646,
        23.085043408854
    ],
    [
        113.09953679923,
        23.085017315826
    ],
    [
        113.09954415764,
        23.08496573316
    ],
    [
        113.09954634003,
        23.084945918683
    ],
    [
        113.09959906726,
        23.084876145378
    ],
    [
        113.09960994198,
        23.084854919671
    ],
    [
        113.09961891177,
        23.084841300848
    ],
    [
        113.09965044267,
        23.084791464716
    ],
    [
        113.09969393693,
        23.084714430347
    ],
    [
        113.0996961135,
        23.084706550733
    ],
    [
        113.09976239542,
        23.08468796444
    ],
    [
        113.09980830542,
        23.084670592327
    ],
    [
        113.09986751397,
        23.084674297458
    ],
    [
        113.09987675558,
        23.084659051508
    ],
    [
        113.09988245805,
        23.084661729117
    ],
    [
        113.100119054,
        23.084589245056
    ],
    [
        113.10018071094,
        23.084576948703
    ],
    [
        113.10017881229,
        23.08457153497
    ],
    [
        113.10038098648,
        23.084317574706
    ],
    [
        113.10041939717,
        23.084048827922
    ],
    [
        113.10066389778,
        23.082450658697
    ],
    [
        113.10066444149,
        23.082449028269
    ],
    [
        113.10067863323,
        23.082247143386
    ],
    [
        113.10075106049,
        23.081664926119
    ],
    [
        113.10106036224,
        23.08166304578
    ],
    [
        113.10132945727,
        23.081669038737
    ],
    [
        113.10180461784,
        23.081680409321
    ],
    [
        113.10191892198,
        23.081682353511
    ],
    [
        113.10203512277,
        23.081688912749
    ],
    [
        113.10262288333,
        23.081698810937
    ],
    [
        113.10288674584,
        23.081697334193
    ],
    [
        113.10294755042,
        23.081701467881
    ],
    [
        113.10297876766,
        23.081700820774
    ],
    [
        113.10299451108,
        23.0817032096
    ],
    [
        113.10299261007,
        23.081705928412
    ],
    [
        113.10312236085,
        23.081709844775
    ],
    [
        113.10313050427,
        23.081709547451
    ],
    [
        113.10315411979,
        23.081709743425
    ],
    [
        113.10320225095,
        23.081431560464
    ],
    [
        113.10323760063,
        23.081220688589
    ],
    [
        113.1032648033,
        23.081014724933
    ],
    [
        113.1032773176,
        23.080913238403
    ],
    [
        113.10328385615,
        23.080825061516
    ],
    [
        113.10330043236,
        23.08075584165
    ],
    [
        113.10331593306,
        23.080646479871
    ],
    [
        113.10334801787,
        23.080429109599
    ],
    [
        113.10335128332,
        23.080396006912
    ],
    [
        113.10335102495,
        23.08034311328
    ],
    [
        113.10335836558,
        23.080294265671
    ],
    [
        113.10336816161,
        23.080192516268
    ],
    [
        113.10336979079,
        23.080190070127
    ],
    [
        113.10337252801,
        23.080092681774
    ],
    [
        113.10337904753,
        23.080070419536
    ],
    [
        113.10340921135,
        23.079916529034
    ],
    [
        113.10345158188,
        23.079791085363
    ],
    [
        113.10347059268,
        23.079740576843
    ],
    [
        113.10349448947,
        23.079687613313
    ],
    [
        113.10349150367,
        23.079688164385
    ],
    [
        113.103495575,
        23.079688423969
    ],
    [
        113.10351485231,
        23.079659344583
    ],
    [
        113.10357240139,
        23.079624190288
    ],
    [
        113.10367146869,
        23.079627715532
    ],
    [
        113.10375072268,
        23.079623435317
    ],
    [
        113.1039089478,
        23.079652868675
    ],
    [
        113.10397109835,
        23.079656513563
    ],
    [
        113.10408698285,
        23.079669258618
    ],
    [
        113.104257144,
        23.079674844546
    ],
    [
        113.10443571539,
        23.079666335034
    ],
    [
        113.10443842768,
        23.079673382255
    ],
    [
        113.10456054856,
        23.07966229499
    ],
    [
        113.10466530126,
        23.079641487214
    ],
    [
        113.10476869665,
        23.079613096714
    ],
    [
        113.10485119611,
        23.0795820371
    ],
    [
        113.10493884731,
        23.079563724878
    ],
    [
        113.10499610592,
        23.079546006885
    ],
    [
        113.10507642882,
        23.079525546657
    ],
    [
        113.10508456966,
        23.079523093927
    ],
    [
        113.10534316987,
        23.079447896241
    ],
    [
        113.10580117944,
        23.079335162094
    ],
    [
        113.10594416067,
        23.079314722259
    ],
    [
        113.10622930071,
        23.079257353191
    ],
    [
        113.10624286667,
        23.07924839723
    ],
    [
        113.10632425328,
        23.079239422427
    ],
    [
        113.10652554565,
        23.079208739162
    ],
    [
        113.10674174887,
        23.079181893149
    ],
    [
        113.10709872568,
        23.079119613094
    ],
    [
        113.10757637171,
        23.079052672621
    ],
    [
        113.10777707179,
        23.079032259561
    ],
    [
        113.10800461757,
        23.07898316554
    ],
    [
        113.10805424796,
        23.078971567797
    ],
    [
        113.10808381025,
        23.078957502996
    ],
    [
        113.10808273276,
        23.078915185286
    ],
    [
        113.10806918834,
        23.078825380205
    ],
    [
        113.1080632276,
        23.078792278538
    ],
    [
        113.10806024516,
        23.078788205589
    ],
    [
        113.10804534043,
        23.078721455797
    ],
    [
        113.10804615383,
        23.078722541931
    ],
    [
        113.1080426302,
        23.07871087306
    ],
    [
        113.10804588576,
        23.07870301096
    ],
    [
        113.10803531089,
        23.078692688894
    ],
    [
        113.10801552825,
        23.078600163332
    ],
    [
        113.10797704655,
        23.078412401825
    ],
    [
        113.10794126929,
        23.078264519897
    ],
    [
        113.10814305321,
        23.078139741135
    ],
    [
        113.10814659306,
        23.078025816924
    ],
    [
        113.10821059755,
        23.077987663593
    ],
    [
        113.10824233104,
        23.077945666409
    ],
    [
        113.108258065,
        23.077899847591
    ],
    [
        113.10827624082,
        23.077841826057
    ],
    [
        113.10832506365,
        23.077746962195
    ],
    [
        113.10836086725,
        23.077669982224
    ],
    [
        113.10841538729,
        23.077532272282
    ],
    [
        113.10843274931,
        23.077459332358
    ],
    [
        113.108434648,
        23.077454181627
    ],
    [
        113.10843953301,
        23.077411601837
    ],
    [
        113.10844523045,
        23.077380145205
    ],
    [
        113.10845363993,
        23.077344353082
    ],
    [
        113.10845255881,
        23.077302848045
    ],
    [
        113.10848972249,
        23.077137442612
    ],
    [
        113.10850871028,
        23.077056911093
    ],
    [
        113.10852037722,
        23.076960090881
    ],
    [
        113.10853638022,
        23.07689664397
    ],
    [
        113.10853638109,
        23.076882809517
    ],
    [
        113.1085548239,
        23.076825877572
    ],
    [
        113.10855645357,
        23.076779765656
    ],
    [
        113.1085597078,
        23.076775702638
    ],
    [
        113.10857272738,
        23.076709538045
    ],
    [
        113.10892522926,
        23.076736828142
    ],
    [
        113.10923297186,
        23.076751101812
    ],
    [
        113.1092533067,
        23.076751151838
    ],
    [
        113.10949379297,
        23.076772388452
    ],
    [
        113.10952552216,
        23.076610258189
    ],
    [
        113.10955508319,
        23.076384646549
    ],
    [
        113.10964889993,
        23.075770219144
    ],
    [
        113.10976492042,
        23.075012359455
    ],
    [
        113.10979771567,
        23.074820940043
    ],
    [
        113.10988389199,
        23.074284897344
    ],
    [
        113.11003181526,
        23.073359233197
    ],
    [
        113.11012228318,
        23.072822672083
    ],
    [
        113.11017048782,
        23.072525512079
    ],
    [
        113.11020217577,
        23.072361495059
    ],
    [
        113.11028366314,
        23.071807278561
    ],
    [
        113.11031642796,
        23.071640825782
    ],
    [
        113.11036433692,
        23.071325222575
    ],
    [
        113.11058690821,
        23.071429379707
    ],
    [
        113.11062594585,
        23.071450141851
    ],
    [
        113.11068395858,
        23.071476673852
    ],
    [
        113.11081326736,
        23.071546618073
    ],
    [
        113.1108425423,
        23.071553243337
    ],
    [
        113.11094229823,
        23.071600570866
    ],
    [
        113.11152316791,
        23.071842053877
    ],
    [
        113.11169707546,
        23.071465508486
    ],
    [
        113.11169111354,
        23.071466565601
    ],
    [
        113.11181625772,
        23.071210800628
    ],
    [
        113.11143917838,
        23.070798604082
    ],
    [
        113.11160062237,
        23.070496586549
    ],
    [
        113.11161903998,
        23.070456521881
    ],
    [
        113.11176013253,
        23.070102346082
    ],
    [
        113.11176554686,
        23.07008311073
    ],
    [
        113.11177881211,
        23.070036784501
    ],
    [
        113.11181970171,
        23.069932536227
    ],
    [
        113.11243217532,
        23.070083228685
    ],
    [
        113.11243651151,
        23.070085422194
    ],
    [
        113.11244030299,
        23.070078389162
    ],
    [
        113.11245898271,
        23.070021248729
    ],
    [
        113.11248307867,
        23.069954642897
    ],
    [
        113.11249986204,
        23.069900476949
    ],
    [
        113.1125077149,
        23.069883699924
    ],
    [
        113.11252801886,
        23.069824127783
    ],
    [
        113.11252910179,
        23.069821149553
    ],
    [
        113.11252530758,
        23.06981895863
    ],
    [
        113.11252612005,
        23.069817606631
    ],
    [
        113.11263880742,
        23.069711882052
    ],
    [
        113.1127346872,
        23.069589254283
    ],
    [
        113.11273738404,
        23.069550204454
    ],
    [
        113.11273142096,
        23.069543931352
    ],
    [
        113.11273440317,
        23.069549102539
    ],
    [
        113.11273602908,
        23.069549654258
    ],
    [
        113.11273142256,
        23.069548814488
    ],
    [
        113.11274333299,
        23.069513343216
    ],
    [
        113.1127443825,
        23.069409718237
    ],
    [
        113.11276385808,
        23.069311080295
    ],
    [
        113.1127719627,
        23.06924059189
    ],
    [
        113.11277330472,
        23.069203433344
    ],
    [
        113.11277817085,
        23.069171449177
    ],
    [
        113.11279196867,
        23.06911157324
    ],
    [
        113.11278843869,
        23.069089850321
    ],
    [
        113.11280818299,
        23.068989857922
    ],
    [
        113.11282034308,
        23.068898232378
    ],
    [
        113.11282819502,
        23.06888254256
    ],
    [
        113.11284063492,
        23.068816690984
    ],
    [
        113.11286201702,
        23.068753874948
    ],
    [
        113.1128660727,
        23.068730567551
    ],
    [
        113.11286579905,
        23.068723241229
    ],
    [
        113.11286904114,
        23.068698030154
    ],
    [
        113.11286902978,
        23.068667374639
    ],
    [
        113.11286252618,
        23.068665166991
    ],
    [
        113.11280126328,
        23.068590212983
    ],
    [
        113.11266116214,
        23.068545205203
    ],
    [
        113.1125690127,
        23.068485827028
    ],
    [
        113.112524555,
        23.068434853455
    ],
    [
        113.11252125745,
        23.068315740079
    ],
    [
        113.11252314789,
        23.068299473069
    ],
    [
        113.11251500097,
        23.068253581064
    ],
    [
        113.11250820074,
        23.068187349766
    ],
    [
        113.11251741405,
        23.068188484951
    ],
    [
        113.11250792527,
        23.068175954153
    ],
    [
        113.11241142245,
        23.06808102621
    ],
    [
        113.11235611066,
        23.067998260365
    ],
    [
        113.11228423883,
        23.067843518816
    ],
    [
        113.11224055796,
        23.067715242647
    ],
    [
        113.11222020521,
        23.06764568703
    ],
    [
        113.11220336301,
        23.067548206935
    ],
    [
        113.11218597436,
        23.067441500313
    ],
    [
        113.11215424797,
        23.067392234113
    ],
    [
        113.11210409997,
        23.067356168558
    ],
    [
        113.11200111412,
        23.067333405716
    ],
    [
        113.11194419165,
        23.067301654296
    ],
    [
        113.11190514853,
        23.06725669976
    ],
    [
        113.1118956406,
        23.067204565434
    ],
    [
        113.11189994421,
        23.067131880381
    ],
    [
        113.11191591724,
        23.067096690614
    ],
    [
        113.11197036239,
        23.067041615129
    ],
    [
        113.11205570062,
        23.066988596064
    ],
    [
        113.11214021377,
        23.066912248185
    ],
    [
        113.11219381859,
        23.06680373467
    ],
    [
        113.11222573662,
        23.066679647499
    ],
    [
        113.1122351915,
        23.066617027882
    ],
    [
        113.11222104268,
        23.066495144151
    ],
    [
        113.11221121163,
        23.066337743312
    ],
    [
        113.11221551289,
        23.066266957927
    ],
    [
        113.11220519739,
        23.066229737458
    ],
    [
        113.11219354221,
        23.066223708953
    ],
    [
        113.11216671006,
        23.066213804607
    ],
    [
        113.1121385231,
        23.066204436585
    ],
    [
        113.11200330323,
        23.066211080423
    ],
    [
        113.11191088756,
        23.066197330958
    ],
    [
        113.11188215475,
        23.066182812152
    ],
    [
        113.11184121313,
        23.066140563059
    ],
    [
        113.11183903412,
        23.06611830643
    ],
    [
        113.11183629285,
        23.066055352972
    ],
    [
        113.11183757465,
        23.065909402811
    ],
    [
        113.11182751161,
        23.065838275087
    ],
    [
        113.11181230178,
        23.065772005971
    ],
    [
        113.11180814627,
        23.065596458091
    ],
    [
        113.11179906876,
        23.065340582768
    ],
    [
        113.11177723101,
        23.065047749585
    ],
    [
        113.11176899691,
        23.064858345067
    ],
    [
        113.11175053309,
        23.064794231064
    ],
    [
        113.1117288427,
        23.064776222619
    ],
    [
        113.11168547781,
        23.064769235884
    ],
    [
        113.1116448248,
        23.064766061625
    ],
    [
        113.11159765644,
        23.064743596665
    ],
    [
        113.11156647172,
        23.064710897562
    ],
    [
        113.11154882991,
        23.064664696234
    ],
    [
        113.11154849486,
        23.064551292234
    ],
    [
        113.1115628027,
        23.064453147805
    ],
    [
        113.11157228229,
        23.064442881945
    ],
    [
        113.11160235742,
        23.064430269381
    ],
    [
        113.11165763319,
        23.064412348987
    ],
    [
        113.11168065882,
        23.064394822295
    ],
    [
        113.11169284061,
        23.064371276513
    ],
    [
        113.11168463334,
        23.064238030424
    ],
    [
        113.11167693937,
        23.064057309313
    ],
    [
        113.1116469866,
        23.063818697263
    ],
    [
        113.11163173058,
        23.063686774606
    ],
    [
        113.1116173545,
        23.063666089139
    ],
    [
        113.11160108326,
        23.063648650705
    ],
    [
        113.11159268007,
        23.063645627645
    ],
    [
        113.11157722805,
        23.063638502736
    ],
    [
        113.11154822394,
        23.063629145643
    ],
    [
        113.11143657508,
        23.063645733086
    ],
    [
        113.11130865906,
        23.063656834861
    ],
    [
        113.11112626915,
        23.063679387902
    ],
    [
        113.11102517364,
        23.063681953532
    ],
    [
        113.11086148165,
        23.063713037407
    ],
    [
        113.11071187586,
        23.06373795933
    ],
    [
        113.11064464914,
        23.063730651415
    ],
    [
        113.11059992078,
        23.063725058624
    ],
    [
        113.1105622307,
        23.063704571992
    ],
    [
        113.11053292744,
        23.063657801095
    ],
    [
        113.11049726281,
        23.063404548236
    ],
    [
        113.11046709904,
        23.063283168092
    ],
    [
        113.11045190817,
        23.063265479127
    ],
    [
        113.1104529894,
        23.063260599571
    ],
    [
        113.11043916213,
        23.063256209412
    ],
    [
        113.11039552148,
        23.063259039141
    ],
    [
        113.11025510981,
        23.063267777826
    ],
    [
        113.10998214475,
        23.063297542572
    ],
    [
        113.10983576543,
        23.063318253713
    ],
    [
        113.10975849977,
        23.063315853527
    ],
    [
        113.10966469483,
        23.063312597627
    ],
    [
        113.10962511117,
        23.063310043741
    ],
    [
        113.10962808716,
        23.063300013982
    ],
    [
        113.10959011775,
        23.063277932235
    ],
    [
        113.10952361395,
        23.063148881005
    ],
    [
        113.10946791136,
        23.062953664829
    ],
    [
        113.10941427941,
        23.062610054077
    ],
    [
        113.1093796447,
        23.062302577375
    ],
    [
        113.109347389,
        23.061911002755
    ],
    [
        113.10930516855,
        23.061625211645
    ],
    [
        113.10926048852,
        23.061316897039
    ],
    [
        113.10923543584,
        23.061163004772
    ],
    [
        113.10922616337,
        23.061087016322
    ],
    [
        113.10922010383,
        23.060954604027
    ],
    [
        113.10918965827,
        23.060845193508
    ],
    [
        113.10915350032,
        23.060711081192
    ],
    [
        113.10907416535,
        23.060488151865
    ],
    [
        113.10902041328,
        23.060398226267
    ],
    [
        113.10897590683,
        23.060345492911
    ],
    [
        113.10894063359,
        23.06031258698
    ],
    [
        113.10893412366,
        23.060309317073
    ],
    [
        113.1089059199,
        23.060303287178
    ],
    [
        113.10887148538,
        23.060305112703
    ],
    [
        113.10881997269,
        23.060313143839
    ],
    [
        113.10867112978,
        23.060342417841
    ],
    [
        113.10854858727,
        23.060373659144
    ],
    [
        113.10849002142,
        23.060382235792
    ],
    [
        113.10843361026,
        23.060371827772
    ],
    [
        113.10841028498,
        23.060365819207
    ],
    [
        113.10835684928,
        23.060346467088
    ],
    [
        113.108274948,
        23.060339010099
    ],
    [
        113.10822450659,
        23.060336761634
    ],
    [
        113.10818600067,
        23.060339688065
    ],
    [
        113.10813448211,
        23.060348837143
    ],
    [
        113.10804636707,
        23.060378015158
    ],
    [
        113.10791593687,
        23.060397922757
    ],
    [
        113.10772695051,
        23.060455494218
    ],
    [
        113.10753442584,
        23.060505499113
    ],
    [
        113.10741213556,
        23.060547179585
    ],
    [
        113.10734624463,
        23.060570463436
    ],
    [
        113.10726164578,
        23.060604591706
    ],
    [
        113.10710358035,
        23.060694306782
    ],
    [
        113.10702467083,
        23.060724658129
    ],
    [
        113.10699538145,
        23.060731700574
    ],
    [
        113.10691428157,
        23.060736284997
    ],
    [
        113.10673905115,
        23.060736517128
    ],
    [
        113.10655268658,
        23.060728096277
    ],
    [
        113.10625264772,
        23.06071865177
    ],
    [
        113.10609177581,
        23.060721698108
    ],
    [
        113.10598189623,
        23.060714971567
    ],
    [
        113.10586552315,
        23.060735933945
    ],
    [
        113.10547949554,
        23.060808700966
    ],
    [
        113.10536690798,
        23.060827000265
    ],
    [
        113.10534901232,
        23.060843841751
    ],
    [
        113.10532949134,
        23.060864483731
    ],
    [
        113.10528070078,
        23.060933182555
    ],
    [
        113.1052481645,
        23.0609665933
    ],
    [
        113.10522781232,
        23.060963905727
    ],
    [
        113.10520231319,
        23.060973162658
    ],
    [
        113.10516975191,
        23.0609723911
    ],
    [
        113.105108695,
        23.0609654192
    ],
    [
        113.10503271021,
        23.060954131278
    ],
    [
        113.10497571652,
        23.06093956444
    ],
    [
        113.10484410627,
        23.060934343184
    ],
    [
        113.10477137263,
        23.060921169236
    ],
    [
        113.10466987175,
        23.060905880509
    ],
    [
        113.10455613689,
        23.060862408308
    ],
    [
        113.1044057574,
        23.060810611004
    ],
    [
        113.10426539989,
        23.060738193535
    ],
    [
        113.10414104671,
        23.060660331621
    ],
    [
        113.10411145159,
        23.060642221473
    ],
    [
        113.1040962527,
        23.060641171213
    ],
    [
        113.10407400006,
        23.060643664573
    ],
    [
        113.10404497781,
        23.060667336335
    ],
    [
        113.10400321066,
        23.060706232545
    ],
    [
        113.1039701327,
        23.06075162064
    ],
    [
        113.10394440096,
        23.060822765951
    ],
    [
        113.10392517029,
        23.06087680341
    ],
    [
        113.10389376066,
        23.060978892909
    ],
    [
        113.10389975158,
        23.061006822634
    ],
    [
        113.10391009288,
        23.061045865184
    ],
    [
        113.10391176558,
        23.061107990369
    ],
    [
        113.10388658097,
        23.061187003401
    ],
    [
        113.1038833529,
        23.061227707507
    ],
    [
        113.10387577862,
        23.061263267688
    ],
    [
        113.10383049545,
        23.06132279851
    ],
    [
        113.10380582219,
        23.06135840294
    ],
    [
        113.10377950509,
        23.061372307674
    ],
    [
        113.10373934295,
        23.061382179864
    ],
    [
        113.10367229817,
        23.061374762125
    ],
    [
        113.10344697735,
        23.061317876385
    ],
    [
        113.10325503748,
        23.061266088597
    ],
    [
        113.10316654004,
        23.061254969903
    ],
    [
        113.10312474755,
        23.061268939471
    ],
    [
        113.10310086232,
        23.061271729222
    ],
    [
        113.10309002265,
        23.061297538342
    ],
    [
        113.10307376544,
        23.061339643539
    ],
    [
        113.10306836087,
        23.06137438835
    ],
    [
        113.10305860967,
        23.061404263821
    ],
    [
        113.10302524447,
        23.061437201189
    ],
    [
        113.10298618573,
        23.061480468132
    ],
    [
        113.10291211962,
        23.06153904785
    ],
    [
        113.10285079867,
        23.061579953602
    ],
    [
        113.10280954929,
        23.061598002876
    ],
    [
        113.1027810489,
        23.061602443528
    ],
    [
        113.10273434678,
        23.061587415438
    ],
    [
        113.10259802817,
        23.061527407256
    ],
    [
        113.10251436632,
        23.061458535102
    ],
    [
        113.10241714384,
        23.061410883205
    ],
    [
        113.10224960888,
        23.061369758557
    ],
    [
        113.10200143128,
        23.061325740867
    ],
    [
        113.1018268394,
        23.061306414453
    ],
    [
        113.10171252128,
        23.061290642158
    ],
    [
        113.10166688838,
        23.061265073293
    ],
    [
        113.10163374189,
        23.0612351085
    ],
    [
        113.10160275677,
        23.061190212888
    ],
    [
        113.10159566567,
        23.061145750961
    ],
    [
        113.10160212694,
        23.061068127425
    ],
    [
        113.10164927459,
        23.060932801363
    ],
    [
        113.1016685051,
        23.060867057797
    ],
    [
        113.10166522379,
        23.060835058279
    ],
    [
        113.10164944751,
        23.060796061345
    ],
    [
        113.10160434503,
        23.060754485331
    ],
    [
        113.10153913973,
        23.060699709984
    ],
    [
        113.10145847666,
        23.060672684516
    ],
    [
        113.10131698696,
        23.06064324405
    ],
    [
        113.10117928326,
        23.060597524151
    ],
    [
        113.10103696211,
        23.060555100271
    ],
    [
        113.10095384954,
        23.060530836574
    ],
    [
        113.10087074705,
        23.060522043553
    ],
    [
        113.10071512595,
        23.060499806751
    ],
    [
        113.10060378028,
        23.060496068836
    ],
    [
        113.10037211849,
        23.060486506128
    ],
    [
        113.10023604195,
        23.060469921867
    ],
    [
        113.10014097567,
        23.060457181938
    ],
    [
        113.10008338261,
        23.060436902041
    ],
    [
        113.10002633454,
        23.060419877494
    ],
    [
        113.09997062825,
        23.060381685577
    ],
    [
        113.09992986895,
        23.060356157284
    ],
    [
        113.09987169419,
        23.060287055808
    ],
    [
        113.09980918081,
        23.060228565033
    ],
    [
        113.09978414052,
        23.060158721642
    ],
    [
        113.09975148262,
        23.060072647438
    ],
    [
        113.09971936176,
        23.059978974061
    ],
    [
        113.09968365749,
        23.059816953717
    ],
    [
        113.09967560434,
        23.059586390029
    ],
    [
        113.09968090324,
        23.059413531528
    ],
    [
        113.09971873292,
        23.05916151769
    ],
    [
        113.0997867082,
        23.058908504039
    ],
    [
        113.09990481401,
        23.05851410551
    ],
    [
        113.0999887975,
        23.058250695641
    ],
    [
        113.10005134793,
        23.058019705134
    ],
    [
        113.10009218934,
        23.057814078086
    ],
    [
        113.10012238504,
        23.057546383745
    ],
    [
        113.10015494731,
        23.057189684429
    ],
    [
        113.10019035445,
        23.056672078159
    ],
    [
        113.10021565439,
        23.056407397409
    ],
    [
        113.10023669486,
        23.056243128775
    ],
    [
        113.10025881248,
        23.056069358059
    ],
    [
        113.10025225304,
        23.056022457994
    ],
    [
        113.10023593675,
        23.055998676337
    ],
    [
        113.10021718018,
        23.055979521462
    ],
    [
        113.1001462772,
        23.055959586195
    ],
    [
        113.09999169664,
        23.0559122085
    ],
    [
        113.09994495398,
        23.055881559628
    ],
    [
        113.09994492874,
        23.055853071423
    ],
    [
        113.0999389381,
        23.055835743284
    ],
    [
        113.10000245152,
        23.055484818287
    ],
    [
        113.10004057435,
        23.055292768504
    ],
    [
        113.10008277038,
        23.055101238327
    ],
    [
        113.10011065691,
        23.055004484105
    ],
    [
        113.10013150291,
        23.054931105303
    ],
    [
        113.1001317614,
        23.054916723875
    ],
    [
        113.10011301828,
        23.054913307004
    ],
    [
        113.10010024893,
        23.054908498567
    ],
    [
        113.10005490492,
        23.054922333084
    ],
    [
        113.09992756688,
        23.054969221117
    ],
    [
        113.09982602223,
        23.055008910265
    ],
    [
        113.09969485735,
        23.05503495603
    ],
    [
        113.0995218694,
        23.055071865304
    ],
    [
        113.09929427602,
        23.055106717783
    ],
    [
        113.09919243203,
        23.055128557485
    ],
    [
        113.09916338025,
        23.055143674729
    ],
    [
        113.09913922398,
        23.055165542687
    ],
    [
        113.09908847123,
        23.055214723015
    ],
    [
        113.0990301464,
        23.055302213166
    ],
    [
        113.0989473785,
        23.055396657543
    ],
    [
        113.0988583772,
        23.055509058211
    ],
    [
        113.09878863955,
        23.055596368612
    ],
    [
        113.09875882143,
        23.055668478101
    ],
    [
        113.09872927177,
        23.0557373306
    ],
    [
        113.09871166719,
        23.055797416766
    ],
    [
        113.09870548352,
        23.055870173915
    ],
    [
        113.09869358017,
        23.055926421362
    ],
    [
        113.09869585316,
        23.056039273388
    ],
    [
        113.0986864298,
        23.056135658215
    ],
    [
        113.09866050387,
        23.056311114184
    ],
    [
        113.09866957076,
        23.056427987145
    ],
    [
        113.09867107443,
        23.056595378965
    ],
    [
        113.09866602561,
        23.056725918328
    ],
    [
        113.09864361892,
        23.056890496281
    ],
    [
        113.09862653199,
        23.056923176679
    ],
    [
        113.09858823322,
        23.056930506246
    ],
    [
        113.09847060126,
        23.056932173651
    ],
    [
        113.09828042934,
        23.056935205987
    ],
    [
        113.09817963567,
        23.056936776631
    ],
    [
        113.09804271746,
        23.056952740553
    ],
    [
        113.09786285902,
        23.05695901619
    ],
    [
        113.09773924747,
        23.056975453457
    ],
    [
        113.09769442816,
        23.056990188867
    ],
    [
        113.09765805304,
        23.057030090909
    ],
    [
        113.09765046623,
        23.057054841283
    ],
    [
        113.09763665985,
        23.057114641235
    ],
    [
        113.09764377159,
        23.057170204149
    ],
    [
        113.09763621548,
        23.057231310684
    ],
    [
        113.09759278116,
        23.057278325354
    ],
    [
        113.09757242976,
        23.057310504374
    ],
    [
        113.09754664946,
        23.057349239137
    ],
    [
        113.09754072181,
        23.057408705159
    ],
    [
        113.09754085751,
        23.057570408095
    ],
    [
        113.09755243846,
        23.057772986994
    ],
    [
        113.09755708529,
        23.057806321235
    ],
    [
        113.09758078301,
        23.057876943459
    ],
    [
        113.09762052264,
        23.057961003154
    ],
    [
        113.09765046975,
        23.058032390528
    ],
    [
        113.09765976111,
        23.058097160466
    ],
    [
        113.09766583193,
        23.058211064004
    ],
    [
        113.09765645035,
        23.058368772322
    ],
    [
        113.09763703258,
        23.05854880852
    ],
    [
        113.09762326511,
        23.05866069989
    ],
    [
        113.09762819934,
        23.058714923009
    ],
    [
        113.09761463719,
        23.058744333533
    ],
    [
        113.09759779929,
        23.058754778602
    ],
    [
        113.09756547021,
        23.058761007674
    ],
    [
        113.09748286087,
        23.058751909152
    ],
    [
        113.09735050569,
        23.058718806843
    ],
    [
        113.0972999688,
        23.058724107848
    ],
    [
        113.09727714466,
        23.058725382284
    ],
    [
        113.09725622946,
        23.058735323294
    ],
    [
        113.09725217239,
        23.058758961284
    ],
    [
        113.09726333508,
        23.058786271107
    ],
    [
        113.09729000967,
        23.058843025493
    ],
    [
        113.09733818747,
        23.058946540005
    ],
    [
        113.09735486969,
        23.05908205885
    ],
    [
        113.09736908809,
        23.059195079124
    ],
    [
        113.09736722147,
        23.05924040362
    ],
    [
        113.09735718446,
        23.059261919875
    ],
    [
        113.09732758159,
        23.059281427113
    ],
    [
        113.09723820912,
        23.059314997105
    ],
    [
        113.0971287264,
        23.059347928836
    ],
    [
        113.09704070431,
        23.059374719049
    ],
    [
        113.09693881808,
        23.059396479416
    ],
    [
        113.09680622939,
        23.059427196319
    ],
    [
        113.09654401833,
        23.05947019702
    ],
    [
        113.09644320824,
        23.059488732729
    ],
    [
        113.09632093154,
        23.059513711229
    ],
    [
        113.09619130672,
        23.059528730453
    ],
    [
        113.09607498304,
        23.059526275721
    ],
    [
        113.09598231525,
        23.059540160579
    ],
    [
        113.09589562834,
        23.059557794288
    ],
    [
        113.09583993656,
        23.059590876722
    ],
    [
        113.09580380706,
        23.059615636679
    ],
    [
        113.0957581789,
        23.059659208482
    ],
    [
        113.09570822257,
        23.059730225699
    ],
    [
        113.09567836776,
        23.059786672688
    ],
    [
        113.09565123708,
        23.059851504855
    ],
    [
        113.09563362447,
        23.059923300148
    ],
    [
        113.09562339931,
        23.060060139187
    ],
    [
        113.09561041402,
        23.060141657372
    ],
    [
        113.09562652671,
        23.060243786415
    ],
    [
        113.09563581275,
        23.06030392806
    ],
    [
        113.09564158977,
        23.060397203277
    ],
    [
        113.09562968909,
        23.060476540156
    ],
    [
        113.09560716999,
        23.060531561436
    ],
    [
        113.09558055617,
        23.060562747345
    ],
    [
        113.09556343958,
        23.060572408503
    ],
    [
        113.09550909689,
        23.060597624048
    ],
    [
        113.09545364563,
        23.060594365166
    ],
    [
        113.09536150362,
        23.060597165979
    ],
    [
        113.09532753545,
        23.060608895029
    ],
    [
        113.09522535224,
        23.060636222277
    ],
    [
        113.09513051032,
        23.060668638984
    ],
    [
        113.09504273737,
        23.060705061029
    ],
    [
        113.09496910634,
        23.060752469412
    ],
    [
        113.09493107138,
        23.060781885016
    ],
    [
        113.09490203075,
        23.060844581236
    ],
    [
        113.09485367779,
        23.060890925212
    ],
    [
        113.09479390555,
        23.060934946197
    ],
    [
        113.09469769421,
        23.06096252447
    ],
    [
        113.09462757075,
        23.060979257635
    ],
    [
        113.09458271855,
        23.060982436977
    ],
    [
        113.09441472949,
        23.061002103017
    ],
    [
        113.09405020467,
        23.061058627202
    ],
    [
        113.09391755496,
        23.061091267603
    ],
    [
        113.09374764665,
        23.061112122247
    ],
    [
        113.09356904494,
        23.061148830629
    ],
    [
        113.09324745633,
        23.061236289349
    ],
    [
        113.09311724175,
        23.061274404421
    ],
    [
        113.09288315869,
        23.061319162876
    ],
    [
        113.0926960825,
        23.061324337024
    ],
    [
        113.09260851596,
        23.061314246664
    ],
    [
        113.09251874549,
        23.06126539064
    ],
    [
        113.09244583863,
        23.061223663971
    ],
    [
        113.09237538722,
        23.061194391677
    ],
    [
        113.09228863308,
        23.061185124632
    ],
    [
        113.09218474942,
        23.061181225035
    ],
    [
        113.09203461972,
        23.061158091521
    ],
    [
        113.0918739,
        23.061161963161
    ],
    [
        113.09170310799,
        23.061157023983
    ],
    [
        113.09156658901,
        23.061165239663
    ],
    [
        113.09150431739,
        23.061177144759
    ],
    [
        113.09145483423,
        23.061198115683
    ],
    [
        113.0913632114,
        23.061241868459
    ],
    [
        113.09123053899,
        23.06131382281
    ],
    [
        113.09108506081,
        23.061357194043
    ],
    [
        113.09100728948,
        23.061379627829
    ],
    [
        113.09086723471,
        23.061405856825
    ],
    [
        113.09085907606,
        23.061407319258
    ],
    [
        113.09076144123,
        23.0614216125
    ],
    [
        113.09064017096,
        23.061478003086
    ],
    [
        113.09050583461,
        23.061522908943
    ],
    [
        113.09025971514,
        23.061588848746
    ],
    [
        113.09001496612,
        23.061680852331
    ],
    [
        113.08973702547,
        23.061777685748
    ],
    [
        113.08955833278,
        23.061823274559
    ],
    [
        113.08944244312,
        23.061819447801
    ],
    [
        113.08930858987,
        23.061805026261
    ],
    [
        113.08921743359,
        23.061773197149
    ],
    [
        113.08921769908,
        23.061763697661
    ],
    [
        113.0890970974,
        23.061640583952
    ],
    [
        113.08905786157,
        23.061553230962
    ],
    [
        113.08904637409,
        23.061465488425
    ],
    [
        113.08907026463,
        23.061394612398
    ],
    [
        113.08920100971,
        23.06123976244
    ],
    [
        113.08921458423,
        23.061200775596
    ],
    [
        113.08922380968,
        23.061167004427
    ],
    [
        113.08920011842,
        23.061134235542
    ],
    [
        113.08915875491,
        23.061116636245
    ],
    [
        113.08907142384,
        23.061111349254
    ],
    [
        113.08901128899,
        23.061094831062
    ],
    [
        113.08899060145,
        23.061078572552
    ],
    [
        113.08894919755,
        23.061006174108
    ],
    [
        113.08891971305,
        23.060863881421
    ],
    [
        113.08891389874,
        23.060724781393
    ],
    [
        113.08892173186,
        23.060647618506
    ],
    [
        113.08895459158,
        23.060567660498
    ],
    [
        113.08898203459,
        23.06052115063
    ],
    [
        113.08903451105,
        23.060481342964
    ],
    [
        113.08909815245,
        23.060456844883
    ],
    [
        113.08915201827,
        23.060457446521
    ],
    [
        113.08925594938,
        23.060470916693
    ],
    [
        113.08942409297,
        23.060501409351
    ],
    [
        113.08962869988,
        23.060551494368
    ],
    [
        113.08973291189,
        23.060585066199
    ],
    [
        113.08975766514,
        23.060583371569
    ],
    [
        113.0897853996,
        23.060566714562
    ],
    [
        113.08980850978,
        23.060550392296
    ],
    [
        113.08980902423,
        23.060510231294
    ],
    [
        113.08979637909,
        23.060332152235
    ],
    [
        113.08972209715,
        23.059945461816
    ],
    [
        113.0896557268,
        23.05959610611
    ],
    [
        113.08962624136,
        23.059458954938
    ],
    [
        113.08960873122,
        23.059330321603
    ],
    [
        113.08960321147,
        23.059229197513
    ],
    [
        113.08962684008,
        23.059180579186
    ],
    [
        113.08965700553,
        23.059142452778
    ],
    [
        113.08969480552,
        23.059127012742
    ],
    [
        113.08971982527,
        23.059118259757
    ],
    [
        113.08977804321,
        23.059123433689
    ],
    [
        113.08978973381,
        23.05911513488
    ],
    [
        113.08981611124,
        23.059103651667
    ],
    [
        113.08982942428,
        23.059083121919
    ],
    [
        113.08982857049,
        23.059035382293
    ],
    [
        113.08978981953,
        23.058879904458
    ],
    [
        113.08977338875,
        23.058743114736
    ],
    [
        113.0897504728,
        23.058661219148
    ],
    [
        113.08974689349,
        23.058607819018
    ],
    [
        113.089758296,
        23.058579717916
    ],
    [
        113.08979333887,
        23.058519550685
    ],
    [
        113.08979930099,
        23.05849179531
    ],
    [
        113.08979655397,
        23.058458732305
    ],
    [
        113.08978806447,
        23.058388848701
    ],
    [
        113.08975424959,
        23.058286210168
    ],
    [
        113.08972829383,
        23.05814792245
    ],
    [
        113.08969959471,
        23.057982540927
    ],
    [
        113.08960575331,
        23.057666116163
    ],
    [
        113.08950672374,
        23.057331589121
    ],
    [
        113.08944511995,
        23.05718592868
    ],
    [
        113.08940610099,
        23.057048096789
    ],
    [
        113.08938667141,
        23.056914063708
    ],
    [
        113.08938186395,
        23.056701959547
    ],
    [
        113.08938607135,
        23.056534497688
    ],
    [
        113.08939275804,
        23.056403358031
    ],
    [
        113.08942959822,
        23.056224048563
    ],
    [
        113.08944773906,
        23.056126665313
    ],
    [
        113.08948194036,
        23.056041269719
    ],
    [
        113.08951887725,
        23.055973472812
    ],
    [
        113.08956807038,
        23.055922601129
    ],
    [
        113.08963656488,
        23.055857628625
    ],
    [
        113.08968873375,
        23.05578908376
    ],
    [
        113.08974550239,
        23.055693345652
    ],
    [
        113.08976718013,
        23.055598901721
    ],
    [
        113.08976165695,
        23.05550672822
    ],
    [
        113.08972947051,
        23.055409763736
    ],
    [
        113.08968940033,
        23.055318876751
    ],
    [
        113.08965345849,
        23.055281384223
    ],
    [
        113.08964501288,
        23.055267391353
    ],
    [
        113.08956936236,
        23.055239127861
    ],
    [
        113.08948746052,
        23.055217736995
    ],
    [
        113.08944148539,
        23.055216744389
    ],
    [
        113.08934927585,
        23.055229689066
    ],
    [
        113.08922333989,
        23.055251519942
    ],
    [
        113.08906586856,
        23.055300120585
    ],
    [
        113.08893478177,
        23.05534673451
    ],
    [
        113.08885973131,
        23.055387408522
    ],
    [
        113.08883905726,
        23.055389871963
    ],
    [
        113.08875389419,
        23.055379956762
    ],
    [
        113.08873157434,
        23.055367793518
    ],
    [
        113.08871116054,
        23.055357502643
    ],
    [
        113.08869475797,
        23.055270099739
    ],
    [
        113.08867699365,
        23.055181359754
    ],
    [
        113.0886661032,
        23.055172561506
    ],
    [
        113.08864051959,
        23.055161802529
    ],
    [
        113.08861465867,
        23.055145350131
    ],
    [
        113.0885517961,
        23.055128071325
    ],
    [
        113.08850251802,
        23.05509052183
    ],
    [
        113.08843661404,
        23.055020654291
    ],
    [
        113.08831755158,
        23.054837059074
    ],
    [
        113.08825732098,
        23.054725332215
    ],
    [
        113.0882330668,
        23.054682272268
    ],
    [
        113.08819113879,
        23.054651407354
    ],
    [
        113.08816610009,
        23.054643088829
    ],
    [
        113.08813453804,
        23.054641919915
    ],
    [
        113.0881086937,
        23.054645280707
    ],
    [
        113.08810000975,
        23.054669826169
    ],
    [
        113.08808151983,
        23.05468230513
    ],
    [
        113.0880750356,
        23.054732051549
    ],
    [
        113.08808190888,
        23.054809820631
    ],
    [
        113.08806895343,
        23.054923964575
    ],
    [
        113.08805789279,
        23.055027770681
    ],
    [
        113.08804787409,
        23.055080824534
    ],
    [
        113.08802480815,
        23.055147906365
    ],
    [
        113.08798213962,
        23.055201166474
    ],
    [
        113.08794297741,
        23.05522073234
    ],
    [
        113.08789564646,
        23.055233635845
    ],
    [
        113.08777076627,
        23.055241984327
    ],
    [
        113.08763336863,
        23.055250797441
    ],
    [
        113.08747176946,
        23.055278430163
    ],
    [
        113.08741600198,
        23.05529228479
    ],
    [
        113.08730719904,
        23.055333252483
    ],
    [
        113.08713584405,
        23.055411252529
    ],
    [
        113.08701454232,
        23.055476028882
    ],
    [
        113.08691525719,
        23.055515245518
    ],
    [
        113.08683826293,
        23.055530523027
    ],
    [
        113.08680153212,
        23.055535694069
    ],
    [
        113.08675200239,
        23.055530479254
    ],
    [
        113.08668258787,
        23.055503049562
    ],
    [
        113.08657912998,
        23.055444670176
    ],
    [
        113.0864702095,
        23.055365216629
    ],
    [
        113.08643369369,
        23.055308529453
    ],
    [
        113.08640698952,
        23.055268784985
    ],
    [
        113.08639823545,
        23.055217911428
    ],
    [
        113.08639601789,
        23.055173177584
    ],
    [
        113.08639896911,
        23.055126736184
    ],
    [
        113.08642120534,
        23.055040927565
    ],
    [
        113.08644480788,
        23.054961609835
    ],
    [
        113.0864705564,
        23.054848615451
    ],
    [
        113.08648111265,
        23.054786863187
    ],
    [
        113.08648349226,
        23.054711127824
    ],
    [
        113.0864692682,
        23.054631035098
    ],
    [
        113.08645556417,
        23.054524887506
    ],
    [
        113.08645142874,
        23.05446688814
    ],
    [
        113.08643450959,
        23.054415597154
    ],
    [
        113.08641868085,
        23.054366460079
    ],
    [
        113.08638189614,
        23.054314932709
    ],
    [
        113.08635874988,
        23.054298196194
    ],
    [
        113.08635901646,
        23.054292222988
    ],
    [
        113.08633669962,
        23.054289582684
    ],
    [
        113.08631655997,
        23.054287180312
    ],
    [
        113.08628935261,
        23.054293026996
    ],
    [
        113.08628907797,
        23.054290318014
    ],
    [
        113.08626377617,
        23.054296949535
    ],
    [
        113.08625344574,
        23.054308233524
    ],
    [
        113.08618272669,
        23.054345685727
    ],
    [
        113.08599206126,
        23.054453650755
    ],
    [
        113.08564768105,
        23.054614782063
    ],
    [
        113.08538680872,
        23.054741537871
    ],
    [
        113.08511339714,
        23.054853056253
    ],
    [
        113.08492513835,
        23.054934749609
    ],
    [
        113.08485276884,
        23.054962499948
    ],
    [
        113.08474939743,
        23.055017883248
    ],
    [
        113.08466886275,
        23.055046584099
    ],
    [
        113.08460355585,
        23.055060932724
    ],
    [
        113.08452082045,
        23.055064983357
    ],
    [
        113.08448299416,
        23.055070750784
    ],
    [
        113.08440517231,
        23.055091547358
    ],
    [
        113.08435293706,
        23.055115457631
    ],
    [
        113.08421118489,
        23.055170942741
    ],
    [
        113.08406616409,
        23.055225403212
    ],
    [
        113.08372686293,
        23.055346009698
    ],
    [
        113.08356850189,
        23.055402885299
    ],
    [
        113.08336577236,
        23.055460233293
    ],
    [
        113.08324931115,
        23.055501508248
    ],
    [
        113.0831205921,
        23.055533766769
    ],
    [
        113.08294506309,
        23.055576308725
    ],
    [
        113.08274395866,
        23.055633940252
    ],
    [
        113.08257304854,
        23.055671540438
    ],
    [
        113.0823681117,
        23.055710265872
    ],
    [
        113.08225325749,
        23.055730385069
    ],
    [
        113.08210112099,
        23.055763349164
    ],
    [
        113.08187929507,
        23.055795062358
    ],
    [
        113.08170674021,
        23.05582920333
    ],
    [
        113.08151893827,
        23.055861984396
    ],
    [
        113.08130500375,
        23.055897663802
    ],
    [
        113.08107120067,
        23.055940207037
    ],
    [
        113.08084256474,
        23.055979688447
    ],
    [
        113.08067081716,
        23.056012770612
    ],
    [
        113.08049716131,
        23.056044263735
    ],
    [
        113.08036705577,
        23.056069038091
    ],
    [
        113.08018032067,
        23.056089372842
    ],
    [
        113.08002816608,
        23.056118336721
    ],
    [
        113.07993098328,
        23.056125183749
    ],
    [
        113.07978807691,
        23.056146666944
    ],
    [
        113.07974698207,
        23.056161763779
    ],
    [
        113.07967593833,
        23.056174127806
    ],
    [
        113.07952623179,
        23.05620360375
    ],
    [
        113.07930087012,
        23.056266151815
    ],
    [
        113.07906107511,
        23.056325432638
    ],
    [
        113.07888770019,
        23.056377313355
    ],
    [
        113.07873282301,
        23.056412864397
    ],
    [
        113.07856324339,
        23.05644786272
    ],
    [
        113.07844755383,
        23.056466178296
    ],
    [
        113.07831525564,
        23.056483159811
    ],
    [
        113.07820637098,
        23.056500544026
    ],
    [
        113.07804821546,
        23.056525581279
    ],
    [
        113.07792600301,
        23.056557854227
    ],
    [
        113.07777792872,
        23.056592755406
    ],
    [
        113.07750055565,
        23.056652190899
    ],
    [
        113.07728253058,
        23.056708952581
    ],
    [
        113.07711321318,
        23.056736637168
    ],
    [
        113.07701359,
        23.056761461637
    ],
    [
        113.07696186334,
        23.056763190724
    ],
    [
        113.07679988625,
        23.056779080035
    ],
    [
        113.07670214939,
        23.056781623506
    ],
    [
        113.07666403869,
        23.056787181674
    ],
    [
        113.07657339933,
        23.056811576524
    ],
    [
        113.07644681831,
        23.056831181059
    ],
    [
        113.07631452897,
        23.056861196688
    ],
    [
        113.07616237105,
        23.056898075362
    ],
    [
        113.07592365876,
        23.056960632162
    ],
    [
        113.0757099833,
        23.057010806605
    ],
    [
        113.07560655426,
        23.057042208929
    ],
    [
        113.07549061934,
        23.057094180708
    ],
    [
        113.07537711913,
        23.057127930432
    ],
    [
        113.0753224057,
        23.057138664383
    ],
    [
        113.0752442825,
        23.057153881333
    ],
    [
        113.07514845633,
        23.057161270846
    ],
    [
        113.07489881152,
        23.057171915738
    ],
    [
        113.07464426845,
        23.057183998662
    ],
    [
        113.07440552272,
        23.057202852195
    ],
    [
        113.07416570032,
        23.057234742172
    ],
    [
        113.07396996068,
        23.057240619871
    ],
    [
        113.07382049742,
        23.057239441821
    ],
    [
        113.07366995878,
        23.05725347356
    ],
    [
        113.07355208351,
        23.057260148158
    ],
    [
        113.07341897865,
        23.05728499385
    ],
    [
        113.07332180482,
        23.057303783557
    ],
    [
        113.07317507156,
        23.057308241972
    ],
    [
        113.07295921237,
        23.05733804708
    ],
    [
        113.07279616435,
        23.057363128958
    ],
    [
        113.07263474765,
        23.057384650693
    ],
    [
        113.07251796649,
        23.057392642985
    ],
    [
        113.07235164774,
        23.057409899905
    ],
    [
        113.07224548929,
        23.057423128789
    ],
    [
        113.07213769082,
        23.057427972782
    ],
    [
        113.07198034234,
        23.057426612856
    ],
    [
        113.07186436811,
        23.057419381925
    ],
    [
        113.0717698973,
        23.057408794597
    ],
    [
        113.07165393155,
        23.057410240257
    ],
    [
        113.07160357378,
        23.057414087208
    ],
    [
        113.07149959177,
        23.057421563855
    ],
    [
        113.07133600224,
        23.057438194605
    ],
    [
        113.07121188709,
        23.057456860081
    ],
    [
        113.07099794921,
        23.057483830044
    ],
    [
        113.07087656521,
        23.057510578039
    ],
    [
        113.07075163597,
        23.057528699847
    ],
    [
        113.07059024612,
        23.057563711408
    ],
    [
        113.07040190163,
        23.057589401339
    ],
    [
        113.07020756126,
        23.057603786102
    ],
    [
        113.07006166022,
        23.057601342998
    ],
    [
        113.06981614037,
        23.057602722165
    ],
    [
        113.06958641692,
        23.057610603786
    ],
    [
        113.06939507562,
        23.057618920698
    ],
    [
        113.06921598808,
        23.057630822488
    ],
    [
        113.06898003073,
        23.057658566199
    ],
    [
        113.06887934909,
        23.057687071059
    ],
    [
        113.0687857197,
        23.057685883845
    ],
    [
        113.06860637308,
        23.057703991738
    ],
    [
        113.06835436851,
        23.057731670921
    ],
    [
        113.06814809466,
        23.057762662513
    ],
    [
        113.0679502566,
        23.057788347839
    ],
    [
        113.06778045534,
        23.057816285255
    ],
    [
        113.0676343179,
        23.057825658085
    ],
    [
        113.06740352864,
        23.05781546457
    ],
    [
        113.06725059268,
        23.057825192338
    ],
    [
        113.06702308648,
        23.05782657671
    ],
    [
        113.06690496671,
        23.057810235223
    ],
    [
        113.06677841889,
        23.057801886141
    ],
    [
        113.06662383644,
        23.057785008259
    ],
    [
        113.06654628133,
        23.057785387126
    ],
    [
        113.06642139504,
        23.057806294334
    ],
    [
        113.06631309957,
        23.057815545962
    ],
    [
        113.06616017046,
        23.05781516017
    ],
    [
        113.0660499798,
        23.057832566673
    ],
    [
        113.06590686715,
        23.057852091372
    ],
    [
        113.06577138168,
        23.057879088672
    ],
    [
        113.06563697618,
        23.057893851573
    ],
    [
        113.06552323993,
        23.057894461053
    ],
    [
        113.06536679957,
        23.057910618716
    ],
    [
        113.06526775976,
        23.057911810063
    ],
    [
        113.06509500302,
        23.057933341603
    ],
    [
        113.06497501972,
        23.057939165913
    ],
    [
        113.06496413438,
        23.057936611552
    ],
    [
        113.0648291892,
        23.057943187532
    ],
    [
        113.0647252503,
        23.057935468622
    ],
    [
        113.06456335532,
        23.05791989577
    ],
    [
        113.06444090631,
        23.057896961927
    ],
    [
        113.06425699124,
        23.057895243009
    ],
    [
        113.06416067524,
        23.057886027449
    ],
    [
        113.06401131782,
        23.057885964693
    ],
    [
        113.06385542641,
        23.057877027363
    ],
    [
        113.06365437983,
        23.057868974414
    ],
    [
        113.06347237397,
        23.057853310767
    ],
    [
        113.06332872741,
        23.057836832268
    ],
    [
        113.0631644097,
        23.057820622586
    ],
    [
        113.06294566152,
        23.057768502231
    ],
    [
        113.0627057006,
        23.057714193735
    ],
    [
        113.06247310191,
        23.057673047822
    ],
    [
        113.06224322414,
        23.057625050155
    ],
    [
        113.06203376112,
        23.057587880424
    ],
    [
        113.06181723101,
        23.057549145165
    ],
    [
        113.06167170843,
        23.057530374054
    ],
    [
        113.06154087495,
        23.057511675955
    ],
    [
        113.06141575605,
        23.057494251937
    ],
    [
        113.06131375018,
        23.057470290349
    ],
    [
        113.06111111067,
        23.057432097165
    ],
    [
        113.06095089668,
        23.057389833204
    ],
    [
        113.06076919223,
        23.057335059504
    ],
    [
        113.0606250328,
        23.057296365105
    ],
    [
        113.06048113393,
        23.05724110308
    ],
    [
        113.06033585632,
        23.057160339195
    ],
    [
        113.06016065387,
        23.057060103302
    ],
    [
        113.06000419917,
        23.056939009667
    ],
    [
        113.05991358213,
        23.056856486153
    ],
    [
        113.05983273838,
        23.056755395636
    ],
    [
        113.0597303667,
        23.056598924486
    ],
    [
        113.05966064715,
        23.056469480592
    ],
    [
        113.0595865903,
        23.056354461827
    ],
    [
        113.05947605696,
        23.056190195288
    ],
    [
        113.05942648285,
        23.056088460355
    ],
    [
        113.05937090123,
        23.055957487697
    ],
    [
        113.05932454185,
        23.055802263349
    ],
    [
        113.05929724622,
        23.055682912682
    ],
    [
        113.05924808238,
        23.055433839651
    ],
    [
        113.05922452618,
        23.055242003576
    ],
    [
        113.05921785505,
        23.055082268862
    ],
    [
        113.05917007875,
        23.054867092224
    ],
    [
        113.05917315681,
        23.05466736603
    ],
    [
        113.05917950982,
        23.05448198383
    ],
    [
        113.05918964702,
        23.05427376893
    ],
    [
        113.05920629631,
        23.054052730187
    ],
    [
        113.05921422434,
        23.053810352278
    ],
    [
        113.05922381101,
        23.053598072681
    ],
    [
        113.05922889574,
        23.053512821448
    ],
    [
        113.0592446755,
        23.053238883014
    ],
    [
        113.05925209575,
        23.053038022113
    ],
    [
        113.05927908472,
        23.052830976326
    ],
    [
        113.05930749851,
        23.052692287719
    ],
    [
        113.0593535925,
        23.052561813768
    ],
    [
        113.05939882028,
        23.052379253603
    ],
    [
        113.05943619221,
        23.052226625019
    ],
    [
        113.05946566152,
        23.0520559048
    ],
    [
        113.05949321133,
        23.051868925829
    ],
    [
        113.05949768864,
        23.051721275124
    ],
    [
        113.05952599315,
        23.05147323873
    ],
    [
        113.05955136405,
        23.051283840722
    ],
    [
        113.05958332709,
        23.051162199368
    ],
    [
        113.05957671867,
        23.051078434128
    ],
    [
        113.05957763016,
        23.050900977068
    ],
    [
        113.05957148181,
        23.050733366972
    ],
    [
        113.05955813477,
        23.050436415213
    ],
    [
        113.05956399047,
        23.050310454278
    ],
    [
        113.05956485268,
        23.050085515375
    ],
    [
        113.05957012132,
        23.0499169627
    ],
    [
        113.05957817055,
        23.049809969743
    ],
    [
        113.05959866462,
        23.049641245643
    ],
    [
        113.05960121775,
        23.049476793145
    ],
    [
        113.05960022918,
        23.049305597296
    ],
    [
        113.05959026962,
        23.049136130296
    ],
    [
        113.05957522884,
        23.049050560212
    ],
    [
        113.05957568302,
        23.048962102634
    ],
    [
        113.05957736915,
        23.04874800694
    ],
    [
        113.05958071444,
        23.048561567856
    ],
    [
        113.05958482272,
        23.04832356803
    ],
    [
        113.05959635824,
        23.048170409887
    ],
    [
        113.05959244867,
        23.048069248932
    ],
    [
        113.05958358498,
        23.047909265716
    ],
    [
        113.05956550267,
        23.047774619411
    ],
    [
        113.05952050335,
        23.047640274592
    ],
    [
        113.05950461666,
        23.047525681089
    ],
    [
        113.05948807667,
        23.047303920495
    ],
    [
        113.05944329155,
        23.047112863404
    ],
    [
        113.05941518395,
        23.047011971365
    ],
    [
        113.05932525079,
        23.046805675038
    ],
    [
        113.05928160487,
        23.046664253002
    ],
    [
        113.05920422018,
        23.046497424146
    ],
    [
        113.05906151427,
        23.046259943492
    ],
    [
        113.05891636962,
        23.046027358172
    ],
    [
        113.05876907328,
        23.045814315927
    ],
    [
        113.05861445886,
        23.045619513793
    ],
    [
        113.05847917858,
        23.045453252906
    ],
    [
        113.0583972636,
        23.045366195694
    ],
    [
        113.05837958165,
        23.045354440716
    ],
    [
        113.05829000933,
        23.045221330726
    ],
    [
        113.05817753165,
        23.045017361265
    ],
    [
        113.05805578456,
        23.044784715545
    ],
    [
        113.05789975276,
        23.044515501675
    ],
    [
        113.05777097239,
        23.044310575432
    ],
    [
        113.05770180997,
        23.044191875021
    ],
    [
        113.05758798562,
        23.043988954019
    ],
    [
        113.05742386443,
        23.043771043264
    ],
    [
        113.05727470067,
        23.043557039294
    ],
    [
        113.05721972691,
        23.043487016804
    ],
    [
        113.05712664415,
        23.043359015921
    ],
    [
        113.0569546555,
        23.043142204793
    ],
    [
        113.05678297469,
        23.042956027497
    ],
    [
        113.05670024297,
        23.042844451808
    ],
    [
        113.05657886753,
        23.042679224328
    ],
    [
        113.05641508769,
        23.042501608614
    ],
    [
        113.05624882744,
        23.042284650971
    ],
    [
        113.05607741756,
        23.042076126459
    ],
    [
        113.05595413537,
        23.041892404752
    ],
    [
        113.05585043615,
        23.041723972234
    ],
    [
        113.05571059623,
        23.041552574704
    ],
    [
        113.05559524805,
        23.041414605451
    ],
    [
        113.05541767188,
        23.041268987103
    ],
    [
        113.05531459768,
        23.041172405326
    ],
    [
        113.05518730462,
        23.041036120354
    ],
    [
        113.05506465448,
        23.040921220676
    ],
    [
        113.05496485787,
        23.040835436723
    ],
    [
        113.05493440721,
        23.040813963613
    ],
    [
        113.05479219086,
        23.040688332418
    ],
    [
        113.05462307273,
        23.04055311531
    ],
    [
        113.05443628927,
        23.040405520919
    ],
    [
        113.05428215874,
        23.040306504471
    ],
    [
        113.05409243086,
        23.040191978131
    ],
    [
        113.05395896928,
        23.040107698957
    ],
    [
        113.05375895607,
        23.040019778352
    ],
    [
        113.05351954349,
        23.039910371681
    ],
    [
        113.05338177131,
        23.039848302643
    ],
    [
        113.05324263013,
        23.039771302949
    ],
    [
        113.05307304427,
        23.03966462545
    ],
    [
        113.05289697282,
        23.039586450019
    ],
    [
        113.05272145096,
        23.039509058358
    ],
    [
        113.05245003377,
        23.039395271273
    ],
    [
        113.05219030501,
        23.039279187291
    ],
    [
        113.05199281241,
        23.039203969262
    ],
    [
        113.05190425857,
        23.039173486232
    ],
    [
        113.05183500392,
        23.039162164618
    ],
    [
        113.05160446606,
        23.039159213151
    ],
    [
        113.05142849536,
        23.039136972547
    ],
    [
        113.0509962185,
        23.03910550071
    ],
    [
        113.05084742564,
        23.039092549982
    ],
    [
        113.05065954649,
        23.039083259517
    ],
    [
        113.05052272483,
        23.039088125584
    ],
    [
        113.05040681367,
        23.039096967964
    ],
    [
        113.05027245886,
        23.039119972422
    ],
    [
        113.05010664946,
        23.039175626273
    ],
    [
        113.04993621021,
        23.039209835739
    ],
    [
        113.04975110607,
        23.039230769118
    ],
    [
        113.04955894604,
        23.039246265216
    ],
    [
        113.04935811218,
        23.039266634833
    ],
    [
        113.04915565304,
        23.039282359099
    ],
    [
        113.04891521469,
        23.039307087495
    ],
    [
        113.0487369425,
        23.039340313623
    ],
    [
        113.04849707594,
        23.039375529682
    ],
    [
        113.04826915989,
        23.039410400936
    ],
    [
        113.04800897915,
        23.039462093905
    ],
    [
        113.04785218219,
        23.039504367462
    ],
    [
        113.04774067821,
        23.039521059791
    ],
    [
        113.04764762674,
        23.039537448517
    ],
    [
        113.04756707507,
        23.039571723226
    ],
    [
        113.04748001839,
        23.039611696035
    ],
    [
        113.04735878542,
        23.039660102875
    ],
    [
        113.04721123573,
        23.039705802352
    ],
    [
        113.04712551935,
        23.039722683262
    ],
    [
        113.04701674347,
        23.039739027581
    ],
    [
        113.04688735533,
        23.039759168405
    ],
    [
        113.04676775361,
        23.039796926474
    ],
    [
        113.04670837154,
        23.039827060229
    ],
    [
        113.04661262217,
        23.03983983304
    ],
    [
        113.04646044449,
        23.039846631472
    ],
    [
        113.04625972714,
        23.039865340006
    ],
    [
        113.04607746682,
        23.039888629698
    ],
    [
        113.04586186111,
        23.039922995625
    ],
    [
        113.04569834014,
        23.03995735491
    ],
    [
        113.04553753359,
        23.039988707058
    ],
    [
        113.0453534142,
        23.040026795165
    ],
    [
        113.04509772178,
        23.040082944175
    ],
    [
        113.04484829827,
        23.040158848122
    ],
    [
        113.04450264956,
        23.040264100569
    ],
    [
        113.04416759691,
        23.04036763672
    ],
    [
        113.04393583499,
        23.040436583772
    ],
    [
        113.04364230589,
        23.040545750243
    ],
    [
        113.04333850373,
        23.040667831365
    ],
    [
        113.04304990172,
        23.040791231889
    ],
    [
        113.04281983158,
        23.04087649676
    ],
    [
        113.04265344161,
        23.040929378819
    ],
    [
        113.04245426459,
        23.040988898683
    ],
    [
        113.04223477981,
        23.041062412606
    ],
    [
        113.04198522402,
        23.04114145759
    ],
    [
        113.04180420902,
        23.041178685666
    ],
    [
        113.04163185597,
        23.041198829181
    ],
    [
        113.04137061194,
        23.041214194561
    ],
    [
        113.04114485873,
        23.041206880536
    ],
    [
        113.04104105308,
        23.041192262825
    ],
    [
        113.04082638845,
        23.041149124879
    ],
    [
        113.04066374325,
        23.041089942821
    ],
    [
        113.04049158406,
        23.04099514254
    ],
    [
        113.04033567352,
        23.040885755454
    ],
    [
        113.04016834901,
        23.040736940181
    ],
    [
        113.04001291878,
        23.040554797736
    ],
    [
        113.03987620281,
        23.040387940196
    ],
    [
        113.03973645956,
        23.040168683207
    ],
    [
        113.03961218661,
        23.039973652977
    ],
    [
        113.03951125113,
        23.039815113497
    ],
    [
        113.03935497156,
        23.039572915345
    ],
    [
        113.03926923238,
        23.039435072832
    ],
    [
        113.03921932323,
        23.039369630228
    ],
    [
        113.03910352725,
        23.039242702143
    ],
    [
        113.0389868939,
        23.039086997139
    ],
    [
        113.03885672232,
        23.038934714734
    ],
    [
        113.03872331383,
        23.038793247981
    ],
    [
        113.03860889574,
        23.03867903247
    ],
    [
        113.03842913153,
        23.038490807799
    ],
    [
        113.03824776956,
        23.038325063298
    ],
    [
        113.03808565998,
        23.038176257742
    ],
    [
        113.03794470475,
        23.038052824481
    ],
    [
        113.03778313812,
        23.037895299764
    ],
    [
        113.03762107664,
        23.037783059212
    ],
    [
        113.03744327724,
        23.037632685661
    ],
    [
        113.03731728583,
        23.037566004371
    ],
    [
        113.03717965781,
        23.037505182555
    ],
    [
        113.03701330159,
        23.037415344032
    ],
    [
        113.03687104383,
        23.037317820622
    ],
    [
        113.03679761938,
        23.037274323638
    ],
    [
        113.03675183402,
        23.037250324656
    ],
    [
        113.03654537052,
        23.037111781354
    ],
    [
        113.03640312377,
        23.037013389989
    ],
    [
        113.03621400442,
        23.036877659173
    ],
    [
        113.03606581336,
        23.0367837877
    ],
    [
        113.03591382702,
        23.036680367364
    ],
    [
        113.03584745381,
        23.036636337247
    ],
    [
        113.03578215682,
        23.036583903022
    ],
    [
        113.03571522838,
        23.036522767923
    ],
    [
        113.03561039888,
        23.036463438374
    ],
    [
        113.03544002765,
        23.036374436441
    ],
    [
        113.0352133361,
        23.036268578735
    ],
    [
        113.03501454061,
        23.036167573183
    ],
    [
        113.03491188851,
        23.036107665792
    ],
    [
        113.03477457233,
        23.03602976177
    ],
    [
        113.03456547137,
        23.035890598661
    ],
    [
        113.0344007831,
        23.035766248474
    ],
    [
        113.03419223039,
        23.035619978073
    ],
    [
        113.03408090988,
        23.035536038294
    ],
    [
        113.03394981935,
        23.035436681977
    ],
    [
        113.03383011691,
        23.035357514403
    ],
    [
        113.03371474504,
        23.035275670791
    ],
    [
        113.03362103069,
        23.035197313005
    ],
    [
        113.0335037534,
        23.035098066556
    ],
    [
        113.03338916715,
        23.034977949367
    ],
    [
        113.03331601318,
        23.034883523019
    ],
    [
        113.03327102749,
        23.034813558736
    ],
    [
        113.03323606217,
        23.034751032151
    ],
    [
        113.0331981315,
        23.034702036559
    ],
    [
        113.03313692667,
        23.034653317057
    ],
    [
        113.03309331516,
        23.034606424263
    ],
    [
        113.0330868142,
        23.034599567047
    ],
    [
        113.03307328287,
        23.034599954638
    ],
    [
        113.03304946858,
        23.034601580653
    ],
    [
        113.03301483086,
        23.034605252284
    ],
    [
        113.03296395702,
        23.034610634962
    ],
    [
        113.03292363264,
        23.034609626413
    ],
    [
        113.03283083943,
        23.034646804726
    ],
    [
        113.03266421619,
        23.034740357878
    ],
    [
        113.03244377619,
        23.034869607522
    ],
    [
        113.03229447898,
        23.034960339412
    ],
    [
        113.03216707972,
        23.035023104596
    ],
    [
        113.03207537635,
        23.03505672019
    ],
    [
        113.03192769468,
        23.035128442318
    ],
    [
        113.03164775531,
        23.035261995892
    ],
    [
        113.03133347436,
        23.035406186538
    ],
    [
        113.0309021038,
        23.035603335304
    ],
    [
        113.03051509362,
        23.035762423665
    ],
    [
        113.0302335752,
        23.035883490508
    ],
    [
        113.03004454951,
        23.035964246737
    ],
    [
        113.02980657631,
        23.036057338035
    ],
    [
        113.02960780802,
        23.036121361298
    ],
    [
        113.02936009856,
        23.036201503406
    ],
    [
        113.02913835129,
        23.036267594081
    ],
    [
        113.02911374545,
        23.036277558882
    ],
    [
        113.02892337503,
        23.036337007872
    ],
    [
        113.02873651574,
        23.036385905038
    ],
    [
        113.02853235343,
        23.036438332552
    ],
    [
        113.02825387727,
        23.036556945608
    ],
    [
        113.0281265247,
        23.036596061152
    ],
    [
        113.0279896942,
        23.03661983553
    ],
    [
        113.02779150153,
        23.036674981476
    ],
    [
        113.02763277252,
        23.036701662459
    ],
    [
        113.02748135578,
        23.036736850238
    ],
    [
        113.02729099022,
        23.036762759682
    ],
    [
        113.02712875315,
        23.036788533161
    ],
    [
        113.0268854131,
        23.036838835621
    ],
    [
        113.02660504472,
        23.036903463281
    ],
    [
        113.0263773945,
        23.036946350292
    ],
    [
        113.02622464239,
        23.036978711288
    ],
    [
        113.02605161169,
        23.03701047379
    ],
    [
        113.0258172353,
        23.037077344272
    ],
    [
        113.02566691287,
        23.037096682028
    ],
    [
        113.0254949869,
        23.037144155484
    ],
    [
        113.02520195884,
        23.037221699341
    ],
    [
        113.02490002907,
        23.037313715262
    ],
    [
        113.02471486333,
        23.037357935539
    ],
    [
        113.02456592108,
        23.037392692018
    ],
    [
        113.02438969275,
        23.037448157792
    ],
    [
        113.02419590139,
        23.037512277688
    ],
    [
        113.02401020527,
        23.037556439565
    ],
    [
        113.02384504817,
        23.037589261454
    ],
    [
        113.02358285724,
        23.037643527104
    ],
    [
        113.02338418056,
        23.037674409698
    ],
    [
        113.02329064943,
        23.037683160116
    ],
    [
        113.023182528,
        23.03770007443
    ],
    [
        113.02300441128,
        23.03774050074
    ],
    [
        113.02281438833,
        23.037766336913
    ],
    [
        113.02267923798,
        23.037784406744
    ],
    [
        113.02251380292,
        23.037793005128
    ],
    [
        113.02237650221,
        23.037821607717
    ],
    [
        113.0222240563,
        23.037841536542
    ],
    [
        113.02210405891,
        23.037870422911
    ],
    [
        113.02199433173,
        23.037896224963
    ],
    [
        113.02189026914,
        23.037908283638
    ],
    [
        113.02179565101,
        23.037901780535
    ],
    [
        113.0216899643,
        23.037910278876
    ],
    [
        113.02155454567,
        23.037921247907
    ],
    [
        113.02141264666,
        23.037938883673
    ],
    [
        113.02125264983,
        23.03796949668
    ],
    [
        113.02108157008,
        23.037998555449
    ],
    [
        113.02091885513,
        23.03801038854
    ],
    [
        113.02081263352,
        23.038020212421
    ],
    [
        113.02068640262,
        23.038022360606
    ],
    [
        113.0205685494,
        23.038021938228
    ],
    [
        113.02052179396,
        23.038029534817
    ],
    [
        113.02040369687,
        23.038056507124
    ],
    [
        113.02021533223,
        23.038094187065
    ],
    [
        113.02003262494,
        23.038110254413
    ],
    [
        113.01985883394,
        23.03812131737
    ],
    [
        113.01966938772,
        23.038154619452
    ],
    [
        113.01950210329,
        23.038184236169
    ],
    [
        113.01931183148,
        23.038199606674
    ],
    [
        113.0191345229,
        23.038202449115
    ],
    [
        113.01898452711,
        23.038218793081
    ],
    [
        113.01882641951,
        23.038231192453
    ],
    [
        113.01858397013,
        23.038230157884
    ],
    [
        113.01837665722,
        23.038227027119
    ],
    [
        113.01819448462,
        23.038227051667
    ],
    [
        113.01799149854,
        23.038224804582
    ],
    [
        113.01785204131,
        23.038234807467
    ],
    [
        113.01771230972,
        23.038240191822
    ],
    [
        113.01749607477,
        23.038231190933
    ],
    [
        113.01729524893,
        23.038224903868
    ],
    [
        113.01713280921,
        23.038224725046
    ],
    [
        113.01694253017,
        23.038224049555
    ],
    [
        113.01674954486,
        23.038219526651
    ],
    [
        113.01653467773,
        23.038226551295
    ],
    [
        113.01642953394,
        23.038221964903
    ],
    [
        113.01636845187,
        23.038223589827
    ],
    [
        113.01619059908,
        23.038215537749
    ],
    [
        113.01601679384,
        23.038200504054
    ],
    [
        113.01588596886,
        23.038191391371
    ],
    [
        113.01579866248,
        23.038185767124
    ],
    [
        113.01574162025,
        23.038172271122
    ],
    [
        113.01568079295,
        23.03815762261
    ],
    [
        113.01559428122,
        23.038134920342
    ],
    [
        113.01547642708,
        23.038123327332
    ],
    [
        113.01536830034,
        23.038108923555
    ],
    [
        113.01523098211,
        23.03809373017
    ],
    [
        113.01511366882,
        23.038082963135
    ],
    [
        113.01504420132,
        23.038078201862
    ],
    [
        113.01495985791,
        23.038062595491
    ],
    [
        113.01482767288,
        23.0380458692
    ],
    [
        113.01466926074,
        23.038019454519
    ],
    [
        113.01455328335,
        23.037993251445
    ],
    [
        113.01444621846,
        23.037959882022
    ],
    [
        113.01435890325,
        23.037946669341
    ],
    [
        113.01415179854,
        23.037878432389
    ],
    [
        113.01395389967,
        23.037828269704
    ],
    [
        113.01377356479,
        23.037773809272
    ],
    [
        113.01366379483,
        23.037740130715
    ],
    [
        113.01349671129,
        23.037694592643
    ],
    [
        113.01333881916,
        23.0376513907
    ],
    [
        113.01313388658,
        23.037599499369
    ],
    [
        113.01306494784,
        23.037585538987
    ],
    [
        113.0129992571,
        23.037576519952
    ],
    [
        113.01291546448,
        23.037576409529
    ],
    [
        113.01275303269,
        23.037596088396
    ],
    [
        113.01267274118,
        23.037583019708
    ],
    [
        113.01254135513,
        23.037562278493
    ],
    [
        113.0124372678,
        23.037540116636
    ],
    [
        113.0122387948,
        23.03746558076
    ],
    [
        113.0121665876,
        23.037427428327
    ],
    [
        113.01208005467,
        23.037390113882
    ],
    [
        113.01197349893,
        23.037331563172
    ],
    [
        113.01185967207,
        23.037303005138
    ],
    [
        113.01171744888,
        23.03726039427
    ],
    [
        113.01155521867,
        23.037214730491
    ],
    [
        113.01135242703,
        23.037155353492
    ],
    [
        113.01120804132,
        23.03711652146
    ],
    [
        113.01102199644,
        23.03704659584
    ],
    [
        113.01086705178,
        23.036992674134
    ],
    [
        113.010768635,
        23.036972549183
    ],
    [
        113.01067967531,
        23.036948246546
    ],
    [
        113.01051553666,
        23.036894455166
    ],
    [
        113.01038951689,
        23.036844571493
    ],
    [
        113.01024643792,
        23.036764831686
    ],
    [
        113.0100754826,
        23.0366515292
    ],
    [
        113.00995323217,
        23.03658815994
    ],
    [
        113.00981826996,
        23.036519427823
    ],
    [
        113.00959971076,
        23.036385006932
    ],
    [
        113.00943905709,
        23.036310166322
    ],
    [
        113.00931518425,
        23.036251679456
    ],
    [
        113.00910042574,
        23.036142319437
    ],
    [
        113.00888946625,
        23.036052030087
    ],
    [
        113.00867632717,
        23.035946527922
    ],
    [
        113.00852051572,
        23.035855540497
    ],
    [
        113.00819077821,
        23.035679812774
    ],
    [
        113.00802520971,
        23.035568349619
    ],
    [
        113.00789834583,
        23.035504725748
    ],
    [
        113.00773172611,
        23.035431791903
    ],
    [
        113.00762188445,
        23.035357601704
    ],
    [
        113.00756290895,
        23.035322207642
    ],
    [
        113.00750446661,
        23.035278412848
    ],
    [
        113.00741731576,
        23.035180988047
    ],
    [
        113.00736317985,
        23.035115017402
    ],
    [
        113.00727657433,
        23.035023575441
    ],
    [
        113.00720158107,
        23.034915498088
    ],
    [
        113.00710872005,
        23.034782724917
    ],
    [
        113.00701882741,
        23.034643219331
    ],
    [
        113.00696088264,
        23.034551153023
    ],
    [
        113.00689643533,
        23.034444064794
    ],
    [
        113.00681412299,
        23.034315538354
    ],
    [
        113.00671938161,
        23.034198759938
    ],
    [
        113.00662302482,
        23.03409091398
    ],
    [
        113.00648901528,
        23.033905711398
    ],
    [
        113.00637886,
        23.033790610074
    ],
    [
        113.00623568167,
        23.033638111566
    ],
    [
        113.00613200776,
        23.03351444057
    ],
    [
        113.0059566166,
        23.033325658424
    ],
    [
        113.00588244225,
        23.033231748661
    ],
    [
        113.00575817313,
        23.033058407732
    ],
    [
        113.00567318965,
        23.032975738185
    ],
    [
        113.00547127695,
        23.032770322849
    ],
    [
        113.00524203627,
        23.032552586925
    ],
    [
        113.00501602203,
        23.032315663213
    ],
    [
        113.00480464883,
        23.032129985692
    ],
    [
        113.00468124064,
        23.032031066162
    ],
    [
        113.00451831592,
        23.031897672375
    ],
    [
        113.00438245555,
        23.031789369574
    ],
    [
        113.00427908804,
        23.031729832772
    ],
    [
        113.00414624237,
        23.031677480102
    ],
    [
        113.00393195032,
        23.031588720188
    ],
    [
        113.00373253776,
        23.031509689909
    ],
    [
        113.00356504898,
        23.031442790866
    ],
    [
        113.00333316031,
        23.031354675996
    ],
    [
        113.0031848626,
        23.031277497118
    ],
    [
        113.00296053855,
        23.031189808562
    ],
    [
        113.00273810866,
        23.031110857872
    ],
    [
        113.00259713356,
        23.03107235551
    ],
    [
        113.0023812148,
        23.031031523364
    ],
    [
        113.00218260615,
        23.030992030909
    ],
    [
        113.00193934114,
        23.030939509366
    ],
    [
        113.00172340646,
        23.030902023658
    ],
    [
        113.00151720629,
        23.030864690855
    ],
    [
        113.0013672864,
        23.030835140882
    ],
    [
        113.00113836443,
        23.030821451812
    ],
    [
        113.00091322342,
        23.030807572838
    ],
    [
        113.00073489585,
        23.030802430531
    ],
    [
        113.00065291445,
        23.030817724126
    ],
    [
        113.00050355456,
        23.030838460403
    ],
    [
        113.00036691474,
        23.030865059482
    ],
    [
        113.00016423803,
        23.030888188336
    ],
    [
        112.99991476965,
        23.03095693105
    ],
    [
        112.99965474686,
        23.031038621991
    ],
    [
        112.99943017102,
        23.031121840625
    ],
    [
        112.99916338538,
        23.031232850586
    ],
    [
        112.99887494704,
        23.031359145817
    ],
    [
        112.99855023842,
        23.031503843737
    ],
    [
        112.99832213369,
        23.03162166697
    ],
    [
        112.99812837879,
        23.031710305258
    ],
    [
        112.99789537579,
        23.031813503023
    ],
    [
        112.9976902483,
        23.0319153879
    ],
    [
        112.99754519817,
        23.031992925703
    ],
    [
        112.99741882167,
        23.032065232727
    ],
    [
        112.9971617389,
        23.032221781654
    ],
    [
        112.99703482413,
        23.032307416283
    ],
    [
        112.99688030799,
        23.03241641467
    ],
    [
        112.99667300784,
        23.032549645814
    ],
    [
        112.99651929539,
        23.032658153873
    ],
    [
        112.99627655268,
        23.032843229541
    ],
    [
        112.99613527841,
        23.032940227389
    ],
    [
        112.99598236524,
        23.033047724633
    ],
    [
        112.99587574346,
        23.033139347699
    ],
    [
        112.99576019702,
        23.033247727871
    ],
    [
        112.99562163676,
        23.033365156479
    ],
    [
        112.99547224249,
        23.033484684876
    ],
    [
        112.99537643728,
        23.033565857899
    ],
    [
        112.9952681852,
        23.03366240584
    ],
    [
        112.99512175011,
        23.033767350657
    ],
    [
        112.99502078747,
        23.033840915963
    ],
    [
        112.99490413986,
        23.033945301322
    ],
    [
        112.99476204588,
        23.034068772721
    ],
    [
        112.99459910375,
        23.034205675311
    ],
    [
        112.9944269701,
        23.03436858121
    ],
    [
        112.9943070556,
        23.034465948847
    ],
    [
        112.99424237313,
        23.034533325011
    ],
    [
        112.99407858539,
        23.03464696181
    ],
    [
        112.99394596042,
        23.034776837882
    ],
    [
        112.99384364588,
        23.034874643126
    ],
    [
        112.99372536398,
        23.034992701912
    ],
    [
        112.99357865546,
        23.035135009298
    ],
    [
        112.99355915885,
        23.035145466189
    ],
    [
        112.99354994843,
        23.035146221498
    ],
    [
        112.99354966848,
        23.03513590978
    ],
    [
        112.99354367197,
        23.03509436059
    ],
    [
        112.99358648194,
        23.034789676777
    ],
    [
        112.99361397026,
        23.034622181157
    ],
    [
        112.9934823465,
        23.034669366385
    ],
    [
        112.99339161901,
        23.03470488277
    ],
    [
        112.99323398506,
        23.034756818632
    ],
    [
        112.9931717238,
        23.035128684082
    ],
    [
        112.99307254802,
        23.035421109829
    ],
    [
        112.99291362447,
        23.03585916398
    ],
    [
        112.99285425999,
        23.036130136526
    ],
    [
        112.99273898163,
        23.036589631442
    ],
    [
        112.99268581407,
        23.036819137452
    ],
    [
        112.99258729467,
        23.037230449023
    ],
    [
        112.99253795259,
        23.037491999312
    ],
    [
        112.99252133396,
        23.037685086716
    ],
    [
        112.99250540669,
        23.037748488313
    ],
    [
        112.99251533404,
        23.037931410691
    ],
    [
        112.99251072685,
        23.037930571638
    ],
    [
        112.99250075165,
        23.037983967028
    ],
    [
        112.9924850615,
        23.038011284968
    ],
    [
        112.99247966708,
        23.038037573592
    ],
    [
        112.99247400839,
        23.03807091509
    ],
    [
        112.99246589839,
        23.038090948771
    ],
    [
        112.99246430065,
        23.038120513829
    ],
    [
        112.99245403398,
        23.038152202636
    ],
    [
        112.99244620862,
        23.038186617877
    ],
    [
        112.99244108575,
        23.038213450807
    ],
    [
        112.99243434766,
        23.038251399134
    ],
    [
        112.99241976488,
        23.038303413958
    ],
    [
        112.99241655023,
        23.038342195269
    ],
    [
        112.99239735295,
        23.038385774796
    ],
    [
        112.99239765684,
        23.038420233887
    ],
    [
        112.99238766199,
        23.038452738751
    ],
    [
        112.99237306112,
        23.038485761819
    ],
    [
        112.9923627914,
        23.038514195669
    ],
    [
        112.99235821837,
        23.038549171502
    ],
    [
        112.99234443015,
        23.038581927953
    ],
    [
        112.9923455242,
        23.038592515184
    ],
    [
        112.99233123075,
        23.038663525092
    ],
    [
        112.99232394074,
        23.038690889798
    ],
    [
        112.99230582813,
        23.03873529064
    ],
    [
        112.99229935445,
        23.038766186957
    ],
    [
        112.99229370991,
        23.038813909453
    ],
    [
        112.99228400833,
        23.038869478963
    ],
    [
        112.99227321293,
        23.038914732713
    ],
    [
        112.99226186275,
        23.038946689035
    ],
    [
        112.99225458197,
        23.038983550446
    ],
    [
        112.9922500089,
        23.039018255466
    ],
    [
        112.99224083891,
        23.039062975391
    ],
    [
        112.99223737214,
        23.039120748382
    ],
    [
        112.99222685047,
        23.039168717243
    ],
    [
        112.9922184814,
        23.039200960839
    ],
    [
        112.99221039068,
        23.03924080289
    ],
    [
        112.99220689929,
        23.039273071845
    ],
    [
        112.99220395383,
        23.039309413433
    ],
    [
        112.99219209214,
        23.039372569627
    ],
    [
        112.99217884887,
        23.039408315556
    ],
    [
        112.99216886242,
        23.039449233457
    ],
    [
        112.99216157682,
        23.039480940443
    ],
    [
        112.9921532163,
        23.039521866844
    ],
    [
        112.99214000006,
        23.039585288017
    ],
    [
        112.99213543045,
        23.039623249441
    ],
    [
        112.9921202903,
        23.039658986406
    ],
    [
        112.99211246517,
        23.039693132867
    ],
    [
        112.99210599763,
        23.039729999488
    ],
    [
        112.99209383619,
        23.039763581411
    ],
    [
        112.99209143056,
        23.039797484218
    ],
    [
        112.99208087269,
        23.039808283535
    ],
    [
        112.99208116923,
        23.039834331766
    ],
    [
        112.99207117277,
        23.039864940388
    ],
    [
        112.99207225753,
        23.039865759829
    ],
    [
        112.99206906163,
        23.039922720919
    ],
    [
        112.99206205914,
        23.039966639448
    ],
    [
        112.99205561199,
        23.04002412684
    ],
    [
        112.99204752693,
        23.040069396623
    ],
    [
        112.99204972799,
        23.040103051421
    ],
    [
        112.99205300955,
        23.040133184503
    ],
    [
        112.99204653069,
        23.04015838469
    ],
    [
        112.99205008219,
        23.040187433844
    ],
    [
        112.99205363665,
        23.040219467552
    ],
    [
        112.99205040433,
        23.04023925767
    ],
    [
        112.99205179439,
        23.040274807651
    ],
    [
        112.9920496718,
        23.040320650132
    ],
    [
        112.99204049438,
        23.040357232254
    ],
    [
        112.99202672357,
        23.040407357453
    ],
    [
        112.99202052895,
        23.040445853948
    ],
    [
        112.99201675712,
        23.040468083363
    ],
    [
        112.99200595082,
        23.04050167311
    ],
    [
        112.99200517336,
        23.04053748356
    ],
    [
        112.99199519917,
        23.040590341347
    ],
    [
        112.99198845751,
        23.040623680222
    ],
    [
        112.99198307216,
        23.040658382489
    ],
    [
        112.99197848524,
        23.040678437428
    ],
    [
        112.99196578147,
        23.040711475518
    ],
    [
        112.99196174275,
        23.040737773627
    ],
    [
        112.99195255487,
        23.040763774954
    ],
    [
        112.99194716875,
        23.040797663443
    ],
    [
        112.99194476546,
        23.040833465935
    ],
    [
        112.99193558246,
        23.040864351211
    ],
    [
        112.99193020069,
        23.040902580949
    ],
    [
        112.99193131741,
        23.040935416293
    ],
    [
        112.99192323519,
        23.040983129009
    ],
    [
        112.99191625161,
        23.041045498527
    ],
    [
        112.99190572993,
        23.041092656761
    ],
    [
        112.99189709819,
        23.041132770001
    ],
    [
        112.99188711119,
        23.041172605367
    ],
    [
        112.99188201084,
        23.041221146954
    ],
    [
        112.9918731209,
        23.041274011233
    ],
    [
        112.99186233263,
        23.041325509749
    ],
    [
        112.99185506245,
        23.041372141676
    ],
    [
        112.99185072212,
        23.041367779459
    ],
    [
        112.99184561967,
        23.041414150656
    ],
    [
        112.99184105544,
        23.04145672599
    ],
    [
        112.99183025413,
        23.04149520135
    ],
    [
        112.99182758719,
        23.041538057246
    ],
    [
        112.99183087274,
        23.04157144567
    ],
    [
        112.99182766875,
        23.041619182763
    ],
    [
        112.99182311661,
        23.041673696399
    ],
    [
        112.99180934993,
        23.041727622997
    ],
    [
        112.99180044377,
        23.041764208552
    ],
    [
        112.99179261561,
        23.04179483028
    ],
    [
        112.99179453833,
        23.041820343747
    ],
    [
        112.99178778817,
        23.041845001615
    ],
    [
        112.99177943033,
        23.041887830378
    ],
    [
        112.99177431632,
        23.041922535072
    ],
    [
        112.99176324353,
        23.041960467186
    ],
    [
        112.99176056445,
        23.041991113753
    ],
    [
        112.99175571515,
        23.042019579405
    ],
    [
        112.99175303664,
        23.04205076864
    ],
    [
        112.99173871344,
        23.042090313455
    ],
    [
        112.99173522001,
        23.042119599613
    ],
    [
        112.99172902832,
        23.042160539819
    ],
    [
        112.99171957855,
        23.042195495549
    ],
    [
        112.99171094123,
        23.042229912559
    ],
    [
        112.99170745963,
        23.042270865711
    ],
    [
        112.9916969272,
        23.042307173138
    ],
    [
        112.99169127784,
        23.042348387451
    ],
    [
        112.99167100975,
        23.042404998467
    ],
    [
        112.9916678036,
        23.042450294203
    ],
    [
        112.99164833089,
        23.042489544765
    ],
    [
        112.99163781356,
        23.042540775554
    ],
    [
        112.99162213547,
        23.042580586924
    ],
    [
        112.99161539493,
        23.042614742201
    ],
    [
        112.99160648767,
        23.042650244091
    ],
    [
        112.99160624671,
        23.042679817086
    ],
    [
        112.99159624769,
        23.042707716985
    ],
    [
        112.99158896457,
        23.042741327279
    ],
    [
        112.99157436356,
        23.04277436126
    ],
    [
        112.99157628659,
        23.042799874401
    ],
    [
        112.99156466091,
        23.042827224456
    ],
    [
        112.99155738579,
        23.042868703346
    ],
    [
        112.99154496389,
        23.042912600615
    ],
    [
        112.99154282948,
        23.042945692162
    ],
    [
        112.99153311689,
        23.042988788004
    ],
    [
        112.9915269087,
        23.043013449997
    ],
    [
        112.99153073415,
        23.043044126873
    ],
    [
        112.99152317587,
        23.043073666529
    ],
    [
        112.99151101612,
        23.043108883075
    ],
    [
        112.99150752584,
        23.043141154569
    ],
    [
        112.99150403639,
        23.043174240047
    ],
    [
        112.99150241223,
        23.04317613193
    ],
    [
        112.99149513602,
        23.04321652596
    ],
    [
        112.99149408407,
        23.04324799459
    ],
    [
        112.99149246213,
        23.043252057077
    ],
    [
        112.99148870943,
        23.043292738445
    ],
    [
        112.99147627836,
        23.043327682835
    ],
    [
        112.99146899164,
        23.043357766746
    ],
    [
        112.99146604563,
        23.043392211418
    ],
    [
        112.99146147214,
        23.043425292159
    ],
    [
        112.9914587894,
        23.043452141009
    ],
    [
        112.9914463583,
        23.043487085745
    ],
    [
        112.99144693112,
        23.043517205113
    ],
    [
        112.99144263642,
        23.04355788422
    ],
    [
        112.99143644154,
        23.043595570285
    ],
    [
        112.99143294742,
        23.043624043505
    ],
    [
        112.99142756116,
        23.043657392082
    ],
    [
        112.99141324261,
        23.043701825053
    ],
    [
        112.99141301852,
        23.04374767757
    ],
    [
        112.99140411315,
        23.043785080423
    ],
    [
        112.99140169896,
        23.043809488716
    ],
    [
        112.99140443696,
        23.043836633159
    ],
    [
        112.99139796634,
        23.043869705741
    ],
    [
        112.99139259121,
        23.043913907454
    ],
    [
        112.99139260511,
        23.043927473648
    ],
    [
        112.9913899174,
        23.043949438853
    ],
    [
        112.9913918204,
        23.043955145074
    ],
    [
        112.99139211978,
        23.043982821314
    ],
    [
        112.99139270131,
        23.044021351713
    ],
    [
        112.99138975094,
        23.044051455435
    ],
    [
        112.99139438751,
        23.044079964898
    ],
    [
        112.99139251067,
        23.04409976312
    ],
    [
        112.99139116335,
        23.044107354175
    ],
    [
        112.99139200451,
        23.0441347615
    ],
    [
        112.99139636284,
        23.044156215348
    ],
    [
        112.99139014298,
        23.044169482545
    ],
    [
        112.99139585948,
        23.044193926967
    ],
    [
        112.9913969739,
        23.044223506094
    ],
    [
        112.99139103647,
        23.044247898773
    ],
    [
        112.99139701955,
        23.044268003222
    ],
    [
        112.99139515553,
        23.044300282346
    ],
    [
        112.99139626106,
        23.044321179107
    ],
    [
        112.99126939601,
        23.04482365528
    ],
    [
        112.99118898305,
        23.045167618975
    ],
    [
        112.99116282012,
        23.045291231231
    ],
    [
        112.99103977512,
        23.045823053193
    ],
    [
        112.99104411818,
        23.045829311517
    ],
    [
        112.99103707199,
        23.04583009646
    ],
    [
        112.99090028092,
        23.046703744514
    ],
    [
        112.99073459741,
        23.047690710937
    ],
    [
        112.99054121222,
        23.048902797291
    ],
    [
        112.99036158361,
        23.049796974444
    ],
    [
        112.99036537673,
        23.049795088466
    ],
    [
        112.99011396145,
        23.051029021201
    ],
    [
        112.98987817223,
        23.052197938616
    ],
    [
        112.98961535016,
        23.053486749176
    ],
    [
        112.98877774741,
        23.056386182351
    ],
    [
        112.98870128856,
        23.056707266004
    ],
    [
        112.98852090216,
        23.057591138172
    ],
    [
        112.98844093368,
        23.057949944137
    ],
    [
        112.98802677309,
        23.059925265609
    ],
    [
        112.98769794067,
        23.06122145437
    ],
    [
        112.98764842982,
        23.061393141088
    ],
    [
        112.98755158434,
        23.061753072234
    ],
    [
        112.9871710819,
        23.063030910045
    ],
    [
        112.98687821064,
        23.064037318076
    ],
    [
        112.98638436282,
        23.065741319888
    ],
    [
        112.9862335159,
        23.066254920611
    ],
    [
        112.98547407579,
        23.068643073518
    ],
    [
        112.98503097253,
        23.070247464949
    ],
    [
        112.98490762648,
        23.070671936874
    ],
    [
        112.9845535073,
        23.07185478834
    ],
    [
        112.9840633874,
        23.073533126466
    ],
    [
        112.98367185131,
        23.074767044635
    ],
    [
        112.98363874353,
        23.074874014917
    ],
    [
        112.98362625957,
        23.074903074947
    ],
    [
        112.98306248816,
        23.076632737967
    ],
    [
        112.98302013529,
        23.076763897419
    ],
    [
        112.98300275933,
        23.076818750167
    ],
    [
        112.98239615035,
        23.078359793704
    ],
    [
        112.98205229149,
        23.079283180951
    ],
    [
        112.98193167806,
        23.079619505766
    ],
    [
        112.98180426549,
        23.079968078731
    ],
    [
        112.98156846384,
        23.080491303576
    ],
    [
        112.98140219179,
        23.080863697704
    ],
    [
        112.98136089201,
        23.080961816723
    ],
    [
        112.98117287048,
        23.081370694931
    ],
    [
        112.98117124131,
        23.081370431762
    ],
    [
        112.98014927434,
        23.083802537135
    ],
    [
        112.98012318496,
        23.083841749383
    ],
    [
        112.97994981848,
        23.084046486046
    ],
    [
        112.97939406631,
        23.084715872337
    ],
    [
        112.97872678857,
        23.085527077475
    ],
    [
        112.97777038406,
        23.086712491789
    ],
    [
        112.9777703768,
        23.086725511135
    ],
    [
        112.97772465617,
        23.08685796404
    ],
    [
        112.97760786514,
        23.087256524694
    ],
    [
        112.97754526287,
        23.087441738485
    ],
    [
        112.97745704725,
        23.087743251109
    ],
    [
        112.97735795644,
        23.088046486062
    ],
    [
        112.9773255668,
        23.088134903215
    ],
    [
        112.97727300339,
        23.088328183578
    ],
    [
        112.97727300032,
        23.088333065762
    ],
    [
        112.97719976653,
        23.088973778888
    ],
    [
        112.97690328907,
        23.089403477171
    ],
    [
        112.97638798243,
        23.089890798489
    ],
    [
        112.97571697048,
        23.090641265751
    ],
    [
        112.97500479895,
        23.09142042873
    ],
    [
        112.97455596677,
        23.091823728285
    ],
    [
        112.97430728735,
        23.092096208944
    ],
    [
        112.97431299738,
        23.092094792291
    ],
    [
        112.97405995768,
        23.092365736684
    ],
    [
        112.97393670268,
        23.092492376045
    ],
    [
        112.97387738313,
        23.092558115614
    ],
    [
        112.97385424961,
        23.092589016407
    ],
    [
        112.97381479997,
        23.092624435927
    ],
    [
        112.97373793359,
        23.09287263426
    ],
    [
        112.96999931945,
        23.097431637025
    ],
    [
        112.96905195001,
        23.098187528408
    ],
    [
        112.96822591131,
        23.099403215099
    ],
    [
        112.9675894102,
        23.100628914357
    ],
    [
        112.96685068026,
        23.101980302538
    ],
    [
        112.96674155698,
        23.102797752551
    ],
    [
        112.964758248,
        23.106521559081
    ],
    [
        112.96420218892,
        23.107348781411
    ],
    [
        112.96398142765,
        23.107645285821
    ],
    [
        112.96306672835,
        23.108881898804
    ],
    [
        112.96222529745,
        23.110032645423
    ],
    [
        112.96131425176,
        23.111085244571
    ],
    [
        112.96131425202,
        23.111084973358
    ],
    [
        112.96128127549,
        23.111123778538
    ],
    [
        112.96037893187,
        23.112160966919
    ],
    [
        112.95906375467,
        23.113600142196
    ],
    [
        112.95855822758,
        23.114155503605
    ],
    [
        112.95816851076,
        23.114596841091
    ],
    [
        112.95722203159,
        23.115662588503
    ],
    [
        112.95676637201,
        23.116181336063
    ],
    [
        112.95598680057,
        23.117266686463
    ],
    [
        112.95528520173,
        23.118596106636
    ],
    [
        112.95454672255,
        23.119818484957
    ],
    [
        112.95428260643,
        23.120228331313
    ],
    [
        112.95414169993,
        23.12043774709
    ],
    [
        112.95399725147,
        23.120653732422
    ],
    [
        112.95260220052,
        23.121959040541
    ],
    [
        112.95249025085,
        23.122051567371
    ],
    [
        112.95103177585,
        23.123164187162
    ],
    [
        112.95004075698,
        23.123919698225
    ],
    [
        112.9494667169,
        23.124358315134
    ],
    [
        112.94887527272,
        23.124823418792
    ],
    [
        112.94828276706,
        23.125301978921
    ],
    [
        112.94827405094,
        23.125314595901
    ],
    [
        112.94805894743,
        23.125493535421
    ],
    [
        112.9479780809,
        23.12556046689
    ],
    [
        112.94774366497,
        23.12573345005
    ],
    [
        112.94751170395,
        23.125906914978
    ],
    [
        112.94742157283,
        23.126005709293
    ],
    [
        112.94720537603,
        23.126234229173
    ],
    [
        112.94703629874,
        23.126394729166
    ],
    [
        112.94687183634,
        23.12658552406
    ],
    [
        112.94667880343,
        23.126779460466
    ],
    [
        112.94659848095,
        23.126874817294
    ],
    [
        112.94629767057,
        23.127125980191
    ],
    [
        112.94619232417,
        23.127208412921
    ],
    [
        112.94607771212,
        23.127324072078
    ],
    [
        112.94600448942,
        23.127379969946
    ],
    [
        112.94595984187,
        23.127428382187
    ],
    [
        112.94584851525,
        23.127507633261
    ],
    [
        112.94576903023,
        23.127577179081
    ],
    [
        112.9455703242,
        23.127744791668
    ],
    [
        112.94550988873,
        23.127814314951
    ],
    [
        112.94541924833,
        23.127891607819
    ],
    [
        112.94524641835,
        23.128016220235
    ],
    [
        112.94516558118,
        23.128081693786
    ],
    [
        112.9451086877,
        23.128148169357
    ],
    [
        112.94507194229,
        23.12818234179
    ],
    [
        112.94493450053,
        23.128282267894
    ],
    [
        112.94483353186,
        23.128351275874
    ],
    [
        112.94472630893,
        23.128415215378
    ],
    [
        112.94464683784,
        23.12848064759
    ],
    [
        112.94453906736,
        23.128559502797
    ],
    [
        112.94436407129,
        23.128709021818
    ],
    [
        112.94432325109,
        23.128737541864
    ],
    [
        112.94393463179,
        23.129067986883
    ],
    [
        112.9438369316,
        23.129163476952
    ],
    [
        112.94362549499,
        23.129328623814
    ],
    [
        112.94350658348,
        23.129416794628
    ],
    [
        112.94342277713,
        23.129473553395
    ],
    [
        112.94329951167,
        23.129575874723
    ],
    [
        112.94318931223,
        23.129659293587
    ],
    [
        112.9430622412,
        23.129766532158
    ],
    [
        112.94293136739,
        23.129865132489
    ],
    [
        112.94282226039,
        23.129953666616
    ],
    [
        112.94259643144,
        23.130144376855
    ],
    [
        112.94249277629,
        23.130213829829
    ],
    [
        112.94241441979,
        23.130279146718
    ],
    [
        112.94224546679,
        23.13042050748
    ],
    [
        112.94212304308,
        23.130512695046
    ],
    [
        112.9420275541,
        23.130584996314
    ],
    [
        112.94194049575,
        23.130664778685
    ],
    [
        112.94182623694,
        23.130758194999
    ],
    [
        112.94172639976,
        23.130834602461
    ],
    [
        112.94165322568,
        23.130881642638
    ],
    [
        112.94151122238,
        23.13100793699
    ],
    [
        112.94138147097,
        23.131097175442
    ],
    [
        112.94122314866,
        23.131254027148
    ],
    [
        112.94109557473,
        23.131359489679
    ],
    [
        112.94082086165,
        23.131545664377
    ],
    [
        112.94055186996,
        23.131737145571
    ],
    [
        112.94037454117,
        23.131872163254
    ],
    [
        112.9401806265,
        23.132026069677
    ],
    [
        112.93998536115,
        23.132169386941
    ],
    [
        112.93972809818,
        23.13236437878
    ],
    [
        112.93961959636,
        23.132436675041
    ],
    [
        112.93940939686,
        23.132576013058
    ],
    [
        112.93928730355,
        23.132664981466
    ],
    [
        112.93926500717,
        23.132676077584
    ],
    [
        112.93909914409,
        23.132770393745
    ],
    [
        112.93901866122,
        23.132816839687
    ],
    [
        112.93883050864,
        23.132930352971
    ],
    [
        112.93872964041,
        23.132974287419
    ],
    [
        112.93866982616,
        23.133005845154
    ],
    [
        112.93861273366,
        23.133022452416
    ],
    [
        112.93854558226,
        23.133044316733
    ],
    [
        112.93837050424,
        23.133091713533
    ],
    [
        112.93823620894,
        23.13312564921
    ],
    [
        112.9380440151,
        23.133167211003
    ],
    [
        112.93789124246,
        23.133202383544
    ],
    [
        112.93756151851,
        23.133264773391
    ],
    [
        112.93735575432,
        23.133311791499
    ],
    [
        112.93719838069,
        23.133330108783
    ],
    [
        112.93709482214,
        23.133367162175
    ],
    [
        112.9369972439,
        23.133409034183
    ],
    [
        112.93691379829,
        23.133461347272
    ],
    [
        112.93689993722,
        23.133462831599
    ],
    [
        112.93690156774,
        23.13346390158
    ],
    [
        112.93689395729,
        23.133467769443
    ],
    [
        112.93688580266,
        23.133475711156
    ],
    [
        112.93680453528,
        23.133512535266
    ],
    [
        112.93669391595,
        23.133560471046
    ],
    [
        112.93664282042,
        23.133578293944
    ],
    [
        112.9366025954,
        23.133600357169
    ],
    [
        112.93657161117,
        23.133619352394
    ],
    [
        112.93649741485,
        23.13365066812
    ],
    [
        112.93632782611,
        23.133727306849
    ],
    [
        112.93628950678,
        23.133740934279
    ],
    [
        112.93622890311,
        23.133761536027
    ],
    [
        112.93616612607,
        23.133782153617
    ],
    [
        112.93597263582,
        23.133844844917
    ],
    [
        112.93585279607,
        23.133872982504
    ],
    [
        112.935566384,
        23.13395754456
    ],
    [
        112.93555361352,
        23.133954393563
    ],
    [
        112.93554220212,
        23.13394770499
    ],
    [
        112.93521697644,
        23.133838278073
    ],
    [
        112.93500095618,
        23.133980471579
    ],
    [
        112.93495720943,
        23.134012002173
    ],
    [
        112.93470914725,
        23.134106103875
    ],
    [
        112.93457438829,
        23.134159995671
    ],
    [
        112.93451488788,
        23.134192710595
    ],
    [
        112.93050847978,
        23.135833564291
    ],
    [
        112.93041020572,
        23.135842068298
    ],
    [
        112.93012082312,
        23.135881615008
    ],
    [
        112.92991180411,
        23.135912148672
    ],
    [
        112.92970496484,
        23.135941008309
    ],
    [
        112.92961946279,
        23.135952115396
    ],
    [
        112.92892436871,
        23.136040756936
    ],
    [
        112.92720209137,
        23.136406072948
    ],
    [
        112.92547252156,
        23.136885280207
    ],
    [
        112.92544404403,
        23.136899360913
    ],
    [
        112.9251166971,
        23.136979583207
    ],
    [
        112.92473567695,
        23.137065049328
    ],
    [
        112.92411417316,
        23.137222866589
    ],
    [
        112.92407512866,
        23.137240957716
    ],
    [
        112.92387909705,
        23.137325693727
    ],
    [
        112.92375139588,
        23.137380182817
    ],
    [
        112.92365894433,
        23.137437188884
    ],
    [
        112.92352501419,
        23.137510624459
    ],
    [
        112.92338051386,
        23.137576147108
    ],
    [
        112.92324252421,
        23.137641941022
    ],
    [
        112.92312785254,
        23.137703990846
    ],
    [
        112.92303324304,
        23.137746831292
    ],
    [
        112.92292318519,
        23.137814842074
    ],
    [
        112.92282424427,
        23.137883150034
    ],
    [
        112.9226919638,
        23.137961643297
    ],
    [
        112.92252444902,
        23.138051930652
    ],
    [
        112.92234094669,
        23.138134265636
    ],
    [
        112.92220054585,
        23.138194222764
    ],
    [
        112.92212926345,
        23.138231921629
    ],
    [
        112.92205852439,
        23.138271788263
    ],
    [
        112.92199076928,
        23.138326040021
    ],
    [
        112.92185959448,
        23.1383962998
    ],
    [
        112.92166039988,
        23.138504769395
    ],
    [
        112.92160809566,
        23.138533023049
    ],
    [
        112.92156609057,
        23.138559963863
    ],
    [
        112.92148994,
        23.138606009421
    ],
    [
        112.92140295167,
        23.138664478509
    ],
    [
        112.92128019036,
        23.138709208924
    ],
    [
        112.92117856996,
        23.138754298966
    ],
    [
        112.9210531082,
        23.138831273094
    ],
    [
        112.92090732721,
        23.138920066831
    ],
    [
        112.92075856681,
        23.138987938047
    ],
    [
        112.92057350236,
        23.139068345929
    ],
    [
        112.92048707042,
        23.139115896029
    ],
    [
        112.92039115686,
        23.139167185173
    ],
    [
        112.92016898475,
        23.139244608957
    ],
    [
        112.91997770925,
        23.139322985029
    ],
    [
        112.91985362862,
        23.139379488461
    ],
    [
        112.91975393099,
        23.139413882074
    ],
    [
        112.91951255346,
        23.139510864259
    ],
    [
        112.91928202333,
        23.139608951228
    ],
    [
        112.91910296739,
        23.139671526469
    ],
    [
        112.91897619695,
        23.139720592904
    ],
    [
        112.91888843516,
        23.139757976149
    ],
    [
        112.91879119674,
        23.139811021441
    ],
    [
        112.91867256329,
        23.139877744025
    ],
    [
        112.91850897044,
        23.139957697917
    ],
    [
        112.918380051,
        23.14002675884
    ],
    [
        112.91828525824,
        23.140072184164
    ],
    [
        112.91820374173,
        23.14013072167
    ],
    [
        112.91807103576,
        23.140189412229
    ],
    [
        112.9179732684,
        23.140230992294
    ],
    [
        112.91780292115,
        23.140287738401
    ],
    [
        112.91764422509,
        23.140346179719
    ],
    [
        112.91744952026,
        23.140432252687
    ],
    [
        112.91725157406,
        23.14052504957
    ],
    [
        112.91711943653,
        23.140601001272
    ],
    [
        112.9169835108,
        23.14067582159
    ],
    [
        112.9168692477,
        23.140732364542
    ],
    [
        112.91674875939,
        23.140791284706
    ],
    [
        112.91660905035,
        23.140859520137
    ],
    [
        112.91641574179,
        23.14097012668
    ],
    [
        112.91629309914,
        23.14103685037
    ],
    [
        112.91609356614,
        23.141115611011
    ],
    [
        112.91593844111,
        23.141186071468
    ],
    [
        112.91586128681,
        23.141223332941
    ],
    [
        112.9157589577,
        23.141273645675
    ],
    [
        112.91567450366,
        23.141340396674
    ],
    [
        112.91554673385,
        23.141409440497
    ],
    [
        112.91545686468,
        23.141462018529
    ],
    [
        112.91538080105,
        23.141503601877
    ],
    [
        112.9152903922,
        23.141552907612
    ],
    [
        112.9151420587,
        23.141629848189
    ],
    [
        112.91501105105,
        23.141694466161
    ],
    [
        112.91497857266,
        23.141718827627
    ],
    [
        112.91490629859,
        23.141737090722
    ],
    [
        112.91481914875,
        23.141797247729
    ],
    [
        112.91476123812,
        23.141864750687
    ],
    [
        112.91470440574,
        23.141914357475
    ],
    [
        112.91459046322,
        23.141983719695
    ],
    [
        112.91450142109,
        23.142035426373
    ],
    [
        112.91442104531,
        23.142096983887
    ],
    [
        112.91438694906,
        23.142130266224
    ],
    [
        112.91427382347,
        23.1421947267
    ],
    [
        112.91418938686,
        23.142243477026
    ],
    [
        112.9140751758,
        23.142287020297
    ],
    [
        112.91399831334,
        23.14231250928
    ],
    [
        112.913893309,
        23.142358035218
    ],
    [
        112.91380995766,
        23.142398363712
    ],
    [
        112.91369522076,
        23.142468183712
    ],
    [
        112.91353853919,
        23.142550279177
    ],
    [
        112.91342570259,
        23.142621725451
    ],
    [
        112.913305832,
        23.142694710928
    ],
    [
        112.91321708062,
        23.142748778099
    ],
    [
        112.91312535162,
        23.142797108668
    ],
    [
        112.9130360591,
        23.142843833463
    ],
    [
        112.91292512494,
        23.142911191779
    ],
    [
        112.91282582653,
        23.142969995506
    ],
    [
        112.91279984991,
        23.142978645832
    ],
    [
        112.91267241864,
        23.143063425854
    ],
    [
        112.91245515918,
        23.143179684461
    ],
    [
        112.91235451489,
        23.143237354356
    ],
    [
        112.91215512058,
        23.143339945647
    ],
    [
        112.91206800524,
        23.143383109732
    ],
    [
        112.91199333499,
        23.143417739334
    ],
    [
        112.91191650721,
        23.143469158523
    ],
    [
        112.91178178682,
        23.14354997324
    ],
    [
        112.91168547729,
        23.143594357744
    ],
    [
        112.91159214526,
        23.143638230605
    ],
    [
        112.91146744038,
        23.143713173578
    ],
    [
        112.91136681351,
        23.143775931076
    ],
    [
        112.91127971191,
        23.143827459341
    ],
    [
        112.91119018193,
        23.143892787428
    ],
    [
        112.91107198723,
        23.143990297955
    ],
    [
        112.91100193676,
        23.144047454654
    ],
    [
        112.9109002408,
        23.144124274963
    ],
    [
        112.91082369657,
        23.144175100109
    ],
    [
        112.91070685006,
        23.144244657778
    ],
    [
        112.9104934452,
        23.144364753254
    ],
    [
        112.91039770351,
        23.144428869158
    ],
    [
        112.91016646328,
        23.144571201933
    ],
    [
        112.91010506835,
        23.144602933814
    ],
    [
        112.91005070444,
        23.144627704471
    ],
    [
        112.90994333563,
        23.144689195524
    ],
    [
        112.90982325585,
        23.14475403363
    ],
    [
        112.90968802579,
        23.144810245946
    ],
    [
        112.90950466604,
        23.144905121732
    ],
    [
        112.90933970133,
        23.144992908302
    ],
    [
        112.90917825681,
        23.145080999501
    ],
    [
        112.9090276334,
        23.145165158508
    ],
    [
        112.90888377306,
        23.145245059577
    ],
    [
        112.90877128393,
        23.14531020262
    ],
    [
        112.90863121523,
        23.145390408398
    ],
    [
        112.90854008979,
        23.145440378378
    ],
    [
        112.90844058669,
        23.145502431367
    ],
    [
        112.90825266369,
        23.145606606184
    ],
    [
        112.90812828788,
        23.145680489755
    ],
    [
        112.9079841846,
        23.145782290805
    ],
    [
        112.90788712975,
        23.145858457242
    ],
    [
        112.90776575526,
        23.145973326303
    ],
    [
        112.90766085346,
        23.146035529562
    ],
    [
        112.90753838027,
        23.146109402804
    ],
    [
        112.90747702362,
        23.146174684951
    ],
    [
        112.90727373432,
        23.146327909868
    ],
    [
        112.90706505351,
        23.146503278877
    ],
    [
        112.90670037325,
        23.146728878611
    ],
    [
        112.90661495214,
        23.146785628009
    ],
    [
        112.90653656344,
        23.14684383852
    ],
    [
        112.90645493054,
        23.146901996181
    ],
    [
        112.90636493011,
        23.146986337181
    ],
    [
        112.90628762145,
        23.147037230343
    ],
    [
        112.90620517723,
        23.147090754023
    ],
    [
        112.90607165564,
        23.147194211678
    ],
    [
        112.90597787125,
        23.14727359461
    ],
    [
        112.90585436131,
        23.14738289298
    ],
    [
        112.90566167217,
        23.147560547195
    ],
    [
        112.90555951723,
        23.147651446862
    ],
    [
        112.9054651889,
        23.147715065133
    ],
    [
        112.90538222191,
        23.147785913866
    ],
    [
        112.90527304248,
        23.147880216515
    ],
    [
        112.90523683184,
        23.147914908121
    ],
    [
        112.90520629426,
        23.147941008196
    ],
    [
        112.90504740082,
        23.148090665619
    ],
    [
        112.90488823009,
        23.148223759268
    ],
    [
        112.90472583488,
        23.1483847346
    ],
    [
        112.90457234447,
        23.148512474355
    ],
    [
        112.90452504795,
        23.14854073618
    ],
    [
        112.90448181843,
        23.148587240274
    ],
    [
        112.90436968664,
        23.148697734078
    ],
    [
        112.90421512976,
        23.148839543425
    ],
    [
        112.9039852066,
        23.14907506184
    ],
    [
        112.90388387663,
        23.149156412982
    ],
    [
        112.90379309446,
        23.149242546684
    ],
    [
        112.90361611543,
        23.149394533978
    ],
    [
        112.90350886005,
        23.149503717935
    ],
    [
        112.90340323365,
        23.149621335528
    ],
    [
        112.90330220934,
        23.149746351354
    ],
    [
        112.90317765327,
        23.149851165862
    ],
    [
        112.90306606854,
        23.149946697067
    ],
    [
        112.90306877231,
        23.149947284937
    ],
    [
        112.90308554369,
        23.149962758585
    ],
    [
        112.90327377705,
        23.150076865788
    ],
    [
        112.90340252536,
        23.150172880621
    ],
    [
        112.90356317456,
        23.150266977329
    ],
    [
        112.90370029287,
        23.150342770418
    ],
    [
        112.90385444238,
        23.150415039473
    ],
    [
        112.90402263683,
        23.15046528392
    ],
    [
        112.90419326841,
        23.150517999751
    ],
    [
        112.90436093228,
        23.150576353873
    ],
    [
        112.9045467108,
        23.150631735705
    ],
    [
        112.90472845882,
        23.150718510397
    ],
    [
        112.90498161227,
        23.150838704417
    ],
    [
        112.90520827339,
        23.150957636111
    ],
    [
        112.9054303596,
        23.151099806227
    ],
    [
        112.90566190491,
        23.15122881078
    ],
    [
        112.9057998608,
        23.151305590305
    ],
    [
        112.90592971037,
        23.151387389464
    ],
    [
        112.90618075964,
        23.151547846576
    ],
    [
        112.90638990403,
        23.151710612968
    ],
    [
        112.90651842078,
        23.151807007474
    ],
    [
        112.90667211774,
        23.151942847862
    ],
    [
        112.9067963231,
        23.152053810149
    ],
    [
        112.90689132222,
        23.152161337019
    ],
    [
        112.90698714325,
        23.152281080838
    ],
    [
        112.90703344858,
        23.152362902676
    ],
    [
        112.90706757353,
        23.152429617577
    ],
    [
        112.90710521749,
        23.152500454661
    ],
    [
        112.90715590903,
        23.15265722087
    ],
    [
        112.90720140703,
        23.15274173998
    ],
    [
        112.90723713354,
        23.152779717656
    ],
    [
        112.90728014881,
        23.152800983011
    ],
    [
        112.9073358678,
        23.152813484601
    ],
    [
        112.90737399269,
        23.152805373428
    ],
    [
        112.90744887462,
        23.152768509072
    ],
    [
        112.90754889397,
        23.152713566888
    ],
    [
        112.90758403873,
        23.152697539394
    ],
    [
        112.90761541282,
        23.152701260783
    ],
    [
        112.90764867908,
        23.152703653165
    ],
    [
        112.90767897985,
        23.152717938615
    ],
    [
        112.90770496986,
        23.152753050536
    ],
    [
        112.90774346585,
        23.152871638365
    ],
    [
        112.90778981879,
        23.153007162485
    ],
    [
        112.90783266835,
        23.153157284683
    ],
    [
        112.90788281523,
        23.153300187985
    ],
    [
        112.90791070488,
        23.15334183657
    ],
    [
        112.90798432244,
        23.153410200514
    ],
    [
        112.90808253823,
        23.153461285567
    ],
    [
        112.9081604579,
        23.153496334391
    ],
    [
        112.90822321179,
        23.153505656843
    ],
    [
        112.90833247892,
        23.15350669688
    ],
    [
        112.9085004322,
        23.153499621019
    ],
    [
        112.90876439972,
        23.153483315955
    ],
    [
        112.90899998047,
        23.153474440137
    ],
    [
        112.90923285885,
        23.153460611318
    ],
    [
        112.90943788077,
        23.153444738183
    ],
    [
        112.90963777205,
        23.153433653532
    ],
    [
        112.909859026,
        23.153406827965
    ],
    [
        112.91019551556,
        23.153364425131
    ],
    [
        112.91048469052,
        23.153340049354
    ],
    [
        112.91079497346,
        23.153309112766
    ],
    [
        112.91109335908,
        23.153271179685
    ],
    [
        112.91128516579,
        23.153247306113
    ],
    [
        112.91141312462,
        23.153224776256
    ],
    [
        112.91148343865,
        23.15318252189
    ],
    [
        112.91152371824,
        23.153137989406
    ],
    [
        112.91154095415,
        23.153035921694
    ],
    [
        112.91154440288,
        23.152948603476
    ],
    [
        112.91154104325,
        23.15280449674
    ],
    [
        112.9115507258,
        23.152730008072
    ],
    [
        112.91157095025,
        23.152641814347
    ],
    [
        112.91161795975,
        23.152550969875
    ],
    [
        112.91167040979,
        23.1524970894
    ],
    [
        112.91174939099,
        23.152461441757
    ],
    [
        112.91184245578,
        23.152441970434
    ],
    [
        112.91196636996,
        23.152424227126
    ],
    [
        112.91211816649,
        23.152418477731
    ],
    [
        112.91221071671,
        23.152427464165
    ],
    [
        112.91228837733,
        23.152426227727
    ],
    [
        112.91246048673,
        23.152434251596
    ],
    [
        112.91261310902,
        23.152432801081
    ],
    [
        112.9126961777,
        23.152420211361
    ],
    [
        112.91283929411,
        23.152367348076
    ],
    [
        112.91292747061,
        23.152306511384
    ],
    [
        112.91300454184,
        23.152231433567
    ],
    [
        112.91304291215,
        23.15215373772
    ],
    [
        112.91305556998,
        23.152071948108
    ],
    [
        112.91306364057,
        23.152007740835
    ],
    [
        112.9130589906,
        23.151942031308
    ],
    [
        112.91304759526,
        23.151903375133
    ],
    [
        112.9129898859,
        23.151815351488
    ],
    [
        112.91292241546,
        23.151701167361
    ],
    [
        112.91285736123,
        23.151559063613
    ],
    [
        112.91278988326,
        23.151431307992
    ],
    [
        112.91275542819,
        23.151312345635
    ],
    [
        112.91272043317,
        23.151194190148
    ],
    [
        112.91266320773,
        23.15101907039
    ],
    [
        112.91260356568,
        23.150868337513
    ],
    [
        112.91255665731,
        23.150737015407
    ],
    [
        112.9125363007,
        23.150650228742
    ],
    [
        112.91253029382,
        23.150573649942
    ],
    [
        112.91252506497,
        23.150447974388
    ],
    [
        112.91252094401,
        23.150358395416
    ],
    [
        112.91252227728,
        23.150329653028
    ],
    [
        112.91250952395,
        23.150279039577
    ],
    [
        112.91246698205,
        23.150196330117
    ],
    [
        112.91242686914,
        23.150103338854
    ],
    [
        112.91231745942,
        23.149975876563
    ],
    [
        112.91222483643,
        23.149859460488
    ],
    [
        112.91209915959,
        23.149677796886
    ],
    [
        112.91205770467,
        23.149595360308
    ],
    [
        112.91205929117,
        23.149538948819
    ],
    [
        112.91208332787,
        23.149468702379
    ],
    [
        112.91214307626,
        23.149387764724
    ],
    [
        112.91225583883,
        23.149270023362
    ],
    [
        112.91237944257,
        23.149175192057
    ],
    [
        112.91255689757,
        23.14907637522
    ],
    [
        112.91271028068,
        23.148990277325
    ],
    [
        112.91286285614,
        23.148904967455
    ],
    [
        112.91304032791,
        23.148811245319
    ],
    [
        112.9132391752,
        23.148701736339
    ],
    [
        112.91353272088,
        23.14853601052
    ],
    [
        112.91376595406,
        23.148420567615
    ],
    [
        112.91396806743,
        23.148302036191
    ],
    [
        112.91416828774,
        23.148174772818
    ],
    [
        112.91441154521,
        23.148033009081
    ],
    [
        112.91456416345,
        23.1479477814
    ],
    [
        112.91469812685,
        23.147895714793
    ],
    [
        112.91477554299,
        23.147889180504
    ],
    [
        112.91485540973,
        23.147905455495
    ],
    [
        112.91491146814,
        23.147943732279
    ],
    [
        112.91498758559,
        23.148026158216
    ],
    [
        112.91504692898,
        23.148123605249
    ],
    [
        112.91508866948,
        23.148208666265
    ],
    [
        112.9151277003,
        23.148288544449
    ],
    [
        112.91519568831,
        23.148351615516
    ],
    [
        112.91523740021,
        23.148386481189
    ],
    [
        112.91526909055,
        23.148412837022
    ],
    [
        112.91530834262,
        23.148408337851
    ],
    [
        112.9153346022,
        23.148407237725
    ],
    [
        112.91545855967,
        23.148348212154
    ],
    [
        112.91556817626,
        23.148298261579
    ],
    [
        112.91571107458,
        23.14821253395
    ],
    [
        112.91589132248,
        23.148097567066
    ],
    [
        112.91605209109,
        23.147998402283
    ],
    [
        112.9161768659,
        23.147921408183
    ],
    [
        112.91622722269,
        23.147912640537
    ],
    [
        112.91627351871,
        23.147904376879
    ],
    [
        112.91628164475,
        23.147909604722
    ],
    [
        112.91631442393,
        23.147937571799
    ],
    [
        112.91635722997,
        23.147979463934
    ],
    [
        112.91641143046,
        23.148058081374
    ],
    [
        112.91647785491,
        23.148201102548
    ],
    [
        112.91651365666,
        23.148300171581
    ],
    [
        112.91660315435,
        23.148532375835
    ],
    [
        112.91667586122,
        23.148755204162
    ],
    [
        112.91673880356,
        23.148947558662
    ],
    [
        112.91678605607,
        23.14916147964
    ],
    [
        112.91684113321,
        23.149327988265
    ],
    [
        112.91686856253,
        23.149450579599
    ],
    [
        112.91691796335,
        23.149628702766
    ],
    [
        112.91697600086,
        23.149760775619
    ],
    [
        112.91704216424,
        23.149893727911
    ],
    [
        112.91712049398,
        23.149995035531
    ],
    [
        112.91722318468,
        23.150076733857
    ],
    [
        112.917329125,
        23.150155194357
    ],
    [
        112.9174428932,
        23.15019247048
    ],
    [
        112.91758456764,
        23.150242980166
    ],
    [
        112.91774709502,
        23.150286582009
    ],
    [
        112.91796814445,
        23.150352855588
    ],
    [
        112.91815697247,
        23.150421290073
    ],
    [
        112.91833035008,
        23.150464079021
    ],
    [
        112.91848991038,
        23.150494806049
    ],
    [
        112.91865272606,
        23.150526076864
    ],
    [
        112.91881040752,
        23.150568684398
    ],
    [
        112.91898162653,
        23.150594812417
    ],
    [
        112.9191742616,
        23.150634892856
    ],
    [
        112.9193726004,
        23.150686372566
    ],
    [
        112.91952651218,
        23.150732927985
    ],
    [
        112.9197229614,
        23.150776196228
    ],
    [
        112.91986008,
        23.150815550283
    ],
    [
        112.92004840608,
        23.150849218213
    ],
    [
        112.92021395654,
        23.15085152583
    ],
    [
        112.9203567471,
        23.150847714532
    ],
    [
        112.92044994784,
        23.150833848356
    ],
    [
        112.92061738044,
        23.150798124378
    ],
    [
        112.92083657213,
        23.150757486843
    ],
    [
        112.92104599812,
        23.150689899096
    ],
    [
        112.92116248463,
        23.150630237768
    ],
    [
        112.92126705746,
        23.150581902779
    ],
    [
        112.92132558272,
        23.150564814767
    ],
    [
        112.92135267225,
        23.150548662946
    ],
    [
        112.92137327028,
        23.150550657817
    ],
    [
        112.92138682323,
        23.150554247567
    ],
    [
        112.92143291365,
        23.150581047748
    ],
    [
        112.92147359134,
        23.150618131021
    ],
    [
        112.92149638912,
        23.150664898997
    ],
    [
        112.9214964323,
        23.150726756836
    ],
    [
        112.92150025578,
        23.150768555199
    ],
    [
        112.92147266786,
        23.150847651299
    ],
    [
        112.92141717522,
        23.150939641454
    ],
    [
        112.92137059808,
        23.150991245703
    ],
    [
        112.92131129202,
        23.15105391189
    ],
    [
        112.92130235828,
        23.151067163918
    ],
    [
        112.92129912168,
        23.151088853192
    ],
    [
        112.92129218144,
        23.151236682505
    ],
    [
        112.92128312876,
        23.151459925301
    ],
    [
        112.92126726856,
        23.151636471312
    ],
    [
        112.92126273077,
        23.151730593512
    ],
    [
        112.92125275435,
        23.151799187025
    ],
    [
        112.92125666231,
        23.151952494512
    ],
    [
        112.92126703919,
        23.152057811244
    ],
    [
        112.92126083949,
        23.152102276427
    ],
    [
        112.92124785436,
        23.152132872637
    ],
    [
        112.92118774713,
        23.152205838652
    ],
    [
        112.92106972343,
        23.152378360088
    ],
    [
        112.92098688876,
        23.152494612969
    ],
    [
        112.92090328051,
        23.152659691555
    ],
    [
        112.92086270822,
        23.152757156875
    ],
    [
        112.92083433226,
        23.152856582499
    ],
    [
        112.92081352054,
        23.152925659683
    ],
    [
        112.92080817562,
        23.153021133279
    ],
    [
        112.9208039,
        23.153097620708
    ],
    [
        112.92080915139,
        23.153227876668
    ],
    [
        112.92080950583,
        23.153333146959
    ],
    [
        112.92082910581,
        23.153445298945
    ],
    [
        112.9208446598,
        23.153580220118
    ],
    [
        112.92086644797,
        23.153716258223
    ],
    [
        112.92088633177,
        23.153842247837
    ],
    [
        112.92088539101,
        23.154018053021
    ],
    [
        112.92088598916,
        23.154086697964
    ],
    [
        112.92091132401,
        23.154248799631
    ],
    [
        112.92092803575,
        23.154468104418
    ],
    [
        112.92092361974,
        23.154696527529
    ],
    [
        112.9209379014,
        23.154922603359
    ],
    [
        112.92093073729,
        23.155102448147
    ],
    [
        112.92093649716,
        23.155183599956
    ],
    [
        112.92094900757,
        23.155236297737
    ],
    [
        112.9209572889,
        23.155413236038
    ],
    [
        112.9209835543,
        23.155703131217
    ],
    [
        112.92096339999,
        23.155898105751
    ],
    [
        112.92093944679,
        23.156086006826
    ],
    [
        112.92091381673,
        23.156215023656
    ],
    [
        112.9209022838,
        23.156350080413
    ],
    [
        112.92087532383,
        23.156505950062
    ],
    [
        112.92085993066,
        23.156565289791
    ],
    [
        112.92085103542,
        23.156618150969
    ],
    [
        112.92082562925,
        23.156692090107
    ],
    [
        112.92081220402,
        23.156830121027
    ],
    [
        112.92081337634,
        23.156928343562
    ],
    [
        112.92082398892,
        23.156977506377
    ],
    [
        112.92082835673,
        23.157013071255
    ],
    [
        112.92085277218,
        23.157043041085
    ],
    [
        112.92089506689,
        23.157066589611
    ],
    [
        112.92093192378,
        23.157069760412
    ],
    [
        112.92097420291,
        23.157075398979
    ],
    [
        112.92102756605,
        23.157051246079
    ],
    [
        112.92106656627,
        23.157026206133
    ],
    [
        112.92109900487,
        23.156936830758
    ],
    [
        112.92112133146,
        23.156752173278
    ],
    [
        112.92113885665,
        23.156652142821
    ],
    [
        112.92119781781,
        23.156521653118
    ],
    [
        112.92123381974,
        23.156475430346
    ],
    [
        112.92128313544,
        23.156467796233
    ],
    [
        112.92141917179,
        23.156457306571
    ],
    [
        112.92155359678,
        23.156459544888
    ],
    [
        112.9217633972,
        23.156491937691
    ],
    [
        112.92204288615,
        23.156550078076
    ],
    [
        112.9223061086,
        23.156588279924
    ],
    [
        112.92257069085,
        23.156616927565
    ],
    [
        112.92283773856,
        23.156659628022
    ],
    [
        112.92309314034,
        23.156699785646
    ],
    [
        112.92339408807,
        23.156725632443
    ],
    [
        112.92365600586,
        23.156745870355
    ],
    [
        112.92386643514,
        23.15678220333
    ],
    [
        112.92404461891,
        23.156832262023
    ],
    [
        112.92415230356,
        23.156875904938
    ],
    [
        112.92422746747,
        23.156936835696
    ],
    [
        112.92428990968,
        23.15702161207
    ],
    [
        112.924359963,
        23.157125934342
    ],
    [
        112.92440426089,
        23.157234545264
    ],
    [
        112.92445340385,
        23.15730300829
    ],
    [
        112.92447945609,
        23.15732530367
    ],
    [
        112.92451687236,
        23.157319944191
    ],
    [
        112.92461067943,
        23.157300028648
    ],
    [
        112.9247435393,
        23.157281523185
    ],
    [
        112.92501227275,
        23.157266986535
    ],
    [
        112.92526663011,
        23.15723500324
    ],
    [
        112.92540901265,
        23.157231348493
    ],
    [
        112.92565118152,
        23.157196549696
    ],
    [
        112.92591181283,
        23.1571693023
    ],
    [
        112.92616352537,
        23.157163695117
    ],
    [
        112.92636562041,
        23.157171322083
    ],
    [
        112.92644974137,
        23.157202524984
    ],
    [
        112.9265118788,
        23.157220700058
    ],
    [
        112.92660741007,
        23.157267626124
    ],
    [
        112.92664135559,
        23.157306960967
    ],
    [
        112.92665905028,
        23.157374515505
    ],
    [
        112.92664254953,
        23.157426340764
    ],
    [
        112.92662930076,
        23.157474366712
    ],
    [
        112.92663911394,
        23.15752591531
    ],
    [
        112.92667172291,
        23.157586412367
    ],
    [
        112.92671082325,
        23.157625472582
    ],
    [
        112.92681531332,
        23.157674819797
    ],
    [
        112.92703405936,
        23.157765610159
    ],
    [
        112.92724441285,
        23.157865858774
    ],
    [
        112.927395336,
        23.157944416029
    ],
    [
        112.92747460077,
        23.157986938891
    ],
    [
        112.92750365666,
        23.158013228184
    ],
    [
        112.92752159647,
        23.158048210282
    ],
    [
        112.92754605926,
        23.158095123381
    ],
    [
        112.92758030815,
        23.158161560502
    ],
    [
        112.92760640258,
        23.158211997668
    ],
    [
        112.92764442258,
        23.158248312177
    ],
    [
        112.92768514988,
        23.158277839204
    ],
    [
        112.927719083,
        23.158295434806
    ],
    [
        112.92787865783,
        23.158325076741
    ],
    [
        112.92801952322,
        23.158364219131
    ],
    [
        112.92825375907,
        23.158423538031
    ],
    [
        112.92846766638,
        23.15849776755
    ],
    [
        112.92866474879,
        23.158563578998
    ],
    [
        112.92882192132,
        23.158605296438
    ],
    [
        112.9288564067,
        23.158625025797
    ],
    [
        112.9289443938,
        23.158683429525
    ],
    [
        112.92903295313,
        23.158771398723
    ],
    [
        112.92907669534,
        23.158820401388
    ],
    [
        112.92910084983,
        23.158819799256
    ],
    [
        112.92912201717,
        23.158817304795
    ],
    [
        112.92922674338,
        23.158777154492
    ],
    [
        112.92936429152,
        23.158713843232
    ],
    [
        112.92950183308,
        23.158639661835
    ],
    [
        112.92960600596,
        23.158580212955
    ],
    [
        112.92970824502,
        23.158482503839
    ],
    [
        112.92984547922,
        23.158359985167
    ],
    [
        112.92996807264,
        23.158252148586
    ],
    [
        112.93011918391,
        23.158156953642
    ],
    [
        112.93026649536,
        23.158057681601
    ],
    [
        112.93033624004,
        23.158033556373
    ],
    [
        112.930385103,
        23.158031751327
    ],
    [
        112.93045976546,
        23.158039616099
    ],
    [
        112.93055047767,
        23.158081330009
    ],
    [
        112.93066645636,
        23.158141116645
    ],
    [
        112.93072349899,
        23.158173722359
    ],
    [
        112.93076373767,
        23.158236237549
    ],
    [
        112.93079934923,
        23.158285746536
    ],
    [
        112.93085559105,
        23.158331372084
    ],
    [
        112.93090880595,
        23.158333053342
    ],
    [
        112.93101739793,
        23.158324189664
    ],
    [
        112.9311186662,
        23.158320502047
    ],
    [
        112.9311895377,
        23.158328334013
    ],
    [
        112.93125256816,
        23.158370382627
    ],
    [
        112.9312729777,
        23.158419401083
    ],
    [
        112.93130704617,
        23.158556808686
    ],
    [
        112.93133490894,
        23.158735212785
    ],
    [
        112.93134558445,
        23.158826599895
    ],
    [
        112.9313741689,
        23.158905696357
    ],
    [
        112.93139210749,
        23.158924878625
    ],
    [
        112.93142852561,
        23.15896079793
    ],
    [
        112.93147282439,
        23.159003191343
    ],
    [
        112.93150057511,
        23.159061125422
    ],
    [
        112.93153052665,
        23.159148893915
    ],
    [
        112.93154671902,
        23.159329518332
    ],
    [
        112.93156018898,
        23.1595020158
    ],
    [
        112.93158505337,
        23.159663606551
    ],
    [
        112.93162352793,
        23.159859318779
    ],
    [
        112.93167913377,
        23.160079366622
    ],
    [
        112.93177637704,
        23.160392272599
    ],
    [
        112.931855969,
        23.160700917176
    ],
    [
        112.93192928359,
        23.160974587342
    ],
    [
        112.93199773592,
        23.161272154265
    ],
    [
        112.9320554984,
        23.161467483207
    ],
    [
        112.93211238624,
        23.161601223293
    ],
    [
        112.93220758837,
        23.161758364253
    ],
    [
        112.9322535612,
        23.161837347409
    ],
    [
        112.93228726002,
        23.161862129553
    ],
    [
        112.93254782883,
        23.161992841327
    ],
    [
        112.93258585665,
        23.161999411742
    ],
    [
        112.93260894559,
        23.162003894498
    ],
    [
        112.93264558455,
        23.161978997099
    ],
    [
        112.93274078884,
        23.161855815396
    ],
    [
        112.93280154221,
        23.161772439435
    ],
    [
        112.93288786525,
        23.161728252361
    ],
    [
        112.93296581238,
        23.161726706508
    ],
    [
        112.93304240826,
        23.161730861291
    ],
    [
        112.93308725245,
        23.16176043662
    ],
    [
        112.93312042712,
        23.161799306212
    ],
    [
        112.93315498083,
        23.16185905842
    ],
    [
        112.93318305211,
        23.161954935537
    ],
    [
        112.93323183727,
        23.162122042699
    ],
    [
        112.93328875071,
        23.162268205317
    ],
    [
        112.93339352409,
        23.162468329022
    ],
    [
        112.93348608604,
        23.162677746554
    ],
    [
        112.9336183329,
        23.162911861204
    ],
    [
        112.9337410337,
        23.163103968686
    ],
    [
        112.93392409405,
        23.163346936898
    ],
    [
        112.93410710722,
        23.163536968456
    ],
    [
        112.93427134778,
        23.163693459977
    ],
    [
        112.93447798718,
        23.163862917522
    ],
    [
        112.9346835662,
        23.164050797165
    ],
    [
        112.93487205532,
        23.16425749242
    ],
    [
        112.93499551947,
        23.16437050853
    ],
    [
        112.93506458619,
        23.164424784551
    ],
    [
        112.9350847046,
        23.164437109882
    ],
    [
        112.93513117334,
        23.16444461748
    ],
    [
        112.93519746634,
        23.164441657624
    ],
    [
        112.93530856105,
        23.164407951038
    ],
    [
        112.93548485978,
        23.164363941567
    ],
    [
        112.93565193174,
        23.164326494182
    ],
    [
        112.93580244568,
        23.164301914442
    ],
    [
        112.93600352392,
        23.164293438327
    ],
    [
        112.93616058495,
        23.164284767348
    ],
    [
        112.93630976227,
        23.164269362292
    ],
    [
        112.93645105307,
        23.164245055493
    ],
    [
        112.93657142467,
        23.164224447527
    ],
    [
        112.93675644734,
        23.164170410529
    ],
    [
        112.93690698132,
        23.164138371107
    ],
    [
        112.93698388688,
        23.164128705652
    ],
    [
        112.936986613,
        23.164136820137
    ],
    [
        112.93697798817,
        23.164207987779
    ],
    [
        112.93698564313,
        23.164519128443
    ],
    [
        112.93698257251,
        23.164706372423
    ],
    [
        112.9369790418,
        23.164708847134
    ],
    [
        112.93700378034,
        23.164714586511
    ],
    [
        112.93738596221,
        23.16474950373
    ],
    [
        112.93778419861,
        23.164778179526
    ],
    [
        112.93820557772,
        23.164817893297
    ],
    [
        112.93859353987,
        23.164851584566
    ],
    [
        112.93889044069,
        23.164877733452
    ],
    [
        112.93926675307,
        23.164912170921
    ],
    [
        112.93955850842,
        23.164929006896
    ],
    [
        112.93956776082,
        23.164936771572
    ],
    [
        112.93957650324,
        23.164977643857
    ],
    [
        112.93955326479,
        23.165119266222
    ],
    [
        112.93950130945,
        23.165362414595
    ],
    [
        112.93942003653,
        23.165650656342
    ],
    [
        112.93939661774,
        23.165881002222
    ],
    [
        112.93936173242,
        23.166065077755
    ],
    [
        112.93934818621,
        23.166112167379
    ],
    [
        112.9392542878,
        23.166282240283
    ],
    [
        112.93913270956,
        23.166501719316
    ],
    [
        112.93904644849,
        23.166693129546
    ],
    [
        112.93900716257,
        23.166825962886
    ],
    [
        112.93897383439,
        23.166935667964
    ],
    [
        112.93895930133,
        23.167080442245
    ],
    [
        112.93896267969,
        23.167193820652
    ],
    [
        112.93895108167,
        23.167284297696
    ],
    [
        112.93890822085,
        23.167377010208
    ],
    [
        112.93883901134,
        23.167491438251
    ],
    [
        112.93879965991,
        23.167559147677
    ],
    [
        112.93868856201,
        23.167651222628
    ],
    [
        112.93855275616,
        23.167771765675
    ],
    [
        112.93842781974,
        23.167885127585
    ],
    [
        112.93831597277,
        23.168036328757
    ],
    [
        112.93825408152,
        23.168123789767
    ],
    [
        112.93821204074,
        23.168216742884
    ],
    [
        112.93819203218,
        23.168322493542
    ],
    [
        112.93816718133,
        23.168478217393
    ],
    [
        112.93815072672,
        23.168603738014
    ],
    [
        112.93811307671,
        23.168737070897
    ],
    [
        112.93809744495,
        23.168869908268
    ],
    [
        112.93806932559,
        23.169019422764
    ],
    [
        112.93806096172,
        23.169081641164
    ],
    [
        112.93805782848,
        23.169208925008
    ],
    [
        112.93803192764,
        23.16940209974
    ],
    [
        112.93799977615,
        23.169596964773
    ],
    [
        112.9379689697,
        23.169777977793
    ],
    [
        112.93793899218,
        23.169972548016
    ],
    [
        112.93788014583,
        23.170112326535
    ],
    [
        112.93784185934,
        23.170153135412
    ],
    [
        112.93779628337,
        23.17024339674
    ],
    [
        112.93777593303,
        23.170279684592
    ],
    [
        112.93768629577,
        23.170342973335
    ],
    [
        112.93741309231,
        23.170582767535
    ],
    [
        112.9369742552,
        23.170970837009
    ],
    [
        112.93661530362,
        23.171314355607
    ],
    [
        112.93627597397,
        23.171694500402
    ],
    [
        112.93604363099,
        23.171975424932
    ],
    [
        112.93599589591,
        23.172069437895
    ],
    [
        112.93597721204,
        23.172137427373
    ],
    [
        112.93598110287,
        23.172226117351
    ],
    [
        112.93598041251,
        23.172354459413
    ],
    [
        112.93600341747,
        23.172538493051
    ],
    [
        112.93606559953,
        23.172770487597
    ],
    [
        112.93611644706,
        23.173085058438
    ],
    [
        112.93619086677,
        23.173327522707
    ],
    [
        112.93627698038,
        23.173579105414
    ],
    [
        112.93636059943,
        23.173779152579
    ],
    [
        112.93639656754,
        23.173880582089
    ],
    [
        112.93641212557,
        23.173952345317
    ],
    [
        112.93640479369,
        23.173958379069
    ],
    [
        112.93639067348,
        23.173970441658
    ],
    [
        112.93636676925,
        23.173981776122
    ],
    [
        112.93624124188,
        23.174007563007
    ],
    [
        112.93610622743,
        23.174056209649
    ],
    [
        112.93600980207,
        23.174103428913
    ],
    [
        112.93596336453,
        23.174135838658
    ],
    [
        112.93595849357,
        23.174157585609
    ],
    [
        112.93595552809,
        23.174182843614
    ],
    [
        112.93596645227,
        23.174241085396
    ],
    [
        112.93599564074,
        23.174361033536
    ],
    [
        112.93605290701,
        23.174575975472
    ],
    [
        112.93608456856,
        23.174726016878
    ],
    [
        112.93615521285,
        23.175009754649
    ],
    [
        112.93620817074,
        23.175270036386
    ],
    [
        112.93626417832,
        23.175598390319
    ],
    [
        112.93632526215,
        23.175832006232
    ],
    [
        112.93638799098,
        23.176082697506
    ],
    [
        112.93646650182,
        23.176356850239
    ],
    [
        112.93654446526,
        23.176627746703
    ],
    [
        112.93662352532,
        23.176910837364
    ],
    [
        112.93666614994,
        23.17717471701
    ],
    [
        112.93670712737,
        23.177421245415
    ],
    [
        112.9367352906,
        23.177621493332
    ],
    [
        112.93673406432,
        23.177778325505
    ],
    [
        112.93670100253,
        23.177890950159
    ],
    [
        112.9366890819,
        23.177935553858
    ],
    [
        112.93666789989,
        23.177955008631
    ],
    [
        112.93664317244,
        23.177959572581
    ],
    [
        112.93654699515,
        23.177994349408
    ],
    [
        112.93640760019,
        23.17801837664
    ],
    [
        112.93624321513,
        23.178052101618
    ],
    [
        112.93603184621,
        23.178114151233
    ],
    [
        112.93591966086,
        23.178166922492
    ],
    [
        112.93584849681,
        23.178204418713
    ],
    [
        112.93577110647,
        23.178269365364
    ],
    [
        112.93570648774,
        23.178333659186
    ],
    [
        112.93568643434,
        23.178399754046
    ],
    [
        112.93567887491,
        23.178459234278
    ],
    [
        112.93567591423,
        23.178493715646
    ],
    [
        112.93570611483,
        23.178540947063
    ],
    [
        112.93573744057,
        23.178634834571
    ],
    [
        112.93584084872,
        23.178818739974
    ],
    [
        112.93596162587,
        23.178974001718
    ],
    [
        112.93604405969,
        23.179093222771
    ],
    [
        112.93614768804,
        23.179209271558
    ],
    [
        112.93631899727,
        23.179341000441
    ],
    [
        112.9364168879,
        23.179413395283
    ],
    [
        112.93654688744,
        23.179535417855
    ],
    [
        112.93666574789,
        23.179659155264
    ],
    [
        112.93672967848,
        23.179740784739
    ],
    [
        112.93678438764,
        23.179846370528
    ],
    [
        112.9368293359,
        23.179981887587
    ],
    [
        112.93686832006,
        23.18013753478
    ],
    [
        112.93688444533,
        23.180255678626
    ],
    [
        112.93690085671,
        23.180393353959
    ],
    [
        112.93689195732,
        23.180485410431
    ],
    [
        112.93686592534,
        23.180564058593
    ],
    [
        112.93684204882,
        23.180617725815
    ],
    [
        112.9368184473,
        23.180675731024
    ],
    [
        112.93680950069,
        23.180705385662
    ],
    [
        112.93682068511,
        23.180761173471
    ],
    [
        112.93685989595,
        23.180861741904
    ],
    [
        112.93690969195,
        23.180942948532
    ],
    [
        112.93699186557,
        23.18107187506
    ],
    [
        112.93710122272,
        23.181206239409
    ],
    [
        112.93717276652,
        23.181292115281
    ],
    [
        112.93726334285,
        23.181386488513
    ],
    [
        112.93739143344,
        23.18148700749
    ],
    [
        112.93750267706,
        23.181591746418
    ],
    [
        112.93762614783,
        23.181687945707
    ],
    [
        112.93771510616,
        23.181793426424
    ],
    [
        112.93779019547,
        23.181888999911
    ],
    [
        112.93784625415,
        23.18197960346
    ],
    [
        112.93793060174,
        23.182097323937
    ],
    [
        112.93801955217,
        23.182187590462
    ],
    [
        112.93810114897,
        23.182255949548
    ],
    [
        112.93818412263,
        23.182348978491
    ],
    [
        112.9382845124,
        23.18246786887
    ],
    [
        112.93841100139,
        23.182588109092
    ],
    [
        112.9385195184,
        23.182661046464
    ],
    [
        112.93858152902,
        23.1827029923
    ],
    [
        112.93860790116,
        23.182706242282
    ],
    [
        112.93863209676,
        23.182706801606
    ],
    [
        112.93867368655,
        23.182700122916
    ],
    [
        112.93878239502,
        23.182646336856
    ],
    [
        112.93892779712,
        23.182577226229
    ],
    [
        112.93899602339,
        23.182557499641
    ],
    [
        112.93903653361,
        23.182559232008
    ],
    [
        112.93910342295,
        23.182571257452
    ],
    [
        112.93915618847,
        23.182602967985
    ],
    [
        112.93925955245,
        23.182676716441
    ],
    [
        112.9393689288,
        23.182794884844
    ],
    [
        112.939492167,
        23.182904208118
    ],
    [
        112.93961868952,
        23.183043869737
    ],
    [
        112.93972208435,
        23.183156379977
    ],
    [
        112.93977653533,
        23.183265641134
    ],
    [
        112.93982091472,
        23.183357651337
    ],
    [
        112.93986531504,
        23.183482759024
    ],
    [
        112.93988469944,
        23.183607880201
    ],
    [
        112.93988939167,
        23.183719332613
    ],
    [
        112.93988677879,
        23.183890555317
    ],
    [
        112.9398843958,
        23.183995034473
    ],
    [
        112.93987520036,
        23.18407598802
    ],
    [
        112.93985919931,
        23.184144267926
    ],
    [
        112.93983640213,
        23.184215338146
    ],
    [
        112.9397924013,
        23.184294788307
    ],
    [
        112.9397443142,
        23.184361260848
    ],
    [
        112.93970300635,
        23.184396726587
    ],
    [
        112.93955514405,
        23.184480866753
    ],
    [
        112.93937168798,
        23.184600112398
    ],
    [
        112.93918821909,
        23.184689761928
    ],
    [
        112.93896778908,
        23.18479443609
    ],
    [
        112.93879166054,
        23.184866047414
    ],
    [
        112.93862342817,
        23.184951389086
    ],
    [
        112.93845576378,
        23.185072515456
    ],
    [
        112.93827914872,
        23.185223013024
    ],
    [
        112.93800253976,
        23.185439879605
    ],
    [
        112.93787187574,
        23.185595556607
    ],
    [
        112.93779800015,
        23.185707251468
    ],
    [
        112.93779365598,
        23.185716518636
    ],
    [
        112.93777437411,
        23.185748993904
    ],
    [
        112.9377760101,
        23.185758473191
    ],
    [
        112.93776407497,
        23.185805254482
    ],
    [
        112.93775975599,
        23.185861998521
    ],
    [
        112.93777337975,
        23.185923991286
    ],
    [
        112.93778863528,
        23.185987866814
    ],
    [
        112.93783815913,
        23.186088027441
    ],
    [
        112.93793527427,
        23.186230575775
    ],
    [
        112.93804625161,
        23.186369721365
    ],
    [
        112.93819747916,
        23.186543444578
    ],
    [
        112.93834518958,
        23.186747300408
    ],
    [
        112.9384724851,
        23.186893837483
    ],
    [
        112.93862725953,
        23.187082666646
    ],
    [
        112.93880080376,
        23.187291624933
    ],
    [
        112.93892375118,
        23.187431111279
    ],
    [
        112.93906874141,
        23.187614568235
    ],
    [
        112.93919686525,
        23.187772150055
    ],
    [
        112.9392882702,
        23.187893228636
    ],
    [
        112.93939164189,
        23.188021764634
    ],
    [
        112.93955131112,
        23.188186016607
    ],
    [
        112.93968814973,
        23.188366243086
    ],
    [
        112.93982687424,
        23.188500314944
    ],
    [
        112.93997812295,
        23.18867085331
    ],
    [
        112.9400893825,
        23.188791378898
    ],
    [
        112.94027871253,
        23.188985859644
    ],
    [
        112.94039922414,
        23.189116290237
    ],
    [
        112.94057278127,
        23.189294640494
    ],
    [
        112.94066854446,
        23.189410964709
    ],
    [
        112.94070880658,
        23.189453888114
    ],
    [
        112.94086142621,
        23.189625943932
    ],
    [
        112.94101186579,
        23.189779834121
    ],
    [
        112.9411408129,
        23.189903860452
    ],
    [
        112.9413214577,
        23.190101024728
    ],
    [
        112.94146510394,
        23.190255495839
    ],
    [
        112.9415878029,
        23.190387157746
    ],
    [
        112.94159188421,
        23.190392803371
    ],
    [
        112.94170751841,
        23.190542720595
    ],
    [
        112.94179077582,
        23.190652077032
    ],
    [
        112.94188980903,
        23.190763397626
    ],
    [
        112.94197605999,
        23.190876232368
    ],
    [
        112.94209659618,
        23.191041248999
    ],
    [
        112.94221223653,
        23.191204692045
    ],
    [
        112.94228733864,
        23.191325249941
    ],
    [
        112.94237794753,
        23.191457266433
    ],
    [
        112.94246338213,
        23.191563302558
    ],
    [
        112.94256923347,
        23.191736342425
    ],
    [
        112.94264705686,
        23.191862001294
    ],
    [
        112.94278446474,
        23.192050342403
    ],
    [
        112.94286609326,
        23.192161561855
    ],
    [
        112.94296623048,
        23.192327055633
    ],
    [
        112.94307588776,
        23.192489972976
    ],
    [
        112.943159157,
        23.192644559985
    ],
    [
        112.94324786291,
        23.192780079135
    ],
    [
        112.9433131704,
        23.192894210785
    ],
    [
        112.94337575358,
        23.192986132311
    ],
    [
        112.94341031213,
        23.193047238939
    ],
    [
        112.94343834443,
        23.193124439766
    ],
    [
        112.94346583325,
        23.193206801797
    ],
    [
        112.94349876641,
        23.193314317139
    ],
    [
        112.94351266314,
        23.193467397032
    ],
    [
        112.9435344597,
        23.193709346069
    ],
    [
        112.94353745788,
        23.193753251352
    ],
    [
        112.94354562145,
        23.19377212809
    ],
    [
        112.9435687505,
        23.193817383289
    ],
    [
        112.94364357496,
        23.193926486717
    ],
    [
        112.9437807069,
        23.194118001699
    ],
    [
        112.9438672331,
        23.194261655281
    ],
    [
        112.94396409968,
        23.194433914349
    ],
    [
        112.94402504934,
        23.194544280401
    ],
    [
        112.944106134,
        23.194693694847
    ],
    [
        112.94415946499,
        23.194797110358
    ],
    [
        112.9442372844,
        23.194950633672
    ],
    [
        112.94429116154,
        23.195099610775
    ],
    [
        112.94434476447,
        23.195223090499
    ],
    [
        112.94439564632,
        23.195348234905
    ],
    [
        112.94444843201,
        23.195471722887
    ],
    [
        112.94449169456,
        23.195586664908
    ],
    [
        112.94452760997,
        23.195671600228
    ],
    [
        112.94456134876,
        23.195764704073
    ],
    [
        112.94462637606,
        23.195903201655
    ],
    [
        112.94471534524,
        23.19603972368
    ],
    [
        112.94483995629,
        23.196220755138
    ],
    [
        112.94499531188,
        23.196443647522
    ],
    [
        112.94511883397,
        23.196639866659
    ],
    [
        112.94518930089,
        23.19676171666
    ],
    [
        112.94528670319,
        23.196914905303
    ],
    [
        112.94533893912,
        23.197041900779
    ],
    [
        112.94539634292,
        23.197192689511
    ],
    [
        112.94545946166,
        23.197314366397
    ],
    [
        112.94553400923,
        23.197419324262
    ],
    [
        112.94560066727,
        23.197505408296
    ],
    [
        112.94567739298,
        23.197592967336
    ],
    [
        112.94579955829,
        23.197704256425
    ],
    [
        112.94593913982,
        23.197810121931
    ],
    [
        112.94608362166,
        23.197905595823
    ],
    [
        112.9462515081,
        23.197990667217
    ],
    [
        112.94640470372,
        23.198062115425
    ],
    [
        112.94659708608,
        23.198145157662
    ],
    [
        112.94677505041,
        23.198212130043
    ],
    [
        112.94703465548,
        23.198301418904
    ],
    [
        112.94725453285,
        23.198395098149
    ],
    [
        112.94747659072,
        23.198492248631
    ],
    [
        112.94776886099,
        23.198640346888
    ],
    [
        112.94799065512,
        23.198736911688
    ],
    [
        112.948192315,
        23.198817233091
    ],
    [
        112.94832049857,
        23.198858032951
    ],
    [
        112.94839234772,
        23.19887749174
    ],
    [
        112.94845303958,
        23.198888448374
    ],
    [
        112.94853713806,
        23.19890146658
    ],
    [
        112.94863566248,
        23.198912620853
    ],
    [
        112.94872220849,
        23.198946751783
    ],
    [
        112.94882943873,
        23.198991664972
    ],
    [
        112.94891053937,
        23.199044324142
    ],
    [
        112.94902456727,
        23.199139572901
    ],
    [
        112.94911872787,
        23.199225377182
    ],
    [
        112.94923384462,
        23.199324397174
    ],
    [
        112.94932256164,
        23.199412454078
    ],
    [
        112.94944039789,
        23.199527967684
    ],
    [
        112.9495253058,
        23.19960929974
    ],
    [
        112.9496230063,
        23.199693401502
    ],
    [
        112.9497103625,
        23.19978363919
    ],
    [
        112.94982166898,
        23.199888395628
    ],
    [
        112.94993705842,
        23.199994165082
    ],
    [
        112.9500334012,
        23.200066883642
    ],
    [
        112.95012130406,
        23.200148962939
    ],
    [
        112.95022934997,
        23.200230974029
    ],
    [
        112.95055103778,
        23.200485978845
    ],
    [
        112.95077230037,
        23.200666700506
    ],
    [
        112.95090075254,
        23.200794729932
    ],
    [
        112.95105615569,
        23.200916058835
    ],
    [
        112.95124531861,
        23.201020803233
    ],
    [
        112.95145707263,
        23.201141970657
    ],
    [
        112.95169632064,
        23.201270251493
    ],
    [
        112.95189338423,
        23.201367235786
    ],
    [
        112.95209914356,
        23.201522651789
    ],
    [
        112.95222570107,
        23.201621919476
    ],
    [
        112.95229264662,
        23.201699698736
    ],
    [
        112.95246054199,
        23.201934142658
    ],
    [
        112.95265184392,
        23.202180381301
    ],
    [
        112.95280232137,
        23.202388803691
    ],
    [
        112.95291360818,
        23.202559656494
    ],
    [
        112.9531497957,
        23.202887013037
    ],
    [
        112.95343059291,
        23.203304719298
    ],
    [
        112.95358270492,
        23.203489493156
    ],
    [
        112.95378543367,
        23.203723015347
    ],
    [
        112.95390623555,
        23.203906701957
    ],
    [
        112.95402731814,
        23.20406705462
    ],
    [
        112.95421125433,
        23.204307674855
    ],
    [
        112.9544009138,
        23.204529745775
    ],
    [
        112.95457261222,
        23.204731785368
    ],
    [
        112.95472117854,
        23.204910902297
    ],
    [
        112.95492226454,
        23.20513981356
    ],
    [
        112.95507518796,
        23.205310982729
    ],
    [
        112.95527300298,
        23.205541030436
    ],
    [
        112.95542673107,
        23.205731167789
    ],
    [
        112.95553311988,
        23.205854058879
    ],
    [
        112.95562561601,
        23.205991027656
    ],
    [
        112.95573144562,
        23.206139694748
    ],
    [
        112.95582475781,
        23.206274749299
    ],
    [
        112.95593384226,
        23.206442886614
    ],
    [
        112.95600969823,
        23.206633851745
    ],
    [
        112.95604420913,
        23.206753669975
    ],
    [
        112.95607788475,
        23.20690577963
    ],
    [
        112.95609632212,
        23.207041884329
    ],
    [
        112.95610797895,
        23.207130914095
    ],
    [
        112.95618712009,
        23.20727977844
    ],
    [
        112.95628694277,
        23.207443737135
    ],
    [
        112.9564216227,
        23.207590534107
    ],
    [
        112.95653126086,
        23.207726381726
    ],
    [
        112.95666566619,
        23.207873996753
    ],
    [
        112.95681506374,
        23.207989612672
    ],
    [
        112.95694212129,
        23.20812922065
    ],
    [
        112.95703053644,
        23.208238862597
    ],
    [
        112.95711457948,
        23.208373535023
    ],
    [
        112.95722527385,
        23.208553845657
    ],
    [
        112.95731992036,
        23.208708130616
    ],
    [
        112.9573620419,
        23.208829982137
    ],
    [
        112.95739246193,
        23.208942547234
    ],
    [
        112.95746068186,
        23.209120624452
    ],
    [
        112.9575087862,
        23.209249422049
    ],
    [
        112.95754358733,
        23.209320954221
    ],
    [
        112.95756370587,
        23.209363453019
    ],
    [
        112.95756014898,
        23.209390096085
    ],
    [
        112.95756122739,
        23.209406079459
    ],
    [
        112.95755414679,
        23.209409187946
    ],
    [
        112.95754815449,
        23.209413362133
    ],
    [
        112.95754706152,
        23.209419348426
    ],
    [
        112.95752691269,
        23.209422687614
    ],
    [
        112.95750160056,
        23.209411742933
    ],
    [
        112.95741477748,
        23.209373676754
    ],
    [
        112.95722262703,
        23.20928349712
    ],
    [
        112.95712410119,
        23.209238586673
    ],
    [
        112.95711566696,
        23.209230056412
    ],
    [
        112.95711729782,
        23.209234096011
    ],
    [
        112.95710831392,
        23.209233441068
    ],
    [
        112.95709415574,
        23.209235047377
    ],
    [
        112.95703015572,
        23.209266555805
    ],
    [
        112.95694626865,
        23.209317130492
    ],
    [
        112.95692366784,
        23.209322954481
    ],
    [
        112.95689725688,
        23.209326676002
    ],
    [
        112.95680768629,
        23.209325818123
    ],
    [
        112.95663726332,
        23.209314726811
    ],
    [
        112.95644970013,
        23.209285766407
    ],
    [
        112.95628090852,
        23.209277901048
    ],
    [
        112.95616219869,
        23.209289492278
    ],
    [
        112.95605108938,
        23.209335394845
    ],
    [
        112.95597073435,
        23.209396756101
    ],
    [
        112.9558996341,
        23.20946066591
    ],
    [
        112.95584866832,
        23.209542663263
    ],
    [
        112.95583063317,
        23.209641979696
    ],
    [
        112.95582757644,
        23.209733979532
    ],
    [
        112.95583598646,
        23.209778040875
    ],
    [
        112.95585175357,
        23.209812750525
    ],
    [
        112.9559083501,
        23.209859757637
    ],
    [
        112.95596303689,
        23.209912494128
    ],
    [
        112.95598696332,
        23.209958993439
    ],
    [
        112.95598937811,
        23.210010754918
    ],
    [
        112.95597082872,
        23.210063429277
    ],
    [
        112.95593048116,
        23.210141983974
    ],
    [
        112.9558364539,
        23.210286309791
    ],
    [
        112.95573506737,
        23.210441614122
    ],
    [
        112.95565813128,
        23.210669174216
    ],
    [
        112.95561203704,
        23.21078634336
    ],
    [
        112.95557769183,
        23.210844178057
    ],
    [
        112.95553329399,
        23.210873169202
    ],
    [
        112.95549134936,
        23.210898048585
    ],
    [
        112.95541837475,
        23.210913711484
    ],
    [
        112.95533452294,
        23.210911665254
    ],
    [
        112.95528495349,
        23.210939119714
    ],
    [
        112.95521357112,
        23.211011981862
    ],
    [
        112.95515362762,
        23.211078675037
    ],
    [
        112.95513973222,
        23.211093294886
    ],
    [
        112.95509011258,
        23.211189369057
    ],
    [
        112.95507290015,
        23.211272124283
    ],
    [
        112.95507008704,
        23.211395037801
    ],
    [
        112.95508093319,
        23.211454244356
    ],
    [
        112.95507924041,
        23.211534013594
    ],
    [
        112.95505908174,
        23.211550371055
    ],
    [
        112.95502394813,
        23.211568348525
    ],
    [
        112.95501385857,
        23.211590224121
    ],
    [
        112.95501464492,
        23.21163089359
    ],
    [
        112.95500777759,
        23.211712381229
    ],
    [
        112.95499529364,
        23.21201989532
    ],
    [
        112.95500710945,
        23.212232866842
    ],
    [
        112.95503013804,
        23.212378648928
    ],
    [
        112.9550572073,
        23.212578603613
    ],
    [
        112.9551292387,
        23.21272487741
    ],
    [
        112.95523418226,
        23.212908269716
    ],
    [
        112.95527519769,
        23.213026882702
    ],
    [
        112.95532545386,
        23.213164588982
    ],
    [
        112.95540883367,
        23.213413994872
    ],
    [
        112.9555096258,
        23.213675297352
    ],
    [
        112.95553429386,
        23.213805317576
    ],
    [
        112.95554695723,
        23.213965654717
    ],
    [
        112.95553784888,
        23.214114984938
    ],
    [
        112.95552056354,
        23.214274765592
    ],
    [
        112.955499696,
        23.214484513096
    ],
    [
        112.95548155474,
        23.214688245406
    ],
    [
        112.95547729608,
        23.214893088451
    ],
    [
        112.95549287753,
        23.21513609355
    ],
    [
        112.95553671386,
        23.215445047023
    ],
    [
        112.95559881823,
        23.215720046693
    ],
    [
        112.95568591909,
        23.216049660628
    ],
    [
        112.95575644262,
        23.216342681451
    ],
    [
        112.95580603041,
        23.216602712282
    ],
    [
        112.9558545788,
        23.216806348843
    ],
    [
        112.95592670241,
        23.217129715444
    ],
    [
        112.95600427216,
        23.217449188129
    ],
    [
        112.95607833408,
        23.21773237985
    ],
    [
        112.95615431524,
        23.217999264485
    ],
    [
        112.95619854508,
        23.218156056057
    ],
    [
        112.95623726932,
        23.218376407983
    ],
    [
        112.95626437635,
        23.218501227898
    ],
    [
        112.95630448302,
        23.218697688542
    ],
    [
        112.95633856893,
        23.218925986937
    ],
    [
        112.95638299176,
        23.219162238641
    ],
    [
        112.95640456754,
        23.219374485167
    ],
    [
        112.95641453233,
        23.219486860714
    ],
    [
        112.95640703277,
        23.219640497449
    ],
    [
        112.95639767682,
        23.219742908491
    ],
    [
        112.95634880575,
        23.219884800818
    ],
    [
        112.95628827521,
        23.219977810445
    ],
    [
        112.95621825264,
        23.220033018622
    ],
    [
        112.95605128452,
        23.220112721586
    ],
    [
        112.95583042382,
        23.220179002023
    ],
    [
        112.95557061013,
        23.220267122888
    ],
    [
        112.95527703045,
        23.220362887795
    ],
    [
        112.95500660256,
        23.220448747305
    ],
    [
        112.95465036709,
        23.220586013841
    ],
    [
        112.95437478367,
        23.220657033791
    ],
    [
        112.95419231979,
        23.220717462454
    ],
    [
        112.95400741362,
        23.220770607617
    ],
    [
        112.95372014409,
        23.220824997414
    ],
    [
        112.95347259813,
        23.220905261214
    ],
    [
        112.95319049798,
        23.220967133402
    ],
    [
        112.9530083376,
        23.22100176293
    ],
    [
        112.95287218828,
        23.221033961049
    ],
    [
        112.95268401917,
        23.22109038142
    ],
    [
        112.95247895393,
        23.221166071999
    ],
    [
        112.95224203396,
        23.221247456796
    ],
    [
        112.95183683805,
        23.221372943818
    ],
    [
        112.95134832232,
        23.221527207134
    ],
    [
        112.95094725748,
        23.221621622045
    ],
    [
        112.95076127196,
        23.221688230648
    ],
    [
        112.9505211035,
        23.22177092946
    ],
    [
        112.95026948913,
        23.221870347353
    ],
    [
        112.95021967112,
        23.221875792055
    ],
    [
        112.94994388391,
        23.22192731536
    ],
    [
        112.94955811498,
        23.222000975804
    ],
    [
        112.94931391093,
        23.222054362653
    ],
    [
        112.94891510856,
        23.222113509947
    ],
    [
        112.94849649505,
        23.222127358235
    ],
    [
        112.94817316998,
        23.222121986272
    ],
    [
        112.94796742476,
        23.22211578525
    ],
    [
        112.94785693262,
        23.222113206532
    ],
    [
        112.94775706127,
        23.222104759017
    ],
    [
        112.94762890293,
        23.222080753879
    ],
    [
        112.94747652061,
        23.222061191892
    ],
    [
        112.9472609867,
        23.222058611557
    ],
    [
        112.94703920749,
        23.222046345171
    ],
    [
        112.94682205434,
        23.222038596264
    ],
    [
        112.94676980737,
        23.222036963242
    ],
    [
        112.94676817485,
        23.222036717257
    ],
    [
        112.94676380768,
        23.222049802674
    ],
    [
        112.94676482949,
        23.22211623267
    ],
    [
        112.94678599065,
        23.222180724195
    ],
    [
        112.94686698732,
        23.222277918912
    ],
    [
        112.94687786423,
        23.222286157782
    ],
    [
        112.94696298066,
        23.222346401006
    ],
    [
        112.9472181113,
        23.222477755349
    ],
    [
        112.94739273473,
        23.222567769275
    ],
    [
        112.94757055803,
        23.222725521474
    ],
    [
        112.94772743444,
        23.22287708386
    ],
    [
        112.94793460876,
        23.223080448815
    ],
    [
        112.94812057345,
        23.2232684064
    ],
    [
        112.94841854337,
        23.223583097781
    ],
    [
        112.94860283525,
        23.223816339152
    ],
    [
        112.94879095177,
        23.22403784381
    ],
    [
        112.94903853402,
        23.224399661849
    ],
    [
        112.94926194013,
        23.224718191537
    ],
    [
        112.94934968424,
        23.224885167036
    ],
    [
        112.94944208215,
        23.22502656983
    ],
    [
        112.94947946757,
        23.22519843975
    ],
    [
        112.94951388868,
        23.225341339154
    ],
    [
        112.94959153892,
        23.2255317979
    ],
    [
        112.94968631494,
        23.225744209724
    ],
    [
        112.94980424663,
        23.225938334516
    ],
    [
        112.94995727428,
        23.226150041195
    ],
    [
        112.9500934514,
        23.226338156015
    ],
    [
        112.9502184671,
        23.226528621711
    ],
    [
        112.95028941871,
        23.226618829616
    ],
    [
        112.95037722323,
        23.226732348092
    ],
    [
        112.95047372888,
        23.226855481462
    ],
    [
        112.95055908175,
        23.22697174863
    ],
    [
        112.95067351579,
        23.22713227223
    ],
    [
        112.9507504064,
        23.227272814892
    ],
    [
        112.95082533385,
        23.227470071121
    ],
    [
        112.95087095141,
        23.227581036165
    ],
    [
        112.95091328508,
        23.227709142229
    ],
    [
        112.95092791368,
        23.227778323139
    ],
    [
        112.95097893495,
        23.227929333822
    ],
    [
        112.95102918941,
        23.228031811025
    ],
    [
        112.95108839653,
        23.228164239428
    ],
    [
        112.95115956551,
        23.228312193588
    ],
    [
        112.95123617681,
        23.228462494739
    ],
    [
        112.95130166865,
        23.228572574181
    ],
    [
        112.95138973837,
        23.228698811156
    ],
    [
        112.95151128933,
        23.228827186488
    ],
    [
        112.95164781905,
        23.22894987788
    ],
    [
        112.95178108938,
        23.229066383144
    ],
    [
        112.95188366287,
        23.229120220531
    ],
    [
        112.95194545138,
        23.229126481864
    ],
    [
        112.95200833393,
        23.229127841847
    ],
    [
        112.95206852293,
        23.229101041899
    ],
    [
        112.9522513029,
        23.228986969811
    ],
    [
        112.9525975081,
        23.228788973521
    ],
    [
        112.95299302839,
        23.228555926049
    ],
    [
        112.95343676483,
        23.228299229893
    ],
    [
        112.95371190083,
        23.228129529626
    ],
    [
        112.95403171274,
        23.227934627699
    ],
    [
        112.95427412557,
        23.22782189231
    ],
    [
        112.95438171248,
        23.227773084078
    ],
    [
        112.95450511184,
        23.227702842645
    ],
    [
        112.95461026093,
        23.22764241302
    ],
    [
        112.9546584773,
        23.227614444162
    ],
    [
        112.95471349171,
        23.227594491613
    ],
    [
        112.95477639152,
        23.227584163373
    ],
    [
        112.95492069569,
        23.227571858507
    ],
    [
        112.9553094878,
        23.227552257026
    ],
    [
        112.9555485188,
        23.227556987955
    ],
    [
        112.95563019052,
        23.227560427529
    ],
    [
        112.95573063022,
        23.227580892475
    ],
    [
        112.95593341648,
        23.227620973983
    ],
    [
        112.95610137575,
        23.227640515875
    ],
    [
        112.95623830728,
        23.227651384687
    ],
    [
        112.95651490801,
        23.227658428225
    ],
    [
        112.95691944637,
        23.227685720598
    ],
    [
        112.95715819144,
        23.227704825474
    ],
    [
        112.95717861593,
        23.227699311728
    ],
    [
        112.95719059077,
        23.227703439462
    ],
    [
        112.95732942474,
        23.227717259434
    ],
    [
        112.9576299569,
        23.227749108783
    ],
    [
        112.95784364367,
        23.227777883755
    ],
    [
        112.95793402017,
        23.227787952097
    ],
    [
        112.95808974711,
        23.227787377336
    ],
    [
        112.95826317342,
        23.227783238364
    ],
    [
        112.95838458496,
        23.227793848381
    ],
    [
        112.95854954675,
        23.227813186321
    ],
    [
        112.95872786071,
        23.22782008821
    ],
    [
        112.9588800458,
        23.227819858054
    ],
    [
        112.95906489791,
        23.227821227758
    ],
    [
        112.95924539597,
        23.227819965773
    ],
    [
        112.9593629892,
        23.227834723803
    ],
    [
        112.95949854688,
        23.22785242445
    ],
    [
        112.95972038715,
        23.227886251589
    ],
    [
        112.95989430645,
        23.227925801765
    ],
    [
        112.96012591241,
        23.227990933025
    ],
    [
        112.96028263523,
        23.228073101195
    ],
    [
        112.96046600701,
        23.228183560445
    ],
    [
        112.96060527539,
        23.228295059008
    ],
    [
        112.96075296106,
        23.228427299058
    ],
    [
        112.96091234251,
        23.228568563212
    ],
    [
        112.96113264252,
        23.228767638284
    ],
    [
        112.96128682083,
        23.228937210116
    ],
    [
        112.96143989704,
        23.229119010536
    ],
    [
        112.96150866662,
        23.229219808933
    ],
    [
        112.9615554104,
        23.229296847014
    ],
    [
        112.96157081111,
        23.22941157568
    ],
    [
        112.96158891696,
        23.22954334429
    ],
    [
        112.96157286442,
        23.229805874976
    ],
    [
        112.961567291,
        23.229934522077
    ],
    [
        112.96156469349,
        23.230081831709
    ],
    [
        112.96155990761,
        23.230240027028
    ],
    [
        112.96155534452,
        23.230448120726
    ],
    [
        112.96155378613,
        23.230646399798
    ],
    [
        112.96153125823,
        23.230853986824
    ],
    [
        112.96154474424,
        23.230980139276
    ],
    [
        112.96156582914,
        23.231130028407
    ],
    [
        112.96159373272,
        23.231266783414
    ],
    [
        112.96168176629,
        23.231434245065
    ],
    [
        112.96178127142,
        23.231562459567
    ],
    [
        112.9618816102,
        23.231673033913
    ],
    [
        112.96205323514,
        23.231817388245
    ],
    [
        112.96221481945,
        23.231928561435
    ],
    [
        112.96238401256,
        23.232051817874
    ],
    [
        112.96262777729,
        23.232186034248
    ],
    [
        112.96283671807,
        23.23229888216
    ],
    [
        112.96295968873,
        23.232363816537
    ],
    [
        112.96299802976,
        23.232403858338
    ],
    [
        112.96301787054,
        23.232434445392
    ],
    [
        112.96303959657,
        23.232485884263
    ],
    [
        112.9630519478,
        23.232662235715
    ],
    [
        112.96305575416,
        23.232666782869
    ],
    [
        112.96309646873,
        23.232786250719
    ],
    [
        112.96320626231,
        23.232966678012
    ],
    [
        112.96332238648,
        23.233073235243
    ],
    [
        112.96336455079,
        23.233099657725
    ],
    [
        112.96340755844,
        23.233097860999
    ],
    [
        112.96351619524,
        23.233062435438
    ],
    [
        112.96372422117,
        23.232982255716
    ],
    [
        112.96388185672,
        23.232937902011
    ],
    [
        112.9641497404,
        23.232874129869
    ],
    [
        112.96439040638,
        23.232805671333
    ],
    [
        112.96467516196,
        23.232733811869
    ],
    [
        112.9648795904,
        23.232697441262
    ],
    [
        112.96516816088,
        23.232609302183
    ],
    [
        112.96532248512,
        23.232594376692
    ],
    [
        112.96546402124,
        23.232574509781
    ],
    [
        112.965894703,
        23.232414517115
    ],
    [
        112.9663743513,
        23.232254393121
    ],
    [
        112.96688959405,
        23.232126378988
    ],
    [
        112.9673737957,
        23.231994614341
    ],
    [
        112.96770393864,
        23.23189804839
    ],
    [
        112.96771131706,
        23.231865123265
    ],
    [
        112.96770349241,
        23.231797436405
    ],
    [
        112.9676747634,
        23.23140406517
    ],
    [
        112.96768579171,
        23.231256636101
    ],
    [
        112.96772008417,
        23.231247180356
    ],
    [
        112.96828337512,
        23.231160307311
    ],
    [
        112.96848965172,
        23.231110961332
    ],
    [
        112.96856939094,
        23.231086224486
    ],
    [
        112.96878361871,
        23.230967910699
    ],
    [
        112.96904900643,
        23.230829647797
    ],
    [
        112.96930158838,
        23.230703535394
    ],
    [
        112.96958981957,
        23.2305569004
    ],
    [
        112.96979040318,
        23.23045706695
    ],
    [
        112.97010117832,
        23.230327297807
    ],
    [
        112.97034229511,
        23.230210985482
    ],
    [
        112.97063263711,
        23.23009379191
    ],
    [
        112.97078963292,
        23.230038044185
    ],
    [
        112.97085766311,
        23.230005158732
    ],
    [
        112.97097196737,
        23.229935066192
    ],
    [
        112.97116462854,
        23.229836316703
    ],
    [
        112.97124435706,
        23.229796789663
    ],
    [
        112.97128162094,
        23.229793333139
    ],
    [
        112.9712922207,
        23.229800521304
    ],
    [
        112.97131122427,
        23.229834995063
    ],
    [
        112.97137741062,
        23.230009629613
    ],
    [
        112.97145037467,
        23.230205607273
    ],
    [
        112.97151827222,
        23.23029994885
    ],
    [
        112.97154791237,
        23.230303916953
    ],
    [
        112.97161375886,
        23.230272176546
    ],
    [
        112.97184012932,
        23.230169565399
    ],
    [
        112.97212744523,
        23.230029905631
    ],
    [
        112.97215493063,
        23.23001058786
    ],
    [
        112.97219326414,
        23.230020701135
    ],
    [
        112.972198966,
        23.230029582099
    ],
    [
        112.97220575591,
        23.230038178734
    ],
    [
        112.97224294322,
        23.230106616933
    ],
    [
        112.97231703658,
        23.23025244944
    ],
    [
        112.97244769559,
        23.230393813765
    ],
    [
        112.97254712905,
        23.230486741829
    ],
    [
        112.9726028308,
        23.230530018827
    ],
    [
        112.97267152865,
        23.230629556493
    ],
    [
        112.97270625547,
        23.230709426313
    ],
    [
        112.97278787679,
        23.230938455873
    ],
    [
        112.97286459916,
        23.231171886543
    ],
    [
        112.97292394127,
        23.231382741162
    ],
    [
        112.97298537372,
        23.231680903828
    ],
    [
        112.97300424659,
        23.231846124163
    ],
    [
        112.97301670104,
        23.231901036264
    ],
    [
        112.97302293157,
        23.231925102195
    ],
    [
        112.97299381388,
        23.231949304299
    ],
    [
        112.97284398891,
        23.231950769362
    ],
    [
        112.97261774998,
        23.231952878274
    ],
    [
        112.9725513969,
        23.231956374669
    ],
    [
        112.97253180428,
        23.231970709752
    ],
    [
        112.97253232264,
        23.231997010981
    ],
    [
        112.97254721651,
        23.23206111127
    ],
    [
        112.97268131629,
        23.23229982126
    ],
    [
        112.97273991621,
        23.232439891949
    ],
    [
        112.97274993458,
        23.232484253179
    ],
    [
        112.97275181876,
        23.232504300711
    ],
    [
        112.97272732833,
        23.232522758676
    ],
    [
        112.97260924246,
        23.232597645698
    ],
    [
        112.97257683447,
        23.232648744965
    ],
    [
        112.97254658497,
        23.232717448095
    ],
    [
        112.97254682397,
        23.232751889042
    ],
    [
        112.97254977194,
        23.232797146345
    ],
    [
        112.97257259353,
        23.232818301904
    ],
    [
        112.97263212105,
        23.232843364092
    ],
    [
        112.97296884295,
        23.23303552012
    ],
    [
        112.97327267164,
        23.233204532832
    ],
    [
        112.97370121031,
        23.233449796255
    ],
    [
        112.9739104499,
        23.233562226332
    ],
    [
        112.97408544336,
        23.233658512241
    ],
    [
        112.97416423217,
        23.233713808256
    ],
    [
        112.97419413346,
        23.233717556974
    ],
    [
        112.97421425135,
        23.233717342404
    ],
    [
        112.9742849625,
        23.233687570871
    ],
    [
        112.97432901967,
        23.233670017938
    ],
    [
        112.97435648035,
        23.233666473314
    ],
    [
        112.9743768597,
        23.233676835683
    ],
    [
        112.9744281896,
        23.233730538222
    ],
    [
        112.97446237044,
        23.233808017743
    ],
    [
        112.97446909496,
        23.233884971697
    ],
    [
        112.97445436973,
        23.233933673007
    ],
    [
        112.97440780431,
        23.234018508992
    ],
    [
        112.97440804672,
        23.234050238343
    ],
    [
        112.97442049422,
        23.234112486481
    ],
    [
        112.97444653772,
        23.23417106635
    ],
    [
        112.97455056229,
        23.234272226921
    ],
    [
        112.97460349641,
        23.234354397046
    ],
    [
        112.97466134813,
        23.234409668397
    ],
    [
        112.97476837026,
        23.234499695379
    ],
    [
        112.97482893758,
        23.234556573535
    ],
    [
        112.97484900239,
        23.234612239055
    ],
    [
        112.97485493843,
        23.234660725873
    ],
    [
        112.97484511668,
        23.234699880674
    ],
    [
        112.97481844498,
        23.234734868014
    ],
    [
        112.97476813281,
        23.234759520536
    ],
    [
        112.9747499131,
        23.23476675888
    ],
    [
        112.97474584339,
        23.234758121791
    ],
    [
        112.97463909736,
        23.234662398137
    ],
    [
        112.9745046735,
        23.234509745769
    ],
    [
        112.97440824362,
        23.234425866396
    ],
    [
        112.97433299523,
        23.234365907899
    ],
    [
        112.97427156975,
        23.234350556985
    ],
    [
        112.97423460234,
        23.234344712014
    ],
    [
        112.97419270124,
        23.234382314816
    ],
    [
        112.97416767649,
        23.234396956454
    ],
    [
        112.97415512059,
        23.234451604631
    ],
    [
        112.97416730823,
        23.234501919949
    ],
    [
        112.97420316894,
        23.234529200759
    ],
    [
        112.97429389547,
        23.234610413817
    ],
    [
        112.97438678982,
        23.234698119306
    ],
    [
        112.97449440033,
        23.234744724098
    ],
    [
        112.9745930347,
        23.234795227641
    ],
    [
        112.97465063251,
        23.23483151633
    ],
    [
        112.97468212037,
        23.234881908354
    ],
    [
        112.97467609429,
        23.234932145098
    ],
    [
        112.97463907602,
        23.234984871745
    ],
    [
        112.97460888247,
        23.235005796616
    ],
    [
        112.97454743529,
        23.235017012234
    ],
    [
        112.9744642629,
        23.235002421444
    ],
    [
        112.97431424298,
        23.234954911084
    ],
    [
        112.97428161443,
        23.234961223513
    ],
    [
        112.97425143419,
        23.234965612202
    ],
    [
        112.97423293874,
        23.234975572641
    ],
    [
        112.97422150407,
        23.23499386574
    ],
    [
        112.97422366842,
        23.235005504894
    ],
    [
        112.9742179485,
        23.235017499248
    ],
    [
        112.97426518312,
        23.235093750426
    ],
    [
        112.97434582095,
        23.235208705015
    ],
    [
        112.97447728858,
        23.235329912118
    ],
    [
        112.97464869639,
        23.235471873616
    ],
    [
        112.97473099788,
        23.235546152197
    ],
    [
        112.97474674606,
        23.235566874081
    ],
    [
        112.97474970157,
        23.235605898736
    ],
    [
        112.97471344387,
        23.235722080068
    ],
    [
        112.9746891853,
        23.235795286731
    ],
    [
        112.97468074378,
        23.235811646662
    ],
    [
        112.97470380661,
        23.235861041523
    ],
    [
        112.97482462793,
        23.236027414758
    ],
    [
        112.97494085739,
        23.236158587543
    ],
    [
        112.97506524714,
        23.236281552421
    ],
    [
        112.97512853752,
        23.236332722171
    ],
    [
        112.97512308454,
        23.236351761699
    ],
    [
        112.97511490483,
        23.236380592257
    ],
    [
        112.97501669743,
        23.236471348801
    ],
    [
        112.97497101985,
        23.236483471225
    ],
    [
        112.97491421015,
        23.236480248645
    ],
    [
        112.97483103813,
        23.236469974197
    ],
    [
        112.97478047551,
        23.236471304361
    ],
    [
        112.97476063003,
        23.236472863699
    ],
    [
        112.97473831611,
        23.236499671812
    ],
    [
        112.97471733209,
        23.236560368711
    ],
    [
        112.97469575636,
        23.236676942722
    ],
    [
        112.97468257795,
        23.236828688803
    ],
    [
        112.97466883737,
        23.237002952003
    ],
    [
        112.97466180189,
        23.237286175873
    ],
    [
        112.97465478693,
        23.23754770262
    ],
    [
        112.97466553634,
        23.237697304277
    ],
    [
        112.9746716526,
        23.237862142222
    ],
    [
        112.97466829225,
        23.237981784511
    ],
    [
        112.97471496632,
        23.238082739779
    ],
    [
        112.97477553444,
        23.238146397373
    ],
    [
        112.97482797918,
        23.238170542511
    ],
    [
        112.97489973236,
        23.238183916172
    ],
    [
        112.9749696011,
        23.238173716636
    ],
    [
        112.97514440675,
        23.23814674098
    ],
    [
        112.97518002572,
        23.238133910694
    ],
    [
        112.97522595779,
        23.238140507101
    ],
    [
        112.97526971277,
        23.238149838788
    ],
    [
        112.9753351929,
        23.238183368388
    ],
    [
        112.97537918748,
        23.238231485836
    ],
    [
        112.97540986325,
        23.238279463411
    ],
    [
        112.97542830656,
        23.238328645687
    ],
    [
        112.97543858246,
        23.238394180906
    ],
    [
        112.97544858079,
        23.238467041885
    ],
    [
        112.97543412912,
        23.238524138758
    ],
    [
        112.97541151059,
        23.238597046223
    ],
    [
        112.97540495613,
        23.2386358947
    ],
    [
        112.97539814741,
        23.23865277683
    ],
    [
        112.97540792446,
        23.238662987804
    ],
    [
        112.97541363468,
        23.238660219908
    ],
    [
        112.97550959254,
        23.238648167785
    ],
    [
        112.97559739697,
        23.238633488891
    ],
    [
        112.97562403698,
        23.238629164891
    ],
    [
        112.97563789633,
        23.238632286735
    ],
    [
        112.97564386647,
        23.238644163282
    ],
    [
        112.97563706838,
        23.238648025462
    ],
    [
        112.97564899853,
        23.238684526052
    ],
    [
        112.97565651577,
        23.238801892781
    ],
    [
        112.97565507984,
        23.238899274878
    ],
    [
        112.97564115262,
        23.238982401848
    ],
    [
        112.97563703919,
        23.239028820093
    ],
    [
        112.97560164744,
        23.239102389341
    ],
    [
        112.97555403688,
        23.239160075268
    ],
    [
        112.9754895674,
        23.239226334126
    ],
    [
        112.97544522932,
        23.239269346415
    ],
    [
        112.97541066827,
        23.239322571281
    ],
    [
        112.97539541091,
        23.239369099132
    ],
    [
        112.97540407941,
        23.239407256839
    ],
    [
        112.97542308684,
        23.23943229518
    ],
    [
        112.97544861102,
        23.239465949539
    ],
    [
        112.97548556696,
        23.239478880638
    ],
    [
        112.97552416666,
        23.239474709901
    ],
    [
        112.97556548751,
        23.239466174545
    ],
    [
        112.97563617933,
        23.23943593231
    ],
    [
        112.97565955598,
        23.23943353885
    ],
    [
        112.97565927416,
        23.239446560213
    ],
    [
        112.975701649,
        23.239480058608
    ],
    [
        112.97571656259,
        23.239526024425
    ],
    [
        112.97572628987,
        23.239601060548
    ],
    [
        112.97571511156,
        23.239646461059
    ],
    [
        112.97568762901,
        23.239687135072
    ],
    [
        112.97564982308,
        23.239721127834
    ],
    [
        112.97551904688,
        23.239772561833
    ],
    [
        112.97535455818,
        23.239830848213
    ],
    [
        112.97517781941,
        23.239907720191
    ],
    [
        112.97502120658,
        23.239964071911
    ],
    [
        112.97485858548,
        23.240052778982
    ],
    [
        112.9748115366,
        23.240081465696
    ],
    [
        112.97478434626,
        23.240090422706
    ],
    [
        112.97477074033,
        23.240109276376
    ],
    [
        112.97476881098,
        23.240144826419
    ],
    [
        112.97475081732,
        23.240215257743
    ],
    [
        112.97474556307,
        23.240336006257
    ],
    [
        112.97472531819,
        23.240511424919
    ],
    [
        112.97467817491,
        23.240669220319
    ],
    [
        112.97464544471,
        23.240820359167
    ],
    [
        112.97463070007,
        23.240911100811
    ],
    [
        112.9746145959,
        23.241002670439
    ],
    [
        112.97458517534,
        23.241088953951
    ],
    [
        112.97443410265,
        23.241368536933
    ],
    [
        112.97432576798,
        23.241565503317
    ],
    [
        112.97427242171,
        23.241655844366
    ],
    [
        112.97419377058,
        23.241777919657
    ],
    [
        112.97411729219,
        23.241902688592
    ],
    [
        112.97402232433,
        23.242030644905
    ],
    [
        112.97394968405,
        23.24210656103
    ],
    [
        112.97385257552,
        23.242180849372
    ],
    [
        112.97370731688,
        23.242294460169
    ],
    [
        112.97352888482,
        23.242408727056
    ],
    [
        112.97339234341,
        23.242487827724
    ],
    [
        112.97325687795,
        23.242581033415
    ],
    [
        112.97321932813,
        23.242623500409
    ],
    [
        112.97321958036,
        23.242653875198
    ],
    [
        112.97322389649,
        23.242706987044
    ],
    [
        112.97322742721,
        23.242713185184
    ],
    [
        112.97330726139,
        23.242875831441
    ],
    [
        112.9733909232,
        23.243005349346
    ],
    [
        112.97349168577,
        23.243179705401
    ],
    [
        112.97354517061,
        23.243304145914
    ],
    [
        112.97361984215,
        23.243462257497
    ],
    [
        112.97368689363,
        23.243632934073
    ],
    [
        112.97376021424,
        23.243778049492
    ],
    [
        112.97377922662,
        23.243810117404
    ],
    [
        112.9738039551,
        23.243831002454
    ],
    [
        112.97391350963,
        23.243850149348
    ],
    [
        112.97407336247,
        23.243861711018
    ],
    [
        112.97434549666,
        23.243860167371
    ],
    [
        112.97446430005,
        23.243854307649
    ],
    [
        112.97449148703,
        23.2438510398
    ],
    [
        112.97451297375,
        23.243833185405
    ],
    [
        112.97456601822,
        23.243775945628
    ],
    [
        112.97464329323,
        23.243657701427
    ],
    [
        112.97469392803,
        23.243538650906
    ],
    [
        112.97474319052,
        23.243441315014
    ],
    [
        112.97476986116,
        23.243391677593
    ],
    [
        112.97482616448,
        23.243337941027
    ],
    [
        112.97485145033,
        23.243329546521
    ],
    [
        112.97494851425,
        23.243297641932
    ],
    [
        112.97508391481,
        23.243248544228
    ],
    [
        112.9752070891,
        23.243186020034
    ],
    [
        112.97530335049,
        23.243125127983
    ],
    [
        112.97534495755,
        23.243094070479
    ],
    [
        112.97539800579,
        23.243022760497
    ],
    [
        112.97546085306,
        23.242929116649
    ],
    [
        112.97552670033,
        23.242819173144
    ],
    [
        112.97560321008,
        23.242612572971
    ],
    [
        112.97562669353,
        23.242445812982
    ],
    [
        112.97568226028,
        23.242264100835
    ],
    [
        112.97573204616,
        23.242193378648
    ],
    [
        112.97578859837,
        23.242165177265
    ],
    [
        112.9758424168,
        23.242160058529
    ],
    [
        112.97599513208,
        23.24220500985
    ],
    [
        112.97626871984,
        23.242347061088
    ],
    [
        112.97642383988,
        23.242439236243
    ],
    [
        112.97647599569,
        23.242474572466
    ],
    [
        112.97652542219,
        23.242527293769
    ],
    [
        112.97665278933,
        23.242662869567
    ],
    [
        112.97680703026,
        23.242841622674
    ],
    [
        112.97691647024,
        23.242958123726
    ],
    [
        112.97700035968,
        23.243083530703
    ],
    [
        112.97714509088,
        23.243251558276
    ],
    [
        112.97724694014,
        23.243332621436
    ],
    [
        112.97729203406,
        23.243353675665
    ],
    [
        112.97747540341,
        23.2434248659
    ],
    [
        112.97754848042,
        23.243449229197
    ],
    [
        112.9776030916,
        23.243454758239
    ],
    [
        112.97764004661,
        23.243451208423
    ],
    [
        112.97766341766,
        23.243444784089
    ],
    [
        112.97770120817,
        23.243407325533
    ],
    [
        112.977815948,
        23.243277316281
    ],
    [
        112.97789833172,
        23.243183371064
    ],
    [
        112.97797800244,
        23.243081857951
    ],
    [
        112.97803592965,
        23.242992179052
    ],
    [
        112.97806151271,
        23.24292254883
    ],
    [
        112.97807245957,
        23.242797970729
    ],
    [
        112.9780997103,
        23.242670556758
    ],
    [
        112.97810114147,
        23.242557985533
    ],
    [
        112.97808950492,
        23.242487011712
    ],
    [
        112.97803959449,
        23.24236344004
    ],
    [
        112.97797773015,
        23.242239148755
    ],
    [
        112.9779164016,
        23.242126248256
    ],
    [
        112.97786838215,
        23.242019485638
    ],
    [
        112.97777281837,
        23.241907130755
    ],
    [
        112.97761940635,
        23.241754831238
    ],
    [
        112.97748065354,
        23.241617892492
    ],
    [
        112.97732532966,
        23.241471341822
    ],
    [
        112.97720422488,
        23.24134757995
    ],
    [
        112.97716485915,
        23.241296917785
    ],
    [
        112.97715997514,
        23.241286652013
    ],
    [
        112.97717683406,
        23.24127023754
    ],
    [
        112.9773748335,
        23.24101283398
    ],
    [
        112.97739960172,
        23.24095458909
    ],
    [
        112.97741781607,
        23.24094196407
    ],
    [
        112.97742677963,
        23.240946501865
    ],
    [
        112.97745745926,
        23.240981240493
    ],
    [
        112.97751773899,
        23.241039879772
    ],
    [
        112.97761227215,
        23.241073023784
    ],
    [
        112.97771279064,
        23.241093108968
    ],
    [
        112.97789808323,
        23.241106032607
    ],
    [
        112.97806273954,
        23.241093375338
    ],
    [
        112.97815079177,
        23.241058262002
    ],
    [
        112.97827773012,
        23.240971332305
    ],
    [
        112.97832286042,
        23.240927330062
    ],
    [
        112.97834413749,
        23.240807019749
    ],
    [
        112.97835046113,
        23.240702822461
    ],
    [
        112.97832718428,
        23.240582027933
    ],
    [
        112.97832908841,
        23.240578759147
    ],
    [
        112.97836902885,
        23.240573582369
    ],
    [
        112.97845327445,
        23.240537434621
    ],
    [
        112.97861739541,
        23.240492582081
    ],
    [
        112.9787320684,
        23.240449727542
    ],
    [
        112.97874674524,
        23.24043985998
    ],
    [
        112.97875108189,
        23.240453390692
    ],
    [
        112.9787584074,
        23.240466086722
    ],
    [
        112.9787825376,
        23.240531011274
    ],
    [
        112.97883624231,
        23.240645635405
    ],
    [
        112.97888321003,
        23.240684908036
    ],
    [
        112.97890820413,
        23.240682022912
    ],
    [
        112.97895357549,
        23.240674116153
    ],
    [
        112.97903291819,
        23.240644281637
    ],
    [
        112.97920058337,
        23.240558531329
    ],
    [
        112.9796389076,
        23.240299660051
    ],
    [
        112.98007667669,
        23.240014378714
    ],
    [
        112.98019189178,
        23.239934507495
    ],
    [
        112.98021200658,
        23.239911608232
    ],
    [
        112.98022124633,
        23.23990396059
    ],
    [
        112.98008434394,
        23.239571967449
    ],
    [
        112.97999189823,
        23.239351740204
    ],
    [
        112.97999272224,
        23.239339801475
    ],
    [
        112.97999028788,
        23.239326797317
    ],
    [
        112.98003865274,
        23.23930047202
    ],
    [
        112.98031470314,
        23.239152950044
    ],
    [
        112.98044512838,
        23.239067593917
    ],
    [
        112.98044242446,
        23.239052420542
    ],
    [
        112.98044271194,
        23.23903207726
    ],
    [
        112.9803441113,
        23.238709063658
    ],
    [
        112.98031509141,
        23.238659323637
    ],
    [
        112.9803091271,
        23.238646067734
    ],
    [
        112.98031701062,
        23.238636530105
    ],
    [
        112.98063491972,
        23.238429722616
    ],
    [
        112.98083028481,
        23.238291716007
    ],
    [
        112.98093055365,
        23.238211727631
    ],
    [
        112.98103681237,
        23.238110291471
    ],
    [
        112.98114796977,
        23.237993381535
    ],
    [
        112.98128248696,
        23.237864978207
    ],
    [
        112.98141021912,
        23.237729300165
    ],
    [
        112.98147025622,
        23.23769375969
    ],
    [
        112.98157511319,
        23.237634962826
    ],
    [
        112.98169925045,
        23.237570665202
    ],
    [
        112.98186140554,
        23.237495096606
    ],
    [
        112.98199639908,
        23.237427801896
    ],
    [
        112.98211645465,
        23.237363567991
    ],
    [
        112.98218109423,
        23.237334556348
    ],
    [
        112.98221803908,
        23.237308099789
    ],
    [
        112.98224006798,
        23.237262447099
    ],
    [
        112.98224172038,
        23.237234504929
    ],
    [
        112.98223904131,
        23.237191934144
    ],
    [
        112.98222390305,
        23.237114696976
    ],
    [
        112.98219437039,
        23.237044027055
    ],
    [
        112.98213314161,
        23.236892663396
    ],
    [
        112.9821006375,
        23.236804378978
    ],
    [
        112.98203262637,
        23.236647082161
    ],
    [
        112.98197759441,
        23.236551030207
    ],
    [
        112.98190899836,
        23.236441749275
    ],
    [
        112.98178398287,
        23.236268982635
    ],
    [
        112.98169044148,
        23.236118871298
    ],
    [
        112.98158631643,
        23.235961222151
    ],
    [
        112.98149573461,
        23.235839591717
    ],
    [
        112.98145316097,
        23.235776054388
    ],
    [
        112.98144180635,
        23.235719965766
    ],
    [
        112.98142906965,
        23.235691547883
    ],
    [
        112.98143562888,
        23.235643511683
    ],
    [
        112.98145363623,
        23.235546060442
    ],
    [
        112.98147870881,
        23.235442609819
    ],
    [
        112.98152115533,
        23.235343418794
    ],
    [
        112.98160326495,
        23.235220723637
    ],
    [
        112.98164545591,
        23.235103367134
    ],
    [
        112.98165742888,
        23.235074293066
    ],
    [
        112.98167089424,
        23.234896043804
    ],
    [
        112.98165375074,
        23.234639008733
    ],
    [
        112.98163982769,
        23.234424811664
    ],
    [
        112.98159801091,
        23.234132903172
    ],
    [
        112.9815525689,
        23.233945430803
    ],
    [
        112.98150327489,
        23.233812763573
    ],
    [
        112.98140401449,
        23.23368548692
    ],
    [
        112.98127926832,
        23.233515490505
    ],
    [
        112.98127168994,
        23.2334892195
    ],
    [
        112.98126682008,
        23.23347025817
    ],
    [
        112.98127064122,
        23.233449356186
    ],
    [
        112.98130135702,
        23.233415034739
    ],
    [
        112.98137830746,
        23.233301841494
    ],
    [
        112.98156720193,
        23.233107584366
    ],
    [
        112.98177211864,
        23.232904067389
    ],
    [
        112.98191697996,
        23.232749119003
    ],
    [
        112.98206263707,
        23.23261018781
    ],
    [
        112.98217596177,
        23.232493645317
    ],
    [
        112.9822224703,
        23.232406399208
    ],
    [
        112.98229452289,
        23.232293560375
    ],
    [
        112.98234378869,
        23.232161558526
    ],
    [
        112.9823419862,
        23.232060132116
    ],
    [
        112.98234297334,
        23.231881670644
    ],
    [
        112.98234064918,
        23.231758820618
    ],
    [
        112.98232362314,
        23.231679150668
    ],
    [
        112.98228865079,
        23.231628571189
    ],
    [
        112.98223769951,
        23.231537917018
    ],
    [
        112.98213569733,
        23.231457506948
    ],
    [
        112.98205185515,
        23.231406321615
    ],
    [
        112.98193219732,
        23.231330614347
    ],
    [
        112.9819077804,
        23.231311733803
    ],
    [
        112.98190263664,
        23.231296567993
    ],
    [
        112.9819088927,
        23.231284879106
    ],
    [
        112.98193555177,
        23.231232150303
    ],
    [
        112.98198126251,
        23.23113187969
    ],
    [
        112.98199323975,
        23.231100097543
    ],
    [
        112.98200057935,
        23.231090845525
    ],
    [
        112.98201877365,
        23.231086972341
    ],
    [
        112.98202828255,
        23.23108042355
    ],
    [
        112.98215529438,
        23.231129532509
    ],
    [
        112.98231975426,
        23.231192883207
    ],
    [
        112.98233198359,
        23.231180088523
    ],
    [
        112.98234909349,
        23.231173512876
    ],
    [
        112.98239424932,
        23.231081940196
    ],
    [
        112.98247101816,
        23.230866577302
    ],
    [
        112.98248273178,
        23.230825851484
    ],
    [
        112.98249250816,
        23.230822560209
    ],
    [
        112.98247840526,
        23.230808510253
    ],
    [
        112.9822954839,
        23.230750903958
    ],
    [
        112.98225152939,
        23.230724227761
    ],
    [
        112.98224909322,
        23.23071691474
    ],
    [
        112.9823888693,
        23.230481228163
    ],
    [
        112.98254909503,
        23.230153000581
    ],
    [
        112.9826119369,
        23.230020418856
    ],
    [
        112.98268290088,
        23.229909237256
    ],
    [
        112.98275143852,
        23.229780440099
    ],
    [
        112.98281538562,
        23.229626711753
    ],
    [
        112.98295137453,
        23.229366429867
    ],
    [
        112.98304960601,
        23.229129610998
    ],
    [
        112.98317499938,
        23.228874002017
    ],
    [
        112.9833126697,
        23.228554364878
    ],
    [
        112.98342911062,
        23.228289319762
    ],
    [
        112.98350639643,
        23.228091386133
    ],
    [
        112.98368995849,
        23.227743190647
    ],
    [
        112.98385771532,
        23.227452019699
    ],
    [
        112.98398064094,
        23.227205459568
    ],
    [
        112.98402851046,
        23.227104184611
    ],
    [
        112.98405602209,
        23.22700567108
    ],
    [
        112.98409635343,
        23.226844208151
    ],
    [
        112.98414971693,
        23.226677293221
    ],
    [
        112.98419601415,
        23.226519888775
    ],
    [
        112.98423137844,
        23.226437906222
    ],
    [
        112.98428139069,
        23.226362402666
    ],
    [
        112.98431099659,
        23.226337931376
    ],
    [
        112.98435607748,
        23.226307191185
    ],
    [
        112.98447118811,
        23.226261940128
    ],
    [
        112.98454150503,
        23.226231430001
    ],
    [
        112.98457246855,
        23.226204793609
    ],
    [
        112.98458715637,
        23.226171678899
    ],
    [
        112.98459614513,
        23.226138846022
    ],
    [
        112.98459754608,
        23.226095721118
    ],
    [
        112.98458405748,
        23.226017637511
    ],
    [
        112.98454512514,
        23.225875867324
    ],
    [
        112.98454113973,
        23.225792613459
    ],
    [
        112.98454579856,
        23.225748126312
    ],
    [
        112.9845463721,
        23.225718020964
    ],
    [
        112.98456485477,
        23.22568923818
    ],
    [
        112.98458033705,
        23.22567537778
    ],
    [
        112.98459690059,
        23.225665583764
    ],
    [
        112.98461833706,
        23.225667171967
    ],
    [
        112.98466608268,
        23.225681731827
    ],
    [
        112.98478463518,
        23.225713802686
    ],
    [
        112.98490644707,
        23.225740186093
    ],
    [
        112.98507928109,
        23.225754849297
    ],
    [
        112.98521006944,
        23.225752777502
    ],
    [
        112.98529040865,
        23.225729354839
    ],
    [
        112.98532950606,
        23.225704357703
    ],
    [
        112.98536480651,
        23.225677467763
    ],
    [
        112.98541153523,
        23.22561856383
    ],
    [
        112.98545122599,
        23.225543125419
    ],
    [
        112.98549337862,
        23.225447887668
    ],
    [
        112.98552384772,
        23.225368664261
    ],
    [
        112.98555540304,
        23.225288355842
    ],
    [
        112.98555704482,
        23.225274793795
    ],
    [
        112.98554728923,
        23.225263141018
    ],
    [
        112.98551176501,
        23.225244733171
    ],
    [
        112.98544041984,
        23.225232058983
    ],
    [
        112.98537964277,
        23.225231853408
    ],
    [
        112.98533839478,
        23.225237595311
    ],
    [
        112.98532293277,
        23.225233816207
    ],
    [
        112.98533270986,
        23.225224854978
    ],
    [
        112.98535291648,
        23.225099532932
    ],
    [
        112.9853693133,
        23.224985063903
    ],
    [
        112.98536934684,
        23.224952247467
    ],
    [
        112.98536719977,
        23.224929197027
    ],
    [
        112.98528341313,
        23.224875594555
    ],
    [
        112.98516166176,
        23.224798452417
    ],
    [
        112.98503882134,
        23.224722139199
    ],
    [
        112.98496913522,
        23.224672880503
    ],
    [
        112.98496941599,
        23.22466365895
    ],
    [
        112.98497702959,
        23.224648188683
    ],
    [
        112.98500941541,
        23.224554844997
    ],
    [
        112.98507032775,
        23.224426747221
    ],
    [
        112.98516091096,
        23.224205046088
    ],
    [
        112.98520498435,
        23.224090809763
    ],
    [
        112.98521448808,
        23.224084017475
    ],
    [
        112.9852063579,
        23.224074264207
    ],
    [
        112.9850354473,
        23.224040051071
    ],
    [
        112.98489899124,
        23.224007709345
    ],
    [
        112.98489249339,
        23.223993345336
    ],
    [
        112.98489955717,
        23.223984926828
    ],
    [
        112.98493630171,
        23.223875030312
    ],
    [
        112.98496550389,
        23.223710361827
    ],
    [
        112.98496742376,
        23.223690289417
    ],
    [
        112.98495875545,
        23.223675657034
    ],
    [
        112.98487466169,
        23.223650563849
    ],
    [
        112.98470050149,
        23.223599051415
    ],
    [
        112.98458248132,
        23.223575125284
    ],
    [
        112.98442267163,
        23.223546141571
    ],
    [
        112.98423300779,
        23.223513991253
    ],
    [
        112.98409787707,
        23.223492324805
    ],
    [
        112.98406777114,
        23.223473680794
    ],
    [
        112.98401707649,
        23.223417930421
    ],
    [
        112.98395396154,
        23.22329847814
    ],
    [
        112.98388331596,
        23.22311043212
    ],
    [
        112.98383325646,
        23.222961663683
    ],
    [
        112.98382573444,
        23.222885201555
    ],
    [
        112.98381797991,
        23.222770228224
    ],
    [
        112.98381429669,
        23.222654973308
    ],
    [
        112.98382034467,
        23.2225787478
    ],
    [
        112.98381993649,
        23.222445313389
    ],
    [
        112.98385586985,
        23.222338636681
    ],
    [
        112.98390486417,
        23.222198298664
    ],
    [
        112.98390839407,
        23.222196662679
    ],
    [
        112.98395026337,
        23.22212387569
    ],
    [
        112.98397308432,
        23.222100767562
    ],
    [
        112.9839782445,
        23.222097229402
    ],
    [
        112.98400539601,
        23.222085773596
    ],
    [
        112.9841126118,
        23.222071691952
    ],
    [
        112.98437531235,
        23.222073836464
    ],
    [
        112.98472402042,
        23.222078063123
    ],
    [
        112.98514785679,
        23.222092877127
    ],
    [
        112.98549409681,
        23.222072404011
    ],
    [
        112.98584762315,
        23.222068038518
    ],
    [
        112.98619272503,
        23.222054570814
    ],
    [
        112.98647053633,
        23.222033895541
    ],
    [
        112.98669841732,
        23.222017082114
    ],
    [
        112.98689536863,
        23.221997595217
    ],
    [
        112.98722768293,
        23.221955164764
    ],
    [
        112.98746069833,
        23.221924412833
    ],
    [
        112.98774797271,
        23.221866105397
    ],
    [
        112.9879842435,
        23.22181133239
    ],
    [
        112.9882503257,
        23.221764522179
    ],
    [
        112.98836124664,
        23.221755479025
    ],
    [
        112.98854484268,
        23.22174196696
    ],
    [
        112.98874769712,
        23.221715777736
    ],
    [
        112.9888960274,
        23.221705509386
    ],
    [
        112.98905060735,
        23.221677646889
    ],
    [
        112.98921196213,
        23.221648738111
    ],
    [
        112.98937251163,
        23.221606833051
    ],
    [
        112.98961062481,
        23.221534791085
    ],
    [
        112.98977849954,
        23.221475337746
    ],
    [
        112.98997215276,
        23.221385886335
    ],
    [
        112.99018346185,
        23.221253676379
    ],
    [
        112.99041018288,
        23.221152208682
    ],
    [
        112.9906076125,
        23.221058001176
    ],
    [
        112.99083513248,
        23.22095255596
    ],
    [
        112.99098182791,
        23.220892390275
    ],
    [
        112.99122669162,
        23.220772993286
    ],
    [
        112.99156746476,
        23.220672529056
    ],
    [
        112.9917848583,
        23.220626357106
    ],
    [
        112.99195699565,
        23.220571866657
    ],
    [
        112.99220175116,
        23.220517232558
    ],
    [
        112.99233211129,
        23.220497300397
    ],
    [
        112.992520731,
        23.220472545878
    ],
    [
        112.99276599781,
        23.220423461664
    ],
    [
        112.9929738406,
        23.220397806917
    ],
    [
        112.99328463803,
        23.220363322764
    ],
    [
        112.99350598452,
        23.220360900991
    ],
    [
        112.99391913192,
        23.220347580406
    ],
    [
        112.99418107725,
        23.220354509883
    ],
    [
        112.99448721588,
        23.220307299758
    ],
    [
        112.9947849269,
        23.220275023991
    ],
    [
        112.99496317219,
        23.220250321726
    ],
    [
        112.99511542315,
        23.220213512684
    ],
    [
        112.99539282036,
        23.220150044149
    ],
    [
        112.9957214006,
        23.220074039994
    ],
    [
        112.99589501643,
        23.220046455403
    ],
    [
        112.99612143837,
        23.220012835569
    ],
    [
        112.99635137503,
        23.21997603379
    ],
    [
        112.9966492636,
        23.219942593851
    ],
    [
        112.99680010101,
        23.219922527771
    ],
    [
        112.99692899733,
        23.219908516311
    ],
    [
        112.9970809063,
        23.219893104689
    ],
    [
        112.997367643,
        23.219876005606
    ],
    [
        112.99755933654,
        23.219862929791
    ],
    [
        112.99777862437,
        23.219863715094
    ],
    [
        112.99795242696,
        23.219862184326
    ],
    [
        112.99808967108,
        23.219868986383
    ],
    [
        112.99821959035,
        23.219889017838
    ],
    [
        112.99838578369,
        23.219905639005
    ],
    [
        112.99865724952,
        23.219943183685
    ],
    [
        112.99883235904,
        23.219964836857
    ],
    [
        112.99899365794,
        23.219988262613
    ],
    [
        112.99910624875,
        23.219995718601
    ],
    [
        112.99917498336,
        23.220010298804
    ],
    [
        112.99931702075,
        23.220070981005
    ],
    [
        112.99958273888,
        23.220134686191
    ],
    [
        112.99986548087,
        23.220214367412
    ],
    [
        113.00015173388,
        23.220289264949
    ],
    [
        113.00030730285,
        23.220328237507
    ],
    [
        113.00066983374,
        23.220417968313
    ],
    [
        113.00100556274,
        23.220502309472
    ],
    [
        113.00131935282,
        23.220592963859
    ],
    [
        113.00163961719,
        23.220689461613
    ],
    [
        113.00194524453,
        23.220799128625
    ],
    [
        113.00240371202,
        23.220913296741
    ],
    [
        113.002841032,
        23.22104684175
    ],
    [
        113.0034046253,
        23.221210713325
    ],
    [
        113.00394923797,
        23.221382101078
    ],
    [
        113.00437132986,
        23.221514203655
    ],
    [
        113.00479831364,
        23.2216022687
    ],
    [
        113.00529205255,
        23.221716099959
    ],
    [
        113.00561408118,
        23.221786527341
    ],
    [
        113.00591418894,
        23.22186210023
    ],
    [
        113.00617024226,
        23.221903957474
    ],
    [
        113.00658175065,
        23.221973192791
    ],
    [
        113.00691133008,
        23.222022785759
    ],
    [
        113.00722331157,
        23.222084355801
    ],
    [
        113.00765911626,
        23.222152004699
    ],
    [
        113.0080381427,
        23.222202276068
    ],
    [
        113.00834145559,
        23.222250293345
    ],
    [
        113.00869693936,
        23.222300554145
    ],
    [
        113.00896318899,
        23.222356988847
    ],
    [
        113.0092359146,
        23.222420607884
    ],
    [
        113.00944486549,
        23.222451461473
    ],
    [
        113.00973681449,
        23.222477205383
    ],
    [
        113.01003176074,
        23.222474007428
    ],
    [
        113.01041023911,
        23.222466281159
    ],
    [
        113.010757089,
        23.222450194004
    ],
    [
        113.01088630996,
        23.222445342219
    ],
    [
        113.01104798983,
        23.222419623377
    ],
    [
        113.011146406,
        23.222400964926
    ],
    [
        113.01119561703,
        23.222388517719
    ],
    [
        113.01132779114,
        23.222400818284
    ],
    [
        113.01160541143,
        23.222396369835
    ],
    [
        113.01185571161,
        23.222406655631
    ],
    [
        113.01209926301,
        23.222405176375
    ],
    [
        113.01229497355,
        23.222397725121
    ],
    [
        113.01243960037,
        23.22238478152
    ],
    [
        113.01259555566,
        23.222395092997
    ],
    [
        113.0127442013,
        23.222415858877
    ],
    [
        113.01293637027,
        23.222430881241
    ],
    [
        113.01294123258,
        23.22243394972
    ],
    [
        113.01297095576,
        23.222443691385
    ],
    [
        113.01318204916,
        23.222453629015
    ],
    [
        113.01332799834,
        23.222464870145
    ],
    [
        113.01341636915,
        23.222480797619
    ],
    [
        113.01355636541,
        23.222497363559
    ],
    [
        113.01384798404,
        23.222525284626
    ],
    [
        113.01395851896,
        23.222539711393
    ],
    [
        113.01417607882,
        23.222563896728
    ],
    [
        113.01443203185,
        23.222574935359
    ],
    [
        113.01466471758,
        23.222606994146
    ],
    [
        113.01486038247,
        23.222629721795
    ],
    [
        113.0150781881,
        23.22267427195
    ],
    [
        113.01523843569,
        23.222705597448
    ],
    [
        113.01540703748,
        23.222760940144
    ],
    [
        113.01570563961,
        23.222822123918
    ],
    [
        113.01593612779,
        23.222885081537
    ],
    [
        113.01614282593,
        23.222952769974
    ],
    [
        113.01636249118,
        23.223026656946
    ],
    [
        113.0165767458,
        23.223105329748
    ],
    [
        113.01675073611,
        23.223176233476
    ],
    [
        113.0169498348,
        23.223274705637
    ],
    [
        113.01708786607,
        23.223356901395
    ],
    [
        113.01725049802,
        23.223434381478
    ],
    [
        113.01740801137,
        23.223495496555
    ],
    [
        113.01745475174,
        23.223513957339
    ],
    [
        113.01755960553,
        23.223530197316
    ],
    [
        113.01776362297,
        23.223576948771
    ],
    [
        113.01792412845,
        23.223620212475
    ],
    [
        113.01813570122,
        23.223680382704
    ],
    [
        113.01831672778,
        23.223744889493
    ],
    [
        113.0186079978,
        23.223843620786
    ],
    [
        113.01887387266,
        23.223932130618
    ],
    [
        113.01919489062,
        23.224018892898
    ],
    [
        113.01954835838,
        23.224094278897
    ],
    [
        113.01978102411,
        23.224152610144
    ],
    [
        113.02001424106,
        23.224202263445
    ],
    [
        113.02022691041,
        23.224258328704
    ],
    [
        113.02047471841,
        23.224316896782
    ],
    [
        113.02064549643,
        23.224370587737
    ],
    [
        113.02084950994,
        23.224437596751
    ],
    [
        113.02103812668,
        23.2244956515
    ],
    [
        113.02123105413,
        23.224569232066
    ],
    [
        113.02131402093,
        23.224588292977
    ],
    [
        113.02133969757,
        23.224591447956
    ],
    [
        113.02134781963,
        23.224579112102
    ],
    [
        113.02135538526,
        23.224582225904
    ],
    [
        113.02139136622,
        23.224553826024
    ],
    [
        113.02144389589,
        23.22446739955
    ],
    [
        113.02147994385,
        23.224373637197
    ],
    [
        113.0214916521,
        23.224290846823
    ],
    [
        113.02149683599,
        23.224244015784
    ],
    [
        113.02150714498,
        23.224207850302
    ],
    [
        113.02150455102,
        23.224100946865
    ],
    [
        113.02150747723,
        23.223882397669
    ],
    [
        113.02151931406,
        23.223673223015
    ],
    [
        113.02154926706,
        23.223458935473
    ],
    [
        113.02157868217,
        23.223241655034
    ],
    [
        113.02162079563,
        23.223030559177
    ],
    [
        113.02165562733,
        23.222802522434
    ],
    [
        113.02166765496,
        23.222670375585
    ],
    [
        113.02166929739,
        23.222650062588
    ],
    [
        113.02167119781,
        23.22264195873
    ],
    [
        113.02165391058,
        23.222628914848
    ],
    [
        113.02154824681,
        23.222598621833
    ],
    [
        113.02142072015,
        23.222536488506
    ],
    [
        113.02131617437,
        23.222470950713
    ],
    [
        113.02128511505,
        23.222444378116
    ],
    [
        113.02127297465,
        23.222420844024
    ],
    [
        113.02125760339,
        23.222384506971
    ],
    [
        113.02122342056,
        23.222238544943
    ],
    [
        113.02120489553,
        23.222112651899
    ],
    [
        113.0212014556,
        23.222038821674
    ],
    [
        113.02121635413,
        23.222007617957
    ],
    [
        113.02124963445,
        23.221975917938
    ],
    [
        113.02132078261,
        23.221920461525
    ],
    [
        113.02142601811,
        23.221837655878
    ],
    [
        113.02150284795,
        23.221777683551
    ],
    [
        113.02161429577,
        23.221700675511
    ],
    [
        113.02173818894,
        23.221613571555
    ],
    [
        113.02184885948,
        23.221503997606
    ],
    [
        113.02192465108,
        23.221402231962
    ],
    [
        113.0219695925,
        23.221334111093
    ],
    [
        113.0220175525,
        23.221220748034
    ],
    [
        113.02210639671,
        23.221041633495
    ],
    [
        113.02224341512,
        23.220805838585
    ],
    [
        113.02236473784,
        23.220587129759
    ],
    [
        113.02248390844,
        23.220357802683
    ],
    [
        113.0225737836,
        23.220230224846
    ],
    [
        113.0226498727,
        23.220101869269
    ],
    [
        113.02271431891,
        23.219992571912
    ],
    [
        113.02276335707,
        23.219882199863
    ],
    [
        113.02284165184,
        23.219709668458
    ],
    [
        113.02294589855,
        23.219537571299
    ],
    [
        113.02300574863,
        23.219428733203
    ],
    [
        113.02305044343,
        23.21933672654
    ],
    [
        113.02308567928,
        23.219241577291
    ],
    [
        113.02312251338,
        23.219171135254
    ],
    [
        113.02318559446,
        23.219075908649
    ],
    [
        113.02329712145,
        23.218923991477
    ],
    [
        113.02339567082,
        23.218773481282
    ],
    [
        113.02342738475,
        23.218685863382
    ],
    [
        113.02347807175,
        23.21854675794
    ],
    [
        113.02355281155,
        23.218416187691
    ],
    [
        113.02362103571,
        23.218314527887
    ],
    [
        113.02368623332,
        23.218268958711
    ],
    [
        113.02376275498,
        23.218256392859
    ],
    [
        113.02389145307,
        23.218246584369
    ],
    [
        113.02394822298,
        23.21825185944
    ],
    [
        113.02401741614,
        23.218271441085
    ],
    [
        113.02412470634,
        23.218316598447
    ],
    [
        113.02416713217,
        23.218338720465
    ],
    [
        113.02422412907,
        23.218391185694
    ],
    [
        113.02426381982,
        23.218446892575
    ],
    [
        113.0242997397,
        23.218487620198
    ],
    [
        113.02434945986,
        23.218516096554
    ],
    [
        113.02437080864,
        23.218526751254
    ],
    [
        113.02440378868,
        23.218531628605
    ],
    [
        113.02443272055,
        23.21852884547
    ],
    [
        113.02448626559,
        23.218515885072
    ],
    [
        113.02463718676,
        23.218457854481
    ],
    [
        113.02481973537,
        23.218408462295
    ],
    [
        113.02503314039,
        23.218326734978
    ],
    [
        113.02516648165,
        23.218280866405
    ],
    [
        113.02534606028,
        23.218235184885
    ],
    [
        113.02552591279,
        23.218188680497
    ],
    [
        113.02566816692,
        23.218159469415
    ],
    [
        113.02581906628,
        23.218140149377
    ],
    [
        113.02601701629,
        23.218122369061
    ],
    [
        113.02612628277,
        23.218097766415
    ],
    [
        113.02627965257,
        23.218045907467
    ],
    [
        113.02645142635,
        23.217979404763
    ],
    [
        113.02671894958,
        23.217893472314
    ],
    [
        113.02692453474,
        23.217825821045
    ],
    [
        113.02709332262,
        23.217782545073
    ],
    [
        113.02716772345,
        23.21774813934
    ],
    [
        113.02719235271,
        23.217726813261
    ],
    [
        113.02720213351,
        23.21767814118
    ],
    [
        113.02719762715,
        23.217579891739
    ],
    [
        113.02718617889,
        23.21738444085
    ],
    [
        113.0271628584,
        23.217158705136
    ],
    [
        113.02717917613,
        23.217058328602
    ],
    [
        113.02718492588,
        23.216980846283
    ],
    [
        113.02717179393,
        23.216849648671
    ],
    [
        113.02716160855,
        23.216749143312
    ],
    [
        113.02716490594,
        23.216691423044
    ],
    [
        113.02719823197,
        23.216621950702
    ],
    [
        113.02723667932,
        23.216571269143
    ],
    [
        113.02728619792,
        23.2165391963
    ],
    [
        113.02735707666,
        23.216512324602
    ],
    [
        113.02747553558,
        23.216505418218
    ],
    [
        113.02758775925,
        23.216516854946
    ],
    [
        113.02761911316,
        23.216536577833
    ],
    [
        113.02767018829,
        23.216580189081
    ],
    [
        113.02770255304,
        23.21667885087
    ],
    [
        113.0277342998,
        23.21686239497
    ],
    [
        113.02775635599,
        23.216995076881
    ],
    [
        113.02778436113,
        23.217128388794
    ],
    [
        113.02782403398,
        23.217219562055
    ],
    [
        113.02784320621,
        23.217252120006
    ],
    [
        113.02787699194,
        23.217274857868
    ],
    [
        113.02790050216,
        23.217295816646
    ],
    [
        113.02791132565,
        23.217290009025
    ],
    [
        113.02793404278,
        23.217291156662
    ],
    [
        113.02796217697,
        23.217283704519
    ],
    [
        113.02803040501,
        23.21720415256
    ],
    [
        113.02805532184,
        23.21716627525
    ],
    [
        113.02806186335,
        23.217111042033
    ],
    [
        113.02805624818,
        23.217040442624
    ],
    [
        113.02805499224,
        23.216934648306
    ],
    [
        113.02802321106,
        23.216788266389
    ],
    [
        113.02800342831,
        23.216532215285
    ],
    [
        113.02800634792,
        23.216292227377
    ],
    [
        113.02801193444,
        23.216092961498
    ],
    [
        113.02803690656,
        23.215991347953
    ],
    [
        113.02807970076,
        23.215921456376
    ],
    [
        113.02810838967,
        23.215898550471
    ],
    [
        113.02816357275,
        23.21588823541
    ],
    [
        113.02825336072,
        23.215894694981
    ],
    [
        113.02865390984,
        23.215914301349
    ],
    [
        113.02870259606,
        23.215913912236
    ],
    [
        113.02872423715,
        23.2159106952
    ],
    [
        113.02876918874,
        23.215851667083
    ],
    [
        113.02881333879,
        23.21578150632
    ],
    [
        113.02884638026,
        23.215732884525
    ],
    [
        113.02888561621,
        23.215714726784
    ],
    [
        113.02896109881,
        23.21569491098
    ],
    [
        113.02901953892,
        23.215677835188
    ],
    [
        113.02906069798,
        23.215626611541
    ],
    [
        113.02909078092,
        23.215559500358
    ],
    [
        113.02910710697,
        23.215448528633
    ],
    [
        113.02912669193,
        23.21532214275
    ],
    [
        113.02917629069,
        23.215207839829
    ],
    [
        113.0292477889,
        23.215105775223
    ],
    [
        113.02927848444,
        23.21495459
    ],
    [
        113.0293327412,
        23.214769829246
    ],
    [
        113.02940406186,
        23.214557638618
    ],
    [
        113.0294417192,
        23.21448899865
    ],
    [
        113.02946608729,
        23.214461671222
    ],
    [
        113.02950641174,
        23.214438361092
    ],
    [
        113.02967061717,
        23.214428416556
    ],
    [
        113.02995952105,
        23.214433710677
    ],
    [
        113.03035636849,
        23.214448801148
    ],
    [
        113.03060306883,
        23.214482711295
    ],
    [
        113.03093767576,
        23.214552438789
    ],
    [
        113.03125823091,
        23.214618660757
    ],
    [
        113.03133397888,
        23.214630742751
    ],
    [
        113.03137728564,
        23.214611762873
    ],
    [
        113.03141736412,
        23.21457104315
    ],
    [
        113.03151405979,
        23.214449938338
    ],
    [
        113.03158391081,
        23.21439873868
    ],
    [
        113.03162235241,
        23.214375080086
    ],
    [
        113.03166023786,
        23.214369585568
    ],
    [
        113.03174627998,
        23.214372282226
    ],
    [
        113.03186476669,
        23.214406835903
    ],
    [
        113.03204029965,
        23.214501475103
    ],
    [
        113.03216583861,
        23.214521715695
    ],
    [
        113.03235741929,
        23.214527278553
    ],
    [
        113.03235903948,
        23.214531366316
    ],
    [
        113.03259580519,
        23.214551813001
    ],
    [
        113.0328398818,
        23.214576916376
    ],
    [
        113.03314510454,
        23.214632512142
    ],
    [
        113.0333818796,
        23.214673711145
    ],
    [
        113.03365034439,
        23.214697319628
    ],
    [
        113.03396374161,
        23.214731669043
    ],
    [
        113.03432043695,
        23.214796509259
    ],
    [
        113.0346963832,
        23.214847348043
    ],
    [
        113.03522447033,
        23.214926982917
    ],
    [
        113.03558530132,
        23.214986365144
    ],
    [
        113.03594830114,
        23.21506682027
    ],
    [
        113.03640744243,
        23.215151287345
    ],
    [
        113.03661158808,
        23.215175333868
    ],
    [
        113.03681030644,
        23.215220726319
    ],
    [
        113.03701255736,
        23.215259606944
    ],
    [
        113.03737947057,
        23.215297363533
    ],
    [
        113.03757986108,
        23.215317691087
    ],
    [
        113.03783741873,
        23.215322156316
    ],
    [
        113.03803075791,
        23.215371374145
    ],
    [
        113.03820353669,
        23.21539952352
    ],
    [
        113.03844133441,
        23.21542052591
    ],
    [
        113.03878854362,
        23.215480758167
    ],
    [
        113.03900658069,
        23.215512899387
    ],
    [
        113.03922356424,
        23.215520040324
    ],
    [
        113.0395448458,
        23.215542446838
    ],
    [
        113.0396821917,
        23.215556049504
    ],
    [
        113.03993548773,
        23.21558524802
    ],
    [
        113.04010427116,
        23.215600884812
    ],
    [
        113.04052796667,
        23.215693577707
    ],
    [
        113.04081082892,
        23.215733317631
    ],
    [
        113.04096363498,
        23.215766914747
    ],
    [
        113.04096685878,
        23.215798934919
    ],
    [
        113.04097871367,
        23.215877105802
    ],
    [
        113.04100654913,
        23.21596403548
    ],
    [
        113.04100518055,
        23.215979488163
    ],
    [
        113.04100679859,
        23.215988446493
    ],
    [
        113.0410042362,
        23.216128111739
    ],
    [
        113.04099711323,
        23.216215137536
    ],
    [
        113.0409440481,
        23.216464392387
    ],
    [
        113.04092064069,
        23.216578728289
    ],
    [
        113.04084975743,
        23.216752217773
    ],
    [
        113.04082524009,
        23.216894752533
    ],
    [
        113.04080537486,
        23.216986864153
    ],
    [
        113.04077868409,
        23.217134810848
    ],
    [
        113.04076396605,
        23.217228033239
    ],
    [
        113.0407212636,
        23.217401389329
    ],
    [
        113.04066397675,
        23.21752205028
    ],
    [
        113.04063658256,
        23.217550111408
    ],
    [
        113.04056689606,
        23.217600998393
    ],
    [
        113.04049642156,
        23.21762583989
    ],
    [
        113.04042488518,
        23.217627888861
    ],
    [
        113.0403874897,
        23.217630936755
    ],
    [
        113.04034221163,
        23.217661061159
    ],
    [
        113.04028008979,
        23.21773963679
    ],
    [
        113.04022091217,
        23.217857823461
    ],
    [
        113.04015277638,
        23.217994398254
    ],
    [
        113.04013047971,
        23.218078889492
    ],
    [
        113.04012305449,
        23.218196012303
    ],
    [
        113.04010531571,
        23.218331518035
    ],
    [
        113.04008359957,
        23.218374515462
    ],
    [
        113.04004184547,
        23.218404919475
    ],
    [
        113.03996436118,
        23.218399581712
    ],
    [
        113.03983973992,
        23.218389344867
    ],
    [
        113.0396831124,
        23.218421207339
    ],
    [
        113.0395760609,
        23.218460140067
    ],
    [
        113.03950068336,
        23.218525842738
    ],
    [
        113.03942394321,
        23.218601024312
    ],
    [
        113.03938461284,
        23.218651760998
    ],
    [
        113.03936316883,
        23.218696102521
    ],
    [
        113.03935066303,
        23.218742399874
    ],
    [
        113.03934677264,
        23.218845165727
    ],
    [
        113.03934611948,
        23.218962055671
    ],
    [
        113.03936019485,
        23.219257771839
    ],
    [
        113.03937213085,
        23.219522826377
    ],
    [
        113.03938926304,
        23.219736111778
    ],
    [
        113.03939563024,
        23.219875014821
    ],
    [
        113.03939850719,
        23.219981078369
    ],
    [
        113.03937867107,
        23.220042245614
    ],
    [
        113.03935670707,
        23.220062987761
    ],
    [
        113.03930628814,
        23.220093580079
    ],
    [
        113.0392290518,
        23.22012236733
    ],
    [
        113.03920329521,
        23.220143624098
    ],
    [
        113.03916965588,
        23.220192220919
    ],
    [
        113.03916038594,
        23.220252911738
    ],
    [
        113.03915869397,
        23.220320975455
    ],
    [
        113.03917351961,
        23.220396471193
    ],
    [
        113.03920858903,
        23.220547226462
    ],
    [
        113.03929617935,
        23.220733309809
    ],
    [
        113.03937667027,
        23.220976566927
    ],
    [
        113.03942336275,
        23.221153697771
    ],
    [
        113.03948619674,
        23.221444838769
    ],
    [
        113.03954795205,
        23.221730545018
    ],
    [
        113.03958594293,
        23.221939346122
    ],
    [
        113.03962586976,
        23.222108560731
    ],
    [
        113.03968369854,
        23.222257000876
    ],
    [
        113.03972722208,
        23.222352192771
    ],
    [
        113.03976881244,
        23.222483984976
    ],
    [
        113.03980280647,
        23.222626035734
    ],
    [
        113.0398056889,
        23.222722876196
    ],
    [
        113.03980349459,
        23.222749441773
    ],
    [
        113.03979047513,
        23.222764008361
    ],
    [
        113.03971293403,
        23.222818591541
    ],
    [
        113.03965653914,
        23.222860282197
    ],
    [
        113.03956217868,
        23.222938617751
    ],
    [
        113.0395163205,
        23.223010472093
    ],
    [
        113.03950219244,
        23.223050251195
    ],
    [
        113.03950184424,
        23.223126459782
    ],
    [
        113.03951230894,
        23.223226060925
    ],
    [
        113.03953389359,
        23.223313527387
    ],
    [
        113.03959205293,
        23.223400679795
    ],
    [
        113.03965158592,
        23.223469666486
    ],
    [
        113.03969569304,
        23.223522553776
    ],
    [
        113.0397503012,
        23.223639780825
    ],
    [
        113.03978536769,
        23.223791330752
    ],
    [
        113.03978141943,
        23.223943456914
    ],
    [
        113.03979554957,
        23.224167835207
    ],
    [
        113.03980258833,
        23.224438005203
    ],
    [
        113.03979378356,
        23.224569760966
    ],
    [
        113.03975132208,
        23.224761249744
    ],
    [
        113.03972410806,
        23.224879331912
    ],
    [
        113.0396944104,
        23.22504160572
    ],
    [
        113.03967423889,
        23.225161357236
    ],
    [
        113.03963481236,
        23.225299974004
    ],
    [
        113.03960189569,
        23.225431307255
    ],
    [
        113.03959615005,
        23.225486056274
    ],
    [
        113.03953322434,
        23.225556177379
    ],
    [
        113.03944294681,
        23.225616628772
    ],
    [
        113.03932125431,
        23.225668191349
    ],
    [
        113.03921636482,
        23.225715512098
    ],
    [
        113.03915456627,
        23.225747378997
    ],
    [
        113.03909624347,
        23.225824558192
    ],
    [
        113.03903084373,
        23.225935045965
    ],
    [
        113.03896215527,
        23.226083206228
    ],
    [
        113.03891927027,
        23.226165091763
    ],
    [
        113.03888209151,
        23.226230199686
    ],
    [
        113.03886008951,
        23.226288630513
    ],
    [
        113.03883557067,
        23.22642379661
    ],
    [
        113.03880613031,
        23.226603406948
    ],
    [
        113.03877991002,
        23.226812872245
    ],
    [
        113.03875128127,
        23.226993842922
    ],
    [
        113.03872748646,
        23.227215799734
    ],
    [
        113.03867882772,
        23.227382525561
    ],
    [
        113.03864679587,
        23.227449018254
    ],
    [
        113.03861887075,
        23.227473230036
    ],
    [
        113.03858337862,
        23.227480572224
    ],
    [
        113.03844279029,
        23.227486887141
    ],
    [
        113.03834933725,
        23.22749136092
    ],
    [
        113.03830625133,
        23.227509758901
    ],
    [
        113.03828454145,
        23.227549738674
    ],
    [
        113.03826166335,
        23.227672429202
    ],
    [
        113.03826654095,
        23.227934456398
    ],
    [
        113.03826291598,
        23.228300295304
    ],
    [
        113.03826813067,
        23.228498318963
    ],
    [
        113.03828850007,
        23.228709743684
    ],
    [
        113.0382737639,
        23.228817306591
    ],
    [
        113.03823874737,
        23.228891631455
    ],
    [
        113.03819589706,
        23.228945556095
    ],
    [
        113.03808017078,
        23.22901628991
    ],
    [
        113.0379649811,
        23.229094339263
    ],
    [
        113.03787795402,
        23.229179375122
    ],
    [
        113.03782369223,
        23.229271710595
    ],
    [
        113.03780790715,
        23.229346985356
    ],
    [
        113.03780179323,
        23.22950017326
    ],
    [
        113.03780462836,
        23.229642310976
    ],
    [
        113.03783692968,
        23.229839191015
    ],
    [
        113.03789440891,
        23.230046841479
    ],
    [
        113.03796218608,
        23.230249686044
    ],
    [
        113.03804621202,
        23.230455904359
    ],
    [
        113.03811831764,
        23.230666638045
    ],
    [
        113.03820446926,
        23.230917340266
    ],
    [
        113.03825680551,
        23.231127918655
    ],
    [
        113.0383129478,
        23.231325504465
    ],
    [
        113.03834211692,
        23.231410065681
    ],
    [
        113.03838723735,
        23.231524847083
    ],
    [
        113.03847993585,
        23.231735979869
    ],
    [
        113.03850479411,
        23.231798537731
    ],
    [
        113.03851400043,
        23.231801858295
    ],
    [
        113.03851942932,
        23.231790234954
    ],
    [
        113.03887300446,
        23.231711619709
    ],
    [
        113.03924149745,
        23.231637062692
    ],
    [
        113.03949809923,
        23.231587994592
    ],
    [
        113.03986067644,
        23.231509676014
    ],
    [
        113.04031298328,
        23.231411406895
    ],
    [
        113.04078511858,
        23.23130329594
    ],
    [
        113.04124266776,
        23.23118786524
    ],
    [
        113.04163789222,
        23.231100179511
    ],
    [
        113.04208220098,
        23.231016076569
    ],
    [
        113.04251707583,
        23.23091521645
    ],
    [
        113.0428844607,
        23.230838916227
    ],
    [
        113.04322962265,
        23.230780326905
    ],
    [
        113.04366161409,
        23.230674121124
    ],
    [
        113.04401307778,
        23.23060065387
    ],
    [
        113.04466541265,
        23.230406375722
    ],
    [
        113.04518680553,
        23.230241936031
    ],
    [
        113.04562387453,
        23.230101050935
    ],
    [
        113.04576332148,
        23.230066431302
    ],
    [
        113.04597442279,
        23.229989517359
    ],
    [
        113.04638005207,
        23.229886823576
    ],
    [
        113.04679439266,
        23.229785330065
    ],
    [
        113.04719652705,
        23.229713519067
    ],
    [
        113.04774521508,
        23.229637863224
    ],
    [
        113.04820495525,
        23.229560722537
    ],
    [
        113.04849972358,
        23.229497276143
    ],
    [
        113.04881487067,
        23.229425839637
    ],
    [
        113.0490613328,
        23.229392179426
    ],
    [
        113.04934147341,
        23.229347253556
    ],
    [
        113.04952363036,
        23.229314744864
    ],
    [
        113.04999162232,
        23.229282659185
    ],
    [
        113.05043601448,
        23.229272700445
    ],
    [
        113.05071020803,
        23.229273281136
    ],
    [
        113.05111038667,
        23.229280039235
    ],
    [
        113.05151684475,
        23.22928201341
    ],
    [
        113.05182445836,
        23.229316064081
    ],
    [
        113.05208483945,
        23.229349190954
    ],
    [
        113.0523286631,
        23.229386415186
    ],
    [
        113.05243918445,
        23.229393679347
    ],
    [
        113.05260264084,
        23.229425587231
    ],
    [
        113.05298632268,
        23.229498487685
    ],
    [
        113.05336894095,
        23.229574792091
    ],
    [
        113.05357372173,
        23.229596808183
    ],
    [
        113.05377632612,
        23.229629379746
    ],
    [
        113.05396047699,
        23.229650922251
    ],
    [
        113.05417099141,
        23.22966547162
    ],
    [
        113.05448174354,
        23.229695262088
    ],
    [
        113.05474471172,
        23.229709598838
    ],
    [
        113.05507426865,
        23.229712786342
    ],
    [
        113.05516582868,
        23.229715599218
    ],
    [
        113.05546742616,
        23.229715100451
    ],
    [
        113.05576685752,
        23.229722138624
    ],
    [
        113.05607063349,
        23.229747237327
    ],
    [
        113.05624671932,
        23.229753581539
    ],
    [
        113.05644207767,
        23.229787122148
    ],
    [
        113.05660183521,
        23.229826105798
    ],
    [
        113.05676430732,
        23.229872366978
    ],
    [
        113.05689361799,
        23.229927049803
    ],
    [
        113.05705579241,
        23.230006634917
    ],
    [
        113.05716334463,
        23.230082376627
    ],
    [
        113.05732603517,
        23.230196366016
    ],
    [
        113.05745232232,
        23.230296312964
    ],
    [
        113.05762395948,
        23.230441096063
    ],
    [
        113.05776869236,
        23.230585038425
    ],
    [
        113.05784553273,
        23.23066943463
    ],
    [
        113.05793803005,
        23.230863780187
    ],
    [
        113.05806359176,
        23.231159217018
    ],
    [
        113.05817971757,
        23.231379342314
    ],
    [
        113.05829751989,
        23.231556317933
    ],
    [
        113.05846666419,
        23.231773429903
    ],
    [
        113.05864510773,
        23.231938621285
    ],
    [
        113.05891405105,
        23.232140787187
    ],
    [
        113.05943355527,
        23.232471938771
    ],
    [
        113.05981367261,
        23.232742658623
    ],
    [
        113.06027506515,
        23.233066024662
    ],
    [
        113.06058781611,
        23.233311562967
    ],
    [
        113.06090955578,
        23.233557467846
    ],
    [
        113.0614191441,
        23.233899415341
    ],
    [
        113.06179233075,
        23.234140962752
    ],
    [
        113.062201982,
        23.23438438811
    ],
    [
        113.06257713552,
        23.234602129352
    ],
    [
        113.06286613128,
        23.234763445656
    ],
    [
        113.06328376603,
        23.234968251309
    ],
    [
        113.06372373215,
        23.235171016811
    ],
    [
        113.06408839636,
        23.235337038694
    ],
    [
        113.06439024922,
        23.235481645949
    ],
    [
        113.06464448335,
        23.235645062645
    ],
    [
        113.06481251155,
        23.235770101168
    ],
    [
        113.06490792829,
        23.235861468654
    ],
    [
        113.06494162727,
        23.235904642866
    ],
    [
        113.06500903013,
        23.235986107617
    ],
    [
        113.06503373358,
        23.236048667934
    ],
    [
        113.06503872313,
        23.236250649514
    ],
    [
        113.06502309498,
        23.236385400578
    ],
    [
        113.06500066905,
        23.236515911558
    ],
    [
        113.06497443923,
        23.236641053633
    ],
    [
        113.06495394265,
        23.236744414578
    ],
    [
        113.06491441814,
        23.236827982794
    ],
    [
        113.06488414995,
        23.236905448788
    ],
    [
        113.06487455263,
        23.236991292578
    ],
    [
        113.06486603891,
        23.237082816136
    ],
    [
        113.06484231026,
        23.237149880251
    ],
    [
        113.06480957376,
        23.237251248108
    ],
    [
        113.06478062399,
        23.237379139757
    ],
    [
        113.06475275639,
        23.237514880675
    ],
    [
        113.06473197931,
        23.237631804721
    ],
    [
        113.06471176014,
        23.237732989974
    ],
    [
        113.06465548043,
        23.238009631131
    ],
    [
        113.06460544135,
        23.238310048409
    ],
    [
        113.06457073373,
        23.238497688746
    ],
    [
        113.06455183364,
        23.238653097636
    ],
    [
        113.06452910667,
        23.238831615114
    ],
    [
        113.06448161394,
        23.239021065464
    ],
    [
        113.06441999616,
        23.239184408712
    ],
    [
        113.06439682649,
        23.239239797722
    ],
    [
        113.06427646809,
        23.239374412263
    ],
    [
        113.06410740103,
        23.239525439057
    ],
    [
        113.06384717753,
        23.239707562237
    ],
    [
        113.06370291031,
        23.239814808625
    ],
    [
        113.06361879653,
        23.239883239464
    ],
    [
        113.0635689585,
        23.239954175918
    ],
    [
        113.06354325424,
        23.240126485798
    ],
    [
        113.06356526077,
        23.240521894778
    ],
    [
        113.06355905449,
        23.240818156086
    ],
    [
        113.06356033982,
        23.240919304642
    ],
    [
        113.06355053336,
        23.240937069753
    ],
    [
        113.06351979626,
        23.240932883554
    ],
    [
        113.063473856,
        23.240887137935
    ],
    [
        113.06341544752,
        23.240780808509
    ],
    [
        113.06338862408,
        23.24063634386
    ],
    [
        113.06338492279,
        23.240493731503
    ],
    [
        113.06337232417,
        23.240247363294
    ],
    [
        113.06336790555,
        23.239979185565
    ],
    [
        113.06337887875,
        23.239860511276
    ],
    [
        113.06341326296,
        23.23972171632
    ],
    [
        113.06347022004,
        23.239591560297
    ],
    [
        113.06349119577,
        23.239554656424
    ],
    [
        113.06350812849,
        23.239470344513
    ],
    [
        113.06348723261,
        23.239406082255
    ],
    [
        113.06343425058,
        23.239324632104
    ],
    [
        113.06338669056,
        23.239267244528
    ],
    [
        113.06324720197,
        23.239188872516
    ],
    [
        113.06305899349,
        23.239148577521
    ],
    [
        113.06284983688,
        23.23911749274
    ],
    [
        113.06265263807,
        23.239106292995
    ],
    [
        113.06253920099,
        23.239119730246
    ],
    [
        113.06243687266,
        23.239189156004
    ],
    [
        113.06229588588,
        23.239304374822
    ],
    [
        113.06223597193,
        23.239398998989
    ],
    [
        113.06215807377,
        23.23953616501
    ],
    [
        113.06211065044,
        23.239659643069
    ],
    [
        113.06203843504,
        23.239837141868
    ],
    [
        113.06197410398,
        23.240021045509
    ],
    [
        113.06190979086,
        23.240183791244
    ],
    [
        113.0618185143,
        23.240397868916
    ],
    [
        113.06173695634,
        23.240712441856
    ],
    [
        113.06166962861,
        23.240914273177
    ],
    [
        113.06157566772,
        23.241091756677
    ],
    [
        113.06153321133,
        23.241131619093
    ],
    [
        113.0614994765,
        23.241146418174
    ],
    [
        113.06126666455,
        23.241162344179
    ],
    [
        113.06104145959,
        23.241198754292
    ],
    [
        113.0608451034,
        23.241213354234
    ],
    [
        113.06061530682,
        23.241224803161
    ],
    [
        113.06035369188,
        23.241250695527
    ],
    [
        113.06020573848,
        23.241289319791
    ],
    [
        113.05998570103,
        23.241370259991
    ],
    [
        113.05986274777,
        23.241440835994
    ],
    [
        113.05981023838,
        23.241485103715
    ],
    [
        113.05976177866,
        23.241570278436
    ],
    [
        113.05972521118,
        23.241756754946
    ],
    [
        113.05964797173,
        23.24217396237
    ],
    [
        113.05961793499,
        23.242360092015
    ],
    [
        113.05959560083,
        23.242416759064
    ],
    [
        113.05957490896,
        23.242457676119
    ],
    [
        113.05951861302,
        23.242478379182
    ],
    [
        113.05945062991,
        23.242493785931
    ],
    [
        113.05932312463,
        23.242479743298
    ],
    [
        113.05891369475,
        23.242457634599
    ],
    [
        113.05848633283,
        23.242457831224
    ],
    [
        113.05818049575,
        23.242477267708
    ],
    [
        113.0580657684,
        23.242496608258
    ],
    [
        113.05802524738,
        23.242523327601
    ],
    [
        113.05799015407,
        23.242563552383
    ],
    [
        113.05797190695,
        23.24261472708
    ],
    [
        113.05797099807,
        23.242753605038
    ],
    [
        113.0579593715,
        23.243069974688
    ],
    [
        113.0579134498,
        23.243462904983
    ],
    [
        113.05788584913,
        23.243693184683
    ],
    [
        113.05787900264,
        23.243774079903
    ],
    [
        113.05786349531,
        23.243795390865
    ],
    [
        113.05784065166,
        23.24381216388
    ],
    [
        113.05781346876,
        23.243813248282
    ],
    [
        113.05775176363,
        23.243816301769
    ],
    [
        113.05761504455,
        23.24380924011
    ],
    [
        113.05737315321,
        23.243780938007
    ],
    [
        113.05706632756,
        23.243729874657
    ],
    [
        113.05681115586,
        23.243677179993
    ],
    [
        113.05661195436,
        23.243663530439
    ],
    [
        113.05630296993,
        23.243648646291
    ],
    [
        113.05612061567,
        23.243662978687
    ],
    [
        113.05594698256,
        23.24364574756
    ],
    [
        113.05569754992,
        23.243615830979
    ],
    [
        113.05557636324,
        23.243611402775
    ],
    [
        113.05547852466,
        23.243641762566
    ],
    [
        113.05545948835,
        23.243667140921
    ],
    [
        113.05544995045,
        23.243711157315
    ],
    [
        113.05544443991,
        23.243832442051
    ],
    [
        113.0554589624,
        23.244074534598
    ],
    [
        113.05547891183,
        23.24433312878
    ],
    [
        113.05550400318,
        23.244631824052
    ],
    [
        113.05552182329,
        23.244825068797
    ],
    [
        113.05555784884,
        23.245021148825
    ],
    [
        113.05561234078,
        23.245239860532
    ],
    [
        113.05567551433,
        23.245488063276
    ],
    [
        113.05570699428,
        23.245561579074
    ],
    [
        113.05573605459,
        23.245588461661
    ],
    [
        113.05582408892,
        23.245601017992
    ],
    [
        113.05594419614,
        23.245601904744
    ],
    [
        113.05601374471,
        23.245633319254
    ],
    [
        113.05605258324,
        23.245671502824
    ],
    [
        113.05607346724,
        23.245745913732
    ],
    [
        113.05610381295,
        23.245913277051
    ],
    [
        113.05610805357,
        23.2461163969
    ],
    [
        113.05609952324,
        23.246320983228
    ],
    [
        113.05608099566,
        23.246416346869
    ],
    [
        113.05606738803,
        23.246456335589
    ],
    [
        113.05602117453,
        23.246489822
    ],
    [
        113.05592386779,
        23.246536216839
    ],
    [
        113.05577712098,
        23.246555350935
    ],
    [
        113.0557257602,
        23.246562559068
    ],
    [
        113.05571950384,
        23.246575630395
    ],
    [
        113.0557099608,
        23.246640535459
    ],
    [
        113.05569283073,
        23.246662918791
    ],
    [
        113.0556751574,
        23.246685035135
    ],
    [
        113.05560613064,
        23.246701877307
    ],
    [
        113.05552107552,
        23.246713963667
    ],
    [
        113.05539282003,
        23.246723679051
    ],
    [
        113.05537244045,
        23.246725741052
    ],
    [
        113.05503715649,
        23.246723496484
    ],
    [
        113.05466603522,
        23.246710303855
    ],
    [
        113.05450302669,
        23.246715027867
    ],
    [
        113.0544204284,
        23.246735697979
    ],
    [
        113.05431174202,
        23.246775535044
    ],
    [
        113.05422423769,
        23.246834742313
    ],
    [
        113.05417041458,
        23.24690564242
    ],
    [
        113.05416795592,
        23.246933868521
    ],
    [
        113.05416875299,
        23.246970751514
    ],
    [
        113.0541804013,
        23.247039022341
    ],
    [
        113.05422788689,
        23.247153423126
    ],
    [
        113.05436010499,
        23.247327162662
    ],
    [
        113.0544467136,
        23.247442630416
    ],
    [
        113.05453602954,
        23.247583026363
    ],
    [
        113.05466685694,
        23.247853575834
    ],
    [
        113.05478031873,
        23.248087353262
    ],
    [
        113.05482563619,
        23.248214495991
    ],
    [
        113.05485899948,
        23.248343897782
    ],
    [
        113.05488936269,
        23.248503700931
    ],
    [
        113.05489849557,
        23.248762940823
    ],
    [
        113.05489646459,
        23.249094960131
    ],
    [
        113.05489773141,
        23.249339614205
    ],
    [
        113.05488841801,
        23.249548544845
    ],
    [
        113.05487642808,
        23.24964845483
    ],
    [
        113.05484215034,
        23.249776472126
    ],
    [
        113.0548075833,
        23.24995955412
    ],
    [
        113.05478167679,
        23.250251341138
    ],
    [
        113.05478783596,
        23.250535835299
    ],
    [
        113.05478537978,
        23.250571658734
    ],
    [
        113.05479159147,
        23.250694216996
    ],
    [
        113.05477906371,
        23.2507957588
    ],
    [
        113.05474344437,
        23.250893404861
    ],
    [
        113.05468200912,
        23.251014840955
    ],
    [
        113.05463171341,
        23.251138904288
    ],
    [
        113.0546178308,
        23.251237199887
    ],
    [
        113.05460775252,
        23.25133438239
    ],
    [
        113.05460092205,
        23.251480908943
    ],
    [
        113.05462208215,
        23.251601460373
    ],
    [
        113.05466335604,
        23.251687413427
    ],
    [
        113.05476983093,
        23.251789966473
    ],
    [
        113.05487902822,
        23.251880011777
    ],
    [
        113.05495481005,
        23.25196731986
    ],
    [
        113.05499419238,
        23.252025879638
    ],
    [
        113.05502786021,
        23.252125441711
    ],
    [
        113.05506152423,
        23.252245618341
    ],
    [
        113.05510333654,
        23.252383362372
    ],
    [
        113.05512722684,
        23.252476759255
    ],
    [
        113.05512502745,
        23.252603452827
    ],
    [
        113.05510409512,
        23.252660037217
    ],
    [
        113.05507610398,
        23.252690092984
    ],
    [
        113.05503833425,
        23.252707745957
    ],
    [
        113.05501007568,
        23.252717729305
    ],
    [
        113.0549497588,
        23.252719277681
    ],
    [
        113.05486499017,
        23.252721551273
    ],
    [
        113.05478022695,
        23.252702389571
    ],
    [
        113.05459358839,
        23.252664716646
    ],
    [
        113.05447894524,
        23.252644939207
    ],
    [
        113.05438087767,
        23.252617436633
    ],
    [
        113.05427248349,
        23.252615497208
    ],
    [
        113.05421135706,
        23.252628406578
    ],
    [
        113.05418174248,
        23.252647059946
    ],
    [
        113.05414506194,
        23.2526812235
    ],
    [
        113.05413690491,
        23.252718713751
    ],
    [
        113.05412711542,
        23.252769778148
    ],
    [
        113.05412737779,
        23.25281860249
    ],
    [
        113.05414012317,
        23.252939494179
    ],
    [
        113.05415829307,
        23.253114328211
    ],
    [
        113.05417645823,
        23.253328494757
    ],
    [
        113.0541905441,
        23.253588804175
    ],
    [
        113.05418997217,
        23.253788997495
    ],
    [
        113.05416441549,
        23.253944608391
    ],
    [
        113.0541475547,
        23.254088222873
    ],
    [
        113.05413476683,
        23.254258935061
    ],
    [
        113.05409780499,
        23.254412454682
    ],
    [
        113.05406030359,
        23.254542648612
    ],
    [
        113.05403611384,
        23.25467763267
    ],
    [
        113.05398095375,
        23.254852975529
    ],
    [
        113.05392905765,
        23.254999811319
    ],
    [
        113.05386494088,
        23.255120957426
    ],
    [
        113.05376252239,
        23.255275721058
    ],
    [
        113.05363321269,
        23.255484362557
    ],
    [
        113.05346615279,
        23.25567966897
    ],
    [
        113.05336537716,
        23.255790442993
    ],
    [
        113.05333088015,
        23.255837046577
    ],
    [
        113.05333006426,
        23.255875028926
    ],
    [
        113.05334147129,
        23.255912663224
    ],
    [
        113.05340285539,
        23.256008303814
    ],
    [
        113.05351503432,
        23.256134268451
    ],
    [
        113.05368806216,
        23.256318959406
    ],
    [
        113.05385104634,
        23.256503963896
    ],
    [
        113.05399176131,
        23.256665498377
    ],
    [
        113.05409526396,
        23.256812355165
    ],
    [
        113.05414932683,
        23.256930252234
    ],
    [
        113.05420963814,
        23.257020433547
    ],
    [
        113.05428896674,
        23.257103966501
    ],
    [
        113.05440008281,
        23.257203542116
    ],
    [
        113.05453782503,
        23.257288535694
    ],
    [
        113.05466959397,
        23.25737437152
    ],
    [
        113.05481114696,
        23.257457406387
    ],
    [
        113.0549287929,
        23.257513209046
    ],
    [
        113.05505105927,
        23.257553230692
    ],
    [
        113.05510784518,
        23.257557401354
    ],
    [
        113.05515729511,
        23.257554302473
    ],
    [
        113.05519614757,
        23.257530668318
    ],
    [
        113.05526162559,
        23.257470200848
    ],
    [
        113.05535237308,
        23.257395150846
    ],
    [
        113.05539829114,
        23.257362230547
    ],
    [
        113.05543089654,
        23.257350303675
    ],
    [
        113.05546404666,
        23.257358445548
    ],
    [
        113.05548877499,
        23.257391340426
    ],
    [
        113.05550018859,
        23.257414848434
    ],
    [
        113.05549285534,
        23.257469433354
    ],
    [
        113.05546677284,
        23.25751223408
    ],
    [
        113.0553972173,
        23.257578442121
    ],
    [
        113.05531135939,
        23.257635010282
    ],
    [
        113.055244792,
        23.257660223863
    ],
    [
        113.05510894033,
        23.257680007499
    ],
    [
        113.05505134003,
        23.257686151509
    ],
    [
        113.05503829812,
        23.257681912059
    ],
    [
        113.05496602634,
        23.257680298433
    ],
    [
        113.05491223106,
        23.257685050213
    ],
    [
        113.05486115201,
        23.257673231415
    ],
    [
        113.05476660071,
        23.257623488158
    ],
    [
        113.05459163111,
        23.25753445491
    ],
    [
        113.05445796225,
        23.257461373763
    ],
    [
        113.05434956367,
        23.257421734681
    ],
    [
        113.05430093493,
        23.257412858281
    ],
    [
        113.05426670548,
        23.257416898983
    ],
    [
        113.05422568623,
        23.257447571099
    ],
    [
        113.05418548413,
        23.257508075872
    ],
    [
        113.05416755712,
        23.257547807038
    ],
    [
        113.05416131096,
        23.257578504376
    ],
    [
        113.0541988019,
        23.257608081466
    ],
    [
        113.05427269761,
        23.257661814361
    ],
    [
        113.05433599779,
        23.257692831546
    ],
    [
        113.0543854456,
        23.2577510721
    ],
    [
        113.05441696205,
        23.257787467007
    ],
    [
        113.05443951661,
        23.257861903993
    ],
    [
        113.05442593807,
        23.257922767045
    ],
    [
        113.0543987785,
        23.258009227382
    ],
    [
        113.0543216359,
        23.258129682386
    ],
    [
        113.05426513681,
        23.258203598792
    ],
    [
        113.05429339346,
        23.258239477718
    ],
    [
        113.05436104762,
        23.2583290579
    ],
    [
        113.05442082171,
        23.258392648874
    ],
    [
        113.05453059276,
        23.2585258614
    ],
    [
        113.0546042272,
        23.258608331139
    ],
    [
        113.05465884308,
        23.258674118502
    ],
    [
        113.05474986895,
        23.258766216206
    ],
    [
        113.05484687478,
        23.258864772404
    ],
    [
        113.05492105863,
        23.258950745308
    ],
    [
        113.05499415657,
        23.259033466747
    ],
    [
        113.05507812492,
        23.259123423918
    ],
    [
        113.0552025822,
        23.259232860636
    ],
    [
        113.05530720404,
        23.259319112785
    ],
    [
        113.05537840286,
        23.259379852934
    ],
    [
        113.05548330232,
        23.259478566537
    ],
    [
        113.05555776941,
        23.259568025206
    ],
    [
        113.05561348324,
        23.259626436515
    ],
    [
        113.05565995338,
        23.259653182061
    ],
    [
        113.05572679219,
        23.259614379054
    ],
    [
        113.05580368527,
        23.259571147941
    ],
    [
        113.05590503153,
        23.25950166316
    ],
    [
        113.05601670645,
        23.259434523459
    ],
    [
        113.05613490339,
        23.259353211027
    ],
    [
        113.05625066028,
        23.259291440585
    ],
    [
        113.05629767104,
        23.259271497661
    ],
    [
        113.05633245356,
        23.259255187102
    ],
    [
        113.05637484283,
        23.259220904231
    ],
    [
        113.05640663223,
        23.25917694783
    ],
    [
        113.05646668248,
        23.259113207633
    ],
    [
        113.05653678384,
        23.259014108784
    ],
    [
        113.05660553159,
        23.258943230973
    ],
    [
        113.05664955359,
        23.258906211448
    ],
    [
        113.05671586138,
        23.258867631509
    ],
    [
        113.05676178952,
        23.258851207671
    ],
    [
        113.0568321785,
        23.258836185307
    ],
    [
        113.05687185718,
        23.258824697831
    ],
    [
        113.05694496595,
        23.258814527073
    ],
    [
        113.05702704461,
        23.258803997069
    ],
    [
        113.05714337307,
        23.258813213522
    ],
    [
        113.05724393881,
        23.258818500279
    ],
    [
        113.05732547987,
        23.258823418898
    ],
    [
        113.05738636479,
        23.258828802544
    ],
    [
        113.05746818136,
        23.258847273237
    ],
    [
        113.05757989831,
        23.25886436181
    ],
    [
        113.05768645231,
        23.258878507619
    ],
    [
        113.05778349547,
        23.258901148712
    ],
    [
        113.057857978,
        23.258919938938
    ],
    [
        113.05793681131,
        23.258943021645
    ],
    [
        113.0580050422,
        23.258952371665
    ],
    [
        113.05805560347,
        23.258954030366
    ],
    [
        113.05810752401,
        23.258953503095
    ],
    [
        113.05814259066,
        23.258950704345
    ],
    [
        113.05818717215,
        23.258949706243
    ],
    [
        113.05824099593,
        23.258944000017
    ],
    [
        113.05829536999,
        23.258981690052
    ],
    [
        113.05836034391,
        23.259000550016
    ],
    [
        113.05843075542,
        23.25901880763
    ],
    [
        113.05849029167,
        23.259023882848
    ],
    [
        113.05857075996,
        23.259019240672
    ],
    [
        113.05863056443,
        23.258990126085
    ],
    [
        113.05869607767,
        23.258954708924
    ],
    [
        113.05876403498,
        23.258894576456
    ],
    [
        113.0588058995,
        23.258874868737
    ],
    [
        113.05886271688,
        23.258853914145
    ],
    [
        113.0589168189,
        23.25885387466
    ],
    [
        113.05898288498,
        23.258862655646
    ],
    [
        113.05904542154,
        23.258901854681
    ],
    [
        113.05910741631,
        23.258950280172
    ],
    [
        113.05915962481,
        23.259003693107
    ],
    [
        113.05920775451,
        23.259049553198
    ],
    [
        113.05925044374,
        23.259073498235
    ],
    [
        113.05927627525,
        23.259090032431
    ],
    [
        113.05933718147,
        23.259114316129
    ],
    [
        113.05938612209,
        23.259118655807
    ],
    [
        113.05946469921,
        23.259122120333
    ],
    [
        113.05958569325,
        23.259126188499
    ],
    [
        113.05971103872,
        23.259122601104
    ],
    [
        113.05981082857,
        23.259127975523
    ],
    [
        113.05989919789,
        23.259121809223
    ],
    [
        113.05998566601,
        23.259122712567
    ],
    [
        113.06004875035,
        23.259123339294
    ],
    [
        113.06014065753,
        23.259116303211
    ],
    [
        113.06020918032,
        23.259107636107
    ],
    [
        113.0602719941,
        23.259103915778
    ],
    [
        113.06036471712,
        23.259077595222
    ],
    [
        113.06045444991,
        23.259049676594
    ],
    [
        113.06053113153,
        23.259025434692
    ],
    [
        113.06070407685,
        23.258975346875
    ],
    [
        113.06085472774,
        23.258932020288
    ],
    [
        113.06097845914,
        23.258892534348
    ],
    [
        113.0611215009,
        23.258847646201
    ],
    [
        113.06125829242,
        23.258817470954
    ],
    [
        113.06147286523,
        23.258755112555
    ],
    [
        113.06157757053,
        23.258725853603
    ],
    [
        113.06159633614,
        23.258721276303
    ],
    [
        113.06162842641,
        23.258699982482
    ],
    [
        113.06168254622,
        23.258672711921
    ],
    [
        113.06173829555,
        23.258623445483
    ],
    [
        113.06178398172,
        23.258571050126
    ],
    [
        113.06182014772,
        23.258508737943
    ],
    [
        113.06186148169,
        23.258445545003
    ],
    [
        113.06190254611,
        23.258399987296
    ],
    [
        113.06192674866,
        23.258363054666
    ],
    [
        113.06197624516,
        23.25831657295
    ],
    [
        113.06203689266,
        23.258260722458
    ],
    [
        113.06210678976,
        23.258216414635
    ],
    [
        113.06214812811,
        23.258171660937
    ],
    [
        113.06218647498,
        23.258128301466
    ],
    [
        113.06222264485,
        23.258071405799
    ],
    [
        113.06223134373,
        23.258018936735
    ],
    [
        113.06225010629,
        23.257962267308
    ],
    [
        113.06225934824,
        23.257895413624
    ],
    [
        113.06225770982,
        23.257820292522
    ],
    [
        113.06224437583,
        23.257745324062
    ],
    [
        113.06222805012,
        23.25766930946
    ],
    [
        113.06221825439,
        23.257617352896
    ],
    [
        113.06221253661,
        23.25753414698
    ],
    [
        113.06221198878,
        23.257476644581
    ],
    [
        113.06221606515,
        23.257420438355
    ],
    [
        113.06222150259,
        23.25737967687
    ],
    [
        113.06223918006,
        23.257340383462
    ],
    [
        113.06226447385,
        23.257305602071
    ],
    [
        113.062301735,
        23.257257100301
    ],
    [
        113.06236537956,
        23.257188991632
    ],
    [
        113.06244452789,
        23.257094091981
    ],
    [
        113.06247743821,
        23.257042388311
    ],
    [
        113.06252884511,
        23.256986370574
    ],
    [
        113.06258786839,
        23.256920484614
    ],
    [
        113.06268524453,
        23.256807156819
    ],
    [
        113.06281662535,
        23.256726191851
    ],
    [
        113.06296542008,
        23.256732330404
    ],
    [
        113.06303261155,
        23.256797612784
    ],
    [
        113.06324017264,
        23.256921476001
    ],
    [
        113.06342679336,
        23.257055367958
    ],
    [
        113.06359464659,
        23.257155048629
    ],
    [
        113.06380766227,
        23.257226141879
    ],
    [
        113.06390369692,
        23.257238360899
    ],
    [
        113.06398721791,
        23.257246953105
    ],
    [
        113.06409250396,
        23.25724845217
    ],
    [
        113.06418037872,
        23.257238256172
    ],
    [
        113.06431749594,
        23.25718774903
    ],
    [
        113.06454439779,
        23.257116411248
    ],
    [
        113.06484286064,
        23.256997890873
    ],
    [
        113.06508038668,
        23.256900292184
    ],
    [
        113.06532662576,
        23.256787615805
    ],
    [
        113.06547410032,
        23.256714899396
    ],
    [
        113.06580143746,
        23.256552129197
    ],
    [
        113.06585504266,
        23.256537488405
    ],
    [
        113.06588279797,
        23.256541682045
    ],
    [
        113.06596089371,
        23.256526126894
    ],
    [
        113.06602837754,
        23.256506931686
    ],
    [
        113.06609885517,
        23.256491215385
    ],
    [
        113.06617042146,
        23.256454049984
    ],
    [
        113.06624579806,
        23.256421706951
    ],
    [
        113.0662953236,
        23.256381617877
    ],
    [
        113.06632743365,
        23.256344235185
    ],
    [
        113.06636226518,
        23.256319831268
    ],
    [
        113.06638621201,
        23.256313768327
    ],
    [
        113.06642022753,
        23.256311077389
    ],
    [
        113.06646567246,
        23.256312008375
    ],
    [
        113.06649941627,
        23.256332649395
    ],
    [
        113.06652798973,
        23.256346858932
    ],
    [
        113.06659438911,
        23.256354789345
    ],
    [
        113.06664854303,
        23.256362364112
    ],
    [
        113.06669371672,
        23.256352986374
    ],
    [
        113.06674705463,
        23.256348906813
    ],
    [
        113.06684039648,
        23.256325488438
    ],
    [
        113.06692938494,
        23.256299421212
    ],
    [
        113.0669772812,
        23.256289724173
    ],
    [
        113.06702789911,
        23.256285409052
    ],
    [
        113.06707688446,
        23.256291969012
    ],
    [
        113.06713866081,
        23.25631080624
    ],
    [
        113.06715934374,
        23.256320790857
    ],
    [
        113.0671587995,
        23.256326767266
    ],
    [
        113.06717757776,
        23.256366621
    ],
    [
        113.06719717325,
        23.256456917687
    ],
    [
        113.06721704123,
        23.25654069959
    ],
    [
        113.06724262517,
        23.256644465661
    ],
    [
        113.06727501532,
        23.25680807527
    ],
    [
        113.06731039964,
        23.256948037225
    ],
    [
        113.0673324487,
        23.257063251714
    ],
    [
        113.06735667577,
        23.257179788245
    ],
    [
        113.06738117426,
        23.257270820947
    ],
    [
        113.0674111111,
        23.257278216326
    ],
    [
        113.06749030672,
        23.257275610901
    ],
    [
        113.0676122302,
        23.257259305468
    ],
    [
        113.06776735798,
        23.257240024686
    ],
    [
        113.06791759025,
        23.257244684153
    ],
    [
        113.06804741171,
        23.257243151072
    ],
    [
        113.06814321312,
        23.257231306833
    ],
    [
        113.06824826923,
        23.257223650455
    ],
    [
        113.06829263217,
        23.257213441719
    ],
    [
        113.06836285056,
        23.257186810196
    ],
    [
        113.06842354437,
        23.257179048407
    ],
    [
        113.06849022657,
        23.257176613742
    ],
    [
        113.06853622417,
        23.257180209282
    ],
    [
        113.06863611269,
        23.257182386984
    ],
    [
        113.06878254514,
        23.257194382752
    ],
    [
        113.06887073209,
        23.257203253032
    ],
    [
        113.06896762936,
        23.257210079189
    ],
    [
        113.06909501171,
        23.257210434263
    ],
    [
        113.06917775672,
        23.257215857758
    ],
    [
        113.06920361452,
        23.257215432815
    ],
    [
        113.0692248451,
        23.25721399866
    ],
    [
        113.06924852454,
        23.257197332895
    ],
    [
        113.06925233274,
        23.257153324378
    ],
    [
        113.06927138249,
        23.257087363383
    ],
    [
        113.06928743755,
        23.257002733989
    ],
    [
        113.06931819055,
        23.256901314986
    ],
    [
        113.06934050766,
        23.256838012602
    ],
    [
        113.06938323763,
        23.256722832202
    ],
    [
        113.06943304564,
        23.256616215065
    ],
    [
        113.06946679638,
        23.256571440646
    ],
    [
        113.06951361269,
        23.256531332607
    ],
    [
        113.06954382568,
        23.256506689769
    ],
    [
        113.06958029964,
        23.256502830618
    ],
    [
        113.06964344899,
        23.256505581745
    ],
    [
        113.06973272962,
        23.256512780422
    ],
    [
        113.06978471955,
        23.256519240555
    ],
    [
        113.06983453219,
        23.25653143272
    ],
    [
        113.06989387255,
        23.25656760828
    ],
    [
        113.06997036225,
        23.256617331356
    ],
    [
        113.07001554854,
        23.25664533154
    ],
    [
        113.07003215394,
        23.256681404237
    ],
    [
        113.07005202636,
        23.25673315589
    ],
    [
        113.0700705373,
        23.256766483892
    ],
    [
        113.07013287387,
        23.256818881299
    ],
    [
        113.07020555474,
        23.256873545674
    ],
    [
        113.07028667392,
        23.256914503423
    ],
    [
        113.07035527127,
        23.256938579667
    ],
    [
        113.07044564583,
        23.256965543407
    ],
    [
        113.07054500372,
        23.256989369445
    ],
    [
        113.07065987876,
        23.257021340083
    ],
    [
        113.07074399361,
        23.257038364991
    ],
    [
        113.07080660403,
        23.257058736037
    ],
    [
        113.07087248033,
        23.257060604303
    ],
    [
        113.07093073519,
        23.257070196261
    ],
    [
        113.07102356265,
        23.257093035071
    ],
    [
        113.07109515686,
        23.257104568112
    ],
    [
        113.07119343,
        23.257134634592
    ],
    [
        113.0712535925,
        23.257162906927
    ],
    [
        113.07130096061,
        23.25718841262
    ],
    [
        113.07133063408,
        23.257208794297
    ],
    [
        113.07134315806,
        23.257237335319
    ],
    [
        113.07135214336,
        23.257268649421
    ],
    [
        113.07134534211,
        23.257335769495
    ],
    [
        113.07131812295,
        23.257382078791
    ],
    [
        113.07132683544,
        23.257401732978
    ],
    [
        113.07135079185,
        23.257412988862
    ],
    [
        113.07140904966,
        23.257440477688
    ],
    [
        113.07146431269,
        23.257460963834
    ],
    [
        113.0715386305,
        23.25746538947
    ],
    [
        113.07158028122,
        23.257467389259
    ],
    [
        113.07160804666,
        23.257444669493
    ],
    [
        113.07165622672,
        23.257386876944
    ],
    [
        113.07172373349,
        23.257302167811
    ],
    [
        113.07177545185,
        23.257222069123
    ],
    [
        113.07180239922,
        23.257166538455
    ],
    [
        113.07183914568,
        23.257085882423
    ],
    [
        113.07184975942,
        23.257023850391
    ],
    [
        113.07188160506,
        23.256912896108
    ],
    [
        113.07189984098,
        23.256829574013
    ],
    [
        113.07192515504,
        23.256739890995
    ],
    [
        113.0719393085,
        23.256663420858
    ],
    [
        113.07196353524,
        23.256601968485
    ],
    [
        113.07199511273,
        23.256552325327
    ],
    [
        113.07203540216,
        23.256518265534
    ],
    [
        113.07208004767,
        23.256494981093
    ],
    [
        113.07211761561,
        23.256489179457
    ],
    [
        113.07215790576,
        23.25647437871
    ],
    [
        113.07222188073,
        23.256479513995
    ],
    [
        113.07232914097,
        23.256473592323
    ],
    [
        113.07242442363,
        23.256483609202
    ],
    [
        113.07252651246,
        23.256487809795
    ],
    [
        113.07257442648,
        23.256498101664
    ],
    [
        113.07262860234,
        23.256519677816
    ],
    [
        113.07270265219,
        23.256557455983
    ],
    [
        113.07275764553,
        23.256594479026
    ],
    [
        113.07280011545,
        23.256612187731
    ],
    [
        113.07281726714,
        23.256631149869
    ],
    [
        113.07283251347,
        23.256659639493
    ],
    [
        113.0728404095,
        23.256692054597
    ],
    [
        113.07283333433,
        23.256778441249
    ],
    [
        113.07283360998,
        23.256863072632
    ],
    [
        113.07284041851,
        23.256920192289
    ],
    [
        113.07285457729,
        23.256968503581
    ],
    [
        113.07289296552,
        23.257014223469
    ],
    [
        113.07298144699,
        23.257071550052
    ],
    [
        113.07308653447,
        23.257106341916
    ],
    [
        113.07321939169,
        23.257148514594
    ],
    [
        113.07331767411,
        23.257184777659
    ],
    [
        113.07342303584,
        23.257229596273
    ],
    [
        113.0735060735,
        23.257269920744
    ],
    [
        113.0736059914,
        23.257319172139
    ],
    [
        113.07370400458,
        23.257376864963
    ],
    [
        113.07377942109,
        23.257428170698
    ],
    [
        113.07383686903,
        23.257473822722
    ],
    [
        113.07388097708,
        23.257521064622
    ],
    [
        113.07390847896,
        23.257579177165
    ],
    [
        113.07394469709,
        23.257684066921
    ],
    [
        113.07396921018,
        23.257800555484
    ],
    [
        113.07398800625,
        23.257911990259
    ],
    [
        113.07401061384,
        23.258017118956
    ],
    [
        113.07402831655,
        23.258077031057
    ],
    [
        113.07403975629,
        23.258124303216
    ],
    [
        113.07405418679,
        23.258135172146
    ],
    [
        113.07407651238,
        23.258144274797
    ],
    [
        113.07410319311,
        23.258145433965
    ],
    [
        113.07412851025,
        23.258125728893
    ],
    [
        113.07415355642,
        23.258117150749
    ],
    [
        113.0741766935,
        23.258078223389
    ],
    [
        113.07420581655,
        23.258004739038
    ],
    [
        113.07421806423,
        23.257969800792
    ],
    [
        113.07424365416,
        23.257952803379
    ],
    [
        113.07428013453,
        23.25793914101
    ],
    [
        113.07431225913,
        23.25792772528
    ],
    [
        113.07437787164,
        23.257924401208
    ],
    [
        113.07446254192,
        23.257920741339
    ],
    [
        113.07453632258,
        23.257920799048
    ],
    [
        113.07458124444,
        23.257920821921
    ],
    [
        113.07459676208,
        23.257912681726
    ],
    [
        113.07460764821,
        23.25787234155
    ],
    [
        113.07462369792,
        23.257732353243
    ],
    [
        113.07462504355,
        23.257551119476
    ],
    [
        113.07464518077,
        23.257428692348
    ],
    [
        113.07465333863,
        23.257291556465
    ],
    [
        113.07465224295,
        23.257188763961
    ],
    [
        113.07465060392,
        23.257096289444
    ],
    [
        113.07464787713,
        23.257019025339
    ],
    [
        113.07463997954,
        23.25697603245
    ],
    [
        113.0746356212,
        23.256929721994
    ],
    [
        113.0746108441,
        23.256886755167
    ],
    [
        113.07459069573,
        23.256851031084
    ],
    [
        113.07455067216,
        23.256796125502
    ],
    [
        113.07448914107,
        23.256748380118
    ],
    [
        113.07442733824,
        23.256709319805
    ],
    [
        113.07433286568,
        23.256680599388
    ],
    [
        113.07428522108,
        23.256665432212
    ],
    [
        113.07424765013,
        23.256658768367
    ],
    [
        113.07419592226,
        23.25665533709
    ],
    [
        113.07416842497,
        23.256657719076
    ],
    [
        113.07414065585,
        23.256671770335
    ],
    [
        113.07412159968,
        23.256711710363
    ],
    [
        113.07411533995,
        23.256766345484
    ],
    [
        113.07411507177,
        23.256864549877
    ],
    [
        113.07411670979,
        23.256961364557
    ],
    [
        113.07411725567,
        23.256989024548
    ],
    [
        113.07408921371,
        23.256986261724
    ],
    [
        113.07406144268,
        23.25695663829
    ],
    [
        113.07401161899,
        23.256917093553
    ],
    [
        113.0739498149,
        23.256841951074
    ],
    [
        113.07387222119,
        23.256777664567
    ],
    [
        113.07378972732,
        23.256711021795
    ],
    [
        113.0737271085,
        23.256660848834
    ],
    [
        113.07363889801,
        23.256587794194
    ],
    [
        113.07353489741,
        23.256501722539
    ],
    [
        113.07345730581,
        23.256436618177
    ],
    [
        113.07338706533,
        23.256376809971
    ],
    [
        113.07330511882,
        23.256326971061
    ],
    [
        113.07324032401,
        23.256275204382
    ],
    [
        113.07315021075,
        23.25620922997
    ],
    [
        113.07304240217,
        23.256122946127
    ],
    [
        113.0729656299,
        23.256069215137
    ],
    [
        113.07291689874,
        23.256040223437
    ],
    [
        113.0728736125,
        23.256019274707
    ],
    [
        113.07284176038,
        23.256016301862
    ],
    [
        113.07281780323,
        23.256024042364
    ],
    [
        113.07278758455,
        23.256054406708
    ],
    [
        113.07274157611,
        23.256110272918
    ],
    [
        113.07267596671,
        23.256165122539
    ],
    [
        113.07264438722,
        23.256195238498
    ],
    [
        113.07260518508,
        23.256215992063
    ],
    [
        113.07256788852,
        23.25621745231
    ],
    [
        113.07251834132,
        23.256215598008
    ],
    [
        113.0724960179,
        23.256215984596
    ],
    [
        113.07244184263,
        23.256184098991
    ],
    [
        113.07240645179,
        23.256150260323
    ],
    [
        113.07238603399,
        23.256100971523
    ],
    [
        113.0723876674,
        23.256059168101
    ],
    [
        113.072396379,
        23.25603053437
    ],
    [
        113.07243095343,
        23.255935264047
    ],
    [
        113.07247070071,
        23.255854552453
    ],
    [
        113.07251752684,
        23.255756628257
    ],
    [
        113.07254448016,
        23.255662303278
    ],
    [
        113.07255400999,
        23.255598119415
    ],
    [
        113.0725491108,
        23.255557785705
    ],
    [
        113.07252406633,
        23.255512104404
    ],
    [
        113.0724987499,
        23.255461816209
    ],
    [
        113.07245573731,
        23.255439503288
    ],
    [
        113.0724157192,
        23.255423377314
    ],
    [
        113.0723495665,
        23.255409873014
    ],
    [
        113.07232697097,
        23.255410806106
    ],
    [
        113.07225700734,
        23.255394925074
    ],
    [
        113.07220092755,
        23.255385856372
    ],
    [
        113.07213913141,
        23.255366848804
    ],
    [
        113.07206971249,
        23.255359636192
    ],
    [
        113.07197661053,
        23.255331942823
    ],
    [
        113.07187833706,
        23.255294299704
    ],
    [
        113.07177815839,
        23.255259399841
    ],
    [
        113.07168614643,
        23.255238192221
    ],
    [
        113.07156582443,
        23.255196308762
    ],
    [
        113.07140984229,
        23.255147435819
    ],
    [
        113.07127482255,
        23.255098470989
    ],
    [
        113.07121847317,
        23.255091564603
    ],
    [
        113.07116756856,
        23.255080767052
    ],
    [
        113.07110876955,
        23.255073358284
    ],
    [
        113.07105977026,
        23.255071749918
    ],
    [
        113.07103173196,
        23.255068699872
    ],
    [
        113.07100696093,
        23.255054472322
    ],
    [
        113.07096803521,
        23.255030719353
    ],
    [
        113.07094925265,
        23.25502371393
    ],
    [
        113.07095006965,
        23.255017732264
    ],
    [
        113.07093700622,
        23.254968041342
    ],
    [
        113.07094409133,
        23.254851820387
    ],
    [
        113.07094981294,
        23.254778753527
    ],
    [
        113.07098466754,
        23.254634664005
    ],
    [
        113.0710483845,
        23.254421726084
    ],
    [
        113.07111101362,
        23.254224268045
    ],
    [
        113.07114750698,
        23.254071741049
    ],
    [
        113.07118726199,
        23.253973681793
    ],
    [
        113.07120360688,
        23.25387357967
    ],
    [
        113.07122512401,
        23.253777458385
    ],
    [
        113.07127060213,
        23.253642681109
    ],
    [
        113.07127332902,
        23.253607370906
    ],
    [
        113.07131417632,
        23.253503867128
    ],
    [
        113.07135665678,
        23.253406031621
    ],
    [
        113.07137980744,
        23.253325615148
    ],
    [
        113.07141629857,
        23.253237375521
    ],
    [
        113.07145388316,
        23.253123347486
    ],
    [
        113.07146368984,
        23.253081948693
    ],
    [
        113.0714822152,
        23.252995372099
    ],
    [
        113.07151054562,
        23.252882044616
    ],
    [
        113.07153560128,
        23.252818413106
    ],
    [
        113.07155140595,
        23.252730255491
    ],
    [
        113.07156937836,
        23.252699295878
    ],
    [
        113.07160205373,
        23.252653436575
    ],
    [
        113.07163663011,
        23.252633042553
    ],
    [
        113.07168590754,
        23.252608598635
    ],
    [
        113.0717575051,
        23.252598147733
    ],
    [
        113.07179316709,
        23.25259699304
    ],
    [
        113.0718451586,
        23.252618614292
    ],
    [
        113.07195403988,
        23.252674519804
    ],
    [
        113.07199677556,
        23.252698739905
    ],
    [
        113.07204712971,
        23.252745885204
    ],
    [
        113.07210428509,
        23.252820309697
    ],
    [
        113.07216007368,
        23.252930563088
    ],
    [
        113.0722101474,
        23.253033319412
    ],
    [
        113.07225777164,
        23.25313638891
    ],
    [
        113.07230784625,
        23.253242128321
    ],
    [
        113.07234213597,
        23.253320743139
    ],
    [
        113.07238649567,
        23.253420884351
    ],
    [
        113.07242323372,
        23.25351871584
    ],
    [
        113.07244718157,
        23.253584217429
    ],
    [
        113.07244880992,
        23.253622436814
    ],
    [
        113.07245315941,
        23.253670645724
    ],
    [
        113.07246568039,
        23.253685077022
    ],
    [
        113.07248228491,
        23.253699708856
    ],
    [
        113.07250134047,
        23.253707245445
    ],
    [
        113.07252829253,
        23.253701895987
    ],
    [
        113.07255742336,
        23.25368999841
    ],
    [
        113.07256859122,
        23.253642334472
    ],
    [
        113.07257594755,
        23.253597177928
    ],
    [
        113.07258275573,
        23.253580241858
    ],
    [
        113.07262441237,
        23.253547782385
    ],
    [
        113.07265844803,
        23.25350406192
    ],
    [
        113.07266307709,
        23.25349665763
    ],
    [
        113.07269547467,
        23.25348741526
    ],
    [
        113.07271807027,
        23.253488650678
    ],
    [
        113.07277741703,
        23.25349765689
    ],
    [
        113.07290346039,
        23.253523406171
    ],
    [
        113.07299765242,
        23.253546994608
    ],
    [
        113.07305318783,
        23.253560404498
    ],
    [
        113.0731035518,
        23.253566037468
    ],
    [
        113.07313077677,
        23.25356040916
    ],
    [
        113.07318576944,
        23.253562705688
    ],
    [
        113.07322578902,
        23.253563635358
    ],
    [
        113.07330991287,
        23.253558912435
    ],
    [
        113.07339321967,
        23.253558271598
    ],
    [
        113.07346808702,
        23.253558048505
    ],
    [
        113.07352471331,
        23.253563568778
    ],
    [
        113.07354159203,
        23.253567342502
    ],
    [
        113.0735704457,
        23.253600473991
    ],
    [
        113.07358323782,
        23.253626833636
    ],
    [
        113.07360746459,
        23.253651094378
    ],
    [
        113.07363005972,
        23.253661278103
    ],
    [
        113.07365292616,
        23.253679052279
    ],
    [
        113.07369757242,
        23.253696445057
    ],
    [
        113.07374984347,
        23.253699598508
    ],
    [
        113.07380837587,
        23.253706168253
    ],
    [
        113.07385166499,
        23.25369266031
    ],
    [
        113.07388107033,
        23.253672614086
    ],
    [
        113.07388733629,
        23.25363941055
    ],
    [
        113.07389088022,
        23.253603270899
    ],
    [
        113.07387754598,
        23.253558475652
    ],
    [
        113.0738718314,
        23.253538773921
    ],
    [
        113.07387755277,
        23.253508021325
    ],
    [
        113.07388272839,
        23.253486772371
    ],
    [
        113.07389307872,
        23.253451327216
    ],
    [
        113.07391540575,
        23.253432218815
    ],
    [
        113.07394045516,
        23.253414147639
    ],
    [
        113.07397693876,
        23.253398045851
    ],
    [
        113.07404309456,
        23.253403123815
    ],
    [
        113.07412749125,
        23.253407880923
    ],
    [
        113.07422059891,
        23.253421164433
    ],
    [
        113.07432132911,
        23.253439466893
    ],
    [
        113.07442396807,
        23.25343793282
    ],
    [
        113.07458432252,
        23.253452199571
    ],
    [
        113.07486447096,
        23.253452416805
    ],
    [
        113.07503571884,
        23.253452108647
    ],
    [
        113.07522411722,
        23.253466414858
    ],
    [
        113.07535670594,
        23.253463801823
    ],
    [
        113.07542150092,
        23.253477576312
    ],
    [
        113.07546397113,
        23.253490117553
    ],
    [
        113.0755159694,
        23.253509543051
    ],
    [
        113.07557259566,
        23.253532141735
    ],
    [
        113.07562540963,
        23.253560504127
    ],
    [
        113.07566896802,
        23.253580621014
    ],
    [
        113.07571797075,
        23.253607151794
    ],
    [
        113.07577650417,
        23.253620764751
    ],
    [
        113.07585736157,
        23.253643205589
    ],
    [
        113.07587914134,
        23.253649330599
    ],
    [
        113.07591453492,
        23.253647890779
    ],
    [
        113.07595646245,
        23.25364823416
    ],
    [
        113.07602044265,
        23.253649814924
    ],
    [
        113.07605474966,
        23.253629134768
    ],
    [
        113.07612798876,
        23.253614004741
    ],
    [
        113.07617563751,
        23.253584950672
    ],
    [
        113.0762597668,
        23.253570984104
    ],
    [
        113.07633137187,
        23.253560222941
    ],
    [
        113.07638446121,
        23.25356660748
    ],
    [
        113.0764252998,
        23.253566698571
    ],
    [
        113.07646668019,
        23.253587667049
    ],
    [
        113.07653038618,
        23.253604985335
    ],
    [
        113.07666323802,
        23.253682384737
    ],
    [
        113.07674191622,
        23.253716256293
    ],
    [
        113.07686878209,
        23.253766093468
    ],
    [
        113.07697468767,
        23.253786734401
    ],
    [
        113.07699919009,
        23.253792811189
    ],
    [
        113.0770253272,
        23.253789093709
    ],
    [
        113.07707678419,
        23.2537854709
    ],
    [
        113.07711599083,
        23.253771485688
    ],
    [
        113.07713886336,
        23.253746667745
    ],
    [
        113.07717616565,
        23.253720780852
    ],
    [
        113.07719413867,
        23.253687369295
    ],
    [
        113.07719904377,
        23.253651204998
    ],
    [
        113.0771982274,
        23.253647964318
    ],
    [
        113.07722654992,
        23.253586158792
    ],
    [
        113.07722600561,
        23.25358454086
    ],
    [
        113.07724071433,
        23.253531656432
    ],
    [
        113.07726141808,
        23.253439875985
    ],
    [
        113.07729463943,
        23.253395615888
    ],
    [
        113.07729709614,
        23.253349729705
    ],
    [
        113.07734256786,
        23.253315018438
    ],
    [
        113.07746100003,
        23.253309669899
    ],
    [
        113.07760447992,
        23.253301980685
    ],
    [
        113.07776538278,
        23.253302122685
    ],
    [
        113.07792437948,
        23.253302571168
    ],
    [
        113.07805860028,
        23.253306170932
    ],
    [
        113.07819608692,
        23.253316224697
    ],
    [
        113.07827503976,
        23.253320258485
    ],
    [
        113.0784310394,
        23.253327818726
    ],
    [
        113.07854347854,
        23.253333977515
    ],
    [
        113.07863849314,
        23.253341800246
    ],
    [
        113.07873868248,
        23.253334071208
    ],
    [
        113.07886201243,
        23.253329191952
    ],
    [
        113.07899786583,
        23.253321653359
    ],
    [
        113.0790966919,
        23.253322361351
    ],
    [
        113.0791413393,
        23.253331343983
    ],
    [
        113.07915984936,
        23.253351363983
    ],
    [
        113.07916882603,
        23.253406000986
    ],
    [
        113.07918243376,
        23.253440483705
    ],
    [
        113.07919821896,
        23.253479268461
    ],
    [
        113.07924531298,
        23.25351560604
    ],
    [
        113.07927416897,
        23.253532461315
    ],
    [
        113.07931582215,
        23.253536886003
    ],
    [
        113.07940947399,
        23.253543385044
    ],
    [
        113.07951728291,
        23.253545297727
    ],
    [
        113.07959950281,
        23.253529484554
    ],
    [
        113.07965422577,
        23.253514694841
    ],
    [
        113.07982927889,
        23.25350811507
    ],
    [
        113.08000160725,
        23.253511895462
    ],
    [
        113.08017529823,
        23.253496669004
    ],
    [
        113.0803449022,
        23.253499693105
    ],
    [
        113.08044971113,
        23.25351686486
    ],
    [
        113.08052593555,
        23.253529379377
    ],
    [
        113.08055833002,
        23.25354129679
    ],
    [
        113.08059834316,
        23.253584006263
    ],
    [
        113.08060541814,
        23.253609111085
    ],
    [
        113.0806190191,
        23.25369812046
    ],
    [
        113.08062336109,
        23.253817399929
    ],
    [
        113.08062470694,
        23.2539587035
    ],
    [
        113.08063013544,
        23.254120010081
    ],
    [
        113.08063366452,
        23.254227097429
    ],
    [
        113.08064945048,
        23.254267785134
    ],
    [
        113.08066061036,
        23.254287394404
    ],
    [
        113.08068021023,
        23.254298720025
    ],
    [
        113.08070933867,
        23.254305269699
    ],
    [
        113.08074609039,
        23.25430273629
    ],
    [
        113.0807953652,
        23.254295104365
    ],
    [
        113.08087322453,
        23.254284267531
    ],
    [
        113.08094536767,
        23.254262951185
    ],
    [
        113.081017509,
        23.254259810527
    ],
    [
        113.08106950439,
        23.25426515521
    ],
    [
        113.08112966455,
        23.254293146201
    ],
    [
        113.08116042381,
        23.25432299917
    ],
    [
        113.08119308554,
        23.254391067686
    ],
    [
        113.08123990275,
        23.254466217701
    ],
    [
        113.08124915712,
        23.254483962269
    ],
    [
        113.08128890162,
        23.254492232306
    ],
    [
        113.08136321929,
        23.254493128802
    ],
    [
        113.08144624886,
        23.254481128166
    ],
    [
        113.08154860623,
        23.254465543742
    ],
    [
        113.08162346927,
        23.25444229311
    ],
    [
        113.08170132482,
        23.254440151311
    ],
    [
        113.08177618474,
        23.254449726313
    ],
    [
        113.08184260465,
        23.254471653119
    ],
    [
        113.0818965012,
        23.2545084421
    ],
    [
        113.08195121204,
        23.254577498307
    ],
    [
        113.08199666701,
        23.254655664123
    ],
    [
        113.08203858148,
        23.25476535718
    ],
    [
        113.08209029648,
        23.254871087036
    ],
    [
        113.08215916045,
        23.254998228519
    ],
    [
        113.08222258178,
        23.255100778422
    ],
    [
        113.08226667821,
        23.255153743337
    ],
    [
        113.08230995945,
        23.255169016746
    ],
    [
        113.08236167972,
        23.25516895742
    ],
    [
        113.08242292797,
        23.255149478396
    ],
    [
        113.08251221436,
        23.255110811103
    ],
    [
        113.08262844929,
        23.25506301282
    ],
    [
        113.08287452703,
        23.254971269482
    ],
    [
        113.08300191986,
        23.254925467616
    ],
    [
        113.08308630365,
        23.254892051404
    ],
    [
        113.08319191955,
        23.254838753288
    ],
    [
        113.08325860939,
        23.254810518671
    ],
    [
        113.08332094353,
        23.254788054265
    ],
    [
        113.08337374966,
        23.254782296066
    ],
    [
        113.08341294594,
        23.254776221555
    ],
    [
        113.08348017843,
        23.254762359706
    ],
    [
        113.08364322422,
        23.254704872831
    ],
    [
        113.08376516821,
        23.254646442759
    ],
    [
        113.083966862,
        23.254576131906
    ],
    [
        113.08408907538,
        23.254522593897
    ],
    [
        113.08417100472,
        23.254477855364
    ],
    [
        113.08419931458,
        23.254433720814
    ],
    [
        113.08421619411,
        23.254375667002
    ],
    [
        113.08422028268,
        23.254302359589
    ],
    [
        113.08422219446,
        23.25422501875
    ],
    [
        113.08421757333,
        23.254158363549
    ],
    [
        113.08416042867,
        23.25402176488
    ],
    [
        113.08412260902,
        23.253890277469
    ],
    [
        113.08407063666,
        23.253760106948
    ],
    [
        113.08406275041,
        23.253698388392
    ],
    [
        113.08405731179,
        23.253655346864
    ],
    [
        113.08406384721,
        23.253629199119
    ],
    [
        113.08418361257,
        23.253576790817
    ],
    [
        113.08431072572,
        23.253524539576
    ],
    [
        113.08436380391,
        23.253492482852
    ],
    [
        113.08439156874,
        23.253468432845
    ],
    [
        113.08439646968,
        23.25345424787
    ],
    [
        113.08440327554,
        23.253442473356
    ],
    [
        113.08440409454,
        23.253423200653
    ],
    [
        113.08439947103,
        23.253396692194
    ],
    [
        113.08439703558,
        23.253290940591
    ],
    [
        113.08438235232,
        23.253189185387
    ],
    [
        113.08437501294,
        23.25312420238
    ],
    [
        113.08436685883,
        23.253048653591
    ],
    [
        113.08434836214,
        23.252974629059
    ],
    [
        113.08434320344,
        23.252893335437
    ],
    [
        113.08432035528,
        23.25280229266
    ],
    [
        113.08430811677,
        23.25274498492
    ],
    [
        113.08430186635,
        23.252687308701
    ],
    [
        113.08429644,
        23.252587031815
    ],
    [
        113.08428502067,
        23.252518318234
    ],
    [
        113.08427822968,
        23.25244356186
    ],
    [
        113.08427824386,
        23.252366253609
    ],
    [
        113.08427689107,
        23.252322874642
    ],
    [
        113.08427907294,
        23.252299239902
    ],
    [
        113.08430683671,
        23.252289565938
    ],
    [
        113.08434575979,
        23.252278897302
    ],
    [
        113.08443557941,
        23.252267132899
    ],
    [
        113.08452648618,
        23.252260236517
    ],
    [
        113.08462419505,
        23.252261099922
    ],
    [
        113.08470910954,
        23.25227139558
    ],
    [
        113.08479810569,
        23.25228298471
    ],
    [
        113.08482341809,
        23.252277424357
    ],
    [
        113.08485553512,
        23.252268771274
    ],
    [
        113.0848966379,
        23.252236917836
    ],
    [
        113.08492059804,
        23.252186080424
    ],
    [
        113.08495244875,
        23.252146509705
    ],
    [
        113.08498593205,
        23.252108812084
    ],
    [
        113.08502049845,
        23.252098765652
    ],
    [
        113.08507139249,
        23.252097953045
    ],
    [
        113.08511057734,
        23.252128251206
    ],
    [
        113.08514486216,
        23.252164324398
    ],
    [
        113.08517615191,
        23.252207227132
    ],
    [
        113.08518593636,
        23.252276241655
    ],
    [
        113.08519327059,
        23.252350991626
    ],
    [
        113.08521775896,
        23.252381796655
    ],
    [
        113.08528088991,
        23.252431518754
    ],
    [
        113.08533694374,
        23.25248650854
    ],
    [
        113.08537231527,
        23.252533689356
    ],
    [
        113.08537883994,
        23.252573732051
    ],
    [
        113.08537311627,
        23.252622920173
    ],
    [
        113.08537120274,
        23.252672861772
    ],
    [
        113.085337174,
        23.25273063613
    ],
    [
        113.08529226191,
        23.252771494445
    ],
    [
        113.08524163625,
        23.252801322813
    ],
    [
        113.08520625057,
        23.252834978699
    ],
    [
        113.08516541798,
        23.252892321235
    ],
    [
        113.08510716197,
        23.252984391959
    ],
    [
        113.08507204476,
        23.253042187531
    ],
    [
        113.08504100989,
        23.253101003475
    ],
    [
        113.08502848425,
        23.253144333632
    ],
    [
        113.08503555265,
        23.253199014993
    ],
    [
        113.08504697114,
        23.25328753433
    ],
    [
        113.08506737365,
        23.253358278571
    ],
    [
        113.08506600968,
        23.253382442419
    ],
    [
        113.08507824655,
        23.253462539981
    ],
    [
        113.08509048948,
        23.253496252153
    ],
    [
        113.08511879328,
        23.253502039875
    ],
    [
        113.08518601617,
        23.253502596978
    ],
    [
        113.08529868824,
        23.253505689566
    ],
    [
        113.08538223687,
        23.253525795052
    ],
    [
        113.08543802763,
        23.253528710145
    ],
    [
        113.08548074981,
        23.253573878133
    ],
    [
        113.08551068151,
        23.253614094725
    ],
    [
        113.08558714506,
        23.253702405478
    ],
    [
        113.08568592271,
        23.253807186447
    ],
    [
        113.08577953171,
        23.25388926672
    ],
    [
        113.08586061794,
        23.254011150676
    ],
    [
        113.08591367829,
        23.254086004025
    ],
    [
        113.08598796878,
        23.254124178866
    ],
    [
        113.08604756608,
        23.254133016977
    ],
    [
        113.08611886536,
        23.254136521093
    ],
    [
        113.08618662684,
        23.254135470792
    ],
    [
        113.08625466028,
        23.25413170572
    ],
    [
        113.08632623149,
        23.254122191666
    ],
    [
        113.08636242532,
        23.254115123493
    ],
    [
        113.08641249602,
        23.2541249319
    ],
    [
        113.08646610314,
        23.254145808872
    ],
    [
        113.08659889136,
        23.254244954267
    ],
    [
        113.08664405937,
        23.254297159951
    ],
    [
        113.08672922587,
        23.254389717471
    ],
    [
        113.08677330379,
        23.254462287305
    ],
    [
        113.08680649414,
        23.254579782018
    ],
    [
        113.08684104464,
        23.254715702698
    ],
    [
        113.08685926864,
        23.254860281046
    ],
    [
        113.08688620059,
        23.255025072607
    ],
    [
        113.08690306629,
        23.255171300053
    ],
    [
        113.08690714396,
        23.255308227319
    ],
    [
        113.08690006608,
        23.255436914604
    ],
    [
        113.08689026795,
        23.255563744482
    ],
    [
        113.08690196807,
        23.255647388527
    ],
    [
        113.08691611768,
        23.255707395385
    ],
    [
        113.08695394143,
        23.255749140432
    ],
    [
        113.08700156118,
        23.255797248587
    ],
    [
        113.08707094963,
        23.255768803506
    ],
    [
        113.08720047355,
        23.255715585709
    ],
    [
        113.08731503023,
        23.255660972311
    ],
    [
        113.08740428023,
        23.255617321989
    ],
    [
        113.08750414134,
        23.2555754168
    ],
    [
        113.0875969271,
        23.2555265685
    ],
    [
        113.08766903288,
        23.255483726647
    ],
    [
        113.08780290342,
        23.255410409985
    ],
    [
        113.08794656749,
        23.255334246571
    ],
    [
        113.08807689746,
        23.255264527227
    ],
    [
        113.08817811329,
        23.255199579408
    ],
    [
        113.08828014415,
        23.255143034483
    ],
    [
        113.08838326222,
        23.255089734654
    ],
    [
        113.08849209292,
        23.255030933298
    ],
    [
        113.08863411455,
        23.254970850701
    ],
    [
        113.08874539057,
        23.254923965148
    ],
    [
        113.08885285605,
        23.254886092068
    ],
    [
        113.08896440145,
        23.254841115061
    ],
    [
        113.08909852554,
        23.254800168764
    ],
    [
        113.08921305937,
        23.254776052834
    ],
    [
        113.08929059363,
        23.254753543392
    ],
    [
        113.08933656892,
        23.254755617497
    ],
    [
        113.08944538633,
        23.254739462743
    ],
    [
        113.08957433333,
        23.254717070357
    ],
    [
        113.08969511706,
        23.254701038275
    ],
    [
        113.08980801009,
        23.254687563431
    ],
    [
        113.0898599676,
        23.254680889741
    ]
];

let dali = [
    [
        113.20431138075,
        23.173877411973
    ],
    [
        113.20429394939,
        23.173864672182
    ],
    [
        113.20424629539,
        23.173840486667
    ],
    [
        113.20416679733,
        23.173817635665
    ],
    [
        113.20409654469,
        23.173785953372
    ],
    [
        113.20401131897,
        23.17375153351
    ],
    [
        113.20393481018,
        23.173725112862
    ],
    [
        113.20384413593,
        23.173686717516
    ],
    [
        113.20376843071,
        23.173647535826
    ],
    [
        113.20365896397,
        23.173598331411
    ],
    [
        113.20356038261,
        23.173547594366
    ],
    [
        113.20344081902,
        23.173473060382
    ],
    [
        113.2032872109,
        23.173378747487
    ],
    [
        113.20317255367,
        23.17331390989
    ],
    [
        113.20305680955,
        23.173252079109
    ],
    [
        113.20294078482,
        23.173182388722
    ],
    [
        113.20282286564,
        23.173125215088
    ],
    [
        113.20273408449,
        23.173081393675
    ],
    [
        113.20265593824,
        23.173057745063
    ],
    [
        113.20257723267,
        23.173018913452
    ],
    [
        113.2025058846,
        23.17298864195
    ],
    [
        113.20244431516,
        23.172936772172
    ],
    [
        113.20234789726,
        23.172879794522
    ],
    [
        113.20224956392,
        23.172813084149
    ],
    [
        113.20217083313,
        23.172750113905
    ],
    [
        113.20209455313,
        23.172688460332
    ],
    [
        113.20197579608,
        23.172615863307
    ],
    [
        113.20185270104,
        23.172562336578
    ],
    [
        113.20172169642,
        23.172494025763
    ],
    [
        113.20162146742,
        23.172441472563
    ],
    [
        113.20153648985,
        23.172396529211
    ],
    [
        113.2014814765,
        23.172371966383
    ],
    [
        113.20138126014,
        23.172333798958
    ],
    [
        113.20130283775,
        23.172312353177
    ],
    [
        113.20119338037,
        23.172290356927
    ],
    [
        113.20109671787,
        23.172268957064
    ],
    [
        113.20101530678,
        23.172254622217
    ],
    [
        113.200946415,
        23.17223708829
    ],
    [
        113.20089656742,
        23.172207288369
    ],
    [
        113.20085353917,
        23.172191480168
    ],
    [
        113.20078489459,
        23.172148710986
    ],
    [
        113.20071025594,
        23.172101162545
    ],
    [
        113.20064186831,
        23.172043196627
    ],
    [
        113.20055928703,
        23.171947220499
    ],
    [
        113.20050367418,
        23.171868956964
    ],
    [
        113.20041918148,
        23.171767860919
    ],
    [
        113.20037743609,
        23.171673078488
    ],
    [
        113.2003337726,
        23.171565848635
    ],
    [
        113.20027895415,
        23.171465867392
    ],
    [
        113.20019936061,
        23.171364960799
    ],
    [
        113.20015191097,
        23.171284116788
    ],
    [
        113.20010583895,
        23.17122007143
    ],
    [
        113.20004530602,
        23.171123719032
    ],
    [
        113.20000523633,
        23.171073136241
    ],
    [
        113.19997062637,
        23.171037652862
    ],
    [
        113.19991476963,
        23.170990330423
    ],
    [
        113.19986491681,
        23.170957826725
    ],
    [
        113.19977775384,
        23.170912679709
    ],
    [
        113.199691944,
        23.170859641742
    ],
    [
        113.19960449639,
        23.170802563615
    ],
    [
        113.19948872883,
        23.170739470375
    ],
    [
        113.19939666326,
        23.170693328782
    ],
    [
        113.19929396046,
        23.170627839242
    ],
    [
        113.19925582575,
        23.170607886948
    ],
    [
        113.1992288414,
        23.170576072199
    ],
    [
        113.19920865502,
        23.170535998474
    ],
    [
        113.19919770896,
        23.170479754374
    ],
    [
        113.19919435592,
        23.170393531045
    ],
    [
        113.19917083795,
        23.170288939874
    ],
    [
        113.19914354642,
        23.170222400842
    ],
    [
        113.19912277077,
        23.170137839893
    ],
    [
        113.199112893,
        23.170061227515
    ],
    [
        113.19910142088,
        23.170023714329
    ],
    [
        113.19909541134,
        23.170003741566
    ],
    [
        113.19909266303,
        23.169978013669
    ],
    [
        113.19911465171,
        23.169914679613
    ],
    [
        113.19913529193,
        23.169864121686
    ],
    [
        113.19918751442,
        23.169814908974
    ],
    [
        113.19923861726,
        23.169735327508
    ],
    [
        113.19929163223,
        23.169662224723
    ],
    [
        113.19932397706,
        23.169609834133
    ],
    [
        113.19932230915,
        23.169575676026
    ],
    [
        113.19933016785,
        23.169539451664
    ],
    [
        113.19931842498,
        23.169503570823
    ],
    [
        113.19930886908,
        23.169476605494
    ],
    [
        113.19928923823,
        23.169447917487
    ],
    [
        113.19926988125,
        23.169420852698
    ],
    [
        113.19924781496,
        23.169406859218
    ],
    [
        113.19923120011,
        23.169399282071
    ],
    [
        113.1992153924,
        23.169382194314
    ],
    [
        113.19917996827,
        23.169350799
    ],
    [
        113.19913964423,
        23.169320032489
    ],
    [
        113.19908325411,
        23.169286020963
    ],
    [
        113.19903830452,
        23.169258049449
    ],
    [
        113.19900098983,
        23.169241882501
    ],
    [
        113.19895033476,
        23.169225678803
    ],
    [
        113.19886863664,
        23.169203237939
    ],
    [
        113.19878448923,
        23.169181926226
    ],
    [
        113.19871667323,
        23.16915707192
    ],
    [
        113.19866302638,
        23.16914417843
    ],
    [
        113.19860854598,
        23.169114748885
    ],
    [
        113.19852329041,
        23.169075008653
    ],
    [
        113.19847289494,
        23.169046864506
    ],
    [
        113.19841786568,
        23.169013375711
    ],
    [
        113.19836011496,
        23.168981020492
    ],
    [
        113.19823589195,
        23.168907239635
    ],
    [
        113.19815987711,
        23.168852416063
    ],
    [
        113.19808549262,
        23.168794579542
    ],
    [
        113.19802555277,
        23.168751682732
    ],
    [
        113.19796861119,
        23.168712260488
    ],
    [
        113.19789668028,
        23.168657908907
    ],
    [
        113.19785363059,
        23.168625296198
    ],
    [
        113.19780323282,
        23.168595526771
    ],
    [
        113.19776645921,
        23.168576912458
    ],
    [
        113.19771906745,
        23.168558214625
    ],
    [
        113.19766976852,
        23.168538194003
    ],
    [
        113.19756326034,
        23.16848364133
    ],
    [
        113.19745619454,
        23.16841634664
    ],
    [
        113.19736847489,
        23.168364718473
    ],
    [
        113.19723469732,
        23.168267780037
    ],
    [
        113.19706305776,
        23.168153333619
    ],
    [
        113.19688051782,
        23.168029313193
    ],
    [
        113.19674156688,
        23.167932468072
    ],
    [
        113.19660970443,
        23.167845265424
    ],
    [
        113.19648518946,
        23.16775467674
    ],
    [
        113.19633805239,
        23.167640069163
    ],
    [
        113.19624812641,
        23.167561348745
    ],
    [
        113.19617754656,
        23.167498022633
    ],
    [
        113.19610067877,
        23.167409302875
    ],
    [
        113.19604153275,
        23.16734496009
    ],
    [
        113.19602870989,
        23.167318868261
    ],
    [
        113.19597824378,
        23.16722289749
    ],
    [
        113.19594359115,
        23.167148895617
    ],
    [
        113.19589636816,
        23.16702953299
    ],
    [
        113.19581810989,
        23.166912347728
    ],
    [
        113.19577502072,
        23.166841750975
    ],
    [
        113.19572132394,
        23.166781381096
    ],
    [
        113.19565426981,
        23.166704696427
    ],
    [
        113.19559785889,
        23.166652514194
    ],
    [
        113.195518277,
        23.166571980877
    ],
    [
        113.19544415246,
        23.166503289213
    ],
    [
        113.19535395728,
        23.166427284241
    ],
    [
        113.19522563438,
        23.166339742993
    ],
    [
        113.19514606782,
        23.166273859566
    ],
    [
        113.19510054559,
        23.166219855416
    ],
    [
        113.19503702669,
        23.166138764771
    ],
    [
        113.19496802499,
        23.166020869887
    ],
    [
        113.19490747064,
        23.165910151416
    ],
    [
        113.19486653232,
        23.165812652902
    ],
    [
        113.194812521,
        23.165710501032
    ],
    [
        113.19476066827,
        23.165589317802
    ],
    [
        113.19471838356,
        23.165506223005
    ],
    [
        113.19465266875,
        23.165407261473
    ],
    [
        113.19458370066,
        23.165321652036
    ],
    [
        113.1945239783,
        23.165225297413
    ],
    [
        113.19443159066,
        23.165133859082
    ],
    [
        113.19435556671,
        23.165070078748
    ],
    [
        113.19427575337,
        23.1650277995
    ],
    [
        113.19416625443,
        23.164975459784
    ],
    [
        113.19406057278,
        23.164928478231
    ],
    [
        113.19388650481,
        23.164830872055
    ],
    [
        113.1937783443,
        23.16475516952
    ],
    [
        113.19365030924,
        23.164678728377
    ],
    [
        113.19356096001,
        23.164627926725
    ],
    [
        113.19346207507,
        23.164569964888
    ],
    [
        113.19337245467,
        23.164519708234
    ],
    [
        113.19329588045,
        23.164448058836
    ],
    [
        113.19323291981,
        23.164377527528
    ],
    [
        113.19319963287,
        23.164305935104
    ],
    [
        113.1931641534,
        23.164220000338
    ],
    [
        113.19314991807,
        23.164142919977
    ],
    [
        113.19314057478,
        23.16405761439
    ],
    [
        113.19311573051,
        23.163988858887
    ],
    [
        113.19307127378,
        23.163909320747
    ],
    [
        113.19301234546,
        23.163787707175
    ],
    [
        113.19296543527,
        23.163704683756
    ],
    [
        113.19293133938,
        23.163640158575
    ],
    [
        113.19291114197,
        23.163589500388
    ],
    [
        113.19290238379,
        23.163543798293
    ],
    [
        113.19289550041,
        23.16346767476
    ],
    [
        113.19287803207,
        23.163423480861
    ],
    [
        113.19284776232,
        23.163373269056
    ],
    [
        113.19279133265,
        23.163298549734
    ],
    [
        113.19271285266,
        23.163224755603
    ],
    [
        113.19262539472,
        23.163156542761
    ],
    [
        113.19255511445,
        23.163114349496
    ],
    [
        113.19248319001,
        23.163061330661
    ],
    [
        113.19240471658,
        23.162992958518
    ],
    [
        113.19231558173,
        23.162880543085
    ],
    [
        113.19220603121,
        23.162769564105
    ],
    [
        113.19215779323,
        23.162717488122
    ],
    [
        113.19213896153,
        23.162670330768
    ],
    [
        113.19213511311,
        23.162633496568
    ],
    [
        113.19215683206,
        23.162574243478
    ],
    [
        113.19218100549,
        23.162519289162
    ],
    [
        113.19223429498,
        23.162451350619
    ],
    [
        113.19229248888,
        23.162387396626
    ],
    [
        113.19235177324,
        23.162324779732
    ],
    [
        113.19241814617,
        23.162272349868
    ],
    [
        113.19247173855,
        23.162234249657
    ],
    [
        113.1924967349,
        23.162184977484
    ],
    [
        113.19252063283,
        23.162126227766
    ],
    [
        113.19255241906,
        23.162060829289
    ],
    [
        113.1925891257,
        23.162015423522
    ],
    [
        113.19262340568,
        23.161993393806
    ],
    [
        113.19266585383,
        23.161972307367
    ],
    [
        113.19273689814,
        23.161962119552
    ],
    [
        113.19278534191,
        23.161947168548
    ],
    [
        113.19285882498,
        23.161925269698
    ],
    [
        113.19294318388,
        23.161889342839
    ],
    [
        113.19302101122,
        23.161855427881
    ],
    [
        113.19314319581,
        23.161802830639
    ],
    [
        113.1932389777,
        23.16175476197
    ],
    [
        113.19333721225,
        23.161708819633
    ],
    [
        113.1934413923,
        23.161618545467
    ],
    [
        113.19354912462,
        23.161540959933
    ],
    [
        113.19364840404,
        23.161449683177
    ],
    [
        113.19373518355,
        23.161381687074
    ],
    [
        113.19378986763,
        23.161343556322
    ],
    [
        113.19383801119,
        23.161298756761
    ],
    [
        113.19388288628,
        23.161252386312
    ],
    [
        113.19393156427,
        23.161197266379
    ],
    [
        113.19398349288,
        23.161125538115
    ],
    [
        113.19403379569,
        23.161061435264
    ],
    [
        113.19406126109,
        23.161029207404
    ],
    [
        113.19409746338,
        23.161022059312
    ],
    [
        113.19411814927,
        23.161016811809
    ],
    [
        113.19417095517,
        23.161005844268
    ],
    [
        113.19424497762,
        23.160975510281
    ],
    [
        113.19429259997,
        23.160953508821
    ],
    [
        113.1943483933,
        23.160934890533
    ],
    [
        113.19438239048,
        23.160900104783
    ],
    [
        113.19441858956,
        23.160889428238
    ],
    [
        113.19444713032,
        23.160843071306
    ],
    [
        113.19445881021,
        23.160815732878
    ],
    [
        113.19445088662,
        23.160787111803
    ],
    [
        113.19442578463,
        23.160731660602
    ],
    [
        113.19436227489,
        23.160655722131
    ],
    [
        113.19428842258,
        23.160582678548
    ],
    [
        113.19420559246,
        23.160516032832
    ],
    [
        113.19413965118,
        23.160458585891
    ],
    [
        113.19409822711,
        23.160415901852
    ],
    [
        113.19407776846,
        23.160375291128
    ],
    [
        113.194057036,
        23.160333057215
    ],
    [
        113.19401888676,
        23.160298183733
    ],
    [
        113.19397203129,
        23.160269160841
    ],
    [
        113.19392599422,
        23.160241751276
    ],
    [
        113.19385544989,
        23.160209345008
    ],
    [
        113.19379744538,
        23.160193540403
    ],
    [
        113.19374952061,
        23.16018434179
    ],
    [
        113.19367056281,
        23.160178400005
    ],
    [
        113.19356221492,
        23.160185181691
    ],
    [
        113.19342527432,
        23.160184593374
    ],
    [
        113.19332645935,
        23.160195003234
    ],
    [
        113.19322955062,
        23.160205649656
    ],
    [
        113.19313591303,
        23.160220307442
    ],
    [
        113.19302431945,
        23.160246943774
    ],
    [
        113.19292825866,
        23.160288501912
    ],
    [
        113.19284280561,
        23.160319834893
    ],
    [
        113.1927824123,
        23.160364839982
    ],
    [
        113.19272881972,
        23.160404299744
    ],
    [
        113.19268884777,
        23.160452476228
    ],
    [
        113.19263934453,
        23.160497561966
    ],
    [
        113.19261867499,
        23.160518541532
    ],
    [
        113.19260152053,
        23.160515040641
    ],
    [
        113.1925203263,
        23.160446446624
    ],
    [
        113.19242739826,
        23.160349294003
    ],
    [
        113.19236716896,
        23.160282776467
    ],
    [
        113.19235761274,
        23.160254181258
    ],
    [
        113.19236412904,
        23.160236432286
    ],
    [
        113.19239241935,
        23.160213693867
    ],
    [
        113.19244165195,
        23.160170514453
    ],
    [
        113.19249279136,
        23.160128386835
    ],
    [
        113.19256052865,
        23.160077288442
    ],
    [
        113.1926231154,
        23.160048527324
    ],
    [
        113.19267073337,
        23.160024095315
    ],
    [
        113.19270719087,
        23.160000942077
    ],
    [
        113.19275643028,
        23.159964000168
    ],
    [
        113.19279149586,
        23.159909125435
    ],
    [
        113.19283662083,
        23.159840237912
    ],
    [
        113.19285615915,
        23.159775322481
    ],
    [
        113.19285909982,
        23.159719649538
    ],
    [
        113.19286308039,
        23.159613220615
    ],
    [
        113.19286243052,
        23.159504159043
    ],
    [
        113.19284438311,
        23.159421718746
    ],
    [
        113.19281956598,
        23.159376839055
    ],
    [
        113.19279637189,
        23.159321078032
    ],
    [
        113.192801239,
        23.159286535095
    ],
    [
        113.19281644614,
        23.15924665717
    ],
    [
        113.19283270737,
        23.159170403306
    ],
    [
        113.19290530972,
        23.15908068807
    ],
    [
        113.19296049569,
        23.158998058422
    ],
    [
        113.19301707002,
        23.15894362188
    ],
    [
        113.19305324814,
        23.158912060338
    ],
    [
        113.19308563595,
        23.158902541983
    ],
    [
        113.19313000592,
        23.158896613008
    ],
    [
        113.19317057599,
        23.158902688317
    ],
    [
        113.19319834776,
        23.158905730865
    ],
    [
        113.19325445943,
        23.158936496239
    ],
    [
        113.19330758305,
        23.158974096457
    ],
    [
        113.1933797665,
        23.159014347648
    ],
    [
        113.19342961181,
        23.159039794587
    ],
    [
        113.19346665042,
        23.159053526927
    ],
    [
        113.1935080278,
        23.159049275684
    ],
    [
        113.19355457939,
        23.159046561561
    ],
    [
        113.19361445173,
        23.15902353577
    ],
    [
        113.19366125599,
        23.159000195828
    ],
    [
        113.19371974423,
        23.158953045508
    ],
    [
        113.19377904804,
        23.158904523814
    ],
    [
        113.1938274317,
        23.158824176936
    ],
    [
        113.19389379041,
        23.158750568739
    ],
    [
        113.19394301748,
        23.158697881514
    ],
    [
        113.19397158828,
        23.15868164297
    ],
    [
        113.19401705148,
        23.158678945141
    ],
    [
        113.19405707497,
        23.158681769149
    ],
    [
        113.194106359,
        23.158688771387
    ],
    [
        113.19414639237,
        23.158701905144
    ],
    [
        113.19418805256,
        23.158707955669
    ],
    [
        113.19422616609,
        23.158706199978
    ],
    [
        113.19424249034,
        23.158694788485
    ],
    [
        113.19427459179,
        23.158669261795
    ],
    [
        113.19428845012,
        23.158641342815
    ],
    [
        113.19434065575,
        23.158570964865
    ],
    [
        113.19436891168,
        23.158509419412
    ],
    [
        113.19440313126,
        23.158420365118
    ],
    [
        113.19444059933,
        23.158311446858
    ],
    [
        113.1944557798,
        23.158241720482
    ],
    [
        113.19448156558,
        23.158158512394
    ],
    [
        113.1944953469,
        23.158048112078
    ],
    [
        113.19450695886,
        23.15794670371
    ],
    [
        113.19451039044,
        23.1578313307
    ],
    [
        113.19449939793,
        23.157721367055
    ],
    [
        113.19448651406,
        23.157626630886
    ],
    [
        113.19447011402,
        23.157556647098
    ],
    [
        113.19444824832,
        23.157464239771
    ],
    [
        113.19442286137,
        23.157391158389
    ],
    [
        113.19440291977,
        23.157318252402
    ],
    [
        113.19437260349,
        23.157213512996
    ],
    [
        113.19434063166,
        23.157084383675
    ],
    [
        113.19429749292,
        23.156949753107
    ],
    [
        113.19424969495,
        23.156780475197
    ],
    [
        113.19421447653,
        23.156672294666
    ],
    [
        113.19419314424,
        23.156565226455
    ],
    [
        113.19416825817,
        23.156441670143
    ],
    [
        113.19415239336,
        23.156358924753
    ],
    [
        113.19412426916,
        23.156266898665
    ],
    [
        113.19409147712,
        23.15613018661
    ],
    [
        113.1940486005,
        23.155980085714
    ],
    [
        113.19402943648,
        23.155859684738
    ],
    [
        113.194013285,
        23.155759037273
    ],
    [
        113.19401348164,
        23.155673025274
    ],
    [
        113.19401723906,
        23.155611369577
    ],
    [
        113.19403409144,
        23.155580414324
    ],
    [
        113.19404250281,
        23.155547979443
    ],
    [
        113.19409743771,
        23.155479726649
    ],
    [
        113.19414774037,
        23.155406671229
    ],
    [
        113.19417926811,
        23.155345341191
    ],
    [
        113.19426137963,
        23.155220446335
    ],
    [
        113.19432909232,
        23.155130261876
    ],
    [
        113.19439952968,
        23.155042199564
    ],
    [
        113.19447784209,
        23.154930121989
    ],
    [
        113.19455862793,
        23.154844589551
    ],
    [
        113.19460430808,
        23.154776225947
    ],
    [
        113.19469381916,
        23.154705461288
    ],
    [
        113.19478551681,
        23.154644424851
    ],
    [
        113.19491856576,
        23.154546029746
    ],
    [
        113.19500483709,
        23.154506521726
    ],
    [
        113.19515695588,
        23.154421353466
    ],
    [
        113.19528649149,
        23.154352319499
    ],
    [
        113.19536511651,
        23.154284456315
    ],
    [
        113.19541163731,
        23.154242664557
    ],
    [
        113.19542493412,
        23.154190336363
    ],
    [
        113.19543252548,
        23.154152217614
    ],
    [
        113.19541968035,
        23.154093297589
    ],
    [
        113.19539894543,
        23.154041028743
    ],
    [
        113.19532670534,
        23.153929709601
    ],
    [
        113.1952899157,
        23.153887220674
    ],
    [
        113.19524768647,
        23.153851339452
    ],
    [
        113.19518611919,
        23.153805761204
    ],
    [
        113.19513271823,
        23.153758410529
    ],
    [
        113.19508504889,
        23.153728322695
    ],
    [
        113.19501885189,
        23.153680655079
    ],
    [
        113.19489571727,
        23.153588139974
    ],
    [
        113.19476086432,
        23.153480908131
    ],
    [
        113.19464046498,
        23.153402722153
    ],
    [
        113.19452631711,
        23.15331113029
    ],
    [
        113.19444105053,
        23.153246974107
    ],
    [
        113.19441788961,
        23.153222692306
    ],
    [
        113.19440126224,
        23.15319775277
    ],
    [
        113.19439743118,
        23.153173401824
    ],
    [
        113.19439712873,
        23.15313569428
    ],
    [
        113.19439383572,
        23.153103194403
    ],
    [
        113.194399797,
        23.153067818414
    ],
    [
        113.19441419845,
        23.153032836421
    ],
    [
        113.19443431736,
        23.152998025027
    ],
    [
        113.19444844837,
        23.152965218288
    ],
    [
        113.1944737528,
        23.152946323085
    ],
    [
        113.19449388711,
        23.1529307747
    ],
    [
        113.1945409734,
        23.152913937369
    ],
    [
        113.19457444815,
        23.152898425031
    ],
    [
        113.1946239852,
        23.152882086771
    ],
    [
        113.19471462336,
        23.152854170765
    ],
    [
        113.19476986579,
        23.152822537599
    ],
    [
        113.19481394542,
        23.152790287245
    ],
    [
        113.19483977538,
        23.152746963634
    ],
    [
        113.19486180095,
        23.152712660523
    ],
    [
        113.19486639765,
        23.15267242481
    ],
    [
        113.19486526973,
        23.152622794148
    ],
    [
        113.19486869715,
        23.152479479646
    ],
    [
        113.19486775775,
        23.152321320121
    ],
    [
        113.19485293136,
        23.152159336213
    ],
    [
        113.19484163897,
        23.151989150726
    ],
    [
        113.19483770923,
        23.151833215097
    ],
    [
        113.19484663561,
        23.151756276033
    ],
    [
        113.19485717214,
        23.151647836342
    ],
    [
        113.19487205621,
        23.151527382258
    ],
    [
        113.19490465355,
        23.151428863141
    ],
    [
        113.19495306699,
        23.151364250027
    ],
    [
        113.19499305322,
        23.151316606937
    ],
    [
        113.19504501939,
        23.151269837375
    ],
    [
        113.19508475069,
        23.151245531356
    ],
    [
        113.19513837281,
        23.151229119117
    ],
    [
        113.19518600902,
        23.151217696098
    ],
    [
        113.19522929182,
        23.151209876944
    ],
    [
        113.19527203651,
        23.151210749157
    ],
    [
        113.1953253893,
        23.151198139424
    ],
    [
        113.19539180784,
        23.151182042715
    ],
    [
        113.19546530103,
        23.151160394397
    ],
    [
        113.19554178094,
        23.151127569206
    ],
    [
        113.19561282242,
        23.15110379327
    ],
    [
        113.1956923034,
        23.151079325125
    ],
    [
        113.19576797843,
        23.151062520831
    ],
    [
        113.19582459698,
        23.151047681601
    ],
    [
        113.19586134247,
        23.151035093322
    ],
    [
        113.19588665137,
        23.151019994398
    ],
    [
        113.19591522594,
        23.151002938453
    ],
    [
        113.1959630989,
        23.15094185968
    ],
    [
        113.196015605,
        23.150887210285
    ],
    [
        113.19605996587,
        23.150863634531
    ],
    [
        113.1961021544,
        23.150847965226
    ],
    [
        113.19613617456,
        23.150831355329
    ],
    [
        113.19620886019,
        23.150821657222
    ],
    [
        113.19627637613,
        23.150816391592
    ],
    [
        113.19636322228,
        23.150811054791
    ],
    [
        113.19644217367,
        23.150806671734
    ],
    [
        113.19659409506,
        23.150809406606
    ],
    [
        113.19670844798,
        23.15081633412
    ],
    [
        113.19685546874,
        23.150819156102
    ],
    [
        113.19698180306,
        23.150829127573
    ],
    [
        113.19709561191,
        23.150836879406
    ],
    [
        113.19717375712,
        23.150847433478
    ],
    [
        113.19722358879,
        23.150859574203
    ],
    [
        113.19727260485,
        23.150873357317
    ],
    [
        113.19731400097,
        23.150891616363
    ],
    [
        113.19735432691,
        23.150935940268
    ],
    [
        113.19739056599,
        23.1509759956
    ],
    [
        113.19740203113,
        23.151017845934
    ],
    [
        113.19741678591,
        23.151090567563
    ],
    [
        113.19744052721,
        23.151165843354
    ],
    [
        113.19745527741,
        23.151231782389
    ],
    [
        113.19748334875,
        23.151271168553
    ],
    [
        113.19751496421,
        23.151317003553
    ],
    [
        113.19755938845,
        23.151379976017
    ],
    [
        113.19760734041,
        23.151427150125
    ],
    [
        113.19765120603,
        23.151470869575
    ],
    [
        113.19770867195,
        23.151497798644
    ],
    [
        113.19775224433,
        23.151513307078
    ],
    [
        113.19779118194,
        23.151520215555
    ],
    [
        113.19783554756,
        23.15150423797
    ],
    [
        113.1978995118,
        23.151483301927
    ],
    [
        113.19798387482,
        23.151435145963
    ],
    [
        113.19808103016,
        23.151382152371
    ],
    [
        113.19819206316,
        23.151319418711
    ],
    [
        113.19828459074,
        23.151267322323
    ],
    [
        113.19835860914,
        23.151220707949
    ],
    [
        113.19842881523,
        23.15117307603
    ],
    [
        113.19849957891,
        23.151143341318
    ],
    [
        113.19861443573,
        23.151097908506
    ],
    [
        113.19874670902,
        23.151042403415
    ],
    [
        113.19884850764,
        23.151011040069
    ],
    [
        113.19891927992,
        23.150993788661
    ],
    [
        113.19898052647,
        23.150980774836
    ],
    [
        113.19903061404,
        23.150972298391
    ],
    [
        113.19911120318,
        23.150977395038
    ],
    [
        113.1991727343,
        23.150981741569
    ],
    [
        113.19926584614,
        23.150986348813
    ],
    [
        113.19935842234,
        23.151003446904
    ],
    [
        113.19941860113,
        23.151020570761
    ],
    [
        113.19948231995,
        23.151038989728
    ],
    [
        113.19956674266,
        23.151075767638
    ],
    [
        113.19963618366,
        23.151101413373
    ],
    [
        113.19968738407,
        23.151126835867
    ],
    [
        113.19975657693,
        23.151185587222
    ],
    [
        113.19982004756,
        23.151237385099
    ],
    [
        113.19986500036,
        23.151281909888
    ],
    [
        113.19993393844,
        23.151364271849
    ],
    [
        113.19999852064,
        23.151446439218
    ],
    [
        113.2000562883,
        23.151517059557
    ],
    [
        113.20010669367,
        23.151571801189
    ],
    [
        113.20016471798,
        23.15162152714
    ],
    [
        113.20021483008,
        23.151648329666
    ],
    [
        113.20025949497,
        23.151671971539
    ],
    [
        113.20030334434,
        23.151697255816
    ],
    [
        113.20031560634,
        23.151712236378
    ],
    [
        113.20035456099,
        23.15174493152
    ],
    [
        113.20045263771,
        23.151839274728
    ],
    [
        113.20049895911,
        23.151893548267
    ],
    [
        113.20054010938,
        23.151949539699
    ],
    [
        113.20057498861,
        23.151992888344
    ],
    [
        113.20060822741,
        23.152027040979
    ],
    [
        113.20070028899,
        23.152087579002
    ],
    [
        113.20072044442,
        23.152100796194
    ],
    [
        113.20072545829,
        23.152248032879
    ],
    [
        113.20072531536,
        23.152414350878
    ],
    [
        113.20071643265,
        23.152543378774
    ],
    [
        113.20070479547,
        23.152630943286
    ],
    [
        113.20070378002,
        23.15272402182
    ],
    [
        113.20072178779,
        23.152774988999
    ],
    [
        113.20073731004,
        23.152781232239
    ],
    [
        113.20077379049,
        23.152782772345
    ],
    [
        113.20082034141,
        23.152781696982
    ],
    [
        113.20085109956,
        23.152776553604
    ],
    [
        113.20091452563,
        23.152771660799
    ],
    [
        113.20095671784,
        23.152767134845
    ],
    [
        113.20102938942,
        23.152749603719
    ],
    [
        113.20109525859,
        23.152736531834
    ],
    [
        113.2011744687,
        23.152725944677
    ],
    [
        113.20129667733,
        23.152698884413
    ],
    [
        113.20139220522,
        23.152669300385
    ],
    [
        113.20153400711,
        23.152635128144
    ],
    [
        113.20165132018,
        23.152616301233
    ],
    [
        113.20176863449,
        23.152599919506
    ],
    [
        113.20186633667,
        23.152568681486
    ],
    [
        113.2019349277,
        23.152558560847
    ],
    [
        113.20199861438,
        23.152543098466
    ],
    [
        113.20208543121,
        23.152517477247
    ],
    [
        113.20216027783,
        23.152501556906
    ],
    [
        113.20222613995,
        23.152484162296
    ],
    [
        113.20228465347,
        23.152468521052
    ],
    [
        113.20233499844,
        23.15245030566
    ],
    [
        113.20242753642,
        23.152432735239
    ],
    [
        113.20253259386,
        23.152413057096
    ],
    [
        113.2026384711,
        23.152398251977
    ],
    [
        113.2027348151,
        23.152376555975
    ],
    [
        113.20280883962,
        23.152357136039
    ],
    [
        113.20290000728,
        23.152330919211
    ],
    [
        113.20299471596,
        23.152308444126
    ],
    [
        113.20308888224,
        23.152289236611
    ],
    [
        113.20317841855,
        23.152267395813
    ],
    [
        113.2032641386,
        23.152239109455
    ],
    [
        113.20338006276,
        23.15219920041
    ],
    [
        113.20346905514,
        23.152180090102
    ],
    [
        113.20357137578,
        23.152149909569
    ],
    [
        113.20364620836,
        23.152124526972
    ],
    [
        113.20374363959,
        23.15210881264
    ],
    [
        113.20379562366,
        23.152104158681
    ],
    [
        113.20383181723,
        23.152094881509
    ],
    [
        113.20392271383,
        23.152077924002
    ],
    [
        113.20400081765,
        23.152061450183
    ],
    [
        113.20404626663,
        23.152054465967
    ],
    [
        113.20412274925,
        23.152054300842
    ],
    [
        113.20420711698,
        23.152044241949
    ],
    [
        113.20432822728,
        23.152033316612
    ],
    [
        113.20442838023,
        23.152023821826
    ],
    [
        113.20449886627,
        23.152015082436
    ],
    [
        113.20458650304,
        23.152012036509
    ],
    [
        113.20465589852,
        23.152001962343
    ],
    [
        113.20465943708,
        23.152002447866
    ],
    [
        113.20473862985,
        23.151991946496
    ],
    [
        113.20482953155,
        23.151989670044
    ],
    [
        113.20492451311,
        23.151984889563
    ],
    [
        113.20499527919,
        23.151989996071
    ],
    [
        113.20505270857,
        23.151994503754
    ],
    [
        113.20509244339,
        23.151993868964
    ],
    [
        113.20517110369,
        23.152002381456
    ],
    [
        113.20521764362,
        23.152003810733
    ],
    [
        113.20527315604,
        23.151994245727
    ],
    [
        113.205341731,
        23.151983932058
    ],
    [
        113.20539235042,
        23.151982586796
    ],
    [
        113.20548569217,
        23.151974598007
    ],
    [
        113.20554147882,
        23.151969375821
    ],
    [
        113.20564815981,
        23.151968237012
    ],
    [
        113.20573116419,
        23.151968288653
    ],
    [
        113.20585662221,
        23.15196849241
    ],
    [
        113.2059657551,
        23.151974655201
    ],
    [
        113.20609583404,
        23.151971272857
    ],
    [
        113.20621122125,
        23.151974365785
    ],
    [
        113.20630728771,
        23.151979662292
    ],
    [
        113.20643981397,
        23.151979246603
    ],
    [
        113.206524995,
        23.151986619359
    ],
    [
        113.2066235006,
        23.151982667645
    ],
    [
        113.20670241895,
        23.1519868875
    ],
    [
        113.20677480824,
        23.151994194172
    ],
    [
        113.20683684733,
        23.151989451574
    ],
    [
        113.20691929314,
        23.151982773337
    ],
    [
        113.20708555311,
        23.151982157697
    ],
    [
        113.20717507933,
        23.151985421387
    ],
    [
        113.20727222026,
        23.151984233784
    ],
    [
        113.20739221985,
        23.151987050299
    ],
    [
        113.20753807072,
        23.15199437322
    ],
    [
        113.20761697582,
        23.151990760243
    ],
    [
        113.20762132197,
        23.151981199869
    ],
    [
        113.20763433376,
        23.151917791144
    ],
    [
        113.2076560198,
        23.151811386702
    ],
    [
        113.20766627736,
        23.151703795108
    ],
    [
        113.20769151198,
        23.151611446969
    ],
    [
        113.20769907863,
        23.151542693131
    ],
    [
        113.20773275701,
        23.151461615955
    ],
    [
        113.20775144613,
        23.151347931791
    ],
    [
        113.20777015222,
        23.1512564952
    ],
    [
        113.20778883831,
        23.151137656717
    ],
    [
        113.20782171151,
        23.151070430074
    ],
    [
        113.20783526291,
        23.150998333264
    ],
    [
        113.20785098502,
        23.150917794042
    ],
    [
        113.20785799866,
        23.150834669885
    ],
    [
        113.2078701519,
        23.150709688503
    ],
    [
        113.20788640395,
        23.150608251106
    ],
    [
        113.20789422022,
        23.150504767275
    ],
    [
        113.20791782122,
        23.150405935543
    ],
    [
        113.20793842577,
        23.150301721915
    ],
    [
        113.20796011006,
        23.150184741262
    ],
    [
        113.2079793816,
        23.150118531032
    ],
    [
        113.20798806238,
        23.150081505999
    ],
    [
        113.20800737671,
        23.150076339942
    ],
    [
        113.20804329716,
        23.150084225643
    ],
    [
        113.20806506255,
        23.150082551391
    ],
    [
        113.20810098012,
        23.150086639897
    ],
    [
        113.20813335923,
        23.150088881419
    ],
    [
        113.20817933898,
        23.150086584872
    ],
    [
        113.20821062382,
        23.150080704352
    ],
    [
        113.20828843912,
        23.15008283221
    ],
    [
        113.20835155968,
        23.150081919716
    ],
    [
        113.20842801078,
        23.150080274751
    ],
    [
        113.20856023703,
        23.150081360015
    ],
    [
        113.2086799437,
        23.150078563656
    ],
    [
        113.20875639523,
        23.150081544572
    ],
    [
        113.20881380103,
        23.150083170975
    ],
    [
        113.20890711265,
        23.150077237249
    ],
    [
        113.20897458793,
        23.150085237872
    ],
    [
        113.20903253659,
        23.150087134918
    ],
    [
        113.20908042669,
        23.150100027383
    ],
    [
        113.20912122944,
        23.150093214924
    ],
    [
        113.20917155187,
        23.150083828447
    ],
    [
        113.20922976727,
        23.150080030731
    ],
    [
        113.20932225335,
        23.150067076317
    ],
    [
        113.20942563264,
        23.150072153666
    ],
    [
        113.20951866313,
        23.150062729174
    ],
    [
        113.20959999809,
        23.150057540001
    ],
    [
        113.20964433739,
        23.150054489535
    ],
    [
        113.20973410321,
        23.150048105895
    ],
    [
        113.20982549585,
        23.150035464761
    ],
    [
        113.20990765164,
        23.150041402776
    ],
    [
        113.20998245451,
        23.150036591822
    ],
    [
        113.21004719494,
        23.150035989415
    ],
    [
        113.21014103959,
        23.150033913461
    ],
    [
        113.21021774648,
        23.150032071923
    ],
    [
        113.2102947273,
        23.150034028621
    ],
    [
        113.21039618767,
        23.150035392724
    ],
    [
        113.21047452128,
        23.150029471988
    ],
    [
        113.21054034573,
        23.150028874663
    ],
    [
        113.21057706128,
        23.150022151225
    ],
    [
        113.21063444654,
        23.150012444269
    ],
    [
        113.21067741735,
        23.150005369768
    ],
    [
        113.21077207054,
        23.150003319549
    ],
    [
        113.21084795497,
        23.15000097591
    ],
    [
        113.21092683448,
        23.150004294626
    ],
    [
        113.21102637956,
        23.150001111054
    ],
    [
        113.2111552931,
        23.149991860432
    ],
    [
        113.21130515511,
        23.149994834592
    ],
    [
        113.2114465788,
        23.14999168946
    ],
    [
        113.21145690846,
        23.149984234004
    ],
    [
        113.21147999939,
        23.149946231515
    ],
    [
        113.21149271927,
        23.149855997275
    ],
    [
        113.21151442181,
        23.149776502701
    ],
    [
        113.21153368541,
        23.149709519234
    ],
    [
        113.21156030386,
        23.14965953627
    ],
    [
        113.21161166737,
        23.149604089606
    ],
    [
        113.21163015131,
        23.149590022119
    ],
    [
        113.21165489382,
        23.149581031672
    ],
    [
        113.21171608167,
        23.14957592929
    ],
    [
        113.21182241742,
        23.149575968386
    ],
    [
        113.21193283107,
        23.1495762362
    ],
    [
        113.21200435173,
        23.149572646499
    ],
    [
        113.21212075037,
        23.149580180266
    ],
    [
        113.21217949352,
        23.149584893551
    ],
    [
        113.21224829958,
        23.149591929449
    ],
    [
        113.21229616517,
        23.149598135223
    ],
    [
        113.21236905246,
        23.149610011168
    ],
    [
        113.21243404783,
        23.149614388356
    ],
    [
        113.21251917402,
        23.149631280497
    ],
    [
        113.21261598991,
        23.149645055037
    ],
    [
        113.21269676469,
        23.149664179464
    ],
    [
        113.21278216471,
        23.149688409114
    ],
    [
        113.212896925,
        23.149704434367
    ],
    [
        113.21297742096,
        23.149718151648
    ],
    [
        113.21307396074,
        23.149734944588
    ],
    [
        113.21316995818,
        23.149755819903
    ],
    [
        113.21325779397,
        23.149771910963
    ],
    [
        113.21332632909,
        23.149795551158
    ],
    [
        113.2134209636,
        23.149816459001
    ],
    [
        113.21351288245,
        23.149843915011
    ],
    [
        113.21361893001,
        23.149859553805
    ],
    [
        113.21371626746,
        23.149863359299
    ],
    [
        113.21379321703,
        23.149873635526
    ],
    [
        113.21388022432,
        23.149882720944
    ],
    [
        113.21397703217,
        23.149912324899
    ],
    [
        113.214092321,
        23.149935225238
    ],
    [
        113.2141988977,
        23.149943035188
    ],
    [
        113.21432205423,
        23.149948235967
    ],
    [
        113.21438784327,
        23.149947811767
    ],
    [
        113.21444709645,
        23.14993199487
    ],
    [
        113.21449357146,
        23.14991522907
    ],
    [
        113.214513659,
        23.149872966232
    ],
    [
        113.21452394237,
        23.149805303177
    ],
    [
        113.214524457,
        23.149763245139
    ],
    [
        113.21453586879,
        23.149754715457
    ],
    [
        113.21458561515,
        23.14975202673
    ],
    [
        113.21465602098,
        23.149748854633
    ],
    [
        113.21471935748,
        23.149744673821
    ],
    [
        113.2147870478,
        23.149747776704
    ],
    [
        113.2148517435,
        23.14974548744
    ],
    [
        113.2149569351,
        23.149733837791
    ],
    [
        113.21512137735,
        23.149714006463
    ],
    [
        113.21524830864,
        23.14970026396
    ],
    [
        113.21533961859,
        23.149670333639
    ],
    [
        113.21539939934,
        23.149643702109
    ],
    [
        113.21542981621,
        23.149605693307
    ],
    [
        113.21544935437,
        23.14955856673
    ],
    [
        113.21546016978,
        23.149474898934
    ],
    [
        113.21547588699,
        23.149404477648
    ],
    [
        113.215483161,
        23.1493083645
    ],
    [
        113.21547577195,
        23.149233555802
    ],
    [
        113.21547951836,
        23.149145344943
    ],
    [
        113.21549521993,
        23.149049964128
    ],
    [
        113.21550279142,
        23.148990746046
    ],
    [
        113.21552396813,
        23.148953914571
    ],
    [
        113.21555792853,
        23.148930525206
    ],
    [
        113.21562016559,
        23.148921243911
    ],
    [
        113.21572289916,
        23.148910493894
    ],
    [
        113.21583977098,
        23.148909928216
    ],
    [
        113.21591912844,
        23.148901313923
    ],
    [
        113.21601506676,
        23.148897162471
    ],
    [
        113.2161678003,
        23.148884899151
    ],
    [
        113.21633901771,
        23.148883610552
    ],
    [
        113.21649419636,
        23.148882488249
    ],
    [
        113.21665073517,
        23.148889512417
    ],
    [
        113.21677139617,
        23.148892526881
    ],
    [
        113.2168515634,
        23.1488940028
    ],
    [
        113.21691896707,
        23.148909972492
    ],
    [
        113.21697875893,
        23.14892248379
    ],
    [
        113.21705948723,
        23.148954897232
    ],
    [
        113.21712742815,
        23.148964905083
    ],
    [
        113.21732311839,
        23.149031101914
    ],
    [
        113.21749679098,
        23.149093981445
    ],
    [
        113.21764327101,
        23.14913214252
    ],
    [
        113.21777696632,
        23.149153872292
    ],
    [
        113.21790277301,
        23.149166182462
    ],
    [
        113.217996776,
        23.149159487244
    ],
    [
        113.21808234568,
        23.14913875573
    ],
    [
        113.21813312678,
        23.149101201127
    ],
    [
        113.21816297148,
        23.149039389106
    ],
    [
        113.2181648372,
        23.148984842671
    ],
    [
        113.21816369897,
        23.148906715403
    ],
    [
        113.21816253528,
        23.148789249194
    ],
    [
        113.21815427202,
        23.148615676738
    ],
    [
        113.21812484452,
        23.14848323177
    ],
    [
        113.218097028,
        23.148319575513
    ],
    [
        113.21806810435,
        23.148121744392
    ],
    [
        113.218033509,
        23.147976319155
    ],
    [
        113.21799178417,
        23.147722429034
    ],
    [
        113.21797269272,
        23.147602117979
    ],
    [
        113.21797562977,
        23.147516092703
    ],
    [
        113.21796740911,
        23.147398953856
    ],
    [
        113.21796520584,
        23.147348780123
    ],
    [
        113.21797523648,
        23.147311263227
    ],
    [
        113.21801053616,
        23.147275993889
    ],
    [
        113.21805372269,
        23.147254230363
    ],
    [
        113.21805290666,
        23.147252608793
    ],
    [
        113.21813711947,
        23.147233248507
    ],
    [
        113.21819362451,
        23.14722305523
    ],
    [
        113.21826860734,
        23.147219509161
    ],
    [
        113.21834902356,
        23.147217284145
    ],
    [
        113.21843216064,
        23.147223997579
    ],
    [
        113.21857017264,
        23.147228692352
    ],
    [
        113.21870519561,
        23.147237765266
    ],
    [
        113.2187932228,
        23.147253693691
    ],
    [
        113.21891900139,
        23.147257701344
    ],
    [
        113.21914419884,
        23.147261864452
    ],
    [
        113.21936938261,
        23.147257932155
    ],
    [
        113.21954729289,
        23.147249731588
    ],
    [
        113.21967548977,
        23.147237527628
    ],
    [
        113.21980857284,
        23.147225579216
    ],
    [
        113.2199630899,
        23.147180418596
    ],
    [
        113.2201306405,
        23.147137372788
    ],
    [
        113.220205318,
        23.14711984565
    ],
    [
        113.22024632131,
        23.147108485452
    ],
    [
        113.22025254468,
        23.147068568492
    ],
    [
        113.22025626997,
        23.146935067455
    ],
    [
        113.22024884549,
        23.146774229485
    ],
    [
        113.22023002915,
        23.146637874433
    ],
    [
        113.220190565,
        23.146487532064
    ],
    [
        113.22017253362,
        23.146293658533
    ],
    [
        113.22014472632,
        23.146099300176
    ],
    [
        113.22012049778,
        23.145992822175
    ],
    [
        113.22010683478,
        23.145834736167
    ],
    [
        113.22009071599,
        23.145652248348
    ],
    [
        113.22006077003,
        23.145514606725
    ],
    [
        113.22004766204,
        23.14537333921
    ],
    [
        113.22003345007,
        23.145194639844
    ],
    [
        113.22000318826,
        23.144960149975
    ],
    [
        113.21998569869,
        23.144735351506
    ],
    [
        113.21995924242,
        23.144497042987
    ],
    [
        113.21994585152,
        23.144316170992
    ],
    [
        113.21992213325,
        23.14411718524
    ],
    [
        113.2199120226,
        23.143977259605
    ],
    [
        113.21989129235,
        23.143771746109
    ],
    [
        113.21986704597,
        23.143596910696
    ],
    [
        113.21984308955,
        23.143463581783
    ],
    [
        113.21979058923,
        23.14326613316
    ],
    [
        113.21974947484,
        23.143008933124
    ],
    [
        113.21971572885,
        23.142836331448
    ],
    [
        113.21967841601,
        23.142562562892
    ],
    [
        113.21965010984,
        23.142401324019
    ],
    [
        113.21963323449,
        23.142302138893
    ],
    [
        113.21961036658,
        23.142152532566
    ],
    [
        113.21959864715,
        23.142035682052
    ],
    [
        113.21957087555,
        23.141836191323
    ],
    [
        113.21954826164,
        23.141620934297
    ],
    [
        113.21952893429,
        23.141486228805
    ],
    [
        113.21951205331,
        23.141354492309
    ],
    [
        113.21949839968,
        23.141110424006
    ],
    [
        113.21947362068,
        23.140895726569
    ],
    [
        113.21945428509,
        23.140713006401
    ],
    [
        113.2194412006,
        23.140538113713
    ],
    [
        113.2194223928,
        23.140280246426
    ],
    [
        113.21939245657,
        23.14004334106
    ],
    [
        113.21937476689,
        23.139897236045
    ],
    [
        113.21934703492,
        23.139782665614
    ],
    [
        113.21932066465,
        23.13968192231
    ],
    [
        113.2192766301,
        23.139540604287
    ],
    [
        113.21922009254,
        23.139357051746
    ],
    [
        113.21918882383,
        23.139201003739
    ],
    [
        113.21914723836,
        23.139069169742
    ],
    [
        113.21910294123,
        23.13896068557
    ],
    [
        113.21906352941,
        23.138825584921
    ],
    [
        113.21900564397,
        23.138675962944
    ],
    [
        113.21896053099,
        23.138554197694
    ],
    [
        113.21892628394,
        23.13842883274
    ],
    [
        113.21888660959,
        23.138339043664
    ],
    [
        113.21881024974,
        23.138160533988
    ],
    [
        113.21872791035,
        23.137952231715
    ],
    [
        113.21863226085,
        23.137746472255
    ],
    [
        113.21853443737,
        23.137527715654
    ],
    [
        113.2184743826,
        23.137367015555
    ],
    [
        113.21843606699,
        23.137258515059
    ],
    [
        113.21838334984,
        23.137111058721
    ],
    [
        113.21834992733,
        23.137029652461
    ],
    [
        113.21832818468,
        23.136912352852
    ],
    [
        113.2182743798,
        23.136718251455
    ],
    [
        113.21824285674,
        23.136570915772
    ],
    [
        113.21821649567,
        23.136399399448
    ],
    [
        113.21816921566,
        23.136207696436
    ],
    [
        113.21813660966,
        23.136074207283
    ],
    [
        113.21810590631,
        23.135944231259
    ],
    [
        113.21808199622,
        23.135838889839
    ],
    [
        113.21803798124,
        23.135667784707
    ],
    [
        113.21800510704,
        23.135484931468
    ],
    [
        113.21797304865,
        23.135355241403
    ],
    [
        113.21795104351,
        23.135236596603
    ],
    [
        113.21792414984,
        23.135072417622
    ],
    [
        113.21790486494,
        23.134910621854
    ],
    [
        113.21788014735,
        23.134750225284
    ],
    [
        113.21787010212,
        23.134602464521
    ],
    [
        113.21784837804,
        23.134406781608
    ],
    [
        113.21782420633,
        23.134268355143
    ],
    [
        113.21781253739,
        23.134086971846
    ],
    [
        113.2177929953,
        23.133857908789
    ],
    [
        113.21777942386,
        23.133719672132
    ],
    [
        113.21775770599,
        23.133548134974
    ],
    [
        113.21773625828,
        23.133401823607
    ],
    [
        113.21772024715,
        23.133244619429
    ],
    [
        113.21770885882,
        23.133069204727
    ],
    [
        113.21769637851,
        23.132940184397
    ],
    [
        113.21767738427,
        23.132770527401
    ],
    [
        113.21766002303,
        23.132592991546
    ],
    [
        113.21765788894,
        23.13235918465
    ],
    [
        113.21764759468,
        23.132188646182
    ],
    [
        113.2176416787,
        23.131869153743
    ],
    [
        113.21764686796,
        23.131738367248
    ],
    [
        113.21762870979,
        23.131521508344
    ],
    [
        113.21762467814,
        23.131325695018
    ],
    [
        113.21762418146,
        23.131126870077
    ],
    [
        113.21761198799,
        23.130989442296
    ],
    [
        113.21759788441,
        23.130887835498
    ],
    [
        113.2175778286,
        23.130690524769
    ],
    [
        113.21756645081,
        23.130562314115
    ],
    [
        113.21756107185,
        23.130361088898
    ],
    [
        113.21754616338,
        23.130234806073
    ],
    [
        113.21755654508,
        23.130040778421
    ],
    [
        113.21755851648,
        23.129811285261
    ],
    [
        113.21755830683,
        23.129613275091
    ],
    [
        113.21757030881,
        23.129468603018
    ],
    [
        113.2175836799,
        23.129295439262
    ],
    [
        113.21759105829,
        23.129170606089
    ],
    [
        113.21760498135,
        23.12898035013
    ],
    [
        113.21761970052,
        23.128848135102
    ],
    [
        113.21762599385,
        23.128726023881
    ],
    [
        113.21763365471,
        23.128581659765
    ],
    [
        113.21763695828,
        23.12846635397
    ],
    [
        113.21762937736,
        23.128395076991
    ],
    [
        113.21760331968,
        23.128325575506
    ],
    [
        113.21758052017,
        23.128262558338
    ],
    [
        113.21753109982,
        23.128181582867
    ],
    [
        113.21748466485,
        23.128109265088
    ],
    [
        113.21745099445,
        23.128052306106
    ],
    [
        113.21744611364,
        23.128026848881
    ],
    [
        113.21741189633,
        23.127978575299
    ],
    [
        113.21737332963,
        23.127934678279
    ],
    [
        113.21732823766,
        23.127900058545
    ],
    [
        113.21727852418,
        23.127870089899
    ],
    [
        113.217215766,
        23.127843486835
    ],
    [
        113.21708807099,
        23.127797361104
    ],
    [
        113.21695738333,
        23.127753444197
    ],
    [
        113.21687179427,
        23.127729766445
    ],
    [
        113.21678701254,
        23.12772236222
    ],
    [
        113.21675087565,
        23.127708571798
    ],
    [
        113.21665820831,
        23.127708568668
    ],
    [
        113.21656227834,
        23.1277088726
    ],
    [
        113.2164712378,
        23.127711038922
    ],
    [
        113.21636388683,
        23.127720682465
    ],
    [
        113.21629050849,
        23.127722702735
    ],
    [
        113.21618016191,
        23.127739441512
    ],
    [
        113.21608123263,
        23.127745234608
    ],
    [
        113.21596925083,
        23.127763905629
    ],
    [
        113.2158939635,
        23.12777030664
    ],
    [
        113.2158110595,
        23.127790346282
    ],
    [
        113.21576376648,
        23.127793235619
    ],
    [
        113.21568983733,
        23.12779556713
    ],
    [
        113.2155876412,
        23.127795191179
    ],
    [
        113.21547810107,
        23.127803574473
    ],
    [
        113.21536204047,
        23.127800096277
    ],
    [
        113.21528755719,
        23.127816560947
    ],
    [
        113.21521063202,
        23.127820034432
    ],
    [
        113.21510298614,
        23.127833312986
    ],
    [
        113.21501545487,
        23.127843413967
    ],
    [
        113.21492139626,
        23.12785901185
    ],
    [
        113.21478493574,
        23.127860945602
    ],
    [
        113.21464684095,
        23.127863724065
    ],
    [
        113.21446497594,
        23.127866161439
    ],
    [
        113.2142692364,
        23.127880434412
    ],
    [
        113.21411318918,
        23.127879932665
    ],
    [
        113.21396882483,
        23.127888815504
    ],
    [
        113.21383451985,
        23.127890008568
    ],
    [
        113.2137469721,
        23.127899107461
    ],
    [
        113.21357676814,
        23.127914826213
    ],
    [
        113.21340846657,
        23.127922135847
    ],
    [
        113.21324450982,
        23.127932942452
    ],
    [
        113.21309061614,
        23.127927649157
    ],
    [
        113.21297586687,
        23.127939821369
    ],
    [
        113.21275724106,
        23.127959997338
    ],
    [
        113.21258076648,
        23.127956108626
    ],
    [
        113.21240455856,
        23.127954408107
    ],
    [
        113.21227266868,
        23.127960602623
    ],
    [
        113.21212337519,
        23.127959425487
    ],
    [
        113.21199148557,
        23.127952354128
    ],
    [
        113.21184355136,
        23.127938168706
    ],
    [
        113.21176142872,
        23.127920739628
    ],
    [
        113.21169508043,
        23.12789905011
    ],
    [
        113.21161677375,
        23.127856898306
    ],
    [
        113.21159856908,
        23.127816439295
    ],
    [
        113.21157580891,
        23.127613834441
    ],
    [
        113.21156611888,
        23.127378788888
    ],
    [
        113.2115561234,
        23.127225391393
    ],
    [
        113.211547431,
        23.127201902326
    ],
    [
        113.21154666289,
        23.127094500499
    ],
    [
        113.21150862521,
        23.127011978053
    ],
    [
        113.21143659145,
        23.126930698513
    ],
    [
        113.21133872461,
        23.126839984838
    ],
    [
        113.21127673059,
        23.126806866474
    ],
    [
        113.21120006314,
        23.126744372591
    ],
    [
        113.21119164716,
        23.126711659971
    ],
    [
        113.21118785582,
        23.126676718443
    ],
    [
        113.21120119358,
        23.126653221618
    ],
    [
        113.21126839658,
        23.126598660283
    ],
    [
        113.21132989828,
        23.126521932515
    ],
    [
        113.21136909307,
        23.126456338822
    ],
    [
        113.21140395113,
        23.126360150928
    ],
    [
        113.21141432562,
        23.126278105877
    ],
    [
        113.21142989234,
        23.126146087635
    ],
    [
        113.21141990289,
        23.125998388917
    ],
    [
        113.21140635568,
        23.125896574534
    ],
    [
        113.21138680768,
        23.125830097054
    ],
    [
        113.21136859992,
        23.125802389833
    ],
    [
        113.21128785266,
        23.125748081015
    ],
    [
        113.21120600884,
        23.125709250928
    ],
    [
        113.21111899955,
        23.125664795348
    ],
    [
        113.21104775294,
        23.125642112079
    ],
    [
        113.21095911136,
        23.125595245259
    ],
    [
        113.21094281611,
        23.12554961677
    ],
    [
        113.21093196531,
        23.125494967266
    ],
    [
        113.2109464267,
        23.125406899806
    ],
    [
        113.21096768328,
        23.125327695618
    ],
    [
        113.21099437917,
        23.125249506599
    ],
    [
        113.21103550139,
        23.125150518545
    ],
    [
        113.21104804833,
        23.125084175761
    ],
    [
        113.21108265447,
        23.124965201493
    ],
    [
        113.21113329225,
        23.124874231215
    ],
    [
        113.21118148212,
        23.124783565148
    ],
    [
        113.21125254773,
        23.124639447473
    ],
    [
        113.21132360157,
        23.124516489623
    ],
    [
        113.21142407931,
        23.124303927937
    ],
    [
        113.21151772051,
        23.124156554903
    ],
    [
        113.21153596509,
        23.124116997211
    ],
    [
        113.21151261882,
        23.12404459983
    ],
    [
        113.21146724492,
        23.123970038862
    ],
    [
        113.21140339897,
        23.123859096107
    ],
    [
        113.21129552188,
        23.123701791509
    ],
    [
        113.2112501529,
        23.123618828942
    ],
    [
        113.21116864048,
        23.123488321328
    ],
    [
        113.21111296966,
        23.123351519679
    ],
    [
        113.21107413313,
        23.12326088436
    ],
    [
        113.21101626736,
        23.123155577339
    ],
    [
        113.21094779132,
        23.123055020518
    ],
    [
        113.21089290757,
        23.122965139805
    ],
    [
        113.21083395729,
        23.122854429225
    ],
    [
        113.21079104161,
        23.122763583073
    ],
    [
        113.2107622361,
        23.122724358894
    ],
    [
        113.21072336192,
        23.122692861146
    ],
    [
        113.21068420628,
        23.122675743174
    ],
    [
        113.21058740129,
        23.122637684688
    ],
    [
        113.2104650283,
        23.122598071282
    ],
    [
        113.21033476266,
        23.122562640508
    ],
    [
        113.21018873236,
        23.122506004077
    ],
    [
        113.21007995639,
        23.122462982749
    ],
    [
        113.21004135661,
        23.122423360802
    ],
    [
        113.21002151747,
        23.122396234281
    ],
    [
        113.21002233853,
        23.122388628813
    ],
    [
        113.21001173578,
        23.122379821354
    ],
    [
        113.21001448698,
        23.122332861749
    ],
    [
        113.21001370799,
        23.122276999283
    ],
    [
        113.21004395456,
        23.122197392803
    ],
    [
        113.21009410612,
        23.122046457516
    ],
    [
        113.21017013303,
        23.121845813628
    ],
    [
        113.21023633841,
        23.121688972252
    ],
    [
        113.21027667565,
        23.121572620048
    ],
    [
        113.21035240165,
        23.121416199192
    ],
    [
        113.21039844858,
        23.121304113974
    ],
    [
        113.21045432816,
        23.121134942708
    ],
    [
        113.21051101862,
        23.120973899643
    ],
    [
        113.21056662911,
        23.120802566443
    ],
    [
        113.21061704434,
        23.12066981744
    ],
    [
        113.21068136523,
        23.120491051224
    ],
    [
        113.21071106699,
        23.120416618617
    ],
    [
        113.21074623137,
        23.120311467048
    ],
    [
        113.21077046435,
        23.120276434415
    ],
    [
        113.21079604415,
        23.120259014152
    ],
    [
        113.21083956185,
        23.120259261935
    ],
    [
        113.21086050837,
        23.12025437918
    ],
    [
        113.21091680765,
        23.120256361831
    ],
    [
        113.21097067256,
        23.120239663483
    ],
    [
        113.21102345463,
        23.120215657882
    ],
    [
        113.21110778924,
        23.120186909657
    ],
    [
        113.21117280513,
        23.120168447983
    ],
    [
        113.21124136485,
        23.120138281283
    ],
    [
        113.21129822958,
        23.120107723621
    ],
    [
        113.21135266672,
        23.120049805252
    ],
    [
        113.21144848128,
        23.119940105747
    ],
    [
        113.2115364229,
        23.119810982995
    ],
    [
        113.21161023143,
        23.119669836935
    ],
    [
        113.21165981394,
        23.119557203416
    ],
    [
        113.21168654519,
        23.119453806143
    ],
    [
        113.21174429135,
        23.119335107101
    ],
    [
        113.21177972546,
        23.119231874904
    ],
    [
        113.21182275451,
        23.119154044556
    ],
    [
        113.21187284682,
        23.119085621167
    ],
    [
        113.21192019047,
        23.119054119324
    ],
    [
        113.21196916298,
        23.119025853665
    ],
    [
        113.21202519319,
        23.119013505388
    ],
    [
        113.21207578517,
        23.118999869373
    ],
    [
        113.21211140717,
        23.119002690339
    ],
    [
        113.2121579141,
        23.118995887332
    ],
    [
        113.21222564284,
        23.118974996879
    ],
    [
        113.21226372863,
        23.118956094049
    ],
    [
        113.21227679976,
        23.118932882688
    ],
    [
        113.21228497947,
        23.118905390825
    ],
    [
        113.21228910249,
        23.118849740896
    ],
    [
        113.21227964086,
        23.118779066267
    ],
    [
        113.2122786278,
        23.118685236167
    ],
    [
        113.21228308875,
        23.118547673721
    ],
    [
        113.21228237873,
        23.11841614055
    ],
    [
        113.21228300369,
        23.118315781686
    ],
    [
        113.21227136629,
        23.118247032136
    ],
    [
        113.21226659247,
        23.118098461432
    ],
    [
        113.2122495399,
        23.118001570678
    ],
    [
        113.21221070441,
        23.117939117113
    ],
    [
        113.21218410368,
        23.117879499737
    ],
    [
        113.21205069697,
        23.117739545687
    ],
    [
        113.21194175101,
        23.117614762666
    ],
    [
        113.21183985407,
        23.117514581497
    ],
    [
        113.21174039842,
        23.117420615009
    ],
    [
        113.21165833868,
        23.117336473242
    ],
    [
        113.21162793125,
        23.117275014926
    ],
    [
        113.21160811449,
        23.11723213886
    ],
    [
        113.21159945574,
        23.11718017333
    ],
    [
        113.21160903779,
        23.117105197535
    ],
    [
        113.21162459368,
        23.117041267135
    ],
    [
        113.21163360136,
        23.117002370616
    ],
    [
        113.21163882223,
        23.116939383084
    ],
    [
        113.21164136631,
        23.116826525071
    ],
    [
        113.21163866925,
        23.116800250685
    ],
    [
        113.21160468463,
        23.11678847037
    ],
    [
        113.21151249943,
        23.116777691964
    ],
    [
        113.21138904369,
        23.116759177573
    ],
    [
        113.21128217166,
        23.116745886528
    ],
    [
        113.21120820305,
        23.11673706463
    ],
    [
        113.21111709511,
        23.116733076488
    ],
    [
        113.21106760272,
        23.116724490193
    ],
    [
        113.21107171556,
        23.116685924603
    ],
    [
        113.21106977002,
        23.116419615156
    ],
    [
        113.2110687597,
        23.11633039806
    ],
    [
        113.21106062226,
        23.11630527954
    ],
    [
        113.2110135867,
        23.116286085991
    ],
    [
        113.21094152732,
        23.116268302014
    ],
    [
        113.21086566017,
        23.116249757081
    ],
    [
        113.21076340349,
        23.116238068849
    ],
    [
        113.21067012699,
        23.116219760339
    ],
    [
        113.21057902608,
        23.116200614983
    ],
    [
        113.21046454105,
        23.116171477671
    ],
    [
        113.21030981388,
        23.116124170094
    ],
    [
        113.21019641739,
        23.116090155227
    ],
    [
        113.21010585613,
        23.11606994421
    ],
    [
        113.20995927587,
        23.116030425287
    ],
    [
        113.20984941086,
        23.115996386323
    ],
    [
        113.20976782336,
        23.115975257982
    ],
    [
        113.20966420224,
        23.115952808129
    ],
    [
        113.20957145464,
        23.115937537721
    ],
    [
        113.20945613432,
        23.115914447841
    ],
    [
        113.2093196037,
        23.115879998222
    ],
    [
        113.20920319975,
        23.115847990114
    ],
    [
        113.20910011998,
        23.115820955804
    ],
    [
        113.2090582478,
        23.115795507163
    ],
    [
        113.20902398655,
        23.11577700397
    ],
    [
        113.20900932094,
        23.115749004095
    ],
    [
        113.2089998303,
        23.115714151074
    ],
    [
        113.20900504001,
        23.115668242428
    ],
    [
        113.20902300926,
        23.115652258997
    ],
    [
        113.20904614112,
        23.115643254727
    ],
    [
        113.20907879554,
        23.115633032153
    ],
    [
        113.20912723405,
        23.11561635096
    ],
    [
        113.20916751195,
        23.115598700404
    ],
    [
        113.20918059427,
        23.115571395954
    ],
    [
        113.20919095518,
        23.115545214504
    ],
    [
        113.20919235177,
        23.115504512828
    ],
    [
        113.20918513226,
        23.115364396011
    ],
    [
        113.20917822739,
        23.11517762615
    ],
    [
        113.20918158191,
        23.115078043789
    ],
    [
        113.20920923779,
        23.11487994258
    ],
    [
        113.20921700865,
        23.114711410604
    ],
    [
        113.20921852421,
        23.114541881298
    ],
    [
        113.2092254273,
        23.114430858868
    ],
    [
        113.20923041511,
        23.114332067826
    ],
    [
        113.20924762496,
        23.114254803337
    ],
    [
        113.209268335,
        23.114216816067
    ],
    [
        113.20931680292,
        23.114167865484
    ],
    [
        113.20937451387,
        23.11412529708
    ],
    [
        113.20948336352,
        23.11408582047
    ],
    [
        113.20951873471,
        23.114078009543
    ],
    [
        113.20958697621,
        23.114118565215
    ],
    [
        113.20968838828,
        23.114176297903
    ],
    [
        113.20976151265,
        23.11423008313
    ],
    [
        113.20982703584,
        23.114266617361
    ],
    [
        113.20987349802,
        23.114324025114
    ],
    [
        113.20991696905,
        23.114380118654
    ],
    [
        113.2099389754,
        23.114409382643
    ],
    [
        113.20994383429,
        23.11444999877
    ],
    [
        113.2099385839,
        23.114539298941
    ],
    [
        113.2099491123,
        23.114626758198
    ],
    [
        113.20995452337,
        23.114658688104
    ],
    [
        113.20997870695,
        23.11468683834
    ],
    [
        113.21000615321,
        23.114716572146
    ],
    [
        113.21003388825,
        23.114727860009
    ],
    [
        113.21013126574,
        23.114730617667
    ],
    [
        113.21024849256,
        23.114739896109
    ],
    [
        113.21036924902,
        23.114754289059
    ],
    [
        113.21049463684,
        23.114758594859
    ],
    [
        113.21059444409,
        23.114775179816
    ],
    [
        113.21068174851,
        23.11478081483
    ],
    [
        113.21072119053,
        23.114777044395
    ],
    [
        113.21074946709,
        23.114788337336
    ],
    [
        113.21077475635,
        23.114794516654
    ],
    [
        113.21078588177,
        23.114823120326
    ],
    [
        113.21080733022,
        23.114865421609
    ],
    [
        113.21083936011,
        23.114936334327
    ],
    [
        113.21085429682,
        23.114961091993
    ],
    [
        113.2108874697,
        23.114971238979
    ],
    [
        113.21092717305,
        23.114978047592
    ],
    [
        113.21094729995,
        23.114977787329
    ],
    [
        113.21099164246,
        23.114967179922
    ],
    [
        113.21104305821,
        23.114954313045
    ],
    [
        113.21109367122,
        23.114926541391
    ],
    [
        113.21115298991,
        23.114895676617
    ],
    [
        113.21121257866,
        23.114866437934
    ],
    [
        113.21128931633,
        23.114820439501
    ],
    [
        113.21136630373,
        23.114798037293
    ],
    [
        113.2114533858,
        23.114739711497
    ],
    [
        113.2115733762,
        23.114679079711
    ],
    [
        113.21170314083,
        23.114634066141
    ],
    [
        113.2117779611,
        23.114597879699
    ],
    [
        113.21180082516,
        23.114575899567
    ],
    [
        113.2118267003,
        23.114532456722
    ],
    [
        113.21185449775,
        23.114468649616
    ],
    [
        113.21187764856,
        23.114430394328
    ],
    [
        113.2119073104,
        23.114409145722
    ],
    [
        113.21202427326,
        23.114380318883
    ],
    [
        113.21208711146,
        23.11435893988
    ],
    [
        113.21217713818,
        23.114342657987
    ],
    [
        113.21223207988,
        23.114331144524
    ],
    [
        113.21229137238,
        23.114319309482
    ],
    [
        113.21236998091,
        23.114297210205
    ],
    [
        113.21243581539,
        23.114267131281
    ],
    [
        113.21254461926,
        23.114230577906
    ],
    [
        113.21265150977,
        23.114203005265
    ],
    [
        113.21274861439,
        23.114170402221
    ],
    [
        113.21283267157,
        23.114131720046
    ],
    [
        113.21290476012,
        23.11409697882
    ],
    [
        113.21294611154,
        23.114073988169
    ],
    [
        113.21300050353,
        23.11406251013
    ],
    [
        113.21307174598,
        23.114058705383
    ],
    [
        113.21310953348,
        23.114066136328
    ],
    [
        113.2131584635,
        23.114079136199
    ],
    [
        113.21322941657,
        23.114092429102
    ],
    [
        113.21326992219,
        23.114099833369
    ],
    [
        113.21332047743,
        23.114118244651
    ],
    [
        113.21335880235,
        23.114131100446
    ],
    [
        113.21337484285,
        23.114132275324
    ],
    [
        113.21340828043,
        23.114137593691
    ],
    [
        113.21344662244,
        23.114131466779
    ],
    [
        113.21348959012,
        23.11412122087
    ],
    [
        113.21354698591,
        23.11409101654
    ],
    [
        113.21358642727,
        23.114071320542
    ],
    [
        113.21362397125,
        23.114045137632
    ],
    [
        113.21363079353,
        23.114017940544
    ],
    [
        113.213638721,
        23.113971746317
    ],
    [
        113.21363740701,
        23.113922942581
    ],
    [
        113.2136353394,
        23.113807700099
    ],
    [
        113.21362536004,
        23.113721836524
    ],
    [
        113.21361569927,
        23.113586337634
    ],
    [
        113.21360683666,
        23.113469814877
    ],
    [
        113.21359525855,
        23.113350067922
    ],
    [
        113.21357739402,
        23.113265648743
    ],
    [
        113.21355434808,
        23.11319783158
    ],
    [
        113.21354600721,
        23.11310544145
    ],
    [
        113.21352680157,
        23.113002053174
    ],
    [
        113.21351465409,
        23.112910248307
    ],
    [
        113.21351120149,
        23.112824312886
    ],
    [
        113.21351075225,
        23.112725325734
    ],
    [
        113.21351079971,
        23.112675693523
    ],
    [
        113.21353125936,
        23.112604407293
    ],
    [
        113.21355715703,
        23.11253278947
    ],
    [
        113.21359228733,
        23.112473002599
    ],
    [
        113.21362549139,
        23.112437104604
    ],
    [
        113.21367610359,
        23.112392878174
    ],
    [
        113.21372970272,
        23.112352146375
    ],
    [
        113.21378437016,
        23.112330932104
    ],
    [
        113.2138428408,
        23.112312390447
    ],
    [
        113.21389994426,
        23.112301460103
    ],
    [
        113.21395052835,
        23.112284365169
    ],
    [
        113.21399892875,
        23.112275974527
    ],
    [
        113.21403102147,
        23.112262880098
    ],
    [
        113.21405250184,
        23.112259664601
    ],
    [
        113.21410035228,
        23.112256978927
    ],
    [
        113.21415200583,
        23.112256966243
    ],
    [
        113.21418218355,
        23.112255557996
    ],
    [
        113.21420448346,
        23.11224772554
    ],
    [
        113.21423004273,
        23.11224284199
    ],
    [
        113.21426568132,
        23.112216425934
    ],
    [
        113.21429452018,
        23.112193337563
    ],
    [
        113.2142934828,
        23.112141547291
    ],
    [
        113.21429105444,
        23.112122588326
    ],
    [
        113.21428996989,
        23.11211961653
    ],
    [
        113.21426963648,
        23.112062064828
    ],
    [
        113.21424632577,
        23.111990984637
    ],
    [
        113.21422465174,
        23.111914191974
    ],
    [
        113.21419970145,
        23.111851808873
    ],
    [
        113.21416389698,
        23.111768659341
    ],
    [
        113.21415171835,
        23.111712106948
    ],
    [
        113.21414172021,
        23.111649835847
    ],
    [
        113.21413712763,
        23.111620052016
    ],
    [
        113.2141395871,
        23.111607007508
    ],
    [
        113.21416108039,
        23.111590233065
    ],
    [
        113.21418938523,
        23.111557927069
    ],
    [
        113.21424568378,
        23.111533188088
    ],
    [
        113.2143457718,
        23.111486290405
    ],
    [
        113.2144629931,
        23.11143081267
    ],
    [
        113.21459272518,
        23.111367078694
    ],
    [
        113.21471537628,
        23.11131427872
    ],
    [
        113.21485082977,
        23.111232339853
    ],
    [
        113.21495255381,
        23.111171096866
    ],
    [
        113.21498982601,
        23.111138445841
    ],
    [
        113.21501404768,
        23.111108639495
    ],
    [
        113.21502114317,
        23.111080090913
    ],
    [
        113.21503126907,
        23.111010559137
    ],
    [
        113.21503673416,
        23.110981484646
    ],
    [
        113.21506992727,
        23.11095023302
    ],
    [
        113.21512384025,
        23.110856396607
    ],
    [
        113.2149730212,
        23.11081343493
    ],
    [
        113.21487492337,
        23.110781071955
    ],
    [
        113.21482546012,
        23.110770999663
    ],
    [
        113.21485217547,
        23.110694245589
    ],
    [
        113.21488240125,
        23.11064105156
    ],
    [
        113.21490936307,
        23.110589789863
    ],
    [
        113.21500068931,
        23.110597272411
    ],
    [
        113.21506484155,
        23.110595270423
    ],
    [
        113.21513687489,
        23.110594277662
    ],
    [
        113.21515970382,
        23.11059811796
    ],
    [
        113.21519747305,
        23.110611573571
    ],
    [
        113.21526921321,
        23.110630660546
    ],
    [
        113.21532735708,
        23.110654767015
    ],
    [
        113.21541948152,
        23.110673661808
    ],
    [
        113.21549069221,
        23.110675951199
    ],
    [
        113.21554832667,
        23.110663459218
    ],
    [
        113.21557497627,
        23.110650183657
    ],
    [
        113.2155899697,
        23.110605289412
    ],
    [
        113.21560766635,
        23.110575285859
    ],
    [
        113.21560335112,
        23.110541426184
    ],
    [
        113.21556506061,
        23.110507894262
    ],
    [
        113.21553327867,
        23.110488945761
    ],
    [
        113.21547837179,
        23.110491648333
    ],
    [
        113.21538107121,
        23.110485546954
    ],
    [
        113.2153144804,
        23.110482946863
    ],
    [
        113.21526582796,
        23.110480986269
    ],
    [
        113.21516691608,
        23.110451864056
    ],
    [
        113.21511120698,
        23.11043804636
    ],
    [
        113.21507641549,
        23.110436496588
    ],
    [
        113.21504571384,
        23.110422159744
    ],
    [
        113.2150153022,
        23.110389378448
    ],
    [
        113.21499740528,
        23.110345623073
    ],
    [
        113.21499010044,
        23.110310982031
    ],
    [
        113.21499910203,
        23.110279430836
    ],
    [
        113.21501244044,
        23.110260311596
    ],
    [
        113.21503909532,
        23.110244041707
    ],
    [
        113.21507960827,
        23.110232515012
    ],
    [
        113.21516577341,
        23.110234094202
    ],
    [
        113.21529051849,
        23.110252112638
    ],
    [
        113.2154179749,
        23.110274455895
    ],
    [
        113.21552748966,
        23.110296985415
    ],
    [
        113.21563049416,
        23.110304670252
    ],
    [
        113.21568893067,
        23.110304381289
    ],
    [
        113.21573622518,
        23.110302031405
    ],
    [
        113.21576940465,
        23.110281103826
    ],
    [
        113.21580041636,
        23.110253417408
    ],
    [
        113.21582164585,
        23.110223383355
    ],
    [
        113.21583337933,
        23.110176624371
    ],
    [
        113.21583372327,
        23.110104208181
    ],
    [
        113.21583838482,
        23.110062940296
    ],
    [
        113.21582182555,
        23.110043027333
    ],
    [
        113.21580362412,
        23.110034520939
    ],
    [
        113.2157601439,
        23.110028153368
    ],
    [
        113.21571638427,
        23.110029112596
    ],
    [
        113.21565279628,
        23.11001697409
    ],
    [
        113.21558430953,
        23.110010581371
    ],
    [
        113.21550902961,
        23.110001546102
    ],
    [
        113.21542342113,
        23.109991531252
    ],
    [
        113.21536063967,
        23.109985365889
    ],
    [
        113.21527474601,
        23.109986754455
    ],
    [
        113.2151774483,
        23.109974701749
    ],
    [
        113.21511656419,
        23.109971512571
    ],
    [
        113.21504537426,
        23.109944292239
    ],
    [
        113.21497688936,
        23.109929524042
    ],
    [
        113.21491901436,
        23.109905430507
    ],
    [
        113.21489348581,
        23.109882094823
    ],
    [
        113.21485113009,
        23.109832352798
    ],
    [
        113.21483431926,
        23.109789673465
    ],
    [
        113.21482322046,
        23.109743410197
    ],
    [
        113.21482381546,
        23.109692145608
    ],
    [
        113.21483934969,
        23.109652390301
    ],
    [
        113.21484833217,
        23.109640365369
    ],
    [
        113.21487279959,
        23.109637674911
    ],
    [
        113.21492688617,
        23.109644989878
    ],
    [
        113.21499783213,
        23.109645627727
    ],
    [
        113.21503887737,
        23.109645756386
    ],
    [
        113.21510575318,
        23.109638033557
    ],
    [
        113.21521421769,
        23.109628815632
    ],
    [
        113.21529795452,
        23.109610629363
    ],
    [
        113.21534065645,
        23.109583087838
    ],
    [
        113.21536650145,
        23.109560052383
    ],
    [
        113.21537740873,
        23.109525230632
    ],
    [
        113.21538781051,
        23.109452444671
    ],
    [
        113.21538594052,
        23.109419917919
    ],
    [
        113.21538216051,
        23.109394732533
    ],
    [
        113.21534686369,
        23.109356567324
    ],
    [
        113.21528329061,
        23.109326004727
    ],
    [
        113.21520827655,
        23.109319425245
    ],
    [
        113.21513081193,
        23.109316129075
    ],
    [
        113.21503513162,
        23.109315461642
    ],
    [
        113.21496202154,
        23.109304808982
    ],
    [
        113.21491907026,
        23.109307414178
    ],
    [
        113.2149316394,
        23.109242738896
    ],
    [
        113.21492225643,
        23.109112653958
    ],
    [
        113.21495000003,
        23.109095557603
    ],
    [
        113.2149983975,
        23.109083134902
    ],
    [
        113.21505358531,
        23.109075527449
    ],
    [
        113.21509355931,
        23.109059396051
    ],
    [
        113.21508952681,
        23.109014958256
    ],
    [
        113.21509778769,
        23.108909646505
    ],
    [
        113.21508701774,
        23.108807780047
    ],
    [
        113.21508185967,
        23.108801322781
    ],
    [
        113.21501281387,
        23.10880418699
    ],
    [
        113.21491385997,
        23.10881332496
    ],
    [
        113.21484780364,
        23.10881508262
    ],
    [
        113.21478364921,
        23.108817095278
    ],
    [
        113.21478288166,
        23.108769641669
    ],
    [
        113.21477099379,
        23.108697622244
    ],
    [
        113.21476508581,
        23.108626083905
    ],
    [
        113.21475374771,
        23.108548092423
    ],
    [
        113.21473233898,
        23.108482680302
    ],
    [
        113.21471471453,
        23.108438383756
    ],
    [
        113.21469953275,
        23.108397859146
    ],
    [
        113.21465966237,
        23.108309315015
    ],
    [
        113.21462524106,
        23.108208511163
    ],
    [
        113.21459457781,
        23.108154588132
    ],
    [
        113.21457478962,
        23.108099196445
    ],
    [
        113.2145267503,
        23.108023488245
    ],
    [
        113.21448441481,
        23.107952332508
    ],
    [
        113.21444101154,
        23.107861662371
    ],
    [
        113.21440794007,
        23.107769257454
    ],
    [
        113.21437840396,
        23.107675459976
    ],
    [
        113.21434290355,
        23.107565453835
    ],
    [
        113.21431635407,
        23.107475151826
    ],
    [
        113.21429715489,
        23.107374737551
    ],
    [
        113.21428693972,
        23.107261752458
    ],
    [
        113.21425982788,
        23.107189628497
    ],
    [
        113.21424246161,
        23.107157811075
    ],
    [
        113.21422588955,
        23.107146868395
    ],
    [
        113.21418349096,
        23.107135931022
    ],
    [
        113.21414299762,
        23.107122533646
    ],
    [
        113.21411257716,
        23.107095197457
    ],
    [
        113.21408895207,
        23.107068873525
    ],
    [
        113.2140756761,
        23.107024538613
    ],
    [
        113.21406243198,
        23.106949014605
    ],
    [
        113.21405378491,
        23.10689757854
    ],
    [
        113.21404401018,
        23.106885479835
    ],
    [
        113.21403368865,
        23.1068763704
    ],
    [
        113.214021451,
        23.106880028549
    ],
    [
        113.21398936136,
        23.106889326232
    ],
    [
        113.21393958638,
        23.106912106278
    ],
    [
        113.21391048723,
        23.106921102047
    ],
    [
        113.21388547215,
        23.106924087234
    ],
    [
        113.21387597154,
        23.106909545866
    ],
    [
        113.21385559815,
        23.106892953903
    ],
    [
        113.21384231426,
        23.106855943964
    ],
    [
        113.21381356335,
        23.106789813463
    ],
    [
        113.2137815817,
        23.106692530239
    ],
    [
        113.21374985043,
        23.106616127988
    ],
    [
        113.21370320168,
        23.106504634393
    ],
    [
        113.21368126366,
        23.106422430101
    ],
    [
        113.21364221167,
        23.106326042087
    ],
    [
        113.21361752021,
        23.106277499123
    ],
    [
        113.2135708509,
        23.10618526598
    ],
    [
        113.21349785058,
        23.106051834531
    ],
    [
        113.21343433599,
        23.105947319339
    ],
    [
        113.21337572157,
        23.105836242705
    ],
    [
        113.21332824912,
        23.105730195201
    ],
    [
        113.21327478042,
        23.105638049032
    ],
    [
        113.21325255279,
        23.105571856056
    ],
    [
        113.2132509575,
        23.105536617253
    ],
    [
        113.21324719674,
        23.105491910848
    ],
    [
        113.21334861708,
        23.105488047573
    ],
    [
        113.21345356829,
        23.105486321592
    ],
    [
        113.21353786475,
        23.105474799569
    ],
    [
        113.21367597966,
        23.105475703253
    ],
    [
        113.21378011352,
        23.105470756471
    ],
    [
        113.21388506111,
        23.105466079868
    ],
    [
        113.21398457106,
        23.105460114269
    ],
    [
        113.21406042359,
        23.105457936908
    ],
    [
        113.21414851242,
        23.105452377862
    ],
    [
        113.21423387677,
        23.105451464132
    ],
    [
        113.21432712078,
        23.105453455498
    ],
    [
        113.21445707166,
        23.105446930911
    ],
    [
        113.21452775478,
        23.105443749258
    ],
    [
        113.21461991835,
        23.105434923938
    ],
    [
        113.21468897617,
        23.105424445089
    ],
    [
        113.21474606795,
        23.105418432226
    ],
    [
        113.21484801666,
        23.105407352397
    ],
    [
        113.21497033734,
        23.105409363281
    ],
    [
        113.21512583388,
        23.105395594452
    ],
    [
        113.21520384797,
        23.105393189247
    ],
    [
        113.21524598583,
        23.105386804414
    ],
    [
        113.21530525051,
        23.105377539809
    ],
    [
        113.21537456583,
        23.105373874625
    ],
    [
        113.21544170538,
        23.105370776793
    ],
    [
        113.2155110206,
        23.105365762873
    ],
    [
        113.21559555431,
        23.105362233128
    ],
    [
        113.21570019632,
        23.105362042278
    ],
    [
        113.21578880217,
        23.105360655998
    ],
    [
        113.21588936439,
        23.105360248121
    ],
    [
        113.21595731323,
        23.105357712053
    ],
    [
        113.21604809274,
        23.10535334017
    ],
    [
        113.21614240264,
        23.105350298304
    ],
    [
        113.21624404955,
        23.10534665405
    ],
    [
        113.21632503892,
        23.105344561151
    ],
    [
        113.21640141329,
        23.105336548444
    ],
    [
        113.21649326721,
        23.105338165527
    ],
    [
        113.21661067164,
        23.105333054299
    ],
    [
        113.21669056636,
        23.105333706823
    ],
    [
        113.21674492157,
        23.105328620594
    ],
    [
        113.21680498829,
        23.105318334196
    ],
    [
        113.21686613419,
        23.105315092808
    ],
    [
        113.21694874935,
        23.105309500714
    ],
    [
        113.21699821259,
        23.105302840276
    ],
    [
        113.21708625566,
        23.105302092893
    ],
    [
        113.21720446044,
        23.105300285779
    ],
    [
        113.21729358961,
        23.105297374548
    ],
    [
        113.21743353099,
        23.10529242644
    ],
    [
        113.21753868879,
        23.105288588691
    ],
    [
        113.21766422714,
        23.105280529161
    ],
    [
        113.21775416953,
        23.105272763495
    ],
    [
        113.21782372153,
        23.105276283898
    ],
    [
        113.21794842457,
        23.105282092142
    ],
    [
        113.21809404899,
        23.105283956819
    ],
    [
        113.21829047869,
        23.105281120031
    ],
    [
        113.21841680986,
        23.105279100014
    ],
    [
        113.21853906492,
        23.10527549574
    ],
    [
        113.2187004262,
        23.105281931375
    ],
    [
        113.21880827221,
        23.105283610491
    ],
    [
        113.21885444886,
        23.1052878979
    ],
    [
        113.21896446489,
        23.105289847438
    ],
    [
        113.2190706733,
        23.105294274059
    ],
    [
        113.21915677761,
        23.105299658889
    ],
    [
        113.2192773835,
        23.105299668345
    ],
    [
        113.21937516031,
        23.105309331514
    ],
    [
        113.21954490798,
        23.105325863792
    ],
    [
        113.2196421311,
        23.105341248437
    ],
    [
        113.21973853994,
        23.105354476673
    ],
    [
        113.21983657705,
        23.105367431792
    ],
    [
        113.2199674679,
        23.105388333375
    ],
    [
        113.22007743762,
        23.105414526579
    ],
    [
        113.22017682149,
        23.105432655812
    ],
    [
        113.22027239333,
        23.105458680679
    ],
    [
        113.22037122195,
        23.105485237536
    ],
    [
        113.2204618982,
        23.10551510299
    ],
    [
        113.22053493462,
        23.105531512466
    ],
    [
        113.22060415922,
        23.10555662614
    ],
    [
        113.22067175578,
        23.105579583164
    ],
    [
        113.22076568197,
        23.10561325233
    ],
    [
        113.22084956559,
        23.105640472886
    ],
    [
        113.22093859275,
        23.105682047207
    ],
    [
        113.22105666634,
        23.105731075162
    ],
    [
        113.22114677937,
        23.105769677183
    ],
    [
        113.2212518244,
        23.105809298268
    ],
    [
        113.22135713508,
        23.105852724867
    ],
    [
        113.22145212595,
        23.105895938678
    ],
    [
        113.22154413564,
        23.105932122907
    ],
    [
        113.22162502204,
        23.105958059322
    ],
    [
        113.2216931302,
        23.105999517819
    ],
    [
        113.22179299966,
        23.106045450909
    ],
    [
        113.22192948687,
        23.106124052175
    ],
    [
        113.22205023489,
        23.106191887333
    ],
    [
        113.22217668323,
        23.106258085305
    ],
    [
        113.22228304671,
        23.106316511938
    ],
    [
        113.22234681455,
        23.106346637023
    ],
    [
        113.22237612438,
        23.106356557929
    ],
    [
        113.22238970149,
        23.106353522151
    ],
    [
        113.22242338167,
        23.106337120133
    ],
    [
        113.22245462582,
        23.106313405738
    ],
    [
        113.22250599034,
        23.10625896985
    ],
    [
        113.22255735687,
        23.106202095459
    ],
    [
        113.22263291503,
        23.106114488504
    ],
    [
        113.22271825209,
        23.10601980042
    ],
    [
        113.22280551495,
        23.105898804914
    ],
    [
        113.22288027334,
        23.105793589093
    ],
    [
        113.22295695084,
        23.105668844844
    ],
    [
        113.22300591112,
        23.105571860405
    ],
    [
        113.22306546544,
        23.105466978644
    ],
    [
        113.22313128506,
        23.105339840946
    ],
    [
        113.22319793982,
        23.105191550223
    ],
    [
        113.2232398452,
        23.105089987694
    ],
    [
        113.22328040304,
        23.104978667316
    ],
    [
        113.22330952039,
        23.104906437148
    ],
    [
        113.22333538619,
        23.104828522088
    ],
    [
        113.22334576469,
        23.104765841558
    ],
    [
        113.22334636022,
        23.104714309913
    ],
    [
        113.22334756762,
        23.104595245192
    ],
    [
        113.22335153361,
        23.10443277865
    ],
    [
        113.22333376967,
        23.104285293619
    ],
    [
        113.22332436581,
        23.104190940823
    ],
    [
        113.22331904004,
        23.104090066767
    ],
    [
        113.22329796603,
        23.103994122159
    ],
    [
        113.22327932957,
        23.103903323504
    ],
    [
        113.22325471448,
        23.103819323766
    ],
    [
        113.22321951837,
        23.103730204392
    ],
    [
        113.22320573403,
        23.103672208336
    ],
    [
        113.22317972901,
        23.103619946187
    ],
    [
        113.22314885139,
        23.103554410797
    ],
    [
        113.22312854279,
        23.103505657551
    ],
    [
        113.22310446226,
        23.103428982146
    ],
    [
        113.22307579482,
        23.103324929883
    ],
    [
        113.22303869272,
        23.103240161838
    ],
    [
        113.22300645468,
        23.103176804585
    ],
    [
        113.22297392378,
        23.103134332437
    ],
    [
        113.22292133204,
        23.103065350242
    ],
    [
        113.22287878997,
        23.102990098349
    ],
    [
        113.22283976219,
        23.102928938895
    ],
    [
        113.22282921018,
        23.10289453168
    ],
    [
        113.22281001151,
        23.102820557924
    ],
    [
        113.22279596856,
        23.102748464948
    ],
    [
        113.22278277939,
        23.102637314866
    ],
    [
        113.22276337601,
        23.102496896072
    ],
    [
        113.22273798816,
        23.102368432055
    ],
    [
        113.22272098567,
        23.102269500648
    ],
    [
        113.22268631074,
        23.102197482689
    ],
    [
        113.22264620018,
        23.102131452167
    ],
    [
        113.22257787156,
        23.102050339125
    ],
    [
        113.22249757802,
        23.101988260046
    ],
    [
        113.22242731819,
        23.101935911942
    ],
    [
        113.22236411079,
        23.101888693891
    ],
    [
        113.2222523073,
        23.101840858528
    ],
    [
        113.2221309962,
        23.101796056714
    ],
    [
        113.22200505925,
        23.101758881572
    ],
    [
        113.22190136792,
        23.101736541354
    ],
    [
        113.22183948113,
        23.101719994402
    ],
    [
        113.22177568735,
        23.101709154745
    ],
    [
        113.22169479087,
        23.101694869675
    ],
    [
        113.22162692478,
        23.101681887159
    ],
    [
        113.22158077228,
        23.101676131531
    ],
    [
        113.221491716,
        23.101673018349
    ],
    [
        113.22139696292,
        23.101663159095
    ],
    [
        113.2212992156,
        23.101659017796
    ],
    [
        113.22122210357,
        23.101654783452
    ],
    [
        113.22110480383,
        23.101648856882
    ],
    [
        113.22100216639,
        23.101641782714
    ],
    [
        113.22094378305,
        23.101641811319
    ],
    [
        113.2208120812,
        23.101639515444
    ],
    [
        113.22069340649,
        23.101642046527
    ],
    [
        113.22060895849,
        23.10163301191
    ],
    [
        113.22051962278,
        23.101622112171
    ],
    [
        113.22041834214,
        23.10160531998
    ],
    [
        113.22029261787,
        23.101587863144
    ],
    [
        113.22013267776,
        23.101563026864
    ],
    [
        113.21999338769,
        23.101525070837
    ],
    [
        113.21986794143,
        23.101491657692
    ],
    [
        113.21974958891,
        23.101423499259
    ],
    [
        113.2196442636,
        23.101363135924
    ],
    [
        113.21956202569,
        23.101301007564
    ],
    [
        113.21946975937,
        23.101215896851
    ],
    [
        113.21941957037,
        23.101154114655
    ],
    [
        113.21937536615,
        23.101082803135
    ],
    [
        113.21935179282,
        23.101024104754
    ],
    [
        113.21934180709,
        23.100959079732
    ],
    [
        113.21934293048,
        23.10092191651
    ],
    [
        113.2193433123,
        23.100810717647
    ],
    [
        113.21935568619,
        23.100658487282
    ],
    [
        113.21937506671,
        23.100562351817
    ],
    [
        113.21940611074,
        23.100482684534
    ],
    [
        113.21944259318,
        23.100396744964
    ],
    [
        113.21950866839,
        23.100324719107
    ],
    [
        113.21957447061,
        23.100253241161
    ],
    [
        113.21963808999,
        23.100191001892
    ],
    [
        113.21970929172,
        23.100151229259
    ],
    [
        113.21974272027,
        23.100130408855
    ],
    [
        113.21986363164,
        23.100083286238
    ],
    [
        113.22000764863,
        23.100013255999
    ],
    [
        113.22011986269,
        23.099966754889
    ],
    [
        113.22025026422,
        23.099926939898
    ],
    [
        113.22032089392,
        23.099908634232
    ],
    [
        113.22039914391,
        23.099872932359
    ],
    [
        113.22049884037,
        23.099844168001
    ],
    [
        113.2206254413,
        23.099793839853
    ],
    [
        113.22074197165,
        23.099763920485
    ],
    [
        113.22084274945,
        23.099733824547
    ],
    [
        113.22095548138,
        23.0996958108
    ],
    [
        113.22114695353,
        23.09966310872
    ],
    [
        113.22128384467,
        23.099626363839
    ],
    [
        113.2213976407,
        23.099601678673
    ],
    [
        113.22155353192,
        23.099565147729
    ],
    [
        113.22163065708,
        23.099551233549
    ],
    [
        113.22175530166,
        23.099531417351
    ],
    [
        113.22187695733,
        23.099511085625
    ],
    [
        113.2219956314,
        23.099482914645
    ],
    [
        113.22213685425,
        23.099436763795
    ],
    [
        113.22224711381,
        23.099401060269
    ],
    [
        113.22235166341,
        23.099372170302
    ],
    [
        113.22245594159,
        23.099341121565
    ],
    [
        113.22256781949,
        23.099309512089
    ],
    [
        113.22267998277,
        23.099261097753
    ],
    [
        113.22279159369,
        23.099220019527
    ],
    [
        113.22290949463,
        23.099128214449
    ],
    [
        113.22298150182,
        23.099053117722
    ],
    [
        113.2230288111,
        23.09897295347
    ],
    [
        113.22306417358,
        23.098895542143
    ],
    [
        113.22307701452,
        23.098808983411
    ],
    [
        113.22307873819,
        23.09870971371
    ],
    [
        113.22306935719,
        23.098584443466
    ],
    [
        113.22305314399,
        23.098507200337
    ],
    [
        113.22302907305,
        23.09841479523
    ],
    [
        113.22300637039,
        23.098310452686
    ],
    [
        113.22292835004,
        23.098143916701
    ],
    [
        113.22282728562,
        23.097943835288
    ],
    [
        113.22274599086,
        23.097791155361
    ],
    [
        113.22263078132,
        23.097616636167
    ],
    [
        113.22254863324,
        23.097501401415
    ],
    [
        113.22249033226,
        23.097430561698
    ],
    [
        113.22238941568,
        23.097351752573
    ],
    [
        113.22227138687,
        23.097280072129
    ],
    [
        113.22219866244,
        23.09724293586
    ],
    [
        113.22210583759,
        23.097215379608
    ],
    [
        113.22201952037,
        23.097195126585
    ],
    [
        113.22194350137,
        23.097193821315
    ],
    [
        113.22187182669,
        23.097191146338
    ],
    [
        113.22180204161,
        23.097199316278
    ],
    [
        113.22168635425,
        23.097224240403
    ],
    [
        113.22160950074,
        23.097239505847
    ],
    [
        113.22154187345,
        23.097259615688
    ],
    [
        113.2214152877,
        23.097318791522
    ],
    [
        113.22131232909,
        23.097370815557
    ],
    [
        113.22121941395,
        23.097424426873
    ],
    [
        113.22117404219,
        23.097450958811
    ],
    [
        113.22112702159,
        23.097498113126
    ],
    [
        113.22106886081,
        23.097552105998
    ],
    [
        113.22100090961,
        23.097621068674
    ],
    [
        113.22095196647,
        23.097689666018
    ],
    [
        113.22087313943,
        23.097771439554
    ],
    [
        113.22078014692,
        23.097899128839
    ],
    [
        113.22069858074,
        23.098002897331
    ],
    [
        113.22061944957,
        23.098114794778
    ],
    [
        113.2205356913,
        23.098236215713
    ],
    [
        113.22044516493,
        23.098333542688
    ],
    [
        113.22039407129,
        23.098372613718
    ],
    [
        113.22030682973,
        23.098440099637
    ],
    [
        113.22024350867,
        23.098484129325
    ],
    [
        113.22017123573,
        23.098516281437
    ],
    [
        113.22008403444,
        23.098537677903
    ],
    [
        113.22003053147,
        23.098536368711
    ],
    [
        113.21997160114,
        23.098529670421
    ],
    [
        113.21993684285,
        23.098522828657
    ],
    [
        113.21988608679,
        23.098487607972
    ],
    [
        113.21985000038,
        23.098448773797
    ],
    [
        113.2198049617,
        23.098398333749
    ],
    [
        113.21976075904,
        23.098325108366
    ],
    [
        113.21969213766,
        23.09822355996
    ],
    [
        113.2195963918,
        23.098081505429
    ],
    [
        113.21950660634,
        23.097953523568
    ],
    [
        113.21946102802,
        23.097895777577
    ],
    [
        113.21941004977,
        23.097802810719
    ],
    [
        113.21933518715,
        23.097688848129
    ],
    [
        113.21925325037,
        23.097586057067
    ],
    [
        113.21920578475,
        23.097510433443
    ],
    [
        113.21913689429,
        23.097396986029
    ],
    [
        113.21905119086,
        23.097251111408
    ],
    [
        113.21898663046,
        23.097152560038
    ],
    [
        113.21890388618,
        23.097034882065
    ],
    [
        113.21878585336,
        23.096886539429
    ],
    [
        113.21870688415,
        23.096795698917
    ],
    [
        113.21866212997,
        23.096719264182
    ],
    [
        113.21863393848,
        23.096651933516
    ],
    [
        113.21861090468,
        23.096588634622
    ],
    [
        113.21859546653,
        23.096537214874
    ],
    [
        113.21859634623,
        23.096465878915
    ],
    [
        113.21859180547,
        23.096380207574
    ],
    [
        113.21859624638,
        23.096275757587
    ],
    [
        113.21861615296,
        23.096192351112
    ],
    [
        113.21863519657,
        23.096162109424
    ],
    [
        113.21867354303,
        23.096115185895
    ],
    [
        113.21872113222,
        23.096060875116
    ],
    [
        113.21876274105,
        23.096010405495
    ],
    [
        113.21883643057,
        23.095930963372
    ],
    [
        113.21891201427,
        23.095858564315
    ],
    [
        113.21895279613,
        23.095819769404
    ],
    [
        113.21900825458,
        23.095771925063
    ],
    [
        113.2190960546,
        23.09570514968
    ],
    [
        113.21917598595,
        23.095626771334
    ],
    [
        113.21925972034,
        23.095546745872
    ],
    [
        113.21932495684,
        23.095495868237
    ],
    [
        113.21939944888,
        23.095421066773
    ],
    [
        113.21950411407,
        23.095318682747
    ],
    [
        113.21955794579,
        23.095260568645
    ],
    [
        113.21964440553,
        23.095162653015
    ],
    [
        113.21969226535,
        23.095098616006
    ],
    [
        113.21972409621,
        23.095038477886
    ],
    [
        113.21973149983,
        23.094957608816
    ],
    [
        113.21973102836,
        23.094874619063
    ],
    [
        113.21972593134,
        23.094800879526
    ],
    [
        113.21970209749,
        23.094721832709
    ],
    [
        113.219664414,
        23.094639347547
    ],
    [
        113.21962699356,
        23.094566354564
    ],
    [
        113.2195732804,
        23.094487770836
    ],
    [
        113.2195154862,
        23.094416267452
    ],
    [
        113.21944818573,
        23.094343201157
    ],
    [
        113.21937490112,
        23.094278856879
    ],
    [
        113.2193089415,
        23.094223961526
    ],
    [
        113.21925301989,
        23.094182835322
    ],
    [
        113.21915718705,
        23.094117841149
    ],
    [
        113.21906785555,
        23.094072338365
    ],
    [
        113.21897227672,
        23.094024444442
    ],
    [
        113.21888810291,
        23.09397973353
    ],
    [
        113.21882483492,
        23.093947357955
    ],
    [
        113.21874689728,
        23.093914275882
    ],
    [
        113.2186290357,
        23.093867381499
    ],
    [
        113.21851769421,
        23.093817468028
    ],
    [
        113.21843105174,
        23.093792877966
    ],
    [
        113.21833382959,
        23.093747760087
    ],
    [
        113.21823605879,
        23.093706993795
    ],
    [
        113.21815484734,
        23.093680484554
    ],
    [
        113.21801605906,
        23.093626486874
    ],
    [
        113.21792969431,
        23.093585386715
    ],
    [
        113.21783789108,
        23.09354813249
    ],
    [
        113.21765834671,
        23.093484732574
    ],
    [
        113.21755676052,
        23.093443780885
    ],
    [
        113.21747500646,
        23.093404574572
    ],
    [
        113.21737206483,
        23.093355783985
    ],
    [
        113.2172843215,
        23.09332721736
    ],
    [
        113.21715692716,
        23.093270511515
    ],
    [
        113.21706103509,
        23.093233892796
    ],
    [
        113.21696079864,
        23.093191080682
    ],
    [
        113.21684562099,
        23.09314026936
    ],
    [
        113.21677227562,
        23.093107817622
    ],
    [
        113.21666009076,
        23.093048047173
    ],
    [
        113.21658839346,
        23.092990910676
    ],
    [
        113.2164938674,
        23.092933710962
    ],
    [
        113.21642432468,
        23.092898262271
    ],
    [
        113.21634529284,
        23.092833340269
    ],
    [
        113.21628609253,
        23.09277665032
    ],
    [
        113.21620137248,
        23.092685209442
    ],
    [
        113.21611911393,
        23.092572324954
    ],
    [
        113.21606944978,
        23.092481925523
    ],
    [
        113.21601055748,
        23.09237479824
    ],
    [
        113.21594839263,
        23.092280722945
    ],
    [
        113.21591828928,
        23.092197469045
    ],
    [
        113.21586782229,
        23.09208728557
    ],
    [
        113.21582496924,
        23.091971064974
    ],
    [
        113.21578756394,
        23.091838249352
    ],
    [
        113.21575068529,
        23.091726585089
    ],
    [
        113.21573880283,
        23.091625803294
    ],
    [
        113.21573343206,
        23.091539605453
    ],
    [
        113.21573237531,
        23.091499203212
    ],
    [
        113.21573486691,
        23.091438696537
    ],
    [
        113.21575692542,
        23.091380986792
    ],
    [
        113.21578607382,
        23.091291748018
    ],
    [
        113.21584675749,
        23.091191633565
    ],
    [
        113.21590905073,
        23.091118900454
    ],
    [
        113.21598220359,
        23.091060986139
    ],
    [
        113.21606133209,
        23.091006546426
    ],
    [
        113.21617662275,
        23.090928724495
    ],
    [
        113.21625438627,
        23.090878920166
    ],
    [
        113.21631827324,
        23.090850130905
    ],
    [
        113.21641015389,
        23.090817837675
    ],
    [
        113.21648408732,
        23.09079873048
    ],
    [
        113.21657949003,
        23.090777809608
    ],
    [
        113.21662243743,
        23.090764139213
    ],
    [
        113.2166705628,
        23.090729811582
    ],
    [
        113.21669587575,
        23.090674530291
    ],
    [
        113.21669781615,
        23.09062162425
    ],
    [
        113.21670035105,
        23.090497380554
    ],
    [
        113.21666862312,
        23.090403272736
    ],
    [
        113.21662657714,
        23.090296237915
    ],
    [
        113.21657662135,
        23.090229144922
    ],
    [
        113.21651822704,
        23.090181115034
    ],
    [
        113.21643836209,
        23.090134094305
    ],
    [
        113.21638076982,
        23.09010287966
    ],
    [
        113.21633267375,
        23.090093279626
    ],
    [
        113.21626039239,
        23.090079833573
    ],
    [
        113.2161889168,
        23.090078860703
    ],
    [
        113.21610873736,
        23.090086651608
    ],
    [
        113.21604541008,
        23.090090493603
    ],
    [
        113.2159698499,
        23.090097165446
    ],
    [
        113.21590353722,
        23.090092905653
    ],
    [
        113.2158905031,
        23.09007621231
    ],
    [
        113.21585736724,
        23.090044248897
    ],
    [
        113.21583593689,
        23.089985324037
    ],
    [
        113.21582374708,
        23.089926583169
    ],
    [
        113.21579665558,
        23.089799634478
    ],
    [
        113.21575950432,
        23.089676579177
    ],
    [
        113.21573047188,
        23.089603895704
    ],
    [
        113.21571556759,
        23.089538400894
    ],
    [
        113.21568950987,
        23.089487116865
    ],
    [
        113.21567595633,
        23.089433272332
    ],
    [
        113.21561676491,
        23.089342979739
    ],
    [
        113.21559314608,
        23.089301438317
    ],
    [
        113.21555891446,
        23.089278443547
    ],
    [
        113.21546786283,
        23.089274445984
    ],
    [
        113.21536891886,
        23.089283280107
    ],
    [
        113.21522865191,
        23.089300397261
    ],
    [
        113.21513350356,
        23.089318433355
    ],
    [
        113.21506608142,
        23.089334027357
    ],
    [
        113.21499050898,
        23.089341841621
    ],
    [
        113.21489372645,
        23.089359369169
    ],
    [
        113.2148135297,
        23.089368868076
    ],
    [
        113.21473876909,
        23.089377773343
    ],
    [
        113.21466318408,
        23.089398625406
    ],
    [
        113.21459276797,
        23.08941237597
    ],
    [
        113.21451501103,
        23.089426478343
    ],
    [
        113.21443208488,
        23.089445250561
    ],
    [
        113.21434726145,
        23.089454012561
    ],
    [
        113.21427874821,
        23.089462877325
    ],
    [
        113.21422600252,
        23.089471034475
    ],
    [
        113.21415639637,
        23.089486155359
    ],
    [
        113.21408379969,
        23.08950022717
    ],
    [
        113.21402234478,
        23.089520149054
    ],
    [
        113.21393424905,
        23.089535753031
    ],
    [
        113.21381324892,
        23.089560945672
    ],
    [
        113.21371562854,
        23.089585618888
    ],
    [
        113.21360794682,
        23.089610682256
    ],
    [
        113.213519573,
        23.089627400695
    ],
    [
        113.21344941992,
        23.089636325201
    ],
    [
        113.21335370158,
        23.089655035387
    ],
    [
        113.21328845148,
        23.089648452477
    ],
    [
        113.21321503508,
        23.089654713516
    ],
    [
        113.2130448119,
        23.089673483751
    ],
    [
        113.2129969487,
        23.089684885979
    ],
    [
        113.21296159916,
        23.089687194119
    ],
    [
        113.21287322072,
        23.089698528503
    ],
    [
        113.21283624203,
        23.089696519094
    ],
    [
        113.21269130606,
        23.089703644573
    ],
    [
        113.21260455448,
        23.089716874844
    ],
    [
        113.212507471,
        23.089726707377
    ],
    [
        113.21241338375,
        23.089727288749
    ],
    [
        113.21230025349,
        23.089737327294
    ],
    [
        113.21221676228,
        23.08974782897
    ],
    [
        113.21219364782,
        23.089747566612
    ],
    [
        113.21211451296,
        23.089748528281
    ],
    [
        113.21200083302,
        23.08976022374
    ],
    [
        113.21189178191,
        23.089761021676
    ],
    [
        113.21186975293,
        23.089762649539
    ],
    [
        113.21177320277,
        23.089773608453
    ],
    [
        113.21164701317,
        23.089777077823
    ],
    [
        113.2115210908,
        23.089784351457
    ],
    [
        113.21142046719,
        23.089779923981
    ],
    [
        113.21131004494,
        23.089784849281
    ],
    [
        113.21120207165,
        23.089785682737
    ],
    [
        113.21109789953,
        23.089793797962
    ],
    [
        113.21101603361,
        23.089794309145
    ],
    [
        113.21093661524,
        23.089793979207
    ],
    [
        113.21078048389,
        23.089810925715
    ],
    [
        113.21070214682,
        23.089816831594
    ],
    [
        113.21060123045,
        23.089827106596
    ],
    [
        113.2105236992,
        23.08984521576
    ],
    [
        113.21043475166,
        23.089851003521
    ],
    [
        113.21036375325,
        23.089859811992
    ],
    [
        113.21026256094,
        23.089869569222
    ],
    [
        113.21020081067,
        23.089876362584
    ],
    [
        113.21010560211,
        23.089883879443
    ],
    [
        113.21001147789,
        23.089895184269
    ],
    [
        113.20991055394,
        23.089903874416
    ],
    [
        113.20981099243,
        23.08990739873
    ],
    [
        113.20968014378,
        23.089915425985
    ],
    [
        113.20958983136,
        23.089914768057
    ],
    [
        113.20948183147,
        23.089920597549
    ],
    [
        113.20935559916,
        23.089933196535
    ],
    [
        113.20923344748,
        23.089943035381
    ],
    [
        113.20909932852,
        23.089946541307
    ],
    [
        113.2090125393,
        23.089956441592
    ],
    [
        113.20887787265,
        23.089960243145
    ],
    [
        113.20874918995,
        23.089962884634
    ],
    [
        113.20864988306,
        23.089972166983
    ],
    [
        113.20854649826,
        23.08997554625
    ],
    [
        113.20844611269,
        23.089967767823
    ],
    [
        113.20834054787,
        23.089972817345
    ],
    [
        113.20822845903,
        23.089967932162
    ],
    [
        113.20814330077,
        23.089967814484
    ],
    [
        113.20806168023,
        23.089965479127
    ],
    [
        113.20797706817,
        23.089960207593
    ],
    [
        113.2078546384,
        23.089951698749
    ],
    [
        113.20774281095,
        23.089953890015
    ],
    [
        113.20762363708,
        23.089954298032
    ],
    [
        113.20747725495,
        23.089951321458
    ],
    [
        113.20735045946,
        23.089951316994
    ],
    [
        113.20722991449,
        23.089960176992
    ],
    [
        113.20714419644,
        23.089969875061
    ],
    [
        113.20705494703,
        23.089969865922
    ],
    [
        113.20693739322,
        23.089976528023
    ],
    [
        113.20683398657,
        23.089984879938
    ],
    [
        113.20672459199,
        23.089993870794
    ],
    [
        113.20663261945,
        23.08999148011
    ],
    [
        113.20652159324,
        23.089995895461
    ],
    [
        113.20642661959,
        23.090002238882
    ],
    [
        113.20634525583,
        23.090001866731
    ],
    [
        113.20622497412,
        23.090006711296
    ],
    [
        113.20613027469,
        23.09000628252
    ],
    [
        113.20603584432,
        23.09000910824
    ],
    [
        113.20590631077,
        23.090008147007
    ],
    [
        113.2058012659,
        23.090010063522
    ],
    [
        113.20568097625,
        23.090017920376
    ],
    [
        113.20554136784,
        23.090019307784
    ],
    [
        113.20541890264,
        23.090020974076
    ],
    [
        113.20528527409,
        23.090028519792
    ],
    [
        113.20518375955,
        23.090033390791
    ],
    [
        113.20506591432,
        23.090039340683
    ],
    [
        113.20496821115,
        23.090039819884
    ],
    [
        113.20485091645,
        23.090033837027
    ],
    [
        113.20475947488,
        23.090029070265
    ],
    [
        113.20466640267,
        23.090019993425
    ],
    [
        113.20458122089,
        23.090013233257
    ],
    [
        113.20449712215,
        23.090013781368
    ],
    [
        113.20440295826,
        23.090006358806
    ],
    [
        113.20429790498,
        23.09000182905
    ],
    [
        113.20417652442,
        23.089991874068
    ],
    [
        113.20405105676,
        23.08998687334
    ],
    [
        113.20395770385,
        23.089982978564
    ],
    [
        113.20386925797,
        23.089966801008
    ],
    [
        113.20383768923,
        23.089961352996
    ],
    [
        113.20378680062,
        23.089948900199
    ],
    [
        113.20373808032,
        23.089949431411
    ],
    [
        113.20365479894,
        23.089941312023
    ],
    [
        113.20356226054,
        23.089936602748
    ],
    [
        113.20347244269,
        23.089932936139
    ],
    [
        113.20334533405,
        23.089930433731
    ],
    [
        113.20321904167,
        23.089926838018
    ],
    [
        113.20315644646,
        23.089914861887
    ],
    [
        113.2030734279,
        23.089915704268
    ],
    [
        113.20299667293,
        23.089911290763
    ],
    [
        113.20289133358,
        23.089912239778
    ],
    [
        113.20278300308,
        23.0899078178
    ],
    [
        113.20266868289,
        23.089904313684
    ],
    [
        113.20257940473,
        23.089900120316
    ],
    [
        113.20245800679,
        23.089895386215
    ],
    [
        113.20232000083,
        23.089894734287
    ],
    [
        113.20219587289,
        23.089899005665
    ],
    [
        113.20209461715,
        23.089892043821
    ],
    [
        113.20199198957,
        23.089900025454
    ],
    [
        113.20188364646,
        23.089905937335
    ],
    [
        113.20178428933,
        23.089906545645
    ],
    [
        113.20167649302,
        23.089907300561
    ],
    [
        113.20159482857,
        23.08990815382
    ],
    [
        113.20150689701,
        23.089917523998
    ],
    [
        113.20141080725,
        23.089914288233
    ],
    [
        113.20132397459,
        23.089907912226
    ],
    [
        113.2012523867,
        23.089900191096
    ],
    [
        113.2011263554,
        23.0898915091
    ],
    [
        113.20103816475,
        23.089878923809
    ],
    [
        113.20096930503,
        23.089861124765
    ],
    [
        113.20092004382,
        23.089845158366
    ],
    [
        113.20085989347,
        23.089829380465
    ],
    [
        113.20077143489,
        23.089808939187
    ],
    [
        113.20065738581,
        23.089790027206
    ],
    [
        113.20056755554,
        23.089783988272
    ],
    [
        113.20050141117,
        23.089774285496
    ],
    [
        113.20043064405,
        23.08975679818
    ],
    [
        113.20033510679,
        23.089735131078
    ],
    [
        113.20017942738,
        23.089682506736
    ],
    [
        113.20004524784,
        23.089637920112
    ],
    [
        113.19992603707,
        23.089598228773
    ],
    [
        113.19982615055,
        23.089564169416
    ],
    [
        113.19975021598,
        23.08953647392
    ],
    [
        113.19966122211,
        23.089496531109
    ],
    [
        113.19955154287,
        23.089449356978
    ],
    [
        113.19941982238,
        23.089386568147
    ],
    [
        113.19934062821,
        23.089346186555
    ],
    [
        113.19922387635,
        23.08928856345
    ],
    [
        113.19913759992,
        23.089253461502
    ],
    [
        113.19903064136,
        23.089205704781
    ],
    [
        113.19893457286,
        23.089156673091
    ],
    [
        113.19881972256,
        23.08910281944
    ],
    [
        113.19868609611,
        23.089035193841
    ],
    [
        113.19858838425,
        23.088999756073
    ],
    [
        113.19857395842,
        23.088995128054
    ],
    [
        113.19849339443,
        23.088964542498
    ],
    [
        113.1984022221,
        23.088919498226
    ],
    [
        113.1982587905,
        23.088856119341
    ],
    [
        113.19815890999,
        23.08880444986
    ],
    [
        113.19806937409,
        23.088753412153
    ],
    [
        113.19794254874,
        23.088689201074
    ],
    [
        113.19786389076,
        23.088656144817
    ],
    [
        113.19780020205,
        23.088629605076
    ],
    [
        113.19774930897,
        23.088602839352
    ],
    [
        113.19764072776,
        23.088531256117
    ],
    [
        113.19751825809,
        23.088465343771
    ],
    [
        113.19745593759,
        23.088426846852
    ],
    [
        113.19734354131,
        23.088359672269
    ],
    [
        113.19726216486,
        23.088318529567
    ],
    [
        113.19716418619,
        23.08826927289
    ],
    [
        113.1970449851,
        23.088198693863
    ],
    [
        113.19693775596,
        23.088139023562
    ],
    [
        113.19686400407,
        23.088094220629
    ],
    [
        113.19677364674,
        23.088046457142
    ],
    [
        113.19669771989,
        23.087996268246
    ],
    [
        113.19660110446,
        23.08794210618
    ],
    [
        113.1964862518,
        23.08788202888
    ],
    [
        113.19636296131,
        23.087818574985
    ],
    [
        113.19626553158,
        23.08775954501
    ],
    [
        113.19612755107,
        23.087676279785
    ],
    [
        113.19602032763,
        23.087604403661
    ],
    [
        113.19585948474,
        23.087509336901
    ],
    [
        113.19577784145,
        23.087455993318
    ],
    [
        113.19565837047,
        23.087377009376
    ],
    [
        113.19554787675,
        23.0873098002
    ],
    [
        113.19542295618,
        23.08723850584
    ],
    [
        113.19531872401,
        23.087171184561
    ],
    [
        113.19523218547,
        23.087107889606
    ],
    [
        113.19522837811,
        23.087100633596
    ],
    [
        113.19515707549,
        23.08705469908
    ],
    [
        113.19510592284,
        23.08700189861
    ],
    [
        113.19497691535,
        23.086935826297
    ],
    [
        113.19489798536,
        23.086897890881
    ],
    [
        113.19471835766,
        23.086800703714
    ],
    [
        113.19460432166,
        23.08673843186
    ],
    [
        113.19453900188,
        23.086704322563
    ],
    [
        113.19449708669,
        23.086685532171
    ],
    [
        113.19444728053,
        23.08665928601
    ],
    [
        113.19439665457,
        23.086638749962
    ],
    [
        113.19432969865,
        23.086609821552
    ],
    [
        113.19424505846,
        23.086559776192
    ],
    [
        113.19416912037,
        23.086527749781
    ],
    [
        113.19403442167,
        23.086414570826
    ],
    [
        113.19392612284,
        23.086315030457
    ],
    [
        113.19383006549,
        23.086232904143
    ],
    [
        113.19376257757,
        23.086180654177
    ],
    [
        113.193665155,
        23.08610614423
    ],
    [
        113.19357835031,
        23.08603036209
    ],
    [
        113.19350868872,
        23.085969739382
    ],
    [
        113.19344392973,
        23.085904419168
    ],
    [
        113.19337507807,
        23.085857071476
    ],
    [
        113.19327847107,
        23.085784711496
    ],
    [
        113.19317941964,
        23.08570100068
    ],
    [
        113.19304199403,
        23.085595715513
    ],
    [
        113.19291817279,
        23.085505379661
    ],
    [
        113.19281694528,
        23.085418174394
    ],
    [
        113.19271924403,
        23.085357487371
    ],
    [
        113.19258943295,
        23.085269689254
    ],
    [
        113.19244465326,
        23.08517428119
    ],
    [
        113.19235158181,
        23.085110794673
    ],
    [
        113.19225551476,
        23.085050070547
    ],
    [
        113.19223210871,
        23.085038811641
    ],
    [
        113.1921395821,
        23.084975311634
    ],
    [
        113.19203535424,
        23.084902789305
    ],
    [
        113.19194337082,
        23.084842802124
    ],
    [
        113.19183832096,
        23.084783037697
    ],
    [
        113.19172809899,
        23.084723902036
    ],
    [
        113.19164101008,
        23.084677657782
    ],
    [
        113.19150167237,
        23.084594603725
    ],
    [
        113.19135307685,
        23.08451875533
    ],
    [
        113.19125047487,
        23.084468156614
    ],
    [
        113.19117072678,
        23.084445646411
    ],
    [
        113.19108744165,
        23.084419939856
    ],
    [
        113.19103164531,
        23.084404885312
    ],
    [
        113.19086944118,
        23.08433169098
    ],
    [
        113.19068899904,
        23.084262052776
    ],
    [
        113.19042364571,
        23.084159930237
    ],
    [
        113.19024211857,
        23.084090829866
    ],
    [
        113.19009433577,
        23.084044482111
    ],
    [
        113.18996043799,
        23.083993284861
    ],
    [
        113.18981701307,
        23.083945766786
    ],
    [
        113.18970652256,
        23.083901763953
    ],
    [
        113.18960364607,
        23.083877160478
    ],
    [
        113.1895078473,
        23.083851893966
    ],
    [
        113.18934400942,
        23.083812557604
    ],
    [
        113.18925800608,
        23.083798785007
    ],
    [
        113.18919431989,
        23.0837897967
    ],
    [
        113.18913172325,
        23.083779432891
    ],
    [
        113.18903565139,
        23.083763920292
    ],
    [
        113.18894339007,
        23.08374969836
    ],
    [
        113.18886092836,
        23.083733414755
    ],
    [
        113.18880949019,
        23.083728015296
    ],
    [
        113.18869790565,
        23.083715727685
    ],
    [
        113.18862224649,
        23.083707192367
    ],
    [
        113.1885490364,
        23.083700785189
    ],
    [
        113.18847854697,
        23.083697858157
    ],
    [
        113.18840588243,
        23.083690353253
    ],
    [
        113.18820230768,
        23.083687937983
    ],
    [
        113.18808364827,
        23.083685774273
    ],
    [
        113.18794784449,
        23.083683336516
    ],
    [
        113.18778673037,
        23.083685905418
    ],
    [
        113.1876258914,
        23.083686289473
    ],
    [
        113.18747457931,
        23.083687326234
    ],
    [
        113.18733143681,
        23.083679545153
    ],
    [
        113.18721469068,
        23.083678122895
    ],
    [
        113.18709277573,
        23.083675419293
    ],
    [
        113.18697221912,
        23.083681910366
    ],
    [
        113.18686282494,
        23.083678457049
    ],
    [
        113.18672648671,
        23.083687349794
    ],
    [
        113.18658144381,
        23.083692570734
    ],
    [
        113.18645735328,
        23.083704241957
    ],
    [
        113.1863419721,
        23.0837152305
    ],
    [
        113.18620564225,
        23.083719750604
    ],
    [
        113.18610822476,
        23.083726113146
    ],
    [
        113.18600155701,
        23.083731526067
    ],
    [
        113.18582142035,
        23.083744006597
    ],
    [
        113.18570414142,
        23.08375553097
    ],
    [
        113.18557244511,
        23.083761567439
    ],
    [
        113.18539694694,
        23.083760921347
    ],
    [
        113.18520648569,
        23.083764548702
    ],
    [
        113.1850358925,
        23.083761628131
    ],
    [
        113.18495508386,
        23.083766335297
    ],
    [
        113.18485577442,
        23.083772393136
    ],
    [
        113.18475238994,
        23.083766027589
    ],
    [
        113.1846035705,
        23.083762481445
    ],
    [
        113.18447624774,
        23.083755360366
    ],
    [
        113.18439381672,
        23.08374731814
    ],
    [
        113.18428554433,
        23.083731231648
    ],
    [
        113.18417918361,
        23.083699921933
    ],
    [
        113.18405133715,
        23.083656160619
    ],
    [
        113.18393627916,
        23.083610854421
    ],
    [
        113.18384326708,
        23.083541905478
    ],
    [
        113.18376412984,
        23.083472758185
    ],
    [
        113.18369860804,
        23.083368969867
    ],
    [
        113.18363525844,
        23.083275998666
    ],
    [
        113.18361460262,
        23.083225290833
    ],
    [
        113.18361625504,
        23.0831704763
    ],
    [
        113.18361845336,
        23.083110229247
    ],
    [
        113.18362961327,
        23.083092443562
    ],
    [
        113.18363750853,
        23.083075245575
    ],
    [
        113.18371780471,
        23.082949085539
    ],
    [
        113.18379782168,
        23.082843269055
    ],
    [
        113.18386286588,
        23.082768038129
    ],
    [
        113.18397090555,
        23.082657481153
    ],
    [
        113.18409336984,
        23.082531252647
    ],
    [
        113.18418290609,
        23.082436947505
    ],
    [
        113.18425720341,
        23.082355874476
    ],
    [
        113.1843113702,
        23.082270474042
    ],
    [
        113.18439900179,
        23.082179982586
    ],
    [
        113.1844969808,
        23.082061942256
    ],
    [
        113.18456366011,
        23.081985034493
    ],
    [
        113.1846453044,
        23.081904382156
    ],
    [
        113.18472505239,
        23.081797713639
    ],
    [
        113.18482629616,
        23.081684219493
    ],
    [
        113.18489107711,
        23.081589153554
    ],
    [
        113.18501627711,
        23.081430001177
    ],
    [
        113.18509302918,
        23.081336651767
    ],
    [
        113.18517250388,
        23.08123729164
    ],
    [
        113.18523429885,
        23.081116759897
    ],
    [
        113.18529336765,
        23.081015525205
    ],
    [
        113.18534972422,
        23.080879337175
    ],
    [
        113.18539546242,
        23.080768802496
    ],
    [
        113.18542052042,
        23.080662371016
    ],
    [
        113.18543768999,
        23.080544392274
    ],
    [
        113.18544995782,
        23.080441404978
    ],
    [
        113.18544100424,
        23.080328696176
    ],
    [
        113.18543803194,
        23.080234614996
    ],
    [
        113.18541138581,
        23.08014793751
    ],
    [
        113.18539344317,
        23.080075778399
    ],
    [
        113.18535781796,
        23.079987063026
    ],
    [
        113.18532844993,
        23.079900966965
    ],
    [
        113.18528030964,
        23.079804839845
    ],
    [
        113.18523570604,
        23.079709473078
    ],
    [
        113.18519327844,
        23.079616243215
    ],
    [
        113.18511466899,
        23.07949370541
    ],
    [
        113.18503334041,
        23.079360624985
    ],
    [
        113.18497295141,
        23.079288268235
    ],
    [
        113.1849318792,
        23.079219968085
    ],
    [
        113.18489026425,
        23.079142452122
    ],
    [
        113.18483640861,
        23.079047210028
    ],
    [
        113.18479207325,
        23.078965662398
    ],
    [
        113.18475698546,
        23.078902425289
    ],
    [
        113.1846955127,
        23.078798337693
    ],
    [
        113.18463431138,
        23.078697499148
    ],
    [
        113.18459078945,
        23.078632752789
    ],
    [
        113.18453911143,
        23.078522008399
    ],
    [
        113.18450810752,
        23.078430225251
    ],
    [
        113.18446295894,
        23.078313416992
    ],
    [
        113.18443848276,
        23.078230490504
    ],
    [
        113.18442570486,
        23.078147667504
    ],
    [
        113.18441347024,
        23.078069719271
    ],
    [
        113.18440042126,
        23.077969810325
    ],
    [
        113.18438301634,
        23.077896818351
    ],
    [
        113.18437594744,
        23.077845922052
    ],
    [
        113.1843615375,
        23.077740335491
    ],
    [
        113.18434359333,
        23.077594652193
    ],
    [
        113.18433136223,
        23.077435052582
    ],
    [
        113.18431341805,
        23.077250035182
    ],
    [
        113.18429954947,
        23.077134131631
    ],
    [
        113.18427724606,
        23.077026757061
    ],
    [
        113.18426473609,
        23.076919514093
    ],
    [
        113.18424134249,
        23.076835211877
    ],
    [
        113.1842255654,
        23.076773044918
    ],
    [
        113.18421087644,
        23.07670787841
    ],
    [
        113.18416626295,
        23.076575861932
    ],
    [
        113.18413769935,
        23.076473727679
    ],
    [
        113.18410124589,
        23.076362481286
    ],
    [
        113.18408111469,
        23.07629549143
    ],
    [
        113.18406125526,
        23.076251012647
    ],
    [
        113.18404928522,
        23.076189875067
    ],
    [
        113.18404683668,
        23.076113140868
    ],
    [
        113.18404819577,
        23.07595877024
    ],
    [
        113.18404792117,
        23.075798454457
    ],
    [
        113.1840484622,
        23.075669051558
    ],
    [
        113.18405961291,
        23.075558487677
    ],
    [
        113.18408246129,
        23.07545182749
    ],
    [
        113.18398534277,
        23.075534305869
    ],
    [
        113.18382211947,
        23.075653240139
    ],
    [
        113.18382565618,
        23.075658887366
    ],
    [
        113.18286268795,
        23.076209188277
    ],
    [
        113.18101291648,
        23.077469354196
    ],
    [
        113.17949064104,
        23.078412458081
    ],
    [
        113.17894577271,
        23.078649826149
    ],
    [
        113.17843710571,
        23.078854590854
    ],
    [
        113.17842133823,
        23.078858552449
    ],
    [
        113.17841834712,
        23.078864551238
    ],
    [
        113.17802662244,
        23.078939904908
    ],
    [
        113.17696166254,
        23.079157460366
    ],
    [
        113.17598873586,
        23.079336451512
    ],
    [
        113.17593955133,
        23.079337953117
    ],
    [
        113.17523197616,
        23.079447889651
    ],
    [
        113.17521730443,
        23.079446648705
    ],
    [
        113.17511840238,
        23.079465595828
    ],
    [
        113.17510699037,
        23.079469753347
    ],
    [
        113.1750064607,
        23.079484635014
    ],
    [
        113.17407813762,
        23.07961862146
    ],
    [
        113.17406808747,
        23.079613808087
    ],
    [
        113.17406319701,
        23.079618181874
    ],
    [
        113.17235283622,
        23.079881229283
    ],
    [
        113.17147869749,
        23.080068704272
    ],
    [
        113.17017195606,
        23.080348750054
    ],
    [
        113.16918959147,
        23.080572485736
    ],
    [
        113.16868205654,
        23.080687581304
    ],
    [
        113.16867445747,
        23.080689224523
    ],
    [
        113.1679466288,
        23.080829633517
    ],
    [
        113.1671608344,
        23.080991562577
    ],
    [
        113.16644160133,
        23.081207984596
    ],
    [
        113.16614725941,
        23.081304507236
    ],
    [
        113.1658350323,
        23.081399311506
    ],
    [
        113.16551441572,
        23.081492932681
    ],
    [
        113.16520520831,
        23.08158782774
    ],
    [
        113.16512004258,
        23.081618105746
    ],
    [
        113.16499121193,
        23.081662694878
    ],
    [
        113.16477830882,
        23.081736978635
    ],
    [
        113.16464270702,
        23.08178097297
    ],
    [
        113.16449219217,
        23.0818325182
    ],
    [
        113.16431510537,
        23.081892669993
    ],
    [
        113.16405449802,
        23.081996281312
    ],
    [
        113.16397938342,
        23.082022965225
    ],
    [
        113.16384461432,
        23.082068488665
    ],
    [
        113.16352329334,
        23.0821883695
    ],
    [
        113.1630761869,
        23.082353881301
    ],
    [
        113.16285386851,
        23.082432096753
    ],
    [
        113.16278473362,
        23.082459802886
    ],
    [
        113.16262613411,
        23.082520826449
    ],
    [
        113.16238702353,
        23.082612178458
    ],
    [
        113.16213545386,
        23.082706683639
    ],
    [
        113.16186791477,
        23.082770955112
    ],
    [
        113.16165324809,
        23.082805830807
    ],
    [
        113.1614112274,
        23.082812328266
    ],
    [
        113.16111935895,
        23.082803882058
    ],
    [
        113.16098766199,
        23.082786681943
    ],
    [
        113.16081532398,
        23.0827600341
    ],
    [
        113.16061861215,
        23.082708817057
    ],
    [
        113.16025338562,
        23.082614306325
    ],
    [
        113.16001985241,
        23.082540803758
    ],
    [
        113.15989225362,
        23.082498815758
    ],
    [
        113.15981287906,
        23.082470398248
    ],
    [
        113.15974326299,
        23.082429828782
    ],
    [
        113.15944992489,
        23.08220828079
    ],
    [
        113.15945534268,
        23.08220994287
    ],
    [
        113.15873383991,
        23.081641724629
    ],
    [
        113.15756972438,
        23.080531974083
    ],
    [
        113.15721992341,
        23.08008481027
    ],
    [
        113.15694593537,
        23.079747778632
    ],
    [
        113.1562463372,
        23.079142958861
    ],
    [
        113.15534508594,
        23.078688502366
    ],
    [
        113.15458848195,
        23.078419104344
    ],
    [
        113.15397432809,
        23.078202089986
    ],
    [
        113.15317916829,
        23.078002270409
    ],
    [
        113.15216977238,
        23.077909003215
    ],
    [
        113.15077630443,
        23.078097337671
    ],
    [
        113.15058854486,
        23.078114406435
    ],
    [
        113.15033260821,
        23.078199174658
    ],
    [
        113.1497225612,
        23.078375655636
    ],
    [
        113.14852856561,
        23.078699035512
    ],
    [
        113.14707159048,
        23.07902145398
    ],
    [
        113.14695854633,
        23.079048490806
    ],
    [
        113.14683955519,
        23.079068106552
    ],
    [
        113.14665160348,
        23.079115410693
    ],
    [
        113.1453065892,
        23.079266041975
    ],
    [
        113.14486586278,
        23.079279853147
    ],
    [
        113.14462225385,
        23.079284317603
    ],
    [
        113.14424103387,
        23.07928488033
    ],
    [
        113.14359731446,
        23.079261780626
    ],
    [
        113.14296633083,
        23.079232514789
    ],
    [
        113.14180717186,
        23.079096721454
    ],
    [
        113.14099274219,
        23.078865665028
    ],
    [
        113.14018455504,
        23.078644608988
    ],
    [
        113.14018401447,
        23.078644328264
    ],
    [
        113.14000751,
        23.078623603813
    ],
    [
        113.139520439,
        23.078564317316
    ],
    [
        113.13876902273,
        23.078550772563
    ],
    [
        113.13750838266,
        23.078651797636
    ],
    [
        113.13667614779,
        23.078829557116
    ],
    [
        113.13583661528,
        23.079001755827
    ],
    [
        113.13514844014,
        23.079157410377
    ],
    [
        113.13491057698,
        23.079213943219
    ],
    [
        113.1346929961,
        23.079203568441
    ],
    [
        113.13445460314,
        23.079186318734
    ],
    [
        113.13371673026,
        23.079023804339
    ],
    [
        113.13272073545,
        23.078633871828
    ],
    [
        113.13145332491,
        23.078003990184
    ],
    [
        113.13069374507,
        23.077685828159
    ],
    [
        113.13028961218,
        23.077510255661
    ],
    [
        113.12907470758,
        23.076996553347
    ],
    [
        113.12905037624,
        23.07697987659
    ],
    [
        113.12745383317,
        23.07630275925
    ],
    [
        113.12643278373,
        23.075756490946
    ],
    [
        113.12588192159,
        23.075484691936
    ],
    [
        113.12542622443,
        23.075268710737
    ],
    [
        113.1253899838,
        23.075245656551
    ],
    [
        113.12515252399,
        23.075135805191
    ],
    [
        113.12453910023,
        23.074854241079
    ],
    [
        113.12387774218,
        23.074421113083
    ],
    [
        113.12364861243,
        23.07418814676
    ],
    [
        113.12336049581,
        23.073887938308
    ],
    [
        113.12305773526,
        23.073418034175
    ],
    [
        113.12302604006,
        23.073095060003
    ],
    [
        113.12304684514,
        23.072928778597
    ],
    [
        113.12306008414,
        23.072824245534
    ],
    [
        113.12307873799,
        23.072750440026
    ],
    [
        113.12317471642,
        23.072430824076
    ],
    [
        113.12326882901,
        23.072288602508
    ],
    [
        113.12344812755,
        23.072036605042
    ],
    [
        113.12365340649,
        23.071876950314
    ],
    [
        113.12399714247,
        23.071591765603
    ],
    [
        113.12449502187,
        23.071267352026
    ],
    [
        113.12514428934,
        23.0708153554
    ],
    [
        113.12536059739,
        23.070622417854
    ],
    [
        113.12537195336,
        23.070612277766
    ],
    [
        113.12542224551,
        23.070573146897
    ],
    [
        113.12566125716,
        23.0703648461
    ],
    [
        113.1257001878,
        23.07032202525
    ],
    [
        113.12604268962,
        23.069872257201
    ],
    [
        113.12613836905,
        23.069710671278
    ],
    [
        113.12623729241,
        23.069552394558
    ],
    [
        113.12610504517,
        23.069524062863
    ],
    [
        113.12590219672,
        23.06944556845
    ],
    [
        113.12570772465,
        23.069359081715
    ],
    [
        113.12551081265,
        23.069267694476
    ],
    [
        113.12522435066,
        23.069100941049
    ],
    [
        113.1249705974,
        23.068915718978
    ],
    [
        113.12486914353,
        23.068830137831
    ],
    [
        113.12484044941,
        23.068762169264
    ],
    [
        113.1248285318,
        23.068715876973
    ],
    [
        113.12482525213,
        23.068625219478
    ],
    [
        113.12481950884,
        23.068459108237
    ],
    [
        113.12486543509,
        23.068324947592
    ],
    [
        113.1248984086,
        23.06826737319
    ],
    [
        113.12495949194,
        23.068165719266
    ],
    [
        113.12496218377,
        23.068134017967
    ],
    [
        113.12495135375,
        23.06810510297
    ],
    [
        113.12492484143,
        23.068087081579
    ],
    [
        113.12487723449,
        23.068072550721
    ],
    [
        113.12481096336,
        23.068053137461
    ],
    [
        113.12427352657,
        23.068027761433
    ],
    [
        113.12412827889,
        23.068030308568
    ],
    [
        113.1240246722,
        23.068004155839
    ],
    [
        113.12397353765,
        23.06797413567
    ],
    [
        113.1239656749,
        23.067928991045
    ],
    [
        113.12396807625,
        23.067849265999
    ],
    [
        113.12398534066,
        23.067737466904
    ],
    [
        113.12401824225,
        23.067508420124
    ],
    [
        113.12405415443,
        23.067365143688
    ],
    [
        113.12409305075,
        23.06724415584
    ],
    [
        113.1241262699,
        23.067131769547
    ],
    [
        113.12414354431,
        23.067051169858
    ],
    [
        113.1241462348,
        23.06701973829
    ],
    [
        113.12413946523,
        23.067003364828
    ],
    [
        113.12413188667,
        23.066992405738
    ],
    [
        113.12409698675,
        23.06697617645
    ],
    [
        113.12403612144,
        23.06696310776
    ],
    [
        113.12394982556,
        23.066941001821
    ],
    [
        113.12376479627,
        23.066913991709
    ],
    [
        113.12370176833,
        23.066909043301
    ],
    [
        113.1236406398,
        23.066917959452
    ],
    [
        113.12357708055,
        23.066936068013
    ],
    [
        113.12353786137,
        23.066943935103
    ],
    [
        113.12351134889,
        23.066937057606
    ],
    [
        113.12337175383,
        23.066906649149
    ],
    [
        113.12302627433,
        23.066834931619
    ],
    [
        113.12282850889,
        23.066806767563
    ],
    [
        113.12256660725,
        23.066747392586
    ],
    [
        113.12238235458,
        23.06671349399
    ],
    [
        113.12225627418,
        23.066698822428
    ],
    [
        113.12213425,
        23.066684213602
    ],
    [
        113.12195081536,
        23.066685915604
    ],
    [
        113.1218704553,
        23.066677017904
    ],
    [
        113.12184474242,
        23.066656613555
    ],
    [
        113.12181114604,
        23.066558248262
    ],
    [
        113.12175640263,
        23.066372258335
    ],
    [
        113.12171436552,
        23.066169611109
    ],
    [
        113.12167425387,
        23.066033727242
    ],
    [
        113.12167043666,
        23.065975622107
    ],
    [
        113.12167335047,
        23.065852762988
    ],
    [
        113.12168165388,
        23.0656892779
    ],
    [
        113.12168215265,
        23.065607895936
    ],
    [
        113.12166969174,
        23.065579523476
    ],
    [
        113.12166914207,
        23.065563238848
    ],
    [
        113.1216512781,
        23.0655508045
    ],
    [
        113.12163179138,
        23.065539706325
    ],
    [
        113.12155954194,
        23.065525772844
    ],
    [
        113.12137662747,
        23.06551398579
    ],
    [
        113.12111822233,
        23.065516212345
    ],
    [
        113.12109467976,
        23.065513481453
    ],
    [
        113.12091473519,
        23.065511283152
    ],
    [
        113.12052235687,
        23.065502226131
    ],
    [
        113.12029368987,
        23.065506309413
    ],
    [
        113.12017651307,
        23.065510366474
    ],
    [
        113.12001927771,
        23.065507731112
    ],
    [
        113.11991346295,
        23.065511941139
    ],
    [
        113.11981144549,
        23.065535193034
    ],
    [
        113.11972323637,
        23.065572173338
    ],
    [
        113.11965452316,
        23.065629725846
    ],
    [
        113.11961476378,
        23.065678654084
    ],
    [
        113.11955038404,
        23.065744941853
    ],
    [
        113.11949060388,
        23.065809927395
    ],
    [
        113.11935614477,
        23.065919123207
    ],
    [
        113.11918404949,
        23.066006759762
    ],
    [
        113.11900843185,
        23.066096821795
    ],
    [
        113.11885283655,
        23.066181423156
    ],
    [
        113.11867342529,
        23.066282882849
    ],
    [
        113.11850890601,
        23.066403783542
    ],
    [
        113.11837442343,
        23.066512534616
    ],
    [
        113.11828702226,
        23.066584885169
    ],
    [
        113.11820287067,
        23.066662700446
    ],
    [
        113.1181068247,
        23.066779466859
    ],
    [
        113.11794881401,
        23.066963442927
    ],
    [
        113.11784329387,
        23.067094783747
    ],
    [
        113.11776268309,
        23.067238314721
    ],
    [
        113.11770207055,
        23.067305542375
    ],
    [
        113.11765389162,
        23.067329216343
    ],
    [
        113.11763629946,
        23.067340981634
    ],
    [
        113.11761978541,
        23.067341906041
    ],
    [
        113.11756698779,
        23.067329999326
    ],
    [
        113.11749956322,
        23.06730249025
    ],
    [
        113.11742996874,
        23.067267639113
    ],
    [
        113.11738501843,
        23.067250118038
    ],
    [
        113.11729702416,
        23.067242499084
    ],
    [
        113.11712401627,
        23.067241143243
    ],
    [
        113.11694044378,
        23.067239442829
    ],
    [
        113.1167917991,
        23.06724785219
    ],
    [
        113.1166252825,
        23.067262359195
    ],
    [
        113.1164934265,
        23.067289130942
    ],
    [
        113.11636129704,
        23.067316457001
    ],
    [
        113.11628060985,
        23.067332847263
    ],
    [
        113.11613655044,
        23.067336763382
    ],
    [
        113.11606126551,
        23.067328798127
    ],
    [
        113.11596350618,
        23.067327973493
    ],
    [
        113.11586384649,
        23.067320087387
    ],
    [
        113.11568808529,
        23.067309415233
    ],
    [
        113.1155296522,
        23.067300264304
    ],
    [
        113.11538882573,
        23.067307008441
    ],
    [
        113.1151616003,
        23.067317439109
    ],
    [
        113.11498799,
        23.06731855199
    ],
    [
        113.11484823554,
        23.067329166382
    ],
    [
        113.11476454687,
        23.067342651992
    ],
    [
        113.11467028703,
        23.067341687828
    ],
    [
        113.11457684347,
        23.06735267392
    ],
    [
        113.11451157022,
        23.067366582157
    ],
    [
        113.11441353203,
        23.067407118991
    ],
    [
        113.11430627969,
        23.067441902424
    ],
    [
        113.11421851955,
        23.067454856009
    ],
    [
        113.11411449942,
        23.067455496923
    ],
    [
        113.1139389598,
        23.067453496719
    ],
    [
        113.11383710294,
        23.067456889928
    ],
    [
        113.11373064817,
        23.067481965461
    ],
    [
        113.11368216311,
        23.067499556412
    ],
    [
        113.11363016062,
        23.067528521027
    ],
    [
        113.11353105142,
        23.067635591758
    ],
    [
        113.1134259736,
        23.067728255372
    ],
    [
        113.11334228283,
        23.067787691558
    ],
    [
        113.11313614071,
        23.067875965349
    ],
    [
        113.11299826181,
        23.067947583205
    ],
    [
        113.11285088775,
        23.067998816656
    ],
    [
        113.11275688797,
        23.068050098128
    ],
    [
        113.11263662706,
        23.068160925105
    ],
    [
        113.11259328556,
        23.068192155286
    ],
    [
        113.11256700646,
        23.068203133839
    ],
    [
        113.11254641312,
        23.068203021208
    ],
    [
        113.11251714148,
        23.068184414142
    ],
    [
        113.11251659879,
        23.068182512174
    ],
    [
        113.11251036794,
        23.068186005085
    ],
    [
        113.11251662634,
        23.068252504741
    ],
    [
        113.1125212507,
        23.068298377598
    ],
    [
        113.11252233932,
        23.068310591487
    ],
    [
        113.11252374106,
        23.068432136148
    ],
    [
        113.11257415999,
        23.06848314237
    ],
    [
        113.11266414126,
        23.068541423751
    ],
    [
        113.11280099243,
        23.068590482731
    ],
    [
        113.11286415188,
        23.068665176324
    ],
    [
        113.1128619869,
        23.068672217363
    ],
    [
        113.1128628122,
        23.068705861707
    ],
    [
        113.1128633623,
        23.068728110404
    ],
    [
        113.11286309225,
        23.068730550437
    ],
    [
        113.11285903866,
        23.068759554884
    ],
    [
        113.11284009469,
        23.068821299769
    ],
    [
        113.11282982161,
        23.068884993428
    ],
    [
        113.11282467763,
        23.068896358099
    ],
    [
        113.11281143403,
        23.068988791287
    ],
    [
        113.11279087851,
        23.069093390887
    ],
    [
        113.11278736359,
        23.069114802536
    ],
    [
        113.1127757347,
        23.06917848881
    ],
    [
        113.11277222155,
        23.069205326213
    ],
    [
        113.11276735629,
        23.069240023257
    ],
    [
        113.11276440027,
        23.069311897217
    ],
    [
        113.11275332666,
        23.069417635946
    ],
    [
        113.1127414363,
        23.06951333253
    ],
    [
        113.11273386143,
        23.069549642061
    ],
    [
        113.11273792462,
        23.069546138225
    ],
    [
        113.11273223374,
        23.069543664639
    ],
    [
        113.11273114947,
        23.069542302117
    ],
    [
        113.11273169608,
        23.069556683286
    ],
    [
        113.11273604444,
        23.069596857892
    ],
    [
        113.11263284533,
        23.0697088649
    ],
    [
        113.11252828702,
        23.069815176868
    ],
    [
        113.11252747455,
        23.069816528866
    ],
    [
        113.11252422456,
        23.069821665579
    ],
    [
        113.11252774899,
        23.069827653007
    ],
    [
        113.1125093433,
        23.069892118561
    ],
    [
        113.11249877708,
        23.069896944381
    ],
    [
        113.11248199654,
        23.069960334008
    ],
    [
        113.11246304627,
        23.070018015204
    ],
    [
        113.11243515365,
        23.070075377429
    ],
    [
        113.11243542697,
        23.070083246113
    ],
    [
        113.11243759661,
        23.070089497263
    ],
    [
        113.11181482568,
        23.069939023594
    ],
    [
        113.11178287675,
        23.070035447493
    ],
    [
        113.1117655467,
        23.070082568162
    ],
    [
        113.11176175637,
        23.070095029157
    ],
    [
        113.11161605931,
        23.07045813578
    ],
    [
        113.11160224799,
        23.070494966356
    ],
    [
        113.11144297358,
        23.070802147702
    ],
    [
        113.11181029568,
        23.071210771985
    ],
    [
        113.11168894683,
        23.071472523581
    ],
    [
        113.11169030076,
        23.071467646904
    ],
    [
        113.1115199151,
        23.071839055041
    ],
    [
        113.11093850473,
        23.071605709937
    ],
    [
        113.11084010201,
        23.071549435847
    ],
    [
        113.11081299534,
        23.071542276543
    ],
    [
        113.11068965221,
        23.071482934831
    ],
    [
        113.11062621765,
        23.07145339822
    ],
    [
        113.1105877227,
        23.071435079589
    ],
    [
        113.11036027163,
        23.071328735032
    ],
    [
        113.1103172409,
        23.071639472189
    ],
    [
        113.11029016987,
        23.07181136999
    ],
    [
        113.11019702486,
        23.072359578918
    ],
    [
        113.11016859167,
        23.072533915372
    ],
    [
        113.11012038578,
        23.072824022261
    ],
    [
        113.11003750789,
        23.073357081154
    ],
    [
        113.10988877209,
        23.074289252582
    ],
    [
        113.10980205317,
        23.074817968968
    ],
    [
        113.10976600463,
        23.075006937257
    ],
    [
        113.10965377993,
        23.075766706512
    ],
    [
        113.10955345664,
        23.076380573101
    ],
    [
        113.1095214557,
        23.076604008047
    ],
    [
        113.10949270858,
        23.076771029213
    ],
    [
        113.10925954235,
        23.076757406331
    ],
    [
        113.1092316162,
        23.076751098491
    ],
    [
        113.1089249584,
        23.07673140227
    ],
    [
        113.10857381212,
        23.07670818372
    ],
    [
        113.10855699597,
        23.076778681589
    ],
    [
        113.10855780951,
        23.076777869282
    ],
    [
        113.10855563767,
        23.076821267569
    ],
    [
        113.10853394077,
        23.076879821209
    ],
    [
        113.10853204154,
        23.07689663614
    ],
    [
        113.10852878383,
        23.076953866913
    ],
    [
        113.10850681208,
        23.077057178977
    ],
    [
        113.10848565478,
        23.077139605551
    ],
    [
        113.10845825362,
        23.077300416543
    ],
    [
        113.10845011491,
        23.077341905627
    ],
    [
        113.10845336551,
        23.077381244295
    ],
    [
        113.10844143119,
        23.077411876359
    ],
    [
        113.10843491972,
        23.077448214325
    ],
    [
        113.10843464737,
        23.077460963179
    ],
    [
        113.10841728482,
        23.077539328308
    ],
    [
        113.10835978226,
        23.077672693056
    ],
    [
        113.10832750375,
        23.077751577569
    ],
    [
        113.10828274958,
        23.077838038612
    ],
    [
        113.1082548111,
        23.07789740121
    ],
    [
        113.1082363657,
        23.077939960799
    ],
    [
        113.10820842794,
        23.077988745373
    ],
    [
        113.10814388182,
        23.07802065906
    ],
    [
        113.10814956131,
        23.0781427344
    ],
    [
        113.10794479541,
        23.07826045543
    ],
    [
        113.10797487687,
        23.078413212811
    ],
    [
        113.10801661373,
        23.07859555337
    ],
    [
        113.10803558221,
        23.078691875483
    ],
    [
        113.10804181818,
        23.07870110666
    ],
    [
        113.10804452958,
        23.07870436542
    ],
    [
        113.10804262898,
        23.078718468294
    ],
    [
        113.10804805183,
        23.078724714566
    ],
    [
        113.10806322916,
        23.078782784502
    ],
    [
        113.10806078696,
        23.078791732686
    ],
    [
        113.10807135751,
        23.078827553251
    ],
    [
        113.10808327542,
        23.078913558492
    ],
    [
        113.1080802844,
        23.078959668173
    ],
    [
        113.10805479063,
        23.078969940989
    ],
    [
        113.10800082009,
        23.078987500681
    ],
    [
        113.10778005582,
        23.079027922734
    ],
    [
        113.10757637031,
        23.079060539084
    ],
    [
        113.10709194543,
        23.079115269803
    ],
    [
        113.10674961589,
        23.079179181705
    ],
    [
        113.10652608839,
        23.079207654101
    ],
    [
        113.10632723767,
        23.079237794148
    ],
    [
        113.10623988254,
        23.079248398202
    ],
    [
        113.10622387509,
        23.07925681252
    ],
    [
        113.10594850137,
        23.079315262167
    ],
    [
        113.10580253535,
        23.079338416176
    ],
    [
        113.10533937069,
        23.079450613217
    ],
    [
        113.10508239907,
        23.0795222832
    ],
    [
        113.10507046016,
        23.079520943723
    ],
    [
        113.10499637854,
        23.079539767596
    ],
    [
        113.10493830578,
        23.079558029337
    ],
    [
        113.10484658198,
        23.079587198425
    ],
    [
        113.10476326943,
        23.079613105912
    ],
    [
        113.10466557416,
        23.079634162825
    ],
    [
        113.1045605497,
        23.079656869878
    ],
    [
        113.10443897049,
        23.079673109916
    ],
    [
        113.10443870083,
        23.07966497279
    ],
    [
        113.10425768677,
        23.079674843372
    ],
    [
        113.10409431013,
        23.079671140421
    ],
    [
        113.1039740841,
        23.079654878785
    ],
    [
        113.10391274787,
        23.079650960449
    ],
    [
        113.10374936522,
        23.079625337678
    ],
    [
        113.10367581248,
        23.079622278686
    ],
    [
        113.10357837193,
        23.079627699942
    ],
    [
        113.10351865152,
        23.079662860094
    ],
    [
        113.10349801795,
        23.079687874462
    ],
    [
        113.10349177487,
        23.079689248629
    ],
    [
        113.10349638807,
        23.079694118003
    ],
    [
        113.10346380863,
        23.079733001307
    ],
    [
        113.1034483258,
        23.079786212236
    ],
    [
        113.10341653984,
        23.079917049994
    ],
    [
        113.10337551835,
        23.080072871317
    ],
    [
        113.10336981286,
        23.080096216166
    ],
    [
        113.10336436265,
        23.080187916285
    ],
    [
        113.10337033359,
        23.080190339764
    ],
    [
        113.10336352379,
        23.080290181454
    ],
    [
        113.10335455452,
        23.080339305159
    ],
    [
        113.10334829755,
        23.080396015864
    ],
    [
        113.10335073213,
        23.080429372713
    ],
    [
        113.1033167485,
        23.08064213736
    ],
    [
        113.10329500465,
        23.08075206065
    ],
    [
        113.10328982797,
        23.080824229512
    ],
    [
        113.10327568696,
        23.080920567199
    ],
    [
        113.1032669754,
        23.081012548243
    ],
    [
        113.10323434525,
        23.081214188666
    ],
    [
        113.10320007992,
        23.081429939766
    ],
    [
        113.10315629331,
        23.081703497785
    ],
    [
        113.10312941944,
        23.081706567177
    ],
    [
        113.10312887586,
        23.081708738912
    ],
    [
        113.102991797,
        23.081701862373
    ],
    [
        113.10298881078,
        23.081702686055
    ],
    [
        113.10297360878,
        23.081704906742
    ],
    [
        113.10294999401,
        23.081699832163
    ],
    [
        113.10288783064,
        23.081700585477
    ],
    [
        113.10262858446,
        23.081697976334
    ],
    [
        113.10203946949,
        23.081680214552
    ],
    [
        113.10191349256,
        23.08168020686
    ],
    [
        113.10180163096,
        23.081681236215
    ],
    [
        113.10133488728,
        23.081671182543
    ],
    [
        113.10105520112,
        23.081668496923
    ],
    [
        113.10075432086,
        23.081659754976
    ],
    [
        113.10067944756,
        23.082248223978
    ],
    [
        113.10066579654,
        23.082456887099
    ],
    [
        113.10066199709,
        23.082449855251
    ],
    [
        113.10041369178,
        23.084054013673
    ],
    [
        113.10037609705,
        23.084319772348
    ],
    [
        113.10018532972,
        23.084573124362
    ],
    [
        113.1001820725,
        23.084569074758
    ],
    [
        113.10012231201,
        23.084591667028
    ],
    [
        113.09987947089,
        23.084660662379
    ],
    [
        113.09987403802,
        23.084662322994
    ],
    [
        113.09986968594,
        23.084676182868
    ],
    [
        113.09980721974,
        23.084668971575
    ],
    [
        113.099758594,
        23.084685546865
    ],
    [
        113.09969665974,
        23.084700037534
    ],
    [
        113.09969040519,
        23.08471607992
    ],
    [
        113.09964908293,
        23.084794999413
    ],
    [
        113.09961565069,
        23.084844847617
    ],
    [
        113.09961700521,
        23.084852433772
    ],
    [
        113.09960069902,
        23.084871795179
    ],
    [
        113.0995528583,
        23.084947233239
    ],
    [
        113.09954334213,
        23.084967094575
    ],
    [
        113.0995338136,
        23.085012723859
    ],
    [
        113.09952510699,
        23.085043429742
    ],
    [
        113.09952157069,
        23.085054302008
    ],
    [
        113.09951176901,
        23.085102645582
    ],
    [
        113.0995090186,
        23.085173185538
    ],
    [
        113.0995027714,
        23.085172954447
    ],
    [
        113.09950711513,
        23.085177537599
    ],
    [
        113.09949755458,
        23.085287450997
    ],
    [
        113.09941326832,
        23.085453994565
    ],
    [
        113.09925801394,
        23.085756632061
    ],
    [
        113.09901489446,
        23.086276605913
    ],
    [
        113.09888734593,
        23.08654384017
    ],
    [
        113.09888979363,
        23.086538669665
    ],
    [
        113.09887048746,
        23.086572979793
    ],
    [
        113.09867874939,
        23.08696572437
    ],
    [
        113.09855581456,
        23.087213973463
    ],
    [
        113.09855717149,
        23.087216404749
    ],
    [
        113.09861529282,
        23.087242566522
    ],
    [
        113.09909351938,
        23.087506663007
    ],
    [
        113.09931971625,
        23.087635072053
    ],
    [
        113.09921148579,
        23.087834603517
    ],
    [
        113.09918374407,
        23.087891747947
    ],
    [
        113.09909972222,
        23.088030913794
    ],
    [
        113.09889904554,
        23.088355056111
    ],
    [
        113.09887184744,
        23.088407321719
    ],
    [
        113.0988568938,
        23.088427497123
    ],
    [
        113.09884873747,
        23.088438132105
    ],
    [
        113.09884439083,
        23.088438433721
    ],
    [
        113.09882562738,
        23.088468942938
    ],
    [
        113.09875439571,
        23.088559764159
    ],
    [
        113.09873373989,
        23.088575099267
    ],
    [
        113.09873482013,
        23.088585127148
    ],
    [
        113.09862522982,
        23.088757597578
    ],
    [
        113.09860377331,
        23.088749886111
    ],
    [
        113.09856705966,
        23.088809821517
    ],
    [
        113.09847486851,
        23.088956413087
    ],
    [
        113.09843434939,
        23.089017465216
    ],
    [
        113.09841258635,
        23.089061835552
    ],
    [
        113.09840850836,
        23.089066205234
    ],
    [
        113.09859997023,
        23.089164895017
    ],
    [
        113.09854852938,
        23.089309017886
    ],
    [
        113.09849792345,
        23.089421674203
    ],
    [
        113.09849246901,
        23.089452905244
    ],
    [
        113.09848513058,
        23.089457840877
    ],
    [
        113.09848947678,
        23.089458622861
    ],
    [
        113.09847778354,
        23.08947552436
    ],
    [
        113.09847996204,
        23.089467914055
    ],
    [
        113.09856116209,
        23.089510720608
    ],
    [
        113.09865079059,
        23.089541538331
    ],
    [
        113.09870048134,
        23.089575901027
    ],
    [
        113.09861426514,
        23.089721353329
    ],
    [
        113.09858487191,
        23.089799136112
    ],
    [
        113.0983811862,
        23.090093819382
    ],
    [
        113.09836622345,
        23.090123222473
    ],
    [
        113.09833439961,
        23.090176889977
    ],
    [
        113.09833304255,
        23.090175001463
    ],
    [
        113.09840853519,
        23.090222179352
    ],
    [
        113.09856061815,
        23.090296470788
    ],
    [
        113.09872790198,
        23.090381794161
    ],
    [
        113.09887807951,
        23.090449088053
    ],
    [
        113.09894460395,
        23.090490938089
    ],
    [
        113.09894541734,
        23.090493102283
    ],
    [
        113.09899511065,
        23.090518526709
    ],
    [
        113.09899728422,
        23.090517969343
    ],
    [
        113.09901357489,
        23.090529249195
    ],
    [
        113.09903367167,
        23.090536163655
    ],
    [
        113.09903312779,
        23.090536981048
    ],
    [
        113.09902715566,
        23.090531326102
    ],
    [
        113.09903339982,
        23.090536436738
    ],
    [
        113.0990735918,
        23.090552165276
    ],
    [
        113.09912546096,
        23.090572155925
    ],
    [
        113.09914691183,
        23.090584216486
    ],
    [
        113.09916890101,
        23.090603054479
    ],
    [
        113.09917650105,
        23.090611140263
    ],
    [
        113.09918003392,
        23.090608946764
    ],
    [
        113.09919333132,
        23.090626758613
    ],
    [
        113.09918435044,
        23.090650144191
    ],
    [
        113.09917891531,
        23.090653435333
    ],
    [
        113.09916804211,
        23.090664086101
    ],
    [
        113.09913241977,
        23.090716129971
    ],
    [
        113.09897635867,
        23.090905423568
    ],
    [
        113.09872650048,
        23.091189242795
    ],
    [
        113.09857017448,
        23.091350384107
    ],
    [
        113.09838503303,
        23.091528574029
    ],
    [
        113.09818739381,
        23.09169793638
    ],
    [
        113.09799193105,
        23.091853482037
    ],
    [
        113.09778777143,
        23.092002618459
    ],
    [
        113.09764397639,
        23.092083770566
    ],
    [
        113.09757384267,
        23.092125559299
    ],
    [
        113.09747569731,
        23.092198227784
    ],
    [
        113.09733484501,
        23.092328212447
    ],
    [
        113.09722119364,
        23.092417573878
    ],
    [
        113.09714750785,
        23.092477317305
    ],
    [
        113.09692101552,
        23.092649026366
    ],
    [
        113.09669584062,
        23.092860634637
    ],
    [
        113.09661099593,
        23.092932441456
    ],
    [
        113.0965005844,
        23.093029163033
    ],
    [
        113.096406209,
        23.09312059664
    ],
    [
        113.09630748442,
        23.093210991876
    ],
    [
        113.09617286853,
        23.093320166949
    ],
    [
        113.09583152489,
        23.093633352666
    ],
    [
        113.0956971998,
        23.093705417942
    ],
    [
        113.09519687732,
        23.093944902001
    ],
    [
        113.09481486251,
        23.094065380862
    ],
    [
        113.09430698063,
        23.094158550773
    ],
    [
        113.09369085768,
        23.094245782034
    ],
    [
        113.09339285375,
        23.094267283045
    ],
    [
        113.09330122279,
        23.094271031713
    ],
    [
        113.09310818424,
        23.094260216286
    ],
    [
        113.09309485793,
        23.094263895174
    ],
    [
        113.0929200688,
        23.094208958427
    ],
    [
        113.09276949575,
        23.094130163066
    ],
    [
        113.09253660059,
        23.093963128024
    ],
    [
        113.09221127648,
        23.093751138216
    ],
    [
        113.09197125436,
        23.093628216036
    ],
    [
        113.09197125011,
        23.093633369247
    ],
    [
        113.09193726526,
        23.093623208742
    ],
    [
        113.09163574418,
        23.093533642923
    ],
    [
        113.09127082533,
        23.093464198201
    ],
    [
        113.09124690272,
        23.093450941682
    ],
    [
        113.09091918376,
        23.093434265118
    ],
    [
        113.09057833847,
        23.093486989703
    ],
    [
        113.09018956362,
        23.093590331475
    ],
    [
        113.08977167996,
        23.093673819824
    ],
    [
        113.08917090377,
        23.09383183241
    ],
    [
        113.08899023191,
        23.093873695413
    ],
    [
        113.08876470398,
        23.093871733912
    ],
    [
        113.08858133694,
        23.093872993447
    ],
    [
        113.08808671364,
        23.093880681725
    ],
    [
        113.08797324351,
        23.093898341119
    ],
    [
        113.08793922461,
        23.09390941686
    ],
    [
        113.08787256016,
        23.093915548102
    ],
    [
        113.08787524916,
        23.093953750327
    ],
    [
        113.08795978444,
        23.094374524919
    ],
    [
        113.08814967534,
        23.09534325019
    ],
    [
        113.08836645664,
        23.09632733101
    ],
    [
        113.08844797332,
        23.096740842152
    ],
    [
        113.0885167679,
        23.097078598895
    ],
    [
        113.08857554093,
        23.0973646995
    ],
    [
        113.0886418613,
        23.097723649817
    ],
    [
        113.08876573624,
        23.097918242488
    ],
    [
        113.08877713945,
        23.097942760728
    ],
    [
        113.08883381303,
        23.098139669764
    ],
    [
        113.08890047399,
        23.098418073743
    ],
    [
        113.08890291242,
        23.098428616505
    ],
    [
        113.08890319194,
        23.098420747432
    ],
    [
        113.08891489019,
        23.098420582111
    ],
    [
        113.08897533034,
        23.098658666028
    ],
    [
        113.08901867534,
        23.098849530364
    ],
    [
        113.08901785296,
        23.09885605099
    ],
    [
        113.08901839368,
        23.09885956912
    ],
    [
        113.08904519074,
        23.099000764151
    ],
    [
        113.08905629443,
        23.099052951723
    ],
    [
        113.08908094218,
        23.099165429097
    ],
    [
        113.08908607449,
        23.099203326503
    ],
    [
        113.08911341218,
        23.099346955678
    ],
    [
        113.08914588514,
        23.09952468575
    ],
    [
        113.08915240107,
        23.099538155041
    ],
    [
        113.08914803914,
        23.099547708438
    ],
    [
        113.08915728551,
        23.099550833553
    ],
    [
        113.0891716736,
        23.09958182142
    ],
    [
        113.08917383468,
        23.09959752137
    ],
    [
        113.08917953628,
        23.099609103676
    ],
    [
        113.08918305231,
        23.09963020889
    ],
    [
        113.08918577353,
        23.099629357226
    ],
    [
        113.08918793803,
        23.099641531416
    ],
    [
        113.08918820058,
        23.099651291299
    ],
    [
        113.08919498691,
        23.09966638422
    ],
    [
        113.08919958475,
        23.099693983383
    ],
    [
        113.08919873564,
        23.099727896457
    ],
    [
        113.08920743522,
        23.099733741569
    ],
    [
        113.08920333926,
        23.099749528931
    ],
    [
        113.08922233155,
        23.099801336034
    ],
    [
        113.08921824192,
        23.099810614238
    ],
    [
        113.08922960319,
        23.099876630835
    ],
    [
        113.08923420991,
        23.09989500882
    ],
    [
        113.08923502286,
        23.099898251995
    ],
    [
        113.08924802368,
        23.099956651958
    ],
    [
        113.08925639812,
        23.100016743729
    ],
    [
        113.08927288779,
        23.100123641708
    ],
    [
        113.08929292362,
        23.100220455715
    ],
    [
        113.08929970281,
        23.100242600551
    ],
    [
        113.08925390512,
        23.100339788709
    ],
    [
        113.08922965365,
        23.100380537029
    ],
    [
        113.08916313274,
        23.100526020712
    ],
    [
        113.08900542456,
        23.1007237754
    ],
    [
        113.08898364343,
        23.100741439509
    ],
    [
        113.08882319312,
        23.100957148495
    ],
    [
        113.0888207301,
        23.100971828679
    ],
    [
        113.0887755099,
        23.101031865111
    ],
    [
        113.08873630109,
        23.101065238702
    ],
    [
        113.08872021708,
        23.101098283806
    ],
    [
        113.08860527104,
        23.101237426298
    ],
    [
        113.08857939004,
        23.101273053593
    ],
    [
        113.08854970195,
        23.101306837332
    ],
    [
        113.08851892712,
        23.101339009885
    ],
    [
        113.08850612684,
        23.101352482743
    ],
    [
        113.08842494299,
        23.10146213287
    ],
    [
        113.08838190755,
        23.101511570315
    ],
    [
        113.08834813659,
        23.101546500952
    ],
    [
        113.08829773394,
        23.1016169297
    ],
    [
        113.08824871167,
        23.101666999189
    ],
    [
        113.08821302887,
        23.101708740132
    ],
    [
        113.08820593676,
        23.101727013964
    ],
    [
        113.08818524692,
        23.101739518673
    ],
    [
        113.08816753954,
        23.101762286162
    ],
    [
        113.08811415947,
        23.10181621935
    ],
    [
        113.0880752174,
        23.101851772541
    ],
    [
        113.08803954336,
        23.101884024315
    ],
    [
        113.08798451913,
        23.101948833413
    ],
    [
        113.08792297491,
        23.102003433747
    ],
    [
        113.08791344223,
        23.102013336988
    ],
    [
        113.087903644,
        23.102016735188
    ],
    [
        113.08789140655,
        23.102010676965
    ],
    [
        113.08788242754,
        23.102011079965
    ],
    [
        113.08787563254,
        23.10200412833
    ],
    [
        113.08787263472,
        23.102009054089
    ],
    [
        113.08786910717,
        23.101999613628
    ],
    [
        113.08785387402,
        23.101996311718
    ],
    [
        113.08785033775,
        23.101995550064
    ],
    [
        113.08783945983,
        23.101990285811
    ],
    [
        113.08781878413,
        23.101987877825
    ],
    [
        113.08781409221,
        23.102054121524
    ],
    [
        113.08779559559,
        23.102049240851
    ],
    [
        113.08780104003,
        23.102046448614
    ],
    [
        113.08779880256,
        23.102106960849
    ],
    [
        113.08779196988,
        23.102137436707
    ],
    [
        113.08778950447,
        23.102154016676
    ],
    [
        113.0877775196,
        23.102167211186
    ],
    [
        113.08776908165,
        23.102170590019
    ],
    [
        113.0877562723,
        23.102191933036
    ],
    [
        113.08775517222,
        23.10220361118
    ],
    [
        113.08775979415,
        23.102207068731
    ],
    [
        113.08776767428,
        23.102217258455
    ],
    [
        113.08777581312,
        23.102240733566
    ],
    [
        113.08778369051,
        23.10225363547
    ],
    [
        113.08778042356,
        23.10225558205
    ],
    [
        113.08778177034,
        23.102269122583
    ],
    [
        113.08778720605,
        23.102275009077
    ],
    [
        113.08778257458,
        23.102281043864
    ],
    [
        113.08777003431,
        23.102305366103
    ],
    [
        113.08775830727,
        23.102332659712
    ],
    [
        113.08775366758,
        23.10234683091
    ],
    [
        113.08798593249,
        23.102436986329
    ],
    [
        113.08824837578,
        23.102542462326
    ],
    [
        113.08849781073,
        23.102590394354
    ],
    [
        113.08872629116,
        23.102637844434
    ],
    [
        113.08901976123,
        23.102708545169
    ],
    [
        113.08925805473,
        23.10272310853
    ],
    [
        113.08953525717,
        23.102722522635
    ],
    [
        113.08986085435,
        23.102737324469
    ],
    [
        113.09022344827,
        23.102735692883
    ],
    [
        113.09060915606,
        23.102723531326
    ],
    [
        113.09066627187,
        23.102726036884
    ],
    [
        113.09066379539,
        23.10275427491
    ],
    [
        113.09065473669,
        23.102836298272
    ],
    [
        113.09066444784,
        23.103184130309
    ],
    [
        113.09064183098,
        23.103492789429
    ],
    [
        113.09063956784,
        23.103578520603
    ],
    [
        113.0906042815,
        23.104041120675
    ],
    [
        113.09057556293,
        23.104463496253
    ],
    [
        113.09054853608,
        23.104826726795
    ],
    [
        113.09051548065,
        23.105233159075
    ],
    [
        113.09046917565,
        23.105562744247
    ],
    [
        113.09044582911,
        23.105784086505
    ],
    [
        113.09043486012,
        23.105871017836
    ],
    [
        113.09040565717,
        23.105967683042
    ],
    [
        113.09033923662,
        23.106018737955
    ],
    [
        113.0902153066,
        23.106182843028
    ],
    [
        113.09017032761,
        23.106278367353
    ],
    [
        113.09013294836,
        23.106389792101
    ],
    [
        113.09012140832,
        23.106502769028
    ],
    [
        113.09011689513,
        23.106660129587
    ],
    [
        113.09013117616,
        23.106792558028
    ],
    [
        113.09013765288,
        23.106842915603
    ],
    [
        113.09011436871,
        23.107002697785
    ],
    [
        113.09006197844,
        23.107163414262
    ],
    [
        113.08995922531,
        23.107363324044
    ],
    [
        113.08988508313,
        23.107514034488
    ],
    [
        113.08977667171,
        23.10765897719
    ],
    [
        113.08962032745,
        23.107858011654
    ],
    [
        113.08946834051,
        23.108049677612
    ],
    [
        113.08927797989,
        23.108255179772
    ],
    [
        113.0892392894,
        23.108315384297
    ],
    [
        113.0892139399,
        23.108364555162
    ],
    [
        113.08921415937,
        23.108416352671
    ],
    [
        113.08920104407,
        23.108472946843
    ],
    [
        113.08919282914,
        23.108525946972
    ],
    [
        113.08921453514,
        23.10858232625
    ],
    [
        113.08924902241,
        23.108643138172
    ],
    [
        113.08931985206,
        23.108813013212
    ],
    [
        113.08948134399,
        23.109177178173
    ],
    [
        113.08965319272,
        23.109519791195
    ],
    [
        113.0898182261,
        23.109874990093
    ],
    [
        113.08994443227,
        23.110157232857
    ],
    [
        113.09003341772,
        23.110393338666
    ],
    [
        113.09017832087,
        23.110746404383
    ],
    [
        113.09031501091,
        23.111152478264
    ],
    [
        113.09037171087,
        23.111303601995
    ],
    [
        113.09061835526,
        23.111918976668
    ],
    [
        113.0908627642,
        23.112595170818
    ],
    [
        113.09101716889,
        23.112964464125
    ],
    [
        113.09115878464,
        23.113339903226
    ],
    [
        113.0912512926,
        23.113589052409
    ],
    [
        113.0912678522,
        23.113621658536
    ],
    [
        113.09133617572,
        23.113848881224
    ],
    [
        113.09140855514,
        23.114102092426
    ],
    [
        113.09147222168,
        23.114367079061
    ],
    [
        113.09151603222,
        23.114636385901
    ],
    [
        113.09154285875,
        23.114743178881
    ],
    [
        113.09158406494,
        23.114887762479
    ],
    [
        113.09166319367,
        23.115200298667
    ],
    [
        113.09170622483,
        23.115433821592
    ],
    [
        113.09177504116,
        23.115725337953
    ],
    [
        113.09180407011,
        23.115804173794
    ],
    [
        113.09186861441,
        23.116007874013
    ],
    [
        113.0918973707,
        23.11608780001
    ],
    [
        113.09191664349,
        23.116128245539
    ],
    [
        113.091933459,
        23.116179841324
    ],
    [
        113.09193343528,
        23.116206963198
    ],
    [
        113.09203079031,
        23.116208212714
    ],
    [
        113.09214800193,
        23.116202176029
    ],
    [
        113.09227580865,
        23.116205784755
    ],
    [
        113.09237723782,
        23.116207279146
    ],
    [
        113.09244413576,
        23.116203225202
    ],
    [
        113.09247705415,
        23.116185746382
    ],
    [
        113.09249828425,
        23.116162982902
    ],
    [
        113.09252118912,
        23.116090838568
    ],
    [
        113.09251689829,
        23.116022543159
    ],
    [
        113.09252459629,
        23.115926983867
    ],
    [
        113.09253529795,
        23.115817557047
    ],
    [
        113.09253287077,
        23.115794803757
    ],
    [
        113.09255224699,
        23.11571619277
    ],
    [
        113.09257029628,
        23.115600983753
    ],
    [
        113.09260899322,
        23.115506685726
    ],
    [
        113.0926814821,
        23.11532981282
    ],
    [
        113.09274759681,
        23.115286455893
    ],
    [
        113.09293385378,
        23.11528943848
    ],
    [
        113.0930486047,
        23.115282146595
    ],
    [
        113.09311713923,
        23.115265357891
    ],
    [
        113.09314274841,
        23.115209194447
    ],
    [
        113.09324632227,
        23.114929747263
    ],
    [
        113.0935013944,
        23.114887544501
    ],
    [
        113.09406981792,
        23.114661890018
    ],
    [
        113.09421337937,
        23.114640823306
    ],
    [
        113.09454553108,
        23.114695088886
    ],
    [
        113.09465694725,
        23.114737597739
    ],
    [
        113.09475776583,
        23.11477371551
    ],
    [
        113.09483986686,
        23.114765552631
    ],
    [
        113.09490702579,
        23.11474696908
    ],
    [
        113.09499946227,
        23.114730032392
    ],
    [
        113.09507831218,
        23.114706729133
    ],
    [
        113.09514733256,
        23.114730719825
    ],
    [
        113.09524217065,
        23.114759069081
    ],
    [
        113.09533917839,
        23.114791200936
    ],
    [
        113.09544025565,
        23.114830080751
    ],
    [
        113.09554378273,
        23.114863249291
    ],
    [
        113.09563044819,
        23.114905809127
    ],
    [
        113.09577335518,
        23.114968723729
    ],
    [
        113.09589127386,
        23.115010462783
    ],
    [
        113.09596517399,
        23.115038519668
    ],
    [
        113.09602954593,
        23.115083213374
    ],
    [
        113.09611289614,
        23.115178452508
    ],
    [
        113.09615823528,
        23.115231193598
    ],
    [
        113.09617723918,
        23.115253801341
    ],
    [
        113.0962459359,
        23.115322604648
    ],
    [
        113.09632440914,
        23.115398646042
    ],
    [
        113.09640939498,
        23.115484668844
    ],
    [
        113.0964862465,
        23.115548801516
    ],
    [
        113.09656201713,
        23.115605083257
    ],
    [
        113.09661956648,
        23.115675904517
    ],
    [
        113.09667982937,
        23.115750772925
    ],
    [
        113.09668471446,
        23.115758052953
    ],
    [
        113.09673301909,
        23.115833842448
    ],
    [
        113.09678023649,
        23.115909643302
    ],
    [
        113.09682501392,
        23.115978686679
    ],
    [
        113.09689154905,
        23.116026660867
    ],
    [
        113.09695808921,
        23.116068129415
    ],
    [
        113.09708818574,
        23.116142694772
    ],
    [
        113.09715743953,
        23.116186049771
    ],
    [
        113.09726227034,
        23.116250539323
    ],
    [
        113.09734943035,
        23.116323319544
    ],
    [
        113.09741132959,
        23.116384378582
    ],
    [
        113.0975047421,
        23.116451423362
    ],
    [
        113.09760656676,
        23.116529527883
    ],
    [
        113.09771166176,
        23.11659432544
    ],
    [
        113.09777004629,
        23.116631292391
    ],
    [
        113.09790614669,
        23.116655723005
    ],
    [
        113.09802594243,
        23.116680293832
    ],
    [
        113.09812644988,
        23.116700411921
    ],
    [
        113.0982304262,
        23.116792114041
    ],
    [
        113.09828795949,
        23.116865727119
    ],
    [
        113.09835798077,
        23.116949557068
    ],
    [
        113.09842393114,
        23.117027725427
    ],
    [
        113.09854069715,
        23.117088984809
    ],
    [
        113.0986096698,
        23.117124831635
    ],
    [
        113.09864307078,
        23.117140865781
    ],
    [
        113.09877370335,
        23.117182792793
    ],
    [
        113.09890867623,
        23.117228501379
    ],
    [
        113.09906645362,
        23.117286546768
    ],
    [
        113.09925897993,
        23.117363639694
    ],
    [
        113.09952834238,
        23.117472546706
    ],
    [
        113.09986666407,
        23.117600893652
    ],
    [
        113.1002345549,
        23.117746256341
    ],
    [
        113.10050821906,
        23.11785292778
    ],
    [
        113.10075308794,
        23.117955749553
    ],
    [
        113.10105523044,
        23.118073793801
    ],
    [
        113.10106717761,
        23.118074818503
    ],
    [
        113.10133128723,
        23.118195027607
    ],
    [
        113.10153974848,
        23.118283550165
    ],
    [
        113.10175961624,
        23.118358771476
    ],
    [
        113.10197188371,
        23.118421049701
    ],
    [
        113.10208805571,
        23.118457180281
    ],
    [
        113.10213208637,
        23.118396517423
    ],
    [
        113.1021478395,
        23.118388316654
    ],
    [
        113.10220219737,
        23.118314053616
    ],
    [
        113.10227581705,
        23.118256261588
    ],
    [
        113.10238985102,
        23.118242256254
    ],
    [
        113.10262060053,
        23.118246275332
    ],
    [
        113.10292000634,
        23.118265026971
    ],
    [
        113.10327910984,
        23.118285847315
    ],
    [
        113.10374594802,
        23.11829754917
    ],
    [
        113.10410852582,
        23.118316463749
    ],
    [
        113.10454652071,
        23.118335084654
    ],
    [
        113.10529814266,
        23.118361063585
    ],
    [
        113.10529350145,
        23.118396599167
    ],
    [
        113.10524367344,
        23.118614179486
    ],
    [
        113.10520692086,
        23.118768279689
    ],
    [
        113.10514375266,
        23.119045279962
    ],
    [
        113.10510129086,
        23.119215665168
    ],
    [
        113.10504769689,
        23.119396103116
    ],
    [
        113.10498265322,
        23.119647079068
    ],
    [
        113.10523278565,
        23.119705868774
    ],
    [
        113.10515110566,
        23.1200770087
    ],
    [
        113.10511898146,
        23.120219987183
    ],
    [
        113.10491181637,
        23.121149236207
    ],
    [
        113.10540862341,
        23.121170017958
    ],
    [
        113.10541567751,
        23.1211705529
    ],
    [
        113.10539958224,
        23.121294792595
    ],
    [
        113.10535363707,
        23.121425303906
    ],
    [
        113.10530824864,
        23.121535745729
    ],
    [
        113.10526695056,
        23.121616620681
    ],
    [
        113.10517290236,
        23.121860572657
    ],
    [
        113.10509437608,
        23.122022600649
    ],
    [
        113.10499956835,
        23.122185471687
    ],
    [
        113.10492782757,
        23.12234424764
    ],
    [
        113.10489219789,
        23.122470695644
    ],
    [
        113.10486120304,
        23.122564047454
    ],
    [
        113.10485468544,
        23.122571923438
    ],
    [
        113.10484896772,
        23.122601767912
    ],
    [
        113.10481689101,
        23.122689969415
    ],
    [
        113.10480489993,
        23.122770273354
    ],
    [
        113.10481325127,
        23.122865733328
    ],
    [
        113.10483083697,
        23.122948701937
    ],
    [
        113.10488126154,
        23.123024024794
    ],
    [
        113.1049699227,
        23.123136994319
    ],
    [
        113.10502630877,
        23.123224249549
    ],
    [
        113.10514372475,
        23.123346686223
    ],
    [
        113.10526388368,
        23.123417326991
    ],
    [
        113.10535257851,
        23.123467402224
    ],
    [
        113.10543069966,
        23.123502035495
    ],
    [
        113.10553432449,
        23.123535564971
    ],
    [
        113.10567132253,
        23.123563109303
    ],
    [
        113.10580778571,
        23.123571956332
    ],
    [
        113.10591684117,
        23.123585718828
    ],
    [
        113.10596160192,
        23.123591660265
    ],
    [
        113.10604651698,
        23.123592430324
    ],
    [
        113.10610593041,
        23.123591590073
    ],
    [
        113.10615422136,
        23.123589129808
    ],
    [
        113.10617864164,
        23.123581797634
    ],
    [
        113.10620724117,
        23.123393280727
    ],
    [
        113.10620981779,
        23.123174123677
    ],
    [
        113.10628376292,
        23.122924839769
    ],
    [
        113.10630440461,
        23.122886319766
    ],
    [
        113.10598350921,
        23.122404193646
    ],
    [
        113.10591062867,
        23.122253701995
    ],
    [
        113.10627985273,
        23.12225815416
    ],
    [
        113.10634068653,
        23.122156699974
    ],
    [
        113.10636675946,
        23.122111128339
    ],
    [
        113.10635972757,
        23.122079124446
    ],
    [
        113.10624394522,
        23.121997782982
    ],
    [
        113.10629803512,
        23.121842082647
    ],
    [
        113.10668189104,
        23.121830395528
    ],
    [
        113.10678658933,
        23.121841261894
    ],
    [
        113.10699175637,
        23.122093569054
    ],
    [
        113.10718061212,
        23.122394456727
    ],
    [
        113.10742677846,
        23.12256279097
    ],
    [
        113.10788503438,
        23.122702943444
    ],
    [
        113.10798536741,
        23.122717989739
    ],
    [
        113.10793296446,
        23.1246325633
    ],
    [
        113.10797468499,
        23.124711004886
    ],
    [
        113.1079833518,
        23.124731630341
    ],
    [
        113.10810605714,
        23.124995171349
    ],
    [
        113.10794736735,
        23.125074426941
    ],
    [
        113.10696717868,
        23.125584346556
    ],
    [
        113.10694749733,
        23.126441457123
    ],
    [
        113.10688571438,
        23.127516369938
    ],
    [
        113.10686357174,
        23.127933265983
    ],
    [
        113.10685024872,
        23.128012737041
    ],
    [
        113.10681781211,
        23.128420139701
    ],
    [
        113.10692387079,
        23.128421255911
    ],
    [
        113.10717121947,
        23.128484841053
    ],
    [
        113.10718342697,
        23.128479694443
    ],
    [
        113.10719346143,
        23.12848295532
    ],
    [
        113.10721597636,
        23.128476187779
    ],
    [
        113.10723224951,
        23.12847836789
    ],
    [
        113.10723252398,
        23.128469688176
    ],
    [
        113.10724771337,
        23.128468612879
    ],
    [
        113.10726481721,
        23.128425224621
    ],
    [
        113.10729168606,
        23.128379944582
    ],
    [
        113.10733508954,
        23.128361530484
    ],
    [
        113.10734051727,
        23.128353125808
    ],
    [
        113.10737415618,
        23.12833497744
    ],
    [
        113.10740969479,
        23.128313305439
    ],
    [
        113.107434654,
        23.128295694592
    ],
    [
        113.10746205045,
        23.128287579992
    ],
    [
        113.10750843288,
        23.128277312801
    ],
    [
        113.10754395452,
        23.128297688356
    ],
    [
        113.10759005433,
        23.128315362765
    ],
    [
        113.10760767947,
        23.128325144746
    ],
    [
        113.10769498109,
        23.12839955527
    ],
    [
        113.10779937355,
        23.128457446552
    ],
    [
        113.10791757748,
        23.128563104836
    ],
    [
        113.10793655312,
        23.128585100049
    ],
    [
        113.10794306152,
        23.128585922173
    ],
    [
        113.10792345356,
        23.128811574677
    ],
    [
        113.10788942041,
        23.129195890318
    ],
    [
        113.10788587723,
        23.129248236907
    ],
    [
        113.10787365185,
        23.129312507798
    ],
    [
        113.1078641375,
        23.129380308407
    ],
    [
        113.10786274716,
        23.129485822656
    ],
    [
        113.10786354445,
        23.129536547269
    ],
    [
        113.10786487396,
        23.129619822521
    ],
    [
        113.10785372331,
        23.129720171439
    ],
    [
        113.10789032621,
        23.129749240057
    ],
    [
        113.10791581694,
        23.129755239537
    ],
    [
        113.1080112678,
        23.129786558406
    ],
    [
        113.10812541868,
        23.129851276694
    ],
    [
        113.10823876055,
        23.129893492058
    ],
    [
        113.10837596313,
        23.129936573249
    ],
    [
        113.108396027,
        23.129946372434
    ],
    [
        113.10845540424,
        23.129977127048
    ],
    [
        113.10850665079,
        23.129991323856
    ],
    [
        113.10859720969,
        23.130025127075
    ],
    [
        113.10860777613,
        23.130055256042
    ],
    [
        113.10860504558,
        23.13012007985
    ],
    [
        113.10860909367,
        23.13018708664
    ],
    [
        113.10860825195,
        23.130286363092
    ],
    [
        113.10861394305,
        23.130298037792
    ],
    [
        113.10861013805,
        23.130329224467
    ],
    [
        113.10860985052,
        23.130388085574
    ],
    [
        113.10857540977,
        23.13039941292
    ],
    [
        113.10853228854,
        23.130421575456
    ],
    [
        113.10851682816,
        23.130435923505
    ],
    [
        113.1085043525,
        23.130443224629
    ],
    [
        113.10850407896,
        23.130451904201
    ],
    [
        113.10849565745,
        23.130508309432
    ],
    [
        113.10849972019,
        23.130525948171
    ],
    [
        113.10849700662,
        23.130532995829
    ],
    [
        113.10849564991,
        23.130536248409
    ],
    [
        113.10849509249,
        23.130592667913
    ],
    [
        113.10848070284,
        23.130659912703
    ],
    [
        113.10848665987,
        23.130693016223
    ],
    [
        113.10847878642,
        23.130729892501
    ],
    [
        113.10847931959,
        23.130765427594
    ],
    [
        113.10847849768,
        23.130798247745
    ],
    [
        113.10851183665,
        23.130855813566
    ],
    [
        113.10851074,
        23.130903552161
    ],
    [
        113.10850665929,
        23.130956710434
    ],
    [
        113.10849362817,
        23.131018261446
    ],
    [
        113.10848574764,
        23.131087145745
    ],
    [
        113.10848003842,
        23.131148710176
    ],
    [
        113.10846999949,
        23.131172833872
    ],
    [
        113.10846647009,
        23.131190730371
    ],
    [
        113.10846537938,
        23.131216497589
    ],
    [
        113.10843662841,
        23.13124655613
    ],
    [
        113.10842360765,
        23.131266334997
    ],
    [
        113.10841248669,
        23.131279064689
    ],
    [
        113.10840380235,
        23.131308887721
    ],
    [
        113.10838210022,
        23.131345469998
    ],
    [
        113.10837206356,
        23.131359829488
    ],
    [
        113.10836310131,
        23.131420032946
    ],
    [
        113.10836959706,
        23.13147619367
    ],
    [
        113.10837176365,
        23.131488946317
    ],
    [
        113.10839453177,
        23.131536725939
    ],
    [
        113.10842788,
        23.131563909037
    ],
    [
        113.10843113411,
        23.131563643455
    ],
    [
        113.10847261848,
        23.131584874552
    ],
    [
        113.10856535752,
        23.131583687637
    ],
    [
        113.10868060217,
        23.131577399069
    ],
    [
        113.10868412629,
        23.131581746124
    ],
    [
        113.10880316151,
        23.131589312162
    ],
    [
        113.10881671895,
        23.131589883083
    ],
    [
        113.10882756566,
        23.131586650871
    ],
    [
        113.10889616422,
        23.131596020601
    ],
    [
        113.10890972229,
        23.131592523858
    ],
    [
        113.10901384193,
        23.131589772852
    ],
    [
        113.10908867463,
        23.131597270256
    ],
    [
        113.10908784931,
        23.131653418207
    ],
    [
        113.1090810661,
        23.131676187745
    ],
    [
        113.10907970458,
        23.131704123889
    ],
    [
        113.10907671752,
        23.131726088607
    ],
    [
        113.1090731724,
        23.131825631244
    ],
    [
        113.10906476326,
        23.131844870794
    ],
    [
        113.10906421082,
        23.131895865677
    ],
    [
        113.10906040768,
        23.131932476427
    ],
    [
        113.1091043297,
        23.131943701043
    ],
    [
        113.10911192034,
        23.131949686684
    ],
    [
        113.10915801096,
        23.131961189887
    ],
    [
        113.10919108627,
        23.131975918194
    ],
    [
        113.10925994819,
        23.132002129571
    ],
    [
        113.10928461745,
        23.132019552228
    ],
    [
        113.10935944216,
        23.132049853914
    ],
    [
        113.1094041711,
        23.132082522084
    ],
    [
        113.10943209278,
        23.132102126771
    ],
    [
        113.10947085803,
        23.132127186605
    ],
    [
        113.1094917305,
        23.132146231271
    ],
    [
        113.10952670032,
        23.132168298947
    ],
    [
        113.10957251428,
        23.132191211828
    ],
    [
        113.10963838667,
        23.132232358063
    ],
    [
        113.10972242414,
        23.132263524987
    ],
    [
        113.10967929724,
        23.132383837527
    ],
    [
        113.10967197243,
        23.132412569652
    ],
    [
        113.10970314807,
        23.132421882988
    ],
    [
        113.10980480536,
        23.132459075598
    ],
    [
        113.10981754505,
        23.132471049407
    ],
    [
        113.10981564613,
        23.132478367632
    ],
    [
        113.10977713818,
        23.132548779018
    ],
    [
        113.10988936422,
        23.132603642995
    ],
    [
        113.1100083678,
        23.132642807237
    ],
    [
        113.11004984142,
        23.132661657568
    ],
    [
        113.11006204035,
        23.132661697134
    ],
    [
        113.11013984196,
        23.132660867645
    ],
    [
        113.11014526418,
        23.132657359301
    ],
    [
        113.1102274618,
        23.132298218833
    ],
    [
        113.11023479089,
        23.132242364749
    ],
    [
        113.11023424878,
        23.132242091645
    ],
    [
        113.11019955249,
        23.132231666222
    ],
    [
        113.11015916473,
        23.132213085172
    ],
    [
        113.11013097423,
        23.132201327379
    ],
    [
        113.11008326647,
        23.132183809952
    ],
    [
        113.11011338243,
        23.13204719528
    ],
    [
        113.11014862505,
        23.132038089275
    ],
    [
        113.11015973933,
        23.132038668835
    ],
    [
        113.11015486057,
        23.132034854964
    ],
    [
        113.11022534091,
        23.132038347291
    ],
    [
        113.1102337442,
        23.132039189651
    ],
    [
        113.11023482887,
        23.132037294549
    ],
    [
        113.11025489003,
        23.132030039151
    ],
    [
        113.11027196839,
        23.132027385217
    ],
    [
        113.11030097625,
        23.132013108814
    ],
    [
        113.11032320864,
        23.131990943086
    ],
    [
        113.11032619655,
        23.131959487748
    ],
    [
        113.11033135518,
        23.131917461014
    ],
    [
        113.11038068841,
        23.131927399792
    ],
    [
        113.11049507256,
        23.131961446539
    ],
    [
        113.11056310675,
        23.131975801966
    ],
    [
        113.1105931931,
        23.131983237835
    ],
    [
        113.11063872725,
        23.132002939298
    ],
    [
        113.11064226021,
        23.131955482738
    ],
    [
        113.11065203692,
        23.131861122502
    ],
    [
        113.11068487163,
        23.131681133379
    ],
    [
        113.11067836561,
        23.131684363629
    ],
    [
        113.11068595739,
        23.13167381362
    ],
    [
        113.11068460268,
        23.13167109589
    ],
    [
        113.11069762284,
        23.131626117234
    ],
    [
        113.11069870949,
        23.131614728661
    ],
    [
        113.11071092045,
        23.131551844233
    ],
    [
        113.11073341656,
        23.131558169756
    ],
    [
        113.1107515747,
        23.131569361505
    ],
    [
        113.11082854844,
        23.131590820672
    ],
    [
        113.11087055776,
        23.131605092637
    ],
    [
        113.11136164809,
        23.131717018435
    ],
    [
        113.11139958884,
        23.131727494954
    ],
    [
        113.11170608951,
        23.131796991414
    ],
    [
        113.1117218052,
        23.131809543836
    ],
    [
        113.11172613966,
        23.131817430889
    ],
    [
        113.11173778918,
        23.131835389315
    ],
    [
        113.11175269077,
        23.131853092163
    ],
    [
        113.11175648491,
        23.131852567808
    ],
    [
        113.11174943613,
        23.131866096899
    ],
    [
        113.11175512691,
        23.131867480404
    ],
    [
        113.11174780471,
        23.131893214736
    ],
    [
        113.11174725793,
        23.131917353945
    ],
    [
        113.11175240036,
        23.131951014342
    ],
    [
        113.11174507723,
        23.131982173843
    ],
    [
        113.1117453444,
        23.132001976857
    ],
    [
        113.11174262854,
        23.132032344641
    ],
    [
        113.11173882902,
        23.132061079728
    ],
    [
        113.11173882436,
        23.132085764085
    ],
    [
        113.11173773932,
        23.132091184047
    ],
    [
        113.11173773622,
        23.132107730708
    ],
    [
        113.1117407134,
        23.132128360451
    ],
    [
        113.11173637292,
        23.132152210365
    ],
    [
        113.11173501485,
        23.132168750575
    ],
    [
        113.11174530739,
        23.132199180511
    ],
    [
        113.11174611097,
        23.13225126576
    ],
    [
        113.11174338768,
        23.132325848571
    ],
    [
        113.11174283547,
        23.132384437601
    ],
    [
        113.11174607936,
        23.132431923223
    ],
    [
        113.11175329385,
        23.133105493581
    ],
    [
        113.11175166718,
        23.133110368477
    ],
    [
        113.11174814017,
        23.133140190204
    ],
    [
        113.11174542283,
        23.133196056789
    ],
    [
        113.11174920697,
        23.133273655306
    ],
    [
        113.11174838459,
        23.133349604306
    ],
    [
        113.1117494664,
        23.133367783939
    ],
    [
        113.11175271852,
        23.133366985711
    ],
    [
        113.11175027558,
        23.133399796568
    ],
    [
        113.11174891402,
        23.133455669783
    ],
    [
        113.11175026118,
        23.133524576515
    ],
    [
        113.11174565154,
        23.133547882937
    ],
    [
        113.11175025512,
        23.133579371241
    ],
    [
        113.11174537411,
        23.1336067453
    ],
    [
        113.11174455708,
        23.133644446728
    ],
    [
        113.11174563743,
        23.13367944462
    ],
    [
        113.11174400917,
        23.133701137767
    ],
    [
        113.11174481956,
        23.133726911493
    ],
    [
        113.11174400548,
        23.13373748681
    ],
    [
        113.11174373258,
        23.133756473827
    ],
    [
        113.11174454402,
        23.133772210886
    ],
    [
        113.11174779189,
        23.133814814519
    ],
    [
        113.11174887196,
        23.133856051504
    ],
    [
        113.11174643028,
        23.133884522352
    ],
    [
        113.11173829388,
        23.13395392663
    ],
    [
        113.11173341054,
        23.134014394858
    ],
    [
        113.1117296112,
        23.134077309674
    ],
    [
        113.11172798565,
        23.134071605416
    ],
    [
        113.11173042081,
        23.134119087994
    ],
    [
        113.11173312697,
        23.134168199472
    ],
    [
        113.11173393516,
        23.134231678876
    ],
    [
        113.11173799396,
        23.134318502477
    ],
    [
        113.11173094089,
        23.134423176573
    ],
    [
        113.11172307633,
        23.134511842395
    ],
    [
        113.11171955138,
        23.134544377309
    ],
    [
        113.11170897792,
        23.134622179898
    ],
    [
        113.11168702103,
        23.134731395489
    ],
    [
        113.11156045769,
        23.134782344916
    ],
    [
        113.11152602725,
        23.135113944033
    ],
    [
        113.11148401424,
        23.135428149864
    ],
    [
        113.11144634225,
        23.135701959059
    ],
    [
        113.11140054309,
        23.135956473963
    ],
    [
        113.11135664232,
        23.136149964381
    ],
    [
        113.11126641349,
        23.1366682358
    ],
    [
        113.11120491291,
        23.137012755332
    ],
    [
        113.11113096456,
        23.137501543868
    ],
    [
        113.11106594771,
        23.137789905754
    ],
    [
        113.11106054335,
        23.137925791384
    ],
    [
        113.11112830442,
        23.137944793216
    ],
    [
        113.11120175518,
        23.137955142824
    ],
    [
        113.11121422269,
        23.137956552717
    ],
    [
        113.11121991491,
        23.137961460133
    ],
    [
        113.1112464762,
        23.137965915152
    ],
    [
        113.11126192576,
        23.137974120344
    ],
    [
        113.11149826202,
        23.138024272329
    ],
    [
        113.11158337899,
        23.138167624918
    ],
    [
        113.11166252325,
        23.138238525748
    ],
    [
        113.11169369417,
        23.138275837441
    ],
    [
        113.11173245366,
        23.138317255288
    ],
    [
        113.11181620714,
        23.138413960291
    ],
    [
        113.11191351005,
        23.138513993692
    ],
    [
        113.11205254558,
        23.138624554268
    ],
    [
        113.11211162887,
        23.138676668089
    ],
    [
        113.11214415138,
        23.138704233502
    ],
    [
        113.1121707127,
        23.138735024414
    ],
    [
        113.11219049752,
        23.138754387264
    ],
    [
        113.1122146181,
        23.138774586825
    ],
    [
        113.11229917694,
        23.138856955021
    ],
    [
        113.11238833961,
        23.13892958833
    ],
    [
        113.11247506281,
        23.139004385734
    ],
    [
        113.11254118594,
        23.139047337206
    ],
    [
        113.11266557145,
        23.139128324815
    ],
    [
        113.11274686993,
        23.13919226183
    ],
    [
        113.112854187,
        23.13930003016
    ],
    [
        113.11297856284,
        23.139362605455
    ],
    [
        113.11303763833,
        23.139415310742
    ],
    [
        113.11316336778,
        23.139490935733
    ],
    [
        113.11321349701,
        23.139524606753
    ],
    [
        113.11323382104,
        23.139545347704
    ],
    [
        113.11325279048,
        23.139566623293
    ],
    [
        113.11325929362,
        23.139570732265
    ],
    [
        113.11330915304,
        23.13961308678
    ],
    [
        113.113331103,
        23.139636823575
    ],
    [
        113.11338258875,
        23.139685159518
    ],
    [
        113.11342377907,
        23.139732890686
    ],
    [
        113.11345764987,
        23.139759960047
    ],
    [
        113.11349044354,
        23.139817135588
    ],
    [
        113.11349694972,
        23.139835895019
    ],
    [
        113.11353353078,
        23.139869223235
    ],
    [
        113.11353786849,
        23.139882814806
    ],
    [
        113.113559819,
        23.139911439084
    ],
    [
        113.11356876728,
        23.139947033865
    ],
    [
        113.11356579055,
        23.139961392656
    ],
    [
        113.11357202425,
        23.139973097529
    ],
    [
        113.11357990898,
        23.140093596203
    ],
    [
        113.11357449876,
        23.140127200297
    ],
    [
        113.11354173407,
        23.140192640939
    ],
    [
        113.11352033477,
        23.140204712455
    ],
    [
        113.113517627,
        23.140210392149
    ],
    [
        113.11342363582,
        23.140280060962
    ],
    [
        113.11335998407,
        23.140339074338
    ],
    [
        113.11329145751,
        23.140407556135
    ],
    [
        113.11326112052,
        23.140434226766
    ],
    [
        113.11323511869,
        23.140462552337
    ],
    [
        113.11313488003,
        23.140485275376
    ],
    [
        113.11303437508,
        23.140532692261
    ],
    [
        113.11294877361,
        23.14059268408
    ],
    [
        113.11287834941,
        23.140672844966
    ],
    [
        113.11281930728,
        23.140763112944
    ],
    [
        113.11278708976,
        23.140855707094
    ],
    [
        113.11274429426,
        23.140908906303
    ],
    [
        113.11272181995,
        23.140961407915
    ],
    [
        113.1127188566,
        23.141021615902
    ],
    [
        113.11273567458,
        23.141087090108
    ],
    [
        113.11276793271,
        23.141138003064
    ],
    [
        113.11282050931,
        23.141179809698
    ],
    [
        113.11290018164,
        23.141226930165
    ],
    [
        113.11290722831,
        23.141234024462
    ],
    [
        113.11290695648,
        23.141231038767
    ],
    [
        113.11294516671,
        23.141255134409
    ],
    [
        113.11298201973,
        23.141271627433
    ],
    [
        113.11298906599,
        23.141277637106
    ],
    [
        113.11299123279,
        23.141275208309
    ],
    [
        113.11304542854,
        23.14130157181
    ],
    [
        113.11307306769,
        23.141313401341
    ],
    [
        113.11315002714,
        23.141359709394
    ],
    [
        113.11316384958,
        23.1413757985
    ],
    [
        113.11320341114,
        23.141394214062
    ],
    [
        113.11324866302,
        23.141416192456
    ],
    [
        113.11331613272,
        23.141445634215
    ],
    [
        113.11335596452,
        23.141465141883
    ],
    [
        113.11336897058,
        23.141470919638
    ],
    [
        113.11340392529,
        23.1414898561
    ],
    [
        113.11349307032,
        23.141531380458
    ],
    [
        113.11357815034,
        23.141572885742
    ],
    [
        113.11360768588,
        23.141592607619
    ],
    [
        113.11366918973,
        23.141616334939
    ],
    [
        113.11360799881,
        23.141724453796
    ],
    [
        113.1136050215,
        23.141732844486
    ],
    [
        113.11359987988,
        23.141750444962
    ],
    [
        113.11359879571,
        23.141748810296
    ],
    [
        113.11360178497,
        23.141777314367
    ],
    [
        113.11361045642,
        23.14178442348
    ],
    [
        113.11363159353,
        23.141803278198
    ],
    [
        113.11362644544,
        23.141800803457
    ],
    [
        113.1136340303,
        23.141798953355
    ],
    [
        113.11365380987,
        23.141808847335
    ],
    [
        113.11365841576,
        23.141810233551
    ],
    [
        113.11366627043,
        23.141805129991
    ],
    [
        113.11368739911,
        23.141798756206
    ],
    [
        113.11375972418,
        23.141778610637
    ],
    [
        113.1137735437,
        23.141789281454
    ],
    [
        113.11378546271,
        23.141787189551
    ],
    [
        113.11379169426,
        23.141789672138
    ],
    [
        113.11380144621,
        23.141788108699
    ],
    [
        113.11380740516,
        23.141785435165
    ],
    [
        113.11382799523,
        23.141790454362
    ],
    [
        113.11382718403,
        23.141795060833
    ],
    [
        113.11385833874,
        23.141799065387
    ],
    [
        113.1138878671,
        23.141800618372
    ],
    [
        113.11394096509,
        23.141808027131
    ],
    [
        113.11397022416,
        23.14181581996
    ],
    [
        113.11399948114,
        23.141817645253
    ],
    [
        113.11404093017,
        23.141826064982
    ],
    [
        113.11405068204,
        23.141825588784
    ],
    [
        113.11411570252,
        23.141848278762
    ],
    [
        113.11418803033,
        23.141853389484
    ],
    [
        113.11422107854,
        23.141855246641
    ],
    [
        113.11422214953,
        23.141817002946
    ],
    [
        113.11422268466,
        23.141796660322
    ],
    [
        113.11423324207,
        23.141775302351
    ],
    [
        113.11423486366,
        23.1417639197
    ],
    [
        113.1142378366,
        23.141743051515
    ],
    [
        113.11424594949,
        23.141701059019
    ],
    [
        113.11425487113,
        23.141646593174
    ],
    [
        113.11429740114,
        23.141653130609
    ],
    [
        113.11429578626,
        23.14168567338
    ],
    [
        113.11429741778,
        23.141705217308
    ],
    [
        113.11434130318,
        23.141715835134
    ],
    [
        113.11434780612,
        23.141721849322
    ],
    [
        113.11435945306,
        23.141719761401
    ],
    [
        113.11440062751,
        23.141724936593
    ],
    [
        113.11444369942,
        23.141735281203
    ],
    [
        113.11450519175,
        23.141750914299
    ],
    [
        113.11453607187,
        23.141754935046
    ],
    [
        113.11455232553,
        23.141760207029
    ],
    [
        113.11457832817,
        23.141759039177
    ],
    [
        113.11460162355,
        23.141762464019
    ],
    [
        113.11459620891,
        23.141770563132
    ],
    [
        113.11463656829,
        23.141773299135
    ],
    [
        113.11467530733,
        23.141791759126
    ],
    [
        113.1147235191,
        23.141788587565
    ],
    [
        113.11474139649,
        23.141791161318
    ],
    [
        113.11477471385,
        23.141797647946
    ],
    [
        113.11481588172,
        23.141791715008
    ],
    [
        113.11481886217,
        23.141794992676
    ],
    [
        113.11481804864,
        23.141792002471
    ],
    [
        113.11487086554,
        23.141794568314
    ],
    [
        113.11490824348,
        23.141796748673
    ],
    [
        113.11491474413,
        23.141797611582
    ],
    [
        113.11491555147,
        23.141781611889
    ],
    [
        113.11492420635,
        23.141743697438
    ],
    [
        113.1149269047,
        23.141712248847
    ],
    [
        113.11493285364,
        23.141681909993
    ],
    [
        113.11493285251,
        23.141678383289
    ],
    [
        113.1149363706,
        23.141669186243
    ],
    [
        113.11493880875,
        23.141670832401
    ],
    [
        113.11493366021,
        23.141663197484
    ],
    [
        113.11493717374,
        23.141639622348
    ],
    [
        113.11494096303,
        23.141631512508
    ],
    [
        113.11494068952,
        23.14162310063
    ],
    [
        113.11494176879,
        23.141610087168
    ],
    [
        113.11494799187,
        23.141589788004
    ],
    [
        113.11495069412,
        23.141570004753
    ],
    [
        113.11494771217,
        23.141561572354
    ],
    [
        113.11495069225,
        23.141564036493
    ],
    [
        113.11497019178,
        23.141559572623
    ],
    [
        113.11500702864,
        23.141565821251
    ],
    [
        113.11501786149,
        23.1415629198
    ],
    [
        113.11502273676,
        23.141563228323
    ],
    [
        113.1150398005,
        23.141565257805
    ],
    [
        113.11505984448,
        23.141570565799
    ],
    [
        113.11508720109,
        23.141575930378
    ],
    [
        113.11511238678,
        23.141568257207
    ],
    [
        113.1151370357,
        23.141576586169
    ],
    [
        113.1151584314,
        23.141575124189
    ],
    [
        113.11519689183,
        23.141580577453
    ],
    [
        113.11521503567,
        23.141573936779
    ],
    [
        113.11525214336,
        23.141585078238
    ],
    [
        113.11527353744,
        23.14157982034
    ],
    [
        113.11532255805,
        23.141580748794
    ],
    [
        113.11537347634,
        23.141589018984
    ],
    [
        113.1153927049,
        23.141588629151
    ],
    [
        113.11541085223,
        23.141595013112
    ],
    [
        113.11541707926,
        23.141588823204
    ],
    [
        113.11546474642,
        23.14159571495
    ],
    [
        113.11549751665,
        23.141598148204
    ],
    [
        113.11552270508,
        23.141604861766
    ],
    [
        113.11557009938,
        23.141607957527
    ],
    [
        113.11560774312,
        23.141608534285
    ],
    [
        113.11563374302,
        23.141613629071
    ],
    [
        113.11567382617,
        23.141622095022
    ],
    [
        113.11568601295,
        23.141622737406
    ],
    [
        113.11569982535,
        23.141625834809
    ],
    [
        113.11570848903,
        23.141618581276
    ],
    [
        113.11571498981,
        23.141622703952
    ],
    [
        113.11577132013,
        23.14162859396
    ],
    [
        113.11605160752,
        23.141651018359
    ],
    [
        113.11622031871,
        23.141675522805
    ],
    [
        113.11632998773,
        23.141678102504
    ],
    [
        113.11633134183,
        23.141678656888
    ],
    [
        113.11642990808,
        23.141684946661
    ],
    [
        113.11647188083,
        23.141691827836
    ],
    [
        113.11654445112,
        23.141699796223
    ],
    [
        113.11656476167,
        23.141707844387
    ],
    [
        113.11658723444,
        23.141703704415
    ],
    [
        113.1165856111,
        23.141707759175
    ],
    [
        113.11662108211,
        23.141707805261
    ],
    [
        113.11665194904,
        23.141705369424
    ],
    [
        113.11666033027,
        23.141665837295
    ],
    [
        113.11666627447,
        23.14162574074
    ],
    [
        113.11668440511,
        23.141591450964
    ],
    [
        113.11670227629,
        23.141593239866
    ],
    [
        113.11672366567,
        23.141589635164
    ],
    [
        113.11672935346,
        23.141595112296
    ],
    [
        113.11687122481,
        23.141569547101
    ],
    [
        113.11699359667,
        23.141537577797
    ],
    [
        113.11702743809,
        23.141528939303
    ],
    [
        113.11730412192,
        23.141468873152
    ],
    [
        113.11739480992,
        23.141438812361
    ],
    [
        113.11753639493,
        23.141411691849
    ],
    [
        113.11768772039,
        23.141376544105
    ],
    [
        113.11788316752,
        23.141336698661
    ],
    [
        113.11792674868,
        23.14132411196
    ],
    [
        113.11799036285,
        23.141313898069
    ],
    [
        113.11808131415,
        23.141291484521
    ],
    [
        113.11813844201,
        23.141321904746
    ],
    [
        113.11821019017,
        23.141361971647
    ],
    [
        113.11829791383,
        23.141418754934
    ],
    [
        113.11831578227,
        23.141426805978
    ],
    [
        113.11840291247,
        23.141315937243
    ],
    [
        113.11845216125,
        23.141258393922
    ],
    [
        113.11830404174,
        23.141086767857
    ],
    [
        113.11827832011,
        23.141068056343
    ],
    [
        113.1182412273,
        23.141043260663
    ],
    [
        113.11823093566,
        23.141025521998
    ],
    [
        113.1182693621,
        23.140980068996
    ],
    [
        113.11830346006,
        23.140944610047
    ],
    [
        113.11835216962,
        23.140888142772
    ],
    [
        113.11836895183,
        23.140885060737
    ],
    [
        113.11840792051,
        23.140844500543
    ],
    [
        113.11846664758,
        23.140797093739
    ],
    [
        113.11848775232,
        23.140763674706
    ],
    [
        113.11850155573,
        23.140757307939
    ],
    [
        113.1185061554,
        23.140749760073
    ],
    [
        113.11850453083,
        23.140748115425
    ],
    [
        113.11853429763,
        23.140715058885
    ],
    [
        113.1185323893,
        23.140664309338
    ],
    [
        113.11853427873,
        23.14064398302
    ],
    [
        113.11853290286,
        23.140558243844
    ],
    [
        113.11856131467,
        23.140518391788
    ],
    [
        113.11859108292,
        23.140490490955
    ],
    [
        113.11864142686,
        23.140477727989
    ],
    [
        113.11869015049,
        23.140481226632
    ],
    [
        113.11874212059,
        23.140479607199
    ],
    [
        113.11877975019,
        23.140500624617
    ],
    [
        113.11883200535,
        23.140557608366
    ],
    [
        113.11887858288,
        23.140640305009
    ],
    [
        113.11890593467,
        23.140692684485
    ],
    [
        113.11890214489,
        23.140691287379
    ],
    [
        113.11890241875,
        23.140703226692
    ],
    [
        113.11895359274,
        23.140767257012
    ],
    [
        113.11902236495,
        23.140849655622
    ],
    [
        113.11909708681,
        23.140915574361
    ],
    [
        113.11923244785,
        23.141024210643
    ],
    [
        113.11934207953,
        23.141080218159
    ],
    [
        113.11940650104,
        23.141101821159
    ],
    [
        113.11978249818,
        23.141350747222
    ],
    [
        113.1202120753,
        23.141647333133
    ],
    [
        113.12040693674,
        23.141705509017
    ],
    [
        113.12058663172,
        23.141740742321
    ],
    [
        113.12067025123,
        23.141750696634
    ],
    [
        113.1207465614,
        23.141753785493
    ],
    [
        113.12087913822,
        23.14170601728
    ],
    [
        113.12097382446,
        23.141639892918
    ],
    [
        113.12107092355,
        23.141504355841
    ],
    [
        113.1212338112,
        23.141493073168
    ],
    [
        113.1212676307,
        23.141483455304
    ],
    [
        113.12126521941,
        23.141561283644
    ],
    [
        113.12128255541,
        23.141622266491
    ],
    [
        113.12129529215,
        23.141684548784
    ],
    [
        113.12132724703,
        23.141768773241
    ],
    [
        113.12135000429,
        23.141858309372
    ],
    [
        113.12138195691,
        23.141934125298
    ],
    [
        113.12141201603,
        23.1420110034
    ],
    [
        113.1214274678,
        23.142098007942
    ],
    [
        113.12142695052,
        23.142168535518
    ],
    [
        113.12144185928,
        23.142248208841
    ],
    [
        113.12145134209,
        23.142285222524
    ],
    [
        113.12146136534,
        23.142320072779
    ],
    [
        113.12145866235,
        23.142327906139
    ],
    [
        113.12146624283,
        23.142340751677
    ],
    [
        113.12147976965,
        23.142335767097
    ],
    [
        113.12148626508,
        23.142340731833
    ],
    [
        113.12167348986,
        23.142318408909
    ],
    [
        113.12177088304,
        23.142291976711
    ],
    [
        113.12191426084,
        23.142240368683
    ],
    [
        113.12192833079,
        23.142243533626
    ],
    [
        113.12211741485,
        23.142151840034
    ],
    [
        113.12215014232,
        23.142125950471
    ],
    [
        113.12215257634,
        23.142123269264
    ],
    [
        113.12214175277,
        23.142118245471
    ],
    [
        113.12213634006,
        23.142113020743
    ],
    [
        113.12215013656,
        23.142108859459
    ],
    [
        113.1222410176,
        23.142042764829
    ],
    [
        113.12234298615,
        23.141965155735
    ],
    [
        113.12239733856,
        23.141885841018
    ],
    [
        113.12240058723,
        23.141892665863
    ],
    [
        113.12240031361,
        23.141883167319
    ],
    [
        113.12243167364,
        23.141814131559
    ],
    [
        113.12245086757,
        23.141769894057
    ],
    [
        113.12246924582,
        23.141712624424
    ],
    [
        113.12247005469,
        23.141703954027
    ],
    [
        113.12247734773,
        23.14166769833
    ],
    [
        113.12247814357,
        23.141617250123
    ],
    [
        113.1224810816,
        23.141494397638
    ],
    [
        113.12248565598,
        23.141412801906
    ],
    [
        113.12249349322,
        23.141385234625
    ],
    [
        113.12249971027,
        23.141367683429
    ],
    [
        113.12250592661,
        23.141347690707
    ],
    [
        113.12250672463,
        23.141301854504
    ],
    [
        113.12251430146,
        23.141308194224
    ],
    [
        113.12257001081,
        23.141238398784
    ],
    [
        113.12256972076,
        23.141171116937
    ],
    [
        113.12257647271,
        23.141131599325
    ],
    [
        113.12257320388,
        23.141052612906
    ],
    [
        113.12259238808,
        23.140968498914
    ],
    [
        113.12261563438,
        23.140898274569
    ],
    [
        113.12266268286,
        23.140811005545
    ],
    [
        113.12269619814,
        23.140697514372
    ],
    [
        113.12272567903,
        23.140672407622
    ],
    [
        113.12276109791,
        23.140595294991
    ],
    [
        113.12276622433,
        23.140542463907
    ],
    [
        113.12289389531,
        23.140479070784
    ],
    [
        113.12298099706,
        23.14045664462
    ],
    [
        113.12300829868,
        23.140373459672
    ],
    [
        113.12305994631,
        23.140287350022
    ],
    [
        113.12309537626,
        23.140256091367
    ],
    [
        113.12313459356,
        23.140225970153
    ],
    [
        113.1232024898,
        23.140216315889
    ],
    [
        113.12327309109,
        23.140208871687
    ],
    [
        113.12328904606,
        23.140187659204
    ],
    [
        113.12331716352,
        23.140122395203
    ],
    [
        113.12339232844,
        23.139966357765
    ],
    [
        113.12340368376,
        23.139940200092
    ],
    [
        113.12340855171,
        23.139935112855
    ],
    [
        113.12353218067,
        23.139977241182
    ],
    [
        113.12358249954,
        23.14000371036
    ],
    [
        113.12366419021,
        23.140005931305
    ],
    [
        113.12371991285,
        23.140008878548
    ],
    [
        113.12372342879,
        23.140006757405
    ],
    [
        113.12377942381,
        23.140019747706
    ],
    [
        113.12378402268,
        23.140021982306
    ],
    [
        113.12380566061,
        23.140015774631
    ],
    [
        113.12388737224,
        23.140118651037
    ],
    [
        113.12393309992,
        23.14018358766
    ],
    [
        113.12395231433,
        23.140225092859
    ],
    [
        113.12399884851,
        23.140269425391
    ],
    [
        113.12404456674,
        23.140295843175
    ],
    [
        113.12406134269,
        23.140320495774
    ],
    [
        113.12412329385,
        23.140364507424
    ],
    [
        113.12416657722,
        23.140390893851
    ],
    [
        113.12419958017,
        23.140408996565
    ],
    [
        113.12426206758,
        23.140437286507
    ],
    [
        113.12431319423,
        23.140464059759
    ],
    [
        113.12440246652,
        23.140527190441
    ],
    [
        113.12441977804,
        23.140532321983
    ],
    [
        113.12443736505,
        23.140557261114
    ],
    [
        113.12446414836,
        23.1405834178
    ],
    [
        113.12447930103,
        23.140608051058
    ],
    [
        113.12448552124,
        23.140605699067
    ],
    [
        113.12436624065,
        23.14059584748
    ],
    [
        113.12428644993,
        23.140593349509
    ],
    [
        113.12421396345,
        23.140598826271
    ],
    [
        113.12421209746,
        23.140704056581
    ],
    [
        113.12420239077,
        23.140818941473
    ],
    [
        113.12418431192,
        23.140977383732
    ],
    [
        113.12417540094,
        23.141030699449
    ],
    [
        113.12415595304,
        23.14112510031
    ],
    [
        113.12411300118,
        23.141313574111
    ],
    [
        113.12409300352,
        23.141374329088
    ],
    [
        113.12409112042,
        23.141408755289
    ],
    [
        113.12408167368,
        23.141475628256
    ],
    [
        113.12406819743,
        23.141631696406
    ],
    [
        113.12405767495,
        23.141715916558
    ],
    [
        113.12403711574,
        23.141708029724
    ],
    [
        113.1240271101,
        23.141715212893
    ],
    [
        113.12398166276,
        23.141696394974
    ],
    [
        113.12392702012,
        23.141682331846
    ],
    [
        113.1238845508,
        23.141673595884
    ],
    [
        113.12387513007,
        23.14181995663
    ],
    [
        113.12386842103,
        23.141983717911
    ],
    [
        113.12386116187,
        23.142116274026
    ],
    [
        113.12384605891,
        23.142247363824
    ],
    [
        113.12383122898,
        23.142383340884
    ],
    [
        113.12382028952,
        23.142802052784
    ],
    [
        113.12381731401,
        23.142801739788
    ],
    [
        113.12381542973,
        23.142826400439
    ],
    [
        113.12383329703,
        23.142866530062
    ],
    [
        113.12385683938,
        23.142892632649
    ],
    [
        113.12388443089,
        23.14289708954
    ],
    [
        113.12388956988,
        23.142896347918
    ],
    [
        113.12390661284,
        23.142902284618
    ],
    [
        113.12394268637,
        23.143161057648
    ],
    [
        113.12396631556,
        23.143406905981
    ],
    [
        113.12400157733,
        23.143649935271
    ],
    [
        113.12402354395,
        23.143788060289
    ],
    [
        113.12403061163,
        23.143871445919
    ],
    [
        113.12403902281,
        23.143933147504
    ],
    [
        113.12408607525,
        23.143906142146
    ],
    [
        113.12408877847,
        23.143902382407
    ],
    [
        113.12413880471,
        23.143872436438
    ],
    [
        113.12416151723,
        23.143854040176
    ],
    [
        113.12419857177,
        23.143851583065
    ],
    [
        113.12420777965,
        23.143879114353
    ],
    [
        113.12418615819,
        23.143918686101
    ],
    [
        113.1241726506,
        23.143957017043
    ],
    [
        113.12416076268,
        23.14398777502
    ],
    [
        113.12418541076,
        23.144067884618
    ],
    [
        113.12418869449,
        23.144155286611
    ],
    [
        113.12417170108,
        23.144261661828
    ],
    [
        113.12417063538,
        23.144298270837
    ],
    [
        113.12416928455,
        23.144301778402
    ],
    [
        113.12417712908,
        23.144303246403
    ],
    [
        113.12418146316,
        23.144317686428
    ],
    [
        113.12422770708,
        23.144300168403
    ],
    [
        113.12432885907,
        23.144286963123
    ],
    [
        113.12439728687,
        23.144282788966
    ],
    [
        113.12439891608,
        23.144297190714
    ],
    [
        113.12440325366,
        23.144319770031
    ],
    [
        113.1244335876,
        23.14441190167
    ],
    [
        113.12443603405,
        23.14443906586
    ],
    [
        113.1244560551,
        23.144452918147
    ],
    [
        113.12445984268,
        23.144455142935
    ],
    [
        113.12446173684,
        23.144457069208
    ],
    [
        113.1244760695,
        23.144452120874
    ],
    [
        113.12450284524,
        23.144450607333
    ],
    [
        113.12453827532,
        23.144447862545
    ],
    [
        113.12456072253,
        23.144444388396
    ],
    [
        113.12459344648,
        23.144438892717
    ],
    [
        113.12460481699,
        23.144463201958
    ],
    [
        113.12462971061,
        23.144487164382
    ],
    [
        113.12465055842,
        23.144535755987
    ],
    [
        113.12467060035,
        23.144596272964
    ],
    [
        113.12466763107,
        23.144608980592
    ],
    [
        113.12469061401,
        23.144594935459
    ],
    [
        113.1247479501,
        23.144590884924
    ],
    [
        113.12482421598,
        23.144582500131
    ],
    [
        113.12488560192,
        23.144564948385
    ],
    [
        113.1249223777,
        23.144551107748
    ],
    [
        113.12492669552,
        23.144530281554
    ],
    [
        113.12493397709,
        23.144484540028
    ],
    [
        113.1249466729,
        23.144450000745
    ],
    [
        113.12496506042,
        23.144442402714
    ],
    [
        113.12499535211,
        23.144444203357
    ],
    [
        113.12502916168,
        23.144450668101
    ],
    [
        113.12508757969,
        23.14445152716
    ],
    [
        113.12509650475,
        23.144451929856
    ],
    [
        113.12516303012,
        23.14444016
    ],
    [
        113.12517844604,
        23.144440930193
    ],
    [
        113.12523956613,
        23.144438578359
    ],
    [
        113.12529148369,
        23.144420628453
    ],
    [
        113.1253098377,
        23.144339513626
    ],
    [
        113.12531686039,
        23.144319542371
    ],
    [
        113.12536360269,
        23.144218774212
    ],
    [
        113.12543144726,
        23.144135412845
    ],
    [
        113.12545686192,
        23.144119785619
    ],
    [
        113.12551768565,
        23.144061552564
    ],
    [
        113.12560771641,
        23.144003487767
    ],
    [
        113.12569478002,
        23.143964915326
    ],
    [
        113.12571235335,
        23.143953514183
    ],
    [
        113.12581970512,
        23.143930716028
    ],
    [
        113.12593868707,
        23.143914882099
    ],
    [
        113.12594599658,
        23.143933711842
    ],
    [
        113.1260477985,
        23.144216313546
    ],
    [
        113.12605054422,
        23.144310492892
    ],
    [
        113.12605764826,
        23.144473917656
    ],
    [
        113.12610235884,
        23.144673183155
    ],
    [
        113.12611481099,
        23.144700773306
    ],
    [
        113.12611943117,
        23.144750489989
    ],
    [
        113.12599182499,
        23.144823153663
    ],
    [
        113.12594374238,
        23.144936366596
    ],
    [
        113.12586755151,
        23.145082795758
    ],
    [
        113.12570112136,
        23.145401496153
    ],
    [
        113.12570328404,
        23.14539990092
    ],
    [
        113.12570112566,
        23.145410177584
    ],
    [
        113.12574902863,
        23.145483333691
    ],
    [
        113.12575335612,
        23.145484484046
    ],
    [
        113.12576823472,
        23.145494203484
    ],
    [
        113.12577932235,
        23.145494099329
    ],
    [
        113.12581962577,
        23.145512612722
    ],
    [
        113.12588129905,
        23.145543386988
    ],
    [
        113.12592322794,
        23.145568438092
    ],
    [
        113.12594243359,
        23.14557903826
    ],
    [
        113.12595514509,
        23.145581943913
    ],
    [
        113.12595271575,
        23.145590859748
    ],
    [
        113.12596163893,
        23.14558909602
    ],
    [
        113.12595947577,
        23.145589605797
    ],
    [
        113.12595704397,
        23.145593638314
    ],
    [
        113.12595839912,
        23.145599627315
    ],
    [
        113.12595326221,
        23.145601991053
    ],
    [
        113.12594840327,
        23.145619280143
    ],
    [
        113.12593218934,
        23.145642365605
    ],
    [
        113.12592435803,
        23.145664221708
    ],
    [
        113.12592193547,
        23.145686431063
    ],
    [
        113.12590977829,
        23.145710120761
    ],
    [
        113.12589005103,
        23.145737494081
    ],
    [
        113.12587681659,
        23.145769849082
    ],
    [
        113.12585709296,
        23.145804276429
    ],
    [
        113.12584629471,
        23.145841009176
    ],
    [
        113.12582819555,
        23.145878988197
    ],
    [
        113.12580928203,
        23.145910986637
    ],
    [
        113.12580604925,
        23.145934811718
    ],
    [
        113.12579524027,
        23.145950654982
    ],
    [
        113.12578930376,
        23.14597552449
    ],
    [
        113.12578985838,
        23.146001848382
    ],
    [
        113.1257828392,
        23.146024802534
    ],
    [
        113.12577851568,
        23.146031248406
    ],
    [
        113.12578284717,
        23.146039995129
    ],
    [
        113.12577446445,
        23.146041225218
    ],
    [
        113.12577662948,
        23.146044242092
    ],
    [
        113.1257717701,
        23.146060175201
    ],
    [
        113.12577880436,
        23.146065978421
    ],
    [
        113.12577583159,
        23.146069731724
    ],
    [
        113.12578476861,
        23.146094011665
    ],
    [
        113.1257945125,
        23.146109893695
    ],
    [
        113.1258315732,
        23.14613215663
    ],
    [
        113.12583022147,
        23.146132950099
    ],
    [
        113.12585808553,
        23.146151547831
    ],
    [
        113.12592974705,
        23.146148020347
    ],
    [
        113.12596192864,
        23.146149593387
    ],
    [
        113.12596841949,
        23.146150777026
    ],
    [
        113.12597518062,
        23.146151693492
    ],
    [
        113.12603222952,
        23.146131398995
    ],
    [
        113.12609523048,
        23.146116893939
    ],
    [
        113.12636235581,
        23.146024670875
    ],
    [
        113.12767869581,
        23.145573238146
    ],
    [
        113.12768869733,
        23.145567971853
    ],
    [
        113.12782467214,
        23.145514259018
    ],
    [
        113.12781146936,
        23.145605744631
    ],
    [
        113.12775362764,
        23.146167753765
    ],
    [
        113.12771646818,
        23.146453647287
    ],
    [
        113.12768872403,
        23.146646095344
    ],
    [
        113.12768413018,
        23.146650905367
    ],
    [
        113.12768278709,
        23.146666890373
    ],
    [
        113.12766719673,
        23.146832132074
    ],
    [
        113.1276340836,
        23.147086893955
    ],
    [
        113.12759991214,
        23.14737663733
    ],
    [
        113.12759939866,
        23.147423292272
    ],
    [
        113.12760183517,
        23.147428485705
    ],
    [
        113.12754988635,
        23.147824296531
    ],
    [
        113.12750738456,
        23.148182820535
    ],
    [
        113.12750282649,
        23.148244875636
    ],
    [
        113.12750985745,
        23.148246343771
    ],
    [
        113.12779271422,
        23.14830456963
    ],
    [
        113.12778784954,
        23.148308018695
    ],
    [
        113.12788167916,
        23.148321187357
    ],
    [
        113.1278789818,
        23.148331453475
    ],
    [
        113.12791088918,
        23.148336034789
    ],
    [
        113.12796983027,
        23.148334539665
    ],
    [
        113.12836946802,
        23.148381146772
    ],
    [
        113.12834517683,
        23.148447763569
    ],
    [
        113.12825476327,
        23.148699421192
    ],
    [
        113.1282021305,
        23.148838289417
    ],
    [
        113.12815681152,
        23.148997353227
    ],
    [
        113.12803703356,
        23.149401831081
    ],
    [
        113.12799878002,
        23.149609032664
    ],
    [
        113.12791898962,
        23.149960443677
    ],
    [
        113.12787342776,
        23.150149896118
    ],
    [
        113.12785808459,
        23.150247319323
    ],
    [
        113.1277612624,
        23.150590596524
    ],
    [
        113.12754999213,
        23.151193323053
    ],
    [
        113.127202026,
        23.151942862072
    ],
    [
        113.12716045754,
        23.152036622672
    ],
    [
        113.12702323036,
        23.152209461684
    ],
    [
        113.12688147316,
        23.152468243154
    ],
    [
        113.12677832867,
        23.152657094408
    ],
    [
        113.12655358497,
        23.152950692816
    ],
    [
        113.12630884675,
        23.153266527459
    ],
    [
        113.12614322555,
        23.153443872433
    ],
    [
        113.12614241495,
        23.153444673996
    ],
    [
        113.12595168731,
        23.153676185071
    ],
    [
        113.1257817671,
        23.153891206827
    ],
    [
        113.12569181226,
        23.15400922926
    ],
    [
        113.1255748246,
        23.154140416512
    ],
    [
        113.12550058718,
        23.154297480667
    ],
    [
        113.12547118062,
        23.154381419456
    ],
    [
        113.12542825274,
        23.154465971213
    ],
    [
        113.12540131772,
        23.154593629075
    ],
    [
        113.12539440228,
        23.154728910561
    ],
    [
        113.12541668733,
        23.154855402131
    ],
    [
        113.12547361126,
        23.155007642501
    ],
    [
        113.12552753158,
        23.155126468371
    ],
    [
        113.12562932259,
        23.155249540236
    ],
    [
        113.1257957761,
        23.155407234342
    ],
    [
        113.1259773422,
        23.155532071512
    ],
    [
        113.12622545416,
        23.155686158125
    ],
    [
        113.12647053736,
        23.155785422644
    ],
    [
        113.12671018849,
        23.155864011444
    ],
    [
        113.12707231937,
        23.155937219214
    ],
    [
        113.12745552742,
        23.156009191707
    ],
    [
        113.12758235031,
        23.156023143573
    ],
    [
        113.12778407791,
        23.156049422864
    ],
    [
        113.12825022383,
        23.156074557557
    ],
    [
        113.12871200852,
        23.156079629462
    ],
    [
        113.12887558974,
        23.156096961351
    ],
    [
        113.12903916751,
        23.156112675108
    ],
    [
        113.12919843131,
        23.156143520662
    ],
    [
        113.12940645782,
        23.156288322136
    ],
    [
        113.12953983637,
        23.15639852293
    ],
    [
        113.12965481982,
        23.156496484867
    ],
    [
        113.12969026136,
        23.156526378485
    ],
    [
        113.12981715375,
        23.156640824376
    ],
    [
        113.12989970433,
        23.15674856267
    ],
    [
        113.12993815067,
        23.156812966413
    ],
    [
        113.12994193863,
        23.156816557067
    ],
    [
        113.12995193522,
        23.156810213334
    ],
    [
        113.1299684053,
        23.156787970816
    ],
    [
        113.13005999923,
        23.156734162209
    ],
    [
        113.13010133845,
        23.156710439615
    ],
    [
        113.13016321464,
        23.156677838937
    ],
    [
        113.1302191418,
        23.156643511193
    ],
    [
        113.13033423519,
        23.156570029688
    ],
    [
        113.13044555557,
        23.156510053938
    ],
    [
        113.13076329634,
        23.156333127916
    ],
    [
        113.13141198079,
        23.15594784293
    ],
    [
        113.13193448519,
        23.155641055335
    ],
    [
        113.13263421679,
        23.155244090879
    ],
    [
        113.13268824582,
        23.155209221822
    ],
    [
        113.13323666638,
        23.15489000486
    ],
    [
        113.13365622221,
        23.154651855204
    ],
    [
        113.13387316676,
        23.154539021049
    ],
    [
        113.13410252727,
        23.154406878405
    ],
    [
        113.13457633752,
        23.154089159904
    ],
    [
        113.13496266821,
        23.153883043793
    ],
    [
        113.13512474468,
        23.153772247493
    ],
    [
        113.13519579059,
        23.153726575028
    ],
    [
        113.13532140097,
        23.153641991724
    ],
    [
        113.13567342234,
        23.153456446143
    ],
    [
        113.13598814706,
        23.153272682616
    ],
    [
        113.13598922534,
        23.153269174834
    ],
    [
        113.13616481495,
        23.153156457196
    ],
    [
        113.13638066898,
        23.153034691174
    ],
    [
        113.13669430481,
        23.15283843201
    ],
    [
        113.13696012652,
        23.152671977342
    ],
    [
        113.1376649302,
        23.152218701642
    ],
    [
        113.13784890652,
        23.152109112252
    ],
    [
        113.13789510822,
        23.152087958308
    ],
    [
        113.13804478495,
        23.152011127103
    ],
    [
        113.13812909702,
        23.151990649762
    ],
    [
        113.13820935782,
        23.151973898172
    ],
    [
        113.13823098002,
        23.1519734683
    ],
    [
        113.13836233612,
        23.151972273542
    ],
    [
        113.13838962985,
        23.151965975297
    ],
    [
        113.13847719559,
        23.151958304517
    ],
    [
        113.13852882693,
        23.151967902013
    ],
    [
        113.13856180604,
        23.151973912894
    ],
    [
        113.13858559543,
        23.151979760759
    ],
    [
        113.13858911205,
        23.15198362138
    ],
    [
        113.13863537267,
        23.152038973817
    ],
    [
        113.13868327841,
        23.152124741478
    ],
    [
        113.13884215422,
        23.152408899604
    ],
    [
        113.13890467822,
        23.152522326993
    ],
    [
        113.13892470817,
        23.152559307765
    ],
    [
        113.13899725573,
        23.152701127821
    ],
    [
        113.13904271753,
        23.152769486985
    ],
    [
        113.13915974984,
        23.152767213736
    ],
    [
        113.13916353968,
        23.15277460596
    ],
    [
        113.13977737318,
        23.15278243486
    ],
    [
        113.14004631634,
        23.152784169674
    ],
    [
        113.14044311816,
        23.152792465633
    ],
    [
        113.14087614265,
        23.152795391387
    ],
    [
        113.14095399168,
        23.152797285022
    ],
    [
        113.14096669851,
        23.152800489797
    ],
    [
        113.14096263983,
        23.152795264565
    ],
    [
        113.14097777923,
        23.152798240192
    ],
    [
        113.14098291189,
        23.152794259582
    ],
    [
        113.14093094241,
        23.152703826761
    ],
    [
        113.14089575931,
        23.152648140819
    ],
    [
        113.14074450651,
        23.152450985802
    ],
    [
        113.14071499827,
        23.152392412917
    ],
    [
        113.14070956157,
        23.15235270757
    ],
    [
        113.1407268473,
        23.152335102041
    ],
    [
        113.1408181704,
        23.152284327511
    ],
    [
        113.14090625527,
        23.152240006381
    ],
    [
        113.14090462946,
        23.152234823342
    ],
    [
        113.14098704741,
        23.152202339804
    ],
    [
        113.14101219298,
        23.152211728831
    ],
    [
        113.14110473598,
        23.152339760721
    ],
    [
        113.14119672271,
        23.152446347937
    ],
    [
        113.14129329138,
        23.152534834848
    ],
    [
        113.1413936443,
        23.152622299657
    ],
    [
        113.14146287715,
        23.152665003001
    ],
    [
        113.14149640786,
        23.152680502442
    ],
    [
        113.14153749324,
        23.152677954055
    ],
    [
        113.14160344208,
        23.152668507537
    ],
    [
        113.14167938971,
        23.152655162068
    ],
    [
        113.14177695933,
        23.152637302489
    ],
    [
        113.14190426727,
        23.152623205281
    ],
    [
        113.14202319673,
        23.152609774584
    ],
    [
        113.14209725108,
        23.152592861492
    ],
    [
        113.14224050289,
        23.152569257781
    ],
    [
        113.14235214337,
        23.1525654593
    ],
    [
        113.14252054729,
        23.15255420909
    ],
    [
        113.14269138612,
        23.152543263021
    ],
    [
        113.14275949923,
        23.152530305096
    ],
    [
        113.14283194116,
        23.152521488316
    ],
    [
        113.14296763937,
        23.152509935565
    ],
    [
        113.14313767262,
        23.152499766452
    ],
    [
        113.14329500647,
        23.152495615989
    ],
    [
        113.14333069206,
        23.152496483193
    ],
    [
        113.14335043056,
        23.152501153527
    ],
    [
        113.14337773013,
        23.152494826255
    ],
    [
        113.14352074187,
        23.152495308695
    ],
    [
        113.14364319855,
        23.152482691897
    ],
    [
        113.14373941787,
        23.152451186857
    ],
    [
        113.14379429919,
        23.152451823511
    ],
    [
        113.14380024653,
        23.152451379227
    ],
    [
        113.14385594733,
        23.152462609205
    ],
    [
        113.14387622894,
        23.1524694554
    ],
    [
        113.14393571986,
        23.152486986415
    ],
    [
        113.14396790693,
        23.152506508293
    ],
    [
        113.14398574499,
        23.152499748096
    ],
    [
        113.14400115554,
        23.152500273115
    ],
    [
        113.14405332487,
        23.152488651248
    ],
    [
        113.14410981554,
        23.152471130606
    ],
    [
        113.1441814259,
        23.152426997349
    ],
    [
        113.14424924685,
        23.152376560126
    ],
    [
        113.14431653232,
        23.152332352505
    ],
    [
        113.14442729073,
        23.152215328217
    ],
    [
        113.14448833848,
        23.152144155248
    ],
    [
        113.14457804352,
        23.152070462202
    ],
    [
        113.14464886452,
        23.152050721115
    ],
    [
        113.14472698517,
        23.152030011013
    ],
    [
        113.14490974636,
        23.15201749819
    ],
    [
        113.14501411015,
        23.15201673592
    ],
    [
        113.14507927564,
        23.15202320848
    ],
    [
        113.14520150976,
        23.152053925084
    ],
    [
        113.14534432705,
        23.15212782996
    ],
    [
        113.14549958543,
        23.152203551579
    ],
    [
        113.14550743336,
        23.15221235791
    ],
    [
        113.14554962398,
        23.152225778306
    ],
    [
        113.14554665258,
        23.152229529506
    ],
    [
        113.14564023575,
        23.152267094549
    ],
    [
        113.14582307881,
        23.152342959147
    ],
    [
        113.1459391193,
        23.152396058229
    ],
    [
        113.14606138624,
        23.152456845177
    ],
    [
        113.1461087199,
        23.15247440512
    ],
    [
        113.14615498683,
        23.152510938922
    ],
    [
        113.14620097393,
        23.152534987276
    ],
    [
        113.14620368641,
        23.152545881759
    ],
    [
        113.14622289498,
        23.152558660623
    ],
    [
        113.14624400633,
        23.152584220323
    ],
    [
        113.1463890407,
        23.152708286001
    ],
    [
        113.14651539406,
        23.152800311157
    ],
    [
        113.14652053279,
        23.152801475578
    ],
    [
        113.14653646414,
        23.15277214848
    ],
    [
        113.14653348448,
        23.152765591205
    ],
    [
        113.14655455082,
        23.152732544761
    ],
    [
        113.14656211781,
        23.152726692461
    ],
    [
        113.14656265906,
        23.152727243406
    ],
    [
        113.14659369755,
        23.152651483451
    ],
    [
        113.14662932545,
        23.152565483888
    ],
    [
        113.14667496175,
        23.152482892961
    ],
    [
        113.14669925452,
        23.152424934359
    ],
    [
        113.14671168715,
        23.152416443017
    ],
    [
        113.14670735187,
        23.152405253021
    ],
    [
        113.14672786608,
        23.152356460655
    ],
    [
        113.14674378097,
        23.152304613353
    ],
    [
        113.1467559275,
        23.152275498065
    ],
    [
        113.14676645175,
        23.152246629213
    ],
    [
        113.14677699136,
        23.152237837234
    ],
    [
        113.14678212834,
        23.152236559221
    ],
    [
        113.14678996851,
        23.152233965969
    ],
    [
        113.14679375173,
        23.152230496788
    ],
    [
        113.14680727264,
        23.152230432014
    ],
    [
        113.14680970707,
        23.15223128311
    ],
    [
        113.14682783099,
        23.152238885072
    ],
    [
        113.14683459612,
        23.152244957055
    ],
    [
        113.14683973168,
        23.15224177973
    ],
    [
        113.14686272433,
        23.152250812191
    ],
    [
        113.14693061716,
        23.152273008003
    ],
    [
        113.14694062313,
        23.152273431494
    ],
    [
        113.14699391403,
        23.152296217026
    ],
    [
        113.14706911375,
        23.152324216581
    ],
    [
        113.14715622014,
        23.152361617604
    ],
    [
        113.14724765576,
        23.152400979178
    ],
    [
        113.14729310598,
        23.152423910057
    ],
    [
        113.14731366267,
        23.152428831168
    ],
    [
        113.14734152748,
        23.152442000963
    ],
    [
        113.14735343299,
        23.152450318804
    ],
    [
        113.14737615646,
        23.152459341374
    ],
    [
        113.14737615186,
        23.15245337255
    ],
    [
        113.14738021366,
        23.152460216107
    ],
    [
        113.14738752386,
        23.152471177937
    ],
    [
        113.14739401522,
        23.15247236042
    ],
    [
        113.14739645105,
        23.152474838672
    ],
    [
        113.14740537846,
        23.152478770676
    ],
    [
        113.14743242323,
        23.152480260703
    ],
    [
        113.14745162384,
        23.152479733945
    ],
    [
        113.14746297272,
        23.152467423463
    ],
    [
        113.14748186556,
        23.152418327849
    ],
    [
        113.1474764438,
        23.152401425832
    ],
    [
        113.14747886381,
        23.152383284416
    ],
    [
        113.14747913071,
        23.152378676185
    ],
    [
        113.1474715517,
        23.152369881142
    ],
    [
        113.14747180944,
        23.152353335273
    ],
    [
        113.1474723472,
        23.152349273704
    ],
    [
        113.14746829205,
        23.152351112262
    ],
    [
        113.14747396777,
        23.152346584847
    ],
    [
        113.14746585413,
        23.152345921002
    ],
    [
        113.14746368582,
        23.15233964854
    ],
    [
        113.14746367688,
        23.152327982213
    ],
    [
        113.14746286598,
        23.152328512708
    ],
    [
        113.14747960922,
        23.152297291278
    ],
    [
        113.14750337904,
        23.152259663231
    ],
    [
        113.14751283788,
        23.152251122562
    ],
    [
        113.1475657969,
        23.152189240133
    ],
    [
        113.14760523289,
        23.152125527376
    ],
    [
        113.14768736795,
        23.15202039503
    ],
    [
        113.14771897553,
        23.151974741424
    ],
    [
        113.14778841383,
        23.151886509017
    ],
    [
        113.14812086696,
        23.151976853599
    ],
    [
        113.1482269211,
        23.152022621821
    ],
    [
        113.1486278762,
        23.152187122819
    ],
    [
        113.14894407818,
        23.152206002377
    ],
    [
        113.14895246115,
        23.152203407848
    ],
    [
        113.14921833096,
        23.152179201786
    ],
    [
        113.14947636895,
        23.152160543719
    ],
    [
        113.1496391969,
        23.152141897667
    ],
    [
        113.14973061799,
        23.152128771704
    ],
    [
        113.14976929469,
        23.152120889905
    ],
    [
        113.14980066445,
        23.152108566653
    ],
    [
        113.14982500242,
        23.152098046163
    ],
    [
        113.14988368663,
        23.152075783609
    ],
    [
        113.14993155592,
        23.152060426324
    ],
    [
        113.14997455617,
        23.152045001756
    ],
    [
        113.14998293468,
        23.152035076786
    ],
    [
        113.15000482956,
        23.152012583102
    ],
    [
        113.15002537988,
        23.152000651924
    ],
    [
        113.15004809566,
        23.151990377538
    ],
    [
        113.15006838027,
        23.151984682283
    ],
    [
        113.15006324077,
        23.151985155627
    ],
    [
        113.15008920271,
        23.151974653115
    ],
    [
        113.1501527578,
        23.151951632582
    ],
    [
        113.1501876476,
        23.15194151963
    ],
    [
        113.15022254,
        23.151934661637
    ],
    [
        113.15023605863,
        23.151924532835
    ],
    [
        113.1502839342,
        23.151914591406
    ],
    [
        113.15035372531,
        23.15190792454
    ],
    [
        113.15039186302,
        23.151898664274
    ],
    [
        113.15043514614,
        23.151896253932
    ],
    [
        113.15048951966,
        23.151891547251
    ],
    [
        113.15053686403,
        23.151892714787
    ],
    [
        113.15058095979,
        23.151890582495
    ],
    [
        113.1506131516,
        23.15188775003
    ],
    [
        113.15065318844,
        23.151883934559
    ],
    [
        113.15070621686,
        23.151887341981
    ],
    [
        113.15076735775,
        23.151885155972
    ],
    [
        113.15080225784,
        23.151885068004
    ],
    [
        113.15084717508,
        23.151894062489
    ],
    [
        113.15086151194,
        23.151891264247
    ],
    [
        113.15095268006,
        23.151882406403
    ],
    [
        113.15119341243,
        23.151800850092
    ],
    [
        113.15124886191,
        23.15178039488
    ],
    [
        113.15134922456,
        23.151758879086
    ],
    [
        113.1513559849,
        23.151753809841
    ],
    [
        113.15140602366,
        23.151732466493
    ],
    [
        113.15145959064,
        23.15172527382
    ],
    [
        113.15149691885,
        23.151711363989
    ],
    [
        113.15153694435,
        23.151685820888
    ],
    [
        113.15157806021,
        23.151670871296
    ],
    [
        113.1515880719,
        23.151671539102
    ],
    [
        113.15162755799,
        23.151647614679
    ],
    [
        113.15166028526,
        23.151630930322
    ],
    [
        113.15166190853,
        23.15163067923
    ],
    [
        113.15172682519,
        23.151601099902
    ],
    [
        113.15177362341,
        23.151584858894
    ],
    [
        113.15183042458,
        23.151556531105
    ],
    [
        113.15190590012,
        23.151533042913
    ],
    [
        113.15196026947,
        23.151507935921
    ],
    [
        113.15204196646,
        23.151479633452
    ],
    [
        113.15208173552,
        23.151468994349
    ],
    [
        113.15211852925,
        23.151459674568
    ],
    [
        113.15213043506,
        23.151459276471
    ],
    [
        113.15215370198,
        23.151453589883
    ],
    [
        113.15220158844,
        23.151441418022
    ],
    [
        113.15223865003,
        23.151427486246
    ],
    [
        113.15230601785,
        23.151412018771
    ],
    [
        113.15237879211,
        23.151387931062
    ],
    [
        113.15243533916,
        23.151375312426
    ],
    [
        113.15246509124,
        23.151355318946
    ],
    [
        113.15248457272,
        23.151352295025
    ],
    [
        113.15254868201,
        23.151318057374
    ],
    [
        113.15261062231,
        23.15127727993
    ],
    [
        113.15265173577,
        23.151250091357
    ],
    [
        113.15265309277,
        23.151255533436
    ],
    [
        113.15270583798,
        23.151221426232
    ],
    [
        113.15277319615,
        23.151186131388
    ],
    [
        113.15280349282,
        23.151168578969
    ],
    [
        113.15286408992,
        23.151138084413
    ],
    [
        113.15292252901,
        23.151116515333
    ],
    [
        113.15292685611,
        23.151112495859
    ],
    [
        113.15296797474,
        23.151089639048
    ],
    [
        113.15301558274,
        23.151058445312
    ],
    [
        113.15307267099,
        23.151038210951
    ],
    [
        113.15310324457,
        23.151027437873
    ],
    [
        113.15313570964,
        23.151012344863
    ],
    [
        113.15316195798,
        23.151008032382
    ],
    [
        113.15316195953,
        23.151010202838
    ],
    [
        113.15317873181,
        23.151000355803
    ],
    [
        113.15321660982,
        23.150985051278
    ],
    [
        113.15325719696,
        23.150973303405
    ],
    [
        113.1532696462,
        23.150973173216
    ],
    [
        113.15330184744,
        23.15096648378
    ],
    [
        113.15334297233,
        23.150949042071
    ],
    [
        113.15336543305,
        23.150945496925
    ],
    [
        113.15337949865,
        23.150934531756
    ],
    [
        113.15341413161,
        23.150921355744
    ],
    [
        113.15341251082,
        23.150925678424
    ],
    [
        113.1534336118,
        23.150912621235
    ],
    [
        113.15345633654,
        23.150899310597
    ],
    [
        113.15346147731,
        23.150897197702
    ],
    [
        113.1534833879,
        23.150880621851
    ],
    [
        113.15353397637,
        23.150848629714
    ],
    [
        113.15355832099,
        23.150829095427
    ],
    [
        113.15357158084,
        23.150826258472
    ],
    [
        113.15360025109,
        23.150799717579
    ],
    [
        113.15363082315,
        23.150783235402
    ],
    [
        113.15363352798,
        23.150780823596
    ],
    [
        113.1536440755,
        23.150769545483
    ],
    [
        113.15367356268,
        23.150749523396
    ],
    [
        113.15369411601,
        23.15072614659
    ],
    [
        113.15370764051,
        23.150714358185
    ],
    [
        113.15371413136,
        23.150707375728
    ],
    [
        113.15378224672,
        23.150578169011
    ],
    [
        113.15380683578,
        23.150519293915
    ],
    [
        113.15380899449,
        23.150509821888
    ],
    [
        113.15384007935,
        23.150450474632
    ],
    [
        113.15386062001,
        23.150407561343
    ],
    [
        113.15386764269,
        23.15038647617
    ],
    [
        113.15390250498,
        23.150308991335
    ],
    [
        113.15394737961,
        23.150227544597
    ],
    [
        113.15397765196,
        23.150165472456
    ],
    [
        113.15397981417,
        23.150160883675
    ],
    [
        113.15398008078,
        23.150154917887
    ],
    [
        113.15401955828,
        23.150095928635
    ],
    [
        113.15403253965,
        23.150080061626
    ],
    [
        113.15405632174,
        23.150025514344
    ],
    [
        113.15406931256,
        23.150023483536
    ],
    [
        113.15408202085,
        23.150003814882
    ],
    [
        113.15411797618,
        23.14993827372
    ],
    [
        113.15412338331,
        23.149928836002
    ],
    [
        113.15413311834,
        23.149915103712
    ],
    [
        113.15417746845,
        23.14985453419
    ],
    [
        113.15418422181,
        23.149834258482
    ],
    [
        113.15421451085,
        23.149794156835
    ],
    [
        113.15422667284,
        23.149766341956
    ],
    [
        113.15423126431,
        23.149751197797
    ],
    [
        113.15427236804,
        23.149691675912
    ],
    [
        113.15428264068,
        23.149671708296
    ],
    [
        113.15429400323,
        23.149662604213
    ],
    [
        113.15430913607,
        23.149624239234
    ],
    [
        113.15432806534,
        23.149596223619
    ],
    [
        113.15436457534,
        23.149547231259
    ],
    [
        113.15437295469,
        23.149529142158
    ],
    [
        113.15437998595,
        23.149519177896
    ],
    [
        113.15440972958,
        23.1494706558
    ],
    [
        113.15441756291,
        23.149445235554
    ],
    [
        113.15445054897,
        23.149387250987
    ],
    [
        113.15446407305,
        23.149371385521
    ],
    [
        113.15449571272,
        23.149323695247
    ],
    [
        113.15450733284,
        23.149293430529
    ],
    [
        113.15454058381,
        23.149225137085
    ],
    [
        113.15457787619,
        23.149126498987
    ],
    [
        113.1545813864,
        23.14911269899
    ],
    [
        113.15462705614,
        23.148990543141
    ],
    [
        113.15467626752,
        23.148902877405
    ],
    [
        113.15469925836,
        23.148873541863
    ],
    [
        113.15471549099,
        23.148858786872
    ],
    [
        113.15471872633,
        23.148837929908
    ],
    [
        113.15472549519,
        23.148840169678
    ],
    [
        113.15471978239,
        23.148795075279
    ],
    [
        113.15471027348,
        23.148739632534
    ],
    [
        113.15462674433,
        23.148488092029
    ],
    [
        113.15427579878,
        23.147806176325
    ],
    [
        113.15418719316,
        23.147643270575
    ],
    [
        113.15418257316,
        23.147610936941
    ],
    [
        113.15418555232,
        23.147613952958
    ],
    [
        113.15418257145,
        23.14760795265
    ],
    [
        113.15403071793,
        23.147114193188
    ],
    [
        113.15400256519,
        23.147108463765
    ],
    [
        113.15398740262,
        23.147099075988
    ],
    [
        113.1539611382,
        23.147081429058
    ],
    [
        113.15391484634,
        23.147066819902
    ],
    [
        113.15389481111,
        23.147055750401
    ],
    [
        113.15362834544,
        23.146801607456
    ],
    [
        113.15359882817,
        23.146771437946
    ],
    [
        113.15359040179,
        23.14670352063
    ],
    [
        113.15355463888,
        23.146633671783
    ],
    [
        113.1535505771,
        23.146629828472
    ],
    [
        113.15354461418,
        23.146613484418
    ],
    [
        113.15352998317,
        23.146583207763
    ],
    [
        113.1535261764,
        23.146549524774
    ],
    [
        113.15353266038,
        23.146527350822
    ],
    [
        113.15353995478,
        23.146502201623
    ],
    [
        113.15353940938,
        23.146494328002
    ],
    [
        113.15356862424,
        23.1464648105
    ],
    [
        113.15358621033,
        23.146452797527
    ],
    [
        113.1536119113,
        23.146431650241
    ],
    [
        113.15360379492,
        23.146437800069
    ],
    [
        113.15365817101,
        23.146389026143
    ],
    [
        113.15372526332,
        23.146330080764
    ],
    [
        113.15376963273,
        23.146293943184
    ],
    [
        113.1537796383,
        23.146276690005
    ],
    [
        113.15377909019,
        23.146263390581
    ],
    [
        113.15377611347,
        23.14626444314
    ],
    [
        113.15373330668,
        23.146180414765
    ],
    [
        113.1536366264,
        23.146068932181
    ],
    [
        113.15364716051,
        23.146026184252
    ],
    [
        113.15353451839,
        23.145923742032
    ],
    [
        113.15351069737,
        23.14591588034
    ],
    [
        113.15350934292,
        23.145913423592
    ],
    [
        113.15348958992,
        23.145922155801
    ],
    [
        113.15348498821,
        23.145920747931
    ],
    [
        113.15346171605,
        23.145927812656
    ],
    [
        113.15341842513,
        23.145952829171
    ],
    [
        113.15334212147,
        23.145988595505
    ],
    [
        113.15324931459,
        23.146033937095
    ],
    [
        113.15318897023,
        23.146049257606
    ],
    [
        113.15317841729,
        23.146052935513
    ],
    [
        113.15315646686,
        23.145994899685
    ],
    [
        113.15302908846,
        23.145624481842
    ],
    [
        113.15292395444,
        23.14534926349
    ],
    [
        113.15292367861,
        23.145338137328
    ],
    [
        113.15278332883,
        23.144973517595
    ],
    [
        113.15275406713,
        23.144895857724
    ],
    [
        113.15273483271,
        23.144849784478
    ],
    [
        113.15273374121,
        23.144829424897
    ],
    [
        113.15272913564,
        23.144817976747
    ],
    [
        113.15272073901,
        23.144801058345
    ],
    [
        113.15264623467,
        23.144606753189
    ],
    [
        113.15259202781,
        23.144409971467
    ],
    [
        113.15284147979,
        23.144273453036
    ],
    [
        113.15302437836,
        23.144165697031
    ],
    [
        113.15325868248,
        23.144005599596
    ],
    [
        113.15335580573,
        23.143913645225
    ],
    [
        113.15340098975,
        23.143879699892
    ],
    [
        113.15340937741,
        23.143873825741
    ],
    [
        113.15345022145,
        23.143814328994
    ],
    [
        113.15350080963,
        23.143755753705
    ],
    [
        113.15356086447,
        23.143679919428
    ],
    [
        113.15355842671,
        23.143675009149
    ],
    [
        113.15360603945,
        23.143617753399
    ],
    [
        113.15360658366,
        23.143625355482
    ],
    [
        113.15385492122,
        23.14328789089
    ],
    [
        113.15395258347,
        23.143156021399
    ],
    [
        113.15400126403,
        23.14304477765
    ],
    [
        113.1540618465,
        23.142908701907
    ],
    [
        113.15410836657,
        23.142805298594
    ],
    [
        113.15414161818,
        23.142683304662
    ],
    [
        113.15415729945,
        23.142629757694
    ],
    [
        113.15417324943,
        23.1425697026
    ],
    [
        113.15419648729,
        23.142446244358
    ],
    [
        113.15419783875,
        23.142440290484
    ],
    [
        113.15421270982,
        23.142389989781
    ],
    [
        113.15423811936,
        23.14228228859
    ],
    [
        113.15427000338,
        23.142101409016
    ],
    [
        113.15427837848,
        23.142048868678
    ],
    [
        113.15428378587,
        23.142028308354
    ],
    [
        113.15431132841,
        23.141802349364
    ],
    [
        113.15433754578,
        23.141666984619
    ],
    [
        113.15435107754,
        23.14165844611
    ],
    [
        113.15438382634,
        23.141644141225
    ],
    [
        113.15445014626,
        23.141649990473
    ],
    [
        113.15448344208,
        23.141653864753
    ],
    [
        113.15449535277,
        23.141655074025
    ],
    [
        113.15455896598,
        23.141657634207
    ],
    [
        113.15461391892,
        23.141664984976
    ],
    [
        113.15463855452,
        23.141673106372
    ],
    [
        113.15469594167,
        23.141670712627
    ],
    [
        113.15469079753,
        23.141667675704
    ],
    [
        113.15470135412,
        23.14166534253
    ],
    [
        113.15471164109,
        23.141666804458
    ],
    [
        113.15471895007,
        23.141667150662
    ],
    [
        113.15485510977,
        23.141654432205
    ],
    [
        113.15506382473,
        23.141646495003
    ],
    [
        113.15522246515,
        23.141646169805
    ],
    [
        113.15535620329,
        23.14164802387
    ],
    [
        113.15545312542,
        23.141652220972
    ],
    [
        113.15551404312,
        23.141662575249
    ],
    [
        113.15556304394,
        23.141654907721
    ],
    [
        113.15557928662,
        23.141649637764
    ],
    [
        113.1556033819,
        23.141648511927
    ],
    [
        113.15561989673,
        23.14164785585
    ],
    [
        113.15576772161,
        23.141647902038
    ],
    [
        113.15608314125,
        23.141626150018
    ],
    [
        113.15617709403,
        23.141621854407
    ],
    [
        113.15646248121,
        23.141608956213
    ],
    [
        113.15650390777,
        23.141600913302
    ],
    [
        113.15658541164,
        23.141598375577
    ],
    [
        113.15660788771,
        23.141602641768
    ],
    [
        113.15662413887,
        23.141617704446
    ],
    [
        113.15662061808,
        23.141615503409
    ],
    [
        113.15663334636,
        23.141620768996
    ],
    [
        113.15664201404,
        23.14163006826
    ],
    [
        113.15666773466,
        23.141616185747
    ],
    [
        113.15670239295,
        23.141608077205
    ],
    [
        113.15683101443,
        23.141595622336
    ],
    [
        113.15699267388,
        23.141575023397
    ],
    [
        113.15698996746,
        23.141580697482
    ],
    [
        113.15700323465,
        23.141573484776
    ],
    [
        113.15753808025,
        23.141541523234
    ],
    [
        113.1575803281,
        23.14153806193
    ],
    [
        113.15793267872,
        23.141518023571
    ],
    [
        113.15801961861,
        23.141512988942
    ],
    [
        113.15803126374,
        23.14150819409
    ],
    [
        113.15803072041,
        23.141502221771
    ],
    [
        113.15806620141,
        23.141501676044
    ],
    [
        113.15808976192,
        23.141489103239
    ],
    [
        113.15810952899,
        23.141470533298
    ],
    [
        113.1581124929,
        23.141413315059
    ],
    [
        113.15811193527,
        23.141353628894
    ],
    [
        113.15809537143,
        23.141193177179
    ],
    [
        113.15809807361,
        23.141168510902
    ],
    [
        113.15808882024,
        23.140991566192
    ],
    [
        113.15808713268,
        23.140731124429
    ],
    [
        113.15808385842,
        23.140626657078
    ],
    [
        113.15807517863,
        23.140570979411
    ],
    [
        113.15806079182,
        23.140427092925
    ],
    [
        113.15805805613,
        23.140299842481
    ],
    [
        113.15802956982,
        23.140068769212
    ],
    [
        113.15800485541,
        23.139712394379
    ],
    [
        113.15799644892,
        23.139654819799
    ],
    [
        113.15793625454,
        23.139251786717
    ],
    [
        113.15785603089,
        23.138876267857
    ],
    [
        113.15783570677,
        23.138792286968
    ],
    [
        113.15777391779,
        23.13848174119
    ],
    [
        113.15774302393,
        23.138311954372
    ],
    [
        113.15773353979,
        23.138264407451
    ],
    [
        113.15773624902,
        23.138273109373
    ],
    [
        113.15770428114,
        23.138178456029
    ],
    [
        113.15769614312,
        23.138040314448
    ],
    [
        113.15765224707,
        23.137785787116
    ],
    [
        113.1584100696,
        23.137638798281
    ],
    [
        113.15882369291,
        23.137578788383
    ],
    [
        113.15908212083,
        23.13753415383
    ],
    [
        113.15948007909,
        23.137452917054
    ],
    [
        113.15993279433,
        23.13735125141
    ],
    [
        113.16001380521,
        23.137341691713
    ],
    [
        113.16022704067,
        23.137325287809
    ],
    [
        113.16139036143,
        23.13720432405
    ],
    [
        113.16361309866,
        23.136848864833
    ],
    [
        113.1637229042,
        23.136824730545
    ],
    [
        113.1649463805,
        23.136848796433
    ],
    [
        113.16506868876,
        23.136820744529
    ],
    [
        113.16532904416,
        23.136763258712
    ],
    [
        113.16615087817,
        23.136699483815
    ],
    [
        113.16643271848,
        23.136694361845
    ],
    [
        113.16657866291,
        23.136692179282
    ],
    [
        113.16662206729,
        23.136694341913
    ],
    [
        113.16675309631,
        23.136694037319
    ],
    [
        113.16690501839,
        23.136710797325
    ],
    [
        113.16695792074,
        23.136709686794
    ],
    [
        113.16703958149,
        23.136717780441
    ],
    [
        113.16790618694,
        23.136841439706
    ],
    [
        113.16817699665,
        23.136881178035
    ],
    [
        113.16826600329,
        23.136894049536
    ],
    [
        113.16834008617,
        23.13690449908
    ],
    [
        113.16843777973,
        23.136926835287
    ],
    [
        113.16844185047,
        23.136932253014
    ],
    [
        113.16846464576,
        23.136932209863
    ],
    [
        113.16846763084,
        23.136931390369
    ],
    [
        113.16852163455,
        23.136936440188
    ],
    [
        113.16870536016,
        23.13696400592
    ],
    [
        113.16885652457,
        23.136981577797
    ],
    [
        113.16885598162,
        23.136976153641
    ],
    [
        113.16921694822,
        23.137018679218
    ],
    [
        113.16951523887,
        23.137044990611
    ],
    [
        113.16953722464,
        23.137049267581
    ],
    [
        113.17121818517,
        23.137387361735
    ],
    [
        113.17141883916,
        23.137429589148
    ],
    [
        113.17143594534,
        23.137433308146
    ],
    [
        113.17226225852,
        23.137507045808
    ],
    [
        113.17227556488,
        23.137501820398
    ],
    [
        113.17242818787,
        23.137521879701
    ],
    [
        113.17249037843,
        23.13752289254
    ],
    [
        113.17273127221,
        23.137536720985
    ],
    [
        113.17308706494,
        23.137563912491
    ],
    [
        113.1732508452,
        23.137566432556
    ],
    [
        113.17382831317,
        23.137395595661
    ],
    [
        113.17410185718,
        23.137311531806
    ],
    [
        113.17523801509,
        23.137128935609
    ],
    [
        113.17523488273,
        23.138669786755
    ],
    [
        113.17523841414,
        23.138663519528
    ],
    [
        113.17523434094,
        23.138682812219
    ],
    [
        113.1752454807,
        23.138681096495
    ],
    [
        113.17568458264,
        23.138735324632
    ],
    [
        113.17597262523,
        23.138771700067
    ],
    [
        113.17602316527,
        23.138741700065
    ],
    [
        113.17603974053,
        23.138733420004
    ],
    [
        113.17603892482,
        23.13872962914
    ],
    [
        113.1761245137,
        23.138642899283
    ],
    [
        113.17620277843,
        23.138651173348
    ],
    [
        113.17625305704,
        23.138687357264
    ],
    [
        113.17631556579,
        23.138728585994
    ],
    [
        113.17633567839,
        23.138749026028
    ],
    [
        113.17655473025,
        23.138840126145
    ],
    [
        113.17662811243,
        23.138875544855
    ],
    [
        113.17667024018,
        23.138899578284
    ],
    [
        113.17686348358,
        23.138976480822
    ],
    [
        113.17699775114,
        23.139023251245
    ],
    [
        113.17703525847,
        23.139028326328
    ],
    [
        113.17712467257,
        23.138995475924
    ],
    [
        113.17723040581,
        23.139032995853
    ],
    [
        113.17731575628,
        23.139073143925
    ],
    [
        113.17734727914,
        23.139031878968
    ],
    [
        113.17734972401,
        23.139022632112
    ],
    [
        113.17741846348,
        23.138830992136
    ],
    [
        113.17742417093,
        23.138827681703
    ],
    [
        113.17748259376,
        23.138709653819
    ],
    [
        113.17763124085,
        23.138434215165
    ],
    [
        113.17764238355,
        23.138419456879
    ],
    [
        113.17776141607,
        23.138202618737
    ],
    [
        113.17777174571,
        23.138207670399
    ],
    [
        113.17786335218,
        23.138233613608
    ],
    [
        113.1780481971,
        23.138256438017
    ],
    [
        113.17816264059,
        23.13827100637
    ],
    [
        113.17846031163,
        23.138306178163
    ],
    [
        113.17892655455,
        23.138362803764
    ],
    [
        113.17892274882,
        23.138366642682
    ],
    [
        113.17892247585,
        23.138356608495
    ],
    [
        113.17898174453,
        23.138368174814
    ],
    [
        113.17907798839,
        23.138378793216
    ],
    [
        113.17919843157,
        23.138396192132
    ],
    [
        113.17947847655,
        23.138431334372
    ],
    [
        113.17963318562,
        23.138447497645
    ],
    [
        113.17969952957,
        23.138455697947
    ],
    [
        113.17972862753,
        23.13849605839
    ],
    [
        113.17977077714,
        23.138537897104
    ],
    [
        113.17978654897,
        23.138550467037
    ],
    [
        113.17978165578,
        23.138559203675
    ],
    [
        113.1798151116,
        23.138654310143
    ],
    [
        113.17981320955,
        23.138664369064
    ],
    [
        113.17981593051,
        23.138679529341
    ],
    [
        113.17981837854,
        23.138686554488
    ],
    [
        113.17982518028,
        23.138718758391
    ],
    [
        113.17982817094,
        23.138716553964
    ],
    [
        113.17985891038,
        23.13882389805
    ],
    [
        113.17986516563,
        23.138834406045
    ],
    [
        113.17989128355,
        23.138942073861
    ],
    [
        113.1798923719,
        23.138947215594
    ],
    [
        113.17990326076,
        23.139034441266
    ],
    [
        113.17990951564,
        23.139041422506
    ],
    [
        113.17992530659,
        23.139176336351
    ],
    [
        113.17992394777,
        23.139180963697
    ],
    [
        113.17993265777,
        23.139238374024
    ],
    [
        113.17993510674,
        23.139249739432
    ],
    [
        113.17994409397,
        23.139338614664
    ],
    [
        113.17994191942,
        23.13934298016
    ],
    [
        113.17995117268,
        23.139393873568
    ],
    [
        113.17994519254,
        23.139405064884
    ],
    [
        113.17996915523,
        23.13960716145
    ],
    [
        113.17999824933,
        23.139605468877
    ],
    [
        113.18000368807,
        23.139608390022
    ],
    [
        113.18016085565,
        23.139615243998
    ],
    [
        113.1804738421,
        23.1396310868
    ],
    [
        113.18068540835,
        23.139643203958
    ],
    [
        113.18087604009,
        23.139649848788
    ],
    [
        113.18091683257,
        23.139653692317
    ],
    [
        113.18092879778,
        23.139651376125
    ],
    [
        113.18093233289,
        23.139650247869
    ],
    [
        113.18097856517,
        23.139657007361
    ],
    [
        113.18110611024,
        23.139658153985
    ],
    [
        113.1811164438,
        23.139654500008
    ],
    [
        113.18115968447,
        23.13965423757
    ],
    [
        113.18122386746,
        23.139661581423
    ],
    [
        113.18123012198,
        23.139658791076
    ],
    [
        113.1813163333,
        23.139660160777
    ],
    [
        113.18131279914,
        23.139667529318
    ],
    [
        113.1813128301,
        23.139834365118
    ],
    [
        113.18131799827,
        23.139839183738
    ],
    [
        113.18134172633,
        23.14017771552
    ],
    [
        113.18134199931,
        23.140182595149
    ],
    [
        113.18136738999,
        23.140628805635
    ],
    [
        113.18155803513,
        23.140614746751
    ],
    [
        113.18155450173,
        23.14062428617
    ],
    [
        113.18155559219,
        23.140635394937
    ],
    [
        113.18155260192,
        23.140641400846
    ],
    [
        113.18155457365,
        23.14092459392
    ],
    [
        113.18154832093,
        23.140934981508
    ],
    [
        113.1815494117,
        23.140946632879
    ],
    [
        113.18155294763,
        23.140947944688
    ],
    [
        113.1815483683,
        23.141122436989
    ],
    [
        113.18155353788,
        23.141130781543
    ],
    [
        113.18156361304,
        23.14117812888
    ],
    [
        113.18156579049,
        23.141184612182
    ],
    [
        113.18155763071,
        23.141182002336
    ],
    [
        113.1812209414,
        23.141188926512
    ],
    [
        113.18121662507,
        23.141321366111
    ],
    [
        113.18122375564,
        23.141539660941
    ],
    [
        113.18122705295,
        23.141659527593
    ],
    [
        113.18123282796,
        23.141879196443
    ],
    [
        113.18123885467,
        23.14202453048
    ],
    [
        113.18130223342,
        23.142064435481
    ],
    [
        113.18132154641,
        23.142076674024
    ],
    [
        113.18151600214,
        23.142079121148
    ],
    [
        113.18172949716,
        23.142068279739
    ],
    [
        113.18191498334,
        23.14205559883
    ],
    [
        113.18222287413,
        23.142055682459
    ],
    [
        113.18298557747,
        23.142043114468
    ],
    [
        113.1832086333,
        23.142031947924
    ],
    [
        113.18341456247,
        23.142038621377
    ],
    [
        113.18341700976,
        23.14203533227
    ],
    [
        113.18340951782,
        23.141534101086
    ],
    [
        113.18339392887,
        23.141229392789
    ],
    [
        113.18339881515,
        23.141190260841
    ],
    [
        113.18339745349,
        23.141184582624
    ],
    [
        113.18340203872,
        23.141032329961
    ],
    [
        113.18344637686,
        23.141018969261
    ],
    [
        113.18358647177,
        23.141002655052
    ],
    [
        113.1836286341,
        23.140987420866
    ],
    [
        113.18380651886,
        23.14086042327
    ],
    [
        113.18387371324,
        23.140855141626
    ],
    [
        113.18395641391,
        23.140845298791
    ],
    [
        113.18398960168,
        23.140835065325
    ],
    [
        113.1841278161,
        23.140879501735
    ],
    [
        113.18432616599,
        23.140954267495
    ],
    [
        113.18461811686,
        23.141045567716
    ],
    [
        113.18506218979,
        23.141206487011
    ],
    [
        113.18531362171,
        23.141291220963
    ],
    [
        113.18531743113,
        23.141291707157
    ],
    [
        113.1855408436,
        23.141374927647
    ],
    [
        113.18587909803,
        23.141486236184
    ],
    [
        113.18656083975,
        23.141798946244
    ],
    [
        113.1865616604,
        23.141813311718
    ],
    [
        113.18654180564,
        23.1418480706
    ],
    [
        113.18644878412,
        23.141995723117
    ],
    [
        113.18645313789,
        23.141995113722
    ],
    [
        113.18638785733,
        23.142087809379
    ],
    [
        113.1862314702,
        23.142343309602
    ],
    [
        113.18609794168,
        23.142585430288
    ],
    [
        113.18604056043,
        23.142687219719
    ],
    [
        113.18587141216,
        23.142984937965
    ],
    [
        113.18580859978,
        23.143107963821
    ],
    [
        113.18579962389,
        23.143117865235
    ],
    [
        113.18546843046,
        23.143714773661
    ],
    [
        113.18496029725,
        23.144680199173
    ],
    [
        113.18495486651,
        23.14470496625
    ],
    [
        113.18483823794,
        23.144915563174
    ],
    [
        113.18431287164,
        23.146059592012
    ],
    [
        113.18416341001,
        23.146394872147
    ],
    [
        113.18415552038,
        23.146394984051
    ],
    [
        113.18414329552,
        23.146429069667
    ],
    [
        113.18405144994,
        23.146637098774
    ],
    [
        113.18397372683,
        23.146794734414
    ],
    [
        113.18397264462,
        23.146805872925
    ],
    [
        113.18388351148,
        23.146989438979
    ],
    [
        113.18368079199,
        23.147398136712
    ],
    [
        113.18353649161,
        23.147666827671
    ],
    [
        113.18324109982,
        23.148192330825
    ],
    [
        113.18311365431,
        23.148415992784
    ],
    [
        113.18295714768,
        23.14870569343
    ],
    [
        113.18294708776,
        23.148713425623
    ],
    [
        113.18267104043,
        23.149219038736
    ],
    [
        113.18229658251,
        23.149774462248
    ],
    [
        113.18192655202,
        23.150395671876
    ],
    [
        113.18170352382,
        23.150779439673
    ],
    [
        113.18135707709,
        23.151594206574
    ],
    [
        113.18111903848,
        23.152222803736
    ],
    [
        113.181116054,
        23.152232065134
    ],
    [
        113.18106474231,
        23.152347190411
    ],
    [
        113.18105878013,
        23.152374394916
    ],
    [
        113.18105904813,
        23.152369236687
    ],
    [
        113.18093854539,
        23.152685435148
    ],
    [
        113.18088996764,
        23.152815172356
    ],
    [
        113.18062676857,
        23.153552799949
    ],
    [
        113.180490594,
        23.153967368602
    ],
    [
        113.18030669462,
        23.154533069007
    ],
    [
        113.18011515505,
        23.155050542496
    ],
    [
        113.18004143243,
        23.1553292281
    ],
    [
        113.1800414378,
        23.15533546835
    ],
    [
        113.18000257956,
        23.155679135689
    ],
    [
        113.17999780965,
        23.155821904417
    ],
    [
        113.18000890133,
        23.156067048476
    ],
    [
        113.18005015599,
        23.156593473277
    ],
    [
        113.18006579594,
        23.156750386174
    ],
    [
        113.18006853459,
        23.156772060005
    ],
    [
        113.1800775671,
        23.15683788596
    ],
    [
        113.1800836077,
        23.156902661364
    ],
    [
        113.18009760246,
        23.157043042741
    ],
    [
        113.18011941792,
        23.157111433048
    ],
    [
        113.18012325111,
        23.157140419735
    ],
    [
        113.18014949143,
        23.15728988305
    ],
    [
        113.1801587916,
        23.157350007818
    ],
    [
        113.18015500759,
        23.157375013515
    ],
    [
        113.18017579409,
        23.157506632954
    ],
    [
        113.18018213495,
        23.157600978708
    ],
    [
        113.18022044268,
        23.157859642686
    ],
    [
        113.18024474742,
        23.157971413749
    ],
    [
        113.18025293351,
        23.158001977092
    ],
    [
        113.18027833324,
        23.15812106052
    ],
    [
        113.18028161273,
        23.158138657915
    ],
    [
        113.18029336865,
        23.158206350237
    ],
    [
        113.18029392035,
        23.158214754738
    ],
    [
        113.18031873833,
        23.15829260342
    ],
    [
        113.1803154811,
        23.158298882203
    ],
    [
        113.18031902955,
        23.158313220492
    ],
    [
        113.18034712411,
        23.158405138894
    ],
    [
        113.18034278835,
        23.15842119808
    ],
    [
        113.18034850206,
        23.158424657858
    ],
    [
        113.18034932751,
        23.158434958374
    ],
    [
        113.18034634323,
        23.1584423193
    ],
    [
        113.18035341606,
        23.158445220376
    ],
    [
        113.18037604622,
        23.158509256534
    ],
    [
        113.18037823106,
        23.158519269647
    ],
    [
        113.18039735219,
        23.158610750575
    ],
    [
        113.18039735398,
        23.158612649814
    ],
    [
        113.18040497635,
        23.158621513241
    ],
    [
        113.18042242878,
        23.158673400494
    ],
    [
        113.18042516111,
        23.158687205577
    ],
    [
        113.18042898551,
        23.158705610198
    ],
    [
        113.18044069607,
        23.158724192593
    ],
    [
        113.18044587116,
        23.158733084844
    ],
    [
        113.18047585358,
        23.158807071221
    ],
    [
        113.18047858289,
        23.158817620371
    ],
    [
        113.18050474261,
        23.158874829597
    ],
    [
        113.18052217522,
        23.158905281424
    ],
    [
        113.18052572062,
        23.158916092087
    ],
    [
        113.18054752972,
        23.158973352437
    ],
    [
        113.18055461129,
        23.158985206111
    ],
    [
        113.1805562421,
        23.158984372665
    ],
    [
        113.18056634202,
        23.159024679179
    ],
    [
        113.1805919618,
        23.15908542056
    ],
    [
        113.18060448004,
        23.159095038338
    ],
    [
        113.18062384761,
        23.159158024633
    ],
    [
        113.18063119812,
        23.159166618841
    ],
    [
        113.18065709905,
        23.159236580757
    ],
    [
        113.18065709879,
        23.159236309436
    ],
    [
        113.1806630946,
        23.159250074908
    ],
    [
        113.18066799489,
        23.159255713816
    ],
    [
        113.18068816125,
        23.159300511023
    ],
    [
        113.18069116761,
        23.159316211619
    ],
    [
        113.18071488253,
        23.159374803275
    ],
    [
        113.18071870162,
        23.15938723814
    ],
    [
        113.18075030555,
        23.159448447375
    ],
    [
        113.18075984165,
        23.159467324868
    ],
    [
        113.180768588,
        23.15951334424
    ],
    [
        113.18077484914,
        23.159520051646
    ],
    [
        113.18078792496,
        23.159543498668
    ],
    [
        113.18078956886,
        23.159556231003
    ],
    [
        113.18081519658,
        23.159623751659
    ],
    [
        113.18082500059,
        23.159638284317
    ],
    [
        113.18085773046,
        23.159738277033
    ],
    [
        113.18085910431,
        23.159752911851
    ],
    [
        113.18086619447,
        23.159773175019
    ],
    [
        113.18088609512,
        23.15982339935
    ],
    [
        113.18089263935,
        23.159841498445
    ],
    [
        113.18091118276,
        23.159894180893
    ],
    [
        113.18092370775,
        23.159910036387
    ],
    [
        113.18094607249,
        23.15997705202
    ],
    [
        113.18094663215,
        23.159993324656
    ],
    [
        113.18096489495,
        23.160036784861
    ],
    [
        113.18097252895,
        23.160056769578
    ],
    [
        113.18100523438,
        23.160130169717
    ],
    [
        113.18101069393,
        23.160151266172
    ],
    [
        113.18102269715,
        23.160189647194
    ],
    [
        113.18103304416,
        23.160202815241
    ],
    [
        113.18102733982,
        23.160209668307
    ],
    [
        113.18105817613,
        23.160318091151
    ],
    [
        113.18106035941,
        23.160325932757
    ],
    [
        113.18107344877,
        23.160362400784
    ],
    [
        113.18107208796,
        23.16036133221
    ],
    [
        113.18107264589,
        23.160375705571
    ],
    [
        113.18109582561,
        23.160440809803
    ],
    [
        113.18109747296,
        23.160456797701
    ],
    [
        113.18111085989,
        23.16051930896
    ],
    [
        113.18111739737,
        23.160530081432
    ],
    [
        113.18113215108,
        23.160599630131
    ],
    [
        113.18112997758,
        23.16060182753
    ],
    [
        113.18113325643,
        23.160617523959
    ],
    [
        113.18114032537,
        23.160615537501
    ],
    [
        113.18114524393,
        23.160639353431
    ],
    [
        113.18114307813,
        23.160649419183
    ],
    [
        113.18115042089,
        23.160649328576
    ],
    [
        113.18116382035,
        23.160724320214
    ],
    [
        113.18117035312,
        23.160730208669
    ],
    [
        113.18118047192,
        23.160787604567
    ],
    [
        113.18118673063,
        23.160791325738
    ],
    [
        113.18119956613,
        23.160845703346
    ],
    [
        113.18120038787,
        23.160851662334
    ],
    [
        113.18121675327,
        23.160900298287
    ],
    [
        113.18122628591,
        23.160914560433
    ],
    [
        113.18124265195,
        23.16096373876
    ],
    [
        113.18123912132,
        23.160968666404
    ],
    [
        113.18125576447,
        23.161022996348
    ],
    [
        113.18126665644,
        23.161036698723
    ],
    [
        113.18127649029,
        23.161080531303
    ],
    [
        113.18128193803,
        23.161089146022
    ],
    [
        113.18129257282,
        23.161117774317
    ],
    [
        113.18129530045,
        23.161125880163
    ],
    [
        113.1813034879,
        23.161154810148
    ],
    [
        113.18130431477,
        23.16116592421
    ],
    [
        113.18131603263,
        23.16118965501
    ],
    [
        113.18131576684,
        23.161195898809
    ],
    [
        113.18132095929,
        23.161221338762
    ],
    [
        113.18131769603,
        23.161221650726
    ],
    [
        113.18132941582,
        23.161247280683
    ],
    [
        113.18140142149,
        23.161456116636
    ],
    [
        113.18161598458,
        23.161980876044
    ],
    [
        113.18218982461,
        23.163285650043
    ],
    [
        113.18239507052,
        23.163710849543
    ],
    [
        113.18247436277,
        23.163847911445
    ],
    [
        113.18256781231,
        23.163996720462
    ],
    [
        113.18263619699,
        23.164105158259
    ],
    [
        113.18270816265,
        23.164256957917
    ],
    [
        113.18276023465,
        23.164372119845
    ],
    [
        113.18278945633,
        23.164485958088
    ],
    [
        113.1828655551,
        23.164687891308
    ],
    [
        113.18290268574,
        23.164821157003
    ],
    [
        113.18290761333,
        23.164851750777
    ],
    [
        113.18293494192,
        23.164975651123
    ],
    [
        113.18295570812,
        23.165066266174
    ],
    [
        113.18296037319,
        23.16510608849
    ],
    [
        113.18296759432,
        23.1652514229
    ],
    [
        113.18299356345,
        23.165375611993
    ],
    [
        113.18302361744,
        23.165504086719
    ],
    [
        113.18306236236,
        23.16561887683
    ],
    [
        113.18308200151,
        23.165670977043
    ],
    [
        113.18309946176,
        23.165720393307
    ],
    [
        113.18310383383,
        23.165739598283
    ],
    [
        113.18314498769,
        23.16581555391
    ],
    [
        113.18314390487,
        23.165820723861
    ],
    [
        113.18316871658,
        23.16587655135
    ],
    [
        113.18320304706,
        23.165930078168
    ],
    [
        113.18322456548,
        23.165957460267
    ],
    [
        113.18329810746,
        23.166048707148
    ],
    [
        113.18338360589,
        23.16612649163
    ],
    [
        113.1834729009,
        23.166191738428
    ],
    [
        113.18362042952,
        23.166272182245
    ],
    [
        113.18363132084,
        23.166281527635
    ],
    [
        113.18373775552,
        23.166344894915
    ],
    [
        113.18385860973,
        23.166407782515
    ],
    [
        113.18392802509,
        23.166448864814
    ],
    [
        113.18395280357,
        23.166469951559
    ],
    [
        113.18403938622,
        23.166537378247
    ],
    [
        113.18412324362,
        23.166599412762
    ],
    [
        113.18421229369,
        23.166683618545
    ],
    [
        113.18427196657,
        23.166772579661
    ],
    [
        113.18429570913,
        23.16684387216
    ],
    [
        113.18431756842,
        23.166935812154
    ],
    [
        113.1843247475,
        23.167038814485
    ],
    [
        113.18430937958,
        23.167175511731
    ],
    [
        113.18431047032,
        23.167177938135
    ],
    [
        113.18427544242,
        23.16751108552
    ],
    [
        113.18427446059,
        23.167615289497
    ],
    [
        113.18430853854,
        23.167683721348
    ],
    [
        113.18434422432,
        23.167727981409
    ],
    [
        113.18437148957,
        23.167785384871
    ],
    [
        113.18449226614,
        23.168030563529
    ],
    [
        113.18474441446,
        23.168501479329
    ],
    [
        113.18488422831,
        23.168734418106
    ],
    [
        113.18492704052,
        23.16882821617
    ],
    [
        113.18498535407,
        23.168914460888
    ],
    [
        113.18506253673,
        23.169094306734
    ],
    [
        113.18510616767,
        23.169189988051
    ],
    [
        113.18517619333,
        23.169287450747
    ],
    [
        113.18526993638,
        23.169429329939
    ],
    [
        113.18527238683,
        23.169430921725
    ],
    [
        113.18553454548,
        23.169828869474
    ],
    [
        113.18562693839,
        23.169978348923
    ],
    [
        113.18570354348,
        23.170121548827
    ],
    [
        113.18573734044,
        23.170177206955
    ],
    [
        113.18576104954,
        23.170212937744
    ],
    [
        113.18576269493,
        23.170225665423
    ],
    [
        113.18581696825,
        23.170349389187
    ],
    [
        113.18587750609,
        23.170478986301
    ],
    [
        113.18590069555,
        23.170539142707
    ],
    [
        113.18591354953,
        23.170604067322
    ],
    [
        113.18594246108,
        23.170672005401
    ],
    [
        113.18599587438,
        23.170751511044
    ],
    [
        113.1860601869,
        23.170845501805
    ],
    [
        113.18611032909,
        23.170918813538
    ],
    [
        113.18672830235,
        23.171723052593
    ],
    [
        113.18693212725,
        23.171996372505
    ],
    [
        113.18716675547,
        23.172319658299
    ],
    [
        113.18749532122,
        23.172687020563
    ],
    [
        113.18772004278,
        23.172888853338
    ],
    [
        113.18796572966,
        23.173096299394
    ],
    [
        113.18856309244,
        23.173617932585
    ],
    [
        113.18866929089,
        23.173670473025
    ],
    [
        113.18882615044,
        23.173759897342
    ],
    [
        113.18882560737,
        23.173761262822
    ],
    [
        113.188828059,
        23.173763393418
    ],
    [
        113.18897783102,
        23.173839629889
    ],
    [
        113.18920630063,
        23.173952007796
    ],
    [
        113.1894143201,
        23.174022650442
    ],
    [
        113.1895885874,
        23.174090311064
    ],
    [
        113.18968307174,
        23.17412482956
    ],
    [
        113.1898396366,
        23.174179203717
    ],
    [
        113.19001172461,
        23.174240093903
    ],
    [
        113.19012036251,
        23.174270835688
    ],
    [
        113.19020423051,
        23.174301718
    ],
    [
        113.19025815837,
        23.174335000099
    ],
    [
        113.19027831476,
        23.174349041889
    ],
    [
        113.19031235177,
        23.174360951142
    ],
    [
        113.19037827106,
        23.174409223968
    ],
    [
        113.19044774408,
        23.174473443755
    ],
    [
        113.19062809516,
        23.174632382221
    ],
    [
        113.19068285352,
        23.174679481142
    ],
    [
        113.190910897,
        23.174895933219
    ],
    [
        113.19122837973,
        23.175276082729
    ],
    [
        113.19148327528,
        23.175681967805
    ],
    [
        113.19193990733,
        23.177039686077
    ],
    [
        113.1923408827,
        23.178638425293
    ],
    [
        113.19308593472,
        23.178556299838
    ],
    [
        113.19346704344,
        23.17851491594
    ],
    [
        113.19347112929,
        23.178517557634
    ],
    [
        113.19353156427,
        23.178512973078
    ],
    [
        113.19353074577,
        23.17851081687
    ],
    [
        113.19345112958,
        23.178033606619
    ],
    [
        113.19341358786,
        23.177741239964
    ],
    [
        113.19334842905,
        23.177310440015
    ],
    [
        113.19334235519,
        23.177211514759
    ],
    [
        113.19339544042,
        23.177208416394
    ],
    [
        113.19340223996,
        23.177200700591
    ],
    [
        113.19343273361,
        23.177203151917
    ],
    [
        113.19349588569,
        23.177192551099
    ],
    [
        113.19354815327,
        23.177188109254
    ],
    [
        113.19357102192,
        23.177187980242
    ],
    [
        113.19371799655,
        23.177142265889
    ],
    [
        113.19372915555,
        23.177138543143
    ],
    [
        113.19374166041,
        23.177116889725
    ],
    [
        113.19379825841,
        23.177082253736
    ],
    [
        113.19384506776,
        23.177061897664
    ],
    [
        113.19388834241,
        23.177046758408
    ],
    [
        113.19390058482,
        23.177036504735
    ],
    [
        113.19396751501,
        23.176986220955
    ],
    [
        113.19399091157,
        23.176966546414
    ],
    [
        113.19401132278,
        23.176957777019
    ],
    [
        113.19405402988,
        23.176915786213
    ],
    [
        113.19407878183,
        23.176889304615
    ],
    [
        113.19411877537,
        23.176857671294
    ],
    [
        113.19413700465,
        23.176844327511
    ],
    [
        113.19417972891,
        23.176822142085
    ],
    [
        113.19422463047,
        23.176799104196
    ],
    [
        113.19424804072,
        23.17679516524
    ],
    [
        113.19426328166,
        23.176789199397
    ],
    [
        113.19426654534,
        23.176785343501
    ],
    [
        113.1942975835,
        23.176786967925
    ],
    [
        113.19436918104,
        23.176781366624
    ],
    [
        113.19437843326,
        23.176776319982
    ],
    [
        113.19440048445,
        23.176774846452
    ],
    [
        113.19439939617,
        23.176775679574
    ],
    [
        113.19448297729,
        23.176775021505
    ],
    [
        113.19457472888,
        23.176777474591
    ],
    [
        113.19458588546,
        23.176770766278
    ],
    [
        113.19463380096,
        23.17676937898
    ],
    [
        113.19465476304,
        23.176767652795
    ],
    [
        113.19486057245,
        23.176750184802
    ],
    [
        113.19496919151,
        23.176737685797
    ],
    [
        113.19524278547,
        23.176710603867
    ],
    [
        113.19544422686,
        23.176677468066
    ],
    [
        113.19561817646,
        23.176651057039
    ],
    [
        113.19568105856,
        23.176640176676
    ],
    [
        113.19595161659,
        23.176563758382
    ],
    [
        113.19596387751,
        23.176574394069
    ],
    [
        113.19597258491,
        23.176568813476
    ],
    [
        113.19606458603,
        23.176543308023
    ],
    [
        113.19618483944,
        23.177074049922
    ],
    [
        113.19677776486,
        23.177010910525
    ],
    [
        113.19699691456,
        23.176989393191
    ],
    [
        113.19723239669,
        23.176964603311
    ],
    [
        113.19728335089,
        23.177013352741
    ],
    [
        113.19733940894,
        23.177299958637
    ],
    [
        113.19738941608,
        23.177516942391
    ],
    [
        113.19750921084,
        23.177518621138
    ],
    [
        113.1975143832,
        23.177517986994
    ],
    [
        113.19750680497,
        23.17757129945
    ],
    [
        113.19749566475,
        23.177597814411
    ],
    [
        113.19745910548,
        23.177830980767
    ],
    [
        113.19731466605,
        23.178651014982
    ],
    [
        113.19730759315,
        23.178658194395
    ],
    [
        113.19730814709,
        23.178669851185
    ],
    [
        113.19725849549,
        23.178883170454
    ],
    [
        113.19725877405,
        23.178891033678
    ],
    [
        113.19738702386,
        23.178911554196
    ],
    [
        113.19738538882,
        23.178909683922
    ],
    [
        113.19788940934,
        23.179001157158
    ],
    [
        113.19814564527,
        23.179055778443
    ],
    [
        113.1981960253,
        23.179071982106
    ],
    [
        113.19826196571,
        23.179141089215
    ],
    [
        113.19825978921,
        23.17914302682
    ],
    [
        113.19829386216,
        23.179195060858
    ],
    [
        113.19830856732,
        23.179199413827
    ],
    [
        113.19847281384,
        23.179297718416
    ],
    [
        113.19851835656,
        23.1793951318
    ],
    [
        113.19862975648,
        23.179457199827
    ],
    [
        113.19866053816,
        23.179479176955
    ],
    [
        113.19928881995,
        23.179737552979
    ],
    [
        113.19939145618,
        23.179736025636
    ],
    [
        113.19946199187,
        23.179766805391
    ],
    [
        113.19969377796,
        23.179903562964
    ],
    [
        113.1998691747,
        23.179997359338
    ],
    [
        113.19988469381,
        23.179998987795
    ],
    [
        113.19989095862,
        23.180003219526
    ],
    [
        113.19989422446,
        23.180001805995
    ],
    [
        113.1999018449,
        23.179998688634
    ],
    [
        113.19990048205,
        23.179996541899
    ],
    [
        113.19994320047,
        23.179965409888
    ],
    [
        113.20001255112,
        23.179872225948
    ],
    [
        113.20003186529,
        23.179852626208
    ],
    [
        113.20003404112,
        23.17984987517
    ],
    [
        113.20008245452,
        23.179790428295
    ],
    [
        113.20028180237,
        23.179525956838
    ],
    [
        113.20044796344,
        23.179299780297
    ],
    [
        113.20045639587,
        23.179290951966
    ],
    [
        113.20051894321,
        23.179205488605
    ],
    [
        113.20052248694,
        23.179211396111
    ],
    [
        113.20056627085,
        23.17915284737
    ],
    [
        113.20068130589,
        23.179000547299
    ],
    [
        113.20072237025,
        23.178946387904
    ],
    [
        113.20074712097,
        23.178918014476
    ],
    [
        113.20081456034,
        23.178824601795
    ],
    [
        113.20083169604,
        23.178805856363
    ],
    [
        113.20092333696,
        23.178679469305
    ],
    [
        113.20094590239,
        23.178642452425
    ],
    [
        113.20096005038,
        23.178632441067
    ],
    [
        113.20106527014,
        23.178467295565
    ],
    [
        113.20123661995,
        23.178277410908
    ],
    [
        113.20124260311,
        23.178270253869
    ],
    [
        113.20126980934,
        23.178249980379
    ],
    [
        113.20129047591,
        23.178222222474
    ],
    [
        113.2013010804,
        23.178207117974
    ],
    [
        113.20131113664,
        23.178187410523
    ],
    [
        113.20140928669,
        23.178037045052
    ],
    [
        113.2014612241,
        23.177967240405
    ],
    [
        113.2014595883,
        23.177964283939
    ],
    [
        113.20146501946,
        23.177948183178
    ],
    [
        113.2014827024,
        23.177934043113
    ],
    [
        113.20148568963,
        23.177925309799
    ],
    [
        113.20156154814,
        23.177814399108
    ],
    [
        113.20162191715,
        23.17773685521
    ],
    [
        113.20161891955,
        23.177733108002
    ],
    [
        113.20186580458,
        23.177385406726
    ],
    [
        113.20197783717,
        23.177241871915
    ],
    [
        113.20199741491,
        23.177216035123
    ],
    [
        113.2020721802,
        23.177105152191
    ],
    [
        113.20211544142,
        23.177080270526
    ],
    [
        113.20220142095,
        23.177032688429
    ],
    [
        113.20220223177,
        23.177025891718
    ],
    [
        113.20222862556,
        23.177012963911
    ],
    [
        113.20223325594,
        23.177016141315
    ],
    [
        113.20223352466,
        23.17701206698
    ],
    [
        113.20225066277,
        23.176998753459
    ],
    [
        113.20226943785,
        23.176989753411
    ],
    [
        113.20225851773,
        23.176953038882
    ],
    [
        113.20223694044,
        23.176869023991
    ],
    [
        113.2021902624,
        23.176719503885
    ],
    [
        113.20218508215,
        23.176710095501
    ],
    [
        113.20217390335,
        23.176689393388
    ],
    [
        113.20211329939,
        23.176491815242
    ],
    [
        113.20182857883,
        23.176204716569
    ],
    [
        113.20164221689,
        23.176021499637
    ],
    [
        113.20162341594,
        23.176001743218
    ],
    [
        113.2015449522,
        23.175930642455
    ],
    [
        113.20154713359,
        23.175934674941
    ],
    [
        113.20223564518,
        23.175101120577
    ],
    [
        113.20239287282,
        23.174978265599
    ],
    [
        113.2026963563,
        23.17494439207
    ],
    [
        113.20318704909,
        23.174845560238
    ],
    [
        113.20373810975,
        23.174405570192
    ],
    [
        113.20410173791,
        23.174099789726
    ],
    [
        113.20424666069,
        23.173939785127
    ],
    [
        113.2043037642,
        23.173882148438
    ],
    [
        113.20430376446,
        23.173882419757
    ],
    [
        113.20430892762,
        23.173873653367
    ]
];

let lishui =
    [
        [
            113.20430729839,
            23.173877749737
        ],
        [
            113.20430567426,
            23.173887272495
        ],
        [
            113.20430403383,
            23.173879430814
        ],
        [
            113.20424857023,
            23.173944366505
        ],
        [
            113.20409765676,
            23.174101484395
        ],
        [
            113.20374028472,
            23.174402821128
        ],
        [
            113.20318105707,
            23.174841590215
        ],
        [
            113.20269227275,
            23.174943918054
        ],
        [
            113.20239342071,
            23.174982054855
        ],
        [
            113.20222856917,
            23.175102868349
        ],
        [
            113.20154522033,
            23.175926025413
        ],
        [
            113.20154794952,
            23.175933847017
        ],
        [
            113.20162151016,
            23.176001504472
        ],
        [
            113.20164847842,
            23.176021935287
        ],
        [
            113.20182830398,
            23.176201736729
        ],
        [
            113.20211248939,
            23.176499425942
        ],
        [
            113.20218234286,
            23.176690335609
        ],
        [
            113.20218617123,
            23.176710348362
        ],
        [
            113.20218862795,
            23.176718174988
        ],
        [
            113.20223041392,
            23.176876731461
        ],
        [
            113.20226314974,
            23.176958115529
        ],
        [
            113.20226589888,
            23.176989541996
        ],
        [
            113.20224767497,
            23.177006400978
        ],
        [
            113.20223379757,
            23.177012876315
        ],
        [
            113.20222944405,
            23.1770151206
        ],
        [
            113.20223026232,
            23.177017005973
        ],
        [
            113.20220413888,
            23.177027758635
        ],
        [
            113.20219815022,
            23.177027860112
        ],
        [
            113.20212142917,
            23.177079083656
        ],
        [
            113.20207054344,
            23.1771011102
        ],
        [
            113.20199387797,
            23.177218265797
        ],
        [
            113.2019721172,
            23.177237899402
        ],
        [
            113.2018658078,
            23.177389205127
        ],
        [
            113.20162164266,
            23.177734146726
        ],
        [
            113.20161592514,
            23.17773315919
        ],
        [
            113.20156181448,
            23.177807340296
        ],
        [
            113.20148650292,
            23.177921226111
        ],
        [
            113.20148541853,
            23.177926671028
        ],
        [
            113.2014658386,
            23.177951153636
        ],
        [
            113.20145441405,
            23.177961930732
        ],
        [
            113.2014595883,
            23.177964283939
        ],
        [
            113.20140874718,
            23.178043023278
        ],
        [
            113.20132011958,
            23.178186713694
        ],
        [
            113.20130080595,
            23.178204409518
        ],
        [
            113.20128884658,
            23.178227134153
        ],
        [
            113.20126382174,
            23.178251711125
        ],
        [
            113.20124641915,
            23.17827615727
        ],
        [
            113.20123607727,
            23.178279590766
        ],
        [
            113.20106826463,
            23.178467243997
        ],
        [
            113.2009537946,
            23.178639331842
        ],
        [
            113.20095189339,
            23.178644790948
        ],
        [
            113.20091435188,
            23.178677725107
        ],
        [
            113.20082924488,
            23.178804542117
        ],
        [
            113.20081374756,
            23.178829499516
        ],
        [
            113.20074793853,
            23.178919085604
        ],
        [
            113.20072291385,
            23.178945293242
        ],
        [
            113.2006845718,
            23.178999405536
        ],
        [
            113.20056817691,
            23.179153356981
        ],
        [
            113.20051921672,
            23.179207111754
        ],
        [
            113.20051785598,
            23.179207677968
        ],
        [
            113.2004599379,
            23.179294688939
        ],
        [
            113.20045748907,
            23.179296359299
        ],
        [
            113.2002815295,
            23.179525147637
        ],
        [
            113.20008000646,
            23.179793184056
        ],
        [
            113.2000362238,
            23.179856077361
        ],
        [
            113.20002397287,
            23.17985601946
        ],
        [
            113.20001064379,
            23.179870088672
        ],
        [
            113.19994129211,
            23.179961916087
        ],
        [
            113.19990810228,
            23.179993153236
        ],
        [
            113.19989993468,
            23.17999275306
        ],
        [
            113.1998969516,
            23.180007998631
        ],
        [
            113.19989531487,
            23.180003686168
        ],
        [
            113.19987679948,
            23.179999939449
        ],
        [
            113.19986154931,
            23.179993965308
        ],
        [
            113.19969649478,
            23.179896190029
        ],
        [
            113.19946008951,
            23.179771179717
        ],
        [
            113.19939281865,
            23.179737629652
        ],
        [
            113.19928364647,
            23.179736558424
        ],
        [
            113.1986638026,
            23.179475863711
        ],
        [
            113.1986297531,
            23.179452858856
        ],
        [
            113.1985202572,
            23.179388586761
        ],
        [
            113.19846546033,
            23.179294320923
        ],
        [
            113.19830911375,
            23.179201846023
        ],
        [
            113.1982995822,
            23.179198487054
        ],
        [
            113.19826006254,
            23.179144378574
        ],
        [
            113.19826223689,
            23.179139727856
        ],
        [
            113.19819602638,
            23.179073338664
        ],
        [
            113.19814727641,
            23.179052765182
        ],
        [
            113.19788913903,
            23.179003603773
        ],
        [
            113.19737912568,
            23.17890816687
        ],
        [
            113.19737994266,
            23.178908423727
        ],
        [
            113.1972653038,
            23.178885491774
        ],
        [
            113.19726694232,
            23.17889170303
        ],
        [
            113.19730243567,
            23.178677277815
        ],
        [
            113.19731521122,
            23.178651819281
        ],
        [
            113.19731574914,
            23.178643670275
        ],
        [
            113.19746047015,
            23.177835026387
        ],
        [
            113.1975011121,
            23.177600431217
        ],
        [
            113.19749944955,
            23.177566003218
        ],
        [
            113.19751574149,
            23.177514435826
        ],
        [
            113.19750921268,
            23.177520791653
        ],
        [
            113.19739023468,
            23.177519098451
        ],
        [
            113.19734239888,
            23.177294208024
        ],
        [
            113.19728416392,
            23.177008997241
        ],
        [
            113.19723021772,
            23.176963556608
        ],
        [
            113.19699963407,
            23.176985817878
        ],
        [
            113.19677885061,
            23.177007092822
        ],
        [
            113.19619000948,
            23.177070702516
        ],
        [
            113.19606703703,
            23.176544078575
        ],
        [
            113.19596660124,
            23.176575702438
        ],
        [
            113.19596496463,
            23.176572204258
        ],
        [
            113.1959456289,
            23.17656603497
        ],
        [
            113.19567724606,
            23.176639158872
        ],
        [
            113.19562116889,
            23.176648290885
        ],
        [
            113.19544287031,
            23.176682918458
        ],
        [
            113.19524224214,
            23.17671197007
        ],
        [
            113.19497355248,
            23.176743306506
        ],
        [
            113.19486139108,
            23.176752340911
        ],
        [
            113.19464931498,
            23.176764221698
        ],
        [
            113.19463570459,
            23.176766903541
        ],
        [
            113.19458561533,
            23.176773212917
        ],
        [
            113.19458044212,
            23.176772761459
        ],
        [
            113.1944816224,
            23.176782371005
        ],
        [
            113.19439994019,
            23.176775127355
        ],
        [
            113.194399671,
            23.176778659252
        ],
        [
            113.19437353655,
            23.176780747306
        ],
        [
            113.19436482459,
            23.176780900677
        ],
        [
            113.19428941229,
            23.176782770597
        ],
        [
            113.19426791152,
            23.176791017178
        ],
        [
            113.19426600296,
            23.176787794921
        ],
        [
            113.1942491243,
            23.176788905824
        ],
        [
            113.19421864103,
            23.176799209544
        ],
        [
            113.19417808978,
            23.176815659236
        ],
        [
            113.19414408284,
            23.176843931757
        ],
        [
            113.19411224848,
            23.176865925605
        ],
        [
            113.1940774213,
            23.176890142482
        ],
        [
            113.19405484616,
            23.176915229232
        ],
        [
            113.19400751063,
            23.17695703002
        ],
        [
            113.19399771842,
            23.176967240826
        ],
        [
            113.19396615167,
            23.17698380302
        ],
        [
            113.19389949374,
            23.177034082011
        ],
        [
            113.19388616561,
            23.177048153206
        ],
        [
            113.19384806176,
            23.177061031178
        ],
        [
            113.19379907211,
            23.177078712316
        ],
        [
            113.19374302186,
            23.177117137177
        ],
        [
            113.19372887818,
            23.177132578985
        ],
        [
            113.1937220737,
            23.177134597491
        ],
        [
            113.19357728536,
            23.177190041135
        ],
        [
            113.19355387223,
            23.177190179699
        ],
        [
            113.19348934978,
            23.177190223581
        ],
        [
            113.19343300121,
            23.177197720858
        ],
        [
            113.19340306063,
            23.177205298666
        ],
        [
            113.19340360164,
            23.177201219423
        ],
        [
            113.19333963463,
            23.177213732849
        ],
        [
            113.19334733985,
            23.17731018773
        ],
        [
            113.19340868637,
            23.177739969072
        ],
        [
            113.1934522208,
            23.178036300708
        ],
        [
            113.19352775044,
            23.178510055343
        ],
        [
            113.19353374509,
            23.178516462025
        ],
        [
            113.19346704919,
            23.178521970069
        ],
        [
            113.1934678637,
            23.178519242656
        ],
        [
            113.19308892846,
            23.178555162381
        ],
        [
            113.19234687025,
            23.178636422504
        ],
        [
            113.19193800292,
            23.177041075457
        ],
        [
            113.19147375388,
            23.175689185067
        ],
        [
            113.19122728766,
            23.175272574159
        ],
        [
            113.19091443527,
            23.174895330541
        ],
        [
            113.1906823106,
            23.174681118257
        ],
        [
            113.19063245351,
            23.174635564485
        ],
        [
            113.19044801502,
            23.174472082577
        ],
        [
            113.19037854553,
            23.174411661261
        ],
        [
            113.19031997347,
            23.174360823096
        ],
        [
            113.19028566222,
            23.174346747937
        ],
        [
            113.19026114729,
            23.174329252142
        ],
        [
            113.19020668058,
            23.174301948242
        ],
        [
            113.19012390517,
            23.174275117551
        ],
        [
            113.19001607573,
            23.174235680021
        ],
        [
            113.18983664625,
            23.174183323375
        ],
        [
            113.1896863312,
            23.174117449694
        ],
        [
            113.18958396245,
            23.174092829634
        ],
        [
            113.18940914955,
            23.174023821138
        ],
        [
            113.18920630063,
            23.173952007796
        ],
        [
            113.18897783127,
            23.173839901208
        ],
        [
            113.18883268677,
            23.173764131886
        ],
        [
            113.18882751132,
            23.17375987514
        ],
        [
            113.18882805798,
            23.173762308138
        ],
        [
            113.18867282247,
            23.173663361182
        ],
        [
            113.18856690104,
            23.173615971546
        ],
        [
            113.18797117516,
            23.173098654247
        ],
        [
            113.18771296629,
            23.172888423119
        ],
        [
            113.18749749945,
            23.172688071454
        ],
        [
            113.18716266731,
            23.172313481817
        ],
        [
            113.18693321711,
            23.171997712181
        ],
        [
            113.1867272149,
            23.171724154714
        ],
        [
            113.18611278269,
            23.17092338885
        ],
        [
            113.18606726423,
            23.170847836484
        ],
        [
            113.18599152387,
            23.170754832754
        ],
        [
            113.18594163962,
            23.170666862593
        ],
        [
            113.18592225535,
            23.170602308027
        ],
        [
            113.18590722396,
            23.17053687365
        ],
        [
            113.18587887177,
            23.170484120938
        ],
        [
            113.18581968686,
            23.170346906363
        ],
        [
            113.18576432348,
            23.17022157107
        ],
        [
            113.185756691,
            23.17020811927
        ],
        [
            113.18572944321,
            23.170171084855
        ],
        [
            113.18569837627,
            23.170124339503
        ],
        [
            113.1856242163,
            23.169977304289
        ],
        [
            113.18553427911,
            23.169834571316
        ],
        [
            113.18527510663,
            23.169429796254
        ],
        [
            113.18527564889,
            23.169427888954
        ],
        [
            113.18516993341,
            23.169285643565
        ],
        [
            113.1851113329,
            23.169185570977
        ],
        [
            113.1850679806,
            23.169096397555
        ],
        [
            113.18498018012,
            23.168910195266
        ],
        [
            113.18492976324,
            23.168830075746
        ],
        [
            113.18488313917,
            23.168733619985
        ],
        [
            113.18474441859,
            23.168505549188
        ],
        [
            113.18449035752,
            23.168026521007
        ],
        [
            113.18436359974,
            23.1677854976
        ],
        [
            113.18434368407,
            23.167731787714
        ],
        [
            113.18430010132,
            23.167680585669
        ],
        [
            113.18427120086,
            23.167620219808
        ],
        [
            113.18427353412,
            23.167507314095
        ],
        [
            113.18431047615,
            23.167183635944
        ],
        [
            113.18431645762,
            23.167179752061
        ],
        [
            113.18432257295,
            23.167040744801
        ],
        [
            113.18431485002,
            23.166938021545
        ],
        [
            113.18429570635,
            23.166841158918
        ],
        [
            113.18427141856,
            23.166768788867
        ],
        [
            113.18421582768,
            23.166680855065
        ],
        [
            113.18412705212,
            23.166599087524
        ],
        [
            113.18404400918,
            23.166535413726
        ],
        [
            113.18394437029,
            23.166470341429
        ],
        [
            113.18391877514,
            23.166448723376
        ],
        [
            113.18386296304,
            23.166408264195
        ],
        [
            113.18373748431,
            23.166345712679
        ],
        [
            113.18362479383,
            23.16628351749
        ],
        [
            113.18361472308,
            23.166278501931
        ],
        [
            113.18347861752,
            23.166195458211
        ],
        [
            113.18337979383,
            23.166123016711
        ],
        [
            113.18329893216,
            23.166057107035
        ],
        [
            113.18322538684,
            23.165962604298
        ],
        [
            113.18320223071,
            23.165929817964
        ],
        [
            113.18317361053,
            23.1658740428
        ],
        [
            113.18314662039,
            23.165816074372
        ],
        [
            113.18313927907,
            23.165819430088
        ],
        [
            113.18311063663,
            23.165741676592
        ],
        [
            113.18309674125,
            23.165720158882
        ],
        [
            113.18307737881,
            23.165672667667
        ],
        [
            113.18306345128,
            23.165619676066
        ],
        [
            113.18302796865,
            23.16550294257
        ],
        [
            113.18300063345,
            23.165373074562
        ],
        [
            113.18297602967,
            23.165254022389
        ],
        [
            113.18295139577,
            23.165105395524
        ],
        [
            113.18295516159,
            23.16506383159
        ],
        [
            113.18294146978,
            23.164975020538
        ],
        [
            113.18290978974,
            23.164851992828
        ],
        [
            113.18290676182,
            23.164817032262
        ],
        [
            113.18286473768,
            23.164686545643
        ],
        [
            113.18279408302,
            23.164488338124
        ],
        [
            113.18275425012,
            23.164371928476
        ],
        [
            113.18270544588,
            23.164260250064
        ],
        [
            113.18264028538,
            23.164113243759
        ],
        [
            113.1825648266,
            23.16400300054
        ],
        [
            113.18247571864,
            23.163843823651
        ],
        [
            113.18240377696,
            23.163713177071
        ],
        [
            113.18218956003,
            23.16329297932
        ],
        [
            113.18161680456,
            23.161984935569
        ],
        [
            113.18140251311,
            23.161459901546
        ],
        [
            113.18133132008,
            23.161247799607
        ],
        [
            113.18131960002,
            23.161221898341
        ],
        [
            113.18131660283,
            23.161216237825
        ],
        [
            113.18131549139,
            23.161192375005
        ],
        [
            113.18131059638,
            23.16119270727
        ],
        [
            113.1813083872,
            23.161158819063
        ],
        [
            113.18130620455,
            23.161151791761
        ],
        [
            113.18128850602,
            23.161130577188
        ],
        [
            113.18128631722,
            23.161117309447
        ],
        [
            113.1812860209,
            23.161092622503
        ],
        [
            113.18128084698,
            23.161085903675
        ],
        [
            113.18126474684,
            23.161030753275
        ],
        [
            113.18126174514,
            23.161020480177
        ],
        [
            113.18123967298,
            23.160976528001
        ],
        [
            113.18124373818,
            23.160962097335
        ],
        [
            113.18121893693,
            23.160908411001
        ],
        [
            113.18122491518,
            23.160903453078
        ],
        [
            113.18120692175,
            23.160858635922
        ],
        [
            113.1811987492,
            23.160844628153
        ],
        [
            113.18118401241,
            23.160792715976
        ],
        [
            113.18118617553,
            23.160779936941
        ],
        [
            113.18117062987,
            23.160735089103
        ],
        [
            113.18116028175,
            23.160721108012
        ],
        [
            113.18114444003,
            23.160651572982
        ],
        [
            113.18115042701,
            23.160655568979
        ],
        [
            113.18114171172,
            23.160642652912
        ],
        [
            113.1811414177,
            23.160620136553
        ],
        [
            113.18113380512,
            23.160622401045
        ],
        [
            113.18113814203,
            23.160607696004
        ],
        [
            113.18113188072,
            23.160601261415
        ],
        [
            113.18111005199,
            23.160527458661
        ],
        [
            113.18110787371,
            23.160524772235
        ],
        [
            113.18109774438,
            23.160456251711
        ],
        [
            113.18108848661,
            23.160444698647
        ],
        [
            113.1810772725,
            23.160379175923
        ],
        [
            113.18107262895,
            23.160358340988
        ],
        [
            113.18106610662,
            23.160363033659
        ],
        [
            113.18105709573,
            23.160325701514
        ],
        [
            113.18105463733,
            23.160314607385
        ],
        [
            113.1810265274,
            23.160213205489
        ],
        [
            113.18103222831,
            23.160202825246
        ],
        [
            113.18102296936,
            23.160189915182
        ],
        [
            113.1810125915,
            23.16014500246
        ],
        [
            113.18100578092,
            23.160132876271
        ],
        [
            113.18097443443,
            23.160058645556
        ],
        [
            113.18096544516,
            23.160043289926
        ],
        [
            113.18095097936,
            23.159989201718
        ],
        [
            113.18094661769,
            23.159978401987
        ],
        [
            113.18092288692,
            23.159904891231
        ],
        [
            113.18091553862,
            23.159899011658
        ],
        [
            113.18089617437,
            23.159841184094
        ],
        [
            113.18088664582,
            23.159830447081
        ],
        [
            113.18087027311,
            23.159772582798
        ],
        [
            113.1808631811,
            23.159750420403
        ],
        [
            113.18086126834,
            23.159740947296
        ],
        [
            113.18081657013,
            23.159638115189
        ],
        [
            113.18082091049,
            23.159626938293
        ],
        [
            113.18078902315,
            23.159554338339
        ],
        [
            113.18078248693,
            23.159544378431
        ],
        [
            113.18077974797,
            23.159524062264
        ],
        [
            113.18077022068,
            23.1595144098
        ],
        [
            113.18075549296,
            23.159469819314
        ],
        [
            113.1807456831,
            23.15944904583
        ],
        [
            113.18071788476,
            23.159386162691
        ],
        [
            113.18071380024,
            23.159380514116
        ],
        [
            113.18069551808,
            23.159315616608
        ],
        [
            113.18069142942,
            23.159305626844
        ],
        [
            113.18066881147,
            23.159256517972
        ],
        [
            113.18066826631,
            23.159255167906
        ],
        [
            113.18066281151,
            23.159238411394
        ],
        [
            113.18066526049,
            23.159240009908
        ],
        [
            113.18062983509,
            23.159163107983
        ],
        [
            113.18062792585,
            23.159157161763
        ],
        [
            113.18060611681,
            23.159100445204
        ],
        [
            113.18059250153,
            23.159081072926
        ],
        [
            113.18056879148,
            23.159026820493
        ],
        [
            113.18055080708,
            23.158988236092
        ],
        [
            113.18056032237,
            23.158985680544
        ],
        [
            113.18055487626,
            23.158977877218
        ],
        [
            113.18051892621,
            23.158920242924
        ],
        [
            113.18052054879,
            23.158910727274
        ],
        [
            113.18050745702,
            23.158869642131
        ],
        [
            113.18047749492,
            23.158817361984
        ],
        [
            113.18047667091,
            23.158808689442
        ],
        [
            113.18044614385,
            23.158733895576
        ],
        [
            113.18043416956,
            23.158723998687
        ],
        [
            113.18042925308,
            23.158700994536
        ],
        [
            113.18042897091,
            23.158690144965
        ],
        [
            113.1804194381,
            23.158673978581
        ],
        [
            113.18040959833,
            23.158620644542
        ],
        [
            113.18040523344,
            23.158605773474
        ],
        [
            113.18040116197,
            23.158613690035
        ],
        [
            113.18038014168,
            23.158526844095
        ],
        [
            113.18037686225,
            23.158509518211
        ],
        [
            113.18034906374,
            23.15844364381
        ],
        [
            113.18034906476,
            23.158444729088
        ],
        [
            113.18035313471,
            23.158435184762
        ],
        [
            113.18034796305,
            23.158429819347
        ],
        [
            113.18034251567,
            23.158420387329
        ],
        [
            113.18034685703,
            23.158410297174
        ],
        [
            113.18032256277,
            23.158311279607
        ],
        [
            113.18031275857,
            23.158295387075
        ],
        [
            113.18031819042,
            23.158288268716
        ],
        [
            113.18030098475,
            23.15820870253
        ],
        [
            113.18029254554,
            23.158198491573
        ],
        [
            113.18028569585,
            23.15814322239
        ],
        [
            113.18028133145,
            23.158128622301
        ],
        [
            113.18025075941,
            23.158003359213
        ],
        [
            113.1802512725,
            23.157970251911
        ],
        [
            113.18022750856,
            23.15785521876
        ],
        [
            113.1801829517,
            23.157602054449
        ],
        [
            113.1801782401,
            23.157505247771
        ],
        [
            113.18016315814,
            23.157367321405
        ],
        [
            113.18015661279,
            23.157346234748
        ],
        [
            113.18015138939,
            23.157283891849
        ],
        [
            113.18012543186,
            23.157146363395
        ],
        [
            113.18011888148,
            23.157119578916
        ],
        [
            113.18010412472,
            23.157038897078
        ],
        [
            113.18008986171,
            23.156902588691
        ],
        [
            113.18008218327,
            23.156830778013
        ],
        [
            113.18007342414,
            23.156766576837
        ],
        [
            113.18006552207,
            23.156748218791
        ],
        [
            113.18005368891,
            23.15659126175
        ],
        [
            113.18001189545,
            23.156070540991
        ],
        [
            113.18000106902,
            23.155817796959
        ],
        [
            113.18000366839,
            23.155680479692
        ],
        [
            113.18003463627,
            23.155331206073
        ],
        [
            113.18004279176,
            23.155328941028
        ],
        [
            113.18011053342,
            23.155051681559
        ],
        [
            113.18030152901,
            23.154534215086
        ],
        [
            113.18049494753,
            23.15397057257
        ],
        [
            113.18063465446,
            23.153552434026
        ],
        [
            113.18088969316,
            23.152811919937
        ],
        [
            113.18093528119,
            23.152684389734
        ],
        [
            113.18105796303,
            23.152372777081
        ],
        [
            113.18106313176,
            23.152374884071
        ],
        [
            113.18106311226,
            23.152349380943
        ],
        [
            113.1811157872,
            23.152238851226
        ],
        [
            113.18111577257,
            23.152219588244
        ],
        [
            113.18136061479,
            23.151597146826
        ],
        [
            113.18170679134,
            23.150784824323
        ],
        [
            113.18193090767,
            23.150401313362
        ],
        [
            113.18230012062,
            23.149777671627
        ],
        [
            113.18267620841,
            23.149218698602
        ],
        [
            113.18295279962,
            23.148712534684
        ],
        [
            113.18295333893,
            23.148704930892
        ],
        [
            113.18311365083,
            23.148410295458
        ],
        [
            113.18323456792,
            23.148186993969
        ],
        [
            113.18352914489,
            23.14766394495
        ],
        [
            113.18367508219,
            23.147403642167
        ],
        [
            113.18388568756,
            23.146988865849
        ],
        [
            113.1839723714,
            23.146803706377
        ],
        [
            113.18398215894,
            23.146791902676
        ],
        [
            113.18405798138,
            23.146641075999
        ],
        [
            113.18414492927,
            23.146431759492
        ],
        [
            113.1841650432,
            23.146396476768
        ],
        [
            113.18415742407,
            23.146393600562
        ],
        [
            113.18431559171,
            23.14605846801
        ],
        [
            113.18483769379,
            23.144915571092
        ],
        [
            113.18494942383,
            23.144702604129
        ],
        [
            113.18496029629,
            23.144678028839
        ],
        [
            113.18547169741,
            23.143719337005
        ],
        [
            113.18580452176,
            23.143117791569
        ],
        [
            113.18581295148,
            23.143102472571
        ],
        [
            113.18587440639,
            23.142987877002
        ],
        [
            113.18604273796,
            23.14268908573
        ],
        [
            113.18610093391,
            23.142582400693
        ],
        [
            113.18623310245,
            23.142341928282
        ],
        [
            113.1863973827,
            23.142091461438
        ],
        [
            113.18645476953,
            23.141991561962
        ],
        [
            113.18644851208,
            23.141995998578
        ],
        [
            113.18654425443,
            23.14184694777
        ],
        [
            113.18656601471,
            23.141814329801
        ],
        [
            113.18656546602,
            23.141799417569
        ],
        [
            113.18587528869,
            23.141486836186
        ],
        [
            113.18553948148,
            23.141368979717
        ],
        [
            113.18531879129,
            23.141290601893
        ],
        [
            113.18530845258,
            23.141293467714
        ],
        [
            113.18505865199,
            23.14120382607
        ],
        [
            113.18461158836,
            23.141050273746
        ],
        [
            113.18432371587,
            23.14094806298
        ],
        [
            113.18413244085,
            23.140878622362
        ],
        [
            113.18398198432,
            23.140835443922
        ],
        [
            113.18395913322,
            23.140840377449
        ],
        [
            113.18386609465,
            23.140850094104
        ],
        [
            113.18380869456,
            23.140857680017
        ],
        [
            113.18362047313,
            23.140988348014
        ],
        [
            113.18358456702,
            23.141000782477
        ],
        [
            113.18344773731,
            23.141020035643
        ],
        [
            113.18340666237,
            23.141028739686
        ],
        [
            113.18339255698,
            23.141184921237
        ],
        [
            113.18339745449,
            23.141188380572
        ],
        [
            113.18339420198,
            23.14123345828
        ],
        [
            113.18340380628,
            23.141538248921
        ],
        [
            113.18342299499,
            23.142036877597
        ],
        [
            113.18341483433,
            23.142038075065
        ],
        [
            113.18320319353,
            23.142034463689
        ],
        [
            113.18298530529,
            23.142042575574
        ],
        [
            113.18221553083,
            23.142057405926
        ],
        [
            113.18190872834,
            23.142057578177
        ],
        [
            113.18172922518,
            23.142068283201
        ],
        [
            113.18151518707,
            23.142081844265
        ],
        [
            113.1813258967,
            23.142073093086
        ],
        [
            113.18130304914,
            23.142063882754
        ],
        [
            113.18124456735,
            23.142029614
        ],
        [
            113.18123309903,
            23.141876208947
        ],
        [
            113.18122270179,
            23.141660124117
        ],
        [
            113.18122783545,
            23.141541238052
        ],
        [
            113.18121961558,
            23.141317531078
        ],
        [
            113.1812195814,
            23.141188129524
        ],
        [
            113.18155735811,
            23.141179564231
        ],
        [
            113.18155953386,
            23.141179536776
        ],
        [
            113.18156034871,
            23.141175457251
        ],
        [
            113.18155326696,
            23.1411348542
        ],
        [
            113.18154864125,
            23.141126231503
        ],
        [
            113.18155131575,
            23.140947693991
        ],
        [
            113.18154913899,
            23.140943652216
        ],
        [
            113.1815494082,
            23.140932526257
        ],
        [
            113.18155239864,
            23.14092760546
        ],
        [
            113.18155967292,
            23.140640497787
        ],
        [
            113.18156048832,
            23.140638317248
        ],
        [
            113.18155395635,
            23.140618053586
        ],
        [
            113.18154905978,
            23.140613232293
        ],
        [
            113.1813627679,
            23.140634288998
        ],
        [
            113.1813387364,
            23.140185619935
        ],
        [
            113.18133982215,
            23.140175569041
        ],
        [
            113.18132071731,
            23.139836165787
        ],
        [
            113.18131718162,
            23.139835124735
        ],
        [
            113.18131742217,
            23.139665844048
        ],
        [
            113.18131089405,
            23.139659957265
        ],
        [
            113.18122767383,
            23.139655837381
        ],
        [
            113.18122413942,
            23.139661578051
        ],
        [
            113.18115533311,
            23.139653748779
        ],
        [
            113.18111209256,
            23.139654553647
        ],
        [
            113.18110556506,
            23.139651107474
        ],
        [
            113.18097502995,
            23.139657593172
        ],
        [
            113.1809336935,
            23.139655114265
        ],
        [
            113.18092716567,
            23.139648954539
        ],
        [
            113.18091900862,
            23.139656378558
        ],
        [
            113.1808692416,
            23.139650474052
        ],
        [
            113.18068051295,
            23.139640278829
        ],
        [
            113.18047329805,
            23.139630008159
        ],
        [
            113.18016112786,
            23.139616868486
        ],
        [
            113.18001021378,
            23.139607500677
        ],
        [
            113.17999226793,
            23.139609064652
        ],
        [
            113.17996344567,
            23.13961021141
        ],
        [
            113.17994954235,
            23.139400674297
        ],
        [
            113.17994410414,
            23.139400465718
        ],
        [
            113.17994735718,
            23.139340475983
        ],
        [
            113.17994082997,
            23.139331870361
        ],
        [
            113.17993102761,
            23.139246531101
        ],
        [
            113.17993401748,
            23.139239443467
        ],
        [
            113.17992340399,
            23.139181241233
        ],
        [
            113.17993237682,
            23.139180324074
        ],
        [
            113.17990869937,
            23.139037634031
        ],
        [
            113.17990625161,
            23.139033593044
        ],
        [
            113.17989617855,
            23.138946900571
        ],
        [
            113.17989291441,
            23.138937985985
        ],
        [
            113.17986870065,
            23.138836264415
        ],
        [
            113.17985755086,
            23.138823913639
        ],
        [
            113.17983660031,
            23.138719170209
        ],
        [
            113.17982762664,
            23.138712762344
        ],
        [
            113.17982245685,
            23.138684608907
        ],
        [
            113.17981729058,
            23.138683854183
        ],
        [
            113.17981538449,
            23.138662173993
        ],
        [
            113.17981456817,
            23.138657300381
        ],
        [
            113.17978845336,
            23.138559397354
        ],
        [
            113.17978818104,
            23.138555873894
        ],
        [
            113.1797677858,
            23.138534404649
        ],
        [
            113.17973379308,
            23.138491387958
        ],
        [
            113.17970224834,
            23.138453768154
        ],
        [
            113.17963046638,
            23.138445086922
        ],
        [
            113.17947222318,
            23.138432218199
        ],
        [
            113.17920332575,
            23.138399393601
        ],
        [
            113.17908315462,
            23.138384433609
        ],
        [
            113.17898337535,
            23.138364630579
        ],
        [
            113.17892410735,
            23.138359303623
        ],
        [
            113.17892655482,
            23.138365245226
        ],
        [
            113.17892872937,
            23.138361695186
        ],
        [
            113.178459496,
            23.138305372866
        ],
        [
            113.17816209686,
            23.138270469384
        ],
        [
            113.17805118668,
            23.138250982227
        ],
        [
            113.17786362331,
            23.138226829062
        ],
        [
            113.17776929956,
            23.138209864874
        ],
        [
            113.17776032913,
            23.138205884801
        ],
        [
            113.17764319951,
            23.138424060516
        ],
        [
            113.17763504636,
            23.138435262879
        ],
        [
            113.17748667187,
            23.138717481198
        ],
        [
            113.17742362681,
            23.138823889106
        ],
        [
            113.17741656067,
            23.138829654135
        ],
        [
            113.17734782215,
            23.139027804617
        ],
        [
            113.17734646342,
            23.139029716594
        ],
        [
            113.17731249472,
            23.139073446434
        ],
        [
            113.177236657,
            23.139032122557
        ],
        [
            113.17712304101,
            23.138989794515
        ],
        [
            113.17703906263,
            23.139022322655
        ],
        [
            113.17699720706,
            23.139019729734
        ],
        [
            113.17686158216,
            23.138983822799
        ],
        [
            113.17667322981,
            23.138900636269
        ],
        [
            113.17663055736,
            23.138868198327
        ],
        [
            113.17655989417,
            23.13884279253
        ],
        [
            113.17634410225,
            23.138744340183
        ],
        [
            113.17631393526,
            23.138728600318
        ],
        [
            113.17626066606,
            23.138686748226
        ],
        [
            113.17620440907,
            23.138652244268
        ],
        [
            113.17612369855,
            23.138643720142
        ],
        [
            113.17603729401,
            23.138726930353
        ],
        [
            113.1760364801,
            23.138737245765
        ],
        [
            113.17602561092,
            23.138741407879
        ],
        [
            113.17596501672,
            23.138773392427
        ],
        [
            113.17568295162,
            23.138730183902
        ],
        [
            113.1752449376,
            23.138683542264
        ],
        [
            113.17524031862,
            23.138683850069
        ],
        [
            113.17524194642,
            23.138664305423
        ],
        [
            113.17523488192,
            23.138663276171
        ],
        [
            113.17523312448,
            23.137131415688
        ],
        [
            113.17409234908,
            23.137306986242
        ],
        [
            113.17382260832,
            23.137388309648
        ],
        [
            113.17324948709,
            23.137565627184
        ],
        [
            113.17308760801,
            23.137561739024
        ],
        [
            113.17272719843,
            23.137537286996
        ],
        [
            113.17248331727,
            23.137519676463
        ],
        [
            113.17243361902,
            23.13751696696
        ],
        [
            113.1722815395,
            23.13750477233
        ],
        [
            113.17226171546,
            23.137508133797
        ],
        [
            113.17143784596,
            23.137432485564
        ],
        [
            113.1714237265,
            23.13742821031
        ],
        [
            113.17122198656,
            23.13739114272
        ],
        [
            113.16953912475,
            23.13705251732
        ],
        [
            113.16951116754,
            23.137046901178
        ],
        [
            113.16921966226,
            23.137016502011
        ],
        [
            113.1688619522,
            23.136973969949
        ],
        [
            113.16886222376,
            23.136979123448
        ],
        [
            113.16870617417,
            23.136959392613
        ],
        [
            113.16852190613,
            23.136943221385
        ],
        [
            113.16846627395,
            23.136930307878
        ],
        [
            113.1684657314,
            23.13693709064
        ],
        [
            113.16843533759,
            23.136933892869
        ],
        [
            113.1684318097,
            23.136931729331
        ],
        [
            113.16833682963,
            23.136899350787
        ],
        [
            113.1682708879,
            23.136896753815
        ],
        [
            113.16818269522,
            23.136882796302
        ],
        [
            113.16791351333,
            23.136844684749
        ],
        [
            113.16703524054,
            23.136709102367
        ],
        [
            113.16696144761,
            23.136710770078
        ],
        [
            113.16690583213,
            23.136702387632
        ],
        [
            113.16674767053,
            23.136688884917
        ],
        [
            113.16662613634,
            23.136686745604
        ],
        [
            113.16658408838,
            23.13668865195
        ],
        [
            113.16643461739,
            23.136696531958
        ],
        [
            113.16614599547,
            23.136691887092
        ],
        [
            113.16532470471,
            23.136759999098
        ],
        [
            113.16506462089,
            23.136825079729
        ],
        [
            113.16494773646,
            23.136848798284
        ],
        [
            113.16371748159,
            23.13682336064
        ],
        [
            113.16361418311,
            23.13684696877
        ],
        [
            113.16138954823,
            23.137200522508
        ],
        [
            113.16022595686,
            23.137325281665
        ],
        [
            113.16002057895,
            23.137344715334
        ],
        [
            113.15993441999,
            23.137351803586
        ],
        [
            113.15947330621,
            23.13745368801
        ],
        [
            113.1590845586,
            23.137529287214
        ],
        [
            113.15883181942,
            23.137577759294
        ],
        [
            113.15841088218,
            23.1376385329
        ],
        [
            113.1576514346,
            23.137786051977
        ],
        [
            113.15768720585,
            23.138042414407
        ],
        [
            113.15770455211,
            23.138179814518
        ],
        [
            113.15773760269,
            23.138268237044
        ],
        [
            113.15772893641,
            23.138272238351
        ],
        [
            113.15774681511,
            23.138307101074
        ],
        [
            113.15777337649,
            23.138484992257
        ],
        [
            113.15783597764,
            23.138792560338
        ],
        [
            113.15785575909,
            23.138869212618
        ],
        [
            113.15793408745,
            23.139249599929
        ],
        [
            113.15800159458,
            23.139652417405
        ],
        [
            113.15800891734,
            23.139708084783
        ],
        [
            113.15803363185,
            23.14006527335
        ],
        [
            113.15805588831,
            23.140294943099
        ],
        [
            113.15806024948,
            23.140424104762
        ],
        [
            113.15807653203,
            23.140567191694
        ],
        [
            113.15807817074,
            23.140627428095
        ],
        [
            113.15808875899,
            23.140736290982
        ],
        [
            113.15808259094,
            23.140992604438
        ],
        [
            113.15809401126,
            23.141170108055
        ],
        [
            113.15809753664,
            23.141186953986
        ],
        [
            113.15810814334,
            23.141353600438
        ],
        [
            113.15811330699,
            23.141419018085
        ],
        [
            113.15811223876,
            23.141475165425
        ],
        [
            113.15809545002,
            23.141489959856
        ],
        [
            113.15806078479,
            23.141502991592
        ],
        [
            113.15803722233,
            23.141507967907
        ],
        [
            113.15803126226,
            23.141502768438
        ],
        [
            113.15801474195,
            23.141507797602
        ],
        [
            113.15793024247,
            23.141522887998
        ],
        [
            113.1575805996,
            23.141540505628
        ],
        [
            113.15753185254,
            23.141546085279
        ],
        [
            113.1570045891,
            23.141575123886
        ],
        [
            113.15698834183,
            23.141577699655
        ],
        [
            113.15698915295,
            23.141573094705
        ],
        [
            113.15683642968,
            23.141593498482
        ],
        [
            113.1567040176,
            23.141607820018
        ],
        [
            113.15667369262,
            23.141618679137
        ],
        [
            113.156639575,
            23.141622993634
        ],
        [
            113.15663849186,
            23.14162298418
        ],
        [
            113.15662170311,
            23.141622294953
        ],
        [
            113.15662576327,
            23.141616633514
        ],
        [
            113.15660138969,
            23.141605297691
        ],
        [
            113.15658459847,
            23.141595384339
        ],
        [
            113.15650336652,
            23.141601993648
        ],
        [
            113.15647168556,
            23.141601713218
        ],
        [
            113.15617628288,
            23.141625916258
        ],
        [
            113.15608503793,
            23.141631050506
        ],
        [
            113.15577232283,
            23.141642791053
        ],
        [
            113.15562016693,
            23.141645959453
        ],
        [
            113.15560852624,
            23.141649646225
        ],
        [
            113.15557847456,
            23.14165017255
        ],
        [
            113.15556764616,
            23.141653866726
        ],
        [
            113.15550727392,
            23.141659525936
        ],
        [
            113.1554517723,
            23.141654106852
        ],
        [
            113.15536540757,
            23.141646485923
        ],
        [
            113.15522544363,
            23.141648098142
        ],
        [
            113.15506490981,
            23.141654373022
        ],
        [
            113.15484861236,
            23.14165273859
        ],
        [
            113.1547205755,
            23.141671507837
        ],
        [
            113.15471407801,
            23.141668999702
        ],
        [
            113.15470243699,
            23.141665624923
        ],
        [
            113.15469296397,
            23.141670682057
        ],
        [
            113.15469377653,
            23.141672318094
        ],
        [
            113.15464017708,
            23.141667426168
        ],
        [
            113.15461770943,
            23.141667736943
        ],
        [
            113.15456059206,
            23.141664433128
        ],
        [
            113.15449887306,
            23.141659722496
        ],
        [
            113.15448371246,
            23.141652782443
        ],
        [
            113.15444960442,
            23.141648357116
        ],
        [
            113.1543849084,
            23.141641711049
        ],
        [
            113.15435134661,
            23.141652752013
        ],
        [
            113.15432969748,
            23.141672327539
        ],
        [
            113.15430807872,
            23.141797160679
        ],
        [
            113.15428649269,
            23.142028336985
        ],
        [
            113.1542756724,
            23.142051281588
        ],
        [
            113.15426513286,
            23.142107054388
        ],
        [
            113.1542316221,
            23.142279235495
        ],
        [
            113.15421054344,
            23.142386982618
        ],
        [
            113.15419892199,
            23.14244192972
        ],
        [
            113.15420163123,
            23.142449554515
        ],
        [
            113.15417757883,
            23.142565408195
        ],
        [
            113.15416054603,
            23.142625180499
        ],
        [
            113.15413376986,
            23.142687018767
        ],
        [
            113.15411486036,
            23.142798314708
        ],
        [
            113.15406076494,
            23.142911945714
        ],
        [
            113.1540072208,
            23.14305053892
        ],
        [
            113.15394473282,
            23.143152409657
        ],
        [
            113.15385113053,
            23.143284051556
        ],
        [
            113.15360739584,
            23.143625907058
        ],
        [
            113.15360712424,
            23.14362346246
        ],
        [
            113.1535578873,
            23.143679886331
        ],
        [
            113.15356113229,
            23.143672597637
        ],
        [
            113.15349647828,
            23.14375326377
        ],
        [
            113.15345157704,
            23.143820312509
        ],
        [
            113.15340666998,
            23.14387135375
        ],
        [
            113.15340098975,
            23.143879699892
        ],
        [
            113.15335445327,
            23.143915529006
        ],
        [
            113.15325651594,
            23.144002048284
        ],
        [
            113.15302519192,
            23.144169775724
        ],
        [
            113.15284391856,
            23.144281077506
        ],
        [
            113.15258742554,
            23.14440557647
        ],
        [
            113.15264677661,
            23.144608387309
        ],
        [
            113.1527229042,
            23.144801626302
        ],
        [
            113.15272399303,
            23.144816017461
        ],
        [
            113.15273347143,
            23.144831320772
        ],
        [
            113.15274430115,
            23.144842570478
        ],
        [
            113.15275325515,
            23.144895576936
        ],
        [
            113.15278792683,
            23.144967874164
        ],
        [
            113.15291799634,
            23.145339970579
        ],
        [
            113.15292693019,
            23.145346856308
        ],
        [
            113.15302665213,
            23.145623097355
        ],
        [
            113.15315024238,
            23.145995099942
        ],
        [
            113.15317165464,
            23.146059369489
        ],
        [
            113.15319167905,
            23.146054171735
        ],
        [
            113.1532463381,
            23.146034988504
        ],
        [
            113.15333860568,
            23.145993710434
        ],
        [
            113.15342004725,
            23.145949320557
        ],
        [
            113.15345603486,
            23.145932632359
        ],
        [
            113.15348471649,
            23.145918574548
        ],
        [
            113.15349392044,
            23.145922475454
        ],
        [
            113.15351096601,
            23.145911813936
        ],
        [
            113.153511238,
            23.145914529903
        ],
        [
            113.15353099992,
            23.145923702846
        ],
        [
            113.1536436428,
            23.146027773126
        ],
        [
            113.15364177076,
            23.146072787187
        ],
        [
            113.15372789433,
            23.146181983037
        ],
        [
            113.15377475906,
            23.146262257943
        ],
        [
            113.15377773979,
            23.146269072964
        ],
        [
            113.15377909809,
            23.146278854441
        ],
        [
            113.15376205493,
            23.146295216557
        ],
        [
            113.15372769897,
            23.146329564955
        ],
        [
            113.15366547845,
            23.146388564249
        ],
        [
            113.15361083108,
            23.146436250282
        ],
        [
            113.15360812341,
            23.14643404992
        ],
        [
            113.1535845881,
            23.146456035058
        ],
        [
            113.15357376791,
            23.146467309296
        ],
        [
            113.1535431968,
            23.146491114622
        ],
        [
            113.15353480873,
            23.146495090661
        ],
        [
            113.15352697558,
            23.146525117137
        ],
        [
            113.15352428114,
            23.146548147181
        ],
        [
            113.15352754788,
            23.146584265813
        ],
        [
            113.15354758777,
            23.14660673513
        ],
        [
            113.15355625706,
            23.146622837973
        ],
        [
            113.15355951448,
            23.146641050967
        ],
        [
            113.15358985919,
            23.146701072952
        ],
        [
            113.15360640618,
            23.146770979368
        ],
        [
            113.15362888312,
            23.146794831018
        ],
        [
            113.15389129631,
            23.147062765888
        ],
        [
            113.15391619759,
            23.147063036424
        ],
        [
            113.15396493039,
            23.147086624719
        ],
        [
            113.15398794113,
            23.147093927175
        ],
        [
            113.15400878971,
            23.14710690314
        ],
        [
            113.15402747345,
            23.147120669353
        ],
        [
            113.15417634851,
            23.147612498379
        ],
        [
            113.15418473641,
            23.147607161826
        ],
        [
            113.15418365494,
            23.147609320683
        ],
        [
            113.15419206396,
            23.147640880777
        ],
        [
            113.15427498705,
            23.147806710327
        ],
        [
            113.15462295243,
            23.148484525994
        ],
        [
            113.15470459115,
            23.148743372441
        ],
        [
            113.15472384036,
            23.148791047361
        ],
        [
            113.1547214313,
            23.148834702028
        ],
        [
            113.15471764811,
            23.148845243966
        ],
        [
            113.15471115623,
            23.148853045112
        ],
        [
            113.15470359091,
            23.148875756735
        ],
        [
            113.15467247775,
            23.148902838429
        ],
        [
            113.15462651458,
            23.148990266251
        ],
        [
            113.15458301402,
            23.149118141864
        ],
        [
            113.1545757115,
            23.149127833068
        ],
        [
            113.1545441002,
            23.149221104086
        ],
        [
            113.15450733022,
            23.149289360981
        ],
        [
            113.15449381597,
            23.149320691164
        ],
        [
            113.15446244628,
            23.149367299006
        ],
        [
            113.15445975186,
            23.149386533267
        ],
        [
            113.15442162039,
            23.149440937244
        ],
        [
            113.15441081251,
            23.149470938456
        ],
        [
            113.15438404677,
            23.149520034469
        ],
        [
            113.1543740408,
            23.149534308313
        ],
        [
            113.15436782463,
            23.14954889325
        ],
        [
            113.15433212453,
            23.149594638617
        ],
        [
            113.15431590421,
            23.149625938515
        ],
        [
            113.15428966928,
            23.149657946244
        ],
        [
            113.15427939125,
            23.14966977479
        ],
        [
            113.15427074592,
            23.149694643058
        ],
        [
            113.15423207923,
            23.149755547289
        ],
        [
            113.1542312798,
            23.149774529965
        ],
        [
            113.15420991238,
            23.149798720071
        ],
        [
            113.15419098929,
            23.149835144488
        ],
        [
            113.15417367897,
            23.149854493784
        ],
        [
            113.15413393382,
            23.149920267184
        ],
        [
            113.15412122046,
            23.149932611092
        ],
        [
            113.15411310422,
            23.149938492855
        ],
        [
            113.15407958424,
            23.150002974819
        ],
        [
            113.15406768889,
            23.150024008699
        ],
        [
            113.15406173537,
            23.150025843844
        ],
        [
            113.15403145495,
            23.15007706561
        ],
        [
            113.1540198273,
            23.150093489807
        ],
        [
            113.15397602093,
            23.150155145301
        ],
        [
            113.1539743984,
            23.150157298183
        ],
        [
            113.15397765029,
            23.150163030709
        ],
        [
            113.15394061533,
            23.150230998244
        ],
        [
            113.15390656329,
            23.150306593698
        ],
        [
            113.15386574412,
            23.150380758112
        ],
        [
            113.15385601984,
            23.150409139025
        ],
        [
            113.15384089435,
            23.150454824386
        ],
        [
            113.15381549151,
            23.150511520748
        ],
        [
            113.15380440171,
            23.150521980329
        ],
        [
            113.15377575426,
            23.150582981337
        ],
        [
            113.15371305025,
            23.150709534263
        ],
        [
            113.15370818164,
            23.150714092839
        ],
        [
            113.15369871967,
            23.150729724275
        ],
        [
            113.15367951445,
            23.150745790806
        ],
        [
            113.15364678683,
            23.150776358072
        ],
        [
            113.15363299164,
            23.150787871576
        ],
        [
            113.15362595309,
            23.150785623234
        ],
        [
            113.15360539542,
            23.150802487665
        ],
        [
            113.15357022528,
            23.150822987755
        ],
        [
            113.15355859414,
            23.150832625424
        ],
        [
            113.15353262158,
            23.150846444186
        ],
        [
            113.15348988136,
            23.150877710052
        ],
        [
            113.15346066171,
            23.150892033786
        ],
        [
            113.15345904302,
            23.150899340894
        ],
        [
            113.1534292776,
            23.15090714654
        ],
        [
            113.15340600992,
            23.150918008891
        ],
        [
            113.15341331659,
            23.15091700572
        ],
        [
            113.15338518103,
            23.15093296785
        ],
        [
            113.15336786364,
            23.150938199067
        ],
        [
            113.15334324413,
            23.150950672964
        ],
        [
            113.15330428418,
            23.150967867855
        ],
        [
            113.15327019038,
            23.150977248953
        ],
        [
            113.15325178784,
            23.150978396848
        ],
        [
            113.15321796301,
            23.150985066662
        ],
        [
            113.15317656691,
            23.151000602434
        ],
        [
            113.15315843816,
            23.151005821783
        ],
        [
            113.15316006604,
            23.151011537759
        ],
        [
            113.15313164953,
            23.151011484547
        ],
        [
            113.15310351695,
            23.151029882736
        ],
        [
            113.153066448,
            23.151040309982
        ],
        [
            113.15302208175,
            23.151063946221
        ],
        [
            113.15296012789,
            23.15109144755
        ],
        [
            113.15293009974,
            23.151107107305
        ],
        [
            113.15292388292,
            23.151117616231
        ],
        [
            113.15286219594,
            23.151138605011
        ],
        [
            113.15280836324,
            23.151167550551
        ],
        [
            113.15277048858,
            23.151184200609
        ],
        [
            113.15270800077,
            23.15121846725
        ],
        [
            113.15265471627,
            23.15125528124
        ],
        [
            113.15264984578,
            23.151256037824
        ],
        [
            113.15261251995,
            23.151281914513
        ],
        [
            113.15254029128,
            23.151315516221
        ],
        [
            113.15248916993,
            23.151348008786
        ],
        [
            113.15246915037,
            23.151355367254
        ],
        [
            113.1524350652,
            23.151370696966
        ],
        [
            113.15237689886,
            23.151389264941
        ],
        [
            113.15231088771,
            23.151410720736
        ],
        [
            113.15223675365,
            23.151424479014
        ],
        [
            113.15219590666,
            23.151442434569
        ],
        [
            113.1521531594,
            23.151451684169
        ],
        [
            113.15212394096,
            23.151459468963
        ],
        [
            113.15212366878,
            23.151457295214
        ],
        [
            113.152076869,
            23.151474632547
        ],
        [
            113.15204142885,
            23.151484510398
        ],
        [
            113.15195432207,
            23.151515459611
        ],
        [
            113.15190725086,
            23.151530075147
        ],
        [
            113.15183178109,
            23.151561431346
        ],
        [
            113.15177875968,
            23.151578411116
        ],
        [
            113.15172736975,
            23.151605718858
        ],
        [
            113.15165920555,
            23.151634443853
        ],
        [
            113.15166705312,
            23.151635626789
        ],
        [
            113.15162728741,
            23.151647611304
        ],
        [
            113.15158833907,
            23.15166693024
        ],
        [
            113.15157562383,
            23.151669212983
        ],
        [
            113.15154425385,
            23.15169133862
        ],
        [
            113.15149339819,
            23.151706978861
        ],
        [
            113.15145904648,
            23.15172119738
        ],
        [
            113.15140169757,
            23.151736481472
        ],
        [
            113.15135625607,
            23.151754627191
        ],
        [
            113.1513440846,
            23.151759899229
        ],
        [
            113.15124994739,
            23.151784749592
        ],
        [
            113.1511942231,
            23.151799503908
        ],
        [
            113.15094889273,
            23.151882900082
        ],
        [
            113.15086313585,
            23.15189209924
        ],
        [
            113.15085501755,
            23.151889552112
        ],
        [
            113.15079874418,
            23.151889634474
        ],
        [
            113.15076789884,
            23.151885163027
        ],
        [
            113.15071026954,
            23.151880069704
        ],
        [
            113.15064831362,
            23.151877087981
        ],
        [
            113.15061152572,
            23.15188420169
        ],
        [
            113.15058420727,
            23.151891981749
        ],
        [
            113.15053929603,
            23.151888948562
        ],
        [
            113.15048329814,
            23.15189255025
        ],
        [
            113.15043108184,
            23.151887789586
        ],
        [
            113.15038645297,
            23.151899406361
        ],
        [
            113.15035507756,
            23.151907399911
        ],
        [
            113.15028582709,
            23.151913531437
        ],
        [
            113.1502379509,
            23.151922658994
        ],
        [
            113.15021983229,
            23.151931369726
        ],
        [
            113.15018547892,
            23.151935521823
        ],
        [
            113.15015410981,
            23.151950836812
        ],
        [
            113.15008351706,
            23.151968336509
        ],
        [
            113.15007054077,
            23.151979827882
        ],
        [
            113.15006270033,
            23.151985962261
        ],
        [
            113.15005405018,
            23.151994527442
        ],
        [
            113.1500294383,
            23.152001520638
        ],
        [
            113.15000347758,
            23.152013378748
        ],
        [
            113.14998888303,
            23.15203108765
        ],
        [
            113.14997293204,
            23.152043623242
        ],
        [
            113.14993318148,
            23.152063704044
        ],
        [
            113.1498766561,
            23.152079486348
        ],
        [
            113.14982391975,
            23.152097217492
        ],
        [
            113.1498039067,
            23.152103456046
        ],
        [
            113.14977118642,
            23.152118473982
        ],
        [
            113.14973169551,
            23.1521228177
        ],
        [
            113.14964000883,
            23.152142451434
        ],
        [
            113.14946933672,
            23.152161531653
        ],
        [
            113.14921643462,
            23.152175376971
        ],
        [
            113.14894921491,
            23.152202819337
        ],
        [
            113.14895300563,
            23.15220802776
        ],
        [
            113.14862787744,
            23.152188750677
        ],
        [
            113.14823151877,
            23.152022417369
        ],
        [
            113.14812087289,
            23.151984721566
        ],
        [
            113.14778786825,
            23.151880260916
        ],
        [
            113.14771762431,
            23.151976077939
        ],
        [
            113.14768655313,
            23.15201577074
        ],
        [
            113.14760333895,
            23.152124413983
        ],
        [
            113.14756012007,
            23.152192411262
        ],
        [
            113.14751067165,
            23.152247563254
        ],
        [
            113.14750689686,
            23.152262428797
        ],
        [
            113.14748339395,
            23.152295448658
        ],
        [
            113.14746178526,
            23.15232985309
        ],
        [
            113.14746232406,
            23.152327148074
        ],
        [
            113.14746774285,
            23.152340251781
        ],
        [
            113.14746882731,
            23.152343794975
        ],
        [
            113.14747342876,
            23.152349018556
        ],
        [
            113.1474720778,
            23.152350626213
        ],
        [
            113.14747478721,
            23.152357178056
        ],
        [
            113.14747478471,
            23.152353922336
        ],
        [
            113.14746992572,
            23.152365515937
        ],
        [
            113.1474704741,
            23.15237529118
        ],
        [
            113.14747534557,
            23.152379976178
        ],
        [
            113.14747265596,
            23.152399198789
        ],
        [
            113.14747970244,
            23.152418838154
        ],
        [
            113.14745620836,
            23.152462981444
        ],
        [
            113.14745622698,
            23.152487128054
        ],
        [
            113.14742890898,
            23.152482107274
        ],
        [
            113.14741376584,
            23.152483779784
        ],
        [
            113.14739347978,
            23.152479406383
        ],
        [
            113.14739834454,
            23.152475409648
        ],
        [
            113.1473883335,
            23.152469019612
        ],
        [
            113.14738102811,
            23.152464297919
        ],
        [
            113.14736939216,
            23.152454899057
        ],
        [
            113.1473677712,
            23.152457045209
        ],
        [
            113.14735775686,
            23.152446314057
        ],
        [
            113.14733584329,
            23.152435404283
        ],
        [
            113.14731366602,
            23.15243317213
        ],
        [
            113.14729499841,
            23.152423124581
        ],
        [
            113.14724928108,
            23.152404530636
        ],
        [
            113.14715676121,
            23.152361897081
        ],
        [
            113.14706343327,
            23.152322231403
        ],
        [
            113.14699824253,
            23.152298453184
        ],
        [
            113.14693737864,
            23.152274196073
        ],
        [
            113.14693115635,
            23.152270845752
        ],
        [
            113.14687164874,
            23.152251490836
        ],
        [
            113.14684243944,
            23.152246433251
        ],
        [
            113.14683215672,
            23.152237594553
        ],
        [
            113.1468316194,
            23.152242198566
        ],
        [
            113.14681106394,
            23.152237543882
        ],
        [
            113.14680186709,
            23.152234147747
        ],
        [
            113.14678834287,
            23.152229871529
        ],
        [
            113.14678320837,
            23.152234405275
        ],
        [
            113.14677806705,
            23.152229985786
        ],
        [
            113.14677320525,
            23.152237508048
        ],
        [
            113.14677429419,
            23.152247020427
        ],
        [
            113.14674970408,
            23.152270519339
        ],
        [
            113.1467348602,
            23.152308546425
        ],
        [
            113.14672786254,
            23.152351848385
        ],
        [
            113.14671654929,
            23.152409463509
        ],
        [
            113.146709794,
            23.15241614271
        ],
        [
            113.14670790816,
            23.152425338256
        ],
        [
            113.14667333965,
            23.152483410698
        ],
        [
            113.14663068237,
            23.152571744792
        ],
        [
            113.14659883547,
            23.152651562438
        ],
        [
            113.14656265695,
            23.152724530299
        ],
        [
            113.14656428304,
            23.152729167549
        ],
        [
            113.14655996168,
            23.152735883733
        ],
        [
            113.14653591652,
            23.152763458204
        ],
        [
            113.14653916257,
            23.152764864734
        ],
        [
            113.14651539257,
            23.152798411981
        ],
        [
            113.14651945326,
            23.152804172019
        ],
        [
            113.14638849501,
            23.152702037488
        ],
        [
            113.14625049486,
            23.152582693289
        ],
        [
            113.14621829616,
            23.152556147352
        ],
        [
            113.14620503928,
            23.152546988033
        ],
        [
            113.14620205724,
            23.152537174586
        ],
        [
            113.14615363627,
            23.152512817031
        ],
        [
            113.1461057444,
            23.152473002166
        ],
        [
            113.14606787258,
            23.152452605582
        ],
        [
            113.14593993113,
            23.152396884876
        ],
        [
            113.14582091125,
            23.152337227614
        ],
        [
            113.14563617944,
            23.15226648781
        ],
        [
            113.1455463795,
            23.152225998194
        ],
        [
            113.14554610869,
            23.152225451289
        ],
        [
            113.14550580543,
            23.152205006807
        ],
        [
            113.14549525858,
            23.152202668994
        ],
        [
            113.14534810895,
            23.152123278013
        ],
        [
            113.1452025954,
            23.152059368571
        ],
        [
            113.14508576927,
            23.152029281395
        ],
        [
            113.14502194989,
            23.152015234067
        ],
        [
            113.14490569154,
            23.152018518073
        ],
        [
            113.14472022279,
            23.152025831954
        ],
        [
            113.14464750959,
            23.15204662955
        ],
        [
            113.14458237292,
            23.152075144733
        ],
        [
            113.14448563254,
            23.152141126827
        ],
        [
            113.14443269701,
            23.152214059816
        ],
        [
            113.1443162607,
            23.152330720226
        ],
        [
            113.14424979343,
            23.152384165661
        ],
        [
            113.14417953673,
            23.152431307285
        ],
        [
            113.14410873641,
            23.152474097261
        ],
        [
            113.14404954217,
            23.152491573427
        ],
        [
            113.14400602743,
            23.152507407285
        ],
        [
            113.14398655879,
            23.152503288487
        ],
        [
            113.14396520231,
            23.152505107205
        ],
        [
            113.14394248106,
            23.152490082236
        ],
        [
            113.14387866108,
            23.152468139009
        ],
        [
            113.14385648594,
            23.15245990503
        ],
        [
            113.14379997807,
            23.15245381655
        ],
        [
            113.14379753818,
            23.152445094394
        ],
        [
            113.1437464422,
            23.15244506307
        ],
        [
            113.14363832679,
            23.152475557106
        ],
        [
            113.14352425408,
            23.152492382722
        ],
        [
            113.1433739453,
            23.152494763132
        ],
        [
            113.14334475249,
            23.152499973549
        ],
        [
            113.14332988166,
            23.152497283586
        ],
        [
            113.1432985182,
            23.152492147659
        ],
        [
            113.14313469825,
            23.152498902692
        ],
        [
            113.14296034404,
            23.15251469645
        ],
        [
            113.14283059411,
            23.152527434368
        ],
        [
            113.1427659921,
            23.152536654709
        ],
        [
            113.14269543775,
            23.152538990558
        ],
        [
            113.14252622908,
            23.152560545425
        ],
        [
            113.14235376555,
            23.152565758174
        ],
        [
            113.14224428661,
            23.15256823697
        ],
        [
            113.1421040115,
            23.152595961229
        ],
        [
            113.14202481401,
            23.15260383346
        ],
        [
            113.14189966526,
            23.152614715988
        ],
        [
            113.14178344635,
            23.152636599814
        ],
        [
            113.14168398299,
            23.152652527883
        ],
        [
            113.14160154626,
            23.152663862719
        ],
        [
            113.14154181193,
            23.152669889164
        ],
        [
            113.14150046259,
            23.152680572264
        ],
        [
            113.14146449692,
            23.152662317835
        ],
        [
            113.14139607437,
            23.152618814571
        ],
        [
            113.14128842808,
            23.152537735237
        ],
        [
            113.14119429474,
            23.152452546008
        ],
        [
            113.14110798221,
            23.152343072598
        ],
        [
            113.14102084203,
            23.152210793511
        ],
        [
            113.14098109792,
            23.152198709663
        ],
        [
            113.14090436311,
            23.15223997354
        ],
        [
            113.14090598496,
            23.152240001689
        ],
        [
            113.14081519953,
            23.152287531569
        ],
        [
            113.14072873714,
            23.152332150541
        ],
        [
            113.14070550637,
            23.152351823097
        ],
        [
            113.14071715736,
            23.152388109571
        ],
        [
            113.14074747567,
            23.152445611301
        ],
        [
            113.14089521784,
            23.152647046191
        ],
        [
            113.1409349949,
            23.152701184001
        ],
        [
            113.14098291829,
            23.152802398914
        ],
        [
            113.14097832348,
            23.152802861854
        ],
        [
            113.14096480166,
            23.152794488137
        ],
        [
            113.14096507666,
            23.152800461669
        ],
        [
            113.14095210102,
            23.152799151378
        ],
        [
            113.14086884308,
            23.152793636796
        ],
        [
            113.14044365535,
            23.15278813409
        ],
        [
            113.14005010222,
            23.152786406476
        ],
        [
            113.13977682938,
            23.152778355697
        ],
        [
            113.13916569837,
            23.152770031857
        ],
        [
            113.1391597524,
            23.152770469469
        ],
        [
            113.13903568764,
            23.152766378349
        ],
        [
            113.13899833156,
            23.152694364163
        ],
        [
            113.13891876032,
            23.152557303401
        ],
        [
            113.13890007844,
            23.152516005556
        ],
        [
            113.13884188099,
            23.152405096475
        ],
        [
            113.13868759948,
            23.152120205829
        ],
        [
            113.13863591407,
            23.152040068635
        ],
        [
            113.13858559893,
            23.151984373021
        ],
        [
            113.13858829974,
            23.15198170784
        ],
        [
            113.13855559089,
            23.15197570184
        ],
        [
            113.13853152856,
            23.151966322086
        ],
        [
            113.13848125174,
            23.151960818217
        ],
        [
            113.13838773661,
            23.151964313863
        ],
        [
            113.13835962831,
            23.15196571414
        ],
        [
            113.13823205868,
            23.151970231788
        ],
        [
            113.1382050314,
            23.151971379571
        ],
        [
            113.13812747923,
            23.151995775828
        ],
        [
            113.13804154464,
            23.152015139093
        ],
        [
            113.13789375473,
            23.152085221173
        ],
        [
            113.13785593597,
            23.152111950365
        ],
        [
            113.1376641252,
            23.152226283889
        ],
        [
            113.1369574252,
            23.152673828328
        ],
        [
            113.13668944448,
            23.152844314094
        ],
        [
            113.1363766139,
            23.153033533621
        ],
        [
            113.13616589781,
            23.153158646971
        ],
        [
            113.13599570882,
            23.153265220805
        ],
        [
            113.13598923038,
            23.153275415013
        ],
        [
            113.13567991021,
            23.153457918292
        ],
        [
            113.13531653721,
            23.153643532997
        ],
        [
            113.13519470924,
            23.153726284478
        ],
        [
            113.13512960978,
            23.153772334039
        ],
        [
            113.13496374351,
            23.153876008868
        ],
        [
            113.13457796263,
            23.154093258385
        ],
        [
            113.13409468867,
            23.154406468402
        ],
        [
            113.1338755943,
            23.154533095106
        ],
        [
            113.13365595261,
            23.154652664381
        ],
        [
            113.13323558753,
            23.15489269901
        ],
        [
            113.13269608218,
            23.155206645679
        ],
        [
            113.13263312898,
            23.155236475156
        ],
        [
            113.13193556523,
            23.155639717485
        ],
        [
            113.13140820023,
            23.155952118906
        ],
        [
            113.13076329902,
            23.156336112407
        ],
        [
            113.13044988331,
            23.156512840378
        ],
        [
            113.13033829509,
            23.156575524593
        ],
        [
            113.13022508323,
            23.156637099906
        ],
        [
            113.13016024022,
            23.156676974869
        ],
        [
            113.130107016,
            23.156711077823
        ],
        [
            113.13006675295,
            23.156729120861
        ],
        [
            113.12996921607,
            23.156787713117
        ],
        [
            113.12995112519,
            23.156811284991
        ],
        [
            113.12994382828,
            23.156813604332
        ],
        [
            113.12992222372,
            23.156837931343
        ],
        [
            113.12985686655,
            23.156907919728
        ],
        [
            113.12976613895,
            23.157023065792
        ],
        [
            113.12969141367,
            23.157195186534
        ],
        [
            113.129634096,
            23.157481009138
        ],
        [
            113.12962874742,
            23.15783308662
        ],
        [
            113.12963416769,
            23.158134879599
        ],
        [
            113.1296795117,
            23.158627803068
        ],
        [
            113.12971339558,
            23.159005769779
        ],
        [
            113.12976694565,
            23.15931026814
        ],
        [
            113.12985696415,
            23.159585533739
        ],
        [
            113.12995377209,
            23.159891846284
        ],
        [
            113.13011112615,
            23.160188870802
        ],
        [
            113.13023269471,
            23.160382469877
        ],
        [
            113.13030983825,
            23.160483888595
        ],
        [
            113.13033907666,
            23.160527522241
        ],
        [
            113.13038806129,
            23.160583699485
        ],
        [
            113.13046949721,
            23.16065236512
        ],
        [
            113.13064588228,
            23.16078776131
        ],
        [
            113.13068538114,
            23.160819905665
        ],
        [
            113.13101565376,
            23.16103445213
        ],
        [
            113.13101835455,
            23.161032056445
        ],
        [
            113.1313589438,
            23.161297003486
        ],
        [
            113.13135949147,
            23.161304067167
        ],
        [
            113.13157238772,
            23.161466452645
        ],
        [
            113.1319806029,
            23.161789323415
        ],
        [
            113.1320377138,
            23.16186601145
        ],
        [
            113.13204910975,
            23.161909077423
        ],
        [
            113.132045917,
            23.16195975857
        ],
        [
            113.1320178249,
            23.161979077591
        ],
        [
            113.1318800149,
            23.162023899391
        ],
        [
            113.13184110311,
            23.16203597797
        ],
        [
            113.13175678695,
            23.16205514023
        ],
        [
            113.13168193192,
            23.162075010105
        ],
        [
            113.13034859071,
            23.162473848611
        ],
        [
            113.13024751074,
            23.1624962885
        ],
        [
            113.13008644472,
            23.162546481305
        ],
        [
            113.13000321007,
            23.162573841542
        ],
        [
            113.12988861809,
            23.162603119965
        ],
        [
            113.12980700196,
            23.162628070658
        ],
        [
            113.12971186909,
            23.162653611604
        ],
        [
            113.12967755531,
            23.16267257345
        ],
        [
            113.12967052501,
            23.162671099482
        ],
        [
            113.12967404057,
            23.162672243449
        ],
        [
            113.12928772741,
            23.16294500616
        ],
        [
            113.12928286716,
            23.162950894677
        ],
        [
            113.12928964382,
            23.162968642666
        ],
        [
            113.12928099536,
            23.162971212608
        ],
        [
            113.12955036501,
            23.164402012115
        ],
        [
            113.12955500477,
            23.164444957875
        ],
        [
            113.12957774073,
            23.164471654628
        ],
        [
            113.1295988393,
            23.164483401684
        ],
        [
            113.12973265072,
            23.164477224361
        ],
        [
            113.12975913562,
            23.16446925624
        ],
        [
            113.12982266331,
            23.164467877377
        ],
        [
            113.12997619742,
            23.164452273429
        ],
        [
            113.13007485769,
            23.164441451013
        ],
        [
            113.13014865237,
            23.164435910351
        ],
        [
            113.13027812731,
            23.16442344284
        ],
        [
            113.1302810993,
            23.164421865109
        ],
        [
            113.13033409138,
            23.164429543381
        ],
        [
            113.13034951446,
            23.1644436414
        ],
        [
            113.13035737157,
            23.164460867379
        ],
        [
            113.1303955794,
            23.164550506464
        ],
        [
            113.13044654966,
            23.164695982606
        ],
        [
            113.13050457761,
            23.164870067714
        ],
        [
            113.13050785382,
            23.164901596323
        ],
        [
            113.13050812805,
            23.164905399446
        ],
        [
            113.13054853695,
            23.165032791001
        ],
        [
            113.13067816209,
            23.16543328971
        ],
        [
            113.13058899955,
            23.165475999937
        ],
        [
            113.13040172962,
            23.165539299021
        ],
        [
            113.13040200358,
            23.165542830812
        ],
        [
            113.13035254913,
            23.165557730818
        ],
        [
            113.13022904585,
            23.165593358367
        ],
        [
            113.13010661741,
            23.165623582263
        ],
        [
            113.13001661988,
            23.165645944731
        ],
        [
            113.12997634209,
            23.165647710003
        ],
        [
            113.1299352646,
            23.165660586475
        ],
        [
            113.12992985225,
            23.165655069272
        ],
        [
            113.12975849191,
            23.16568665661
        ],
        [
            113.12953712129,
            23.165722846902
        ],
        [
            113.12943277522,
            23.165728708467
        ],
        [
            113.1294327794,
            23.165732778332
        ],
        [
            113.12939412184,
            23.165734306914
        ],
        [
            113.12931330301,
            23.165748160341
        ],
        [
            113.12928897344,
            23.165749656487
        ],
        [
            113.12926923756,
            23.165749058334
        ],
        [
            113.12924059928,
            23.165767034058
        ],
        [
            113.12920547639,
            23.165788701318
        ],
        [
            113.12917468046,
            23.165811797105
        ],
        [
            113.12915578891,
            23.165843772059
        ],
        [
            113.12914041666,
            23.165880417682
        ],
        [
            113.12914368542,
            23.165904347793
        ],
        [
            113.12913965018,
            23.165923816184
        ],
        [
            113.1291442799,
            23.165956722318
        ],
        [
            113.12915756259,
            23.165991399291
        ],
        [
            113.12915216221,
            23.165997821769
        ],
        [
            113.12917680444,
            23.166037298901
        ],
        [
            113.12918411566,
            23.166048815152
        ],
        [
            113.12927593842,
            23.166219366367
        ],
        [
            113.12936723795,
            23.166407547605
        ],
        [
            113.12936805123,
            23.166409731655
        ],
        [
            113.12938133452,
            23.166445223628
        ],
        [
            113.12944328658,
            23.166487493002
        ],
        [
            113.12945032062,
            23.166492493647
        ],
        [
            113.12953883728,
            23.166604393145
        ],
        [
            113.12958648626,
            23.16667166015
        ],
        [
            113.12956674912,
            23.166669432059
        ],
        [
            113.1294745931,
            23.166699100083
        ],
        [
            113.12939620256,
            23.166707836539
        ],
        [
            113.12934187634,
            23.166720501189
        ],
        [
            113.1293326928,
            23.166728488514
        ],
        [
            113.12933161308,
            23.166730098532
        ],
        [
            113.12934513751,
            23.166737105766
        ],
        [
            113.12938788967,
            23.166773900551
        ],
        [
            113.12939140587,
            23.166775586831
        ],
        [
            113.12944147146,
            23.166826341106
        ],
        [
            113.12946204012,
            23.166848388517
        ],
        [
            113.12950181477,
            23.166881879633
        ],
        [
            113.12951263169,
            23.166885044123
        ],
        [
            113.12957486766,
            23.166941158269
        ],
        [
            113.12965793986,
            23.167017156376
        ],
        [
            113.12970177911,
            23.167060485486
        ],
        [
            113.1297326179,
            23.167080264435
        ],
        [
            113.12975346204,
            23.167107744836
        ],
        [
            113.12976726059,
            23.167118828361
        ],
        [
            113.12979269463,
            23.167140688084
        ],
        [
            113.12984572727,
            23.167186343649
        ],
        [
            113.12989578181,
            23.167227880393
        ],
        [
            113.12990634338,
            23.167245964576
        ],
        [
            113.12993312415,
            23.167263235598
        ],
        [
            113.12994964453,
            23.167292544008
        ],
        [
            113.12997346151,
            23.167319533134
        ],
        [
            113.12999785662,
            23.167383160284
        ],
        [
            113.13002142068,
            23.167427238648
        ],
        [
            113.13004879438,
            23.167495799992
        ],
        [
            113.13013281797,
            23.167711827571
        ],
        [
            113.13013582881,
            23.167748235077
        ],
        [
            113.13020739775,
            23.167945876407
        ],
        [
            113.13026809777,
            23.16808934321
        ],
        [
            113.13032720613,
            23.168262900638
        ],
        [
            113.13036295374,
            23.168326179684
        ],
        [
            113.13046327522,
            23.168621987586
        ],
        [
            113.13050555767,
            23.168732045687
        ],
        [
            113.13053264315,
            23.168784326885
        ],
        [
            113.13055949732,
            23.168875131664
        ],
        [
            113.13056491902,
            23.168890146206
        ],
        [
            113.13054412465,
            23.168910413647
        ],
        [
            113.13053926094,
            23.168912501698
        ],
        [
            113.13050549956,
            23.168941231659
        ],
        [
            113.13046200568,
            23.168969254439
        ],
        [
            113.13038500058,
            23.169006478198
        ],
        [
            113.13036122656,
            23.169020998652
        ],
        [
            113.13035257732,
            23.169022209005
        ],
        [
            113.13007374664,
            23.169169445264
        ],
        [
            113.12992588935,
            23.169184054595
        ],
        [
            113.12992237193,
            23.169181011085
        ],
        [
            113.1298907472,
            23.169185364517
        ],
        [
            113.12985183859,
            23.169204790106
        ],
        [
            113.12978725845,
            23.169234639338
        ],
        [
            113.12974727204,
            23.169257846676
        ],
        [
            113.12972430064,
            23.169265059672
        ],
        [
            113.12969997749,
            23.169272250265
        ],
        [
            113.12968808926,
            23.169278834706
        ],
        [
            113.12968024931,
            23.169278703806
        ],
        [
            113.12967593972,
            23.169294368354
        ],
        [
            113.12967649658,
            23.169310385464
        ],
        [
            113.12966297695,
            23.169307717928
        ],
        [
            113.12966110729,
            23.16933020619
        ],
        [
            113.12965031246,
            23.169348747056
        ],
        [
            113.1296555098,
            23.16940906656
        ],
        [
            113.129659684,
            23.169527159889
        ],
        [
            113.12968316161,
            23.1700232509
        ],
        [
            113.12968994956,
            23.170052666634
        ],
        [
            113.12969064757,
            23.170209771652
        ],
        [
            113.12970153834,
            23.170287007939
        ],
        [
            113.13036636285,
            23.17036438391
        ],
        [
            113.13074540275,
            23.17041069844
        ],
        [
            113.13109956663,
            23.170458255291
        ],
        [
            113.13135179232,
            23.170481573057
        ],
        [
            113.13152238685,
            23.170510282982
        ],
        [
            113.1316397198,
            23.170529398606
        ],
        [
            113.13185192774,
            23.170546902142
        ],
        [
            113.13203089119,
            23.170569265668
        ],
        [
            113.13203170184,
            23.170569008408
        ],
        [
            113.13219714669,
            23.170589244825
        ],
        [
            113.13229364745,
            23.170592821956
        ],
        [
            113.13230688479,
            23.170585455368
        ],
        [
            113.13239067247,
            23.170580402384
        ],
        [
            113.13239607313,
            23.170575070093
        ],
        [
            113.13239472512,
            23.170578573746
        ],
        [
            113.13245742188,
            23.170566100306
        ],
        [
            113.1326595944,
            23.170556605059
        ],
        [
            113.13277796623,
            23.170539139427
        ],
        [
            113.13286525217,
            23.170520046759
        ],
        [
            113.13288228366,
            23.170523058149
        ],
        [
            113.13289443409,
            23.170510247663
        ],
        [
            113.13291091064,
            23.170498869567
        ],
        [
            113.13300138963,
            23.170429641108
        ],
        [
            113.13309053143,
            23.170375041763
        ],
        [
            113.13311348762,
            23.170356452353
        ],
        [
            113.1331159276,
            23.170363820765
        ],
        [
            113.133144024,
            23.170349934099
        ],
        [
            113.13319373315,
            23.170325574408
        ],
        [
            113.13322884818,
            23.170302857913
        ],
        [
            113.13325586925,
            23.170294921864
        ],
        [
            113.13326370292,
            23.170290175813
        ],
        [
            113.13330884805,
            23.170296938415
        ],
        [
            113.13332402736,
            23.170340073584
        ],
        [
            113.13335870086,
            23.170416652464
        ],
        [
            113.13340233774,
            23.170537342752
        ],
        [
            113.13343632587,
            23.170740344077
        ],
        [
            113.13346854685,
            23.171070019696
        ],
        [
            113.13348501149,
            23.171320464346
        ],
        [
            113.1335001144,
            23.171561388777
        ],
        [
            113.13352802755,
            23.171912422101
        ],
        [
            113.13353486879,
            23.171998550075
        ],
        [
            113.1336170037,
            23.173084720392
        ],
        [
            113.13363914395,
            23.173343945937
        ],
        [
            113.13365087823,
            23.173461903787
        ],
        [
            113.13367187132,
            23.173653280021
        ],
        [
            113.13368031696,
            23.174011836207
        ],
        [
            113.13367954017,
            23.174338214101
        ],
        [
            113.13370761026,
            23.174587233197
        ],
        [
            113.13371305462,
            23.174629111631
        ],
        [
            113.1337476775,
            23.174952043531
        ],
        [
            113.13379021188,
            23.175358679276
        ],
        [
            113.13378805226,
            23.1753616256
        ],
        [
            113.13383011251,
            23.175847475718
        ],
        [
            113.13384439769,
            23.176106831365
        ],
        [
            113.13384318749,
            23.176266884173
        ],
        [
            113.13386348962,
            23.176610723472
        ],
        [
            113.13390308245,
            23.177392527197
        ],
        [
            113.13399502164,
            23.178088976551
        ],
        [
            113.13404041507,
            23.17873413751
        ],
        [
            113.13408751027,
            23.179155226381
        ],
        [
            113.1340975754,
            23.179237067977
        ],
        [
            113.13412674902,
            23.179560710882
        ],
        [
            113.13414501542,
            23.179764242776
        ],
        [
            113.13415896484,
            23.179979635499
        ],
        [
            113.13418496016,
            23.180401704612
        ],
        [
            113.13424604914,
            23.181146160685
        ],
        [
            113.13425241059,
            23.181348937172
        ],
        [
            113.13428167393,
            23.181838072098
        ],
        [
            113.13427237438,
            23.18207149864
        ],
        [
            113.13423195345,
            23.182250655977
        ],
        [
            113.13412619153,
            23.182533650436
        ],
        [
            113.13391783886,
            23.183003928651
        ],
        [
            113.13371818691,
            23.183573930903
        ],
        [
            113.13369040413,
            23.183665953705
        ],
        [
            113.13365966087,
            23.183779356919
        ],
        [
            113.13365615471,
            23.183791774821
        ],
        [
            113.13364347699,
            23.183834145128
        ],
        [
            113.13362188239,
            23.183880970321
        ],
        [
            113.13362485838,
            23.183885634851
        ],
        [
            113.13359139392,
            23.183970503906
        ],
        [
            113.13348479421,
            23.184246163607
        ],
        [
            113.13342568713,
            23.184393251402
        ],
        [
            113.13336147311,
            23.184591796085
        ],
        [
            113.13331693823,
            23.184701973175
        ],
        [
            113.13321196333,
            23.185000995659
        ],
        [
            113.1331339766,
            23.185232669059
        ],
        [
            113.1330972644,
            23.185320195674
        ],
        [
            113.13306164552,
            23.18543107297
        ],
        [
            113.13300224874,
            23.185558082464
        ],
        [
            113.13298281958,
            23.185618511829
        ],
        [
            113.13310365481,
            23.185645047375
        ],
        [
            113.13317150205,
            23.185652206755
        ],
        [
            113.13320529233,
            23.185659311211
        ],
        [
            113.13327800419,
            23.185665743335
        ],
        [
            113.13333098547,
            23.185673728387
        ],
        [
            113.13333017602,
            23.185676427095
        ],
        [
            113.13337153489,
            23.185684750715
        ],
        [
            113.13338694644,
            23.185694245827
        ],
        [
            113.13341290466,
            23.185713964433
        ],
        [
            113.13340506347,
            23.185708671871
        ],
        [
            113.13343859071,
            23.185730151526
        ],
        [
            113.13344805988,
            23.185747409716
        ],
        [
            113.13345887768,
            23.185759265779
        ],
        [
            113.13347077733,
            23.185772497375
        ],
        [
            113.1334980938,
            23.185805533613
        ],
        [
            113.13351054484,
            23.185839664602
        ],
        [
            113.13351002083,
            23.185871668028
        ],
        [
            113.13350731651,
            23.185868907465
        ],
        [
            113.13350842664,
            23.185925084788
        ],
        [
            113.13351765135,
            23.185993070611
        ],
        [
            113.13350632152,
            23.186036820589
        ],
        [
            113.13350689091,
            23.186093530893
        ],
        [
            113.13349826269,
            23.18613515808
        ],
        [
            113.13349721714,
            23.186205947125
        ],
        [
            113.13347833518,
            23.186282661794
        ],
        [
            113.13347887563,
            23.186282400017
        ],
        [
            113.13347215667,
            23.186359600106
        ],
        [
            113.13347245064,
            23.186407624041
        ],
        [
            113.13345706515,
            23.186450488665
        ],
        [
            113.13344873436,
            23.186549363654
        ],
        [
            113.13342958462,
            23.186633940978
        ],
        [
            113.13339451513,
            23.18677683716
        ],
        [
            113.13339265335,
            23.186840829175
        ],
        [
            113.13338780212,
            23.186870585869
        ],
        [
            113.13340567042,
            23.186932754635
        ],
        [
            113.13344975211,
            23.186985075724
        ],
        [
            113.13347030917,
            23.187017449937
        ],
        [
            113.13348681192,
            23.187050024107
        ],
        [
            113.13346439602,
            23.187089509192
        ],
        [
            113.13348225707,
            23.187137299517
        ],
        [
            113.13348361126,
            23.187143291754
        ],
        [
            113.13348766873,
            23.187150145461
        ],
        [
            113.13349877381,
            23.187201072334
        ],
        [
            113.13348445743,
            23.187220895735
        ],
        [
            113.13345797248,
            23.187228568166
        ],
        [
            113.13343879607,
            23.187259971592
        ],
        [
            113.13337312959,
            23.187291370984
        ],
        [
            113.13328555342,
            23.187287389461
        ],
        [
            113.13325447388,
            23.187296338418
        ],
        [
            113.13324149012,
            23.187274678355
        ],
        [
            113.13322120925,
            23.187254789158
        ],
        [
            113.13312525042,
            23.18724388039
        ],
        [
            113.13296468539,
            23.187220717786
        ],
        [
            113.13289332425,
            23.187213499373
        ],
        [
            113.13281871738,
            23.18720188443
        ],
        [
            113.13275600665,
            23.187197532048
        ],
        [
            113.13274302996,
            23.18719215064
        ],
        [
            113.13269194365,
            23.187191800312
        ],
        [
            113.13269788839,
            23.187187834834
        ],
        [
            113.13267329015,
            23.187185234719
        ],
        [
            113.13267707459,
            23.187185843416
        ],
        [
            113.1326435547,
            23.187179289511
        ],
        [
            113.13259570897,
            23.187172757028
        ],
        [
            113.13247271354,
            23.187152163819
        ],
        [
            113.13242513468,
            23.18713885532
        ],
        [
            113.13236999256,
            23.187137081083
        ],
        [
            113.13235757272,
            23.187167791984
        ],
        [
            113.13231707617,
            23.187275332046
        ],
        [
            113.13227280029,
            23.187395285953
        ],
        [
            113.13223338683,
            23.187510170151
        ],
        [
            113.13199335779,
            23.188151942859
        ],
        [
            113.13192776687,
            23.188384927968
        ],
        [
            113.13185514167,
            23.188609110664
        ],
        [
            113.13175306632,
            23.188877004885
        ],
        [
            113.13156784162,
            23.189461413404
        ],
        [
            113.13139850206,
            23.189905303923
        ],
        [
            113.13151206505,
            23.190005462256
        ],
        [
            113.13168484201,
            23.190161715686
        ],
        [
            113.13182190794,
            23.190225393496
        ],
        [
            113.13182325867,
            23.190222704025
        ],
        [
            113.13184218442,
            23.190236595463
        ],
        [
            113.13207578984,
            23.190441662377
        ],
        [
            113.13218502305,
            23.190546645858
        ],
        [
            113.13213423394,
            23.19064559553
        ],
        [
            113.13209559905,
            23.190712474061
        ],
        [
            113.13209343585,
            23.190709723709
        ],
        [
            113.13209100543,
            23.190718091263
        ],
        [
            113.13208235856,
            23.19072852121
        ],
        [
            113.13204913474,
            23.190815026209
        ],
        [
            113.13204184448,
            23.190844469431
        ],
        [
            113.13203130918,
            23.190868973331
        ],
        [
            113.13199564339,
            23.190923425118
        ],
        [
            113.13199780729,
            23.190928888239
        ],
        [
            113.13197214558,
            23.190994636084
        ],
        [
            113.13192863914,
            23.191044069449
        ],
        [
            113.13180516151,
            23.191252175323
        ],
        [
            113.13158222683,
            23.191546463485
        ],
        [
            113.13141685078,
            23.191789666573
        ],
        [
            113.13128470955,
            23.191987600104
        ],
        [
            113.13106203292,
            23.192308775803
        ],
        [
            113.13092879911,
            23.19248879763
        ],
        [
            113.1309336649,
            23.192488880677
        ],
        [
            113.13094610262,
            23.192505098312
        ],
        [
            113.13098530706,
            23.192549172058
        ],
        [
            113.13111697233,
            23.192661290451
        ],
        [
            113.13128649261,
            23.192847578507
        ],
        [
            113.13137382158,
            23.192953790541
        ],
        [
            113.13136679278,
            23.192949871911
        ],
        [
            113.13138059378,
            23.193045326707
        ],
        [
            113.131413586,
            23.193136770978
        ],
        [
            113.13146171457,
            23.193223321615
        ],
        [
            113.13148821257,
            23.193274234698
        ],
        [
            113.13152282356,
            23.193352415073
        ],
        [
            113.1315625692,
            23.193423902292
        ],
        [
            113.13161799851,
            23.193541505551
        ],
        [
            113.13163232873,
            23.193570778979
        ],
        [
            113.13166531355,
            23.193625874013
        ],
        [
            113.13169289178,
            23.193679519581
        ],
        [
            113.13172614666,
            23.193735976059
        ],
        [
            113.13174345162,
            23.193779949936
        ],
        [
            113.13177129965,
            23.193833871864
        ],
        [
            113.13180671547,
            23.193881685489
        ],
        [
            113.13182401961,
            23.193921861792
        ],
        [
            113.13185132518,
            23.193963024961
        ],
        [
            113.13186727774,
            23.19400480566
        ],
        [
            113.13189431426,
            23.194060884396
        ],
        [
            113.13191702473,
            23.194107393835
        ],
        [
            113.13192865037,
            23.194132280907
        ],
        [
            113.13197055475,
            23.194203537474
        ],
        [
            113.1319856957,
            23.194244490623
        ],
        [
            113.13199272415,
            23.194249766587
        ],
        [
            113.13200948596,
            23.1942809821
        ],
        [
            113.13202624685,
            23.194302431863
        ],
        [
            113.13202786907,
            23.194306800337
        ],
        [
            113.13202192343,
            23.194319447032
        ],
        [
            113.13197218929,
            23.194345983543
        ],
        [
            113.13197732487,
            23.194343088533
        ],
        [
            113.13197137793,
            23.194340815324
        ],
        [
            113.13196813449,
            23.194343743121
        ],
        [
            113.13196489083,
            23.194343958199
        ],
        [
            113.13196029602,
            23.194348761493
        ],
        [
            113.13194759186,
            23.194352067973
        ],
        [
            113.13192245413,
            23.194362212258
        ],
        [
            113.13189731636,
            23.194372356683
        ],
        [
            113.1318727189,
            23.19437925534
        ],
        [
            113.13187055698,
            23.194385728451
        ],
        [
            113.13184352711,
            23.194397468073
        ],
        [
            113.13180271168,
            23.194412224788
        ],
        [
            113.13178838539,
            23.194413333512
        ],
        [
            113.13176919405,
            23.194421140006
        ],
        [
            113.13173675817,
            23.194437127225
        ],
        [
            113.13171648558,
            23.194445457821
        ],
        [
            113.13170945785,
            23.194449676823
        ],
        [
            113.13169837498,
            23.194447857862
        ],
        [
            113.13168864364,
            23.194445790986
        ],
        [
            113.1316416113,
            23.194468037528
        ],
        [
            113.13163377167,
            23.194460306711
        ],
        [
            113.13161403967,
            23.194469732206
        ],
        [
            113.13161376962,
            23.194472982806
        ],
        [
            113.13160701143,
            23.1944679834
        ],
        [
            113.13160863335,
            23.194468553906
        ],
        [
            113.131612958,
            23.194464288128
        ],
        [
            113.13158592774,
            23.194476029366
        ],
        [
            113.13149050706,
            23.194471673119
        ],
        [
            113.13149158861,
            23.194475489534
        ],
        [
            113.13139130181,
            23.194471051859
        ],
        [
            113.13131263947,
            23.194462918822
        ],
        [
            113.13129209544,
            23.194462566177
        ],
        [
            113.13126857694,
            23.194449955395
        ],
        [
            113.13124262546,
            23.194436217941
        ],
        [
            113.13122965037,
            23.194437623068
        ],
        [
            113.13122235144,
            23.194432886308
        ],
        [
            113.13121667438,
            23.194427906094
        ],
        [
            113.13121261949,
            23.194426208953
        ],
        [
            113.13120261732,
            23.194420883349
        ],
        [
            113.13119477791,
            23.194418307549
        ],
        [
            113.13118099085,
            23.194407491708
        ],
        [
            113.13117747643,
            23.194403904963
        ],
        [
            113.13116558181,
            23.194396105587
        ],
        [
            113.13115422809,
            23.19439157077
        ],
        [
            113.13114125164,
            23.194377242422
        ],
        [
            113.13112422071,
            23.194366642507
        ],
        [
            113.1311250318,
            23.194368284022
        ],
        [
            113.13111448823,
            23.194354539956
        ],
        [
            113.13110854018,
            23.194342230925
        ],
        [
            113.13109313109,
            23.194331387633
        ],
        [
            113.13109232021,
            23.194332187573
        ],
        [
            113.13108502089,
            23.194323924532
        ],
        [
            113.13107664069,
            23.194320254633
        ],
        [
            113.13105798775,
            23.194309627265
        ],
        [
            113.13105528311,
            23.194293033433
        ],
        [
            113.13103879331,
            23.194289496217
        ],
        [
            113.13103635924,
            23.194275891011
        ],
        [
            113.13102500538,
            23.194271085303
        ],
        [
            113.13101797653,
            23.194264997185
        ],
        [
            113.13100905518,
            23.194256164021
        ],
        [
            113.13100013407,
            23.1942500436
        ],
        [
            113.13099391604,
            23.194242613021
        ],
        [
            113.13098688763,
            23.194241679135
        ],
        [
            113.13098715817,
            23.194244125204
        ],
        [
            113.13098796864,
            23.19423871361
        ],
        [
            113.13098202072,
            23.194229117489
        ],
        [
            113.1309712069,
            23.194218081911
        ],
        [
            113.13097066569,
            23.194211833411
        ],
        [
            113.13097012539,
            23.194215621992
        ],
        [
            113.13096282548,
            23.194201933729
        ],
        [
            113.13096174382,
            23.194197846178
        ],
        [
            113.13096039146,
            23.194189684923
        ],
        [
            113.13095930878,
            23.19417474647
        ],
        [
            113.13095011645,
            23.194159669553
        ],
        [
            113.13095362888,
            23.194141283011
        ],
        [
            113.13094308463,
            23.194123199029
        ],
        [
            113.13094984116,
            23.194107851853
        ],
        [
            113.13093875492,
            23.194076466278
        ],
        [
            113.13094145625,
            23.19405752332
        ],
        [
            113.13093442571,
            23.194035701515
        ],
        [
            113.13093226162,
            23.194020744588
        ],
        [
            113.13092874639,
            23.194010376235
        ],
        [
            113.13092225685,
            23.193992632766
        ],
        [
            113.13091847051,
            23.193974935431
        ],
        [
            113.13091522369,
            23.193946667666
        ],
        [
            113.13091279004,
            23.19393957305
        ],
        [
            113.13090873324,
            23.193921057283
        ],
        [
            113.13089737664,
            23.193892379891
        ],
        [
            113.13089656319,
            23.193869579088
        ],
        [
            113.13088817995,
            23.193840138612
        ],
        [
            113.13088709954,
            23.193847987103
        ],
        [
            113.13088141928,
            23.193816693826
        ],
        [
            113.13088249705,
            23.193785787067
        ],
        [
            113.1308703292,
            23.193756553339
        ],
        [
            113.13086897667,
            23.193748663352
        ],
        [
            113.1308611336,
            23.193716790653
        ],
        [
            113.13085978105,
            23.193708900666
        ],
        [
            113.13085680339,
            23.193674398177
        ],
        [
            113.13085328782,
            23.193662944761
        ],
        [
            113.13084625883,
            23.193657942027
        ],
        [
            113.13084220197,
            23.193641325196
        ],
        [
            113.13083841452,
            23.19361738857
        ],
        [
            113.13083570779,
            23.19358912998
        ],
        [
            113.13082867704,
            23.193570292285
        ],
        [
            113.13082489108,
            23.193558834278
        ],
        [
            113.13082218571,
            23.193541969207
        ],
        [
            113.13081569377,
            23.193509305738
        ],
        [
            113.13081028243,
            23.193471777746
        ],
        [
            113.1308048716,
            23.193438590142
        ],
        [
            113.13079216082,
            23.193396868714
        ],
        [
            113.13079026602,
            23.193378118523
        ],
        [
            113.13078080101,
            23.193351101201
        ],
        [
            113.13077593033,
            23.193316023876
        ],
        [
            113.13076538488,
            23.193295770047
        ],
        [
            113.13076186615,
            23.193263699756
        ],
        [
            113.13076294349,
            23.193236048079
        ],
        [
            113.13075537069,
            23.193210148093
        ],
        [
            113.13074806818,
            23.193184252715
        ],
        [
            113.13074103895,
            23.19317870761
        ],
        [
            113.13073346662,
            23.193156605513
        ],
        [
            113.13072994829,
            23.193128875615
        ],
        [
            113.13071913249,
            23.193109973661
        ],
        [
            113.13067506797,
            23.193099187282
        ],
        [
            113.13066614677,
            23.193096051641
        ],
        [
            113.13060937536,
            23.193075826819
        ],
        [
            113.13058477442,
            23.193067542268
        ],
        [
            113.13054045461,
            23.19315929521
        ],
        [
            113.13054315837,
            23.193162596359
        ],
        [
            113.13051586897,
            23.193256808573
        ],
        [
            113.13051181766,
            23.193282239716
        ],
        [
            113.13044075698,
            23.193548241115
        ],
        [
            113.13040076777,
            23.193707344561
        ],
        [
            113.13039428026,
            23.193710761376
        ],
        [
            113.13033915996,
            23.193952890154
        ],
        [
            113.13021022118,
            23.194044302914
        ],
        [
            113.13014940623,
            23.194147175514
        ],
        [
            113.13013021469,
            23.194170181788
        ],
        [
            113.13013103231,
            23.194242625181
        ],
        [
            113.13014266365,
            23.19432257492
        ],
        [
            113.13015456807,
            23.194441321051
        ],
        [
            113.13015646968,
            23.194563967664
        ],
        [
            113.13015403696,
            23.194567995758
        ],
        [
            113.13014809031,
            23.19457766137
        ],
        [
            113.13014079216,
            23.194589745674
        ],
        [
            113.13014106295,
            23.194596260737
        ],
        [
            113.13012754643,
            23.19459874589
        ],
        [
            113.13011240831,
            23.194607443042
        ],
        [
            113.1300918636,
            23.194617676934
        ],
        [
            113.13007131883,
            23.194627639685
        ],
        [
            113.13004969261,
            23.194636499305
        ],
        [
            113.13003698739,
            23.194644695163
        ],
        [
            113.13001130603,
            23.194652944357
        ],
        [
            113.12997210813,
            23.194666392275
        ],
        [
            113.12993669502,
            23.194682345596
        ],
        [
            113.129886143,
            23.19470048703
        ],
        [
            113.12984829585,
            23.194704735925
        ],
        [
            113.12980666463,
            23.194721129144
        ],
        [
            113.12976395185,
            23.194736691032
        ],
        [
            113.12973475619,
            23.194755192031
        ],
        [
            113.12969880175,
            23.194771139019
        ],
        [
            113.12966041385,
            23.194782434235
        ],
        [
            113.12962094487,
            23.194800493677
        ],
        [
            113.1296052651,
            23.194802945036
        ],
        [
            113.12959607356,
            23.194805233306
        ],
        [
            113.12957633834,
            23.194803276923
        ],
        [
            113.12955281857,
            23.194806411802
        ],
        [
            113.12952713624,
            23.194813579939
        ],
        [
            113.12949415472,
            23.194823882165
        ],
        [
            113.12945819936,
            23.194835220428
        ],
        [
            113.12943711334,
            23.194852773989
        ],
        [
            113.1294117012,
            23.194861303969
        ],
        [
            113.12938223353,
            23.194864884025
        ],
        [
            113.12936925756,
            23.19487796103
        ],
        [
            113.12935087417,
            23.194883081606
        ],
        [
            113.12887339113,
            23.194311776277
        ],
        [
            113.12883499968,
            23.1943046361
        ],
        [
            113.12874307651,
            23.194292822366
        ],
        [
            113.12872712454,
            23.194284694563
        ],
        [
            113.12869468022,
            23.194273042032
        ],
        [
            113.12863952685,
            23.194278109291
        ],
        [
            113.12861276263,
            23.194297746723
        ],
        [
            113.12857870599,
            23.194408684069
        ],
        [
            113.12846868815,
            23.1946974246
        ],
        [
            113.12836055283,
            23.194895595314
        ],
        [
            113.12823024528,
            23.195124065198
        ],
        [
            113.12798989202,
            23.195402583214
        ],
        [
            113.12772735833,
            23.195680227388
        ],
        [
            113.12750239866,
            23.195902614282
        ],
        [
            113.12742263352,
            23.195994395072
        ],
        [
            113.12737125897,
            23.196038341571
        ],
        [
            113.12734313796,
            23.196066922843
        ],
        [
            113.12706868018,
            23.196402501679
        ],
        [
            113.12720333416,
            23.196520175131
        ],
        [
            113.12741179984,
            23.196702227945
        ],
        [
            113.12741261064,
            23.19671064999
        ],
        [
            113.12740368716,
            23.196723800797
        ],
        [
            113.12740693128,
            23.196736059042
        ],
        [
            113.12739800786,
            23.196747311014
        ],
        [
            113.12739746621,
            23.19676574846
        ],
        [
            113.12739232844,
            23.196772720092
        ],
        [
            113.12739962794,
            23.196794265459
        ],
        [
            113.12740070899,
            23.19680459062
        ],
        [
            113.12740368167,
            23.196836375615
        ],
        [
            113.12740773671,
            23.196852173116
        ],
        [
            113.12741557748,
            23.196862605232
        ],
        [
            113.12742314739,
            23.196881442288
        ],
        [
            113.1274247688,
            23.196898557617
        ],
        [
            113.12743396069,
            23.196923116928
        ],
        [
            113.12743747505,
            23.196935650734
        ],
        [
            113.12743909626,
            23.196955207439
        ],
        [
            113.12743828481,
            23.196960077349
        ],
        [
            113.12744423192,
            23.196984856575
        ],
        [
            113.12744693487,
            23.197000632708
        ],
        [
            113.12744504088,
            23.197021218792
        ],
        [
            113.12744368847,
            23.19702879277
        ],
        [
            113.12744368764,
            23.1970420847
        ],
        [
            113.1274442273,
            23.197059725412
        ],
        [
            113.12744584959,
            23.197060564896
        ],
        [
            113.12744774181,
            23.197068461522
        ],
        [
            113.12744963403,
            23.197076358148
        ],
        [
            113.12744016984,
            23.197084888713
        ],
        [
            113.12744179186,
            23.19708979715
        ],
        [
            113.1274252983,
            23.197086280857
        ],
        [
            113.12740799325,
            23.19708736333
        ],
        [
            113.12740853349,
            23.197095509797
        ],
        [
            113.12739447362,
            23.197088777061
        ],
        [
            113.12737446434,
            23.197093885979
        ],
        [
            113.12735688894,
            23.197093065715
        ],
        [
            113.12734066528,
            23.197095250835
        ],
        [
            113.12732498214,
            23.197100971033
        ],
        [
            113.12708108474,
            23.197110697447
        ],
        [
            113.12708135483,
            23.197115313167
        ],
        [
            113.12707919005,
            23.197138879186
        ],
        [
            113.12708784007,
            23.197178348049
        ],
        [
            113.12708405465,
            23.197176118587
        ],
        [
            113.12709405786,
            23.197197705275
        ],
        [
            113.12709027147,
            23.19720903897
        ],
        [
            113.12693314914,
            23.197460211829
        ],
        [
            113.12681064151,
            23.197623773105
        ],
        [
            113.12675736393,
            23.197702424926
        ],
        [
            113.12663674243,
            23.197889624656
        ],
        [
            113.12663566076,
            23.19788987918
        ],
        [
            113.12657940455,
            23.197986934874
        ],
        [
            113.12653558726,
            23.19807767354
        ],
        [
            113.12647905685,
            23.19819290195
        ],
        [
            113.12641685128,
            23.198272780615
        ],
        [
            113.12639088745,
            23.198302762889
        ],
        [
            113.12636789595,
            23.198348795459
        ],
        [
            113.12632407916,
            23.198416481067
        ],
        [
            113.12631650448,
            23.19843806581
        ],
        [
            113.1263105542,
            23.198445841191
        ],
        [
            113.12629757187,
            23.198461917956
        ],
        [
            113.12629567811,
            23.19846785668
        ],
        [
            113.12634029077,
            23.198513026943
        ],
        [
            113.12637571159,
            23.198539882603
        ],
        [
            113.12637733327,
            23.198545603956
        ],
        [
            113.12638301138,
            23.198550031291
        ],
        [
            113.12637678769,
            23.198578418026
        ],
        [
            113.12637246028,
            23.198583505535
        ],
        [
            113.12636705215,
            23.198582066232
        ],
        [
            113.1263378416,
            23.198619323256
        ],
        [
            113.12631972078,
            23.19863830493
        ],
        [
            113.12630619944,
            23.198641081628
        ],
        [
            113.12628348049,
            23.198666232156
        ],
        [
            113.12620072324,
            23.198723016603
        ],
        [
            113.12607929478,
            23.19877785958
        ],
        [
            113.12602682665,
            23.198813411079
        ],
        [
            113.12595840379,
            23.198843568253
        ],
        [
            113.12583697169,
            23.198900324404
        ],
        [
            113.12570580042,
            23.19896806318
        ],
        [
            113.12554136221,
            23.199041009809
        ],
        [
            113.12554379653,
            23.199038876106
        ],
        [
            113.12539720422,
            23.199113729047
        ],
        [
            113.12526440935,
            23.199148108416
        ],
        [
            113.12516812533,
            23.199171642125
        ],
        [
            113.12511916955,
            23.199194791671
        ],
        [
            113.12497041132,
            23.199241977078
        ],
        [
            113.12482895591,
            23.199273276433
        ],
        [
            113.12470508187,
            23.199285853326
        ],
        [
            113.12455659446,
            23.199293201019
        ],
        [
            113.12447004209,
            23.199303890886
        ],
        [
            113.12440376983,
            23.199339017322
        ],
        [
            113.12431775125,
            23.199379560502
        ],
        [
            113.12429800581,
            23.199383076236
        ],
        [
            113.12428664375,
            23.199393764439
        ],
        [
            113.12426744059,
            23.199389964295
        ],
        [
            113.124252293,
            23.199394359846
        ],
        [
            113.12420441936,
            23.199388524691
        ],
        [
            113.12419305883,
            23.199390533276
        ],
        [
            113.12419224791,
            23.199387809178
        ],
        [
            113.12418007839,
            23.199376785992
        ],
        [
            113.12416601442,
            23.199371432403
        ],
        [
            113.12415898291,
            23.199366178711
        ],
        [
            113.12415411631,
            23.199355259353
        ],
        [
            113.12413383458,
            23.199331914809
        ],
        [
            113.1241081513,
            23.199264278975
        ],
        [
            113.12411197678,
            23.199046241636
        ],
        [
            113.12411848037,
            23.198975535297
        ],
        [
            113.12412606006,
            23.198938480267
        ],
        [
            113.12412931676,
            23.19887206802
        ],
        [
            113.12412499637,
            23.198826706543
        ],
        [
            113.12411931683,
            23.198823099696
        ],
        [
            113.12401220898,
            23.198799613426
        ],
        [
            113.12389103475,
            23.198773494883
        ],
        [
            113.12387832207,
            23.198771417661
        ],
        [
            113.12378446475,
            23.198751386496
        ],
        [
            113.12375552394,
            23.198738775607
        ],
        [
            113.12375065557,
            23.198735452546
        ],
        [
            113.12372144419,
            23.198722567195
        ],
        [
            113.12364733096,
            23.198705260186
        ],
        [
            113.12351019328,
            23.198669181452
        ],
        [
            113.12311229049,
            23.198570418641
        ],
        [
            113.12291698018,
            23.198544721729
        ],
        [
            113.12275574694,
            23.198550426676
        ],
        [
            113.1225217255,
            23.198632222251
        ],
        [
            113.12243704098,
            23.198675592336
        ],
        [
            113.12222275515,
            23.19878291879
        ],
        [
            113.12195382003,
            23.198833420889
        ],
        [
            113.12193596161,
            23.198844313175
        ],
        [
            113.12170814096,
            23.198900540327
        ],
        [
            113.12147192906,
            23.198934995762
        ],
        [
            113.12122299479,
            23.198953869295
        ],
        [
            113.12113288954,
            23.198959268269
        ],
        [
            113.12099678208,
            23.198969806791
        ],
        [
            113.12085769782,
            23.198966487713
        ],
        [
            113.12070643419,
            23.198960865537
        ],
        [
            113.12066936136,
            23.198962862099
        ],
        [
            113.12042203034,
            23.198937133621
        ],
        [
            113.12006887892,
            23.198896928909
        ],
        [
            113.12007023286,
            23.198892061909
        ],
        [
            113.11977497734,
            23.198868063447
        ],
        [
            113.11951868296,
            23.198840493487
        ],
        [
            113.11939662012,
            23.198836966028
        ],
        [
            113.11925479332,
            23.198855746984
        ],
        [
            113.11906261658,
            23.19889298469
        ],
        [
            113.11880031695,
            23.199001114562
        ],
        [
            113.118618137,
            23.199066461938
        ],
        [
            113.11837342479,
            23.1991124714
        ],
        [
            113.11821857857,
            23.199148860236
        ],
        [
            113.11804667619,
            23.199172346677
        ],
        [
            113.11782577042,
            23.199189131557
        ],
        [
            113.11775863086,
            23.199194165878
        ],
        [
            113.11762110409,
            23.199186581742
        ],
        [
            113.11757751715,
            23.199184530943
        ],
        [
            113.11739639708,
            23.199180889366
        ],
        [
            113.11701383455,
            23.19917322475
        ],
        [
            113.11676798395,
            23.199177214568
        ],
        [
            113.11646714459,
            23.199240715514
        ],
        [
            113.11626999738,
            23.199331222716
        ],
        [
            113.11606146499,
            23.199446078176
        ],
        [
            113.11581798025,
            23.199610590737
        ],
        [
            113.11580227142,
            23.199619954842
        ],
        [
            113.11559615182,
            23.199764476835
        ],
        [
            113.11541710715,
            23.199906536088
        ],
        [
            113.11526026797,
            23.200032791075
        ],
        [
            113.11512400962,
            23.200150544564
        ],
        [
            113.11499505953,
            23.200271081504
        ],
        [
            113.11486637147,
            23.200412520861
        ],
        [
            113.11476314733,
            23.20052568028
        ],
        [
            113.11461901057,
            23.200676254854
        ],
        [
            113.11458351627,
            23.200718041741
        ],
        [
            113.1144732456,
            23.200820053956
        ],
        [
            113.11433262204,
            23.200965534618
        ],
        [
            113.11433424791,
            23.200963376014
        ],
        [
            113.11421665781,
            23.201063462074
        ],
        [
            113.11414214323,
            23.201138085557
        ],
        [
            113.11407521535,
            23.201202186508
        ],
        [
            113.1140204794,
            23.20125687973
        ],
        [
            113.11394298315,
            23.201326341964
        ],
        [
            113.11379936135,
            23.201476206455
        ],
        [
            113.11379068726,
            23.201493238389
        ],
        [
            113.11366278055,
            23.201619081433
        ],
        [
            113.11358364208,
            23.201721920775
        ],
        [
            113.11351317807,
            23.201803662682
        ],
        [
            113.11342732121,
            23.201726631525
        ],
        [
            113.11342298707,
            23.201724705754
        ],
        [
            113.11332927219,
            23.201646005455
        ],
        [
            113.11328106343,
            23.20159362989
        ],
        [
            113.11322608784,
            23.201518430251
        ],
        [
            113.11320794523,
            23.201486312864
        ],
        [
            113.11320063953,
            23.201455074883
        ],
        [
            113.11315785684,
            23.201372628333
        ],
        [
            113.11314107069,
            23.20133292507
        ],
        [
            113.1130546766,
            23.201213874425
        ],
        [
            113.1129322714,
            23.201000496291
        ],
        [
            113.11288623782,
            23.200901765607
        ],
        [
            113.11288325792,
            23.200899849679
        ],
        [
            113.11279116026,
            23.200806554791
        ],
        [
            113.11273644059,
            23.200758233781
        ],
        [
            113.11273508589,
            23.200757954905
        ],
        [
            113.11253525453,
            23.200215426126
        ],
        [
            113.11248187007,
            23.200232768024
        ],
        [
            113.11245235669,
            23.200139297472
        ],
        [
            113.11241200793,
            23.200028138134
        ],
        [
            113.11213507482,
            23.200001466947
        ],
        [
            113.11187113337,
            23.199984421263
        ],
        [
            113.11182940024,
            23.199981506844
        ],
        [
            113.11181660004,
            23.200252157295
        ],
        [
            113.11182229059,
            23.200254083443
        ],
        [
            113.11182742579,
            23.200311071525
        ],
        [
            113.11186882446,
            23.200567335149
        ],
        [
            113.11186692769,
            23.200566512184
        ],
        [
            113.11173467635,
            23.200577270961
        ],
        [
            113.11155634864,
            23.20059217386
        ],
        [
            113.1113655254,
            23.20069358008
        ],
        [
            113.11130426238,
            23.200736983887
        ],
        [
            113.11129856917,
            23.200743197977
        ],
        [
            113.11126604263,
            23.200755534913
        ],
        [
            113.11121318211,
            23.200792198676
        ],
        [
            113.11116737079,
            23.200818044587
        ],
        [
            113.11113427966,
            23.200909859957
        ],
        [
            113.1110892521,
            23.201037974385
        ],
        [
            113.11106294584,
            23.201093200885
        ],
        [
            113.11100953164,
            23.201161065916
        ],
        [
            113.11094282739,
            23.201256818898
        ],
        [
            113.11091815134,
            23.201294152701
        ],
        [
            113.11080181559,
            23.201481128426
        ],
        [
            113.11067030582,
            23.201637678766
        ],
        [
            113.11058705689,
            23.201743969349
        ],
        [
            113.11054963561,
            23.201789672972
        ],
        [
            113.11051492557,
            23.201832403938
        ],
        [
            113.11050299289,
            23.201850263183
        ],
        [
            113.11047886795,
            23.201850176181
        ],
        [
            113.11045583515,
            23.201825409898
        ],
        [
            113.11039622543,
            23.201744908534
        ],
        [
            113.11032089968,
            23.201641028496
        ],
        [
            113.11025342416,
            23.201567831412
        ],
        [
            113.11020924708,
            23.201538658792
        ],
        [
            113.11015828785,
            23.201524655561
        ],
        [
            113.11005147766,
            23.201531360608
        ],
        [
            113.10981777728,
            23.201584073166
        ],
        [
            113.10964398217,
            23.201636732489
        ],
        [
            113.10948997346,
            23.201687573825
        ],
        [
            113.10935058992,
            23.20177292303
        ],
        [
            113.10920496928,
            23.201849052438
        ],
        [
            113.10916998782,
            23.201865243124
        ],
        [
            113.10911954252,
            23.201908523472
        ],
        [
            113.10902597647,
            23.201978561494
        ],
        [
            113.1089465004,
            23.202071694422
        ],
        [
            113.10888708764,
            23.202165146928
        ],
        [
            113.10882143092,
            23.202277034538
        ],
        [
            113.10881328632,
            23.202306041256
        ],
        [
            113.10880025571,
            23.202349956635
        ],
        [
            113.10879509897,
            23.202363779717
        ],
        [
            113.10880919589,
            23.202372488598
        ],
        [
            113.10883603632,
            23.202382851641
        ],
        [
            113.10896643468,
            23.202450672063
        ],
        [
            113.10915077896,
            23.202537622302
        ],
        [
            113.10940017287,
            23.202661389782
        ],
        [
            113.10966067135,
            23.202780906047
        ],
        [
            113.10968100227,
            23.202786931523
        ],
        [
            113.10967286077,
            23.202809150478
        ],
        [
            113.1096633644,
            23.202829466901
        ],
        [
            113.10959715994,
            23.202971413571
        ],
        [
            113.10951413194,
            23.203145596596
        ],
        [
            113.10948672233,
            23.203214147829
        ],
        [
            113.10946609985,
            23.203258576928
        ],
        [
            113.10945579058,
            23.203275637956
        ],
        [
            113.10941972728,
            23.203286392549
        ],
        [
            113.10927712124,
            23.203271651717
        ],
        [
            113.10925271908,
            23.203272947397
        ],
        [
            113.10911362689,
            23.203274511491
        ],
        [
            113.10902712479,
            23.203296283279
        ],
        [
            113.10884043056,
            23.203655547935
        ],
        [
            113.1086312143,
            23.20402103916
        ],
        [
            113.10848983175,
            23.204261644272
        ],
        [
            113.10840134976,
            23.204440511815
        ],
        [
            113.10838667721,
            23.204504771626
        ],
        [
            113.10839479722,
            23.204538147987
        ],
        [
            113.10842733006,
            23.204555562521
        ],
        [
            113.10850133879,
            23.204600988801
        ],
        [
            113.10869058105,
            23.204666168213
        ],
        [
            113.10872202657,
            23.20468521694
        ],
        [
            113.10874451542,
            23.204722150567
        ],
        [
            113.10857490873,
            23.205000389233
        ],
        [
            113.10854695944,
            23.205040481693
        ],
        [
            113.10854369161,
            23.20506922727
        ],
        [
            113.10854612295,
            23.20508821853
        ],
        [
            113.10860115823,
            23.205111375402
        ],
        [
            113.10866403719,
            23.205174422505
        ],
        [
            113.10866755235,
            23.205194772311
        ],
        [
            113.10867757983,
            23.205205912563
        ],
        [
            113.10865939527,
            23.205240324967
        ],
        [
            113.10852345873,
            23.20540905472
        ],
        [
            113.1083934814,
            23.205581337383
        ],
        [
            113.10816439556,
            23.20598837835
        ],
        [
            113.10815108104,
            23.206038538003
        ],
        [
            113.1081255638,
            23.206087052875
        ],
        [
            113.10811768151,
            23.206120675153
        ],
        [
            113.10810355531,
            23.206166494372
        ],
        [
            113.10808589,
            23.206237533926
        ],
        [
            113.10807447743,
            23.206279559929
        ],
        [
            113.10805899615,
            23.206322936655
        ],
        [
            113.108045136,
            23.206377165269
        ],
        [
            113.10802476232,
            23.206440064908
        ],
        [
            113.10800276732,
            23.206491842049
        ],
        [
            113.10798836093,
            23.206552037798
        ],
        [
            113.10795849512,
            23.20661411257
        ],
        [
            113.10793053957,
            23.206654220357
        ],
        [
            113.10789226898,
            23.206710861727
        ],
        [
            113.10786023029,
            23.206777005041
        ],
        [
            113.10786103064,
            23.206800603534
        ],
        [
            113.10784229604,
            23.206839097067
        ],
        [
            113.10786397075,
            23.206877095583
        ],
        [
            113.10789135909,
            23.206882281881
        ],
        [
            113.10800659209,
            23.206927723972
        ],
        [
            113.10801471727,
            23.206946449983
        ],
        [
            113.10801958486,
            23.206970867666
        ],
        [
            113.10802256134,
            23.206982534765
        ],
        [
            113.10801929511,
            23.207003415566
        ],
        [
            113.10799431672,
            23.207053289993
        ],
        [
            113.10797503446,
            23.207101002418
        ],
        [
            113.10796852576,
            23.20710099405
        ],
        [
            113.10796036894,
            23.207137329159
        ],
        [
            113.10794625294,
            23.20716117996
        ],
        [
            113.10794271812,
            23.207177178385
        ],
        [
            113.1079261669,
            23.20719126191
        ],
        [
            113.10785637941,
            23.207344153942
        ],
        [
            113.10821749693,
            23.207532063229
        ],
        [
            113.10824594508,
            23.207575775406
        ],
        [
            113.10826925126,
            23.207601578814
        ],
        [
            113.10836169274,
            23.20765217673
        ],
        [
            113.10841780412,
            23.207688344782
        ],
        [
            113.10847309479,
            23.207735363666
        ],
        [
            113.10851158504,
            23.207761470208
        ],
        [
            113.10858097777,
            23.207804180141
        ],
        [
            113.10859722818,
            23.207836215929
        ],
        [
            113.10863732438,
            23.207895149205
        ],
        [
            113.10847292094,
            23.208020701131
        ],
        [
            113.10847210743,
            23.208020699706
        ],
        [
            113.10829032941,
            23.20816767642
        ],
        [
            113.10819382877,
            23.208102974643
        ],
        [
            113.10817079182,
            23.2080806994
        ],
        [
            113.10815967757,
            23.208073631049
        ],
        [
            113.1081320239,
            23.208061656756
        ],
        [
            113.10811765714,
            23.20805160061
        ],
        [
            113.10809488949,
            23.208031768463
        ],
        [
            113.10808024843,
            23.208026594628
        ],
        [
            113.10806317727,
            23.20800405873
        ],
        [
            113.10806046603,
            23.208002970083
        ],
        [
            113.10804311344,
            23.207996979345
        ],
        [
            113.10801926248,
            23.207974163757
        ],
        [
            113.10798022016,
            23.207958380997
        ],
        [
            113.10794091398,
            23.207930122583
        ],
        [
            113.1079189579,
            23.207912193792
        ],
        [
            113.10789130784,
            23.207892088666
        ],
        [
            113.10787558203,
            23.207885831361
        ],
        [
            113.10784656712,
            23.207879829892
        ],
        [
            113.10779153163,
            23.207848846295
        ],
        [
            113.10775953693,
            23.207836334235
        ],
        [
            113.10773866007,
            23.20782627606
        ],
        [
            113.10771263871,
            23.20780210875
        ],
        [
            113.10769257184,
            23.207797748222
        ],
        [
            113.10766058077,
            23.207778187027
        ],
        [
            113.10762859212,
            23.207754287041
        ],
        [
            113.10759904222,
            23.207733645098
        ],
        [
            113.10755484887,
            23.207708922197
        ],
        [
            113.10754318946,
            23.207704029573
        ],
        [
            113.10750787682,
            23.207793777184
        ],
        [
            113.10751329694,
            23.207800833907
        ],
        [
            113.10750459899,
            23.207832018327
        ],
        [
            113.10749238106,
            23.207853435438
        ],
        [
            113.10748367871,
            23.207891672078
        ],
        [
            113.10748338197,
            23.207933441772
        ],
        [
            113.10747359741,
            23.207967066601
        ],
        [
            113.10747547565,
            23.208000158601
        ],
        [
            113.10747246601,
            23.208042739723
        ],
        [
            113.10746430726,
            23.208078535805
        ],
        [
            113.10746156869,
            23.208121117148
        ],
        [
            113.10744770857,
            23.208165859398
        ],
        [
            113.10743520394,
            23.208211416573
        ],
        [
            113.10742704148,
            23.208252637532
        ],
        [
            113.10742538679,
            23.208296304678
        ],
        [
            113.10742103376,
            23.20831772866
        ],
        [
            113.10741477718,
            23.208347016929
        ],
        [
            113.1074020021,
            23.208390675583
        ],
        [
            113.10740145759,
            23.208393929957
        ],
        [
            113.10737132511,
            23.208435677343
        ],
        [
            113.10733548487,
            23.208495865349
        ],
        [
            113.10729910662,
            23.208548459669
        ],
        [
            113.10728009933,
            23.208581537549
        ],
        [
            113.10726896824,
            23.208598075578
        ],
        [
            113.10727059512,
            23.208598890305
        ],
        [
            113.10726245798,
            23.208599156402
        ],
        [
            113.10725702552,
            23.208611358435
        ],
        [
            113.10725051228,
            23.208617050268
        ],
        [
            113.10724508762,
            23.208617046939
        ],
        [
            113.10723503998,
            23.208635755831
        ],
        [
            113.10722715278,
            23.2086691126
        ],
        [
            113.10718887351,
            23.208723608055
        ],
        [
            113.10717230461,
            23.208759943928
        ],
        [
            113.10716631597,
            23.208793030909
        ],
        [
            113.10715598713,
            23.208826658074
        ],
        [
            113.10715134998,
            23.208866797842
        ],
        [
            113.10714835947,
            23.208877374291
        ],
        [
            113.10714373905,
            23.208891747138
        ],
        [
            113.10714101604,
            23.208908019595
        ],
        [
            113.10713287268,
            23.20891750852
        ],
        [
            113.10707667048,
            23.209002105529
        ],
        [
            113.10705711482,
            23.209041967731
        ],
        [
            113.107055487,
            23.209042509483
        ],
        [
            113.10704192537,
            23.209041689976
        ],
        [
            113.10701207043,
            23.209069072074
        ],
        [
            113.10696241262,
            23.209098888986
        ],
        [
            113.10688235729,
            23.209154195081
        ],
        [
            113.10684165243,
            23.209179680351
        ],
        [
            113.10680094126,
            23.209214117751
        ],
        [
            113.10676375465,
            23.209250727095
        ],
        [
            113.10670702807,
            23.209300625637
        ],
        [
            113.10666686149,
            23.209330185997
        ],
        [
            113.10661204131,
            23.209367070622
        ],
        [
            113.10657025015,
            23.20939093871
        ],
        [
            113.10652900465,
            23.209409655022
        ],
        [
            113.10648423299,
            23.209427288326
        ],
        [
            113.10642940343,
            23.209475031413
        ],
        [
            113.10637594245,
            23.209503790938
        ],
        [
            113.10630483639,
            23.209549102602
        ],
        [
            113.1062638594,
            23.209568642671
        ],
        [
            113.10624269313,
            23.209577599818
        ],
        [
            113.10621094327,
            23.209591443163
        ],
        [
            113.10619330813,
            23.209593619318
        ],
        [
            113.10619927848,
            23.209590633624
        ],
        [
            113.10617892303,
            23.20960366017
        ],
        [
            113.10614608817,
            23.209616692151
        ],
        [
            113.10609154545,
            23.209635973195
        ],
        [
            113.10606332073,
            23.209650904185
        ],
        [
            113.10604024843,
            23.209668816799
        ],
        [
            113.10603400789,
            23.209669904909
        ],
        [
            113.10602071271,
            23.209672352895
        ],
        [
            113.10595829149,
            23.209705477543
        ],
        [
            113.10594743558,
            23.209711179757
        ],
        [
            113.10593875359,
            23.209711727416
        ],
        [
            113.10575147719,
            23.209821704337
        ],
        [
            113.10567900682,
            23.209865159672
        ],
        [
            113.10562825262,
            23.209891512892
        ],
        [
            113.10545318991,
            23.209978747494
        ],
        [
            113.10543609616,
            23.209979036873
        ],
        [
            113.10539457469,
            23.209991016136
        ],
        [
            113.10532945989,
            23.20998458079
        ],
        [
            113.1052445441,
            23.209967595993
        ],
        [
            113.10511077834,
            23.209960719217
        ],
        [
            113.10502340594,
            23.209959486438
        ],
        [
            113.10488529758,
            23.209945863216
        ],
        [
            113.10477595123,
            23.209930310305
        ],
        [
            113.10462698878,
            23.209906431723
        ],
        [
            113.10449891371,
            23.209888771229
        ],
        [
            113.10440991432,
            23.209871046257
        ],
        [
            113.10435915801,
            23.209882812779
        ],
        [
            113.10429264187,
            23.209922009151
        ],
        [
            113.10423399455,
            23.209962006074
        ],
        [
            113.10416174815,
            23.210043263298
        ],
        [
            113.10418208852,
            23.210063288619
        ],
        [
            113.10419022228,
            23.210074662085
        ],
        [
            113.10419483156,
            23.210080890092
        ],
        [
            113.1044374181,
            23.210507562382
        ],
        [
            113.10454202448,
            23.210708066668
        ],
        [
            113.10455801776,
            23.210732446832
        ],
        [
            113.10461898496,
            23.210857640375
        ],
        [
            113.10449489152,
            23.210962296139
        ],
        [
            113.1042100879,
            23.211130232558
        ],
        [
            113.10404690724,
            23.21122878797
        ],
        [
            113.10395106321,
            23.211282177923
        ],
        [
            113.10380036524,
            23.211372331831
        ],
        [
            113.10362550026,
            23.211470709235
        ],
        [
            113.10349731615,
            23.211567081608
        ],
        [
            113.1034639148,
            23.211588061873
        ],
        [
            113.10339493732,
            23.211633557792
        ],
        [
            113.10326023257,
            23.21172997712
        ],
        [
            113.1031966794,
            23.211777638617
        ],
        [
            113.10312497892,
            23.211829398173
        ],
        [
            113.10303616775,
            23.211892067334
        ],
        [
            113.10291095927,
            23.211981717711
        ],
        [
            113.10283353716,
            23.212055213539
        ],
        [
            113.10275255311,
            23.212169410862
        ],
        [
            113.10272345062,
            23.212241117115
        ],
        [
            113.1026913873,
            23.212280016753
        ],
        [
            113.10266824886,
            23.212361467013
        ],
        [
            113.10261548115,
            23.212492117107
        ],
        [
            113.10256137259,
            23.212600534343
        ],
        [
            113.10251840787,
            23.212691011637
        ],
        [
            113.10248574179,
            23.212802606883
        ],
        [
            113.10245555517,
            23.212868357082
        ],
        [
            113.10240852398,
            23.212949632423
        ],
        [
            113.10235033658,
            23.213061601217
        ],
        [
            113.10229218769,
            23.213124753001
        ],
        [
            113.10221742377,
            23.213253610024
        ],
        [
            113.10213480087,
            23.21336297624
        ],
        [
            113.10206224828,
            23.213440031309
        ],
        [
            113.1019986608,
            23.213508916598
        ],
        [
            113.10189865051,
            23.213626510297
        ],
        [
            113.10187935711,
            23.213646392687
        ],
        [
            113.10177095734,
            23.213727690589
        ],
        [
            113.10161259636,
            23.213808141118
        ],
        [
            113.10144419798,
            23.213871845738
        ],
        [
            113.10143740656,
            23.213875674869
        ],
        [
            113.10138796926,
            23.213898149465
        ],
        [
            113.1012453932,
            23.213922163091
        ],
        [
            113.10114653389,
            23.213944077633
        ],
        [
            113.1010943832,
            23.213960883064
        ],
        [
            113.10093278061,
            23.21399696584
        ],
        [
            113.10076005206,
            23.214017671448
        ],
        [
            113.10063807551,
            23.214069588009
        ],
        [
            113.10052124905,
            23.214129896946
        ],
        [
            113.1003949238,
            23.214179422707
        ],
        [
            113.10034327129,
            23.21424101104
        ],
        [
            113.10028346437,
            23.214309971409
        ],
        [
            113.1002437421,
            23.214393193214
        ],
        [
            113.10017547746,
            23.214505603031
        ],
        [
            113.10012434186,
            23.214594862375
        ],
        [
            113.10006421792,
            23.214713197605
        ],
        [
            113.10003834819,
            23.214792275899
        ],
        [
            113.10000758209,
            23.214879791783
        ],
        [
            113.09997952435,
            23.214975699908
        ],
        [
            113.09995746973,
            23.215039026355
        ],
        [
            113.0999533792,
            23.215058036248
        ],
        [
            113.09991498765,
            23.215167840309
        ],
        [
            113.09989750732,
            23.215279687958
        ],
        [
            113.09987159175,
            23.215408673916
        ],
        [
            113.09983833596,
            23.21554475698
        ],
        [
            113.09981899589,
            23.215608069214
        ],
        [
            113.09978167306,
            23.215734957408
        ],
        [
            113.09976503172,
            23.215817238934
        ],
        [
            113.09974458733,
            23.2158998155
        ],
        [
            113.099717897,
            23.215980804029
        ],
        [
            113.09966672927,
            23.216097204673
        ],
        [
            113.09962047987,
            23.216180216881
        ],
        [
            113.09946274051,
            23.216400638001
        ],
        [
            113.09937820319,
            23.216468177107
        ],
        [
            113.09917048954,
            23.216671607178
        ],
        [
            113.09906554947,
            23.216766156167
        ],
        [
            113.09892823644,
            23.216909214119
        ],
        [
            113.09885696164,
            23.21702009342
        ],
        [
            113.09878651414,
            23.217116325587
        ],
        [
            113.09871036565,
            23.217207178101
        ],
        [
            113.09865320195,
            23.217330987709
        ],
        [
            113.09859415431,
            23.217434743748
        ],
        [
            113.09853591578,
            23.217543921083
        ],
        [
            113.09848176847,
            23.217634900074
        ],
        [
            113.09841049672,
            23.217734686118
        ],
        [
            113.09835495919,
            23.217857955389
        ],
        [
            113.09826818388,
            23.217974408668
        ],
        [
            113.0981778689,
            23.218097404014
        ],
        [
            113.09805517197,
            23.218272183823
        ],
        [
            113.0979626621,
            23.218413383249
        ],
        [
            113.09787152671,
            23.218535865332
        ],
        [
            113.09773580418,
            23.218685285165
        ],
        [
            113.097714055,
            23.218698475712
        ],
        [
            113.09770616635,
            23.218708030749
        ],
        [
            113.09770779557,
            23.218709102661
        ],
        [
            113.09770235697,
            23.218713756457
        ],
        [
            113.09769800519,
            23.218718401639
        ],
        [
            113.09768956946,
            23.218731758099
        ],
        [
            113.09767407129,
            23.218743001171
        ],
        [
            113.09763763174,
            23.218774752632
        ],
        [
            113.09751547401,
            23.218939818877
        ],
        [
            113.09743412345,
            23.219050863516
        ],
        [
            113.09735086816,
            23.219163285266
        ],
        [
            113.09732855701,
            23.21919411605
        ],
        [
            113.09722953612,
            23.219310201931
        ],
        [
            113.09714490249,
            23.21943946414
        ],
        [
            113.0970515717,
            23.219568805803
        ],
        [
            113.09704775865,
            23.219577788093
        ],
        [
            113.09694596922,
            23.219740839575
        ],
        [
            113.09691303463,
            23.219795906589
        ],
        [
            113.09692523465,
            23.219825092613
        ],
        [
            113.0969651494,
            23.219857296093
        ],
        [
            113.09698416801,
            23.219860659425
        ],
        [
            113.09701188468,
            23.219861508111
        ],
        [
            113.09704612221,
            23.21986311573
        ],
        [
            113.09716621698,
            23.219875663567
        ],
        [
            113.09718497433,
            23.219867641347
        ],
        [
            113.0972751933,
            23.219862821532
        ],
        [
            113.09743905314,
            23.219852252213
        ],
        [
            113.09757736879,
            23.219840282957
        ],
        [
            113.09774965219,
            23.219820466613
        ],
        [
            113.09783877916,
            23.21981217154
        ],
        [
            113.09790344909,
            23.21980678511
        ],
        [
            113.09803415295,
            23.219788147115
        ],
        [
            113.09809041359,
            23.219767105028
        ],
        [
            113.09811190207,
            23.219741447636
        ],
        [
            113.09811006728,
            23.219672573984
        ],
        [
            113.09810117027,
            23.219601855574
        ],
        [
            113.09809955224,
            23.219589392179
        ],
        [
            113.09809848418,
            23.219570144318
        ],
        [
            113.09809281392,
            23.219533845206
        ],
        [
            113.09808931008,
            23.219504852306
        ],
        [
            113.09813229645,
            23.219443502919
        ],
        [
            113.09829319052,
            23.219384796462
        ],
        [
            113.09860676105,
            23.219323377405
        ],
        [
            113.0987086448,
            23.219313157218
        ],
        [
            113.09873852767,
            23.219312945426
        ],
        [
            113.09889283415,
            23.219306982065
        ],
        [
            113.09906722468,
            23.219315005366
        ],
        [
            113.09927164922,
            23.219438934066
        ],
        [
            113.0993172608,
            23.219462499667
        ],
        [
            113.09942177582,
            23.219526907438
        ],
        [
            113.09945109931,
            23.219539464445
        ],
        [
            113.09948095958,
            23.219558527813
        ],
        [
            113.09955724756,
            23.219597636003
        ],
        [
            113.09958577523,
            23.219589860632
        ],
        [
            113.0996265446,
            23.219562481393
        ],
        [
            113.09977441423,
            23.219447377306
        ],
        [
            113.09988590241,
            23.21931407064
        ],
        [
            113.09990629488,
            23.21929116488
        ],
        [
            113.09996284776,
            23.219229529101
        ],
        [
            113.10006245387,
            23.219302703338
        ],
        [
            113.10006490061,
            23.219300247915
        ],
        [
            113.10012482346,
            23.219403225734
        ],
        [
            113.10017622316,
            23.219612300107
        ],
        [
            113.10017784217,
            23.219623139125
        ],
        [
            113.10018512056,
            23.219679237484
        ],
        [
            113.10018398456,
            23.219730231864
        ],
        [
            113.10020953563,
            23.219986377984
        ],
        [
            113.10020789734,
            23.219995337466
        ],
        [
            113.10018946817,
            23.220232754346
        ],
        [
            113.10028369587,
            23.220246312601
        ],
        [
            113.10045259308,
            23.220273290463
        ],
        [
            113.10070349829,
            23.220300392498
        ],
        [
            113.10092210342,
            23.220300867002
        ],
        [
            113.10131961113,
            23.22033495063
        ],
        [
            113.10165130778,
            23.220445410348
        ],
        [
            113.1020649788,
            23.220553997974
        ],
        [
            113.10223907671,
            23.220482231154
        ],
        [
            113.10230323049,
            23.220398172319
        ],
        [
            113.10230703984,
            23.220389478558
        ],
        [
            113.1024564772,
            23.220264956966
        ],
        [
            113.10249016179,
            23.220243132558
        ],
        [
            113.10262868979,
            23.22016478136
        ],
        [
            113.1030673709,
            23.220160015905
        ],
        [
            113.10338192617,
            23.220203519314
        ],
        [
            113.1040085368,
            23.220292160201
        ],
        [
            113.10478780842,
            23.220424020704
        ],
        [
            113.10502166993,
            23.220469763346
        ],
        [
            113.10545375656,
            23.220623816099
        ],
        [
            113.10550094875,
            23.220642210238
        ],
        [
            113.10551206869,
            23.220646538555
        ],
        [
            113.1061054477,
            23.220889391375
        ],
        [
            113.10655665811,
            23.22109025591
        ],
        [
            113.10663628359,
            23.221217726884
        ],
        [
            113.10646099785,
            23.221264108782
        ],
        [
            113.10625702801,
            23.221232418437
        ],
        [
            113.10609345996,
            23.221213766007
        ],
        [
            113.10586533437,
            23.221177550505
        ],
        [
            113.1058429902,
            23.221275201708
        ],
        [
            113.10582849313,
            23.221393459929
        ],
        [
            113.1058181448,
            23.221432250422
        ],
        [
            113.10581291957,
            23.221502769095
        ],
        [
            113.10580828541,
            23.221524740521
        ],
        [
            113.10579710164,
            23.221584957497
        ],
        [
            113.10577827938,
            23.221686946764
        ],
        [
            113.10571980291,
            23.221831547354
        ],
        [
            113.10569587115,
            23.221887707396
        ],
        [
            113.10541284971,
            23.221922420147
        ],
        [
            113.10540823523,
            23.221924323625
        ],
        [
            113.10523674382,
            23.221934015867
        ],
        [
            113.10511842043,
            23.221953425637
        ],
        [
            113.10508746523,
            23.221975436098
        ],
        [
            113.10511498449,
            23.222132429491
        ],
        [
            113.10515113136,
            23.22234392545
        ],
        [
            113.10514787909,
            23.22234013281
        ],
        [
            113.10515048397,
            23.222447800012
        ],
        [
            113.1050662866,
            23.222528193161
        ],
        [
            113.10499625195,
            23.222555143495
        ],
        [
            113.10492648853,
            23.222581284321
        ],
        [
            113.10484056395,
            23.22275607892
        ],
        [
            113.10458324764,
            23.223087400713
        ],
        [
            113.10441926564,
            23.223425915353
        ],
        [
            113.10440594686,
            23.223446825247
        ],
        [
            113.10434646567,
            23.223494950747
        ],
        [
            113.10424363226,
            23.223474013804
        ],
        [
            113.10418692599,
            23.223460306171
        ],
        [
            113.10413917757,
            23.223444140346
        ],
        [
            113.10411667505,
            23.223421409754
        ],
        [
            113.1040808622,
            23.223410372352
        ],
        [
            113.1040588799,
            23.223409609767
        ],
        [
            113.10402036231,
            23.223389088321
        ],
        [
            113.10396176622,
            23.223363192481
        ],
        [
            113.10388064501,
            23.223335186117
        ],
        [
            113.10381581045,
            23.223303889539
        ],
        [
            113.10373957354,
            23.223274796388
        ],
        [
            113.10367064452,
            23.223264673598
        ],
        [
            113.10366493595,
            23.223273367684
        ],
        [
            113.10366331103,
            23.223269846334
        ],
        [
            113.10360601659,
            23.22329468241
        ],
        [
            113.10357261389,
            23.223312403376
        ],
        [
            113.10350444906,
            23.223349479493
        ],
        [
            113.10346805505,
            23.223372093938
        ],
        [
            113.10343003828,
            23.223388747698
        ],
        [
            113.10341673712,
            23.223389871322
        ],
        [
            113.10340451091,
            23.223401569138
        ],
        [
            113.10339337949,
            23.223404313944
        ],
        [
            113.10333689174,
            23.223433772327
        ],
        [
            113.10327444142,
            23.223453759466
        ],
        [
            113.10322638936,
            23.223461229847
        ],
        [
            113.10311230875,
            23.223535086832
        ],
        [
            113.10296178375,
            23.223675251857
        ],
        [
            113.10293217926,
            23.223691081218
        ],
        [
            113.10288928345,
            23.223696921778
        ],
        [
            113.10277145911,
            23.223707906287
        ],
        [
            113.10274815134,
            23.223670561441
        ],
        [
            113.10270451222,
            23.223605083722
        ],
        [
            113.1026042623,
            23.223415057219
        ],
        [
            113.10252544366,
            23.223237977646
        ],
        [
            113.10246437375,
            23.22322600298
        ],
        [
            113.10242772761,
            23.223222616756
        ],
        [
            113.10241414808,
            23.223228092951
        ],
        [
            113.10235603075,
            23.2232481157
        ],
        [
            113.10232343331,
            23.223267227601
        ],
        [
            113.10227374022,
            23.223278271786
        ],
        [
            113.1021993104,
            23.223319521877
        ],
        [
            113.10219114609,
            23.223338810688
        ],
        [
            113.10218815857,
            23.223339907591
        ],
        [
            113.10219248096,
            23.223361044482
        ],
        [
            113.10220006814,
            23.223375387992
        ],
        [
            113.10224221423,
            23.223578354908
        ],
        [
            113.10225919417,
            23.223700060323
        ],
        [
            113.10225483075,
            23.223719333549
        ],
        [
            113.10226700689,
            23.223759424159
        ],
        [
            113.1022569527,
            23.223768414014
        ],
        [
            113.10216705903,
            23.223798337034
        ],
        [
            113.10206901975,
            23.22382748747
        ],
        [
            113.10186857981,
            23.223897495189
        ],
        [
            113.10181589007,
            23.223914268224
        ],
        [
            113.10179008679,
            23.223923873736
        ],
        [
            113.10162957252,
            23.223971781674
        ],
        [
            113.10128457531,
            23.224125821507
        ],
        [
            113.10120621229,
            23.224282691973
        ],
        [
            113.1011890783,
            23.224309083683
        ],
        [
            113.10114316835,
            23.224328024635
        ],
        [
            113.10111735633,
            23.224343069878
        ],
        [
            113.10102687155,
            23.224401564605
        ],
        [
            113.10091898274,
            23.224482666874
        ],
        [
            113.10090483163,
            23.224512301972
        ],
        [
            113.1009037022,
            23.22455461642
        ],
        [
            113.10092105104,
            23.224584630719
        ],
        [
            113.10099346115,
            23.224677011873
        ],
        [
            113.10104123886,
            23.224691685271
        ],
        [
            113.10114765537,
            23.224720441683
        ],
        [
            113.10118702251,
            23.224726755651
        ],
        [
            113.10124868169,
            23.224707468305
        ],
        [
            113.10125058192,
            23.224708001448
        ],
        [
            113.10131849014,
            23.224684348113
        ],
        [
            113.10133451656,
            23.224678575595
        ],
        [
            113.10145730418,
            23.224624021673
        ],
        [
            113.10150593341,
            23.224598571934
        ],
        [
            113.10152168442,
            23.224596057884
        ],
        [
            113.1015458618,
            23.224584555224
        ],
        [
            113.1016082431,
            23.22465180003
        ],
        [
            113.10169395424,
            23.224738470531
        ],
        [
            113.10206986964,
            23.225122507927
        ],
        [
            113.10210729217,
            23.225165475687
        ],
        [
            113.10213061945,
            23.225186263129
        ],
        [
            113.10232452722,
            23.225388622645
        ],
        [
            113.10253285444,
            23.225553535569
        ],
        [
            113.10268231264,
            23.225672592125
        ],
        [
            113.10276913845,
            23.225714321283
        ],
        [
            113.10292921536,
            23.225795676124
        ],
        [
            113.10296393537,
            23.22582105351
        ],
        [
            113.10296854286,
            23.225828089603
        ],
        [
            113.10300732023,
            23.225867286539
        ],
        [
            113.10310278209,
            23.22595294962
        ],
        [
            113.10326087153,
            23.22611002675
        ],
        [
            113.10336824445,
            23.226222526361
        ],
        [
            113.10350679843,
            23.226365051908
        ],
        [
            113.10362528519,
            23.22648676652
        ],
        [
            113.10366865859,
            23.226538992506
        ],
        [
            113.10367734005,
            23.226542766138
        ],
        [
            113.10375543067,
            23.226617684701
        ],
        [
            113.10375461698,
            23.226617144405
        ],
        [
            113.10380146476,
            23.22672116767
        ],
        [
            113.10383309556,
            23.226842588879
        ],
        [
            113.10400322196,
            23.226885292966
        ],
        [
            113.10404148726,
            23.226887101029
        ],
        [
            113.104090864,
            23.226904072577
        ],
        [
            113.10419777662,
            23.226919562165
        ],
        [
            113.104389602,
            23.226962008083
        ],
        [
            113.10455673205,
            23.22699829604
        ],
        [
            113.10466226926,
            23.227022783974
        ],
        [
            113.10467176734,
            23.227022495975
        ],
        [
            113.10476645974,
            23.22703535123
        ],
        [
            113.10499517602,
            23.22706997827
        ],
        [
            113.10500223302,
            23.227068069493
        ],
        [
            113.10499599505,
            23.227065095292
        ],
        [
            113.1050038683,
            23.227061015651
        ],
        [
            113.10507074466,
            23.226938333448
        ],
        [
            113.10515152454,
            23.226751088981
        ],
        [
            113.10482163565,
            23.226681331277
        ],
        [
            113.10471121849,
            23.226655480195
        ],
        [
            113.10464800956,
            23.226636877735
        ],
        [
            113.10464751837,
            23.226586433589
        ],
        [
            113.10465052945,
            23.226560934494
        ],
        [
            113.10480982364,
            23.226556322797
        ],
        [
            113.10518916781,
            23.22655685365
        ],
        [
            113.10544830324,
            23.226543533807
        ],
        [
            113.10555765814,
            23.226531763125
        ],
        [
            113.10561844532,
            23.226520045497
        ],
        [
            113.10580326769,
            23.226462129785
        ],
        [
            113.10594305132,
            23.226401016671
        ],
        [
            113.10602801348,
            23.226355949444
        ],
        [
            113.10603317419,
            23.226349980222
        ],
        [
            113.10640075892,
            23.226091666665
        ],
        [
            113.10647405537,
            23.226040398728
        ],
        [
            113.10658182732,
            23.225964184183
        ],
        [
            113.10669935496,
            23.22589530421
        ],
        [
            113.10672596146,
            23.225872797222
        ],
        [
            113.10675364536,
            23.225857613751
        ],
        [
            113.10675066264,
            23.225856528412
        ],
        [
            113.10698517993,
            23.22570444382
        ],
        [
            113.10713202647,
            23.225602263864
        ],
        [
            113.10709300325,
            23.22556780056
        ],
        [
            113.10704988836,
            23.225555576102
        ],
        [
            113.10697960889,
            23.225582125835
        ],
        [
            113.10693971115,
            23.225605977992
        ],
        [
            113.10690742114,
            23.225617087083
        ],
        [
            113.10687294815,
            23.225640672206
        ],
        [
            113.10687023841,
            23.22563795935
        ],
        [
            113.10686617129,
            23.225636330971
        ],
        [
            113.10685018072,
            23.225623308633
        ],
        [
            113.10688637542,
            23.225507782983
        ],
        [
            113.10697886487,
            23.225248808041
        ],
        [
            113.10698893314,
            23.225217351485
        ],
        [
            113.10701098443,
            23.22513870923
        ],
        [
            113.10699754809,
            23.225015574336
        ],
        [
            113.10697509708,
            23.224954543381
        ],
        [
            113.10696455422,
            23.224919553357
        ],
        [
            113.10694073905,
            23.224866116516
        ],
        [
            113.10691476319,
            23.224803458363
        ],
        [
            113.10687443582,
            23.224716387796
        ],
        [
            113.10683543114,
            23.224661864311
        ],
        [
            113.10674688142,
            23.224514036763
        ],
        [
            113.1066883829,
            23.224422359842
        ],
        [
            113.10665345514,
            23.224358622258
        ],
        [
            113.106641266,
            23.224341263963
        ],
        [
            113.1066326005,
            23.224326618097
        ],
        [
            113.10651317084,
            23.224131346772
        ],
        [
            113.10651290455,
            23.224126465
        ],
        [
            113.10647635951,
            23.224051342431
        ],
        [
            113.10647039262,
            23.224050258151
        ],
        [
            113.10640378434,
            23.223927408348
        ],
        [
            113.10635291209,
            23.223801847205
        ],
        [
            113.10630768787,
            23.223723748879
        ],
        [
            113.10631619029,
            23.223632620077
        ],
        [
            113.10632082358,
            23.223611464553
        ],
        [
            113.10633066578,
            23.223536608168
        ],
        [
            113.1063703144,
            23.223495375882
        ],
        [
            113.10648164184,
            23.223392300411
        ],
        [
            113.10661304271,
            23.223287067263
        ],
        [
            113.10671266245,
            23.223221713589
        ],
        [
            113.10677537653,
            23.223169108538
        ],
        [
            113.1068014273,
            23.223159078899
        ],
        [
            113.1068207062,
            23.223139555947
        ],
        [
            113.10687772378,
            23.223085870723
        ],
        [
            113.10690188766,
            23.223063638498
        ],
        [
            113.10690189893,
            23.223052518856
        ],
        [
            113.10691411177,
            23.223046013572
        ],
        [
            113.10695054181,
            23.222964391184
        ],
        [
            113.10708210933,
            23.222950613362
        ],
        [
            113.10719142187,
            23.222947144676
        ],
        [
            113.10728147946,
            23.222939063702
        ],
        [
            113.10730344223,
            23.222945858621
        ],
        [
            113.10731455768,
            23.222950748001
        ],
        [
            113.10735632375,
            23.22295376084
        ],
        [
            113.10750525424,
            23.222925130925
        ],
        [
            113.10763518852,
            23.222903554224
        ],
        [
            113.10791729694,
            23.222849355721
        ],
        [
            113.10811204542,
            23.222817884536
        ],
        [
            113.10830218351,
            23.222779660844
        ],
        [
            113.10841800399,
            23.222751375703
        ],
        [
            113.10842260623,
            23.22275897751
        ],
        [
            113.10846301861,
            23.222751182489
        ],
        [
            113.10846546489,
            23.222745491343
        ],
        [
            113.10847256574,
            23.222695600935
        ],
        [
            113.10847532676,
            23.222646787747
        ],
        [
            113.1084731596,
            23.222644614233
        ],
        [
            113.10847999881,
            23.222585231002
        ],
        [
            113.10862050121,
            23.222546976681
        ],
        [
            113.10881224228,
            23.222514270053
        ],
        [
            113.10887271723,
            23.222505989773
        ],
        [
            113.10895732637,
            23.222494782633
        ],
        [
            113.1090256641,
            23.222485172255
        ],
        [
            113.10905414091,
            23.222478185882
        ],
        [
            113.10905630947,
            23.222478733296
        ],
        [
            113.10906471779,
            23.222475769359
        ],
        [
            113.1091135299,
            23.222468560502
        ],
        [
            113.10920978098,
            23.22247014752
        ],
        [
            113.1093079197,
            23.222480155434
        ],
        [
            113.10939223434,
            23.222485254219
        ],
        [
            113.10946353068,
            23.222493579159
        ],
        [
            113.10957820996,
            23.222496333226
        ],
        [
            113.10967472807,
            23.222493622844
        ],
        [
            113.10979944173,
            23.222488292765
        ],
        [
            113.10979726936,
            23.222491812033
        ],
        [
            113.10980431935,
            23.22249047704
        ],
        [
            113.10986477393,
            23.22249120199
        ],
        [
            113.10992278686,
            23.22249300757
        ],
        [
            113.10995016243,
            23.222497974599
        ],
        [
            113.10998649263,
            23.222494291783
        ],
        [
            113.11002798123,
            23.22248276151
        ],
        [
            113.11006378104,
            23.222466875036
        ],
        [
            113.11015512278,
            23.222481005659
        ],
        [
            113.11019769137,
            23.222472468746
        ],
        [
            113.11021829757,
            23.222468469837
        ],
        [
            113.1102814809,
            23.222446716487
        ],
        [
            113.11035848711,
            23.222426099916
        ],
        [
            113.110453116,
            23.222401212416
        ],
        [
            113.11050895701,
            23.222400058007
        ],
        [
            113.11055450146,
            23.22239452913
        ],
        [
            113.11067158607,
            23.222407984223
        ],
        [
            113.11071440382,
            23.222417097122
        ],
        [
            113.11071169601,
            23.222414374649
        ],
        [
            113.11073608293,
            23.222422333267
        ],
        [
            113.11080744849,
            23.222344229579
        ],
        [
            113.11080907862,
            23.222340438981
        ],
        [
            113.11085196384,
            23.22228148324
        ],
        [
            113.11092115504,
            23.222207717706
        ],
        [
            113.110945838,
            23.222189916995
        ],
        [
            113.11101165486,
            23.222236019362
        ],
        [
            113.1111226821,
            23.222333573505
        ],
        [
            113.1110261101,
            23.222415621145
        ],
        [
            113.11100789851,
            23.222467076809
        ],
        [
            113.11098099136,
            23.222540465556
        ],
        [
            113.11101723049,
            23.222620078669
        ],
        [
            113.11101965915,
            23.222630665899
        ],
        [
            113.11102370419,
            23.222651023405
        ],
        [
            113.11105271348,
            23.222643006517
        ],
        [
            113.11217510314,
            23.222240037755
        ],
        [
            113.11385743917,
            23.221639711436
        ],
        [
            113.11502394744,
            23.221239032204
        ],
        [
            113.11510756239,
            23.221315069881
        ],
        [
            113.11515330275,
            23.221346883409
        ],
        [
            113.11522013106,
            23.2214157478
        ],
        [
            113.11534659525,
            23.22143084241
        ],
        [
            113.1153468336,
            23.221463389947
        ],
        [
            113.11566211243,
            23.221422797086
        ],
        [
            113.11570108379,
            23.221448880903
        ],
        [
            113.11569508883,
            23.221485988127
        ],
        [
            113.11569343524,
            23.221514723263
        ],
        [
            113.11569179736,
            23.221527728126
        ],
        [
            113.11597099136,
            23.221537096108
        ],
        [
            113.11599041815,
            23.221608046505
        ],
        [
            113.11596041137,
            23.221826392276
        ],
        [
            113.11589911497,
            23.222190389781
        ],
        [
            113.11589187472,
            23.222388315135
        ],
        [
            113.11589549743,
            23.222555412806
        ],
        [
            113.11588621015,
            23.222634529566
        ],
        [
            113.11588474841,
            23.222741104178
        ],
        [
            113.11585280299,
            23.222999033038
        ],
        [
            113.11584099038,
            23.22316464605
        ],
        [
            113.11584121496,
            23.223210211704
        ],
        [
            113.1158412012,
            23.22322377224
        ],
        [
            113.11584553299,
            23.223224893082
        ],
        [
            113.11585716054,
            23.22324180497
        ],
        [
            113.11585389271,
            23.223259677845
        ],
        [
            113.11587333474,
            23.223314895938
        ],
        [
            113.11588386221,
            23.223348342907
        ],
        [
            113.11589468332,
            23.223359281742
        ],
        [
            113.11603477357,
            23.22380768982
        ],
        [
            113.11604557394,
            23.223838699577
        ],
        [
            113.11607609563,
            23.223915711883
        ],
        [
            113.11608499398,
            23.223952943717
        ],
        [
            113.11613007739,
            23.224089748173
        ],
        [
            113.11620811088,
            23.224310913482
        ],
        [
            113.11621565337,
            23.224349761868
        ],
        [
            113.11622510963,
            23.224370726758
        ],
        [
            113.1162345645,
            23.224393047773
        ],
        [
            113.11624506538,
            23.224451720408
        ],
        [
            113.11637545139,
            23.224846925964
        ],
        [
            113.11640486468,
            23.224946718645
        ],
        [
            113.11641864808,
            23.224972604816
        ],
        [
            113.11642350019,
            23.22499407324
        ],
        [
            113.1164207544,
            23.225031205262
        ],
        [
            113.11642399931,
            23.225035573171
        ],
        [
            113.11642048029,
            23.225034457407
        ],
        [
            113.11650225082,
            23.225303950132
        ],
        [
            113.11654219055,
            23.225436113618
        ],
        [
            113.11671035438,
            23.225951295684
        ],
        [
            113.11671737292,
            23.225972242384
        ],
        [
            113.11673708383,
            23.226026120545
        ],
        [
            113.11673681695,
            23.226022321154
        ],
        [
            113.11688527459,
            23.226474427775
        ],
        [
            113.11689392276,
            23.226490237365
        ],
        [
            113.11699219885,
            23.226763982256
        ],
        [
            113.11703024804,
            23.226888550137
        ],
        [
            113.1170750428,
            23.227035692664
        ],
        [
            113.11716117245,
            23.227270554482
        ],
        [
            113.117357646,
            23.22788725309
        ],
        [
            113.11739893549,
            23.228018643552
        ],
        [
            113.11764394142,
            23.228025622484
        ],
        [
            113.11764746056,
            23.228025928058
        ],
        [
            113.11766045808,
            23.228023342915
        ],
        [
            113.11774331034,
            23.228013035763
        ],
        [
            113.11782290353,
            23.228011922944
        ],
        [
            113.11794174987,
            23.228010393127
        ],
        [
            113.11804460655,
            23.228024172239
        ],
        [
            113.11814179388,
            23.228021086737
        ],
        [
            113.1181915948,
            23.228029729514
        ],
        [
            113.11821650531,
            23.228024016822
        ],
        [
            113.11822164586,
            23.228026781433
        ],
        [
            113.11825873493,
            23.228023906084
        ],
        [
            113.1182942098,
            23.228010980318
        ],
        [
            113.11830016788,
            23.228008329361
        ],
        [
            113.11833212707,
            23.227991842747
        ],
        [
            113.11836190677,
            23.227988895097
        ],
        [
            113.11850346734,
            23.228000940599
        ],
        [
            113.11866804346,
            23.228002666596
        ],
        [
            113.11867778218,
            23.228008464858
        ],
        [
            113.11881799899,
            23.228004257054
        ],
        [
            113.11881231426,
            23.22800473888
        ],
        [
            113.11877768452,
            23.228254429182
        ],
        [
            113.11873631117,
            23.228481266993
        ],
        [
            113.11871130302,
            23.228585419396
        ],
        [
            113.11869989551,
            23.228623811078
        ],
        [
            113.11867787935,
            23.228713621437
        ],
        [
            113.11866024562,
            23.228752490173
        ],
        [
            113.11863953299,
            23.228891675855
        ],
        [
            113.11861993521,
            23.228999141579
        ],
        [
            113.11859679099,
            23.229133962993
        ],
        [
            113.11859834982,
            23.229198799506
        ],
        [
            113.11859239122,
            23.229202262748
        ],
        [
            113.11858939404,
            23.229221758711
        ],
        [
            113.11858251181,
            23.229336138863
        ],
        [
            113.11858030409,
            23.229378153901
        ],
        [
            113.11856697242,
            23.229445817726
        ],
        [
            113.11854112638,
            23.229576001279
        ],
        [
            113.11852239001,
            23.229634659013
        ],
        [
            113.11851775544,
            23.229667427558
        ],
        [
            113.11847192361,
            23.229752382493
        ],
        [
            113.11843764667,
            23.22992207777
        ],
        [
            113.11839242657,
            23.230207740597
        ],
        [
            113.11838548613,
            23.230381788629
        ],
        [
            113.11842335607,
            23.230409302118
        ],
        [
            113.11858788892,
            23.230456582054
        ],
        [
            113.1186601141,
            23.230504804336
        ],
        [
            113.11871881481,
            23.230542581109
        ],
        [
            113.11871657415,
            23.230618497553
        ],
        [
            113.11869344139,
            23.230744638991
        ],
        [
            113.11864814583,
            23.230837187703
        ],
        [
            113.11850430477,
            23.230944708354
        ],
        [
            113.11823065645,
            23.230918829963
        ],
        [
            113.11796191839,
            23.230843154597
        ],
        [
            113.11791427794,
            23.230837796622
        ],
        [
            113.11785742453,
            23.23084075654
        ],
        [
            113.11776402442,
            23.23084254451
        ],
        [
            113.11747000249,
            23.230853782876
        ],
        [
            113.11733300631,
            23.230856810689
        ],
        [
            113.11732812713,
            23.230862730974
        ],
        [
            113.11714159424,
            23.2308522908
        ],
        [
            113.11710720721,
            23.230854138843
        ],
        [
            113.11685594956,
            23.230850189804
        ],
        [
            113.11678961162,
            23.230851212536
        ],
        [
            113.11677228282,
            23.230851055197
        ],
        [
            113.11665478109,
            23.23166797915
        ],
        [
            113.11662371704,
            23.231869756121
        ],
        [
            113.11660052423,
            23.232052619205
        ],
        [
            113.11658198238,
            23.232186434247
        ],
        [
            113.11657456777,
            23.232294040822
        ],
        [
            113.11656020197,
            23.232309372153
        ],
        [
            113.11650442472,
            23.232306707127
        ],
        [
            113.11648899864,
            23.232298162897
        ],
        [
            113.11639342434,
            23.232286743854
        ],
        [
            113.11637826692,
            23.232280101881
        ],
        [
            113.11626806715,
            23.232269920723
        ],
        [
            113.11620713203,
            23.232277801937
        ],
        [
            113.11620875911,
            23.232275375013
        ],
        [
            113.11620142667,
            23.232297280337
        ],
        [
            113.11621223287,
            23.232323681367
        ],
        [
            113.11620519343,
            23.232322535849
        ],
        [
            113.11621734758,
            23.232355186504
        ],
        [
            113.11621920111,
            23.232398868251
        ],
        [
            113.1162286435,
            23.232435563881
        ],
        [
            113.11622374459,
            23.232461287118
        ],
        [
            113.11623588786,
            23.232505328954
        ],
        [
            113.11622881776,
            23.232536186528
        ],
        [
            113.11622959894,
            23.232568739203
        ],
        [
            113.11622847918,
            23.232606971008
        ],
        [
            113.11622573654,
            23.2326432903
        ],
        [
            113.11622514701,
            23.23269346021
        ],
        [
            113.11621373663,
            23.232732416929
        ],
        [
            113.11621532021,
            23.232775553972
        ],
        [
            113.11620662913,
            23.232802600699
        ],
        [
            113.11619521183,
            23.232848880389
        ],
        [
            113.11619139239,
            23.23287868133
        ],
        [
            113.11618947364,
            23.232903074303
        ],
        [
            113.11619351226,
            23.232927518527
        ],
        [
            113.11620242559,
            23.232951462303
        ],
        [
            113.11620049194,
            23.232991585696
        ],
        [
            113.1162069731,
            23.233010355459
        ],
        [
            113.11620910363,
            23.23304807292
        ],
        [
            113.11620042118,
            23.233066169645
        ],
        [
            113.11620392035,
            23.233088439541
        ],
        [
            113.11619280671,
            23.233100277402
        ],
        [
            113.11619795119,
            23.233100864109
        ],
        [
            113.11618981006,
            23.233119236789
        ],
        [
            113.11618573256,
            23.23313574594
        ],
        [
            113.11619219274,
            23.233176755226
        ],
        [
            113.11618297694,
            23.233186168558
        ],
        [
            113.11611636114,
            23.233186953833
        ],
        [
            113.11596767331,
            23.233207932691
        ],
        [
            113.11580679983,
            23.233224218043
        ],
        [
            113.1157491142,
            23.233227538456
        ],
        [
            113.11573584813,
            23.233223632202
        ],
        [
            113.1157263662,
            23.233227351261
        ],
        [
            113.11573205705,
            23.233223329801
        ],
        [
            113.11570335139,
            23.23322282284
        ],
        [
            113.11564213929,
            23.233231272573
        ],
        [
            113.11559772691,
            23.233229555362
        ],
        [
            113.11557009644,
            23.233236925587
        ],
        [
            113.11553325108,
            23.233251544999
        ],
        [
            113.11546309599,
            23.233264271283
        ],
        [
            113.11536667249,
            23.233274081176
        ],
        [
            113.1152420778,
            23.233286932949
        ],
        [
            113.11504869196,
            23.233294116209
        ],
        [
            113.11493356524,
            23.233312225943
        ],
        [
            113.11475804196,
            23.233323388814
        ],
        [
            113.11467111492,
            23.23330349182
        ],
        [
            113.11466081867,
            23.233307213399
        ],
        [
            113.11456468794,
            23.233279662857
        ],
        [
            113.11444797362,
            23.233247633557
        ],
        [
            113.11435292181,
            23.233221193001
        ],
        [
            113.11425161693,
            23.233217227537
        ],
        [
            113.1141706237,
            23.233216394326
        ],
        [
            113.11415165903,
            23.23321924693
        ],
        [
            113.11403462208,
            23.233233092414
        ],
        [
            113.11397014408,
            23.233238894596
        ],
        [
            113.11392543558,
            23.233250256832
        ],
        [
            113.11383059777,
            23.233274849166
        ],
        [
            113.11377776266,
            23.233284536135
        ],
        [
            113.11375147334,
            23.233296839816
        ],
        [
            113.11368858662,
            23.233335485319
        ],
        [
            113.11366527151,
            23.233353505813
        ],
        [
            113.11364223769,
            23.23336040872
        ],
        [
            113.11362516915,
            23.233361654896
        ],
        [
            113.11360647101,
            23.233367230333
        ],
        [
            113.11354930456,
            23.233371204474
        ],
        [
            113.11354848749,
            23.233375809952
        ],
        [
            113.11352085785,
            23.233371837397
        ],
        [
            113.11351679873,
            23.233366929771
        ],
        [
            113.11346125585,
            23.233372003459
        ],
        [
            113.1134276574,
            23.233376674557
        ],
        [
            113.11340680043,
            23.23337247595
        ],
        [
            113.11338404949,
            23.233365553777
        ],
        [
            113.11332419323,
            23.23334646904
        ],
        [
            113.11314289618,
            23.233394184005
        ],
        [
            113.11310739876,
            23.233399395554
        ],
        [
            113.11305970361,
            23.233410231277
        ],
        [
            113.11303153095,
            23.233404911266
        ],
        [
            113.11300090847,
            23.233411511053
        ],
        [
            113.11291038274,
            23.233444070329
        ],
        [
            113.1128420672,
            23.233483273403
        ],
        [
            113.11273742321,
            23.233543700778
        ],
        [
            113.11260757894,
            23.233603184381
        ],
        [
            113.11248450937,
            23.233658922665
        ],
        [
            113.11235765846,
            23.233698652534
        ],
        [
            113.11220804398,
            23.233736651249
        ],
        [
            113.11214245355,
            23.233750416555
        ],
        [
            113.1120405479,
            23.233766443325
        ],
        [
            113.11168921248,
            23.233898711687
        ],
        [
            113.11155559116,
            23.233913548791
        ],
        [
            113.1115068089,
            23.233913325632
        ],
        [
            113.1114257739,
            23.233914315755
        ],
        [
            113.11128243353,
            23.233881408178
        ],
        [
            113.11118623238,
            23.233866348206
        ],
        [
            113.11109513001,
            23.233904205128
        ],
        [
            113.11100210217,
            23.233970810638
        ],
        [
            113.11091777387,
            23.234007625121
        ],
        [
            113.11075860747,
            23.234073444927
        ],
        [
            113.11056366197,
            23.234133188157
        ],
        [
            113.11048692324,
            23.234163012167
        ],
        [
            113.11043100797,
            23.234244718219
        ],
        [
            113.11035560581,
            23.234292998957
        ],
        [
            113.11016822101,
            23.234369383343
        ],
        [
            113.11003507652,
            23.234414511712
        ],
        [
            113.10991794596,
            23.234435025227
        ],
        [
            113.10971568121,
            23.234461266098
        ],
        [
            113.10936182654,
            23.234516431989
        ],
        [
            113.1091877339,
            23.234547726515
        ],
        [
            113.10911558885,
            23.234573318866
        ],
        [
            113.10910687191,
            23.234617777832
        ],
        [
            113.10913954516,
            23.234765126297
        ],
        [
            113.10912836857,
            23.234831276633
        ],
        [
            113.10910803171,
            23.234833126939
        ],
        [
            113.10906111347,
            23.234845764373
        ],
        [
            113.10904727189,
            23.234860649324
        ],
        [
            113.10905589454,
            23.234920065825
        ],
        [
            113.10905062924,
            23.235045898544
        ],
        [
            113.10904103075,
            23.235166568259
        ],
        [
            113.10903280896,
            23.235264187772
        ],
        [
            113.10902022712,
            23.235386478279
        ],
        [
            113.10902180026,
            23.235446692271
        ],
        [
            113.10897024546,
            23.235489157079
        ],
        [
            113.10891762782,
            23.235506669953
        ],
        [
            113.10880292504,
            23.235514290616
        ],
        [
            113.10871289551,
            23.235521429994
        ],
        [
            113.10867843472,
            23.235548212331
        ],
        [
            113.10862522518,
            23.235618354606
        ],
        [
            113.10858778614,
            23.235639438559
        ],
        [
            113.10852247455,
            23.235595380335
        ],
        [
            113.10845715304,
            23.235561632348
        ],
        [
            113.10836635686,
            23.23550940251
        ],
        [
            113.10831245916,
            23.23543499982
        ],
        [
            113.10826942931,
            23.235337021093
        ],
        [
            113.10826159326,
            23.235305547439
        ],
        [
            113.10819465235,
            23.235259879293
        ],
        [
            113.10815506243,
            23.235256565381
        ],
        [
            113.10807399093,
            23.235241531518
        ],
        [
            113.10799454849,
            23.235222980096
        ],
        [
            113.10786628817,
            23.235205459164
        ],
        [
            113.10781120368,
            23.235239567248
        ],
        [
            113.1078019733,
            23.235250134061
        ],
        [
            113.107725026,
            23.235469734501
        ],
        [
            113.10784225297,
            23.235700131633
        ],
        [
            113.1078476614,
            23.235717767263
        ],
        [
            113.10795469013,
            23.236134220912
        ],
        [
            113.10795169421,
            23.236148862858
        ],
        [
            113.10792609768,
            23.236268437677
        ],
        [
            113.10791761929,
            23.23635060636
        ],
        [
            113.10791753179,
            23.236451771043
        ],
        [
            113.10805523795,
            23.236521656754
        ],
        [
            113.1083005823,
            23.236611256452
        ],
        [
            113.1085762925,
            23.236693103067
        ],
        [
            113.10859255552,
            23.236700998997
        ],
        [
            113.10859093714,
            23.236690960809
        ],
        [
            113.10860205873,
            23.23668637109
        ],
        [
            113.10858746063,
            23.236634269315
        ],
        [
            113.10870764036,
            23.236569138151
        ],
        [
            113.10872714072,
            23.23659575672
        ],
        [
            113.10873248076,
            23.236692592955
        ],
        [
            113.10874356699,
            23.236728958833
        ],
        [
            113.1087441079,
            23.236730587249
        ],
        [
            113.10877094933,
            23.236733896618
        ],
        [
            113.10887721564,
            23.23676286916
        ],
        [
            113.10897101376,
            23.236784230033
        ],
        [
            113.10906643635,
            23.236806416478
        ],
        [
            113.10922853908,
            23.23684803091
        ],
        [
            113.10946165283,
            23.236910199777
        ],
        [
            113.10965383612,
            23.236952501559
        ],
        [
            113.10968419088,
            23.236963437805
        ],
        [
            113.10969367705,
            23.236966448726
        ],
        [
            113.10970262421,
            23.236965661073
        ],
        [
            113.10972647704,
            23.236970883961
        ],
        [
            113.10975196557,
            23.236965263384
        ],
        [
            113.10979235602,
            23.236969723072
        ],
        [
            113.1098248843,
            23.23697416046
        ],
        [
            113.10985605092,
            23.2369856464
        ],
        [
            113.10988180348,
            23.236987623845
        ],
        [
            113.10989806485,
            23.236992827173
        ],
        [
            113.10992001638,
            23.237001303077
        ],
        [
            113.10993709803,
            23.236998101699
        ],
        [
            113.10996474762,
            23.237000358259
        ],
        [
            113.10998371964,
            23.237005571412
        ],
        [
            113.1100053995,
            23.237014319397
        ],
        [
            113.11004741776,
            23.237014996646
        ],
        [
            113.11005988571,
            23.237017477945
        ],
        [
            113.11008021236,
            23.237023239608
        ],
        [
            113.11009567158,
            23.237014611014
        ],
        [
            113.1101157293,
            23.237017660251
        ],
        [
            113.11012982749,
            23.237015536962
        ],
        [
            113.11014040432,
            23.237010147535
        ],
        [
            113.11014853335,
            23.237014242805
        ],
        [
            113.11014799349,
            23.237011528806
        ],
        [
            113.11017320018,
            23.237016223528
        ],
        [
            113.11019596497,
            23.237023351604
        ],
        [
            113.11028757335,
            23.237042377817
        ],
        [
            113.11040627615,
            23.237074526325
        ],
        [
            113.11040301254,
            23.237087262107
        ],
        [
            113.11040598858,
            23.237094053208
        ],
        [
            113.11040652682,
            23.237098665878
        ],
        [
            113.11039485869,
            23.237112999155
        ],
        [
            113.11038888096,
            23.237129793677
        ],
        [
            113.11036523863,
            23.237199956484
        ],
        [
            113.11029326091,
            23.237370574961
        ],
        [
            113.11029433478,
            23.237383054853
        ],
        [
            113.11029026299,
            23.237389821332
        ],
        [
            113.11019710891,
            23.237599158165
        ],
        [
            113.11019059602,
            23.237607544141
        ],
        [
            113.1101384564,
            23.237718571192
        ],
        [
            113.11013655054,
            23.237728600094
        ],
        [
            113.11013003068,
            23.237745394296
        ],
        [
            113.110089281,
            23.23785103703
        ],
        [
            113.11004905604,
            23.237978109612
        ],
        [
            113.11003378933,
            23.238083294724
        ],
        [
            113.11001369482,
            23.238124998565
        ],
        [
            113.1100212831,
            23.238127735082
        ],
        [
            113.10999167782,
            23.238197344845
        ],
        [
            113.10998462397,
            23.238204103024
        ],
        [
            113.10994687779,
            23.238283723497
        ],
        [
            113.1099373657,
            23.238313257004
        ],
        [
            113.10990963602,
            23.238410268473
        ],
        [
            113.10990415087,
            23.238489177418
        ],
        [
            113.10986016186,
            23.238578545759
        ],
        [
            113.10984738702,
            23.238620275193
        ],
        [
            113.10980991723,
            23.238693392091
        ],
        [
            113.10982398171,
            23.238734660525
        ],
        [
            113.10983478553,
            23.238785412088
        ],
        [
            113.10979652607,
            23.238828963724
        ],
        [
            113.10975501765,
            23.23886681139
        ],
        [
            113.10969402141,
            23.238863920275
        ],
        [
            113.10963059582,
            23.238846650798
        ],
        [
            113.10959725704,
            23.238836792362
        ],
        [
            113.10958527415,
            23.238905378339
        ],
        [
            113.109577377,
            23.238949836958
        ],
        [
            113.10964756717,
            23.238984752252
        ],
        [
            113.10975246639,
            23.239008654025
        ],
        [
            113.10983865972,
            23.239030067918
        ],
        [
            113.10983051363,
            23.239046859109
        ],
        [
            113.10976939493,
            23.239202358448
        ],
        [
            113.10971697911,
            23.239322356355
        ],
        [
            113.1096838746,
            23.239360773921
        ],
        [
            113.10967844725,
            23.239367538841
        ],
        [
            113.10962313587,
            23.239374432212
        ],
        [
            113.10960602218,
            23.239418322185
        ],
        [
            113.10958864968,
            23.239446209437
        ],
        [
            113.10953975945,
            23.239563784951
        ],
        [
            113.10947949351,
            23.239666685723
        ],
        [
            113.10944934502,
            23.239738479262
        ],
        [
            113.10941077876,
            23.239827609825
        ],
        [
            113.10937381382,
            23.239950649232
        ],
        [
            113.10934877659,
            23.240076433065
        ],
        [
            113.10932188515,
            23.240143899159
        ],
        [
            113.10929856981,
            23.240141941073
        ],
        [
            113.10924110354,
            23.240124709299
        ],
        [
            113.10917550028,
            23.240110715506
        ],
        [
            113.10913017637,
            23.240170818659
        ],
        [
            113.10909163383,
            23.240226600026
        ],
        [
            113.10903878685,
            23.240192845027
        ],
        [
            113.10900109198,
            23.240201438171
        ],
        [
            113.1089764195,
            23.240199483941
        ],
        [
            113.10895660082,
            23.24023361418
        ],
        [
            113.10893081494,
            23.240270443901
        ],
        [
            113.10882195627,
            23.240445422132
        ],
        [
            113.10892902763,
            23.24048931996
        ],
        [
            113.10898947949,
            23.240507355647
        ],
        [
            113.10891832506,
            23.240665594121
        ],
        [
            113.10889929383,
            23.240736342956
        ],
        [
            113.10889006588,
            23.240748799408
        ],
        [
            113.108874868,
            23.240767752546
        ],
        [
            113.10883525561,
            23.24080211399
        ],
        [
            113.10878344482,
            23.240831298297
        ],
        [
            113.1087376106,
            23.240844223506
        ],
        [
            113.10863072352,
            23.240915616628
        ],
        [
            113.10855474321,
            23.240992773014
        ],
        [
            113.1084570473,
            23.241100002589
        ],
        [
            113.10838269264,
            23.241176360365
        ],
        [
            113.10831813408,
            23.241203375703
        ],
        [
            113.10822296964,
            23.241175830225
        ],
        [
            113.10821049587,
            23.241174997317
        ],
        [
            113.10811045483,
            23.241137961318
        ],
        [
            113.10806897569,
            23.241120001221
        ],
        [
            113.10795564809,
            23.241076451573
        ],
        [
            113.1078897301,
            23.241100778503
        ],
        [
            113.10782023914,
            23.241191284955
        ],
        [
            113.10775938946,
            23.241334423896
        ],
        [
            113.10769176492,
            23.24146996486
        ],
        [
            113.10764615998,
            23.24153040181
        ],
        [
            113.10764371908,
            23.241530399344
        ],
        [
            113.10762932678,
            23.241556694128
        ],
        [
            113.107598921,
            23.241600332156
        ],
        [
            113.10760027186,
            23.24160792788
        ],
        [
            113.10750374215,
            23.241574206266
        ],
        [
            113.10742808533,
            23.241554342687
        ],
        [
            113.10732423292,
            23.241515477957
        ],
        [
            113.1071655671,
            23.241508595922
        ],
        [
            113.1070356578,
            23.241487917015
        ],
        [
            113.10703321568,
            23.241489272077
        ],
        [
            113.10669611617,
            23.24139397481
        ],
        [
            113.10657219391,
            23.241329142499
        ],
        [
            113.10649217762,
            23.241317752874
        ],
        [
            113.10643902117,
            23.241299313948
        ],
        [
            113.10634652407,
            23.241287936629
        ],
        [
            113.10628793486,
            23.241277643111
        ],
        [
            113.10627355901,
            23.241274663317
        ],
        [
            113.10618324011,
            23.24124783947
        ],
        [
            113.10576636264,
            23.241096178185
        ],
        [
            113.10565001017,
            23.241039583616
        ],
        [
            113.10552823094,
            23.240980023336
        ],
        [
            113.10510043098,
            23.240854126158
        ],
        [
            113.10496560434,
            23.240809022335
        ],
        [
            113.1048546517,
            23.240766609595
        ],
        [
            113.1046722979,
            23.240766642325
        ],
        [
            113.1046304984,
            23.240779463991
        ],
        [
            113.10460227168,
            23.240785753096
        ],
        [
            113.10447771385,
            23.240783545409
        ],
        [
            113.10430542231,
            23.240736155904
        ],
        [
            113.10403088476,
            23.240584606409
        ],
        [
            113.10408713284,
            23.240489546898
        ],
        [
            113.10370782879,
            23.240326933058
        ],
        [
            113.10369560218,
            23.24034459508
        ],
        [
            113.10368664528,
            23.240344890093
        ],
        [
            113.10365757687,
            23.240381583275
        ],
        [
            113.10363964385,
            23.240408211729
        ],
        [
            113.10352909286,
            23.240521888592
        ],
        [
            113.10348614651,
            23.240606361202
        ],
        [
            113.10343967465,
            23.2406865061
        ],
        [
            113.10334135018,
            23.240779282533
        ],
        [
            113.10329735837,
            23.240806537003
        ],
        [
            113.10326666315,
            23.240838634767
        ],
        [
            113.10323732674,
            23.240868288185
        ],
        [
            113.10316285918,
            23.240998979554
        ],
        [
            113.10315307513,
            23.241016097616
        ],
        [
            113.10311690714,
            23.241109514215
        ],
        [
            113.10311224713,
            23.241174081151
        ],
        [
            113.10313115972,
            23.241300413104
        ],
        [
            113.10316388547,
            23.241471454706
        ],
        [
            113.10313799779,
            23.241617728258
        ],
        [
            113.10314119504,
            23.241705596184
        ],
        [
            113.10311693636,
            23.241853221514
        ],
        [
            113.10314186895,
            23.241912812874
        ],
        [
            113.1028819646,
            23.242102982433
        ],
        [
            113.10285698152,
            23.242116629003
        ],
        [
            113.10280428655,
            23.24216481798
        ],
        [
            113.10264708347,
            23.242203346155
        ],
        [
            113.10250887449,
            23.242248877677
        ],
        [
            113.10236254203,
            23.242257299442
        ],
        [
            113.1022797216,
            23.242284203291
        ],
        [
            113.10221724444,
            23.242337341126
        ],
        [
            113.10215283858,
            23.242432802216
        ],
        [
            113.10213813342,
            23.242501211962
        ],
        [
            113.10214595088,
            23.242587431429
        ],
        [
            113.10214209545,
            23.24267207103
        ],
        [
            113.10212004255,
            23.242768719061
        ],
        [
            113.10215658014,
            23.242948396605
        ],
        [
            113.10212911521,
            23.243018485946
        ],
        [
            113.10211657956,
            23.243093397039
        ],
        [
            113.10208175683,
            23.243207999773
        ],
        [
            113.10201436183,
            23.243310805192
        ],
        [
            113.10193098189,
            23.243357808844
        ],
        [
            113.10174738891,
            23.243444857214
        ],
        [
            113.10159665227,
            23.243518495338
        ],
        [
            113.10159338908,
            23.243526647189
        ],
        [
            113.10157737915,
            23.243510446336
        ],
        [
            113.10156299718,
            23.243496136876
        ],
        [
            113.101402881,
            23.243358011716
        ],
        [
            113.10121698502,
            23.243187216536
        ],
        [
            113.10113773669,
            23.243120070625
        ],
        [
            113.10110056228,
            23.243076587585
        ],
        [
            113.10100529742,
            23.24299949572
        ],
        [
            113.10094070365,
            23.242943138659
        ],
        [
            113.10077676803,
            23.24280919168
        ],
        [
            113.10068991265,
            23.242738863006
        ],
        [
            113.10066277122,
            23.242715140622
        ],
        [
            113.10043123055,
            23.242543366823
        ],
        [
            113.10042851159,
            23.242548264171
        ],
        [
            113.1003412555,
            23.242670266781
        ],
        [
            113.10032847868,
            23.242689596665
        ],
        [
            113.10031164443,
            23.242683454144
        ],
        [
            113.10025971601,
            23.242770273676
        ],
        [
            113.10023090445,
            23.242806784389
        ],
        [
            113.1001933845,
            23.242870740627
        ],
        [
            113.10005694541,
            23.243028040452
        ],
        [
            113.09995961217,
            23.243189460959
        ],
        [
            113.09983890012,
            23.243383580376
        ],
        [
            113.09969752455,
            23.243610660511
        ],
        [
            113.09962738177,
            23.243720406558
        ],
        [
            113.09960182139,
            23.24376776221
        ],
        [
            113.09952870041,
            23.24386044552
        ],
        [
            113.0994805854,
            23.243924221987
        ],
        [
            113.09946291054,
            23.243956883591
        ],
        [
            113.09944823043,
            23.243977863124
        ],
        [
            113.09943409578,
            23.243995042055
        ],
        [
            113.09942757702,
            23.243994541718
        ],
        [
            113.09941969567,
            23.244001644772
        ],
        [
            113.0994072044,
            23.243995487319
        ],
        [
            113.09937380141,
            23.243982956388
        ],
        [
            113.09935370596,
            23.243974136721
        ],
        [
            113.09934800647,
            23.243966036948
        ],
        [
            113.09932655038,
            23.243961295145
        ],
        [
            113.09922769893,
            23.243921533334
        ],
        [
            113.0992111127,
            23.243949309341
        ],
        [
            113.09919888481,
            23.243956442811
        ],
        [
            113.09903823437,
            23.24414494658
        ],
        [
            113.099034154,
            23.24415473875
        ],
        [
            113.09904746374,
            23.244156275675
        ],
        [
            113.09911315977,
            23.244228521992
        ],
        [
            113.09936891419,
            23.24445032442
        ],
        [
            113.09940909594,
            23.244484510093
        ],
        [
            113.09939358143,
            23.244540756349
        ],
        [
            113.09941365673,
            23.244585651133
        ],
        [
            113.09978285831,
            23.244948130332
        ],
        [
            113.09987351514,
            23.245059324959
        ],
        [
            113.09990227271,
            23.245119907452
        ],
        [
            113.09987345335,
            23.245174600808
        ],
        [
            113.09980199427,
            23.245224131232
        ],
        [
            113.09974603514,
            23.245238038061
        ],
        [
            113.09973408432,
            23.245237840855
        ],
        [
            113.09971452856,
            23.245237148552
        ],
        [
            113.0997009546,
            23.245224484894
        ],
        [
            113.09964530303,
            23.245168958128
        ],
        [
            113.09959372026,
            23.245122901624
        ],
        [
            113.09954214223,
            23.245067354148
        ],
        [
            113.09951825328,
            23.245041739038
        ],
        [
            113.09949192463,
            23.245006918036
        ],
        [
            113.09944741003,
            23.244948074768
        ],
        [
            113.09941673973,
            23.244904875203
        ],
        [
            113.09937901573,
            23.244845719442
        ],
        [
            113.09933205045,
            23.244796932364
        ],
        [
            113.09930083745,
            23.244752112071
        ],
        [
            113.09926799711,
            23.244702692382
        ],
        [
            113.09923840592,
            23.244671967328
        ],
        [
            113.09921317325,
            23.244618972772
        ],
        [
            113.09919308684,
            23.244592525489
        ],
        [
            113.09916458365,
            23.24455881151
        ],
        [
            113.09914801994,
            23.244547530603
        ],
        [
            113.09912819328,
            23.244541967794
        ],
        [
            113.09910536825,
            23.244554598268
        ],
        [
            113.09907764639,
            23.244580010351
        ],
        [
            113.09901948465,
            23.244633024908
        ],
        [
            113.09897519185,
            23.2446585525
        ],
        [
            113.09890696967,
            23.244726830851
        ],
        [
            113.09887272778,
            23.244751479203
        ],
        [
            113.09884011534,
            23.244776659672
        ],
        [
            113.0988028765,
            23.244816520145
        ],
        [
            113.09874688209,
            23.244876314053
        ],
        [
            113.09869605229,
            23.244929835598
        ],
        [
            113.09868137375,
            23.244945942689
        ],
        [
            113.09865609643,
            23.244969177567
        ],
        [
            113.09860772309,
            23.245000444117
        ],
        [
            113.09856967004,
            23.245036791806
        ],
        [
            113.09854031975,
            23.245055447494
        ],
        [
            113.09850797554,
            23.245084161353
        ],
        [
            113.0984797089,
            23.245107964182
        ],
        [
            113.0984400244,
            23.245145684126
        ],
        [
            113.09817012618,
            23.245371186068
        ],
        [
            113.09813505744,
            23.245411322637
        ],
        [
            113.09800292501,
            23.245585378699
        ],
        [
            113.0978686043,
            23.245785234242
        ],
        [
            113.09780386299,
            23.245936819698
        ],
        [
            113.09777445731,
            23.246061006578
        ],
        [
            113.09761579783,
            23.246023477639
        ],
        [
            113.09707428283,
            23.245957134732
        ],
        [
            113.0964522619,
            23.24592104145
        ],
        [
            113.09624871294,
            23.245907688617
        ],
        [
            113.0957779934,
            23.24588439495
        ],
        [
            113.09469620249,
            23.245792567758
        ],
        [
            113.09407642535,
            23.245693043316
        ],
        [
            113.09245039576,
            23.245304911492
        ],
        [
            113.09206133242,
            23.245153096506
        ],
        [
            113.0916478072,
            23.24493849002
        ],
        [
            113.09134761352,
            23.244833493289
        ],
        [
            113.09109824719,
            23.244767774387
        ],
        [
            113.09086736806,
            23.244702397997
        ],
        [
            113.09083758005,
            23.244957202095
        ],
        [
            113.09082582149,
            23.245072629539
        ],
        [
            113.09081983279,
            23.245081658057
        ],
        [
            113.09077117108,
            23.245546375014
        ],
        [
            113.09077116826,
            23.245551799777
        ],
        [
            113.09079020124,
            23.245564300249
        ],
        [
            113.09080623506,
            23.245590672978
        ],
        [
            113.09080351288,
            23.245595048138
        ],
        [
            113.0908062095,
            23.245640038356
        ],
        [
            113.09077353345,
            23.24571179856
        ],
        [
            113.09076916221,
            23.245749557378
        ],
        [
            113.09075145346,
            23.245806747771
        ],
        [
            113.09075359817,
            23.245868290655
        ],
        [
            113.09074322103,
            23.24595033955
        ],
        [
            113.09072931948,
            23.246009921822
        ],
        [
            113.09070507773,
            23.246078590086
        ],
        [
            113.0906819264,
            23.246142633462
        ],
        [
            113.09065217039,
            23.246364624383
        ],
        [
            113.09066060655,
            23.246355834335
        ],
        [
            113.09037662678,
            23.247574731649
        ],
        [
            113.09032838088,
            23.247814607862
        ],
        [
            113.09028968216,
            23.247994142961
        ],
        [
            113.09028288231,
            23.24799314853
        ],
        [
            113.09028859236,
            23.247998497361
        ],
        [
            113.09024663681,
            23.248163158783
        ],
        [
            113.0902270096,
            23.248270833282
        ],
        [
            113.09021936295,
            23.248348782457
        ],
        [
            113.09020545176,
            23.248449057491
        ],
        [
            113.09020814007,
            23.248532836166
        ],
        [
            113.0902491986,
            23.248573517241
        ],
        [
            113.0903637078,
            23.248591794812
        ],
        [
            113.09037730631,
            23.248596768097
        ],
        [
            113.09045046847,
            23.248616685494
        ],
        [
            113.09045917479,
            23.248610874318
        ],
        [
            113.0905152017,
            23.248626409898
        ],
        [
            113.09055790274,
            23.248635070207
        ],
        [
            113.09063432726,
            23.248654953011
        ],
        [
            113.09065499841,
            23.248656852286
        ],
        [
            113.09069307445,
            23.248666390452
        ],
        [
            113.09070993617,
            23.248671866396
        ],
        [
            113.09072625477,
            23.248674908395
        ],
        [
            113.09072570967,
            23.248677899203
        ],
        [
            113.09074175424,
            23.24868636984
        ],
        [
            113.09075317606,
            23.248691645911
        ],
        [
            113.09087989505,
            23.248771373771
        ],
        [
            113.09101449296,
            23.248870268911
        ],
        [
            113.09110041429,
            23.24894131751
        ],
        [
            113.09118905338,
            23.249016133667
        ],
        [
            113.09128339644,
            23.249110412279
        ],
        [
            113.09134267066,
            23.249157129347
        ],
        [
            113.09137502798,
            23.249178691274
        ],
        [
            113.09140765549,
            23.249205132922
        ],
        [
            113.09142641022,
            23.249237988659
        ],
        [
            113.09142667766,
            23.249251276394
        ],
        [
            113.09143727993,
            23.249264705215
        ],
        [
            113.0914543949,
            23.249321180471
        ],
        [
            113.09148348338,
            23.249357433198
        ],
        [
            113.0915324169,
            23.249419206233
        ],
        [
            113.09153594681,
            23.249436250608
        ],
        [
            113.09154954194,
            23.249445845277
        ],
        [
            113.09158161879,
            23.249491556184
        ],
        [
            113.09160254796,
            23.249528455727
        ],
        [
            113.09162402284,
            23.249559923808
        ],
        [
            113.09164169671,
            23.249571367194
        ],
        [
            113.09165174997,
            23.24960026553
        ],
        [
            113.09165310428,
            23.2496173373
        ],
        [
            113.09164466557,
            23.249641854726
        ],
        [
            113.09164003941,
            23.249650592299
        ],
        [
            113.09160113672,
            23.249687967248
        ],
        [
            113.09152822808,
            23.249757233814
        ],
        [
            113.09136636828,
            23.249878620199
        ],
        [
            113.09134895634,
            23.249897014012
        ],
        [
            113.09113433286,
            23.250006886863
        ],
        [
            113.09090826518,
            23.250168203368
        ],
        [
            113.09083672135,
            23.250203578738
        ],
        [
            113.09074776456,
            23.250255187887
        ],
        [
            113.09073416515,
            23.250254008899
        ],
        [
            113.0907175718,
            23.250259650343
        ],
        [
            113.09057227502,
            23.250433796844
        ],
        [
            113.09049634326,
            23.250589680521
        ],
        [
            113.09047811067,
            23.250620301162
        ],
        [
            113.09045715767,
            23.25065231421
        ],
        [
            113.09044110347,
            23.25067422647
        ],
        [
            113.09044191898,
            23.250676114448
        ],
        [
            113.09043348227,
            23.250693043581
        ],
        [
            113.09041878745,
            23.250717379357
        ],
        [
            113.09033960594,
            23.250820962246
        ],
        [
            113.09027645516,
            23.250994318509
        ],
        [
            113.09024051692,
            23.251125812558
        ],
        [
            113.09022499689,
            23.251188679093
        ],
        [
            113.09021410672,
            23.251228698711
        ],
        [
            113.09021409862,
            23.251262605446
        ],
        [
            113.09020756964,
            23.251265405208
        ],
        [
            113.09012286049,
            23.251765646391
        ],
        [
            113.09001855791,
            23.252376560017
        ],
        [
            113.0899575623,
            23.252746564044
        ],
        [
            113.08996325991,
            23.252840884794
        ],
        [
            113.08996730029,
            23.2531110036
        ],
        [
            113.08995939558,
            23.253227751767
        ],
        [
            113.08994577048,
            23.253412663639
        ],
        [
            113.08991798149,
            23.253783852507
        ],
        [
            113.08985592766,
            23.254118887784
        ],
        [
            113.08984993867,
            23.254170508884
        ],
        [
            113.0898118412,
            23.254342464421
        ],
        [
            113.08981264996,
            23.254443634485
        ],
        [
            113.08982162497,
            23.2544711813
        ],
        [
            113.089852353,
            23.25464410122
        ],
        [
            113.08986350378,
            23.254683554395
        ],
        [
            113.08991246825,
            23.254684247059
        ],
        [
            113.08998836269,
            23.254683763746
        ],
        [
            113.09005283205,
            23.25467529965
        ],
        [
            113.09006806375,
            23.254699779781
        ],
        [
            113.09009417408,
            23.254763718465
        ],
        [
            113.09010233204,
            23.25481433532
        ],
        [
            113.09010586407,
            23.254903533892
        ],
        [
            113.09010586052,
            23.254987083461
        ],
        [
            113.09011836874,
            23.255111154977
        ],
        [
            113.09011020522,
            23.255207563722
        ],
        [
            113.090097961,
            23.25534553109
        ],
        [
            113.09008598999,
            23.255469931781
        ],
        [
            113.09005661069,
            23.255576663243
        ],
        [
            113.09003675262,
            23.255681368254
        ],
        [
            113.09001281471,
            23.255747066129
        ],
        [
            113.08998670079,
            23.255814692633
        ],
        [
            113.08996956358,
            23.255851816369
        ],
        [
            113.08994181751,
            23.255891796389
        ],
        [
            113.08991135101,
            23.255913910045
        ],
        [
            113.08988550891,
            23.255941115656
        ],
        [
            113.08983382421,
            23.25596731623
        ],
        [
            113.08979492461,
            23.255995785764
        ],
        [
            113.08974242331,
            23.256021186454
        ],
        [
            113.08966299065,
            23.256055095201
        ],
        [
            113.08960341612,
            23.25610338355
        ],
        [
            113.08947420023,
            23.256180031506
        ],
        [
            113.08940945579,
            23.25622514274
        ],
        [
            113.08933954242,
            23.256279822528
        ],
        [
            113.08926799637,
            23.256335341675
        ],
        [
            113.08916244484,
            23.256420093213
        ],
        [
            113.08907566375,
            23.256499433689
        ],
        [
            113.08896684632,
            23.256593466023
        ],
        [
            113.08887870399,
            23.256678803362
        ],
        [
            113.08878430337,
            23.25675718084
        ],
        [
            113.08872064438,
            23.25682074852
        ],
        [
            113.08862869053,
            23.256887706045
        ],
        [
            113.08855224499,
            23.256972078816
        ],
        [
            113.0884918501,
            23.257038863147
        ],
        [
            113.0884105071,
            23.257128195087
        ],
        [
            113.088354194,
            23.257209031422
        ],
        [
            113.08828754183,
            23.257287848781
        ],
        [
            113.08825517032,
            23.257355321238
        ],
        [
            113.08818416896,
            23.257480592962
        ],
        [
            113.08813547683,
            23.257588452911
        ],
        [
            113.08806094229,
            23.257744977402
        ],
        [
            113.08802748701,
            23.257846379127
        ],
        [
            113.08800328417,
            23.257957412272
        ],
        [
            113.08797882148,
            23.258161225618
        ],
        [
            113.087975025,
            23.258258668852
        ],
        [
            113.087984024,
            23.258405839855
        ],
        [
            113.08799383731,
            23.258532111
        ],
        [
            113.08800147052,
            23.25863074403
        ],
        [
            113.08801291373,
            23.25873122051
        ],
        [
            113.08802979674,
            23.258816968838
        ],
        [
            113.08804504948,
            23.258913863542
        ],
        [
            113.08806546647,
            23.258977044801
        ],
        [
            113.08809295511,
            23.259024931812
        ],
        [
            113.08813514063,
            23.259097834388
        ],
        [
            113.0881721583,
            23.259179493874
        ],
        [
            113.08820971737,
            23.259245140892
        ],
        [
            113.08825408598,
            23.25935029681
        ],
        [
            113.08830198705,
            23.2594304452
        ],
        [
            113.08834009717,
            23.259528911828
        ],
        [
            113.08836514339,
            23.259604508849
        ],
        [
            113.08840597109,
            23.259684762108
        ],
        [
            113.08843264655,
            23.259743246091
        ],
        [
            113.08845306425,
            23.259800735271
        ],
        [
            113.08847865605,
            23.259879310303
        ],
        [
            113.08850043471,
            23.259938136964
        ],
        [
            113.08852629613,
            23.26000395872
        ],
        [
            113.08854589995,
            23.260069056624
        ],
        [
            113.08858129127,
            23.260165668888
        ],
        [
            113.08860960495,
            23.260244478435
        ],
        [
            113.08863519624,
            23.260315188882
        ],
        [
            113.08865397771,
            23.260351815314
        ],
        [
            113.08866351398,
            23.260408648564
        ],
        [
            113.08871142142,
            23.260504814091
        ],
        [
            113.08876313544,
            23.260591160761
        ],
        [
            113.08880505341,
            23.260670051906
        ],
        [
            113.08885758785,
            23.260771581658
        ],
        [
            113.08890141404,
            23.26086346981
        ],
        [
            113.08894224859,
            23.26095811414
        ],
        [
            113.08897546253,
            23.261040930293
        ],
        [
            113.08901113037,
            23.261141888678
        ],
        [
            113.08904706891,
            23.261236875832
        ],
        [
            113.08908654028,
            23.261317707477
        ],
        [
            113.08910723458,
            23.261379541739
        ],
        [
            113.0891200372,
            23.261433619476
        ],
        [
            113.08914510247,
            23.261553990725
        ],
        [
            113.08916580675,
            23.261645938413
        ],
        [
            113.08917480937,
            23.261725570693
        ],
        [
            113.08918299366,
            23.261797347217
        ],
        [
            113.0891982568,
            23.261885573512
        ],
        [
            113.08919258451,
            23.262010173271
        ],
        [
            113.08919153163,
            23.262116261203
        ],
        [
            113.08917496784,
            23.26220873019
        ],
        [
            113.08917663295,
            23.262304471466
        ],
        [
            113.08917204719,
            23.262416848732
        ],
        [
            113.08916637098,
            23.262521102733
        ],
        [
            113.08915144005,
            23.262610022788
        ],
        [
            113.08914249707,
            23.26270564152
        ],
        [
            113.08913709269,
            23.262805280229
        ],
        [
            113.08910558419,
            23.262937839282
        ],
        [
            113.08909527296,
            23.263008519091
        ],
        [
            113.08906755178,
            23.263082427366
        ],
        [
            113.089045546,
            23.263161681678
        ],
        [
            113.08901457805,
            23.263280128159
        ],
        [
            113.08899175717,
            23.26336047993
        ],
        [
            113.08895452667,
            23.263463552243
        ],
        [
            113.08893796001,
            23.263534864117
        ],
        [
            113.08889692637,
            23.263650199588
        ],
        [
            113.0888596872,
            23.2637299432
        ],
        [
            113.08881864435,
            23.263821678397
        ],
        [
            113.08879908923,
            23.26390063036
        ],
        [
            113.08875804499,
            23.263988026436
        ],
        [
            113.08871266239,
            23.264108854288
        ],
        [
            113.0886716185,
            23.264195981213
        ],
        [
            113.08865395911,
            23.26425266197
        ],
        [
            113.0886300568,
            23.264341987271
        ],
        [
            113.08861894548,
            23.264438997824
        ],
        [
            113.08859721031,
            23.264506046655
        ],
        [
            113.08859318055,
            23.264618420145
        ],
        [
            113.08857909133,
            23.264744773638
        ],
        [
            113.0885805162,
            23.264882571208
        ],
        [
            113.0885675163,
            23.265007824384
        ],
        [
            113.0885517878,
            23.265115211333
        ],
        [
            113.08853116032,
            23.265218056676
        ],
        [
            113.08850779806,
            23.265291370245
        ],
        [
            113.0884846944,
            23.265337008192
        ],
        [
            113.08842460141,
            23.265408137421
        ],
        [
            113.08838435487,
            23.265449411276
        ],
        [
            113.08831718544,
            23.265516305249
        ],
        [
            113.08825926566,
            23.265581711308
        ],
        [
            113.08817959715,
            23.265682432119
        ],
        [
            113.08815567445,
            23.265722660245
        ],
        [
            113.08813094416,
            23.265779720901
        ],
        [
            113.08811656159,
            23.265853180536
        ],
        [
            113.08810708577,
            23.265943932017
        ],
        [
            113.08810170238,
            23.266055242757
        ],
        [
            113.08811071587,
            23.266121037183
        ],
        [
            113.08812544441,
            23.266188918968
        ],
        [
            113.08813743985,
            23.26623350891
        ],
        [
            113.08815188438,
            23.266278605963
        ],
        [
            113.08817232454,
            23.266341793153
        ],
        [
            113.08819113648,
            23.266412600615
        ],
        [
            113.08823062169,
            23.266474155808
        ],
        [
            113.08828182482,
            23.266569454888
        ],
        [
            113.08834173328,
            23.266662459428
        ],
        [
            113.08839539164,
            23.266769120987
        ],
        [
            113.08846920446,
            23.266912662906
        ],
        [
            113.0885318425,
            23.267020827548
        ],
        [
            113.0885912388,
            23.2671689221
        ],
        [
            113.08861088182,
            23.267262240548
        ],
        [
            113.08862888962,
            23.267350156588
        ],
        [
            113.0886376451,
            23.267434135337
        ],
        [
            113.08862842238,
            23.267480930973
        ],
        [
            113.0886123976,
            23.267527009905
        ],
        [
            113.08859610147,
            23.267574178087
        ],
        [
            113.08855751967,
            23.267661546786
        ],
        [
            113.08850994864,
            23.267730596619
        ],
        [
            113.08844388933,
            23.267820803736
        ],
        [
            113.08838462231,
            23.267895451117
        ],
        [
            113.08833813204,
            23.267952552578
        ],
        [
            113.08832263221,
            23.267966612803
        ],
        [
            113.08825899828,
            23.268019623017
        ],
        [
            113.08818476413,
            23.268090966582
        ],
        [
            113.0881287362,
            23.268125150899
        ],
        [
            113.08800336806,
            23.268227089365
        ],
        [
            113.08792313128,
            23.26827411354
        ],
        [
            113.08785649922,
            23.268322297783
        ],
        [
            113.08779014416,
            23.268378890709
        ],
        [
            113.08774228387,
            23.268423818378
        ],
        [
            113.08767756768,
            23.268491243227
        ],
        [
            113.08761639315,
            23.26856594305
        ],
        [
            113.08757318002,
            23.268645261909
        ],
        [
            113.08753621196,
            23.268703869808
        ],
        [
            113.0874962557,
            23.268770119411
        ],
        [
            113.08743672404,
            23.268861078903
        ],
        [
            113.08738072986,
            23.268952258748
        ],
        [
            113.08734647768,
            23.2690029619
        ],
        [
            113.08732690914,
            23.269038252906
        ],
        [
            113.087304353,
            23.269081999315
        ],
        [
            113.08724756268,
            23.26920358132
        ],
        [
            113.08721685932,
            23.269271325931
        ],
        [
            113.08720464361,
            23.269315189716
        ],
        [
            113.08719570289,
            23.269373383703
        ],
        [
            113.08719057965,
            23.26944318665
        ],
        [
            113.08719471763,
            23.269526687261
        ],
        [
            113.08719447804,
            23.269574712338
        ],
        [
            113.08719748135,
            23.269589589175
        ],
        [
            113.0872054247,
            23.269666250083
        ],
        [
            113.08721611429,
            23.269779225175
        ],
        [
            113.08721643603,
            23.269851388389
        ],
        [
            113.08722790987,
            23.269916872932
        ],
        [
            113.08723422175,
            23.269993829953
        ],
        [
            113.08724217029,
            23.270076188688
        ],
        [
            113.08725477367,
            23.270199445449
        ],
        [
            113.08726575652,
            23.270339005274
        ],
        [
            113.08726717909,
            23.270426345707
        ],
        [
            113.087256101,
            23.27053612093
        ],
        [
            113.08724688966,
            23.270592420201
        ],
        [
            113.08722897884,
            23.270659702426
        ],
        [
            113.08721595039,
            23.270705206733
        ],
        [
            113.08720483384,
            23.270760449623
        ],
        [
            113.08719755907,
            23.270859858574
        ],
        [
            113.08718456623,
            23.270953655986
        ],
        [
            113.08717132276,
            23.271076216321
        ],
        [
            113.08715859874,
            23.271164583797
        ],
        [
            113.08713334083,
            23.27123007847
        ],
        [
            113.08710808059,
            23.271292317781
        ],
        [
            113.08706136543,
            23.271410771169
        ],
        [
            113.08703883449,
            23.271483551439
        ],
        [
            113.08698067117,
            23.271575862328
        ],
        [
            113.0869380223,
            23.271673094897
        ],
        [
            113.08686055052,
            23.271781166537
        ],
        [
            113.0868216727,
            23.271827608855
        ],
        [
            113.08676647201,
            23.271879997883
        ],
        [
            113.0867202511,
            23.271932251465
        ],
        [
            113.08666231778,
            23.271970305287
        ],
        [
            113.08654863003,
            23.272049911342
        ],
        [
            113.08647001949,
            23.272095070152
        ],
        [
            113.0864090775,
            23.272114999005
        ],
        [
            113.08630950982,
            23.272157773041
        ],
        [
            113.08625074149,
            23.272174416971
        ],
        [
            113.08616149417,
            23.272192077271
        ],
        [
            113.08604232217,
            23.272224585943
        ],
        [
            113.08596613084,
            23.272235539433
        ],
        [
            113.08589375975,
            23.272260272812
        ],
        [
            113.08582058002,
            23.272295602371
        ],
        [
            113.08576616537,
            23.272314632556
        ],
        [
            113.08570632768,
            23.272359523982
        ],
        [
            113.08564485516,
            23.272402272141
        ],
        [
            113.08559861952,
            23.272440712274
        ],
        [
            113.08557849987,
            23.272465718717
        ],
        [
            113.08555620963,
            23.272499170294
        ],
        [
            113.0855491769,
            23.272554086693
        ],
        [
            113.08553967776,
            23.272587336846
        ],
        [
            113.08553075345,
            23.272659104684
        ],
        [
            113.08552102169,
            23.272742009249
        ],
        [
            113.08552600124,
            23.27284340256
        ],
        [
            113.08551302572,
            23.272953218669
        ],
        [
            113.08549953538,
            23.273099128056
        ],
        [
            113.08546937742,
            23.273162549553
        ],
        [
            113.08544440053,
            23.273238370088
        ],
        [
            113.08539549394,
            23.27333871671
        ],
        [
            113.08536398651,
            23.273415726815
        ],
        [
            113.08531263677,
            23.273523439489
        ],
        [
            113.0852528188,
            23.273593032176
        ],
        [
            113.08521123707,
            23.273664506804
        ],
        [
            113.08517235877,
            23.273713962454
        ],
        [
            113.08512558261,
            23.2737573043
        ],
        [
            113.08506221373,
            23.27381203586
        ],
        [
            113.084986324,
            23.273865612674
        ],
        [
            113.0849166914,
            23.273916378358
        ],
        [
            113.08485821571,
            23.273965067717
        ],
        [
            113.08479212299,
            23.274018493213
        ],
        [
            113.08472547589,
            23.274060262679
        ],
        [
            113.08465502904,
            23.27411511837
        ],
        [
            113.08459817404,
            23.274150221631
        ],
        [
            113.08455165613,
            23.274178918735
        ],
        [
            113.08447359427,
            23.274241770603
        ],
        [
            113.0844216373,
            23.274276255731
        ],
        [
            113.08438329491,
            23.274317575229
        ],
        [
            113.08432888898,
            23.27435318716
        ],
        [
            113.08426304678,
            23.274383559835
        ],
        [
            113.08422930535,
            23.274394419027
        ],
        [
            113.08420100996,
            23.274408174413
        ],
        [
            113.08415528899,
            23.274415159905
        ],
        [
            113.08408997263,
            23.274424636613
        ],
        [
            113.08401866976,
            23.274436383287
        ],
        [
            113.08392153153,
            23.27447514426
        ],
        [
            113.08382981957,
            23.274494013165
        ],
        [
            113.08374844557,
            23.274507288531
        ],
        [
            113.08364395432,
            23.274543737884
        ],
        [
            113.08357375163,
            23.274571485143
        ],
        [
            113.08349947152,
            23.274606084419
        ],
        [
            113.08342954339,
            23.274637357644
        ],
        [
            113.08338112955,
            23.274681299198
        ],
        [
            113.08334277502,
            23.27471123743
        ],
        [
            113.08333651985,
            23.2747175815
        ],
        [
            113.08330471448,
            23.274766675249
        ],
        [
            113.08327589303,
            23.274803781751
        ],
        [
            113.08322914175,
            23.274882155654
        ],
        [
            113.08319192824,
            23.274972852346
        ],
        [
            113.08316694552,
            23.275042183075
        ],
        [
            113.08314740807,
            23.275112779989
        ],
        [
            113.08310634521,
            23.275158774131
        ],
        [
            113.08307616751,
            23.275201331531
        ],
        [
            113.08301659794,
            23.27525116251
        ],
        [
            113.08295729851,
            23.275298819523
        ],
        [
            113.08288574974,
            23.275346682475
        ],
        [
            113.08279379575,
            23.275406826856
        ],
        [
            113.08266402091,
            23.275486329718
        ],
        [
            113.08255575863,
            23.275575514423
        ],
        [
            113.08242952799,
            23.275662834836
        ],
        [
            113.08230765732,
            23.275756055172
        ],
        [
            113.08220102046,
            23.275838169005
        ],
        [
            113.08209900937,
            23.275918579621
        ],
        [
            113.08199129532,
            23.27601482648
        ],
        [
            113.0819053422,
            23.276092527912
        ],
        [
            113.08183790909,
            23.276180226309
        ],
        [
            113.08177916899,
            23.276247700046
        ],
        [
            113.08173077107,
            23.276312556504
        ],
        [
            113.08167775489,
            23.276388073886
        ],
        [
            113.08160000657,
            23.276508511022
        ],
        [
            113.08152521856,
            23.276591185325
        ],
        [
            113.08146893318,
            23.276664048169
        ],
        [
            113.08140286218,
            23.276753087349
        ],
        [
            113.08131150968,
            23.276881631366
        ],
        [
            113.08124163291,
            23.276976707457
        ],
        [
            113.08118645553,
            23.277070446975
        ],
        [
            113.08114159249,
            23.277130908594
        ],
        [
            113.08106983212,
            23.277249896289
        ],
        [
            113.08103372413,
            23.277357418717
        ],
        [
            113.08099513835,
            23.277434867241
        ],
        [
            113.08096716817,
            23.27751050537
        ],
        [
            113.08093372897,
            23.277559919517
        ],
        [
            113.0808845134,
            23.277623714646
        ],
        [
            113.08086088269,
            23.277681642638
        ],
        [
            113.08082636978,
            23.27774735552
        ],
        [
            113.08080112633,
            23.277827288894
        ],
        [
            113.08077346365,
            23.277940094395
        ],
        [
            113.08074687026,
            23.278031718364
        ],
        [
            113.0807414863,
            23.278096386489
        ],
        [
            113.08073775349,
            23.27817974751
        ],
        [
            113.08073728892,
            23.278264408756
        ],
        [
            113.08074446095,
            23.278363589709
        ],
        [
            113.08074782215,
            23.278463107834
        ],
        [
            113.08076750577,
            23.278549863298
        ],
        [
            113.08077545683,
            23.278608874886
        ],
        [
            113.08079157292,
            23.278665575001
        ],
        [
            113.08080987574,
            23.278731462508
        ],
        [
            113.08083608275,
            23.27880698148
        ],
        [
            113.08087753152,
            23.278878710623
        ],
        [
            113.08092522088,
            23.278928626602
        ],
        [
            113.0809737248,
            23.278976358442
        ],
        [
            113.08103965042,
            23.279022705735
        ],
        [
            113.08112762734,
            23.279069488952
        ],
        [
            113.08119762508,
            23.279104372885
        ],
        [
            113.08127035639,
            23.279151149351
        ],
        [
            113.08131912415,
            23.27919074062
        ],
        [
            113.08137579217,
            23.279236166275
        ],
        [
            113.08148285855,
            23.279318715979
        ],
        [
            113.08155179996,
            23.279388353409
        ],
        [
            113.08161147064,
            23.279442684691
        ],
        [
            113.08166870907,
            23.279515508501
        ],
        [
            113.08171424819,
            23.279595044388
        ],
        [
            113.08177203097,
            23.279667860414
        ],
        [
            113.0817974191,
            23.279740957424
        ],
        [
            113.08184136512,
            23.279861763536
        ],
        [
            113.08185696274,
            23.279944524009
        ],
        [
            113.08186792342,
            23.280017867012
        ],
        [
            113.08187811749,
            23.28014223249
        ],
        [
            113.08187954936,
            23.280214381011
        ],
        [
            113.08187447336,
            23.280312416266
        ],
        [
            113.08187614295,
            23.280349288306
        ],
        [
            113.08190374718,
            23.280460605569
        ],
        [
            113.08190517406,
            23.280527327725
        ],
        [
            113.08191754738,
            23.280652199129
        ],
        [
            113.0819084035,
            23.28076522662
        ],
        [
            113.08189406637,
            23.28085690762
        ],
        [
            113.08186911033,
            23.280946327361
        ],
        [
            113.08185119736,
            23.281000626223
        ],
        [
            113.08180471035,
            23.281064636694
        ],
        [
            113.08174489115,
            23.281135658074
        ],
        [
            113.0816992177,
            23.281196671334
        ],
        [
            113.08166441286,
            23.281237150117
        ],
        [
            113.08160565848,
            23.281284278599
        ],
        [
            113.08152160461,
            23.281349476639
        ],
        [
            113.08145768382,
            23.281402936086
        ],
        [
            113.08138396295,
            23.28145683567
        ],
        [
            113.08125692035,
            23.281546923625
        ],
        [
            113.08114049433,
            23.281637104148
        ],
        [
            113.08105807525,
            23.281705267718
        ],
        [
            113.08100855765,
            23.281734609143
        ],
        [
            113.08089399779,
            23.281786506594
        ],
        [
            113.080822176,
            23.281835498739
        ],
        [
            113.08073129757,
            23.281884821002
        ],
        [
            113.080666805,
            23.281913067938
        ],
        [
            113.08057293577,
            23.281966786024
        ],
        [
            113.08056287091,
            23.281974828673
        ],
        [
            113.08050900909,
            23.282016731425
        ],
        [
            113.08046276384,
            23.282052533582
        ],
        [
            113.08042279693,
            23.282105049694
        ],
        [
            113.08039099604,
            23.282156339238
        ],
        [
            113.08038125143,
            23.282212130461
        ],
        [
            113.08036987668,
            23.282271205912
        ],
        [
            113.08034571301,
            23.282336743733
        ],
        [
            113.08031479101,
            23.282449610059
        ],
        [
            113.08027815698,
            23.282567459632
        ],
        [
            113.08024555287,
            23.282632059115
        ],
        [
            113.08022276095,
            23.282707884198
        ],
        [
            113.0801901552,
            23.282770856079
        ],
        [
            113.08013280407,
            23.282862476386
        ],
        [
            113.08008849466,
            23.282928365587
        ],
        [
            113.07999907303,
            23.28307399676
        ],
        [
            113.07991642211,
            23.283184781284
        ],
        [
            113.0798362251,
            23.283299322776
        ],
        [
            113.07978401732,
            23.283362367318
        ],
        [
            113.07972908675,
            23.283425188471
        ],
        [
            113.07963905518,
            23.283507073271
        ],
        [
            113.07956914479,
            23.283564188112
        ],
        [
            113.07950142081,
            23.283629676654
        ],
        [
            113.0794119216,
            23.283700159353
        ],
        [
            113.0793431269,
            23.283783847204
        ],
        [
            113.07929201361,
            23.283852845639
        ],
        [
            113.07924444366,
            23.2839258523
        ],
        [
            113.07920095604,
            23.283997431087
        ],
        [
            113.07915938854,
            23.284083085588
        ],
        [
            113.0791371167,
            23.284135028541
        ],
        [
            113.07913117819,
            23.284185057228
        ],
        [
            113.07910675802,
            23.284266070167
        ],
        [
            113.07909374936,
            23.284324362739
        ],
        [
            113.07907830099,
            23.284393008636
        ],
        [
            113.07906289954,
            23.284507508402
        ],
        [
            113.07904884162,
            23.284604619563
        ],
        [
            113.07902770438,
            23.284701040964
        ],
        [
            113.07900843513,
            23.284760528851
        ],
        [
            113.078989704,
            23.284813766766
        ],
        [
            113.07895304598,
            23.284908018786
        ],
        [
            113.07891151355,
            23.28502786152
        ],
        [
            113.07887213689,
            23.285125960245
        ],
        [
            113.07882837053,
            23.285191305396
        ],
        [
            113.0787457146,
            23.285298847619
        ],
        [
            113.07866359664,
            23.285400140542
        ],
        [
            113.07858281478,
            23.285476991005
        ],
        [
            113.07851209449,
            23.285542269193
        ],
        [
            113.07844628665,
            23.285619128544
        ],
        [
            113.07835653897,
            23.285714589035
        ],
        [
            113.07828830681,
            23.285816997014
        ],
        [
            113.07823093918,
            23.285894251583
        ],
        [
            113.07815210226,
            23.286009871076
        ],
        [
            113.07810128032,
            23.286098406682
        ],
        [
            113.0780640717,
            23.286187245025
        ],
        [
            113.07803230845,
            23.28627625874
        ],
        [
            113.07802472201,
            23.286312208071
        ],
        [
            113.07802614728,
            23.286374588723
        ],
        [
            113.07802513004,
            23.286444609689
        ],
        [
            113.07803310976,
            23.286526681771
        ],
        [
            113.07802744496,
            23.286578062983
        ],
        [
            113.07801803948,
            23.286698699214
        ],
        [
            113.07800507796,
            23.286803118412
        ],
        [
            113.07798341143,
            23.286914745773
        ],
        [
            113.07797015202,
            23.286994207937
        ],
        [
            113.07793542877,
            23.287117461587
        ],
        [
            113.0779004282,
            23.287235836274
        ],
        [
            113.07787060238,
            23.287356018995
        ],
        [
            113.07782335482,
            23.287479222623
        ],
        [
            113.07778590177,
            23.287595741529
        ],
        [
            113.07774733689,
            23.287690031139
        ],
        [
            113.07771148177,
            23.287771791822
        ],
        [
            113.07767426643,
            23.287854661915
        ],
        [
            113.0776606901,
            23.287890717191
        ],
        [
            113.07765447054,
            23.287932340433
        ],
        [
            113.07766186827,
            23.287978064397
        ],
        [
            113.07766597234,
            23.287997798935
        ],
        [
            113.07768340429,
            23.288004816912
        ],
        [
            113.07770328407,
            23.288009349709
        ],
        [
            113.07776048275,
            23.288032487859
        ],
        [
            113.07781930219,
            23.288043116446
        ],
        [
            113.0779020813,
            23.288054407666
        ],
        [
            113.07798403829,
            23.288060558595
        ],
        [
            113.07803659649,
            23.288072112496
        ],
        [
            113.07809623082,
            23.288081099841
        ],
        [
            113.07816758315,
            23.288100734026
        ],
        [
            113.07822750011,
            23.288120027505
        ],
        [
            113.07832798854,
            23.288144033046
        ],
        [
            113.07842303639,
            23.28817274786
        ],
        [
            113.07854639985,
            23.288202321844
        ],
        [
            113.07870924549,
            23.288236901036
        ],
        [
            113.07882580245,
            23.288267140829
        ],
        [
            113.0789690469,
            23.288303968241
        ],
        [
            113.07908777588,
            23.288329018148
        ],
        [
            113.07920269522,
            23.288356307178
        ],
        [
            113.07931789114,
            23.288388205659
        ],
        [
            113.07951941399,
            23.288443016066
        ],
        [
            113.07963078856,
            23.288466303818
        ],
        [
            113.07980045574,
            23.288520593523
        ],
        [
            113.07997010597,
            23.288559150963
        ],
        [
            113.08012886968,
            23.288601972314
        ],
        [
            113.08024978802,
            23.288642470323
        ],
        [
            113.08038867719,
            23.288686186631
        ],
        [
            113.08051121151,
            23.288710653959
        ],
        [
            113.08064137969,
            23.288746659304
        ],
        [
            113.08073478083,
            23.288768922369
        ],
        [
            113.08079143408,
            23.288795891179
        ],
        [
            113.08086223923,
            23.288818546661
        ],
        [
            113.08092597902,
            23.288854077362
        ],
        [
            113.08097801319,
            23.288890353119
        ],
        [
            113.08101891403,
            23.2889547679
        ],
        [
            113.08104699817,
            23.288997968554
        ],
        [
            113.08104810908,
            23.289019655733
        ],
        [
            113.0810593236,
            23.289071829232
        ],
        [
            113.08104990008,
            23.289175367533
        ],
        [
            113.08105657349,
            23.28931363027
        ],
        [
            113.08105937799,
            23.289394980561
        ],
        [
            113.08106597013,
            23.289452931447
        ],
        [
            113.08108348458,
            23.289543525225
        ],
        [
            113.08110395687,
            23.289597710206
        ],
        [
            113.08113777223,
            23.289655464548
        ],
        [
            113.08116369256,
            23.289713083428
        ],
        [
            113.08120128214,
            23.289734144084
        ],
        [
            113.0812560382,
            23.289770918831
        ],
        [
            113.0813238597,
            23.289806113606
        ],
        [
            113.08140692679,
            23.289842133648
        ],
        [
            113.08148481578,
            23.2898728173
        ],
        [
            113.08150743616,
            23.289897935261
        ],
        [
            113.08151671471,
            23.289920568162
        ],
        [
            113.08152383478,
            23.289962502275
        ],
        [
            113.08151380788,
            23.290007985492
        ],
        [
            113.08149453233,
            23.290060681429
        ],
        [
            113.08147936893,
            23.290142067858
        ],
        [
            113.08146743062,
            23.290181885979
        ],
        [
            113.08146501859,
            23.290219913151
        ],
        [
            113.08148714081,
            23.290291436561
        ],
        [
            113.08151443009,
            23.29035771649
        ],
        [
            113.08154987602,
            23.290413818049
        ],
        [
            113.08160191999,
            23.290462039231
        ],
        [
            113.08165175435,
            23.290478553432
        ],
        [
            113.08167680462,
            23.290483823885
        ],
        [
            113.0817298749,
            23.290469623811
        ],
        [
            113.08182839931,
            23.290447867259
        ],
        [
            113.08189288213,
            23.290413125523
        ],
        [
            113.08195871525,
            23.290367780125
        ],
        [
            113.08201884805,
            23.290339083582
        ],
        [
            113.08207492232,
            23.290335418956
        ],
        [
            113.08212908927,
            23.29033015951
        ],
        [
            113.08217101337,
            23.290332162652
        ],
        [
            113.08219797416,
            23.290343101987
        ],
        [
            113.08221758807,
            23.290357150427
        ],
        [
            113.08223637013,
            23.290356018691
        ],
        [
            113.08232239408,
            23.290358634485
        ],
        [
            113.08240677241,
            23.290349341653
        ],
        [
            113.08250721677,
            23.290345749421
        ],
        [
            113.0825638312,
            23.290339369916
        ],
        [
            113.08262670002,
            23.290326645673
        ],
        [
            113.08265663163,
            23.290314747004
        ],
        [
            113.08270914753,
            23.290293515692
        ],
        [
            113.08277799485,
            23.290271197417
        ],
        [
            113.08284139288,
            23.290244087878
        ],
        [
            113.08290043701,
            23.290218680322
        ],
        [
            113.08294887826,
            23.29020674604
        ],
        [
            113.08298751978,
            23.290194704773
        ],
        [
            113.08302452961,
            23.290184319156
        ],
        [
            113.0830658935,
            23.290172776042
        ],
        [
            113.08309311068,
            23.290169337707
        ],
        [
            113.08312495876,
            23.290169349723
        ],
        [
            113.08314483539,
            23.290174987918
        ],
        [
            113.0831723374,
            23.290184297915
        ],
        [
            113.08320202781,
            23.290204424858
        ],
        [
            113.08322791117,
            23.290228413952
        ],
        [
            113.08325896354,
            23.290249604095
        ],
        [
            113.08329218773,
            23.290265060599
        ],
        [
            113.08332240899,
            23.290271884799
        ],
        [
            113.0833428105,
            23.290258251262
        ],
        [
            113.08336946408,
            23.29023610304
        ],
        [
            113.0833849383,
            23.290194876047
        ],
        [
            113.08341129977,
            23.2901529261
        ],
        [
            113.08342296534,
            23.290113933006
        ],
        [
            113.08345587732,
            23.290089782585
        ],
        [
            113.08348771078,
            23.290075960811
        ],
        [
            113.0835203602,
            23.290061583226
        ],
        [
            113.08358567732,
            23.290051279097
        ],
        [
            113.08363030922,
            23.290042945452
        ],
        [
            113.08368175037,
            23.290039112847
        ],
        [
            113.08374570934,
            23.290032361852
        ],
        [
            113.0838088599,
            23.29003403669
        ],
        [
            113.08388099777,
            23.290040991968
        ],
        [
            113.08392563772,
            23.290041616486
        ],
        [
            113.08398933265,
            23.290044100313
        ],
        [
            113.08406909127,
            23.29005147822
        ],
        [
            113.08415075714,
            23.290061269212
        ],
        [
            113.0842051996,
            23.290066622132
        ],
        [
            113.08426807423,
            23.290066683676
        ],
        [
            113.08433802357,
            23.290065003744
        ],
        [
            113.08444172724,
            23.290067662209
        ],
        [
            113.08456639315,
            23.290075683679
        ],
        [
            113.08466573918,
            23.290077335923
        ],
        [
            113.08474902021,
            23.290073009848
        ],
        [
            113.08482060592,
            23.290077285441
        ],
        [
            113.08488239542,
            23.290083890752
        ],
        [
            113.08497929301,
            23.290089121514
        ],
        [
            113.08505032953,
            23.290089885054
        ],
        [
            113.08511210428,
            23.290082929801
        ],
        [
            113.08517334092,
            23.290082496504
        ],
        [
            113.08529498864,
            23.290073507725
        ],
        [
            113.08541336682,
            23.290062134773
        ],
        [
            113.08548739362,
            23.290062049572
        ],
        [
            113.08554507893,
            23.290050285928
        ],
        [
            113.08558099495,
            23.290041851211
        ],
        [
            113.0856130964,
            23.290029135847
        ],
        [
            113.08566150709,
            23.289996628835
        ],
        [
            113.08572054845,
            23.289981049543
        ],
        [
            113.08579346483,
            23.289961184395
        ],
        [
            113.08586448689,
            23.28995247558
        ],
        [
            113.08592463072,
            23.289951807235
        ],
        [
            113.08598721532,
            23.289942962597
        ],
        [
            113.08612736298,
            23.28993698434
        ],
        [
            113.08623240656,
            23.289934542349
        ],
        [
            113.08628084855,
            23.289935963855
        ],
        [
            113.08631240234,
            23.289921910093
        ],
        [
            113.0863502363,
            23.289928923467
        ],
        [
            113.08637554585,
            23.289929889926
        ],
        [
            113.08641774374,
            23.28994687633
        ],
        [
            113.08645478162,
            23.289974524641
        ],
        [
            113.08649806959,
            23.28999339512
        ],
        [
            113.08653237857,
            23.290013760803
        ],
        [
            113.08665384209,
            23.290107408343
        ],
        [
            113.08671048113,
            23.290143986665
        ],
        [
            113.08681314287,
            23.290214595956
        ],
        [
            113.08691823359,
            23.290266180471
        ],
        [
            113.08703475928,
            23.290324923335
        ],
        [
            113.08713412816,
            23.290371449884
        ],
        [
            113.08722559541,
            23.290408603353
        ],
        [
            113.08730453031,
            23.290431296832
        ],
        [
            113.0873548874,
            23.290448179793
        ],
        [
            113.08741503697,
            23.290461933311
        ],
        [
            113.08749479474,
            23.290492761739
        ],
        [
            113.08754433156,
            23.29050667704
        ],
        [
            113.08762081363,
            23.290528062705
        ],
        [
            113.08765510512,
            23.290534880838
        ],
        [
            113.08770680976,
            23.290540628309
        ],
        [
            113.0877873692,
            23.290559246932
        ],
        [
            113.08786465504,
            23.290570048479
        ],
        [
            113.08790031689,
            23.290587703845
        ],
        [
            113.08795502908,
            23.290609422048
        ],
        [
            113.08802254058,
            23.290642621836
        ],
        [
            113.08808734692,
            23.29069214302
        ],
        [
            113.08813173933,
            23.290734637502
        ],
        [
            113.08817994468,
            23.290781147523
        ],
        [
            113.08826844273,
            23.29085257964
        ],
        [
            113.08834415417,
            23.290926099752
        ],
        [
            113.08837740784,
            23.29098666837
        ],
        [
            113.08840083339,
            23.291013734671
        ],
        [
            113.08840033325,
            23.291058239406
        ],
        [
            113.08838351288,
            23.291107320583
        ],
        [
            113.08837758644,
            23.291167369151
        ],
        [
            113.08836511113,
            23.291208248037
        ],
        [
            113.08835264166,
            23.291255096093
        ],
        [
            113.08830864891,
            23.2913406567
        ],
        [
            113.08828393844,
            23.291390395471
        ],
        [
            113.08826575055,
            23.291432714295
        ],
        [
            113.08825980908,
            23.291477840462
        ],
        [
            113.08826692522,
            23.291520606916
        ],
        [
            113.0882930804,
            23.291556586051
        ],
        [
            113.08832357567,
            23.291579207856
        ],
        [
            113.08836957516,
            23.291597536549
        ],
        [
            113.0884112199,
            23.291614572458
        ],
        [
            113.08848145491,
            23.291654532391
        ],
        [
            113.08857481579,
            23.291694706438
        ],
        [
            113.08865592789,
            23.291730176099
        ],
        [
            113.08876861825,
            23.291785278476
        ],
        [
            113.08889436148,
            23.291835590678
        ],
        [
            113.08896866622,
            23.291868185953
        ],
        [
            113.08904868689,
            23.291904231195
        ],
        [
            113.08910830207,
            23.291939752011
        ],
        [
            113.08917391436,
            23.291987943247
        ],
        [
            113.08918617539,
            23.292007035946
        ],
        [
            113.08919899316,
            23.292039144567
        ],
        [
            113.08920694038,
            23.292098453811
        ],
        [
            113.08921704575,
            23.292139011512
        ],
        [
            113.08922631728,
            23.292161402111
        ],
        [
            113.0892636124,
            23.292186115359
        ],
        [
            113.08929791166,
            23.292207615171
        ],
        [
            113.0893411817,
            23.292222207917
        ],
        [
            113.08941167059,
            23.292251618814
        ],
        [
            113.08950229223,
            23.292283196634
        ],
        [
            113.08958013026,
            23.292318210823
        ],
        [
            113.08965333009,
            23.292339997176
        ],
        [
            113.08973932738,
            23.292374635424
        ],
        [
            113.08981497745,
            23.292399922458
        ],
        [
            113.08986451163,
            23.292425024752
        ],
        [
            113.08994154343,
            23.29247390392
        ],
        [
            113.09000114143,
            23.292498602684
        ],
        [
            113.09003569698,
            23.292507090181
        ],
        [
            113.09007051683,
            23.292507706418
        ],
        [
            113.09010694822,
            23.292487138399
        ],
        [
            113.0901379375,
            23.292465016254
        ],
        [
            113.09016919369,
            23.292437735938
        ],
        [
            113.09020371945,
            23.292416110279
        ],
        [
            113.09025077847,
            23.292415752603
        ],
        [
            113.09030816795,
            23.292409289521
        ],
        [
            113.09034489463,
            23.292413956009
        ],
        [
            113.09040338589,
            23.292422404467
        ],
        [
            113.09045781284,
            23.292447730895
        ],
        [
            113.09051630876,
            23.292461881152
        ],
        [
            113.09061316824,
            23.292487467629
        ],
        [
            113.09074322316,
            23.292525921297
        ],
        [
            113.09085151139,
            23.292559512752
        ],
        [
            113.09093313643,
            23.292586672981
        ],
        [
            113.09102209984,
            23.292609130401
        ],
        [
            113.09104766957,
            23.292611785996
        ],
        [
            113.09108956622,
            23.292622372161
        ],
        [
            113.09111105412,
            23.292623181894
        ],
        [
            113.09114339051,
            23.292591836781
        ],
        [
            113.09116891332,
            23.292546199204
        ],
        [
            113.09122323961,
            23.292472790879
        ],
        [
            113.09128761972,
            23.292390031634
        ],
        [
            113.09136637659,
            23.292268564949
        ],
        [
            113.09141526581,
            23.292199573276
        ],
        [
            113.09142964858,
            23.292166561509
        ],
        [
            113.09145709863,
            23.292146408832
        ],
        [
            113.09150279094,
            23.292146919335
        ],
        [
            113.09151911155,
            23.292149156279
        ],
        [
            113.0915653619,
            23.2921645845
        ],
        [
            113.09159990736,
            23.292169850059
        ],
        [
            113.09163336717,
            23.292177571868
        ],
        [
            113.09166217525,
            23.292156320619
        ],
        [
            113.0917157116,
            23.292113870441
        ],
        [
            113.0917482978,
            23.292062728147
        ],
        [
            113.09178768492,
            23.292013672947
        ],
        [
            113.09183766894,
            23.291954991537
        ],
        [
            113.09188195178,
            23.291906963648
        ],
        [
            113.09194797111,
            23.291838592103
        ],
        [
            113.09198299751,
            23.291781184417
        ],
        [
            113.09204278372,
            23.29173622734
        ],
        [
            113.09209740398,
            23.291692963471
        ],
        [
            113.09215038626,
            23.291643752323
        ],
        [
            113.09219413581,
            23.291608763718
        ],
        [
            113.09225660765,
            23.291531223669
        ],
        [
            113.09235142448,
            23.291437832201
        ],
        [
            113.09246800487,
            23.29135449759
        ],
        [
            113.09251881723,
            23.291314007922
        ],
        [
            113.09257479695,
            23.291274544092
        ],
        [
            113.09263676103,
            23.291237453683
        ],
        [
            113.09268948441,
            23.291205901146
        ],
        [
            113.09273923307,
            23.291191478935
        ],
        [
            113.09281020173,
            23.291187392022
        ],
        [
            113.09288606767,
            23.291186778861
        ],
        [
            113.0929273997,
            23.291186841327
        ],
        [
            113.09297881375,
            23.291208494362
        ],
        [
            113.09306449155,
            23.291233010449
        ],
        [
            113.09314472744,
            23.291254880736
        ],
        [
            113.0932200721,
            23.291280881177
        ],
        [
            113.09332098004,
            23.291312022363
        ],
        [
            113.09340529857,
            23.291341186975
        ],
        [
            113.09347138575,
            23.291356994811
        ],
        [
            113.09351952466,
            23.291370293146
        ],
        [
            113.09355271345,
            23.29138810112
        ],
        [
            113.0936272392,
            23.29141548915
        ],
        [
            113.09372108666,
            23.291461660485
        ],
        [
            113.09380922964,
            23.29151441257
        ],
        [
            113.09388729383,
            23.291548830194
        ],
        [
            113.09399772612,
            23.291599180522
        ],
        [
            113.094098087,
            23.291639066465
        ],
        [
            113.09419627591,
            23.291683595531
        ],
        [
            113.09430152217,
            23.291718289063
        ],
        [
            113.09438501414,
            23.291749150322
        ],
        [
            113.09447339576,
            23.291777252212
        ],
        [
            113.09459251163,
            23.291821862074
        ],
        [
            113.09468932051,
            23.291852875157
        ],
        [
            113.09477417034,
            23.291887545166
        ],
        [
            113.09485982369,
            23.291911088096
        ],
        [
            113.09495799534,
            23.291949975263
        ],
        [
            113.0950371376,
            23.291989332421
        ],
        [
            113.09512253536,
            23.292033244284
        ],
        [
            113.0952231527,
            23.292075653987
        ],
        [
            113.09528760541,
            23.292107032345
        ],
        [
            113.09537681776,
            23.292163946696
        ],
        [
            113.09543748452,
            23.292217075501
        ],
        [
            113.09544511737,
            23.29223979226
        ],
        [
            113.09545575695,
            23.292279844493
        ],
        [
            113.09544662053,
            23.292388734394
        ],
        [
            113.09543805157,
            23.292522580551
        ],
        [
            113.09542893237,
            23.292649920304
        ],
        [
            113.09542767568,
            23.292756562681
        ],
        [
            113.09542419438,
            23.29281113267
        ],
        [
            113.09544056476,
            23.292875276486
        ],
        [
            113.09545669171,
            23.292969268406
        ],
        [
            113.09546272518,
            23.293025373516
        ],
        [
            113.09547176765,
            23.293101527255
        ],
        [
            113.09546530896,
            23.293169692174
        ],
        [
            113.09547243872,
            23.293235554226
        ],
        [
            113.09545379535,
            23.293353489839
        ],
        [
            113.09544735886,
            23.293445530943
        ],
        [
            113.09544147068,
            23.293542721818
        ],
        [
            113.09543936086,
            23.293611386965
        ],
        [
            113.09545219377,
            23.293672580663
        ],
        [
            113.09546963898,
            23.293724775937
        ],
        [
            113.0954789058,
            23.293751546669
        ],
        [
            113.09552163835,
            23.293813264516
        ],
        [
            113.0955809518,
            23.293875908976
        ],
        [
            113.09562392942,
            23.293909952965
        ],
        [
            113.09566064459,
            23.293932662875
        ],
        [
            113.09573406944,
            23.293972930769
        ],
        [
            113.09582461101,
            23.294007071778
        ],
        [
            113.09588689183,
            23.294049081782
        ],
        [
            113.0959684729,
            23.294094984134
        ],
        [
            113.09604435314,
            23.294149355587
        ],
        [
            113.09612703478,
            23.294212079791
        ],
        [
            113.09619502073,
            23.29425513753
        ],
        [
            113.09628800758,
            23.294296072095
        ],
        [
            113.09640113618,
            23.294371561129
        ],
        [
            113.096501207,
            23.294435509958
        ],
        [
            113.09652242553,
            23.294457840453
        ],
        [
            113.09652299382,
            23.294484696169
        ],
        [
            113.09652333279,
            23.294557678475
        ],
        [
            113.09651988585,
            23.29465131485
        ],
        [
            113.09652461028,
            23.294765227445
        ],
        [
            113.09650484104,
            23.294841644698
        ],
        [
            113.09651058725,
            23.294884462082
        ],
        [
            113.09651853224,
            23.294954391922
        ],
        [
            113.09652513404,
            23.295041698235
        ],
        [
            113.09655455258,
            23.295116320984
        ],
        [
            113.09661769827,
            23.29522266187
        ],
        [
            113.09667320443,
            23.295296514608
        ],
        [
            113.09672162205,
            23.295345741679
        ],
        [
            113.09677600683,
            23.29538270929
        ],
        [
            113.09683719731,
            23.295433457657
        ],
        [
            113.0969154963,
            23.295471852568
        ],
        [
            113.09698997837,
            23.295497532968
        ],
        [
            113.09709599718,
            23.295540586918
        ],
        [
            113.09716312235,
            23.295546533614
        ],
        [
            113.09719003198,
            23.295554990373
        ],
        [
            113.09724628484,
            23.295558862085
        ],
        [
            113.09730117924,
            23.295563561582
        ],
        [
            113.09735280803,
            23.295563406684
        ],
        [
            113.09741097936,
            23.2955873478
        ],
        [
            113.09743109961,
            23.295601291846
        ],
        [
            113.09747242556,
            23.295627815503
        ],
        [
            113.09751457556,
            23.295664644006
        ],
        [
            113.09754667041,
            23.295700198521
        ],
        [
            113.09757034519,
            23.295739620139
        ],
        [
            113.09761494175,
            23.295778602942
        ],
        [
            113.09768454831,
            23.295831767896
        ],
        [
            113.09775524489,
            23.295889540637
        ],
        [
            113.09779113324,
            23.295915032816
        ],
        [
            113.09785502356,
            23.295959027729
        ],
        [
            113.09790640789,
            23.295995254984
        ],
        [
            113.09796185885,
            23.296021956836
        ],
        [
            113.09802573665,
            23.296054022876
        ],
        [
            113.09808526686,
            23.296086396788
        ],
        [
            113.09812984289,
            23.296106949077
        ],
        [
            113.09818176516,
            23.29613992819
        ],
        [
            113.0982910457,
            23.29621019371
        ],
        [
            113.09837830325,
            23.296263809898
        ],
        [
            113.09843755962,
            23.296298102588
        ],
        [
            113.09851800972,
            23.296336585149
        ],
        [
            113.09865226914,
            23.296397749123
        ],
        [
            113.09871396233,
            23.296426069205
        ],
        [
            113.09879874341,
            23.296451245548
        ],
        [
            113.09884466727,
            23.296466388827
        ],
        [
            113.0988843429,
            23.296481848652
        ],
        [
            113.0989351556,
            23.29649669016
        ],
        [
            113.09900525787,
            23.29651465736
        ],
        [
            113.09908703844,
            23.296530650282
        ],
        [
            113.09919110893,
            23.296565491751
        ],
        [
            113.09926799426,
            23.296578002988
        ],
        [
            113.09932558871,
            23.296586304936
        ],
        [
            113.09938073342,
            23.296589470703
        ],
        [
            113.09949401546,
            23.296603116407
        ],
        [
            113.09958909747,
            23.296617973869
        ],
        [
            113.09966488805,
            23.296627262552
        ],
        [
            113.09978250943,
            23.296640095304
        ],
        [
            113.09986510073,
            23.296664548873
        ],
        [
            113.09989715939,
            23.296674663487
        ],
        [
            113.10001126025,
            23.296705176632
        ],
        [
            113.10011041391,
            23.296727649653
        ],
        [
            113.10022776336,
            23.296751110967
        ],
        [
            113.10033343749,
            23.296780891117
        ],
        [
            113.10045323012,
            23.296808702753
        ],
        [
            113.10054856652,
            23.296822824391
        ],
        [
            113.10061755021,
            23.29682705866
        ],
        [
            113.10071615466,
            23.296855285024
        ],
        [
            113.10083131027,
            23.296869052993
        ],
        [
            113.10090981143,
            23.296892518495
        ],
        [
            113.10098151169,
            23.296903272451
        ],
        [
            113.10102876676,
            23.296908728724
        ],
        [
            113.10113114705,
            23.296915538134
        ],
        [
            113.10122511157,
            23.296927010551
        ],
        [
            113.10131418935,
            23.296941498916
        ],
        [
            113.10141058986,
            23.296947548777
        ],
        [
            113.10150482153,
            23.296959586004
        ],
        [
            113.10162701953,
            23.296972860076
        ],
        [
            113.10171011221,
            23.296981438285
        ],
        [
            113.10177881545,
            23.296992527994
        ],
        [
            113.10190889648,
            23.297023976345
        ],
        [
            113.10201615965,
            23.297045496901
        ],
        [
            113.10207453716,
            23.297050950698
        ],
        [
            113.10211907187,
            23.297061348065
        ],
        [
            113.10222362537,
            23.297094023764
        ],
        [
            113.10230155815,
            23.297111620367
        ],
        [
            113.10237540578,
            23.297115401204
        ],
        [
            113.10246581843,
            23.297125906849
        ],
        [
            113.10253803448,
            23.297129162129
        ],
        [
            113.1026156829,
            23.297137014604
        ],
        [
            113.1027082517,
            23.297133966466
        ],
        [
            113.10280761444,
            23.297141483715
        ],
        [
            113.10287086381,
            23.297140179767
        ],
        [
            113.10294335849,
            23.297158383045
        ],
        [
            113.10299874082,
            23.297164981094
        ],
        [
            113.10313910031,
            23.297188672246
        ],
        [
            113.10327022694,
            23.297212138319
        ],
        [
            113.10340162198,
            23.297235890632
        ],
        [
            113.1034939245,
            23.297255157475
        ],
        [
            113.10358351163,
            23.297274982288
        ],
        [
            113.10365490053,
            23.297281026592
        ],
        [
            113.10371218447,
            23.297298508222
        ],
        [
            113.10378438448,
            23.297302930961
        ],
        [
            113.10386745563,
            23.297326051805
        ],
        [
            113.10394399941,
            23.297334543933
        ],
        [
            113.10401430582,
            23.297350110472
        ],
        [
            113.10409899643,
            23.297367004899
        ],
        [
            113.10416576284,
            23.297370922862
        ],
        [
            113.10423959205,
            23.29738378294
        ],
        [
            113.10431721869,
            23.29739555479
        ],
        [
            113.10439512286,
            23.297416013701
        ],
        [
            113.10447546597,
            23.297433760287
        ],
        [
            113.10453897522,
            23.297442591269
        ],
        [
            113.10462201478,
            23.29744243685
        ],
        [
            113.10470017689,
            23.29745233596
        ],
        [
            113.1047902802,
            23.297465205222
        ],
        [
            113.10486708712,
            23.297480002312
        ],
        [
            113.10497374157,
            23.2974947598
        ],
        [
            113.10505977224,
            23.29751037077
        ],
        [
            113.10512300169,
            23.297517608563
        ],
        [
            113.10517944892,
            23.297527300721
        ],
        [
            113.10522205709,
            23.297536741945
        ],
        [
            113.1052744407,
            23.297555397592
        ],
        [
            113.10530700083,
            23.297555358449
        ],
        [
            113.1053314226,
            23.297557500249
        ],
        [
            113.10536805664,
            23.297562613184
        ],
        [
            113.10539573113,
            23.297561225685
        ],
        [
            113.10545895197,
            23.297563056895
        ],
        [
            113.10551511835,
            23.297565712744
        ],
        [
            113.10556043789,
            23.297576249902
        ],
        [
            113.10560927964,
            23.297581359484
        ],
        [
            113.10560791375,
            23.297570236845
        ],
        [
            113.10561354445,
            23.297490194064
        ],
        [
            113.105617809,
            23.297399028609
        ],
        [
            113.10563267593,
            23.297333085939
        ],
        [
            113.10564831947,
            23.297223189796
        ],
        [
            113.1056479469,
            23.297103811605
        ],
        [
            113.10566111165,
            23.296951592494
        ],
        [
            113.10566914538,
            23.296828137186
        ],
        [
            113.10567638621,
            23.296729643546
        ],
        [
            113.10568550718,
            23.296609443069
        ],
        [
            113.10569958192,
            23.296570633256
        ],
        [
            113.10571178371,
            23.296562212507
        ],
        [
            113.10573023387,
            23.296563282973
        ],
        [
            113.10575655572,
            23.296568688725
        ],
        [
            113.10582628666,
            23.296574063676
        ],
        [
            113.10592124262,
            23.296573458363
        ],
        [
            113.10597849868,
            23.296586990402
        ],
        [
            113.10602326746,
            23.296592392452
        ],
        [
            113.10612557613,
            23.296628157657
        ],
        [
            113.10618417864,
            23.296632746647
        ],
        [
            113.10621836574,
            23.296638432112
        ],
        [
            113.10625661882,
            23.296640590317
        ],
        [
            113.106299486,
            23.296645733123
        ],
        [
            113.10634370758,
            23.296648978126
        ],
        [
            113.10637382141,
            23.296651142347
        ],
        [
            113.10649592182,
            23.296682055397
        ],
        [
            113.10660770448,
            23.296705113878
        ],
        [
            113.10671514082,
            23.29672384239
        ],
        [
            113.10681389571,
            23.296743665003
        ],
        [
            113.10689853786,
            23.296756709579
        ],
        [
            113.10697449572,
            23.296766230529
        ],
        [
            113.10703282164,
            23.296775749336
        ],
        [
            113.10708219688,
            23.29678635238
        ],
        [
            113.10715138207,
            23.296808634514
        ],
        [
            113.10722272782,
            23.296821155035
        ],
        [
            113.10733613312,
            23.296857041982
        ],
        [
            113.10744302427,
            23.2968902225
        ],
        [
            113.1075162715,
            23.296910903448
        ],
        [
            113.10757812201,
            23.296926152486
        ],
        [
            113.10765055438,
            23.29694765576
        ],
        [
            113.10771945216,
            23.296959935466
        ],
        [
            113.10776827868,
            23.296970840717
        ],
        [
            113.10784152339,
            23.296993985615
        ],
        [
            113.10791801148,
            23.297005472982
        ],
        [
            113.10800616279,
            23.297020508226
        ],
        [
            113.10810109602,
            23.297039901255
        ],
        [
            113.10814393945,
            23.297035078867
        ],
        [
            113.10816207165,
            23.296991423674
        ],
        [
            113.10818444487,
            23.296833551579
        ],
        [
            113.10819849002,
            23.29676791437
        ],
        [
            113.10821003255,
            23.296630646352
        ],
        [
            113.10821640791,
            23.296477091571
        ],
        [
            113.10820980133,
            23.296364214327
        ],
        [
            113.10821703395,
            23.296261939288
        ],
        [
            113.10824271922,
            23.296174072282
        ],
        [
            113.10825972759,
            23.296087548872
        ],
        [
            113.10829219384,
            23.296002135397
        ],
        [
            113.10834742674,
            23.295903465457
        ],
        [
            113.10840863757,
            23.29581945951
        ],
        [
            113.10846092857,
            23.295768813325
        ],
        [
            113.10854548871,
            23.295719313289
        ],
        [
            113.1086268121,
            23.295690705091
        ],
        [
            113.10869458601,
            23.295672929015
        ],
        [
            113.10878107395,
            23.295661164198
        ],
        [
            113.10885156606,
            23.295653170916
        ],
        [
            113.10891420583,
            23.295658459713
        ],
        [
            113.1089516251,
            23.295659897945
        ],
        [
            113.1089936702,
            23.295680068649
        ],
        [
            113.1090373599,
            23.295720593458
        ],
        [
            113.10906342281,
            23.295758366126
        ],
        [
            113.10910414667,
            23.295818421552
        ],
        [
            113.10914026829,
            23.295886878351
        ],
        [
            113.10919105343,
            23.295981146732
        ],
        [
            113.10923179148,
            23.296058842432
        ],
        [
            113.10924944259,
            23.296090358588
        ],
        [
            113.1092969255,
            23.296130903143
        ],
        [
            113.1093910487,
            23.296180252336
        ],
        [
            113.10950523609,
            23.296233462272
        ],
        [
            113.10964327287,
            23.296280240012
        ],
        [
            113.10977099654,
            23.296318322655
        ],
        [
            113.10985153106,
            23.296338912185
        ],
        [
            113.10991741792,
            23.296351051557
        ],
        [
            113.11001853862,
            23.296355166976
        ],
        [
            113.11012805863,
            23.296356606152
        ],
        [
            113.11017630403,
            23.296348354775
        ],
        [
            113.11023565399,
            23.296329561717
        ],
        [
            113.11027901098,
            23.296312073647
        ],
        [
            113.11036464622,
            23.296284695716
        ],
        [
            113.11045651627,
            23.296259246011
        ],
        [
            113.11048362554,
            23.296262327925
        ],
        [
            113.11058039351,
            23.29626078203
        ],
        [
            113.11067553908,
            23.296265750104
        ],
        [
            113.1107763767,
            23.296272647666
        ],
        [
            113.11083112515,
            23.296268791388
        ],
        [
            113.11090484715,
            23.29626609865
        ],
        [
            113.11099158044,
            23.296266176875
        ],
        [
            113.11110322547,
            23.296241133242
        ],
        [
            113.1112492761,
            23.296201868723
        ],
        [
            113.11134844301,
            23.296170284705
        ],
        [
            113.11143837607,
            23.296118862212
        ],
        [
            113.11148197655,
            23.29608134532
        ],
        [
            113.11150416848,
            23.296045903397
        ],
        [
            113.11153661422,
            23.295960043981
        ],
        [
            113.11154658579,
            23.295896873009
        ],
        [
            113.11155868849,
            23.29579220057
        ],
        [
            113.11157218407,
            23.295730402508
        ],
        [
            113.11159706242,
            23.295669199724
        ],
        [
            113.11163468785,
            23.295619180655
        ],
        [
            113.11168669441,
            23.295589579025
        ],
        [
            113.11172055563,
            23.295573730988
        ],
        [
            113.1117704171,
            23.2955707121
        ],
        [
            113.11185225146,
            23.295562966278
        ],
        [
            113.11198747568,
            23.295562002039
        ],
        [
            113.11207066653,
            23.295559705309
        ],
        [
            113.11210779146,
            23.295559893144
        ],
        [
            113.11218854214,
            23.295558135435
        ],
        [
            113.11224462936,
            23.295552456646
        ],
        [
            113.11229149971,
            23.295543205221
        ],
        [
            113.11242915124,
            23.295541764467
        ],
        [
            113.11264157606,
            23.295531799785
        ],
        [
            113.11278382203,
            23.29552717213
        ],
        [
            113.1128697141,
            23.295529290951
        ],
        [
            113.11297565912,
            23.295536688363
        ],
        [
            113.11311656485,
            23.295557869677
        ],
        [
            113.1132333527,
            23.295577022496
        ],
        [
            113.11331816815,
            23.295594905001
        ],
        [
            113.11336125874,
            23.295610635731
        ],
        [
            113.11338268068,
            23.295632202377
        ],
        [
            113.11339651071,
            23.295646939311
        ],
        [
            113.1134014001,
            23.29566134944
        ],
        [
            113.11339300616,
            23.295666452248
        ],
        [
            113.11337731982,
            23.295696742223
        ],
        [
            113.11331454076,
            23.295780733828
        ],
        [
            113.1132520262,
            23.295858490216
        ],
        [
            113.11321928472,
            23.295904414885
        ],
        [
            113.11317003417,
            23.295970589652
        ],
        [
            113.11312620437,
            23.296039783396
        ],
        [
            113.11307047316,
            23.296131969935
        ],
        [
            113.11299144795,
            23.296232704489
        ],
        [
            113.11291350627,
            23.296334807351
        ],
        [
            113.11285993996,
            23.296427287962
        ],
        [
            113.1127874205,
            23.296535942115
        ],
        [
            113.11272030662,
            23.296630522895
        ],
        [
            113.1126415405,
            23.296725042884
        ],
        [
            113.11259337406,
            23.296799387911
        ],
        [
            113.1125080925,
            23.29688221479
        ],
        [
            113.11244014603,
            23.29695890087
        ],
        [
            113.11238438781,
            23.29703050087
        ],
        [
            113.11233404787,
            23.297101589566
        ],
        [
            113.11227938849,
            23.297192463781
        ],
        [
            113.11225478708,
            23.297260163763
        ],
        [
            113.11222558795,
            23.297338692959
        ],
        [
            113.11220045932,
            23.297424569319
        ],
        [
            113.11218479305,
            23.297484720106
        ],
        [
            113.1121561345,
            23.297562711168
        ],
        [
            113.11214912887,
            23.297610426379
        ],
        [
            113.11214862559,
            23.297656818272
        ],
        [
            113.11214894827,
            23.297718950499
        ],
        [
            113.11215310437,
            23.297829124592
        ],
        [
            113.11215428039,
            23.297940639933
        ],
        [
            113.11217195758,
            23.298017783132
        ],
        [
            113.11219287049,
            23.298075680087
        ],
        [
            113.11221242721,
            23.298132213842
        ],
        [
            113.11225121562,
            23.298179623202
        ],
        [
            113.11230082365,
            23.298203757801
        ],
        [
            113.11234771419,
            23.298218926933
        ],
        [
            113.11239052983,
            23.298221867289
        ],
        [
            113.11245393842,
            23.298224648626
        ],
        [
            113.11252439045,
            23.298226386627
        ],
        [
            113.1126159576,
            23.298205184059
        ],
        [
            113.11271647133,
            23.298192178486
        ],
        [
            113.11281399679,
            23.298171839406
        ],
        [
            113.11289500752,
            23.298169319828
        ],
        [
            113.11301069762,
            23.298167280602
        ],
        [
            113.11307762522,
            23.298175001252
        ],
        [
            113.1131272167,
            23.298188048297
        ],
        [
            113.11319334138,
            23.298209607843
        ],
        [
            113.11322803275,
            23.298225011231
        ],
        [
            113.11327925639,
            23.298247842007
        ],
        [
            113.11329390802,
            23.298274520165
        ],
        [
            113.11331209219,
            23.298314243133
        ],
        [
            113.11332594037,
            23.298352583137
        ],
        [
            113.11332870475,
            23.298420699241
        ],
        [
            113.11333201848,
            23.298498314585
        ],
        [
            113.11331889069,
            23.2986819112
        ],
        [
            113.11331112955,
            23.298801782755
        ],
        [
            113.11330715377,
            23.298912724253
        ],
        [
            113.11330695105,
            23.298998999616
        ],
        [
            113.11330456168,
            23.299061114936
        ],
        [
            113.11332519608,
            23.299117402822
        ],
        [
            113.1133412195,
            23.299167151186
        ],
        [
            113.11336320668,
            23.29922154889
        ],
        [
            113.11341148416,
            23.299290489806
        ],
        [
            113.11344022987,
            23.299327024629
        ],
        [
            113.11346219425,
            23.299352936553
        ],
        [
            113.11351748995,
            23.29939045404
        ],
        [
            113.11356520077,
            23.299429553764
        ],
        [
            113.11365005458,
            23.299506334528
        ],
        [
            113.1137658128,
            23.29961316705
        ],
        [
            113.11387641827,
            23.299716178614
        ],
        [
            113.11400570713,
            23.29981200121
        ],
        [
            113.11407779892,
            23.299858883327
        ],
        [
            113.11411275071,
            23.299868888826
        ],
        [
            113.11415203293,
            23.299874312879
        ],
        [
            113.11417180207,
            23.299867394846
        ],
        [
            113.11421917963,
            23.299832452027
        ],
        [
            113.11432771392,
            23.299717902936
        ],
        [
            113.11442678309,
            23.299626629124
        ],
        [
            113.11451856316,
            23.299569496182
        ],
        [
            113.11457893054,
            23.299523808972
        ],
        [
            113.11466856076,
            23.29949217524
        ],
        [
            113.11474871045,
            23.299461563571
        ],
        [
            113.1148380654,
            23.299427770261
        ],
        [
            113.11492308621,
            23.299395036318
        ],
        [
            113.11500378508,
            23.2993788255
        ],
        [
            113.11505253059,
            23.299371328878
        ],
        [
            113.11508611416,
            23.299370771955
        ],
        [
            113.11517359131,
            23.299367104909
        ],
        [
            113.11524915729,
            23.299372033177
        ],
        [
            113.11532445903,
            23.299386731284
        ],
        [
            113.1154192583,
            23.299400503691
        ],
        [
            113.11552571639,
            23.299433911477
        ],
        [
            113.11562783632,
            23.299463223839
        ],
        [
            113.11571966806,
            23.299498157974
        ],
        [
            113.1158318081,
            23.299532453353
        ],
        [
            113.11592987271,
            23.29957749356
        ],
        [
            113.11601655406,
            23.299611864502
        ],
        [
            113.11608535677,
            23.299639578139
        ],
        [
            113.11615688089,
            23.299686039214
        ],
        [
            113.11625387019,
            23.299748731321
        ],
        [
            113.11630805375,
            23.299784199242
        ],
        [
            113.11637660194,
            23.299837972602
        ],
        [
            113.11642430618,
            23.299900519821
        ],
        [
            113.11647499335,
            23.299969606542
        ],
        [
            113.11650429879,
            23.300051800161
        ],
        [
            113.11655206548,
            23.300199814567
        ],
        [
            113.11661985485,
            23.300330374436
        ],
        [
            113.11666919789,
            23.300416277915
        ],
        [
            113.11676133286,
            23.300518848158
        ],
        [
            113.11684154412,
            23.300609650264
        ],
        [
            113.11694800578,
            23.300684962901
        ],
        [
            113.11705799534,
            23.300774425234
        ],
        [
            113.11712111402,
            23.300822491491
        ],
        [
            113.11721538797,
            23.300899340835
        ],
        [
            113.11727417473,
            23.300949815713
        ],
        [
            113.11733705199,
            23.301042384533
        ],
        [
            113.1173652655,
            23.301122416852
        ],
        [
            113.11738778956,
            23.301197240619
        ],
        [
            113.11738620069,
            23.301247416873
        ],
        [
            113.11730835113,
            23.301420853729
        ],
        [
            113.11719725288,
            23.301673203111
        ],
        [
            113.11711589106,
            23.30186533827
        ],
        [
            113.11703857929,
            23.302044764711
        ],
        [
            113.11699399204,
            23.302173221182
        ],
        [
            113.11694640634,
            23.302272893444
        ],
        [
            113.11688723428,
            23.302458735588
        ],
        [
            113.11686940832,
            23.302525584311
        ],
        [
            113.11686103987,
            23.302563761513
        ],
        [
            113.11687730768,
            23.302598094175
        ],
        [
            113.11689789724,
            23.302616731087
        ],
        [
            113.11692904848,
            23.302638992196
        ],
        [
            113.11697617946,
            23.302669811667
        ],
        [
            113.11704795642,
            23.302713341193
        ],
        [
            113.11709616867,
            23.302743089988
        ],
        [
            113.11714682685,
            23.302787785101
        ],
        [
            113.11723296608,
            23.302855062852
        ],
        [
            113.11732913611,
            23.302945773622
        ],
        [
            113.11734540057,
            23.302977670494
        ],
        [
            113.11735273376,
            23.303014365936
        ],
        [
            113.11734679443,
            23.303040896919
        ],
        [
            113.11731189663,
            23.303083702227
        ],
        [
            113.11728647271,
            23.303123885127
        ],
        [
            113.11723804008,
            23.303170905204
        ],
        [
            113.11718014826,
            23.303245511009
        ],
        [
            113.11715229815,
            23.30330385094
        ],
        [
            113.11710089967,
            23.303373095106
        ],
        [
            113.11706058956,
            23.303423453254
        ],
        [
            113.11702570043,
            23.303484172264
        ],
        [
            113.11698621031,
            23.303548376653
        ],
        [
            113.11695429492,
            23.303602885142
        ],
        [
            113.11690994488,
            23.303690921541
        ],
        [
            113.11685989534,
            23.303757474771
        ],
        [
            113.11682419743,
            23.303827416048
        ],
        [
            113.11678526275,
            23.303918761593
        ],
        [
            113.11675496902,
            23.303971661937
        ],
        [
            113.11672819864,
            23.304030834646
        ],
        [
            113.11671685504,
            23.304079023566
        ],
        [
            113.1167063115,
            23.304106601075
        ],
        [
            113.11669442537,
            23.304153428793
        ],
        [
            113.11668610236,
            23.304274624373
        ],
        [
            113.11668696631,
            23.304363889237
        ],
        [
            113.11666862302,
            23.304483638218
        ],
        [
            113.11664945612,
            23.304584660441
        ],
        [
            113.11662783606,
            23.304657717316
        ],
        [
            113.11661543202,
            23.304749033684
        ],
        [
            113.11659327759,
            23.30483619373
        ],
        [
            113.1165767977,
            23.304903057324
        ],
        [
            113.11655952667,
            23.305008980779
        ],
        [
            113.11653601463,
            23.305091517559
        ],
        [
            113.11650899545,
            23.305198711658
        ],
        [
            113.11648330729,
            23.305264409721
        ],
        [
            113.11646385461,
            23.305345084436
        ],
        [
            113.11642897286,
            23.305436204412
        ],
        [
            113.11640382419,
            23.305500009666
        ],
        [
            113.11637595949,
            23.305548599142
        ],
        [
            113.11636406879,
            23.305593801646
        ],
        [
            113.11633892093,
            23.305660592392
        ],
        [
            113.11631268766,
            23.305723576063
        ],
        [
            113.11629755484,
            23.3057839435
        ],
        [
            113.11628674608,
            23.305828070861
        ],
        [
            113.1162670101,
            23.305889483938
        ],
        [
            113.11625242442,
            23.305962064813
        ],
        [
            113.11623000163,
            23.306066590969
        ],
        [
            113.11620756591,
            23.306146158304
        ],
        [
            113.11619513764,
            23.306202751916
        ],
        [
            113.11618813253,
            23.306274855871
        ],
        [
            113.11617869112,
            23.306349109276
        ],
        [
            113.11616300818,
            23.306396179957
        ],
        [
            113.11611214422,
            23.306488799171
        ],
        [
            113.11606696661,
            23.30658255381
        ],
        [
            113.11602044354,
            23.306696103033
        ],
        [
            113.11598582038,
            23.306779097969
        ],
        [
            113.11593765494,
            23.30685818227
        ],
        [
            113.11589273992,
            23.306940551022
        ],
        [
            113.11584212898,
            23.307004426293
        ],
        [
            113.11578257318,
            23.30705140979
        ],
        [
            113.1157636219,
            23.307062919214
        ],
        [
            113.11572056839,
            23.307073959913
        ],
        [
            113.11566261548,
            23.307075114202
        ],
        [
            113.11560195273,
            23.30707380772
        ],
        [
            113.11556728506,
            23.307066474002
        ],
        [
            113.1155025496,
            23.307044250254
        ],
        [
            113.1154342895,
            23.307014948373
        ],
        [
            113.11535789474,
            23.306965781864
        ],
        [
            113.11529991407,
            23.306914051576
        ],
        [
            113.11523218222,
            23.306861162952
        ],
        [
            113.1151823365,
            23.306834189283
        ],
        [
            113.11513005606,
            23.306814252543
        ],
        [
            113.11507479964,
            23.306802434088
        ],
        [
            113.11501737054,
            23.306778936117
        ],
        [
            113.11498351382,
            23.306775966203
        ],
        [
            113.11493340497,
            23.306770433076
        ],
        [
            113.11487300606,
            23.30677052217
        ],
        [
            113.11480068129,
            23.306753976962
        ],
        [
            113.1146871836,
            23.306733607091
        ],
        [
            113.11456799144,
            23.306704525681
        ],
        [
            113.11446641532,
            23.306701354764
        ],
        [
            113.11442361875,
            23.306702949188
        ],
        [
            113.11437784618,
            23.306712934234
        ],
        [
            113.11434372226,
            23.306725987137
        ],
        [
            113.11430147422,
            23.306744138739
        ],
        [
            113.11424839989,
            23.306782020928
        ],
        [
            113.11422729072,
            23.306823924729
        ],
        [
            113.11418966906,
            23.306890673736
        ],
        [
            113.11412254022,
            23.307000628386
        ],
        [
            113.1140773289,
            23.307059461578
        ],
        [
            113.1140258749,
            23.307092210322
        ],
        [
            113.11397712189,
            23.307108430699
        ],
        [
            113.11390723108,
            23.307107692205
        ],
        [
            113.11377691868,
            23.307084586499
        ],
        [
            113.11367857644,
            23.307075266071
        ],
        [
            113.11357290928,
            23.307046917005
        ],
        [
            113.11348647518,
            23.307018698452
        ],
        [
            113.11336075682,
            23.306991870775
        ],
        [
            113.11321851053,
            23.306968483548
        ],
        [
            113.11309983666,
            23.306955563175
        ],
        [
            113.11299958999,
            23.30695551377
        ],
        [
            113.11289581971,
            23.306956538058
        ],
        [
            113.11283052438,
            23.306962402929
        ],
        [
            113.11278663551,
            23.30697300477
        ],
        [
            113.11275440264,
            23.306995610892
        ],
        [
            113.1127118787,
            23.307030097021
        ],
        [
            113.11268642448,
            23.307064408643
        ],
        [
            113.11265068562,
            23.307125250251
        ],
        [
            113.11262037346,
            23.307204028162
        ],
        [
            113.11257706996,
            23.307317460729
        ],
        [
            113.11254595012,
            23.307410885772
        ],
        [
            113.11251752767,
            23.307477197186
        ],
        [
            113.11247881915,
            23.307569226278
        ],
        [
            113.11244146615,
            23.307664519378
        ],
        [
            113.11241331545,
            23.307735989234
        ],
        [
            113.11239003137,
            23.307782255678
        ],
        [
            113.11236215197,
            23.307856169786
        ],
        [
            113.11230692564,
            23.30798365602
        ],
        [
            113.11225466645,
            23.308080504585
        ],
        [
            113.11222598671,
            23.308190770404
        ],
        [
            113.11219108084,
            23.308319452413
        ],
        [
            113.11215590595,
            23.308456001326
        ],
        [
            113.11214753864,
            23.308543313298
        ],
        [
            113.1121418569,
            23.308566886349
        ],
        [
            113.11215243417,
            23.30859081365
        ],
        [
            113.11215026642,
            23.308591073866
        ],
        [
            113.11216897399,
            23.308617484452
        ],
        [
            113.11219526508,
            23.308633625421
        ],
        [
            113.11223591292,
            23.308636548234
        ],
        [
            113.11230311693,
            23.308642053026
        ],
        [
            113.11238739268,
            23.308651450529
        ],
        [
            113.11244808969,
            23.308651774957
        ],
        [
            113.11250147271,
            23.308659387762
        ],
        [
            113.11258574428,
            23.308665815953
        ],
        [
            113.11263505897,
            23.308666359274
        ],
        [
            113.11268627251,
            23.308673968826
        ],
        [
            113.11272393972,
            23.308686387704
        ],
        [
            113.11279601422,
            23.308690321578
        ],
        [
            113.11290277093,
            23.308700156842
        ],
        [
            113.11302605316,
            23.308710913145
        ],
        [
            113.11316586159,
            23.30872747902
        ],
        [
            113.11332192235,
            23.308745246956
        ],
        [
            113.11342731269,
            23.30875078249
        ],
        [
            113.11351157307,
            23.308765417981
        ],
        [
            113.11358174221,
            23.308772916343
        ],
        [
            113.11366491492,
            23.308782944296
        ],
        [
            113.11376434088,
            23.308793898149
        ],
        [
            113.11382123443,
            23.308805936405
        ],
        [
            113.11387352588,
            23.308828255874
        ],
        [
            113.11391525515,
            23.308859459773
        ],
        [
            113.11395021503,
            23.308899843604
        ],
        [
            113.11397244025,
            23.308933360787
        ],
        [
            113.11398979382,
            23.308979596078
        ],
        [
            113.11399875314,
            23.309035812653
        ],
        [
            113.11399605978,
            23.309080014183
        ],
        [
            113.11398849499,
            23.309137747237
        ],
        [
            113.11397984579,
            23.309193574022
        ],
        [
            113.11394440198,
            23.309319755652
        ],
        [
            113.11390136654,
            23.309429339312
        ],
        [
            113.11389082208,
            23.309491122273
        ],
        [
            113.11388867228,
            23.30954400858
        ],
        [
            113.11388733027,
            23.309582250842
        ],
        [
            113.11389222135,
            23.309628401723
        ],
        [
            113.11391471881,
            23.309669244038
        ],
        [
            113.11394317023,
            23.30969276435
        ],
        [
            113.11397947892,
            23.309721221222
        ],
        [
            113.11401036582,
            23.309737977426
        ],
        [
            113.11403881247,
            23.30974820711
        ],
        [
            113.11412252185,
            23.309765053696
        ],
        [
            113.11419051301,
            23.309763350454
        ],
        [
            113.1143059068,
            23.309761439363
        ],
        [
            113.11442048141,
            23.309746240965
        ],
        [
            113.11450066061,
            23.309752780915
        ],
        [
            113.11457054353,
            23.309751927259
        ],
        [
            113.11467808112,
            23.309770342551
        ],
        [
            113.1147612442,
            23.309802694169
        ],
        [
            113.11481542243,
            23.309826968621
        ],
        [
            113.11483276171,
            23.309842289537
        ],
        [
            113.11483737379,
            23.309866739458
        ],
        [
            113.11483251023,
            23.30990468298
        ],
        [
            113.11482899919,
            23.3099372109
        ],
        [
            113.11480166035,
            23.309993434715
        ],
        [
            113.11474943047,
            23.310142796738
        ],
        [
            113.11468771625,
            23.310282867738
        ],
        [
            113.11466607262,
            23.310370062459
        ],
        [
            113.11465146532,
            23.310437505183
        ],
        [
            113.11464174263,
            23.31053889389
        ],
        [
            113.1146423124,
            23.310641442638
        ],
        [
            113.11465342669,
            23.310674891324
        ],
        [
            113.11466942317,
            23.310733876248
        ],
        [
            113.11470871948,
            23.310816904949
        ],
        [
            113.11478188501,
            23.310950914732
        ],
        [
            113.11484338965,
            23.311034926227
        ],
        [
            113.11490949434,
            23.311105411379
        ],
        [
            113.11494552436,
            23.311135523451
        ],
        [
            113.11498155058,
            23.311151258724
        ],
        [
            113.11501702879,
            23.311142033126
        ],
        [
            113.11503815304,
            23.311136225758
        ],
        [
            113.11505223079,
            23.311111917886
        ],
        [
            113.11506142952,
            23.31107210989
        ],
        [
            113.11506574851,
            23.311014360105
        ],
        [
            113.11507033055,
            23.310926771403
        ],
        [
            113.11508845057,
            23.310825450966
        ],
        [
            113.11510033562,
            23.310705093125
        ],
        [
            113.11513604544,
            23.310555077532
        ],
        [
            113.11516121573,
            23.310492062962
        ],
        [
            113.11519018244,
            23.310446982937
        ],
        [
            113.11521021906,
            23.310428962458
        ],
        [
            113.11526654686,
            23.310410411479
        ],
        [
            113.11531177073,
            23.310393946186
        ],
        [
            113.11535618822,
            23.310400263977
        ],
        [
            113.11539085336,
            23.310398367689
        ],
        [
            113.11543743553,
            23.310400093842
        ],
        [
            113.11547508168,
            23.31040690476
        ],
        [
            113.11551299902,
            23.310415889296
        ],
        [
            113.11554008812,
            23.310441607403
        ],
        [
            113.11556771627,
            23.31045864943
        ],
        [
            113.11559155762,
            23.310492752247
        ],
        [
            113.11561676046,
            23.310554266054
        ],
        [
            113.11564277322,
            23.310607648477
        ],
        [
            113.11565524895,
            23.310675299118
        ],
        [
            113.11565526335,
            23.310729013002
        ],
        [
            113.11565989744,
            23.310843802763
        ],
        [
            113.11567210408,
            23.310921488623
        ],
        [
            113.11568106262,
            23.311007015179
        ],
        [
            113.11568378638,
            23.311069431971
        ],
        [
            113.11570844483,
            23.311128772646
        ],
        [
            113.11572633749,
            23.311207590487
        ],
        [
            113.11577916705,
            23.311299446105
        ],
        [
            113.11583308119,
            23.311401079003
        ],
        [
            113.11588022214,
            23.311493434294
        ],
        [
            113.11595389885,
            23.311577875186
        ],
        [
            113.11601782039,
            23.311638365574
        ],
        [
            113.11608823985,
            23.311697829363
        ],
        [
            113.1161537792,
            23.311734468043
        ],
        [
            113.11621606866,
            23.311772709948
        ],
        [
            113.11626454204,
            23.311785606648
        ],
        [
            113.11634361249,
            23.311794430787
        ],
        [
            113.11639072702,
            23.31178887371
        ],
        [
            113.11643323917,
            23.311788974882
        ],
        [
            113.11647114266,
            23.311764621842
        ],
        [
            113.11649496357,
            23.311730650799
        ],
        [
            113.11652094969,
            23.311692901461
        ],
        [
            113.11653068557,
            23.311638189315
        ],
        [
            113.11654420756,
            23.311563164847
        ],
        [
            113.11656746402,
            23.311431529529
        ],
        [
            113.11660020248,
            23.311325479269
        ],
        [
            113.1166380946,
            23.311260439146
        ],
        [
            113.11667789017,
            23.311230683652
        ],
        [
            113.11672066646,
            23.311211807494
        ],
        [
            113.11676723494,
            23.311200562965
        ],
        [
            113.11681976512,
            23.311211348064
        ],
        [
            113.11686173494,
            23.311220682574
        ],
        [
            113.116927536,
            23.311251125556
        ],
        [
            113.11696490382,
            23.31126693203
        ],
        [
            113.11699144136,
            23.311282910902
        ],
        [
            113.11700282395,
            23.311329404869
        ],
        [
            113.11702259931,
            23.311374348877
        ],
        [
            113.11703181962,
            23.31143818495
        ],
        [
            113.11702479781,
            23.311515705861
        ],
        [
            113.11703184655,
            23.311556734292
        ],
        [
            113.11705053528,
            23.311588104617
        ],
        [
            113.11706272027,
            23.311593914567
        ],
        [
            113.11711768668,
            23.311615043391
        ],
        [
            113.11715992787,
            23.311637411799
        ],
        [
            113.11718971639,
            23.311668074314
        ],
        [
            113.11721057121,
            23.311703265223
        ],
        [
            113.11723630332,
            23.311757491927
        ],
        [
            113.11725797474,
            23.311814936124
        ],
        [
            113.11726664774,
            23.311859507701
        ],
        [
            113.11727802192,
            23.311874535525
        ],
        [
            113.11730888909,
            23.311888934288
        ],
        [
            113.11743451796,
            23.311927025523
        ],
        [
            113.11754823054,
            23.31195687556
        ],
        [
            113.11764515298,
            23.311970837869
        ],
        [
            113.11771987672,
            23.311993813138
        ],
        [
            113.11775859135,
            23.31200287421
        ],
        [
            113.11778485545,
            23.312025377579
        ],
        [
            113.11781599382,
            23.312055525406
        ],
        [
            113.11783549502,
            23.312104819494
        ],
        [
            113.11783008972,
            23.312151154491
        ],
        [
            113.11782279214,
            23.312212391038
        ],
        [
            113.11780141881,
            23.31228271203
        ],
        [
            113.11775920257,
            23.312367748389
        ],
        [
            113.11772131665,
            23.312449844475
        ],
        [
            113.11769480003,
            23.312529611325
        ],
        [
            113.1176485256,
            23.312641467758
        ],
        [
            113.11761118439,
            23.312755311465
        ],
        [
            113.11756869602,
            23.312853372282
        ],
        [
            113.11754867712,
            23.312950566409
        ],
        [
            113.11752811773,
            23.31305833526
        ],
        [
            113.11750620048,
            23.313140862686
        ],
        [
            113.11749646646,
            23.313229475719
        ],
        [
            113.1174905202,
            23.313302662561
        ],
        [
            113.11750352683,
            23.313392308288
        ],
        [
            113.11751734256,
            23.313460531238
        ],
        [
            113.11754279881,
            23.313524526373
        ],
        [
            113.11757881301,
            23.313588081734
        ],
        [
            113.11760480987,
            23.313650726898
        ],
        [
            113.11766654238,
            23.313718061306
        ],
        [
            113.11773802235,
            23.313808281244
        ],
        [
            113.11783738455,
            23.313896339259
        ],
        [
            113.11787420675,
            23.313947703425
        ],
        [
            113.11789261834,
            23.313979896435
        ],
        [
            113.11790317991,
            23.314019878482
        ],
        [
            113.11789560391,
            23.314062392878
        ],
        [
            113.11787936481,
            23.314102922351
        ],
        [
            113.11786041822,
            23.314140983719
        ],
        [
            113.11784336597,
            23.314172824854
        ],
        [
            113.11783579216,
            23.314247078339
        ],
        [
            113.11782145296,
            23.314357886557
        ],
        [
            113.11782362244,
            23.314408364449
        ],
        [
            113.11784798975,
            23.314449567498
        ],
        [
            113.1179005109,
            23.314489151785
        ],
        [
            113.11796386119,
            23.314547835338
        ],
        [
            113.11807241949,
            23.314622167949
        ],
        [
            113.11814659597,
            23.314685309852
        ],
        [
            113.11823863795,
            23.314757861353
        ],
        [
            113.11834881541,
            23.314842812945
        ],
        [
            113.1184649465,
            23.314944925507
        ],
        [
            113.1185615844,
            23.315014563268
        ],
        [
            113.11864035499,
            23.315065573804
        ],
        [
            113.11873725999,
            23.315120578605
        ],
        [
            113.11880547168,
            23.315165247986
        ],
        [
            113.11892105066,
            23.315239182429
        ],
        [
            113.11902038708,
            23.315299116631
        ],
        [
            113.11912026333,
            23.315368829679
        ],
        [
            113.11919117711,
            23.315418430795
        ],
        [
            113.1192696684,
            23.315473001628
        ],
        [
            113.11934003894,
            23.31551880677
        ],
        [
            113.11941365627,
            23.315553258276
        ],
        [
            113.11950702991,
            23.315594715703
        ],
        [
            113.1195102777,
            23.315600719832
        ],
        [
            113.11963964511,
            23.315650183883
        ],
        [
            113.1197543956,
            23.31569515401
        ],
        [
            113.11983612699,
            23.315725108548
        ],
        [
            113.11993869573,
            23.31576832754
        ],
        [
            113.12001284731,
            23.315794679052
        ],
        [
            113.12007427882,
            23.315809222825
        ],
        [
            113.12011866072,
            23.315812449499
        ],
        [
            113.12017116091,
            23.315804107513
        ],
        [
            113.12024070949,
            23.315802205714
        ],
        [
            113.1203089043,
            23.315775063595
        ],
        [
            113.12038007507,
            23.315735481506
        ],
        [
            113.12044989196,
            23.315690732859
        ],
        [
            113.12050509539,
            23.315649069286
        ],
        [
            113.12054947413,
            23.315604837554
        ],
        [
            113.12058952276,
            23.315553773816
        ],
        [
            113.12063714787,
            23.315505514456
        ],
        [
            113.12067935989,
            23.31542219812
        ],
        [
            113.12071264187,
            23.315350982717
        ],
        [
            113.12073942912,
            23.315279689866
        ],
        [
            113.12075566259,
            23.315203116202
        ],
        [
            113.12078271906,
            23.315114194787
        ],
        [
            113.12081058381,
            23.314956652361
        ],
        [
            113.12083195658,
            23.314870375676
        ],
        [
            113.12083790643,
            23.314808326833
        ],
        [
            113.1208443983,
            23.31476500218
        ],
        [
            113.12084709261,
            23.314572975307
        ],
        [
            113.12084437258,
            23.314374100723
        ],
        [
            113.1208408432,
            23.314228385208
        ],
        [
            113.12082350777,
            23.314032317138
        ],
        [
            113.12081294305,
            23.313913643393
        ],
        [
            113.12079020337,
            23.313818694619
        ],
        [
            113.12075365798,
            23.3136809899
        ],
        [
            113.12071250964,
            23.313529938191
        ],
        [
            113.12062832443,
            23.31330187292
        ],
        [
            113.1205955699,
            23.313214673874
        ],
        [
            113.12057282828,
            23.31313573303
        ],
        [
            113.12053546997,
            23.313031661298
        ],
        [
            113.12051326818,
            23.312950014916
        ],
        [
            113.12047211389,
            23.312807107147
        ],
        [
            113.12043907941,
            23.312681658003
        ],
        [
            113.12041335554,
            23.312586136149
        ],
        [
            113.12039764168,
            23.312479610353
        ],
        [
            113.12038191931,
            23.312330222753
        ],
        [
            113.12038515239,
            23.31225403198
        ],
        [
            113.12039515359,
            23.312194468878
        ],
        [
            113.12043843509,
            23.312113054137
        ],
        [
            113.12048630709,
            23.311986120373
        ],
        [
            113.12052146763,
            23.311898101034
        ],
        [
            113.12057044382,
            23.31188376347
        ],
        [
            113.12072251958,
            23.311878801608
        ],
        [
            113.12085808495,
            23.311868772624
        ],
        [
            113.12100419927,
            23.311852645682
        ],
        [
            113.12121416827,
            23.311841661442
        ],
        [
            113.12146011539,
            23.31182383255
        ],
        [
            113.12167277909,
            23.311823797812
        ],
        [
            113.12187921248,
            23.311816931192
        ],
        [
            113.12194495555,
            23.311812077178
        ],
        [
            113.12198039944,
            23.311820671092
        ],
        [
            113.12204398569,
            23.311855671485
        ],
        [
            113.12212489002,
            23.311909074429
        ],
        [
            113.1221795453,
            23.311935826309
        ],
        [
            113.12221607566,
            23.311971024969
        ],
        [
            113.12229318992,
            23.31202248832
        ],
        [
            113.12237219961,
            23.312087001627
        ],
        [
            113.12243849128,
            23.312141585469
        ],
        [
            113.12251992951,
            23.312183622026
        ],
        [
            113.12265304087,
            23.312243981812
        ],
        [
            113.12275341326,
            23.312286282043
        ],
        [
            113.12287623583,
            23.312320751583
        ],
        [
            113.1229625366,
            23.312353109865
        ],
        [
            113.12300230316,
            23.312358258286
        ],
        [
            113.12307480046,
            23.312358154133
        ],
        [
            113.12314188471,
            23.312346043401
        ],
        [
            113.1232606327,
            23.312321619311
        ],
        [
            113.12337315946,
            23.312308240619
        ],
        [
            113.12355627794,
            23.312261935504
        ],
        [
            113.12371396531,
            23.312210955183
        ],
        [
            113.12386975518,
            23.312155079772
        ],
        [
            113.12395468303,
            23.312134842076
        ],
        [
            113.12401635189,
            23.312130556848
        ],
        [
            113.12408126572,
            23.312124692039
        ],
        [
            113.12419351586,
            23.312137134731
        ],
        [
            113.1242938619,
            23.312139919964
        ],
        [
            113.12435958649,
            23.312141401455
        ],
        [
            113.12438365771,
            23.312138761887
        ],
        [
            113.12444802683,
            23.312127748455
        ],
        [
            113.1245026585,
            23.312115512126
        ],
        [
            113.12457054679,
            23.312124899516
        ],
        [
            113.1246357285,
            23.31212692582
        ],
        [
            113.12468576435,
            23.312130633952
        ],
        [
            113.12477799099,
            23.312133057275
        ],
        [
            113.12486021184,
            23.312145376581
        ],
        [
            113.12492593127,
            23.312141995474
        ],
        [
            113.12504006113,
            23.312140954207
        ],
        [
            113.12518123334,
            23.312136249425
        ],
        [
            113.12529184444,
            23.312135985319
        ],
        [
            113.1253754103,
            23.312135325726
        ],
        [
            113.12541733147,
            23.312151682917
        ],
        [
            113.12545005709,
            23.312165462562
        ],
        [
            113.12546223267,
            23.312195755708
        ],
        [
            113.1254809017,
            23.312241879793
        ],
        [
            113.12549606652,
            23.312349531667
        ],
        [
            113.12549878288,
            23.312414407366
        ],
        [
            113.12551826463,
            23.312471666175
        ],
        [
            113.1255142076,
            23.312468892856
        ],
        [
            113.12553666385,
            23.312525653659
        ],
        [
            113.12557642727,
            23.312580503248
        ],
        [
            113.12559536703,
            23.312635041863
        ],
        [
            113.12559698935,
            23.312633438485
        ],
        [
            113.12559618103,
            23.312650788065
        ],
        [
            113.12556968694,
            23.312700035259
        ],
        [
            113.12555698262,
            23.31273619632
        ],
        [
            113.12554374133,
            23.312796764253
        ],
        [
            113.12555024159,
            23.312857627128
        ],
        [
            113.12555511823,
            23.312913311489
        ],
        [
            113.12557161803,
            23.312934717633
        ],
        [
            113.12560407205,
            23.312947953148
        ],
        [
            113.1256411232,
            23.312960715548
        ],
        [
            113.12568953181,
            23.312970393824
        ],
        [
            113.12574172663,
            23.312983114253
        ],
        [
            113.12583151271,
            23.313010509075
        ],
        [
            113.12593238601,
            23.313042687378
        ],
        [
            113.12596402877,
            23.313064597278
        ],
        [
            113.12601162506,
            23.313078340167
        ],
        [
            113.12605841197,
            23.313106449442
        ],
        [
            113.12613494823,
            23.31315942753
        ],
        [
            113.12624123228,
            23.313232394744
        ],
        [
            113.12638321053,
            23.31331459591
        ],
        [
            113.12648948981,
            23.313375639544
        ],
        [
            113.12655277019,
            23.313413508615
        ],
        [
            113.1266384914,
            23.313433551349
        ],
        [
            113.12672150702,
            23.313447044954
        ],
        [
            113.12677585945,
            23.313460096169
        ],
        [
            113.12685806162,
            23.313464630324
        ],
        [
            113.12694080444,
            23.313472973843
        ],
        [
            113.12703733605,
            23.31347583957
        ],
        [
            113.12712278052,
            23.313477179064
        ],
        [
            113.12718524219,
            23.313486841087
        ],
        [
            113.12727933862,
            23.31349347678
        ],
        [
            113.12736721707,
            23.313513581776
        ],
        [
            113.12743860031,
            23.313525290663
        ],
        [
            113.12755621951,
            23.31354533141
        ],
        [
            113.1277884781,
            23.313569106478
        ],
        [
            113.12785823443,
            23.313564525639
        ],
        [
            113.12789257042,
            23.313552054521
        ],
        [
            113.12794069149,
            23.313509151093
        ],
        [
            113.1279777223,
            23.313429991004
        ],
        [
            113.12801367208,
            23.313357595889
        ],
        [
            113.12803177603,
            23.313278132309
        ],
        [
            113.12807583324,
            23.313185522787
        ],
        [
            113.1280950201,
            23.313121268364
        ],
        [
            113.12810879923,
            23.313056384353
        ],
        [
            113.12812148534,
            23.312919323499
        ],
        [
            113.12814309597,
            23.312802752125
        ],
        [
            113.12815795336,
            23.312725678145
        ],
        [
            113.12816199994,
            23.312673115871
        ],
        [
            113.12817334914,
            23.312636948005
        ],
        [
            113.12820795273,
            23.312617432292
        ],
        [
            113.12821579276,
            23.312614032356
        ],
        [
            113.1282644555,
            23.312596100987
        ],
        [
            113.12829987252,
            23.312591519888
        ],
        [
            113.12836097467,
            23.312590882204
        ],
        [
            113.12840396168,
            23.312586967854
        ],
        [
            113.12846398308,
            23.312593096994
        ],
        [
            113.12851643565,
            23.312608056458
        ],
        [
            113.12865946439,
            23.312660302873
        ],
        [
            113.12878518795,
            23.312707933127
        ],
        [
            113.12891956265,
            23.312762764495
        ],
        [
            113.12904690541,
            23.312809348329
        ],
        [
            113.12922020698,
            23.312863750619
        ],
        [
            113.12926589659,
            23.312871559547
        ],
        [
            113.12930239367,
            23.312875147809
        ],
        [
            113.12934023974,
            23.312862482354
        ],
        [
            113.12937970576,
            23.312837636857
        ],
        [
            113.12945809633,
            23.312785768249
        ],
        [
            113.12953757289,
            23.312764845248
        ],
        [
            113.12957190425,
            23.312754565769
        ],
        [
            113.12963246063,
            23.312758016382
        ],
        [
            113.12970572361,
            23.312767648443
        ],
        [
            113.1297579006,
            23.312780456319
        ],
        [
            113.12983332631,
            23.312794196741
        ],
        [
            113.12990604848,
            23.312808978784
        ],
        [
            113.12999553205,
            23.312831097108
        ],
        [
            113.13006068522,
            23.312852266255
        ],
        [
            113.13012989212,
            23.312867808177
        ],
        [
            113.13025262362,
            23.312883982939
        ],
        [
            113.13036183941,
            23.312909428419
        ],
        [
            113.13044996789,
            23.312926653373
        ],
        [
            113.13056593922,
            23.312944895412
        ],
        [
            113.13062973687,
            23.312956558078
        ],
        [
            113.13073029902,
            23.312976442872
        ],
        [
            113.13082680464,
            23.312988936956
        ],
        [
            113.13089087158,
            23.31300033763
        ],
        [
            113.13096467086,
            23.313019501322
        ],
        [
            113.13104982309,
            23.313039131877
        ],
        [
            113.13114470752,
            23.313067611821
        ],
        [
            113.13122580465,
            23.31309016092
        ],
        [
            113.13126554393,
            23.313113358327
        ],
        [
            113.13128203535,
            23.31312964652
        ],
        [
            113.13128906697,
            23.313153368117
        ],
        [
            113.13128664285,
            23.31321246444
        ],
        [
            113.13128557359,
            23.313296269969
        ],
        [
            113.13128396931,
            23.313424283955
        ],
        [
            113.1312804706,
            23.313541414313
        ],
        [
            113.13128995075,
            23.313697288105
        ],
        [
            113.13128157888,
            23.313763335139
        ],
        [
            113.13127726013,
            23.313817786949
        ],
        [
            113.1312513175,
            23.313882989962
        ],
        [
            113.13121267246,
            23.313972118607
        ],
        [
            113.1311994323,
            23.314021805829
        ],
        [
            113.13119051907,
            23.314092455195
        ],
        [
            113.13118457893,
            23.314162341658
        ],
        [
            113.13118890978,
            23.314225351003
        ],
        [
            113.13119026674,
            23.314285596629
        ],
        [
            113.13121162955,
            23.314380907886
        ],
        [
            113.13122704414,
            23.31446526632
        ],
        [
            113.13124083471,
            23.3145259963
        ],
        [
            113.13130544817,
            23.314652160895
        ],
        [
            113.13135924619,
            23.314746673185
        ],
        [
            113.13144737544,
            23.314886264865
        ],
        [
            113.13150468496,
            23.314962392938
        ],
        [
            113.13156983503,
            23.31508341637
        ],
        [
            113.13160281606,
            23.315165636977
        ],
        [
            113.13165498946,
            23.315276400848
        ],
        [
            113.13169770089,
            23.315370997032
        ],
        [
            113.13174068212,
            23.315467768366
        ],
        [
            113.13179636712,
            23.315566115956
        ],
        [
            113.13188178542,
            23.315707296426
        ],
        [
            113.13195936351,
            23.315837763097
        ],
        [
            113.13200855876,
            23.315917283149
        ],
        [
            113.13204126527,
            23.315936296375
        ],
        [
            113.1320669439,
            23.315947321165
        ],
        [
            113.13208856798,
            23.315938473229
        ],
        [
            113.13210802964,
            23.315938810954
        ],
        [
            113.13214830437,
            23.315903974084
        ],
        [
            113.13215560245,
            23.315889994905
        ],
        [
            113.13220858054,
            23.315774541379
        ],
        [
            113.13225453026,
            23.315676055995
        ],
        [
            113.13232669843,
            23.315584266299
        ],
        [
            113.13237913512,
            23.315532281722
        ],
        [
            113.13240319097,
            23.315505573796
        ],
        [
            113.13242859889,
            23.31550547386
        ],
        [
            113.13247995529,
            23.315507453948
        ],
        [
            113.13251644551,
            23.315517855868
        ],
        [
            113.13257537027,
            23.315532176003
        ],
        [
            113.13265862165,
            23.315558586217
        ],
        [
            113.13277538936,
            23.31559860469
        ],
        [
            113.13288783176,
            23.315635837241
        ],
        [
            113.13304649366,
            23.315694227529
        ],
        [
            113.13315920525,
            23.315746118575
        ],
        [
            113.13321083069,
            23.315763572487
        ],
        [
            113.133230562,
            23.315785620524
        ],
        [
            113.13325515863,
            23.315830269334
        ],
        [
            113.13325569951,
            23.315889686451
        ],
        [
            113.13324245546,
            23.315981142133
        ],
        [
            113.13322326468,
            23.316057573601
        ],
        [
            113.13319704587,
            23.316151785249
        ],
        [
            113.13316569086,
            23.316258656266
        ],
        [
            113.13314055302,
            23.316309484328
        ],
        [
            113.1331170369,
            23.316353288006
        ],
        [
            113.1330773038,
            23.316373207088
        ],
        [
            113.13305703166,
            23.316388584938
        ],
        [
            113.13301378531,
            23.316381044941
        ],
        [
            113.13295594359,
            23.316353175812
        ],
        [
            113.1328832357,
            23.316322876825
        ],
        [
            113.13276538878,
            23.316282566169
        ],
        [
            113.13268349026,
            23.316251837827
        ],
        [
            113.13257212939,
            23.31621164472
        ],
        [
            113.13247752623,
            23.316179884102
        ],
        [
            113.13237994934,
            23.316151871205
        ],
        [
            113.13231805126,
            23.316138858055
        ],
        [
            113.1322880481,
            23.316141862566
        ],
        [
            113.13225885577,
            23.316148136564
        ],
        [
            113.13223939401,
            23.316166786885
        ],
        [
            113.13222858176,
            23.31618911408
        ],
        [
            113.13221966146,
            23.316218798374
        ],
        [
            113.13221371436,
            23.316250975742
        ],
        [
            113.13223371598,
            23.316281705219
        ],
        [
            113.13226398878,
            23.316317767421
        ],
        [
            113.13229831539,
            23.316378585545
        ],
        [
            113.13234831889,
            23.316445102043
        ],
        [
            113.13240859223,
            23.316547062432
        ],
        [
            113.13245697302,
            23.316616806847
        ],
        [
            113.13249264955,
            23.316685787634
        ],
        [
            113.13251616452,
            23.316705728778
        ],
        [
            113.13260400951,
            23.316732489196
        ],
        [
            113.13268969107,
            23.316776031728
        ],
        [
            113.13275753427,
            23.31678915326
        ],
        [
            113.13280861967,
            23.316790318037
        ],
        [
            113.13291241116,
            23.316809224566
        ],
        [
            113.13301728272,
            23.316842800248
        ],
        [
            113.1331172885,
            23.316878462542
        ],
        [
            113.13315620883,
            23.316906814702
        ],
        [
            113.13316242476,
            23.316921029597
        ],
        [
            113.13315485438,
            23.316963756507
        ],
        [
            113.13312917225,
            23.317044956311
        ],
        [
            113.13310348882,
            23.317140804397
        ],
        [
            113.13308077765,
            23.317242672448
        ],
        [
            113.13308428848,
            23.317284508662
        ],
        [
            113.1331202348,
            23.317316334727
        ],
        [
            113.13317321013,
            23.317336795646
        ],
        [
            113.13326726928,
            23.3173571651
        ],
        [
            113.13334294806,
            23.31738372303
        ],
        [
            113.13339132773,
            23.31740817393
        ],
        [
            113.13341078689,
            23.317428047274
        ],
        [
            113.13341591718,
            23.31749215568
        ],
        [
            113.13341699034,
            23.31758630284
        ],
        [
            113.13340887429,
            23.317669166441
        ],
        [
            113.13340103141,
            23.317717855714
        ],
        [
            113.13337643076,
            23.317764351325
        ],
        [
            113.13335507254,
            23.31781985569
        ],
        [
            113.13332803959,
            23.317860612155
        ],
        [
            113.13326072855,
            23.317948131634
        ],
        [
            113.13324207501,
            23.317981440338
        ],
        [
            113.13322909587,
            23.318029225642
        ],
        [
            113.13322584805,
            23.318067959
        ],
        [
            113.13323800302,
            23.318137886745
        ],
        [
            113.13324556503,
            23.318189287999
        ],
        [
            113.13327285637,
            23.318254056475
        ],
        [
            113.13333798596,
            23.318333867134
        ],
        [
            113.13338446504,
            23.318414977827
        ],
        [
            113.13344689138,
            23.318490944263
        ],
        [
            113.13350742797,
            23.318547618474
        ],
        [
            113.13354147717,
            23.318597316301
        ],
        [
            113.13356769095,
            23.318625717927
        ],
        [
            113.13360444818,
            23.318637758605
        ],
        [
            113.13366337067,
            23.318636898552
        ],
        [
            113.13375688952,
            23.318636378152
        ],
        [
            113.13384364929,
            23.318647946291
        ],
        [
            113.13389635205,
            23.318666509009
        ],
        [
            113.13392851344,
            23.318683081548
        ],
        [
            113.13395391609,
            23.318710656425
        ],
        [
            113.13399309747,
            23.318776180042
        ],
        [
            113.13402903619,
            23.318835136244
        ],
        [
            113.13407551127,
            23.318922489898
        ],
        [
            113.13411307082,
            23.318983645125
        ],
        [
            113.1341344118,
            23.319053193774
        ],
        [
            113.13418467214,
            23.319126238112
        ],
        [
            113.13424519242,
            23.319259141227
        ],
        [
            113.13430274498,
            23.319356999717
        ],
        [
            113.13436407765,
            23.319472285963
        ],
        [
            113.13441379298,
            23.319558884506
        ],
        [
            113.13447187836,
            23.319687134014
        ],
        [
            113.13449241243,
            23.319723575345
        ],
        [
            113.13447726584,
            23.319777558171
        ],
        [
            113.13446131137,
            23.319816336281
        ],
        [
            113.13441967904,
            23.31986035559
        ],
        [
            113.13440994065,
            23.319900057711
        ],
        [
            113.13440857844,
            23.319951301066
        ],
        [
            113.13440748771,
            23.31999631031
        ],
        [
            113.13441883205,
            23.320030960955
        ],
        [
            113.13444395621,
            23.32008592885
        ],
        [
            113.13450178355,
            23.320143646752
        ],
        [
            113.13452934102,
            23.320193504096
        ],
        [
            113.13456796993,
            23.320286687564
        ],
        [
            113.13458282929,
            23.320312991735
        ],
        [
            113.13459904446,
            23.320320060835
        ],
        [
            113.13465229608,
            23.320291981518
        ],
        [
            113.13477555512,
            23.320241275069
        ],
        [
            113.1349093556,
            23.320186145884
        ],
        [
            113.1349880141,
            23.320152551959
        ],
        [
            113.13499207229,
            23.320134449946
        ],
        [
            113.1350109963,
            23.320113899663
        ],
        [
            113.13500992233,
            23.320081329826
        ],
        [
            113.13499912437,
            23.320020647696
        ],
        [
            113.13496346525,
            23.319938094327
        ],
        [
            113.13494212268,
            23.319893228877
        ],
        [
            113.13492916689,
            23.319808095218
        ],
        [
            113.13492540065,
            23.319720683502
        ],
        [
            113.13493433061,
            23.319666319502
        ],
        [
            113.13496163937,
            23.319611739638
        ],
        [
            113.13498489267,
            23.319563055374
        ],
        [
            113.13503085171,
            23.319500940682
        ],
        [
            113.13506762364,
            23.31942482857
        ],
        [
            113.13512764467,
            23.319317664062
        ],
        [
            113.13516522546,
            23.319248347911
        ],
        [
            113.13522849021,
            23.319132289788
        ],
        [
            113.13528364828,
            23.31900143951
        ],
        [
            113.13533825923,
            23.318906657014
        ],
        [
            113.13538286679,
            23.318829328382
        ],
        [
            113.13543828635,
            23.318743240746
        ],
        [
            113.13550641023,
            23.318644630234
        ],
        [
            113.13555885174,
            23.318588057121
        ],
        [
            113.13562778767,
            23.318473456947
        ],
        [
            113.13566482565,
            23.31839545123
        ],
        [
            113.13569348709,
            23.318298579236
        ],
        [
            113.13572647244,
            23.318201512971
        ],
        [
            113.13574675477,
            23.318100693871
        ],
        [
            113.1357805515,
            23.317988722534
        ],
        [
            113.13580894176,
            23.317879638636
        ],
        [
            113.13585354888,
            23.317759993198
        ],
        [
            113.1358919345,
            23.317689335347
        ],
        [
            113.13592329241,
            23.317621807365
        ],
        [
            113.13596248819,
            23.317552520255
        ],
        [
            113.13602222516,
            23.317476003997
        ],
        [
            113.13607331242,
            23.31740720018
        ],
        [
            113.13611007238,
            23.317372320118
        ],
        [
            113.13616548166,
            23.317331262302
        ],
        [
            113.13623521568,
            23.317285848497
        ],
        [
            113.13629629989,
            23.317253843675
        ],
        [
            113.13633413988,
            23.317230376039
        ],
        [
            113.13637738513,
            23.317209717456
        ],
        [
            113.13644306233,
            23.317201665853
        ],
        [
            113.13647982013,
            23.317194183526
        ],
        [
            113.13652279358,
            23.317196848836
        ],
        [
            113.13657225366,
            23.317198816047
        ],
        [
            113.13661792946,
            23.317207768625
        ],
        [
            113.13664711814,
            23.31722239495
        ],
        [
            113.13669522573,
            23.317241427648
        ],
        [
            113.13675360398,
            23.3172568458
        ],
        [
            113.13679009074,
            23.317261294208
        ],
        [
            113.13683414568,
            23.317258282173
        ],
        [
            113.1368527948,
            23.317255630843
        ],
        [
            113.13689279697,
            23.317232472956
        ],
        [
            113.1369144209,
            23.317202205715
        ],
        [
            113.13694145157,
            23.317150876253
        ],
        [
            113.13696686032,
            23.317101959208
        ],
        [
            113.13697442955,
            23.317075238993
        ],
        [
            113.13701335025,
            23.317055045591
        ],
        [
            113.1370441625,
            23.317038234024
        ],
        [
            113.13707632571,
            23.31702877066
        ],
        [
            113.13713416458,
            23.317027631659
        ],
        [
            113.13717524697,
            23.317016428346
        ],
        [
            113.13723389799,
            23.316990889819
        ],
        [
            113.13727795397,
            23.316968888767
        ],
        [
            113.13732552416,
            23.316933658282
        ],
        [
            113.13741012432,
            23.316848632162
        ],
        [
            113.13749418353,
            23.316765223609
        ],
        [
            113.13754499736,
            23.316713231908
        ],
        [
            113.13758824249,
            23.31668579044
        ],
        [
            113.13762013534,
            23.31667740659
        ],
        [
            113.13764446026,
            23.316674855785
        ],
        [
            113.13768608249,
            23.316682920982
        ],
        [
            113.13771013699,
            23.316685248054
        ],
        [
            113.13774959658,
            23.316705752816
        ],
        [
            113.13777527202,
            23.316727639761
        ],
        [
            113.13782473053,
            23.316780874129
        ],
        [
            113.13785418949,
            23.316809609885
        ],
        [
            113.13787986503,
            23.316827427661
        ],
        [
            113.13789256815,
            23.316824940997
        ],
        [
            113.13793419194,
            23.316797741085
        ],
        [
            113.13800095197,
            23.316758781095
        ],
        [
            113.13805203599,
            23.316717100693
        ],
        [
            113.1381204177,
            23.31667627005
        ],
        [
            113.13816852883,
            23.316626398344
        ],
        [
            113.13820826111,
            23.31658098909
        ],
        [
            113.13826421014,
            23.316530171135
        ],
        [
            113.13833097056,
            23.316465981538
        ],
        [
            113.13833151149,
            23.316449443901
        ],
        [
            113.13823826744,
            23.31634769065
        ],
        [
            113.13817151025,
            23.316243965829
        ],
        [
            113.13811205006,
            23.31614091277
        ],
        [
            113.13805853543,
            23.31606346416
        ],
        [
            113.13801366941,
            23.315992679478
        ],
        [
            113.13796555965,
            23.31589308253
        ],
        [
            113.13792826066,
            23.315809139893
        ],
        [
            113.1378974481,
            23.315734264331
        ],
        [
            113.13789798778,
            23.315682461689
        ],
        [
            113.13788825625,
            23.315605519595
        ],
        [
            113.13789825559,
            23.315567448603
        ],
        [
            113.13791663315,
            23.31551894714
        ],
        [
            113.13795879461,
            23.315459204081
        ],
        [
            113.13796473911,
            23.31540912503
        ],
        [
            113.13795365338,
            23.315288484313
        ],
        [
            113.13793418784,
            23.315157928682
        ],
        [
            113.1379195868,
            23.315035326217
        ],
        [
            113.13791309109,
            23.314877060059
        ],
        [
            113.13792362834,
            23.314821094471
        ],
        [
            113.1379284912,
            23.314788628476
        ],
        [
            113.13795821984,
            23.314762030147
        ],
        [
            113.13799632823,
            23.31475267083
        ],
        [
            113.13805146395,
            23.314741443965
        ],
        [
            113.13814092528,
            23.314735167261
        ],
        [
            113.13816362819,
            23.314729331467
        ],
        [
            113.1382068714,
            23.314712195912
        ],
        [
            113.13824633121,
            23.314701503501
        ],
        [
            113.13828984482,
            23.314685457527
        ],
        [
            113.1383257912,
            23.314676872618
        ],
        [
            113.13837903497,
            23.314662084143
        ],
        [
            113.13843660396,
            23.314657137924
        ],
        [
            113.13850038942,
            23.314651759127
        ],
        [
            113.13854741824,
            23.314654763452
        ],
        [
            113.13861742271,
            23.314682589293
        ],
        [
            113.13868580486,
            23.314700620114
        ],
        [
            113.13875391583,
            23.314704810807
        ],
        [
            113.13879364718,
            23.314705785757
        ],
        [
            113.13885445894,
            23.314685160759
        ],
        [
            113.1389017577,
            23.314678402312
        ],
        [
            113.1389714885,
            23.314652508885
        ],
        [
            113.13902635524,
            23.31464506978
        ],
        [
            113.13909932919,
            23.314613807172
        ],
        [
            113.13918041237,
            23.314590825249
        ],
        [
            113.1392620361,
            23.314565681829
        ],
        [
            113.13931582091,
            23.314543572907
        ],
        [
            113.13935176895,
            23.314545834701
        ],
        [
            113.13940123121,
            23.314547249522
        ],
        [
            113.13946231751,
            23.314569756762
        ],
        [
            113.13954935102,
            23.314587837558
        ],
        [
            113.13960719471,
            23.314618153259
        ],
        [
            113.13968558423,
            23.314701727752
        ],
        [
            113.13974586284,
            23.314764366266
        ],
        [
            113.13986858218,
            23.314890764494
        ],
        [
            113.1399485923,
            23.314963513108
        ],
        [
            113.13997805377,
            23.314961046018
        ],
        [
            113.1400377877,
            23.314956396883
        ],
        [
            113.1400702217,
            23.314940960458
        ],
        [
            113.14007913865,
            23.31489744217
        ],
        [
            113.14009697295,
            23.314820713794
        ],
        [
            113.14009750643,
            23.314717911444
        ],
        [
            113.14010452714,
            23.314625530959
        ],
        [
            113.14011100947,
            23.314565964808
        ],
        [
            113.14012587196,
            23.314522279166
        ],
        [
            113.14015830172,
            23.31445991208
        ],
        [
            113.14018749035,
            23.314426242858
        ],
        [
            113.14021262537,
            23.314401725778
        ],
        [
            113.14024938288,
            23.314376326827
        ],
        [
            113.14030938543,
            23.314348621345
        ],
        [
            113.14039398375,
            23.314309408882
        ],
        [
            113.14045398791,
            23.314296350482
        ],
        [
            113.14051453176,
            23.314272449907
        ],
        [
            113.14058399507,
            23.314244092453
        ],
        [
            113.14064967277,
            23.314199663017
        ],
        [
            113.14077319231,
            23.314135622274
        ],
        [
            113.14086806264,
            23.314091697452
        ],
        [
            113.1409518525,
            23.314062227161
        ],
        [
            113.14106348345,
            23.314030525157
        ],
        [
            113.14115754641,
            23.314009638538
        ],
        [
            113.14125214972,
            23.313983062513
        ],
        [
            113.14134891605,
            23.313958149393
        ],
        [
            113.14144784566,
            23.313936797906
        ],
        [
            113.14153353111,
            23.313919556398
        ],
        [
            113.1415529933,
            23.313919620207
        ],
        [
            113.14163462409,
            23.313898508943
        ],
        [
            113.14164056643,
            23.313860632826
        ],
        [
            113.14164649286,
            23.313695257717
        ],
        [
            113.1416540495,
            23.313602883146
        ],
        [
            113.14165106742,
            23.313538268593
        ],
        [
            113.1416529561,
            23.313512801261
        ],
        [
            113.14167376583,
            23.313483047452
        ],
        [
            113.14172214782,
            23.313457836224
        ],
        [
            113.14178836778,
            23.313413941226
        ],
        [
            113.14181188328,
            23.313402679761
        ],
        [
            113.14186080872,
            23.313395380256
        ],
        [
            113.14192189707,
            23.31337906504
        ],
        [
            113.14201272114,
            23.313369225391
        ],
        [
            113.14215112114,
            23.313358025258
        ],
        [
            113.14222815938,
            23.313343062163
        ],
        [
            113.14234169147,
            23.313330888431
        ],
        [
            113.14240224238,
            23.313325407054
        ],
        [
            113.14244305869,
            23.313310908841
        ],
        [
            113.14246387119,
            23.313295799439
        ],
        [
            113.14251008805,
            23.313241514625
        ],
        [
            113.1425444064,
            23.313159899979
        ],
        [
            113.14256007154,
            23.313074442339
        ],
        [
            113.14257518831,
            23.312945028548
        ],
        [
            113.14259301664,
            23.312868559331
        ],
        [
            113.14260733137,
            23.312797184733
        ],
        [
            113.14262732236,
            23.31272427843
        ],
        [
            113.14264596212,
            23.312654875695
        ],
        [
            113.14267974009,
            23.312586813905
        ],
        [
            113.1427135143,
            23.312500033532
        ],
        [
            113.14275404245,
            23.312393563527
        ],
        [
            113.14278808521,
            23.31230163248
        ],
        [
            113.142832129,
            23.312206343031
        ],
        [
            113.14285184686,
            23.312129632439
        ],
        [
            113.14287048293,
            23.312052089605
        ],
        [
            113.14290560265,
            23.311946882503
        ],
        [
            113.14293423891,
            23.311863539401
        ],
        [
            113.14294990173,
            23.311791914003
        ],
        [
            113.14299124395,
            23.311713124491
        ],
        [
            113.14303959784,
            23.311564461991
        ],
        [
            113.14307229529,
            23.311512382746
        ],
        [
            113.14309039975,
            23.311480675569
        ],
        [
            113.14311391172,
            23.311452585628
        ],
        [
            113.14313391096,
            23.311430947331
        ],
        [
            113.14317364628,
            23.311416421639
        ],
        [
            113.14323824917,
            23.311388747646
        ],
        [
            113.14325987378,
            23.311380157177
        ],
        [
            113.14333259004,
            23.311364281946
        ],
        [
            113.14338259965,
            23.311353723056
        ],
        [
            113.1434639703,
            23.311349654119
        ],
        [
            113.14356588859,
            23.31135080768
        ],
        [
            113.14365023323,
            23.3113435277
        ],
        [
            113.14371267701,
            23.311322318337
        ],
        [
            113.14378755978,
            23.311312435992
        ],
        [
            113.14385162629,
            23.311291521733
        ],
        [
            113.14391650579,
            23.311277130172
        ],
        [
            113.14400328337,
            23.311260927648
        ],
        [
            113.14404843009,
            23.311254617624
        ],
        [
            113.14411169056,
            23.311248604572
        ],
        [
            113.14423767499,
            23.311249315481
        ],
        [
            113.14433662321,
            23.311243067887
        ],
        [
            113.14442070231,
            23.311236031474
        ],
        [
            113.14451937875,
            23.311218921393
        ],
        [
            113.14462454586,
            23.311206524764
        ],
        [
            113.14471808565,
            23.311184440638
        ],
        [
            113.14481703131,
            23.311154302028
        ],
        [
            113.14492976541,
            23.311120041316
        ],
        [
            113.1450016774,
            23.311096512818
        ],
        [
            113.14511008371,
            23.311049424027
        ],
        [
            113.14519064223,
            23.311002155927
        ],
        [
            113.14525470787,
            23.310953536398
        ],
        [
            113.14533255499,
            23.310876107885
        ],
        [
            113.14539878657,
            23.31083620001
        ],
        [
            113.14545798259,
            23.310775289687
        ],
        [
            113.14550501179,
            23.310715269785
        ],
        [
            113.14553744364,
            23.310666682483
        ],
        [
            113.14558689905,
            23.310582012642
        ],
        [
            113.14562878415,
            23.310499392135
        ],
        [
            113.14567256429,
            23.310425210534
        ],
        [
            113.14571526584,
            23.310361048494
        ],
        [
            113.14577310846,
            23.310294954087
        ],
        [
            113.14583446767,
            23.310233525331
        ],
        [
            113.14593314391,
            23.31018109061
        ],
        [
            113.14606155333,
            23.310094120993
        ],
        [
            113.14617158232,
            23.310024219644
        ],
        [
            113.1462697161,
            23.309959011011
        ],
        [
            113.14639137424,
            23.309889550455
        ],
        [
            113.14649465276,
            23.309840688247
        ],
        [
            113.1466103688,
            23.309785230224
        ],
        [
            113.14669904858,
            23.309741016522
        ],
        [
            113.14675501194,
            23.309705522017
        ],
        [
            113.14679258921,
            23.309675441861
        ],
        [
            113.1468125869,
            23.309637496405
        ],
        [
            113.14681932947,
            23.30958578396
        ],
        [
            113.14681118662,
            23.309498305586
        ],
        [
            113.14679222723,
            23.309412018133
        ],
        [
            113.14676217709,
            23.309316065666
        ],
        [
            113.14672429217,
            23.309240881652
        ],
        [
            113.14669966805,
            23.309195199277
        ],
        [
            113.14667369253,
            23.309151394853
        ],
        [
            113.14666393739,
            23.309096173907
        ],
        [
            113.14665175103,
            23.309047968995
        ],
        [
            113.14665227493,
            23.309002672147
        ],
        [
            113.14666523676,
            23.308955124721
        ],
        [
            113.14667766805,
            23.308934969043
        ],
        [
            113.14670740145,
            23.308903684631
        ],
        [
            113.14677715367,
            23.308866230343
        ],
        [
            113.14686529437,
            23.308828240503
        ],
        [
            113.14696371706,
            23.308804238957
        ],
        [
            113.14705700087,
            23.308775542848
        ],
        [
            113.14714109989,
            23.308769491702
        ],
        [
            113.1471989702,
            23.308768195763
        ],
        [
            113.14720816943,
            23.308780542538
        ],
        [
            113.14721872696,
            23.308808915718
        ],
        [
            113.14719332057,
            23.308844342241
        ],
        [
            113.14717738117,
            23.308885337199
        ],
        [
            113.14716685268,
            23.308932924674
        ],
        [
            113.14715632685,
            23.308987836859
        ],
        [
            113.14717826377,
            23.309074980122
        ],
        [
            113.14721914039,
            23.309190080079
        ],
        [
            113.14725676708,
            23.309293193526
        ],
        [
            113.14732550742,
            23.309438009529
        ],
        [
            113.14736556619,
            23.309538444377
        ],
        [
            113.14738154599,
            23.309608947113
        ],
        [
            113.14738860048,
            23.309676874253
        ],
        [
            113.14740159627,
            23.309721288611
        ],
        [
            113.14741459662,
            23.309779538464
        ],
        [
            113.14743679589,
            23.309850947639
        ],
        [
            113.14746953714,
            23.30990813615
        ],
        [
            113.14751742698,
            23.309978572015
        ],
        [
            113.14755530346,
            23.310026612036
        ],
        [
            113.14761021539,
            23.310068122855
        ],
        [
            113.14763997209,
            23.31009488014
        ],
        [
            113.14766837163,
            23.310105882324
        ],
        [
            113.14771245465,
            23.310110334681
        ],
        [
            113.14775464531,
            23.310116385704
        ],
        [
            113.14785335169,
            23.310100211607
        ],
        [
            113.14788850547,
            23.31008770848
        ],
        [
            113.14791637242,
            23.310122300842
        ],
        [
            113.14793802639,
            23.310179860508
        ],
        [
            113.14797996738,
            23.310248840693
        ],
        [
            113.148025967,
            23.310324118955
        ],
        [
            113.14805707611,
            23.310348176655
        ],
        [
            113.14808574766,
            23.310360532973
        ],
        [
            113.14811604575,
            23.31038512038
        ],
        [
            113.14815959319,
            23.310400134523
        ],
        [
            113.14819691861,
            23.310409360013
        ],
        [
            113.14825263426,
            23.310415596939
        ],
        [
            113.14829266028,
            23.310410481758
        ],
        [
            113.14834999168,
            23.310391781136
        ],
        [
            113.14846492425,
            23.310348681421
        ],
        [
            113.14851657324,
            23.310317957065
        ],
        [
            113.14857390676,
            23.310301690947
        ],
        [
            113.14862042062,
            23.310281198588
        ],
        [
            113.14867153727,
            23.310275420233
        ],
        [
            113.14871237131,
            23.310253487747
        ],
        [
            113.1487615911,
            23.310234658079
        ],
        [
            113.14879539473,
            23.310217506491
        ],
        [
            113.14882243908,
            23.310208125317
        ],
        [
            113.14886950147,
            23.31020770925
        ],
        [
            113.14890439561,
            23.310216614317
        ],
        [
            113.14895336007,
            23.31024253752
        ],
        [
            113.14899502392,
            23.310275138287
        ],
        [
            113.14903505879,
            23.310287640078
        ],
        [
            113.14907834006,
            23.310301543092
        ],
        [
            113.14910457769,
            23.310304353979
        ],
        [
            113.14917571174,
            23.310294230668
        ],
        [
            113.14923466892,
            23.310266300626
        ],
        [
            113.14928416639,
            23.310260753036
        ],
        [
            113.14935016828,
            23.310268726848
        ],
        [
            113.14941969142,
            23.310290582477
        ],
        [
            113.14945242411,
            23.310300260316
        ],
        [
            113.14948677948,
            23.310308603573
        ],
        [
            113.14951328628,
            23.310303002135
        ],
        [
            113.1495719801,
            23.310290248677
        ],
        [
            113.14961877324,
            23.31028031349
        ],
        [
            113.14967909073,
            23.310267307356
        ],
        [
            113.14976781456,
            23.31026391149
        ],
        [
            113.14984977394,
            23.310251737625
        ],
        [
            113.14994553004,
            23.310239204421
        ],
        [
            113.14999719241,
            23.310222542539
        ],
        [
            113.1500328871,
            23.310181518979
        ],
        [
            113.15003611781,
            23.310133002786
        ],
        [
            113.15003150619,
            23.310092790381
        ],
        [
            113.15000037527,
            23.31002481943
        ],
        [
            113.14996058544,
            23.309949405751
        ],
        [
            113.1498877739,
            23.309815487117
        ],
        [
            113.14979925568,
            23.309631705398
        ],
        [
            113.14971697144,
            23.309485170284
        ],
        [
            113.14969828279,
            23.309417363775
        ],
        [
            113.14968257639,
            23.30936885928
        ],
        [
            113.1496733555,
            23.309302538807
        ],
        [
            113.14969065123,
            23.309257471439
        ],
        [
            113.1497509643,
            23.309232797179
        ],
        [
            113.14983832244,
            23.309191941238
        ],
        [
            113.14995435453,
            23.309148485733
        ],
        [
            113.15002008011,
            23.309124960186
        ],
        [
            113.15013178994,
            23.309090928675
        ],
        [
            113.15018372506,
            23.309079690092
        ],
        [
            113.15018588841,
            23.309077548837
        ],
        [
            113.15022186952,
            23.309083185877
        ],
        [
            113.15027598013,
            23.309100729906
        ],
        [
            113.15032604699,
            23.309155384491
        ],
        [
            113.15040807868,
            23.309327386963
        ],
        [
            113.15049825726,
            23.30958983092
        ],
        [
            113.15057110056,
            23.309796155949
        ],
        [
            113.15059790692,
            23.309866771942
        ],
        [
            113.15061984743,
            23.309949259973
        ],
        [
            113.15063392247,
            23.309971419092
        ],
        [
            113.15065475477,
            23.309974948177
        ],
        [
            113.15070399014,
            23.309968540476
        ],
        [
            113.15080326628,
            23.309934028159
        ],
        [
            113.15089550671,
            23.309891008411
        ],
        [
            113.15095718041,
            23.309859795866
        ],
        [
            113.15103724544,
            23.309809556695
        ],
        [
            113.15114165827,
            23.309751758331
        ],
        [
            113.15120577006,
            23.309724365042
        ],
        [
            113.15126907162,
            23.309699671594
        ],
        [
            113.15137998899,
            23.309665541549
        ],
        [
            113.15147007713,
            23.309639008326
        ],
        [
            113.15151309253,
            23.309626256761
        ],
        [
            113.15154366299,
            23.309616060661
        ],
        [
            113.15156502761,
            23.309586758538
        ],
        [
            113.15159341175,
            23.309513866962
        ],
        [
            113.15161043581,
            23.309452226768
        ],
        [
            113.15163748161,
            23.309420824322
        ],
        [
            113.15168536041,
            23.309386425616
        ],
        [
            113.15176705722,
            23.309340779865
        ],
        [
            113.15185470965,
            23.309300900143
        ],
        [
            113.151985923,
            23.309250426919
        ],
        [
            113.15207952956,
            23.309207080011
        ],
        [
            113.15215285152,
            23.309186811643
        ],
        [
            113.15219695307,
            23.309174053331
        ],
        [
            113.15223212839,
            23.309169595721
        ],
        [
            113.15226379126,
            23.309178930522
        ],
        [
            113.15229545906,
            23.309201286463
        ],
        [
            113.15235799628,
            23.309281796519
        ],
        [
            113.15247441328,
            23.309445960595
        ],
        [
            113.15251014743,
            23.309487078968
        ],
        [
            113.1525445167,
            23.309494269475
        ],
        [
            113.15257238716,
            23.309488902997
        ],
        [
            113.15260756482,
            23.309485521407
        ],
        [
            113.15268467604,
            23.309450892681
        ],
        [
            113.15279155378,
            23.309411182481
        ],
        [
            113.15287245285,
            23.309368991787
        ],
        [
            113.15295038232,
            23.309344395664
        ],
        [
            113.15302669175,
            23.309327643846
        ],
        [
            113.15310841211,
            23.309304167771
        ],
        [
            113.15318851261,
            23.309288807018
        ],
        [
            113.15325345505,
            23.309263774408
        ],
        [
            113.15330812175,
            23.309260054064
        ],
        [
            113.15338388918,
            23.30923052601
        ],
        [
            113.15344964816,
            23.309213089403
        ],
        [
            113.15350133377,
            23.309194135859
        ],
        [
            113.15355816143,
            23.309173609956
        ],
        [
            113.15358846685,
            23.309154957256
        ],
        [
            113.15359739228,
            23.309139050555
        ],
        [
            113.15359792155,
            23.309106773258
        ],
        [
            113.15359573247,
            23.309042996397
        ],
        [
            113.1535876066,
            23.309025814929
        ],
        [
            113.15356134575,
            23.30900409087
        ],
        [
            113.15354726341,
            23.30898087445
        ],
        [
            113.15349881158,
            23.308963513414
        ],
        [
            113.15341842887,
            23.308957457304
        ],
        [
            113.15334264723,
            23.308949549491
        ],
        [
            113.15321626325,
            23.30895489763
        ],
        [
            113.15306200985,
            23.308967238717
        ],
        [
            113.15296323874,
            23.308984004031
        ],
        [
            113.15288584733,
            23.308999383447
        ],
        [
            113.15282523676,
            23.309019566453
        ],
        [
            113.15276651998,
            23.309037056164
        ],
        [
            113.15271457154,
            23.309061405162
        ],
        [
            113.15264746756,
            23.309080961659
        ],
        [
            113.15258225572,
            23.309093212644
        ],
        [
            113.15253868623,
            23.309087812824
        ],
        [
            113.15249159378,
            23.309067991514
        ],
        [
            113.15247020378,
            23.309034910919
        ],
        [
            113.15244773568,
            23.309013211198
        ],
        [
            113.15244231081,
            23.308979235503
        ],
        [
            113.15242658978,
            23.308910411945
        ],
        [
            113.15242793259,
            23.308883841798
        ],
        [
            113.15243766372,
            23.308856557992
        ],
        [
            113.15245902527,
            23.308815305926
        ],
        [
            113.15249717024,
            23.308789716799
        ],
        [
            113.15253801765,
            23.30875439237
        ],
        [
            113.15262622443,
            23.308726680446
        ],
        [
            113.15277558355,
            23.308680690087
        ],
        [
            113.15295146509,
            23.308630922048
        ],
        [
            113.15309759001,
            23.308601137377
        ],
        [
            113.15328214149,
            23.308555225257
        ],
        [
            113.15339931229,
            23.308518569141
        ],
        [
            113.15353813974,
            23.308489740962
        ],
        [
            113.15364909293,
            23.308460318914
        ],
        [
            113.15374759903,
            23.308433735078
        ],
        [
            113.1538168812,
            23.308420660025
        ],
        [
            113.153889954,
            23.308409250482
        ],
        [
            113.15395815544,
            23.30839724156
        ],
        [
            113.15402933735,
            23.308391229724
        ],
        [
            113.15406993211,
            23.308378916794
        ],
        [
            113.15410023769,
            23.308356725717
        ],
        [
            113.15412268871,
            23.308321699117
        ],
        [
            113.15412916661,
            23.308277819699
        ],
        [
            113.15413266852,
            23.308237435099
        ],
        [
            113.15415025474,
            23.308219989668
        ],
        [
            113.15418001861,
            23.308196434497
        ],
        [
            113.1542419938,
            23.308175663293
        ],
        [
            113.15427691319,
            23.308181460076
        ],
        [
            113.15437814646,
            23.308181716531
        ],
        [
            113.15447749165,
            23.308194153538
        ],
        [
            113.1545779159,
            23.308194114941
        ],
        [
            113.15471299461,
            23.308204191815
        ],
        [
            113.15479230663,
            23.308200392825
        ],
        [
            113.1548900261,
            23.308193791686
        ],
        [
            113.15498910391,
            23.308195064278
        ],
        [
            113.15509738152,
            23.308182314103
        ],
        [
            113.15518752399,
            23.308171545487
        ],
        [
            113.1553109571,
            23.308139394633
        ],
        [
            113.15540136784,
            23.308115591697
        ],
        [
            113.15553184073,
            23.308075620673
        ],
        [
            113.15568126675,
            23.308033375328
        ],
        [
            113.15580361918,
            23.307984075031
        ],
        [
            113.15591676958,
            23.307937118522
        ],
        [
            113.15600203248,
            23.307885010294
        ],
        [
            113.15607403506,
            23.307845524784
        ],
        [
            113.15617175717,
            23.307798945486
        ],
        [
            113.15619964151,
            23.30779051861
        ],
        [
            113.15622129072,
            23.307764400491
        ],
        [
            113.15622939797,
            23.307729206363
        ],
        [
            113.15621855061,
            23.307690855659
        ],
        [
            113.15619009475,
            23.307631997508
        ],
        [
            113.15617220233,
            23.307581916551
        ],
        [
            113.15617082911,
            23.307538768643
        ],
        [
            113.15617731812,
            23.307518481038
        ],
        [
            113.15620600259,
            23.307483474708
        ],
        [
            113.15624118269,
            23.307442558279
        ],
        [
            113.1563007326,
            23.307404031518
        ],
        [
            113.15637815265,
            23.307363491958
        ],
        [
            113.15643175321,
            23.307338741392
        ],
        [
            113.15646233361,
            23.307302932108
        ],
        [
            113.15648776123,
            23.307249442297
        ],
        [
            113.15650290172,
            23.307200744014
        ],
        [
            113.15650313364,
            23.307118001811
        ],
        [
            113.15651583664,
            23.307068739104
        ],
        [
            113.15652692201,
            23.307034383044
        ],
        [
            113.15655263644,
            23.307015348513
        ],
        [
            113.15662707963,
            23.306973139127
        ],
        [
            113.15673834792,
            23.306926633291
        ],
        [
            113.15682580216,
            23.306907584552
        ],
        [
            113.15692355038,
            23.30689404321
        ],
        [
            113.15702482266,
            23.306884864466
        ],
        [
            113.1571523667,
            23.306880508556
        ],
        [
            113.15728126977,
            23.306880762375
        ],
        [
            113.15737929844,
            23.306871527262
        ],
        [
            113.15748139588,
            23.30687235483
        ],
        [
            113.15759541091,
            23.306872454845
        ],
        [
            113.15770075813,
            23.306865150794
        ],
        [
            113.15781342172,
            23.306861963822
        ],
        [
            113.15790441757,
            23.306852630888
        ],
        [
            113.15799352738,
            23.306860639371
        ],
        [
            113.15806421699,
            23.306860091682
        ],
        [
            113.15810782335,
            23.306860692426
        ],
        [
            113.15815087835,
            23.306840669108
        ],
        [
            113.15817064339,
            23.306826438617
        ],
        [
            113.15817714155,
            23.306821875235
        ],
        [
            113.15818851148,
            23.306810023278
        ],
        [
            113.15819768265,
            23.306732772985
        ],
        [
            113.15818868798,
            23.306617948443
        ],
        [
            113.15818483928,
            23.306503976052
        ],
        [
            113.15818371781,
            23.306428276472
        ],
        [
            113.15817418882,
            23.306331081679
        ],
        [
            113.1581817552,
            23.306296955081
        ],
        [
            113.15816249552,
            23.306239567712
        ],
        [
            113.15812073276,
            23.306138332312
        ],
        [
            113.15811014323,
            23.30608724902
        ],
        [
            113.15810794531,
            23.306027547418
        ],
        [
            113.15810494921,
            23.305995511936
        ],
        [
            113.15811685681,
            23.305977153529
        ],
        [
            113.15814582888,
            23.305960822246
        ],
        [
            113.15820810561,
            23.305925476867
        ],
        [
            113.15827174527,
            23.305905330843
        ],
        [
            113.15835786832,
            23.30588805921
        ],
        [
            113.15842124969,
            23.305888521692
        ],
        [
            113.15847325472,
            23.305887542122
        ],
        [
            113.15853311221,
            23.305880648089
        ],
        [
            113.15856317569,
            23.305875437462
        ],
        [
            113.15857427758,
            23.30586846307
        ],
        [
            113.15859294943,
            23.305834412896
        ],
        [
            113.15861107404,
            23.305790049261
        ],
        [
            113.15861562792,
            23.305695127849
        ],
        [
            113.15862236954,
            23.305639288604
        ],
        [
            113.15863995446,
            23.305599261358
        ],
        [
            113.15865591486,
            23.305560578834
        ],
        [
            113.1586862298,
            23.305518741699
        ],
        [
            113.1587398356,
            23.305468656739
        ],
        [
            113.15879047691,
            23.305445407105
        ],
        [
            113.15882567584,
            23.305417436401
        ],
        [
            113.15883677271,
            23.305400692736
        ],
        [
            113.15884597431,
            23.305385563661
        ],
        [
            113.15884568466,
            23.305351649481
        ],
        [
            113.15883780287,
            23.305304389255
        ],
        [
            113.15880878408,
            23.305242332436
        ],
        [
            113.15879441513,
            23.305220257546
        ],
        [
            113.15874319075,
            23.305169439024
        ],
        [
            113.1587022641,
            23.3051260157
        ],
        [
            113.15864128323,
            23.305065086008
        ],
        [
            113.15859168726,
            23.305018070468
        ],
        [
            113.15856945167,
            23.304975318025
        ],
        [
            113.1585569807,
            23.304955966699
        ],
        [
            113.15854720613,
            23.304915201972
        ],
        [
            113.15854934189,
            23.304860957556
        ],
        [
            113.15856961582,
            23.30478975098
        ],
        [
            113.15858176825,
            23.30472662508
        ],
        [
            113.15861341973,
            23.304657669138
        ],
        [
            113.15863451065,
            23.304594606086
        ],
        [
            113.1586401779,
            23.304558834727
        ],
        [
            113.1586469281,
            23.304522257094
        ],
        [
            113.15864173908,
            23.304450597292
        ],
        [
            113.15864304429,
            23.304368131425
        ],
        [
            113.15863566022,
            23.304250606258
        ],
        [
            113.15862531096,
            23.304157748222
        ],
        [
            113.15861714868,
            23.30409827551
        ],
        [
            113.15861574758,
            23.304021758816
        ],
        [
            113.15863008564,
            23.303992288796
        ],
        [
            113.15864116255,
            23.303945432256
        ],
        [
            113.15865793157,
            23.303904855748
        ],
        [
            113.15870800727,
            23.303846878819
        ],
        [
            113.15876728959,
            23.303783266609
        ],
        [
            113.1588189763,
            23.303701421551
        ],
        [
            113.15886525799,
            23.303639341928
        ],
        [
            113.15890260462,
            23.303583439139
        ],
        [
            113.15893589013,
            23.303530763022
        ],
        [
            113.15896348655,
            23.303477233329
        ],
        [
            113.15897672621,
            23.303424148139
        ],
        [
            113.15899375372,
            23.303364034594
        ],
        [
            113.15898966253,
            23.303320598508
        ],
        [
            113.15899124227,
            23.303249799308
        ],
        [
            113.15897738428,
            23.303183778777
        ],
        [
            113.15896516807,
            23.303143271665
        ],
        [
            113.15893885683,
            23.303089103172
        ],
        [
            113.15890550932,
            23.303045195372
        ],
        [
            113.15886321708,
            23.302992543315
        ],
        [
            113.15882770064,
            23.302945362666
        ],
        [
            113.15880898894,
            23.30291349057
        ],
        [
            113.15879405469,
            23.302859126251
        ],
        [
            113.15876936205,
            23.302794655518
        ],
        [
            113.15875741109,
            23.302746008843
        ],
        [
            113.15873789651,
            23.302728780341
        ],
        [
            113.15869806737,
            23.302713036673
        ],
        [
            113.15867504355,
            23.302713688471
        ],
        [
            113.15864173498,
            23.30272674701
        ],
        [
            113.15860463603,
            23.302742219378
        ],
        [
            113.15852283541,
            23.302744347834
        ],
        [
            113.1584256069,
            23.302761551584
        ],
        [
            113.15836034297,
            23.302781423412
        ],
        [
            113.15826744764,
            23.302793762292
        ],
        [
            113.15821463982,
            23.302806392929
        ],
        [
            113.15815884486,
            23.302806518871
        ],
        [
            113.15812931926,
            23.302801685157
        ],
        [
            113.15804669398,
            23.302775287405
        ],
        [
            113.15796515774,
            23.302755674796
        ],
        [
            113.15791070313,
            23.302731381984
        ],
        [
            113.1578792737,
            23.302712690892
        ],
        [
            113.15784973501,
            23.302686145825
        ],
        [
            113.15782559605,
            23.302634139469
        ],
        [
            113.15780198742,
            23.302565315905
        ],
        [
            113.15778782034,
            23.302441219558
        ],
        [
            113.15778019742,
            23.302382829669
        ],
        [
            113.15776927128,
            23.302246820842
        ],
        [
            113.15775832866,
            23.302088022046
        ],
        [
            113.15774878972,
            23.30200167239
        ],
        [
            113.15772591634,
            23.301824601983
        ],
        [
            113.15772337322,
            23.301674821395
        ],
        [
            113.15771737976,
            23.301625125348
        ],
        [
            113.15771735005,
            23.301583344029
        ],
        [
            113.15770134622,
            23.30154821963
        ],
        [
            113.1576772195,
            23.30151574395
        ],
        [
            113.1576287199,
            23.301484973709
        ],
        [
            113.15758348144,
            23.301469420644
        ],
        [
            113.15752064641,
            23.301462677835
        ],
        [
            113.15743344518,
            23.301464959007
        ],
        [
            113.15738036532,
            23.301464256561
        ],
        [
            113.15734922963,
            23.30147485481
        ],
        [
            113.1572899326,
            23.301489019387
        ],
        [
            113.15719461803,
            23.301501526153
        ],
        [
            113.15708955232,
            23.301508517554
        ],
        [
            113.15691273942,
            23.301530625616
        ],
        [
            113.15677952099,
            23.301543047133
        ],
        [
            113.15662815344,
            23.30154145862
        ],
        [
            113.15649927257,
            23.30155225983
        ],
        [
            113.15634142223,
            23.301562515977
        ],
        [
            113.15624611471,
            23.301563554035
        ],
        [
            113.15611749943,
            23.301555597797
        ],
        [
            113.15600811055,
            23.301548349167
        ],
        [
            113.15596830873,
            23.301545809362
        ],
        [
            113.15594069158,
            23.30154446711
        ],
        [
            113.15590710343,
            23.301522449242
        ],
        [
            113.15588596837,
            23.301498647975
        ],
        [
            113.15587863864,
            23.301471177464
        ],
        [
            113.15587292656,
            23.301434226364
        ],
        [
            113.15587560986,
            23.301400609589
        ],
        [
            113.15588913602,
            23.301385271818
        ],
        [
            113.15590508955,
            23.301356933904
        ],
        [
            113.15591618079,
            23.301344014831
        ],
        [
            113.1559521791,
            23.301328886002
        ],
        [
            113.15598493527,
            23.30132295045
        ],
        [
            113.15602066636,
            23.301312158066
        ],
        [
            113.15607724275,
            23.301297487199
        ],
        [
            113.15615086283,
            23.30126289317
        ],
        [
            113.15625858298,
            23.301205543259
        ],
        [
            113.15633653405,
            23.30116636524
        ],
        [
            113.15637442518,
            23.301144458555
        ],
        [
            113.15638146,
            23.301137467666
        ],
        [
            113.15636547741,
            23.301127285959
        ],
        [
            113.15628229462,
            23.301047314953
        ],
        [
            113.1562356891,
            23.300999956538
        ],
        [
            113.15619503418,
            23.300943968791
        ],
        [
            113.15615166924,
            23.300884427915
        ],
        [
            113.15610042403,
            23.300786287509
        ],
        [
            113.15605892278,
            23.300683893924
        ],
        [
            113.15603421698,
            23.300593591767
        ],
        [
            113.156017374,
            23.30051828379
        ],
        [
            113.15598612882,
            23.300373658468
        ],
        [
            113.15594624903,
            23.30026829152
        ],
        [
            113.15592452015,
            23.300177472048
        ],
        [
            113.15591390684,
            23.300106561509
        ],
        [
            113.15590302221,
            23.300035105694
        ],
        [
            113.1558864505,
            23.299961968678
        ],
        [
            113.15586552635,
            23.299862473649
        ],
        [
            113.15585219458,
            23.299778242807
        ],
        [
            113.15584049193,
            23.299700267195
        ],
        [
            113.15581878009,
            23.29963304962
        ],
        [
            113.15580085025,
            23.299555286238
        ],
        [
            113.15578102806,
            23.299481303026
        ],
        [
            113.15577284845,
            23.299408514785
        ],
        [
            113.1557568129,
            23.299330225945
        ],
        [
            113.1557424122,
            23.299265246538
        ],
        [
            113.15573341275,
            23.29918349694
        ],
        [
            113.15572225304,
            23.299109052111
        ],
        [
            113.15571027289,
            23.299024560873
        ],
        [
            113.15570751292,
            23.298959148849
        ],
        [
            113.15568852586,
            23.298915016001
        ],
        [
            113.15566328882,
            23.298842335653
        ],
        [
            113.15564325614,
            23.298844314937
        ],
        [
            113.15560373992,
            23.298857502377
        ],
        [
            113.15547679336,
            23.298888565382
        ],
        [
            113.15534551432,
            23.298915232354
        ],
        [
            113.15519095996,
            23.298945996424
        ],
        [
            113.15506347288,
            23.298967788468
        ],
        [
            113.15500554517,
            23.298972091128
        ],
        [
            113.15493164314,
            23.298972160171
        ],
        [
            113.15487263492,
            23.298977802517
        ],
        [
            113.15481633053,
            23.298978857481
        ],
        [
            113.15479791515,
            23.298968902408
        ],
        [
            113.15478544664,
            23.298948426765
        ],
        [
            113.15478921127,
            23.298917264549
        ],
        [
            113.15480542076,
            23.29887727613
        ],
        [
            113.15487303765,
            23.29880606712
        ],
        [
            113.15498961464,
            23.298688411408
        ],
        [
            113.15507400534,
            23.298602981021
        ],
        [
            113.15516382966,
            23.298540117836
        ],
        [
            113.15525958554,
            23.298446377328
        ],
        [
            113.15533721765,
            23.298368730935
        ],
        [
            113.15540672968,
            23.298292085981
        ],
        [
            113.15546649972,
            23.298219683808
        ],
        [
            113.15552789589,
            23.298148922344
        ],
        [
            113.15558170997,
            23.2980756433
        ],
        [
            113.15566203622,
            23.297978468284
        ],
        [
            113.15571180571,
            23.297923865587
        ],
        [
            113.15573180235,
            23.297878746204
        ],
        [
            113.15574801365,
            23.297839559526
        ],
        [
            113.15576176793,
            23.297776202587
        ],
        [
            113.15576819538,
            23.297692970418
        ],
        [
            113.15576892925,
            23.297600459738
        ],
        [
            113.15575831945,
            23.297540399285
        ],
        [
            113.15574336432,
            23.29746456142
        ],
        [
            113.15573897252,
            23.297394249746
        ],
        [
            113.15571482524,
            23.297333789196
        ],
        [
            113.15569095776,
            23.297283912043
        ],
        [
            113.15566222871,
            23.297247553738
        ],
        [
            113.15562807899,
            23.2972040888
        ],
        [
            113.15557604703,
            23.297144172509
        ],
        [
            113.15554162248,
            23.297095547627
        ],
        [
            113.15552102448,
            23.297069302978
        ],
        [
            113.1555107065,
            23.297034203946
        ],
        [
            113.15551067222,
            23.296994591831
        ],
        [
            113.15552740172,
            23.296930451914
        ],
        [
            113.15554901634,
            23.296880195789
        ],
        [
            113.15558687468,
            23.296829823937
        ],
        [
            113.15563636316,
            23.296766267749
        ],
        [
            113.15571590999,
            23.296710049483
        ],
        [
            113.15580195819,
            23.296656871931
        ],
        [
            113.1558899113,
            23.296613473614
        ],
        [
            113.15593917397,
            23.296598739912
        ],
        [
            113.15597409204,
            23.296589297406
        ],
        [
            113.15598790125,
            23.296590510849
        ],
        [
            113.15599384586,
            23.296577000267
        ],
        [
            113.15599625783,
            23.296548805935
        ],
        [
            113.15598675557,
            23.29651914454
        ],
        [
            113.15596424918,
            23.296480137558
        ],
        [
            113.15595420637,
            23.296451556139
        ],
        [
            113.15594794781,
            23.29641595569
        ],
        [
            113.15595467677,
            23.296370980087
        ],
        [
            113.15596276351,
            23.29633062941
        ],
        [
            113.15599819192,
            23.29628592004
        ],
        [
            113.15604903583,
            23.296221546019
        ],
        [
            113.15609611262,
            23.296183181522
        ],
        [
            113.1561461729,
            23.296150268841
        ],
        [
            113.15618838032,
            23.296115926001
        ],
        [
            113.15622732291,
            23.296063645268
        ],
        [
            113.15625704303,
            23.29599255902
        ],
        [
            113.15627973909,
            23.295939044031
        ],
        [
            113.15630296039,
            23.295867355219
        ],
        [
            113.15632374037,
            23.295790760278
        ],
        [
            113.15637157815,
            23.295693516605
        ],
        [
            113.15642726767,
            23.295595527166
        ],
        [
            113.15646891343,
            23.295537293843
        ],
        [
            113.15651056898,
            23.295489640503
        ],
        [
            113.15653410446,
            23.295465701571
        ],
        [
            113.15658170861,
            23.295408330973
        ],
        [
            113.15664392256,
            23.295337249262
        ],
        [
            113.15669772223,
            23.295243571912
        ],
        [
            113.15673366553,
            23.295166287708
        ],
        [
            113.15678340905,
            23.295078268965
        ],
        [
            113.1568326187,
            23.294998383067
        ],
        [
            113.15690617986,
            23.294896997814
        ],
        [
            113.15698270541,
            23.294779354151
        ],
        [
            113.15706924467,
            23.294654735478
        ],
        [
            113.15711467954,
            23.294590813993
        ],
        [
            113.1571650015,
            23.294540225992
        ],
        [
            113.15722097364,
            23.294449798975
        ],
        [
            113.15725827958,
            23.294379835768
        ],
        [
            113.15729667142,
            23.294312593472
        ],
        [
            113.15733993727,
            23.294244575821
        ],
        [
            113.15740081389,
            23.294184839297
        ],
        [
            113.15745166345,
            23.294117150472
        ],
        [
            113.15752066568,
            23.294057473454
        ],
        [
            113.15756584695,
            23.294008997831
        ],
        [
            113.1575926135,
            23.293961459279
        ],
        [
            113.15762207712,
            23.293902003529
        ],
        [
            113.15763258479,
            23.293844296117
        ],
        [
            113.15766658683,
            23.293715417722
        ],
        [
            113.15768385709,
            23.293649352346
        ],
        [
            113.15770979461,
            23.293584168845
        ],
        [
            113.15771871111,
            23.293562262129
        ],
        [
            113.15784355769,
            23.2935556395
        ],
        [
            113.15790367522,
            23.293547421778
        ],
        [
            113.1579575527,
            23.293527215237
        ],
        [
            113.15802495634,
            23.293489744701
        ],
        [
            113.1580793464,
            23.29343779221
        ],
        [
            113.15813426647,
            23.293373089193
        ],
        [
            113.15816589973,
            23.293314450004
        ],
        [
            113.15819779515,
            23.293246587059
        ],
        [
            113.15820560472,
            23.293199435722
        ],
        [
            113.15821095605,
            23.293130831829
        ],
        [
            113.15823547043,
            23.292992098557
        ],
        [
            113.15824267339,
            23.292877655235
        ],
        [
            113.15826151057,
            23.292750545924
        ],
        [
            113.15827981945,
            23.292637540969
        ],
        [
            113.15829682172,
            23.292573906237
        ],
        [
            113.15832006448,
            23.292521441218
        ],
        [
            113.15835579207,
            23.292495113837
        ],
        [
            113.15837038667,
            23.29246239084
        ],
        [
            113.15841044255,
            23.292430124358
        ],
        [
            113.15845376462,
            23.292413888
        ],
        [
            113.15853340745,
            23.292422872264
        ],
        [
            113.15863418971,
            23.292442582405
        ],
        [
            113.15873171717,
            23.292456020719
        ],
        [
            113.15884362729,
            23.292494511598
        ],
        [
            113.1590181162,
            23.292534500949
        ],
        [
            113.1591058975,
            23.292547299366
        ],
        [
            113.15915953087,
            23.29254331485
        ],
        [
            113.15918850864,
            23.292534824246
        ],
        [
            113.15920392495,
            23.292509150507
        ],
        [
            113.15923229218,
            23.292429568946
        ],
        [
            113.15926416352,
            23.292331831118
        ],
        [
            113.15929196471,
            23.292227282875
        ],
        [
            113.15930836796,
            23.292102310913
        ],
        [
            113.15932910869,
            23.291980622614
        ],
        [
            113.15935309989,
            23.291858683562
        ],
        [
            113.1593717146,
            23.291779306679
        ],
        [
            113.15939138653,
            23.291673075518
        ],
        [
            113.15942054343,
            23.291570160555
        ],
        [
            113.15942374628,
            23.2915213433
        ],
        [
            113.15945648116,
            23.29147542763
        ],
        [
            113.15948979522,
            23.291467228291
        ],
        [
            113.15952337772,
            23.291456316467
        ],
        [
            113.15957404724,
            23.291464774596
        ],
        [
            113.15963095214,
            23.291477067736
        ],
        [
            113.15968487906,
            23.291490967608
        ],
        [
            113.1597970696,
            23.291519057351
        ],
        [
            113.15990491917,
            23.291538699175
        ],
        [
            113.16002010411,
            23.291576552367
        ],
        [
            113.16010818597,
            23.291603112984
        ],
        [
            113.16019246689,
            23.291620420106
        ],
        [
            113.16025344666,
            23.29163704652
        ],
        [
            113.16034479091,
            23.291670932861
        ],
        [
            113.16043287154,
            23.291690956471
        ],
        [
            113.16050523285,
            23.291706003972
        ],
        [
            113.16056648039,
            23.291715831891
        ],
        [
            113.16062176062,
            23.291718841606
        ],
        [
            113.16067758308,
            23.291721580147
        ],
        [
            113.16074370452,
            23.291725726429
        ],
        [
            113.16083611286,
            23.291731089724
        ],
        [
            113.16088895484,
            23.29173190314
        ],
        [
            113.16101551074,
            23.291737967906
        ],
        [
            113.16112309673,
            23.291740669851
        ],
        [
            113.16122851766,
            23.291744164989
        ],
        [
            113.16136023567,
            23.29175537045
        ],
        [
            113.16151444572,
            23.29176123618
        ],
        [
            113.16163911591,
            23.291763965569
        ],
        [
            113.16171338487,
            23.291773245394
        ],
        [
            113.16179361296,
            23.291777933329
        ],
        [
            113.16184919617,
            23.291800689834
        ],
        [
            113.16187389519,
            23.291836608576
        ],
        [
            113.1618939971,
            23.291883089009
        ],
        [
            113.16189596047,
            23.291950656195
        ],
        [
            113.16187495832,
            23.292092197476
        ],
        [
            113.16186590062,
            23.292253595191
        ],
        [
            113.16185787603,
            23.292362903545
        ],
        [
            113.16187391989,
            23.292417506725
        ],
        [
            113.16190701546,
            23.292448033608
        ],
        [
            113.16195581367,
            23.292460446135
        ],
        [
            113.16202168018,
            23.292465057975
        ],
        [
            113.16216072943,
            23.292469686335
        ],
        [
            113.16235724553,
            23.292473972898
        ],
        [
            113.16255241433,
            23.292479033377
        ],
        [
            113.16274026727,
            23.29247996422
        ],
        [
            113.16296473437,
            23.292492105409
        ],
        [
            113.16328815162,
            23.292492555937
        ],
        [
            113.16360209416,
            23.292487458944
        ],
        [
            113.16375691499,
            23.292496809159
        ],
        [
            113.16393179398,
            23.292495331312
        ],
        [
            113.1640925855,
            23.29250030629
        ],
        [
            113.1642219192,
            23.292495968076
        ],
        [
            113.16437811012,
            23.292501162411
        ],
        [
            113.16457388858,
            23.292498263904
        ],
        [
            113.16470459766,
            23.292501738555
        ],
        [
            113.16483721645,
            23.292513611164
        ],
        [
            113.16489633839,
            23.292517224824
        ],
        [
            113.1649503097,
            23.292522184723
        ],
        [
            113.16501077337,
            23.292509786002
        ],
        [
            113.16507096444,
            23.292495212965
        ],
        [
            113.16515012362,
            23.292463566234
        ],
        [
            113.16521816671,
            23.292434071669
        ],
        [
            113.16527346787,
            23.292408628869
        ],
        [
            113.16533610836,
            23.292399741393
        ],
        [
            113.16543887459,
            23.292375694371
        ],
        [
            113.16553812277,
            23.292357603651
        ],
        [
            113.16561596448,
            23.292358480087
        ],
        [
            113.16566803963,
            23.292358247411
        ],
        [
            113.16574752544,
            23.292374309511
        ],
        [
            113.16581805377,
            23.292382220941
        ],
        [
            113.16589320967,
            23.292406138083
        ],
        [
            113.1660074408,
            23.292445531727
        ],
        [
            113.16611110009,
            23.292489522517
        ],
        [
            113.16619982026,
            23.292510709062
        ],
        [
            113.16628093931,
            23.292524290183
        ],
        [
            113.16634632189,
            23.292533251462
        ],
        [
            113.16640708639,
            23.292534611627
        ],
        [
            113.16645590895,
            23.29252891424
        ],
        [
            113.16647921073,
            23.292500696179
        ],
        [
            113.16650251234,
            23.292472206288
        ],
        [
            113.16652417007,
            23.292426894068
        ],
        [
            113.16654851739,
            23.292357704812
        ],
        [
            113.16656959282,
            23.292271422106
        ],
        [
            113.16658798877,
            23.292219325904
        ],
        [
            113.16661916384,
            23.292197072734
        ],
        [
            113.16664382999,
            23.292176447848
        ],
        [
            113.16669400505,
            23.292164498953
        ],
        [
            113.16675883812,
            23.29216095444
        ],
        [
            113.16679763507,
            23.292164198066
        ],
        [
            113.16686005321,
            23.29218669517
        ],
        [
            113.16689614566,
            23.292197804637
        ],
        [
            113.16699005981,
            23.292245513295
        ],
        [
            113.16704624641,
            23.292274243173
        ],
        [
            113.16711003534,
            23.29230839184
        ],
        [
            113.16715618281,
            23.292334951615
        ],
        [
            113.16720367481,
            23.292348756321
        ],
        [
            113.16726771584,
            23.292361189697
        ],
        [
            113.16731874198,
            23.292381227003
        ],
        [
            113.16740476663,
            23.292399331783
        ],
        [
            113.16749160718,
            23.292417971536
        ],
        [
            113.16760015034,
            23.292431425966
        ],
        [
            113.16767938998,
            23.292443004383
        ],
        [
            113.16775509713,
            23.292448069571
        ],
        [
            113.16786391129,
            23.292455528018
        ],
        [
            113.16794858578,
            23.292471149271
        ],
        [
            113.1680462733,
            23.292473178426
        ],
        [
            113.16816974704,
            23.292480855365
        ],
        [
            113.16828045777,
            23.292476330588
        ],
        [
            113.16839199336,
            23.292480475283
        ],
        [
            113.16847746232,
            23.292467022162
        ],
        [
            113.16853714422,
            23.292445744462
        ],
        [
            113.16857241983,
            23.292442148009
        ],
        [
            113.16858923845,
            23.292435060201
        ],
        [
            113.16864810141,
            23.292407537598
        ],
        [
            113.16874032728,
            23.292361219834
        ],
        [
            113.16885696393,
            23.292298289069
        ],
        [
            113.16895569636,
            23.292241085437
        ],
        [
            113.1690631094,
            23.292177611301
        ],
        [
            113.16916020548,
            23.29210845481
        ],
        [
            113.16928036736,
            23.292032988717
        ],
        [
            113.16934545871,
            23.291983163335
        ],
        [
            113.16944906675,
            23.291906637713
        ],
        [
            113.16954806671,
            23.291834456651
        ],
        [
            113.1696495108,
            23.291761716667
        ],
        [
            113.169751225,
            23.291685710522
        ],
        [
            113.16984289472,
            23.291606741994
        ],
        [
            113.16995708575,
            23.291517111108
        ],
        [
            113.1700547375,
            23.291444888379
        ],
        [
            113.17012172663,
            23.291383343326
        ],
        [
            113.1701879035,
            23.291323153595
        ],
        [
            113.17025407577,
            23.2912575334
        ],
        [
            113.17033462937,
            23.291184531817
        ],
        [
            113.17040731814,
            23.291118336244
        ],
        [
            113.17048080155,
            23.291031240945
        ],
        [
            113.17053775015,
            23.290968893853
        ],
        [
            113.170619649,
            23.290879586786
        ],
        [
            113.17067632801,
            23.290817776185
        ],
        [
            113.17071917491,
            23.290769312219
        ],
        [
            113.17076118495,
            23.290698058684
        ],
        [
            113.17079288478,
            23.290633085419
        ],
        [
            113.17082051479,
            23.290570569594
        ],
        [
            113.17084623333,
            23.290496936534
        ],
        [
            113.17087169073,
            23.290433614253
        ],
        [
            113.17087978138,
            23.290379316287
        ],
        [
            113.17091038456,
            23.290303219773
        ],
        [
            113.17092872881,
            23.290185660514
        ],
        [
            113.17094005863,
            23.290112627269
        ],
        [
            113.17094569481,
            23.290047485966
        ],
        [
            113.17094590613,
            23.289987522333
        ],
        [
            113.17094688749,
            23.28988332956
        ],
        [
            113.17093293628,
            23.289779198697
        ],
        [
            113.17091819946,
            23.289703831318
        ],
        [
            113.17089067794,
            23.289604368345
        ],
        [
            113.17082129983,
            23.289458949334
        ],
        [
            113.17076905425,
            23.289341132823
        ],
        [
            113.1707214411,
            23.289239846367
        ],
        [
            113.1706782187,
            23.289184665948
        ],
        [
            113.17062057808,
            23.289099965135
        ],
        [
            113.17053795723,
            23.289010743591
        ],
        [
            113.17045860602,
            23.288932085401
        ],
        [
            113.17038089989,
            23.288868338387
        ],
        [
            113.17023720568,
            23.288782028238
        ],
        [
            113.17009162996,
            23.288710357216
        ],
        [
            113.16995663973,
            23.288633748624
        ],
        [
            113.16985318191,
            23.288597994279
        ],
        [
            113.16974210321,
            23.288540004839
        ],
        [
            113.16963727418,
            23.288486326815
        ],
        [
            113.16954763946,
            23.288424997958
        ],
        [
            113.16948815532,
            23.288384197637
        ],
        [
            113.16945853721,
            23.288351993273
        ],
        [
            113.16945228563,
            23.288343328354
        ],
        [
            113.16945116103,
            23.288305074661
        ],
        [
            113.1694519339,
            23.288264373739
        ],
        [
            113.1694687114,
            23.288214402922
        ],
        [
            113.16947870855,
            23.28816960615
        ],
        [
            113.16951284246,
            23.288104934035
        ],
        [
            113.16951982579,
            23.288032470294
        ],
        [
            113.16952275096,
            23.287973041721
        ],
        [
            113.16950367009,
            23.28789359782
        ],
        [
            113.16947885973,
            23.287785137948
        ],
        [
            113.16947417855,
            23.287719490427
        ],
        [
            113.16947847458,
            23.287673624362
        ],
        [
            113.16950906043,
            23.287589969546
        ],
        [
            113.16955946598,
            23.287511411888
        ],
        [
            113.16962293867,
            23.287469984975
        ],
        [
            113.16969212972,
            23.287445630638
        ],
        [
            113.16975455174,
            23.287437029599
        ],
        [
            113.16981888818,
            23.287441713946
        ],
        [
            113.16989191664,
            23.28745125061
        ],
        [
            113.16994051014,
            23.287455435375
        ],
        [
            113.17000186701,
            23.287464188501
        ],
        [
            113.17010395708,
            23.287486638431
        ],
        [
            113.17023265385,
            23.287510342478
        ],
        [
            113.17031573588,
            23.287523342838
        ],
        [
            113.17038361347,
            23.287533136545
        ],
        [
            113.17048054864,
            23.287551500385
        ],
        [
            113.17055414573,
            23.28757727042
        ],
        [
            113.1706443121,
            23.287610568466
        ],
        [
            113.17070080356,
            23.287632325105
        ],
        [
            113.1708105381,
            23.28768343994
        ],
        [
            113.17090045691,
            23.287735982211
        ],
        [
            113.17102758692,
            23.28780192676
        ],
        [
            113.17116531517,
            23.287874051163
        ],
        [
            113.17126853001,
            23.28791266807
        ],
        [
            113.171356506,
            23.287916343441
        ],
        [
            113.17144801517,
            23.287921894877
        ],
        [
            113.17155660545,
            23.287901040009
        ],
        [
            113.17168014178,
            23.287889327814
        ],
        [
            113.17180826977,
            23.287850718112
        ],
        [
            113.17189213317,
            23.287807160892
        ],
        [
            113.17196594024,
            23.287753609362
        ],
        [
            113.17192616058,
            23.287623031219
        ],
        [
            113.17184666153,
            23.287420205469
        ],
        [
            113.17177049183,
            23.287285731924
        ],
        [
            113.17168180445,
            23.28712390965
        ],
        [
            113.17170647746,
            23.287087704212
        ],
        [
            113.17177802028,
            23.286946808981
        ],
        [
            113.17182319869,
            23.286781077781
        ],
        [
            113.17186619231,
            23.28660287463
        ],
        [
            113.17187206089,
            23.286499741512
        ],
        [
            113.17186872077,
            23.286419988322
        ],
        [
            113.1718482769,
            23.286343847412
        ],
        [
            113.17180199682,
            23.286229034031
        ],
        [
            113.17177341972,
            23.286165412778
        ],
        [
            113.17173020268,
            23.286124382099
        ],
        [
            113.17169244224,
            23.286108285421
        ],
        [
            113.17161857938,
            23.286103484273
        ],
        [
            113.17153848898,
            23.286114987018
        ],
        [
            113.17145813934,
            23.286137338251
        ],
        [
            113.17137262034,
            23.286148311489
        ],
        [
            113.17126564152,
            23.286148249375
        ],
        [
            113.17117140446,
            23.286127229418
        ],
        [
            113.17109263106,
            23.286092568982
        ],
        [
            113.17102115804,
            23.286027212337
        ],
        [
            113.17094310868,
            23.285901915441
        ],
        [
            113.17087588924,
            23.285746180316
        ],
        [
            113.17086331309,
            23.285660764124
        ],
        [
            113.1708661903,
            23.285553850054
        ],
        [
            113.17087071786,
            23.285467821312
        ],
        [
            113.17088857287,
            23.285405343262
        ],
        [
            113.1709243629,
            23.285358527757
        ],
        [
            113.17097644683,
            23.285315170271
        ],
        [
            113.17106735701,
            23.285272188024
        ],
        [
            113.17113952928,
            23.285224124452
        ],
        [
            113.17121171139,
            23.285184738565
        ],
        [
            113.17127084617,
            23.285130211878
        ],
        [
            113.17130035761,
            23.285047868486
        ],
        [
            113.17131332514,
            23.284983777501
        ],
        [
            113.17131026871,
            23.28491541714
        ],
        [
            113.17130612041,
            23.28484136383
        ],
        [
            113.17127941908,
            23.284750589079
        ],
        [
            113.17126001263,
            23.28462423768
        ],
        [
            113.17127515397,
            23.284561765461
        ],
        [
            113.17129976644,
            23.284467776921
        ],
        [
            113.1713889391,
            23.284312718644
        ],
        [
            113.17148548099,
            23.284193434014
        ],
        [
            113.17156710286,
            23.284086421142
        ],
        [
            113.17163547536,
            23.284033188129
        ],
        [
            113.1717035695,
            23.283972355167
        ],
        [
            113.17176925367,
            23.283944088926
        ],
        [
            113.17180563809,
            23.283941739565
        ],
        [
            113.17191100104,
            23.283944471166
        ],
        [
            113.17199193068,
            23.283951658852
        ],
        [
            113.17217633282,
            23.283965627122
        ],
        [
            113.17232380799,
            23.283980036201
        ],
        [
            113.17243299038,
            23.283990024229
        ],
        [
            113.1725158285,
            23.283996892578
        ],
        [
            113.17265680106,
            23.284017534946
        ],
        [
            113.17281759686,
            23.284031532765
        ],
        [
            113.17295856389,
            23.28403911421
        ],
        [
            113.17304711466,
            23.284046995268
        ],
        [
            113.17317071463,
            23.284064694154
        ],
        [
            113.17327422026,
            23.284084946887
        ],
        [
            113.17337907268,
            23.284092158173
        ],
        [
            113.17346437338,
            23.284102740885
        ],
        [
            113.17356135183,
            23.284109714562
        ],
        [
            113.17368250217,
            23.284111366246
        ],
        [
            113.1738340853,
            23.284119042124
        ],
        [
            113.17393840127,
            23.284122679194
        ],
        [
            113.17402342886,
            23.284123454982
        ],
        [
            113.17412338968,
            23.284115167095
        ],
        [
            113.17416278215,
            23.28411706315
        ],
        [
            113.17436543345,
            23.284106676094
        ],
        [
            113.1745498929,
            23.284099643335
        ],
        [
            113.17468301995,
            23.28410273195
        ],
        [
            113.17494111147,
            23.284088306107
        ],
        [
            113.17512886297,
            23.28409418211
        ],
        [
            113.17529324725,
            23.284094245287
        ],
        [
            113.17546959673,
            23.284099073303
        ],
        [
            113.17565301062,
            23.284098119678
        ],
        [
            113.17579810258,
            23.284084706775
        ],
        [
            113.17590054235,
            23.284078963027
        ],
        [
            113.17609510487,
            23.284071608508
        ],
        [
            113.17622826197,
            23.284069643036
        ],
        [
            113.1763614121,
            23.284057895558
        ],
        [
            113.17644674228,
            23.284054156397
        ],
        [
            113.17653804539,
            23.284043303461
        ],
        [
            113.17667473732,
            23.284033390124
        ],
        [
            113.17680544875,
            23.284019175499
        ],
        [
            113.17693154262,
            23.28400499011
        ],
        [
            113.17709487537,
            23.283991256964
        ],
        [
            113.17717043223,
            23.283988645846
        ],
        [
            113.1772584881,
            23.283981298777
        ],
        [
            113.17740822233,
            23.283951103983
        ],
        [
            113.17753024965,
            23.283935270668
        ],
        [
            113.17771804007,
            23.283899785155
        ],
        [
            113.17779088127,
            23.283892280585
        ],
        [
            113.1778792086,
            23.283875934728
        ],
        [
            113.17805070594,
            23.283847075971
        ],
        [
            113.17813686052,
            23.283829106817
        ],
        [
            113.17825671943,
            23.283805630582
        ],
        [
            113.17840186933,
            23.283788664031
        ],
        [
            113.17852390937,
            23.28376649768
        ],
        [
            113.17856984292,
            23.283756247453
        ],
        [
            113.17857173271,
            23.283743203875
        ],
        [
            113.17858040266,
            23.283714080637
        ],
        [
            113.17856319818,
            23.283637747462
        ],
        [
            113.17854298499,
            23.283543266773
        ],
        [
            113.17851981695,
            23.28348381794
        ],
        [
            113.17847235979,
            23.283331286291
        ],
        [
            113.17845924977,
            23.283270917334
        ],
        [
            113.17844258383,
            23.2831888792
        ],
        [
            113.17842918621,
            23.28311277602
        ],
        [
            113.17841330619,
            23.283001154763
        ],
        [
            113.17839443353,
            23.282887122503
        ],
        [
            113.17837589241,
            23.282832235737
        ],
        [
            113.17836580157,
            23.282800052553
        ],
        [
            113.17830999399,
            23.282721945366
        ],
        [
            113.17823672338,
            23.282578625701
        ],
        [
            113.17820159761,
            23.282520922212
        ],
        [
            113.17819287777,
            23.282500119399
        ],
        [
            113.17820183679,
            23.282488360611
        ],
        [
            113.17827032269,
            23.282469478314
        ],
        [
            113.17834179418,
            23.282445135058
        ],
        [
            113.1784222318,
            23.282414996794
        ],
        [
            113.17859153297,
            23.282350004431
        ],
        [
            113.17880676933,
            23.282270119849
        ],
        [
            113.17897280777,
            23.282194804149
        ],
        [
            113.17912445603,
            23.282134819872
        ],
        [
            113.17939135191,
            23.282037455296
        ],
        [
            113.17951638109,
            23.281994817334
        ],
        [
            113.1795609538,
            23.28197613796
        ],
        [
            113.17957153964,
            23.281957840026
        ],
        [
            113.17954510457,
            23.281896817535
        ],
        [
            113.17949336108,
            23.2818135581
        ],
        [
            113.17942610139,
            23.281711477024
        ],
        [
            113.17934821086,
            23.28158129281
        ],
        [
            113.17927440161,
            23.281452958513
        ],
        [
            113.17923950534,
            23.281357294014
        ],
        [
            113.17921768843,
            23.281290516711
        ],
        [
            113.17922035309,
            23.281235679635
        ],
        [
            113.17921946404,
            23.281161346223
        ],
        [
            113.17922457923,
            23.281110009434
        ],
        [
            113.17921993529,
            23.281087811841
        ],
        [
            113.17920359615,
            23.281061401589
        ],
        [
            113.17914373296,
            23.281011862897
        ],
        [
            113.17910427183,
            23.28097295206
        ],
        [
            113.17910588067,
            23.280950143172
        ],
        [
            113.17912132704,
            23.28089842265
        ],
        [
            113.17915036186,
            23.280840855407
        ],
        [
            113.1792084597,
            23.28075393661
        ],
        [
            113.17928585535,
            23.28066001918
        ],
        [
            113.17936624226,
            23.280565521569
        ],
        [
            113.17943305557,
            23.280491520162
        ],
        [
            113.17949986857,
            23.280416430262
        ],
        [
            113.17956450979,
            23.280344074855
        ],
        [
            113.17962316755,
            23.280269342121
        ],
        [
            113.17967423036,
            23.280212871754
        ],
        [
            113.17974703849,
            23.280148555176
        ],
        [
            113.17982774302,
            23.280094726226
        ],
        [
            113.17993316849,
            23.280015917807
        ],
        [
            113.18000027937,
            23.279961964132
        ],
        [
            113.18008151801,
            23.279894819712
        ],
        [
            113.18015571214,
            23.279852986064
        ],
        [
            113.18028535126,
            23.279781194785
        ],
        [
            113.18035356627,
            23.279740506533
        ],
        [
            113.18042096958,
            23.279703351908
        ],
        [
            113.18051607993,
            23.279633848022
        ],
        [
            113.18059787585,
            23.279573993752
        ],
        [
            113.18070521564,
            23.279493478182
        ],
        [
            113.18083266033,
            23.27939100514
        ],
        [
            113.18098130435,
            23.279272253937
        ],
        [
            113.18108049372,
            23.279193981534
        ],
        [
            113.18118078945,
            23.279133596292
        ],
        [
            113.1812704881,
            23.279081747112
        ],
        [
            113.18137758699,
            23.279022620935
        ],
        [
            113.18144909767,
            23.279004089837
        ],
        [
            113.18149750286,
            23.278997784284
        ],
        [
            113.18153693431,
            23.278992675568
        ],
        [
            113.18158399825,
            23.279005376848
        ],
        [
            113.18161991435,
            23.279021202324
        ],
        [
            113.18163515864,
            23.279035389558
        ],
        [
            113.18167438264,
            23.279097296945
        ],
        [
            113.18172910944,
            23.279158734899
        ],
        [
            113.18175768256,
            23.279174379267
        ],
        [
            113.18178814723,
            23.279176975426
        ],
        [
            113.18180664041,
            23.279175111416
        ],
        [
            113.18183899492,
            23.279162759626
        ],
        [
            113.1818843955,
            23.279140472298
        ],
        [
            113.18194527813,
            23.279095464752
        ],
        [
            113.1819936498,
            23.279050616173
        ],
        [
            113.18203114454,
            23.279008348534
        ],
        [
            113.18206210321,
            23.278957210874
        ],
        [
            113.18215069497,
            23.278874122808
        ],
        [
            113.18221372302,
            23.278794347667
        ],
        [
            113.18229470414,
            23.278714877986
        ],
        [
            113.18237648329,
            23.278615315822
        ],
        [
            113.18246155131,
            23.278540939259
        ],
        [
            113.18251482358,
            23.27849682434
        ],
        [
            113.18261077189,
            23.278420396885
        ],
        [
            113.18277736824,
            23.278260809389
        ],
        [
            113.18287031419,
            23.278169755544
        ],
        [
            113.18296815046,
            23.27807076219
        ],
        [
            113.1831325545,
            23.277884579198
        ],
        [
            113.18323282324,
            23.277764374307
        ],
        [
            113.1833029233,
            23.27767225172
        ],
        [
            113.18342847914,
            23.277535409698
        ],
        [
            113.18354372138,
            23.277422306273
        ],
        [
            113.18363749631,
            23.277333912404
        ],
        [
            113.18377828255,
            23.277185438155
        ],
        [
            113.18386472677,
            23.277109886675
        ],
        [
            113.18391664017,
            23.277055708028
        ],
        [
            113.18396504997,
            23.27703766294
        ],
        [
            113.18399496889,
            23.27702937338
        ],
        [
            113.18402680461,
            23.277034622359
        ],
        [
            113.18406300569,
            23.277053375194
        ],
        [
            113.18412862535,
            23.277111323873
        ],
        [
            113.18420024405,
            23.277183565053
        ],
        [
            113.18425253901,
            23.277247396223
        ],
        [
            113.18430182107,
            23.277288749148
        ],
        [
            113.18435054193,
            23.277311116226
        ],
        [
            113.18439571626,
            23.27732267988
        ],
        [
            113.18442700934,
            23.277327929608
        ],
        [
            113.18452196586,
            23.277330907979
        ],
        [
            113.1846707886,
            23.277326863097
        ],
        [
            113.18483647833,
            23.277317677334
        ],
        [
            113.18498557828,
            23.27731360356
        ],
        [
            113.18517058663,
            23.277298137102
        ],
        [
            113.18530636296,
            23.277298304451
        ],
        [
            113.18554607504,
            23.277287690567
        ],
        [
            113.1856818455,
            23.277275622827
        ],
        [
            113.18568021684,
            23.277279988373
        ],
        [
            113.1857490498,
            23.277268103489
        ],
        [
            113.18576230055,
            23.277177554298
        ],
        [
            113.18577280182,
            23.277055573028
        ],
        [
            113.18578081369,
            23.276888589799
        ],
        [
            113.18578748334,
            23.276741162002
        ],
        [
            113.1857846468,
            23.276612869662
        ],
        [
            113.1857907369,
            23.276424752654
        ],
        [
            113.18580036413,
            23.276235226051
        ],
        [
            113.18579996003,
            23.276086277187
        ],
        [
            113.18580822965,
            23.275898127937
        ],
        [
            113.18580868696,
            23.275799089273
        ],
        [
            113.18580342077,
            23.275689283953
        ],
        [
            113.18580606639,
            23.275602693209
        ],
        [
            113.18581606458,
            23.275522232261
        ],
        [
            113.18582226778,
            23.275458378886
        ],
        [
            113.18583359264,
            23.275338285369
        ],
        [
            113.18584138028,
            23.275217973819
        ],
        [
            113.18584919414,
            23.275127778314
        ],
        [
            113.18584857306,
            23.275037981192
        ],
        [
            113.18585663942,
            23.274924177261
        ],
        [
            113.18586800118,
            23.274845323776
        ],
        [
            113.18587285454,
            23.274792614907
        ],
        [
            113.18587852867,
            23.274745048716
        ],
        [
            113.18588247192,
            23.274580841938
        ],
        [
            113.18589214144,
            23.274429843543
        ],
        [
            113.18590727106,
            23.27429938299
        ],
        [
            113.18590881204,
            23.274188933665
        ],
        [
            113.18591062843,
            23.274082007388
        ],
        [
            113.18591570005,
            23.273962280181
        ],
        [
            113.18593409852,
            23.273833669731
        ],
        [
            113.1859356502,
            23.273734344549
        ],
        [
            113.18595404504,
            23.273600036549
        ],
        [
            113.18596597281,
            23.273543965211
        ],
        [
            113.18597300025,
            23.273484983454
        ],
        [
            113.1859895043,
            23.273366711578
        ],
        [
            113.18599080035,
            23.273286111309
        ],
        [
            113.18600705966,
            23.273201214922
        ],
        [
            113.18601435474,
            23.273135717561
        ],
        [
            113.18603872222,
            23.272980156415
        ],
        [
            113.18604841464,
            23.272848150674
        ],
        [
            113.1860584141,
            23.272760093259
        ],
        [
            113.1860789966,
            23.272633620052
        ],
        [
            113.1860941552,
            23.272530290763
        ],
        [
            113.18610904458,
            23.272430221296
        ],
        [
            113.1861097751,
            23.27231842908
        ],
        [
            113.18612168997,
            23.272242009096
        ],
        [
            113.18612649847,
            23.272124186201
        ],
        [
            113.1861509061,
            23.272014204857
        ],
        [
            113.18615625676,
            23.271892304176
        ],
        [
            113.18616108743,
            23.271802155031
        ],
        [
            113.18617434157,
            23.271695056437
        ],
        [
            113.18618703687,
            23.271567617983
        ],
        [
            113.18620004718,
            23.271497692813
        ],
        [
            113.18621551095,
            23.271433427761
        ],
        [
            113.18623094101,
            23.271322768933
        ],
        [
            113.18623438094,
            23.271188417568
        ],
        [
            113.18625554007,
            23.271096391866
        ],
        [
            113.18625845092,
            23.27098158313
        ],
        [
            113.18627849644,
            23.270853218796
        ],
        [
            113.18628223951,
            23.270759288413
        ],
        [
            113.18629576517,
            23.270645131789
        ],
        [
            113.18630876306,
            23.270553773239
        ],
        [
            113.18631250043,
            23.270450076002
        ],
        [
            113.18633089986,
            23.270298404357
        ],
        [
            113.18633846309,
            23.270216624792
        ],
        [
            113.18634139549,
            23.270127590769
        ],
        [
            113.18635736159,
            23.269996304643
        ],
        [
            113.1863687308,
            23.269907412936
        ],
        [
            113.18639337888,
            23.269735297753
        ],
        [
            113.1864022967,
            23.2696415601
        ],
        [
            113.1864093118,
            23.269550564723
        ],
        [
            113.18642641262,
            23.269484917587
        ],
        [
            113.18644130349,
            23.269368569934
        ],
        [
            113.18645538084,
            23.269255761768
        ],
        [
            113.18647435196,
            23.269135010604
        ],
        [
            113.18648082684,
            23.269047279378
        ],
        [
            113.18649356165,
            23.26896053724
        ],
        [
            113.18650414329,
            23.268910997025
        ],
        [
            113.18651146327,
            23.268867475645
        ],
        [
            113.1865282974,
            23.268807258315
        ],
        [
            113.1865329021,
            23.268773003041
        ],
        [
            113.18654699608,
            23.268682170328
        ],
        [
            113.18655726114,
            23.26855992523
        ],
        [
            113.18657297176,
            23.268441394611
        ],
        [
            113.18658026219,
            23.26834795371
        ],
        [
            113.18658374992,
            23.268265694916
        ],
        [
            113.18659866428,
            23.268178105304
        ],
        [
            113.18660542241,
            23.268102850078
        ],
        [
            113.18660672931,
            23.268012757273
        ],
        [
            113.18662026431,
            23.26789181875
        ],
        [
            113.18664711586,
            23.26773893238
        ],
        [
            113.1866595778,
            23.267642156382
        ],
        [
            113.18667721799,
            23.26755805159
        ],
        [
            113.18668316104,
            23.267481452661
        ],
        [
            113.18669154907,
            23.267396948241
        ],
        [
            113.18669369095,
            23.267334787123
        ],
        [
            113.18670644859,
            23.267276802723
        ],
        [
            113.18672843496,
            23.267175809957
        ],
        [
            113.18673329728,
            23.267110893832
        ],
        [
            113.18674875893,
            23.267020311411
        ],
        [
            113.18676230996,
            23.266918635252
        ],
        [
            113.18678429102,
            23.266804619979
        ],
        [
            113.18681442282,
            23.266664433445
        ],
        [
            113.18683587253,
            23.266572130132
        ],
        [
            113.18684943258,
            23.266483476109
        ],
        [
            113.1868814696,
            23.26633946136
        ],
        [
            113.18690753876,
            23.266230807966
        ],
        [
            113.18692844621,
            23.266138512607
        ],
        [
            113.18696457781,
            23.266014238183
        ],
        [
            113.18698113709,
            23.265932048283
        ],
        [
            113.18701155417,
            23.265805963354
        ],
        [
            113.18703518038,
            23.265704129612
        ],
        [
            113.1870577381,
            23.265642464316
        ],
        [
            113.18707130919,
            23.265568188344
        ],
        [
            113.18710446111,
            23.265465120087
        ],
        [
            113.18713054912,
            23.265385764774
        ],
        [
            113.18715499288,
            23.265281475786
        ],
        [
            113.1871780833,
            23.26519185781
        ],
        [
            113.18720634991,
            23.265113010315
        ],
        [
            113.18723272433,
            23.265061321736
        ],
        [
            113.18723814956,
            23.265022712697
        ],
        [
            113.18724383058,
            23.264948017447
        ],
        [
            113.18725061,
            23.264894465964
        ],
        [
            113.18726255899,
            23.264837849054
        ],
        [
            113.18728430579,
            23.264781892022
        ],
        [
            113.18730333118,
            23.264725706325
        ],
        [
            113.18731553041,
            23.264618082078
        ],
        [
            113.18735060239,
            23.264537227196
        ],
        [
            113.18738156985,
            23.26440353438
        ],
        [
            113.18740247044,
            23.264274069494
        ],
        [
            113.18743019416,
            23.264188988902
        ],
        [
            113.18744947738,
            23.26409373223
        ],
        [
            113.18746821743,
            23.264000111831
        ],
        [
            113.18749566624,
            23.26390499728
        ],
        [
            113.18751549844,
            23.26381787043
        ],
        [
            113.18753750452,
            23.263721213911
        ],
        [
            113.18755462369,
            23.263653662785
        ],
        [
            113.18759104961,
            23.263543484381
        ],
        [
            113.18760190431,
            23.263461382632
        ],
        [
            113.18763044098,
            23.263356754705
        ],
        [
            113.1876562655,
            23.263275771822
        ],
        [
            113.18766794302,
            23.263207764015
        ],
        [
            113.18768424078,
            23.26312150643
        ],
        [
            113.18769727159,
            23.263031231396
        ],
        [
            113.1877122143,
            23.262958831053
        ],
        [
            113.18772959752,
            23.262860348163
        ],
        [
            113.18772739604,
            23.262791204625
        ],
        [
            113.18774370316,
            23.26272664994
        ],
        [
            113.1877602747,
            23.262638760225
        ],
        [
            113.18777575538,
            23.262543020514
        ],
        [
            113.18778063607,
            23.262488685301
        ],
        [
            113.18780020853,
            23.262419195289
        ],
        [
            113.18781378909,
            23.262335422471
        ],
        [
            113.18782845761,
            23.26224837687
        ],
        [
            113.18784828609,
            23.262124896594
        ],
        [
            113.18785561233,
            23.262054245311
        ],
        [
            113.18785940559,
            23.261999385019
        ],
        [
            113.18787163117,
            23.261928655611
        ],
        [
            113.18787839576,
            23.261797788027
        ],
        [
            113.18789440242,
            23.261624452608
        ],
        [
            113.18790933206,
            23.26148694416
        ],
        [
            113.18791393677,
            23.261408198171
        ],
        [
            113.18794520575,
            23.261300269935
        ],
        [
            113.18796341816,
            23.26121696586
        ],
        [
            113.18797700856,
            23.26115028398
        ],
        [
            113.18799467804,
            23.26106970134
        ],
        [
            113.18804226558,
            23.260908882178
        ],
        [
            113.18805368198,
            23.260850916001
        ],
        [
            113.18807979311,
            23.260783219226
        ],
        [
            113.18811052635,
            23.260694830605
        ],
        [
            113.18813309202,
            23.260593551407
        ],
        [
            113.18815484358,
            23.260500152369
        ],
        [
            113.18817252058,
            23.260439643772
        ],
        [
            113.18817958104,
            23.260369268463
        ],
        [
            113.18821112699,
            23.260253737935
        ],
        [
            113.18823070751,
            23.260181533422
        ],
        [
            113.18824511492,
            23.260098832232
        ],
        [
            113.18827013621,
            23.260010805682
        ],
        [
            113.18828944197,
            23.259920700913
        ],
        [
            113.18832044681,
            23.259806534777
        ],
        [
            113.18835281465,
            23.259699670941
        ],
        [
            113.18839280137,
            23.259578577223
        ],
        [
            113.1884186454,
            23.259510339792
        ],
        [
            113.18844774963,
            23.259406783276
        ],
        [
            113.18848039875,
            23.259338706512
        ],
        [
            113.18848719529,
            23.259292479239
        ],
        [
            113.18850324218,
            23.259223857348
        ],
        [
            113.18852744829,
            23.259115767971
        ],
        [
            113.18855274454,
            23.259012815081
        ],
        [
            113.18856253539,
            23.258963555173
        ],
        [
            113.18858593393,
            23.258905936069
        ],
        [
            113.18861204934,
            23.258812735509
        ],
        [
            113.18863843548,
            23.25870515279
        ],
        [
            113.18866427305,
            23.258560142897
        ],
        [
            113.18867841513,
            23.258472019742
        ],
        [
            113.18869637069,
            23.258405265232
        ],
        [
            113.18870588891,
            23.258337834207
        ],
        [
            113.18874860716,
            23.258216692661
        ],
        [
            113.18876873689,
            23.258109753931
        ],
        [
            113.18879621906,
            23.258032264062
        ],
        [
            113.18880056896,
            23.2579822788
        ],
        [
            113.18880900051,
            23.257919748398
        ],
        [
            113.1888125338,
            23.257865707414
        ],
        [
            113.1888291323,
            23.257816064843
        ],
        [
            113.18883919924,
            23.257773581947
        ],
        [
            113.1888666811,
            23.257673847362
        ],
        [
            113.1888791959,
            23.257604468458
        ],
        [
            113.1888917107,
            23.257531563021
        ],
        [
            113.18890313686,
            23.257455691405
        ],
        [
            113.18891537944,
            23.257373024673
        ],
        [
            113.18894259278,
            23.257296080976
        ],
        [
            113.18895592478,
            23.257212582584
        ],
        [
            113.1889839541,
            23.257110668388
        ],
        [
            113.18899755928,
            23.257030149481
        ],
        [
            113.18900354735,
            23.257030593904
        ],
        [
            113.18900599478,
            23.25698253898
        ],
        [
            113.18902422797,
            23.256909268509
        ],
        [
            113.18903892204,
            23.25680784399
        ],
        [
            113.18905089631,
            23.256753664984
        ],
        [
            113.189068858,
            23.25667117573
        ],
        [
            113.18907865495,
            23.256606452937
        ],
        [
            113.1890827361,
            23.256535313537
        ],
        [
            113.18909008341,
            23.256444317983
        ],
        [
            113.18909062573,
            23.256261203145
        ],
        [
            113.1890936194,
            23.256157801046
        ],
        [
            113.18908354886,
            23.25603535358
        ],
        [
            113.18907266236,
            23.255930823248
        ],
        [
            113.18906286525,
            23.255823562468
        ],
        [
            113.18903401676,
            23.255678908279
        ],
        [
            113.1890378293,
            23.255606417806
        ],
        [
            113.18902966707,
            23.255502385702
        ],
        [
            113.18900708001,
            23.255390994712
        ],
        [
            113.18898422559,
            23.255194973564
        ],
        [
            113.18897089485,
            23.255080175899
        ],
        [
            113.18895946842,
            23.254992202251
        ],
        [
            113.18895185255,
            23.254910676601
        ],
        [
            113.1889461431,
            23.254817998022
        ],
        [
            113.18894832933,
            23.254700234143
        ],
        [
            113.18894779377,
            23.254590924108
        ],
        [
            113.1889464466,
            23.25443415666
        ],
        [
            113.1889377461,
            23.254335559786
        ],
        [
            113.1889260486,
            23.254271733473
        ],
        [
            113.18890619116,
            23.254157857311
        ],
        [
            113.18889585658,
            23.254081530728
        ],
        [
            113.18888497523,
            23.254029084037
        ],
        [
            113.18888770259,
            23.253980755094
        ],
        [
            113.18888826558,
            23.25382585635
        ],
        [
            113.1888877344,
            23.253722243816
        ],
        [
            113.18886325021,
            23.253631229492
        ],
        [
            113.18884502106,
            23.253580530511
        ],
        [
            113.18884828849,
            23.253571254342
        ],
        [
            113.18881862383,
            23.253550309185
        ],
        [
            113.18879195532,
            23.253514395609
        ],
        [
            113.18874733139,
            23.253421810111
        ],
        [
            113.18871685772,
            23.253352864341
        ],
        [
            113.18865754373,
            23.253219285523
        ],
        [
            113.1886091082,
            23.253145748124
        ],
        [
            113.18855251575,
            23.253025143487
        ],
        [
            113.18848775542,
            23.252926099463
        ],
        [
            113.18841918782,
            23.252814366508
        ],
        [
            113.18835524227,
            23.252734565537
        ],
        [
            113.18834762349,
            23.252723838312
        ],
        [
            113.18826953356,
            23.252603846544
        ],
        [
            113.18819716029,
            23.252484303151
        ],
        [
            113.18811852769,
            23.252368384745
        ],
        [
            113.18805078025,
            23.252264767323
        ],
        [
            113.18798956058,
            23.252184914143
        ],
        [
            113.18796888454,
            23.252146455635
        ],
        [
            113.18791555483,
            23.252083021035
        ],
        [
            113.18788318048,
            23.252025489716
        ],
        [
            113.18784046697,
            23.251956459014
        ],
        [
            113.1877882353,
            23.251857198843
        ],
        [
            113.18773300874,
            23.251766122919
        ],
        [
            113.18770145227,
            23.251708847686
        ],
        [
            113.18766282749,
            23.251620761484
        ],
        [
            113.18760080232,
            23.251515685626
        ],
        [
            113.18756462424,
            23.251443020658
        ],
        [
            113.18752082923,
            23.251359083119
        ],
        [
            113.18747050555,
            23.251266025445
        ],
        [
            113.18740005212,
            23.25114100537
        ],
        [
            113.18735543785,
            23.251074709334
        ],
        [
            113.18731517624,
            23.251015939065
        ],
        [
            113.18729042495,
            23.250965333138
        ],
        [
            113.18725697067,
            23.250895333646
        ],
        [
            113.18721807354,
            23.250826504137
        ],
        [
            113.18718353413,
            23.250747026976
        ],
        [
            113.18716504471,
            23.250690896715
        ],
        [
            113.1871443758,
            23.250643480465
        ],
        [
            113.187109022,
            23.250560488868
        ],
        [
            113.18708781274,
            23.250501416911
        ],
        [
            113.18702471241,
            23.250383052888
        ],
        [
            113.18698201364,
            23.250296105466
        ],
        [
            113.1869627168,
            23.250216659079
        ],
        [
            113.18693335367,
            23.250129774363
        ],
        [
            113.18690725365,
            23.25005206103
        ],
        [
            113.18687707535,
            23.249964103435
        ],
        [
            113.18685750351,
            23.249897951851
        ],
        [
            113.18683058692,
            23.249824047979
        ],
        [
            113.18680666342,
            23.249752267403
        ],
        [
            113.18677947269,
            23.24968623345
        ],
        [
            113.18677649142,
            23.249650746317
        ],
        [
            113.18674822193,
            23.24955787537
        ],
        [
            113.18670282473,
            23.249419970969
        ],
        [
            113.18668896474,
            23.249367834769
        ],
        [
            113.18662507542,
            23.249199835329
        ],
        [
            113.18658594732,
            23.249042845203
        ],
        [
            113.18654462743,
            23.248928202534
        ],
        [
            113.1865008711,
            23.248782946085
        ],
        [
            113.18643780846,
            23.248604351059
        ],
        [
            113.18641527009,
            23.248484807122
        ],
        [
            113.1863941167,
            23.248307738404
        ],
        [
            113.18636831494,
            23.248187701877
        ],
        [
            113.18636482858,
            23.248065967493
        ],
        [
            113.18635862417,
            23.24793857879
        ],
        [
            113.18635214063,
            23.247829096443
        ],
        [
            113.18634564254,
            23.247754062044
        ],
        [
            113.1863342518,
            23.24766716792
        ],
        [
            113.18632258412,
            23.247591941399
        ],
        [
            113.18630955184,
            23.247526229144
        ],
        [
            113.18629897195,
            23.247453698385
        ],
        [
            113.18629221021,
            23.247363207471
        ],
        [
            113.18628490751,
            23.24726648637
        ],
        [
            113.18628359953,
            23.247153399446
        ],
        [
            113.18627739425,
            23.247039844952
        ],
        [
            113.18628071627,
            23.24692099159
        ],
        [
            113.1862769612,
            23.246807671197
        ],
        [
            113.18628219151,
            23.246684449178
        ],
        [
            113.18629096441,
            23.246552493593
        ],
        [
            113.18630325015,
            23.246471477113
        ],
        [
            113.18631446318,
            23.246359827223
        ],
        [
            113.18632376379,
            23.246264209618
        ],
        [
            113.18631238164,
            23.246172705581
        ],
        [
            113.18631079695,
            23.246079695679
        ],
        [
            113.1863100448,
            23.245956565938
        ],
        [
            113.18630655662,
            23.245862771619
        ],
        [
            113.18629707829,
            23.245776392258
        ],
        [
            113.1862913962,
            23.245715722309
        ],
        [
            113.18629142297,
            23.245665814605
        ],
        [
            113.18626969694,
            23.245585318258
        ],
        [
            113.18626483234,
            23.245523550938
        ],
        [
            113.1862586137,
            23.245450141215
        ],
        [
            113.1862461385,
            23.245373300915
        ],
        [
            113.18622605072,
            23.24528491358
        ],
        [
            113.18619591575,
            23.245159520112
        ],
        [
            113.18616169906,
            23.245035544636
        ],
        [
            113.1861446081,
            23.244943585199
        ],
        [
            113.18613049479,
            23.244879517464
        ],
        [
            113.18611392499,
            23.244828777404
        ],
        [
            113.18609575499,
            23.244722187581
        ],
        [
            113.18609091269,
            23.244626515988
        ],
        [
            113.18607602748,
            23.244488684649
        ],
        [
            113.18607230567,
            23.244340919732
        ],
        [
            113.18606473372,
            23.244262106188
        ],
        [
            113.18605094629,
            23.244112595567
        ],
        [
            113.1860301104,
            23.243921693568
        ],
        [
            113.18602418587,
            23.243821428034
        ],
        [
            113.18601937566,
            23.243680461196
        ],
        [
            113.18600886409,
            23.243520323552
        ],
        [
            113.18600785438,
            23.243396386988
        ],
        [
            113.18600218839,
            23.243320799814
        ],
        [
            113.18598179089,
            23.243304021014
        ],
        [
            113.18591705184,
            23.243268383327
        ],
        [
            113.18584795708,
            23.243236606435
        ],
        [
            113.18577314212,
            23.243214948649
        ],
        [
            113.185676015,
            23.243193893648
        ],
        [
            113.18554378538,
            23.243177154932
        ],
        [
            113.18543822221,
            23.243161367598
        ],
        [
            113.18533646407,
            23.243153926412
        ],
        [
            113.18520722544,
            23.243147427722
        ],
        [
            113.18501133467,
            23.243130777047
        ],
        [
            113.18486251314,
            23.243120744737
        ],
        [
            113.1847558642,
            23.243112801783
        ],
        [
            113.18465003645,
            23.24309914513
        ],
        [
            113.18451863296,
            23.243089376394
        ],
        [
            113.18437199054,
            23.243087681941
        ],
        [
            113.18425609126,
            23.243089064332
        ],
        [
            113.18413801598,
            23.243092097546
        ],
        [
            113.18397968066,
            23.243091893244
        ],
        [
            113.18382243537,
            23.243093287006
        ],
        [
            113.18371633971,
            23.243090428839
        ],
        [
            113.1835846791,
            23.2430792394
        ],
        [
            113.1835493198,
            23.243070507279
        ],
        [
            113.18348376152,
            23.243066531096
        ],
        [
            113.18332190246,
            23.243065502352
        ],
        [
            113.18313202865,
            23.243063483179
        ],
        [
            113.18295059543,
            23.243055904263
        ],
        [
            113.18273271214,
            23.243055302262
        ],
        [
            113.18258039184,
            23.243048649966
        ],
        [
            113.18246914043,
            23.243051477622
        ],
        [
            113.18235109983,
            23.243040282839
        ],
        [
            113.18219008024,
            23.243038047614
        ],
        [
            113.18206034136,
            23.243037561579
        ],
        [
            113.18195263889,
            23.243031628133
        ],
        [
            113.1819273412,
            23.243036564378
        ],
        [
            113.18191836889,
            23.24303179756
        ],
        [
            113.18192547294,
            23.242982342676
        ],
        [
            113.18192253065,
            23.242907250217
        ],
        [
            113.18192284738,
            23.242839710316
        ],
        [
            113.181926722,
            23.242739306149
        ],
        [
            113.18194232893,
            23.242584505678
        ],
        [
            113.18194758663,
            23.242451536626
        ],
        [
            113.18195253208,
            23.242378512892
        ],
        [
            113.18195070061,
            23.242272757961
        ],
        [
            113.18195127928,
            23.242222302342
        ],
        [
            113.18193389725,
            23.242186181549
        ],
        [
            113.18191651588,
            23.242149246887
        ],
        [
            113.18186786326,
            23.242102948941
        ],
        [
            113.18179122138,
            23.24202201887
        ],
        [
            113.18172763756,
            23.241937935492
        ],
        [
            113.18167709929,
            23.241868059016
        ],
        [
            113.18166271722,
            23.241821861876
        ],
        [
            113.18164916422,
            23.241757210769
        ],
        [
            113.18165381257,
            23.241722163748
        ],
        [
            113.18170472723,
            23.241643946978
        ],
        [
            113.18174530185,
            23.241573454623
        ],
        [
            113.18178833442,
            23.241489368634
        ],
        [
            113.18185231853,
            23.241393350717
        ],
        [
            113.18192419187,
            23.241296144008
        ],
        [
            113.18197836752,
            23.241226013435
        ],
        [
            113.18204286823,
            23.241170936177
        ],
        [
            113.18211635643,
            23.241100551206
        ],
        [
            113.18217325726,
            23.241025767923
        ],
        [
            113.18223123469,
            23.240967242039
        ],
        [
            113.18225518357,
            23.240949028703
        ],
        [
            113.18228430189,
            23.240928848853
        ],
        [
            113.1823136801,
            23.240925209718
        ],
        [
            113.18234359962,
            23.240925360078
        ],
        [
            113.18238276168,
            23.240932982741
        ],
        [
            113.18245372028,
            23.240978156938
        ],
        [
            113.18251270199,
            23.241036233926
        ],
        [
            113.18258120752,
            23.241090114173
        ],
        [
            113.18268043456,
            23.241166094204
        ],
        [
            113.18276444326,
            23.24122437105
        ],
        [
            113.18284111678,
            23.241271350664
        ],
        [
            113.18291290812,
            23.241299949212
        ],
        [
            113.18296322732,
            23.241305509211
        ],
        [
            113.18302441971,
            23.24132204083
        ],
        [
            113.18305053023,
            23.241326840645
        ],
        [
            113.1830921351,
            23.241346889678
        ],
        [
            113.18313156104,
            23.241371035672
        ],
        [
            113.18317589367,
            23.241381281477
        ],
        [
            113.18321669289,
            23.241387777185
        ],
        [
            113.18324279896,
            23.241399625928
        ],
        [
            113.18327707055,
            23.241405124431
        ],
        [
            113.18331107982,
            23.24139733583
        ],
        [
            113.18332849128,
            23.241395198658
        ],
        [
            113.1833467543,
            23.241343957977
        ],
        [
            113.18338651311,
            23.241285641242
        ],
        [
            113.18345569048,
            23.241174300905
        ],
        [
            113.18347884177,
            23.241135467841
        ],
        [
            113.1834766962,
            23.241093457721
        ],
        [
            113.18346746499,
            23.241068903663
        ],
        [
            113.18343049083,
            23.241038222377
        ],
        [
            113.18326679937,
            23.240941471603
        ],
        [
            113.18316755332,
            23.240882342766
        ],
        [
            113.18305470318,
            23.240829088168
        ],
        [
            113.18295383026,
            23.240766714147
        ],
        [
            113.18285188102,
            23.240690516127
        ],
        [
            113.18277357495,
            23.240645457623
        ],
        [
            113.18270424733,
            23.240598648371
        ],
        [
            113.1826479726,
            23.24055735832
        ],
        [
            113.18262676767,
            23.240541909313
        ],
        [
            113.18261671803,
            23.240522514784
        ],
        [
            113.18261618341,
            23.240510045639
        ],
        [
            113.18264776274,
            23.240474909395
        ],
        [
            113.18268996156,
            23.240425256266
        ],
        [
            113.18274904034,
            23.240355848582
        ],
        [
            113.18280730244,
            23.240288077098
        ],
        [
            113.18288625425,
            23.240199412664
        ],
        [
            113.18296847344,
            23.240107988238
        ],
        [
            113.18303980905,
            23.240021589196
        ],
        [
            113.18311821905,
            23.239934006212
        ],
        [
            113.18319037024,
            23.239850573263
        ],
        [
            113.18322031937,
            23.239816804675
        ],
        [
            113.18325135656,
            23.239783291923
        ],
        [
            113.18329028981,
            23.239740720275
        ],
        [
            113.1833161581,
            23.239708090757
        ],
        [
            113.18334420914,
            23.239667294288
        ],
        [
            113.18340792675,
            23.239588036269
        ],
        [
            113.18344739996,
            23.239551962982
        ],
        [
            113.1834781746,
            23.239507872203
        ],
        [
            113.18348580708,
            23.239488239017
        ],
        [
            113.18347875467,
            23.239462299156
        ],
        [
            113.18347034682,
            23.239430411114
        ],
        [
            113.18343064553,
            23.239410616628
        ],
        [
            113.18338957955,
            23.23939680683
        ],
        [
            113.18335257277,
            23.239410062389
        ],
        [
            113.1832809947,
            23.23945335346
        ],
        [
            113.18322655473,
            23.239496950166
        ],
        [
            113.18320261445,
            23.239499446498
        ],
        [
            113.18315664491,
            23.239496004307
        ],
        [
            113.18309355261,
            23.239474350299
        ],
        [
            113.18302938302,
            23.239439689924
        ],
        [
            113.18296686073,
            23.239386561886
        ],
        [
            113.18296363461,
            23.239338599421
        ],
        [
            113.18298217826,
            23.239280308011
        ],
        [
            113.18302169556,
            23.239187016698
        ],
        [
            113.18303697666,
            23.239127141556
        ],
        [
            113.18303102786,
            23.23908274202
        ],
        [
            113.1830084897,
            23.239033684868
        ],
        [
            113.18295223727,
            23.23896501215
        ],
        [
            113.18289353569,
            23.238898269043
        ],
        [
            113.18280927509,
            23.238819661677
        ],
        [
            113.18269622523,
            23.238688817571
        ],
        [
            113.18259511185,
            23.238599303941
        ],
        [
            113.18254590743,
            23.238564697602
        ],
        [
            113.18250268724,
            23.238530281953
        ],
        [
            113.18246844234,
            23.238497102893
        ],
        [
            113.18245024021,
            23.238470492235
        ],
        [
            113.18244020965,
            23.238429941609
        ],
        [
            113.18244676685,
            23.238394596815
        ],
        [
            113.18248652386,
            23.238340371214
        ],
        [
            113.18254042323,
            23.23828866974
        ],
        [
            113.18260737562,
            23.238241403978
        ],
        [
            113.18263270655,
            23.238200113567
        ],
        [
            113.18263272756,
            23.238174890008
        ],
        [
            113.18262868566,
            23.238129107883
        ],
        [
            113.18257814625,
            23.238064957612
        ],
        [
            113.18247675486,
            23.237986560616
        ],
        [
            113.18239331316,
            23.237912532193
        ],
        [
            113.18231258702,
            23.237844973151
        ],
        [
            113.18226178328,
            23.237774849788
        ],
        [
            113.18223977959,
            23.237742048525
        ],
        [
            113.18223300866,
            23.237707963481
        ],
        [
            113.18224120261,
            23.237667716439
        ],
        [
            113.18228040725,
            23.237623538439
        ],
        [
            113.18232668319,
            23.237580351731
        ],
        [
            113.18232668435,
            23.237578995631
        ],
        [
            113.18236453115,
            23.237532934877
        ],
        [
            113.1824200625,
            23.237481758719
        ],
        [
            113.18248320974,
            23.23743129382
        ],
        [
            113.18255072432,
            23.237363682017
        ],
        [
            113.18255564187,
            23.237338664977
        ],
        [
            113.18256465494,
            23.237295693384
        ],
        [
            113.18254455655,
            23.237260972619
        ],
        [
            113.18253833968,
            23.237215490547
        ],
        [
            113.18253427995,
            23.237191948444
        ],
        [
            113.18257076073,
            23.237154579984
        ],
        [
            113.1826431723,
            23.237087442009
        ],
        [
            113.18270032114,
            23.237056033707
        ],
        [
            113.18277570243,
            23.237016243145
        ],
        [
            113.18289025854,
            23.236971854615
        ],
        [
            113.18302358635,
            23.236926661965
        ],
        [
            113.18312100344,
            23.236888184888
        ],
        [
            113.18323583398,
            23.236846752396
        ],
        [
            113.18331475853,
            23.236804990741
        ],
        [
            113.18341872157,
            23.236750947643
        ],
        [
            113.18351343356,
            23.236700551895
        ],
        [
            113.18355915168,
            23.23668229074
        ],
        [
            113.18360923057,
            23.236655017803
        ],
        [
            113.183647868,
            23.236646073826
        ],
        [
            113.18368078576,
            23.236645073807
        ],
        [
            113.18371069186,
            23.23666608355
        ],
        [
            113.18377563554,
            23.236751153101
        ],
        [
            113.18381720787,
            23.23680888339
        ],
        [
            113.18391503312,
            23.236936882118
        ],
        [
            113.18406172772,
            23.237182436069
        ],
        [
            113.1841239263,
            23.237300620291
        ],
        [
            113.18417257434,
            23.2373587847
        ],
        [
            113.1841959464,
            23.23738774433
        ],
        [
            113.18423510693,
            23.237406172962
        ],
        [
            113.18427237157,
            23.23741486396
        ],
        [
            113.18432625039,
            23.237402162267
        ],
        [
            113.18439183002,
            23.237387393095
        ],
        [
            113.18446666837,
            23.237363267399
        ],
        [
            113.18453525998,
            23.23732729503
        ],
        [
            113.18458615856,
            23.237301881445
        ],
        [
            113.18458780685,
            23.237283414984
        ],
        [
            113.18458188241,
            23.237212441736
        ],
        [
            113.18454412412,
            23.237143825384
        ],
        [
            113.18450230175,
            23.237056010364
        ],
        [
            113.18447107917,
            23.236981060712
        ],
        [
            113.1844651276,
            23.236942091056
        ],
        [
            113.184457,
            23.23690261017
        ],
        [
            113.18446301055,
            23.236873775102
        ],
        [
            113.184478271,
            23.236845349696
        ],
        [
            113.18451174432,
            23.236834833925
        ],
        [
            113.18457244884,
            23.236796532717
        ],
        [
            113.18463096274,
            23.2367748053
        ],
        [
            113.18471042924,
            23.23675006064
        ],
        [
            113.18475643134,
            23.236725255846
        ],
        [
            113.18482200461,
            23.236721591506
        ],
        [
            113.18485765183,
            23.236715648615
        ],
        [
            113.1848886719,
            23.236711942217
        ],
        [
            113.18491261817,
            23.23670806729
        ],
        [
            113.18493032896,
            23.236678788855
        ],
        [
            113.18495379523,
            23.236601963562
        ],
        [
            113.18495192309,
            23.23656510567
        ],
        [
            113.18493266876,
            23.236493243648
        ],
        [
            113.18487779424,
            23.236396677726
        ],
        [
            113.18478244876,
            23.236223944535
        ],
        [
            113.18469336792,
            23.236045420559
        ],
        [
            113.18463390363,
            23.23591230031
        ],
        [
            113.18456603238,
            23.235750008273
        ],
        [
            113.18453075256,
            23.235651523044
        ],
        [
            113.18451069476,
            23.235568548872
        ],
        [
            113.18447893919,
            23.235484657616
        ],
        [
            113.18446510512,
            23.235439292312
        ],
        [
            113.18445318548,
            23.235383050936
        ],
        [
            113.18444643449,
            23.235327549045
        ],
        [
            113.1844462385,
            23.235244289458
        ],
        [
            113.18445369343,
            23.235125120115
        ],
        [
            113.18445515947,
            23.235010104905
        ],
        [
            113.1844614775,
            23.234944380844
        ],
        [
            113.18446153682,
            23.234880102635
        ],
        [
            113.18447657783,
            23.234796353405
        ],
        [
            113.18448673913,
            23.234693960518
        ],
        [
            113.18449767782,
            23.234633594333
        ],
        [
            113.18451734986,
            23.234544082902
        ],
        [
            113.18452806886,
            23.234427850101
        ],
        [
            113.18453008521,
            23.234308216731
        ],
        [
            113.18454021258,
            23.234243251483
        ],
        [
            113.18455121185,
            23.234119149558
        ],
        [
            113.1845605504,
            23.234025447215
        ],
        [
            113.18457373556,
            23.233892092635
        ],
        [
            113.18458033382,
            23.233819584223
        ],
        [
            113.18459370621,
            23.233776268955
        ],
        [
            113.18462424707,
            23.233703415133
        ],
        [
            113.18466238147,
            23.233656487346
        ],
        [
            113.18472389835,
            23.233626306526
        ],
        [
            113.18479331806,
            23.233583262049
        ],
        [
            113.18489729053,
            23.233541881376
        ],
        [
            113.18500535271,
            23.233492841303
        ],
        [
            113.18514580632,
            23.233431114626
        ],
        [
            113.18520705106,
            23.233404448026
        ],
        [
            113.1852857192,
            23.233368029751
        ],
        [
            113.1853469737,
            23.233332137486
        ],
        [
            113.18540222718,
            23.233312333776
        ],
        [
            113.18543327498,
            23.233281768555
        ],
        [
            113.18545563112,
            23.233235330655
        ],
        [
            113.1854777215,
            23.233182387422
        ],
        [
            113.18548650703,
            23.233100622481
        ],
        [
            113.1854830642,
            23.23300249568
        ],
        [
            113.18548640021,
            23.232928948161
        ],
        [
            113.18547692387,
            23.23288027136
        ],
        [
            113.18545276087,
            23.232825032599
        ],
        [
            113.18537884327,
            23.232730392721
        ],
        [
            113.18533832506,
            23.232706312877
        ],
        [
            113.18529812382,
            23.232636121884
        ],
        [
            113.18523044582,
            23.23256199617
        ],
        [
            113.18515868048,
            23.232494708502
        ],
        [
            113.18508664077,
            23.232430405527
        ],
        [
            113.18503934849,
            23.232379026743
        ],
        [
            113.18495837105,
            23.232273897313
        ],
        [
            113.18489451149,
            23.23219319512
        ],
        [
            113.18479583966,
            23.23209943622
        ],
        [
            113.18470313503,
            23.232025655307
        ],
        [
            113.18460799209,
            23.231942412681
        ],
        [
            113.18452807607,
            23.231869252268
        ],
        [
            113.18444243221,
            23.23181162943
        ],
        [
            113.18437936532,
            23.231759104119
        ],
        [
            113.18430923568,
            23.23169610023
        ],
        [
            113.18425843964,
            23.231616003661
        ],
        [
            113.18419674738,
            23.231550434484
        ],
        [
            113.18413450292,
            23.231493549711
        ],
        [
            113.18408233309,
            23.231428384166
        ],
        [
            113.18394777789,
            23.231317458205
        ],
        [
            113.18386814008,
            23.23124480734
        ],
        [
            113.18379475884,
            23.231173421535
        ],
        [
            113.18371757749,
            23.231094220571
        ],
        [
            113.18365180329,
            23.2310343848
        ],
        [
            113.18356263768,
            23.230971344728
        ],
        [
            113.18350610003,
            23.230925478433
        ],
        [
            113.18342727558,
            23.230860118923
        ],
        [
            113.18335415055,
            23.230808780452
        ],
        [
            113.18328917061,
            23.230773871148
        ],
        [
            113.1832255535,
            23.230736771108
        ],
        [
            113.18317036459,
            23.23070470695
        ],
        [
            113.18312360154,
            23.230679849188
        ],
        [
            113.1831005019,
            23.230657652504
        ],
        [
            113.18306599145,
            23.230621507317
        ],
        [
            113.18305569419,
            23.230582050416
        ],
        [
            113.18305518356,
            23.230548698742
        ],
        [
            113.18305629447,
            23.230525902224
        ],
        [
            113.18309032465,
            23.230498320234
        ],
        [
            113.18314123228,
            23.23045884629
        ],
        [
            113.18316819039,
            23.23043108764
        ],
        [
            113.18317121316,
            23.230400671214
        ],
        [
            113.18315085007,
            23.230362165512
        ],
        [
            113.18310001694,
            23.230327327759
        ],
        [
            113.18301304302,
            23.230255279461
        ],
        [
            113.18287305194,
            23.230158717309
        ],
        [
            113.18279746644,
            23.230125016268
        ],
        [
            113.18270993609,
            23.230068689625
        ],
        [
            113.18266589299,
            23.230046766034
        ],
        [
            113.18260308594,
            23.230020751005
        ],
        [
            113.18254571295,
            23.230001170646
        ],
        [
            113.18248234098,
            23.229996855059
        ],
        [
            113.18239149958,
            23.22999072845
        ],
        [
            113.18230256076,
            23.229987012704
        ],
        [
            113.18217690132,
            23.229986210827
        ],
        [
            113.18210482071,
            23.229989858593
        ],
        [
            113.18209367921,
            23.229979968241
        ],
        [
            113.18208878858,
            23.229974878626
        ],
        [
            113.18207058386,
            23.229956672112
        ],
        [
            113.18206382408,
            23.229917163211
        ],
        [
            113.18204240211,
            23.22985289266
        ],
        [
            113.18202317286,
            23.229772049858
        ],
        [
            113.18201317209,
            23.229710072345
        ],
        [
            113.18202028985,
            23.229664417624
        ],
        [
            113.18203148608,
            23.229620066257
        ],
        [
            113.18204975131,
            23.229578335552
        ],
        [
            113.18210311677,
            23.229522861063
        ],
        [
            113.18219455837,
            23.22947014419
        ],
        [
            113.18229281062,
            23.229407840781
        ],
        [
            113.18235186505,
            23.22937669227
        ],
        [
            113.18239078774,
            23.229349874299
        ],
        [
            113.18241066362,
            23.229330086138
        ],
        [
            113.18241342602,
            23.229288283876
        ],
        [
            113.18240204574,
            23.229245311527
        ],
        [
            113.18235478242,
            23.229182198328
        ],
        [
            113.18228743241,
            23.229079207771
        ],
        [
            113.18221679182,
            23.229003106787
        ],
        [
            113.18217034933,
            23.228936451773
        ],
        [
            113.18214618865,
            23.228890931632
        ],
        [
            113.18214596747,
            23.228841032376
        ],
        [
            113.18214764501,
            23.228796261408
        ],
        [
            113.18216511941,
            23.228730402279
        ],
        [
            113.18218067776,
            23.228676501
        ],
        [
            113.18219678734,
            23.228615541015
        ],
        [
            113.18220009471,
            23.228572918451
        ],
        [
            113.18220068243,
            23.228530060083
        ],
        [
            113.18220943414,
            23.22848302731
        ],
        [
            113.18221113285,
            23.228417644291
        ],
        [
            113.1822245074,
            23.228371636056
        ],
        [
            113.18224006849,
            23.228315293331
        ],
        [
            113.18224362993,
            23.228290295836
        ],
        [
            113.18225833433,
            23.228273831538
        ],
        [
            113.18229045543,
            23.228248460876
        ],
        [
            113.18233289985,
            23.228235429888
        ],
        [
            113.18236799302,
            23.228229816846
        ],
        [
            113.1824183101,
            23.228232139076
        ],
        [
            113.182470788,
            23.228249618835
        ],
        [
            113.18251648387,
            23.228249829281
        ],
        [
            113.18255917878,
            23.228259028006
        ],
        [
            113.18260106927,
            23.228257116799
        ],
        [
            113.18263998673,
            23.228236801961
        ],
        [
            113.18267511925,
            23.228194026414
        ],
        [
            113.18272557977,
            23.228058021744
        ],
        [
            113.18277628633,
            23.227947776908
        ],
        [
            113.18279649675,
            23.22786804294
        ],
        [
            113.1828254576,
            23.227743442374
        ],
        [
            113.18284567183,
            23.227660182088
        ],
        [
            113.18286234713,
            23.22757968114
        ],
        [
            113.18288607548,
            23.227518069731
        ],
        [
            113.18291932706,
            23.227453888987
        ],
        [
            113.18294306478,
            23.227383326829
        ],
        [
            113.18298257143,
            23.227320687789
        ],
        [
            113.18303269744,
            23.227247869571
        ],
        [
            113.18305448126,
            23.227226149457
        ],
        [
            113.18309015033,
            23.227192578947
        ],
        [
            113.18312009812,
            23.227167763987
        ],
        [
            113.18314623543,
            23.22714516995
        ],
        [
            113.18319466375,
            23.22713718836
        ],
        [
            113.18326677036,
            23.227117762523
        ],
        [
            113.18332390023,
            23.227113726417
        ],
        [
            113.18345039107,
            23.227116870742
        ],
        [
            113.1835613717,
            23.227125915777
        ],
        [
            113.18364489695,
            23.227116350673
        ],
        [
            113.18374310373,
            23.227116069181
        ],
        [
            113.18381520085,
            23.227110452107
        ],
        [
            113.18389954335,
            23.227102219472
        ],
        [
            113.18402442715,
            23.227089072366
        ],
        [
            113.18411803389,
            23.227068765656
        ],
        [
            113.1841849909,
            23.22703798415
        ],
        [
            113.1842312804,
            23.226999086665
        ],
        [
            113.18423865446,
            23.226971318784
        ],
        [
            113.1842465771,
            23.22693920377
        ],
        [
            113.18424502524,
            23.226860847208
        ],
        [
            113.18425551432,
            23.226713975379
        ],
        [
            113.18426348548,
            23.226634669706
        ],
        [
            113.18427066584,
            23.226530695484
        ],
        [
            113.18427559417,
            23.226500250212
        ],
        [
            113.18428786625,
            23.226471598772
        ],
        [
            113.18431998976,
            23.226451614027
        ],
        [
            113.18436679625,
            23.226439826373
        ],
        [
            113.18443019599,
            23.226430783201
        ],
        [
            113.18448787186,
            23.226432397061
        ],
        [
            113.18460594433,
            23.226436664983
        ],
        [
            113.18465735387,
            23.226447856127
        ],
        [
            113.18473571509,
            23.226443196836
        ],
        [
            113.18477244935,
            23.226438867409
        ],
        [
            113.18480294769,
            23.226413473756
        ],
        [
            113.18483945418,
            23.226366295751
        ],
        [
            113.18488008438,
            23.22627783365
        ],
        [
            113.18491526142,
            23.226200840871
        ],
        [
            113.18493710852,
            23.226122143579
        ],
        [
            113.18494612124,
            23.226088924875
        ],
        [
            113.18496632197,
            23.226023811593
        ],
        [
            113.18497534921,
            23.225976489817
        ],
        [
            113.18500150713,
            23.225939223341
        ],
        [
            113.18504371424,
            23.225905518359
        ],
        [
            113.18512457461,
            23.225854972621
        ],
        [
            113.1851869202,
            23.225817714087
        ],
        [
            113.18523076904,
            23.225775844674
        ],
        [
            113.18527298525,
            23.225734269595
        ],
        [
            113.18532391113,
            23.225690123931
        ],
        [
            113.18535877702,
            23.22565272382
        ],
        [
            113.18539775399,
            23.225586514276
        ],
        [
            113.18543020832,
            23.225513078247
        ],
        [
            113.18542729687,
            23.22543365806
        ],
        [
            113.18541429168,
            23.225379881048
        ],
        [
            113.18538744028,
            23.225296476582
        ],
        [
            113.18534860984,
            23.225220029287
        ],
        [
            113.18529289895,
            23.225154407775
        ],
        [
            113.18520974509,
            23.225052305165
        ],
        [
            113.18518692851,
            23.225014672335
        ],
        [
            113.18516275377,
            23.224974889565
        ],
        [
            113.18512361315,
            23.22493641122
        ],
        [
            113.18503663151,
            23.224853884248
        ],
        [
            113.18496920558,
            23.224805239732
        ],
        [
            113.18487541777,
            23.224728228978
        ],
        [
            113.18478843172,
            23.224652199696
        ],
        [
            113.18475091148,
            23.224626979293
        ],
        [
            113.18473325264,
            23.224601741758
        ],
        [
            113.18472211586,
            23.224584003416
        ],
        [
            113.18472433774,
            23.22453976459
        ],
        [
            113.18473038366,
            23.224480825228
        ],
        [
            113.18475356288,
            23.224428960138
        ],
        [
            113.18480179354,
            23.224356933072
        ],
        [
            113.18489519665,
            23.224277466964
        ],
        [
            113.18497609232,
            23.224190856505
        ],
        [
            113.18507548798,
            23.224106412282
        ],
        [
            113.18518194457,
            23.22403596176
        ],
        [
            113.18520100107,
            23.224025646524
        ],
        [
            113.18530065339,
            23.223958544199
        ],
        [
            113.18539403774,
            23.223902106823
        ],
        [
            113.18551898885,
            23.223842754393
        ],
        [
            113.18557450902,
            23.223830265031
        ],
        [
            113.18566486799,
            23.223808032126
        ],
        [
            113.18573752216,
            23.223804502856
        ],
        [
            113.18579357063,
            23.223808814361
        ],
        [
            113.18583983902,
            23.223798083962
        ],
        [
            113.18590382485,
            23.223757523907
        ],
        [
            113.1859239886,
            23.223730099087
        ],
        [
            113.18595013992,
            23.223701498827
        ],
        [
            113.18597794524,
            23.223651990327
        ],
        [
            113.18598697021,
            23.223607376006
        ],
        [
            113.18598923794,
            23.223518114732
        ],
        [
            113.18598987735,
            23.223424538758
        ],
        [
            113.18597550316,
            23.2233778373
        ],
        [
            113.18596848561,
            23.223321532351
        ],
        [
            113.1859489639,
            23.22325266952
        ],
        [
            113.18594660494,
            23.223164020513
        ],
        [
            113.18595131556,
            23.223080417665
        ],
        [
            113.1859595358,
            23.223024153676
        ],
        [
            113.18598542373,
            23.222986878303
        ],
        [
            113.1860257257,
            23.222957249454
        ],
        [
            113.18608779253,
            23.222931629124
        ],
        [
            113.18611392705,
            23.222919841866
        ],
        [
            113.18615555136,
            23.222928430621
        ],
        [
            113.1862135048,
            23.222934871517
        ],
        [
            113.18629266491,
            23.222959700495
        ],
        [
            113.18637614053,
            23.223022971869
        ],
        [
            113.18645852004,
            23.223094393009
        ],
        [
            113.18658058739,
            23.223207779703
        ],
        [
            113.18669097429,
            23.22330181315
        ],
        [
            113.18674943027,
            23.223352167393
        ],
        [
            113.1868081631,
            23.223398176496
        ],
        [
            113.18687996888,
            23.223433946384
        ],
        [
            113.18695612075,
            23.223478053731
        ],
        [
            113.18702059658,
            23.223497389632
        ],
        [
            113.18706903312,
            23.223500701848
        ],
        [
            113.18711992134,
            23.223501805051
        ],
        [
            113.18721299487,
            23.223499262838
        ],
        [
            113.18729927409,
            23.223488416285
        ],
        [
            113.18739563058,
            23.223470356433
        ],
        [
            113.18750885839,
            23.223454738156
        ],
        [
            113.18761774664,
            23.223425622989
        ],
        [
            113.18770457897,
            23.223409057674
        ],
        [
            113.18782137259,
            23.223368959563
        ],
        [
            113.18797927644,
            23.223315452009
        ],
        [
            113.18808055966,
            23.223275318612
        ],
        [
            113.18813204121,
            23.223232455568
        ],
        [
            113.18823853782,
            23.223151822428
        ],
        [
            113.18830610645,
            23.223080491427
        ],
        [
            113.18834891519,
            23.223002507013
        ],
        [
            113.18838135659,
            23.222949369162
        ],
        [
            113.18842415258,
            23.222884130428
        ],
        [
            113.18847892119,
            23.222821680487
        ],
        [
            113.18853342166,
            23.222755436867
        ],
        [
            113.18855550822,
            23.222714940195
        ],
        [
            113.1885604731,
            23.222649770052
        ],
        [
            113.18855235969,
            23.222598643538
        ],
        [
            113.18851028164,
            23.222491656388
        ],
        [
            113.18847879123,
            23.222411346667
        ],
        [
            113.18844811844,
            23.222329938504
        ],
        [
            113.18839703237,
            23.222249402275
        ],
        [
            113.18834594535,
            23.222169949882
        ],
        [
            113.18831659781,
            23.222124046889
        ],
        [
            113.18829296555,
            23.22207832266
        ],
        [
            113.18824922402,
            23.222002004428
        ],
        [
            113.18821447056,
            23.221919031892
        ],
        [
            113.18816854912,
            23.221845459402
        ],
        [
            113.1881484611,
            23.221793710299
        ],
        [
            113.18813379166,
            23.221766553916
        ],
        [
            113.188121582,
            23.221729052083
        ],
        [
            113.18811022379,
            23.221656550758
        ],
        [
            113.18810432639,
            23.221566333269
        ],
        [
            113.1880899748,
            23.221493337427
        ],
        [
            113.18807615911,
            23.221428740336
        ],
        [
            113.18807186824,
            23.221364804104
        ],
        [
            113.18805642974,
            23.221289926998
        ],
        [
            113.18804806738,
            23.221214936419
        ],
        [
            113.18804813012,
            23.221151743974
        ],
        [
            113.18804953802,
            23.221104260027
        ],
        [
            113.18805992159,
            23.221062327611
        ],
        [
            113.18810541896,
            23.221014950276
        ],
        [
            113.18814218494,
            23.220990222622
        ],
        [
            113.18818031076,
            23.220966557416
        ],
        [
            113.18823095014,
            23.220948928082
        ],
        [
            113.18825354932,
            23.220939072017
        ],
        [
            113.18833357773,
            23.220926391471
        ],
        [
            113.18837004802,
            23.22092607408
        ],
        [
            113.18841877035,
            23.220921218836
        ],
        [
            113.18848245932,
            23.220919103739
        ],
        [
            113.18855867659,
            23.220908647738
        ],
        [
            113.1886272592,
            23.220912687621
        ],
        [
            113.18871354379,
            23.220906131841
        ],
        [
            113.18881969605,
            23.220901147785
        ],
        [
            113.18891932111,
            23.220891927057
        ],
        [
            113.18907773029,
            23.220889875363
        ],
        [
            113.18925629031,
            23.220880160585
        ],
        [
            113.18935944996,
            23.220877917808
        ],
        [
            113.18940600072,
            23.220870640354
        ],
        [
            113.18950345534,
            23.220858452122
        ],
        [
            113.18959247797,
            23.220840976392
        ],
        [
            113.18968475084,
            23.220840259003
        ],
        [
            113.18979499353,
            23.220834900544
        ],
        [
            113.18988236164,
            23.220840767955
        ],
        [
            113.18993298038,
            23.220850229659
        ],
        [
            113.18999038176,
            23.220882358751
        ],
        [
            113.19012342532,
            23.220943596443
        ],
        [
            113.19027358844,
            23.221035187894
        ],
        [
            113.1904248473,
            23.22112105886
        ],
        [
            113.1905146175,
            23.221178398707
        ],
        [
            113.19062998236,
            23.221228795053
        ],
        [
            113.19073934525,
            23.22129339204
        ],
        [
            113.19086504294,
            23.221356352785
        ],
        [
            113.19095321081,
            23.221384689699
        ],
        [
            113.19105417192,
            23.221414163075
        ],
        [
            113.19114725843,
            23.221424512186
        ],
        [
            113.19122428957,
            23.221429979894
        ],
        [
            113.19129697847,
            23.221422502267
        ],
        [
            113.19138437489,
            23.221407449444
        ],
        [
            113.1914625145,
            23.221394180366
        ],
        [
            113.19157741786,
            23.221366990924
        ],
        [
            113.19163949341,
            23.221357519463
        ],
        [
            113.1916803477,
            23.221336206933
        ],
        [
            113.1917778343,
            23.221304700402
        ],
        [
            113.19183147543,
            23.221291302999
        ],
        [
            113.19190146628,
            23.221261622411
        ],
        [
            113.19198644019,
            23.221221376794
        ],
        [
            113.19209539275,
            23.221158477058
        ],
        [
            113.19218719437,
            23.221096684631
        ],
        [
            113.19225475415,
            23.221048869839
        ],
        [
            113.19232448794,
            23.221005084631
        ],
        [
            113.19239530277,
            23.220969415965
        ],
        [
            113.1924426887,
            23.220951238214
        ],
        [
            113.19250560903,
            23.220915704737
        ],
        [
            113.19254782187,
            23.220898429301
        ],
        [
            113.19259656523,
            23.22088429473
        ],
        [
            113.19266245368,
            23.220875828666
        ],
        [
            113.19272888194,
            23.220872234165
        ],
        [
            113.19277923089,
            23.220886546877
        ],
        [
            113.19282712683,
            23.22090388508
        ],
        [
            113.1928954287,
            23.220933072156
        ],
        [
            113.19298576146,
            23.220982757728
        ],
        [
            113.19315418223,
            23.221076914228
        ],
        [
            113.19332966084,
            23.221192368213
        ],
        [
            113.19341482316,
            23.221241053027
        ],
        [
            113.19352066033,
            23.221305376194
        ],
        [
            113.19359522413,
            23.221335530919
        ],
        [
            113.19364473715,
            23.221370463069
        ],
        [
            113.19369236422,
            23.2213856298
        ],
        [
            113.19373482138,
            23.221398174784
        ],
        [
            113.19379144811,
            23.221397724297
        ],
        [
            113.19384535461,
            23.221395151461
        ],
        [
            113.19389083746,
            23.221376724871
        ],
        [
            113.19397635159,
            23.221346746833
        ],
        [
            113.19405044846,
            23.221299882454
        ],
        [
            113.19410793582,
            23.221255750244
        ],
        [
            113.19417713965,
            23.221201648162
        ],
        [
            113.19426376512,
            23.221149679904
        ],
        [
            113.19432805597,
            23.221108409847
        ],
        [
            113.19440623462,
            23.221063911532
        ],
        [
            113.19442857478,
            23.221047788087
        ],
        [
            113.19444463865,
            23.221046420341
        ],
        [
            113.19447214541,
            23.221036443572
        ],
        [
            113.19450373379,
            23.221028564478
        ],
        [
            113.19455193357,
            23.221016324443
        ],
        [
            113.19460011994,
            23.221017644802
        ],
        [
            113.19461346888,
            23.221008730844
        ],
        [
            113.19465022798,
            23.221002929822
        ],
        [
            113.19468998377,
            23.220995177378
        ],
        [
            113.19474497711,
            23.220995834652
        ],
        [
            113.19479235066,
            23.220993371627
        ],
        [
            113.19487129107,
            23.221004996487
        ],
        [
            113.19492846611,
            23.22100208873
        ],
        [
            113.19500168748,
            23.221015712212
        ],
        [
            113.19505094442,
            23.221035996407
        ],
        [
            113.19511190803,
            23.221056344806
        ],
        [
            113.19518076087,
            23.221082791302
        ],
        [
            113.19521913958,
            23.221091334052
        ],
        [
            113.19527875038,
            23.22110329827
        ],
        [
            113.19531522443,
            23.221110789638
        ],
        [
            113.19536095542,
            23.221117846029
        ],
        [
            113.19542411613,
            23.221119169887
        ],
        [
            113.1954815598,
            23.221120323463
        ],
        [
            113.19553872344,
            23.221129346845
        ],
        [
            113.19562446424,
            23.221147627846
        ],
        [
            113.19568843003,
            23.22116086979
        ],
        [
            113.19578342817,
            23.22117844397
        ],
        [
            113.19588141903,
            23.221198134504
        ],
        [
            113.19595601181,
            23.221202237851
        ],
        [
            113.19607306124,
            23.221221047951
        ],
        [
            113.19620127594,
            23.22123694792
        ],
        [
            113.19633573828,
            23.221267110954
        ],
        [
            113.19648408762,
            23.221295129371
        ],
        [
            113.19659921085,
            23.221334584644
        ],
        [
            113.19669720295,
            23.221353189276
        ],
        [
            113.19673041312,
            23.221357753919
        ],
        [
            113.19675382258,
            23.221361949766
        ],
        [
            113.19677345881,
            23.221327701036
        ],
        [
            113.19678877696,
            23.221255288572
        ],
        [
            113.19681963925,
            23.221156836064
        ],
        [
            113.19686058592,
            23.221047085417
        ],
        [
            113.19690805422,
            23.2209496948
        ],
        [
            113.19695415574,
            23.220857752555
        ],
        [
            113.19702777884,
            23.220741185459
        ],
        [
            113.19709842079,
            23.220610568434
        ],
        [
            113.19718676631,
            23.220472315444
        ],
        [
            113.19725603974,
            23.220348503068
        ],
        [
            113.19729723043,
            23.220266140305
        ],
        [
            113.19736594244,
            23.220159152968
        ],
        [
            113.19741640278,
            23.220063065877
        ],
        [
            113.19749876811,
            23.219913799938
        ],
        [
            113.19756475498,
            23.219808759738
        ],
        [
            113.19760839196,
            23.219729608611
        ],
        [
            113.19766241526,
            23.219608236529
        ],
        [
            113.19773003552,
            23.219502625481
        ],
        [
            113.19779055883,
            23.219415853523
        ],
        [
            113.19787507614,
            23.219291502098
        ],
        [
            113.19792115,
            23.219225326595
        ],
        [
            113.1979849283,
            23.219150431
        ],
        [
            113.19805661324,
            23.219063462836
        ],
        [
            113.19814386492,
            23.218925504052
        ],
        [
            113.19821941133,
            23.218785582641
        ],
        [
            113.19831782695,
            23.218644715821
        ],
        [
            113.19837974639,
            23.218519138524
        ],
        [
            113.19848225654,
            23.218365725096
        ],
        [
            113.19855969798,
            23.218234993356
        ],
        [
            113.19864559577,
            23.218085942124
        ],
        [
            113.198723842,
            23.217966859377
        ],
        [
            113.1988037266,
            23.21784205296
        ],
        [
            113.19888825209,
            23.217703062599
        ],
        [
            113.1989291729,
            23.217612572399
        ],
        [
            113.19897362693,
            23.217528258133
        ],
        [
            113.19904833414,
            23.217406799168
        ],
        [
            113.19909823485,
            23.217319948921
        ],
        [
            113.19916529786,
            23.21722086446
        ],
        [
            113.1992157378,
            23.217139158427
        ],
        [
            113.19925935371,
            23.217076828395
        ],
        [
            113.19932039793,
            23.217009040082
        ],
        [
            113.19937436901,
            23.216935409489
        ],
        [
            113.19945667435,
            23.216838230087
        ],
        [
            113.19949320351,
            23.216784433001
        ],
        [
            113.19954090492,
            23.216719049686
        ],
        [
            113.19958561886,
            23.216645582546
        ],
        [
            113.19963905075,
            23.216564911727
        ],
        [
            113.1996952063,
            23.21648256643
        ],
        [
            113.19974453574,
            23.216422309046
        ],
        [
            113.19982713697,
            23.216296380095
        ],
        [
            113.19988057333,
            23.216209473115
        ],
        [
            113.19992746497,
            23.216134614056
        ],
        [
            113.19998091601,
            23.216030621147
        ],
        [
            113.20003353116,
            23.215947797882
        ],
        [
            113.20007662055,
            23.215861886325
        ],
        [
            113.2001047339,
            23.21577921906
        ],
        [
            113.2001576315,
            23.215683916007
        ],
        [
            113.20020944957,
            23.215577512367
        ],
        [
            113.20025500198,
            23.215475557461
        ],
        [
            113.20030108476,
            23.215389324098
        ],
        [
            113.2003446824,
            23.215343002801
        ],
        [
            113.20038992206,
            23.215286618389
        ],
        [
            113.20043814625,
            23.215241573589
        ],
        [
            113.20046921383,
            23.215203335862
        ],
        [
            113.20049129005,
            23.215173933067
        ],
        [
            113.20053433722,
            23.215133860737
        ],
        [
            113.20057304143,
            23.21507894714
        ],
        [
            113.20068965984,
            23.214958136138
        ],
        [
            113.20076756893,
            23.214897935258
        ],
        [
            113.20086346931,
            23.21480894731
        ],
        [
            113.20096835914,
            23.21471221217
        ],
        [
            113.201062895,
            23.214625692589
        ],
        [
            113.20115607278,
            23.214534858792
        ],
        [
            113.20123617366,
            23.214455371407
        ],
        [
            113.20130646273,
            23.214389343458
        ],
        [
            113.20138819057,
            23.214316340016
        ],
        [
            113.20146502543,
            23.214234471747
        ],
        [
            113.201544021,
            23.214172366679
        ],
        [
            113.20160941551,
            23.214098019594
        ],
        [
            113.20168759812,
            23.214030506747
        ],
        [
            113.20177041748,
            23.213951525151
        ],
        [
            113.20183824789,
            23.213892599472
        ],
        [
            113.20190825345,
            23.213836350078
        ],
        [
            113.20199269373,
            23.213770635096
        ],
        [
            113.2020466358,
            23.213717102218
        ],
        [
            113.20212589801,
            23.21365771608
        ],
        [
            113.20218119212,
            23.21361446842
        ],
        [
            113.20226998963,
            23.213544346168
        ],
        [
            113.20239392158,
            23.21344922271
        ],
        [
            113.20249578961,
            23.21337156223
        ],
        [
            113.20260528457,
            23.213286453346
        ],
        [
            113.20269325271,
            23.21322856025
        ],
        [
            113.20276625235,
            23.213166852325
        ],
        [
            113.2028547588,
            23.213115192345
        ],
        [
            113.20295716086,
            23.213045944182
        ],
        [
            113.20307072661,
            23.212971088399
        ],
        [
            113.20314017226,
            23.212925992306
        ],
        [
            113.20323494883,
            23.212859049693
        ],
        [
            113.20335095753,
            23.212789587487
        ],
        [
            113.20342503836,
            23.212732486964
        ],
        [
            113.20348196145,
            23.212687334788
        ],
        [
            113.20351818579,
            23.21265771449
        ],
        [
            113.2036279251,
            23.212596502996
        ],
        [
            113.20374093969,
            23.212522494176
        ],
        [
            113.20382318063,
            23.212469065973
        ],
        [
            113.2039277396,
            23.212415816122
        ],
        [
            113.20401896547,
            23.212356821568
        ],
        [
            113.2041270729,
            23.21228833247
        ],
        [
            113.20421828627,
            23.212243447978
        ],
        [
            113.20429479979,
            23.21220097554
        ],
        [
            113.20442877616,
            23.212112549115
        ],
        [
            113.20449631183,
            23.212063447505
        ],
        [
            113.20458644175,
            23.212008015164
        ],
        [
            113.20467629026,
            23.211963710478
        ],
        [
            113.20477295609,
            23.211901127213
        ],
        [
            113.20485927139,
            23.211848477804
        ],
        [
            113.20495374489,
            23.211803565885
        ],
        [
            113.20504114391,
            23.211755515962
        ],
        [
            113.20513263053,
            23.211699538359
        ],
        [
            113.20521703642,
            23.211648830074
        ],
        [
            113.20526305296,
            23.211618534327
        ],
        [
            113.20529818455,
            23.21158651387
        ],
        [
            113.20533956698,
            23.211565785985
        ],
        [
            113.20541117132,
            23.21152695017
        ],
        [
            113.20549393555,
            23.211484956493
        ],
        [
            113.20559711281,
            23.211439117726
        ],
        [
            113.20569810465,
            23.211403081808
        ],
        [
            113.20581107626,
            23.211358183202
        ],
        [
            113.20590035664,
            23.211332374899
        ],
        [
            113.205980384,
            23.211306171994
        ],
        [
            113.20603863283,
            23.211289803927
        ],
        [
            113.20610750043,
            23.21126540672
        ],
        [
            113.20616574937,
            23.211247957017
        ],
        [
            113.2062558566,
            23.211203977836
        ],
        [
            113.20635466454,
            23.211168818285
        ],
        [
            113.2064469419,
            23.211131865133
        ],
        [
            113.20655773416,
            23.211079171874
        ],
        [
            113.20660973127,
            23.211048811085
        ],
        [
            113.20668349891,
            23.211016491224
        ],
        [
            113.20678640595,
            23.210951725165
        ],
        [
            113.20685718369,
            23.210912947479
        ],
        [
            113.20690809499,
            23.210876643499
        ],
        [
            113.20697016222,
            23.2108407141
        ],
        [
            113.20700799386,
            23.210829020945
        ],
        [
            113.20706406752,
            23.210802135447
        ],
        [
            113.20711741507,
            23.210781801957
        ],
        [
            113.20722111844,
            23.210737929388
        ],
        [
            113.20728399596,
            23.210707421668
        ],
        [
            113.20739014132,
            23.210670572861
        ],
        [
            113.20746662985,
            23.210629832047
        ],
        [
            113.2075431119,
            23.210597230972
        ],
        [
            113.20764082829,
            23.21054804444
        ],
        [
            113.20776249686,
            23.210485490179
        ],
        [
            113.20785204605,
            23.210439418142
        ],
        [
            113.20792281329,
            23.210403661169
        ],
        [
            113.20803495348,
            23.210343433557
        ],
        [
            113.20812041939,
            23.210296348713
        ],
        [
            113.20816778165,
            23.210266637775
        ],
        [
            113.20823665085,
            23.210217901132
        ],
        [
            113.20831912982,
            23.210159477068
        ],
        [
            113.20841139247,
            23.210115290433
        ],
        [
            113.20848297799,
            23.210069778302
        ],
        [
            113.20856108853,
            23.210029871068
        ],
        [
            113.20862832154,
            23.209981714695
        ],
        [
            113.20870480916,
            23.209926105625
        ],
        [
            113.20879924393,
            23.209881907316
        ],
        [
            113.20892253551,
            23.209808284299
        ],
        [
            113.20907413515,
            23.209709861076
        ],
        [
            113.20920286936,
            23.209627230274
        ],
        [
            113.20928206685,
            23.209578659649
        ],
        [
            113.20937624136,
            23.209506830203
        ],
        [
            113.20951150814,
            23.209410841057
        ],
        [
            113.20959125437,
            23.209350342804
        ],
        [
            113.2096731882,
            23.209271374715
        ],
        [
            113.20975213134,
            23.20918838295
        ],
        [
            113.20979296678,
            23.209140631556
        ],
        [
            113.20986184339,
            23.209057782173
        ],
        [
            113.20993044995,
            23.208970599538
        ],
        [
            113.21001374036,
            23.20889000185
        ],
        [
            113.21008671115,
            23.208781339394
        ],
        [
            113.21015395319,
            23.208696625138
        ],
        [
            113.21024460977,
            23.208576611577
        ],
        [
            113.21032763477,
            23.208478402927
        ],
        [
            113.21038643961,
            23.208396793872
        ],
        [
            113.21045748773,
            23.208309057587
        ],
        [
            113.21056093412,
            23.208170990497
        ],
        [
            113.21064669493,
            23.208038857775
        ],
        [
            113.21068699296,
            23.207969165276
        ],
        [
            113.21072266071,
            23.207909298635
        ],
        [
            113.21079644321,
            23.207789535731
        ],
        [
            113.2108647674,
            23.207698597592
        ],
        [
            113.21092603661,
            23.207577918137
        ],
        [
            113.21096987741,
            23.207491641396
        ],
        [
            113.21101698226,
            23.207403967536
        ],
        [
            113.21107768286,
            23.207321002325
        ],
        [
            113.21113213352,
            23.207226998962
        ],
        [
            113.21121407538,
            23.207094130912
        ],
        [
            113.211253282,
            23.20702039761
        ],
        [
            113.21129521758,
            23.206929542789
        ],
        [
            113.21132543269,
            23.206883320222
        ],
        [
            113.21135783202,
            23.206821610175
        ],
        [
            113.21143405887,
            23.206686655773
        ],
        [
            113.21149449033,
            23.206587706756
        ],
        [
            113.21155029167,
            23.206499396306
        ],
        [
            113.21160854403,
            23.206403462538
        ],
        [
            113.21166434349,
            23.206315698576
        ],
        [
            113.21172014666,
            23.20621952822
        ],
        [
            113.21177077805,
            23.206130476129
        ],
        [
            113.21183910422,
            23.206006217262
        ],
        [
            113.21188320575,
            23.205919690621
        ],
        [
            113.21193357037,
            23.205816000204
        ],
        [
            113.21199971956,
            23.20568797768
        ],
        [
            113.21206124591,
            23.205556759522
        ],
        [
            113.21211786421,
            23.205449201198
        ],
        [
            113.21216249918,
            23.205375966463
        ],
        [
            113.21221286429,
            23.205261977807
        ],
        [
            113.21226240529,
            23.20516319006
        ],
        [
            113.21230241776,
            23.205085132868
        ],
        [
            113.21235032531,
            23.204987181296
        ],
        [
            113.21239987034,
            23.204875107091
        ],
        [
            113.21246519371,
            23.204747385216
        ],
        [
            113.21250139111,
            23.204681041999
        ],
        [
            113.21259173705,
            23.204537024303
        ],
        [
            113.2126543342,
            23.204416395027
        ],
        [
            113.21271366451,
            23.204301502822
        ],
        [
            113.21280645524,
            23.204150959334
        ],
        [
            113.2128510947,
            23.20404682297
        ],
        [
            113.21289871174,
            23.203972489854
        ],
        [
            113.21292185128,
            23.203909292375
        ],
        [
            113.21296022491,
            23.203828830124
        ],
        [
            113.21303042805,
            23.203708399306
        ],
        [
            113.21306635333,
            23.203627425532
        ],
        [
            113.21310362828,
            23.203569492765
        ],
        [
            113.213185254,
            23.203435104491
        ],
        [
            113.21322634087,
            23.203360856572
        ],
        [
            113.21332483157,
            23.203200515426
        ],
        [
            113.2133931204,
            23.203089617052
        ],
        [
            113.21345623315,
            23.203002107173
        ],
        [
            113.21351472714,
            23.202902988271
        ],
        [
            113.21361211775,
            23.202755698645
        ],
        [
            113.21369074197,
            23.202619473306
        ],
        [
            113.21374868993,
            23.202515758692
        ],
        [
            113.2138302931,
            23.20240392026
        ],
        [
            113.21389204315,
            23.202305594618
        ],
        [
            113.21395596906,
            23.202201551752
        ],
        [
            113.21402424267,
            23.202100719586
        ],
        [
            113.21410476501,
            23.201951205193
        ],
        [
            113.21416405852,
            23.201868378991
        ],
        [
            113.21425463161,
            23.201733683894
        ],
        [
            113.21434873476,
            23.201605195962
        ],
        [
            113.21440612404,
            23.201514533998
        ],
        [
            113.21451980033,
            23.201374187441
        ],
        [
            113.21460654896,
            23.201275089126
        ],
        [
            113.21466338788,
            23.201194479842
        ],
        [
            113.21469956709,
            23.201110017593
        ],
        [
            113.214772995,
            23.200999675065
        ],
        [
            113.21483146428,
            23.200912003418
        ],
        [
            113.21490217007,
            23.200806035706
        ],
        [
            113.21497478292,
            23.200678623422
        ],
        [
            113.21502292593,
            23.200565566874
        ],
        [
            113.21505909364,
            23.200507967993
        ],
        [
            113.21510532414,
            23.200427755102
        ],
        [
            113.21516977457,
            23.200312641358
        ],
        [
            113.21523829359,
            23.200228684384
        ],
        [
            113.21528724177,
            23.200140041826
        ],
        [
            113.21534352465,
            23.200066790231
        ],
        [
            113.21542047728,
            23.199936375099
        ],
        [
            113.2155034052,
            23.199818383932
        ],
        [
            113.21555588447,
            23.199722392879
        ],
        [
            113.21560999398,
            23.199624760604
        ],
        [
            113.21568041691,
            23.199495508315
        ],
        [
            113.21571576757,
            23.199410809279
        ],
        [
            113.21577885246,
            23.19926508562
        ],
        [
            113.21580821861,
            23.199199162559
        ],
        [
            113.21584166932,
            23.199088444081
        ],
        [
            113.21588707942,
            23.19896974708
        ],
        [
            113.21592297218,
            23.198872841565
        ],
        [
            113.21598088671,
            23.198728260637
        ],
        [
            113.21601189149,
            23.198592341882
        ],
        [
            113.21607170114,
            23.198478127947
        ],
        [
            113.21610025116,
            23.19838861907
        ],
        [
            113.21614021666,
            23.198290053793
        ],
        [
            113.2161679496,
            23.198204622687
        ],
        [
            113.21621008914,
            23.19809627404
        ],
        [
            113.21623891158,
            23.197980995677
        ],
        [
            113.2162690898,
            23.197885507477
        ],
        [
            113.21629301652,
            23.197790619334
        ],
        [
            113.2163025386,
            23.197696676317
        ],
        [
            113.21633652272,
            23.19757212981
        ],
        [
            113.21635963159,
            23.197484845348
        ],
        [
            113.21638518874,
            23.197364716378
        ],
        [
            113.21640394764,
            23.197283710866
        ],
        [
            113.21641427524,
            23.197279006306
        ],
        [
            113.21643004417,
            23.197198841838
        ],
        [
            113.21645342447,
            23.197087142611
        ],
        [
            113.21646946488,
            23.196997481807
        ],
        [
            113.2164971916,
            23.196893339562
        ],
        [
            113.21653741929,
            23.196779320831
        ],
        [
            113.21657057855,
            23.196699002817
        ],
        [
            113.2165887897,
            23.196634551466
        ],
        [
            113.21661216652,
            23.1965106476
        ],
        [
            113.21663255318,
            23.196383786494
        ],
        [
            113.2166613624,
            23.196292929617
        ],
        [
            113.2166763128,
            23.196141431623
        ],
        [
            113.21667984598,
            23.196124853303
        ],
        [
            113.21669615282,
            23.196042516275
        ],
        [
            113.21670321943,
            23.195971653666
        ],
        [
            113.21671816719,
            23.195791943862
        ],
        [
            113.21671925405,
            23.195672576705
        ],
        [
            113.21670240387,
            23.195517830633
        ],
        [
            113.21669723884,
            23.195412081403
        ],
        [
            113.21667440927,
            23.195316795633
        ],
        [
            113.21666054755,
            23.195236079631
        ],
        [
            113.21663527152,
            23.195153294332
        ],
        [
            113.21660456025,
            23.195082764722
        ],
        [
            113.21653797216,
            23.194924121083
        ],
        [
            113.21647763456,
            23.194802859986
        ],
        [
            113.21641077318,
            23.194682745494
        ],
        [
            113.21637054647,
            23.19460335511
        ],
        [
            113.2163197174,
            23.19448527045
        ],
        [
            113.2162555674,
            23.194330958918
        ],
        [
            113.21619386097,
            23.194170931212
        ],
        [
            113.21615389953,
            23.194059534686
        ],
        [
            113.21610578186,
            23.193929496909
        ],
        [
            113.2160304796,
            23.193754682295
        ],
        [
            113.21598045601,
            23.19362195383
        ],
        [
            113.21593478182,
            23.193506547839
        ],
        [
            113.21586028566,
            23.193307048868
        ],
        [
            113.21580454773,
            23.193159460483
        ],
        [
            113.21573385647,
            23.192993298915
        ],
        [
            113.21570258882,
            23.192922252223
        ],
        [
            113.21564222463,
            23.192767390065
        ],
        [
            113.21559409477,
            23.192641981469
        ],
        [
            113.21553454368,
            23.192493084114
        ],
        [
            113.21548070188,
            23.19236068156
        ],
        [
            113.21542577076,
            23.192224765088
        ],
        [
            113.21537926926,
            23.192113454268
        ],
        [
            113.21533440163,
            23.19202193223
        ],
        [
            113.21528409403,
            23.191916630221
        ],
        [
            113.21521992238,
            23.191810382706
        ],
        [
            113.21515058406,
            23.191700663221
        ],
        [
            113.21508450675,
            23.191593084743
        ],
        [
            113.21501597484,
            23.191455693381
        ],
        [
            113.21493956319,
            23.191340087879
        ],
        [
            113.21484709745,
            23.191166596521
        ],
        [
            113.21477175803,
            23.191005956565
        ],
        [
            113.21472332984,
            23.190849111797
        ],
        [
            113.21465884848,
            23.190645502911
        ],
        [
            113.21460606414,
            23.190478669453
        ],
        [
            113.2145829244,
            23.19036361489
        ],
        [
            113.21456440023,
            23.190231150181
        ],
        [
            113.21454942035,
            23.190136085781
        ],
        [
            113.21456569354,
            23.190010853464
        ],
        [
            113.21456864313,
            23.189878706745
        ],
        [
            113.21457541722,
            23.189808101809
        ],
        [
            113.21458300113,
            23.189720397397
        ],
        [
            113.21460716114,
            23.189613530274
        ],
        [
            113.21463567923,
            23.189534560703
        ],
        [
            113.21466147382,
            23.189441784286
        ],
        [
            113.21469106225,
            23.189315329423
        ],
        [
            113.21472418763,
            23.189200232613
        ],
        [
            113.21474644351,
            23.189099355404
        ],
        [
            113.21477033352,
            23.189008770595
        ],
        [
            113.21478824276,
            23.188918790127
        ],
        [
            113.21483820442,
            23.188763100829
        ],
        [
            113.21485639319,
            23.188697262906
        ],
        [
            113.21490662885,
            23.188553238471
        ],
        [
            113.21492616469,
            23.188458088373
        ],
        [
            113.21498942237,
            23.188253707986
        ],
        [
            113.21501927405,
            23.188128341371
        ],
        [
            113.21506733329,
            23.187993025499
        ],
        [
            113.21509284473,
            23.187894290431
        ],
        [
            113.21511781465,
            23.187802072182
        ],
        [
            113.2151509431,
            23.187720081828
        ],
        [
            113.21520578897,
            23.1875724945
        ],
        [
            113.21523022131,
            23.187498731326
        ],
        [
            113.21528479524,
            23.187356032959
        ],
        [
            113.21531574003,
            23.187259418202
        ],
        [
            113.21536298645,
            23.187147722553
        ],
        [
            113.21540181541,
            23.187057543186
        ],
        [
            113.21546127267,
            23.186904494566
        ],
        [
            113.21551205527,
            23.186804977702
        ],
        [
            113.21555874435,
            23.186672404425
        ],
        [
            113.21561495108,
            23.186551677875
        ],
        [
            113.21565269744,
            23.186479692731
        ],
        [
            113.21569886166,
            23.1863921642
        ],
        [
            113.21572329202,
            23.186326819652
        ],
        [
            113.21575968582,
            23.186270856868
        ],
        [
            113.2157976972,
            23.186188835322
        ],
        [
            113.21582974015,
            23.186130202817
        ],
        [
            113.21591093839,
            23.185993788284
        ],
        [
            113.21597258899,
            23.18590286809
        ],
        [
            113.21601766549,
            23.185823499685
        ],
        [
            113.21608119105,
            23.185682648452
        ],
        [
            113.21616481652,
            23.185522081576
        ],
        [
            113.21621612992,
            23.18542150131
        ],
        [
            113.21631226672,
            23.185286059945
        ],
        [
            113.21636303177,
            23.185180878353
        ],
        [
            113.21642601645,
            23.185059039461
        ],
        [
            113.21645505472,
            23.184984171273
        ],
        [
            113.21651613637,
            23.184864795469
        ],
        [
            113.21656988072,
            23.184748200677
        ],
        [
            113.21660760793,
            23.184663220567
        ],
        [
            113.21664261038,
            23.184566599671
        ],
        [
            113.21665100324,
            23.184510909089
        ],
        [
            113.21669443171,
            23.18441855605
        ],
        [
            113.21674434857,
            23.184269174534
        ],
        [
            113.21678316211,
            23.1841879881
        ],
        [
            113.21682793524,
            23.184075551451
        ],
        [
            113.21686944893,
            23.183967213998
        ],
        [
            113.21689875449,
            23.183894523529
        ],
        [
            113.21691964192,
            23.183832486862
        ],
        [
            113.21695383853,
            23.183760298159
        ],
        [
            113.21698776084,
            23.183684585773
        ],
        [
            113.21700946345,
            23.183623900059
        ],
        [
            113.21704773682,
            23.1835546634
        ],
        [
            113.21708763133,
            23.183471035117
        ],
        [
            113.21713214966,
            23.183395236879
        ],
        [
            113.21720328074,
            23.183292629449
        ],
        [
            113.21726244997,
            23.183183071656
        ],
        [
            113.21731483247,
            23.18308551016
        ],
        [
            113.21739382309,
            23.182956260718
        ],
        [
            113.21744105678,
            23.182883706757
        ],
        [
            113.21747686995,
            23.182799310164
        ],
        [
            113.21752655148,
            23.182732165588
        ],
        [
            113.21759060597,
            23.182622854955
        ],
        [
            113.21764272063,
            23.18253914585
        ],
        [
            113.21768968722,
            23.182478540895
        ],
        [
            113.2177021675,
            23.182450497059
        ],
        [
            113.21774859321,
            23.182394782154
        ],
        [
            113.21776189127,
            23.182371073327
        ],
        [
            113.21773144885,
            23.182354493565
        ],
        [
            113.21769965185,
            23.182344165379
        ],
        [
            113.21765888296,
            23.182326041864
        ],
        [
            113.21755805282,
            23.182290497256
        ],
        [
            113.21750478277,
            23.182270852138
        ],
        [
            113.21735692469,
            23.18221047565
        ],
        [
            113.21729168981,
            23.182180628911
        ],
        [
            113.21723433876,
            23.182157231183
        ],
        [
            113.21718650001,
            23.18213701203
        ],
        [
            113.21711747492,
            23.182131081278
        ],
        [
            113.21705659665,
            23.182118302568
        ],
        [
            113.21696093813,
            23.18211097915
        ],
        [
            113.21688349904,
            23.182124125065
        ],
        [
            113.21681937163,
            23.182132547993
        ],
        [
            113.21676665113,
            23.182131921575
        ],
        [
            113.21672642852,
            23.18212766092
        ],
        [
            113.21660818209,
            23.182080952048
        ],
        [
            113.2165269126,
            23.182062682599
        ],
        [
            113.21644754787,
            23.182049556149
        ],
        [
            113.21633746261,
            23.182022876286
        ],
        [
            113.21621270178,
            23.181999867487
        ],
        [
            113.21609610052,
            23.181989546854
        ],
        [
            113.21600831272,
            23.181988192275
        ],
        [
            113.21588762189,
            23.181964906243
        ],
        [
            113.21581884738,
            23.181949549073
        ],
        [
            113.21571692415,
            23.181951332982
        ],
        [
            113.21561743959,
            23.18194441968
        ],
        [
            113.2155209531,
            23.181951864218
        ],
        [
            113.2154812689,
            23.181951978815
        ],
        [
            113.21541413592,
            23.181958874468
        ],
        [
            113.21530703387,
            23.181949346623
        ],
        [
            113.21523581012,
            23.181939199567
        ],
        [
            113.21516023751,
            23.181930727664
        ],
        [
            113.21510912868,
            23.181922557248
        ],
        [
            113.21505093639,
            23.18189167035
        ],
        [
            113.21499791275,
            23.181867245124
        ],
        [
            113.21493780597,
            23.181820918067
        ],
        [
            113.21486437936,
            23.181775814908
        ],
        [
            113.21479909052,
            23.181706757225
        ],
        [
            113.21474848361,
            23.181642434959
        ],
        [
            113.21470196678,
            23.181596792546
        ],
        [
            113.21459641669,
            23.181490992185
        ],
        [
            113.21450392186,
            23.181397272017
        ],
        [
            113.21444759645,
            23.181323796447
        ],
        [
            113.21441003371,
            23.181257721711
        ],
        [
            113.21439206708,
            23.181223726533
        ],
        [
            113.21438386442,
            23.181157613894
        ],
        [
            113.21437591133,
            23.181060569401
        ],
        [
            113.21436905173,
            23.18097246651
        ],
        [
            113.21436517931,
            23.180880262323
        ],
        [
            113.21435585603,
            23.180769666745
        ],
        [
            113.2143424768,
            23.180689772145
        ],
        [
            113.21432094135,
            23.180609692891
        ],
        [
            113.21430839329,
            23.180551765822
        ],
        [
            113.2142740959,
            23.180493527734
        ],
        [
            113.2142512266,
            23.180449005336
        ],
        [
            113.21420765056,
            23.180343931178
        ],
        [
            113.21416245883,
            23.180260580538
        ],
        [
            113.21410878353,
            23.180103797412
        ],
        [
            113.21408042676,
            23.179994493467
        ],
        [
            113.21404638405,
            23.179916723672
        ],
        [
            113.21398320607,
            23.179780667602
        ],
        [
            113.2139548853,
            23.179720744379
        ],
        [
            113.21391323577,
            23.179652285171
        ],
        [
            113.21387296065,
            23.179603889251
        ],
        [
            113.21383404983,
            23.179562262328
        ],
        [
            113.21380657021,
            23.179536789506
        ],
        [
            113.21376956374,
            23.179497313943
        ],
        [
            113.21371868408,
            23.179449039388
        ],
        [
            113.21366918105,
            23.179423541677
        ],
        [
            113.21362348111,
            23.179394205027
        ],
        [
            113.21358050097,
            23.179366467401
        ],
        [
            113.2135391542,
            23.179341697262
        ],
        [
            113.2135187489,
            23.179324561671
        ],
        [
            113.21346596401,
            23.179276588954
        ],
        [
            113.21342515813,
            23.179249102961
        ],
        [
            113.21337835326,
            23.179199980886
        ],
        [
            113.2133386184,
            23.179152136793
        ],
        [
            113.2132610579,
            23.179065112207
        ],
        [
            113.21316333879,
            23.178932199258
        ],
        [
            113.21307896586,
            23.178830068967
        ],
        [
            113.21299403512,
            23.178712213826
        ],
        [
            113.21292352264,
            23.178604505918
        ],
        [
            113.21286906417,
            23.178511536401
        ],
        [
            113.21283937677,
            23.178451922338
        ],
        [
            113.21278439383,
            23.178384194334
        ],
        [
            113.21271119352,
            23.178319124536
        ],
        [
            113.21262521203,
            23.178254480864
        ],
        [
            113.21254631304,
            23.178206308295
        ],
        [
            113.21248347193,
            23.178176126497
        ],
        [
            113.21244593179,
            23.178160024479
        ],
        [
            113.21240187391,
            23.178154854123
        ],
        [
            113.21235346323,
            23.178147838175
        ],
        [
            113.21226998416,
            23.178155897791
        ],
        [
            113.21221615199,
            23.178171199678
        ],
        [
            113.21215987703,
            23.178192773445
        ],
        [
            113.21206719428,
            23.17825576201
        ],
        [
            113.21198811567,
            23.178328356784
        ],
        [
            113.2119239855,
            23.178391004353
        ],
        [
            113.21183839017,
            23.17847860948
        ],
        [
            113.21178240069,
            23.178520813804
        ],
        [
            113.2117400006,
            23.178552812613
        ],
        [
            113.21167964732,
            23.17858069527
        ],
        [
            113.21160242696,
            23.178602822424
        ],
        [
            113.21152357115,
            23.178621446944
        ],
        [
            113.21143982754,
            23.178650718476
        ],
        [
            113.21132100184,
            23.178684780728
        ],
        [
            113.21123779814,
            23.178711885825
        ],
        [
            113.21117825487,
            23.178737607273
        ],
        [
            113.21108064054,
            23.178772501944
        ],
        [
            113.2109903573,
            23.178793199656
        ],
        [
            113.21089083421,
            23.178825146268
        ],
        [
            113.21078722819,
            23.178854981831
        ],
        [
            113.21069558364,
            23.178878427185
        ],
        [
            113.21056314852,
            23.178915709207
        ],
        [
            113.21046361125,
            23.178936829945
        ],
        [
            113.21037169087,
            23.178960297304
        ],
        [
            113.21030941766,
            23.178982288982
        ],
        [
            113.21022076328,
            23.179010333593
        ],
        [
            113.21014869632,
            23.179032462487
        ],
        [
            113.21010083331,
            23.17904802832
        ],
        [
            113.21007336321,
            23.17905301064
        ],
        [
            113.21004425234,
            23.179047162991
        ],
        [
            113.2100080652,
            23.179036799137
        ],
        [
            113.20991773158,
            23.179009534525
        ],
        [
            113.20984345096,
            23.178987753735
        ],
        [
            113.20977106545,
            23.178955369065
        ],
        [
            113.20969378962,
            23.178931736527
        ],
        [
            113.20960536338,
            23.178912873148
        ],
        [
            113.20954686289,
            23.178897128547
        ],
        [
            113.2094777493,
            23.178877462933
        ],
        [
            113.20940918937,
            23.178870544178
        ],
        [
            113.20933708001,
            23.17884821256
        ],
        [
            113.20924701337,
            23.178823963984
        ],
        [
            113.20915885746,
            23.178808917946
        ],
        [
            113.2090747751,
            23.178785950906
        ],
        [
            113.20897655036,
            23.178769698916
        ],
        [
            113.20888974238,
            23.178742709329
        ],
        [
            113.20880428402,
            23.178703495572
        ],
        [
            113.20870794887,
            23.178672580361
        ],
        [
            113.20862902715,
            23.17864440553
        ],
        [
            113.2085683353,
            23.178618685787
        ],
        [
            113.2085364852,
            23.178596352222
        ],
        [
            113.20848260752,
            23.178586816402
        ],
        [
            113.20840014265,
            23.178553547316
        ],
        [
            113.208301615,
            23.178508576514
        ],
        [
            113.20818049878,
            23.178457699007
        ],
        [
            113.20810728505,
            23.178428377931
        ],
        [
            113.20803025826,
            23.17839504568
        ],
        [
            113.2079867103,
            23.178377504835
        ],
        [
            113.20792872178,
            23.178335758431
        ],
        [
            113.20788787935,
            23.178300001943
        ],
        [
            113.20781817237,
            23.17823645449
        ],
        [
            113.20772096071,
            23.178145370328
        ],
        [
            113.20763654175,
            23.178060884121
        ],
        [
            113.20752433911,
            23.177941814901
        ],
        [
            113.20745353022,
            23.177866087296
        ],
        [
            113.20738109707,
            23.177801239107
        ],
        [
            113.20727707308,
            23.177705394461
        ],
        [
            113.2071716815,
            23.177602792714
        ],
        [
            113.20711094614,
            23.177537506598
        ],
        [
            113.20705458254,
            23.177494132883
        ],
        [
            113.20697098939,
            23.177429739015
        ],
        [
            113.2068743264,
            23.177356593574
        ],
        [
            113.20673627684,
            23.177256138089
        ],
        [
            113.20662191396,
            23.177172150242
        ],
        [
            113.20649910708,
            23.177080429977
        ],
        [
            113.20635559988,
            23.176969229811
        ],
        [
            113.206262213,
            23.17691613855
        ],
        [
            113.20620419859,
            23.176858161277
        ],
        [
            113.20613612259,
            23.176809295313
        ],
        [
            113.20605852068,
            23.176759765744
        ],
        [
            113.20599779718,
            23.176717572403
        ],
        [
            113.20589405195,
            23.176648921358
        ],
        [
            113.20582897436,
            23.176608157158
        ],
        [
            113.20574972867,
            23.17654889621
        ],
        [
            113.20566531325,
            23.176491618529
        ],
        [
            113.20557899043,
            23.176432474697
        ],
        [
            113.20547631943,
            23.176352429617
        ],
        [
            113.20540550278,
            23.176287620319
        ],
        [
            113.20530826344,
            23.176196643414
        ],
        [
            113.20527094121,
            23.176154910818
        ],
        [
            113.205224626,
            23.176100027276
        ],
        [
            113.20520061572,
            23.176031765712
        ],
        [
            113.20514420189,
            23.175945028749
        ],
        [
            113.20511882966,
            23.175875975679
        ],
        [
            113.2050942234,
            23.175750475894
        ],
        [
            113.20507832426,
            23.175623209156
        ],
        [
            113.20506952028,
            23.17551753468
        ],
        [
            113.20505690775,
            23.175414091639
        ],
        [
            113.20505246311,
            23.175314316462
        ],
        [
            113.20505456132,
            23.175226917388
        ],
        [
            113.20506183502,
            23.17514459063
        ],
        [
            113.20507973011,
            23.175070233741
        ],
        [
            113.20511097926,
            23.175016012803
        ],
        [
            113.20513814271,
            23.174958330253
        ],
        [
            113.20516012612,
            23.174890963002
        ],
        [
            113.20519077508,
            23.174776247746
        ],
        [
            113.20521626444,
            23.174674367123
        ],
        [
            113.20523795635,
            23.174586655924
        ],
        [
            113.20524631803,
            23.17450512608
        ],
        [
            113.20524518879,
            23.174461189788
        ],
        [
            113.20523182263,
            23.17442830118
        ],
        [
            113.20520920243,
            23.174394746064
        ],
        [
            113.20517323472,
            23.174348651752
        ],
        [
            113.20514353577,
            23.174312496863
        ],
        [
            113.20511739466,
            23.174297720022
        ],
        [
            113.20509859669,
            23.174277399686
        ],
        [
            113.20505557285,
            23.174253396922
        ],
        [
            113.20494337863,
            23.174185734811
        ],
        [
            113.20482791884,
            23.174119758058
        ],
        [
            113.20474703908,
            23.174070593768
        ],
        [
            113.20467188109,
            23.174028665348
        ],
        [
            113.20458856545,
            23.173995282
        ],
        [
            113.20450578926,
            23.173957280022
        ],
        [
            113.20443961955,
            23.173923894886
        ],
        [
            113.20437154732,
            23.173893798166
        ],
        [
            113.20431382929,
            23.173876286831
        ],
        [
            113.20430783765,
            23.173872314489
        ]
    ];


import { bsType } from "./index.js";

let cordData = {
    平台大屏: {
        九江: {
            offset: [550, 350],
            singleOffset: [1685, 1195],
        },
        狮山: {
            offset: [-1550, -250],
            singleOffset: [620, 1730],
        },
        丹灶: {
            offset: [-1200, -300],
            singleOffset: [120, 310],
        },
        西樵: {
            offset: [-1200, 300],
            singleOffset: [630, 1520],
        },
        里水: {
            offset: [300, -500],
            singleOffset: [365, 80],
        },
        大沥: {
            offset: [300, 200],
            singleOffset: [420, 1710],
        },
        桂城: {
            offset: [370, 650],
            singleOffset: [1215, 1445],
        },
    },
    康养港大屏: {
        九江: {
            offset: [550, 350],
            singleOffset: [1265, 1195],
        },
        狮山: {
            offset: [-1050, -550],
            singleOffset: [200, 1710],
        },
        丹灶: {
            offset: [-850, -300],
            singleOffset: [-300, 310],
        },
        西樵: {
            offset: [-800, 600],
            singleOffset: [210, 1520],
        },
        里水: {
            offset: [80, -500],
            singleOffset: [-45, 0],
        },
        大沥: {
            offset: [80, 150],
            singleOffset: [10, 1710],
        },
        桂城: {
            offset: [150, 450],
            singleOffset: [795, 1445],
        },
    },
};

let jiujiangLOC = {
    location: { lng: 112.990058, lat: 22.796775 },
    color: "rgb(255, 132, 0)",
    zoom: 15,
    center: {
        lat: 22.86306,
        lng: 112.962605
    },
    ...cordData[bsType].九江
}
let shishanLOC = {
    location: { lng: 112.903821, lat: 23.222823 },
    color: "rgb(23,140,251)",
    zoom: 14,
    center: {
        lat: 23.144368,
        lng: 113.02037
    },
    ...cordData[bsType].狮山
}
let danzaoLOC = {
    location: { lng: 112.903821, lat: 23.14841 },
    color: "rgb(3, 226, 228)",
    zoom: 15,
    center: {
        lat: 23.074087,
        lng: 112.922865
    },
    ...cordData[bsType].丹灶
}
let xiqiaoLOC = {
    location: { lng: 112.903821, lat: 22.958466 },
    color: "rgb(253, 65, 95)",
    zoom: 15,
    center: {
        lat: 22.944489,
        lng: 112.952545
    },
    ...cordData[bsType].西樵
}
let lishuiLOC = {
    location: { lng: 113.188117, lat: 23.269576 },
    color: "rgb(139, 13, 255)",
    zoom: 15,
    center: {
        lat: 23.228734,
        lng: 113.151035
    },
    ...cordData[bsType].里水
}
let daliLOC = {
    location: { lng: 113.188117, lat: 23.263467 },
    color: "rgb(79, 44, 255)",
    zoom: 15,
    center: {
        lat: 23.120201,
        lng: 113.155375
    },
    ...cordData[bsType].大沥
}
let guichengLOC = {
    location: { lng: 113.188117, lat: 23.041766 },
    color: "rgb(165, 227, 0)",
    zoom: 15,
    center: {
        lat: 23.039504,
        lng: 113.19214
    },
    ...cordData[bsType].桂城
}

let nanhai = [],
    chancheng = [],
    shunde = [],
    sanshui = [],
    gaoming = [];

for (let i = 0; i < nanhaiArray.length; i++) {
    nanhai.push(nanhaiArray[i].split(','));
}
for (let i = 0; i < chanchengArray.length; i++) {
    chancheng.push(chanchengArray[i].split(','));
}
for (let i = 0; i < shundeArray.length; i++) {
    shunde.push(shundeArray[i].split(','));
}
for (let i = 0; i < sanshuiArray.length; i++) {
    sanshui.push(sanshuiArray[i].split(','));
}
for (let i = 0; i < gaomingArray.length; i++) {
    gaoming.push(gaomingArray[i].split(','));
}

export { nanhai, chancheng, shunde, sanshui, gaoming, guicheng, guichengLOC, jiujiang, jiujiangLOC, xiqiao, xiqiaoLOC, danzao, danzaoLOC, shishan, shishanLOC, dali, daliLOC, lishui, lishuiLOC }